
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2521"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2521"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j3oOb", function(module, exports) {

$parcel$export(module.exports, "a7", function () { return $ddf18a96c86c2e3c$export$a93c5207d687da10; });
$parcel$export(module.exports, "ae", function () { return $ddf18a96c86c2e3c$export$f787f51d84a910ad; });
$parcel$export(module.exports, "a0", function () { return $ddf18a96c86c2e3c$export$34aec0b863436764; });
$parcel$export(module.exports, "E", function () { return $ddf18a96c86c2e3c$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "D", function () { return $ddf18a96c86c2e3c$export$96f57966bedc81b4; });
$parcel$export(module.exports, "Q", function () { return $ddf18a96c86c2e3c$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "ar", function () { return $ddf18a96c86c2e3c$export$d24c54395ce0c509; });
$parcel$export(module.exports, "aq", function () { return $ddf18a96c86c2e3c$export$8a5498727ef6be21; });
$parcel$export(module.exports, "r", function () { return $ddf18a96c86c2e3c$export$43caf9889c228507; });
$parcel$export(module.exports, "ap", function () { return $ddf18a96c86c2e3c$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "as", function () { return $ddf18a96c86c2e3c$export$6554612db691658e; });
$parcel$export(module.exports, "a6", function () { return $ddf18a96c86c2e3c$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "a4", function () { return $ddf18a96c86c2e3c$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "h", function () { return $ddf18a96c86c2e3c$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "ao", function () { return $ddf18a96c86c2e3c$export$7a38258bbe170828; });
$parcel$export(module.exports, "af", function () { return $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "ah", function () { return $ddf18a96c86c2e3c$export$995eb9fca571757; });
$parcel$export(module.exports, "a5", function () { return $ddf18a96c86c2e3c$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "a3", function () { return $ddf18a96c86c2e3c$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "n", function () { return $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "L", function () { return $ddf18a96c86c2e3c$export$61196ced6d74a310; });
$parcel$export(module.exports, "Z", function () { return $ddf18a96c86c2e3c$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "s", function () { return $ddf18a96c86c2e3c$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "a1", function () { return $ddf18a96c86c2e3c$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "c", function () { return $ddf18a96c86c2e3c$export$db3b6bfb95261072; });
$parcel$export(module.exports, "l", function () { return $ddf18a96c86c2e3c$export$882b5998b3b9117c; });
$parcel$export(module.exports, "m", function () { return $ddf18a96c86c2e3c$export$953cecd6e717a553; });
$parcel$export(module.exports, "a", function () { return $ddf18a96c86c2e3c$export$407448d2b89b1813; });
$parcel$export(module.exports, "j", function () { return $ddf18a96c86c2e3c$export$35e795649ee09318; });
$parcel$export(module.exports, "b", function () { return $ddf18a96c86c2e3c$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "d", function () { return $ddf18a96c86c2e3c$export$4368d992c4eafac0; });
$parcel$export(module.exports, "B", function () { return $ddf18a96c86c2e3c$export$ef35774e6d314e91; });
$parcel$export(module.exports, "t", function () { return $ddf18a96c86c2e3c$export$625550452a3fa3ec; });
$parcel$export(module.exports, "G", function () { return $ddf18a96c86c2e3c$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "e", function () { return $ddf18a96c86c2e3c$export$f1e1789686576879; });
$parcel$export(module.exports, "p", function () { return $ddf18a96c86c2e3c$export$ffb5f4729a158638; });
$parcel$export(module.exports, "J", function () { return $ddf18a96c86c2e3c$export$b4171a6734a65d42; });
$parcel$export(module.exports, "k", function () { return $ddf18a96c86c2e3c$export$342063e11d6c3cad; });
$parcel$export(module.exports, "v", function () { return $ddf18a96c86c2e3c$export$90a7f3efeed30595; });
$parcel$export(module.exports, "T", function () { return $ddf18a96c86c2e3c$export$971d5caa766a69d7; });
$parcel$export(module.exports, "o", function () { return $ddf18a96c86c2e3c$export$ae1af26003f05816; });
$parcel$export(module.exports, "H", function () { return $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "a2", function () { return $ddf18a96c86c2e3c$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "az", function () { return $ddf18a96c86c2e3c$export$3d12bd131bb975d1; });
$parcel$export(module.exports, "ax", function () { return $ddf18a96c86c2e3c$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "ay", function () { return $ddf18a96c86c2e3c$export$28f7fcd39efa255; });
$parcel$export(module.exports, "al", function () { return $ddf18a96c86c2e3c$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "ai", function () { return $ddf18a96c86c2e3c$export$f38c853ae54ed474; });
$parcel$export(module.exports, "g", function () { return $ddf18a96c86c2e3c$export$39b482c5e57630a8; });
$parcel$export(module.exports, "U", function () { return $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "ad", function () { return $ddf18a96c86c2e3c$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "y", function () { return $ddf18a96c86c2e3c$export$4a5767248b18ef41; });
$parcel$export(module.exports, "z", function () { return $ddf18a96c86c2e3c$export$df995fae86a55f06; });
$parcel$export(module.exports, "x", function () { return $ddf18a96c86c2e3c$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "A", function () { return $ddf18a96c86c2e3c$export$ebd11618f299a286; });
$parcel$export(module.exports, "V", function () { return $ddf18a96c86c2e3c$export$e7c866399fa523f5; });
$parcel$export(module.exports, "ak", function () { return $ddf18a96c86c2e3c$export$21579262ef46735b; });
$parcel$export(module.exports, "a9", function () { return $ddf18a96c86c2e3c$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "_", function () { return $ddf18a96c86c2e3c$export$71511d61b312f219; });
$parcel$export(module.exports, "$", function () { return $ddf18a96c86c2e3c$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "q", function () { return $ddf18a96c86c2e3c$export$9e5f44173e64f162; });
$parcel$export(module.exports, "a8", function () { return $ddf18a96c86c2e3c$export$c3950d9923825c02; });
$parcel$export(module.exports, "aA", function () { return $ddf18a96c86c2e3c$export$91c6e00c14e7e6fd; });
$parcel$export(module.exports, "u", function () { return $ddf18a96c86c2e3c$export$3b14a55fb2447963; });
$parcel$export(module.exports, "ac", function () { return $ddf18a96c86c2e3c$export$2219238a014317b0; });
$parcel$export(module.exports, "F", function () { return $ddf18a96c86c2e3c$export$d66501df72047452; });
$parcel$export(module.exports, "I", function () { return $ddf18a96c86c2e3c$export$9bb611d729802a56; });
$parcel$export(module.exports, "K", function () { return $ddf18a96c86c2e3c$export$3466f893ebf79586; });
$parcel$export(module.exports, "i", function () { return $ddf18a96c86c2e3c$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "S", function () { return $ddf18a96c86c2e3c$export$25ce5a424b770e84; });
$parcel$export(module.exports, "N", function () { return $ddf18a96c86c2e3c$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "w", function () { return $ddf18a96c86c2e3c$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "at", function () { return $ddf18a96c86c2e3c$export$493d36ec626b6698; });
$parcel$export(module.exports, "av", function () { return $ddf18a96c86c2e3c$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "O", function () { return $ddf18a96c86c2e3c$export$c4ce752e73470fba; });
$parcel$export(module.exports, "am", function () { return $ddf18a96c86c2e3c$export$1a82df3d29112e01; });
$parcel$export(module.exports, "aw", function () { return $ddf18a96c86c2e3c$export$92108d983e8ee699; });
$parcel$export(module.exports, "au", function () { return $ddf18a96c86c2e3c$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "aj", function () { return $ddf18a96c86c2e3c$export$3b513254972cfc9c; });
$parcel$export(module.exports, "C", function () { return $ddf18a96c86c2e3c$export$e7094788287c5e9b; });
$parcel$export(module.exports, "M", function () { return $ddf18a96c86c2e3c$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "P", function () { return $ddf18a96c86c2e3c$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "ag", function () { return $ddf18a96c86c2e3c$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "f", function () { return $ddf18a96c86c2e3c$export$2d1720544b23b823; });
$parcel$export(module.exports, "an", function () { return $ddf18a96c86c2e3c$export$306ddfe3a8403e2; });
$parcel$export(module.exports, "aa", function () { return $ddf18a96c86c2e3c$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "X", function () { return $ddf18a96c86c2e3c$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "ab", function () { return $ddf18a96c86c2e3c$export$555508cbc6add439; });
$parcel$export(module.exports, "Y", function () { return $ddf18a96c86c2e3c$export$8743009a87fcb00f; });
$parcel$export(module.exports, "R", function () { return $ddf18a96c86c2e3c$export$db202ddc8be9136; });
$parcel$export(module.exports, "W", function () { return $ddf18a96c86c2e3c$export$71cec2538cb2c617; });
$parcel$export(module.exports, "aB", function () { return $ddf18a96c86c2e3c$export$9d398bebfec1c039; });

var $l4gH8 = parcelRequire("l4gH8");
var $hh9se = parcelRequire("hh9se");
var $i27jC = parcelRequire("i27jC");
var $bPD7y = parcelRequire("bPD7y");
var $eqreU = parcelRequire("eqreU");
var $3u3jm = parcelRequire("3u3jm");
var $9La4g = parcelRequire("9La4g");
var $kBz4k = parcelRequire("kBz4k");
var $fn8ZQ = parcelRequire("fn8ZQ");
var $lLJqC = parcelRequire("lLJqC");
var $6jCRi = parcelRequire("6jCRi");
var $czRBO = parcelRequire("czRBO");
var $1mIQr = parcelRequire("1mIQr");

var $fR4Va = parcelRequire("fR4Va");
var $bPD7y = parcelRequire("bPD7y");
var $cH4fw = parcelRequire("cH4fw");
var $7J7ms = parcelRequire("7J7ms");
var $esA4D = parcelRequire("esA4D");
var $fn8ZQ = parcelRequire("fn8ZQ");
var $lLJqC = parcelRequire("lLJqC");
var $gZfTb = parcelRequire("gZfTb");
var $czRBO = parcelRequire("czRBO");
var $1mIQr = parcelRequire("1mIQr");
var $g5uH8 = parcelRequire("g5uH8");

var $hRLut = parcelRequire("hRLut");

var $8VqiI = parcelRequire("8VqiI");

var $fEL8l = parcelRequire("fEL8l");

var $6zFHJ = parcelRequire("6zFHJ");
parcelRequire("lH5oz");
var $3lyD3 = parcelRequire("3lyD3");
var $2AQn5 = parcelRequire("2AQn5");
var $9s7cO = parcelRequire("9s7cO");
parcelRequire("9EcIH");
var $4wDz6 = parcelRequire("4wDz6");

var $cW7tz = parcelRequire("cW7tz");

var $8RKFj = parcelRequire("8RKFj");
var $kslqr = parcelRequire("kslqr");

var $eSAm6 = parcelRequire("eSAm6");

var $aTZNU = parcelRequire("aTZNU");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $ddf18a96c86c2e3c$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
var $ddf18a96c86c2e3c$var$defaultBnIcon = `<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="56" height="56" rx="8" fill="#262A3D"/>
<g clip-path="url(#clip0_15747_103507)">
<path d="M20.6176 35.9801L16.0142 27.9949H25.2218L29.826 35.9801H20.6176Z" fill="#262A3D"/>
<path d="M20.6176 35.9801L16.0142 27.9949H25.2218L29.826 35.9801H20.6176Z" fill="white"/>
<path d="M25.2218 27.9947H16.0142L20.6176 20.0095H29.826L25.2218 27.9947Z" fill="url(#paint0_linear_15747_103507)"/>
<path d="M34.4302 27.9948L29.826 20.0096H20.6176L16.0142 12.0244H34.4302L43.6379 27.9948H34.4302Z" fill="#262A3D"/>
<path d="M34.4302 27.9948L29.826 20.0096H20.6176L16.0142 12.0244H34.4302L43.6379 27.9948H34.4302Z" fill="white"/>
<path d="M34.4302 43.9652H16.0142L20.6176 35.9801H29.826L34.4302 27.9949H43.6379L34.4302 43.9652Z" fill="url(#paint1_linear_15747_103507)"/>
</g>
<defs>
<linearGradient id="paint0_linear_15747_103507" x1="16.0142" y1="24.0021" x2="29.826" y2="24.0021" gradientUnits="userSpaceOnUse">
<stop stop-color="#55CCFE"/>
<stop offset="1" stop-color="#5E93EF"/>
</linearGradient>
<linearGradient id="paint1_linear_15747_103507" x1="76.5102" y1="5214.05" x2="10391.8" y2="5214.05" gradientUnits="userSpaceOnUse">
<stop stop-color="#55CCFE"/>
<stop offset="1" stop-color="#5E93EF"/>
</linearGradient>
<clipPath id="clip0_15747_103507">
<rect width="27.6667" height="32" fill="white" transform="translate(16 12)"/>
</clipPath>
</defs>
</svg>
`;
var $ddf18a96c86c2e3c$export$a93c5207d687da10 = `
<svg width="152" height="16" viewBox="0 0 152 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.03641 6.252C3.23241 6.252 2.41641 6.636 2.04441 7.272V6.396H1.00041V14.724H2.04441V11.124C2.41641 11.784 3.20841 12.144 4.04841 12.144C5.58441 12.144 6.84441 10.98 6.84441 9.204C6.84441 7.44 5.57241 6.252 4.03641 6.252ZM3.94041 11.16C3.02841 11.16 2.04441 10.428 2.04441 9.216C2.04441 8.016 2.94441 7.236 3.94041 7.236C4.97241 7.236 5.78841 8.1 5.78841 9.216C5.78841 10.344 4.97241 11.16 3.94041 11.16ZM10.8452 12.144C12.4412 12.144 13.7852 10.968 13.7852 9.192C13.7852 7.416 12.4412 6.252 10.8452 6.252C9.24919 6.252 7.91719 7.416 7.91719 9.192C7.91719 10.968 9.24919 12.144 10.8452 12.144ZM10.8452 11.16C9.82519 11.16 8.97319 10.356 8.97319 9.192C8.97319 8.04 9.82519 7.236 10.8452 7.236C11.8772 7.236 12.7412 8.04 12.7412 9.192C12.7412 10.356 11.8772 11.16 10.8452 11.16ZM22.2729 6.396L20.8449 10.38L19.4049 6.396H18.3849L16.9569 10.38L15.5289 6.396H14.4009L16.5369 12H17.4009L18.8889 7.836L20.4369 12H21.3129L23.4009 6.396H22.2729ZM29.6948 9.18C29.6948 7.404 28.5068 6.252 26.9108 6.252C25.3148 6.252 24.0308 7.404 24.0308 9.18C24.0308 10.956 25.3148 12.144 26.9108 12.144C27.9908 12.144 28.9988 11.616 29.4788 10.644L28.5788 10.284C28.2548 10.848 27.6308 11.16 26.9468 11.16C25.9868 11.16 25.2668 10.644 25.1108 9.648H29.6708C29.6828 9.492 29.6948 9.336 29.6948 9.18ZM25.1228 8.748C25.2908 7.74 25.9628 7.236 26.9108 7.236C27.8348 7.236 28.5188 7.788 28.6508 8.748H25.1228ZM33.7456 6.252C33.0016 6.252 32.4616 6.684 32.1736 7.668V6.396H31.1176V12H32.1736V9.948C32.1736 8.472 32.6176 7.26 33.7336 7.26C33.9496 7.26 34.2496 7.308 34.5496 7.452L34.7176 6.468C34.5496 6.36 34.1416 6.252 33.7456 6.252ZM40.8627 9.18C40.8627 7.404 39.6747 6.252 38.0787 6.252C36.4827 6.252 35.1987 7.404 35.1987 9.18C35.1987 10.956 36.4827 12.144 38.0787 12.144C39.1587 12.144 40.1667 11.616 40.6467 10.644L39.7467 10.284C39.4227 10.848 38.7987 11.16 38.1147 11.16C37.1547 11.16 36.4347 10.644 36.2787 9.648H40.8387C40.8507 9.492 40.8627 9.336 40.8627 9.18ZM36.2907 8.748C36.4587 7.74 37.1307 7.236 38.0787 7.236C39.0027 7.236 39.6867 7.788 39.8187 8.748H36.2907ZM46.7136 3.348V7.272C46.3416 6.612 45.5496 6.252 44.7096 6.252C43.1736 6.252 41.9136 7.416 41.9136 9.192C41.9136 10.956 43.1856 12.144 44.7216 12.144C45.5256 12.144 46.3416 11.76 46.7136 11.124V12H47.7576V3.348H46.7136ZM44.8056 11.16C43.7856 11.16 42.9696 10.296 42.9696 9.18C42.9696 8.052 43.7856 7.236 44.8056 7.236C45.7296 7.236 46.7136 7.968 46.7136 9.18C46.7136 10.38 45.8136 11.16 44.8056 11.16ZM55.6695 6.252C54.8295 6.252 54.0375 6.612 53.6655 7.272V3.348H52.6215V12H53.6655V11.124C54.0375 11.76 54.8535 12.144 55.6575 12.144C57.1935 12.144 58.4655 10.956 58.4655 9.192C58.4655 7.416 57.2055 6.252 55.6695 6.252ZM55.5615 11.16C54.5655 11.16 53.6655 10.38 53.6655 9.18C53.6655 7.968 54.6495 7.236 55.5615 7.236C56.5935 7.236 57.4095 8.052 57.4095 9.18C57.4095 10.296 56.5935 11.16 55.5615 11.16ZM63.6097 6.396L61.8937 10.524L60.2017 6.396H59.0737L61.3297 11.832L60.1537 14.724H61.2577L64.7377 6.396H63.6097Z" fill="var(--w3o-text-color, #707481)"/>
<g clip-path="url(#clip0_13558_103869)">
<path d="M143.502 11.0888L141.863 8.24889H145.142L146.782 11.0888H143.502Z" fill="currentColor"/>
<path d="M145.142 8.24887H141.863L143.502 5.40895H146.782L145.142 8.24887Z" fill="url(#paint0_linear_13558_103869)"/>
<path d="M148.421 8.24888L146.782 5.40896H143.502L141.863 2.56903H148.421L151.701 8.24888H148.421Z" fill="currentColor"/>
<path d="M148.421 13.9287H141.863L143.502 11.0888H146.782L148.421 8.24889H151.701L148.421 13.9287Z" fill="url(#paint1_linear_13558_103869)"/>
<path d="M76.4774 8.89232C76.4774 10.9327 74.9716 12.5077 73.1366 12.5077C72.1369 12.5077 71.4106 12.1378 70.9181 11.508V12.316H69.1513V2.71994L70.9181 2.17606V6.27771C71.4106 5.64894 72.1369 5.27797 73.1366 5.27797C74.9716 5.27797 76.4774 6.85198 76.4774 8.89232ZM74.7106 8.89232C74.7106 7.73959 73.9037 6.96201 72.8076 6.96201C71.7114 6.96201 70.9213 7.74273 70.9213 8.89232C70.9213 10.0419 71.7292 10.8237 72.8076 10.8237C73.8859 10.8237 74.7106 10.043 74.7106 8.89232Z" fill="currentColor"/>
<path d="M77.2718 2.71994L79.0376 2.17606V12.316H77.2718V2.71994Z" fill="currentColor"/>
<path d="M79.8183 8.89232C79.8171 8.17544 80.0286 7.47431 80.4261 6.87774C80.8236 6.28117 81.3893 5.816 82.0514 5.54113C82.7135 5.26627 83.4422 5.19408 84.1454 5.33371C84.8485 5.47333 85.4944 5.8185 86.0013 6.32549C86.5081 6.83247 86.8531 7.47847 86.9925 8.18166C87.1319 8.88486 87.0595 9.61361 86.7845 10.2756C86.5094 10.9376 86.0441 11.5031 85.4474 11.9005C84.8507 12.2978 84.1495 12.5092 83.4326 12.5077C82.9565 12.5128 82.4842 12.4227 82.0433 12.2428C81.6024 12.0629 81.2019 11.7967 80.8653 11.46C80.5286 11.1232 80.2626 10.7227 80.0828 10.2817C79.903 9.84083 79.8131 9.36845 79.8183 8.89232ZM85.2948 8.89232C85.2948 7.78359 84.4869 7.00602 83.4326 7.00602C82.3784 7.00602 81.5841 7.78674 81.5841 8.89232C81.5841 9.9979 82.392 10.7786 83.4326 10.7786C84.4733 10.7786 85.2948 10.0021 85.2948 8.89232Z" fill="currentColor"/>
<path d="M87.7313 8.89233C87.7313 6.85198 89.2645 5.27797 91.3457 5.27797C92.6881 5.27797 93.8513 5.98952 94.413 7.04375L92.8935 7.93451C92.6189 7.37281 92.03 7.01651 91.3321 7.01651C90.2778 7.01651 89.4971 7.79723 89.4971 8.89233C89.4971 9.98743 90.2778 10.7545 91.3321 10.7545C92.0447 10.7545 92.6326 10.4129 92.904 9.8512L94.4371 10.7273C94.1281 11.2741 93.6779 11.7279 93.1335 12.0413C92.5891 12.3547 91.9706 12.5161 91.3425 12.5088C89.2645 12.5077 87.7313 10.9327 87.7313 8.89233Z" fill="currentColor"/>
<path d="M99.5123 12.316L97.0203 9.20776V12.316H95.2534V2.71994L97.0203 2.17606V8.48153L99.374 5.46974H101.482L98.7316 8.85145L101.566 12.316H99.5123Z" fill="currentColor"/>
<path d="M108.623 8.11161V12.316H106.856V8.33377C106.856 7.40215 106.296 6.92324 105.501 6.92324C104.639 6.92324 103.994 7.4294 103.994 8.62091V12.316H102.229V5.46974H103.994V6.23579C104.405 5.6196 105.118 5.27797 106.035 5.27797C107.486 5.27797 108.623 6.29657 108.623 8.11161Z" fill="currentColor"/>
<path d="M116.74 5.46974V12.316H114.975V11.508C114.481 12.1242 113.742 12.5077 112.743 12.5077C110.921 12.5077 109.415 10.9358 109.415 8.89233C109.415 6.84884 110.921 5.27797 112.743 5.27797C113.742 5.27797 114.481 5.66152 114.975 6.27771V5.46974H116.74ZM114.975 8.89233C114.975 7.73959 114.167 6.96201 113.071 6.96201C111.974 6.96201 111.184 7.74273 111.184 8.89233C111.184 10.0419 111.992 10.8237 113.071 10.8237C114.149 10.8237 114.975 10.043 114.975 8.89233Z" fill="currentColor"/>
<path d="M121.344 7.16742V5.46975H119.796V3.45665L118.027 4.00053V10.0157C118.027 11.8643 118.866 12.5895 121.342 12.3212V10.7137C120.329 10.7692 119.794 10.7545 119.794 10.0157V7.16742H121.344Z" fill="currentColor"/>
<path d="M122.582 5.46974H124.347V12.316H122.582V5.46974Z" fill="currentColor"/>
<path d="M132.293 5.46974L129.691 12.316H127.678L125.077 5.46974H127.021L128.678 10.262L130.348 5.46974H132.293Z" fill="currentColor"/>
<path d="M136.073 10.9075C136.757 10.9075 137.305 10.6204 137.607 10.2232L139.03 11.0448C138.387 11.9754 137.36 12.5119 136.046 12.5119C133.74 12.5119 132.294 10.94 132.294 8.89652C132.294 6.85303 133.761 5.28217 135.908 5.28217C137.935 5.28217 139.373 6.88447 139.373 8.89652C139.37 9.13886 139.346 9.38049 139.301 9.61856H134.143C134.389 10.5219 135.142 10.9075 136.073 10.9075ZM137.607 8.25099C137.387 7.26487 136.648 6.8677 135.908 6.8677C134.965 6.8677 134.321 7.37491 134.114 8.25099H137.607Z" fill="currentColor"/>
</g>
<defs>
<linearGradient id="paint0_linear_13558_103869" x1="141.863" y1="6.82891" x2="146.782" y2="6.82891" gradientUnits="userSpaceOnUse">
<stop stop-color="#55CCFE"/>
<stop offset="1" stop-color="#5E93EF"/>
</linearGradient>
<linearGradient id="paint1_linear_13558_103869" x1="6973.93" y1="500.862" x2="7897.53" y2="500.862" gradientUnits="userSpaceOnUse">
<stop stop-color="#55CCFE"/>
<stop offset="1" stop-color="#5E93EF"/>
</linearGradient>
<clipPath id="clip0_13558_103869">
<rect width="82.8232" height="12" fill="white" transform="translate(69.0884 2)"/>
</clipPath>
</defs>
</svg>
`;
var $ddf18a96c86c2e3c$var$ethereumIcon = `
  <svg height="100%" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.99902 0.12619V5.20805L9.58065 7.12736L4.99902 0.12619Z" fill="white" fill-opacity="0.602"/>
    <path d="M4.99923 0.12619L0.416992 7.12736L4.99923 5.20805V0.12619Z" fill="white"/>
    <path d="M4.99902 10.4207V13.8737L9.58371 7.92728L4.99902 10.4207Z" fill="white" fill-opacity="0.602"/>
    <path d="M4.99923 13.8737V10.4201L0.416992 7.92728L4.99923 13.8737Z" fill="white"/>
    <path d="M4.99902 9.62134L9.58065 7.12739L4.99902 5.20923V9.62134Z" fill="white" fill-opacity="0.2"/>
    <path d="M0.416992 7.12739L4.99923 9.62134V5.20923L0.416992 7.12739Z" fill="white" fill-opacity="0.602"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$polygonIcon = `
  <svg width="100%" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5091 4.05856C10.2585 3.91901 9.9362 3.91901 9.64974 4.05856L7.64453 5.20986L6.28385 5.94251L4.31445 7.09382C4.0638 7.23337 3.74154 7.23337 3.45508 7.09382L1.91536 6.18673C1.66471 6.04718 1.48568 5.76807 1.48568 5.45408V3.70968C1.48568 3.43057 1.62891 3.15147 1.91536 2.97703L3.45508 2.10483C3.70573 1.96527 4.02799 1.96527 4.31445 2.10483L5.85417 3.01192C6.10482 3.15147 6.28385 3.43057 6.28385 3.74457V4.89587L7.64453 4.12833V2.94214C7.64453 2.66304 7.5013 2.38393 7.21484 2.20949L4.35026 0.569752C4.09961 0.4302 3.77734 0.4302 3.49089 0.569752L0.554687 2.24438C0.268229 2.38393 0.125 2.66304 0.125 2.94214V6.22162C0.125 6.50072 0.268229 6.77983 0.554687 6.95427L3.45508 8.59401C3.70573 8.73356 4.02799 8.73356 4.31445 8.59401L6.28385 7.47759L7.64453 6.71005L9.61393 5.59363C9.86458 5.45408 10.1868 5.45408 10.4733 5.59363L12.013 6.46583C12.2637 6.60539 12.4427 6.88449 12.4427 7.19848V8.94289C12.4427 9.22199 12.2995 9.50109 12.013 9.67553L10.5091 10.5477C10.2585 10.6873 9.9362 10.6873 9.64974 10.5477L8.11002 9.67553C7.85937 9.53598 7.68034 9.25688 7.68034 8.94289V7.82647L6.31966 8.59401V9.74531C6.31966 10.0244 6.46289 10.3035 6.74935 10.478L9.64974 12.1177C9.90039 12.2572 10.2227 12.2572 10.5091 12.1177L13.4095 10.478C13.6602 10.3384 13.8392 10.0593 13.8392 9.74531V6.43095C13.8392 6.15184 13.696 5.87274 13.4095 5.6983L10.5091 4.05856Z" fill="white"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$binanceIcon = `
  <svg width="100%" height="100%" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.32975 5.90275L7 3.2325L9.67163 5.90413L11.2254 4.35038L7 0.125L2.776 4.349L4.32975 5.90275ZM0.125 7L1.67875 5.44625L3.2325 7L1.67875 8.55375L0.125 7ZM4.32975 8.09725L7 10.7675L9.67163 8.09587L11.2254 9.64894L7 13.875L2.776 9.651L2.77394 9.64894L4.32975 8.09725ZM10.7675 7L12.3212 5.44625L13.875 7L12.3212 8.55375L10.7675 7ZM8.57575 6.99863H8.57713V7L7 8.57713L5.42494 7.00275L5.42219 7L5.42494 6.99794L5.70062 6.72156L5.83469 6.5875L7 5.42288L8.57644 6.99931L8.57575 6.99863Z" fill="white"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$fantomIcon = `
  <svg height="100%" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.26613 0.133876C5.46683 0.0457135 5.68592 0 5.90775 0C6.12958 0 6.34867 0.0457135 6.54938 0.133876L10.2679 1.9598C10.3617 1.99893 10.4437 2.05898 10.5068 2.13465C10.5699 2.21033 10.6121 2.29932 10.6298 2.3938H10.6335V11.5637C10.6245 11.6667 10.5857 11.7654 10.5213 11.8495C10.457 11.9336 10.3694 11.9998 10.2679 12.0411L6.54938 13.8656C6.34867 13.9538 6.12958 13.9995 5.90775 13.9995C5.68592 13.9995 5.46683 13.9538 5.26613 13.8656L1.54762 12.0397C1.44724 11.9979 1.36095 11.9313 1.29799 11.8472C1.23504 11.7631 1.19779 11.6646 1.19025 11.5623C1.19025 11.5465 1.19025 11.5332 1.19025 11.522V2.39205C1.20579 2.29767 1.24673 2.20852 1.30923 2.13292C1.37173 2.05733 1.45375 1.99776 1.54762 1.9598L5.26613 0.133876ZM10.0478 7.50898L6.54938 9.22396C6.34872 9.31229 6.12961 9.35809 5.90775 9.35809C5.68589 9.35809 5.46678 9.31229 5.26613 9.22396L1.77525 7.51283V11.5455L5.26613 13.2493C5.43937 13.3471 5.62982 13.4154 5.82863 13.4512L5.9085 13.4558C6.12668 13.4357 6.3373 13.3704 6.525 13.2647L10.05 11.5301V7.50898H10.0478ZM0.585375 11.3642C0.568078 11.6186 0.612957 11.8734 0.716625 12.1093C0.805331 12.2602 0.936232 12.3857 1.09538 12.4726L1.10662 12.4796C1.1505 12.5069 1.1985 12.5356 1.25663 12.5692L1.32563 12.6081L1.53675 12.7267L1.23375 13.1922L0.9975 13.0592L0.95775 13.0365C0.889125 12.9973 0.8325 12.9637 0.779625 12.9315C0.214875 12.5769 0.004125 12.1912 0 11.3887V11.3642H0.585H0.585375ZM5.61412 5.05096C5.58845 5.05933 5.5634 5.06926 5.53912 5.08071L1.82137 6.90524L1.81013 6.91119H1.80675L1.81275 6.91469L1.82137 6.91889L5.53988 8.74341C5.56405 8.75505 5.58912 8.76499 5.61487 8.77316L5.61412 5.05096ZM6.201 5.05096V8.77456C6.22675 8.76639 6.25182 8.75645 6.276 8.74481L9.9945 6.92029L10.0057 6.91434H10.0091L10.0031 6.91154L9.9945 6.90699L6.276 5.08246C6.25182 5.07083 6.22675 5.06088 6.201 5.05271V5.05096ZM10.0478 3.04479L6.71025 4.68137L10.0478 6.31795V3.04304V3.04479ZM1.77525 3.04864V6.3141L5.103 4.68137L1.77525 3.04864ZM6.27525 0.61617C6.15894 0.569406 6.03364 0.545286 5.907 0.545286C5.78036 0.545286 5.65506 0.569406 5.53875 0.61617L1.821 2.4393L1.80975 2.4449L1.80638 2.44665L1.81238 2.4498L1.821 2.45365L5.5395 4.27817C5.65571 4.32526 5.78106 4.34956 5.90775 4.34956C6.03444 4.34956 6.15979 4.32526 6.276 4.27817L9.9945 2.45365L10.0057 2.4498L10.0091 2.44805L10.0031 2.4449L9.9945 2.4407L6.27525 0.61617ZM10.5968 0.816717L10.833 0.949365L10.875 0.970015C10.9432 1.00921 10.9999 1.04316 11.0528 1.07501C11.6179 1.42851 11.8282 1.81455 11.8328 2.61709V2.64159H11.2459C11.2632 2.38703 11.2183 2.13212 11.1146 1.8961C11.0258 1.74528 10.8948 1.61983 10.7355 1.53316L10.7242 1.52616C10.6807 1.49851 10.6327 1.47016 10.5743 1.43656L10.5056 1.39981L10.2945 1.28151L10.5975 0.816017L10.5968 0.816717Z" fill="white"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$optimismIcon = `
  <svg width="100%" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.33611 9.25254C2.38341 9.25254 1.60287 9.02834 0.99442 8.58002C0.393974 8.1237 0.09375 7.47526 0.09375 6.63462C0.09375 6.45849 0.113782 6.2423 0.153782 5.9861C0.257909 5.40972 0.406006 4.71718 0.598133 3.9086C1.14252 1.707 2.54757 0.606201 4.81323 0.606201C5.42967 0.606201 5.98206 0.710266 6.47044 0.918394C6.95882 1.11852 7.34308 1.42278 7.62327 1.8311C7.90346 2.23135 8.04362 2.71174 8.04362 3.27212C8.04362 3.44025 8.02359 3.65241 7.98352 3.9086C7.86346 4.62111 7.71933 5.31366 7.55121 5.9861C7.27101 7.08294 6.78666 7.90354 6.09815 8.44793C5.40964 8.98431 4.489 9.25254 3.33611 9.25254ZM3.50424 7.52326C3.95262 7.52326 4.33284 7.39116 4.6451 7.12697C4.96535 6.86278 5.19351 6.45849 5.32958 5.9141C5.51371 5.16153 5.65387 4.50502 5.74993 3.94463C5.78193 3.7765 5.79793 3.60441 5.79793 3.42822C5.79793 2.6997 5.41764 2.33542 4.65713 2.33542C4.20875 2.33542 3.82449 2.46751 3.50424 2.7317C3.19205 2.99596 2.96786 3.40025 2.83179 3.94463C2.68766 4.48102 2.54354 5.13753 2.39947 5.9141C2.36741 6.07417 2.35141 6.2423 2.35141 6.41842C2.35141 7.155 2.73573 7.52326 3.50424 7.52326Z" fill="white"/>
    <path d="M8.59569 9.13247C8.50762 9.13247 8.43953 9.10443 8.39153 9.04837C8.35146 8.98431 8.33949 8.9123 8.35549 8.83224L10.0127 1.02648C10.0287 0.938417 10.0727 0.866353 10.1448 0.810289C10.2169 0.754289 10.2929 0.726257 10.373 0.726257H13.5673C14.456 0.726257 15.1685 0.910385 15.7049 1.27864C16.2493 1.64696 16.5215 2.17931 16.5215 2.87582C16.5215 3.07595 16.4975 3.28415 16.4495 3.50027C16.2493 4.42098 15.845 5.10149 15.2366 5.54181C14.6361 5.98213 13.8115 6.20229 12.7627 6.20229H11.1415L10.5892 8.83224C10.5731 8.92031 10.5291 8.99231 10.4571 9.04837C10.385 9.10443 10.3089 9.13247 10.2289 9.13247H8.59569ZM12.8468 4.54507C13.183 4.54507 13.4752 4.45298 13.7234 4.26885C13.9796 4.08472 14.1478 3.82053 14.2278 3.47627C14.2518 3.34015 14.2639 3.22008 14.2639 3.11602C14.2639 2.88383 14.1958 2.7077 14.0597 2.58763C13.9236 2.45951 13.6914 2.3955 13.3632 2.3955H11.9221L11.4658 4.54507H12.8468Z" fill="white"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$avalancheIcon = `
  <svg width="100%" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.8682 0.489349H0.110352V18.4468H19.8682V0.489349Z" fill="white"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$celoIcon = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Symbol" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 384 383" style="enable-background:new 0 0 384 383;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#FCFF52;}
</style>
<path class="st0" d="M383.5,0H0.5v383h383V249.3h-63.6C298,298.1,248.7,332,192.3,332c-77.8,0-140.8-63.6-140.8-140.8
	C51.4,114,114.5,51,192.3,51c57.5,0,106.8,35,128.7,84.9h62.5V0z"/>
</svg>
`;
var $ddf18a96c86c2e3c$var$gnosisIcon = `
  <svg width="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z" fill="#04795B"/>
    <path d="M11.6529 17.4492C12.2831 17.4492 12.8648 17.2392 13.3334 16.8758L9.4877 13.0316C9.12413 13.4919 8.9141 14.0734 8.9141 14.7114C8.906 16.2216 10.134 17.4492 11.6529 17.4492Z" fill="#EFEFEF"/>
    <path d="M23.0931 14.7033C23.0931 14.0734 22.8831 13.4919 22.5195 13.0234L18.6738 16.8677C19.1343 17.2311 19.716 17.4411 20.3543 17.4411C21.8651 17.4492 23.0931 16.2216 23.0931 14.7033Z" fill="#EFEFEF"/>
    <path d="M25.0322 10.528L23.3275 12.2321C23.8931 12.9105 24.2324 13.7666 24.2324 14.7195C24.2324 16.8597 22.4954 18.5961 20.3544 18.5961C19.4092 18.5961 18.5447 18.2569 17.866 17.6915L15.9998 19.5571L14.1335 17.6915C13.4549 18.2569 12.5985 18.5961 11.6451 18.5961C9.50416 18.5961 7.7672 16.8597 7.7672 14.7195C7.7672 13.7746 8.10651 12.9105 8.67206 12.2321L7.79947 11.3599L6.96736 10.528C5.99787 12.1271 5.44043 13.9927 5.44043 15.9956C5.44043 21.8265 10.1667 26.543 15.9917 26.543C21.8167 26.543 26.543 21.8185 26.543 15.9956C26.5591 13.9846 26.0017 12.119 25.0322 10.528Z" fill="#EFEFEF"/>
    <path d="M23.6338 8.71084C21.7191 6.6999 19.0045 5.44 15.9991 5.44C12.9937 5.44 10.2872 6.6999 8.36435 8.71084C8.10584 8.98545 7.85539 9.27617 7.62109 9.575L15.991 17.9419L24.361 9.56695C24.1509 9.27617 23.9005 8.97734 23.6338 8.71084ZM15.9991 6.81297C18.4713 6.81297 20.7658 7.76593 22.4866 9.50231L15.9991 15.9874L9.5116 9.50231C11.2405 7.76593 13.5269 6.81297 15.9991 6.81297Z" fill="#EFEFEF"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$harmonyOneIcon = `
  <svg width="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5484 1.04102e-06C11.6346 -0.000708404 10.7578 0.361217 10.1105 1.00633C9.46322 1.65145 9.09835 2.52703 9.096 3.44089V7.256C8.74045 7.28 8.37689 7.29511 8 7.29511C7.62311 7.29511 7.26133 7.31022 6.904 7.33156V3.44089C6.88946 2.53496 6.51938 1.67105 5.87358 1.03553C5.22779 0.400017 4.35805 0.0438409 3.452 0.0438409C2.54595 0.0438409 1.67621 0.400017 1.03042 1.03553C0.384623 1.67105 0.0145378 2.53496 0 3.44089V12.5591C0.0145378 13.465 0.384623 14.329 1.03042 14.9645C1.67621 15.6 2.54595 15.9562 3.452 15.9562C4.35805 15.9562 5.22779 15.6 5.87358 14.9645C6.51938 14.329 6.88946 13.465 6.904 12.5591V8.744C7.25956 8.72 7.62311 8.70489 8 8.70489C8.37689 8.70489 8.73867 8.68978 9.096 8.66845V12.5591C9.11054 13.465 9.48062 14.329 10.1264 14.9645C10.7722 15.6 11.6419 15.9562 12.548 15.9562C13.4541 15.9562 14.3238 15.6 14.9696 14.9645C15.6154 14.329 15.9855 13.465 16 12.5591V3.44089C15.9976 2.52719 15.6329 1.65173 14.9858 1.00665C14.3387 0.361557 13.4622 -0.000472854 12.5484 1.04102e-06ZM3.45156 1.40978C3.99089 1.40954 4.50828 1.62326 4.89023 2.00404C5.27218 2.38482 5.48748 2.90156 5.48889 3.44089V7.48089C4.47892 7.62724 3.49264 7.90609 2.55556 8.31023C2.14954 8.48842 1.76733 8.71655 1.41778 8.98934V3.44089C1.41919 2.90218 1.634 2.38597 2.01518 2.00529C2.39636 1.62462 2.91284 1.41048 3.45156 1.40978ZM5.48889 12.5591C5.48889 13.0994 5.27424 13.6177 4.89217 13.9997C4.51009 14.3818 3.99189 14.5964 3.45156 14.5964C2.91122 14.5964 2.39302 14.3818 2.01094 13.9997C1.62887 13.6177 1.41422 13.0994 1.41422 12.5591V11.6444C1.41422 10.8364 2.05422 10.0711 3.12711 9.59467C3.88309 9.26852 4.6763 9.03656 5.48889 8.904V12.5591ZM12.5484 14.5902C12.0091 14.5905 11.4917 14.3767 11.1098 13.996C10.7278 13.6152 10.5125 13.0984 10.5111 12.5591V8.51911C11.5211 8.37276 12.5074 8.09392 13.4444 7.68978C13.8505 7.51159 14.2327 7.28345 14.5822 7.01067V12.5591C14.5808 13.0978 14.366 13.614 13.9848 13.9947C13.6036 14.3754 13.0872 14.5895 12.5484 14.5902ZM12.8729 6.4C12.1169 6.72615 11.3237 6.95811 10.5111 7.09067V3.44089C10.5111 2.90056 10.7258 2.38235 11.1078 2.00028C11.4899 1.6182 12.0081 1.40356 12.5484 1.40356C13.0888 1.40356 13.607 1.6182 13.9891 2.00028C14.3711 2.38235 14.5858 2.90056 14.5858 3.44089V4.35556C14.5858 5.16 13.9458 5.92534 12.8729 6.4Z" fill="url(#paint0_linear_10254_2422)"/>
    <defs>
      <linearGradient id="paint0_linear_10254_2422" x1="1.01333" y1="14.7674" x2="14.8954" y2="0.847434" gradientUnits="userSpaceOnUse">
        <stop stop-color="#00AEE9"/>
        <stop offset="1" stop-color="#69FABD"/>
      </linearGradient>
    </defs>
  </svg>
`;
var $ddf18a96c86c2e3c$var$arbitrumIcon = `
  <svg height="100%" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.7827 11.3172L15.5966 8.23933L20.4858 15.8545L20.4881 17.3159L20.4722 7.25942C20.4606 7.0136 20.3301 6.7887 20.1218 6.6561L11.3194 1.5928C11.1135 1.49162 10.8523 1.49269 10.6468 1.59594C10.6191 1.60989 10.593 1.62499 10.568 1.64147L10.5374 1.66079L1.99318 6.6121L1.95999 6.62712C1.91737 6.64674 1.8743 6.67165 1.83382 6.70063C1.67186 6.81683 1.56424 6.98861 1.52944 7.18131C1.52423 7.21052 1.52039 7.24026 1.51855 7.27023L1.53197 15.4653L6.08607 8.40666C6.65942 7.47067 7.90869 7.1692 9.06835 7.1856L10.4295 7.22155L2.40986 20.0827L3.3552 20.627L11.4709 7.23458L15.0581 7.22155L6.96327 20.9519L10.3366 22.8921L10.7396 23.1239C10.9101 23.1932 11.111 23.1967 11.283 23.1347L20.2091 17.9618L18.5026 18.9507L13.7827 11.3172ZM14.4747 21.2849L11.0677 15.9375L13.1474 12.4083L17.622 19.461L14.4747 21.2849Z" fill="#2D374B"/>
    <path d="M11.0684 15.9375L14.4754 21.2849L17.6228 19.4609L13.1482 12.4083L11.0684 15.9375Z" fill="#28A0F0"/>
    <path d="M20.4887 17.3159L20.4864 15.8545L15.5972 8.23932L13.7832 11.3172L18.5031 18.9507L20.2097 17.9618C20.3771 17.8259 20.4783 17.6264 20.489 17.4111L20.4887 17.3159Z" fill="#28A0F0"/>
    <path d="M7.71943e-05 18.694L2.41 20.0826L10.4296 7.22152L9.0685 7.18557C7.90883 7.16916 6.65964 7.47063 6.08621 8.40662L1.53211 15.4652L0 17.8193V18.694H7.71943e-05Z" fill="white"/>
    <path d="M15.0582 7.22156L11.4712 7.23459L3.35547 20.627L6.19211 22.2603L6.96354 20.9519L15.0582 7.22156Z" fill="white"/>
    <path d="M21.9999 7.20306C21.97 6.45287 21.5638 5.76608 20.9275 5.36626L12.0097 0.237888C11.3803 -0.079066 10.594 -0.0794494 9.96363 0.237658C9.88913 0.275218 1.2912 5.26171 1.2912 5.26171C1.17223 5.31874 1.05764 5.38673 0.949789 5.46384C0.381801 5.87094 0.0355663 6.50346 0 7.19846V17.8194L1.53211 15.4653L1.5187 7.27029C1.52054 7.24032 1.52429 7.21088 1.52958 7.18175C1.56415 6.9889 1.67185 6.81689 1.83397 6.70069C1.87444 6.67171 10.6192 1.60995 10.647 1.596C10.8526 1.49275 11.1137 1.49168 11.3195 1.59286L20.122 6.65616C20.3302 6.78876 20.4608 7.01366 20.4723 7.25948V17.4111C20.4617 17.6265 20.3766 17.8259 20.2092 17.9619L18.5026 18.9508L17.6221 19.461L14.4748 21.285L11.283 23.1347C11.1111 23.1968 10.9101 23.1933 10.7397 23.124L6.96334 20.952L6.19191 22.2603L9.58559 24.2142C9.6978 24.278 9.79784 24.3345 9.87985 24.3807C10.0069 24.452 10.0935 24.4996 10.1241 24.5144C10.3653 24.6315 10.7123 24.6997 11.025 24.6997C11.3118 24.6997 11.5913 24.647 11.8559 24.5434L21.1266 19.1745C21.6587 18.7623 21.9717 18.1406 21.9999 17.467V7.20306Z" fill="#96BEDC"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$baseIcon = `
<svg height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1607_202)">
<mask id="mask0_1607_202" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<path d="M32 0H0V32H32V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_1607_202)">
<path d="M16 32C19.1645 32 22.258 31.0616 24.8892 29.3036C27.5204 27.5454 29.571 25.0466 30.782 22.123C31.993 19.1993 32.31 15.9823 31.6926 12.8786C31.0752 9.77486 29.5514 6.92394 27.3138 4.6863C25.076 2.44866 22.2252 0.924806 19.1214 0.307442C16.0177 -0.30992 12.8007 0.0069325 9.87706 1.21793C6.95344 2.42894 4.45458 4.4797 2.69648 7.11088C0.938384 9.74206 0 12.8355 0 16C0 20.2434 1.68571 24.3132 4.6863 27.3138C7.68688 30.3142 11.7565 32 16 32Z" fill="#0052FF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9624 27.2676C22.1852 27.2676 27.23 22.223 27.23 16C27.23 9.7771 22.1852 4.73242 15.9624 4.73242C10.0588 4.73242 5.21566 9.2726 4.7341 15.0518H21.4546V16.928H4.73242C5.20432 22.7168 10.0519 27.2676 15.9624 27.2676Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_1607_202">
<rect width="32" height="32" fill="white"/>
</clipPath>
</defs>
</svg>
`;
var $ddf18a96c86c2e3c$var$hourglass = `
<svg width="100%" height="100%" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0L0.0100002 6L4 10L0.0100002 14.01L0 20H12V14L8 10L12 6.01V0H0ZM10 14.5V18H2V14.5L6 10.5L10 14.5Z" fill="#929BED"/>
</svg>
`;
var $ddf18a96c86c2e3c$export$f787f51d84a910ad = `
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.07 12.85C11.84 11.46 13.32 10.64 14.18 9.41C15.09 8.12 14.58 5.71 12 5.71C10.31 5.71 9.48 6.99 9.13 8.05L6.54 6.96C7.25 4.83 9.18 3 11.99 3C14.34 3 15.95 4.07 16.77 5.41C17.47 6.56 17.88 8.71 16.8 10.31C15.6 12.08 14.45 12.62 13.83 13.76C13.58 14.22 13.48 14.52 13.48 16H10.59C10.58 15.22 10.46 13.95 11.07 12.85ZM14 20C14 21.1 13.1 22 12 22C10.9 22 10 21.1 10 20C10 18.9 10.9 18 12 18C13.1 18 14 18.9 14 20Z" fill="currentColor"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$checkmark = `
<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.48076 8.10881L1.33076 4.95881L0.280762 6.00881L4.48076 10.2088L13.4808 1.20881L12.4308 0.158813L4.48076 8.10881Z" fill="#A4F4C6"/>
</svg>
`;
var $ddf18a96c86c2e3c$var$errorIcon = `<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.666992 13.0002H15.3337L8.00033 0.333496L0.666992 13.0002ZM8.66699 11.0002H7.33366V9.66683H8.66699V11.0002ZM8.66699 8.3335H7.33366V5.66683H8.66699V8.3335Z" fill="#FFB3B3"/>
</svg>
`;
var $ddf18a96c86c2e3c$var$infoIcon = `
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="currentColor"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$successIcon = `
  <svg width="100%" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.74999 12.15L3.59999 9L2.54999 10.05L6.74999 14.25L15.75 5.25L14.7 4.2L6.74999 12.15Z" fill="currentColor"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$pendingIcon = `
  <svg width="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 2L6.01 8L10 12L6.01 16.01L6 22H18V16L14 12L18 8.01V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5Z" fill="currenColor"/>
  </svg>
`;
var $ddf18a96c86c2e3c$var$degenIcon = `
<?xml version="1.0" encoding="UTF-8"?>
<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477 477">
  <defs>
    <style>.cls-1{fill:#a36dfe;}.cls-2{fill:#4b2895;}</style>
  </defs>
  <circle class="cls-1" cx="238.5" cy="238.5" r="238.5"/>
  <g>
    <path class="cls-2" d="M237.85,113.99c29.25,1.32,54.97,2.45,80.69,3.69,3.95,.19,7.92,.72,11.82,1.43,9.23,1.69,15.34,8.72,14.78,18.2-1.33,22.33-3.22,44.63-4.79,66.95-.81,11.47-1.49,22.96-2.12,34.44-.29,5.24-2.03,8.14-7.74,10.18-37.84,13.52-76.98,15.46-116.47,13.42-23.24-1.2-45.99-5.86-68.06-13.68-4.71-1.67-6.72-3.91-7.03-8.72-1.31-20.46-2.83-40.9-4.25-61.35-.94-13.55-2.1-27.1-2.7-40.66-.49-11.15,6.17-18.37,17.2-19.01,30.7-1.78,61.4-3.39,88.69-4.88Z"/><path class="cls-2" d="M238.34,363.01c-31.19-1.24-61.52-5.51-90.12-18.31-20.8-9.31-38.13-23.01-48.65-43.63-3.63-7.1-5.68-15.3-6.91-23.24-1.17-7.59,1.95-14.47,8.76-18.93,6.74-4.42,13.4-3.5,20.12,.38,14.24,8.24,14.6,8.18,14.39,24.44-.09,7.1,3.71,11.23,8.41,15.24,12.51,10.67,26.94,17.78,42.7,21.94,38.88,10.26,77.66,10.06,115.42-4.42,11.31-4.33,21.33-12.17,31.67-18.82,5.27-3.39,7.7-8.7,6.88-15.19-1.34-10.7,2.19-17.99,12.86-22.48,7.8-3.29,14.95-6.25,22.38-.72,7.42,5.53,9.4,13.33,7.88,22.37-4.05,24.14-19.06,40.5-38.25,53.68-18.5,12.7-39.59,19.06-61.42,22.61-15.24,2.48-30.72,3.44-46.1,5.09Z"/>
  </g>
</svg>
`;
function $ddf18a96c86c2e3c$var$getDevice() {
    if (typeof window !== "undefined") {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($hRLut))).getParser(window.navigator.userAgent);
        const os = parsed.getOS();
        const browser = parsed.getBrowser();
        const { type: type } = parsed.getPlatform();
        return {
            type: type,
            os: os,
            browser: browser
        };
    } else return {
        type: null,
        os: null,
        browser: null
    };
}
const $ddf18a96c86c2e3c$var$notNullish = (value)=>value != null;
function $ddf18a96c86c2e3c$export$34aec0b863436764(str) {
    return str.includes("<svg");
}
function $ddf18a96c86c2e3c$export$a9c23c6ac3fc3eca(add) {
    return `${add.slice(0, 6)}\u{2026}${add.slice(-4)}`;
}
function $ddf18a96c86c2e3c$export$96f57966bedc81b4(domain) {
    return domain.length > 11 ? `${domain.slice(0, 4)}\u{2026}${domain.slice(-6)}` : domain;
}
async function $ddf18a96c86c2e3c$export$3722cfe417b6ed86(text) {
    try {
        const copy = await navigator.clipboard.writeText(text);
        return copy;
    } catch (err) {
        console.error("Failed to copy: ", err);
    }
}
const $ddf18a96c86c2e3c$export$d24c54395ce0c509 = (val)=>typeof val === "number" ? `0x${val.toString(16)}` : val;
function $ddf18a96c86c2e3c$var$chainIdToHex(chains) {
    return chains.map((_a)=>{
        var { id: id } = _a, rest = $ddf18a96c86c2e3c$var$__rest(_a, [
            "id"
        ]);
        const hexId = $ddf18a96c86c2e3c$export$d24c54395ce0c509(id);
        return Object.assign({
            id: hexId
        }, rest);
    });
}
function $ddf18a96c86c2e3c$export$8a5498727ef6be21(gwei) {
    return `0x${(gwei * 1e9).toString(16)}`;
}
const $ddf18a96c86c2e3c$export$43caf9889c228507 = {
    "0x1": "Ethereum",
    "0xaa36a7": "Sepolia",
    "0x38": "Binance",
    "0x89": "Polygon",
    "0xfa": "Fantom",
    "0xa": "OP Mainnet",
    "0x45": "OP Kovan",
    "0xa86a": "Avalanche",
    "0xa4ec": "Celo",
    "0x2105": "Base",
    "0x14a33": "Base Goerli",
    "0x64": "Gnosis",
    "0x63564C40": "Harmony One",
    "0xa4b1": "Arbitrum One",
    "0xa4ba": "Arbitrum Nova",
    "0x27bc86aa": "Degen"
};
function $ddf18a96c86c2e3c$var$validEnsChain(chainId) {
    // return L2s as Eth for ens resolution
    switch(chainId){
        case "0x1":
        case "0x89":
        case "0xa":
        case "0xa4b1":
        case "0x144":
            return "0x1";
        case "0x5":
            return chainId;
        case "0xaa36a7":
            return chainId;
        default:
            return null;
    }
}


const $ddf18a96c86c2e3c$var$chainIdToViemENSImport = async (chainId)=>{
    switch(chainId){
        case "0x89":
        case "0xa":
        case "0xa4b1":
        case "0x144":
        case "0x1":
            {
                const { mainnet: mainnet } = await (parcelRequire("kMSZN"));
                return mainnet;
            }
        case "0xaa36a7":
            {
                const { sepolia: sepolia } = await (parcelRequire("kMSZN"));
                return sepolia;
            }
        default:
            return null;
    }
};
const $ddf18a96c86c2e3c$export$2f6ca3d3b1f80bf5 = {
    main: "0x1",
    sepolia: "0xaa36a7",
    xdai: "0x64",
    "bsc-main": "0x38",
    "matic-main": "0x89",
    "fantom-main": "0xfa",
    "matic-mumbai": "0x80001",
    degen: "0x27bc86aa"
};
const $ddf18a96c86c2e3c$export$6554612db691658e = {
    "0x1": {
        icon: $ddf18a96c86c2e3c$var$ethereumIcon,
        color: "#627EEA"
    },
    "0xaa36a7": {
        icon: $ddf18a96c86c2e3c$var$ethereumIcon,
        color: "#627EEA"
    },
    "0x38": {
        icon: $ddf18a96c86c2e3c$var$binanceIcon,
        color: "#F3BA2F"
    },
    "0x89": {
        icon: $ddf18a96c86c2e3c$var$polygonIcon,
        color: "#8247E5"
    },
    "0xfa": {
        icon: $ddf18a96c86c2e3c$var$fantomIcon,
        color: "#1969FF"
    },
    "0xa": {
        icon: $ddf18a96c86c2e3c$var$optimismIcon,
        color: "#FF0420"
    },
    "0x45": {
        icon: $ddf18a96c86c2e3c$var$optimismIcon,
        color: "#FF0420"
    },
    "0xa86a": {
        icon: $ddf18a96c86c2e3c$var$avalancheIcon,
        color: "#E84142"
    },
    "0xa4ec": {
        icon: $ddf18a96c86c2e3c$var$celoIcon,
        color: "#FBCC5C"
    },
    "0x64": {
        icon: $ddf18a96c86c2e3c$var$gnosisIcon,
        color: "#04795B"
    },
    "0x63564C40": {
        icon: $ddf18a96c86c2e3c$var$harmonyOneIcon,
        color: "#ffffff"
    },
    "0xa4b1": {
        icon: $ddf18a96c86c2e3c$var$arbitrumIcon,
        color: "#33394B"
    },
    "0xa4ba": {
        icon: $ddf18a96c86c2e3c$var$arbitrumIcon,
        color: "#33394B"
    },
    "0x2105": {
        icon: $ddf18a96c86c2e3c$var$baseIcon,
        color: "#0259F9"
    },
    "0x14a33": {
        icon: $ddf18a96c86c2e3c$var$baseIcon,
        color: "#0259F9"
    },
    "0x80001": {
        icon: $ddf18a96c86c2e3c$var$polygonIcon,
        color: "#8247E5"
    },
    "0x27bc86aa": {
        icon: $ddf18a96c86c2e3c$var$degenIcon,
        color: "#a36dfe"
    }
};
const $ddf18a96c86c2e3c$export$2e2af4578d910ddf = {
    icon: $ddf18a96c86c2e3c$export$f787f51d84a910ad,
    color: "#33394B"
};
function $ddf18a96c86c2e3c$export$efca4cbe5dd06740(chainId) {
    return chainId ? $ddf18a96c86c2e3c$export$6554612db691658e[chainId.toLowerCase()] : undefined;
}
function $ddf18a96c86c2e3c$export$dda1d9f60106f0e9(walletConnectedChain, chains) {
    return !!chains.find(({ id: id, namespace: namespace })=>id === walletConnectedChain.id && namespace === walletConnectedChain.namespace);
}
const $ddf18a96c86c2e3c$export$7a38258bbe170828 = {
    pending: {
        backgroundColor: "var(--onboard-primary-700, var(--primary-700))",
        borderColor: "#6370E5",
        eventIcon: $ddf18a96c86c2e3c$var$hourglass
    },
    success: {
        backgroundColor: "#052E17",
        borderColor: "var(--onboard-success-300, var(--success-300))",
        eventIcon: $ddf18a96c86c2e3c$var$checkmark
    },
    error: {
        backgroundColor: "#FDB1B11A",
        borderColor: "var(--onboard-danger-300, var(--danger-300))",
        eventIcon: $ddf18a96c86c2e3c$var$errorIcon
    },
    hint: {
        backgroundColor: "var(--onboard-gray-500, var(--gray-500))",
        borderColor: "var(--onboard-gray-500, var(--gray-500))",
        iconColor: "var(--onboard-gray-100, var(--gray-100))",
        eventIcon: $ddf18a96c86c2e3c$var$infoIcon
    }
};
const $ddf18a96c86c2e3c$var$wait$1 = (time)=>new Promise((resolve)=>setTimeout(resolve, time));
function $ddf18a96c86c2e3c$var$getLocalStore(key) {
    try {
        const result = localStorage.getItem(key);
        return result;
    } catch (error) {
        return null;
    }
}
function $ddf18a96c86c2e3c$var$setLocalStore(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch (error) {
        return;
    }
}
function $ddf18a96c86c2e3c$var$delLocalStore(key) {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        return;
    }
}
let $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57 = {
    svelteInstance: null,
    apiKey: undefined,
    device: $ddf18a96c86c2e3c$var$getDevice(),
    initialWalletInit: [],
    gas: undefined,
    containerElements: {
        accountCenter: undefined,
        connectModal: undefined
    },
    transactionPreview: undefined,
    unstoppableResolution: undefined,
    wagmi: undefined
};
function $ddf18a96c86c2e3c$var$updateConfiguration(update) {
    $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57 = Object.assign(Object.assign({}, $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57), update);
}
const $ddf18a96c86c2e3c$var$APP_INITIAL_STATE = {
    wallets: [],
    walletModules: [],
    chains: [],
    accountCenter: {
        enabled: true,
        position: "bottomRight",
        expanded: false,
        minimal: true
    },
    notify: {
        enabled: true,
        transactionHandler: ()=>{},
        position: "topRight",
        replacement: {
            gasPriceProbability: {
                speedup: 80,
                cancel: 95
            }
        }
    },
    notifications: [],
    locale: "",
    connect: {
        showSidebar: true,
        disableClose: false
    },
    appMetadata: null,
    wagmiConfig: null
};
const $ddf18a96c86c2e3c$var$STORAGE_KEYS = {
    TERMS_AGREEMENT: "onboard.js:agreement",
    LAST_CONNECTED_WALLET: "onboard.js:last_connected_wallet"
};
const $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH = 768;
const $ddf18a96c86c2e3c$export$995eb9fca571757 = "https://rpc.blocknative.com/boost";
const $ddf18a96c86c2e3c$export$a8550f7dbe79f93a = "https://docs.blocknative.com/blocknative-mev-protection/transaction-boost";
const $ddf18a96c86c2e3c$var$ADD_CHAINS = "add_chains";
const $ddf18a96c86c2e3c$var$UPDATE_CHAINS = "update_chains";
const $ddf18a96c86c2e3c$var$RESET_STORE = "reset_store";
const $ddf18a96c86c2e3c$var$ADD_WALLET = "add_wallet";
const $ddf18a96c86c2e3c$var$UPDATE_WALLET = "update_wallet";
const $ddf18a96c86c2e3c$var$REMOVE_WALLET = "remove_wallet";
const $ddf18a96c86c2e3c$var$UPDATE_ACCOUNT = "update_account";
const $ddf18a96c86c2e3c$var$UPDATE_ACCOUNT_CENTER = "update_account_center";
const $ddf18a96c86c2e3c$var$UPDATE_CONNECT_MODAL = "update_connect_modal";
const $ddf18a96c86c2e3c$var$SET_WALLET_MODULES = "set_wallet_modules";
const $ddf18a96c86c2e3c$var$SET_LOCALE = "set_locale";
const $ddf18a96c86c2e3c$var$UPDATE_NOTIFY = "update_notify";
const $ddf18a96c86c2e3c$var$ADD_NOTIFICATION = "add_notification";
const $ddf18a96c86c2e3c$var$REMOVE_NOTIFICATION = "remove_notification";
const $ddf18a96c86c2e3c$var$UPDATE_ALL_WALLETS = "update_balance";
const $ddf18a96c86c2e3c$var$UPDATE_APP_METADATA = "update_app_metadata";
const $ddf18a96c86c2e3c$var$UPDATE_WAGMI_CONFIG = "update_wagmi_config";
function $ddf18a96c86c2e3c$var$reducer(state1, action) {
    const { type: type, payload: payload } = action;
    switch(type){
        case $ddf18a96c86c2e3c$var$ADD_CHAINS:
            return Object.assign(Object.assign({}, state1), {
                chains: [
                    ...state1.chains,
                    ...payload
                ]
            });
        case $ddf18a96c86c2e3c$var$UPDATE_CHAINS:
            {
                const updatedChain = payload;
                const chains = state1.chains;
                const index = chains.findIndex((chain)=>chain.id === updatedChain.id);
                chains[index] = updatedChain;
                return Object.assign(Object.assign({}, state1), {
                    chains: chains
                });
            }
        case $ddf18a96c86c2e3c$var$ADD_WALLET:
            {
                const wallet = payload;
                const existingWallet = state1.wallets.find(({ label: label })=>label === wallet.label);
                return Object.assign(Object.assign({}, state1), {
                    wallets: [
                        // add to front of wallets as it is now the primary wallet
                        existingWallet || payload,
                        // filter out wallet if it already existed
                        ...state1.wallets.filter(({ label: label })=>label !== wallet.label)
                    ]
                });
            }
        case $ddf18a96c86c2e3c$var$UPDATE_WALLET:
            {
                const update = payload;
                const { id: id } = update, walletUpdate = $ddf18a96c86c2e3c$var$__rest(update, [
                    "id"
                ]);
                const updatedWallets = state1.wallets.map((wallet)=>wallet.label === id ? Object.assign(Object.assign({}, wallet), walletUpdate) : wallet);
                return Object.assign(Object.assign({}, state1), {
                    wallets: updatedWallets
                });
            }
        case $ddf18a96c86c2e3c$var$REMOVE_WALLET:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state1), {
                    wallets: state1.wallets.filter(({ label: label })=>label !== update.id)
                });
            }
        case $ddf18a96c86c2e3c$var$UPDATE_ACCOUNT:
            {
                const update = payload;
                const { id: id, address: address } = update, accountUpdate = $ddf18a96c86c2e3c$var$__rest(update, [
                    "id",
                    "address"
                ]);
                const updatedWallets = state1.wallets.map((wallet)=>{
                    if (wallet.label === id) wallet.accounts = wallet.accounts.map((account)=>{
                        if (account.address === address) return Object.assign(Object.assign({}, account), accountUpdate);
                        return account;
                    });
                    return wallet;
                });
                return Object.assign(Object.assign({}, state1), {
                    wallets: updatedWallets
                });
            }
        case $ddf18a96c86c2e3c$var$UPDATE_ALL_WALLETS:
            {
                const updatedWallets = payload;
                return Object.assign(Object.assign({}, state1), {
                    wallets: updatedWallets
                });
            }
        case $ddf18a96c86c2e3c$var$UPDATE_CONNECT_MODAL:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state1), {
                    connect: Object.assign(Object.assign({}, state1.connect), update)
                });
            }
        case $ddf18a96c86c2e3c$var$UPDATE_ACCOUNT_CENTER:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state1), {
                    accountCenter: Object.assign(Object.assign({}, state1.accountCenter), update)
                });
            }
        case $ddf18a96c86c2e3c$var$UPDATE_NOTIFY:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state1), {
                    notify: Object.assign(Object.assign({}, state1.notify), update)
                });
            }
        case $ddf18a96c86c2e3c$var$ADD_NOTIFICATION:
            {
                const update = payload;
                const notificationsUpdate = [
                    ...state1.notifications
                ];
                const notificationExistsIndex = notificationsUpdate.findIndex(({ id: id })=>id === update.id);
                if (notificationExistsIndex !== -1) // if notification with same id, replace it with update
                notificationsUpdate[notificationExistsIndex] = update;
                else // otherwise add it to the beginning of array as new notification
                notificationsUpdate.unshift(update);
                return Object.assign(Object.assign({}, state1), {
                    notifications: notificationsUpdate
                });
            }
        case $ddf18a96c86c2e3c$var$REMOVE_NOTIFICATION:
            {
                const id = payload;
                return Object.assign(Object.assign({}, state1), {
                    notifications: state1.notifications.filter((notification)=>notification.id !== id)
                });
            }
        case $ddf18a96c86c2e3c$var$SET_WALLET_MODULES:
            return Object.assign(Object.assign({}, state1), {
                walletModules: payload
            });
        case $ddf18a96c86c2e3c$var$SET_LOCALE:
            // Set the locale in the svelte-i18n internal state
            (0, $8VqiI.locale).set(payload);
            return Object.assign(Object.assign({}, state1), {
                locale: payload
            });
        case $ddf18a96c86c2e3c$var$UPDATE_APP_METADATA:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state1), {
                    appMetadata: Object.assign(Object.assign(Object.assign({}, state1.appMetadata), update), {
                        name: update.name || ""
                    })
                });
            }
        case $ddf18a96c86c2e3c$var$UPDATE_WAGMI_CONFIG:
            {
                const update = payload;
                return Object.assign(Object.assign({}, state1), {
                    wagmiConfig: update
                });
            }
        case $ddf18a96c86c2e3c$var$RESET_STORE:
            return $ddf18a96c86c2e3c$var$APP_INITIAL_STATE;
        default:
            throw new Error(`Unknown type: ${type} in appStore reducer`);
    }
}
const $ddf18a96c86c2e3c$var$_store = new (0, $l4gH8.BehaviorSubject)($ddf18a96c86c2e3c$var$APP_INITIAL_STATE);
const $ddf18a96c86c2e3c$var$_stateUpdates = new (0, $6jCRi.Subject)();
$ddf18a96c86c2e3c$var$_stateUpdates.subscribe($ddf18a96c86c2e3c$var$_store);
function $ddf18a96c86c2e3c$var$dispatch$1(action) {
    const state1 = $ddf18a96c86c2e3c$var$_store.getValue();
    $ddf18a96c86c2e3c$var$_stateUpdates.next($ddf18a96c86c2e3c$var$reducer(state1, action));
}
function $ddf18a96c86c2e3c$var$select(stateKey) {
    if (!stateKey) return $ddf18a96c86c2e3c$var$_stateUpdates.asObservable();
    const validStateKeys = Object.keys($ddf18a96c86c2e3c$var$_store.getValue());
    if (!validStateKeys.includes(String(stateKey))) throw new Error(`key: ${stateKey} does not exist on this store`);
    return $ddf18a96c86c2e3c$var$_stateUpdates.asObservable().pipe((0, $fR4Va.distinctUntilKeyChanged)(stateKey), (0, $7J7ms.pluck)(stateKey), (0, $bPD7y.filter)($ddf18a96c86c2e3c$var$notNullish));
}
function $ddf18a96c86c2e3c$var$get() {
    return $ddf18a96c86c2e3c$var$_store.getValue();
}
const $ddf18a96c86c2e3c$export$6559d589eb85fbb6 = {
    select: $ddf18a96c86c2e3c$var$select,
    get: $ddf18a96c86c2e3c$var$get
};
function $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5() {}
const $ddf18a96c86c2e3c$var$identity = (x)=>x;
function $ddf18a96c86c2e3c$var$assign(tar, src) {
    // @ts-ignore
    for(const k in src)tar[k] = src[k];
    return tar;
}
// Adapted from https://github.com/then/is-promise/blob/master/index.js
// Distributed under MIT License https://github.com/then/is-promise/blob/master/LICENSE
function $ddf18a96c86c2e3c$var$is_promise(value) {
    return !!value && (typeof value === "object" || typeof value === "function") && typeof value.then === "function";
}
function $ddf18a96c86c2e3c$var$run(fn) {
    return fn();
}
function $ddf18a96c86c2e3c$var$blank_object() {
    return Object.create(null);
}
function $ddf18a96c86c2e3c$export$61196ced6d74a310(fns) {
    fns.forEach($ddf18a96c86c2e3c$var$run);
}
function $ddf18a96c86c2e3c$export$dc98b0b04f4c7758(thing) {
    return typeof thing === "function";
}
function $ddf18a96c86c2e3c$export$2408f22a0fab9ae5(a, b) {
    return a != a ? b == b : a !== b || a && typeof a === "object" || typeof a === "function";
}
let $ddf18a96c86c2e3c$var$src_url_equal_anchor;
function $ddf18a96c86c2e3c$export$3c2fa207a37baaea(element_src, url) {
    if (!$ddf18a96c86c2e3c$var$src_url_equal_anchor) $ddf18a96c86c2e3c$var$src_url_equal_anchor = document.createElement("a");
    $ddf18a96c86c2e3c$var$src_url_equal_anchor.href = url;
    return element_src === $ddf18a96c86c2e3c$var$src_url_equal_anchor.href;
}
function $ddf18a96c86c2e3c$var$is_empty(obj) {
    return Object.keys(obj).length === 0;
}
function $ddf18a96c86c2e3c$var$subscribe(store, ...callbacks) {
    if (store == null) return $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5;
    const unsub = store.subscribe(...callbacks);
    return unsub.unsubscribe ? ()=>unsub.unsubscribe() : unsub;
}
function $ddf18a96c86c2e3c$export$db3b6bfb95261072(component, store, callback) {
    component.$$.on_destroy.push($ddf18a96c86c2e3c$var$subscribe(store, callback));
}
function $ddf18a96c86c2e3c$var$create_slot(definition, ctx, $$scope, fn) {
    if (definition) {
        const slot_ctx = $ddf18a96c86c2e3c$var$get_slot_context(definition, ctx, $$scope, fn);
        return definition[0](slot_ctx);
    }
}
function $ddf18a96c86c2e3c$var$get_slot_context(definition, ctx, $$scope, fn) {
    return definition[1] && fn ? $ddf18a96c86c2e3c$var$assign($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}
function $ddf18a96c86c2e3c$var$get_slot_changes(definition, $$scope, dirty, fn) {
    if (definition[2] && fn) {
        const lets = definition[2](fn(dirty));
        if ($$scope.dirty === undefined) return lets;
        if (typeof lets === "object") {
            const merged = [];
            const len = Math.max($$scope.dirty.length, lets.length);
            for(let i = 0; i < len; i += 1)merged[i] = $$scope.dirty[i] | lets[i];
            return merged;
        }
        return $$scope.dirty | lets;
    }
    return $$scope.dirty;
}
function $ddf18a96c86c2e3c$var$update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
    if (slot_changes) {
        const slot_context = $ddf18a96c86c2e3c$var$get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
        slot.p(slot_context, slot_changes);
    }
}
function $ddf18a96c86c2e3c$var$get_all_dirty_from_scope($$scope) {
    if ($$scope.ctx.length > 32) {
        const dirty = [];
        const length = $$scope.ctx.length / 32;
        for(let i = 0; i < length; i++)dirty[i] = -1;
        return dirty;
    }
    return -1;
}
function $ddf18a96c86c2e3c$export$882b5998b3b9117c(value) {
    return value == null ? "" : value;
}
function $ddf18a96c86c2e3c$var$split_css_unit(value) {
    const split = typeof value === "string" && value.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
    return split ? [
        parseFloat(split[1]),
        split[2] || "px"
    ] : [
        value,
        "px"
    ];
}
const $ddf18a96c86c2e3c$var$is_client = typeof window !== "undefined";
let $ddf18a96c86c2e3c$var$now = $ddf18a96c86c2e3c$var$is_client ? ()=>window.performance.now() : ()=>Date.now();
let $ddf18a96c86c2e3c$var$raf = $ddf18a96c86c2e3c$var$is_client ? (cb)=>requestAnimationFrame(cb) : $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5;
const $ddf18a96c86c2e3c$var$tasks = new Set();
function $ddf18a96c86c2e3c$var$run_tasks(now) {
    $ddf18a96c86c2e3c$var$tasks.forEach((task)=>{
        if (!task.c(now)) {
            $ddf18a96c86c2e3c$var$tasks.delete(task);
            task.f();
        }
    });
    if ($ddf18a96c86c2e3c$var$tasks.size !== 0) $ddf18a96c86c2e3c$var$raf($ddf18a96c86c2e3c$var$run_tasks);
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */ function $ddf18a96c86c2e3c$var$loop(callback) {
    let task;
    if ($ddf18a96c86c2e3c$var$tasks.size === 0) $ddf18a96c86c2e3c$var$raf($ddf18a96c86c2e3c$var$run_tasks);
    return {
        promise: new Promise((fulfill)=>{
            $ddf18a96c86c2e3c$var$tasks.add(task = {
                c: callback,
                f: fulfill
            });
        }),
        abort () {
            $ddf18a96c86c2e3c$var$tasks.delete(task);
        }
    };
}
function $ddf18a96c86c2e3c$export$953cecd6e717a553(target, node) {
    target.appendChild(node);
}
function $ddf18a96c86c2e3c$export$407448d2b89b1813(target, style_sheet_id, styles) {
    const append_styles_to = $ddf18a96c86c2e3c$var$get_root_for_style(target);
    if (!append_styles_to.getElementById(style_sheet_id)) {
        const style = $ddf18a96c86c2e3c$export$35e795649ee09318("style");
        style.id = style_sheet_id;
        style.textContent = styles;
        $ddf18a96c86c2e3c$var$append_stylesheet(append_styles_to, style);
    }
}
function $ddf18a96c86c2e3c$var$get_root_for_style(node) {
    if (!node) return document;
    const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    if (root && root.host) return root;
    return node.ownerDocument;
}
function $ddf18a96c86c2e3c$var$append_empty_stylesheet(node) {
    const style_element = $ddf18a96c86c2e3c$export$35e795649ee09318("style");
    $ddf18a96c86c2e3c$var$append_stylesheet($ddf18a96c86c2e3c$var$get_root_for_style(node), style_element);
    return style_element.sheet;
}
function $ddf18a96c86c2e3c$var$append_stylesheet(node, style) {
    $ddf18a96c86c2e3c$export$953cecd6e717a553(node.head || node, style);
    return style.sheet;
}
function $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
function $ddf18a96c86c2e3c$export$4368d992c4eafac0(node) {
    if (node.parentNode) node.parentNode.removeChild(node);
}
function $ddf18a96c86c2e3c$export$ef35774e6d314e91(iterations, detaching) {
    for(let i = 0; i < iterations.length; i += 1)if (iterations[i]) iterations[i].d(detaching);
}
function $ddf18a96c86c2e3c$export$35e795649ee09318(name) {
    return document.createElement(name);
}
function $ddf18a96c86c2e3c$var$svg_element(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function $ddf18a96c86c2e3c$export$625550452a3fa3ec(data) {
    return document.createTextNode(data);
}
function $ddf18a96c86c2e3c$export$2329c99376c9d0a4() {
    return $ddf18a96c86c2e3c$export$625550452a3fa3ec(" ");
}
function $ddf18a96c86c2e3c$export$f1e1789686576879() {
    return $ddf18a96c86c2e3c$export$625550452a3fa3ec("");
}
function $ddf18a96c86c2e3c$export$ffb5f4729a158638(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return ()=>node.removeEventListener(event, handler, options);
}
function $ddf18a96c86c2e3c$export$b4171a6734a65d42(fn) {
    return function(event) {
        event.stopPropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $ddf18a96c86c2e3c$export$342063e11d6c3cad(node, attribute, value) {
    if (value == null) node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}
function $ddf18a96c86c2e3c$var$children(element) {
    return Array.from(element.childNodes);
}
function $ddf18a96c86c2e3c$export$90a7f3efeed30595(text, data) {
    data = "" + data;
    if (text.data === data) return;
    text.data = data;
}
function $ddf18a96c86c2e3c$export$971d5caa766a69d7(node, key, value, important) {
    if (value == null) node.style.removeProperty(key);
    else node.style.setProperty(key, value, important ? "important" : "");
}
function $ddf18a96c86c2e3c$export$ae1af26003f05816(select, value, mounting) {
    for(let i = 0; i < select.options.length; i += 1){
        const option = select.options[i];
        if (option.__value === value) {
            option.selected = true;
            return;
        }
    }
    if (!mounting || value !== undefined) select.selectedIndex = -1; // no option should be selected
}
function $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(element, name, toggle) {
    element.classList[toggle ? "add" : "remove"](name);
}
function $ddf18a96c86c2e3c$var$custom_event(type, detail, { bubbles: bubbles = false, cancelable: cancelable = false } = {}) {
    const e = document.createEvent("CustomEvent");
    e.initCustomEvent(type, bubbles, cancelable, detail);
    return e;
}
class $ddf18a96c86c2e3c$export$ce26c07117d59d6a {
    constructor(is_svg = false){
        this.is_svg = false;
        this.is_svg = is_svg;
        this.e = this.n = null;
    }
    c(html) {
        this.h(html);
    }
    m(html, target, anchor = null) {
        if (!this.e) {
            if (this.is_svg) this.e = $ddf18a96c86c2e3c$var$svg_element(target.nodeName);
            else this.e = $ddf18a96c86c2e3c$export$35e795649ee09318(target.nodeType === 11 ? "TEMPLATE" : target.nodeName);
            this.t = target.tagName !== "TEMPLATE" ? target : target.content;
            this.c(html);
        }
        this.i(anchor);
    }
    h(html) {
        this.e.innerHTML = html;
        this.n = Array.from(this.e.nodeName === "TEMPLATE" ? this.e.content.childNodes : this.e.childNodes);
    }
    i(anchor) {
        for(let i = 0; i < this.n.length; i += 1)$ddf18a96c86c2e3c$export$8b22cf2602fb60ce(this.t, this.n[i], anchor);
    }
    p(html) {
        this.d();
        this.h(html);
        this.i(this.a);
    }
    d() {
        this.n.forEach($ddf18a96c86c2e3c$export$4368d992c4eafac0);
    }
}
function $ddf18a96c86c2e3c$var$construct_svelte_component(component, props) {
    return new component(props);
}
// we need to store the information for multiple documents because a Svelte application could also contain iframes
// https://github.com/sveltejs/svelte/issues/3624
const $ddf18a96c86c2e3c$var$managed_styles = new Map();
let $ddf18a96c86c2e3c$var$active = 0;
// https://github.com/darkskyapp/string-hash/blob/master/index.js
function $ddf18a96c86c2e3c$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i--)hash = (hash << 5) - hash ^ str.charCodeAt(i);
    return hash >>> 0;
}
function $ddf18a96c86c2e3c$var$create_style_information(doc, node) {
    const info = {
        stylesheet: $ddf18a96c86c2e3c$var$append_empty_stylesheet(node),
        rules: {}
    };
    $ddf18a96c86c2e3c$var$managed_styles.set(doc, info);
    return info;
}
function $ddf18a96c86c2e3c$var$create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
    const step = 16.666 / duration;
    let keyframes = "{\n";
    for(let p = 0; p <= 1; p += step){
        const t = a + (b - a) * ease(p);
        keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
    }
    const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
    const name = `__svelte_${$ddf18a96c86c2e3c$var$hash(rule)}_${uid}`;
    const doc = $ddf18a96c86c2e3c$var$get_root_for_style(node);
    const { stylesheet: stylesheet, rules: rules } = $ddf18a96c86c2e3c$var$managed_styles.get(doc) || $ddf18a96c86c2e3c$var$create_style_information(doc, node);
    if (!rules[name]) {
        rules[name] = true;
        stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
    }
    const animation = node.style.animation || "";
    node.style.animation = `${animation ? `${animation}, ` : ""}${name} ${duration}ms linear ${delay}ms 1 both`;
    $ddf18a96c86c2e3c$var$active += 1;
    return name;
}
function $ddf18a96c86c2e3c$var$delete_rule(node, name) {
    const previous = (node.style.animation || "").split(", ");
    const next = previous.filter(name ? (anim)=>anim.indexOf(name) < 0 // remove specific animation
     : (anim)=>anim.indexOf("__svelte") === -1 // remove all Svelte animations
    );
    const deleted = previous.length - next.length;
    if (deleted) {
        node.style.animation = next.join(", ");
        $ddf18a96c86c2e3c$var$active -= deleted;
        if (!$ddf18a96c86c2e3c$var$active) $ddf18a96c86c2e3c$var$clear_rules();
    }
}
function $ddf18a96c86c2e3c$var$clear_rules() {
    $ddf18a96c86c2e3c$var$raf(()=>{
        if ($ddf18a96c86c2e3c$var$active) return;
        $ddf18a96c86c2e3c$var$managed_styles.forEach((info)=>{
            const { ownerNode: ownerNode } = info.stylesheet;
            // there is no ownerNode if it runs on jsdom.
            if (ownerNode) $ddf18a96c86c2e3c$export$4368d992c4eafac0(ownerNode);
        });
        $ddf18a96c86c2e3c$var$managed_styles.clear();
    });
}
function $ddf18a96c86c2e3c$export$3d12bd131bb975d1(node, from, fn, params) {
    if (!from) return $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5;
    const to = node.getBoundingClientRect();
    if (from.left === to.left && from.right === to.right && from.top === to.top && from.bottom === to.bottom) return $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5;
    const { delay: delay = 0, duration: duration = 300, easing: easing = $ddf18a96c86c2e3c$var$identity, // @ts-ignore todo: should this be separated from destructuring? Or start/end added to public api and documentation?
    start: start_time = $ddf18a96c86c2e3c$var$now() + delay, end: // @ts-ignore todo:
    end = start_time + duration, tick: tick = $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5, css: css } = fn(node, {
        from: from,
        to: to
    }, params);
    let running = true;
    let started = false;
    let name;
    function start() {
        if (css) name = $ddf18a96c86c2e3c$var$create_rule(node, 0, 1, duration, delay, easing, css);
        if (!delay) started = true;
    }
    function stop() {
        if (css) $ddf18a96c86c2e3c$var$delete_rule(node, name);
        running = false;
    }
    $ddf18a96c86c2e3c$var$loop((now)=>{
        if (!started && now >= start_time) started = true;
        if (started && now >= end) {
            tick(1, 0);
            stop();
        }
        if (!running) return false;
        if (started) {
            const p = now - start_time;
            const t = 0 + 1 * easing(p / duration);
            tick(t, 1 - t);
        }
        return true;
    });
    start();
    tick(0, 1);
    return stop;
}
function $ddf18a96c86c2e3c$export$9fa96a7d116ea3ce(node) {
    const style = getComputedStyle(node);
    if (style.position !== "absolute" && style.position !== "fixed") {
        const { width: width, height: height } = style;
        const a = node.getBoundingClientRect();
        node.style.position = "absolute";
        node.style.width = width;
        node.style.height = height;
        $ddf18a96c86c2e3c$export$28f7fcd39efa255(node, a);
    }
}
function $ddf18a96c86c2e3c$export$28f7fcd39efa255(node, a) {
    const b = node.getBoundingClientRect();
    if (a.left !== b.left || a.top !== b.top) {
        const style = getComputedStyle(node);
        const transform = style.transform === "none" ? "" : style.transform;
        node.style.transform = `${transform} translate(${a.left - b.left}px, ${a.top - b.top}px)`;
    }
}
let $ddf18a96c86c2e3c$var$current_component;
function $ddf18a96c86c2e3c$var$set_current_component(component) {
    $ddf18a96c86c2e3c$var$current_component = component;
}
function $ddf18a96c86c2e3c$var$get_current_component() {
    if (!$ddf18a96c86c2e3c$var$current_component) throw new Error("Function called outside component initialization");
    return $ddf18a96c86c2e3c$var$current_component;
}
/**
 * Schedules a callback to run immediately before the component is updated after any state change.
 *
 * The first time the callback runs will be before the initial `onMount`
 *
 * https://svelte.dev/docs#run-time-svelte-beforeupdate
 */ function $ddf18a96c86c2e3c$var$beforeUpdate(fn) {
    $ddf18a96c86c2e3c$var$get_current_component().$$.before_update.push(fn);
}
/**
 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
 * it can be called from an external module).
 *
 * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
 *
 * https://svelte.dev/docs#run-time-svelte-onmount
 */ function $ddf18a96c86c2e3c$var$onMount(fn) {
    $ddf18a96c86c2e3c$var$get_current_component().$$.on_mount.push(fn);
}
/**
 * Schedules a callback to run immediately after the component has been updated.
 *
 * The first time the callback runs will be after the initial `onMount`
 */ function $ddf18a96c86c2e3c$var$afterUpdate(fn) {
    $ddf18a96c86c2e3c$var$get_current_component().$$.after_update.push(fn);
}
/**
 * Schedules a callback to run immediately before the component is unmounted.
 *
 * Out of `onMount`, `beforeUpdate`, `afterUpdate` and `onDestroy`, this is the
 * only one that runs inside a server-side component.
 *
 * https://svelte.dev/docs#run-time-svelte-ondestroy
 */ function $ddf18a96c86c2e3c$export$ab83b03e4111b1d0(fn) {
    $ddf18a96c86c2e3c$var$get_current_component().$$.on_destroy.push(fn);
}
// TODO figure out if we still want to support
// shorthand events, or if we want to implement
// a real bubbling mechanism
function $ddf18a96c86c2e3c$export$f38c853ae54ed474(component, event) {
    const callbacks = component.$$.callbacks[event.type];
    if (callbacks) // @ts-ignore
    callbacks.slice().forEach((fn)=>fn.call(this, event));
}
const $ddf18a96c86c2e3c$var$dirty_components = [];
const $ddf18a96c86c2e3c$export$39b482c5e57630a8 = [];
let $ddf18a96c86c2e3c$var$render_callbacks = [];
const $ddf18a96c86c2e3c$var$flush_callbacks = [];
const $ddf18a96c86c2e3c$var$resolved_promise = /* @__PURE__ */ Promise.resolve();
let $ddf18a96c86c2e3c$var$update_scheduled = false;
function $ddf18a96c86c2e3c$var$schedule_update() {
    if (!$ddf18a96c86c2e3c$var$update_scheduled) {
        $ddf18a96c86c2e3c$var$update_scheduled = true;
        $ddf18a96c86c2e3c$var$resolved_promise.then($ddf18a96c86c2e3c$var$flush);
    }
}
function $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(fn) {
    $ddf18a96c86c2e3c$var$render_callbacks.push(fn);
}
function $ddf18a96c86c2e3c$export$4c3d22f3d993c33f(fn) {
    $ddf18a96c86c2e3c$var$flush_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const $ddf18a96c86c2e3c$var$seen_callbacks = new Set();
let $ddf18a96c86c2e3c$var$flushidx = 0; // Do *not* move this inside the flush() function
function $ddf18a96c86c2e3c$var$flush() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if ($ddf18a96c86c2e3c$var$flushidx !== 0) return;
    const saved_component = $ddf18a96c86c2e3c$var$current_component;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while($ddf18a96c86c2e3c$var$flushidx < $ddf18a96c86c2e3c$var$dirty_components.length){
                const component = $ddf18a96c86c2e3c$var$dirty_components[$ddf18a96c86c2e3c$var$flushidx];
                $ddf18a96c86c2e3c$var$flushidx++;
                $ddf18a96c86c2e3c$var$set_current_component(component);
                $ddf18a96c86c2e3c$var$update(component.$$);
            }
        } catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            $ddf18a96c86c2e3c$var$dirty_components.length = 0;
            $ddf18a96c86c2e3c$var$flushidx = 0;
            throw e;
        }
        $ddf18a96c86c2e3c$var$set_current_component(null);
        $ddf18a96c86c2e3c$var$dirty_components.length = 0;
        $ddf18a96c86c2e3c$var$flushidx = 0;
        while($ddf18a96c86c2e3c$export$39b482c5e57630a8.length)$ddf18a96c86c2e3c$export$39b482c5e57630a8.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for(let i = 0; i < $ddf18a96c86c2e3c$var$render_callbacks.length; i += 1){
            const callback = $ddf18a96c86c2e3c$var$render_callbacks[i];
            if (!$ddf18a96c86c2e3c$var$seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                $ddf18a96c86c2e3c$var$seen_callbacks.add(callback);
                callback();
            }
        }
        $ddf18a96c86c2e3c$var$render_callbacks.length = 0;
    }while ($ddf18a96c86c2e3c$var$dirty_components.length);
    while($ddf18a96c86c2e3c$var$flush_callbacks.length)$ddf18a96c86c2e3c$var$flush_callbacks.pop()();
    $ddf18a96c86c2e3c$var$update_scheduled = false;
    $ddf18a96c86c2e3c$var$seen_callbacks.clear();
    $ddf18a96c86c2e3c$var$set_current_component(saved_component);
}
function $ddf18a96c86c2e3c$var$update($$) {
    if ($$.fragment !== null) {
        $$.update();
        $ddf18a96c86c2e3c$export$61196ced6d74a310($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [
            -1
        ];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach($ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 */ function $ddf18a96c86c2e3c$var$flush_render_callbacks(fns) {
    const filtered = [];
    const targets = [];
    $ddf18a96c86c2e3c$var$render_callbacks.forEach((c)=>fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c)=>c());
    $ddf18a96c86c2e3c$var$render_callbacks = filtered;
}
let $ddf18a96c86c2e3c$var$promise;
function $ddf18a96c86c2e3c$var$wait() {
    if (!$ddf18a96c86c2e3c$var$promise) {
        $ddf18a96c86c2e3c$var$promise = Promise.resolve();
        $ddf18a96c86c2e3c$var$promise.then(()=>{
            $ddf18a96c86c2e3c$var$promise = null;
        });
    }
    return $ddf18a96c86c2e3c$var$promise;
}
function $ddf18a96c86c2e3c$var$dispatch(node, direction, kind) {
    node.dispatchEvent($ddf18a96c86c2e3c$var$custom_event(`${direction ? "intro" : "outro"}${kind}`));
}
const $ddf18a96c86c2e3c$var$outroing = new Set();
let $ddf18a96c86c2e3c$var$outros;
function $ddf18a96c86c2e3c$export$4a5767248b18ef41() {
    $ddf18a96c86c2e3c$var$outros = {
        r: 0,
        c: [],
        p: $ddf18a96c86c2e3c$var$outros // parent group
    };
}
function $ddf18a96c86c2e3c$export$df995fae86a55f06() {
    if (!$ddf18a96c86c2e3c$var$outros.r) $ddf18a96c86c2e3c$export$61196ced6d74a310($ddf18a96c86c2e3c$var$outros.c);
    $ddf18a96c86c2e3c$var$outros = $ddf18a96c86c2e3c$var$outros.p;
}
function $ddf18a96c86c2e3c$export$d141bba7fdc215a3(block, local) {
    if (block && block.i) {
        $ddf18a96c86c2e3c$var$outroing.delete(block);
        block.i(local);
    }
}
function $ddf18a96c86c2e3c$export$ebd11618f299a286(block, local, detach, callback) {
    if (block && block.o) {
        if ($ddf18a96c86c2e3c$var$outroing.has(block)) return;
        $ddf18a96c86c2e3c$var$outroing.add(block);
        $ddf18a96c86c2e3c$var$outros.c.push(()=>{
            $ddf18a96c86c2e3c$var$outroing.delete(block);
            if (callback) {
                if (detach) block.d(1);
                callback();
            }
        });
        block.o(local);
    } else if (callback) callback();
}
const $ddf18a96c86c2e3c$var$null_transition = {
    duration: 0
};
function $ddf18a96c86c2e3c$export$e7c866399fa523f5(node, fn, params) {
    const options = {
        direction: "in"
    };
    let config = fn(node, params, options);
    let running = false;
    let animation_name;
    let task;
    let uid = 0;
    function cleanup() {
        if (animation_name) $ddf18a96c86c2e3c$var$delete_rule(node, animation_name);
    }
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $ddf18a96c86c2e3c$var$identity, tick: tick = $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5, css: css } = config || $ddf18a96c86c2e3c$var$null_transition;
        if (css) animation_name = $ddf18a96c86c2e3c$var$create_rule(node, 0, 1, duration, delay, easing, css, uid++);
        tick(0, 1);
        const start_time = $ddf18a96c86c2e3c$var$now() + delay;
        const end_time = start_time + duration;
        if (task) task.abort();
        running = true;
        $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(()=>$ddf18a96c86c2e3c$var$dispatch(node, true, "start"));
        task = $ddf18a96c86c2e3c$var$loop((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(1, 0);
                    $ddf18a96c86c2e3c$var$dispatch(node, true, "end");
                    cleanup();
                    return running = false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(t, 1 - t);
                }
            }
            return running;
        });
    }
    let started = false;
    return {
        start () {
            if (started) return;
            started = true;
            $ddf18a96c86c2e3c$var$delete_rule(node);
            if ($ddf18a96c86c2e3c$export$dc98b0b04f4c7758(config)) {
                config = config(options);
                $ddf18a96c86c2e3c$var$wait().then(go);
            } else go();
        },
        invalidate () {
            started = false;
        },
        end () {
            if (running) {
                cleanup();
                running = false;
            }
        }
    };
}
function $ddf18a96c86c2e3c$export$21579262ef46735b(node, fn, params) {
    const options = {
        direction: "out"
    };
    let config = fn(node, params, options);
    let running = true;
    let animation_name;
    const group = $ddf18a96c86c2e3c$var$outros;
    group.r += 1;
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $ddf18a96c86c2e3c$var$identity, tick: tick = $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5, css: css } = config || $ddf18a96c86c2e3c$var$null_transition;
        if (css) animation_name = $ddf18a96c86c2e3c$var$create_rule(node, 1, 0, duration, delay, easing, css);
        const start_time = $ddf18a96c86c2e3c$var$now() + delay;
        const end_time = start_time + duration;
        $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(()=>$ddf18a96c86c2e3c$var$dispatch(node, false, "start"));
        $ddf18a96c86c2e3c$var$loop((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(0, 1);
                    $ddf18a96c86c2e3c$var$dispatch(node, false, "end");
                    if (!--group.r) // this will result in `end()` being called,
                    // so we don't need to clean up here
                    $ddf18a96c86c2e3c$export$61196ced6d74a310(group.c);
                    return false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(1 - t, t);
                }
            }
            return running;
        });
    }
    if ($ddf18a96c86c2e3c$export$dc98b0b04f4c7758(config)) $ddf18a96c86c2e3c$var$wait().then(()=>{
        // @ts-ignore
        config = config(options);
        go();
    });
    else go();
    return {
        end (reset) {
            if (reset && config.tick) config.tick(1, 0);
            if (running) {
                if (animation_name) $ddf18a96c86c2e3c$var$delete_rule(node, animation_name);
                running = false;
            }
        }
    };
}
function $ddf18a96c86c2e3c$export$a9c996f45e5784d0(node, fn, params, intro) {
    const options = {
        direction: "both"
    };
    let config = fn(node, params, options);
    let t = intro ? 0 : 1;
    let running_program = null;
    let pending_program = null;
    let animation_name = null;
    function clear_animation() {
        if (animation_name) $ddf18a96c86c2e3c$var$delete_rule(node, animation_name);
    }
    function init(program, duration) {
        const d = program.b - t;
        duration *= Math.abs(d);
        return {
            a: t,
            b: program.b,
            d: d,
            duration: duration,
            start: program.start,
            end: program.start + duration,
            group: program.group
        };
    }
    function go(b) {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $ddf18a96c86c2e3c$var$identity, tick: tick = $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5, css: css } = config || $ddf18a96c86c2e3c$var$null_transition;
        const program = {
            start: $ddf18a96c86c2e3c$var$now() + delay,
            b: b
        };
        if (!b) {
            // @ts-ignore todo: improve typings
            program.group = $ddf18a96c86c2e3c$var$outros;
            $ddf18a96c86c2e3c$var$outros.r += 1;
        }
        if (running_program || pending_program) pending_program = program;
        else {
            // if this is an intro, and there's a delay, we need to do
            // an initial tick and/or apply CSS animation immediately
            if (css) {
                clear_animation();
                animation_name = $ddf18a96c86c2e3c$var$create_rule(node, t, b, duration, delay, easing, css);
            }
            if (b) tick(0, 1);
            running_program = init(program, duration);
            $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(()=>$ddf18a96c86c2e3c$var$dispatch(node, b, "start"));
            $ddf18a96c86c2e3c$var$loop((now)=>{
                if (pending_program && now > pending_program.start) {
                    running_program = init(pending_program, duration);
                    pending_program = null;
                    $ddf18a96c86c2e3c$var$dispatch(node, running_program.b, "start");
                    if (css) {
                        clear_animation();
                        animation_name = $ddf18a96c86c2e3c$var$create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
                    }
                }
                if (running_program) {
                    if (now >= running_program.end) {
                        tick(t = running_program.b, 1 - t);
                        $ddf18a96c86c2e3c$var$dispatch(node, running_program.b, "end");
                        if (!pending_program) {
                            // we're done
                            if (running_program.b) // intro — we can tidy up immediately
                            clear_animation();
                            else // outro — needs to be coordinated
                            if (!--running_program.group.r) $ddf18a96c86c2e3c$export$61196ced6d74a310(running_program.group.c);
                        }
                        running_program = null;
                    } else if (now >= running_program.start) {
                        const p = now - running_program.start;
                        t = running_program.a + running_program.d * easing(p / running_program.duration);
                        tick(t, 1 - t);
                    }
                }
                return !!(running_program || pending_program);
            });
        }
    }
    return {
        run (b) {
            if ($ddf18a96c86c2e3c$export$dc98b0b04f4c7758(config)) $ddf18a96c86c2e3c$var$wait().then(()=>{
                // @ts-ignore
                config = config(options);
                go(b);
            });
            else go(b);
        },
        end () {
            clear_animation();
            running_program = pending_program = null;
        }
    };
}
function $ddf18a96c86c2e3c$export$71511d61b312f219(promise, info) {
    const token = info.token = {};
    function update(type, index, key, value) {
        if (info.token !== token) return;
        info.resolved = value;
        let child_ctx = info.ctx;
        if (key !== undefined) {
            child_ctx = child_ctx.slice();
            child_ctx[key] = value;
        }
        const block = type && (info.current = type)(child_ctx);
        let needs_flush = false;
        if (info.block) {
            if (info.blocks) info.blocks.forEach((block, i)=>{
                if (i !== index && block) {
                    $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                    $ddf18a96c86c2e3c$export$ebd11618f299a286(block, 1, 1, ()=>{
                        if (info.blocks[i] === block) info.blocks[i] = null;
                    });
                    $ddf18a96c86c2e3c$export$df995fae86a55f06();
                }
            });
            else info.block.d(1);
            block.c();
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(block, 1);
            block.m(info.mount(), info.anchor);
            needs_flush = true;
        }
        info.block = block;
        if (info.blocks) info.blocks[index] = block;
        if (needs_flush) $ddf18a96c86c2e3c$var$flush();
    }
    if ($ddf18a96c86c2e3c$var$is_promise(promise)) {
        const current_component = $ddf18a96c86c2e3c$var$get_current_component();
        promise.then((value)=>{
            $ddf18a96c86c2e3c$var$set_current_component(current_component);
            update(info.then, 1, info.value, value);
            $ddf18a96c86c2e3c$var$set_current_component(null);
        }, (error)=>{
            $ddf18a96c86c2e3c$var$set_current_component(current_component);
            update(info.catch, 2, info.error, error);
            $ddf18a96c86c2e3c$var$set_current_component(null);
            if (!info.hasCatch) throw error;
        });
        // if we previously had a then/catch block, destroy it
        if (info.current !== info.pending) {
            update(info.pending, 0);
            return true;
        }
    } else {
        if (info.current !== info.then) {
            update(info.then, 1, info.value, promise);
            return true;
        }
        info.resolved = promise;
    }
}
function $ddf18a96c86c2e3c$export$3d8c2f653ac9d0b9(info, ctx, dirty) {
    const child_ctx = ctx.slice();
    const { resolved: resolved } = info;
    if (info.current === info.then) child_ctx[info.value] = resolved;
    if (info.current === info.catch) child_ctx[info.error] = resolved;
    info.block.p(child_ctx, dirty);
}
function $ddf18a96c86c2e3c$export$9e5f44173e64f162(block, lookup) {
    block.d(1);
    lookup.delete(block.key);
}
function $ddf18a96c86c2e3c$export$c3950d9923825c02(block, lookup) {
    $ddf18a96c86c2e3c$export$ebd11618f299a286(block, 1, 1, ()=>{
        lookup.delete(block.key);
    });
}
function $ddf18a96c86c2e3c$export$91c6e00c14e7e6fd(block, lookup) {
    block.f();
    $ddf18a96c86c2e3c$export$c3950d9923825c02(block, lookup);
}
function $ddf18a96c86c2e3c$export$3b14a55fb2447963(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
    let o = old_blocks.length;
    let n = list.length;
    let i = o;
    const old_indexes = {};
    while(i--)old_indexes[old_blocks[i].key] = i;
    const new_blocks = [];
    const new_lookup = new Map();
    const deltas = new Map();
    const updates = [];
    i = n;
    while(i--){
        const child_ctx = get_context(ctx, list, i);
        const key = get_key(child_ctx);
        let block = lookup.get(key);
        if (!block) {
            block = create_each_block(key, child_ctx);
            block.c();
        } else if (dynamic) // defer updates until all the DOM shuffling is done
        updates.push(()=>block.p(child_ctx, dirty));
        new_lookup.set(key, new_blocks[i] = block);
        if (key in old_indexes) deltas.set(key, Math.abs(i - old_indexes[key]));
    }
    const will_move = new Set();
    const did_move = new Set();
    function insert(block) {
        $ddf18a96c86c2e3c$export$d141bba7fdc215a3(block, 1);
        block.m(node, next);
        lookup.set(block.key, block);
        next = block.first;
        n--;
    }
    while(o && n){
        const new_block = new_blocks[n - 1];
        const old_block = old_blocks[o - 1];
        const new_key = new_block.key;
        const old_key = old_block.key;
        if (new_block === old_block) {
            // do nothing
            next = new_block.first;
            o--;
            n--;
        } else if (!new_lookup.has(old_key)) {
            // remove old block
            destroy(old_block, lookup);
            o--;
        } else if (!lookup.has(new_key) || will_move.has(new_key)) insert(new_block);
        else if (did_move.has(old_key)) o--;
        else if (deltas.get(new_key) > deltas.get(old_key)) {
            did_move.add(new_key);
            insert(new_block);
        } else {
            will_move.add(old_key);
            o--;
        }
    }
    while(o--){
        const old_block = old_blocks[o];
        if (!new_lookup.has(old_block.key)) destroy(old_block, lookup);
    }
    while(n)insert(new_blocks[n - 1]);
    $ddf18a96c86c2e3c$export$61196ced6d74a310(updates);
    return new_blocks;
}
function $ddf18a96c86c2e3c$export$2219238a014317b0(component, name, callback) {
    const index = component.$$.props[name];
    if (index !== undefined) {
        component.$$.bound[index] = callback;
        callback(component.$$.ctx[index]);
    }
}
function $ddf18a96c86c2e3c$export$d66501df72047452(block) {
    block && block.c();
}
function $ddf18a96c86c2e3c$export$9bb611d729802a56(component, target, anchor, customElement) {
    const { fragment: fragment, after_update: after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    if (!customElement) // onMount happens before the initial afterUpdate
    $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(()=>{
        const new_on_destroy = component.$$.on_mount.map($ddf18a96c86c2e3c$var$run).filter($ddf18a96c86c2e3c$export$dc98b0b04f4c7758);
        // if the component was destroyed immediately
        // it will update the `$$.on_destroy` reference to `null`.
        // the destructured on_destroy may still reference to the old array
        if (component.$$.on_destroy) component.$$.on_destroy.push(...new_on_destroy);
        else // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        $ddf18a96c86c2e3c$export$61196ced6d74a310(new_on_destroy);
        component.$$.on_mount = [];
    });
    after_update.forEach($ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08);
}
function $ddf18a96c86c2e3c$export$3466f893ebf79586(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        $ddf18a96c86c2e3c$var$flush_render_callbacks($$.after_update);
        $ddf18a96c86c2e3c$export$61196ced6d74a310($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
function $ddf18a96c86c2e3c$var$make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        $ddf18a96c86c2e3c$var$dirty_components.push(component);
        $ddf18a96c86c2e3c$var$schedule_update();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function $ddf18a96c86c2e3c$export$23f2a1d2818174ef(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [
    -1
]) {
    const parent_component = $ddf18a96c86c2e3c$var$current_component;
    $ddf18a96c86c2e3c$var$set_current_component(component);
    const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        props: // state
        props,
        update: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        not_equal: not_equal,
        bound: $ddf18a96c86c2e3c$var$blank_object(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: $ddf18a96c86c2e3c$var$blank_object(),
        dirty: dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance ? instance(component, options.props || {}, (i, ret, ...rest)=>{
        const value = rest.length ? rest[0] : ret;
        if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
            if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
            if (ready) $ddf18a96c86c2e3c$var$make_dirty(component, i);
        }
        return ret;
    }) : [];
    $$.update();
    ready = true;
    $ddf18a96c86c2e3c$export$61196ced6d74a310($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            const nodes = $ddf18a96c86c2e3c$var$children(options.target);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach($ddf18a96c86c2e3c$export$4368d992c4eafac0);
        } else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $$.fragment && $$.fragment.c();
        if (options.intro) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(component.$$.fragment);
        $ddf18a96c86c2e3c$export$9bb611d729802a56(component, options.target, options.anchor, options.customElement);
        $ddf18a96c86c2e3c$var$flush();
    }
    $ddf18a96c86c2e3c$var$set_current_component(parent_component);
}
/**
 * Base class for Svelte components. Used when dev=false.
 */ class $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    $destroy() {
        $ddf18a96c86c2e3c$export$3466f893ebf79586(this, 1);
        this.$destroy = $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5;
    }
    $on(type, callback) {
        if (!$ddf18a96c86c2e3c$export$dc98b0b04f4c7758(callback)) return $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$ddf18a96c86c2e3c$var$is_empty($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
}
const $ddf18a96c86c2e3c$var$reset$ = new (0, $6jCRi.Subject)();
const $ddf18a96c86c2e3c$var$disconnectWallet$ = new (0, $6jCRi.Subject)();
const $ddf18a96c86c2e3c$export$a07804094c3ecf2d = new (0, $l4gH8.BehaviorSubject)({
    inProgress: false,
    actionRequired: ""
});
const $ddf18a96c86c2e3c$var$switchChainModal$ = new (0, $l4gH8.BehaviorSubject)(null);
const $ddf18a96c86c2e3c$export$efccba1c4a2ef57b = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("wallets").pipe((0, $fn8ZQ.shareReplay)(1));
// reset logic
$ddf18a96c86c2e3c$var$reset$.pipe((0, $g5uH8.withLatestFrom)($ddf18a96c86c2e3c$export$efccba1c4a2ef57b), (0, $7J7ms.pluck)("1")).subscribe((wallets)=>{
    // disconnect all wallets
    wallets.forEach(({ label: label })=>{
        $ddf18a96c86c2e3c$var$disconnectWallet$.next(label);
    });
    $ddf18a96c86c2e3c$var$resetStore();
});
// keep transactions for all notifications for replacement actions
const $ddf18a96c86c2e3c$export$493d36ec626b6698 = new (0, $l4gH8.BehaviorSubject)([]);
function $ddf18a96c86c2e3c$var$updateTransaction(tx) {
    const currentTransactions = $ddf18a96c86c2e3c$export$493d36ec626b6698.getValue();
    const txIndex = currentTransactions.findIndex(({ hash: hash })=>hash === tx.hash);
    if (txIndex !== -1) {
        const updatedTransactions = currentTransactions.map((val, i)=>i === txIndex ? tx : val);
        $ddf18a96c86c2e3c$export$493d36ec626b6698.next(updatedTransactions);
    } else $ddf18a96c86c2e3c$export$493d36ec626b6698.next([
        ...currentTransactions,
        tx
    ]);
}
function $ddf18a96c86c2e3c$export$d66dc83d8cfc8dd(hash) {
    const currentTransactions = $ddf18a96c86c2e3c$export$493d36ec626b6698.getValue();
    $ddf18a96c86c2e3c$export$493d36ec626b6698.next(currentTransactions.filter((tx)=>tx.hash !== hash));
}
(0, $hh9se.defer)(()=>{
    const subject = new (0, $6jCRi.Subject)();
    $ddf18a96c86c2e3c$var$onMount(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $czRBO.take)(1));
});
const $ddf18a96c86c2e3c$var$onDestroy$ = (0, $hh9se.defer)(()=>{
    const subject = new (0, $6jCRi.Subject)();
    $ddf18a96c86c2e3c$export$ab83b03e4111b1d0(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $czRBO.take)(1));
});
(0, $hh9se.defer)(()=>{
    const subject = new (0, $6jCRi.Subject)();
    $ddf18a96c86c2e3c$var$afterUpdate(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $1mIQr.takeUntil)($ddf18a96c86c2e3c$var$onDestroy$));
});
(0, $hh9se.defer)(()=>{
    const subject = new (0, $6jCRi.Subject)();
    $ddf18a96c86c2e3c$var$beforeUpdate(()=>{
        subject.next();
    });
    return subject.asObservable().pipe((0, $1mIQr.takeUntil)($ddf18a96c86c2e3c$var$onDestroy$));
});
const $ddf18a96c86c2e3c$var$themes = {
    default: {
        "--w3o-background-color": "unset",
        "--w3o-foreground-color": "unset",
        "--w3o-text-color": "unset",
        "--w3o-border-color": "unset",
        "--w3o-action-color": "unset",
        "--w3o-border-radius": "unset",
        "--w3o-font-family": "inherit"
    },
    light: {
        "--w3o-background-color": "#ffffff",
        "--w3o-foreground-color": "#EFF1FC",
        "--w3o-text-color": "#1a1d26",
        "--w3o-border-color": "#d0d4f7",
        "--w3o-action-color": "#6370E5",
        "--w3o-border-radius": "16px",
        "--w3o-font-family": "inherit"
    },
    dark: {
        "--w3o-background-color": "#1A1D26",
        "--w3o-foreground-color": "#242835",
        "--w3o-text-color": "#EFF1FC",
        "--w3o-border-color": "#33394B",
        "--w3o-action-color": "#929bed",
        "--w3o-border-radius": "16px",
        "--w3o-font-family": "inherit"
    }
};
const $ddf18a96c86c2e3c$var$returnTheme = (theme)=>{
    if (typeof theme === "string" && theme === "system") return $ddf18a96c86c2e3c$var$watchForSystemThemeChange();
    return $ddf18a96c86c2e3c$var$returnThemeMap(theme);
};
const $ddf18a96c86c2e3c$var$returnThemeMap = (theme)=>{
    if (typeof theme === "string" && theme in $ddf18a96c86c2e3c$var$themes) return $ddf18a96c86c2e3c$var$themes[theme];
    if (typeof theme === "object") return theme;
};
const $ddf18a96c86c2e3c$var$handleThemeChange = (update)=>{
    Object.keys(update).forEach((targetStyle)=>{
        document.documentElement.style.setProperty(targetStyle, update[targetStyle] || null);
    });
};
const $ddf18a96c86c2e3c$var$watchForSystemThemeChange = ()=>{
    const systemThemeDark = window.matchMedia("(prefers-color-scheme: dark)");
    systemThemeDark.matches ? $ddf18a96c86c2e3c$var$handleThemeChange($ddf18a96c86c2e3c$var$themes["dark"]) : $ddf18a96c86c2e3c$var$handleThemeChange($ddf18a96c86c2e3c$var$themes["light"]);
    (0, $3u3jm.fromEvent)(systemThemeDark, "change").pipe((0, $1mIQr.takeUntil)($ddf18a96c86c2e3c$var$reset$)).subscribe((changes)=>{
        const themeChange = changes;
        themeChange.matches ? $ddf18a96c86c2e3c$var$handleThemeChange($ddf18a96c86c2e3c$var$themes["dark"]) : $ddf18a96c86c2e3c$var$handleThemeChange($ddf18a96c86c2e3c$var$themes["light"]);
    });
};
const $ddf18a96c86c2e3c$var$unknownObject = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object().unknown();
const $ddf18a96c86c2e3c$var$connectedChain = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    namespace: (0, $2AQn5.chainNamespaceValidation).required(),
    id: (0, $2AQn5.chainIdValidation).required()
});
const $ddf18a96c86c2e3c$var$ens = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    avatar: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    contentHash: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(), null),
    getText: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().arity(1).required()
}), null);
const $ddf18a96c86c2e3c$var$uns = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required()
}), null);
const $ddf18a96c86c2e3c$var$balance = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    eth: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number()
}).unknown(), null);
const $ddf18a96c86c2e3c$var$secondaryTokens = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    balance: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
}), null);
const $ddf18a96c86c2e3c$var$account = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    address: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    ens: $ddf18a96c86c2e3c$var$ens,
    uns: $ddf18a96c86c2e3c$var$uns,
    balance: $ddf18a96c86c2e3c$var$balance,
    secondaryTokens: $ddf18a96c86c2e3c$var$secondaryTokens
});
const $ddf18a96c86c2e3c$var$chains = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items((0, $2AQn5.chainValidation)).unique((a, b)=>a.id === b.id).error((e)=>{
    if (e[0].code === "array.unique") return new Error(`There is a duplicate Chain ID in your Onboard Chains array: ${e}`);
    return new Error(`${e}`);
});
const $ddf18a96c86c2e3c$var$accounts = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items($ddf18a96c86c2e3c$var$account);
const $ddf18a96c86c2e3c$var$wallet = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    provider: $ddf18a96c86c2e3c$var$unknownObject,
    instance: $ddf18a96c86c2e3c$var$unknownObject,
    accounts: $ddf18a96c86c2e3c$var$accounts,
    chains: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items($ddf18a96c86c2e3c$var$connectedChain),
    wagmiConnector: $ddf18a96c86c2e3c$var$unknownObject
}).required().error(new Error("wallet must be defined"));
const $ddf18a96c86c2e3c$var$wallets = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items($ddf18a96c86c2e3c$var$wallet);
const $ddf18a96c86c2e3c$var$recommendedWallet = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    url: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().uri().required()
});
const $ddf18a96c86c2e3c$var$agreement = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    version: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    termsUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().uri(),
    privacyUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().uri()
});
const $ddf18a96c86c2e3c$var$appMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    logo: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    gettingStartedGuide: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    appUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    explore: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    recommendedInjectedWallets: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items($ddf18a96c86c2e3c$var$recommendedWallet),
    agreement: $ddf18a96c86c2e3c$var$agreement
});
const $ddf18a96c86c2e3c$var$appMetadataUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    name: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    description: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    logo: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    gettingStartedGuide: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    appUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    explore: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    recommendedInjectedWallets: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items($ddf18a96c86c2e3c$var$recommendedWallet),
    agreement: $ddf18a96c86c2e3c$var$agreement
});
(0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    getInfo: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().arity(1).required(),
    getInterface: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().arity(1).required()
});
const $ddf18a96c86c2e3c$var$walletInit = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function()).required();
const $ddf18a96c86c2e3c$var$locale = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string();
const $ddf18a96c86c2e3c$var$commonPositions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().valid("topRight", "bottomRight", "bottomLeft", "topLeft");
const $ddf18a96c86c2e3c$var$gasPriceProbabilities = [
    70,
    80,
    90,
    95,
    99
];
const $ddf18a96c86c2e3c$var$notify$1 = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    transactionHandler: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    position: $ddf18a96c86c2e3c$var$commonPositions,
    replacement: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
        gasPriceProbability: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
            speedup: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number().valid(...$ddf18a96c86c2e3c$var$gasPriceProbabilities),
            cancel: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number().valid(...$ddf18a96c86c2e3c$var$gasPriceProbabilities)
        })
    })
});
const $ddf18a96c86c2e3c$var$notifyOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    desktop: $ddf18a96c86c2e3c$var$notify$1,
    mobile: $ddf18a96c86c2e3c$var$notify$1
});
const $ddf18a96c86c2e3c$var$accountCenterInitOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    position: $ddf18a96c86c2e3c$var$commonPositions,
    minimal: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    containerElement: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    hideTransactionProtectionBtn: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    transactionProtectionInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
});
const $ddf18a96c86c2e3c$var$accountCenter$1 = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    position: $ddf18a96c86c2e3c$var$commonPositions,
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    minimal: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    hideTransactionProtectionBtn: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    transactionProtectionInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    containerElement: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
});
const $ddf18a96c86c2e3c$var$connectModalOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    showSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    disableClose: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    autoConnectLastWallet: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    autoConnectAllPreviousWallet: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    iDontHaveAWalletLink: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    wheresMyWalletLink: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    removeWhereIsMyWalletWarning: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    removeIDontHaveAWalletInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    disableUDResolution: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean()
});
const $ddf18a96c86c2e3c$var$containerElements = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    accountCenter: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    connectModal: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
});
const $ddf18a96c86c2e3c$var$themeMap = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    "--w3o-background-color": (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    "--w3o-font-family": (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    "--w3o-foreground-color": (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    "--w3o-text-color": (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    "--w3o-border-color": (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    "--w3o-action-color": (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    "--w3o-border-radius": (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
});
const $ddf18a96c86c2e3c$var$presetTheme = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().valid("default", "dark", "light", "system");
const $ddf18a96c86c2e3c$var$theme = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).alternatives().try($ddf18a96c86c2e3c$var$themeMap, $ddf18a96c86c2e3c$var$presetTheme);
const $ddf18a96c86c2e3c$var$initOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    wallets: $ddf18a96c86c2e3c$var$walletInit,
    chains: $ddf18a96c86c2e3c$var$chains.required(),
    appMetadata: $ddf18a96c86c2e3c$var$appMetadata,
    i18n: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object().unknown(),
    apiKey: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    accountCenter: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
        desktop: $ddf18a96c86c2e3c$var$accountCenterInitOptions,
        mobile: $ddf18a96c86c2e3c$var$accountCenterInitOptions,
        hideTransactionProtectionBtn: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
        transactionProtectionInfoLink: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
    }),
    notify: [
        $ddf18a96c86c2e3c$var$notifyOptions,
        $ddf18a96c86c2e3c$var$notify$1
    ],
    gas: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
        get: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().required(),
        stream: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().required()
    }),
    wagmi: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    connect: $ddf18a96c86c2e3c$var$connectModalOptions,
    containerElements: $ddf18a96c86c2e3c$var$containerElements,
    transactionPreview: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
        patchProvider: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().required(),
        init: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().required(),
        previewTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function()
    }),
    theme: $ddf18a96c86c2e3c$var$theme,
    disableFontDownload: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
    unstoppableResolution: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function()
});
const $ddf18a96c86c2e3c$var$connectOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    autoSelect: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).alternatives().try((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
        disableModals: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean()
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string())
});
const $ddf18a96c86c2e3c$var$disconnectOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required()
}).required();
const $ddf18a96c86c2e3c$var$secondaryTokenValidation = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    address: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().optional()
});
const $ddf18a96c86c2e3c$var$setChainOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    chainId: (0, $2AQn5.chainIdValidation).required(),
    chainNamespace: (0, $2AQn5.chainNamespaceValidation),
    wallet: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    rpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    token: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    protectedRpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    secondaryTokens: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().max(5).items($ddf18a96c86c2e3c$var$secondaryTokenValidation).optional()
});
const $ddf18a96c86c2e3c$var$customNotificationUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    key: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().allow("pending", "error", "success", "hint"),
    eventCode: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    autoDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number(),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    link: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
});
const $ddf18a96c86c2e3c$var$preflightNotifications$1 = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    sendTransaction: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    estimateGas: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    gasPrice: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    balance: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).alternatives((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(), (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number()),
    txDetails: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).alternatives((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(), (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number()),
        to: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
        from: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
    }),
    txApproveReminderTimeout: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number()
});
const $ddf18a96c86c2e3c$var$customNotification$1 = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    key: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().allow("pending", "error", "success", "hint"),
    eventCode: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    autoDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number(),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    link: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
});
const $ddf18a96c86c2e3c$var$notification = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    id: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    key: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    type: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().allow("pending", "error", "success", "hint").required(),
    eventCode: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    message: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    autoDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number().required(),
    network: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    startTime: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number(),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    link: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
});
const $ddf18a96c86c2e3c$var$transactionHandlerReturn = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).any().allow($ddf18a96c86c2e3c$var$customNotificationUpdate, (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean().allow(false));
function $ddf18a96c86c2e3c$var$validateWallet(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$wallet, data);
}
function $ddf18a96c86c2e3c$var$validateInitOptions(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$initOptions, data);
}
function $ddf18a96c86c2e3c$var$validateConnectOptions(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$connectOptions, data);
}
function $ddf18a96c86c2e3c$var$validateDisconnectOptions(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$disconnectOptions, data);
}
function $ddf18a96c86c2e3c$var$validateString(str, label) {
    return (0, $2AQn5.validate)((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required().label(label || "value"), str);
}
function $ddf18a96c86c2e3c$var$validateSetChainOptions(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$setChainOptions, data);
}
function $ddf18a96c86c2e3c$var$validateAccountCenterUpdate(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$accountCenter$1, data);
}
function $ddf18a96c86c2e3c$var$validateConnectModalUpdate(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$connectModalOptions, data);
}
function $ddf18a96c86c2e3c$var$validateWalletInit(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$walletInit, data);
}
function $ddf18a96c86c2e3c$var$validateLocale(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$locale, data);
}
function $ddf18a96c86c2e3c$var$validateNotify(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$notify$1, data);
}
function $ddf18a96c86c2e3c$var$validateNotifyOptions(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$notifyOptions, data);
}
function $ddf18a96c86c2e3c$var$validateTransactionHandlerReturn(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$transactionHandlerReturn, data);
}
function $ddf18a96c86c2e3c$var$validateNotification(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$notification, data);
}
function $ddf18a96c86c2e3c$var$validatePreflightNotifications(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$preflightNotifications$1, data);
}
function $ddf18a96c86c2e3c$var$validateCustomNotificationUpdate(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$customNotificationUpdate, data);
}
function $ddf18a96c86c2e3c$var$validateCustomNotification(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$customNotification$1, data);
}
function $ddf18a96c86c2e3c$var$validateUpdateBalances(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$wallets, data);
}
function $ddf18a96c86c2e3c$var$validateUpdateTheme(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$theme, data);
}
function $ddf18a96c86c2e3c$var$validateAppMetadataUpdate(data) {
    return (0, $2AQn5.validate)($ddf18a96c86c2e3c$var$appMetadataUpdate, data);
}
function $ddf18a96c86c2e3c$var$addChains(chains) {
    // chains are validated on init
    const action = {
        type: $ddf18a96c86c2e3c$var$ADD_CHAINS,
        payload: chains.map((_a)=>{
            var { namespace: namespace = "evm", id: id, rpcUrl: rpcUrl } = _a, rest = $ddf18a96c86c2e3c$var$__rest(_a, [
                "namespace",
                "id",
                "rpcUrl"
            ]);
            return Object.assign(Object.assign({}, rest), {
                namespace: namespace,
                id: id.toLowerCase(),
                rpcUrl: rpcUrl ? rpcUrl.trim() : null
            });
        })
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$updateChain(updatedChain) {
    const { label: label, token: token, rpcUrl: rpcUrl, id: chainId, namespace: chainNamespace } = updatedChain;
    const error = $ddf18a96c86c2e3c$var$validateSetChainOptions({
        label: label,
        token: token,
        rpcUrl: rpcUrl,
        chainId: chainId,
        chainNamespace: chainNamespace
    });
    if (error) throw error;
    const action = {
        type: $ddf18a96c86c2e3c$var$UPDATE_CHAINS,
        payload: updatedChain
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$addWallet(wallet) {
    const error = $ddf18a96c86c2e3c$var$validateWallet(wallet);
    if (error) {
        console.error(error);
        throw error;
    }
    const action = {
        type: $ddf18a96c86c2e3c$var$ADD_WALLET,
        payload: wallet
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$updateWallet(id, update) {
    const error = $ddf18a96c86c2e3c$var$validateWallet(update);
    if (error) {
        console.error(error);
        throw error;
    }
    const action = {
        type: $ddf18a96c86c2e3c$var$UPDATE_WALLET,
        payload: Object.assign({
            id: id
        }, update)
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$removeWallet(id) {
    const error = $ddf18a96c86c2e3c$var$validateString(id, "wallet id");
    if (error) throw error;
    const action = {
        type: $ddf18a96c86c2e3c$var$REMOVE_WALLET,
        payload: {
            id: id
        }
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$export$c4ce752e73470fba(wallet, address) {
    const error = $ddf18a96c86c2e3c$var$validateWallet(wallet) || address && $ddf18a96c86c2e3c$var$validateString(address, "address");
    if (error) throw error;
    // if also setting the primary account
    if (address) {
        const account = wallet.accounts.find((ac)=>ac.address === address);
        if (account) wallet.accounts = [
            account,
            ...wallet.accounts.filter(({ address: address })=>address !== account.address)
        ];
    }
    // Update wagmi config if wagmi is being used
    $ddf18a96c86c2e3c$var$handleWagmiConnectorUpdate(wallet);
    // add wallet will set it to first wallet since it already exists
    $ddf18a96c86c2e3c$var$addWallet(wallet);
}
function $ddf18a96c86c2e3c$var$updateAccount(id, address, update) {
    const action = {
        type: $ddf18a96c86c2e3c$var$UPDATE_ACCOUNT,
        payload: Object.assign({
            id: id,
            address: address
        }, update)
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$export$1a82df3d29112e01(update) {
    const error = $ddf18a96c86c2e3c$var$validateAccountCenterUpdate(update);
    if (error) throw error;
    const action = {
        type: $ddf18a96c86c2e3c$var$UPDATE_ACCOUNT_CENTER,
        payload: update
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$updateConnectModal(update) {
    const error = $ddf18a96c86c2e3c$var$validateConnectModalUpdate(update);
    if (error) throw error;
    const action = {
        type: $ddf18a96c86c2e3c$var$UPDATE_CONNECT_MODAL,
        payload: update
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$updateNotify(update) {
    const error = $ddf18a96c86c2e3c$var$validateNotify(update);
    if (error) throw error;
    const action = {
        type: $ddf18a96c86c2e3c$var$UPDATE_NOTIFY,
        payload: update
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$addNotification(notification) {
    const error = $ddf18a96c86c2e3c$var$validateNotification(notification);
    if (error) throw error;
    const action = {
        type: $ddf18a96c86c2e3c$var$ADD_NOTIFICATION,
        payload: notification
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$export$92108d983e8ee699(notification) {
    const customNotificationError = $ddf18a96c86c2e3c$var$validateCustomNotificationUpdate(notification);
    if (customNotificationError) throw customNotificationError;
    const action = {
        type: $ddf18a96c86c2e3c$var$ADD_NOTIFICATION,
        payload: notification
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$customNotification(updatedNotification) {
    const customNotificationError = $ddf18a96c86c2e3c$var$validateCustomNotification(updatedNotification);
    if (customNotificationError) throw customNotificationError;
    const customIdKey = `customNotification-${(0, $fEL8l.nanoid)()}`;
    const notification = Object.assign(Object.assign({}, updatedNotification), {
        id: customIdKey,
        key: customIdKey
    });
    $ddf18a96c86c2e3c$export$92108d983e8ee699(notification);
    const dismiss = ()=>{
        if (notification.id) $ddf18a96c86c2e3c$export$1fbe638ecf81657e(notification.id);
    };
    const update = (notificationUpdate)=>{
        const customNotificationError = $ddf18a96c86c2e3c$var$validateCustomNotification(updatedNotification);
        if (customNotificationError) throw customNotificationError;
        const notificationAfterUpdate = Object.assign(Object.assign({}, notificationUpdate), {
            id: notification.id,
            key: notification.key
        });
        $ddf18a96c86c2e3c$export$92108d983e8ee699(notificationAfterUpdate);
        return {
            dismiss: dismiss,
            update: update
        };
    };
    $ddf18a96c86c2e3c$export$92108d983e8ee699(notification);
    return {
        dismiss: dismiss,
        update: update
    };
}
function $ddf18a96c86c2e3c$export$1fbe638ecf81657e(id) {
    if (typeof id !== "string") throw new Error("Notification id must be of type string");
    const action = {
        type: $ddf18a96c86c2e3c$var$REMOVE_NOTIFICATION,
        payload: id
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$resetStore() {
    const action = {
        type: $ddf18a96c86c2e3c$var$RESET_STORE
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$setWalletModules(wallets) {
    const error = $ddf18a96c86c2e3c$var$validateWalletInit(wallets);
    if (error) throw error;
    const modules = $ddf18a96c86c2e3c$var$initializeWalletModules(wallets);
    const dedupedWallets = $ddf18a96c86c2e3c$var$uniqueWalletsByLabel(modules);
    const action = {
        type: $ddf18a96c86c2e3c$var$SET_WALLET_MODULES,
        payload: dedupedWallets
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$setLocale(locale) {
    const error = $ddf18a96c86c2e3c$var$validateLocale(locale);
    if (error) throw error;
    const action = {
        type: $ddf18a96c86c2e3c$var$SET_LOCALE,
        payload: locale
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$updateAllWallets(wallets) {
    const error = $ddf18a96c86c2e3c$var$validateUpdateBalances(wallets);
    if (error) throw error;
    const action = {
        type: $ddf18a96c86c2e3c$var$UPDATE_ALL_WALLETS,
        payload: wallets
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
// ==== HELPERS ==== //
function $ddf18a96c86c2e3c$var$initializeWalletModules(modules) {
    const { device: device } = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57;
    if (!device) return [];
    return modules.reduce((acc, walletInit)=>{
        const initialized = walletInit({
            device: device
        });
        if (initialized) // injected wallets is an array of wallets
        acc.push(...Array.isArray(initialized) ? initialized : [
            initialized
        ]);
        return acc;
    }, []);
}
function $ddf18a96c86c2e3c$var$uniqueWalletsByLabel(walletModuleList) {
    return walletModuleList.filter((wallet, i)=>wallet && walletModuleList.findIndex((innerWallet)=>innerWallet && innerWallet.label === wallet.label) === i);
}
function $ddf18a96c86c2e3c$var$updateTheme(theme) {
    const error = $ddf18a96c86c2e3c$var$validateUpdateTheme(theme);
    if (error) throw error;
    const themingObj = $ddf18a96c86c2e3c$var$returnTheme(theme);
    themingObj && $ddf18a96c86c2e3c$var$handleThemeChange(themingObj);
}
function $ddf18a96c86c2e3c$var$updateAppMetadata(update) {
    const error = $ddf18a96c86c2e3c$var$validateAppMetadataUpdate(update);
    if (error) throw error;
    const action = {
        type: $ddf18a96c86c2e3c$var$UPDATE_APP_METADATA,
        payload: update
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$updateWagmiConfig(update) {
    const action = {
        type: $ddf18a96c86c2e3c$var$UPDATE_WAGMI_CONFIG,
        payload: update
    };
    $ddf18a96c86c2e3c$var$dispatch$1(action);
}
function $ddf18a96c86c2e3c$var$handleWagmiConnectorUpdate(wallet) {
    const { wagmi: wagmi } = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57;
    if (!wagmi) return;
    try {
        const { label: label } = wallet;
        const { wagmiConnect: wagmiConnect, getWagmiConnector: getWagmiConnector } = wagmi;
        const wagmiConfig = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().wagmiConfig;
        const wagmiConnector = getWagmiConnector(label);
        wagmiConnect(wagmiConfig, {
            connector: wagmiConnector
        }).then(()=>{
            $ddf18a96c86c2e3c$var$updateWallet(label, {
                wagmiConnector: wagmiConnector
            });
        });
    } catch (e) {
        console.error(`Error updating Wagmi connector on primary wallet switch ${e}`);
    }
}
async function $ddf18a96c86c2e3c$export$3b513254972cfc9c(options) {
    if (options) {
        const error = $ddf18a96c86c2e3c$var$validateConnectOptions(options);
        if (error) throw error;
    }
    const { chains: chains } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
    // Wallets require the chains for initializing providers,
    // so we must ensure at least one is set
    if (!chains.length) throw new Error("At least one chain must be set before attempting to connect a wallet");
    let { autoSelect: autoSelect } = options || {};
    if (!autoSelect) autoSelect = {
        label: "",
        disableModals: false
    };
    // if auto selecting, wait until next event loop
    if (autoSelect && (typeof autoSelect === "string" || autoSelect.label)) await $ddf18a96c86c2e3c$var$wait$1(50);
    // first time calling connect, so initialize and set wallet modules
    if (!$ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().walletModules.length) $ddf18a96c86c2e3c$var$setWalletModules($ddf18a96c86c2e3c$export$c9170ad7d4cd7e57.initialWalletInit);
    $ddf18a96c86c2e3c$export$a07804094c3ecf2d.next({
        autoSelect: typeof autoSelect === "string" ? {
            label: autoSelect,
            disableModals: false
        } : autoSelect,
        inProgress: true
    });
    const result$ = $ddf18a96c86c2e3c$export$a07804094c3ecf2d.pipe((0, $bPD7y.filter)(({ inProgress: inProgress, actionRequired: actionRequired })=>inProgress === false && !actionRequired), (0, $g5uH8.withLatestFrom)($ddf18a96c86c2e3c$export$efccba1c4a2ef57b), (0, $7J7ms.pluck)(1));
    return (0, $eqreU.firstValueFrom)(result$);
}
var $ddf18a96c86c2e3c$var$connect = {
    selectingWallet: {
        header: "Available Wallets",
        sidebar: {
            heading: "",
            subheading: "Connect your wallet",
            paragraph: "Connecting your wallet is like \u201Clogging in\u201D to Web3. Select your wallet from the options to get started.",
            IDontHaveAWallet: "I don't have a wallet"
        },
        recommendedWalletsPart1: "{app} only supports",
        recommendedWalletsPart2: "on this platform. Please use or install one of the supported wallets to continue",
        installWallet: "You do not have any wallets installed that {app} supports, please use a supported wallet",
        agreement: {
            agree: "I agree to the",
            terms: "Terms & Conditions",
            and: "and",
            privacy: "Privacy Policy"
        },
        whyDontISeeMyWallet: "Why don't I see my wallet?",
        learnMore: "Click here to learn more"
    },
    connectingWallet: {
        header: "{connectionRejected, select, false {Connecting to {wallet}...} other {Connection Rejected}}",
        sidebar: {
            subheading: "Approve Connection",
            paragraph: "Please approve the connection in your wallet and authorize access to continue."
        },
        mainText: "Connecting...",
        paragraph: "Make sure to select all accounts that you want to grant access to.",
        previousConnection: "{wallet} already has a pending connection request, please open the {wallet} app to login and connect.",
        rejectedText: "Connection Rejected!",
        rejectedCTA: "Click here to try again",
        primaryButton: "Back to wallets"
    },
    connectedWallet: {
        header: "Connection Successful",
        sidebar: {
            subheading: "Connection Successful!",
            paragraph: "Your wallet is now connected to {app}"
        },
        mainText: "Connected"
    }
};
var $ddf18a96c86c2e3c$var$modals = {
    actionRequired: {
        heading: "Action required in {wallet}",
        paragraph: "Please switch the active account in your wallet.",
        linkText: "Learn more.",
        buttonText: "Okay"
    },
    switchChain: {
        heading: "Switch Chain",
        paragraph1: "{app} requires that you switch your wallet to the {nextNetworkName} network to continue.",
        paragraph2: "*Some wallets may not support changing networks. If you can not change networks in your wallet you may consider switching to a different wallet."
    },
    confirmDisconnectAll: {
        heading: "Disconnect all Wallets",
        description: "Are you sure that you would like to disconnect all your wallets?",
        confirm: "Confirm",
        cancel: "Cancel"
    },
    confirmTransactionProtection: {
        heading: "Enable Transaction Protection",
        description: "Protect RPC endpoints hide your transaction from front-running and sandwich bots.",
        link: "Learn more",
        enable: "Enable",
        dismiss: "Dismiss"
    }
};
var $ddf18a96c86c2e3c$var$accountCenter = {
    connectAnotherWallet: "Connect another Wallet",
    disconnectAllWallets: "Disconnect all Wallets",
    currentNetwork: "Current Network",
    enableTransactionProtection: "Enable Transaction Protection",
    appInfo: "App Info",
    learnMore: "Learn More",
    gettingStartedGuide: "Getting Started Guide",
    smartContracts: "Smart Contract(s)",
    explore: "Explore",
    poweredBy: "powered by",
    addAccount: "Add Account",
    setPrimaryAccount: "Set Primary Account",
    disconnectWallet: "Disconnect Wallet",
    copyAddress: "Copy Wallet address"
};
var $ddf18a96c86c2e3c$var$notify = {
    transaction: {
        txRequest: "Your transaction is waiting for you to confirm",
        nsfFail: "You have insufficient funds for this transaction",
        txUnderpriced: "The gas price for your transaction is too low, try a higher gas price",
        txRepeat: "This could be a repeat transaction",
        txAwaitingApproval: "You have a previous transaction waiting for you to confirm",
        txConfirmReminder: "Please confirm your transaction to continue",
        txSendFail: "You rejected the transaction",
        txSent: "Your transaction has been sent to the network",
        txStallPending: "Your transaction has stalled before it was sent, please try again",
        txStuck: "Your transaction is stuck due to a nonce gap",
        txPool: "Your transaction has started",
        txStallConfirmed: "Your transaction has stalled and hasn't been confirmed",
        txSpeedUp: "Your transaction has been sped up",
        txCancel: "Your transaction is being canceled",
        txFailed: "Your transaction has failed",
        txConfirmed: "Your transaction has succeeded",
        txError: "Oops something went wrong, please try again",
        txReplaceError: "There was an error replacing your transaction, please try again"
    },
    watched: {
        txPool: "Your account is {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        txSpeedUp: "Transaction for {formattedValue} {asset} {preposition} {counterpartyShortened} has been sped up",
        txCancel: "Transaction for {formattedValue} {asset} {preposition} {counterpartyShortened} has been canceled",
        txConfirmed: "Your account successfully {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        txFailed: "Your account failed to {verb} {formattedValue} {asset} {preposition} {counterpartyShortened}",
        txStuck: "Your transaction is stuck due to a nonce gap"
    },
    time: {
        minutes: "min",
        seconds: "sec"
    }
};
var $ddf18a96c86c2e3c$export$e7094788287c5e9b = {
    connect: $ddf18a96c86c2e3c$var$connect,
    modals: $ddf18a96c86c2e3c$var$modals,
    accountCenter: $ddf18a96c86c2e3c$var$accountCenter,
    notify: $ddf18a96c86c2e3c$var$notify
};
const $ddf18a96c86c2e3c$var$viemProviders = {};

async function $ddf18a96c86c2e3c$var$getProvider(chain) {
    if (!chain) return null;
    if (!$ddf18a96c86c2e3c$var$viemProviders[chain.rpcUrl]) {
        const viemChain = await $ddf18a96c86c2e3c$var$chainIdToViemENSImport(chain.id);
        if (!viemChain) return null;
        const { createPublicClient: createPublicClient, http: http } = await (parcelRequire("l1VSl"));
        const publicProvider = createPublicClient({
            chain: viemChain,
            transport: http()
        });
        $ddf18a96c86c2e3c$var$viemProviders[chain.rpcUrl] = publicProvider;
    }
    return $ddf18a96c86c2e3c$var$viemProviders[chain.rpcUrl];
}
function $ddf18a96c86c2e3c$var$requestAccounts(provider) {
    const args = {
        method: "eth_requestAccounts"
    };
    return provider.request(args);
}
function $ddf18a96c86c2e3c$export$3a1a48c8f6ef640e(provider) {
    const args = {
        method: "eth_selectAccounts"
    };
    return provider.request(args);
}
function $ddf18a96c86c2e3c$var$getChainId(provider) {
    return provider.request({
        method: "eth_chainId"
    });
}
function $ddf18a96c86c2e3c$var$listenAccountsChanged(args) {
    const { provider: provider, disconnected$: disconnected$ } = args;
    const addHandler = (handler)=>{
        provider.on("accountsChanged", handler);
    };
    const removeHandler = (handler)=>{
        provider.removeListener("accountsChanged", handler);
    };
    return (0, $9La4g.fromEventPattern)(addHandler, removeHandler).pipe((0, $1mIQr.takeUntil)(disconnected$));
}
function $ddf18a96c86c2e3c$var$listenChainChanged(args) {
    const { provider: provider, disconnected$: disconnected$ } = args;
    const addHandler = (handler)=>{
        provider.on("chainChanged", handler);
    };
    const removeHandler = (handler)=>{
        provider.removeListener("chainChanged", handler);
    };
    return (0, $9La4g.fromEventPattern)(addHandler, removeHandler).pipe((0, $1mIQr.takeUntil)(disconnected$));
}
function $ddf18a96c86c2e3c$var$trackWallet(provider, label) {
    const disconnected$ = $ddf18a96c86c2e3c$var$disconnectWallet$.pipe((0, $bPD7y.filter)((wallet)=>wallet === label), (0, $czRBO.take)(1));
    const accountsChanged$ = $ddf18a96c86c2e3c$var$listenAccountsChanged({
        provider: provider,
        disconnected$: disconnected$
    }).pipe((0, $esA4D.share)());
    // when account changed, set it to first account and subscribe to events
    accountsChanged$.subscribe(async ([address])=>{
        var _a;
        // sync accounts with internal state
        // in the case of an account has been manually disconnected
        try {
            await $ddf18a96c86c2e3c$var$syncWalletConnectedAccounts(label);
        } catch (error) {
            console.warn("Web3Onboard: Error whilst trying to sync connected accounts:", error);
        }
        // no address, then no account connected, so disconnect wallet
        // this could happen if user locks wallet,
        // or if disconnects app from wallet
        if (!address) {
            $ddf18a96c86c2e3c$export$56c0d5a1e737357d({
                label: label
            });
            return;
        }
        const { wallets: wallets } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
        const wallet = wallets.find((wallet)=>wallet.label === label);
        const accounts = wallet ? wallet.accounts : [];
        const [[existingAccount], restAccounts] = (0, (/*@__PURE__*/$parcel$interopDefault($cW7tz)))(accounts, (account)=>account.address === address);
        // update accounts without ens/uns and balance first
        $ddf18a96c86c2e3c$var$updateWallet(label, {
            accounts: [
                existingAccount || {
                    address: address,
                    ens: null,
                    uns: null,
                    balance: null
                },
                ...restAccounts
            ]
        });
        // if not existing account and notifications,
        // then subscribe to transaction events
        if ($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().notify.enabled && !existingAccount) {
            const sdk = await $ddf18a96c86c2e3c$var$getBNMulitChainSdk();
            if (sdk) {
                const wallet = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
                try {
                    if (wallet) sdk.subscribe({
                        id: address,
                        chainId: (_a = wallet.chains[0]) === null || _a === void 0 ? void 0 : _a.id,
                        type: "account"
                    });
                } catch (error) {
                // unsupported network for transaction events
                }
            }
        }
    });
    // also when accounts change, update Balance and ENS/UNS
    accountsChanged$.pipe((0, $gZfTb.switchMap)(async ([address])=>{
        if (!address) return;
        const { wallets: wallets, chains: chains } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
        const primaryWallet = wallets.find((wallet)=>wallet.label === label);
        if (!primaryWallet) return; // Add null check for primaryWallet
        const { chains: walletChains, accounts: accounts } = primaryWallet;
        const [connectedWalletChain] = walletChains;
        const chain = chains.find(({ namespace: namespace, id: id })=>namespace === "evm" && id === connectedWalletChain.id);
        if (!chain) return;
        const balanceProm = $ddf18a96c86c2e3c$var$getBalance(address, chain);
        const secondaryTokenBal = $ddf18a96c86c2e3c$var$updateSecondaryTokens(address, chain);
        const account = accounts.find((account)=>account.address === address);
        const ensChain = chains.find(({ id: id })=>id === $ddf18a96c86c2e3c$var$validEnsChain(connectedWalletChain.id));
        const ensProm = account && account.ens ? Promise.resolve(account.ens) : ensChain ? $ddf18a96c86c2e3c$var$getEns(address, ensChain) : Promise.resolve(null);
        const unsProm = account && account.uns ? Promise.resolve(account.uns) : ensChain ? $ddf18a96c86c2e3c$var$getUns(address, ensChain) : Promise.resolve(null);
        return Promise.all([
            Promise.resolve(address),
            balanceProm,
            ensProm,
            unsProm,
            secondaryTokenBal
        ]);
    })).subscribe((res)=>{
        if (!res) return;
        const [address, balance, ens, uns, secondaryTokens] = res;
        $ddf18a96c86c2e3c$var$updateAccount(label, address, {
            balance: balance,
            ens: ens,
            uns: uns,
            secondaryTokens: secondaryTokens
        });
    });
    const chainChanged$ = $ddf18a96c86c2e3c$var$listenChainChanged({
        provider: provider,
        disconnected$: disconnected$
    }).pipe((0, $esA4D.share)());
    // Update chain on wallet when chainId changed
    chainChanged$.subscribe(async (chainId)=>{
        const { wallets: wallets } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
        const wallet = wallets.find((wallet)=>wallet.label === label);
        if (!wallet) return; // Add null check for wallet
        const { chains: chains, accounts: accounts } = wallet;
        const [connectedWalletChain] = chains;
        if (!(0, $8RKFj.isHex)(chainId)) chainId = (0, $kslqr.toHex)(chainId);
        if (chainId === connectedWalletChain.id) return;
        if ($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().notify.enabled) {
            const sdk = await $ddf18a96c86c2e3c$var$getBNMulitChainSdk();
            if (sdk) {
                const wallet = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
                if (!wallet) return; // Add null check for wallet
                // Unsubscribe with timeout of 60 seconds
                // to allow for any currently inflight transactions
                wallet.accounts.forEach(({ address: address })=>{
                    sdk.unsubscribe({
                        id: address,
                        chainId: wallet.chains[0].id,
                        timeout: 60000
                    });
                });
                // resubscribe for new chainId
                wallet.accounts.forEach(({ address: address })=>{
                    try {
                        sdk.subscribe({
                            id: address,
                            chainId: chainId,
                            type: "account"
                        });
                    } catch (error) {
                    // unsupported network for transaction events
                    }
                });
            }
        }
        const resetAccounts = accounts.map(({ address: address })=>({
                address: address,
                ens: null,
                uns: null,
                balance: null
            }));
        $ddf18a96c86c2e3c$var$updateWallet(label, {
            chains: [
                {
                    namespace: "evm",
                    id: chainId
                }
            ],
            accounts: resetAccounts
        });
    });
    // when chain changes get ens/uns and balance for each account for wallet
    chainChanged$.pipe((0, $gZfTb.switchMap)(async (chainId)=>{
        const { wallets: wallets, chains: chains } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
        const primaryWallet = wallets.find((wallet)=>wallet.label === label);
        const accounts = (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.accounts) || [];
        if (!(0, $8RKFj.isHex)(chainId)) chainId = (0, $kslqr.toHex)(chainId);
        const chain = chains.find(({ namespace: namespace, id: id })=>namespace === "evm" && id === chainId);
        if (!chain) return Promise.resolve(null);
        return Promise.all(accounts.map(async ({ address: address })=>{
            const balanceProm = $ddf18a96c86c2e3c$var$getBalance(address, chain);
            const secondaryTokenBal = $ddf18a96c86c2e3c$var$updateSecondaryTokens(address, chain);
            const ensChain = chains.find(({ id: id })=>id === $ddf18a96c86c2e3c$var$validEnsChain(chainId));
            const ensProm = ensChain ? $ddf18a96c86c2e3c$var$getEns(address, ensChain) : Promise.resolve(null);
            const unsProm = ensChain ? $ddf18a96c86c2e3c$var$getUns(address, ensChain) : Promise.resolve(null);
            const [balance, ens, uns, secondaryTokens] = await Promise.all([
                balanceProm,
                ensProm,
                unsProm,
                secondaryTokenBal
            ]);
            return {
                address: address,
                balance: balance,
                ens: ens,
                uns: uns,
                secondaryTokens: secondaryTokens
            };
        }));
    })).subscribe((updatedAccounts)=>{
        updatedAccounts && $ddf18a96c86c2e3c$var$updateWallet(label, {
            accounts: updatedAccounts
        });
    });
    disconnected$.subscribe(()=>{
        provider.disconnect && provider.disconnect();
    });
}

async function $ddf18a96c86c2e3c$var$getEns(address, chain) {
    // chain we don't recognize and don't have a rpcUrl for requests
    if (!chain) return null;
    const provider = await $ddf18a96c86c2e3c$var$getProvider(chain);
    if (!provider) return null;
    try {
        const name = await provider.getEnsName({
            address: address
        });
        let ens = null;
        if (name) {
            const { labelhash: labelhash, normalize: normalize } = await (parcelRequire("aWRt8")).then(function(n) {
                return n.i;
            });
            const normalizedName = normalize(name);
            const ensResolver = await provider.getEnsResolver({
                name: normalizedName
            });
            const avatar = await provider.getEnsAvatar({
                name: normalizedName
            });
            const contentHash = labelhash(normalizedName);
            const getText = async (key)=>{
                return await provider.getEnsText({
                    name: name,
                    key: key
                });
            };
            ens = {
                name: name,
                avatar: avatar,
                contentHash: contentHash,
                ensResolver: ensResolver,
                getText: getText
            };
        }
        return ens;
    } catch (error) {
        console.error(error);
        return null;
    }
}
async function $ddf18a96c86c2e3c$var$getUns(address, chain) {
    const { unstoppableResolution: unstoppableResolution } = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57;
    // check if address is valid ETH address before attempting to resolve
    // chain we don't recognize and don't have a rpcUrl for requests
    if (!unstoppableResolution || !(0, $3lyD3.isAddress)(address) || !chain) return null;
    try {
        return await unstoppableResolution(address);
    } catch (error) {
        console.error(error);
        return null;
    }
}
async function $ddf18a96c86c2e3c$var$getBalance(address, chain) {
    // chain we don't recognize and don't have a rpcUrl for requests
    if (!chain) return null;
    const { wallets: wallets } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
    try {
        const wallet = wallets.find((wallet)=>!!wallet.provider);
        if (!wallet) return null;
        const provider = wallet.provider;
        const balanceHex = await provider.request({
            method: "eth_getBalance",
            params: [
                address,
                "latest"
            ]
        });
        return balanceHex ? {
            [chain.token || "eth"]: (0, $3lyD3.weiHexToEth)(balanceHex)
        } : null;
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $ddf18a96c86c2e3c$var$switchChain(provider, chainId) {
    return provider.request({
        method: "wallet_switchEthereumChain",
        params: [
            {
                chainId: chainId
            }
        ]
    });
}
function $ddf18a96c86c2e3c$var$addNewChain(provider, chain) {
    return provider.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: chain.id,
                chainName: chain.label,
                nativeCurrency: {
                    name: chain.label,
                    symbol: chain.token,
                    decimals: 18
                },
                rpcUrls: [
                    chain.publicRpcUrl || chain.rpcUrl
                ],
                blockExplorerUrls: chain.blockExplorerUrl ? [
                    chain.blockExplorerUrl
                ] : undefined
            }
        ]
    });
}
function $ddf18a96c86c2e3c$export$ee7c8ad385a60b7b(provider, chain, rpcUrl) {
    return provider.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: chain.id,
                chainName: chain.label,
                nativeCurrency: {
                    name: chain.label,
                    symbol: chain.token,
                    decimals: 18
                },
                rpcUrls: [
                    rpcUrl
                ],
                blockExplorerUrls: chain.blockExplorerUrl ? [
                    chain.blockExplorerUrl
                ] : undefined
            }
        ]
    });
}
async function $ddf18a96c86c2e3c$var$getPermissions(provider) {
    try {
        const permissions = await provider.request({
            method: "wallet_getPermissions"
        });
        return Array.isArray(permissions) ? permissions : [];
    } catch (error) {
        return [];
    }
}
async function $ddf18a96c86c2e3c$var$syncWalletConnectedAccounts(label) {
    const wallet = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
    if (!wallet) return;
    const permissions = await $ddf18a96c86c2e3c$var$getPermissions(wallet.provider);
    const accountsPermissions = permissions.find(({ parentCapability: parentCapability })=>parentCapability === "eth_accounts");
    if (accountsPermissions) {
        const { value: connectedAccounts } = accountsPermissions.caveats.find(({ type: type })=>type === "restrictReturnedAccounts") || {
            value: null
        };
        if (connectedAccounts) {
            const syncedAccounts = wallet.accounts.filter(({ address: address })=>connectedAccounts.includes(address));
            $ddf18a96c86c2e3c$var$updateWallet(wallet.label, Object.assign(Object.assign({}, wallet), {
                accounts: syncedAccounts
            }));
        }
    }
}
const $ddf18a96c86c2e3c$var$addOrSwitchChain = async (provider, chain)=>{
    try {
        const { id: id } = chain;
        await $ddf18a96c86c2e3c$var$addNewChain(provider, chain);
        await $ddf18a96c86c2e3c$var$switchChain(provider, id);
        return id;
    } catch (error) {
        return undefined;
    }
};
const $ddf18a96c86c2e3c$var$wagmiProviderMethods = ()=>({
        addOrSwitchChain: $ddf18a96c86c2e3c$var$addOrSwitchChain,
        getChainId: $ddf18a96c86c2e3c$var$getChainId,
        requestAccounts: $ddf18a96c86c2e3c$var$requestAccounts,
        switchChain: $ddf18a96c86c2e3c$var$switchChain
    });
async function $ddf18a96c86c2e3c$var$updateBalances(addresses) {
    const { wallets: wallets, chains: chains } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
    const updatedWallets = await Promise.all(wallets.map(async (wallet)=>{
        const chain = chains.find(({ id: id })=>id === wallet.chains[0].id);
        if (!chain) return;
        const updatedAccounts = await Promise.all(wallet.accounts.map(async (account)=>{
            const secondaryTokens = await $ddf18a96c86c2e3c$var$updateSecondaryTokens(account.address, chain);
            // if no provided addresses, we want to update all balances
            // otherwise check if address is in addresses array
            if (!addresses || addresses.some((address)=>address.toLowerCase() === account.address.toLowerCase())) {
                const updatedBalance = await $ddf18a96c86c2e3c$var$getBalance(account.address, chain);
                return Object.assign(Object.assign({}, account), {
                    balance: updatedBalance,
                    secondaryTokens: secondaryTokens
                });
            }
            return Object.assign(Object.assign({}, account), {
                secondaryTokens: secondaryTokens
            });
        }));
        return Object.assign(Object.assign({}, wallet), {
            accounts: updatedAccounts
        });
    }));
    $ddf18a96c86c2e3c$var$updateAllWallets(updatedWallets);
}

const $ddf18a96c86c2e3c$var$updateSecondaryTokens = async (accountAddress, chain)=>{
    if (!chain) return [];
    const chainRPC = chain.rpcUrl;
    if (!chain.secondaryTokens || !chain.secondaryTokens.length || !chainRPC) return [];
    const tokenBalances = await Promise.all(chain.secondaryTokens.map(async (token)=>{
        try {
            const { createPublicClient: createPublicClient, http: http } = await (parcelRequire("l1VSl"));
            const viemChain = await (0, $3lyD3.chainIdToViemImport)(chain);
            const client = createPublicClient({
                chain: viemChain,
                transport: http(chain.providerConnectionInfo && chain.providerConnectionInfo.url ? chain.providerConnectionInfo.url : chainRPC)
            });
            const viemTokenInterface = {
                abi: [
                    {
                        inputs: [
                            {
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "balanceOf",
                        outputs: [
                            {
                                name: "",
                                type: "uint256"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [],
                        name: "symbol",
                        outputs: [
                            {
                                name: "",
                                type: "string"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    }
                ],
                address: token.address
            };
            const supplyProm = client.readContract(Object.assign(Object.assign({}, viemTokenInterface), {
                functionName: "balanceOf",
                args: [
                    accountAddress
                ]
            })) || "";
            const tokenProm = client.readContract(Object.assign(Object.assign({}, viemTokenInterface), {
                functionName: "symbol",
                args: []
            })) || "";
            const [tokenSupply, tokenName] = await Promise.all([
                supplyProm,
                tokenProm
            ]);
            return {
                name: tokenName,
                balance: (0, $3lyD3.weiToEth)(tokenSupply.toString()),
                icon: token.icon
            };
        } catch (error) {
            console.error(`There was an error fetching balance and/or symbol 
          for token contract: ${token.address} - ${error}`);
        }
    }));
    return tokenBalances;
};
function $ddf18a96c86c2e3c$var$handleTransactionUpdates(transaction) {
    const customized = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().notify.transactionHandler(transaction);
    const invalid = $ddf18a96c86c2e3c$var$validateTransactionHandlerReturn(customized);
    if (invalid) throw invalid;
    if (transaction.eventCode === "txConfirmed") {
        const addresses = [
            transaction.watchedAddress,
            transaction.counterparty
        ].filter(Boolean);
        $ddf18a96c86c2e3c$var$updateBalances(addresses);
    }
    const notification = $ddf18a96c86c2e3c$var$transactionEventToNotification(transaction, customized);
    $ddf18a96c86c2e3c$var$addNotification(notification);
    $ddf18a96c86c2e3c$var$updateTransaction(transaction);
}
function $ddf18a96c86c2e3c$var$transactionEventToNotification(transaction, customization) {
    const { id: id, hash: hash, startTime: startTime, eventCode: eventCode, direction: direction, counterparty: counterparty, value: value, asset: asset, network: network } = transaction;
    const type = $ddf18a96c86c2e3c$var$eventToType(eventCode);
    const key = `${id || hash}-${typeof customization === "object" && customization.eventCode || eventCode}`;
    const counterpartyShortened = counterparty && counterparty.substring(0, 4) + "..." + counterparty.substring(counterparty.length - 4);
    const formattedValue = (0, $3lyD3.weiToEth)(value);
    const formatterOptions = counterparty && value ? {
        messageId: `notify.watched['${eventCode}']`,
        values: {
            verb: eventCode === "txConfirmed" ? direction === "incoming" ? "received" : "sent" : direction === "incoming" ? "receiving" : "sending",
            formattedValue: formattedValue,
            preposition: direction === "incoming" ? "from" : "to",
            counterpartyShortened: counterpartyShortened,
            asset: asset
        }
    } : {
        messageId: `notify.transaction['${eventCode}']`,
        values: {
            formattedValue: formattedValue,
            asset: asset
        }
    };
    const formatter = (0, $4wDz6.get_store_value)((0, $8VqiI._));
    const notificationDefaultMessages = $ddf18a96c86c2e3c$export$e7094788287c5e9b.notify;
    const typeKey = counterparty ? "watched" : "transaction";
    const notificationMessageType = notificationDefaultMessages[typeKey];
    const defaultMessage = notificationMessageType[eventCode];
    const message = formatter(formatterOptions.messageId, {
        values: formatterOptions.values,
        default: defaultMessage
    });
    let notification = {
        id: id || hash,
        type: type,
        key: key,
        network: network,
        startTime: startTime || Date.now(),
        eventCode: eventCode,
        message: message,
        autoDismiss: $ddf18a96c86c2e3c$var$typeToDismissTimeout(typeof customization === "object" && customization.type || type)
    };
    if (typeof customization === "object") notification = Object.assign(Object.assign({}, notification), customization);
    return notification;
}
function $ddf18a96c86c2e3c$var$eventToType(eventCode) {
    switch(eventCode){
        case "txSent":
        case "txPool":
            return "pending";
        case "txSpeedUp":
        case "txCancel":
        case "txRequest":
        case "txRepeat":
        case "txAwaitingApproval":
        case "txConfirmReminder":
        case "txStuck":
            return "hint";
        case "txError":
        case "txSendFail":
        case "txFailed":
        case "txDropped":
        case "nsfFail":
        case "txUnderpriced":
            return "error";
        case "txConfirmed":
            return "success";
        default:
            return "hint";
    }
}
function $ddf18a96c86c2e3c$var$typeToDismissTimeout(type) {
    switch(type){
        case "success":
        case "hint":
            return 4000;
        default:
            return 0;
    }
}
let $ddf18a96c86c2e3c$var$blocknativeMultiChainSdk;
let $ddf18a96c86c2e3c$var$blocknativeSdk;

/**
 *
 * @returns MultiChain SDK if apiKey
 */ async function $ddf18a96c86c2e3c$var$getBNMulitChainSdk() {
    var _a;
    const { apiKey: apiKey } = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57;
    if (!apiKey) return null;
    if (!$ddf18a96c86c2e3c$var$blocknativeMultiChainSdk) {
        const { default: Blocknative } = await (parcelRequire("1M6JJ"));
        $ddf18a96c86c2e3c$var$blocknativeMultiChainSdk = Blocknative.multichain({
            apiKey: (_a = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57.apiKey) !== null && _a !== void 0 ? _a : ""
        });
        $ddf18a96c86c2e3c$var$blocknativeMultiChainSdk.transactions$.subscribe($ddf18a96c86c2e3c$var$handleTransactionUpdates);
    }
    return $ddf18a96c86c2e3c$var$blocknativeMultiChainSdk;
}

/**
 *
 * @returns SDK if apiKey
 */ async function $ddf18a96c86c2e3c$var$getBlocknativeSdk() {
    var _a;
    const { apiKey: apiKey } = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57;
    if (!apiKey) return null;
    if (!$ddf18a96c86c2e3c$var$blocknativeSdk) {
        const { default: Blocknative } = await (parcelRequire("1M6JJ"));
        $ddf18a96c86c2e3c$var$blocknativeSdk = new Blocknative({
            dappId: (_a = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57.apiKey) !== null && _a !== void 0 ? _a : "",
            networkId: 1
        });
        return $ddf18a96c86c2e3c$var$blocknativeSdk;
    }
    return $ddf18a96c86c2e3c$var$blocknativeSdk;
}
async function $ddf18a96c86c2e3c$export$56c0d5a1e737357d(options) {
    const error = $ddf18a96c86c2e3c$var$validateDisconnectOptions(options);
    if (error) throw error;
    const { label: label } = options;
    if ($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().notify.enabled) {
        // handle unwatching addresses
        const sdk = await $ddf18a96c86c2e3c$var$getBNMulitChainSdk();
        if (sdk) {
            const wallet = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
            if (wallet) wallet.accounts.forEach(({ address: address })=>{
                sdk.unsubscribe({
                    id: address,
                    chainId: wallet.chains[0].id,
                    timeout: 60000
                });
            });
        }
    }
    const { wagmi: wagmi } = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57;
    if (wagmi) {
        const wagmiConfig = await wagmi.wagmiDisconnectWallet(label);
        if (wagmiConfig) $ddf18a96c86c2e3c$var$updateWagmiConfig(wagmiConfig);
    }
    $ddf18a96c86c2e3c$var$disconnectWallet$.next(label);
    $ddf18a96c86c2e3c$var$removeWallet(label);
    const lastConnectedWallets = $ddf18a96c86c2e3c$var$getLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
    if (lastConnectedWallets) try {
        const labels = JSON.parse(lastConnectedWallets);
        if (Array.isArray(labels) && labels.indexOf(label) >= 0) $ddf18a96c86c2e3c$var$setLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.LAST_CONNECTED_WALLET, JSON.stringify(labels.filter((walletLabel)=>walletLabel !== label)));
        if (typeof labels === "string" && labels === label) $ddf18a96c86c2e3c$var$delLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
    } catch (e) {
        console.error(`There was an error disconnecting the last connected wallet from localStorage - Error: ${e}`);
    }
    return $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().wallets;
}
async function $ddf18a96c86c2e3c$export$2d1720544b23b823(options) {
    const error = $ddf18a96c86c2e3c$var$validateSetChainOptions(options);
    if (error) throw error;
    const { wallets: wallets, chains: chains } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
    const { chainId: chainId, chainNamespace: chainNamespace = "evm", wallet: walletToSet, rpcUrl: rpcUrl, label: label, token: token } = options;
    const chainIdHex = $ddf18a96c86c2e3c$export$d24c54395ce0c509(chainId);
    // validate that chainId has been added to chains
    const chain = chains.find(({ namespace: namespace, id: id })=>namespace === chainNamespace && id.toLowerCase() === chainIdHex.toLowerCase());
    if (!chain) throw new Error(`Chain with chainId: ${chainId} and chainNamespace: ${chainNamespace} has not been set and must be added when Onboard is initialized.`);
    const wallet = walletToSet ? wallets.find(({ label: label })=>label === walletToSet) : wallets[0];
    // validate a wallet is connected
    if (!wallet) throw new Error(walletToSet ? `Wallet with label ${walletToSet} is not connected` : "A wallet must be connected before a chain can be set");
    const [walletConnectedChain] = wallet.chains;
    // check if wallet is already connected to chainId
    if (walletConnectedChain.namespace === chainNamespace && walletConnectedChain.id === chainIdHex) return true;
    try {
        await $ddf18a96c86c2e3c$var$switchChain(wallet.provider, chainIdHex);
        return true;
    } catch (error) {
        const { code: code } = error;
        const switchChainModalClosed$ = $ddf18a96c86c2e3c$var$switchChainModal$.pipe((0, $bPD7y.filter)((x)=>x === null), (0, $cH4fw.map)(()=>false));
        if (code === (0, $9s7cO.ProviderRpcErrorCode).CHAIN_NOT_ADDED || code === (0, $9s7cO.ProviderRpcErrorCode).UNRECOGNIZED_CHAIN_ID) {
            // chain has not been added to wallet
            if (rpcUrl || label || token) {
                if (rpcUrl) chain.rpcUrl = rpcUrl;
                if (label) chain.label = label;
                if (token) chain.token = token;
                $ddf18a96c86c2e3c$var$updateChain(chain);
            }
            // add chain to wallet
            return $ddf18a96c86c2e3c$var$chainNotInWallet(wallet, chain, switchChainModalClosed$, chainIdHex);
        }
        if (code === (0, $9s7cO.ProviderRpcErrorCode).UNSUPPORTED_METHOD) {
            // method not supported
            $ddf18a96c86c2e3c$var$switchChainModal$.next({
                chain: chain
            });
            return (0, $eqreU.firstValueFrom)(switchChainModalClosed$);
        }
    }
    return false;
}
const $ddf18a96c86c2e3c$var$chainNotInWallet = async (wallet, chain, switchChainModalClosed$, chainIdHex)=>{
    try {
        await $ddf18a96c86c2e3c$var$addNewChain(wallet.provider, chain);
        await $ddf18a96c86c2e3c$var$switchChain(wallet.provider, chainIdHex);
        return true;
    } catch (error) {
        const { code: code } = error;
        if (code === (0, $9s7cO.ProviderRpcErrorCode).ACCOUNT_ACCESS_REJECTED) // add new chain rejected by user
        return false;
        // display notification to user to switch chain
        $ddf18a96c86c2e3c$var$switchChainModal$.next({
            chain: chain
        });
        return (0, $eqreU.firstValueFrom)(switchChainModalClosed$);
    }
};
function $ddf18a96c86c2e3c$var$initialize(options) {
    if (options) {
        const { en: customizedEn } = options;
        const merged = (0, (/*@__PURE__*/$parcel$interopDefault($eSAm6)))($ddf18a96c86c2e3c$export$e7094788287c5e9b, customizedEn || {});
        (0, $8VqiI.addMessages)("en", merged);
        const customLocales = Object.keys(options).filter((key)=>key !== "en");
        // Sync register all customLocales
        customLocales.forEach((locale)=>{
            const dictionary = options[locale];
            dictionary && (0, $8VqiI.addMessages)(locale, dictionary);
        });
    } else (0, $8VqiI.addMessages)("en", $ddf18a96c86c2e3c$export$e7094788287c5e9b);
    (0, $8VqiI.init)({
        fallbackLocale: "en",
        initialLocale: (0, $8VqiI.getLocaleFromNavigator)()
    });
}
var $ddf18a96c86c2e3c$var$closeIcon = `
  <svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
  </svg>
`;
/* src/views/shared/CloseButton.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$i(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-1ubf722", ".close-button.svelte-1ubf722.svelte-1ubf722{position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center;height:2rem;width:2rem;border-radius:2rem;cursor:pointer;color:var(--onboard-close-button-color, inherit)}.close-button.svelte-1ubf722.svelte-1ubf722:hover::before{opacity:0.2}.close-button.svelte-1ubf722:hover .svg-box.svelte-1ubf722{opacity:1}.close-button.svelte-1ubf722.svelte-1ubf722::before{content:'';position:absolute;height:inherit;width:inherit;opacity:0.1;background:currentColor;transition:300ms ease-in-out opacity}.svg-box.svelte-1ubf722.svelte-1ubf722{position:absolute;height:1.5rem;width:1.5rem;opacity:0.6;transition:300ms ease-in-out opacity}");
}
function $ddf18a96c86c2e3c$var$create_fragment$i(ctx) {
    let div1;
    let div0;
    return {
        c () {
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "svg-box svelte-1ubf722");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "close-button svelte-1ubf722");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div1, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            div0.innerHTML = $ddf18a96c86c2e3c$var$closeIcon;
        },
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div1);
        }
    };
}
class $ddf18a96c86c2e3c$var$CloseButton extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, null, $ddf18a96c86c2e3c$var$create_fragment$i, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {}, $ddf18a96c86c2e3c$var$add_css$i);
    }
}
function $ddf18a96c86c2e3c$export$306ddfe3a8403e2(t) {
    const f = t - 1.0;
    return f * f * f + 1.0;
}
function $ddf18a96c86c2e3c$export$7910e0436ed8d1de(t) {
    return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
}
function $ddf18a96c86c2e3c$export$78acf4525d8a74c4(node, { delay: delay = 0, duration: duration = 400, easing: easing = $ddf18a96c86c2e3c$var$identity } = {}) {
    const o = +getComputedStyle(node).opacity;
    return {
        delay: delay,
        duration: duration,
        easing: easing,
        css: (t)=>`opacity: ${t * o}`
    };
}
function $ddf18a96c86c2e3c$export$555508cbc6add439(node, { delay: delay = 0, duration: duration = 400, easing: easing = $ddf18a96c86c2e3c$export$306ddfe3a8403e2, x: x = 0, y: y = 0, opacity: opacity = 0 } = {}) {
    const style = getComputedStyle(node);
    const target_opacity = +style.opacity;
    const transform = style.transform === "none" ? "" : style.transform;
    const od = target_opacity * (1 - opacity);
    const [xValue, xUnit] = $ddf18a96c86c2e3c$var$split_css_unit(x);
    const [yValue, yUnit] = $ddf18a96c86c2e3c$var$split_css_unit(y);
    return {
        delay: delay,
        duration: duration,
        easing: easing,
        css: (t, u)=>`
			transform: ${transform} translate(${(1 - t) * xValue}${xUnit}, ${(1 - t) * yValue}${yUnit});
			opacity: ${target_opacity - od * u}`
    };
}
function $ddf18a96c86c2e3c$var$slide(node, { delay: delay = 0, duration: duration = 400, easing: easing = $ddf18a96c86c2e3c$export$306ddfe3a8403e2, axis: axis = "y" } = {}) {
    const style = getComputedStyle(node);
    const opacity = +style.opacity;
    const primary_property = axis === "y" ? "height" : "width";
    const primary_property_value = parseFloat(style[primary_property]);
    const secondary_properties = axis === "y" ? [
        "top",
        "bottom"
    ] : [
        "left",
        "right"
    ];
    const capitalized_secondary_properties = secondary_properties.map((e)=>`${e[0].toUpperCase()}${e.slice(1)}`);
    const padding_start_value = parseFloat(style[`padding${capitalized_secondary_properties[0]}`]);
    const padding_end_value = parseFloat(style[`padding${capitalized_secondary_properties[1]}`]);
    const margin_start_value = parseFloat(style[`margin${capitalized_secondary_properties[0]}`]);
    const margin_end_value = parseFloat(style[`margin${capitalized_secondary_properties[1]}`]);
    const border_width_start_value = parseFloat(style[`border${capitalized_secondary_properties[0]}Width`]);
    const border_width_end_value = parseFloat(style[`border${capitalized_secondary_properties[1]}Width`]);
    return {
        delay: delay,
        duration: duration,
        easing: easing,
        css: (t)=>"overflow: hidden;" + `opacity: ${Math.min(t * 20, 1) * opacity};` + `${primary_property}: ${t * primary_property_value}px;` + `padding-${secondary_properties[0]}: ${t * padding_start_value}px;` + `padding-${secondary_properties[1]}: ${t * padding_end_value}px;` + `margin-${secondary_properties[0]}: ${t * margin_start_value}px;` + `margin-${secondary_properties[1]}: ${t * margin_end_value}px;` + `border-${secondary_properties[0]}-width: ${t * border_width_start_value}px;` + `border-${secondary_properties[1]}-width: ${t * border_width_end_value}px;`
    };
}
/* src/views/shared/Modal.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$h(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-7ee2g7", "section.svelte-7ee2g7{top:0;left:0;pointer-events:none;z-index:var(--onboard-modal-z-index, var(--modal-z-index))}.background.svelte-7ee2g7{background:var(--onboard-modal-backdrop, var(--modal-backdrop));pointer-events:all}.full-screen-background.svelte-7ee2g7{width:100vw;height:100vh;height:100dvh}.max-height.svelte-7ee2g7{max-height:calc(100vh - 2rem)}.modal-position.svelte-7ee2g7{top:var(--onboard-modal-top, var(--modal-top));bottom:var(--onboard-modal-bottom, var(--modal-bottom));left:var(--onboard-modal-left, var(--modal-left));right:var(--onboard-modal-right, var(--modal-right))}.modal-overflow.svelte-7ee2g7{overflow:hidden}.modal-styling.svelte-7ee2g7{--border-radius:var(\n      --onboard-modal-border-radius,\n      var(--w3o-border-radius, 1rem)\n    );border-radius:var(--border-radius) var(--border-radius) 0 0;box-shadow:var(--onboard-modal-box-shadow, var(--box-shadow-0));max-width:100vw}.modal.svelte-7ee2g7{overflow-y:auto;background:var(--onboard-modal-background, white);color:var(--onboard-modal-color, initial)}.width-100.svelte-7ee2g7{width:100%}.modal-container-mobile.svelte-7ee2g7{bottom:0}@media all and (min-width: 768px){.modal-styling.svelte-7ee2g7{border-radius:var(--border-radius)}.modal-container-mobile.svelte-7ee2g7{bottom:unset;margin:1rem}.width-100.svelte-7ee2g7{width:unset}}");
}
function $ddf18a96c86c2e3c$var$create_fragment$h(ctx) {
    let section;
    let div4;
    let div3;
    let div2;
    let div1;
    let div0;
    let section_transition;
    let current;
    let mounted;
    let dispose;
    const default_slot_template = /*#slots*/ ctx[3].default;
    const default_slot = $ddf18a96c86c2e3c$var$create_slot(default_slot_template, ctx, /*$$scope*/ ctx[2], null);
    return {
        c () {
            section = $ddf18a96c86c2e3c$export$35e795649ee09318("section");
            div4 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div3 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (default_slot) default_slot.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "modal relative svelte-7ee2g7");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "modal-overflow modal-styling relative flex justify-center svelte-7ee2g7");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", `${ctx[1] ? "max-width: 100%;" : ""}`);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "flex relative max-height svelte-7ee2g7");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div2, "width-100", /*connectContainerEl*/ ctx[1]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "class", "modal-container-mobile modal-position flex svelte-7ee2g7");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div3, "absolute", !/*connectContainerEl*/ ctx[1]);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div3, "width-100", /*connectContainerEl*/ ctx[1]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "class", "background flex items-center justify-center relative svelte-7ee2g7");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div4, "full-screen-background", !/*connectContainerEl*/ ctx[1]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(section, "class", "svelte-7ee2g7");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(section, "fixed", !/*connectContainerEl*/ ctx[1]);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, section, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(section, div4);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, div2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, div1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            if (default_slot) default_slot.m(div0, null);
            current = true;
            if (!mounted) {
                dispose = [
                    $ddf18a96c86c2e3c$export$ffb5f4729a158638(div2, "click", $ddf18a96c86c2e3c$export$b4171a6734a65d42(/*click_handler*/ ctx[4])),
                    $ddf18a96c86c2e3c$export$ffb5f4729a158638(div4, "click", function() {
                        if ($ddf18a96c86c2e3c$export$dc98b0b04f4c7758(/*close*/ ctx[0])) /*close*/ ctx[0].apply(this, arguments);
                    })
                ];
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 4)) $ddf18a96c86c2e3c$var$update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[2], !current ? $ddf18a96c86c2e3c$var$get_all_dirty_from_scope(/*$$scope*/ ctx[2]) : $ddf18a96c86c2e3c$var$get_slot_changes(default_slot_template, /*$$scope*/ ctx[2], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(default_slot, local);
            $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(()=>{
                if (!current) return;
                if (!section_transition) section_transition = $ddf18a96c86c2e3c$export$a9c996f45e5784d0(section, $ddf18a96c86c2e3c$export$78acf4525d8a74c4, {}, true);
                section_transition.run(1);
            });
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(default_slot, local);
            if (!section_transition) section_transition = $ddf18a96c86c2e3c$export$a9c996f45e5784d0(section, $ddf18a96c86c2e3c$export$78acf4525d8a74c4, {}, false);
            section_transition.run(0);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(section);
            if (default_slot) default_slot.d(detaching);
            if (detaching && section_transition) section_transition.end();
            mounted = false;
            $ddf18a96c86c2e3c$export$61196ced6d74a310(dispose);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$h($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    const connectContainerEl = !!$ddf18a96c86c2e3c$export$c9170ad7d4cd7e57.containerElements.connectModal;
    const html = document.documentElement;
    $ddf18a96c86c2e3c$var$onMount(()=>{
        if (!connectContainerEl) {
            html.style.position = "sticky";
            html.style.overflow = "hidden";
        }
    });
    $ddf18a96c86c2e3c$export$ab83b03e4111b1d0(()=>{
        if (!connectContainerEl) {
            html.style.position = "";
            html.style.removeProperty("overflow");
        }
    });
    let { close: close } = $$props;
    function click_handler(event) {
        $ddf18a96c86c2e3c$export$f38c853ae54ed474.call(this, $$self, event);
    }
    $$self.$$set = ($$props)=>{
        if ("close" in $$props) $$invalidate(0, close = $$props.close);
        if ("$$scope" in $$props) $$invalidate(2, $$scope = $$props.$$scope);
    };
    return [
        close,
        connectContainerEl,
        $$scope,
        slots,
        click_handler
    ];
}
class $ddf18a96c86c2e3c$export$8743009a87fcb00f extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$h, $ddf18a96c86c2e3c$var$create_fragment$h, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            close: 0
        }, $ddf18a96c86c2e3c$var$add_css$h);
    }
}
/* src/views/connect/Agreement.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$g(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-tz7ru1", ".container.svelte-tz7ru1{padding:var(--onboard-spacing-4, var(--spacing-4));font-size:var(--onboard-font-size-6, var(--font-size-6));line-height:24px}input.svelte-tz7ru1{height:1rem;width:1rem;margin-right:0.5rem}");
}
// (43:0) {#if showTermsOfService}
function $ddf18a96c86c2e3c$var$create_if_block$a(ctx) {
    let div;
    let label;
    let input;
    let t0;
    let span;
    let t1_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.agree") + "";
    let t1;
    let t2;
    let t3_value = " ";
    let t3;
    let t4;
    let t5;
    let mounted;
    let dispose;
    let if_block0 = /*termsUrl*/ ctx[3] && $ddf18a96c86c2e3c$var$create_if_block_2$4(ctx);
    let if_block1 = /*privacyUrl*/ ctx[4] && $ddf18a96c86c2e3c$var$create_if_block_1$5(ctx);
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            label = $ddf18a96c86c2e3c$export$35e795649ee09318("label");
            input = $ddf18a96c86c2e3c$export$35e795649ee09318("input");
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            span = $ddf18a96c86c2e3c$export$35e795649ee09318("span");
            t1 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t1_value);
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            t3 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t3_value);
            t4 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block0) if_block0.c();
            t5 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(input, "class", " svelte-tz7ru1");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(input, "type", "checkbox");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(label, "class", "flex");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "container flex items-center svelte-tz7ru1");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div, label);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(label, input);
            input.checked = /*agreed*/ ctx[0];
            $ddf18a96c86c2e3c$export$953cecd6e717a553(label, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(label, span);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(span, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(span, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(span, t3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(span, t4);
            if (if_block0) if_block0.m(span, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(span, t5);
            if (if_block1) if_block1.m(span, null);
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(input, "change", /*input_change_handler*/ ctx[6]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (dirty & /*agreed*/ 1) input.checked = /*agreed*/ ctx[0];
            if (dirty & /*$_*/ 2 && t1_value !== (t1_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.agree") + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t1, t1_value);
            if (/*termsUrl*/ ctx[3]) if_block0.p(ctx, dirty);
            if (/*privacyUrl*/ ctx[4]) if_block1.p(ctx, dirty);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            mounted = false;
            dispose();
        }
    };
}
// (50:8) {#if termsUrl}
function $ddf18a96c86c2e3c$var$create_if_block_2$4(ctx) {
    let a;
    let t0_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.terms") + "";
    let t0;
    let t1_value = /*privacyUrl*/ (ctx[4] ? " " + /*$_*/ ctx[1]("connect.selectingWallet.agreement.and") + " " : ".") + "";
    let t1;
    return {
        c () {
            a = $ddf18a96c86c2e3c$export$35e795649ee09318("a");
            t0 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t0_value);
            t1 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t1_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "href", /*termsUrl*/ ctx[3]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "target", "_blank");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, a, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(a, t0);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t1, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 2 && t0_value !== (t0_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.terms") + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$_*/ 2 && t1_value !== (t1_value = /*privacyUrl*/ (ctx[4] ? " " + /*$_*/ ctx[1]("connect.selectingWallet.agreement.and") + " " : ".") + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t1, t1_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(a);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t1);
        }
    };
}
// (56:8) {#if privacyUrl}
function $ddf18a96c86c2e3c$var$create_if_block_1$5(ctx) {
    let a;
    let t0_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.privacy") + "";
    let t0;
    let t1;
    return {
        c () {
            a = $ddf18a96c86c2e3c$export$35e795649ee09318("a");
            t0 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t0_value);
            t1 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(".");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "href", /*privacyUrl*/ ctx[4]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "target", "_blank");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, a, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(a, t0);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t1, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 2 && t0_value !== (t0_value = /*$_*/ ctx[1]("connect.selectingWallet.agreement.privacy") + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t0, t0_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(a);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t1);
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$g(ctx) {
    let if_block_anchor;
    let if_block = /*showTermsOfService*/ ctx[5] && $ddf18a96c86c2e3c$var$create_if_block$a(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, [dirty]) {
            if (/*showTermsOfService*/ ctx[5]) if_block.p(ctx, dirty);
        },
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$g($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, (0, $8VqiI._), ($$value)=>$$invalidate(1, $_ = $$value));
    let { agreed: agreed } = $$props;
    const { terms: termsAgreed, privacy: privacyAgreed, version: versionAgreed } = JSON.parse($ddf18a96c86c2e3c$var$getLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.TERMS_AGREEMENT) || "{}");
    const blankAgreement = {
        termsUrl: "",
        privacyUrl: "",
        version: ""
    };
    const appMetadata$ = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $lLJqC.startWith)($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().appMetadata), (0, $fn8ZQ.shareReplay)(1));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(7, $appMetadata$ = value));
    const { termsUrl: termsUrl, privacyUrl: privacyUrl, version: version } = $appMetadata$ && $appMetadata$.agreement || blankAgreement;
    const showTermsOfService = !!(termsUrl && !termsAgreed || privacyUrl && !privacyAgreed || version && version !== versionAgreed);
    agreed = !showTermsOfService;
    function input_change_handler() {
        agreed = this.checked;
        $$invalidate(0, agreed);
    }
    $$self.$$set = ($$props)=>{
        if ("agreed" in $$props) $$invalidate(0, agreed = $$props.agreed);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*agreed*/ 1) {
            if (agreed) $ddf18a96c86c2e3c$var$setLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.TERMS_AGREEMENT, JSON.stringify({
                version: version,
                terms: !!termsUrl,
                privacy: !!privacyUrl
            }));
            else if (agreed === false) $ddf18a96c86c2e3c$var$delLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.TERMS_AGREEMENT);
        }
    };
    return [
        agreed,
        $_,
        appMetadata$,
        termsUrl,
        privacyUrl,
        showTermsOfService,
        input_change_handler
    ];
}
class $ddf18a96c86c2e3c$var$Agreement extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$g, $ddf18a96c86c2e3c$var$create_fragment$g, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            agreed: 0
        }, $ddf18a96c86c2e3c$var$add_css$g);
    }
}
/* src/views/shared/PendingStatusIcon.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$f(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-2btye1", ".icon.svelte-2btye1{color:var(--onboard-white, var(--white));border-radius:50px;bottom:-0.25rem;right:-0.25rem}.yellow.svelte-2btye1{background:var(--onboard-warning-500, var(--warning-500))}");
}
function $ddf18a96c86c2e3c$var$create_fragment$f(ctx) {
    let div;
    let div_class_value;
    let div_style_value;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", div_class_value = "" + ($ddf18a96c86c2e3c$export$882b5998b3b9117c(`${ctx[2]} icon flex absolute`) + " svelte-2btye1"));
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 6}px;`);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "yellow", /*color*/ ctx[1] === "yellow");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            div.innerHTML = $ddf18a96c86c2e3c$var$pendingIcon;
        },
        p (ctx, [dirty]) {
            if (dirty & /*className*/ 4 && div_class_value !== (div_class_value = "" + ($ddf18a96c86c2e3c$export$882b5998b3b9117c(`${ctx[2]} icon flex absolute`) + " svelte-2btye1"))) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", div_class_value);
            if (dirty & /*size*/ 1 && div_style_value !== (div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 6}px;`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value);
            if (dirty & /*className, color*/ 6) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "yellow", /*color*/ ctx[1] === "yellow");
        },
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$f($$self, $$props, $$invalidate) {
    let { size: size } = $$props;
    let { color: color = "yellow" } = $$props;
    let { class: className = "test" } = $$props;
    $$self.$$set = ($$props)=>{
        if ("size" in $$props) $$invalidate(0, size = $$props.size);
        if ("color" in $$props) $$invalidate(1, color = $$props.color);
        if ("class" in $$props) $$invalidate(2, className = $$props.class);
    };
    return [
        size,
        color,
        className
    ];
}
class $ddf18a96c86c2e3c$var$PendingStatusIcon extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$f, $ddf18a96c86c2e3c$var$create_fragment$f, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            size: 0,
            color: 1,
            class: 2
        }, $ddf18a96c86c2e3c$var$add_css$f);
    }
}
/* src/views/shared/SuccessStatusIcon.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$e(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-1bikw7k", ".icon.svelte-1bikw7k{color:var(--onboard-white, var(--white));border-radius:50px}.green.svelte-1bikw7k{background:var(--onboard-success-600, var(--success-600))}.blue.svelte-1bikw7k{background:var(--onboard-primary-1, var(--primary-1))}");
}
function $ddf18a96c86c2e3c$var$create_fragment$e(ctx) {
    let div;
    let div_style_value;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "icon flex svelte-1bikw7k");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 5}px;`);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "green", /*color*/ ctx[1] === "green");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "blue", /*color*/ ctx[1] === "blue");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            div.innerHTML = $ddf18a96c86c2e3c$var$successIcon;
        },
        p (ctx, [dirty]) {
            if (dirty & /*size*/ 1 && div_style_value !== (div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px; padding: ${ctx[0] / 5}px;`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value);
            if (dirty & /*color*/ 2) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "green", /*color*/ ctx[1] === "green");
            if (dirty & /*color*/ 2) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "blue", /*color*/ ctx[1] === "blue");
        },
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$e($$self, $$props, $$invalidate) {
    let { size: size } = $$props;
    let { color: color = "green" } = $$props;
    $$self.$$set = ($$props)=>{
        if ("size" in $$props) $$invalidate(0, size = $$props.size);
        if ("color" in $$props) $$invalidate(1, color = $$props.color);
    };
    return [
        size,
        color
    ];
}
class $ddf18a96c86c2e3c$export$db202ddc8be9136 extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$e, $ddf18a96c86c2e3c$var$create_fragment$e, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            size: 0,
            color: 1
        }, $ddf18a96c86c2e3c$var$add_css$e);
    }
}
/* src/views/shared/Spinner.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$d(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-1le5672", ".loading-container.svelte-1le5672.svelte-1le5672{font-family:inherit;font-size:inherit;color:inherit}span.svelte-1le5672.svelte-1le5672{font-family:inherit;font-size:0.889em;margin-top:1rem}.loading.svelte-1le5672.svelte-1le5672{display:inline-block}.loading.svelte-1le5672 div.svelte-1le5672{font-size:inherit;display:block;position:absolute;border:3px solid;border-radius:50%;animation:svelte-1le5672-bn-loading 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;border-color:currentColor transparent transparent transparent}.loading.svelte-1le5672 .loading-first.svelte-1le5672{animation-delay:-0.45s}.loading.svelte-1le5672 .loading-second.svelte-1le5672{animation-delay:-0.3s}.loading.svelte-1le5672 .loading-third.svelte-1le5672{animation-delay:-0.15s}@keyframes svelte-1le5672-bn-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}");
}
// (63:2) {#if description}
function $ddf18a96c86c2e3c$var$create_if_block$9(ctx) {
    let span;
    let t;
    return {
        c () {
            span = $ddf18a96c86c2e3c$export$35e795649ee09318("span");
            t = $ddf18a96c86c2e3c$export$625550452a3fa3ec(/*description*/ ctx[0]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(span, "class", "svelte-1le5672");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, span, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(span, t);
        },
        p (ctx, dirty) {
            if (dirty & /*description*/ 1) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t, /*description*/ ctx[0]);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(span);
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$d(ctx) {
    let div4;
    let div3;
    let div0;
    let div0_style_value;
    let t0;
    let div1;
    let div1_style_value;
    let t1;
    let div2;
    let div2_style_value;
    let div3_style_value;
    let t2;
    let if_block = /*description*/ ctx[0] && $ddf18a96c86c2e3c$var$create_if_block$9(ctx);
    return {
        c () {
            div4 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div3 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block) if_block.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "loading-first svelte-1le5672");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "style", div0_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "loading-second svelte-1le5672");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "loading-third svelte-1le5672");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "style", div2_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "class", "loading relative svelte-1le5672");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "style", div3_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "class", "loading-container flex flex-column justify-center items-center absolute svelte-1le5672");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div4, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, div0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, div1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, div2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, t2);
            if (if_block) if_block.m(div4, null);
        },
        p (ctx, [dirty]) {
            if (dirty & /*size*/ 2 && div0_style_value !== (div0_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "style", div0_style_value);
            if (dirty & /*size*/ 2 && div1_style_value !== (div1_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value);
            if (dirty & /*size*/ 2 && div2_style_value !== (div2_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "style", div2_style_value);
            if (dirty & /*size*/ 2 && div3_style_value !== (div3_style_value = `height: ${ctx[1]}; width: ${ctx[1]};`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "style", div3_style_value);
            if (/*description*/ ctx[0]) {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $ddf18a96c86c2e3c$var$create_if_block$9(ctx);
                    if_block.c();
                    if_block.m(div4, null);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
        },
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div4);
            if (if_block) if_block.d();
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$d($$self, $$props, $$invalidate) {
    let { description: description = "" } = $$props;
    let { size: size = "2rem" } = $$props;
    $$self.$$set = ($$props)=>{
        if ("description" in $$props) $$invalidate(0, description = $$props.description);
        if ("size" in $$props) $$invalidate(1, size = $$props.size);
    };
    return [
        description,
        size
    ];
}
class $ddf18a96c86c2e3c$var$Spinner extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$d, $ddf18a96c86c2e3c$var$create_fragment$d, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            description: 0,
            size: 1
        }, $ddf18a96c86c2e3c$var$add_css$d);
    }
}
/* src/views/shared/WalletAppBadge.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$c(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-i129jl", ".icon.svelte-i129jl{height:100%}.border-custom.svelte-i129jl{border:1px solid var(--border-color)}.border-yellow.svelte-i129jl{border:1px solid var(--onboard-warning-500, var(--warning-500))}.border-gray.svelte-i129jl{border:1px solid var(--onboard-gray-400, var(--gray-400))}.border-green.svelte-i129jl{border:1px solid var(--onboard-success-500, var(--success-500))}.border-dark-green.svelte-i129jl{border:1px solid var(--onboard-success-700, var(--success-700))}.border-blue.svelte-i129jl{border:1px solid\n      var(\n        --onboard-wallet-app-icon-border-color,\n        var(--onboard-primary-300, var(--primary-300))\n      )}.border-dark-blue.svelte-i129jl{border:1px solid\n      var(\n        --onboard-wallet-app-icon-border-color,\n        var(--onboard-primary-600, var(--primary-600))\n      )}.border-transparent.svelte-i129jl{border:1px solid transparent}.border-black.svelte-i129jl{border:1px solid var(--onboard-gray-600, var(--gray-600))}.background-gray.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-gray,\n      var(--onboard-gray-500, var(--gray-500))\n    )}.background-light-gray.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-light-gray,\n      var(--onboard-gray-100, var(--gray-100))\n    )}.background-light-blue.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-light-blue,\n      var(--onboard-primary-100, var(--primary-100))\n    )}.background-green.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-green,\n      var(--onboard-success-100, var(--success-100))\n    )}.background-white.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-white,\n      var(--onboard-white, var(--white))\n    )}.background-transparent.svelte-i129jl{background:var(\n      --onboard-wallet-app-icon-background-transparent,\n      transparent\n    )}@keyframes svelte-i129jl-pulse{from{opacity:0}to{opacity:1}}.placeholder-icon.svelte-i129jl{width:100%;height:100%;background:var(--onboard-gray-100, var(--gray-100));border-radius:32px;animation:svelte-i129jl-pulse infinite 750ms alternate ease-in-out}.spinner-container.svelte-i129jl{color:var(--onboard-primary-300, var(--primary-300))}img.svelte-i129jl{max-width:100%;height:auto}.pending-status-icon{z-index:1;fill:white;box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.1)}.status-icon-container.svelte-i129jl{right:-0.25rem;bottom:-0.25rem;position:absolute}");
}
const $ddf18a96c86c2e3c$var$get_status_slot_changes = (dirty)=>({});
const $ddf18a96c86c2e3c$var$get_status_slot_context = (ctx)=>({});
// (178:2) {:else}
function $ddf18a96c86c2e3c$var$create_else_block$4(ctx) {
    let await_block_anchor;
    let promise;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $ddf18a96c86c2e3c$var$create_pending_block$1,
        then: $ddf18a96c86c2e3c$var$create_then_block$1,
        catch: $ddf18a96c86c2e3c$var$create_catch_block$1,
        value: 13,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $ddf18a96c86c2e3c$export$71511d61b312f219(promise = /*icon*/ ctx[1], info);
    return {
        c () {
            await_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            info.ctx = ctx;
            if (dirty & /*icon*/ 2 && promise !== (promise = /*icon*/ ctx[1]) && $ddf18a96c86c2e3c$export$71511d61b312f219(promise, info)) ;
            else $ddf18a96c86c2e3c$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $ddf18a96c86c2e3c$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (174:2) {#if loading && windowWidth >= MOBILE_WINDOW_WIDTH}
function $ddf18a96c86c2e3c$var$create_if_block$8(ctx) {
    let div;
    let spinner;
    let current;
    spinner = new $ddf18a96c86c2e3c$var$Spinner({
        props: {
            size: "2rem"
        }
    });
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(spinner.$$.fragment);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "spinner-container svelte-i129jl");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(spinner, div, null);
            current = true;
        },
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(spinner.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(spinner.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(spinner);
        }
    };
}
// (1:0) <script lang="ts">import { fade }
function $ddf18a96c86c2e3c$var$create_catch_block$1(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (181:4) {:then iconLoaded}
function $ddf18a96c86c2e3c$var$create_then_block$1(ctx) {
    let div;
    let show_if;
    let div_intro;
    let t;
    let if_block1_anchor;
    let current;
    function select_block_type_1(ctx, dirty) {
        if (dirty & /*icon*/ 2) show_if = null;
        if (show_if == null) show_if = !!$ddf18a96c86c2e3c$export$34aec0b863436764(/*iconLoaded*/ ctx[13]);
        if (show_if) return $ddf18a96c86c2e3c$var$create_if_block_2$3;
        return $ddf18a96c86c2e3c$var$create_else_block_1$2;
    }
    let current_block_type = select_block_type_1(ctx, -1);
    let if_block0 = current_block_type(ctx);
    let if_block1 = /*loading*/ ctx[2] && /*windowWidth*/ ctx[9] <= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH && $ddf18a96c86c2e3c$var$create_if_block_1$4();
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if_block0.c();
            t = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            if_block1_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "icon flex justify-center items-center svelte-i129jl");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            if_block0.m(div, null);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t, anchor);
            if (if_block1) if_block1.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block1_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block0) if_block0.p(ctx, dirty);
            else {
                if_block0.d(1);
                if_block0 = current_block_type(ctx);
                if (if_block0) {
                    if_block0.c();
                    if_block0.m(div, null);
                }
            }
            if (/*loading*/ ctx[2] && /*windowWidth*/ ctx[9] <= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH) {
                if (if_block1) {
                    if (dirty & /*loading, windowWidth*/ 516) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1, 1);
                } else {
                    if_block1 = $ddf18a96c86c2e3c$var$create_if_block_1$4();
                    if_block1.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1, 1);
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            if (local) {
                if (!div_intro) $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(()=>{
                    div_intro = $ddf18a96c86c2e3c$export$e7c866399fa523f5(div, $ddf18a96c86c2e3c$export$78acf4525d8a74c4, {});
                    div_intro.start();
                });
            }
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            if_block0.d();
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t);
            if (if_block1) if_block1.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block1_anchor);
        }
    };
}
// (186:8) {:else}
function $ddf18a96c86c2e3c$var$create_else_block_1$2(ctx) {
    let img;
    let img_src_value;
    return {
        c () {
            img = $ddf18a96c86c2e3c$export$35e795649ee09318("img");
            if (!$ddf18a96c86c2e3c$export$3c2fa207a37baaea(img.src, img_src_value = /*iconLoaded*/ ctx[13])) $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "src", img_src_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "alt", "logo");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "class", "svelte-i129jl");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, img, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*icon*/ 2 && !$ddf18a96c86c2e3c$export$3c2fa207a37baaea(img.src, img_src_value = /*iconLoaded*/ ctx[13])) $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "src", img_src_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(img);
        }
    };
}
// (183:8) {#if isSVG(iconLoaded)}
function $ddf18a96c86c2e3c$var$create_if_block_2$3(ctx) {
    let html_tag;
    let raw_value = /*iconLoaded*/ ctx[13] + "";
    let html_anchor;
    return {
        c () {
            html_tag = new $ddf18a96c86c2e3c$export$ce26c07117d59d6a(false);
            html_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*icon*/ 2 && raw_value !== (raw_value = /*iconLoaded*/ ctx[13] + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (191:6) {#if loading && windowWidth <= MOBILE_WINDOW_WIDTH}
function $ddf18a96c86c2e3c$var$create_if_block_1$4(ctx) {
    let div;
    let pendingstatusicon;
    let current;
    pendingstatusicon = new $ddf18a96c86c2e3c$var$PendingStatusIcon({
        props: {
            class: "pending-status-icon",
            size: 20
        }
    });
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(pendingstatusicon.$$.fragment);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "status-icon-container svelte-i129jl");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(pendingstatusicon, div, null);
            current = true;
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(pendingstatusicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(pendingstatusicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(pendingstatusicon);
        }
    };
}
// (179:17)        <div class="placeholder-icon" />     {:then iconLoaded}
function $ddf18a96c86c2e3c$var$create_pending_block$1(ctx) {
    let div;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "placeholder-icon svelte-i129jl");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
        },
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$c(ctx) {
    let div;
    let current_block_type_index;
    let if_block;
    let t;
    let div_style_value;
    let current;
    let mounted;
    let dispose;
    $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[12]);
    const if_block_creators = [
        $ddf18a96c86c2e3c$var$create_if_block$8,
        $ddf18a96c86c2e3c$var$create_else_block$4
    ];
    const if_blocks = [];
    function select_block_type(ctx, dirty) {
        if (/*loading*/ ctx[2] && /*windowWidth*/ ctx[9] >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH) return 0;
        return 1;
    }
    current_block_type_index = select_block_type(ctx);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    const status_slot_template = /*#slots*/ ctx[11].status;
    const status_slot = $ddf18a96c86c2e3c$var$create_slot(status_slot_template, ctx, /*$$scope*/ ctx[10], $ddf18a96c86c2e3c$var$get_status_slot_context);
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if_block.c();
            t = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (status_slot) status_slot.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "relative svelte-i129jl");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value = `${ctx[6] === "custom" ? `background-color: ${ctx[7]}` : ""}; padding: ${ctx[3] - 1}px; width: ${ctx[0]}px; height: ${ctx[0]}px; border-radius: ${ctx[8]}px; color: ${ctx[4]};`);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-custom", /*border*/ ctx[5] === "custom");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-yellow", /*border*/ ctx[5] === "yellow");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-gray", /*border*/ ctx[5] === "gray");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-green", /*border*/ ctx[5] === "green");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-dark-green", /*border*/ ctx[5] === "darkGreen");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-blue", /*border*/ ctx[5] === "blue");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-dark-blue", /*border*/ ctx[5] === "darkBlue");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-transparent", /*border*/ ctx[5] === "transparent");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-black", /*border*/ ctx[5] === "black");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-gray", /*background*/ ctx[6] === "gray");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-light-gray", /*background*/ ctx[6] === "lightGray");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-light-blue", /*background*/ ctx[6] === "lightBlue");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-green", /*background*/ ctx[6] === "green");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-white", /*background*/ ctx[6] === "white");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-transparent", /*background*/ ctx[6] === "transparent");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            if_blocks[current_block_type_index].m(div, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div, t);
            if (status_slot) status_slot.m(div, null);
            current = true;
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[12]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type(ctx);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block, 1);
                if_block.m(div, t);
            }
            if (status_slot) {
                if (status_slot.p && (!current || dirty & /*$$scope*/ 1024)) $ddf18a96c86c2e3c$var$update_slot_base(status_slot, status_slot_template, ctx, /*$$scope*/ ctx[10], !current ? $ddf18a96c86c2e3c$var$get_all_dirty_from_scope(/*$$scope*/ ctx[10]) : $ddf18a96c86c2e3c$var$get_slot_changes(status_slot_template, /*$$scope*/ ctx[10], dirty, $ddf18a96c86c2e3c$var$get_status_slot_changes), $ddf18a96c86c2e3c$var$get_status_slot_context);
            }
            if (!current || dirty & /*background, customBackgroundColor, padding, size, radius, color*/ 473 && div_style_value !== (div_style_value = `${ctx[6] === "custom" ? `background-color: ${ctx[7]}` : ""}; padding: ${ctx[3] - 1}px; width: ${ctx[0]}px; height: ${ctx[0]}px; border-radius: ${ctx[8]}px; color: ${ctx[4]};`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value);
            if (!current || dirty & /*border*/ 32) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-custom", /*border*/ ctx[5] === "custom");
            if (!current || dirty & /*border*/ 32) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-yellow", /*border*/ ctx[5] === "yellow");
            if (!current || dirty & /*border*/ 32) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-gray", /*border*/ ctx[5] === "gray");
            if (!current || dirty & /*border*/ 32) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-green", /*border*/ ctx[5] === "green");
            if (!current || dirty & /*border*/ 32) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-dark-green", /*border*/ ctx[5] === "darkGreen");
            if (!current || dirty & /*border*/ 32) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-blue", /*border*/ ctx[5] === "blue");
            if (!current || dirty & /*border*/ 32) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-dark-blue", /*border*/ ctx[5] === "darkBlue");
            if (!current || dirty & /*border*/ 32) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-transparent", /*border*/ ctx[5] === "transparent");
            if (!current || dirty & /*border*/ 32) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "border-black", /*border*/ ctx[5] === "black");
            if (!current || dirty & /*background*/ 64) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-gray", /*background*/ ctx[6] === "gray");
            if (!current || dirty & /*background*/ 64) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-light-gray", /*background*/ ctx[6] === "lightGray");
            if (!current || dirty & /*background*/ 64) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-light-blue", /*background*/ ctx[6] === "lightBlue");
            if (!current || dirty & /*background*/ 64) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-green", /*background*/ ctx[6] === "green");
            if (!current || dirty & /*background*/ 64) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-white", /*background*/ ctx[6] === "white");
            if (!current || dirty & /*background*/ 64) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "background-transparent", /*background*/ ctx[6] === "transparent");
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(status_slot, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(status_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            if_blocks[current_block_type_index].d();
            if (status_slot) status_slot.d(detaching);
            mounted = false;
            dispose();
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$c($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    let { size: size } = $$props;
    let { icon: icon } = $$props;
    let { loading: loading = false } = $$props;
    let { padding: padding = size / 6 } = $$props;
    let { color: color = "black" } = $$props;
    let { border: border = "transparent" } = $$props;
    let { background: background = "transparent" } = $$props;
    let { customBackgroundColor: customBackgroundColor = "" } = $$props;
    let { radius: radius = 12 } = $$props;
    let windowWidth;
    function onwindowresize() {
        $$invalidate(9, windowWidth = window.innerWidth);
    }
    $$self.$$set = ($$props)=>{
        if ("size" in $$props) $$invalidate(0, size = $$props.size);
        if ("icon" in $$props) $$invalidate(1, icon = $$props.icon);
        if ("loading" in $$props) $$invalidate(2, loading = $$props.loading);
        if ("padding" in $$props) $$invalidate(3, padding = $$props.padding);
        if ("color" in $$props) $$invalidate(4, color = $$props.color);
        if ("border" in $$props) $$invalidate(5, border = $$props.border);
        if ("background" in $$props) $$invalidate(6, background = $$props.background);
        if ("customBackgroundColor" in $$props) $$invalidate(7, customBackgroundColor = $$props.customBackgroundColor);
        if ("radius" in $$props) $$invalidate(8, radius = $$props.radius);
        if ("$$scope" in $$props) $$invalidate(10, $$scope = $$props.$$scope);
    };
    return [
        size,
        icon,
        loading,
        padding,
        color,
        border,
        background,
        customBackgroundColor,
        radius,
        windowWidth,
        $$scope,
        slots,
        onwindowresize
    ];
}
class $ddf18a96c86c2e3c$export$71cec2538cb2c617 extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$c, $ddf18a96c86c2e3c$var$create_fragment$c, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            size: 0,
            icon: 1,
            loading: 2,
            padding: 3,
            color: 4,
            border: 5,
            background: 6,
            customBackgroundColor: 7,
            radius: 8
        }, $ddf18a96c86c2e3c$var$add_css$c);
    }
}
/* src/views/shared/Warning.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$b(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-q2gson", ".container.svelte-q2gson{gap:1rem;padding:0.75rem;color:var(--onboard-warning-700, var(--warning-700));font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:16px;border:1px solid var(--onboard-warning-400, var(--warning-400));background:var(--onboard-warning-100, var(--warning-100));border-radius:12px}.icon.svelte-q2gson{color:var(--onboard-warning-700, var(--warning-700));width:1rem;height:1rem;flex:0 0 auto}");
}
function $ddf18a96c86c2e3c$var$create_fragment$b(ctx) {
    let div2;
    let div0;
    let t;
    let div1;
    let div2_intro;
    let current;
    const default_slot_template = /*#slots*/ ctx[1].default;
    const default_slot = $ddf18a96c86c2e3c$var$create_slot(default_slot_template, ctx, /*$$scope*/ ctx[0], null);
    return {
        c () {
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (default_slot) default_slot.c();
            t = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "icon svelte-q2gson");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "container flex justify-between svelte-q2gson");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div2, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, div0);
            if (default_slot) default_slot.m(div0, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, div1);
            div1.innerHTML = $ddf18a96c86c2e3c$var$infoIcon;
            current = true;
        },
        p (ctx, [dirty]) {
            if (default_slot) {
                if (default_slot.p && (!current || dirty & /*$$scope*/ 1)) $ddf18a96c86c2e3c$var$update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[0], !current ? $ddf18a96c86c2e3c$var$get_all_dirty_from_scope(/*$$scope*/ ctx[0]) : $ddf18a96c86c2e3c$var$get_slot_changes(default_slot_template, /*$$scope*/ ctx[0], dirty, null), null);
            }
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(default_slot, local);
            if (local) {
                if (!div2_intro) $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(()=>{
                    div2_intro = $ddf18a96c86c2e3c$export$e7c866399fa523f5(div2, $ddf18a96c86c2e3c$var$slide, {
                        delay: 50,
                        duration: 500
                    });
                    div2_intro.start();
                });
            }
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(default_slot, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div2);
            if (default_slot) default_slot.d(detaching);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$b($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope: $$scope } = $$props;
    $$self.$$set = ($$props)=>{
        if ("$$scope" in $$props) $$invalidate(0, $$scope = $$props.$$scope);
    };
    return [
        $$scope,
        slots
    ];
}
class $ddf18a96c86c2e3c$var$Warning extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$b, $ddf18a96c86c2e3c$var$create_fragment$b, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {}, $ddf18a96c86c2e3c$var$add_css$b);
    }
}
/* src/views/connect/ConnectedWallet.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$a(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-1kfgpsl", ".container.svelte-1kfgpsl{padding:var(--onboard-spacing-4, var(--spacing-4));color:var(\n      --onboard-connect-accent-text-color,\n      var(--onboard-gray-700, var(--gray-700))\n    )}.connecting-container.svelte-1kfgpsl{padding:var(--onboard-spacing-4, var(--spacing-4));border-radius:var(--onboard-border-radius-1, var(--border-radius-1));background:var(--onboard-success-100, var(--success-100));border:1px solid var(--onboard-success-600, var(--success-600));width:100%}.text.svelte-1kfgpsl{right:var(--onboard-spacing-5, var(--spacing-5))}.tick.svelte-1kfgpsl{color:var(--onboard-success-700, var(--success-700))}");
}
function $ddf18a96c86c2e3c$var$create_fragment$a(ctx) {
    let div7;
    let div6;
    let div4;
    let div2;
    let walletappbadge0;
    let t0;
    let div0;
    let successstatusicon;
    let t1;
    let div1;
    let walletappbadge1;
    let t2;
    let div3;
    let t3_value = /*$_*/ ctx[2]("connect.connectedWallet.mainText", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectedWallet.mainText,
        values: {
            wallet: /*selectedWallet*/ ctx[0].label
        }
    }) + "";
    let t3;
    let t4;
    let div5;
    let current;
    walletappbadge0 = new $ddf18a96c86c2e3c$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            background: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon ? "lightBlue" : "lightGray",
            border: "darkGreen",
            icon: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon || $ddf18a96c86c2e3c$export$f787f51d84a910ad
        }
    });
    successstatusicon = new $ddf18a96c86c2e3c$export$db202ddc8be9136({
        props: {
            size: 17
        }
    });
    walletappbadge1 = new $ddf18a96c86c2e3c$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            border: "darkGreen",
            background: "white",
            icon: /*selectedWallet*/ ctx[0].icon
        }
    });
    return {
        c () {
            div7 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div6 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div4 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(walletappbadge0.$$.fragment);
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(successstatusicon.$$.fragment);
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(walletappbadge1.$$.fragment);
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div3 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t3 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t3_value);
            t4 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div5 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "relative");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div0, "right", "1rem");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div0, "top", "4px");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div0, "z-index", "1");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "relative");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div1, "right", "1.75rem");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "flex justify-center items-end relative");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "class", "text relative svelte-1kfgpsl");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "class", "flex items-center");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div5, "class", "tick flex items-center svelte-1kfgpsl");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div5, "width", "24px");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div6, "class", "connecting-container flex justify-between items-center svelte-1kfgpsl");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div7, "class", "container svelte-1kfgpsl");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div7, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div7, div6);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div6, div4);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div2);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(walletappbadge0, div2, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, div0);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(successstatusicon, div0, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, div1);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(walletappbadge1, div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, t3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div6, t4);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div6, div5);
            div5.innerHTML = $ddf18a96c86c2e3c$var$successIcon;
            current = true;
        },
        p (ctx, [dirty]) {
            const walletappbadge0_changes = {};
            if (dirty & /*$appMetadata$*/ 2) walletappbadge0_changes.background = /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon ? "lightBlue" : "lightGray";
            if (dirty & /*$appMetadata$*/ 2) walletappbadge0_changes.icon = /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].icon || $ddf18a96c86c2e3c$export$f787f51d84a910ad;
            walletappbadge0.$set(walletappbadge0_changes);
            const walletappbadge1_changes = {};
            if (dirty & /*selectedWallet*/ 1) walletappbadge1_changes.icon = /*selectedWallet*/ ctx[0].icon;
            walletappbadge1.$set(walletappbadge1_changes);
            if ((!current || dirty & /*$_, selectedWallet*/ 5) && t3_value !== (t3_value = /*$_*/ ctx[2]("connect.connectedWallet.mainText", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectedWallet.mainText,
                values: {
                    wallet: /*selectedWallet*/ ctx[0].label
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t3, t3_value);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(walletappbadge0.$$.fragment, local);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(successstatusicon.$$.fragment, local);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(walletappbadge1.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(walletappbadge0.$$.fragment, local);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(successstatusicon.$$.fragment, local);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(walletappbadge1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div7);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(walletappbadge0);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(successstatusicon);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(walletappbadge1);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$a($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, (0, $8VqiI._), ($$value)=>$$invalidate(2, $_ = $$value));
    let { selectedWallet: selectedWallet } = $$props;
    const appMetadata$ = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $lLJqC.startWith)($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().appMetadata), (0, $fn8ZQ.shareReplay)(1));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(1, $appMetadata$ = value));
    $$self.$$set = ($$props)=>{
        if ("selectedWallet" in $$props) $$invalidate(0, selectedWallet = $$props.selectedWallet);
    };
    return [
        selectedWallet,
        $appMetadata$,
        $_,
        appMetadata$
    ];
}
class $ddf18a96c86c2e3c$var$ConnectedWallet extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$a, $ddf18a96c86c2e3c$var$create_fragment$a, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            selectedWallet: 0
        }, $ddf18a96c86c2e3c$var$add_css$a);
    }
}
/* src/views/connect/ConnectingWallet.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$9(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-j1ywa3", ".container.svelte-j1ywa3{padding:var(--onboard-spacing-4, var(--spacing-4))}.connecting-container.svelte-j1ywa3{width:100%;padding:var(--onboard-spacing-4, var(--spacing-4));transition:background-color 100ms ease-in-out,\n      border-color 100ms ease-in-out;border-radius:24px;background:var(--onboard-primary-100, var(--primary-100));border:1px solid;border-color:var(--onboard-primary-300, var(--primary-300));color:var(--onboard-gray-600, var(--gray-600))}.connecting-container.warning.svelte-j1ywa3{background:var(--onboard-warning-100, var(--warning-100));border-color:var(--onboard-warning-400, var(--warning-400))}.text.svelte-j1ywa3{line-height:16px;margin-bottom:var(--onboard-spacing-5, var(--spacing-5))}.text.text-rejected.svelte-j1ywa3{line-height:24px;margin-bottom:0}.subtext.svelte-j1ywa3{font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:16px}.rejected-cta.svelte-j1ywa3{color:var(--onboard-primary-500, var(--primary-500))}.onboard-button-primary.svelte-j1ywa3{bottom:var(--onboard-spacing-3, var(--spacing-3))}.ml.svelte-j1ywa3{margin-left:var(--onboard-spacing-4, var(--spacing-4))}@media all and (max-width: 520px){.connecting-container.svelte-j1ywa3{border-radius:var(--onboard-border-radius-4, var(--border-radius-4))}.container.svelte-j1ywa3{padding-bottom:0}.wallet-badges.svelte-j1ywa3{display:none}.connecting-wallet-info.svelte-j1ywa3{margin:0}.onboard-button-primary.svelte-j1ywa3{display:none}}");
}
// (141:8) {:else}
function $ddf18a96c86c2e3c$var$create_else_block$3(ctx) {
    let div;
    let t_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[5] ? "previousConnection" : "paragraph"}`, {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.paragraph,
        values: {
            wallet: /*selectedWallet*/ ctx[1].label
        }
    }) + "";
    let t;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "subtext svelte-j1ywa3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div, t);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, previousConnectionRequest, selectedWallet*/ 162 && t_value !== (t_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[5] ? "previousConnection" : "paragraph"}`, {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.paragraph,
                values: {
                    wallet: /*selectedWallet*/ ctx[1].label
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
// (134:8) {#if connectionRejected}
function $ddf18a96c86c2e3c$var$create_if_block$7(ctx) {
    let div;
    let t_value = /*$_*/ ctx[7]("connect.connectingWallet.rejectedCTA", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.rejectedCTA,
        values: {
            wallet: /*selectedWallet*/ ctx[1].label
        }
    }) + "";
    let t;
    let mounted;
    let dispose;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "rejected-cta pointer subtext svelte-j1ywa3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div, t);
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(div, "click", function() {
                    if ($ddf18a96c86c2e3c$export$dc98b0b04f4c7758(/*connectWallet*/ ctx[0])) /*connectWallet*/ ctx[0].apply(this, arguments);
                });
                mounted = true;
            }
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*$_, selectedWallet*/ 130 && t_value !== (t_value = /*$_*/ ctx[7]("connect.connectingWallet.rejectedCTA", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.rejectedCTA,
                values: {
                    wallet: /*selectedWallet*/ ctx[1].label
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            mounted = false;
            dispose();
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$9(ctx) {
    let div6;
    let div5;
    let div4;
    let div1;
    let walletappbadge0;
    let t0;
    let div0;
    let walletappbadge1;
    let t1;
    let div3;
    let div2;
    let t2_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[4] ? "rejectedText" : "mainText"}`, {
        default: /*connectionRejected*/ ctx[4] ? $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.rejectedText : $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.mainText,
        values: {
            wallet: /*selectedWallet*/ ctx[1].label
        }
    }) + "";
    let t2;
    let t3;
    let t4;
    let button;
    let t5_value = /*$_*/ ctx[7]("connect.connectingWallet.primaryButton", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.primaryButton
    }) + "";
    let t5;
    let current;
    let mounted;
    let dispose;
    walletappbadge0 = new $ddf18a96c86c2e3c$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            icon: /*$appMetadata$*/ ctx[6] && /*$appMetadata$*/ ctx[6].icon || $ddf18a96c86c2e3c$export$f787f51d84a910ad,
            border: /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? "yellow" : "blue",
            background: "lightGray"
        }
    });
    walletappbadge1 = new $ddf18a96c86c2e3c$export$71cec2538cb2c617({
        props: {
            size: 40,
            padding: 8,
            border: /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? "yellow" : "blue",
            background: "white",
            icon: /*selectedWallet*/ ctx[1].icon
        }
    });
    function select_block_type(ctx, dirty) {
        if (/*connectionRejected*/ ctx[4]) return $ddf18a96c86c2e3c$var$create_if_block$7;
        return $ddf18a96c86c2e3c$var$create_else_block$3;
    }
    let current_block_type = select_block_type(ctx);
    let if_block = current_block_type(ctx);
    return {
        c () {
            div6 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div5 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div4 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(walletappbadge0.$$.fragment);
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(walletappbadge1.$$.fragment);
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div3 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t2 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t2_value);
            t3 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if_block.c();
            t4 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            button = $ddf18a96c86c2e3c$export$35e795649ee09318("button");
            t5 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t5_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "relative");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div0, "right", "0.5rem");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "flex justify-center relative wallet-badges svelte-j1ywa3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "text svelte-j1ywa3");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div2, "text-rejected", /*connectionRejected*/ ctx[4]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "class", "flex flex-column justify-center ml connecting-wallet-info svelte-j1ywa3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "class", "flex");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div5, "class", "connecting-container flex justify-between items-center svelte-j1ywa3");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div5, "warning", /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(button, "class", "onboard-button-primary absolute svelte-j1ywa3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div6, "class", "container flex flex-column items-center svelte-j1ywa3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div6, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div6, div5);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div4);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div1);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(walletappbadge0, div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(walletappbadge1, div0, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, div2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, t3);
            if_block.m(div3, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div6, t4);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div6, button);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(button, t5);
            current = true;
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(button, "click", /*click_handler*/ ctx[9]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            const walletappbadge0_changes = {};
            if (dirty & /*$appMetadata$*/ 64) walletappbadge0_changes.icon = /*$appMetadata$*/ ctx[6] && /*$appMetadata$*/ ctx[6].icon || $ddf18a96c86c2e3c$export$f787f51d84a910ad;
            if (dirty & /*connectionRejected, previousConnectionRequest*/ 48) walletappbadge0_changes.border = /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? "yellow" : "blue";
            walletappbadge0.$set(walletappbadge0_changes);
            const walletappbadge1_changes = {};
            if (dirty & /*connectionRejected, previousConnectionRequest*/ 48) walletappbadge1_changes.border = /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5] ? "yellow" : "blue";
            if (dirty & /*selectedWallet*/ 2) walletappbadge1_changes.icon = /*selectedWallet*/ ctx[1].icon;
            walletappbadge1.$set(walletappbadge1_changes);
            if ((!current || dirty & /*$_, connectionRejected, selectedWallet*/ 146) && t2_value !== (t2_value = /*$_*/ ctx[7](`connect.connectingWallet.${ctx[4] ? "rejectedText" : "mainText"}`, {
                default: /*connectionRejected*/ ctx[4] ? $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.rejectedText : $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.mainText,
                values: {
                    wallet: /*selectedWallet*/ ctx[1].label
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t2, t2_value);
            if (!current || dirty & /*connectionRejected*/ 16) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div2, "text-rejected", /*connectionRejected*/ ctx[4]);
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(div3, null);
                }
            }
            if (!current || dirty & /*connectionRejected, previousConnectionRequest*/ 48) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div5, "warning", /*connectionRejected*/ ctx[4] || /*previousConnectionRequest*/ ctx[5]);
            if ((!current || dirty & /*$_*/ 128) && t5_value !== (t5_value = /*$_*/ ctx[7]("connect.connectingWallet.primaryButton", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.connectingWallet.primaryButton
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t5, t5_value);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(walletappbadge0.$$.fragment, local);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(walletappbadge1.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(walletappbadge0.$$.fragment, local);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(walletappbadge1.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div6);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(walletappbadge0);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(walletappbadge1);
            if_block.d();
            mounted = false;
            dispose();
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$9($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, (0, $8VqiI._), ($$value)=>$$invalidate(7, $_ = $$value));
    let { connectWallet: connectWallet } = $$props;
    let { selectedWallet: selectedWallet } = $$props;
    let { deselectWallet: deselectWallet } = $$props;
    let { setStep: setStep } = $$props;
    let { connectionRejected: connectionRejected } = $$props;
    let { previousConnectionRequest: previousConnectionRequest } = $$props;
    const appMetadata$ = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $lLJqC.startWith)($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().appMetadata), (0, $fn8ZQ.shareReplay)(1));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(6, $appMetadata$ = value));
    const click_handler = ()=>{
        deselectWallet(selectedWallet.label);
        setStep("selectingWallet");
    };
    $$self.$$set = ($$props)=>{
        if ("connectWallet" in $$props) $$invalidate(0, connectWallet = $$props.connectWallet);
        if ("selectedWallet" in $$props) $$invalidate(1, selectedWallet = $$props.selectedWallet);
        if ("deselectWallet" in $$props) $$invalidate(2, deselectWallet = $$props.deselectWallet);
        if ("setStep" in $$props) $$invalidate(3, setStep = $$props.setStep);
        if ("connectionRejected" in $$props) $$invalidate(4, connectionRejected = $$props.connectionRejected);
        if ("previousConnectionRequest" in $$props) $$invalidate(5, previousConnectionRequest = $$props.previousConnectionRequest);
    };
    return [
        connectWallet,
        selectedWallet,
        deselectWallet,
        setStep,
        connectionRejected,
        previousConnectionRequest,
        $appMetadata$,
        $_,
        appMetadata$,
        click_handler
    ];
}
class $ddf18a96c86c2e3c$var$ConnectingWallet extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$9, $ddf18a96c86c2e3c$var$create_fragment$9, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            connectWallet: 0,
            selectedWallet: 1,
            deselectWallet: 2,
            setStep: 3,
            connectionRejected: 4,
            previousConnectionRequest: 5
        }, $ddf18a96c86c2e3c$var$add_css$9);
    }
}
/* src/views/connect/InstallWallet.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$8(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-1uy2ffh", ".outer-container.svelte-1uy2ffh{padding:var(--onboard-spacing-4, var(--spacing-4))}.link.svelte-1uy2ffh{font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:16px;color:var(--onboard-primary-500, var(--primary-500));text-decoration:none}");
}
function $ddf18a96c86c2e3c$var$get_each_context$1(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[3] = list[i].name;
    child_ctx[4] = list[i].url;
    child_ctx[6] = i;
    return child_ctx;
}
// (44:4) {:else}
function $ddf18a96c86c2e3c$var$create_else_block$2(ctx) {
    let t_value = /*$_*/ ctx[1]("connect.selectingWallet.installWallet", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.installWallet,
        values: {
            app: /*$appMetadata$*/ ctx[0].name || "this app"
        }
    }) + "";
    let t;
    return {
        c () {
            t = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t_value);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, $appMetadata$*/ 3 && t_value !== (t_value = /*$_*/ ctx[1]("connect.selectingWallet.installWallet", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.installWallet,
                values: {
                    app: /*$appMetadata$*/ ctx[0].name || "this app"
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t);
        }
    };
}
// (25:4) {#if $appMetadata$.recommendedInjectedWallets}
function $ddf18a96c86c2e3c$var$create_if_block$6(ctx) {
    let t0_value = /*$_*/ ctx[1]("connect.selectingWallet.recommendedWalletsPart1", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart1,
        values: {
            app: /*$appMetadata$*/ ctx[0].name || "This app"
        }
    }) + "";
    let t0;
    let t1;
    let t2;
    let t3_value = /*$_*/ ctx[1]("connect.selectingWallet.recommendedWalletsPart2", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart2
    }) + "";
    let t3;
    let each_value = /*$appMetadata$*/ ctx[0].recommendedInjectedWallets;
    let each_blocks = [];
    for(let i = 0; i < each_value.length; i += 1)each_blocks[i] = $ddf18a96c86c2e3c$var$create_each_block$1($ddf18a96c86c2e3c$var$get_each_context$1(ctx, each_value, i));
    return {
        c () {
            t0 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t0_value);
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            t3 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t3_value);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t0, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t1, anchor);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t2, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t3, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, $appMetadata$*/ 3 && t0_value !== (t0_value = /*$_*/ ctx[1]("connect.selectingWallet.recommendedWalletsPart1", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart1,
                values: {
                    app: /*$appMetadata$*/ ctx[0].name || "This app"
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$appMetadata$*/ 1) {
                each_value = /*$appMetadata$*/ ctx[0].recommendedInjectedWallets;
                let i;
                for(i = 0; i < each_value.length; i += 1){
                    const child_ctx = $ddf18a96c86c2e3c$var$get_each_context$1(ctx, each_value, i);
                    if (each_blocks[i]) each_blocks[i].p(child_ctx, dirty);
                    else {
                        each_blocks[i] = $ddf18a96c86c2e3c$var$create_each_block$1(child_ctx);
                        each_blocks[i].c();
                        each_blocks[i].m(t2.parentNode, t2);
                    }
                }
                for(; i < each_blocks.length; i += 1)each_blocks[i].d(1);
                each_blocks.length = each_value.length;
            }
            if (dirty & /*$_*/ 2 && t3_value !== (t3_value = /*$_*/ ctx[1]("connect.selectingWallet.recommendedWalletsPart2", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.recommendedWalletsPart2
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t3, t3_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t0);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t1);
            $ddf18a96c86c2e3c$export$ef35774e6d314e91(each_blocks, detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t2);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t3);
        }
    };
}
// (32:6) {#each $appMetadata$.recommendedInjectedWallets as { name, url }
function $ddf18a96c86c2e3c$var$create_each_block$1(ctx) {
    let a;
    let t0_value = /*name*/ ctx[3] + "";
    let t0;
    let t1_value = /*i*/ (ctx[6] < /*$appMetadata$*/ ctx[0].recommendedInjectedWallets.length - 1 ? ", " : "") + "";
    let t1;
    let a_href_value;
    return {
        c () {
            a = $ddf18a96c86c2e3c$export$35e795649ee09318("a");
            t0 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t0_value);
            t1 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t1_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "class", "link pointer svelte-1uy2ffh");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "href", a_href_value = /*url*/ ctx[4]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "target", "_blank");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, a, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(a, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(a, t1);
        },
        p (ctx, dirty) {
            if (dirty & /*$appMetadata$*/ 1 && t0_value !== (t0_value = /*name*/ ctx[3] + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$appMetadata$*/ 1 && t1_value !== (t1_value = /*i*/ (ctx[6] < /*$appMetadata$*/ ctx[0].recommendedInjectedWallets.length - 1 ? ", " : "") + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t1, t1_value);
            if (dirty & /*$appMetadata$*/ 1 && a_href_value !== (a_href_value = /*url*/ ctx[4])) $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "href", a_href_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(a);
        }
    };
}
// (24:2) <Warning>
function $ddf18a96c86c2e3c$var$create_default_slot$4(ctx) {
    let if_block_anchor;
    function select_block_type(ctx, dirty) {
        if (/*$appMetadata$*/ ctx[0].recommendedInjectedWallets) return $ddf18a96c86c2e3c$var$create_if_block$6;
        return $ddf18a96c86c2e3c$var$create_else_block$2;
    }
    let current_block_type = select_block_type(ctx);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        d (detaching) {
            if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$8(ctx) {
    let div;
    let warning;
    let current;
    warning = new $ddf18a96c86c2e3c$var$Warning({
        props: {
            $$slots: {
                default: [
                    $ddf18a96c86c2e3c$var$create_default_slot$4
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(warning.$$.fragment);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "outer-container svelte-1uy2ffh");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(warning, div, null);
            current = true;
        },
        p (ctx, [dirty]) {
            const warning_changes = {};
            if (dirty & /*$$scope, $_, $appMetadata$*/ 131) warning_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            warning.$set(warning_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(warning.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(warning.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(warning);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$8($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, (0, $8VqiI._), ($$value)=>$$invalidate(1, $_ = $$value));
    const appMetadata$ = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $lLJqC.startWith)($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().appMetadata), (0, $fn8ZQ.shareReplay)(1));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(0, $appMetadata$ = value));
    return [
        $appMetadata$,
        $_,
        appMetadata$
    ];
}
class $ddf18a96c86c2e3c$var$InstallWallet extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$8, $ddf18a96c86c2e3c$var$create_fragment$8, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {}, $ddf18a96c86c2e3c$var$add_css$8);
    }
}
/* src/views/connect/WalletButton.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$7(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-1ct6vh0", "button.svelte-1ct6vh0:disabled{opacity:0.5}button.wallet-button-styling.svelte-1ct6vh0{position:relative;align-items:flex-start;flex:1;padding:0;background:none;color:var(--onboard-wallet-button-color, inherit)}.wallet-button-container.svelte-1ct6vh0{display:flex}.wallet-button-container-inner.svelte-1ct6vh0{position:relative;display:flex;flex-flow:column;align-items:center;gap:0.5rem;padding:0.75rem;width:5rem}.name.svelte-1ct6vh0{font-size:var(--onboard-font-size-7, var(--font-size-7));line-height:1rem;text-overflow:ellipsis;max-width:5rem;max-height:2rem;overflow:hidden}.status-icon.svelte-1ct6vh0{position:absolute;top:3.5rem;left:3.5rem}@media screen and (min-width: 768px){button.wallet-button-styling.svelte-1ct6vh0{transition:background-color 250ms ease-in-out;background:var(--onboard-wallet-button-background, none);border:1px solid transparent;border-color:var(--onboard-wallet-button-border-color, var(--border-color));border-radius:var(--onboard-wallet-button-border-radius, var(--border-radius-1))}button.wallet-button-styling.svelte-1ct6vh0:hover{background:var(--onboard-wallet-button-background-hover, var(--foreground-color));color:var(--onboard-wallet-button-color-hover)}.wallet-button-container-inner.svelte-1ct6vh0{flex:1;flex-flow:row nowrap;gap:1rem;padding:1rem}button.connected.svelte-1ct6vh0{border-color:var(--onboard-success-500, var(--success-500))}.name.svelte-1ct6vh0{font-size:var(--onboard-font-size-5, var(--font-size-5));line-height:1.25rem;text-align:initial;max-width:inherit;max-height:3rem}.status-icon.svelte-1ct6vh0{top:0;bottom:0;left:auto;right:1rem;margin:auto;height:20px}}");
}
// (120:6) {#if connected}
function $ddf18a96c86c2e3c$var$create_if_block$5(ctx) {
    let div;
    let successstatusicon;
    let current;
    successstatusicon = new $ddf18a96c86c2e3c$export$db202ddc8be9136({
        props: {
            size: 20
        }
    });
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(successstatusicon.$$.fragment);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "status-icon svelte-1ct6vh0");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(successstatusicon, div, null);
            current = true;
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(successstatusicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(successstatusicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(successstatusicon);
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$7(ctx) {
    let div2;
    let button;
    let div1;
    let walletappbadge;
    let t0;
    let div0;
    let t1;
    let t2;
    let button_intro;
    let current;
    let mounted;
    let dispose;
    $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[7]);
    walletappbadge = new $ddf18a96c86c2e3c$export$71cec2538cb2c617({
        props: {
            size: /*windowWidth*/ ctx[6] >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH ? 48 : 56,
            icon: /*icon*/ ctx[0],
            loading: /*connecting*/ ctx[4],
            border: /*connected*/ ctx[3] ? "green" : "custom",
            background: "transparent"
        }
    });
    let if_block = /*connected*/ ctx[3] && $ddf18a96c86c2e3c$var$create_if_block$5();
    return {
        c () {
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            button = $ddf18a96c86c2e3c$export$35e795649ee09318("button");
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(walletappbadge.$$.fragment);
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t1 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(/*label*/ ctx[1]);
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block) if_block.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "name svelte-1ct6vh0");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "wallet-button-container-inner svelte-1ct6vh0");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(button, "class", "wallet-button-styling svelte-1ct6vh0");
            button.disabled = /*disabled*/ ctx[5];
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(button, "connected", /*connected*/ ctx[3]);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "wallet-button-container svelte-1ct6vh0");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div2, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, button);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(button, div1);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(walletappbadge, div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div0, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t2);
            if (if_block) if_block.m(div1, null);
            current = true;
            if (!mounted) {
                dispose = [
                    $ddf18a96c86c2e3c$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[7]),
                    $ddf18a96c86c2e3c$export$ffb5f4729a158638(button, "click", function() {
                        if ($ddf18a96c86c2e3c$export$dc98b0b04f4c7758(/*onClick*/ ctx[2])) /*onClick*/ ctx[2].apply(this, arguments);
                    })
                ];
                mounted = true;
            }
        },
        p (new_ctx, [dirty]) {
            ctx = new_ctx;
            const walletappbadge_changes = {};
            if (dirty & /*windowWidth*/ 64) walletappbadge_changes.size = /*windowWidth*/ ctx[6] >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH ? 48 : 56;
            if (dirty & /*icon*/ 1) walletappbadge_changes.icon = /*icon*/ ctx[0];
            if (dirty & /*connecting*/ 16) walletappbadge_changes.loading = /*connecting*/ ctx[4];
            if (dirty & /*connected*/ 8) walletappbadge_changes.border = /*connected*/ ctx[3] ? "green" : "custom";
            walletappbadge.$set(walletappbadge_changes);
            if (!current || dirty & /*label*/ 2) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t1, /*label*/ ctx[1]);
            if (/*connected*/ ctx[3]) {
                if (if_block) {
                    if (dirty & /*connected*/ 8) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block, 1);
                } else {
                    if_block = $ddf18a96c86c2e3c$var$create_if_block$5();
                    if_block.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block, 1);
                    if_block.m(div1, null);
                }
            } else if (if_block) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (!current || dirty & /*disabled*/ 32) button.disabled = /*disabled*/ ctx[5];
            if (!current || dirty & /*connected*/ 8) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(button, "connected", /*connected*/ ctx[3]);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(walletappbadge.$$.fragment, local);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block);
            if (local) {
                if (!button_intro) $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(()=>{
                    button_intro = $ddf18a96c86c2e3c$export$e7c866399fa523f5(button, $ddf18a96c86c2e3c$export$78acf4525d8a74c4, {});
                    button_intro.start();
                });
            }
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(walletappbadge.$$.fragment, local);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div2);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(walletappbadge);
            if (if_block) if_block.d();
            mounted = false;
            $ddf18a96c86c2e3c$export$61196ced6d74a310(dispose);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$7($$self, $$props, $$invalidate) {
    let { icon: icon } = $$props;
    let { label: label } = $$props;
    let { onClick: onClick } = $$props;
    let { connected: connected } = $$props;
    let { connecting: connecting } = $$props;
    let { disabled: disabled } = $$props;
    let windowWidth;
    function onwindowresize() {
        $$invalidate(6, windowWidth = window.innerWidth);
    }
    $$self.$$set = ($$props)=>{
        if ("icon" in $$props) $$invalidate(0, icon = $$props.icon);
        if ("label" in $$props) $$invalidate(1, label = $$props.label);
        if ("onClick" in $$props) $$invalidate(2, onClick = $$props.onClick);
        if ("connected" in $$props) $$invalidate(3, connected = $$props.connected);
        if ("connecting" in $$props) $$invalidate(4, connecting = $$props.connecting);
        if ("disabled" in $$props) $$invalidate(5, disabled = $$props.disabled);
    };
    return [
        icon,
        label,
        onClick,
        connected,
        connecting,
        disabled,
        windowWidth,
        onwindowresize
    ];
}
class $ddf18a96c86c2e3c$var$WalletButton extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$7, $ddf18a96c86c2e3c$var$create_fragment$7, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            icon: 0,
            label: 1,
            onClick: 2,
            connected: 3,
            connecting: 4,
            disabled: 5
        }, $ddf18a96c86c2e3c$var$add_css$7);
    }
}
/* src/views/connect/SelectingWallet.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$6(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-kpc6js", ".wallets-container.svelte-kpc6js{display:flex;gap:0.5rem;overflow-x:scroll;overflow-y:hidden;padding:0.75rem 0.5rem;border-bottom:1px solid var(--border-color);-ms-overflow-style:none;scrollbar-width:none}.wallets-container.svelte-kpc6js::-webkit-scrollbar{display:none}.warning-container.svelte-kpc6js{margin:1rem 1rem 0}.notice-container.svelte-kpc6js{flex:0 0 100%;margin-top:0.75rem}@media all and (min-width: 768px){.wallets-container.svelte-kpc6js{display:grid;grid-template-columns:repeat(var(--onboard-wallet-columns, 2), 1fr);padding:1rem;border:none}.notice-container.svelte-kpc6js{grid-column:span 2;margin:0}}");
}
function $ddf18a96c86c2e3c$var$get_each_context(ctx, list, i) {
    const child_ctx = ctx.slice();
    child_ctx[10] = list[i];
    return child_ctx;
}
// (65:2) {#if connectingErrorMessage}
function $ddf18a96c86c2e3c$var$create_if_block_1$3(ctx) {
    let div;
    let warning;
    let current;
    warning = new $ddf18a96c86c2e3c$var$Warning({
        props: {
            $$slots: {
                default: [
                    $ddf18a96c86c2e3c$var$create_default_slot_1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(warning.$$.fragment);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "warning-container svelte-kpc6js");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(warning, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const warning_changes = {};
            if (dirty & /*$$scope, connectingErrorMessage*/ 8200) warning_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            warning.$set(warning_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(warning.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(warning.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(warning);
        }
    };
}
// (67:6) <Warning>
function $ddf18a96c86c2e3c$var$create_default_slot_1(ctx) {
    let html_tag;
    let html_anchor;
    return {
        c () {
            html_tag = new $ddf18a96c86c2e3c$export$ce26c07117d59d6a(false);
            html_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(/*connectingErrorMessage*/ ctx[3], target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*connectingErrorMessage*/ 8) html_tag.p(/*connectingErrorMessage*/ ctx[3]);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (72:4) {#each wallets as wallet}
function $ddf18a96c86c2e3c$var$create_each_block(ctx) {
    let walletbutton;
    let current;
    function func() {
        return /*func*/ ctx[9](/*wallet*/ ctx[10]);
    }
    walletbutton = new $ddf18a96c86c2e3c$var$WalletButton({
        props: {
            connected: /*checkConnected*/ ctx[7](/*wallet*/ ctx[10].label),
            connecting: /*connectingWalletLabel*/ ctx[2] === /*wallet*/ ctx[10].label,
            label: /*wallet*/ ctx[10].label,
            icon: /*wallet*/ ctx[10].icon,
            onClick: func,
            disabled: /*windowWidth*/ ctx[4] <= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH && /*connectingWalletLabel*/ ctx[2] && /*connectingWalletLabel*/ ctx[2] !== /*wallet*/ ctx[10].label
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(walletbutton.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(walletbutton, target, anchor);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            const walletbutton_changes = {};
            if (dirty & /*wallets*/ 1) walletbutton_changes.connected = /*checkConnected*/ ctx[7](/*wallet*/ ctx[10].label);
            if (dirty & /*connectingWalletLabel, wallets*/ 5) walletbutton_changes.connecting = /*connectingWalletLabel*/ ctx[2] === /*wallet*/ ctx[10].label;
            if (dirty & /*wallets*/ 1) walletbutton_changes.label = /*wallet*/ ctx[10].label;
            if (dirty & /*wallets*/ 1) walletbutton_changes.icon = /*wallet*/ ctx[10].icon;
            if (dirty & /*selectWallet, wallets*/ 3) walletbutton_changes.onClick = func;
            if (dirty & /*windowWidth, connectingWalletLabel, wallets*/ 21) walletbutton_changes.disabled = /*windowWidth*/ ctx[4] <= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH && /*connectingWalletLabel*/ ctx[2] && /*connectingWalletLabel*/ ctx[2] !== /*wallet*/ ctx[10].label;
            walletbutton.$set(walletbutton_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(walletbutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(walletbutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(walletbutton, detaching);
        }
    };
}
// (84:4) {#if !connect.removeWhereIsMyWalletWarning}
function $ddf18a96c86c2e3c$var$create_if_block$4(ctx) {
    let div;
    let warning;
    let current;
    warning = new $ddf18a96c86c2e3c$var$Warning({
        props: {
            $$slots: {
                default: [
                    $ddf18a96c86c2e3c$var$create_default_slot$3
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(warning.$$.fragment);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "notice-container svelte-kpc6js");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(warning, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const warning_changes = {};
            if (dirty & /*$$scope, $_*/ 8224) warning_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            warning.$set(warning_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(warning.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(warning.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(warning);
        }
    };
}
// (86:8) <Warning>
function $ddf18a96c86c2e3c$var$create_default_slot$3(ctx) {
    let div;
    let t0_value = /*$_*/ ctx[5]("connect.selectingWallet.whyDontISeeMyWallet", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.whyDontISeeMyWallet
    }) + "";
    let t0;
    let t1;
    let a;
    let t2_value = /*$_*/ ctx[5]("connect.selectingWallet.learnMore", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.learnMore
    }) + "";
    let t2;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t0 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t0_value);
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            a = $ddf18a96c86c2e3c$export$35e795649ee09318("a");
            t2 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t2_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "class", "link pointer");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "href", /*connect*/ ctx[6].wheresMyWalletLink || $ddf18a96c86c2e3c$var$wheresMyWalletDefault);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "target", "_blank");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div, t0);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t1, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, a, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(a, t2);
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 32 && t0_value !== (t0_value = /*$_*/ ctx[5]("connect.selectingWallet.whyDontISeeMyWallet", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.whyDontISeeMyWallet
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t0, t0_value);
            if (dirty & /*$_*/ 32 && t2_value !== (t2_value = /*$_*/ ctx[5]("connect.selectingWallet.learnMore", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.learnMore
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t2, t2_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t1);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(a);
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$6(ctx) {
    let div1;
    let t0;
    let div0;
    let t1;
    let current;
    let mounted;
    let dispose;
    $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[8]);
    let if_block0 = /*connectingErrorMessage*/ ctx[3] && $ddf18a96c86c2e3c$var$create_if_block_1$3(ctx);
    let each_value = /*wallets*/ ctx[0];
    let each_blocks = [];
    for(let i = 0; i < each_value.length; i += 1)each_blocks[i] = $ddf18a96c86c2e3c$var$create_each_block($ddf18a96c86c2e3c$var$get_each_context(ctx, each_value, i));
    const out = (i)=>$ddf18a96c86c2e3c$export$ebd11618f299a286(each_blocks[i], 1, 1, ()=>{
            each_blocks[i] = null;
        });
    let if_block1 = !/*connect*/ ctx[6].removeWhereIsMyWalletWarning && $ddf18a96c86c2e3c$var$create_if_block$4(ctx);
    return {
        c () {
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            for(let i = 0; i < each_blocks.length; i += 1)each_blocks[i].c();
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "wallets-container svelte-kpc6js");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "outer-container");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div1, anchor);
            if (if_block0) if_block0.m(div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            for(let i = 0; i < each_blocks.length; i += 1)if (each_blocks[i]) each_blocks[i].m(div0, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div0, t1);
            if (if_block1) if_block1.m(div0, null);
            current = true;
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[8]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (/*connectingErrorMessage*/ ctx[3]) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*connectingErrorMessage*/ 8) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0, 1);
                } else {
                    if_block0 = $ddf18a96c86c2e3c$var$create_if_block_1$3(ctx);
                    if_block0.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0, 1);
                    if_block0.m(div1, t0);
                }
            } else if (if_block0) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (dirty & /*checkConnected, wallets, connectingWalletLabel, selectWallet, windowWidth, MOBILE_WINDOW_WIDTH*/ 151) {
                each_value = /*wallets*/ ctx[0];
                let i;
                for(i = 0; i < each_value.length; i += 1){
                    const child_ctx = $ddf18a96c86c2e3c$var$get_each_context(ctx, each_value, i);
                    if (each_blocks[i]) {
                        each_blocks[i].p(child_ctx, dirty);
                        $ddf18a96c86c2e3c$export$d141bba7fdc215a3(each_blocks[i], 1);
                    } else {
                        each_blocks[i] = $ddf18a96c86c2e3c$var$create_each_block(child_ctx);
                        each_blocks[i].c();
                        $ddf18a96c86c2e3c$export$d141bba7fdc215a3(each_blocks[i], 1);
                        each_blocks[i].m(div0, t1);
                    }
                }
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                for(i = each_value.length; i < each_blocks.length; i += 1)out(i);
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (!/*connect*/ ctx[6].removeWhereIsMyWalletWarning) if_block1.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0);
            for(let i = 0; i < each_value.length; i += 1)$ddf18a96c86c2e3c$export$d141bba7fdc215a3(each_blocks[i]);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block0);
            each_blocks = each_blocks.filter(Boolean);
            for(let i = 0; i < each_blocks.length; i += 1)$ddf18a96c86c2e3c$export$ebd11618f299a286(each_blocks[i]);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div1);
            if (if_block0) if_block0.d();
            $ddf18a96c86c2e3c$export$ef35774e6d314e91(each_blocks, detaching);
            if (if_block1) if_block1.d();
            mounted = false;
            dispose();
        }
    };
}
const $ddf18a96c86c2e3c$var$wheresMyWalletDefault = "https://www.blocknative.com/blog/metamask-wont-connect-web3-wallet-troubleshooting";
function $ddf18a96c86c2e3c$var$instance$6($$self, $$props, $$invalidate) {
    let $_;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, (0, $8VqiI._), ($$value)=>$$invalidate(5, $_ = $$value));
    let { wallets: wallets } = $$props;
    let { selectWallet: selectWallet } = $$props;
    let { connectingWalletLabel: connectingWalletLabel } = $$props;
    let { connectingErrorMessage: connectingErrorMessage } = $$props;
    let windowWidth;
    const { connect: connect } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
    function checkConnected(label) {
        const { wallets: wallets } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
        return !!wallets.find((wallet)=>wallet.label === label);
    }
    function onwindowresize() {
        $$invalidate(4, windowWidth = window.innerWidth);
    }
    const func = (wallet)=>selectWallet(wallet);
    $$self.$$set = ($$props)=>{
        if ("wallets" in $$props) $$invalidate(0, wallets = $$props.wallets);
        if ("selectWallet" in $$props) $$invalidate(1, selectWallet = $$props.selectWallet);
        if ("connectingWalletLabel" in $$props) $$invalidate(2, connectingWalletLabel = $$props.connectingWalletLabel);
        if ("connectingErrorMessage" in $$props) $$invalidate(3, connectingErrorMessage = $$props.connectingErrorMessage);
    };
    return [
        wallets,
        selectWallet,
        connectingWalletLabel,
        connectingErrorMessage,
        windowWidth,
        $_,
        connect,
        checkConnected,
        onwindowresize,
        func
    ];
}
class $ddf18a96c86c2e3c$var$SelectingWallet extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$6, $ddf18a96c86c2e3c$var$create_fragment$6, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            wallets: 0,
            selectWallet: 1,
            connectingWalletLabel: 2,
            connectingErrorMessage: 3
        }, $ddf18a96c86c2e3c$var$add_css$6);
    }
}
/* src/views/connect/Sidebar.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$5(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-obaru3", ".sidebar.svelte-obaru3{--background-color:var(\n      --onboard-connect-sidebar-background,\n      var(--w3o-foreground-color, none)\n    );--text-color:var(--onboard-connect-sidebar-color, inherit);--border-color:var(--onboard-connect-sidebar-border-color, inherit);display:flex;flex-flow:column;gap:1rem;padding:1rem;align-items:center}.inner-container.svelte-obaru3{display:flex;flex-flow:column;align-items:center;align-self:stretch;gap:0.5rem;padding:1.5rem;text-align:center;border:1px solid transparent;border-radius:12px;border-color:var(--border-color);background:var(--background-color);color:var(--text-color)}.icon-container.svelte-obaru3{display:flex;height:3.5rem;width:auto;min-width:3.5rem;max-width:100%}.heading.svelte-obaru3{font-size:var(--onboard-font-size-3, var(--font-size-3));margin:0 0 var(--onboard-spacing-5, var(--spacing-5)) 0}.subheading.svelte-obaru3{line-height:1rem}.description.svelte-obaru3{line-height:1.25rem;font-size:var(--onboard-font-size-6, var(--font-size-6))}img.svelte-obaru3{max-width:100%;height:auto}.indicators.svelte-obaru3{margin-top:auto}.indicator.svelte-obaru3{box-sizing:content-box;width:8px;height:8px;border-radius:8px;background:var(\n      --onboard-connect-sidebar-progress-background,\n      var(--onboard-gray-700, var(--gray-700))\n    );transition:background 250ms ease-in-out}.indicator.on.svelte-obaru3{background:var(\n      --onboard-connect-sidebar-progress-color,\n      var(--action-color)\n    );border:2px solid\n      var(\n        --onboard-connect-sidebar-progress-background,\n        var(--onboard-gray-700, var(--gray-700))\n      )}.join.svelte-obaru3{box-sizing:content-box;z-index:1;right:4px;height:2px;background:var(\n      --onboard-connect-sidebar-progress-background,\n      var(--onboard-gray-700, var(--gray-700))\n    );transition:background 250ms ease-in-out}.join.active.svelte-obaru3{background:var(\n      --onboard-connect-sidebar-progress-color,\n      var(--action-color)\n    )}.no-link.svelte-obaru3{display:flex;flex-direction:row;align-items:center;padding:0.25rem 0.5rem 0.25rem 0.75rem;gap:0.25rem;font-size:var(--onboard-font-size-6, var(--font-size-6))}.info-icon.svelte-obaru3{width:1.25rem;display:flex;align-items:center}@media all and (min-width: 768px){.sidebar.svelte-obaru3{max-width:280px;border-right:1px solid;border-color:var(--border-color);background:var(--background-color)}.inner-container.svelte-obaru3{border:none;text-align:initial;flex:1;align-items:flex-start;gap:1rem}.indicators.svelte-obaru3{margin-bottom:0.25rem}}");
}
// (164:4) {#if windowWidth >= MOBILE_WINDOW_WIDTH}
function $ddf18a96c86c2e3c$var$create_if_block_3$2(ctx) {
    let div;
    let t;
    let show_if = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
        default: ""
    });
    let if_block1_anchor;
    function select_block_type(ctx, dirty) {
        if (/*$appMetadata$*/ ctx[2] && /*$appMetadata$*/ (ctx[2].logo || /*$appMetadata$*/ ctx[2].icon)) return $ddf18a96c86c2e3c$var$create_if_block_5$2;
        return $ddf18a96c86c2e3c$var$create_else_block_1$1;
    }
    let current_block_type = select_block_type(ctx);
    let if_block0 = current_block_type(ctx);
    let if_block1 = show_if && $ddf18a96c86c2e3c$var$create_if_block_4$2(ctx);
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if_block0.c();
            t = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            if_block1_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "icon-container svelte-obaru3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            if_block0.m(div, null);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t, anchor);
            if (if_block1) if_block1.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block1_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block0) if_block0.p(ctx, dirty);
            else {
                if_block0.d(1);
                if_block0 = current_block_type(ctx);
                if (if_block0) {
                    if_block0.c();
                    if_block0.m(div, null);
                }
            }
            if (dirty & /*$_, step*/ 9) show_if = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
                default: ""
            });
            if (show_if) {
                if (if_block1) if_block1.p(ctx, dirty);
                else {
                    if_block1 = $ddf18a96c86c2e3c$var$create_if_block_4$2(ctx);
                    if_block1.c();
                    if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            if_block0.d();
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t);
            if (if_block1) if_block1.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block1_anchor);
        }
    };
}
// (172:8) {:else}
function $ddf18a96c86c2e3c$var$create_else_block_1$1(ctx) {
    let html_tag;
    let html_anchor;
    return {
        c () {
            html_tag = new $ddf18a96c86c2e3c$export$ce26c07117d59d6a(false);
            html_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m($ddf18a96c86c2e3c$var$defaultBnIcon, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (166:8) {#if $appMetadata$ && ($appMetadata$.logo || $appMetadata$.icon)}
function $ddf18a96c86c2e3c$var$create_if_block_5$2(ctx) {
    let show_if;
    let if_block_anchor;
    function select_block_type_1(ctx, dirty) {
        if (dirty & /*$appMetadata$*/ 4) show_if = null;
        if (show_if == null) show_if = !!$ddf18a96c86c2e3c$export$34aec0b863436764(/*$appMetadata$*/ ctx[2].logo || /*$appMetadata$*/ ctx[2].icon);
        if (show_if) return $ddf18a96c86c2e3c$var$create_if_block_6$2;
        return $ddf18a96c86c2e3c$var$create_else_block$1;
    }
    let current_block_type = select_block_type_1(ctx, -1);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        d (detaching) {
            if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (169:10) {:else}
function $ddf18a96c86c2e3c$var$create_else_block$1(ctx) {
    let img;
    let img_src_value;
    return {
        c () {
            img = $ddf18a96c86c2e3c$export$35e795649ee09318("img");
            if (!$ddf18a96c86c2e3c$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[2].logo || /*$appMetadata$*/ ctx[2].icon)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "src", img_src_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "alt", "logo");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "class", "svelte-obaru3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, img, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$appMetadata$*/ 4 && !$ddf18a96c86c2e3c$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[2].logo || /*$appMetadata$*/ ctx[2].icon)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "src", img_src_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(img);
        }
    };
}
// (167:10) {#if isSVG($appMetadata$.logo || $appMetadata$.icon)}
function $ddf18a96c86c2e3c$var$create_if_block_6$2(ctx) {
    let html_tag;
    let raw_value = /*$appMetadata$*/ (ctx[2].logo || /*$appMetadata$*/ ctx[2].icon) + "";
    let t;
    return {
        c () {
            html_tag = new $ddf18a96c86c2e3c$export$ce26c07117d59d6a(false);
            t = $ddf18a96c86c2e3c$export$625550452a3fa3ec("\u200B");
            html_tag.a = t;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t, anchor);
        },
        p (ctx, dirty) {
            if (dirty & /*$appMetadata$*/ 4 && raw_value !== (raw_value = /*$appMetadata$*/ (ctx[2].logo || /*$appMetadata$*/ ctx[2].icon) + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) html_tag.d();
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t);
        }
    };
}
// (176:6) {#if $_(`connect.${step}.sidebar.header`, { default: '' })}
function $ddf18a96c86c2e3c$var$create_if_block_4$2(ctx) {
    let div;
    let t_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
        default: /*heading*/ ctx[7]
    }) + "";
    let t;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "heading svelte-obaru3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div, t);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, step*/ 9 && t_value !== (t_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.header`, {
                default: /*heading*/ ctx[7]
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
// (197:4) {#if !connect.removeIDontHaveAWalletInfoLink}
function $ddf18a96c86c2e3c$var$create_if_block_2$2(ctx) {
    let a;
    let t0_value = /*$_*/ ctx[3]("connect.selectingWallet.sidebar.IDontHaveAWallet", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.sidebar.IDontHaveAWallet
    }) + "";
    let t0;
    let t1;
    let div;
    return {
        c () {
            a = $ddf18a96c86c2e3c$export$35e795649ee09318("a");
            t0 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t0_value);
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "info-icon svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "href", /*connect*/ ctx[4].iDontHaveAWalletLink || "https://ethereum.org/en/wallets/find-wallet/#main-content");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "target", "_blank");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "class", "no-link svelte-obaru3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, a, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(a, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(a, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(a, div);
            div.innerHTML = $ddf18a96c86c2e3c$var$infoIcon;
        },
        p (ctx, dirty) {
            if (dirty & /*$_*/ 8 && t0_value !== (t0_value = /*$_*/ ctx[3]("connect.selectingWallet.sidebar.IDontHaveAWallet", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect.selectingWallet.sidebar.IDontHaveAWallet
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t0, t0_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(a);
        }
    };
}
// (210:4) {#if windowWidth < MOBILE_WINDOW_WIDTH}
function $ddf18a96c86c2e3c$var$create_if_block_1$2(ctx) {
    let div5;
    let div0;
    let t0;
    let div1;
    let div1_style_value;
    let t1;
    let div2;
    let t2;
    let div3;
    let div3_style_value;
    let t3;
    let div4;
    return {
        c () {
            div5 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div3 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t3 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div4 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "indicator relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div0, "on", true);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "join relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value = `${ctx[0] !== "selectingWallet" ? "right: 4px; width: 52px;" : "right: 2px; width: 54px;"}`);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== "selectingWallet");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "indicator relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "style", `right: 8px;`);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== "selectingWallet");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "class", "join relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "style", div3_style_value = `${ctx[0] === "connectedWallet" ? "right: 12px; width: 52px;" : "right: 10px; width: 54px;"}`);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === "connectedWallet");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "style", `right: 16px;`);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "class", "indicator relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === "connectedWallet");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div5, "class", "indicators flex items-center svelte-obaru3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div5, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, t3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div4);
        },
        p (ctx, dirty) {
            if (dirty & /*step*/ 1 && div1_style_value !== (div1_style_value = `${ctx[0] !== "selectingWallet" ? "right: 4px; width: 52px;" : "right: 2px; width: 54px;"}`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value);
            if (dirty & /*step*/ 1) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== "selectingWallet");
            if (dirty & /*step*/ 1) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== "selectingWallet");
            if (dirty & /*step*/ 1 && div3_style_value !== (div3_style_value = `${ctx[0] === "connectedWallet" ? "right: 12px; width: 52px;" : "right: 10px; width: 54px;"}`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "style", div3_style_value);
            if (dirty & /*step*/ 1) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === "connectedWallet");
            if (dirty & /*step*/ 1) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === "connectedWallet");
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div5);
        }
    };
}
// (244:2) {#if windowWidth >= MOBILE_WINDOW_WIDTH}
function $ddf18a96c86c2e3c$var$create_if_block$3(ctx) {
    let div5;
    let div0;
    let t0;
    let div1;
    let div1_style_value;
    let t1;
    let div2;
    let t2;
    let div3;
    let div3_style_value;
    let t3;
    let div4;
    return {
        c () {
            div5 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div3 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t3 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div4 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "indicator relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div0, "on", true);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "join relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value = `right: 2px; ${ctx[0] !== "selectingWallet" ? "width: 78px;" : "width: 82px;"}`);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== "selectingWallet");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "indicator relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "style", `right: 4px;`);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== "selectingWallet");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "class", "join relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "style", div3_style_value = `right: 6px; ${ctx[0] === "connectedWallet" ? "width: 74px;" : "width: 81px;"}`);
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === "connectedWallet");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "style", `right: 8px;`);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "class", "indicator relative svelte-obaru3");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === "connectedWallet");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div5, "class", "indicators flex items-center svelte-obaru3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div5, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, t3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div5, div4);
        },
        p (ctx, dirty) {
            if (dirty & /*step*/ 1 && div1_style_value !== (div1_style_value = `right: 2px; ${ctx[0] !== "selectingWallet" ? "width: 78px;" : "width: 82px;"}`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value);
            if (dirty & /*step*/ 1) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div1, "active", /*step*/ ctx[0] !== "selectingWallet");
            if (dirty & /*step*/ 1) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div2, "on", /*step*/ ctx[0] !== "selectingWallet");
            if (dirty & /*step*/ 1 && div3_style_value !== (div3_style_value = `right: 6px; ${ctx[0] === "connectedWallet" ? "width: 74px;" : "width: 81px;"}`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "style", div3_style_value);
            if (dirty & /*step*/ 1) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div3, "active", /*step*/ ctx[0] === "connectedWallet");
            if (dirty & /*step*/ 1) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div4, "on", /*step*/ ctx[0] === "connectedWallet");
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div5);
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$5(ctx) {
    let div4;
    let div2;
    let t0;
    let div0;
    let t1_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.subheading`, {
        default: /*subheading*/ ctx[5]
    }) + "";
    let t1;
    let t2;
    let div1;
    let t3_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.paragraph`, {
        values: {
            app: /*$appMetadata$*/ ctx[2] && /*$appMetadata$*/ ctx[2].name || "This App"
        },
        default: /*paragraph*/ ctx[6]
    }) + "";
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let div3;
    let mounted;
    let dispose;
    $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[9]);
    let if_block0 = /*windowWidth*/ ctx[1] >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH && $ddf18a96c86c2e3c$var$create_if_block_3$2(ctx);
    let if_block1 = !/*connect*/ ctx[4].removeIDontHaveAWalletInfoLink && $ddf18a96c86c2e3c$var$create_if_block_2$2(ctx);
    let if_block2 = /*windowWidth*/ ctx[1] < $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH && $ddf18a96c86c2e3c$var$create_if_block_1$2(ctx);
    let if_block3 = /*windowWidth*/ ctx[1] >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH && $ddf18a96c86c2e3c$var$create_if_block$3(ctx);
    return {
        c () {
            div4 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t1 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t1_value);
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t3 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t3_value);
            t4 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            t5 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t6 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block3) if_block3.c();
            t7 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div3 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "subheading svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "description svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "inner-container svelte-obaru3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "class", "sidebar svelte-obaru3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div4, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div2);
            if (if_block0) if_block0.m(div2, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, div0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div0, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, div1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t4);
            if (if_block1) if_block1.m(div2, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t5);
            if (if_block2) if_block2.m(div2, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, t6);
            if (if_block3) if_block3.m(div4, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, t7);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div3);
            div3.innerHTML = $ddf18a96c86c2e3c$export$a93c5207d687da10;
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[9]);
                mounted = true;
            }
        },
        p (ctx, [dirty]) {
            if (/*windowWidth*/ ctx[1] >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH) {
                if (if_block0) if_block0.p(ctx, dirty);
                else {
                    if_block0 = $ddf18a96c86c2e3c$var$create_if_block_3$2(ctx);
                    if_block0.c();
                    if_block0.m(div2, t0);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            if (dirty & /*$_, step*/ 9 && t1_value !== (t1_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.subheading`, {
                default: /*subheading*/ ctx[5]
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t1, t1_value);
            if (dirty & /*$_, step, $appMetadata$*/ 13 && t3_value !== (t3_value = /*$_*/ ctx[3](`connect.${ctx[0]}.sidebar.paragraph`, {
                values: {
                    app: /*$appMetadata$*/ ctx[2] && /*$appMetadata$*/ ctx[2].name || "This App"
                },
                default: /*paragraph*/ ctx[6]
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t3, t3_value);
            if (!/*connect*/ ctx[4].removeIDontHaveAWalletInfoLink) if_block1.p(ctx, dirty);
            if (/*windowWidth*/ ctx[1] < $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH) {
                if (if_block2) if_block2.p(ctx, dirty);
                else {
                    if_block2 = $ddf18a96c86c2e3c$var$create_if_block_1$2(ctx);
                    if_block2.c();
                    if_block2.m(div2, null);
                }
            } else if (if_block2) {
                if_block2.d(1);
                if_block2 = null;
            }
            if (/*windowWidth*/ ctx[1] >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH) {
                if (if_block3) if_block3.p(ctx, dirty);
                else {
                    if_block3 = $ddf18a96c86c2e3c$var$create_if_block$3(ctx);
                    if_block3.c();
                    if_block3.m(div4, t7);
                }
            } else if (if_block3) {
                if_block3.d(1);
                if_block3 = null;
            }
        },
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div4);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            if (if_block2) if_block2.d();
            if (if_block3) if_block3.d();
            mounted = false;
            dispose();
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$5($$self, $$props, $$invalidate) {
    let $appMetadata$;
    let $_;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, (0, $8VqiI._), ($$value)=>$$invalidate(3, $_ = $$value));
    let { step: step } = $$props;
    const { connect: connect } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
    const defaultContent = $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect[step].sidebar;
    const { subheading: subheading, paragraph: paragraph } = defaultContent;
    const { heading: heading } = defaultContent;
    let windowWidth;
    const appMetadata$ = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $lLJqC.startWith)($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().appMetadata), (0, $fn8ZQ.shareReplay)(1));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(2, $appMetadata$ = value));
    function onwindowresize() {
        $$invalidate(1, windowWidth = window.innerWidth);
    }
    $$self.$$set = ($$props)=>{
        if ("step" in $$props) $$invalidate(0, step = $$props.step);
    };
    return [
        step,
        windowWidth,
        $appMetadata$,
        $_,
        connect,
        subheading,
        paragraph,
        heading,
        appMetadata$,
        onwindowresize
    ];
}
class $ddf18a96c86c2e3c$var$Sidebar extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$5, $ddf18a96c86c2e3c$var$create_fragment$5, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            step: 0
        }, $ddf18a96c86c2e3c$var$add_css$5);
    }
}
/* src/views/connect/Index.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$4(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-1qwmck3", ".container.svelte-1qwmck3{--background-color:var(\n      --onboard-main-scroll-container-background,\n      var(--w3o-background-color)\n    );--foreground-color:var(--w3o-foreground-color);--text-color:var(--onboard-connect-text-color, var(--w3o-text-color));--border-color:var(--w3o-border-color, var(--gray-200));--action-color:var(--w3o-action-color, var(--primary-500));font-family:var(--onboard-font-family-normal, var(--font-family-normal));font-size:var(--onboard-font-size-5, 1rem);background:var(--background-color);color:var(--text-color);border-color:var(--border-color);line-height:24px;overflow:hidden;position:relative;display:flex;height:min-content;flex-flow:column-reverse}.content.svelte-1qwmck3{width:var(--onboard-connect-content-width, 100%)}.header.svelte-1qwmck3{display:flex;padding:1rem;border-bottom:1px solid transparent;background:var(--onboard-connect-header-background);color:var(--onboard-connect-header-color);border-color:var(--border-color)}.header-heading.svelte-1qwmck3{line-height:1rem}.button-container.svelte-1qwmck3{right:0.5rem;top:0.5rem}.mobile-header.svelte-1qwmck3{display:flex;gap:0.5rem;height:4.5rem;padding:1rem;border-bottom:1px solid;border-color:var(--border-color)}.mobile-subheader.svelte-1qwmck3{opacity:0.6;font-size:0.875rem;font-weight:400;line-height:1rem;margin-top:0.25rem}.icon-container.svelte-1qwmck3{display:flex;flex:0 0 auto;height:2.5rem;width:2.5rem;min-width:2.5rem;justify-content:center;align-items:center}.disabled.svelte-1qwmck3{opacity:0.2;pointer-events:none;overflow:hidden}.icon-container svg{display:block;height:100%;width:auto}.w-full.svelte-1qwmck3{width:100%}.scroll-container.svelte-1qwmck3{overflow-y:auto;transition:opacity 250ms ease-in-out;scrollbar-width:none}.scroll-container.svelte-1qwmck3::-webkit-scrollbar{display:none}@media all and (min-width: 768px){.container.svelte-1qwmck3{margin:0;flex-flow:row;height:var(--onboard-connect-content-height, 440px)}.content.svelte-1qwmck3{width:var(--onboard-connect-content-width, 488px)}.mobile-subheader.svelte-1qwmck3{display:none}.icon-container.svelte-1qwmck3{display:none}}");
}
// (454:0) {#if !autoSelect.disableModals}
function $ddf18a96c86c2e3c$var$create_if_block$2(ctx) {
    let modal;
    let current;
    modal = new $ddf18a96c86c2e3c$export$8743009a87fcb00f({
        props: {
            close: !/*connect*/ ctx[16].disableClose && /*close*/ ctx[20],
            $$slots: {
                default: [
                    $ddf18a96c86c2e3c$var$create_default_slot$2
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(modal.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(modal, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const modal_changes = {};
            if (dirty[0] & /*scrollContainer, selectedWallet, $modalStep$, windowWidth, connectionRejected, previousConnectionRequest, displayConnectingWallet, agreed, wallets, connectingWalletLabel, connectingErrorMessage, availableWallets, $_, $appMetadata$*/ 32766 | dirty[1] & /*$$scope*/ 32) modal_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            modal.$set(modal_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(modal.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(modal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(modal, detaching);
        }
    };
}
// (457:6) {#if connect.showSidebar}
function $ddf18a96c86c2e3c$var$create_if_block_9$1(ctx) {
    let sidebar;
    let current;
    sidebar = new $ddf18a96c86c2e3c$var$Sidebar({
        props: {
            step: /*$modalStep$*/ ctx[5]
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(sidebar.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(sidebar, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const sidebar_changes = {};
            if (dirty[0] & /*$modalStep$*/ 32) sidebar_changes.step = /*$modalStep$*/ ctx[5];
            sidebar.$set(sidebar_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(sidebar.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(sidebar.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(sidebar, detaching);
        }
    };
}
// (500:8) {:else}
function $ddf18a96c86c2e3c$var$create_else_block_3(ctx) {
    let div1;
    let div0;
    let t0_value = /*$_*/ ctx[14](`connect.${ctx[5]}.header`, {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header,
        values: {
            connectionRejected: /*connectionRejected*/ ctx[1],
            wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
        }
    }) + "";
    let t0;
    let t1;
    let t2_value = /*$modalStep$*/ (ctx[5] === "selectingWallet" ? `(${ctx[12]})` : "") + "";
    let t2;
    return {
        c () {
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t0 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t0_value);
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            t2 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t2_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "header-heading svelte-1qwmck3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "header relative flex items-center svelte-1qwmck3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div1, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div0, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div0, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div0, t2);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$_, $modalStep$, connectionRejected, selectedWallet*/ 16426 && t0_value !== (t0_value = /*$_*/ ctx[14](`connect.${ctx[5]}.header`, {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header,
                values: {
                    connectionRejected: /*connectionRejected*/ ctx[1],
                    wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t0, t0_value);
            if (dirty[0] & /*$modalStep$, availableWallets*/ 4128 && t2_value !== (t2_value = /*$modalStep$*/ (ctx[5] === "selectingWallet" ? `(${ctx[12]})` : "") + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t2, t2_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div1);
        }
    };
}
// (462:8) {#if windowWidth <= MOBILE_WINDOW_WIDTH}
function $ddf18a96c86c2e3c$var$create_if_block_6$1(ctx) {
    let div4;
    let div0;
    let t0;
    let div3;
    let div1;
    let t1_value = /*$_*/ ctx[14](/*$modalStep$*/ ctx[5] === "connectingWallet" && /*selectedWallet*/ ctx[3] ? `connect.${ctx[5]}.header` : `connect.${ctx[5]}.sidebar.subheading`, {
        default: /*$modalStep$*/ ctx[5] === "connectingWallet" && /*selectedWallet*/ ctx[3] ? $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header : $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].sidebar.subheading,
        values: {
            connectionRejected: /*connectionRejected*/ ctx[1],
            wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
        }
    }) + "";
    let t1;
    let t2;
    let div2;
    let t3_value = /*$modalStep$*/ (ctx[5] === "selectingWallet" ? `${ctx[12]} available wallets` : "1 account selected") + "";
    let t3;
    function select_block_type_1(ctx, dirty) {
        if (/*$appMetadata$*/ ctx[13] && /*$appMetadata$*/ ctx[13].icon) return $ddf18a96c86c2e3c$var$create_if_block_7$1;
        return $ddf18a96c86c2e3c$var$create_else_block_2;
    }
    let current_block_type = select_block_type_1(ctx);
    let if_block = current_block_type(ctx);
    return {
        c () {
            div4 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if_block.c();
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div3 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t1 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t1_value);
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            t3 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t3_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "icon-container svelte-1qwmck3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "header-heading svelte-1qwmck3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "mobile-subheader svelte-1qwmck3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div3, "class", "flex flex-column justify-center w-full svelte-1qwmck3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div4, "class", "mobile-header svelte-1qwmck3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div4, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div0);
            if_block.m(div0, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div4, div3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, div1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div3, div2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t3);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_1(ctx)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(div0, null);
                }
            }
            if (dirty[0] & /*$_, $modalStep$, selectedWallet, connectionRejected*/ 16426 && t1_value !== (t1_value = /*$_*/ ctx[14](/*$modalStep$*/ ctx[5] === "connectingWallet" && /*selectedWallet*/ ctx[3] ? `connect.${ctx[5]}.header` : `connect.${ctx[5]}.sidebar.subheading`, {
                default: /*$modalStep$*/ ctx[5] === "connectingWallet" && /*selectedWallet*/ ctx[3] ? $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].header : $ddf18a96c86c2e3c$export$e7094788287c5e9b.connect[/*$modalStep$*/ ctx[5]].sidebar.subheading,
                values: {
                    connectionRejected: /*connectionRejected*/ ctx[1],
                    wallet: /*selectedWallet*/ ctx[3] && /*selectedWallet*/ ctx[3].label
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t1, t1_value);
            if (dirty[0] & /*$modalStep$, availableWallets*/ 4128 && t3_value !== (t3_value = /*$modalStep$*/ (ctx[5] === "selectingWallet" ? `${ctx[12]} available wallets` : "1 account selected") + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t3, t3_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div4);
            if_block.d();
        }
    };
}
// (471:14) {:else}
function $ddf18a96c86c2e3c$var$create_else_block_2(ctx) {
    let html_tag;
    let html_anchor;
    return {
        c () {
            html_tag = new $ddf18a96c86c2e3c$export$ce26c07117d59d6a(false);
            html_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m($ddf18a96c86c2e3c$var$defaultBnIcon, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (465:14) {#if $appMetadata$ && $appMetadata$.icon}
function $ddf18a96c86c2e3c$var$create_if_block_7$1(ctx) {
    let show_if;
    let if_block_anchor;
    function select_block_type_2(ctx, dirty) {
        if (dirty[0] & /*$appMetadata$*/ 8192) show_if = null;
        if (show_if == null) show_if = !!$ddf18a96c86c2e3c$export$34aec0b863436764(/*$appMetadata$*/ ctx[13].icon);
        if (show_if) return $ddf18a96c86c2e3c$var$create_if_block_8$1;
        return $ddf18a96c86c2e3c$var$create_else_block_1;
    }
    let current_block_type = select_block_type_2(ctx, [
        -1,
        -1
    ]);
    let if_block = current_block_type(ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
        },
        p (ctx, dirty) {
            if (current_block_type === (current_block_type = select_block_type_2(ctx, dirty)) && if_block) if_block.p(ctx, dirty);
            else {
                if_block.d(1);
                if_block = current_block_type(ctx);
                if (if_block) {
                    if_block.c();
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            }
        },
        d (detaching) {
            if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (468:16) {:else}
function $ddf18a96c86c2e3c$var$create_else_block_1(ctx) {
    let img;
    let img_src_value;
    return {
        c () {
            img = $ddf18a96c86c2e3c$export$35e795649ee09318("img");
            if (!$ddf18a96c86c2e3c$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[13].icon)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "src", img_src_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "alt", "logo");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, img, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$appMetadata$*/ 8192 && !$ddf18a96c86c2e3c$export$3c2fa207a37baaea(img.src, img_src_value = /*$appMetadata$*/ ctx[13].icon)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(img, "src", img_src_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(img);
        }
    };
}
// (466:16) {#if isSVG($appMetadata$.icon)}
function $ddf18a96c86c2e3c$var$create_if_block_8$1(ctx) {
    let html_tag;
    let raw_value = /*$appMetadata$*/ ctx[13].icon + "";
    let html_anchor;
    return {
        c () {
            html_tag = new $ddf18a96c86c2e3c$export$ce26c07117d59d6a(false);
            html_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            html_tag.a = html_anchor;
        },
        m (target, anchor) {
            html_tag.m(raw_value, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, html_anchor, anchor);
        },
        p (ctx, dirty) {
            if (dirty[0] & /*$appMetadata$*/ 8192 && raw_value !== (raw_value = /*$appMetadata$*/ ctx[13].icon + "")) html_tag.p(raw_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(html_anchor);
            if (detaching) html_tag.d();
        }
    };
}
// (514:8) {#if !connect.disableClose}
function $ddf18a96c86c2e3c$var$create_if_block_5$1(ctx) {
    let div;
    let closebutton;
    let current;
    let mounted;
    let dispose;
    closebutton = new $ddf18a96c86c2e3c$var$CloseButton({});
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(closebutton.$$.fragment);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "button-container absolute svelte-1qwmck3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(closebutton, div, null);
            current = true;
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(div, "click", /*close*/ ctx[20]);
                mounted = true;
            }
        },
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(closebutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(closebutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(closebutton);
            mounted = false;
            dispose();
        }
    };
}
// (521:10) {#if $modalStep$ === 'selectingWallet' || windowWidth <= MOBILE_WINDOW_WIDTH}
function $ddf18a96c86c2e3c$var$create_if_block_3$1(ctx) {
    let current_block_type_index;
    let if_block;
    let if_block_anchor;
    let current;
    const if_block_creators = [
        $ddf18a96c86c2e3c$var$create_if_block_4$1,
        $ddf18a96c86c2e3c$var$create_else_block
    ];
    const if_blocks = [];
    function select_block_type_3(ctx, dirty) {
        if (/*wallets*/ ctx[2].length) return 0;
        return 1;
    }
    current_block_type_index = select_block_type_3(ctx);
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
    return {
        c () {
            if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if_blocks[current_block_type_index].m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            let previous_block_index = current_block_type_index;
            current_block_type_index = select_block_type_3(ctx);
            if (current_block_type_index === previous_block_index) if_blocks[current_block_type_index].p(ctx, dirty);
            else {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_blocks[previous_block_index], 1, 1, ()=>{
                    if_blocks[previous_block_index] = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
                if_block = if_blocks[current_block_type_index];
                if (!if_block) {
                    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
                    if_block.c();
                } else if_block.p(ctx, dirty);
                $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block, 1);
                if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if_blocks[current_block_type_index].d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (533:12) {:else}
function $ddf18a96c86c2e3c$var$create_else_block(ctx) {
    let installwallet;
    let current;
    installwallet = new $ddf18a96c86c2e3c$var$InstallWallet({});
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(installwallet.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(installwallet, target, anchor);
            current = true;
        },
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(installwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(installwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(installwallet, detaching);
        }
    };
}
// (522:12) {#if wallets.length}
function $ddf18a96c86c2e3c$var$create_if_block_4$1(ctx) {
    let agreement;
    let updating_agreed;
    let t;
    let div;
    let selectingwallet;
    let current;
    function agreement_agreed_binding(value) {
        /*agreement_agreed_binding*/ ctx[24](value);
    }
    let agreement_props = {};
    if (/*agreed*/ ctx[7] !== void 0) agreement_props.agreed = /*agreed*/ ctx[7];
    agreement = new $ddf18a96c86c2e3c$var$Agreement({
        props: agreement_props
    });
    $ddf18a96c86c2e3c$export$39b482c5e57630a8.push(()=>$ddf18a96c86c2e3c$export$2219238a014317b0(agreement, "agreed", agreement_agreed_binding));
    selectingwallet = new $ddf18a96c86c2e3c$var$SelectingWallet({
        props: {
            selectWallet: /*selectWallet*/ ctx[18],
            wallets: /*wallets*/ ctx[2],
            connectingWalletLabel: /*connectingWalletLabel*/ ctx[8],
            connectingErrorMessage: /*connectingErrorMessage*/ ctx[9]
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(agreement.$$.fragment);
            t = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(selectingwallet.$$.fragment);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "svelte-1qwmck3");
            $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "disabled", !/*agreed*/ ctx[7]);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(agreement, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(selectingwallet, div, null);
            current = true;
        },
        p (ctx, dirty) {
            const agreement_changes = {};
            if (!updating_agreed && dirty[0] & /*agreed*/ 128) {
                updating_agreed = true;
                agreement_changes.agreed = /*agreed*/ ctx[7];
                $ddf18a96c86c2e3c$export$4c3d22f3d993c33f(()=>updating_agreed = false);
            }
            agreement.$set(agreement_changes);
            const selectingwallet_changes = {};
            if (dirty[0] & /*wallets*/ 4) selectingwallet_changes.wallets = /*wallets*/ ctx[2];
            if (dirty[0] & /*connectingWalletLabel*/ 256) selectingwallet_changes.connectingWalletLabel = /*connectingWalletLabel*/ ctx[8];
            if (dirty[0] & /*connectingErrorMessage*/ 512) selectingwallet_changes.connectingErrorMessage = /*connectingErrorMessage*/ ctx[9];
            selectingwallet.$set(selectingwallet_changes);
            if (!current || dirty[0] & /*agreed*/ 128) $ddf18a96c86c2e3c$export$7f8ddf7c7c20b3cd(div, "disabled", !/*agreed*/ ctx[7]);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(agreement.$$.fragment, local);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(selectingwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(agreement.$$.fragment, local);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(selectingwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(agreement, detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(selectingwallet);
        }
    };
}
// (538:10) {#if displayConnectingWallet}
function $ddf18a96c86c2e3c$var$create_if_block_2$1(ctx) {
    let connectingwallet;
    let current;
    connectingwallet = new $ddf18a96c86c2e3c$var$ConnectingWallet({
        props: {
            connectWallet: /*connectWallet*/ ctx[21],
            connectionRejected: /*connectionRejected*/ ctx[1],
            previousConnectionRequest: /*previousConnectionRequest*/ ctx[6],
            setStep: /*setStep*/ ctx[22],
            deselectWallet: /*deselectWallet*/ ctx[19],
            selectedWallet: /*selectedWallet*/ ctx[3]
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(connectingwallet.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(connectingwallet, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const connectingwallet_changes = {};
            if (dirty[0] & /*connectionRejected*/ 2) connectingwallet_changes.connectionRejected = /*connectionRejected*/ ctx[1];
            if (dirty[0] & /*previousConnectionRequest*/ 64) connectingwallet_changes.previousConnectionRequest = /*previousConnectionRequest*/ ctx[6];
            if (dirty[0] & /*selectedWallet*/ 8) connectingwallet_changes.selectedWallet = /*selectedWallet*/ ctx[3];
            connectingwallet.$set(connectingwallet_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(connectingwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(connectingwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(connectingwallet, detaching);
        }
    };
}
// (549:10) {#if $modalStep$ === 'connectedWallet' && selectedWallet && windowWidth >= MOBILE_WINDOW_WIDTH}
function $ddf18a96c86c2e3c$var$create_if_block_1$1(ctx) {
    let connectedwallet;
    let current;
    connectedwallet = new $ddf18a96c86c2e3c$var$ConnectedWallet({
        props: {
            selectedWallet: /*selectedWallet*/ ctx[3]
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(connectedwallet.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(connectedwallet, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const connectedwallet_changes = {};
            if (dirty[0] & /*selectedWallet*/ 8) connectedwallet_changes.selectedWallet = /*selectedWallet*/ ctx[3];
            connectedwallet.$set(connectedwallet_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(connectedwallet.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(connectedwallet.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(connectedwallet, detaching);
        }
    };
}
// (455:2) <Modal close={!connect.disableClose && close}>
function $ddf18a96c86c2e3c$var$create_default_slot$2(ctx) {
    let div2;
    let t0;
    let div1;
    let t1;
    let t2;
    let div0;
    let t3;
    let t4;
    let current;
    let if_block0 = /*connect*/ ctx[16].showSidebar && $ddf18a96c86c2e3c$var$create_if_block_9$1(ctx);
    function select_block_type(ctx, dirty) {
        if (/*windowWidth*/ ctx[4] <= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH) return $ddf18a96c86c2e3c$var$create_if_block_6$1;
        return $ddf18a96c86c2e3c$var$create_else_block_3;
    }
    let current_block_type = select_block_type(ctx);
    let if_block1 = current_block_type(ctx);
    let if_block2 = !/*connect*/ ctx[16].disableClose && $ddf18a96c86c2e3c$var$create_if_block_5$1(ctx);
    let if_block3 = /*$modalStep$*/ (ctx[5] === "selectingWallet" || /*windowWidth*/ ctx[4] <= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH) && $ddf18a96c86c2e3c$var$create_if_block_3$1(ctx);
    let if_block4 = /*displayConnectingWallet*/ ctx[11] && $ddf18a96c86c2e3c$var$create_if_block_2$1(ctx);
    let if_block5 = /*$modalStep$*/ ctx[5] === "connectedWallet" && /*selectedWallet*/ ctx[3] && /*windowWidth*/ ctx[4] >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH && $ddf18a96c86c2e3c$var$create_if_block_1$1(ctx);
    return {
        c () {
            div2 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if_block1.c();
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (if_block3) if_block3.c();
            t3 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block4) if_block4.c();
            t4 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block5) if_block5.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "scroll-container svelte-1qwmck3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "content flex flex-column svelte-1qwmck3");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div2, "class", "container svelte-1qwmck3");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div2, anchor);
            if (if_block0) if_block0.m(div2, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div2, div1);
            if_block1.m(div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t1);
            if (if_block2) if_block2.m(div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            if (if_block3) if_block3.m(div0, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div0, t3);
            if (if_block4) if_block4.m(div0, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div0, t4);
            if (if_block5) if_block5.m(div0, null);
            /*div0_binding*/ ctx[25](div0);
            current = true;
        },
        p (ctx, dirty) {
            if (/*connect*/ ctx[16].showSidebar) if_block0.p(ctx, dirty);
            if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block1) if_block1.p(ctx, dirty);
            else {
                if_block1.d(1);
                if_block1 = current_block_type(ctx);
                if (if_block1) {
                    if_block1.c();
                    if_block1.m(div1, t1);
                }
            }
            if (!/*connect*/ ctx[16].disableClose) if_block2.p(ctx, dirty);
            if (/*$modalStep$*/ ctx[5] === "selectingWallet" || /*windowWidth*/ ctx[4] <= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH) {
                if (if_block3) {
                    if_block3.p(ctx, dirty);
                    if (dirty[0] & /*$modalStep$, windowWidth*/ 48) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block3, 1);
                } else {
                    if_block3 = $ddf18a96c86c2e3c$var$create_if_block_3$1(ctx);
                    if_block3.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block3, 1);
                    if_block3.m(div0, t3);
                }
            } else if (if_block3) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block3, 1, 1, ()=>{
                    if_block3 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (/*displayConnectingWallet*/ ctx[11]) {
                if (if_block4) {
                    if_block4.p(ctx, dirty);
                    if (dirty[0] & /*displayConnectingWallet*/ 2048) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block4, 1);
                } else {
                    if_block4 = $ddf18a96c86c2e3c$var$create_if_block_2$1(ctx);
                    if_block4.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block4, 1);
                    if_block4.m(div0, t4);
                }
            } else if (if_block4) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block4, 1, 1, ()=>{
                    if_block4 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (/*$modalStep$*/ ctx[5] === "connectedWallet" && /*selectedWallet*/ ctx[3] && /*windowWidth*/ ctx[4] >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH) {
                if (if_block5) {
                    if_block5.p(ctx, dirty);
                    if (dirty[0] & /*$modalStep$, selectedWallet, windowWidth*/ 56) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block5, 1);
                } else {
                    if_block5 = $ddf18a96c86c2e3c$var$create_if_block_1$1(ctx);
                    if_block5.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block5, 1);
                    if_block5.m(div0, null);
                }
            } else if (if_block5) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block5, 1, 1, ()=>{
                    if_block5 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block2);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block3);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block4);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block5);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block0);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block2);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block3);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block4);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block5);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div2);
            if (if_block0) if_block0.d();
            if_block1.d();
            if (if_block2) if_block2.d();
            if (if_block3) if_block3.d();
            if (if_block4) if_block4.d();
            if (if_block5) if_block5.d();
            /*div0_binding*/ ctx[25](null);
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$4(ctx) {
    let if_block_anchor;
    let current;
    let mounted;
    let dispose;
    $ddf18a96c86c2e3c$export$3a6d5c9ae78a2c08(/*onwindowresize*/ ctx[23]);
    let if_block = !/*autoSelect*/ ctx[0].disableModals && $ddf18a96c86c2e3c$var$create_if_block$2(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(window, "resize", /*onwindowresize*/ ctx[23]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if (!/*autoSelect*/ ctx[0].disableModals) {
                if (if_block) {
                    if_block.p(ctx, dirty);
                    if (dirty[0] & /*autoSelect*/ 1) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block, 1);
                } else {
                    if_block = $ddf18a96c86c2e3c$var$create_if_block$2(ctx);
                    if_block.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block, 1);
                    if_block.m(if_block_anchor.parentNode, if_block_anchor);
                }
            } else if (if_block) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block, 1, 1, ()=>{
                    if_block = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
            mounted = false;
            dispose();
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$4($$self, $$props, $$invalidate) {
    let availableWallets;
    let displayConnectingWallet;
    let $appMetadata$;
    let $modalStep$;
    let $_;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, (0, $8VqiI._), ($$value)=>$$invalidate(14, $_ = $$value));
    let { autoSelect: autoSelect } = $$props;
    const appMetadata$ = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("appMetadata").pipe((0, $lLJqC.startWith)($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().appMetadata), (0, $fn8ZQ.shareReplay)(1));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(13, $appMetadata$ = value));
    const { walletModules: walletModules, connect: connect, chains: chains } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
    const cancelPreviousConnect$ = new (0, $6jCRi.Subject)();
    const { unstoppableResolution: unstoppableResolution, wagmi: wagmi } = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57;
    let connectionRejected = false;
    let previousConnectionRequest = false;
    let wallets = [];
    let selectedWallet;
    let agreed;
    let connectingWalletLabel;
    let connectingErrorMessage;
    let windowWidth;
    let scrollContainer;
    const modalStep$ = new (0, $l4gH8.BehaviorSubject)("selectingWallet");
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, modalStep$, (value)=>$$invalidate(5, $modalStep$ = value));
    // handle the edge case where disableModals was set to true on first call
    // and then set to false on second call and there is still a pending call
    $ddf18a96c86c2e3c$export$a07804094c3ecf2d.pipe((0, $i27jC.distinctUntilChanged)((prev, curr)=>prev.autoSelect && curr.autoSelect && prev.autoSelect.disableModals === curr.autoSelect.disableModals), (0, $bPD7y.filter)(({ autoSelect: autoSelect })=>autoSelect && autoSelect.disableModals === false), (0, $1mIQr.takeUntil)($ddf18a96c86c2e3c$var$onDestroy$)).subscribe(()=>{
        selectedWallet && connectWallet();
    });
    // ==== SELECT WALLET ==== //
    async function selectWallet({ label: label, icon: icon, getInterface: getInterface }) {
        $$invalidate(8, connectingWalletLabel = label);
        try {
            const existingWallet = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().wallets.find((wallet)=>wallet.label === label);
            if (existingWallet) {
                // set as first wallet
                $ddf18a96c86c2e3c$var$addWallet(existingWallet);
                setTimeout(()=>setStep("connectedWallet"), 1);
                $$invalidate(3, selectedWallet = existingWallet);
                return;
            }
            const { chains: chains } = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get();
            const { provider: provider, instance: instance } = await getInterface({
                chains: chains,
                EventEmitter: (/*@__PURE__*/$parcel$interopDefault($aTZNU)),
                appMetadata: $appMetadata$
            });
            const loadedIcon = await icon;
            $$invalidate(3, selectedWallet = {
                label: label,
                icon: loadedIcon,
                provider: provider,
                instance: instance,
                accounts: [],
                chains: [
                    {
                        namespace: "evm",
                        id: "0x1"
                    }
                ]
            });
            $$invalidate(9, connectingErrorMessage = "");
            scrollToTop();
            // change step on next event loop
            setTimeout(()=>setStep("connectingWallet"), 1);
        } catch (error) {
            const { message: message } = error;
            $$invalidate(9, connectingErrorMessage = message);
            $$invalidate(8, connectingWalletLabel = "");
            scrollToTop();
        }
    }
    function deselectWallet() {
        $$invalidate(3, selectedWallet = null);
    }
    function updateSelectedWallet(update) {
        $$invalidate(3, selectedWallet = Object.assign(Object.assign({}, selectedWallet), update));
    }
    async function autoSelectWallet(wallet) {
        const { getIcon: getIcon, getInterface: getInterface, label: label } = wallet;
        const icon = getIcon();
        selectWallet({
            label: label,
            icon: icon,
            getInterface: getInterface
        });
    }
    async function loadWalletsForSelection() {
        $$invalidate(2, wallets = walletModules.map(({ getIcon: getIcon, getInterface: getInterface, label: label })=>{
            return {
                label: label,
                icon: getIcon(),
                getInterface: getInterface
            };
        }));
    }
    function close() {
        $ddf18a96c86c2e3c$export$a07804094c3ecf2d.next({
            inProgress: false
        });
    }
    // ==== CONNECT WALLET ==== //
    async function connectWallet() {
        $$invalidate(1, connectionRejected = false);
        const { provider: provider, label: label } = selectedWallet;
        cancelPreviousConnect$.next();
        try {
            let address;
            let wagmiConnector;
            if (wagmi) {
                const { buildWagmiConfig: buildWagmiConfig, wagmiConnect: wagmiConnect, getWagmiConnector: getWagmiConnector } = wagmi;
                const wagmiConfig = await buildWagmiConfig(chains, {
                    label: label,
                    provider: provider
                });
                $ddf18a96c86c2e3c$var$updateWagmiConfig(wagmiConfig);
                wagmiConnector = getWagmiConnector(label);
                const accountsReq = await Promise.race([
                    wagmiConnect(wagmiConfig, {
                        connector: wagmiConnector
                    }),
                    // or connect wallet is called again whilst waiting for response
                    (0, $eqreU.firstValueFrom)(cancelPreviousConnect$.pipe((0, $kBz4k.mapTo)([])))
                ]);
                // canceled previous request
                if (!accountsReq || !("accounts" in accountsReq)) return;
                const [connectedAddress] = accountsReq.accounts;
                address = connectedAddress;
            } else {
                const [connectedAddress] = await Promise.race([
                    // resolved account
                    $ddf18a96c86c2e3c$var$requestAccounts(provider),
                    // or connect wallet is called again whilst waiting for response
                    (0, $eqreU.firstValueFrom)(cancelPreviousConnect$.pipe((0, $kBz4k.mapTo)([])))
                ]);
                // canceled previous request
                if (!connectedAddress) return;
                address = connectedAddress;
            }
            // store last connected wallet
            if ($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().connect.autoConnectLastWallet || $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().connect.autoConnectAllPreviousWallet) {
                let labelsList = $ddf18a96c86c2e3c$var$getLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
                try {
                    let labelsListParsed = JSON.parse(labelsList);
                    if (labelsListParsed && Array.isArray(labelsListParsed)) {
                        const tempLabels = labelsListParsed;
                        labelsList = [
                            ...new Set([
                                label,
                                ...tempLabels
                            ])
                        ];
                    }
                } catch (err) {
                    if (err instanceof SyntaxError && labelsList && typeof labelsList === "string") {
                        const tempLabel = labelsList;
                        labelsList = [
                            tempLabel
                        ];
                    } else throw new Error(err);
                }
                if (!labelsList) labelsList = [
                    label
                ];
                $ddf18a96c86c2e3c$var$setLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.LAST_CONNECTED_WALLET, JSON.stringify(labelsList));
            }
            const chain = await $ddf18a96c86c2e3c$var$getChainId(provider);
            if ($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().notify.enabled) {
                const sdk = await $ddf18a96c86c2e3c$var$getBNMulitChainSdk();
                if (sdk) try {
                    sdk.subscribe({
                        id: address,
                        chainId: chain,
                        type: "account"
                    });
                } catch (error) {} // unsupported network for transaction events
            }
            const update = {
                accounts: [
                    {
                        address: address,
                        ens: null,
                        uns: null,
                        balance: null
                    }
                ],
                chains: [
                    {
                        namespace: "evm",
                        id: chain
                    }
                ],
                wagmiConnector: wagmiConnector
            };
            $ddf18a96c86c2e3c$var$addWallet(Object.assign(Object.assign({}, selectedWallet), update));
            $ddf18a96c86c2e3c$var$trackWallet(provider, label);
            updateSelectedWallet(update);
            setStep("connectedWallet");
            scrollToTop();
        } catch (error) {
            const { code: code } = error;
            scrollToTop();
            // user rejected account access
            if (code === (0, $9s7cO.ProviderRpcErrorCode).ACCOUNT_ACCESS_REJECTED) {
                $$invalidate(1, connectionRejected = true);
                if (autoSelect.disableModals) $ddf18a96c86c2e3c$export$a07804094c3ecf2d.next({
                    inProgress: false
                });
                else if (autoSelect.label) $$invalidate(0, autoSelect.label = "", autoSelect);
                return;
            }
            // account access has already been requested and is awaiting approval
            if (code === (0, $9s7cO.ProviderRpcErrorCode).ACCOUNT_ACCESS_ALREADY_REQUESTED) {
                $$invalidate(6, previousConnectionRequest = true);
                if (autoSelect.disableModals) {
                    $ddf18a96c86c2e3c$export$a07804094c3ecf2d.next({
                        inProgress: false
                    });
                    return;
                }
                $ddf18a96c86c2e3c$var$listenAccountsChanged({
                    provider: selectedWallet.provider,
                    disconnected$: $ddf18a96c86c2e3c$export$a07804094c3ecf2d.pipe((0, $bPD7y.filter)(({ inProgress: inProgress })=>!inProgress), (0, $kBz4k.mapTo)(""))
                }).pipe((0, $czRBO.take)(1)).subscribe(([account])=>{
                    account && connectWallet();
                });
                return;
            }
        }
    }
    // ==== CONNECTED WALLET ==== //
    async function updateAccountDetails() {
        const { accounts: accounts, chains: selectedWalletChains } = selectedWallet;
        const appChains = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().chains;
        const [connectedWalletChain] = selectedWalletChains;
        const appChain = appChains.find(({ namespace: namespace, id: id })=>namespace === connectedWalletChain.namespace && id === connectedWalletChain.id);
        const { address: address } = accounts[0];
        let { balance: balance, ens: ens, uns: uns, secondaryTokens: secondaryTokens } = accounts[0];
        if (balance === null) $ddf18a96c86c2e3c$var$getBalance(address, appChain).then((balance)=>{
            $ddf18a96c86c2e3c$var$updateAccount(selectedWallet.label, address, {
                balance: balance
            });
        });
        if (appChain && !secondaryTokens && Array.isArray(appChain.secondaryTokens) && appChain.secondaryTokens.length) $ddf18a96c86c2e3c$var$updateSecondaryTokens(address, appChain).then((secondaryTokens)=>{
            $ddf18a96c86c2e3c$var$updateAccount(selectedWallet.label, address, {
                secondaryTokens: secondaryTokens
            });
        });
        if (ens === null && $ddf18a96c86c2e3c$var$validEnsChain(connectedWalletChain.id)) {
            const ensChain = chains.find(({ id: id })=>id === $ddf18a96c86c2e3c$var$validEnsChain(connectedWalletChain.id));
            $ddf18a96c86c2e3c$var$getEns(address, ensChain).then((ens)=>{
                $ddf18a96c86c2e3c$var$updateAccount(selectedWallet.label, address, {
                    ens: ens
                });
            });
        }
        if (uns === null && unstoppableResolution) $ddf18a96c86c2e3c$var$getUns(address, appChain).then((uns)=>{
            $ddf18a96c86c2e3c$var$updateAccount(selectedWallet.label, address, {
                uns: uns
            });
        });
        setTimeout(()=>$ddf18a96c86c2e3c$export$a07804094c3ecf2d.next({
                inProgress: false
            }), 1500);
    }
    modalStep$.pipe((0, $1mIQr.takeUntil)($ddf18a96c86c2e3c$var$onDestroy$)).subscribe((step)=>{
        switch(step){
            case "selectingWallet":
                if (autoSelect.label) {
                    const walletToAutoSelect = walletModules.find(({ label: label })=>label.toLowerCase() === autoSelect.label.toLowerCase());
                    if (walletToAutoSelect) autoSelectWallet(walletToAutoSelect);
                    else if (autoSelect.disableModals) $ddf18a96c86c2e3c$export$a07804094c3ecf2d.next({
                        inProgress: false
                    });
                } else {
                    $$invalidate(8, connectingWalletLabel = "");
                    loadWalletsForSelection();
                }
                break;
            case "connectingWallet":
                connectWallet();
                break;
            case "connectedWallet":
                $$invalidate(8, connectingWalletLabel = "");
                updateAccountDetails();
                break;
        }
    });
    function setStep(update) {
        cancelPreviousConnect$.next();
        modalStep$.next(update);
    }
    function scrollToTop() {
        scrollContainer && scrollContainer.scrollTo(0, 0);
    }
    function onwindowresize() {
        $$invalidate(4, windowWidth = window.innerWidth);
    }
    function agreement_agreed_binding(value) {
        agreed = value;
        $$invalidate(7, agreed);
    }
    function div0_binding($$value) {
        $ddf18a96c86c2e3c$export$39b482c5e57630a8[$$value ? "unshift" : "push"](()=>{
            scrollContainer = $$value;
            $$invalidate(10, scrollContainer);
        });
    }
    $$self.$$set = ($$props)=>{
        if ("autoSelect" in $$props) $$invalidate(0, autoSelect = $$props.autoSelect);
    };
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty[0] & /*wallets*/ 4) $$invalidate(12, availableWallets = wallets.length - $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().wallets.length);
        if ($$self.$$.dirty[0] & /*$modalStep$, selectedWallet, windowWidth, connectionRejected*/ 58) $$invalidate(11, displayConnectingWallet = $modalStep$ === "connectingWallet" && selectedWallet && windowWidth >= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH || windowWidth <= $ddf18a96c86c2e3c$var$MOBILE_WINDOW_WIDTH && connectionRejected && $modalStep$ === "connectingWallet" && selectedWallet);
    };
    return [
        autoSelect,
        connectionRejected,
        wallets,
        selectedWallet,
        windowWidth,
        $modalStep$,
        previousConnectionRequest,
        agreed,
        connectingWalletLabel,
        connectingErrorMessage,
        scrollContainer,
        displayConnectingWallet,
        availableWallets,
        $appMetadata$,
        $_,
        appMetadata$,
        connect,
        modalStep$,
        selectWallet,
        deselectWallet,
        close,
        connectWallet,
        setStep,
        onwindowresize,
        agreement_agreed_binding,
        div0_binding
    ];
}
class $ddf18a96c86c2e3c$var$Index$1 extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$4, $ddf18a96c86c2e3c$var$create_fragment$4, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            autoSelect: 0
        }, $ddf18a96c86c2e3c$var$add_css$4, [
            -1,
            -1
        ]);
    }
}
/* src/views/chain/SwitchChain.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$3(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-12yam41", ".container.svelte-12yam41{padding:var(--onboard-spacing-4, var(--spacing-4));font-family:var(--onboard-font-family-normal, var(--font-family-normal));line-height:16px;font-size:var(--onboard-font-size-5, var(--font-size-5))}.close.svelte-12yam41{top:var(--onboard-spacing-5, var(--spacing-5));right:var(--onboard-spacing-5, var(--spacing-5));padding:0.5rem}h4.svelte-12yam41{font-size:var(--onboard-font-size-3, var(--font-size-3));margin:var(--onboard-spacing-4, var(--spacing-4)) 0}p.svelte-12yam41{margin:0 0 var(--onboard-spacing-4, var(--spacing-4)) 0;max-width:488px}");
}
// (43:0) <Modal {close}>
function $ddf18a96c86c2e3c$var$create_default_slot$1(ctx) {
    let div1;
    let h4;
    let t0_value = /*$_*/ ctx[0]("modals.switchChain.heading", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.modals.switchChain.heading
    }) + "";
    let t0;
    let t1;
    let p0;
    let t2_value = /*$_*/ ctx[0]("modals.switchChain.paragraph1", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.modals.switchChain.paragraph1,
        values: {
            app: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].name || "This app",
            nextNetworkName: /*nextNetworkName*/ ctx[2]
        }
    }) + "";
    let t2;
    let t3;
    let p1;
    let t4_value = /*$_*/ ctx[0]("modals.switchChain.paragraph2", {
        default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.modals.switchChain.paragraph2
    }) + "";
    let t4;
    let t5;
    let div0;
    let closebutton;
    let current;
    let mounted;
    let dispose;
    closebutton = new $ddf18a96c86c2e3c$var$CloseButton({});
    return {
        c () {
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            h4 = $ddf18a96c86c2e3c$export$35e795649ee09318("h4");
            t0 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t0_value);
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            p0 = $ddf18a96c86c2e3c$export$35e795649ee09318("p");
            t2 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t2_value);
            t3 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            p1 = $ddf18a96c86c2e3c$export$35e795649ee09318("p");
            t4 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t4_value);
            t5 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(closebutton.$$.fragment);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(h4, "class", "svelte-12yam41");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(p0, "class", "svelte-12yam41");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(p1, "class", "svelte-12yam41");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "close absolute svelte-12yam41");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "container relative svelte-12yam41");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div1, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, h4);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(h4, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, p0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(p0, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, p1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(p1, t4);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t5);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(closebutton, div0, null);
            current = true;
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(div0, "click", /*close*/ ctx[3]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if ((!current || dirty & /*$_*/ 1) && t0_value !== (t0_value = /*$_*/ ctx[0]("modals.switchChain.heading", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.modals.switchChain.heading
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t0, t0_value);
            if ((!current || dirty & /*$_, $appMetadata$*/ 3) && t2_value !== (t2_value = /*$_*/ ctx[0]("modals.switchChain.paragraph1", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.modals.switchChain.paragraph1,
                values: {
                    app: /*$appMetadata$*/ ctx[1] && /*$appMetadata$*/ ctx[1].name || "This app",
                    nextNetworkName: /*nextNetworkName*/ ctx[2]
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t2, t2_value);
            if ((!current || dirty & /*$_*/ 1) && t4_value !== (t4_value = /*$_*/ ctx[0]("modals.switchChain.paragraph2", {
                default: $ddf18a96c86c2e3c$export$e7094788287c5e9b.modals.switchChain.paragraph2
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t4, t4_value);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(closebutton.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(closebutton.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div1);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(closebutton);
            mounted = false;
            dispose();
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$3(ctx) {
    let modal;
    let current;
    modal = new $ddf18a96c86c2e3c$export$8743009a87fcb00f({
        props: {
            close: /*close*/ ctx[3],
            $$slots: {
                default: [
                    $ddf18a96c86c2e3c$var$create_default_slot$1
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(modal.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(modal, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const modal_changes = {};
            if (dirty & /*$$scope, $_, $appMetadata$*/ 67) modal_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            modal.$set(modal_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(modal.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(modal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(modal, detaching);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$3($$self, $$props, $$invalidate) {
    let $switchChainModal$;
    let $_;
    let $appMetadata$;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, $ddf18a96c86c2e3c$var$switchChainModal$, ($$value)=>$$invalidate(5, $switchChainModal$ = $$value));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, (0, $8VqiI._), ($$value)=>$$invalidate(0, $_ = $$value));
    const nextNetworkName = $switchChainModal$.chain.label;
    function close() {
        $ddf18a96c86c2e3c$var$switchChainModal$.next(null);
    }
    const appMetadata$ = state.select("appMetadata").pipe(startWith(state.get().appMetadata), shareReplay(1));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, appMetadata$, (value)=>$$invalidate(1, $appMetadata$ = value));
    return [
        $_,
        $appMetadata$,
        nextNetworkName,
        close,
        appMetadata$
    ];
}
class $ddf18a96c86c2e3c$var$SwitchChain extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$3, $ddf18a96c86c2e3c$var$create_fragment$3, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {}, $ddf18a96c86c2e3c$var$add_css$3);
    }
}
/* src/views/shared/InfoIcon.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$2(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-z54y2j", ".icon.svelte-z54y2j{border-radius:50px;color:var(--onboard-primary-500, var(--primary-500))}");
}
function $ddf18a96c86c2e3c$var$create_fragment$2(ctx) {
    let div;
    let div_style_value;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "icon flex svelte-z54y2j");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px;`);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            div.innerHTML = $ddf18a96c86c2e3c$var$infoIcon;
        },
        p (ctx, [dirty]) {
            if (dirty & /*size*/ 1 && div_style_value !== (div_style_value = `width: ${ctx[0]}px; height: ${ctx[0]}px;`)) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value);
        },
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$2($$self, $$props, $$invalidate) {
    let { size: size = 20 } = $$props;
    $$self.$$set = ($$props)=>{
        if ("size" in $$props) $$invalidate(0, size = $$props.size);
    };
    return [
        size
    ];
}
class $ddf18a96c86c2e3c$var$InfoIcon extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$2, $ddf18a96c86c2e3c$var$create_fragment$2, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            size: 0
        }, $ddf18a96c86c2e3c$var$add_css$2);
    }
}
/* src/views/connect/ActionRequired.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css$1(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-20hjq1", ".content.svelte-20hjq1{padding:1rem;width:300px;font-family:var(--onboard-font-family-normal, var(--font-family-normal));font-size:var(--onboard-font-size-5, var(--font-size-5));line-height:24px;background:var(\n      --onboard-action-required-modal-background,\n      var(--onboard-white, var(--white))\n    )}.icon-container.svelte-20hjq1{width:3rem;height:3rem;background:var(--onboard-primary-100, var(--primary-100));border-radius:24px}h4.svelte-20hjq1{margin:1.5rem 0 0.5rem 0;font-weight:600}.action-required-heading.svelte-20hjq1,.action-required-info.svelte-20hjq1{color:var(\n      --onboard-action-required-text-color,\n      var(--onboard-black, inherit)\n    )}.action-required-btn.svelte-20hjq1{color:var(\n      --onboard-action-required-btn-text-color,\n      var(--onboard-black, inherit)\n    )}p.svelte-20hjq1{margin:0;font-weight:400}a.svelte-20hjq1{font-weight:600}button.svelte-20hjq1{margin-top:1.5rem;font-weight:600}");
}
// (79:6) {#if wallet === 'MetaMask'}
function $ddf18a96c86c2e3c$var$create_if_block$1(ctx) {
    let a;
    let t_value = /*$_*/ ctx[1]("modals.actionRequired.linkText", {
        values: {
            wallet: /*wallet*/ ctx[0]
        }
    }) + "";
    let t;
    return {
        c () {
            a = $ddf18a96c86c2e3c$export$35e795649ee09318("a");
            t = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "href", "https://metamask.zendesk.com/hc/en-us/articles/360061346311-Switching-accounts-in-MetaMask");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "target", "_blank");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "rel", "noreferrer noopener");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(a, "class", "svelte-20hjq1");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, a, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(a, t);
        },
        p (ctx, dirty) {
            if (dirty & /*$_, wallet*/ 3 && t_value !== (t_value = /*$_*/ ctx[1]("modals.actionRequired.linkText", {
                values: {
                    wallet: /*wallet*/ ctx[0]
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t, t_value);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(a);
        }
    };
}
// (66:0) <Modal {close}>
function $ddf18a96c86c2e3c$var$create_default_slot(ctx) {
    let div1;
    let div0;
    let infoicon;
    let t0;
    let h4;
    let t1_value = /*$_*/ ctx[1]("modals.actionRequired.heading", {
        values: {
            wallet: /*wallet*/ ctx[0]
        }
    }) + "";
    let t1;
    let t2;
    let p;
    let t3_value = /*$_*/ ctx[1]("modals.actionRequired.paragraph", {
        values: {
            wallet: /*wallet*/ ctx[0]
        }
    }) + "";
    let t3;
    let t4;
    let t5;
    let button;
    let t6_value = /*$_*/ ctx[1]("modals.actionRequired.buttonText") + "";
    let t6;
    let current;
    let mounted;
    let dispose;
    infoicon = new $ddf18a96c86c2e3c$var$InfoIcon({});
    let if_block = /*wallet*/ ctx[0] === "MetaMask" && $ddf18a96c86c2e3c$var$create_if_block$1(ctx);
    return {
        c () {
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$d66501df72047452(infoicon.$$.fragment);
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            h4 = $ddf18a96c86c2e3c$export$35e795649ee09318("h4");
            t1 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t1_value);
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            p = $ddf18a96c86c2e3c$export$35e795649ee09318("p");
            t3 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t3_value);
            t4 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block) if_block.c();
            t5 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            button = $ddf18a96c86c2e3c$export$35e795649ee09318("button");
            t6 = $ddf18a96c86c2e3c$export$625550452a3fa3ec(t6_value);
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "class", "icon-container flex justify-center items-center svelte-20hjq1");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(h4, "class", "action-required-heading svelte-20hjq1");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(p, "class", "action-required-info svelte-20hjq1");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(button, "class", "button-neutral-solid rounded action-required-btn svelte-20hjq1");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "content svelte-20hjq1");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div1, anchor);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            $ddf18a96c86c2e3c$export$9bb611d729802a56(infoicon, div0, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, h4);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(h4, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t2);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, p);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(p, t3);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(p, t4);
            if (if_block) if_block.m(p, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t5);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, button);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(button, t6);
            current = true;
            if (!mounted) {
                dispose = $ddf18a96c86c2e3c$export$ffb5f4729a158638(button, "click", /*close*/ ctx[2]);
                mounted = true;
            }
        },
        p (ctx, dirty) {
            if ((!current || dirty & /*$_, wallet*/ 3) && t1_value !== (t1_value = /*$_*/ ctx[1]("modals.actionRequired.heading", {
                values: {
                    wallet: /*wallet*/ ctx[0]
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t1, t1_value);
            if ((!current || dirty & /*$_, wallet*/ 3) && t3_value !== (t3_value = /*$_*/ ctx[1]("modals.actionRequired.paragraph", {
                values: {
                    wallet: /*wallet*/ ctx[0]
                }
            }) + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t3, t3_value);
            if (/*wallet*/ ctx[0] === "MetaMask") {
                if (if_block) if_block.p(ctx, dirty);
                else {
                    if_block = $ddf18a96c86c2e3c$var$create_if_block$1(ctx);
                    if_block.c();
                    if_block.m(p, null);
                }
            } else if (if_block) {
                if_block.d(1);
                if_block = null;
            }
            if ((!current || dirty & /*$_*/ 2) && t6_value !== (t6_value = /*$_*/ ctx[1]("modals.actionRequired.buttonText") + "")) $ddf18a96c86c2e3c$export$90a7f3efeed30595(t6, t6_value);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(infoicon.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(infoicon.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div1);
            $ddf18a96c86c2e3c$export$3466f893ebf79586(infoicon);
            if (if_block) if_block.d();
            mounted = false;
            dispose();
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment$1(ctx) {
    let modal;
    let current;
    modal = new $ddf18a96c86c2e3c$export$8743009a87fcb00f({
        props: {
            close: /*close*/ ctx[2],
            $$slots: {
                default: [
                    $ddf18a96c86c2e3c$var$create_default_slot
                ]
            },
            $$scope: {
                ctx: ctx
            }
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(modal.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(modal, target, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            const modal_changes = {};
            if (dirty & /*$$scope, $_, wallet*/ 11) modal_changes.$$scope = {
                dirty: dirty,
                ctx: ctx
            };
            modal.$set(modal_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(modal.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(modal.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(modal, detaching);
        }
    };
}
function $ddf18a96c86c2e3c$var$instance$1($$self, $$props, $$invalidate) {
    let $_;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, (0, $8VqiI._), ($$value)=>$$invalidate(1, $_ = $$value));
    let { wallet: wallet } = $$props;
    function close() {
        $ddf18a96c86c2e3c$export$a07804094c3ecf2d.next({
            inProgress: false,
            actionRequired: ""
        });
    }
    $$self.$$set = ($$props)=>{
        if ("wallet" in $$props) $$invalidate(0, wallet = $$props.wallet);
    };
    return [
        wallet,
        $_,
        close
    ];
}
class $ddf18a96c86c2e3c$var$ActionRequired extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance$1, $ddf18a96c86c2e3c$var$create_fragment$1, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {
            wallet: 0
        }, $ddf18a96c86c2e3c$var$add_css$1);
    }
}
/* src/views/Index.svelte generated by Svelte v3.59.2 */ function $ddf18a96c86c2e3c$var$add_css(target) {
    $ddf18a96c86c2e3c$export$407448d2b89b1813(target, "svelte-w5zexe", ".flex{display:flex}.inline-flex{display:inline-flex}.flex-column{flex-direction:column}.items-center{align-items:center}.items-end{align-items:flex-end}.items-start{align-items:flex-start}.justify-center{justify-content:center}.justify-start{justify-content:flex-start}.justify-between{justify-content:space-between}.justify-end{justify-content:flex-end}.justify-around{justify-content:space-around}.relative{position:relative}.absolute{position:absolute}.fixed{position:fixed}.pointer{cursor:pointer}.shadow-1{box-shadow:var(--onboard-shadow-1, var(--shadow-1))}.w-100{width:100%}*{box-sizing:border-box}input{background:var(--onboard-white, var(--white))}input{width:100%;padding:0.5rem 1rem;outline:2px solid var(--onboard-gray-200, var(--gray-200));border:none;border-radius:8px;font-size:1rem;line-height:1.5;color:var(--onboard-gray-600, var(--gray-600));transition:all 200ms ease-in-out}input[type='checkbox']{-webkit-appearance:none;appearance:none;width:auto;background:var(--onboard-white, var(--white));outline:1px solid var(--onboard-gray-300, var(--gray-300));border:none;padding:0.5em;border-radius:3px;display:flex;justify-content:center;align-items:center;position:relative;cursor:pointer}input[type='checkbox']:hover{border-color:var(\n      --onboard-checkbox-background,\n      var(--onboard-primary-500, var(--primary-500))\n    )}input[type='checkbox']:checked{background:var(\n      --onboard-checkbox-background,\n      var(--onboard-primary-500, var(--primary-500))\n    );border-color:var(\n      --onboard-checkbox-background,\n      var(--onboard-primary-500, var(--primary-500))\n    );color:var(--onboard-checkbox-color, var(--onboard-white, var(--white)))}input[type='checkbox']:checked:after{content:url(\"data:image/svg+xml,%3Csvg width='0.885em' height='0.6em' viewBox='0 0 14 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 6L5 11L14 2L12.59 0.58L5 8.17L1.41 4.59L0 6Z' fill='white'/%3E%3C/svg%3E\");font-size:12px;position:absolute;color:var(--onboard-checkbox-color, var(--onboard-white, var(--white)))}input:hover{border-color:var(\n      --onboard-checkbox-color,\n      var(--onboard-white, var(--white))\n    )}input:focus{border-color:var(--onboard-primary-500, var(--primary-500));box-shadow:0 0 1px 1px\n      var(\n        --onboard-checkbox-background,\n        var(--onboard-primary-500, var(--primary-500))\n      );box-shadow:0 0 0 1px -moz-mac-focusring}input:disabled, textarea:disabled, select:disabled{background:var(--gray-100)}input::-moz-focus-inner{outline:0;padding:0;margin-top:-2px;margin-bottom:-2px}a{color:var(\n      --onboard-link-color,\n      var(--onboard-primary-500, var(--primary-500))\n    );text-decoration:none}a:hover{text-decoration:underline}button{display:flex;align-items:center;justify-content:center;padding:calc(var(--onboard-spacing-4, var(--spacing-4)) - 1px);border-radius:24px;cursor:pointer;font:inherit;border:none;transition:background-color 150ms ease-in-out, color 150ms ease-in-out}.onboard-button-primary{background:var(--onboard-white, var(--white));padding:calc(var(--onboard-spacing-5, var(--spacing-5)) - 1px)\n      calc(var(--onboard-spacing-4, var(--spacing-4)) - 1px);color:var(--onboard-gray-500, var(--gray-500));font-size:var(--onboard-font-size-6, var(--font-size-6));line-height:var(--onboard-font-line-height-3, var(--font-line-height-3));border:1px solid var(--onboard-gray-500, var(--gray-500));font-weight:600}.button-neutral-solid{width:100%;border-radius:8px;background:var(--onboard-gray-500, var(--gray-500));color:var(--onboard-white, var(--white));line-height:var(--onboard-font-line-height-3, var(--font-line-height-3))}.button-neutral-solid-b{width:100%;background:var(--onboard-gray-100, var(--gray-100));color:var(--onboard-gray-500, var(--gray-500));line-height:var(--onboard-font-line-height-3, var(--font-line-height-3))}button.rounded{border-radius:24px}.button-neutral-solid:hover{background:var(--onboard-gray-700, var(--gray-700))}.button-neutral-solid-b:hover{background:var(--onboard-gray-200, var(--gray-200))}.button-neutral-solid:active{color:var(--onboard-gray-300, var(--gray-300))}.button-neutral-solid-b:active{color:var(--onboard-gray-600, var(--gray-600));background:var(--onboard-gray-300, var(--gray-300))}.container.svelte-w5zexe{padding:16px;font-family:var(--onboard-font-family-normal, var(--font-family-normal));pointer-events:none;touch-action:none;width:100%}.z-indexed.svelte-w5zexe{z-index:var(--account-center-z-index)}@media all and (min-width: 428px){.container.svelte-w5zexe{max-width:348px}}");
}
// (364:0) {#if $connectWallet$.inProgress}
function $ddf18a96c86c2e3c$var$create_if_block_20(ctx) {
    let connect;
    let current;
    connect = new $ddf18a96c86c2e3c$var$Index$1({
        props: {
            autoSelect: /*$connectWallet$*/ ctx[8].autoSelect
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(connect.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(connect, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const connect_changes = {};
            if (dirty & /*$connectWallet$*/ 256) connect_changes.autoSelect = /*$connectWallet$*/ ctx[8].autoSelect;
            connect.$set(connect_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(connect.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(connect.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(connect, detaching);
        }
    };
}
// (368:0) {#if $connectWallet$.actionRequired}
function $ddf18a96c86c2e3c$var$create_if_block_19(ctx) {
    let actionrequired;
    let current;
    actionrequired = new $ddf18a96c86c2e3c$var$ActionRequired({
        props: {
            wallet: /*$connectWallet$*/ ctx[8].actionRequired
        }
    });
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(actionrequired.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(actionrequired, target, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const actionrequired_changes = {};
            if (dirty & /*$connectWallet$*/ 256) actionrequired_changes.wallet = /*$connectWallet$*/ ctx[8].actionRequired;
            actionrequired.$set(actionrequired_changes);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(actionrequired.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(actionrequired.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(actionrequired, detaching);
        }
    };
}
// (372:0) {#if $switchChainModal$}
function $ddf18a96c86c2e3c$var$create_if_block_18(ctx) {
    let switchchain;
    let current;
    switchchain = new $ddf18a96c86c2e3c$var$SwitchChain({});
    return {
        c () {
            $ddf18a96c86c2e3c$export$d66501df72047452(switchchain.$$.fragment);
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$9bb611d729802a56(switchchain, target, anchor);
            current = true;
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switchchain.$$.fragment, local);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(switchchain.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            $ddf18a96c86c2e3c$export$3466f893ebf79586(switchchain, detaching);
        }
    };
}
// (376:0) {#if !$accountCenter$.enabled && !$notify$.enabled}
function $ddf18a96c86c2e3c$var$create_if_block_17(ctx) {
    let div;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "container flex flex-column fixed z-indexed svelte-w5zexe");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", "top: 0; right: 0; " + /*device*/ (ctx[11].type === "mobile" ? "padding-bottom: 0;" : "") + "");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
        },
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
// (386:0) {#if displayAccountCenterNotifySameContainer}
function $ddf18a96c86c2e3c$var$create_if_block_9(ctx) {
    let div1;
    let show_if_3 = /*$notify$*/ ctx[3].position.includes("bottom") && /*$accountCenter$*/ ctx[1].position.includes("bottom") && /*samePositionOrMobile*/ ctx[7];
    let t0;
    let show_if_2 = /*$accountCenter$*/ ctx[1].position.includes("bottom");
    let t1;
    let div0;
    let t2;
    let show_if_1 = /*$accountCenter$*/ ctx[1].position.includes("top");
    let t3;
    let show_if = /*$notify$*/ ctx[3].position.includes("top") && /*$accountCenter$*/ ctx[1].position.includes("top") && /*samePositionOrMobile*/ ctx[7];
    let div1_style_value;
    let current;
    let if_block0 = show_if_3 && $ddf18a96c86c2e3c$var$create_if_block_15(ctx);
    let if_block1 = show_if_2 && $ddf18a96c86c2e3c$var$create_if_block_14();
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $ddf18a96c86c2e3c$var$create_pending_block_3,
        then: $ddf18a96c86c2e3c$var$create_then_block_3,
        catch: $ddf18a96c86c2e3c$var$create_catch_block_3,
        value: 23,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $ddf18a96c86c2e3c$export$71511d61b312f219(/*accountCenterComponent*/ ctx[16], info);
    let if_block2 = show_if_1 && $ddf18a96c86c2e3c$var$create_if_block_12();
    let if_block3 = show_if && $ddf18a96c86c2e3c$var$create_if_block_10(ctx);
    return {
        c () {
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            info.block.c();
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t3 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block3) if_block3.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div0, "id", "account-center-with-notify");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "container flex flex-column fixed z-indexed svelte-w5zexe");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($ddf18a96c86c2e3c$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("bottom") ? "padding-top:0;" : "") + ""));
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div1, anchor);
            if (if_block0) if_block0.m(div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t0);
            if (if_block1) if_block1.m(div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t1);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            info.block.m(div0, info.anchor = null);
            info.mount = ()=>div0;
            info.anchor = null;
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t2);
            if (if_block2) if_block2.m(div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t3);
            if (if_block3) if_block3.m(div1, null);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) show_if_3 = /*$notify$*/ ctx[3].position.includes("bottom") && /*$accountCenter$*/ ctx[1].position.includes("bottom") && /*samePositionOrMobile*/ ctx[7];
            if (show_if_3) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0, 1);
                } else {
                    if_block0 = $ddf18a96c86c2e3c$var$create_if_block_15(ctx);
                    if_block0.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0, 1);
                    if_block0.m(div1, t0);
                }
            } else if (if_block0) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (dirty & /*$accountCenter$*/ 2) show_if_2 = /*$accountCenter$*/ ctx[1].position.includes("bottom");
            if (show_if_2) {
                if (if_block1) ;
                else {
                    if_block1 = $ddf18a96c86c2e3c$var$create_if_block_14();
                    if_block1.c();
                    if_block1.m(div1, t1);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            $ddf18a96c86c2e3c$export$3d8c2f653ac9d0b9(info, ctx, dirty);
            if (dirty & /*$accountCenter$*/ 2) show_if_1 = /*$accountCenter$*/ ctx[1].position.includes("top");
            if (show_if_1) {
                if (if_block2) ;
                else {
                    if_block2 = $ddf18a96c86c2e3c$var$create_if_block_12();
                    if_block2.c();
                    if_block2.m(div1, t3);
                }
            } else if (if_block2) {
                if_block2.d(1);
                if_block2 = null;
            }
            if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) show_if = /*$notify$*/ ctx[3].position.includes("top") && /*$accountCenter$*/ ctx[1].position.includes("top") && /*samePositionOrMobile*/ ctx[7];
            if (show_if) {
                if (if_block3) {
                    if_block3.p(ctx, dirty);
                    if (dirty & /*$notify$, $accountCenter$, samePositionOrMobile*/ 138) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block3, 1);
                } else {
                    if_block3 = $ddf18a96c86c2e3c$var$create_if_block_10(ctx);
                    if_block3.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block3, 1);
                    if_block3.m(div1, null);
                }
            } else if (if_block3) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block3, 1, 1, ()=>{
                    if_block3 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (!current || dirty & /*$accountCenter$*/ 2 && div1_style_value !== (div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($ddf18a96c86c2e3c$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("bottom") ? "padding-top:0;" : "") + ""))) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(info.block);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block3);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block0);
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $ddf18a96c86c2e3c$export$ebd11618f299a286(block);
            }
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block3);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div1);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            info.block.d();
            info.token = null;
            info = null;
            if (if_block2) if_block2.d();
            if (if_block3) if_block3.d();
        }
    };
}
// (397:4) {#if $notify$.position.includes('bottom') && $accountCenter$.position.includes('bottom') && samePositionOrMobile}
function $ddf18a96c86c2e3c$var$create_if_block_15(ctx) {
    let await_block_anchor;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $ddf18a96c86c2e3c$var$create_pending_block_4,
        then: $ddf18a96c86c2e3c$var$create_then_block_4,
        catch: $ddf18a96c86c2e3c$var$create_catch_block_4,
        value: 22,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $ddf18a96c86c2e3c$export$71511d61b312f219(/*notifyComponent*/ ctx[17], info);
    return {
        c () {
            await_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $ddf18a96c86c2e3c$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $ddf18a96c86c2e3c$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_catch_block_4(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (398:42)          {#if Notify}
function $ddf18a96c86c2e3c$var$create_then_block_4(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*Notify*/ ctx[22] && $ddf18a96c86c2e3c$var$create_if_block_16(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*Notify*/ ctx[22]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (399:8) {#if Notify}
function $ddf18a96c86c2e3c$var$create_if_block_16(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*Notify*/ ctx[22];
    function switch_props(ctx) {
        return {
            props: {
                notifications: /*$notifications$*/ ctx[10],
                position: /*$notify$*/ ctx[3].position,
                sharedContainer: /*sharedContainer*/ ctx[0]
            }
        };
    }
    if (switch_value) switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const switch_instance_changes = {};
            if (dirty & /*$notifications$*/ 1024) switch_instance_changes.notifications = /*$notifications$*/ ctx[10];
            if (dirty & /*$notify$*/ 8) switch_instance_changes.position = /*$notify$*/ ctx[3].position;
            if (dirty & /*sharedContainer*/ 1) switch_instance_changes.sharedContainer = /*sharedContainer*/ ctx[0];
            if (switch_value !== (switch_value = /*Notify*/ ctx[22])) {
                if (switch_instance) {
                    $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $ddf18a96c86c2e3c$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $ddf18a96c86c2e3c$export$3466f893ebf79586(old_component, 1);
                    });
                    $ddf18a96c86c2e3c$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props(ctx));
                    $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else if (switch_value) switch_instance.$set(switch_instance_changes);
        },
        i (local) {
            if (current) return;
            if (switch_instance) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $ddf18a96c86c2e3c$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $ddf18a96c86c2e3c$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_pending_block_4(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (409:4) {#if $accountCenter$.position.includes('bottom')}
function $ddf18a96c86c2e3c$var$create_if_block_14(ctx) {
    let div;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div, "margin-bottom", "8px");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_catch_block_3(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (413:56)          {#if AccountCenter}
function $ddf18a96c86c2e3c$var$create_then_block_3(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*AccountCenter*/ ctx[23] && $ddf18a96c86c2e3c$var$create_if_block_13(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*AccountCenter*/ ctx[23]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (414:8) {#if AccountCenter}
function $ddf18a96c86c2e3c$var$create_if_block_13(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*AccountCenter*/ ctx[23];
    function switch_props(ctx) {
        return {};
    }
    if (switch_value) switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props());
    return {
        c () {
            if (switch_instance) $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (switch_value !== (switch_value = /*AccountCenter*/ ctx[23])) {
                if (switch_instance) {
                    $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $ddf18a96c86c2e3c$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $ddf18a96c86c2e3c$export$3466f893ebf79586(old_component, 1);
                    });
                    $ddf18a96c86c2e3c$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props());
                    $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            }
        },
        i (local) {
            if (current) return;
            if (switch_instance) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $ddf18a96c86c2e3c$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $ddf18a96c86c2e3c$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_pending_block_3(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (419:4) {#if $accountCenter$.position.includes('top')}
function $ddf18a96c86c2e3c$var$create_if_block_12(ctx) {
    let div;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div, "margin-top", "8px");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
// (422:4) {#if $notify$.position.includes('top') && $accountCenter$.position.includes('top') && samePositionOrMobile}
function $ddf18a96c86c2e3c$var$create_if_block_10(ctx) {
    let await_block_anchor;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $ddf18a96c86c2e3c$var$create_pending_block_2,
        then: $ddf18a96c86c2e3c$var$create_then_block_2,
        catch: $ddf18a96c86c2e3c$var$create_catch_block_2,
        value: 22,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $ddf18a96c86c2e3c$export$71511d61b312f219(/*notifyComponent*/ ctx[17], info);
    return {
        c () {
            await_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $ddf18a96c86c2e3c$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $ddf18a96c86c2e3c$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_catch_block_2(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (423:42)          {#if Notify}
function $ddf18a96c86c2e3c$var$create_then_block_2(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*Notify*/ ctx[22] && $ddf18a96c86c2e3c$var$create_if_block_11(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*Notify*/ ctx[22]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (424:8) {#if Notify}
function $ddf18a96c86c2e3c$var$create_if_block_11(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*Notify*/ ctx[22];
    function switch_props(ctx) {
        return {
            props: {
                notifications: /*$notifications$*/ ctx[10],
                position: /*$notify$*/ ctx[3].position,
                sharedContainer: /*sharedContainer*/ ctx[0]
            }
        };
    }
    if (switch_value) switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const switch_instance_changes = {};
            if (dirty & /*$notifications$*/ 1024) switch_instance_changes.notifications = /*$notifications$*/ ctx[10];
            if (dirty & /*$notify$*/ 8) switch_instance_changes.position = /*$notify$*/ ctx[3].position;
            if (dirty & /*sharedContainer*/ 1) switch_instance_changes.sharedContainer = /*sharedContainer*/ ctx[0];
            if (switch_value !== (switch_value = /*Notify*/ ctx[22])) {
                if (switch_instance) {
                    $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $ddf18a96c86c2e3c$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $ddf18a96c86c2e3c$export$3466f893ebf79586(old_component, 1);
                    });
                    $ddf18a96c86c2e3c$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props(ctx));
                    $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else if (switch_value) switch_instance.$set(switch_instance_changes);
        },
        i (local) {
            if (current) return;
            if (switch_instance) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $ddf18a96c86c2e3c$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $ddf18a96c86c2e3c$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_pending_block_2(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (436:0) {#if displayAccountCenterSeparate}
function $ddf18a96c86c2e3c$var$create_if_block_4(ctx) {
    let div1;
    let show_if_1 = /*$accountCenter$*/ ctx[1].position.includes("bottom");
    let t0;
    let div0;
    let t1;
    let show_if = /*$accountCenter$*/ ctx[1].position.includes("top");
    let div1_style_value;
    let current;
    let if_block0 = show_if_1 && $ddf18a96c86c2e3c$var$create_if_block_8();
    let if_block1 = /*$accountCenter$*/ ctx[1].enabled && /*$wallets$*/ ctx[2].length && $ddf18a96c86c2e3c$var$create_if_block_6(ctx);
    let if_block2 = show_if && $ddf18a96c86c2e3c$var$create_if_block_5();
    return {
        c () {
            div1 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            div0 = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (if_block1) if_block1.c();
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "class", "container flex flex-column fixed z-indexed svelte-w5zexe");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($ddf18a96c86c2e3c$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("bottom") ? "padding-top:0;" : "") + ""));
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div1, anchor);
            if (if_block0) if_block0.m(div1, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t0);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, div0);
            if (if_block1) if_block1.m(div0, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div1, t1);
            if (if_block2) if_block2.m(div1, null);
            current = true;
        },
        p (ctx, dirty) {
            if (dirty & /*$accountCenter$*/ 2) show_if_1 = /*$accountCenter$*/ ctx[1].position.includes("bottom");
            if (show_if_1) {
                if (if_block0) ;
                else {
                    if_block0 = $ddf18a96c86c2e3c$var$create_if_block_8();
                    if_block0.c();
                    if_block0.m(div1, t0);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            if (/*$accountCenter$*/ ctx[1].enabled && /*$wallets$*/ ctx[2].length) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*$accountCenter$, $wallets$*/ 6) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1, 1);
                } else {
                    if_block1 = $ddf18a96c86c2e3c$var$create_if_block_6(ctx);
                    if_block1.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1, 1);
                    if_block1.m(div0, null);
                }
            } else if (if_block1) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (dirty & /*$accountCenter$*/ 2) show_if = /*$accountCenter$*/ ctx[1].position.includes("top");
            if (show_if) {
                if (if_block2) ;
                else {
                    if_block2 = $ddf18a96c86c2e3c$var$create_if_block_5();
                    if_block2.c();
                    if_block2.m(div1, null);
                }
            } else if (if_block2) {
                if_block2.d(1);
                if_block2 = null;
            }
            if (!current || dirty & /*$accountCenter$*/ 2 && div1_style_value !== (div1_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($ddf18a96c86c2e3c$var$accountCenterPositioning)[/*$accountCenter$*/ ctx[1].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$accountCenter$*/ ctx[1].position.includes("bottom") ? "padding-top:0;" : "") + ""))) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div1, "style", div1_style_value);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block1);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div1);
            if (if_block0) if_block0.d();
            if (if_block1) if_block1.d();
            if (if_block2) if_block2.d();
        }
    };
}
// (447:4) {#if $accountCenter$.position.includes('bottom')}
function $ddf18a96c86c2e3c$var$create_if_block_8(ctx) {
    let div;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div, "margin-bottom", "8px");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
// (451:6) {#if $accountCenter$.enabled && $wallets$.length}
function $ddf18a96c86c2e3c$var$create_if_block_6(ctx) {
    let await_block_anchor;
    let current;
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $ddf18a96c86c2e3c$var$create_pending_block_1,
        then: $ddf18a96c86c2e3c$var$create_then_block_1,
        catch: $ddf18a96c86c2e3c$var$create_catch_block_1,
        value: 23,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $ddf18a96c86c2e3c$export$71511d61b312f219(/*accountCenterComponent*/ ctx[16], info);
    return {
        c () {
            await_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
            info.block.c();
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, await_block_anchor, anchor);
            info.block.m(target, info.anchor = anchor);
            info.mount = ()=>await_block_anchor.parentNode;
            info.anchor = await_block_anchor;
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            $ddf18a96c86c2e3c$export$3d8c2f653ac9d0b9(info, ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $ddf18a96c86c2e3c$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(await_block_anchor);
            info.block.d(detaching);
            info.token = null;
            info = null;
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_catch_block_1(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (452:58)            {#if AccountCenter}
function $ddf18a96c86c2e3c$var$create_then_block_1(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*AccountCenter*/ ctx[23] && $ddf18a96c86c2e3c$var$create_if_block_7(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*AccountCenter*/ ctx[23]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (453:10) {#if AccountCenter}
function $ddf18a96c86c2e3c$var$create_if_block_7(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*AccountCenter*/ ctx[23];
    function switch_props(ctx) {
        return {};
    }
    if (switch_value) switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props());
    return {
        c () {
            if (switch_instance) $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (switch_value !== (switch_value = /*AccountCenter*/ ctx[23])) {
                if (switch_instance) {
                    $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $ddf18a96c86c2e3c$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $ddf18a96c86c2e3c$export$3466f893ebf79586(old_component, 1);
                    });
                    $ddf18a96c86c2e3c$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props());
                    $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            }
        },
        i (local) {
            if (current) return;
            if (switch_instance) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $ddf18a96c86c2e3c$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $ddf18a96c86c2e3c$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_pending_block_1(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (459:4) {#if $accountCenter$.position.includes('top')}
function $ddf18a96c86c2e3c$var$create_if_block_5(ctx) {
    let div;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
            $ddf18a96c86c2e3c$export$971d5caa766a69d7(div, "margin-top", "8px");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
// (464:0) {#if displayNotifySeparate}
function $ddf18a96c86c2e3c$var$create_if_block(ctx) {
    let div;
    let show_if_1 = /*$notify$*/ ctx[3].position.includes("top");
    let t0;
    let t1;
    let show_if = /*$notify$*/ ctx[3].position.includes("bottom");
    let div_style_value;
    let current;
    let if_block0 = show_if_1 && $ddf18a96c86c2e3c$var$create_if_block_3();
    let info = {
        ctx: ctx,
        current: null,
        token: null,
        hasCatch: false,
        pending: $ddf18a96c86c2e3c$var$create_pending_block,
        then: $ddf18a96c86c2e3c$var$create_then_block,
        catch: $ddf18a96c86c2e3c$var$create_catch_block,
        value: 22,
        blocks: [
            ,
            ,
            , 
        ]
    };
    $ddf18a96c86c2e3c$export$71511d61b312f219(/*notifyComponent*/ ctx[17], info);
    let if_block1 = show_if && $ddf18a96c86c2e3c$var$create_if_block_1();
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            if (if_block0) if_block0.c();
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            info.block.c();
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "class", "container flex flex-column fixed z-indexed svelte-w5zexe");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($ddf18a96c86c2e3c$var$notifyPositioning)[/*$notify$*/ ctx[3].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$notify$*/ ctx[3].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$notify$*/ ctx[3].position.includes("bottom") ? "padding-top:0;" : "") + ""));
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
            if (if_block0) if_block0.m(div, null);
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div, t0);
            info.block.m(div, info.anchor = null);
            info.mount = ()=>div;
            info.anchor = t1;
            $ddf18a96c86c2e3c$export$953cecd6e717a553(div, t1);
            if (if_block1) if_block1.m(div, null);
            current = true;
        },
        p (new_ctx, dirty) {
            ctx = new_ctx;
            if (dirty & /*$notify$*/ 8) show_if_1 = /*$notify$*/ ctx[3].position.includes("top");
            if (show_if_1) {
                if (if_block0) ;
                else {
                    if_block0 = $ddf18a96c86c2e3c$var$create_if_block_3();
                    if_block0.c();
                    if_block0.m(div, t0);
                }
            } else if (if_block0) {
                if_block0.d(1);
                if_block0 = null;
            }
            $ddf18a96c86c2e3c$export$3d8c2f653ac9d0b9(info, ctx, dirty);
            if (dirty & /*$notify$*/ 8) show_if = /*$notify$*/ ctx[3].position.includes("bottom");
            if (show_if) {
                if (if_block1) ;
                else {
                    if_block1 = $ddf18a96c86c2e3c$var$create_if_block_1();
                    if_block1.c();
                    if_block1.m(div, null);
                }
            } else if (if_block1) {
                if_block1.d(1);
                if_block1 = null;
            }
            if (!current || dirty & /*$notify$*/ 8 && div_style_value !== (div_style_value = "" + /*setPositioningDefaults*/ (ctx[15]($ddf18a96c86c2e3c$var$notifyPositioning)[/*$notify$*/ ctx[3].position] + "; " + /*device*/ (ctx[11].type === "mobile" && /*$notify$*/ ctx[3].position.includes("top") ? "padding-bottom: 0;" : /*device*/ ctx[11].type === "mobile" && /*$notify$*/ ctx[3].position.includes("bottom") ? "padding-top:0;" : "") + ""))) $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "style", div_style_value);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(info.block);
            current = true;
        },
        o (local) {
            for(let i = 0; i < 3; i += 1){
                const block = info.blocks[i];
                $ddf18a96c86c2e3c$export$ebd11618f299a286(block);
            }
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
            if (if_block0) if_block0.d();
            info.block.d();
            info.token = null;
            info = null;
            if (if_block1) if_block1.d();
        }
    };
}
// (475:4) {#if $notify$.position.includes('top')}
function $ddf18a96c86c2e3c$var$create_if_block_3(ctx) {
    let div;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_catch_block(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (478:40)        {#if Notify}
function $ddf18a96c86c2e3c$var$create_then_block(ctx) {
    let if_block_anchor;
    let current;
    let if_block = /*Notify*/ ctx[22] && $ddf18a96c86c2e3c$var$create_if_block_2(ctx);
    return {
        c () {
            if (if_block) if_block.c();
            if_block_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block) if_block.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            if (/*Notify*/ ctx[22]) if_block.p(ctx, dirty);
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block);
            current = false;
        },
        d (detaching) {
            if (if_block) if_block.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block_anchor);
        }
    };
}
// (479:6) {#if Notify}
function $ddf18a96c86c2e3c$var$create_if_block_2(ctx) {
    let switch_instance;
    let switch_instance_anchor;
    let current;
    var switch_value = /*Notify*/ ctx[22];
    function switch_props(ctx) {
        return {
            props: {
                notifications: /*$notifications$*/ ctx[10],
                position: /*$notify$*/ ctx[3].position,
                sharedContainer: /*sharedContainer*/ ctx[0]
            }
        };
    }
    if (switch_value) switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props(ctx));
    return {
        c () {
            if (switch_instance) $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
            switch_instance_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (switch_instance) $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, switch_instance_anchor, anchor);
            current = true;
        },
        p (ctx, dirty) {
            const switch_instance_changes = {};
            if (dirty & /*$notifications$*/ 1024) switch_instance_changes.notifications = /*$notifications$*/ ctx[10];
            if (dirty & /*$notify$*/ 8) switch_instance_changes.position = /*$notify$*/ ctx[3].position;
            if (dirty & /*sharedContainer*/ 1) switch_instance_changes.sharedContainer = /*sharedContainer*/ ctx[0];
            if (switch_value !== (switch_value = /*Notify*/ ctx[22])) {
                if (switch_instance) {
                    $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                    const old_component = switch_instance;
                    $ddf18a96c86c2e3c$export$ebd11618f299a286(old_component.$$.fragment, 1, 0, ()=>{
                        $ddf18a96c86c2e3c$export$3466f893ebf79586(old_component, 1);
                    });
                    $ddf18a96c86c2e3c$export$df995fae86a55f06();
                }
                if (switch_value) {
                    switch_instance = $ddf18a96c86c2e3c$var$construct_svelte_component(switch_value, switch_props(ctx));
                    $ddf18a96c86c2e3c$export$d66501df72047452(switch_instance.$$.fragment);
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, 1);
                    $ddf18a96c86c2e3c$export$9bb611d729802a56(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
                } else switch_instance = null;
            } else if (switch_value) switch_instance.$set(switch_instance_changes);
        },
        i (local) {
            if (current) return;
            if (switch_instance) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(switch_instance.$$.fragment, local);
            current = true;
        },
        o (local) {
            if (switch_instance) $ddf18a96c86c2e3c$export$ebd11618f299a286(switch_instance.$$.fragment, local);
            current = false;
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(switch_instance_anchor);
            if (switch_instance) $ddf18a96c86c2e3c$export$3466f893ebf79586(switch_instance, detaching);
        }
    };
}
// (1:0) <script lang="ts">import { shareReplay, startWith }
function $ddf18a96c86c2e3c$var$create_pending_block(ctx) {
    return {
        c: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        m: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        p: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        i: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        o: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5,
        d: $ddf18a96c86c2e3c$export$7ccc53e8f1e7dfc5
    };
}
// (488:4) {#if $notify$.position.includes('bottom')}
function $ddf18a96c86c2e3c$var$create_if_block_1(ctx) {
    let div;
    return {
        c () {
            div = $ddf18a96c86c2e3c$export$35e795649ee09318("div");
            $ddf18a96c86c2e3c$export$342063e11d6c3cad(div, "id", "w3o-transaction-preview-container");
        },
        m (target, anchor) {
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, div, anchor);
        },
        d (detaching) {
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(div);
        }
    };
}
function $ddf18a96c86c2e3c$var$create_fragment(ctx) {
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let if_block6_anchor;
    let current;
    let if_block0 = /*$connectWallet$*/ ctx[8].inProgress && $ddf18a96c86c2e3c$var$create_if_block_20(ctx);
    let if_block1 = /*$connectWallet$*/ ctx[8].actionRequired && $ddf18a96c86c2e3c$var$create_if_block_19(ctx);
    let if_block2 = /*$switchChainModal$*/ ctx[9] && $ddf18a96c86c2e3c$var$create_if_block_18();
    let if_block3 = !/*$accountCenter$*/ ctx[1].enabled && !/*$notify$*/ ctx[3].enabled && $ddf18a96c86c2e3c$var$create_if_block_17(ctx);
    let if_block4 = /*displayAccountCenterNotifySameContainer*/ ctx[4] && $ddf18a96c86c2e3c$var$create_if_block_9(ctx);
    let if_block5 = /*displayAccountCenterSeparate*/ ctx[5] && $ddf18a96c86c2e3c$var$create_if_block_4(ctx);
    let if_block6 = /*displayNotifySeparate*/ ctx[6] && $ddf18a96c86c2e3c$var$create_if_block(ctx);
    return {
        c () {
            if (if_block0) if_block0.c();
            t0 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block1) if_block1.c();
            t1 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block2) if_block2.c();
            t2 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block3) if_block3.c();
            t3 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block4) if_block4.c();
            t4 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block5) if_block5.c();
            t5 = $ddf18a96c86c2e3c$export$2329c99376c9d0a4();
            if (if_block6) if_block6.c();
            if_block6_anchor = $ddf18a96c86c2e3c$export$f1e1789686576879();
        },
        m (target, anchor) {
            if (if_block0) if_block0.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t0, anchor);
            if (if_block1) if_block1.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t1, anchor);
            if (if_block2) if_block2.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t2, anchor);
            if (if_block3) if_block3.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t3, anchor);
            if (if_block4) if_block4.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t4, anchor);
            if (if_block5) if_block5.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, t5, anchor);
            if (if_block6) if_block6.m(target, anchor);
            $ddf18a96c86c2e3c$export$8b22cf2602fb60ce(target, if_block6_anchor, anchor);
            current = true;
        },
        p (ctx, [dirty]) {
            if (/*$connectWallet$*/ ctx[8].inProgress) {
                if (if_block0) {
                    if_block0.p(ctx, dirty);
                    if (dirty & /*$connectWallet$*/ 256) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0, 1);
                } else {
                    if_block0 = $ddf18a96c86c2e3c$var$create_if_block_20(ctx);
                    if_block0.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0, 1);
                    if_block0.m(t0.parentNode, t0);
                }
            } else if (if_block0) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block0, 1, 1, ()=>{
                    if_block0 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (/*$connectWallet$*/ ctx[8].actionRequired) {
                if (if_block1) {
                    if_block1.p(ctx, dirty);
                    if (dirty & /*$connectWallet$*/ 256) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1, 1);
                } else {
                    if_block1 = $ddf18a96c86c2e3c$var$create_if_block_19(ctx);
                    if_block1.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1, 1);
                    if_block1.m(t1.parentNode, t1);
                }
            } else if (if_block1) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block1, 1, 1, ()=>{
                    if_block1 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (/*$switchChainModal$*/ ctx[9]) {
                if (if_block2) {
                    if (dirty & /*$switchChainModal$*/ 512) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block2, 1);
                } else {
                    if_block2 = $ddf18a96c86c2e3c$var$create_if_block_18();
                    if_block2.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block2, 1);
                    if_block2.m(t2.parentNode, t2);
                }
            } else if (if_block2) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block2, 1, 1, ()=>{
                    if_block2 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (!/*$accountCenter$*/ ctx[1].enabled && !/*$notify$*/ ctx[3].enabled) {
                if (if_block3) if_block3.p(ctx, dirty);
                else {
                    if_block3 = $ddf18a96c86c2e3c$var$create_if_block_17(ctx);
                    if_block3.c();
                    if_block3.m(t3.parentNode, t3);
                }
            } else if (if_block3) {
                if_block3.d(1);
                if_block3 = null;
            }
            if (/*displayAccountCenterNotifySameContainer*/ ctx[4]) {
                if (if_block4) {
                    if_block4.p(ctx, dirty);
                    if (dirty & /*displayAccountCenterNotifySameContainer*/ 16) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block4, 1);
                } else {
                    if_block4 = $ddf18a96c86c2e3c$var$create_if_block_9(ctx);
                    if_block4.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block4, 1);
                    if_block4.m(t4.parentNode, t4);
                }
            } else if (if_block4) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block4, 1, 1, ()=>{
                    if_block4 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (/*displayAccountCenterSeparate*/ ctx[5]) {
                if (if_block5) {
                    if_block5.p(ctx, dirty);
                    if (dirty & /*displayAccountCenterSeparate*/ 32) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block5, 1);
                } else {
                    if_block5 = $ddf18a96c86c2e3c$var$create_if_block_4(ctx);
                    if_block5.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block5, 1);
                    if_block5.m(t5.parentNode, t5);
                }
            } else if (if_block5) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block5, 1, 1, ()=>{
                    if_block5 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
            if (/*displayNotifySeparate*/ ctx[6]) {
                if (if_block6) {
                    if_block6.p(ctx, dirty);
                    if (dirty & /*displayNotifySeparate*/ 64) $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block6, 1);
                } else {
                    if_block6 = $ddf18a96c86c2e3c$var$create_if_block(ctx);
                    if_block6.c();
                    $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block6, 1);
                    if_block6.m(if_block6_anchor.parentNode, if_block6_anchor);
                }
            } else if (if_block6) {
                $ddf18a96c86c2e3c$export$4a5767248b18ef41();
                $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block6, 1, 1, ()=>{
                    if_block6 = null;
                });
                $ddf18a96c86c2e3c$export$df995fae86a55f06();
            }
        },
        i (local) {
            if (current) return;
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block0);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block1);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block2);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block4);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block5);
            $ddf18a96c86c2e3c$export$d141bba7fdc215a3(if_block6);
            current = true;
        },
        o (local) {
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block0);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block1);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block2);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block4);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block5);
            $ddf18a96c86c2e3c$export$ebd11618f299a286(if_block6);
            current = false;
        },
        d (detaching) {
            if (if_block0) if_block0.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t0);
            if (if_block1) if_block1.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t1);
            if (if_block2) if_block2.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t2);
            if (if_block3) if_block3.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t3);
            if (if_block4) if_block4.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t4);
            if (if_block5) if_block5.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(t5);
            if (if_block6) if_block6.d(detaching);
            if (detaching) $ddf18a96c86c2e3c$export$4368d992c4eafac0(if_block6_anchor);
        }
    };
}
const $ddf18a96c86c2e3c$var$accountCenterPositioning = "account-center";
const $ddf18a96c86c2e3c$var$notifyPositioning = "notify-onboard-container";


function $ddf18a96c86c2e3c$var$instance($$self, $$props, $$invalidate) {
    let sharedContainer;
    let samePositionOrMobile;
    let sharedMobileContainerCheck;
    let displayNotifySeparate;
    let displayAccountCenterSeparate;
    let displayAccountCenterNotifySameContainer;
    let $accountCenter$;
    let $wallets$;
    let $notify$;
    let $connectWallet$;
    let $switchChainModal$;
    let $notifications$;
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, $ddf18a96c86c2e3c$export$efccba1c4a2ef57b, ($$value)=>$$invalidate(2, $wallets$ = $$value));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, $ddf18a96c86c2e3c$export$a07804094c3ecf2d, ($$value)=>$$invalidate(8, $connectWallet$ = $$value));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, $ddf18a96c86c2e3c$var$switchChainModal$, ($$value)=>$$invalidate(9, $switchChainModal$ = $$value));
    const { device: device, containerElements: containerElements } = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57;
    const accountCenter$ = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("accountCenter").pipe((0, $lLJqC.startWith)($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().accountCenter), (0, $fn8ZQ.shareReplay)(1));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, accountCenter$, (value)=>$$invalidate(1, $accountCenter$ = value));
    const notify$ = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("notify").pipe((0, $lLJqC.startWith)($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().notify), (0, $fn8ZQ.shareReplay)(1));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, notify$, (value)=>$$invalidate(3, $notify$ = value));
    const notifications$ = $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("notifications").pipe((0, $lLJqC.startWith)($ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().notifications));
    $ddf18a96c86c2e3c$export$db3b6bfb95261072($$self, notifications$, (value)=>$$invalidate(10, $notifications$ = value));
    const setPositioningDefaults = (targetComponentVariable)=>{
        return {
            topLeft: `
        top: var(--${targetComponentVariable}-position-top, 0); 
        left: var(--${targetComponentVariable}-position-left, 0);`,
            topRight: `
        top: var(--${targetComponentVariable}-position-top, 0); 
        right: var(--${targetComponentVariable}-position-right, 0);`,
            bottomRight: `
        bottom: var(--${targetComponentVariable}-position-bottom, 0); 
        right: var(--${targetComponentVariable}-position-right, 0);`,
            bottomLeft: `
        bottom: var(--${targetComponentVariable}-position-bottom, 0); 
        left: var(--${targetComponentVariable}-position-left, 0);`
        };
    };
    const accountCenterComponent = $accountCenter$.enabled ? (parcelRequire("asBZJ")).then((mod)=>mod.default) : Promise.resolve(null);
    const notifyComponent = $notify$.enabled ? (parcelRequire("dFJ70")).then((mod)=>mod.default) : Promise.resolve(null);
    const accountCenterMountToElement = $accountCenter$.enabled && containerElements && containerElements.accountCenter;
    const attachCompToDom = (domEl, targetEl, component, compSettings)=>{
        const target = domEl.attachShadow({
            mode: "open"
        });
        let getW3OEl = document.querySelector("onboard-v2");
        let w3OStyleSheets = getW3OEl.shadowRoot.styleSheets;
        const copiedStyleSheet = new CSSStyleSheet();
        // Copy Onboard stylesheets over to AccountCenter shadow DOM
        Object.values(w3OStyleSheets).forEach((sheet)=>{
            const styleRules = Object.values(sheet.cssRules);
            styleRules.forEach((rule)=>copiedStyleSheet.insertRule(rule.cssText));
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        target.adoptedStyleSheets = [
            copiedStyleSheet
        ];
        const containerElement = document.querySelector(targetEl);
        containerElement.appendChild(domEl);
        if (!containerElement) throw new Error(`Element with query ${targetEl} does not exist.`);
        const getACComp = async ()=>{
            let newComp = await component;
            if (newComp) new newComp({
                target: target,
                props: {
                    settings: compSettings,
                    mountInContainer: true
                }
            });
        };
        getACComp();
    };
    if (accountCenterMountToElement) {
        const accountCenter = document.createElement("onboard-account-center");
        attachCompToDom(accountCenter, accountCenterMountToElement, accountCenterComponent, $accountCenter$);
    }
    $$self.$$.update = ()=>{
        if ($$self.$$.dirty & /*$accountCenter$, $notify$*/ 10) $$invalidate(0, sharedContainer = !accountCenterMountToElement && $accountCenter$.enabled && $notify$.enabled && $notify$.position === $accountCenter$.position);
        if ($$self.$$.dirty & /*$accountCenter$, $notify$*/ 10) $$invalidate(7, samePositionOrMobile = device.type === "mobile" || $accountCenter$.position === $notify$.position);
        if ($$self.$$.dirty & /*$notify$, $accountCenter$*/ 10) $$invalidate(18, sharedMobileContainerCheck = $notify$.position.includes("bottom") && $accountCenter$.position.includes("bottom") || $notify$.position.includes("top") && $accountCenter$.position.includes("top"));
        if ($$self.$$.dirty & /*$notify$, $accountCenter$, sharedMobileContainerCheck, $wallets$*/ 262158) $$invalidate(6, displayNotifySeparate = $notify$.enabled && (!$accountCenter$.enabled || accountCenterMountToElement || $notify$.position !== $accountCenter$.position && device.type !== "mobile" || device.type === "mobile" && !sharedMobileContainerCheck || !$wallets$.length));
        if ($$self.$$.dirty & /*$accountCenter$, $notify$, sharedMobileContainerCheck, $wallets$*/ 262158) $$invalidate(5, displayAccountCenterSeparate = $accountCenter$.enabled && (!$notify$.enabled || $notify$.position !== $accountCenter$.position && device.type !== "mobile" || device.type === "mobile" && !sharedMobileContainerCheck) && $wallets$.length);
        if ($$self.$$.dirty & /*$notify$, $accountCenter$, sharedContainer, sharedMobileContainerCheck, $wallets$*/ 262159) $$invalidate(4, displayAccountCenterNotifySameContainer = $notify$.enabled && $accountCenter$.enabled && (sharedContainer || device.type === "mobile" && sharedMobileContainerCheck) && $wallets$.length);
    };
    return [
        sharedContainer,
        $accountCenter$,
        $wallets$,
        $notify$,
        displayAccountCenterNotifySameContainer,
        displayAccountCenterSeparate,
        displayNotifySeparate,
        samePositionOrMobile,
        $connectWallet$,
        $switchChainModal$,
        $notifications$,
        device,
        accountCenter$,
        notify$,
        notifications$,
        setPositioningDefaults,
        accountCenterComponent,
        notifyComponent,
        sharedMobileContainerCheck
    ];
}
class $ddf18a96c86c2e3c$var$Index extends $ddf18a96c86c2e3c$export$25ce5a424b770e84 {
    constructor(options){
        super();
        $ddf18a96c86c2e3c$export$23f2a1d2818174ef(this, options, $ddf18a96c86c2e3c$var$instance, $ddf18a96c86c2e3c$var$create_fragment, $ddf18a96c86c2e3c$export$2408f22a0fab9ae5, {}, $ddf18a96c86c2e3c$var$add_css);
    }
}
let $ddf18a96c86c2e3c$var$notificationsArr;
$ddf18a96c86c2e3c$export$6559d589eb85fbb6.select("notifications").subscribe((notifications)=>{
    $ddf18a96c86c2e3c$var$notificationsArr = notifications;
});
async function $ddf18a96c86c2e3c$var$preflightNotifications(options) {
    const invalid = $ddf18a96c86c2e3c$var$validatePreflightNotifications(options);
    if (invalid) throw invalid;
    const { sendTransaction: sendTransaction, estimateGas: estimateGas, gasPrice: gasPrice, balance: balance, txDetails: txDetails, txApproveReminderTimeout: txApproveReminderTimeout } = options;
    // Check for reminder timeout and confirm its greater than 3 seconds
    const reminderTimeout = txApproveReminderTimeout && txApproveReminderTimeout > 3000 ? txApproveReminderTimeout : 15000;
    // if `balance` or `estimateGas` or `gasPrice` is not provided,
    // then sufficient funds check is disabled
    // if `txDetails` is not provided,
    // then duplicate transaction check is disabled
    // if dev doesn't want notify to initiate the transaction
    // and `sendTransaction` is not provided, then transaction
    // rejected notification is disabled
    // to disable hints for `txAwaitingApproval`, `txConfirmReminder`
    // or any other notification, then return false from listener functions
    const [gas, price] = await $ddf18a96c86c2e3c$var$gasEstimates(estimateGas || (()=>Promise.resolve("")), gasPrice || (()=>Promise.resolve("")));
    const id = $ddf18a96c86c2e3c$var$createId((0, $fEL8l.nanoid)());
    const value = BigInt(txDetails && txDetails.value || 0);
    // check sufficient balance if required parameters are available
    if (balance && gas && price) {
        const transactionCost = BigInt(gas) * BigInt(price) + value;
        // if transaction cost is greater than the current balance
        if ((0, $3lyD3.bigIntToHex)(transactionCost) > (0, $3lyD3.bigIntToHex)((0, $3lyD3.ethToWeiBigInt)(balance))) {
            const eventCode = "nsfFail";
            $ddf18a96c86c2e3c$var$addNotification($ddf18a96c86c2e3c$var$buildNotification(eventCode, id));
        }
    }
    // check previous transactions awaiting approval
    const txRequested = $ddf18a96c86c2e3c$var$notificationsArr.find((tx)=>tx.eventCode === "txRequest");
    if (txRequested) {
        const eventCode = "txAwaitingApproval";
        const newNotification = $ddf18a96c86c2e3c$var$buildNotification(eventCode, txRequested.id);
        $ddf18a96c86c2e3c$var$addNotification(newNotification);
    }
    // confirm reminder timeout defaults to 20 seconds
    setTimeout(()=>{
        const awaitingApproval = $ddf18a96c86c2e3c$var$notificationsArr.find((tx)=>tx.id === id && tx.eventCode === "txRequest");
        if (awaitingApproval) {
            const eventCode = "txConfirmReminder";
            const newNotification = $ddf18a96c86c2e3c$var$buildNotification(eventCode, awaitingApproval.id);
            $ddf18a96c86c2e3c$var$addNotification(newNotification);
        }
    }, reminderTimeout);
    const eventCode = "txRequest";
    $ddf18a96c86c2e3c$var$addNotification($ddf18a96c86c2e3c$var$buildNotification(eventCode, id));
    // if not provided with sendTransaction function,
    // resolve with transaction hash(or void) so dev can initiate transaction
    if (!sendTransaction) return id;
    // get result and handle errors
    let hash;
    try {
        hash = await sendTransaction();
    } catch (error) {
        const { eventCode: eventCode, errorMsg: errorMsg } = $ddf18a96c86c2e3c$var$extractMessageFromError(error);
        $ddf18a96c86c2e3c$var$addNotification($ddf18a96c86c2e3c$var$buildNotification(eventCode, id));
        console.error(errorMsg);
        return;
    }
    // Remove preflight notification if a resolves to hash
    // and let the SDK take over
    $ddf18a96c86c2e3c$export$1fbe638ecf81657e(id);
    if (hash) return hash;
    return;
}
const $ddf18a96c86c2e3c$var$buildNotification = (eventCode, id)=>{
    return {
        eventCode: eventCode,
        type: $ddf18a96c86c2e3c$var$eventToType(eventCode),
        id: id,
        key: $ddf18a96c86c2e3c$var$createKey(id, eventCode),
        message: $ddf18a96c86c2e3c$var$createMessageText(eventCode),
        startTime: Date.now(),
        network: Object.keys($ddf18a96c86c2e3c$export$2f6ca3d3b1f80bf5).find((key)=>$ddf18a96c86c2e3c$export$2f6ca3d3b1f80bf5[key] === $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().chains[0].id),
        autoDismiss: 0
    };
};
const $ddf18a96c86c2e3c$var$createKey = (id, eventCode)=>{
    return `${id}-${eventCode}`;
};
const $ddf18a96c86c2e3c$var$createId = (id)=>{
    return `${id}-preflight`;
};
const $ddf18a96c86c2e3c$var$createMessageText = (eventCode)=>{
    const notificationDefaultMessages = $ddf18a96c86c2e3c$export$e7094788287c5e9b.notify;
    notificationDefaultMessages.transaction;
    return notificationDefaultMessages.transaction[eventCode];
};
function $ddf18a96c86c2e3c$var$extractMessageFromError(error) {
    if (!error.stack || !error.message) return {
        eventCode: "txError",
        errorMsg: "An unknown error occurred"
    };
    const message = error.stack || error.message;
    if (message.includes("User denied transaction signature")) return {
        eventCode: "txSendFail",
        errorMsg: "User denied transaction signature"
    };
    if (message.includes("transaction underpriced")) return {
        eventCode: "txUnderpriced",
        errorMsg: "Transaction is under priced"
    };
    return {
        eventCode: "txError",
        errorMsg: message
    };
}
const $ddf18a96c86c2e3c$var$gasEstimates = async (gasFunc, gasPriceFunc)=>{
    if (!gasFunc || !gasPriceFunc) return Promise.resolve([]);
    const gasProm = gasFunc();
    if (!gasProm.then) throw new Error("The `estimateGas` function must return a Promise");
    const gasPriceProm = gasPriceFunc();
    if (!gasPriceProm.then) throw new Error("The `gasPrice` function must return a Promise");
    return Promise.all([
        gasProm,
        gasPriceProm
    ]).then(([gasResult, gasPriceResult])=>{
        if (typeof gasResult !== "string") throw new Error(`The Promise returned from calling 'estimateGas' must resolve with a value of type 'string'. Received a value of: ${gasResult} with a type: ${typeof gasResult}`);
        if (typeof gasPriceResult !== "string") throw new Error(`The Promise returned from calling 'gasPrice' must resolve with a value of type 'string'. Received a value of: ${gasPriceResult} with a type: ${typeof gasPriceResult}`);
        return [
            BigInt(gasResult),
            BigInt(gasPriceResult)
        ];
    }).catch((error)=>{
        throw new Error(`There was an error getting gas estimates: ${error}`);
    });
};
const $ddf18a96c86c2e3c$var$API = {
    connectWallet: $ddf18a96c86c2e3c$export$3b513254972cfc9c,
    disconnectWallet: $ddf18a96c86c2e3c$export$56c0d5a1e737357d,
    setChain: $ddf18a96c86c2e3c$export$2d1720544b23b823,
    state: {
        get: $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get,
        select: $ddf18a96c86c2e3c$export$6559d589eb85fbb6.select,
        actions: {
            setWalletModules: $ddf18a96c86c2e3c$var$setWalletModules,
            setLocale: $ddf18a96c86c2e3c$var$setLocale,
            updateNotify: $ddf18a96c86c2e3c$var$updateNotify,
            customNotification: $ddf18a96c86c2e3c$var$customNotification,
            preflightNotifications: $ddf18a96c86c2e3c$var$preflightNotifications,
            updateBalances: $ddf18a96c86c2e3c$var$updateBalances,
            updateAccountCenter: $ddf18a96c86c2e3c$export$1a82df3d29112e01,
            setPrimaryWallet: $ddf18a96c86c2e3c$export$c4ce752e73470fba,
            updateTheme: $ddf18a96c86c2e3c$var$updateTheme,
            updateAppMetadata: $ddf18a96c86c2e3c$var$updateAppMetadata
        }
    }
};
function $ddf18a96c86c2e3c$export$9d398bebfec1c039(options) {
    if (typeof window === "undefined") return $ddf18a96c86c2e3c$var$API;
    if (options) {
        const error = $ddf18a96c86c2e3c$var$validateInitOptions(options);
        if (error) throw error;
    }
    const { wallets: wallets, chains: chains, appMetadata: appMetadata, i18n: i18n, accountCenter: accountCenter, apiKey: apiKey, notify: notify, gas: gas, connect: connect, containerElements: containerElements, transactionPreview: transactionPreview, theme: theme, disableFontDownload: disableFontDownload, unstoppableResolution: unstoppableResolution, wagmi: wagmi } = options;
    if (containerElements) $ddf18a96c86c2e3c$var$updateConfiguration({
        containerElements: containerElements
    });
    const { device: device, svelteInstance: svelteInstance } = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57;
    if (svelteInstance) {
        // if already initialized, need to cleanup old instance
        console.warn("Re-initializing Onboard and resetting back to initial state");
        $ddf18a96c86c2e3c$var$reset$.next();
    }
    $ddf18a96c86c2e3c$var$initialize(i18n);
    $ddf18a96c86c2e3c$var$addChains($ddf18a96c86c2e3c$var$chainIdToHex(chains));
    if (typeof connect !== "undefined") $ddf18a96c86c2e3c$var$updateConnectModal(connect);
    // update accountCenter
    if (typeof accountCenter !== "undefined") {
        let accountCenterUpdate;
        const { hideTransactionProtectionBtn: hideTransactionProtectionBtn, transactionProtectionInfoLink: transactionProtectionInfoLink } = accountCenter;
        if (device.type === "mobile") accountCenterUpdate = Object.assign(Object.assign(Object.assign({}, $ddf18a96c86c2e3c$var$APP_INITIAL_STATE.accountCenter), {
            hideTransactionProtectionBtn: hideTransactionProtectionBtn,
            transactionProtectionInfoLink: transactionProtectionInfoLink
        }), accountCenter.mobile ? accountCenter.mobile : {});
        else if (accountCenter.desktop) accountCenterUpdate = Object.assign(Object.assign(Object.assign({}, $ddf18a96c86c2e3c$var$APP_INITIAL_STATE.accountCenter), {
            hideTransactionProtectionBtn: hideTransactionProtectionBtn,
            transactionProtectionInfoLink: transactionProtectionInfoLink
        }), accountCenter.desktop);
        if (typeof accountCenterUpdate !== "undefined") $ddf18a96c86c2e3c$export$1a82df3d29112e01(accountCenterUpdate);
    }
    let wagmiApi;
    if (typeof wagmi !== "undefined") wagmiApi = wagmi(Object.assign({
        disconnect: $ddf18a96c86c2e3c$export$56c0d5a1e737357d,
        updateChain: $ddf18a96c86c2e3c$var$updateChain
    }, $ddf18a96c86c2e3c$var$wagmiProviderMethods()));
    // update notify
    if (typeof notify !== "undefined") {
        if ("desktop" in notify || "mobile" in notify) {
            const error = $ddf18a96c86c2e3c$var$validateNotifyOptions(notify);
            if (error) throw error;
            if (notify && notify.desktop && notify.desktop.position && accountCenter && accountCenter.desktop && accountCenter.desktop.position) notify.desktop.position = accountCenter.desktop.position;
            if (notify && notify.mobile && notify.mobile.position && accountCenter && accountCenter.mobile && accountCenter.mobile.position) notify.mobile.position = accountCenter.mobile.position;
            let notifyUpdate = {};
            if (device.type === "mobile" && notify.mobile) notifyUpdate = Object.assign(Object.assign({}, $ddf18a96c86c2e3c$var$APP_INITIAL_STATE.notify), notify.mobile);
            else if (notify.desktop) notifyUpdate = Object.assign(Object.assign({}, $ddf18a96c86c2e3c$var$APP_INITIAL_STATE.notify), notify.desktop);
            $ddf18a96c86c2e3c$var$updateNotify(notifyUpdate);
        } else {
            const error = $ddf18a96c86c2e3c$var$validateNotify(notify);
            if (error) throw error;
            const notifyUpdate = Object.assign(Object.assign({}, $ddf18a96c86c2e3c$var$APP_INITIAL_STATE.notify), notify);
            $ddf18a96c86c2e3c$var$updateNotify(notifyUpdate);
        }
    } else {
        const notifyUpdate = $ddf18a96c86c2e3c$var$APP_INITIAL_STATE.notify;
        $ddf18a96c86c2e3c$var$updateNotify(notifyUpdate);
    }
    const app = svelteInstance || $ddf18a96c86c2e3c$var$mountApp(theme || {}, disableFontDownload || false);
    $ddf18a96c86c2e3c$var$updateConfiguration({
        svelteInstance: app,
        apiKey: apiKey,
        initialWalletInit: wallets,
        gas: gas,
        transactionPreview: transactionPreview,
        unstoppableResolution: unstoppableResolution,
        wagmi: wagmiApi
    });
    appMetadata && $ddf18a96c86c2e3c$var$updateAppMetadata(appMetadata);
    if (apiKey && transactionPreview) {
        console.warn("Transaction Preview support is going to be sunset on July 1st 2024 and will no longer work after that date");
        const getBnSDK = async ()=>{
            const sdk = await $ddf18a96c86c2e3c$var$getBlocknativeSdk();
            if (!sdk) return;
            transactionPreview.init({
                containerElement: "#w3o-transaction-preview-container",
                sdk: sdk,
                apiKey: apiKey
            });
            $ddf18a96c86c2e3c$export$efccba1c4a2ef57b.subscribe((wallets)=>{
                wallets.forEach(({ provider: provider })=>{
                    transactionPreview.patchProvider(provider);
                });
            });
        };
        getBnSDK();
    }
    theme && $ddf18a96c86c2e3c$var$updateTheme(theme);
    // handle auto connection of last wallet
    if (connect && (connect.autoConnectLastWallet || connect.autoConnectAllPreviousWallet)) {
        const lastConnectedWallets = $ddf18a96c86c2e3c$var$getLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.LAST_CONNECTED_WALLET);
        try {
            const lastConnectedWalletsParsed = JSON.parse(lastConnectedWallets);
            if (lastConnectedWalletsParsed && Array.isArray(lastConnectedWalletsParsed) && lastConnectedWalletsParsed.length) $ddf18a96c86c2e3c$var$connectAllPreviousWallets(lastConnectedWalletsParsed, connect);
            if (lastConnectedWalletsParsed && typeof lastConnectedWalletsParsed === "string") $ddf18a96c86c2e3c$var$connectAllPreviousWallets([
                lastConnectedWalletsParsed
            ], connect);
        } catch (err) {
            // Handle for legacy single wallet approach
            // Above try will throw syntax error is local storage is not json
            if (err instanceof SyntaxError && lastConnectedWallets) $ddf18a96c86c2e3c$var$API.connectWallet({
                autoSelect: {
                    label: lastConnectedWallets,
                    disableModals: true
                }
            });
        }
    }
    return $ddf18a96c86c2e3c$var$API;
}
const $ddf18a96c86c2e3c$var$fontFamilyExternallyDefined = (theme, disableFontDownload)=>{
    if (disableFontDownload) return true;
    if (document.body && (getComputedStyle(document.body).getPropertyValue("--onboard-font-family-normal") || getComputedStyle(document.body).getPropertyValue("--w3o-font-family"))) return true;
    if (!theme) return false;
    if (typeof theme === "object" && theme["--w3o-font-family"]) return true;
    return false;
};

const $ddf18a96c86c2e3c$var$importInterFont = async ()=>{
    const { InterVar: InterVar } = await Promise.resolve((parcelRequire("lH5oz")));
    // Add Fonts to main page
    const styleEl = document.createElement("style");
    styleEl.innerHTML = `
    ${InterVar}
  `;
    document.body.appendChild(styleEl);
};
const $ddf18a96c86c2e3c$var$connectAllPreviousWallets = async (lastConnectedWallets, connect)=>{
    const activeWalletsList = [];
    const parsedWalletList = lastConnectedWallets;
    if (!connect.autoConnectAllPreviousWallet) {
        $ddf18a96c86c2e3c$var$API.connectWallet({
            autoSelect: {
                label: parsedWalletList[0],
                disableModals: true
            }
        });
        activeWalletsList.push(parsedWalletList[0]);
    } else // Loop in reverse to maintain wallet order
    for(let i = parsedWalletList.length; i--;){
        const walletConnectionPromise = await $ddf18a96c86c2e3c$var$API.connectWallet({
            autoSelect: {
                label: parsedWalletList[i],
                disableModals: true
            }
        });
        // Update localStorage list for available wallets
        if (walletConnectionPromise.some((r)=>r.label === parsedWalletList[i])) activeWalletsList.unshift(parsedWalletList[i]);
    }
    $ddf18a96c86c2e3c$var$setLocalStore($ddf18a96c86c2e3c$var$STORAGE_KEYS.LAST_CONNECTED_WALLET, JSON.stringify(activeWalletsList));
};
function $ddf18a96c86c2e3c$var$mountApp(theme, disableFontDownload) {
    class Onboard extends HTMLElement {
        constructor(){
            super();
        }
    }
    if (!customElements.get("onboard-v2")) customElements.define("onboard-v2", Onboard);
    if (!$ddf18a96c86c2e3c$var$fontFamilyExternallyDefined(theme, disableFontDownload)) $ddf18a96c86c2e3c$var$importInterFont();
    // add to DOM
    const onboard = document.createElement("onboard-v2");
    const target = onboard.attachShadow({
        mode: "open"
    });
    onboard.style.all = "initial";
    target.innerHTML = `

  <style>
    :host {
          /* COLORS */
          --white: white;
          --black: black;
          --primary-1: #2F80ED;
          --primary-100: #eff1fc;
          --primary-200: #d0d4f7;
          --primary-300: #b1b8f2;
          --primary-400: #929bed;
          --primary-500: #6370e5;
          --primary-600: #454ea0;
          --primary-700: #323873;
          --gray-100: #ebebed;
          --gray-200: #c2c4c9;
          --gray-300: #999ca5;
          --gray-400: #707481;
          --gray-500: #33394b;
          --gray-600: #242835;
          --gray-700: #1a1d26;
          --success-100: #d1fae3;
          --success-200: #baf7d5;
          --success-300: #a4f4c6;
          --success-400: #8df2b8;
          --success-500: #5aec99;
          --success-600: #18ce66;
          --success-700: #129b4d;
          --danger-100: #ffe5e6;
          --danger-200: #ffcccc;
          --danger-300: #ffb3b3;
          --danger-400: #ff8080;
          --danger-500: #ff4f4f;
          --danger-600: #cc0000;
          --danger-700: #660000;
          --warning-100: #ffefcc;
          --warning-200: #ffe7b3;
          --warning-300: #ffd780;
          --warning-400: #ffc74c;
          --warning-500: #ffaf00;
          --warning-600: #cc8c00;
          --warning-700: #664600;

          /* FONTS */
          --font-family-normal: var(--w3o-font-family, Inter, sans-serif);

          --font-size-1: 3rem;
          --font-size-2: 2.25rem;
          --font-size-3: 1.5rem;
          --font-size-4: 1.25rem;
          --font-size-5: 1rem;
          --font-size-6: .875rem;
          --font-size-7: .75rem;

          --font-line-height-1: 24px;
          --font-line-height-2: 20px;
          --font-line-height-3: 16px;
          --font-line-height-4: 12px;

          /* SPACING */
          --spacing-1: 3rem;
          --spacing-2: 2rem;
          --spacing-3: 1.5rem;
          --spacing-4: 1rem;
          --spacing-5: 0.5rem;
          --spacing-6: 0.25rem;
          --spacing-7: 0.125rem;

          /* BORDER RADIUS */
          --border-radius-1: 24px;
          --border-radius-2: 20px;
          --border-radius-3: 16px;
          --border-radius-4: 12px;
          --border-radius-5: 8px;

          /* SHADOWS */
          --shadow-0: none;
          --shadow-1: 0px 4px 12px rgba(0, 0, 0, 0.1);
          --shadow-2: inset 0px -1px 0px rgba(0, 0, 0, 0.1);
          --shadow-3: 0px 4px 16px rgba(0, 0, 0, 0.2);

          /* MODAL POSITIONING */
          --modal-z-index: 10;
          --modal-top: unset;
          --modal-right: unset;
          --modal-bottom: unset;
          --modal-left: unset;

          /* MODAL STYLES */
          --modal-backdrop: rgba(0, 0, 0, 0.6);

        }
      </style>
    `;
    let connectModalContEl;
    if ($ddf18a96c86c2e3c$export$c9170ad7d4cd7e57 && $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57.containerElements && $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57.containerElements.connectModal) connectModalContEl = $ddf18a96c86c2e3c$export$c9170ad7d4cd7e57.containerElements.connectModal;
    const containerElementQuery = connectModalContEl || $ddf18a96c86c2e3c$export$6559d589eb85fbb6.get().accountCenter.containerElement || "body";
    const containerElement = document.querySelector(containerElementQuery);
    if (!containerElement) throw new Error(`Element with query ${containerElementQuery} does not exist.`);
    containerElement.appendChild(onboard);
    const app = new $ddf18a96c86c2e3c$var$Index({
        target: target
    });
    return app;
}

});
parcelRegister("l4gH8", function(module, exports) {

$parcel$export(module.exports, "BehaviorSubject", function () { return $f566ebead5ee1997$export$cc3d42e6b2b9cf8b; });

var $fxST9 = parcelRequire("fxST9");

var $6jCRi = parcelRequire("6jCRi");
var $f566ebead5ee1997$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $fxST9.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $6jCRi.Subject));

});
parcelRegister("fxST9", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $b51483c9368cd68e$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $b51483c9368cd68e$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__awaiter", function () { return $b51483c9368cd68e$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $b51483c9368cd68e$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $b51483c9368cd68e$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $b51483c9368cd68e$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $b51483c9368cd68e$export$1216008129fb82ed; });
$parcel$export(module.exports, "__await", function () { return $b51483c9368cd68e$export$10c90e4f7922046c; });
$parcel$export(module.exports, "__asyncGenerator", function () { return $b51483c9368cd68e$export$e427f37a30a4de9b; });
$parcel$export(module.exports, "__asyncValues", function () { return $b51483c9368cd68e$export$e3b29a3d6162315f; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $b51483c9368cd68e$var$extendStatics = function(d, b) {
    $b51483c9368cd68e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b51483c9368cd68e$var$extendStatics(d, b);
};
function $b51483c9368cd68e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b51483c9368cd68e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b51483c9368cd68e$export$18ce0697a983be9b = function() {
    $b51483c9368cd68e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b51483c9368cd68e$export$18ce0697a983be9b.apply(this, arguments);
};
function $b51483c9368cd68e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b51483c9368cd68e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b51483c9368cd68e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b51483c9368cd68e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b51483c9368cd68e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b51483c9368cd68e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $b51483c9368cd68e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b51483c9368cd68e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b51483c9368cd68e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b51483c9368cd68e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b51483c9368cd68e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b51483c9368cd68e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b51483c9368cd68e$export$45d3717a4c69092e(o, m, p);
}
function $b51483c9368cd68e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b51483c9368cd68e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b51483c9368cd68e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b51483c9368cd68e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b51483c9368cd68e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b51483c9368cd68e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b51483c9368cd68e$export$10c90e4f7922046c(v) {
    return this instanceof $b51483c9368cd68e$export$10c90e4f7922046c ? (this.v = v, this) : new $b51483c9368cd68e$export$10c90e4f7922046c(v);
}
function $b51483c9368cd68e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b51483c9368cd68e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b51483c9368cd68e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b51483c9368cd68e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b51483c9368cd68e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b51483c9368cd68e$export$19a8beecd37a4c45 === "function" ? $b51483c9368cd68e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b51483c9368cd68e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b51483c9368cd68e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $b51483c9368cd68e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b51483c9368cd68e$export$45d3717a4c69092e(result, mod, k);
    }
    $b51483c9368cd68e$var$__setModuleDefault(result, mod);
    return result;
}
function $b51483c9368cd68e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b51483c9368cd68e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b51483c9368cd68e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b51483c9368cd68e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b51483c9368cd68e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b51483c9368cd68e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b51483c9368cd68e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b51483c9368cd68e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $b51483c9368cd68e$export$2e2bcd8739ae039 = {
    __extends: $b51483c9368cd68e$export$a8ba968b8961cb8a,
    __assign: $b51483c9368cd68e$export$18ce0697a983be9b,
    __rest: $b51483c9368cd68e$export$3c9a16f847548506,
    __decorate: $b51483c9368cd68e$export$29e00dfd3077644b,
    __param: $b51483c9368cd68e$export$d5ad3fd78186038f,
    __metadata: $b51483c9368cd68e$export$f1db080c865becb9,
    __awaiter: $b51483c9368cd68e$export$1050f835b63b671e,
    __generator: $b51483c9368cd68e$export$67ebef60e6f28a6,
    __createBinding: $b51483c9368cd68e$export$45d3717a4c69092e,
    __exportStar: $b51483c9368cd68e$export$f33643c0debef087,
    __values: $b51483c9368cd68e$export$19a8beecd37a4c45,
    __read: $b51483c9368cd68e$export$8d051b38c9118094,
    __spread: $b51483c9368cd68e$export$afc72e2116322959,
    __spreadArrays: $b51483c9368cd68e$export$6388937ca91ccae8,
    __spreadArray: $b51483c9368cd68e$export$1216008129fb82ed,
    __await: $b51483c9368cd68e$export$10c90e4f7922046c,
    __asyncGenerator: $b51483c9368cd68e$export$e427f37a30a4de9b,
    __asyncDelegator: $b51483c9368cd68e$export$bbd80228419bb833,
    __asyncValues: $b51483c9368cd68e$export$e3b29a3d6162315f,
    __makeTemplateObject: $b51483c9368cd68e$export$4fb47efe1390b86f,
    __importStar: $b51483c9368cd68e$export$c21735bcef00d192,
    __importDefault: $b51483c9368cd68e$export$da59b14a69baef04,
    __classPrivateFieldGet: $b51483c9368cd68e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b51483c9368cd68e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b51483c9368cd68e$export$81fdc39f203e4e04,
    __addDisposableResource: $b51483c9368cd68e$export$88ac25d8e944e405,
    __disposeResources: $b51483c9368cd68e$export$8f076105dc360e92
};

});

parcelRegister("6jCRi", function(module, exports) {

$parcel$export(module.exports, "Subject", function () { return $4992a8f2805a740f$export$b6bbab5a9b109038; });

var $fxST9 = parcelRequire("fxST9");

var $gwAql = parcelRequire("gwAql");

var $bMMx0 = parcelRequire("bMMx0");

var $5v7Yt = parcelRequire("5v7Yt");

var $5rNDa = parcelRequire("5rNDa");

var $8frNh = parcelRequire("8frNh");
var $4992a8f2805a740f$export$b6bbab5a9b109038 = function(_super) {
    (0, $fxST9.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $4992a8f2805a740f$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $5v7Yt.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $8frNh.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $fxST9.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $8frNh.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $8frNh.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $bMMx0.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $bMMx0.Subscription)(function() {
            _this.currentObservers = null;
            (0, $5rNDa.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $gwAql.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $4992a8f2805a740f$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $gwAql.Observable));
var $4992a8f2805a740f$export$155189cde295587d = function(_super) {
    (0, $fxST9.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $bMMx0.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}($4992a8f2805a740f$export$b6bbab5a9b109038);

});
parcelRegister("gwAql", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return $c07be38165ba1273$export$77cea355fa80b5f4; });

var $crWnj = parcelRequire("crWnj");

var $bMMx0 = parcelRequire("bMMx0");

var $5SsQz = parcelRequire("5SsQz");

var $2hWVO = parcelRequire("2hWVO");

var $9raMu = parcelRequire("9raMu");

var $lzJVf = parcelRequire("lzJVf");

var $8frNh = parcelRequire("8frNh");
var $c07be38165ba1273$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $c07be38165ba1273$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $crWnj.SafeSubscriber)(observerOrNext, error, complete);
        (0, $8frNh.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $c07be38165ba1273$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $crWnj.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $5SsQz.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $2hWVO.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $c07be38165ba1273$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $c07be38165ba1273$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $9raMu.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $c07be38165ba1273$var$isObserver(value) {
    return value && (0, $lzJVf.isFunction)(value.next) && (0, $lzJVf.isFunction)(value.error) && (0, $lzJVf.isFunction)(value.complete);
}
function $c07be38165ba1273$var$isSubscriber(value) {
    return value && value instanceof (0, $crWnj.Subscriber) || $c07be38165ba1273$var$isObserver(value) && (0, $bMMx0.isSubscription)(value);
}

});
parcelRegister("crWnj", function(module, exports) {

$parcel$export(module.exports, "Subscriber", function () { return $910549b2f8f37f0c$export$60959659b2c22881; });
$parcel$export(module.exports, "SafeSubscriber", function () { return $910549b2f8f37f0c$export$94eeb6a328cab6c7; });

var $fxST9 = parcelRequire("fxST9");

var $lzJVf = parcelRequire("lzJVf");

var $bMMx0 = parcelRequire("bMMx0");

var $9raMu = parcelRequire("9raMu");

var $2kKNb = parcelRequire("2kKNb");

var $i2qGl = parcelRequire("i2qGl");

var $1tXi2 = parcelRequire("1tXi2");

var $kb354 = parcelRequire("kb354");

var $8frNh = parcelRequire("8frNh");
var $910549b2f8f37f0c$export$60959659b2c22881 = function(_super) {
    (0, $fxST9.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $bMMx0.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $910549b2f8f37f0c$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $910549b2f8f37f0c$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $910549b2f8f37f0c$var$handleStoppedNotification((0, $1tXi2.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $910549b2f8f37f0c$var$handleStoppedNotification((0, $1tXi2.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $910549b2f8f37f0c$var$handleStoppedNotification((0, $1tXi2.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $bMMx0.Subscription));
var $910549b2f8f37f0c$var$_bind = Function.prototype.bind;
function $910549b2f8f37f0c$var$bind(fn, thisArg) {
    return $910549b2f8f37f0c$var$_bind.call(fn, thisArg);
}
var $910549b2f8f37f0c$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $910549b2f8f37f0c$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $910549b2f8f37f0c$var$handleUnhandledError(error);
        }
        else $910549b2f8f37f0c$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $910549b2f8f37f0c$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $910549b2f8f37f0c$export$94eeb6a328cab6c7 = function(_super) {
    (0, $fxST9.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $lzJVf.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $9raMu.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $910549b2f8f37f0c$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $910549b2f8f37f0c$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $910549b2f8f37f0c$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $910549b2f8f37f0c$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($910549b2f8f37f0c$export$60959659b2c22881);
function $910549b2f8f37f0c$var$handleUnhandledError(error) {
    if ((0, $9raMu.config).useDeprecatedSynchronousErrorHandling) (0, $8frNh.captureError)(error);
    else (0, $2kKNb.reportUnhandledError)(error);
}
function $910549b2f8f37f0c$var$defaultErrorHandler(err) {
    throw err;
}
function $910549b2f8f37f0c$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $9raMu.config).onStoppedNotification;
    onStoppedNotification && (0, $kb354.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $910549b2f8f37f0c$export$88d395d20619a0af = {
    closed: true,
    next: (0, $i2qGl.noop),
    error: $910549b2f8f37f0c$var$defaultErrorHandler,
    complete: (0, $i2qGl.noop)
};

});
parcelRegister("lzJVf", function(module, exports) {

$parcel$export(module.exports, "isFunction", function () { return $fb507d15b931d80f$export$f6e2535fb5126e54; });
function $fb507d15b931d80f$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}

});

parcelRegister("bMMx0", function(module, exports) {

$parcel$export(module.exports, "Subscription", function () { return $8949d2b9eba672dc$export$f55210826850c514; });
$parcel$export(module.exports, "EMPTY_SUBSCRIPTION", function () { return $8949d2b9eba672dc$export$610f9c3ca1a38dd8; });
$parcel$export(module.exports, "isSubscription", function () { return $8949d2b9eba672dc$export$4f9221cbada3c4fc; });

var $fxST9 = parcelRequire("fxST9");

var $lzJVf = parcelRequire("lzJVf");

var $f21f3 = parcelRequire("f21f3");

var $5rNDa = parcelRequire("5rNDa");
var $8949d2b9eba672dc$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $fxST9.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $lzJVf.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f21f3.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $fxST9.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8949d2b9eba672dc$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f21f3.UnsubscriptionError)) errors = (0, $fxST9.__spreadArray)((0, $fxST9.__spreadArray)([], (0, $fxST9.__read)(errors)), (0, $fxST9.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f21f3.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8949d2b9eba672dc$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $5rNDa.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $5rNDa.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8949d2b9eba672dc$export$610f9c3ca1a38dd8 = $8949d2b9eba672dc$export$f55210826850c514.EMPTY;
function $8949d2b9eba672dc$export$4f9221cbada3c4fc(value) {
    return value instanceof $8949d2b9eba672dc$export$f55210826850c514 || value && "closed" in value && (0, $lzJVf.isFunction)(value.remove) && (0, $lzJVf.isFunction)(value.add) && (0, $lzJVf.isFunction)(value.unsubscribe);
}
function $8949d2b9eba672dc$var$execFinalizer(finalizer) {
    if ((0, $lzJVf.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("f21f3", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", function () { return $af1801839c7af89d$export$c9648b76fd580c34; });

var $1kBoI = parcelRequire("1kBoI");
var $af1801839c7af89d$export$c9648b76fd580c34 = (0, $1kBoI.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});

});
parcelRegister("1kBoI", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", function () { return $0f84ab1827b2a9f9$export$128a15b65d1b6041; });
function $0f84ab1827b2a9f9$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("5rNDa", function(module, exports) {

$parcel$export(module.exports, "arrRemove", function () { return $3f75f903b59b364d$export$dae3f38077fc36c0; });
function $3f75f903b59b364d$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});


parcelRegister("9raMu", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $6deeff93867d8a9a$export$e506a1d27d1eaa20; });
var $6deeff93867d8a9a$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("2kKNb", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", function () { return $1b31bf00f2a2ef8e$export$ebf645db02d3e99f; });

var $9raMu = parcelRequire("9raMu");

var $kb354 = parcelRequire("kb354");
function $1b31bf00f2a2ef8e$export$ebf645db02d3e99f(err) {
    (0, $kb354.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $9raMu.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("kb354", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", function () { return $eb073986b2d75a4c$export$365aa6bd3c788e3d; });

var $fxST9 = parcelRequire("fxST9");
var $eb073986b2d75a4c$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $eb073986b2d75a4c$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $fxST9.__spreadArray)([
            handler,
            timeout
        ], (0, $fxST9.__read)(args)));
        return setTimeout.apply(void 0, (0, $fxST9.__spreadArray)([
            handler,
            timeout
        ], (0, $fxST9.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $eb073986b2d75a4c$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("i2qGl", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $d21d1c5cab029369$export$8793edee2d425525; });
function $d21d1c5cab029369$export$8793edee2d425525() {}

});

parcelRegister("1tXi2", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", function () { return $11467da3acd7d593$export$b7f97edb34bc1f87; });
$parcel$export(module.exports, "errorNotification", function () { return $11467da3acd7d593$export$dd472c3d8fe5a85a; });
$parcel$export(module.exports, "nextNotification", function () { return $11467da3acd7d593$export$ff9346b0d1d30313; });
var $11467da3acd7d593$export$b7f97edb34bc1f87 = function() {
    return $11467da3acd7d593$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $11467da3acd7d593$export$dd472c3d8fe5a85a(error) {
    return $11467da3acd7d593$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $11467da3acd7d593$export$ff9346b0d1d30313(value) {
    return $11467da3acd7d593$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $11467da3acd7d593$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("8frNh", function(module, exports) {

$parcel$export(module.exports, "errorContext", function () { return $601548b5a60e5f29$export$d974811edc77eafa; });
$parcel$export(module.exports, "captureError", function () { return $601548b5a60e5f29$export$3e205fbb5df021e0; });

var $9raMu = parcelRequire("9raMu");
var $601548b5a60e5f29$var$context = null;
function $601548b5a60e5f29$export$d974811edc77eafa(cb) {
    if ((0, $9raMu.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$601548b5a60e5f29$var$context;
        if (isRoot) $601548b5a60e5f29$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $601548b5a60e5f29$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $601548b5a60e5f29$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $601548b5a60e5f29$export$3e205fbb5df021e0(err) {
    if ((0, $9raMu.config).useDeprecatedSynchronousErrorHandling && $601548b5a60e5f29$var$context) {
        $601548b5a60e5f29$var$context.errorThrown = true;
        $601548b5a60e5f29$var$context.error = err;
    }
}

});


parcelRegister("5SsQz", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return $44785f4513b0810b$export$5ab46cbf6120b33a; });
var $44785f4513b0810b$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

});

parcelRegister("2hWVO", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", function () { return $1aaae1d771247b07$export$71f88a61afaa14d7; });

var $43nmT = parcelRequire("43nmT");
function $1aaae1d771247b07$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $1aaae1d771247b07$export$71f88a61afaa14d7(fns);
}
function $1aaae1d771247b07$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $43nmT.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("43nmT", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $2f3991ac607dcbef$export$f0954fd7d5368655; });
function $2f3991ac607dcbef$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("5v7Yt", function(module, exports) {

$parcel$export(module.exports, "ObjectUnsubscribedError", function () { return $40160888668a9b11$export$f708eee25634bc80; });

var $1kBoI = parcelRequire("1kBoI");
var $40160888668a9b11$export$f708eee25634bc80 = (0, $1kBoI.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});

});



parcelRegister("hh9se", function(module, exports) {

$parcel$export(module.exports, "defer", function () { return $c93b5b9ed06eff73$export$260e5c0943f31606; });

var $gwAql = parcelRequire("gwAql");

var $GK7sD = parcelRequire("GK7sD");
function $c93b5b9ed06eff73$export$260e5c0943f31606(observableFactory) {
    return new (0, $gwAql.Observable)(function(subscriber) {
        (0, $GK7sD.innerFrom)(observableFactory()).subscribe(subscriber);
    });
}

});
parcelRegister("GK7sD", function(module, exports) {

$parcel$export(module.exports, "innerFrom", function () { return $0807b2b2abc933a5$export$6a9cfa3ebc765910; });

var $fxST9 = parcelRequire("fxST9");

var $6burP = parcelRequire("6burP");

var $kIhgZ = parcelRequire("kIhgZ");

var $gwAql = parcelRequire("gwAql");

var $e7U14 = parcelRequire("e7U14");

var $9oCbS = parcelRequire("9oCbS");

var $lHhvr = parcelRequire("lHhvr");

var $fyfRB = parcelRequire("fyfRB");

var $G23Vj = parcelRequire("G23Vj");

var $lzJVf = parcelRequire("lzJVf");

var $2kKNb = parcelRequire("2kKNb");

var $5SsQz = parcelRequire("5SsQz");
function $0807b2b2abc933a5$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $gwAql.Observable)) return input;
    if (input != null) {
        if ((0, $e7U14.isInteropObservable)(input)) return $0807b2b2abc933a5$export$aa3d41784b3267fa(input);
        if ((0, $6burP.isArrayLike)(input)) return $0807b2b2abc933a5$export$4cb2acdbcda2c253(input);
        if ((0, $kIhgZ.isPromise)(input)) return $0807b2b2abc933a5$export$60f45028237c39d1(input);
        if ((0, $9oCbS.isAsyncIterable)(input)) return $0807b2b2abc933a5$export$e073fccf36d78cc1(input);
        if ((0, $fyfRB.isIterable)(input)) return $0807b2b2abc933a5$export$dcccc29c315dd646(input);
        if ((0, $G23Vj.isReadableStreamLike)(input)) return $0807b2b2abc933a5$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $lHhvr.createInvalidObservableTypeError)(input);
}
function $0807b2b2abc933a5$export$aa3d41784b3267fa(obj) {
    return new (0, $gwAql.Observable)(function(subscriber) {
        var obs = obj[0, $5SsQz.observable]();
        if ((0, $lzJVf.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $0807b2b2abc933a5$export$4cb2acdbcda2c253(array) {
    return new (0, $gwAql.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $0807b2b2abc933a5$export$60f45028237c39d1(promise) {
    return new (0, $gwAql.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $2kKNb.reportUnhandledError));
    });
}
function $0807b2b2abc933a5$export$dcccc29c315dd646(iterable) {
    return new (0, $gwAql.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $fxST9.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $0807b2b2abc933a5$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $gwAql.Observable)(function(subscriber) {
        $0807b2b2abc933a5$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $0807b2b2abc933a5$export$b2dcb11d46e7a4ad(readableStream) {
    return $0807b2b2abc933a5$export$e073fccf36d78cc1((0, $G23Vj.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $0807b2b2abc933a5$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $fxST9.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $fxST9.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $fxST9.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("6burP", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", function () { return $480b637d09703c06$export$1e2f57719e155213; });
var $480b637d09703c06$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

});

parcelRegister("kIhgZ", function(module, exports) {

$parcel$export(module.exports, "isPromise", function () { return $f14550c415135e85$export$4369c812aac99591; });

var $lzJVf = parcelRequire("lzJVf");
function $f14550c415135e85$export$4369c812aac99591(value) {
    return (0, $lzJVf.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});

parcelRegister("e7U14", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", function () { return $a48d2bcc8108bc19$export$48c0cddbc99c45c2; });

var $5SsQz = parcelRequire("5SsQz");

var $lzJVf = parcelRequire("lzJVf");
function $a48d2bcc8108bc19$export$48c0cddbc99c45c2(input) {
    return (0, $lzJVf.isFunction)(input[0, $5SsQz.observable]);
}

});

parcelRegister("9oCbS", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", function () { return $6d73facacd4d0266$export$edb10ab8dd75a915; });

var $lzJVf = parcelRequire("lzJVf");
function $6d73facacd4d0266$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $lzJVf.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("lHhvr", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", function () { return $fcbb31772ccd92cd$export$7cbe71b9fa263484; });
function $fcbb31772ccd92cd$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("fyfRB", function(module, exports) {

$parcel$export(module.exports, "isIterable", function () { return $b52656246d1c34ac$export$9652023d9040757; });

var $17zsx = parcelRequire("17zsx");

var $lzJVf = parcelRequire("lzJVf");
function $b52656246d1c34ac$export$9652023d9040757(input) {
    return (0, $lzJVf.isFunction)(input === null || input === void 0 ? void 0 : input[0, $17zsx.iterator]);
}

});
parcelRegister("17zsx", function(module, exports) {

$parcel$export(module.exports, "iterator", function () { return $0d11f35ff8110635$export$6f58e2338da23f4d; });
function $0d11f35ff8110635$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $0d11f35ff8110635$export$6f58e2338da23f4d = $0d11f35ff8110635$export$aa9956be4ae4fe8();

});


parcelRegister("G23Vj", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", function () { return $07e585e280e0940c$export$cf4785e597badab3; });
$parcel$export(module.exports, "isReadableStreamLike", function () { return $07e585e280e0940c$export$c088ffafdba7405f; });

var $fxST9 = parcelRequire("fxST9");

var $lzJVf = parcelRequire("lzJVf");
function $07e585e280e0940c$export$cf4785e597badab3(readableStream) {
    return (0, $fxST9.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $fxST9.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $fxST9.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $fxST9.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $fxST9.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $07e585e280e0940c$export$c088ffafdba7405f(obj) {
    return (0, $lzJVf.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});



parcelRegister("i27jC", function(module, exports) {

$parcel$export(module.exports, "distinctUntilChanged", function () { return $d20e169648b71405$export$779c5fb865a0172e; });

var $43nmT = parcelRequire("43nmT");

var $5G2KO = parcelRequire("5G2KO");

var $c6TEu = parcelRequire("c6TEu");
function $d20e169648b71405$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $43nmT.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $d20e169648b71405$var$defaultCompare;
    return (0, $5G2KO.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $d20e169648b71405$var$defaultCompare(a, b) {
    return a === b;
}

});
parcelRegister("5G2KO", function(module, exports) {

$parcel$export(module.exports, "operate", function () { return $422302e9310e1ef7$export$871731df685d7753; });

var $lzJVf = parcelRequire("lzJVf");
function $422302e9310e1ef7$export$ebec8610810318c5(source) {
    return (0, $lzJVf.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $422302e9310e1ef7$export$871731df685d7753(init) {
    return function(source) {
        if ($422302e9310e1ef7$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}

});

parcelRegister("c6TEu", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", function () { return $8d1136eda3034547$export$b9e075132cc6937f; });

var $fxST9 = parcelRequire("fxST9");

var $crWnj = parcelRequire("crWnj");
function $8d1136eda3034547$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $8d1136eda3034547$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $8d1136eda3034547$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $fxST9.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $crWnj.Subscriber));

});


parcelRegister("bPD7y", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $89d2cdb82a155c19$export$3dea766d36a8935f; });

var $5G2KO = parcelRequire("5G2KO");

var $c6TEu = parcelRequire("c6TEu");
function $89d2cdb82a155c19$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $5G2KO.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

});

parcelRegister("eqreU", function(module, exports) {

$parcel$export(module.exports, "firstValueFrom", function () { return $a8089f91f5fd6455$export$400f9f949cef996c; });

var $9P2sA = parcelRequire("9P2sA");

var $crWnj = parcelRequire("crWnj");
function $a8089f91f5fd6455$export$400f9f949cef996c(source, config) {
    var hasConfig = typeof config === "object";
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, $crWnj.SafeSubscriber)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $9P2sA.EmptyError)());
            }
        });
        source.subscribe(subscriber);
    });
}

});
parcelRegister("9P2sA", function(module, exports) {

$parcel$export(module.exports, "EmptyError", function () { return $726ac8fe68710820$export$78f6d1b1dbcda304; });

var $1kBoI = parcelRequire("1kBoI");
var $726ac8fe68710820$export$78f6d1b1dbcda304 = (0, $1kBoI.createErrorClass)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = "EmptyError";
        this.message = "no elements in sequence";
    };
});

});


parcelRegister("3u3jm", function(module, exports) {

$parcel$export(module.exports, "fromEvent", function () { return $2896be0131b63b20$export$a36e16046ae8f1bb; });

var $fxST9 = parcelRequire("fxST9");

var $GK7sD = parcelRequire("GK7sD");

var $gwAql = parcelRequire("gwAql");

var $2PbLw = parcelRequire("2PbLw");

var $6burP = parcelRequire("6burP");

var $lzJVf = parcelRequire("lzJVf");

var $k7sdG = parcelRequire("k7sdG");
var $2896be0131b63b20$var$nodeEventEmitterMethods = [
    "addListener",
    "removeListener"
];
var $2896be0131b63b20$var$eventTargetMethods = [
    "addEventListener",
    "removeEventListener"
];
var $2896be0131b63b20$var$jqueryMethods = [
    "on",
    "off"
];
function $2896be0131b63b20$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $lzJVf.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $2896be0131b63b20$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $k7sdG.mapOneOrManyArgs)(resultSelector));
    var _a = (0, $fxST9.__read)($2896be0131b63b20$var$isEventTarget(target) ? $2896be0131b63b20$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $2896be0131b63b20$var$isNodeStyleEventEmitter(target) ? $2896be0131b63b20$var$nodeEventEmitterMethods.map($2896be0131b63b20$var$toCommonHandlerRegistry(target, eventName)) : $2896be0131b63b20$var$isJQueryStyleEventEmitter(target) ? $2896be0131b63b20$var$jqueryMethods.map($2896be0131b63b20$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $6burP.isArrayLike)(target)) return (0, $2PbLw.mergeMap)(function(subTarget) {
            return $2896be0131b63b20$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $GK7sD.innerFrom)(target));
    }
    if (!add) throw new TypeError("Invalid event target");
    return new (0, $gwAql.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $2896be0131b63b20$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $2896be0131b63b20$var$isNodeStyleEventEmitter(target) {
    return (0, $lzJVf.isFunction)(target.addListener) && (0, $lzJVf.isFunction)(target.removeListener);
}
function $2896be0131b63b20$var$isJQueryStyleEventEmitter(target) {
    return (0, $lzJVf.isFunction)(target.on) && (0, $lzJVf.isFunction)(target.off);
}
function $2896be0131b63b20$var$isEventTarget(target) {
    return (0, $lzJVf.isFunction)(target.addEventListener) && (0, $lzJVf.isFunction)(target.removeEventListener);
}

});
parcelRegister("2PbLw", function(module, exports) {

$parcel$export(module.exports, "mergeMap", function () { return $20e97896e9786362$export$6b9f6c0d32c093f9; });

var $cH4fw = parcelRequire("cH4fw");

var $GK7sD = parcelRequire("GK7sD");

var $5G2KO = parcelRequire("5G2KO");

var $auufM = parcelRequire("auufM");

var $lzJVf = parcelRequire("lzJVf");
function $20e97896e9786362$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $lzJVf.isFunction)(resultSelector)) return $20e97896e9786362$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $cH4fw.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $GK7sD.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $5G2KO.operate)(function(source, subscriber) {
        return (0, $auufM.mergeInternals)(source, subscriber, project, concurrent);
    });
}

});
parcelRegister("cH4fw", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $93dccc096c81ee91$export$871de8747c9eaa88; });

var $5G2KO = parcelRequire("5G2KO");

var $c6TEu = parcelRequire("c6TEu");
function $93dccc096c81ee91$export$871de8747c9eaa88(project, thisArg) {
    return (0, $5G2KO.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});

parcelRegister("auufM", function(module, exports) {

$parcel$export(module.exports, "mergeInternals", function () { return $7a342c7508082bab$export$600918ebaa9e0a1b; });

var $GK7sD = parcelRequire("GK7sD");

var $jELV7 = parcelRequire("jELV7");

var $c6TEu = parcelRequire("c6TEu");
function $7a342c7508082bab$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $GK7sD.innerFrom)(project(value, index++)).subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $jELV7.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

});
parcelRegister("jELV7", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", function () { return $e4f6ecb8f3934a18$export$a2b7447487315232; });
function $e4f6ecb8f3934a18$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});



parcelRegister("k7sdG", function(module, exports) {

$parcel$export(module.exports, "mapOneOrManyArgs", function () { return $ea5a59f274da99e1$export$559affaa48f4288d; });

var $fxST9 = parcelRequire("fxST9");

var $cH4fw = parcelRequire("cH4fw");
var $ea5a59f274da99e1$var$isArray = Array.isArray;
function $ea5a59f274da99e1$var$callOrApply(fn, args) {
    return $ea5a59f274da99e1$var$isArray(args) ? fn.apply(void 0, (0, $fxST9.__spreadArray)([], (0, $fxST9.__read)(args))) : fn(args);
}
function $ea5a59f274da99e1$export$559affaa48f4288d(fn) {
    return (0, $cH4fw.map)(function(args) {
        return $ea5a59f274da99e1$var$callOrApply(fn, args);
    });
}

});


parcelRegister("9La4g", function(module, exports) {

$parcel$export(module.exports, "fromEventPattern", function () { return $71b0501693ed62d5$export$af596f9f0ff848f8; });

var $gwAql = parcelRequire("gwAql");

var $lzJVf = parcelRequire("lzJVf");

var $k7sdG = parcelRequire("k7sdG");
function $71b0501693ed62d5$export$af596f9f0ff848f8(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return $71b0501693ed62d5$export$af596f9f0ff848f8(addHandler, removeHandler).pipe((0, $k7sdG.mapOneOrManyArgs)(resultSelector));
    return new (0, $gwAql.Observable)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return (0, $lzJVf.isFunction)(removeHandler) ? function() {
            return removeHandler(handler, retValue);
        } : undefined;
    });
}

});

parcelRegister("kBz4k", function(module, exports) {

$parcel$export(module.exports, "mapTo", function () { return $f002774a609f33b6$export$e0eaf3a86c03b2ad; });

var $cH4fw = parcelRequire("cH4fw");
function $f002774a609f33b6$export$e0eaf3a86c03b2ad(value) {
    return (0, $cH4fw.map)(function() {
        return value;
    });
}

});

parcelRegister("fn8ZQ", function(module, exports) {

$parcel$export(module.exports, "shareReplay", function () { return $b30ffb8821837bb7$export$db61d692014e534e; });

var $bwD8D = parcelRequire("bwD8D");

var $esA4D = parcelRequire("esA4D");
function $b30ffb8821837bb7$export$db61d692014e534e(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === "object") _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, $esA4D.share)({
        connector: function() {
            return new (0, $bwD8D.ReplaySubject)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}

});
parcelRegister("bwD8D", function(module, exports) {

$parcel$export(module.exports, "ReplaySubject", function () { return $86410ae7f2118fd6$export$915d2682b0aa0991; });

var $fxST9 = parcelRequire("fxST9");

var $6jCRi = parcelRequire("6jCRi");

var $f5OPh = parcelRequire("f5OPh");
var $86410ae7f2118fd6$export$915d2682b0aa0991 = function(_super) {
    (0, $fxST9.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $f5OPh.dateTimestampProvider);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $6jCRi.Subject));

});
parcelRegister("f5OPh", function(module, exports) {

$parcel$export(module.exports, "dateTimestampProvider", function () { return $afcebfa2a90387bd$export$c1895ea2d519a677; });
var $afcebfa2a90387bd$export$c1895ea2d519a677 = {
    now: function() {
        return ($afcebfa2a90387bd$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};

});


parcelRegister("esA4D", function(module, exports) {

$parcel$export(module.exports, "share", function () { return $a86fa9b62c94a16e$export$ed80d9de1d9df928; });

var $fxST9 = parcelRequire("fxST9");

var $GK7sD = parcelRequire("GK7sD");

var $6jCRi = parcelRequire("6jCRi");

var $crWnj = parcelRequire("crWnj");

var $5G2KO = parcelRequire("5G2KO");
function $a86fa9b62c94a16e$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $6jCRi.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $5G2KO.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $a86fa9b62c94a16e$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $crWnj.SafeSubscriber)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $a86fa9b62c94a16e$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $a86fa9b62c94a16e$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $GK7sD.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $a86fa9b62c94a16e$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $crWnj.SafeSubscriber)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $GK7sD.innerFrom)(on.apply(void 0, (0, $fxST9.__spreadArray)([], (0, $fxST9.__read)(args)))).subscribe(onSubscriber);
}

});


parcelRegister("lLJqC", function(module, exports) {

$parcel$export(module.exports, "startWith", function () { return $fd9139e7c81f1a0b$export$a4fe86229b0e9bdd; });

var $4ggSr = parcelRequire("4ggSr");

var $3syJC = parcelRequire("3syJC");

var $5G2KO = parcelRequire("5G2KO");
function $fd9139e7c81f1a0b$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $3syJC.popScheduler)(values);
    return (0, $5G2KO.operate)(function(source, subscriber) {
        (scheduler ? (0, $4ggSr.concat)(values, source, scheduler) : (0, $4ggSr.concat)(values, source)).subscribe(subscriber);
    });
}

});
parcelRegister("4ggSr", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $31a5bf75e965f34b$export$ee1b3e54f0441b22; });

var $jNEM9 = parcelRequire("jNEM9");

var $3syJC = parcelRequire("3syJC");

var $20XpC = parcelRequire("20XpC");
function $31a5bf75e965f34b$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $jNEM9.concatAll)()((0, $20XpC.from)(args, (0, $3syJC.popScheduler)(args)));
}

});
parcelRegister("jNEM9", function(module, exports) {

$parcel$export(module.exports, "concatAll", function () { return $e6a2391bb100d1fe$export$b314777ae20abca9; });

var $7OKYQ = parcelRequire("7OKYQ");
function $e6a2391bb100d1fe$export$b314777ae20abca9() {
    return (0, $7OKYQ.mergeAll)(1);
}

});
parcelRegister("7OKYQ", function(module, exports) {

$parcel$export(module.exports, "mergeAll", function () { return $5b11a54338aa4673$export$18aef43295bbe906; });

var $2PbLw = parcelRequire("2PbLw");

var $43nmT = parcelRequire("43nmT");
function $5b11a54338aa4673$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $2PbLw.mergeMap)((0, $43nmT.identity), concurrent);
}

});


parcelRegister("3syJC", function(module, exports) {

$parcel$export(module.exports, "popResultSelector", function () { return $284eee3feee3cb63$export$9ae19b645239a61b; });
$parcel$export(module.exports, "popScheduler", function () { return $284eee3feee3cb63$export$29534b2f653ae592; });
$parcel$export(module.exports, "popNumber", function () { return $284eee3feee3cb63$export$3de14b735070dcd5; });

var $lzJVf = parcelRequire("lzJVf");

var $aeBVv = parcelRequire("aeBVv");
function $284eee3feee3cb63$var$last(arr) {
    return arr[arr.length - 1];
}
function $284eee3feee3cb63$export$9ae19b645239a61b(args) {
    return (0, $lzJVf.isFunction)($284eee3feee3cb63$var$last(args)) ? args.pop() : undefined;
}
function $284eee3feee3cb63$export$29534b2f653ae592(args) {
    return (0, $aeBVv.isScheduler)($284eee3feee3cb63$var$last(args)) ? args.pop() : undefined;
}
function $284eee3feee3cb63$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $284eee3feee3cb63$var$last(args) === "number" ? args.pop() : defaultValue;
}

});
parcelRegister("aeBVv", function(module, exports) {

$parcel$export(module.exports, "isScheduler", function () { return $7738a19b83420395$export$187e35932e88c15c; });

var $lzJVf = parcelRequire("lzJVf");
function $7738a19b83420395$export$187e35932e88c15c(value) {
    return value && (0, $lzJVf.isFunction)(value.schedule);
}

});


parcelRegister("20XpC", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $1779aaddba2099b5$export$6788812c4e6611e6; });

var $8iF0X = parcelRequire("8iF0X");

var $GK7sD = parcelRequire("GK7sD");
function $1779aaddba2099b5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $8iF0X.scheduled)(input, scheduler) : (0, $GK7sD.innerFrom)(input);
}

});
parcelRegister("8iF0X", function(module, exports) {

$parcel$export(module.exports, "scheduled", function () { return $60afd1c8be1fd0b2$export$49c44dfc2bb21d70; });

var $knaoA = parcelRequire("knaoA");

var $gy3a8 = parcelRequire("gy3a8");

var $2G36l = parcelRequire("2G36l");

var $ks7Qm = parcelRequire("ks7Qm");

var $9zwqO = parcelRequire("9zwqO");

var $e7U14 = parcelRequire("e7U14");

var $kIhgZ = parcelRequire("kIhgZ");

var $6burP = parcelRequire("6burP");

var $fyfRB = parcelRequire("fyfRB");

var $9oCbS = parcelRequire("9oCbS");

var $lHhvr = parcelRequire("lHhvr");

var $G23Vj = parcelRequire("G23Vj");

var $ISQMb = parcelRequire("ISQMb");
function $60afd1c8be1fd0b2$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $e7U14.isInteropObservable)(input)) return (0, $knaoA.scheduleObservable)(input, scheduler);
        if ((0, $6burP.isArrayLike)(input)) return (0, $2G36l.scheduleArray)(input, scheduler);
        if ((0, $kIhgZ.isPromise)(input)) return (0, $gy3a8.schedulePromise)(input, scheduler);
        if ((0, $9oCbS.isAsyncIterable)(input)) return (0, $9zwqO.scheduleAsyncIterable)(input, scheduler);
        if ((0, $fyfRB.isIterable)(input)) return (0, $ks7Qm.scheduleIterable)(input, scheduler);
        if ((0, $G23Vj.isReadableStreamLike)(input)) return (0, $ISQMb.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $lHhvr.createInvalidObservableTypeError)(input);
}

});
parcelRegister("knaoA", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", function () { return $ed4e04f9248d49d1$export$ed8bd553a12b6a30; });

var $GK7sD = parcelRequire("GK7sD");

var $1hJjY = parcelRequire("1hJjY");

var $3AZYV = parcelRequire("3AZYV");
function $ed4e04f9248d49d1$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $GK7sD.innerFrom)(input).pipe((0, $3AZYV.subscribeOn)(scheduler), (0, $1hJjY.observeOn)(scheduler));
}

});
parcelRegister("1hJjY", function(module, exports) {

$parcel$export(module.exports, "observeOn", function () { return $0efa88d0cef1ef1c$export$9007f49c319d1ac7; });

var $jELV7 = parcelRequire("jELV7");

var $5G2KO = parcelRequire("5G2KO");

var $c6TEu = parcelRequire("c6TEu");
function $0efa88d0cef1ef1c$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $5G2KO.operate)(function(source, subscriber) {
        source.subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $jELV7.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $jELV7.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $jELV7.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});

parcelRegister("3AZYV", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", function () { return $29e4d02c298fda63$export$1eb44d8f5f64733b; });

var $5G2KO = parcelRequire("5G2KO");
function $29e4d02c298fda63$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $5G2KO.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("gy3a8", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", function () { return $c0c24652e45fac94$export$fc9afd948577f0a8; });

var $GK7sD = parcelRequire("GK7sD");

var $1hJjY = parcelRequire("1hJjY");

var $3AZYV = parcelRequire("3AZYV");
function $c0c24652e45fac94$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $GK7sD.innerFrom)(input).pipe((0, $3AZYV.subscribeOn)(scheduler), (0, $1hJjY.observeOn)(scheduler));
}

});

parcelRegister("2G36l", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", function () { return $1f31e8e4e2635ece$export$b34673931371729a; });

var $gwAql = parcelRequire("gwAql");
function $1f31e8e4e2635ece$export$b34673931371729a(input, scheduler) {
    return new (0, $gwAql.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("ks7Qm", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", function () { return $ee3c81bbf04e4640$export$2b75c58ab9b5b766; });

var $gwAql = parcelRequire("gwAql");

var $17zsx = parcelRequire("17zsx");

var $lzJVf = parcelRequire("lzJVf");

var $jELV7 = parcelRequire("jELV7");
function $ee3c81bbf04e4640$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $gwAql.Observable)(function(subscriber) {
        var iterator;
        (0, $jELV7.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $17zsx.iterator]();
            (0, $jELV7.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $lzJVf.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("9zwqO", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", function () { return $6f808a21077e7e18$export$7c7f0979b56a32f3; });

var $gwAql = parcelRequire("gwAql");

var $jELV7 = parcelRequire("jELV7");
function $6f808a21077e7e18$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $gwAql.Observable)(function(subscriber) {
        (0, $jELV7.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $jELV7.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("ISQMb", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", function () { return $086ea849d14806a2$export$3385251aeecad28a; });

var $9zwqO = parcelRequire("9zwqO");

var $G23Vj = parcelRequire("G23Vj");
function $086ea849d14806a2$export$3385251aeecad28a(input, scheduler) {
    return (0, $9zwqO.scheduleAsyncIterable)((0, $G23Vj.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});





parcelRegister("czRBO", function(module, exports) {

$parcel$export(module.exports, "take", function () { return $92825682ffbbbcc8$export$b7df5d561049483a; });

var $hiMvV = parcelRequire("hiMvV");

var $5G2KO = parcelRequire("5G2KO");

var $c6TEu = parcelRequire("c6TEu");
function $92825682ffbbbcc8$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $hiMvV.EMPTY;
    } : (0, $5G2KO.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

});
parcelRegister("hiMvV", function(module, exports) {

$parcel$export(module.exports, "EMPTY", function () { return $c989bff936636c21$export$ccb33e29d92c9a58; });

var $gwAql = parcelRequire("gwAql");
var $c989bff936636c21$export$ccb33e29d92c9a58 = new (0, $gwAql.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $c989bff936636c21$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $c989bff936636c21$var$emptyScheduled(scheduler) : $c989bff936636c21$export$ccb33e29d92c9a58;
}
function $c989bff936636c21$var$emptyScheduled(scheduler) {
    return new (0, $gwAql.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});


parcelRegister("1mIQr", function(module, exports) {

$parcel$export(module.exports, "takeUntil", function () { return $0feaa1c7d18ab466$export$ac8dfd3a7ad06e80; });

var $5G2KO = parcelRequire("5G2KO");

var $c6TEu = parcelRequire("c6TEu");

var $GK7sD = parcelRequire("GK7sD");

var $i2qGl = parcelRequire("i2qGl");
function $0feaa1c7d18ab466$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $5G2KO.operate)(function(source, subscriber) {
        (0, $GK7sD.innerFrom)(notifier).subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function() {
            return subscriber.complete();
        }, (0, $i2qGl.noop)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}

});

parcelRegister("fR4Va", function(module, exports) {

$parcel$export(module.exports, "distinctUntilKeyChanged", function () { return $b8af9f74abe2dfd3$export$571da16e28367bde; });

var $i27jC = parcelRequire("i27jC");
function $b8af9f74abe2dfd3$export$571da16e28367bde(key, compare) {
    return (0, $i27jC.distinctUntilChanged)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}

});

parcelRegister("7J7ms", function(module, exports) {

$parcel$export(module.exports, "pluck", function () { return $5a02722998be0f3e$export$c44985b87d605eff; });

var $cH4fw = parcelRequire("cH4fw");
function $5a02722998be0f3e$export$c44985b87d605eff() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error("list of properties cannot be empty.");
    return (0, $cH4fw.map)(function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== "undefined") currentProp = p;
            else return undefined;
        }
        return currentProp;
    });
}

});

parcelRegister("gZfTb", function(module, exports) {

$parcel$export(module.exports, "switchMap", function () { return $033102c24cdd3091$export$9f6ea8e48bc26eab; });

var $GK7sD = parcelRequire("GK7sD");

var $5G2KO = parcelRequire("5G2KO");

var $c6TEu = parcelRequire("c6TEu");
function $033102c24cdd3091$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $5G2KO.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $GK7sD.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $c6TEu.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

});

parcelRegister("g5uH8", function(module, exports) {

$parcel$export(module.exports, "withLatestFrom", function () { return $bb64ec52c81b0911$export$d449030e5c10edf7; });

var $fxST9 = parcelRequire("fxST9");

var $5G2KO = parcelRequire("5G2KO");

var $c6TEu = parcelRequire("c6TEu");

var $GK7sD = parcelRequire("GK7sD");

var $43nmT = parcelRequire("43nmT");

var $i2qGl = parcelRequire("i2qGl");

var $3syJC = parcelRequire("3syJC");
function $bb64ec52c81b0911$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $3syJC.popResultSelector)(inputs);
    return (0, $5G2KO.operate)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $GK7sD.innerFrom)(inputs[i]).subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $43nmT.identity))) && (hasValue = null);
                }
            }, (0, $i2qGl.noop)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $c6TEu.createOperatorSubscriber)(subscriber, function(value) {
            if (ready) {
                var values = (0, $fxST9.__spreadArray)([
                    value
                ], (0, $fxST9.__read)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $fxST9.__spreadArray)([], (0, $fxST9.__read)(values))) : values);
            }
        }));
    });
}

});

parcelRegister("hRLut", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

});

parcelRegister("8VqiI", function(module, exports) {

$parcel$export(module.exports, "addMessages", function () { return $67f80c647d0b8ed9$export$e8c6a0d7313851e; });
$parcel$export(module.exports, "init", function () { return $67f80c647d0b8ed9$export$2cd8252107eb640b; });
$parcel$export(module.exports, "locale", function () { return $67f80c647d0b8ed9$export$162ce11d62a1ca51; });
$parcel$export(module.exports, "getLocaleFromNavigator", function () { return $67f80c647d0b8ed9$export$3de58040980076f2; });
$parcel$export(module.exports, "_", function () { return $67f80c647d0b8ed9$export$71511d61b312f219; });

var $9EcIH = parcelRequire("9EcIH");

var $1c87A = parcelRequire("1c87A");

var $5WNqo = parcelRequire("5WNqo");
function $67f80c647d0b8ed9$var$delve(obj, fullKey) {
    if (fullKey == null) return void 0;
    if (fullKey in obj) return obj[fullKey];
    const keys = fullKey.split(".");
    let result = obj;
    for(let p = 0; p < keys.length; p++)if (typeof result === "object") {
        if (p > 0) {
            const partialKey = keys.slice(p, keys.length).join(".");
            if (partialKey in result) {
                result = result[partialKey];
                break;
            }
        }
        result = result[keys[p]];
    } else result = void 0;
    return result;
}
const $67f80c647d0b8ed9$var$lookupCache = {};
const $67f80c647d0b8ed9$var$addToCache = (path, locale, message)=>{
    if (!message) return message;
    if (!(locale in $67f80c647d0b8ed9$var$lookupCache)) $67f80c647d0b8ed9$var$lookupCache[locale] = {};
    if (!(path in $67f80c647d0b8ed9$var$lookupCache[locale])) $67f80c647d0b8ed9$var$lookupCache[locale][path] = message;
    return message;
};
const $67f80c647d0b8ed9$var$lookup = (path, refLocale)=>{
    if (refLocale == null) return void 0;
    if (refLocale in $67f80c647d0b8ed9$var$lookupCache && path in $67f80c647d0b8ed9$var$lookupCache[refLocale]) return $67f80c647d0b8ed9$var$lookupCache[refLocale][path];
    const locales = $67f80c647d0b8ed9$var$getPossibleLocales(refLocale);
    for(let i = 0; i < locales.length; i++){
        const locale = locales[i];
        const message = $67f80c647d0b8ed9$var$getMessageFromDictionary(locale, path);
        if (message) return $67f80c647d0b8ed9$var$addToCache(path, refLocale, message);
    }
    return void 0;
};
let $67f80c647d0b8ed9$var$dictionary;
const $67f80c647d0b8ed9$export$d3757880ed390b62 = (0, $9EcIH.writable)({});
function $67f80c647d0b8ed9$var$getLocaleDictionary(locale) {
    return $67f80c647d0b8ed9$var$dictionary[locale] || null;
}
function $67f80c647d0b8ed9$var$hasLocaleDictionary(locale) {
    return locale in $67f80c647d0b8ed9$var$dictionary;
}
function $67f80c647d0b8ed9$var$getMessageFromDictionary(locale, id) {
    if (!$67f80c647d0b8ed9$var$hasLocaleDictionary(locale)) return null;
    const localeDictionary = $67f80c647d0b8ed9$var$getLocaleDictionary(locale);
    const match = $67f80c647d0b8ed9$var$delve(localeDictionary, id);
    return match;
}
function $67f80c647d0b8ed9$var$getClosestAvailableLocale(refLocale) {
    if (refLocale == null) return void 0;
    const relatedLocales = $67f80c647d0b8ed9$var$getPossibleLocales(refLocale);
    for(let i = 0; i < relatedLocales.length; i++){
        const locale = relatedLocales[i];
        if ($67f80c647d0b8ed9$var$hasLocaleDictionary(locale)) return locale;
    }
    return void 0;
}
function $67f80c647d0b8ed9$export$e8c6a0d7313851e(locale, ...partials) {
    delete $67f80c647d0b8ed9$var$lookupCache[locale];
    $67f80c647d0b8ed9$export$d3757880ed390b62.update((d)=>{
        d[locale] = (0, (/*@__PURE__*/$parcel$interopDefault($1c87A))).all([
            d[locale] || {},
            ...partials
        ]);
        return d;
    });
}
const $67f80c647d0b8ed9$export$df1c34db1371eeed = (0, $9EcIH.derived)([
    $67f80c647d0b8ed9$export$d3757880ed390b62
], ([dictionary2])=>Object.keys(dictionary2));
$67f80c647d0b8ed9$export$d3757880ed390b62.subscribe((newDictionary)=>$67f80c647d0b8ed9$var$dictionary = newDictionary);
const $67f80c647d0b8ed9$var$queue = {};
function $67f80c647d0b8ed9$var$createLocaleQueue(locale) {
    $67f80c647d0b8ed9$var$queue[locale] = /* @__PURE__ */ new Set();
}
function $67f80c647d0b8ed9$var$removeLoaderFromQueue(locale, loader) {
    $67f80c647d0b8ed9$var$queue[locale].delete(loader);
    if ($67f80c647d0b8ed9$var$queue[locale].size === 0) delete $67f80c647d0b8ed9$var$queue[locale];
}
function $67f80c647d0b8ed9$var$getLocaleQueue(locale) {
    return $67f80c647d0b8ed9$var$queue[locale];
}
function $67f80c647d0b8ed9$var$getLocalesQueues(locale) {
    return $67f80c647d0b8ed9$var$getPossibleLocales(locale).map((localeItem)=>{
        const localeQueue = $67f80c647d0b8ed9$var$getLocaleQueue(localeItem);
        return [
            localeItem,
            localeQueue ? [
                ...localeQueue
            ] : []
        ];
    }).filter(([, localeQueue])=>localeQueue.length > 0);
}
function $67f80c647d0b8ed9$var$hasLocaleQueue(locale) {
    if (locale == null) return false;
    return $67f80c647d0b8ed9$var$getPossibleLocales(locale).some((localeQueue)=>{
        var _a;
        return (_a = $67f80c647d0b8ed9$var$getLocaleQueue(localeQueue)) == null ? void 0 : _a.size;
    });
}
function $67f80c647d0b8ed9$var$loadLocaleQueue(locale, localeQueue) {
    const allLoadersPromise = Promise.all(localeQueue.map((loader)=>{
        $67f80c647d0b8ed9$var$removeLoaderFromQueue(locale, loader);
        return loader().then((partial)=>partial.default || partial);
    }));
    return allLoadersPromise.then((partials)=>$67f80c647d0b8ed9$export$e8c6a0d7313851e(locale, ...partials));
}
const $67f80c647d0b8ed9$var$activeFlushes = {};
function $67f80c647d0b8ed9$var$flush(locale) {
    if (!$67f80c647d0b8ed9$var$hasLocaleQueue(locale)) {
        if (locale in $67f80c647d0b8ed9$var$activeFlushes) return $67f80c647d0b8ed9$var$activeFlushes[locale];
        return Promise.resolve();
    }
    const queues = $67f80c647d0b8ed9$var$getLocalesQueues(locale);
    $67f80c647d0b8ed9$var$activeFlushes[locale] = Promise.all(queues.map(([localeName, localeQueue])=>$67f80c647d0b8ed9$var$loadLocaleQueue(localeName, localeQueue))).then(()=>{
        if ($67f80c647d0b8ed9$var$hasLocaleQueue(locale)) return $67f80c647d0b8ed9$var$flush(locale);
        delete $67f80c647d0b8ed9$var$activeFlushes[locale];
    });
    return $67f80c647d0b8ed9$var$activeFlushes[locale];
}
function $67f80c647d0b8ed9$export$6503ec6e8aabbaf(locale, loader) {
    if (!$67f80c647d0b8ed9$var$getLocaleQueue(locale)) $67f80c647d0b8ed9$var$createLocaleQueue(locale);
    const localeQueue = $67f80c647d0b8ed9$var$getLocaleQueue(locale);
    if ($67f80c647d0b8ed9$var$getLocaleQueue(locale).has(loader)) return;
    if (!$67f80c647d0b8ed9$var$hasLocaleDictionary(locale)) $67f80c647d0b8ed9$export$d3757880ed390b62.update((d)=>{
        d[locale] = {};
        return d;
    });
    localeQueue.add(loader);
}
var $67f80c647d0b8ed9$var$__getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var $67f80c647d0b8ed9$var$__hasOwnProp$2 = Object.prototype.hasOwnProperty;
var $67f80c647d0b8ed9$var$__propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var $67f80c647d0b8ed9$var$__objRest$1 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($67f80c647d0b8ed9$var$__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $67f80c647d0b8ed9$var$__getOwnPropSymbols$2) {
        for (var prop of $67f80c647d0b8ed9$var$__getOwnPropSymbols$2(source))if (exclude.indexOf(prop) < 0 && $67f80c647d0b8ed9$var$__propIsEnum$2.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $67f80c647d0b8ed9$var$defaultFormats = {
    number: {
        scientific: {
            notation: "scientific"
        },
        engineering: {
            notation: "engineering"
        },
        compactLong: {
            notation: "compact",
            compactDisplay: "long"
        },
        compactShort: {
            notation: "compact",
            compactDisplay: "short"
        }
    },
    date: {
        short: {
            month: "numeric",
            day: "numeric",
            year: "2-digit"
        },
        medium: {
            month: "short",
            day: "numeric",
            year: "numeric"
        },
        long: {
            month: "long",
            day: "numeric",
            year: "numeric"
        },
        full: {
            weekday: "long",
            month: "long",
            day: "numeric",
            year: "numeric"
        }
    },
    time: {
        short: {
            hour: "numeric",
            minute: "numeric"
        },
        medium: {
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        },
        long: {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            timeZoneName: "short"
        },
        full: {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            timeZoneName: "short"
        }
    }
};
function $67f80c647d0b8ed9$var$defaultMissingKeyHandler({ locale: locale, id: id }) {
    console.warn(`[svelte-i18n] The message "${id}" was not found in "${$67f80c647d0b8ed9$var$getPossibleLocales(locale).join('", "')}".${$67f80c647d0b8ed9$var$hasLocaleQueue($67f80c647d0b8ed9$var$getCurrentLocale()) ? `

Note: there are at least one loader still registered to this locale that wasn't executed.` : ""}`);
}
const $67f80c647d0b8ed9$var$defaultOptions = {
    fallbackLocale: null,
    loadingDelay: 200,
    formats: $67f80c647d0b8ed9$var$defaultFormats,
    warnOnMissingMessages: true,
    handleMissingMessage: void 0,
    ignoreTag: true
};
const $67f80c647d0b8ed9$var$options = $67f80c647d0b8ed9$var$defaultOptions;
function $67f80c647d0b8ed9$var$getOptions() {
    return $67f80c647d0b8ed9$var$options;
}
function $67f80c647d0b8ed9$export$2cd8252107eb640b(opts) {
    const _a = opts, { formats: formats } = _a, rest = $67f80c647d0b8ed9$var$__objRest$1(_a, [
        "formats"
    ]);
    let initialLocale = opts.fallbackLocale;
    if (opts.initialLocale) try {
        if ((0, $5WNqo.IntlMessageFormat).resolveLocale(opts.initialLocale)) initialLocale = opts.initialLocale;
    } catch (e) {
        console.warn(`[svelte-i18n] The initial locale "${opts.initialLocale}" is not a valid locale.`);
    }
    if (rest.warnOnMissingMessages) {
        delete rest.warnOnMissingMessages;
        if (rest.handleMissingMessage == null) rest.handleMissingMessage = $67f80c647d0b8ed9$var$defaultMissingKeyHandler;
        else console.warn('[svelte-i18n] The "warnOnMissingMessages" option is deprecated. Please use the "handleMissingMessage" option instead.');
    }
    Object.assign($67f80c647d0b8ed9$var$options, rest, {
        initialLocale: initialLocale
    });
    if (formats) {
        if ("number" in formats) Object.assign($67f80c647d0b8ed9$var$options.formats.number, formats.number);
        if ("date" in formats) Object.assign($67f80c647d0b8ed9$var$options.formats.date, formats.date);
        if ("time" in formats) Object.assign($67f80c647d0b8ed9$var$options.formats.time, formats.time);
    }
    return $67f80c647d0b8ed9$export$162ce11d62a1ca51.set(initialLocale);
}
const $67f80c647d0b8ed9$export$20bb0d907fbbe433 = (0, $9EcIH.writable)(false);
var $67f80c647d0b8ed9$var$__defProp$1 = Object.defineProperty;
var $67f80c647d0b8ed9$var$__defProps = Object.defineProperties;
var $67f80c647d0b8ed9$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $67f80c647d0b8ed9$var$__getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var $67f80c647d0b8ed9$var$__hasOwnProp$1 = Object.prototype.hasOwnProperty;
var $67f80c647d0b8ed9$var$__propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var $67f80c647d0b8ed9$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $67f80c647d0b8ed9$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $67f80c647d0b8ed9$var$__spreadValues$1 = (a, b)=>{
    for(var prop in b || (b = {}))if ($67f80c647d0b8ed9$var$__hasOwnProp$1.call(b, prop)) $67f80c647d0b8ed9$var$__defNormalProp$1(a, prop, b[prop]);
    if ($67f80c647d0b8ed9$var$__getOwnPropSymbols$1) {
        for (var prop of $67f80c647d0b8ed9$var$__getOwnPropSymbols$1(b))if ($67f80c647d0b8ed9$var$__propIsEnum$1.call(b, prop)) $67f80c647d0b8ed9$var$__defNormalProp$1(a, prop, b[prop]);
    }
    return a;
};
var $67f80c647d0b8ed9$var$__spreadProps = (a, b)=>$67f80c647d0b8ed9$var$__defProps(a, $67f80c647d0b8ed9$var$__getOwnPropDescs(b));
let $67f80c647d0b8ed9$var$current;
const $67f80c647d0b8ed9$var$internalLocale = (0, $9EcIH.writable)(null);
function $67f80c647d0b8ed9$var$getSubLocales(refLocale) {
    return refLocale.split("-").map((_, i, arr)=>arr.slice(0, i + 1).join("-")).reverse();
}
function $67f80c647d0b8ed9$var$getPossibleLocales(refLocale, fallbackLocale = $67f80c647d0b8ed9$var$getOptions().fallbackLocale) {
    const locales = $67f80c647d0b8ed9$var$getSubLocales(refLocale);
    if (fallbackLocale) return [
        .../* @__PURE__ */ new Set([
            ...locales,
            ...$67f80c647d0b8ed9$var$getSubLocales(fallbackLocale)
        ])
    ];
    return locales;
}
function $67f80c647d0b8ed9$var$getCurrentLocale() {
    return $67f80c647d0b8ed9$var$current != null ? $67f80c647d0b8ed9$var$current : void 0;
}
$67f80c647d0b8ed9$var$internalLocale.subscribe((newLocale)=>{
    $67f80c647d0b8ed9$var$current = newLocale != null ? newLocale : void 0;
    if (typeof window !== "undefined" && newLocale != null) document.documentElement.setAttribute("lang", newLocale);
});
const $67f80c647d0b8ed9$var$set = (newLocale)=>{
    if (newLocale && $67f80c647d0b8ed9$var$getClosestAvailableLocale(newLocale) && $67f80c647d0b8ed9$var$hasLocaleQueue(newLocale)) {
        const { loadingDelay: loadingDelay } = $67f80c647d0b8ed9$var$getOptions();
        let loadingTimer;
        if (typeof window !== "undefined" && $67f80c647d0b8ed9$var$getCurrentLocale() != null && loadingDelay) loadingTimer = window.setTimeout(()=>$67f80c647d0b8ed9$export$20bb0d907fbbe433.set(true), loadingDelay);
        else $67f80c647d0b8ed9$export$20bb0d907fbbe433.set(true);
        return $67f80c647d0b8ed9$var$flush(newLocale).then(()=>{
            $67f80c647d0b8ed9$var$internalLocale.set(newLocale);
        }).finally(()=>{
            clearTimeout(loadingTimer);
            $67f80c647d0b8ed9$export$20bb0d907fbbe433.set(false);
        });
    }
    return $67f80c647d0b8ed9$var$internalLocale.set(newLocale);
};
const $67f80c647d0b8ed9$export$162ce11d62a1ca51 = $67f80c647d0b8ed9$var$__spreadProps($67f80c647d0b8ed9$var$__spreadValues$1({}, $67f80c647d0b8ed9$var$internalLocale), {
    set: $67f80c647d0b8ed9$var$set
});
const $67f80c647d0b8ed9$var$getFromQueryString = (queryString, key)=>{
    const keyVal = queryString.split("&").find((i)=>i.indexOf(`${key}=`) === 0);
    if (keyVal) return keyVal.split("=").pop();
    return null;
};
const $67f80c647d0b8ed9$var$getFirstMatch = (base, pattern)=>{
    const match = pattern.exec(base);
    if (!match) return null;
    return match[1] || null;
};
const $67f80c647d0b8ed9$export$4b645ee0c03e8679 = (hostname)=>{
    if (typeof window === "undefined") return null;
    return $67f80c647d0b8ed9$var$getFirstMatch(window.location.hostname, hostname);
};
const $67f80c647d0b8ed9$export$7d7c6a2d1731fd0c = (pathname)=>{
    if (typeof window === "undefined") return null;
    return $67f80c647d0b8ed9$var$getFirstMatch(window.location.pathname, pathname);
};
const $67f80c647d0b8ed9$export$3de58040980076f2 = ()=>{
    if (typeof window === "undefined") return null;
    return window.navigator.language || window.navigator.languages[0];
};
const $67f80c647d0b8ed9$export$ec45b8ee346340d7 = (search)=>{
    if (typeof window === "undefined") return null;
    return $67f80c647d0b8ed9$var$getFromQueryString(window.location.search.substr(1), search);
};
const $67f80c647d0b8ed9$export$c75599b9cea22398 = (hash)=>{
    if (typeof window === "undefined") return null;
    return $67f80c647d0b8ed9$var$getFromQueryString(window.location.hash.substr(1), hash);
};
const $67f80c647d0b8ed9$var$monadicMemoize = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    const memoizedFn = (arg)=>{
        const cacheKey = JSON.stringify(arg);
        if (cacheKey in cache) return cache[cacheKey];
        return cache[cacheKey] = fn(arg);
    };
    return memoizedFn;
};
var $67f80c647d0b8ed9$var$__defProp = Object.defineProperty;
var $67f80c647d0b8ed9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $67f80c647d0b8ed9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $67f80c647d0b8ed9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $67f80c647d0b8ed9$var$__defNormalProp = (obj, key, value)=>key in obj ? $67f80c647d0b8ed9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $67f80c647d0b8ed9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($67f80c647d0b8ed9$var$__hasOwnProp.call(b, prop)) $67f80c647d0b8ed9$var$__defNormalProp(a, prop, b[prop]);
    if ($67f80c647d0b8ed9$var$__getOwnPropSymbols) {
        for (var prop of $67f80c647d0b8ed9$var$__getOwnPropSymbols(b))if ($67f80c647d0b8ed9$var$__propIsEnum.call(b, prop)) $67f80c647d0b8ed9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $67f80c647d0b8ed9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($67f80c647d0b8ed9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $67f80c647d0b8ed9$var$__getOwnPropSymbols) {
        for (var prop of $67f80c647d0b8ed9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $67f80c647d0b8ed9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $67f80c647d0b8ed9$var$getIntlFormatterOptions = (type, name)=>{
    const { formats: formats } = $67f80c647d0b8ed9$var$getOptions();
    if (type in formats && name in formats[type]) return formats[type][name];
    throw new Error(`[svelte-i18n] Unknown "${name}" ${type} format.`);
};
const $67f80c647d0b8ed9$var$createNumberFormatter = $67f80c647d0b8ed9$var$monadicMemoize((_a)=>{
    var _b = _a, { locale: locale, format: format } = _b, options = $67f80c647d0b8ed9$var$__objRest(_b, [
        "locale",
        "format"
    ]);
    if (locale == null) throw new Error('[svelte-i18n] A "locale" must be set to format numbers');
    if (format) options = $67f80c647d0b8ed9$var$getIntlFormatterOptions("number", format);
    return new Intl.NumberFormat(locale, options);
});
const $67f80c647d0b8ed9$var$createDateFormatter = $67f80c647d0b8ed9$var$monadicMemoize((_c)=>{
    var _d = _c, { locale: locale, format: format } = _d, options = $67f80c647d0b8ed9$var$__objRest(_d, [
        "locale",
        "format"
    ]);
    if (locale == null) throw new Error('[svelte-i18n] A "locale" must be set to format dates');
    if (format) options = $67f80c647d0b8ed9$var$getIntlFormatterOptions("date", format);
    else if (Object.keys(options).length === 0) options = $67f80c647d0b8ed9$var$getIntlFormatterOptions("date", "short");
    return new Intl.DateTimeFormat(locale, options);
});
const $67f80c647d0b8ed9$var$createTimeFormatter = $67f80c647d0b8ed9$var$monadicMemoize((_e)=>{
    var _f = _e, { locale: locale, format: format } = _f, options = $67f80c647d0b8ed9$var$__objRest(_f, [
        "locale",
        "format"
    ]);
    if (locale == null) throw new Error('[svelte-i18n] A "locale" must be set to format time values');
    if (format) options = $67f80c647d0b8ed9$var$getIntlFormatterOptions("time", format);
    else if (Object.keys(options).length === 0) options = $67f80c647d0b8ed9$var$getIntlFormatterOptions("time", "short");
    return new Intl.DateTimeFormat(locale, options);
});
const $67f80c647d0b8ed9$export$c2604861dc73a731 = (_g = {})=>{
    var _h = _g, { locale: locale = $67f80c647d0b8ed9$var$getCurrentLocale() } = _h, args = $67f80c647d0b8ed9$var$__objRest(_h, [
        "locale"
    ]);
    return $67f80c647d0b8ed9$var$createNumberFormatter($67f80c647d0b8ed9$var$__spreadValues({
        locale: locale
    }, args));
};
const $67f80c647d0b8ed9$export$dec541045008c8e3 = (_i = {})=>{
    var _j = _i, { locale: locale = $67f80c647d0b8ed9$var$getCurrentLocale() } = _j, args = $67f80c647d0b8ed9$var$__objRest(_j, [
        "locale"
    ]);
    return $67f80c647d0b8ed9$var$createDateFormatter($67f80c647d0b8ed9$var$__spreadValues({
        locale: locale
    }, args));
};
const $67f80c647d0b8ed9$export$55180a88c41165a1 = (_k = {})=>{
    var _l = _k, { locale: locale = $67f80c647d0b8ed9$var$getCurrentLocale() } = _l, args = $67f80c647d0b8ed9$var$__objRest(_l, [
        "locale"
    ]);
    return $67f80c647d0b8ed9$var$createTimeFormatter($67f80c647d0b8ed9$var$__spreadValues({
        locale: locale
    }, args));
};
const $67f80c647d0b8ed9$export$3b8be924e637e17c = $67f80c647d0b8ed9$var$monadicMemoize(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(message, locale = $67f80c647d0b8ed9$var$getCurrentLocale())=>new (0, $5WNqo.IntlMessageFormat)(message, locale, $67f80c647d0b8ed9$var$getOptions().formats, {
        ignoreTag: $67f80c647d0b8ed9$var$getOptions().ignoreTag
    }));
const $67f80c647d0b8ed9$var$formatMessage = (id, options = {})=>{
    var _a, _b, _c, _d;
    let messageObj = options;
    if (typeof id === "object") {
        messageObj = id;
        id = messageObj.id;
    }
    const { values: values, locale: locale = $67f80c647d0b8ed9$var$getCurrentLocale(), default: defaultValue } = messageObj;
    if (locale == null) throw new Error("[svelte-i18n] Cannot format a message without first setting the initial locale.");
    let message = $67f80c647d0b8ed9$var$lookup(id, locale);
    if (!message) message = (_d = (_c = (_b = (_a = $67f80c647d0b8ed9$var$getOptions()).handleMissingMessage) == null ? void 0 : _b.call(_a, {
        locale: locale,
        id: id,
        defaultValue: defaultValue
    })) != null ? _c : defaultValue) != null ? _d : id;
    else if (typeof message !== "string") {
        console.warn(`[svelte-i18n] Message with id "${id}" must be of type "string", found: "${typeof message}". Gettin its value through the "$format" method is deprecated; use the "json" method instead.`);
        return message;
    }
    if (!values) return message;
    let result = message;
    try {
        result = $67f80c647d0b8ed9$export$3b8be924e637e17c(message, locale).format(values);
    } catch (e) {
        if (e instanceof Error) console.warn(`[svelte-i18n] Message "${id}" has syntax error:`, e.message);
    }
    return result;
};
const $67f80c647d0b8ed9$var$formatTime = (t, options)=>{
    return $67f80c647d0b8ed9$export$55180a88c41165a1(options).format(t);
};
const $67f80c647d0b8ed9$var$formatDate = (d, options)=>{
    return $67f80c647d0b8ed9$export$dec541045008c8e3(options).format(d);
};
const $67f80c647d0b8ed9$var$formatNumber = (n, options)=>{
    return $67f80c647d0b8ed9$export$c2604861dc73a731(options).format(n);
};
const $67f80c647d0b8ed9$var$getJSON = (id, locale = $67f80c647d0b8ed9$var$getCurrentLocale())=>{
    return $67f80c647d0b8ed9$var$lookup(id, locale);
};
const $67f80c647d0b8ed9$export$71511d61b312f219 = (0, $9EcIH.derived)([
    $67f80c647d0b8ed9$export$162ce11d62a1ca51,
    $67f80c647d0b8ed9$export$d3757880ed390b62
], ()=>$67f80c647d0b8ed9$var$formatMessage);
const $67f80c647d0b8ed9$export$2da9be4cfdb689b1 = (0, $9EcIH.derived)([
    $67f80c647d0b8ed9$export$162ce11d62a1ca51
], ()=>$67f80c647d0b8ed9$var$formatTime);
const $67f80c647d0b8ed9$export$324d90190a8b822a = (0, $9EcIH.derived)([
    $67f80c647d0b8ed9$export$162ce11d62a1ca51
], ()=>$67f80c647d0b8ed9$var$formatDate);
const $67f80c647d0b8ed9$export$98e628dec113755e = (0, $9EcIH.derived)([
    $67f80c647d0b8ed9$export$162ce11d62a1ca51
], ()=>$67f80c647d0b8ed9$var$formatNumber);
const $67f80c647d0b8ed9$export$7b419323e6ed4f31 = (0, $9EcIH.derived)([
    $67f80c647d0b8ed9$export$162ce11d62a1ca51,
    $67f80c647d0b8ed9$export$d3757880ed390b62
], ()=>$67f80c647d0b8ed9$var$getJSON);
function $67f80c647d0b8ed9$export$aa8691a29e6f19c5(store) {
    let localReference;
    const cancel = store.subscribe((value)=>localReference = value);
    const fn = (...args)=>localReference(...args);
    fn.freeze = cancel;
    return fn;
}
function $67f80c647d0b8ed9$export$1adfeb024f5185b(i) {
    return i;
}
function $67f80c647d0b8ed9$export$9d812b4fe93f6cb6(locale) {
    return $67f80c647d0b8ed9$var$flush(locale || $67f80c647d0b8ed9$var$getCurrentLocale() || $67f80c647d0b8ed9$var$getOptions().initialLocale);
}

});
parcelRegister("9EcIH", function(module, exports) {

$parcel$export(module.exports, "writable", function () { return $5370c30af05000fc$export$e6d3eada50a007b1; });
$parcel$export(module.exports, "derived", function () { return $5370c30af05000fc$export$90b0b54dab0a340a; });
$parcel$export(module.exports, "get", function () { return (parcelRequire("4wDz6")).get_store_value; });

var $4wDz6 = parcelRequire("4wDz6");
const $5370c30af05000fc$var$subscriber_queue = [];
/**
 * Creates a `Readable` store that allows reading by subscription.
 * @param value initial value
 * @param {StartStopNotifier} [start]
 */ function $5370c30af05000fc$export$1e3fc3ecfda8b1c3(value, start) {
    return {
        subscribe: $5370c30af05000fc$export$e6d3eada50a007b1(value, start).subscribe
    };
}
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=} start
 */ function $5370c30af05000fc$export$e6d3eada50a007b1(value, start = (0, $4wDz6.noop)) {
    let stop;
    const subscribers = new Set();
    function set(new_value) {
        if ((0, $4wDz6.safe_not_equal)(value, new_value)) {
            value = new_value;
            if (stop) {
                const run_queue = !$5370c30af05000fc$var$subscriber_queue.length;
                for (const subscriber of subscribers){
                    subscriber[1]();
                    $5370c30af05000fc$var$subscriber_queue.push(subscriber, value);
                }
                if (run_queue) {
                    for(let i = 0; i < $5370c30af05000fc$var$subscriber_queue.length; i += 2)$5370c30af05000fc$var$subscriber_queue[i][0]($5370c30af05000fc$var$subscriber_queue[i + 1]);
                    $5370c30af05000fc$var$subscriber_queue.length = 0;
                }
            }
        }
    }
    function update(fn) {
        set(fn(value));
    }
    function subscribe(run, invalidate = (0, $4wDz6.noop)) {
        const subscriber = [
            run,
            invalidate
        ];
        subscribers.add(subscriber);
        if (subscribers.size === 1) stop = start(set) || (0, $4wDz6.noop);
        run(value);
        return ()=>{
            subscribers.delete(subscriber);
            if (subscribers.size === 0 && stop) {
                stop();
                stop = null;
            }
        };
    }
    return {
        set: set,
        update: update,
        subscribe: subscribe
    };
}
function $5370c30af05000fc$export$90b0b54dab0a340a(stores, fn, initial_value) {
    const single = !Array.isArray(stores);
    const stores_array = single ? [
        stores
    ] : stores;
    const auto = fn.length < 2;
    return $5370c30af05000fc$export$1e3fc3ecfda8b1c3(initial_value, (set)=>{
        let started = false;
        const values = [];
        let pending = 0;
        let cleanup = (0, $4wDz6.noop);
        const sync = ()=>{
            if (pending) return;
            cleanup();
            const result = fn(single ? values[0] : values, set);
            if (auto) set(result);
            else cleanup = (0, $4wDz6.is_function)(result) ? result : (0, $4wDz6.noop);
        };
        const unsubscribers = stores_array.map((store, i)=>(0, $4wDz6.subscribe)(store, (value)=>{
                values[i] = value;
                pending &= ~(1 << i);
                if (started) sync();
            }, ()=>{
                pending |= 1 << i;
            }));
        started = true;
        sync();
        return function stop() {
            (0, $4wDz6.run_all)(unsubscribers);
            cleanup();
            // We need to set this to false because callbacks can still happen despite having unsubscribed:
            // Callbacks might already be placed in the queue which doesn't know it should no longer
            // invoke this derived store.
            started = false;
        };
    });
}
/**
 * Takes a store and returns a new one derived from the old one that is readable.
 *
 * @param store - store to make readonly
 */ function $5370c30af05000fc$export$6ec456bd5b7b3c51(store) {
    return {
        subscribe: store.subscribe.bind(store)
    };
}

});
parcelRegister("4wDz6", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $26671684de8882a2$export$8793edee2d425525; });
$parcel$export(module.exports, "run_all", function () { return $26671684de8882a2$export$3f1fcd837f99a9ab; });
$parcel$export(module.exports, "is_function", function () { return $26671684de8882a2$export$b451353ebd749597; });
$parcel$export(module.exports, "safe_not_equal", function () { return $26671684de8882a2$export$170eaf694b129a16; });
$parcel$export(module.exports, "subscribe", function () { return $26671684de8882a2$export$ec068583843480e7; });
$parcel$export(module.exports, "get_store_value", function () { return $26671684de8882a2$export$def9168ec19d7707; });
function $26671684de8882a2$export$8793edee2d425525() {}
const $26671684de8882a2$export$f0954fd7d5368655 = (x)=>x;
function $26671684de8882a2$export$e6e34fd1f2686227(tar, src) {
    // @ts-ignore
    for(const k in src)tar[k] = src[k];
    return tar;
}
// Adapted from https://github.com/then/is-promise/blob/master/index.js
// Distributed under MIT License https://github.com/then/is-promise/blob/master/LICENSE
function $26671684de8882a2$export$7666b03abe8479da(value) {
    return !!value && (typeof value === "object" || typeof value === "function") && typeof value.then === "function";
}
function $26671684de8882a2$export$8d162c0ddfac72(element, file, line, column, char) {
    element.__svelte_meta = {
        loc: {
            file: file,
            line: line,
            column: column,
            char: char
        }
    };
}
function $26671684de8882a2$export$889ea624f2cb2c57(fn) {
    return fn();
}
function $26671684de8882a2$export$31092919e374e43c() {
    return Object.create(null);
}
function $26671684de8882a2$export$3f1fcd837f99a9ab(fns) {
    fns.forEach($26671684de8882a2$export$889ea624f2cb2c57);
}
function $26671684de8882a2$export$b451353ebd749597(thing) {
    return typeof thing === "function";
}
function $26671684de8882a2$export$170eaf694b129a16(a, b) {
    return a != a ? b == b : a !== b || a && typeof a === "object" || typeof a === "function";
}
let $26671684de8882a2$var$src_url_equal_anchor;
function $26671684de8882a2$export$49b3f9828235af7b(element_src, url) {
    if (!$26671684de8882a2$var$src_url_equal_anchor) $26671684de8882a2$var$src_url_equal_anchor = document.createElement("a");
    $26671684de8882a2$var$src_url_equal_anchor.href = url;
    return element_src === $26671684de8882a2$var$src_url_equal_anchor.href;
}
function $26671684de8882a2$export$22fbbf144bff5d00(a, b) {
    return a != a ? b == b : a !== b;
}
function $26671684de8882a2$export$cc2e736493e359e2(obj) {
    return Object.keys(obj).length === 0;
}
function $26671684de8882a2$export$e3d0b9f4796b296b(store, name) {
    if (store != null && typeof store.subscribe !== "function") throw new Error(`'${name}' is not a store with a 'subscribe' method`);
}
function $26671684de8882a2$export$ec068583843480e7(store, ...callbacks) {
    if (store == null) return $26671684de8882a2$export$8793edee2d425525;
    const unsub = store.subscribe(...callbacks);
    return unsub.unsubscribe ? ()=>unsub.unsubscribe() : unsub;
}
function $26671684de8882a2$export$def9168ec19d7707(store) {
    let value;
    $26671684de8882a2$export$ec068583843480e7(store, (_)=>value = _)();
    return value;
}
function $26671684de8882a2$export$e9b69a2eee9b6cbe(component, store, callback) {
    component.$$.on_destroy.push($26671684de8882a2$export$ec068583843480e7(store, callback));
}
function $26671684de8882a2$export$2d30ef90c9114b44(definition, ctx, $$scope, fn) {
    if (definition) {
        const slot_ctx = $26671684de8882a2$var$get_slot_context(definition, ctx, $$scope, fn);
        return definition[0](slot_ctx);
    }
}
function $26671684de8882a2$var$get_slot_context(definition, ctx, $$scope, fn) {
    return definition[1] && fn ? $26671684de8882a2$export$e6e34fd1f2686227($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}
function $26671684de8882a2$export$37743db7f61eb37b(definition, $$scope, dirty, fn) {
    if (definition[2] && fn) {
        const lets = definition[2](fn(dirty));
        if ($$scope.dirty === undefined) return lets;
        if (typeof lets === "object") {
            const merged = [];
            const len = Math.max($$scope.dirty.length, lets.length);
            for(let i = 0; i < len; i += 1)merged[i] = $$scope.dirty[i] | lets[i];
            return merged;
        }
        return $$scope.dirty | lets;
    }
    return $$scope.dirty;
}
function $26671684de8882a2$export$320f2dc7816567d9(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
    if (slot_changes) {
        const slot_context = $26671684de8882a2$var$get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
        slot.p(slot_context, slot_changes);
    }
}
function $26671684de8882a2$export$6f5c611fd589b77(slot, slot_definition, ctx, $$scope, dirty, get_slot_changes_fn, get_slot_context_fn) {
    const slot_changes = $26671684de8882a2$export$37743db7f61eb37b(slot_definition, $$scope, dirty, get_slot_changes_fn);
    $26671684de8882a2$export$320f2dc7816567d9(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn);
}
function $26671684de8882a2$export$a15c6a804dce25b7($$scope) {
    if ($$scope.ctx.length > 32) {
        const dirty = [];
        const length = $$scope.ctx.length / 32;
        for(let i = 0; i < length; i++)dirty[i] = -1;
        return dirty;
    }
    return -1;
}
function $26671684de8882a2$export$1b59c714eb8e4c9f(props) {
    const result = {};
    for(const k in props)if (k[0] !== "$") result[k] = props[k];
    return result;
}
function $26671684de8882a2$export$3086903c15858881(props, keys) {
    const rest = {};
    keys = new Set(keys);
    for(const k in props)if (!keys.has(k) && k[0] !== "$") rest[k] = props[k];
    return rest;
}
function $26671684de8882a2$export$3001519f1cb535ea(slots) {
    const result = {};
    for(const key in slots)result[key] = true;
    return result;
}
function $26671684de8882a2$export$d2de3aaeafa91619(fn) {
    let ran = false;
    return function(...args) {
        if (ran) return;
        ran = true;
        fn.call(this, ...args);
    };
}
function $26671684de8882a2$export$1a9d7733e079fbfa(value) {
    return value == null ? "" : value;
}
function $26671684de8882a2$export$ef3da5b70290de1(store, ret, value) {
    store.set(value);
    return ret;
}
const $26671684de8882a2$export$90ea246e00657977 = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
function $26671684de8882a2$export$44ef7a4ea2170a07(action_result) {
    return action_result && $26671684de8882a2$export$b451353ebd749597(action_result.destroy) ? action_result.destroy : $26671684de8882a2$export$8793edee2d425525;
}
function $26671684de8882a2$export$fde6ca7e0b92f8ff(value) {
    const split = typeof value === "string" && value.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
    return split ? [
        parseFloat(split[1]),
        split[2] || "px"
    ] : [
        value,
        "px"
    ];
}
const $26671684de8882a2$export$e3d839ffa95f7481 = [
    "",
    true,
    1,
    "true",
    "contenteditable"
];
const $26671684de8882a2$export$63e5d6c42bc01b79 = typeof window !== "undefined";
let $26671684de8882a2$export$461939dd4422153 = $26671684de8882a2$export$63e5d6c42bc01b79 ? ()=>window.performance.now() : ()=>Date.now();
let $26671684de8882a2$export$27f233d61a9e2fa4 = $26671684de8882a2$export$63e5d6c42bc01b79 ? (cb)=>requestAnimationFrame(cb) : $26671684de8882a2$export$8793edee2d425525;
// used internally for testing
function $26671684de8882a2$export$50265a0ed747f6de(fn) {
    $26671684de8882a2$export$461939dd4422153 = fn;
}
function $26671684de8882a2$export$43be9c1bea1fd56(fn) {
    $26671684de8882a2$export$27f233d61a9e2fa4 = fn;
}
const $26671684de8882a2$var$tasks = new Set();
function $26671684de8882a2$var$run_tasks(now) {
    $26671684de8882a2$var$tasks.forEach((task)=>{
        if (!task.c(now)) {
            $26671684de8882a2$var$tasks.delete(task);
            task.f();
        }
    });
    if ($26671684de8882a2$var$tasks.size !== 0) $26671684de8882a2$export$27f233d61a9e2fa4($26671684de8882a2$var$run_tasks);
}
/**
 * For testing purposes only!
 */ function $26671684de8882a2$export$36ce6b87b73ae3() {
    $26671684de8882a2$var$tasks.clear();
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */ function $26671684de8882a2$export$f9ef67375ddc185(callback) {
    let task;
    if ($26671684de8882a2$var$tasks.size === 0) $26671684de8882a2$export$27f233d61a9e2fa4($26671684de8882a2$var$run_tasks);
    return {
        promise: new Promise((fulfill)=>{
            $26671684de8882a2$var$tasks.add(task = {
                c: callback,
                f: fulfill
            });
        }),
        abort () {
            $26671684de8882a2$var$tasks.delete(task);
        }
    };
}
const $26671684de8882a2$export$816be348776d53c1 = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : $parcel$global;
/**
 * Resize observer singleton.
 * One listener per element only!
 * https://groups.google.com/a/chromium.org/g/blink-dev/c/z6ienONUb5A/m/F5-VcUZtBAAJ
 */ class $26671684de8882a2$export$cd966d69202271fb {
    constructor(options){
        this.options = options;
        this._listeners = "WeakMap" in $26671684de8882a2$export$816be348776d53c1 ? new WeakMap() : undefined;
    }
    observe(element, listener) {
        this._listeners.set(element, listener);
        this._getObserver().observe(element, this.options);
        return ()=>{
            this._listeners.delete(element);
            this._observer.unobserve(element); // this line can probably be removed
        };
    }
    _getObserver() {
        var _a;
        return (_a = this._observer) !== null && _a !== void 0 ? _a : this._observer = new ResizeObserver((entries)=>{
            var _a;
            for (const entry of entries){
                $26671684de8882a2$export$cd966d69202271fb.entries.set(entry.target, entry);
                (_a = this._listeners.get(entry.target)) === null || _a === void 0 || _a(entry);
            }
        });
    }
}
// Needs to be written like this to pass the tree-shake-test
$26671684de8882a2$export$cd966d69202271fb.entries = "WeakMap" in $26671684de8882a2$export$816be348776d53c1 ? new WeakMap() : undefined;
// Track which nodes are claimed during hydration. Unclaimed nodes can then be removed from the DOM
// at the end of hydration without touching the remaining nodes.
let $26671684de8882a2$var$is_hydrating = false;
function $26671684de8882a2$export$237ef195d41ae60c() {
    $26671684de8882a2$var$is_hydrating = true;
}
function $26671684de8882a2$export$4b42d81e6a3b0cd2() {
    $26671684de8882a2$var$is_hydrating = false;
}
function $26671684de8882a2$var$upper_bound(low, high, key, value) {
    // Return first index of value larger than input value in the range [low, high)
    while(low < high){
        const mid = low + (high - low >> 1);
        if (key(mid) <= value) low = mid + 1;
        else high = mid;
    }
    return low;
}
function $26671684de8882a2$var$init_hydrate(target) {
    if (target.hydrate_init) return;
    target.hydrate_init = true;
    // We know that all children have claim_order values since the unclaimed have been detached if target is not <head>
    let children = target.childNodes;
    // If target is <head>, there may be children without claim_order
    if (target.nodeName === "HEAD") {
        const myChildren = [];
        for(let i = 0; i < children.length; i++){
            const node = children[i];
            if (node.claim_order !== undefined) myChildren.push(node);
        }
        children = myChildren;
    }
    /*
    * Reorder claimed children optimally.
    * We can reorder claimed children optimally by finding the longest subsequence of
    * nodes that are already claimed in order and only moving the rest. The longest
    * subsequence of nodes that are claimed in order can be found by
    * computing the longest increasing subsequence of .claim_order values.
    *
    * This algorithm is optimal in generating the least amount of reorder operations
    * possible.
    *
    * Proof:
    * We know that, given a set of reordering operations, the nodes that do not move
    * always form an increasing subsequence, since they do not move among each other
    * meaning that they must be already ordered among each other. Thus, the maximal
    * set of nodes that do not move form a longest increasing subsequence.
    */ // Compute longest increasing subsequence
    // m: subsequence length j => index k of smallest value that ends an increasing subsequence of length j
    const m = new Int32Array(children.length + 1);
    // Predecessor indices + 1
    const p = new Int32Array(children.length);
    m[0] = -1;
    let longest = 0;
    for(let i = 0; i < children.length; i++){
        const current = children[i].claim_order;
        // Find the largest subsequence length such that it ends in a value less than our current value
        // upper_bound returns first greater value, so we subtract one
        // with fast path for when we are on the current longest subsequence
        const seqLen = (longest > 0 && children[m[longest]].claim_order <= current ? longest + 1 : $26671684de8882a2$var$upper_bound(1, longest, (idx)=>children[m[idx]].claim_order, current)) - 1;
        p[i] = m[seqLen] + 1;
        const newLen = seqLen + 1;
        // We can guarantee that current is the smallest value. Otherwise, we would have generated a longer sequence.
        m[newLen] = i;
        longest = Math.max(newLen, longest);
    }
    // The longest increasing subsequence of nodes (initially reversed)
    const lis = [];
    // The rest of the nodes, nodes that will be moved
    const toMove = [];
    let last = children.length - 1;
    for(let cur = m[longest] + 1; cur != 0; cur = p[cur - 1]){
        lis.push(children[cur - 1]);
        for(; last >= cur; last--)toMove.push(children[last]);
        last--;
    }
    for(; last >= 0; last--)toMove.push(children[last]);
    lis.reverse();
    // We sort the nodes being moved to guarantee that their insertion order matches the claim order
    toMove.sort((a, b)=>a.claim_order - b.claim_order);
    // Finally, we move the nodes
    for(let i = 0, j = 0; i < toMove.length; i++){
        while(j < lis.length && toMove[i].claim_order >= lis[j].claim_order)j++;
        const anchor = j < lis.length ? lis[j] : null;
        target.insertBefore(toMove[i], anchor);
    }
}
function $26671684de8882a2$export$10d8903dec122b9d(target, node) {
    target.appendChild(node);
}
function $26671684de8882a2$export$79c6991e22869eb0(target, style_sheet_id, styles) {
    const append_styles_to = $26671684de8882a2$export$e6f325d87fe70439(target);
    if (!append_styles_to.getElementById(style_sheet_id)) {
        const style = $26671684de8882a2$export$8454457683f90105("style");
        style.id = style_sheet_id;
        style.textContent = styles;
        $26671684de8882a2$var$append_stylesheet(append_styles_to, style);
    }
}
function $26671684de8882a2$export$e6f325d87fe70439(node) {
    if (!node) return document;
    const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    if (root && root.host) return root;
    return node.ownerDocument;
}
function $26671684de8882a2$export$98a01cd5b3256c7(node) {
    const style_element = $26671684de8882a2$export$8454457683f90105("style");
    $26671684de8882a2$var$append_stylesheet($26671684de8882a2$export$e6f325d87fe70439(node), style_element);
    return style_element.sheet;
}
function $26671684de8882a2$var$append_stylesheet(node, style) {
    $26671684de8882a2$export$10d8903dec122b9d(node.head || node, style);
    return style.sheet;
}
function $26671684de8882a2$export$172bc581f7520fb7(target, node) {
    if ($26671684de8882a2$var$is_hydrating) {
        $26671684de8882a2$var$init_hydrate(target);
        if (target.actual_end_child === undefined || target.actual_end_child !== null && target.actual_end_child.parentNode !== target) target.actual_end_child = target.firstChild;
        // Skip nodes of undefined ordering
        while(target.actual_end_child !== null && target.actual_end_child.claim_order === undefined)target.actual_end_child = target.actual_end_child.nextSibling;
        if (node !== target.actual_end_child) // We only insert if the ordering of this node should be modified or the parent node is not target
        {
            if (node.claim_order !== undefined || node.parentNode !== target) target.insertBefore(node, target.actual_end_child);
        } else target.actual_end_child = node.nextSibling;
    } else if (node.parentNode !== target || node.nextSibling !== null) target.appendChild(node);
}
function $26671684de8882a2$export$21a5ca8aa77d35ff(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
function $26671684de8882a2$export$f7a8880e5fbca7f8(target, node, anchor) {
    if ($26671684de8882a2$var$is_hydrating && !anchor) $26671684de8882a2$export$172bc581f7520fb7(target, node);
    else if (node.parentNode !== target || node.nextSibling != anchor) target.insertBefore(node, anchor || null);
}
function $26671684de8882a2$export$3f780019ff766da6(node) {
    if (node.parentNode) node.parentNode.removeChild(node);
}
function $26671684de8882a2$export$7ddc7a4fd25b2662(iterations, detaching) {
    for(let i = 0; i < iterations.length; i += 1)if (iterations[i]) iterations[i].d(detaching);
}
function $26671684de8882a2$export$8454457683f90105(name) {
    return document.createElement(name);
}
function $26671684de8882a2$export$6b474b18510bcd0a(name, is) {
    return document.createElement(name, {
        is: is
    });
}
function $26671684de8882a2$export$9fd581e6a5ec01ab(obj, exclude) {
    const target = {};
    for(const k in obj)if ($26671684de8882a2$export$90ea246e00657977(obj, k) && exclude.indexOf(k) === -1) // @ts-ignore
    target[k] = obj[k];
    return target;
}
function $26671684de8882a2$export$3967a3bb66708d71(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
}
function $26671684de8882a2$export$6f093cfa640b7166(data) {
    return document.createTextNode(data);
}
function $26671684de8882a2$export$a941ed4b947d12f8() {
    return $26671684de8882a2$export$6f093cfa640b7166(" ");
}
function $26671684de8882a2$export$6e22c362a0406a2c() {
    return $26671684de8882a2$export$6f093cfa640b7166("");
}
function $26671684de8882a2$export$4a34f930e789283c(content) {
    return document.createComment(content);
}
function $26671684de8882a2$export$63174c828edd6ff8(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return ()=>node.removeEventListener(event, handler, options);
}
function $26671684de8882a2$export$87efb90f285c3ace(fn) {
    return function(event) {
        event.preventDefault();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $26671684de8882a2$export$52770bb39e602159(fn) {
    return function(event) {
        event.stopPropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $26671684de8882a2$export$11e2a029189b1fe4(fn) {
    return function(event) {
        event.stopImmediatePropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function $26671684de8882a2$export$82c2e460fb230c2a(fn) {
    return function(event) {
        // @ts-ignore
        if (event.target === this) fn.call(this, event);
    };
}
function $26671684de8882a2$export$3db9a96880fcbbea(fn) {
    return function(event) {
        // @ts-ignore
        if (event.isTrusted) fn.call(this, event);
    };
}
function $26671684de8882a2$export$7aabe8b3a840d2fd(node, attribute, value) {
    if (value == null) node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}
/**
 * List of attributes that should always be set through the attr method,
 * because updating them through the property setter doesn't work reliably.
 * In the example of `width`/`height`, the problem is that the setter only
 * accepts numeric values, but the attribute can also be set to a string like `50%`.
 * If this list becomes too big, rethink this approach.
 */ const $26671684de8882a2$var$always_set_through_set_attribute = [
    "width",
    "height"
];
function $26671684de8882a2$export$d7952e694819cff8(node, attributes) {
    // @ts-ignore
    const descriptors = Object.getOwnPropertyDescriptors(node.__proto__);
    for(const key in attributes){
        if (attributes[key] == null) node.removeAttribute(key);
        else if (key === "style") node.style.cssText = attributes[key];
        else if (key === "__value") node.value = node[key] = attributes[key];
        else if (descriptors[key] && descriptors[key].set && $26671684de8882a2$var$always_set_through_set_attribute.indexOf(key) === -1) node[key] = attributes[key];
        else $26671684de8882a2$export$7aabe8b3a840d2fd(node, key, attributes[key]);
    }
}
function $26671684de8882a2$export$368e7860cfb63d61(node, attributes) {
    for(const key in attributes)$26671684de8882a2$export$7aabe8b3a840d2fd(node, key, attributes[key]);
}
function $26671684de8882a2$export$98353888655e5db6(node, data_map) {
    Object.keys(data_map).forEach((key)=>{
        $26671684de8882a2$export$ebd6c566d63faf17(node, key, data_map[key]);
    });
}
function $26671684de8882a2$export$ebd6c566d63faf17(node, prop, value) {
    if (prop in node) node[prop] = typeof node[prop] === "boolean" && value === "" ? true : value;
    else $26671684de8882a2$export$7aabe8b3a840d2fd(node, prop, value);
}
function $26671684de8882a2$export$e796c4bd7c66dc3b(tag) {
    return /-/.test(tag) ? $26671684de8882a2$export$98353888655e5db6 : $26671684de8882a2$export$d7952e694819cff8;
}
function $26671684de8882a2$export$f27475e5487b56e(node, attribute, value) {
    node.setAttributeNS("http://www.w3.org/1999/xlink", attribute, value);
}
function $26671684de8882a2$export$e362e436917dc36e(group, __value, checked) {
    const value = new Set();
    for(let i = 0; i < group.length; i += 1)if (group[i].checked) value.add(group[i].__value);
    if (!checked) value.delete(__value);
    return Array.from(value);
}
function $26671684de8882a2$export$c9db880d5988ec92(group) {
    let _inputs;
    return {
        /* push */ p (...inputs) {
            _inputs = inputs;
            _inputs.forEach((input)=>group.push(input));
        },
        /* remove */ r () {
            _inputs.forEach((input)=>group.splice(group.indexOf(input), 1));
        }
    };
}
function $26671684de8882a2$export$e81314ce0988e002(group, indexes) {
    let _group = get_binding_group(group);
    let _inputs;
    function get_binding_group(group) {
        for(let i = 0; i < indexes.length; i++)group = group[indexes[i]] = group[indexes[i]] || [];
        return group;
    }
    function push() {
        _inputs.forEach((input)=>_group.push(input));
    }
    function remove() {
        _inputs.forEach((input)=>_group.splice(_group.indexOf(input), 1));
    }
    return {
        /* update */ u (new_indexes) {
            indexes = new_indexes;
            const new_group = get_binding_group(group);
            if (new_group !== _group) {
                remove();
                _group = new_group;
                push();
            }
        },
        /* push */ p (...inputs) {
            _inputs = inputs;
            push();
        },
        /* remove */ r: remove
    };
}
function $26671684de8882a2$export$5ba91aa2ee2bd813(value) {
    return value === "" ? null : +value;
}
function $26671684de8882a2$export$fea0a9609a381cb7(ranges) {
    const array = [];
    for(let i = 0; i < ranges.length; i += 1)array.push({
        start: ranges.start(i),
        end: ranges.end(i)
    });
    return array;
}
function $26671684de8882a2$export$bacb5cc5a11aef16(element) {
    return Array.from(element.childNodes);
}
function $26671684de8882a2$var$init_claim_info(nodes) {
    if (nodes.claim_info === undefined) nodes.claim_info = {
        last_index: 0,
        total_claimed: 0
    };
}
function $26671684de8882a2$var$claim_node(nodes, predicate, processNode, createNode, dontUpdateLastIndex = false) {
    // Try to find nodes in an order such that we lengthen the longest increasing subsequence
    $26671684de8882a2$var$init_claim_info(nodes);
    const resultNode = (()=>{
        // We first try to find an element after the previous one
        for(let i = nodes.claim_info.last_index; i < nodes.length; i++){
            const node = nodes[i];
            if (predicate(node)) {
                const replacement = processNode(node);
                if (replacement === undefined) nodes.splice(i, 1);
                else nodes[i] = replacement;
                if (!dontUpdateLastIndex) nodes.claim_info.last_index = i;
                return node;
            }
        }
        // Otherwise, we try to find one before
        // We iterate in reverse so that we don't go too far back
        for(let i = nodes.claim_info.last_index - 1; i >= 0; i--){
            const node = nodes[i];
            if (predicate(node)) {
                const replacement = processNode(node);
                if (replacement === undefined) nodes.splice(i, 1);
                else nodes[i] = replacement;
                if (!dontUpdateLastIndex) nodes.claim_info.last_index = i;
                else if (replacement === undefined) // Since we spliced before the last_index, we decrease it
                nodes.claim_info.last_index--;
                return node;
            }
        }
        // If we can't find any matching node, we create a new one
        return createNode();
    })();
    resultNode.claim_order = nodes.claim_info.total_claimed;
    nodes.claim_info.total_claimed += 1;
    return resultNode;
}
function $26671684de8882a2$var$claim_element_base(nodes, name, attributes, create_element) {
    return $26671684de8882a2$var$claim_node(nodes, (node)=>node.nodeName === name, (node)=>{
        const remove = [];
        for(let j = 0; j < node.attributes.length; j++){
            const attribute = node.attributes[j];
            if (!attributes[attribute.name]) remove.push(attribute.name);
        }
        remove.forEach((v)=>node.removeAttribute(v));
        return undefined;
    }, ()=>create_element(name));
}
function $26671684de8882a2$export$e4d2dfbfb60b531(nodes, name, attributes) {
    return $26671684de8882a2$var$claim_element_base(nodes, name, attributes, $26671684de8882a2$export$8454457683f90105);
}
function $26671684de8882a2$export$565c8233a6bb82a5(nodes, name, attributes) {
    return $26671684de8882a2$var$claim_element_base(nodes, name, attributes, $26671684de8882a2$export$3967a3bb66708d71);
}
function $26671684de8882a2$export$2fada5bb0438cbc3(nodes, data) {
    return $26671684de8882a2$var$claim_node(nodes, (node)=>node.nodeType === 3, (node)=>{
        const dataStr = "" + data;
        if (node.data.startsWith(dataStr)) {
            if (node.data.length !== dataStr.length) return node.splitText(dataStr.length);
        } else node.data = dataStr;
    }, ()=>$26671684de8882a2$export$6f093cfa640b7166(data), true // Text nodes should not update last index since it is likely not worth it to eliminate an increasing subsequence of actual elements
    );
}
function $26671684de8882a2$export$2466e42bcfb45299(nodes) {
    return $26671684de8882a2$export$2fada5bb0438cbc3(nodes, " ");
}
function $26671684de8882a2$export$193ad9a257f71537(nodes, data) {
    return $26671684de8882a2$var$claim_node(nodes, (node)=>node.nodeType === 8, (node)=>{
        node.data = "" + data;
        return undefined;
    }, ()=>$26671684de8882a2$export$4a34f930e789283c(data), true);
}
function $26671684de8882a2$var$find_comment(nodes, text, start) {
    for(let i = start; i < nodes.length; i += 1){
        const node = nodes[i];
        if (node.nodeType === 8 /* comment node */  && node.textContent.trim() === text) return i;
    }
    return nodes.length;
}
function $26671684de8882a2$export$5d5909c037ed7d6(nodes, is_svg) {
    // find html opening tag
    const start_index = $26671684de8882a2$var$find_comment(nodes, "HTML_TAG_START", 0);
    const end_index = $26671684de8882a2$var$find_comment(nodes, "HTML_TAG_END", start_index);
    if (start_index === end_index) return new $26671684de8882a2$export$7cdd9a1105a7b19d(undefined, is_svg);
    $26671684de8882a2$var$init_claim_info(nodes);
    const html_tag_nodes = nodes.splice(start_index, end_index - start_index + 1);
    $26671684de8882a2$export$3f780019ff766da6(html_tag_nodes[0]);
    $26671684de8882a2$export$3f780019ff766da6(html_tag_nodes[html_tag_nodes.length - 1]);
    const claimed_nodes = html_tag_nodes.slice(1, html_tag_nodes.length - 1);
    for (const n of claimed_nodes){
        n.claim_order = nodes.claim_info.total_claimed;
        nodes.claim_info.total_claimed += 1;
    }
    return new $26671684de8882a2$export$7cdd9a1105a7b19d(claimed_nodes, is_svg);
}
function $26671684de8882a2$export$c31d24e2793e6a58(text, data) {
    data = "" + data;
    if (text.data === data) return;
    text.data = data;
}
function $26671684de8882a2$export$3216f7a4c630e86(text, data) {
    data = "" + data;
    if (text.wholeText === data) return;
    text.data = data;
}
function $26671684de8882a2$export$81784c858f228282(text, data, attr_value) {
    if (~$26671684de8882a2$export$e3d839ffa95f7481.indexOf(attr_value)) $26671684de8882a2$export$3216f7a4c630e86(text, data);
    else $26671684de8882a2$export$c31d24e2793e6a58(text, data);
}
function $26671684de8882a2$export$aee788c6eadfac08(input, value) {
    input.value = value == null ? "" : value;
}
function $26671684de8882a2$export$b4858aaf125f1c5a(input, type) {
    try {
        input.type = type;
    } catch (e) {
    // do nothing
    }
}
function $26671684de8882a2$export$4bb9c9f436517f16(node, key, value, important) {
    if (value == null) node.style.removeProperty(key);
    else node.style.setProperty(key, value, important ? "important" : "");
}
function $26671684de8882a2$export$5bf9f186a0379f12(select, value, mounting) {
    for(let i = 0; i < select.options.length; i += 1){
        const option = select.options[i];
        if (option.__value === value) {
            option.selected = true;
            return;
        }
    }
    if (!mounting || value !== undefined) select.selectedIndex = -1; // no option should be selected
}
function $26671684de8882a2$export$336810584d2bdfc9(select, value) {
    for(let i = 0; i < select.options.length; i += 1){
        const option = select.options[i];
        option.selected = ~value.indexOf(option.__value);
    }
}
function $26671684de8882a2$export$10e6f38ae1549a20(select) {
    const selected_option = select.querySelector(":checked");
    return selected_option && selected_option.__value;
}
function $26671684de8882a2$export$4dde2acae9a7963a(select) {
    return [].map.call(select.querySelectorAll(":checked"), (option)=>option.__value);
}
// unfortunately this can't be a constant as that wouldn't be tree-shakeable
// so we cache the result instead
let $26671684de8882a2$var$crossorigin;
function $26671684de8882a2$export$1d584e6276e92aaf() {
    if ($26671684de8882a2$var$crossorigin === undefined) {
        $26671684de8882a2$var$crossorigin = false;
        try {
            if (typeof window !== "undefined" && window.parent) window.parent.document;
        } catch (error) {
            $26671684de8882a2$var$crossorigin = true;
        }
    }
    return $26671684de8882a2$var$crossorigin;
}
function $26671684de8882a2$export$38ac981d7e55f60a(node, fn) {
    const computed_style = getComputedStyle(node);
    if (computed_style.position === "static") node.style.position = "relative";
    const iframe = $26671684de8882a2$export$8454457683f90105("iframe");
    iframe.setAttribute("style", "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; border: 0; opacity: 0; pointer-events: none; z-index: -1;");
    iframe.setAttribute("aria-hidden", "true");
    iframe.tabIndex = -1;
    const crossorigin = $26671684de8882a2$export$1d584e6276e92aaf();
    let unsubscribe;
    if (crossorigin) {
        iframe.src = "data:text/html,<script>onresize=function(){parent.postMessage(0,'*')}</script>";
        unsubscribe = $26671684de8882a2$export$63174c828edd6ff8(window, "message", (event)=>{
            if (event.source === iframe.contentWindow) fn();
        });
    } else {
        iframe.src = "about:blank";
        iframe.onload = ()=>{
            unsubscribe = $26671684de8882a2$export$63174c828edd6ff8(iframe.contentWindow, "resize", fn);
            // make sure an initial resize event is fired _after_ the iframe is loaded (which is asynchronous)
            // see https://github.com/sveltejs/svelte/issues/4233
            fn();
        };
    }
    $26671684de8882a2$export$10d8903dec122b9d(node, iframe);
    return ()=>{
        if (crossorigin) unsubscribe();
        else if (unsubscribe && iframe.contentWindow) unsubscribe();
        $26671684de8882a2$export$3f780019ff766da6(iframe);
    };
}
const $26671684de8882a2$export$75ea48ff5ddc5b1 = /* @__PURE__ */ new $26671684de8882a2$export$cd966d69202271fb({
    box: "content-box"
});
const $26671684de8882a2$export$cfbcf6582d01e769 = /* @__PURE__ */ new $26671684de8882a2$export$cd966d69202271fb({
    box: "border-box"
});
const $26671684de8882a2$export$43fc4a2903df8cae = /* @__PURE__ */ new $26671684de8882a2$export$cd966d69202271fb({
    box: "device-pixel-content-box"
});
function $26671684de8882a2$export$d546e2fde02d30d6(element, name, toggle) {
    element.classList[toggle ? "add" : "remove"](name);
}
function $26671684de8882a2$export$da00493480283d6b(type, detail, { bubbles: bubbles = false, cancelable: cancelable = false } = {}) {
    const e = document.createEvent("CustomEvent");
    e.initCustomEvent(type, bubbles, cancelable, detail);
    return e;
}
function $26671684de8882a2$export$b06f083696d24824(selector, parent = document.body) {
    return Array.from(parent.querySelectorAll(selector));
}
function $26671684de8882a2$export$6a512dd14a7df6a(nodeId, head) {
    const result = [];
    let started = 0;
    for (const node of head.childNodes){
        if (node.nodeType === 8 /* comment node */ ) {
            const comment = node.textContent.trim();
            if (comment === `HEAD_${nodeId}_END`) {
                started -= 1;
                result.push(node);
            } else if (comment === `HEAD_${nodeId}_START`) {
                started += 1;
                result.push(node);
            }
        } else if (started > 0) result.push(node);
    }
    return result;
}
class $26671684de8882a2$export$5b2cf11349dd7485 {
    constructor(is_svg = false){
        this.is_svg = false;
        this.is_svg = is_svg;
        this.e = this.n = null;
    }
    c(html) {
        this.h(html);
    }
    m(html, target, anchor = null) {
        if (!this.e) {
            if (this.is_svg) this.e = $26671684de8882a2$export$3967a3bb66708d71(target.nodeName);
            else this.e = $26671684de8882a2$export$8454457683f90105(target.nodeType === 11 ? "TEMPLATE" : target.nodeName);
            this.t = target.tagName !== "TEMPLATE" ? target : target.content;
            this.c(html);
        }
        this.i(anchor);
    }
    h(html) {
        this.e.innerHTML = html;
        this.n = Array.from(this.e.nodeName === "TEMPLATE" ? this.e.content.childNodes : this.e.childNodes);
    }
    i(anchor) {
        for(let i = 0; i < this.n.length; i += 1)$26671684de8882a2$export$21a5ca8aa77d35ff(this.t, this.n[i], anchor);
    }
    p(html) {
        this.d();
        this.h(html);
        this.i(this.a);
    }
    d() {
        this.n.forEach($26671684de8882a2$export$3f780019ff766da6);
    }
}
class $26671684de8882a2$export$7cdd9a1105a7b19d extends $26671684de8882a2$export$5b2cf11349dd7485 {
    constructor(claimed_nodes, is_svg = false){
        super(is_svg);
        this.e = this.n = null;
        this.l = claimed_nodes;
    }
    c(html) {
        if (this.l) this.n = this.l;
        else super.c(html);
    }
    i(anchor) {
        for(let i = 0; i < this.n.length; i += 1)$26671684de8882a2$export$f7a8880e5fbca7f8(this.t, this.n[i], anchor);
    }
}
function $26671684de8882a2$export$110c642b3fe80ed5(attributes) {
    const result = {};
    for (const attribute of attributes)result[attribute.name] = attribute.value;
    return result;
}
function $26671684de8882a2$export$58283a1df1431097(element) {
    const result = {};
    element.childNodes.forEach((node)=>{
        result[node.slot || "default"] = true;
    });
    return result;
}
function $26671684de8882a2$export$203be6b617b8723(component, props) {
    return new component(props);
}
// we need to store the information for multiple documents because a Svelte application could also contain iframes
// https://github.com/sveltejs/svelte/issues/3624
const $26671684de8882a2$var$managed_styles = new Map();
let $26671684de8882a2$var$active = 0;
// https://github.com/darkskyapp/string-hash/blob/master/index.js
function $26671684de8882a2$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i--)hash = (hash << 5) - hash ^ str.charCodeAt(i);
    return hash >>> 0;
}
function $26671684de8882a2$var$create_style_information(doc, node) {
    const info = {
        stylesheet: $26671684de8882a2$export$98a01cd5b3256c7(node),
        rules: {}
    };
    $26671684de8882a2$var$managed_styles.set(doc, info);
    return info;
}
function $26671684de8882a2$var$create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
    const step = 16.666 / duration;
    let keyframes = "{\n";
    for(let p = 0; p <= 1; p += step){
        const t = a + (b - a) * ease(p);
        keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
    }
    const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
    const name = `__svelte_${$26671684de8882a2$var$hash(rule)}_${uid}`;
    const doc = $26671684de8882a2$export$e6f325d87fe70439(node);
    const { stylesheet: stylesheet, rules: rules } = $26671684de8882a2$var$managed_styles.get(doc) || $26671684de8882a2$var$create_style_information(doc, node);
    if (!rules[name]) {
        rules[name] = true;
        stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
    }
    const animation = node.style.animation || "";
    node.style.animation = `${animation ? `${animation}, ` : ""}${name} ${duration}ms linear ${delay}ms 1 both`;
    $26671684de8882a2$var$active += 1;
    return name;
}
function $26671684de8882a2$var$delete_rule(node, name) {
    const previous = (node.style.animation || "").split(", ");
    const next = previous.filter(name ? (anim)=>anim.indexOf(name) < 0 // remove specific animation
     : (anim)=>anim.indexOf("__svelte") === -1 // remove all Svelte animations
    );
    const deleted = previous.length - next.length;
    if (deleted) {
        node.style.animation = next.join(", ");
        $26671684de8882a2$var$active -= deleted;
        if (!$26671684de8882a2$var$active) $26671684de8882a2$var$clear_rules();
    }
}
function $26671684de8882a2$var$clear_rules() {
    $26671684de8882a2$export$27f233d61a9e2fa4(()=>{
        if ($26671684de8882a2$var$active) return;
        $26671684de8882a2$var$managed_styles.forEach((info)=>{
            const { ownerNode: ownerNode } = info.stylesheet;
            // there is no ownerNode if it runs on jsdom.
            if (ownerNode) $26671684de8882a2$export$3f780019ff766da6(ownerNode);
        });
        $26671684de8882a2$var$managed_styles.clear();
    });
}
function $26671684de8882a2$export$39b5174d4b79e190(node, from, fn, params) {
    if (!from) return $26671684de8882a2$export$8793edee2d425525;
    const to = node.getBoundingClientRect();
    if (from.left === to.left && from.right === to.right && from.top === to.top && from.bottom === to.bottom) return $26671684de8882a2$export$8793edee2d425525;
    const { delay: delay = 0, duration: duration = 300, easing: easing = $26671684de8882a2$export$f0954fd7d5368655, // @ts-ignore todo: should this be separated from destructuring? Or start/end added to public api and documentation?
    start: start_time = $26671684de8882a2$export$461939dd4422153() + delay, end: // @ts-ignore todo:
    end = start_time + duration, tick: tick = $26671684de8882a2$export$8793edee2d425525, css: css } = fn(node, {
        from: from,
        to: to
    }, params);
    let running = true;
    let started = false;
    let name;
    function start() {
        if (css) name = $26671684de8882a2$var$create_rule(node, 0, 1, duration, delay, easing, css);
        if (!delay) started = true;
    }
    function stop() {
        if (css) $26671684de8882a2$var$delete_rule(node, name);
        running = false;
    }
    $26671684de8882a2$export$f9ef67375ddc185((now)=>{
        if (!started && now >= start_time) started = true;
        if (started && now >= end) {
            tick(1, 0);
            stop();
        }
        if (!running) return false;
        if (started) {
            const p = now - start_time;
            const t = 0 + 1 * easing(p / duration);
            tick(t, 1 - t);
        }
        return true;
    });
    start();
    tick(0, 1);
    return stop;
}
function $26671684de8882a2$export$b3559b6401c8ae16(node) {
    const style = getComputedStyle(node);
    if (style.position !== "absolute" && style.position !== "fixed") {
        const { width: width, height: height } = style;
        const a = node.getBoundingClientRect();
        node.style.position = "absolute";
        node.style.width = width;
        node.style.height = height;
        $26671684de8882a2$export$e05da6b8aaec7de(node, a);
    }
}
function $26671684de8882a2$export$e05da6b8aaec7de(node, a) {
    const b = node.getBoundingClientRect();
    if (a.left !== b.left || a.top !== b.top) {
        const style = getComputedStyle(node);
        const transform = style.transform === "none" ? "" : style.transform;
        node.style.transform = `${transform} translate(${a.left - b.left}px, ${a.top - b.top}px)`;
    }
}
let $26671684de8882a2$export$3ec7acbf47bb7c71;
function $26671684de8882a2$export$e72a4c53a1d11dfc(component) {
    $26671684de8882a2$export$3ec7acbf47bb7c71 = component;
}
function $26671684de8882a2$export$d19094f0a5fb37fa() {
    if (!$26671684de8882a2$export$3ec7acbf47bb7c71) throw new Error("Function called outside component initialization");
    return $26671684de8882a2$export$3ec7acbf47bb7c71;
}
/**
 * Schedules a callback to run immediately before the component is updated after any state change.
 *
 * The first time the callback runs will be before the initial `onMount`
 *
 * https://svelte.dev/docs#run-time-svelte-beforeupdate
 */ function $26671684de8882a2$export$4b797776fd97928f(fn) {
    $26671684de8882a2$export$d19094f0a5fb37fa().$$.before_update.push(fn);
}
/**
 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
 * it can be called from an external module).
 *
 * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
 *
 * https://svelte.dev/docs#run-time-svelte-onmount
 */ function $26671684de8882a2$export$1e848a9e87980bd5(fn) {
    $26671684de8882a2$export$d19094f0a5fb37fa().$$.on_mount.push(fn);
}
/**
 * Schedules a callback to run immediately after the component has been updated.
 *
 * The first time the callback runs will be after the initial `onMount`
 */ function $26671684de8882a2$export$f956f39b9a12cea8(fn) {
    $26671684de8882a2$export$d19094f0a5fb37fa().$$.after_update.push(fn);
}
/**
 * Schedules a callback to run immediately before the component is unmounted.
 *
 * Out of `onMount`, `beforeUpdate`, `afterUpdate` and `onDestroy`, this is the
 * only one that runs inside a server-side component.
 *
 * https://svelte.dev/docs#run-time-svelte-ondestroy
 */ function $26671684de8882a2$export$f1238fd06ad9b453(fn) {
    $26671684de8882a2$export$d19094f0a5fb37fa().$$.on_destroy.push(fn);
}
/**
 * Creates an event dispatcher that can be used to dispatch [component events](/docs#template-syntax-component-directives-on-eventname).
 * Event dispatchers are functions that can take two arguments: `name` and `detail`.
 *
 * Component events created with `createEventDispatcher` create a
 * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
 * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
 * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
 * property and can contain any type of data.
 *
 * https://svelte.dev/docs#run-time-svelte-createeventdispatcher
 */ function $26671684de8882a2$export$2a380c922b2bd2b3() {
    const component = $26671684de8882a2$export$d19094f0a5fb37fa();
    return (type, detail, { cancelable: cancelable = false } = {})=>{
        const callbacks = component.$$.callbacks[type];
        if (callbacks) {
            // TODO are there situations where events could be dispatched
            // in a server (non-DOM) environment?
            const event = $26671684de8882a2$export$da00493480283d6b(type, detail, {
                cancelable: cancelable
            });
            callbacks.slice().forEach((fn)=>{
                fn.call(component, event);
            });
            return !event.defaultPrevented;
        }
        return true;
    };
}
/**
 * Associates an arbitrary `context` object with the current component and the specified `key`
 * and returns that object. The context is then available to children of the component
 * (including slotted content) with `getContext`.
 *
 * Like lifecycle functions, this must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-setcontext
 */ function $26671684de8882a2$export$2f04de43fe27971a(key, context) {
    $26671684de8882a2$export$d19094f0a5fb37fa().$$.context.set(key, context);
    return context;
}
/**
 * Retrieves the context that belongs to the closest parent component with the specified `key`.
 * Must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-getcontext
 */ function $26671684de8882a2$export$31553aaa555c1514(key) {
    return $26671684de8882a2$export$d19094f0a5fb37fa().$$.context.get(key);
}
/**
 * Retrieves the whole context map that belongs to the closest parent component.
 * Must be called during component initialisation. Useful, for example, if you
 * programmatically create a component and want to pass the existing context to it.
 *
 * https://svelte.dev/docs#run-time-svelte-getallcontexts
 */ function $26671684de8882a2$export$58bb8454a8b39484() {
    return $26671684de8882a2$export$d19094f0a5fb37fa().$$.context;
}
/**
 * Checks whether a given `key` has been set in the context of a parent component.
 * Must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-hascontext
 */ function $26671684de8882a2$export$1fda64d8edbe0e8d(key) {
    return $26671684de8882a2$export$d19094f0a5fb37fa().$$.context.has(key);
}
// TODO figure out if we still want to support
// shorthand events, or if we want to implement
// a real bubbling mechanism
function $26671684de8882a2$export$f5dbf5ce556e97fb(component, event) {
    const callbacks = component.$$.callbacks[event.type];
    if (callbacks) // @ts-ignore
    callbacks.slice().forEach((fn)=>fn.call(this, event));
}
const $26671684de8882a2$export$befe60e985bb3cce = [];
const $26671684de8882a2$export$eec97e1bbe9a59bc = {
    enabled: false
};
const $26671684de8882a2$export$de8cb20e97391842 = [];
let $26671684de8882a2$var$render_callbacks = [];
const $26671684de8882a2$var$flush_callbacks = [];
const $26671684de8882a2$var$resolved_promise = /* @__PURE__ */ Promise.resolve();
let $26671684de8882a2$var$update_scheduled = false;
function $26671684de8882a2$export$c3d55cc721051d24() {
    if (!$26671684de8882a2$var$update_scheduled) {
        $26671684de8882a2$var$update_scheduled = true;
        $26671684de8882a2$var$resolved_promise.then($26671684de8882a2$export$4909b86c8034bf73);
    }
}
function $26671684de8882a2$export$55d7f61db91b7b70() {
    $26671684de8882a2$export$c3d55cc721051d24();
    return $26671684de8882a2$var$resolved_promise;
}
function $26671684de8882a2$export$8851747095d022df(fn) {
    $26671684de8882a2$var$render_callbacks.push(fn);
}
function $26671684de8882a2$export$53b4f9f742189b3b(fn) {
    $26671684de8882a2$var$flush_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const $26671684de8882a2$var$seen_callbacks = new Set();
let $26671684de8882a2$var$flushidx = 0; // Do *not* move this inside the flush() function
function $26671684de8882a2$export$4909b86c8034bf73() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if ($26671684de8882a2$var$flushidx !== 0) return;
    const saved_component = $26671684de8882a2$export$3ec7acbf47bb7c71;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while($26671684de8882a2$var$flushidx < $26671684de8882a2$export$befe60e985bb3cce.length){
                const component = $26671684de8882a2$export$befe60e985bb3cce[$26671684de8882a2$var$flushidx];
                $26671684de8882a2$var$flushidx++;
                $26671684de8882a2$export$e72a4c53a1d11dfc(component);
                $26671684de8882a2$var$update(component.$$);
            }
        } catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            $26671684de8882a2$export$befe60e985bb3cce.length = 0;
            $26671684de8882a2$var$flushidx = 0;
            throw e;
        }
        $26671684de8882a2$export$e72a4c53a1d11dfc(null);
        $26671684de8882a2$export$befe60e985bb3cce.length = 0;
        $26671684de8882a2$var$flushidx = 0;
        while($26671684de8882a2$export$de8cb20e97391842.length)$26671684de8882a2$export$de8cb20e97391842.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for(let i = 0; i < $26671684de8882a2$var$render_callbacks.length; i += 1){
            const callback = $26671684de8882a2$var$render_callbacks[i];
            if (!$26671684de8882a2$var$seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                $26671684de8882a2$var$seen_callbacks.add(callback);
                callback();
            }
        }
        $26671684de8882a2$var$render_callbacks.length = 0;
    }while ($26671684de8882a2$export$befe60e985bb3cce.length);
    while($26671684de8882a2$var$flush_callbacks.length)$26671684de8882a2$var$flush_callbacks.pop()();
    $26671684de8882a2$var$update_scheduled = false;
    $26671684de8882a2$var$seen_callbacks.clear();
    $26671684de8882a2$export$e72a4c53a1d11dfc(saved_component);
}
function $26671684de8882a2$var$update($$) {
    if ($$.fragment !== null) {
        $$.update();
        $26671684de8882a2$export$3f1fcd837f99a9ab($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [
            -1
        ];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach($26671684de8882a2$export$8851747095d022df);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 */ function $26671684de8882a2$export$99d0f1b00233da03(fns) {
    const filtered = [];
    const targets = [];
    $26671684de8882a2$var$render_callbacks.forEach((c)=>fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c)=>c());
    $26671684de8882a2$var$render_callbacks = filtered;
}
let $26671684de8882a2$var$promise;
function $26671684de8882a2$var$wait() {
    if (!$26671684de8882a2$var$promise) {
        $26671684de8882a2$var$promise = Promise.resolve();
        $26671684de8882a2$var$promise.then(()=>{
            $26671684de8882a2$var$promise = null;
        });
    }
    return $26671684de8882a2$var$promise;
}
function $26671684de8882a2$var$dispatch(node, direction, kind) {
    node.dispatchEvent($26671684de8882a2$export$da00493480283d6b(`${direction ? "intro" : "outro"}${kind}`));
}
const $26671684de8882a2$var$outroing = new Set();
let $26671684de8882a2$var$outros;
function $26671684de8882a2$export$b074532eec6b252c() {
    $26671684de8882a2$var$outros = {
        r: 0,
        c: [],
        p: $26671684de8882a2$var$outros // parent group
    };
}
function $26671684de8882a2$export$e7d251cf909c6ab9() {
    if (!$26671684de8882a2$var$outros.r) $26671684de8882a2$export$3f1fcd837f99a9ab($26671684de8882a2$var$outros.c);
    $26671684de8882a2$var$outros = $26671684de8882a2$var$outros.p;
}
function $26671684de8882a2$export$9e951caa2db2b1da(block, local) {
    if (block && block.i) {
        $26671684de8882a2$var$outroing.delete(block);
        block.i(local);
    }
}
function $26671684de8882a2$export$fdd20dba65b2c00e(block, local, detach, callback) {
    if (block && block.o) {
        if ($26671684de8882a2$var$outroing.has(block)) return;
        $26671684de8882a2$var$outroing.add(block);
        $26671684de8882a2$var$outros.c.push(()=>{
            $26671684de8882a2$var$outroing.delete(block);
            if (callback) {
                if (detach) block.d(1);
                callback();
            }
        });
        block.o(local);
    } else if (callback) callback();
}
const $26671684de8882a2$var$null_transition = {
    duration: 0
};
function $26671684de8882a2$export$60774c4a339e0bce(node, fn, params) {
    const options = {
        direction: "in"
    };
    let config = fn(node, params, options);
    let running = false;
    let animation_name;
    let task;
    let uid = 0;
    function cleanup() {
        if (animation_name) $26671684de8882a2$var$delete_rule(node, animation_name);
    }
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $26671684de8882a2$export$f0954fd7d5368655, tick: tick = $26671684de8882a2$export$8793edee2d425525, css: css } = config || $26671684de8882a2$var$null_transition;
        if (css) animation_name = $26671684de8882a2$var$create_rule(node, 0, 1, duration, delay, easing, css, uid++);
        tick(0, 1);
        const start_time = $26671684de8882a2$export$461939dd4422153() + delay;
        const end_time = start_time + duration;
        if (task) task.abort();
        running = true;
        $26671684de8882a2$export$8851747095d022df(()=>$26671684de8882a2$var$dispatch(node, true, "start"));
        task = $26671684de8882a2$export$f9ef67375ddc185((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(1, 0);
                    $26671684de8882a2$var$dispatch(node, true, "end");
                    cleanup();
                    return running = false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(t, 1 - t);
                }
            }
            return running;
        });
    }
    let started = false;
    return {
        start () {
            if (started) return;
            started = true;
            $26671684de8882a2$var$delete_rule(node);
            if ($26671684de8882a2$export$b451353ebd749597(config)) {
                config = config(options);
                $26671684de8882a2$var$wait().then(go);
            } else go();
        },
        invalidate () {
            started = false;
        },
        end () {
            if (running) {
                cleanup();
                running = false;
            }
        }
    };
}
function $26671684de8882a2$export$f77bfa1b5f956ef9(node, fn, params) {
    const options = {
        direction: "out"
    };
    let config = fn(node, params, options);
    let running = true;
    let animation_name;
    const group = $26671684de8882a2$var$outros;
    group.r += 1;
    function go() {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $26671684de8882a2$export$f0954fd7d5368655, tick: tick = $26671684de8882a2$export$8793edee2d425525, css: css } = config || $26671684de8882a2$var$null_transition;
        if (css) animation_name = $26671684de8882a2$var$create_rule(node, 1, 0, duration, delay, easing, css);
        const start_time = $26671684de8882a2$export$461939dd4422153() + delay;
        const end_time = start_time + duration;
        $26671684de8882a2$export$8851747095d022df(()=>$26671684de8882a2$var$dispatch(node, false, "start"));
        $26671684de8882a2$export$f9ef67375ddc185((now)=>{
            if (running) {
                if (now >= end_time) {
                    tick(0, 1);
                    $26671684de8882a2$var$dispatch(node, false, "end");
                    if (!--group.r) // this will result in `end()` being called,
                    // so we don't need to clean up here
                    $26671684de8882a2$export$3f1fcd837f99a9ab(group.c);
                    return false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(1 - t, t);
                }
            }
            return running;
        });
    }
    if ($26671684de8882a2$export$b451353ebd749597(config)) $26671684de8882a2$var$wait().then(()=>{
        // @ts-ignore
        config = config(options);
        go();
    });
    else go();
    return {
        end (reset) {
            if (reset && config.tick) config.tick(1, 0);
            if (running) {
                if (animation_name) $26671684de8882a2$var$delete_rule(node, animation_name);
                running = false;
            }
        }
    };
}
function $26671684de8882a2$export$20b54ee3658479fb(node, fn, params, intro) {
    const options = {
        direction: "both"
    };
    let config = fn(node, params, options);
    let t = intro ? 0 : 1;
    let running_program = null;
    let pending_program = null;
    let animation_name = null;
    function clear_animation() {
        if (animation_name) $26671684de8882a2$var$delete_rule(node, animation_name);
    }
    function init(program, duration) {
        const d = program.b - t;
        duration *= Math.abs(d);
        return {
            a: t,
            b: program.b,
            d: d,
            duration: duration,
            start: program.start,
            end: program.start + duration,
            group: program.group
        };
    }
    function go(b) {
        const { delay: delay = 0, duration: duration = 300, easing: easing = $26671684de8882a2$export$f0954fd7d5368655, tick: tick = $26671684de8882a2$export$8793edee2d425525, css: css } = config || $26671684de8882a2$var$null_transition;
        const program = {
            start: $26671684de8882a2$export$461939dd4422153() + delay,
            b: b
        };
        if (!b) {
            // @ts-ignore todo: improve typings
            program.group = $26671684de8882a2$var$outros;
            $26671684de8882a2$var$outros.r += 1;
        }
        if (running_program || pending_program) pending_program = program;
        else {
            // if this is an intro, and there's a delay, we need to do
            // an initial tick and/or apply CSS animation immediately
            if (css) {
                clear_animation();
                animation_name = $26671684de8882a2$var$create_rule(node, t, b, duration, delay, easing, css);
            }
            if (b) tick(0, 1);
            running_program = init(program, duration);
            $26671684de8882a2$export$8851747095d022df(()=>$26671684de8882a2$var$dispatch(node, b, "start"));
            $26671684de8882a2$export$f9ef67375ddc185((now)=>{
                if (pending_program && now > pending_program.start) {
                    running_program = init(pending_program, duration);
                    pending_program = null;
                    $26671684de8882a2$var$dispatch(node, running_program.b, "start");
                    if (css) {
                        clear_animation();
                        animation_name = $26671684de8882a2$var$create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
                    }
                }
                if (running_program) {
                    if (now >= running_program.end) {
                        tick(t = running_program.b, 1 - t);
                        $26671684de8882a2$var$dispatch(node, running_program.b, "end");
                        if (!pending_program) {
                            // we're done
                            if (running_program.b) // intro — we can tidy up immediately
                            clear_animation();
                            else // outro — needs to be coordinated
                            if (!--running_program.group.r) $26671684de8882a2$export$3f1fcd837f99a9ab(running_program.group.c);
                        }
                        running_program = null;
                    } else if (now >= running_program.start) {
                        const p = now - running_program.start;
                        t = running_program.a + running_program.d * easing(p / running_program.duration);
                        tick(t, 1 - t);
                    }
                }
                return !!(running_program || pending_program);
            });
        }
    }
    return {
        run (b) {
            if ($26671684de8882a2$export$b451353ebd749597(config)) $26671684de8882a2$var$wait().then(()=>{
                // @ts-ignore
                config = config(options);
                go(b);
            });
            else go(b);
        },
        end () {
            clear_animation();
            running_program = pending_program = null;
        }
    };
}
function $26671684de8882a2$export$784d33b211c10e0c(promise, info) {
    const token = info.token = {};
    function update(type, index, key, value) {
        if (info.token !== token) return;
        info.resolved = value;
        let child_ctx = info.ctx;
        if (key !== undefined) {
            child_ctx = child_ctx.slice();
            child_ctx[key] = value;
        }
        const block = type && (info.current = type)(child_ctx);
        let needs_flush = false;
        if (info.block) {
            if (info.blocks) info.blocks.forEach((block, i)=>{
                if (i !== index && block) {
                    $26671684de8882a2$export$b074532eec6b252c();
                    $26671684de8882a2$export$fdd20dba65b2c00e(block, 1, 1, ()=>{
                        if (info.blocks[i] === block) info.blocks[i] = null;
                    });
                    $26671684de8882a2$export$e7d251cf909c6ab9();
                }
            });
            else info.block.d(1);
            block.c();
            $26671684de8882a2$export$9e951caa2db2b1da(block, 1);
            block.m(info.mount(), info.anchor);
            needs_flush = true;
        }
        info.block = block;
        if (info.blocks) info.blocks[index] = block;
        if (needs_flush) $26671684de8882a2$export$4909b86c8034bf73();
    }
    if ($26671684de8882a2$export$7666b03abe8479da(promise)) {
        const current_component = $26671684de8882a2$export$d19094f0a5fb37fa();
        promise.then((value)=>{
            $26671684de8882a2$export$e72a4c53a1d11dfc(current_component);
            update(info.then, 1, info.value, value);
            $26671684de8882a2$export$e72a4c53a1d11dfc(null);
        }, (error)=>{
            $26671684de8882a2$export$e72a4c53a1d11dfc(current_component);
            update(info.catch, 2, info.error, error);
            $26671684de8882a2$export$e72a4c53a1d11dfc(null);
            if (!info.hasCatch) throw error;
        });
        // if we previously had a then/catch block, destroy it
        if (info.current !== info.pending) {
            update(info.pending, 0);
            return true;
        }
    } else {
        if (info.current !== info.then) {
            update(info.then, 1, info.value, promise);
            return true;
        }
        info.resolved = promise;
    }
}
function $26671684de8882a2$export$69ebd9d202167ab4(info, ctx, dirty) {
    const child_ctx = ctx.slice();
    const { resolved: resolved } = info;
    if (info.current === info.then) child_ctx[info.value] = resolved;
    if (info.current === info.catch) child_ctx[info.error] = resolved;
    info.block.p(child_ctx, dirty);
}
function $26671684de8882a2$export$75442db144d4e64e(block, lookup) {
    block.d(1);
    lookup.delete(block.key);
}
function $26671684de8882a2$export$34db5f5dc4992cab(block, lookup) {
    $26671684de8882a2$export$fdd20dba65b2c00e(block, 1, 1, ()=>{
        lookup.delete(block.key);
    });
}
function $26671684de8882a2$export$ba06fda9300662d1(block, lookup) {
    block.f();
    $26671684de8882a2$export$75442db144d4e64e(block, lookup);
}
function $26671684de8882a2$export$6fdc494652858fb8(block, lookup) {
    block.f();
    $26671684de8882a2$export$34db5f5dc4992cab(block, lookup);
}
function $26671684de8882a2$export$1c17fe0cd58c4da7(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
    let o = old_blocks.length;
    let n = list.length;
    let i = o;
    const old_indexes = {};
    while(i--)old_indexes[old_blocks[i].key] = i;
    const new_blocks = [];
    const new_lookup = new Map();
    const deltas = new Map();
    const updates = [];
    i = n;
    while(i--){
        const child_ctx = get_context(ctx, list, i);
        const key = get_key(child_ctx);
        let block = lookup.get(key);
        if (!block) {
            block = create_each_block(key, child_ctx);
            block.c();
        } else if (dynamic) // defer updates until all the DOM shuffling is done
        updates.push(()=>block.p(child_ctx, dirty));
        new_lookup.set(key, new_blocks[i] = block);
        if (key in old_indexes) deltas.set(key, Math.abs(i - old_indexes[key]));
    }
    const will_move = new Set();
    const did_move = new Set();
    function insert(block) {
        $26671684de8882a2$export$9e951caa2db2b1da(block, 1);
        block.m(node, next);
        lookup.set(block.key, block);
        next = block.first;
        n--;
    }
    while(o && n){
        const new_block = new_blocks[n - 1];
        const old_block = old_blocks[o - 1];
        const new_key = new_block.key;
        const old_key = old_block.key;
        if (new_block === old_block) {
            // do nothing
            next = new_block.first;
            o--;
            n--;
        } else if (!new_lookup.has(old_key)) {
            // remove old block
            destroy(old_block, lookup);
            o--;
        } else if (!lookup.has(new_key) || will_move.has(new_key)) insert(new_block);
        else if (did_move.has(old_key)) o--;
        else if (deltas.get(new_key) > deltas.get(old_key)) {
            did_move.add(new_key);
            insert(new_block);
        } else {
            will_move.add(old_key);
            o--;
        }
    }
    while(o--){
        const old_block = old_blocks[o];
        if (!new_lookup.has(old_block.key)) destroy(old_block, lookup);
    }
    while(n)insert(new_blocks[n - 1]);
    $26671684de8882a2$export$3f1fcd837f99a9ab(updates);
    return new_blocks;
}
function $26671684de8882a2$export$7a64eb7bd69e8d3f(ctx, list, get_context, get_key) {
    const keys = new Set();
    for(let i = 0; i < list.length; i++){
        const key = get_key(get_context(ctx, list, i));
        if (keys.has(key)) throw new Error("Cannot have duplicate keys in a keyed each");
        keys.add(key);
    }
}
function $26671684de8882a2$export$eea1060726e9ab6(levels, updates) {
    const update = {};
    const to_null_out = {};
    const accounted_for = {
        $$scope: 1
    };
    let i = levels.length;
    while(i--){
        const o = levels[i];
        const n = updates[i];
        if (n) {
            for(const key in o)if (!(key in n)) to_null_out[key] = 1;
            for(const key in n)if (!accounted_for[key]) {
                update[key] = n[key];
                accounted_for[key] = 1;
            }
            levels[i] = n;
        } else for(const key in o)accounted_for[key] = 1;
    }
    for(const key in to_null_out)if (!(key in update)) update[key] = undefined;
    return update;
}
function $26671684de8882a2$export$19fac21209f8779d(spread_props) {
    return typeof spread_props === "object" && spread_props !== null ? spread_props : {};
}
const $26671684de8882a2$var$_boolean_attributes = [
    "allowfullscreen",
    "allowpaymentrequest",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "hidden",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected"
];
/**
 * List of HTML boolean attributes (e.g. `<input disabled>`).
 * Source: https://html.spec.whatwg.org/multipage/indices.html
 */ const $26671684de8882a2$var$boolean_attributes = new Set([
    ...$26671684de8882a2$var$_boolean_attributes
]);
/** regex of all html void element names */ const $26671684de8882a2$var$void_element_names = /^(?:area|base|br|col|command|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)$/;
function $26671684de8882a2$export$66cf70365c175aee(name) {
    return $26671684de8882a2$var$void_element_names.test(name) || name.toLowerCase() === "!doctype";
}
const $26671684de8882a2$export$44426fed7d33cfd0 = /[\s'">/=\u{FDD0}-\u{FDEF}\u{FFFE}\u{FFFF}\u{1FFFE}\u{1FFFF}\u{2FFFE}\u{2FFFF}\u{3FFFE}\u{3FFFF}\u{4FFFE}\u{4FFFF}\u{5FFFE}\u{5FFFF}\u{6FFFE}\u{6FFFF}\u{7FFFE}\u{7FFFF}\u{8FFFE}\u{8FFFF}\u{9FFFE}\u{9FFFF}\u{AFFFE}\u{AFFFF}\u{BFFFE}\u{BFFFF}\u{CFFFE}\u{CFFFF}\u{DFFFE}\u{DFFFF}\u{EFFFE}\u{EFFFF}\u{FFFFE}\u{FFFFF}\u{10FFFE}\u{10FFFF}]/u;
// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
// https://infra.spec.whatwg.org/#noncharacter
function $26671684de8882a2$export$3ae0fd4797ed47c8(args, attrs_to_add) {
    const attributes = Object.assign({}, ...args);
    if (attrs_to_add) {
        const classes_to_add = attrs_to_add.classes;
        const styles_to_add = attrs_to_add.styles;
        if (classes_to_add) {
            if (attributes.class == null) attributes.class = classes_to_add;
            else attributes.class += " " + classes_to_add;
        }
        if (styles_to_add) {
            if (attributes.style == null) attributes.style = $26671684de8882a2$var$style_object_to_string(styles_to_add);
            else attributes.style = $26671684de8882a2$var$style_object_to_string($26671684de8882a2$export$59f1d5f66ae7e219(attributes.style, styles_to_add));
        }
    }
    let str = "";
    Object.keys(attributes).forEach((name)=>{
        if ($26671684de8882a2$export$44426fed7d33cfd0.test(name)) return;
        const value = attributes[name];
        if (value === true) str += " " + name;
        else if ($26671684de8882a2$var$boolean_attributes.has(name.toLowerCase())) {
            if (value) str += " " + name;
        } else if (value != null) str += ` ${name}="${value}"`;
    });
    return str;
}
function $26671684de8882a2$export$59f1d5f66ae7e219(style_attribute, style_directive) {
    const style_object = {};
    for (const individual_style of style_attribute.split(";")){
        const colon_index = individual_style.indexOf(":");
        const name = individual_style.slice(0, colon_index).trim();
        const value = individual_style.slice(colon_index + 1).trim();
        if (!name) continue;
        style_object[name] = value;
    }
    for(const name in style_directive){
        const value = style_directive[name];
        if (value) style_object[name] = value;
        else delete style_object[name];
    }
    return style_object;
}
const $26671684de8882a2$var$ATTR_REGEX = /[&"]/g;
const $26671684de8882a2$var$CONTENT_REGEX = /[&<]/g;
/**
 * Note: this method is performance sensitive and has been optimized
 * https://github.com/sveltejs/svelte/pull/5701
 */ function $26671684de8882a2$export$4e7f196112fea3c5(value, is_attr = false) {
    const str = String(value);
    const pattern = is_attr ? $26671684de8882a2$var$ATTR_REGEX : $26671684de8882a2$var$CONTENT_REGEX;
    pattern.lastIndex = 0;
    let escaped = "";
    let last = 0;
    while(pattern.test(str)){
        const i = pattern.lastIndex - 1;
        const ch = str[i];
        escaped += str.substring(last, i) + (ch === "&" ? "&amp;" : ch === '"' ? "&quot;" : "&lt;");
        last = i + 1;
    }
    return escaped + str.substring(last);
}
function $26671684de8882a2$export$7997b567c4bb0bed(value) {
    // keep booleans, null, and undefined for the sake of `spread`
    const should_escape = typeof value === "string" || value && typeof value === "object";
    return should_escape ? $26671684de8882a2$export$4e7f196112fea3c5(value, true) : value;
}
function $26671684de8882a2$export$9a9efab655aeaa3(obj) {
    const result = {};
    for(const key in obj)result[key] = $26671684de8882a2$export$7997b567c4bb0bed(obj[key]);
    return result;
}
function $26671684de8882a2$export$79b2f7037acddd43(items, fn) {
    let str = "";
    for(let i = 0; i < items.length; i += 1)str += fn(items[i], i);
    return str;
}
const $26671684de8882a2$export$84983a965b218545 = {
    $$render: ()=>""
};
function $26671684de8882a2$export$930da2a45a215472(component, name) {
    if (!component || !component.$$render) {
        if (name === "svelte:component") name += " this={...}";
        throw new Error(`<${name}> is not a valid SSR component. You may need to review your build config to ensure that dependencies are compiled, rather than imported as pre-compiled modules. Otherwise you may need to fix a <${name}>.`);
    }
    return component;
}
function $26671684de8882a2$export$1c9f709888824e05(file, line, column, values) {
    console.log(`{@debug} ${file ? file + " " : ""}(${line}:${column})`); // eslint-disable-line no-console
    console.log(values); // eslint-disable-line no-console
    return "";
}
let $26671684de8882a2$var$on_destroy;
function $26671684de8882a2$export$caab6e78cc1ff033(fn) {
    function $$render(result, props, bindings, slots, context) {
        const parent_component = $26671684de8882a2$export$3ec7acbf47bb7c71;
        const $$ = {
            on_destroy: $26671684de8882a2$var$on_destroy,
            context: new Map(context || (parent_component ? parent_component.$$.context : [])),
            // these will be immediately discarded
            on_mount: [],
            before_update: [],
            after_update: [],
            callbacks: $26671684de8882a2$export$31092919e374e43c()
        };
        $26671684de8882a2$export$e72a4c53a1d11dfc({
            $$: $$
        });
        const html = fn(result, props, bindings, slots);
        $26671684de8882a2$export$e72a4c53a1d11dfc(parent_component);
        return html;
    }
    return {
        render: (props = {}, { $$slots: $$slots = {}, context: context = new Map() } = {})=>{
            $26671684de8882a2$var$on_destroy = [];
            const result = {
                title: "",
                head: "",
                css: new Set()
            };
            const html = $$render(result, props, {}, $$slots, context);
            $26671684de8882a2$export$3f1fcd837f99a9ab($26671684de8882a2$var$on_destroy);
            return {
                html: html,
                css: {
                    code: Array.from(result.css).map((css)=>css.code).join("\n"),
                    map: null // TODO
                },
                head: result.title + result.head
            };
        },
        $$render: $$render
    };
}
function $26671684de8882a2$export$b442e23403500748(name, value, boolean) {
    if (value == null || boolean && !value) return "";
    const assignment = boolean && value === true ? "" : `="${$26671684de8882a2$export$4e7f196112fea3c5(value, true)}"`;
    return ` ${name}${assignment}`;
}
function $26671684de8882a2$export$b377786ff5e86c4c(classes) {
    return classes ? ` class="${classes}"` : "";
}
function $26671684de8882a2$var$style_object_to_string(style_object) {
    return Object.keys(style_object).filter((key)=>style_object[key]).map((key)=>`${key}: ${$26671684de8882a2$export$7997b567c4bb0bed(style_object[key])};`).join(" ");
}
function $26671684de8882a2$export$97f189f545ba14e6(style_object) {
    const styles = $26671684de8882a2$var$style_object_to_string(style_object);
    return styles ? ` style="${styles}"` : "";
}
function $26671684de8882a2$export$2385a24977818dd0(component, name, callback) {
    const index = component.$$.props[name];
    if (index !== undefined) {
        component.$$.bound[index] = callback;
        callback(component.$$.ctx[index]);
    }
}
function $26671684de8882a2$export$3dac9ce53bfc6012(block) {
    block && block.c();
}
function $26671684de8882a2$export$a73b5a5296efe9fc(block, parent_nodes) {
    block && block.l(parent_nodes);
}
function $26671684de8882a2$export$18b26e9aca35251(component, target, anchor, customElement) {
    const { fragment: fragment, after_update: after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    if (!customElement) // onMount happens before the initial afterUpdate
    $26671684de8882a2$export$8851747095d022df(()=>{
        const new_on_destroy = component.$$.on_mount.map($26671684de8882a2$export$889ea624f2cb2c57).filter($26671684de8882a2$export$b451353ebd749597);
        // if the component was destroyed immediately
        // it will update the `$$.on_destroy` reference to `null`.
        // the destructured on_destroy may still reference to the old array
        if (component.$$.on_destroy) component.$$.on_destroy.push(...new_on_destroy);
        else // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        $26671684de8882a2$export$3f1fcd837f99a9ab(new_on_destroy);
        component.$$.on_mount = [];
    });
    after_update.forEach($26671684de8882a2$export$8851747095d022df);
}
function $26671684de8882a2$export$ddd2890b29e5aebe(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        $26671684de8882a2$export$99d0f1b00233da03($$.after_update);
        $26671684de8882a2$export$3f1fcd837f99a9ab($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
function $26671684de8882a2$var$make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        $26671684de8882a2$export$befe60e985bb3cce.push(component);
        $26671684de8882a2$export$c3d55cc721051d24();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function $26671684de8882a2$export$2cd8252107eb640b(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [
    -1
]) {
    const parent_component = $26671684de8882a2$export$3ec7acbf47bb7c71;
    $26671684de8882a2$export$e72a4c53a1d11dfc(component);
    const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        props: // state
        props,
        update: $26671684de8882a2$export$8793edee2d425525,
        not_equal: not_equal,
        bound: $26671684de8882a2$export$31092919e374e43c(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: $26671684de8882a2$export$31092919e374e43c(),
        dirty: dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance ? instance(component, options.props || {}, (i, ret, ...rest)=>{
        const value = rest.length ? rest[0] : ret;
        if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
            if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
            if (ready) $26671684de8882a2$var$make_dirty(component, i);
        }
        return ret;
    }) : [];
    $$.update();
    ready = true;
    $26671684de8882a2$export$3f1fcd837f99a9ab($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            $26671684de8882a2$export$237ef195d41ae60c();
            const nodes = $26671684de8882a2$export$bacb5cc5a11aef16(options.target);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach($26671684de8882a2$export$3f780019ff766da6);
        } else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $$.fragment && $$.fragment.c();
        if (options.intro) $26671684de8882a2$export$9e951caa2db2b1da(component.$$.fragment);
        $26671684de8882a2$export$18b26e9aca35251(component, options.target, options.anchor, options.customElement);
        $26671684de8882a2$export$4b42d81e6a3b0cd2();
        $26671684de8882a2$export$4909b86c8034bf73();
    }
    $26671684de8882a2$export$e72a4c53a1d11dfc(parent_component);
}
let $26671684de8882a2$export$1add084de80b788;
if (typeof HTMLElement === "function") $26671684de8882a2$export$1add084de80b788 = class extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        const { on_mount: on_mount } = this.$$;
        this.$$.on_disconnect = on_mount.map($26671684de8882a2$export$889ea624f2cb2c57).filter($26671684de8882a2$export$b451353ebd749597);
        // @ts-ignore todo: improve typings
        for(const key in this.$$.slotted)// @ts-ignore todo: improve typings
        this.appendChild(this.$$.slotted[key]);
    }
    attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
    }
    disconnectedCallback() {
        $26671684de8882a2$export$3f1fcd837f99a9ab(this.$$.on_disconnect);
    }
    $destroy() {
        $26671684de8882a2$export$ddd2890b29e5aebe(this, 1);
        this.$destroy = $26671684de8882a2$export$8793edee2d425525;
    }
    $on(type, callback) {
        // TODO should this delegate to addEventListener?
        if (!$26671684de8882a2$export$b451353ebd749597(callback)) return $26671684de8882a2$export$8793edee2d425525;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$26671684de8882a2$export$cc2e736493e359e2($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
};
/**
 * Base class for Svelte components. Used when dev=false.
 */ class $26671684de8882a2$export$a9dbe146ce5e8823 {
    $destroy() {
        $26671684de8882a2$export$ddd2890b29e5aebe(this, 1);
        this.$destroy = $26671684de8882a2$export$8793edee2d425525;
    }
    $on(type, callback) {
        if (!$26671684de8882a2$export$b451353ebd749597(callback)) return $26671684de8882a2$export$8793edee2d425525;
        const callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return ()=>{
            const index = callbacks.indexOf(callback);
            if (index !== -1) callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !$26671684de8882a2$export$cc2e736493e359e2($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
}
function $26671684de8882a2$export$bf18b7db1b422af6(type, detail) {
    document.dispatchEvent($26671684de8882a2$export$da00493480283d6b(type, Object.assign({
        version: "3.59.2"
    }, detail), {
        bubbles: true
    }));
}
function $26671684de8882a2$export$e914ea5e9eb9f312(target, node) {
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node
    });
    $26671684de8882a2$export$10d8903dec122b9d(target, node);
}
function $26671684de8882a2$export$3d7d958f073d996a(target, node) {
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node
    });
    $26671684de8882a2$export$172bc581f7520fb7(target, node);
}
function $26671684de8882a2$export$f6e687e9f4e253bb(target, node, anchor) {
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node,
        anchor: anchor
    });
    $26671684de8882a2$export$21a5ca8aa77d35ff(target, node, anchor);
}
function $26671684de8882a2$export$b7da215dbd2db801(target, node, anchor) {
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMInsert", {
        target: target,
        node: node,
        anchor: anchor
    });
    $26671684de8882a2$export$f7a8880e5fbca7f8(target, node, anchor);
}
function $26671684de8882a2$export$9e710e34d240cc7b(node) {
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMRemove", {
        node: node
    });
    $26671684de8882a2$export$3f780019ff766da6(node);
}
function $26671684de8882a2$export$a21682f9877e0498(before, after) {
    while(before.nextSibling && before.nextSibling !== after)$26671684de8882a2$export$9e710e34d240cc7b(before.nextSibling);
}
function $26671684de8882a2$export$75f8da77d42fcb5(after) {
    while(after.previousSibling)$26671684de8882a2$export$9e710e34d240cc7b(after.previousSibling);
}
function $26671684de8882a2$export$c97ff19765ca3394(before) {
    while(before.nextSibling)$26671684de8882a2$export$9e710e34d240cc7b(before.nextSibling);
}
function $26671684de8882a2$export$995228cbf38b380f(node, event, handler, options, has_prevent_default, has_stop_propagation, has_stop_immediate_propagation) {
    const modifiers = options === true ? [
        "capture"
    ] : options ? Array.from(Object.keys(options)) : [];
    if (has_prevent_default) modifiers.push("preventDefault");
    if (has_stop_propagation) modifiers.push("stopPropagation");
    if (has_stop_immediate_propagation) modifiers.push("stopImmediatePropagation");
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMAddEventListener", {
        node: node,
        event: event,
        handler: handler,
        modifiers: modifiers
    });
    const dispose = $26671684de8882a2$export$63174c828edd6ff8(node, event, handler, options);
    return ()=>{
        $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMRemoveEventListener", {
            node: node,
            event: event,
            handler: handler,
            modifiers: modifiers
        });
        dispose();
    };
}
function $26671684de8882a2$export$a99ae29e763a6619(node, attribute, value) {
    $26671684de8882a2$export$7aabe8b3a840d2fd(node, attribute, value);
    if (value == null) $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMRemoveAttribute", {
        node: node,
        attribute: attribute
    });
    else $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMSetAttribute", {
        node: node,
        attribute: attribute,
        value: value
    });
}
function $26671684de8882a2$export$1a8b8000a5a2f955(node, property, value) {
    node[property] = value;
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMSetProperty", {
        node: node,
        property: property,
        value: value
    });
}
function $26671684de8882a2$export$9bdcf8c0c1039da5(node, property, value) {
    node.dataset[property] = value;
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMSetDataset", {
        node: node,
        property: property,
        value: value
    });
}
function $26671684de8882a2$export$df702e4649e15993(text, data) {
    data = "" + data;
    if (text.data === data) return;
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMSetData", {
        node: text,
        data: data
    });
    text.data = data;
}
function $26671684de8882a2$export$3eb5e573cac73e07(text, data) {
    data = "" + data;
    if (text.wholeText === data) return;
    $26671684de8882a2$export$bf18b7db1b422af6("SvelteDOMSetData", {
        node: text,
        data: data
    });
    text.data = data;
}
function $26671684de8882a2$export$3e6e8a2bfe41f53c(text, data, attr_value) {
    if (~$26671684de8882a2$export$e3d839ffa95f7481.indexOf(attr_value)) $26671684de8882a2$export$3eb5e573cac73e07(text, data);
    else $26671684de8882a2$export$df702e4649e15993(text, data);
}
function $26671684de8882a2$export$dc082ae212b9df(arg) {
    if (typeof arg !== "string" && !(arg && typeof arg === "object" && "length" in arg)) {
        let msg = "{#each} only iterates over array-like objects.";
        if (typeof Symbol === "function" && arg && Symbol.iterator in arg) msg += " You can use a spread to convert this iterable into an array.";
        throw new Error(msg);
    }
}
function $26671684de8882a2$export$d0e654d7c8c8b385(name, slot, keys) {
    for (const slot_key of Object.keys(slot))if (!~keys.indexOf(slot_key)) console.warn(`<${name}> received an unexpected slot "${slot_key}".`);
}
function $26671684de8882a2$export$3bfb1dac7720acdf(tag) {
    const is_string = typeof tag === "string";
    if (tag && !is_string) throw new Error('<svelte:element> expects "this" attribute to be a string.');
}
function $26671684de8882a2$export$604f774bac268e5a(tag) {
    if (tag && $26671684de8882a2$export$66cf70365c175aee(tag)) console.warn(`<svelte:element this="${tag}"> is self-closing and cannot have content.`);
}
function $26671684de8882a2$export$12b4fecd7d9ee1e9(component, props) {
    const error_message = "this={...} of <svelte:component> should specify a Svelte component.";
    try {
        const instance = new component(props);
        if (!instance.$$ || !instance.$set || !instance.$on || !instance.$destroy) throw new Error(error_message);
        return instance;
    } catch (err) {
        const { message: message } = err;
        if (typeof message === "string" && message.indexOf("is not a constructor") !== -1) throw new Error(error_message);
        else throw err;
    }
}
/**
 * Base class for Svelte components with some minor dev-enhancements. Used when dev=true.
 */ class $26671684de8882a2$export$5a58a898d1ca0447 extends $26671684de8882a2$export$a9dbe146ce5e8823 {
    constructor(options){
        if (!options || !options.target && !options.$$inline) throw new Error("'target' is a required option");
        super();
    }
    $destroy() {
        super.$destroy();
        this.$destroy = ()=>{
            console.warn("Component was already destroyed"); // eslint-disable-line no-console
        };
    }
    $capture_state() {}
    $inject_state() {}
}
/**
 * Base class to create strongly typed Svelte components.
 * This only exists for typing purposes and should be used in `.d.ts` files.
 *
 * ### Example:
 *
 * You have component library on npm called `component-library`, from which
 * you export a component called `MyComponent`. For Svelte+TypeScript users,
 * you want to provide typings. Therefore you create a `index.d.ts`:
 * ```ts
 * import { SvelteComponentTyped } from "svelte";
 * export class MyComponent extends SvelteComponentTyped<{foo: string}> {}
 * ```
 * Typing this makes it possible for IDEs like VS Code with the Svelte extension
 * to provide intellisense and to use the component like this in a Svelte file
 * with TypeScript:
 * ```svelte
 * <script lang="ts">
 * 	import { MyComponent } from "component-library";
 * </script>
 * <MyComponent foo={'bar'} />
 * ```
 *
 * #### Why not make this part of `SvelteComponent(Dev)`?
 * Because
 * ```ts
 * class ASubclassOfSvelteComponent extends SvelteComponent<{foo: string}> {}
 * const component: typeof SvelteComponent = ASubclassOfSvelteComponent;
 * ```
 * will throw a type error, so we need to separate the more strictly typed class.
 */ class $26671684de8882a2$export$3364bb23ce325405 extends $26671684de8882a2$export$5a58a898d1ca0447 {
    constructor(options){
        super(options);
    }
}
function $26671684de8882a2$export$3fad216b09e0538b(timeout) {
    const start = Date.now();
    return ()=>{
        if (Date.now() - start > timeout) throw new Error("Infinite loop detected");
    };
}

});


parcelRegister("1c87A", function(module, exports) {
"use strict";
var $0ded362b6be28d25$var$isMergeableObject = function isMergeableObject(value) {
    return $0ded362b6be28d25$var$isNonNullObject(value) && !$0ded362b6be28d25$var$isSpecial(value);
};
function $0ded362b6be28d25$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $0ded362b6be28d25$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $0ded362b6be28d25$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $0ded362b6be28d25$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $0ded362b6be28d25$var$REACT_ELEMENT_TYPE = $0ded362b6be28d25$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $0ded362b6be28d25$var$isReactElement(value) {
    return value.$$typeof === $0ded362b6be28d25$var$REACT_ELEMENT_TYPE;
}
function $0ded362b6be28d25$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $0ded362b6be28d25$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $0ded362b6be28d25$var$deepmerge($0ded362b6be28d25$var$emptyTarget(value), value, options) : value;
}
function $0ded362b6be28d25$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $0ded362b6be28d25$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $0ded362b6be28d25$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $0ded362b6be28d25$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $0ded362b6be28d25$var$deepmerge;
}
function $0ded362b6be28d25$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $0ded362b6be28d25$var$getKeys(target) {
    return Object.keys(target).concat($0ded362b6be28d25$var$getEnumerableOwnPropertySymbols(target));
}
function $0ded362b6be28d25$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $0ded362b6be28d25$var$propertyIsUnsafe(target, key) {
    return $0ded362b6be28d25$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $0ded362b6be28d25$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $0ded362b6be28d25$var$getKeys(target).forEach(function(key) {
        destination[key] = $0ded362b6be28d25$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $0ded362b6be28d25$var$getKeys(source).forEach(function(key) {
        if ($0ded362b6be28d25$var$propertyIsUnsafe(target, key)) return;
        if ($0ded362b6be28d25$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $0ded362b6be28d25$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $0ded362b6be28d25$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $0ded362b6be28d25$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $0ded362b6be28d25$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $0ded362b6be28d25$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $0ded362b6be28d25$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $0ded362b6be28d25$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $0ded362b6be28d25$var$mergeObject(target, source, options);
}
$0ded362b6be28d25$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $0ded362b6be28d25$var$deepmerge(prev, next, options);
    }, {});
};
var $0ded362b6be28d25$var$deepmerge_1 = $0ded362b6be28d25$var$deepmerge;
module.exports = $0ded362b6be28d25$var$deepmerge_1;

});

parcelRegister("5WNqo", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $4548b53adb3a8124$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $fxST9 = parcelRequire("fxST9");

var $dzjjS = parcelRequire("dzjjS");

var $9Swl3 = parcelRequire("9Swl3");

var $js6Vs = parcelRequire("js6Vs");
// -- MessageFormat --------------------------------------------------------
function $4548b53adb3a8124$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $fxST9.__assign)((0, $fxST9.__assign)((0, $fxST9.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $fxST9.__assign)((0, $fxST9.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $4548b53adb3a8124$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $4548b53adb3a8124$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $fxST9.__assign)({}, defaultConfig));
}
function $4548b53adb3a8124$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $4548b53adb3a8124$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $9Swl3.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $fxST9.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4548b53adb3a8124$var$createFastMemoizeCache(cache.number),
            strategy: (0, $9Swl3.strategies).variadic
        }),
        getDateTimeFormat: (0, $9Swl3.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $fxST9.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4548b53adb3a8124$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $9Swl3.strategies).variadic
        }),
        getPluralRules: (0, $9Swl3.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $fxST9.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $4548b53adb3a8124$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $9Swl3.strategies).variadic
        })
    };
}
var $4548b53adb3a8124$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $js6Vs.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $js6Vs.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $4548b53adb3a8124$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $4548b53adb3a8124$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $dzjjS.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("dzjjS", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("3RZni")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("3RZni")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("3RZni")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("3RZni")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("3RZni")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("3RZni")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("3RZni")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("3RZni")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("3RZni")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("3RZni")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("3RZni")).isTimeElement; });

$parcel$export(module.exports, "parse", function () { return $9e0d87b6865ea770$export$98e6a39c04603d36; });

var $fxST9 = parcelRequire("fxST9");

var $b2GYE = parcelRequire("b2GYE");

var $9H7mZ = parcelRequire("9H7mZ");

var $3RZni = parcelRequire("3RZni");
function $9e0d87b6865ea770$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $3RZni.isSelectElement)(el) || (0, $3RZni.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $9e0d87b6865ea770$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $3RZni.isNumberElement)(el) && (0, $3RZni.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $3RZni.isDateElement)(el) || (0, $3RZni.isTimeElement)(el)) && (0, $3RZni.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $3RZni.isTagElement)(el)) $9e0d87b6865ea770$var$pruneLocation(el.children);
    });
}
function $9e0d87b6865ea770$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $fxST9.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $9H7mZ.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $b2GYE.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $9e0d87b6865ea770$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("b2GYE", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $80a137fde016d8f7$export$896afd8541959ee5; });
var $80a137fde016d8f7$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($80a137fde016d8f7$export$896afd8541959ee5 || ($80a137fde016d8f7$export$896afd8541959ee5 = {}));

});

parcelRegister("9H7mZ", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $70edd8b46de8b5b4$export$7acfa6ed01010e37; });

var $fxST9 = parcelRequire("fxST9");

var $b2GYE = parcelRequire("b2GYE");

var $3RZni = parcelRequire("3RZni");

var $fiO44 = parcelRequire("fiO44");
parcelRequire("aScrz");
var $8RZON = parcelRequire("8RZON");
var $imgHQ = parcelRequire("imgHQ");

var $8qTHa = parcelRequire("8qTHa");
var $70edd8b46de8b5b4$var$_a;
var $70edd8b46de8b5b4$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $fiO44.SPACE_SEPARATOR_REGEX).source, "*"));
var $70edd8b46de8b5b4$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $fiO44.SPACE_SEPARATOR_REGEX).source, "*$"));
function $70edd8b46de8b5b4$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $70edd8b46de8b5b4$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $70edd8b46de8b5b4$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $70edd8b46de8b5b4$var$hasNativeFromEntries = !!Object.fromEntries;
var $70edd8b46de8b5b4$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $70edd8b46de8b5b4$var$hasTrimStart = !!String.prototype.trimStart;
var $70edd8b46de8b5b4$var$hasTrimEnd = !!String.prototype.trimEnd;
var $70edd8b46de8b5b4$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $70edd8b46de8b5b4$var$isSafeInteger = $70edd8b46de8b5b4$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $70edd8b46de8b5b4$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $70edd8b46de8b5b4$var$re = $70edd8b46de8b5b4$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $70edd8b46de8b5b4$var$REGEX_SUPPORTS_U_AND_Y = (($70edd8b46de8b5b4$var$_a = $70edd8b46de8b5b4$var$re.exec("a")) === null || $70edd8b46de8b5b4$var$_a === void 0 ? void 0 : $70edd8b46de8b5b4$var$_a[0]) === "a";
} catch (_) {
    $70edd8b46de8b5b4$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $70edd8b46de8b5b4$var$startsWith = $70edd8b46de8b5b4$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $70edd8b46de8b5b4$var$fromCodePoint = $70edd8b46de8b5b4$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $70edd8b46de8b5b4$var$fromEntries = // native
$70edd8b46de8b5b4$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $70edd8b46de8b5b4$var$codePointAt = $70edd8b46de8b5b4$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $70edd8b46de8b5b4$var$trimStart = $70edd8b46de8b5b4$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($70edd8b46de8b5b4$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $70edd8b46de8b5b4$var$trimEnd = $70edd8b46de8b5b4$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($70edd8b46de8b5b4$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $70edd8b46de8b5b4$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $70edd8b46de8b5b4$var$matchIdentifierAtIndex;
if ($70edd8b46de8b5b4$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $70edd8b46de8b5b4$var$IDENTIFIER_PREFIX_RE_1 = $70edd8b46de8b5b4$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $70edd8b46de8b5b4$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $70edd8b46de8b5b4$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $70edd8b46de8b5b4$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$70edd8b46de8b5b4$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $70edd8b46de8b5b4$var$codePointAt(s, index);
        if (c === undefined || $70edd8b46de8b5b4$var$_isWhiteSpace(c) || $70edd8b46de8b5b4$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $70edd8b46de8b5b4$var$fromCodePoint.apply(void 0, match);
};
var $70edd8b46de8b5b4$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $3RZni.TYPE).pound,
                    location: $70edd8b46de8b5b4$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $b2GYE.ErrorKind).UNMATCHED_CLOSING_TAG, $70edd8b46de8b5b4$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $70edd8b46de8b5b4$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $3RZni.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $70edd8b46de8b5b4$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$70edd8b46de8b5b4$var$_isAlpha(this.char())) return this.error((0, $b2GYE.ErrorKind).INVALID_TAG, $70edd8b46de8b5b4$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $b2GYE.ErrorKind).UNMATCHED_CLOSING_TAG, $70edd8b46de8b5b4$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $b2GYE.ErrorKind).INVALID_TAG, $70edd8b46de8b5b4$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $3RZni.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $70edd8b46de8b5b4$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $b2GYE.ErrorKind).UNCLOSED_TAG, $70edd8b46de8b5b4$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $b2GYE.ErrorKind).INVALID_TAG, $70edd8b46de8b5b4$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $70edd8b46de8b5b4$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $70edd8b46de8b5b4$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $3RZni.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$70edd8b46de8b5b4$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $70edd8b46de8b5b4$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $70edd8b46de8b5b4$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $b2GYE.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $b2GYE.ErrorKind).EMPTY_ARGUMENT, $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $b2GYE.ErrorKind).MALFORMED_ARGUMENT, $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $b2GYE.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $3RZni.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $b2GYE.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $b2GYE.ErrorKind).MALFORMED_ARGUMENT, $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $70edd8b46de8b5b4$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $70edd8b46de8b5b4$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $b2GYE.ErrorKind).EXPECT_ARGUMENT_TYPE, $70edd8b46de8b5b4$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $70edd8b46de8b5b4$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $b2GYE.ErrorKind).EXPECT_ARGUMENT_STYLE, $70edd8b46de8b5b4$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $70edd8b46de8b5b4$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $70edd8b46de8b5b4$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $70edd8b46de8b5b4$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $3RZni.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $b2GYE.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $8qTHa.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $3RZni.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $8RZON.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $3RZni.TYPE).date : (0, $3RZni.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $3RZni.TYPE).number : argType === "date" ? (0, $3RZni.TYPE).date : (0, $3RZni.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $b2GYE.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $70edd8b46de8b5b4$var$createLocation(typeEndPosition_1, (0, $fxST9.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $b2GYE.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $70edd8b46de8b5b4$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $b2GYE.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $b2GYE.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $3RZni.TYPE).select,
                        value: value,
                        options: $70edd8b46de8b5b4$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $3RZni.TYPE).plural,
                        value: value,
                        options: $70edd8b46de8b5b4$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $b2GYE.ErrorKind).INVALID_ARGUMENT_TYPE, $70edd8b46de8b5b4$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $b2GYE.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $b2GYE.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $70edd8b46de8b5b4$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $imgHQ.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $b2GYE.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $3RZni.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $imgHQ.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $b2GYE.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $b2GYE.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $70edd8b46de8b5b4$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $b2GYE.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $b2GYE.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $b2GYE.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $b2GYE.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $70edd8b46de8b5b4$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $70edd8b46de8b5b4$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $b2GYE.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $b2GYE.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $70edd8b46de8b5b4$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $b2GYE.ErrorKind).MISSING_OTHER_CLAUSE, $70edd8b46de8b5b4$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $70edd8b46de8b5b4$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$70edd8b46de8b5b4$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $70edd8b46de8b5b4$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($70edd8b46de8b5b4$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $70edd8b46de8b5b4$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $70edd8b46de8b5b4$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $70edd8b46de8b5b4$var$_isAlphaOrSlash(codepoint) {
    return $70edd8b46de8b5b4$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $70edd8b46de8b5b4$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $70edd8b46de8b5b4$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $70edd8b46de8b5b4$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("3RZni", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $2d15ee19f3b87d0c$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $2d15ee19f3b87d0c$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $2d15ee19f3b87d0c$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $2d15ee19f3b87d0c$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $2d15ee19f3b87d0c$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $2d15ee19f3b87d0c$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $2d15ee19f3b87d0c$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $2d15ee19f3b87d0c$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $2d15ee19f3b87d0c$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $2d15ee19f3b87d0c$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $2d15ee19f3b87d0c$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $2d15ee19f3b87d0c$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $2d15ee19f3b87d0c$export$7680c41f1a55f4cf; });
var $2d15ee19f3b87d0c$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($2d15ee19f3b87d0c$export$b87f371cbc396fcf || ($2d15ee19f3b87d0c$export$b87f371cbc396fcf = {}));
var $2d15ee19f3b87d0c$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($2d15ee19f3b87d0c$export$906452485466fa53 || ($2d15ee19f3b87d0c$export$906452485466fa53 = {}));
function $2d15ee19f3b87d0c$export$cfa10c5697238752(el) {
    return el.type === $2d15ee19f3b87d0c$export$b87f371cbc396fcf.literal;
}
function $2d15ee19f3b87d0c$export$4f55724281bdfaf9(el) {
    return el.type === $2d15ee19f3b87d0c$export$b87f371cbc396fcf.argument;
}
function $2d15ee19f3b87d0c$export$e11187b219e191e1(el) {
    return el.type === $2d15ee19f3b87d0c$export$b87f371cbc396fcf.number;
}
function $2d15ee19f3b87d0c$export$32d811605da75f40(el) {
    return el.type === $2d15ee19f3b87d0c$export$b87f371cbc396fcf.date;
}
function $2d15ee19f3b87d0c$export$34ec46f596b1702f(el) {
    return el.type === $2d15ee19f3b87d0c$export$b87f371cbc396fcf.time;
}
function $2d15ee19f3b87d0c$export$dcfe1c11d168b5a1(el) {
    return el.type === $2d15ee19f3b87d0c$export$b87f371cbc396fcf.select;
}
function $2d15ee19f3b87d0c$export$6c796d116f0a4fbc(el) {
    return el.type === $2d15ee19f3b87d0c$export$b87f371cbc396fcf.plural;
}
function $2d15ee19f3b87d0c$export$c0ece297bdd0c082(el) {
    return el.type === $2d15ee19f3b87d0c$export$b87f371cbc396fcf.pound;
}
function $2d15ee19f3b87d0c$export$5c83de34745812b(el) {
    return el.type === $2d15ee19f3b87d0c$export$b87f371cbc396fcf.tag;
}
function $2d15ee19f3b87d0c$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $2d15ee19f3b87d0c$export$906452485466fa53.number);
}
function $2d15ee19f3b87d0c$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $2d15ee19f3b87d0c$export$906452485466fa53.dateTime);
}
function $2d15ee19f3b87d0c$export$f0ac572c1121c662(value) {
    return {
        type: $2d15ee19f3b87d0c$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $2d15ee19f3b87d0c$export$425e864b0ba114f1(value, style) {
    return {
        type: $2d15ee19f3b87d0c$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("fiO44", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $b23f5f3a9d3e71dd$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $b23f5f3a9d3e71dd$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $b23f5f3a9d3e71dd$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("aScrz", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("8RZON")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("imgHQ")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("imgHQ")).parseNumberSkeletonFromString; });
parcelRequire("8RZON");
parcelRequire("imgHQ");

});
parcelRegister("8RZON", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $675339c8ab95b89f$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $675339c8ab95b89f$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $675339c8ab95b89f$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($675339c8ab95b89f$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("imgHQ", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $d5d73d8b8ddaf499$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $d5d73d8b8ddaf499$export$47c6f8480bda3e11; });

var $fxST9 = parcelRequire("fxST9");

var $1geKd = parcelRequire("1geKd");
function $d5d73d8b8ddaf499$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $1geKd.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $d5d73d8b8ddaf499$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $d5d73d8b8ddaf499$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $d5d73d8b8ddaf499$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $d5d73d8b8ddaf499$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $d5d73d8b8ddaf499$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $d5d73d8b8ddaf499$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($d5d73d8b8ddaf499$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $d5d73d8b8ddaf499$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $d5d73d8b8ddaf499$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$d5d73d8b8ddaf499$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $d5d73d8b8ddaf499$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $d5d73d8b8ddaf499$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $d5d73d8b8ddaf499$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $d5d73d8b8ddaf499$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $fxST9.__assign)((0, $fxST9.__assign)((0, $fxST9.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $fxST9.__assign)((0, $fxST9.__assign)({}, all), $d5d73d8b8ddaf499$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $fxST9.__assign)((0, $fxST9.__assign)((0, $fxST9.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $fxST9.__assign)((0, $fxST9.__assign)({}, all), $d5d73d8b8ddaf499$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($d5d73d8b8ddaf499$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($d5d73d8b8ddaf499$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($d5d73d8b8ddaf499$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($d5d73d8b8ddaf499$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $fxST9.__assign)((0, $fxST9.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $fxST9.__assign)((0, $fxST9.__assign)({}, result), $d5d73d8b8ddaf499$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($d5d73d8b8ddaf499$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $fxST9.__assign)((0, $fxST9.__assign)({}, result), $d5d73d8b8ddaf499$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $d5d73d8b8ddaf499$var$parseSign(token.stem);
        if (signOpts) result = (0, $fxST9.__assign)((0, $fxST9.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $d5d73d8b8ddaf499$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $fxST9.__assign)((0, $fxST9.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("1geKd", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $0eb2b8f9a6a6c7b9$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $0eb2b8f9a6a6c7b9$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("8qTHa", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $623bf459e318bde4$export$29c5368be8904d27; });

var $bufnb = parcelRequire("bufnb");
function $623bf459e318bde4$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $623bf459e318bde4$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $623bf459e318bde4$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $bufnb.timeData)[regionTag || ""] || (0, $bufnb.timeData)[languageTag || ""] || (0, $bufnb.timeData)["".concat(languageTag, "-001")] || (0, $bufnb.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("bufnb", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $85ce6bc7ccc75f8d$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $85ce6bc7ccc75f8d$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("9Swl3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73123df21edd796f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "strategies", function () { return $73123df21edd796f$export$c5491a8691a23b9e; });
//
// Main
//
function $73123df21edd796f$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $73123df21edd796f$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $73123df21edd796f$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $73123df21edd796f$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $73123df21edd796f$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $73123df21edd796f$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $73123df21edd796f$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $73123df21edd796f$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $73123df21edd796f$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $73123df21edd796f$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $73123df21edd796f$var$monadic : $73123df21edd796f$var$variadic;
    return $73123df21edd796f$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $73123df21edd796f$var$strategyVariadic(fn, options) {
    return $73123df21edd796f$var$assemble(fn, this, $73123df21edd796f$var$variadic, options.cache.create(), options.serializer);
}
function $73123df21edd796f$var$strategyMonadic(fn, options) {
    return $73123df21edd796f$var$assemble(fn, this, $73123df21edd796f$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $73123df21edd796f$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $73123df21edd796f$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$73123df21edd796f$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$73123df21edd796f$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $73123df21edd796f$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $73123df21edd796f$var$ObjectWithoutPrototypeCache();
    }
};
var $73123df21edd796f$export$c5491a8691a23b9e = {
    variadic: $73123df21edd796f$var$strategyVariadic,
    monadic: $73123df21edd796f$var$strategyMonadic
};

});

parcelRegister("js6Vs", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $e29601225ec43cc1$export$49694c2877b44c57; });
$parcel$export(module.exports, "formatToParts", function () { return $e29601225ec43cc1$export$275d4a3bb5f66fda; });
parcelRequire("dzjjS");
var $3RZni = parcelRequire("3RZni");

var $hfSJo = parcelRequire("hfSJo");
var $e29601225ec43cc1$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($e29601225ec43cc1$export$49694c2877b44c57 || ($e29601225ec43cc1$export$49694c2877b44c57 = {}));
function $e29601225ec43cc1$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $e29601225ec43cc1$export$49694c2877b44c57.literal || part.type !== $e29601225ec43cc1$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $e29601225ec43cc1$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $e29601225ec43cc1$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $3RZni.isLiteralElement)(els[0])) return [
        {
            type: $e29601225ec43cc1$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $3RZni.isLiteralElement)(el)) {
            result.push({
                type: $e29601225ec43cc1$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $3RZni.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $e29601225ec43cc1$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $hfSJo.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $3RZni.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $e29601225ec43cc1$export$49694c2877b44c57.literal : $e29601225ec43cc1$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $3RZni.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $3RZni.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $e29601225ec43cc1$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $3RZni.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $3RZni.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $e29601225ec43cc1$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $3RZni.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $3RZni.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $e29601225ec43cc1$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $3RZni.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$e29601225ec43cc1$export$df0c12a2d414a163(formatFn)) throw new (0, $hfSJo.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $e29601225ec43cc1$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $e29601225ec43cc1$export$49694c2877b44c57.literal : $e29601225ec43cc1$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $3RZni.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $hfSJo.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $e29601225ec43cc1$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $3RZni.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $hfSJo.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $hfSJo.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $hfSJo.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $e29601225ec43cc1$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $e29601225ec43cc1$var$mergeLiteral(result);
}

});
parcelRegister("hfSJo", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $c8fe4ad5b18fe89d$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $c8fe4ad5b18fe89d$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $c8fe4ad5b18fe89d$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $c8fe4ad5b18fe89d$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $c8fe4ad5b18fe89d$export$8bfc137e4d23fdf0; });

var $fxST9 = parcelRequire("fxST9");
var $c8fe4ad5b18fe89d$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($c8fe4ad5b18fe89d$export$d4e71bc0b80dc0fb || ($c8fe4ad5b18fe89d$export$d4e71bc0b80dc0fb = {}));
var $c8fe4ad5b18fe89d$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $fxST9.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $c8fe4ad5b18fe89d$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $fxST9.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $c8fe4ad5b18fe89d$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($c8fe4ad5b18fe89d$export$7369836851cc1329);
var $c8fe4ad5b18fe89d$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $fxST9.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $c8fe4ad5b18fe89d$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($c8fe4ad5b18fe89d$export$7369836851cc1329);
var $c8fe4ad5b18fe89d$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $fxST9.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $c8fe4ad5b18fe89d$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($c8fe4ad5b18fe89d$export$7369836851cc1329);

});




parcelRegister("fEL8l", function(module, exports) {

$parcel$export(module.exports, "nanoid", function () { return $b65f272cfe63a199$export$ac4959f4f1338dfc; });

let $b65f272cfe63a199$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $b65f272cfe63a199$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $b65f272cfe63a199$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$b65f272cfe63a199$export$a5cee9e955a615e5(alphabet, size, $b65f272cfe63a199$export$4385e60b38654f68);
let $b65f272cfe63a199$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

});

parcelRegister("6zFHJ", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(self, ()=>{
    var e, t;
    return e = {
        7629: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(9474), i = r(1687), o = r(8652), l = r(8160), c = r(3292), u = r(6354), f = r(8901), h = r(9708), m = r(6914), d = r(2294), p = r(6133), g = r(1152), y = r(8863), b = r(2036), v = {
                Base: class {
                    constructor(e){
                        this.type = e, this.$_root = null, this._definition = {}, this._reset();
                    }
                    _reset() {
                        this._ids = new d.Ids, this._preferences = null, this._refs = new p.Manager, this._cache = null, this._valids = null, this._invalids = null, this._flags = {}, this._rules = [], this._singleRules = new Map, this.$_terms = {}, this.$_temp = {
                            ruleset: null,
                            whens: {}
                        };
                    }
                    describe() {
                        return s("function" == typeof h.describe, "Manifest functionality disabled"), h.describe(this);
                    }
                    allow() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        return l.verifyFlat(t, "allow"), this._values(t, "_valids");
                    }
                    alter(e) {
                        s(e && "object" == typeof e && !Array.isArray(e), "Invalid targets argument"), s(!this._inRuleset(), "Cannot set alterations inside a ruleset");
                        const t = this.clone();
                        t.$_terms.alterations = t.$_terms.alterations || [];
                        for(const r in e){
                            const n = e[r];
                            s("function" == typeof n, "Alteration adjuster for", r, "must be a function"), t.$_terms.alterations.push({
                                target: r,
                                adjuster: n
                            });
                        }
                        return t.$_temp.ruleset = !1, t;
                    }
                    artifact(e) {
                        return s(void 0 !== e, "Artifact cannot be undefined"), s(!this._cache, "Cannot set an artifact with a rule cache"), this.$_setFlag("artifact", e);
                    }
                    cast(e) {
                        return s(!1 === e || "string" == typeof e, "Invalid to value"), s(!1 === e || this._definition.cast[e], "Type", this.type, "does not support casting to", e), this.$_setFlag("cast", !1 === e ? void 0 : e);
                    }
                    default(e, t) {
                        return this._default("default", e, t);
                    }
                    description(e) {
                        return s(e && "string" == typeof e, "Description must be a non-empty string"), this.$_setFlag("description", e);
                    }
                    empty(e) {
                        const t = this.clone();
                        return void 0 !== e && (e = t.$_compile(e, {
                            override: !1
                        })), t.$_setFlag("empty", e, {
                            clone: !1
                        });
                    }
                    error(e) {
                        return s(e, "Missing error"), s(e instanceof Error || "function" == typeof e, "Must provide a valid Error object or a function"), this.$_setFlag("error", e);
                    }
                    example(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return s(void 0 !== e, "Missing example"), l.assertOptions(t, [
                            "override"
                        ]), this._inner("examples", e, {
                            single: !0,
                            override: t.override
                        });
                    }
                    external(e, t) {
                        return "object" == typeof e && (s(!t, "Cannot combine options with description"), t = e.description, e = e.method), s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this._inner("externals", {
                            method: e,
                            description: t
                        }, {
                            single: !0
                        });
                    }
                    failover(e, t) {
                        return this._default("failover", e, t);
                    }
                    forbidden() {
                        return this.presence("forbidden");
                    }
                    id(e) {
                        return e ? (s("string" == typeof e, "id must be a non-empty string"), s(/^[^\.]+$/.test(e), "id cannot contain period character"), this.$_setFlag("id", e)) : this.$_setFlag("id", void 0);
                    }
                    invalid() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        return this._values(t, "_invalids");
                    }
                    label(e) {
                        return s(e && "string" == typeof e, "Label name must be a non-empty string"), this.$_setFlag("label", e);
                    }
                    meta(e) {
                        return s(void 0 !== e, "Meta cannot be undefined"), this._inner("metas", e, {
                            single: !0
                        });
                    }
                    note() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        s(t.length, "Missing notes");
                        for (const e of t)s(e && "string" == typeof e, "Notes must be non-empty strings");
                        return this._inner("notes", t);
                    }
                    only() {
                        let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        return s("boolean" == typeof e, "Invalid mode:", e), this.$_setFlag("only", e);
                    }
                    optional() {
                        return this.presence("optional");
                    }
                    prefs(e) {
                        s(e, "Missing preferences"), s(void 0 === e.context, "Cannot override context"), s(void 0 === e.externals, "Cannot override externals"), s(void 0 === e.warnings, "Cannot override warnings"), s(void 0 === e.debug, "Cannot override debug"), l.checkPreferences(e);
                        const t = this.clone();
                        return t._preferences = l.preferences(t._preferences, e), t;
                    }
                    presence(e) {
                        return s([
                            "optional",
                            "required",
                            "forbidden"
                        ].includes(e), "Unknown presence mode", e), this.$_setFlag("presence", e);
                    }
                    raw() {
                        let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        return this.$_setFlag("result", e ? "raw" : void 0);
                    }
                    result(e) {
                        return s([
                            "raw",
                            "strip"
                        ].includes(e), "Unknown result mode", e), this.$_setFlag("result", e);
                    }
                    required() {
                        return this.presence("required");
                    }
                    strict(e) {
                        const t = this.clone(), r = void 0 !== e && !e;
                        return t._preferences = l.preferences(t._preferences, {
                            convert: r
                        }), t;
                    }
                    strip() {
                        let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        return this.$_setFlag("result", e ? "strip" : void 0);
                    }
                    tag() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        s(t.length, "Missing tags");
                        for (const e of t)s(e && "string" == typeof e, "Tags must be non-empty strings");
                        return this._inner("tags", t);
                    }
                    unit(e) {
                        return s(e && "string" == typeof e, "Unit name must be a non-empty string"), this.$_setFlag("unit", e);
                    }
                    valid() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        l.verifyFlat(t, "valid");
                        const s = this.allow(...t);
                        return s.$_setFlag("only", !!s._valids, {
                            clone: !1
                        }), s;
                    }
                    when(e, t) {
                        const r = this.clone();
                        r.$_terms.whens || (r.$_terms.whens = []);
                        const n = c.when(r, e, t);
                        if (![
                            "any",
                            "link"
                        ].includes(r.type)) {
                            const e = n.is ? [
                                n
                            ] : n.switch;
                            for (const t of e)s(!t.then || "any" === t.then.type || t.then.type === r.type, "Cannot combine", r.type, "with", t.then && t.then.type), s(!t.otherwise || "any" === t.otherwise.type || t.otherwise.type === r.type, "Cannot combine", r.type, "with", t.otherwise && t.otherwise.type);
                        }
                        return r.$_terms.whens.push(n), r.$_mutateRebuild();
                    }
                    cache(e) {
                        s(!this._inRuleset(), "Cannot set caching inside a ruleset"), s(!this._cache, "Cannot override schema cache"), s(void 0 === this._flags.artifact, "Cannot cache a rule with an artifact");
                        const t = this.clone();
                        return t._cache = e || o.provider.provision(), t.$_temp.ruleset = !1, t;
                    }
                    clone() {
                        const e = Object.create(Object.getPrototypeOf(this));
                        return this._assign(e);
                    }
                    concat(e) {
                        s(l.isSchema(e), "Invalid schema object"), s("any" === this.type || "any" === e.type || e.type === this.type, "Cannot merge type", this.type, "with another type:", e.type), s(!this._inRuleset(), "Cannot concatenate onto a schema with open ruleset"), s(!e._inRuleset(), "Cannot concatenate a schema with open ruleset");
                        let t = this.clone();
                        if ("any" === this.type && "any" !== e.type) {
                            const r = e.clone();
                            for (const e of Object.keys(t))"type" !== e && (r[e] = t[e]);
                            t = r;
                        }
                        t._ids.concat(e._ids), t._refs.register(e, p.toSibling), t._preferences = t._preferences ? l.preferences(t._preferences, e._preferences) : e._preferences, t._valids = b.merge(t._valids, e._valids, e._invalids), t._invalids = b.merge(t._invalids, e._invalids, e._valids);
                        for (const r of e._singleRules.keys())t._singleRules.has(r) && (t._rules = t._rules.filter((e)=>e.keep || e.name !== r), t._singleRules.delete(r));
                        for (const r of e._rules)e._definition.rules[r.method].multi || t._singleRules.set(r.name, r), t._rules.push(r);
                        if (t._flags.empty && e._flags.empty) {
                            t._flags.empty = t._flags.empty.concat(e._flags.empty);
                            const r = Object.assign({}, e._flags);
                            delete r.empty, i(t._flags, r);
                        } else if (e._flags.empty) {
                            t._flags.empty = e._flags.empty;
                            const r = Object.assign({}, e._flags);
                            delete r.empty, i(t._flags, r);
                        } else i(t._flags, e._flags);
                        for(const r in e.$_terms){
                            const s = e.$_terms[r];
                            s ? t.$_terms[r] ? t.$_terms[r] = t.$_terms[r].concat(s) : t.$_terms[r] = s.slice() : t.$_terms[r] || (t.$_terms[r] = s);
                        }
                        return this.$_root._tracer && this.$_root._tracer._combine(t, [
                            this,
                            e
                        ]), t.$_mutateRebuild();
                    }
                    extend(e) {
                        return s(!e.base, "Cannot extend type with another base"), f.type(this, e);
                    }
                    extract(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.reach(e);
                    }
                    fork(e, t) {
                        s(!this._inRuleset(), "Cannot fork inside a ruleset");
                        let r = this;
                        for (let s of [].concat(e))s = Array.isArray(s) ? s : s.split("."), r = r._ids.fork(s, t, r);
                        return r.$_temp.ruleset = !1, r;
                    }
                    rule(e) {
                        const t = this._definition;
                        l.assertOptions(e, Object.keys(t.modifiers)), s(!1 !== this.$_temp.ruleset, "Cannot apply rules to empty ruleset or the last rule added does not support rule properties");
                        const r = null === this.$_temp.ruleset ? this._rules.length - 1 : this.$_temp.ruleset;
                        s(r >= 0 && r < this._rules.length, "Cannot apply rules to empty ruleset");
                        const a = this.clone();
                        for(let i = r; i < a._rules.length; ++i){
                            const r = a._rules[i], o = n(r);
                            for(const n in e)t.modifiers[n](o, e[n]), s(o.name === r.name, "Cannot change rule name");
                            a._rules[i] = o, a._singleRules.get(o.name) === r && a._singleRules.set(o.name, o);
                        }
                        return a.$_temp.ruleset = !1, a.$_mutateRebuild();
                    }
                    get ruleset() {
                        s(!this._inRuleset(), "Cannot start a new ruleset without closing the previous one");
                        const e = this.clone();
                        return e.$_temp.ruleset = e._rules.length, e;
                    }
                    get $() {
                        return this.ruleset;
                    }
                    tailor(e) {
                        e = [].concat(e), s(!this._inRuleset(), "Cannot tailor inside a ruleset");
                        let t = this;
                        if (this.$_terms.alterations) for (const { target: r, adjuster: n } of this.$_terms.alterations)e.includes(r) && (t = n(t), s(l.isSchema(t), "Alteration adjuster for", r, "failed to return a schema object"));
                        return t = t.$_modify({
                            each: (t)=>t.tailor(e),
                            ref: !1
                        }), t.$_temp.ruleset = !1, t.$_mutateRebuild();
                    }
                    tracer() {
                        return g.location ? g.location(this) : this;
                    }
                    validate(e, t) {
                        return y.entry(e, this, t);
                    }
                    validateAsync(e, t) {
                        return y.entryAsync(e, this, t);
                    }
                    $_addRule(e) {
                        "string" == typeof e && (e = {
                            name: e
                        }), s(e && "object" == typeof e, "Invalid options"), s(e.name && "string" == typeof e.name, "Invalid rule name");
                        for(const t in e)s("_" !== t[0], "Cannot set private rule properties");
                        const t = Object.assign({}, e);
                        t._resolve = [], t.method = t.method || t.name;
                        const r = this._definition.rules[t.method], n = t.args;
                        s(r, "Unknown rule", t.method);
                        const a = this.clone();
                        if (n) {
                            s(1 === Object.keys(n).length || Object.keys(n).length === this._definition.rules[t.name].args.length, "Invalid rule definition for", this.type, t.name);
                            for(const e in n){
                                let i = n[e];
                                if (r.argsByName) {
                                    const o = r.argsByName.get(e);
                                    if (o.ref && l.isResolvable(i)) t._resolve.push(e), a.$_mutateRegister(i);
                                    else if (o.normalize && (i = o.normalize(i), n[e] = i), o.assert) {
                                        const t = l.validateArg(i, e, o);
                                        s(!t, t, "or reference");
                                    }
                                }
                                void 0 !== i ? n[e] = i : delete n[e];
                            }
                        }
                        return r.multi || (a._ruleRemove(t.name, {
                            clone: !1
                        }), a._singleRules.set(t.name, t)), !1 === a.$_temp.ruleset && (a.$_temp.ruleset = null), r.priority ? a._rules.unshift(t) : a._rules.push(t), a;
                    }
                    $_compile(e, t) {
                        return c.schema(this.$_root, e, t);
                    }
                    $_createError(e, t, r, s, n) {
                        let a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
                        const i = !1 !== a.flags ? this._flags : {}, o = a.messages ? m.merge(this._definition.messages, a.messages) : this._definition.messages;
                        return new u.Report(e, t, r, i, o, s, n);
                    }
                    $_getFlag(e) {
                        return this._flags[e];
                    }
                    $_getRule(e) {
                        return this._singleRules.get(e);
                    }
                    $_mapLabels(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.labels(e);
                    }
                    $_match(e, t, r, s) {
                        (r = Object.assign({}, r)).abortEarly = !0, r._externals = !1, t.snapshot();
                        const n = !y.validate(e, this, t, r, s).errors;
                        return t.restore(), n;
                    }
                    $_modify(e) {
                        return l.assertOptions(e, [
                            "each",
                            "once",
                            "ref",
                            "schema"
                        ]), d.schema(this, e) || this;
                    }
                    $_mutateRebuild() {
                        return s(!this._inRuleset(), "Cannot add this rule inside a ruleset"), this._refs.reset(), this._ids.reset(), this.$_modify({
                            each: (e, t)=>{
                                let { source: r, name: s, path: n, key: a } = t;
                                const i = this._definition[r][s] && this._definition[r][s].register;
                                !1 !== i && this.$_mutateRegister(e, {
                                    family: i,
                                    key: a
                                });
                            }
                        }), this._definition.rebuild && this._definition.rebuild(this), this.$_temp.ruleset = !1, this;
                    }
                    $_mutateRegister(e) {
                        let { family: t, key: r } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        this._refs.register(e, t), this._ids.register(e, {
                            key: r
                        });
                    }
                    $_property(e) {
                        return this._definition.properties[e];
                    }
                    $_reach(e) {
                        return this._ids.reach(e);
                    }
                    $_rootReferences() {
                        return this._refs.roots();
                    }
                    $_setFlag(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        s("_" === e[0] || !this._inRuleset(), "Cannot set flag inside a ruleset");
                        const n = this._definition.flags[e] || {};
                        if (a(t, n.default) && (t = void 0), a(t, this._flags[e])) return this;
                        const i = !1 !== r.clone ? this.clone() : this;
                        return void 0 !== t ? (i._flags[e] = t, i.$_mutateRegister(t)) : delete i._flags[e], "_" !== e[0] && (i.$_temp.ruleset = !1), i;
                    }
                    $_parent(e) {
                        for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)r[s - 1] = arguments[s];
                        return this[e][l.symbols.parent].call(this, ...r);
                    }
                    $_validate(e, t, r) {
                        return y.validate(e, this, t, r);
                    }
                    _assign(e) {
                        e.type = this.type, e.$_root = this.$_root, e.$_temp = Object.assign({}, this.$_temp), e.$_temp.whens = {}, e._ids = this._ids.clone(), e._preferences = this._preferences, e._valids = this._valids && this._valids.clone(), e._invalids = this._invalids && this._invalids.clone(), e._rules = this._rules.slice(), e._singleRules = n(this._singleRules, {
                            shallow: !0
                        }), e._refs = this._refs.clone(), e._flags = Object.assign({}, this._flags), e._cache = null, e.$_terms = {};
                        for(const t in this.$_terms)e.$_terms[t] = this.$_terms[t] ? this.$_terms[t].slice() : null;
                        e.$_super = {};
                        for(const t in this.$_super)e.$_super[t] = this._super[t].bind(e);
                        return e;
                    }
                    _bare() {
                        const e = this.clone();
                        e._reset();
                        const t = e._definition.terms;
                        for(const r in t){
                            const s = t[r];
                            e.$_terms[r] = s.init;
                        }
                        return e.$_mutateRebuild();
                    }
                    _default(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        return l.assertOptions(r, "literal"), s(void 0 !== t, "Missing", e, "value"), s("function" == typeof t || !r.literal, "Only function value supports literal option"), "function" == typeof t && r.literal && (t = {
                            [l.symbols.literal]: !0,
                            literal: t
                        }), this.$_setFlag(e, t);
                    }
                    _generate(e, t, r) {
                        if (!this.$_terms.whens) return {
                            schema: this
                        };
                        const s = [], n = [];
                        for(let a = 0; a < this.$_terms.whens.length; ++a){
                            const i = this.$_terms.whens[a];
                            if (i.concat) {
                                s.push(i.concat), n.push(`${a}.concat`);
                                continue;
                            }
                            const o = i.ref ? i.ref.resolve(e, t, r) : e, l = i.is ? [
                                i
                            ] : i.switch, c = n.length;
                            for(let c = 0; c < l.length; ++c){
                                const { is: u, then: f, otherwise: h } = l[c], m = `${a}${i.switch ? "." + c : ""}`;
                                if (u.$_match(o, t.nest(u, `${m}.is`), r)) {
                                    if (f) {
                                        const a = t.localize([
                                            ...t.path,
                                            `${m}.then`
                                        ], t.ancestors, t.schemas), { schema: i, id: o } = f._generate(e, a, r);
                                        s.push(i), n.push(`${m}.then${o ? `(${o})` : ""}`);
                                        break;
                                    }
                                } else if (h) {
                                    const a = t.localize([
                                        ...t.path,
                                        `${m}.otherwise`
                                    ], t.ancestors, t.schemas), { schema: i, id: o } = h._generate(e, a, r);
                                    s.push(i), n.push(`${m}.otherwise${o ? `(${o})` : ""}`);
                                    break;
                                }
                            }
                            if (i.break && n.length > c) break;
                        }
                        const a = n.join(", ");
                        if (t.mainstay.tracer.debug(t, "rule", "when", a), !a) return {
                            schema: this
                        };
                        if (!t.mainstay.tracer.active && this.$_temp.whens[a]) return {
                            schema: this.$_temp.whens[a],
                            id: a
                        };
                        let i = this;
                        this._definition.generate && (i = this._definition.generate(this, e, t, r));
                        for (const e of s)i = i.concat(e);
                        return this.$_root._tracer && this.$_root._tracer._combine(i, [
                            this,
                            ...s
                        ]), this.$_temp.whens[a] = i, {
                            schema: i,
                            id: a
                        };
                    }
                    _inner(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        s(!this._inRuleset(), `Cannot set ${e} inside a ruleset`);
                        const n = this.clone();
                        return n.$_terms[e] && !r.override || (n.$_terms[e] = []), r.single ? n.$_terms[e].push(t) : n.$_terms[e].push(...t), n.$_temp.ruleset = !1, n;
                    }
                    _inRuleset() {
                        return null !== this.$_temp.ruleset && !1 !== this.$_temp.ruleset;
                    }
                    _ruleRemove(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if (!this._singleRules.has(e)) return this;
                        const r = !1 !== t.clone ? this.clone() : this;
                        r._singleRules.delete(e);
                        const s = [];
                        for(let t = 0; t < r._rules.length; ++t){
                            const n = r._rules[t];
                            n.name !== e || n.keep ? s.push(n) : r._inRuleset() && t < r.$_temp.ruleset && --r.$_temp.ruleset;
                        }
                        return r._rules = s, r;
                    }
                    _values(e, t) {
                        l.verifyFlat(e, t.slice(1, -1));
                        const r = this.clone(), n = e[0] === l.symbols.override;
                        if (n && (e = e.slice(1)), !r[t] && e.length ? r[t] = new b : n && (r[t] = e.length ? new b : null, r.$_mutateRebuild()), !r[t]) return r;
                        n && r[t].override();
                        for (const n of e){
                            s(void 0 !== n, "Cannot call allow/valid/invalid with undefined"), s(n !== l.symbols.override, "Override must be the first value");
                            const e = "_invalids" === t ? "_valids" : "_invalids";
                            r[e] && (r[e].remove(n), r[e].length || (s("_valids" === t || !r._flags.only, "Setting invalid value", n, "leaves schema rejecting all values due to previous valid rule"), r[e] = null)), r[t].add(n, r._refs);
                        }
                        return r;
                    }
                }
            };
            v.Base.prototype[l.symbols.any] = {
                version: l.version,
                compile: c.compile,
                root: "$_root"
            }, v.Base.prototype.isImmutable = !0, v.Base.prototype.deny = v.Base.prototype.invalid, v.Base.prototype.disallow = v.Base.prototype.invalid, v.Base.prototype.equal = v.Base.prototype.valid, v.Base.prototype.exist = v.Base.prototype.required, v.Base.prototype.not = v.Base.prototype.invalid, v.Base.prototype.options = v.Base.prototype.prefs, v.Base.prototype.preferences = v.Base.prototype.prefs, e.exports = new v.Base;
        },
        8652: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(8160), i = {
                max: 1e3,
                supported: new Set([
                    "undefined",
                    "boolean",
                    "number",
                    "string"
                ])
            };
            t.provider = {
                provision: (e)=>new i.Cache(e)
            }, i.Cache = class {
                constructor(){
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    a.assertOptions(e, [
                        "max"
                    ]), s(void 0 === e.max || e.max && e.max > 0 && isFinite(e.max), "Invalid max cache size"), this._max = e.max || i.max, this._map = new Map, this._list = new i.List;
                }
                get length() {
                    return this._map.size;
                }
                set(e, t) {
                    if (null !== e && !i.supported.has(typeof e)) return;
                    let r = this._map.get(e);
                    if (r) return r.value = t, void this._list.first(r);
                    r = this._list.unshift({
                        key: e,
                        value: t
                    }), this._map.set(e, r), this._compact();
                }
                get(e) {
                    const t = this._map.get(e);
                    if (t) return this._list.first(t), n(t.value);
                }
                _compact() {
                    if (this._map.size > this._max) {
                        const e = this._list.pop();
                        this._map.delete(e.key);
                    }
                }
            }, i.List = class {
                constructor(){
                    this.tail = null, this.head = null;
                }
                unshift(e) {
                    return e.next = null, e.prev = this.head, this.head && (this.head.next = e), this.head = e, this.tail || (this.tail = e), e;
                }
                first(e) {
                    e !== this.head && (this._remove(e), this.unshift(e));
                }
                pop() {
                    return this._remove(this.tail);
                }
                _remove(e) {
                    const { next: t, prev: r } = e;
                    return t.prev = r, r && (r.next = t), e === this.tail && (this.tail = t), e.prev = null, e.next = null, e;
                }
            };
        },
        8160: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(7916), a = r(5934);
            let i, o;
            const l = {
                isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/
            };
            t.version = a.version, t.defaults = {
                abortEarly: !0,
                allowUnknown: !1,
                artifacts: !1,
                cache: !0,
                context: null,
                convert: !0,
                dateFormat: "iso",
                errors: {
                    escapeHtml: !1,
                    label: "path",
                    language: null,
                    render: !0,
                    stack: !1,
                    wrap: {
                        label: '"',
                        array: "[]"
                    }
                },
                externals: !0,
                messages: {},
                nonEnumerables: !1,
                noDefaults: !1,
                presence: "optional",
                skipFunctions: !1,
                stripUnknown: !1,
                warnings: !1
            }, t.symbols = {
                any: Symbol.for("@hapi/joi/schema"),
                arraySingle: Symbol("arraySingle"),
                deepDefault: Symbol("deepDefault"),
                errors: Symbol("errors"),
                literal: Symbol("literal"),
                override: Symbol("override"),
                parent: Symbol("parent"),
                prefs: Symbol("prefs"),
                ref: Symbol("ref"),
                template: Symbol("template"),
                values: Symbol("values")
            }, t.assertOptions = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Options";
                s(e && "object" == typeof e && !Array.isArray(e), "Options must be of type object");
                const n = Object.keys(e).filter((e)=>!t.includes(e));
                s(0 === n.length, `${r} contain unknown keys: ${n}`);
            }, t.checkPreferences = function(e) {
                o = o || r(3378);
                const t = o.preferences.validate(e);
                if (t.error) throw new n([
                    t.error.details[0].message
                ]);
            }, t.compare = function(e, t, r) {
                switch(r){
                    case "=":
                        return e === t;
                    case ">":
                        return e > t;
                    case "<":
                        return e < t;
                    case ">=":
                        return e >= t;
                    case "<=":
                        return e <= t;
                }
            }, t.default = function(e, t) {
                return void 0 === e ? t : e;
            }, t.isIsoDate = function(e) {
                return l.isoDate.test(e);
            }, t.isNumber = function(e) {
                return "number" == typeof e && !isNaN(e);
            }, t.isResolvable = function(e) {
                return !!e && (e[t.symbols.ref] || e[t.symbols.template]);
            }, t.isSchema = function(e) {
                let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const n = e && e[t.symbols.any];
                return !!n && (s(r.legacy || n.version === t.version, "Cannot mix different versions of joi schemas"), !0);
            }, t.isValues = function(e) {
                return e[t.symbols.values];
            }, t.limit = function(e) {
                return Number.isSafeInteger(e) && e >= 0;
            }, t.preferences = function(e, s) {
                i = i || r(6914), e = e || {}, s = s || {};
                const n = Object.assign({}, e, s);
                return s.errors && e.errors && (n.errors = Object.assign({}, e.errors, s.errors), n.errors.wrap = Object.assign({}, e.errors.wrap, s.errors.wrap)), s.messages && (n.messages = i.compile(s.messages, e.messages)), delete n[t.symbols.prefs], n;
            }, t.tryWithPath = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                try {
                    return e();
                } catch (e) {
                    throw void 0 !== e.path ? e.path = t + "." + e.path : e.path = t, r.append && (e.message = `${e.message} (${e.path})`), e;
                }
            }, t.validateArg = function(e, r, s) {
                let { assert: n, message: a } = s;
                if (t.isSchema(n)) {
                    const t = n.validate(e);
                    if (!t.error) return;
                    return t.error.message;
                }
                if (!n(e)) return r ? `${r} ${a}` : a;
            }, t.verifyFlat = function(e, t) {
                for (const r of e)s(!Array.isArray(r), "Method no longer accepts array arguments:", t);
            };
        },
        3292: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8160), a = r(6133), i = {};
            t.schema = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                n.assertOptions(r, [
                    "appendPath",
                    "override"
                ]);
                try {
                    return i.schema(e, t, r);
                } catch (e) {
                    throw r.appendPath && void 0 !== e.path && (e.message = `${e.message} (${e.path})`), e;
                }
            }, i.schema = function(e, t, r) {
                s(void 0 !== t, "Invalid undefined schema"), Array.isArray(t) && (s(t.length, "Invalid empty array schema"), 1 === t.length && (t = t[0]));
                const a = function(t) {
                    for(var s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), a = 1; a < s; a++)n[a - 1] = arguments[a];
                    return !1 !== r.override ? t.valid(e.override, ...n) : t.valid(...n);
                };
                if (i.simple(t)) return a(e, t);
                if ("function" == typeof t) return e.custom(t);
                if (s("object" == typeof t, "Invalid schema content:", typeof t), n.isResolvable(t)) return a(e, t);
                if (n.isSchema(t)) return t;
                if (Array.isArray(t)) {
                    for (const r of t)if (!i.simple(r)) return e.alternatives().try(...t);
                    return a(e, ...t);
                }
                return t instanceof RegExp ? e.string().regex(t) : t instanceof Date ? a(e.date(), t) : (s(Object.getPrototypeOf(t) === Object.getPrototypeOf({}), "Schema can only contain plain objects"), e.object().keys(t));
            }, t.ref = function(e, t) {
                return a.isRef(e) ? e : a.create(e, t);
            }, t.compile = function(e, r) {
                let a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                n.assertOptions(a, [
                    "legacy"
                ]);
                const o = r && r[n.symbols.any];
                if (o) return s(a.legacy || o.version === n.version, "Cannot mix different versions of joi schemas:", o.version, n.version), r;
                if ("object" != typeof r || !a.legacy) return t.schema(e, r, {
                    appendPath: !0
                });
                const l = i.walk(r);
                return l ? l.compile(l.root, r) : t.schema(e, r, {
                    appendPath: !0
                });
            }, i.walk = function(e) {
                if ("object" != typeof e) return null;
                if (Array.isArray(e)) {
                    for (const t of e){
                        const e = i.walk(t);
                        if (e) return e;
                    }
                    return null;
                }
                const t = e[n.symbols.any];
                if (t) return {
                    root: e[t.root],
                    compile: t.compile
                };
                s(Object.getPrototypeOf(e) === Object.getPrototypeOf({}), "Schema can only contain plain objects");
                for(const t in e){
                    const r = i.walk(e[t]);
                    if (r) return r;
                }
                return null;
            }, i.simple = function(e) {
                return null === e || [
                    "boolean",
                    "string",
                    "number"
                ].includes(typeof e);
            }, t.when = function(e, r, o) {
                if (void 0 === o && (s(r && "object" == typeof r, "Missing options"), o = r, r = a.create(".")), Array.isArray(o) && (o = {
                    switch: o
                }), n.assertOptions(o, [
                    "is",
                    "not",
                    "then",
                    "otherwise",
                    "switch",
                    "break"
                ]), n.isSchema(r)) return s(void 0 === o.is, '"is" can not be used with a schema condition'), s(void 0 === o.not, '"not" can not be used with a schema condition'), s(void 0 === o.switch, '"switch" can not be used with a schema condition'), i.condition(e, {
                    is: r,
                    then: o.then,
                    otherwise: o.otherwise,
                    break: o.break
                });
                if (s(a.isRef(r) || "string" == typeof r, "Invalid condition:", r), s(void 0 === o.not || void 0 === o.is, 'Cannot combine "is" with "not"'), void 0 === o.switch) {
                    let l = o;
                    void 0 !== o.not && (l = {
                        is: o.not,
                        then: o.otherwise,
                        otherwise: o.then,
                        break: o.break
                    });
                    let c = void 0 !== l.is ? e.$_compile(l.is) : e.$_root.invalid(null, !1, 0, "").required();
                    return s(void 0 !== l.then || void 0 !== l.otherwise, 'options must have at least one of "then", "otherwise", or "switch"'), s(void 0 === l.break || void 0 === l.then || void 0 === l.otherwise, "Cannot specify then, otherwise, and break all together"), void 0 === o.is || a.isRef(o.is) || n.isSchema(o.is) || (c = c.required()), i.condition(e, {
                        ref: t.ref(r),
                        is: c,
                        then: l.then,
                        otherwise: l.otherwise,
                        break: l.break
                    });
                }
                s(Array.isArray(o.switch), '"switch" must be an array'), s(void 0 === o.is, 'Cannot combine "switch" with "is"'), s(void 0 === o.not, 'Cannot combine "switch" with "not"'), s(void 0 === o.then, 'Cannot combine "switch" with "then"');
                const l = {
                    ref: t.ref(r),
                    switch: [],
                    break: o.break
                };
                for(let t = 0; t < o.switch.length; ++t){
                    const r = o.switch[t], i = t === o.switch.length - 1;
                    n.assertOptions(r, i ? [
                        "is",
                        "then",
                        "otherwise"
                    ] : [
                        "is",
                        "then"
                    ]), s(void 0 !== r.is, 'Switch statement missing "is"'), s(void 0 !== r.then, 'Switch statement missing "then"');
                    const c = {
                        is: e.$_compile(r.is),
                        then: e.$_compile(r.then)
                    };
                    if (a.isRef(r.is) || n.isSchema(r.is) || (c.is = c.is.required()), i) {
                        s(void 0 === o.otherwise || void 0 === r.otherwise, 'Cannot specify "otherwise" inside and outside a "switch"');
                        const t = void 0 !== o.otherwise ? o.otherwise : r.otherwise;
                        void 0 !== t && (s(void 0 === l.break, "Cannot specify both otherwise and break"), c.otherwise = e.$_compile(t));
                    }
                    l.switch.push(c);
                }
                return l;
            }, i.condition = function(e, t) {
                for (const r of [
                    "then",
                    "otherwise"
                ])void 0 === t[r] ? delete t[r] : t[r] = e.$_compile(t[r]);
                return t;
            };
        },
        6354: (e, t, r)=>{
            "use strict";
            const s = r(5688), n = r(8160), a = r(3328);
            t.Report = class {
                constructor(e, r, s, n, a, i, o){
                    if (this.code = e, this.flags = n, this.messages = a, this.path = i.path, this.prefs = o, this.state = i, this.value = r, this.message = null, this.template = null, this.local = s || {}, this.local.label = t.label(this.flags, this.state, this.prefs, this.messages), void 0 === this.value || this.local.hasOwnProperty("value") || (this.local.value = this.value), this.path.length) {
                        const e = this.path[this.path.length - 1];
                        "object" != typeof e && (this.local.key = e);
                    }
                }
                _setTemplate(e) {
                    if (this.template = e, !this.flags.label && 0 === this.path.length) {
                        const e = this._template(this.template, "root");
                        e && (this.local.label = e);
                    }
                }
                toString() {
                    if (this.message) return this.message;
                    const e = this.code;
                    if (!this.prefs.errors.render) return this.code;
                    const t = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);
                    return void 0 === t ? `Error code "${e}" is not defined, your custom type is missing the correct messages definition` : (this.message = t.render(this.value, this.state, this.prefs, this.local, {
                        errors: this.prefs.errors,
                        messages: [
                            this.prefs.messages,
                            this.messages
                        ]
                    }), this.prefs.errors.label || (this.message = this.message.replace(/^"" /, "").trim()), this.message);
                }
                _template(e, r) {
                    return t.template(this.value, e, r || this.code, this.state, this.prefs);
                }
            }, t.path = function(e) {
                let t = "";
                for (const r of e)"object" != typeof r && ("string" == typeof r ? (t && (t += "."), t += r) : t += `[${r}]`);
                return t;
            }, t.template = function(e, t, r, s, i) {
                if (!t) return;
                if (a.isTemplate(t)) return "root" !== r ? t : null;
                let o = i.errors.language;
                if (n.isResolvable(o) && (o = o.resolve(e, s, i)), o && t[o]) {
                    if (void 0 !== t[o][r]) return t[o][r];
                    if (void 0 !== t[o]["*"]) return t[o]["*"];
                }
                return t[r] ? t[r] : t["*"];
            }, t.label = function(e, r, s, n) {
                if (e.label) return e.label;
                if (!s.errors.label) return "";
                let a = r.path;
                "key" === s.errors.label && r.path.length > 1 && (a = r.path.slice(-1));
                return t.path(a) || t.template(null, s.messages, "root", r, s) || n && t.template(null, n, "root", r, s) || "value";
            }, t.process = function(e, r, s) {
                if (!e) return null;
                const { override: n, message: a, details: i } = t.details(e);
                if (n) return n;
                if (s.errors.stack) return new t.ValidationError(a, i, r);
                const o = Error.stackTraceLimit;
                Error.stackTraceLimit = 0;
                const l = new t.ValidationError(a, i, r);
                return Error.stackTraceLimit = o, l;
            }, t.details = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = [];
                const s = [];
                for (const n of e){
                    if (n instanceof Error) {
                        if (!1 !== t.override) return {
                            override: n
                        };
                        const e = n.toString();
                        r.push(e), s.push({
                            message: e,
                            type: "override",
                            context: {
                                error: n
                            }
                        });
                        continue;
                    }
                    const e = n.toString();
                    r.push(e), s.push({
                        message: e,
                        path: n.path.filter((e)=>"object" != typeof e),
                        type: n.code,
                        context: n.local
                    });
                }
                return r.length > 1 && (r = [
                    ...new Set(r)
                ]), {
                    message: r.join(". "),
                    details: s
                };
            }, t.ValidationError = class extends Error {
                constructor(e, t, r){
                    super(e), this._original = r, this.details = t;
                }
                static isError(e) {
                    return e instanceof t.ValidationError;
                }
            }, t.ValidationError.prototype.isJoi = !0, t.ValidationError.prototype.name = "ValidationError", t.ValidationError.prototype.annotate = s.error;
        },
        8901: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(8160), i = r(6914), o = {};
            t.type = function(e, t) {
                const r = Object.getPrototypeOf(e), l = n(r), c = e._assign(Object.create(l)), u = Object.assign({}, t);
                delete u.base, l._definition = u;
                const f = r._definition || {};
                u.messages = i.merge(f.messages, u.messages), u.properties = Object.assign({}, f.properties, u.properties), c.type = u.type, u.flags = Object.assign({}, f.flags, u.flags);
                const h = Object.assign({}, f.terms);
                if (u.terms) for(const e in u.terms){
                    const t = u.terms[e];
                    s(void 0 === c.$_terms[e], "Invalid term override for", u.type, e), c.$_terms[e] = t.init, h[e] = t;
                }
                u.terms = h, u.args || (u.args = f.args), u.prepare = o.prepare(u.prepare, f.prepare), u.coerce && ("function" == typeof u.coerce && (u.coerce = {
                    method: u.coerce
                }), u.coerce.from && !Array.isArray(u.coerce.from) && (u.coerce = {
                    method: u.coerce.method,
                    from: [].concat(u.coerce.from)
                })), u.coerce = o.coerce(u.coerce, f.coerce), u.validate = o.validate(u.validate, f.validate);
                const m = Object.assign({}, f.rules);
                if (u.rules) for(const e in u.rules){
                    const t = u.rules[e];
                    s("object" == typeof t, "Invalid rule definition for", u.type, e);
                    let r = t.method;
                    if (void 0 === r && (r = function() {
                        return this.$_addRule(e);
                    }), r && (s(!l[e], "Rule conflict in", u.type, e), l[e] = r), s(!m[e], "Rule conflict in", u.type, e), m[e] = t, t.alias) {
                        const e = [].concat(t.alias);
                        for (const r of e)l[r] = t.method;
                    }
                    t.args && (t.argsByName = new Map, t.args = t.args.map((e)=>("string" == typeof e && (e = {
                            name: e
                        }), s(!t.argsByName.has(e.name), "Duplicated argument name", e.name), a.isSchema(e.assert) && (e.assert = e.assert.strict().label(e.name)), t.argsByName.set(e.name, e), e)));
                }
                u.rules = m;
                const d = Object.assign({}, f.modifiers);
                if (u.modifiers) for(const e in u.modifiers){
                    s(!l[e], "Rule conflict in", u.type, e);
                    const t = u.modifiers[e];
                    s("function" == typeof t, "Invalid modifier definition for", u.type, e);
                    const r = function(t) {
                        return this.rule({
                            [e]: t
                        });
                    };
                    l[e] = r, d[e] = t;
                }
                if (u.modifiers = d, u.overrides) {
                    l._super = r, c.$_super = {};
                    for(const e in u.overrides)s(r[e], "Cannot override missing", e), u.overrides[e][a.symbols.parent] = r[e], c.$_super[e] = r[e].bind(c);
                    Object.assign(l, u.overrides);
                }
                u.cast = Object.assign({}, f.cast, u.cast);
                const p = Object.assign({}, f.manifest, u.manifest);
                return p.build = o.build(u.manifest && u.manifest.build, f.manifest && f.manifest.build), u.manifest = p, u.rebuild = o.rebuild(u.rebuild, f.rebuild), c;
            }, o.build = function(e, t) {
                return e && t ? function(r, s) {
                    return t(e(r, s), s);
                } : e || t;
            }, o.coerce = function(e, t) {
                return e && t ? {
                    from: e.from && t.from ? [
                        ...new Set([
                            ...e.from,
                            ...t.from
                        ])
                    ] : null,
                    method (r, s) {
                        let n;
                        if ((!t.from || t.from.includes(typeof r)) && (n = t.method(r, s), n)) {
                            if (n.errors || void 0 === n.value) return n;
                            r = n.value;
                        }
                        if (!e.from || e.from.includes(typeof r)) {
                            const t = e.method(r, s);
                            if (t) return t;
                        }
                        return n;
                    }
                } : e || t;
            }, o.prepare = function(e, t) {
                return e && t ? function(r, s) {
                    const n = e(r, s);
                    if (n) {
                        if (n.errors || void 0 === n.value) return n;
                        r = n.value;
                    }
                    return t(r, s) || n;
                } : e || t;
            }, o.rebuild = function(e, t) {
                return e && t ? function(r) {
                    t(r), e(r);
                } : e || t;
            }, o.validate = function(e, t) {
                return e && t ? function(r, s) {
                    const n = t(r, s);
                    if (n) {
                        if (n.errors && (!Array.isArray(n.errors) || n.errors.length)) return n;
                        r = n.value;
                    }
                    return e(r, s) || n;
                } : e || t;
            };
        },
        5107: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(8652), i = r(8160), o = r(3292), l = r(6354), c = r(8901), u = r(9708), f = r(6133), h = r(3328), m = r(1152);
            let d;
            const p = {
                types: {
                    alternatives: r(4946),
                    any: r(8068),
                    array: r(546),
                    boolean: r(4937),
                    date: r(7500),
                    function: r(390),
                    link: r(8785),
                    number: r(3832),
                    object: r(8966),
                    string: r(7417),
                    symbol: r(8826)
                },
                aliases: {
                    alt: "alternatives",
                    bool: "boolean",
                    func: "function"
                },
                root: function() {
                    const e = {
                        _types: new Set(Object.keys(p.types))
                    };
                    for (const t of e._types)e[t] = function() {
                        for(var e = arguments.length, r = new Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                        return s(!r.length || [
                            "alternatives",
                            "link",
                            "object"
                        ].includes(t), "The", t, "type does not allow arguments"), p.generate(this, p.types[t], r);
                    };
                    for (const t of [
                        "allow",
                        "custom",
                        "disallow",
                        "equal",
                        "exist",
                        "forbidden",
                        "invalid",
                        "not",
                        "only",
                        "optional",
                        "options",
                        "prefs",
                        "preferences",
                        "required",
                        "strip",
                        "valid",
                        "when"
                    ])e[t] = function() {
                        return this.any()[t](...arguments);
                    };
                    Object.assign(e, p.methods);
                    for(const t in p.aliases){
                        const r = p.aliases[t];
                        e[t] = e[r];
                    }
                    return e.x = e.expression, m.setup && m.setup(e), e;
                }
            };
            p.methods = {
                ValidationError: l.ValidationError,
                version: i.version,
                cache: a.provider,
                assert (e, t) {
                    for(var r = arguments.length, s = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++)s[n - 2] = arguments[n];
                    p.assert(e, t, !0, s);
                },
                attempt (e, t) {
                    for(var r = arguments.length, s = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++)s[n - 2] = arguments[n];
                    return p.assert(e, t, !1, s);
                },
                build (e) {
                    return s("function" == typeof u.build, "Manifest functionality disabled"), u.build(this, e);
                },
                checkPreferences (e) {
                    i.checkPreferences(e);
                },
                compile (e, t) {
                    return o.compile(this, e, t);
                },
                defaults (e) {
                    s("function" == typeof e, "modifier must be a function");
                    const t = Object.assign({}, this);
                    for (const r of t._types){
                        const n = e(t[r]());
                        s(i.isSchema(n), "modifier must return a valid schema object"), t[r] = function() {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return p.generate(this, n, t);
                        };
                    }
                    return t;
                },
                expression () {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    return new h(...t);
                },
                extend () {
                    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
                    i.verifyFlat(t, "extend"), d = d || r(3378), s(t.length, "You need to provide at least one extension"), this.assert(t, d.extensions);
                    const a = Object.assign({}, this);
                    a._types = new Set(a._types);
                    for (let e of t){
                        "function" == typeof e && (e = e(a)), this.assert(e, d.extension);
                        const t = p.expandExtension(e, a);
                        for (const e of t){
                            s(void 0 === a[e.type] || a._types.has(e.type), "Cannot override name", e.type);
                            const t = e.base || this.any(), r = c.type(t, e);
                            a._types.add(e.type), a[e.type] = function() {
                                for(var e = arguments.length, t = new Array(e), s = 0; s < e; s++)t[s] = arguments[s];
                                return p.generate(this, r, t);
                            };
                        }
                    }
                    return a;
                },
                isError: l.ValidationError.isError,
                isExpression: h.isTemplate,
                isRef: f.isRef,
                isSchema: i.isSchema,
                in () {
                    return f.in(...arguments);
                },
                override: i.symbols.override,
                ref () {
                    return f.create(...arguments);
                },
                types () {
                    const e = {};
                    for (const t of this._types)e[t] = this[t]();
                    for(const t in p.aliases)e[t] = this[t]();
                    return e;
                }
            }, p.assert = function(e, t, r, s) {
                const a = s[0] instanceof Error || "string" == typeof s[0] ? s[0] : null, o = null !== a ? s[1] : s[0], c = t.validate(e, i.preferences({
                    errors: {
                        stack: !0
                    }
                }, o || {}));
                let u = c.error;
                if (!u) return c.value;
                if (a instanceof Error) throw a;
                const f = r && "function" == typeof u.annotate ? u.annotate() : u.message;
                throw u instanceof l.ValidationError == 0 && (u = n(u)), u.message = a ? `${a} ${f}` : f, u;
            }, p.generate = function(e, t, r) {
                return s(e, "Must be invoked on a Joi instance."), t.$_root = e, t._definition.args && r.length ? t._definition.args(t, ...r) : t;
            }, p.expandExtension = function(e, t) {
                if ("string" == typeof e.type) return [
                    e
                ];
                const r = [];
                for (const s of t._types)if (e.type.test(s)) {
                    const n = Object.assign({}, e);
                    n.type = s, n.base = t[s](), r.push(n);
                }
                return r;
            }, e.exports = p.root();
        },
        6914: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(3328);
            t.compile = function(e, t) {
                if ("string" == typeof e) return s(!t, "Cannot set single message string"), new a(e);
                if (a.isTemplate(e)) return s(!t, "Cannot set single message template"), e;
                s("object" == typeof e && !Array.isArray(e), "Invalid message options"), t = t ? n(t) : {};
                for(let r in e){
                    const n = e[r];
                    if ("root" === r || a.isTemplate(n)) {
                        t[r] = n;
                        continue;
                    }
                    if ("string" == typeof n) {
                        t[r] = new a(n);
                        continue;
                    }
                    s("object" == typeof n && !Array.isArray(n), "Invalid message for", r);
                    const i = r;
                    for(r in t[i] = t[i] || {}, n){
                        const e = n[r];
                        "root" === r || a.isTemplate(e) ? t[i][r] = e : (s("string" == typeof e, "Invalid message for", r, "in", i), t[i][r] = new a(e));
                    }
                }
                return t;
            }, t.decompile = function(e) {
                const t = {};
                for(let r in e){
                    const s = e[r];
                    if ("root" === r) {
                        t.root = s;
                        continue;
                    }
                    if (a.isTemplate(s)) {
                        t[r] = s.describe({
                            compact: !0
                        });
                        continue;
                    }
                    const n = r;
                    for(r in t[n] = {}, s){
                        const e = s[r];
                        "root" !== r ? t[n][r] = e.describe({
                            compact: !0
                        }) : t[n].root = e;
                    }
                }
                return t;
            }, t.merge = function(e, r) {
                if (!e) return t.compile(r);
                if (!r) return e;
                if ("string" == typeof r) return new a(r);
                if (a.isTemplate(r)) return r;
                const i = n(e);
                for(let e in r){
                    const t = r[e];
                    if ("root" === e || a.isTemplate(t)) {
                        i[e] = t;
                        continue;
                    }
                    if ("string" == typeof t) {
                        i[e] = new a(t);
                        continue;
                    }
                    s("object" == typeof t && !Array.isArray(t), "Invalid message for", e);
                    const n = e;
                    for(e in i[n] = i[n] || {}, t){
                        const r = t[e];
                        "root" === e || a.isTemplate(r) ? i[n][e] = r : (s("string" == typeof r, "Invalid message for", e, "in", n), i[n][e] = new a(r));
                    }
                }
                return i;
            };
        },
        2294: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8160), a = r(6133), i = {};
            t.Ids = i.Ids = class {
                constructor(){
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                clone() {
                    const e = new i.Ids;
                    return e._byId = new Map(this._byId), e._byKey = new Map(this._byKey), e._schemaChain = this._schemaChain, e;
                }
                concat(e) {
                    e._schemaChain && (this._schemaChain = !0);
                    for (const [t, r] of e._byId.entries())s(!this._byKey.has(t), "Schema id conflicts with existing key:", t), this._byId.set(t, r);
                    for (const [t, r] of e._byKey.entries())s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, r);
                }
                fork(e, t, r) {
                    const a = this._collect(e);
                    a.push({
                        schema: r
                    });
                    const o = a.shift();
                    let l = {
                        id: o.id,
                        schema: t(o.schema)
                    };
                    s(n.isSchema(l.schema), "adjuster function failed to return a joi schema type");
                    for (const e of a)l = {
                        id: e.id,
                        schema: i.fork(e.schema, l.id, l.schema)
                    };
                    return l.schema;
                }
                labels(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    const r = e[0], s = this._get(r);
                    if (!s) return [
                        ...t,
                        ...e
                    ].join(".");
                    const n = e.slice(1);
                    return t = [
                        ...t,
                        s.schema._flags.label || r
                    ], n.length ? s.schema._ids.labels(n, t) : t.join(".");
                }
                reach(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    const r = e[0], n = this._get(r);
                    s(n, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join("."));
                    const a = e.slice(1);
                    return a.length ? n.schema._ids.reach(a, [
                        ...t,
                        r
                    ]) : n.schema;
                }
                register(e) {
                    let { key: t } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e || !n.isSchema(e)) return;
                    (e.$_property("schemaChain") || e._ids._schemaChain) && (this._schemaChain = !0);
                    const r = e._flags.id;
                    if (r) {
                        const t = this._byId.get(r);
                        s(!t || t.schema === e, "Cannot add different schemas with the same id:", r), s(!this._byKey.has(r), "Schema id conflicts with existing key:", r), this._byId.set(r, {
                            schema: e,
                            id: r
                        });
                    }
                    t && (s(!this._byKey.has(t), "Schema already contains key:", t), s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, {
                        schema: e,
                        id: t
                    }));
                }
                reset() {
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                _collect(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                    const n = e[0], a = this._get(n);
                    s(a, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join(".")), r = [
                        a,
                        ...r
                    ];
                    const i = e.slice(1);
                    return i.length ? a.schema._ids._collect(i, [
                        ...t,
                        n
                    ], r) : r;
                }
                _get(e) {
                    return this._byId.get(e) || this._byKey.get(e);
                }
            }, i.fork = function(e, r, s) {
                const n = t.schema(e, {
                    each: (e, t)=>{
                        let { key: n } = t;
                        if (r === (e._flags.id || n)) return s;
                    },
                    ref: !1
                });
                return n ? n.$_mutateRebuild() : e;
            }, t.schema = function(e, t) {
                let r;
                for(const s in e._flags){
                    if ("_" === s[0]) continue;
                    const n = i.scan(e._flags[s], {
                        source: "flags",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r._flags[s] = n);
                }
                for(let s = 0; s < e._rules.length; ++s){
                    const n = e._rules[s], a = i.scan(n.args, {
                        source: "rules",
                        name: n.name
                    }, t);
                    if (void 0 !== a) {
                        r = r || e.clone();
                        const t = Object.assign({}, n);
                        t.args = a, r._rules[s] = t, r._singleRules.get(n.name) === n && r._singleRules.set(n.name, t);
                    }
                }
                for(const s in e.$_terms){
                    if ("_" === s[0]) continue;
                    const n = i.scan(e.$_terms[s], {
                        source: "terms",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r.$_terms[s] = n);
                }
                return r;
            }, i.scan = function(e, t, r, s, o) {
                const l = s || [];
                if (null === e || "object" != typeof e) return;
                let c;
                if (Array.isArray(e)) {
                    for(let s = 0; s < e.length; ++s){
                        const n = "terms" === t.source && "keys" === t.name && e[s].key, a = i.scan(e[s], t, r, [
                            s,
                            ...l
                        ], n);
                        void 0 !== a && (c = c || e.slice(), c[s] = a);
                    }
                    return c;
                }
                if (!1 !== r.schema && n.isSchema(e) || !1 !== r.ref && a.isRef(e)) {
                    const s = r.each(e, {
                        ...t,
                        path: l,
                        key: o
                    });
                    if (s === e) return;
                    return s;
                }
                for(const s in e){
                    if ("_" === s[0]) continue;
                    const n = i.scan(e[s], t, r, [
                        s,
                        ...l
                    ], o);
                    void 0 !== n && (c = c || Object.assign({}, e), c[s] = n);
                }
                return c;
            };
        },
        6133: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(9621), i = r(8160);
            let o;
            const l = {
                symbol: Symbol("ref"),
                defaults: {
                    adjust: null,
                    in: !1,
                    iterables: null,
                    map: null,
                    separator: ".",
                    type: "value"
                }
            };
            t.create = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                s("string" == typeof e, "Invalid reference key:", e), i.assertOptions(t, [
                    "adjust",
                    "ancestor",
                    "in",
                    "iterables",
                    "map",
                    "prefix",
                    "render",
                    "separator"
                ]), s(!t.prefix || "object" == typeof t.prefix, "options.prefix must be of type object");
                const r = Object.assign({}, l.defaults, t);
                delete r.prefix;
                const n = r.separator, a = l.context(e, n, t.prefix);
                if (r.type = a.type, e = a.key, "value" === r.type) {
                    if (a.root && (s(!n || e[0] !== n, "Cannot specify relative path with root prefix"), r.ancestor = "root", e || (e = null)), n && n === e) e = null, r.ancestor = 0;
                    else if (void 0 !== r.ancestor) s(!n || !e || e[0] !== n, "Cannot combine prefix with ancestor option");
                    else {
                        const [t, s] = l.ancestor(e, n);
                        s && "" === (e = e.slice(s)) && (e = null), r.ancestor = t;
                    }
                }
                return r.path = n ? null === e ? [] : e.split(n) : [
                    e
                ], new l.Ref(r);
            }, t.in = function(e) {
                let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return t.create(e, {
                    ...r,
                    in: !0
                });
            }, t.isRef = function(e) {
                return !!e && !!e[i.symbols.ref];
            }, l.Ref = class {
                constructor(e){
                    s("object" == typeof e, "Invalid reference construction"), i.assertOptions(e, [
                        "adjust",
                        "ancestor",
                        "in",
                        "iterables",
                        "map",
                        "path",
                        "render",
                        "separator",
                        "type",
                        "depth",
                        "key",
                        "root",
                        "display"
                    ]), s([
                        !1,
                        void 0
                    ].includes(e.separator) || "string" == typeof e.separator && 1 === e.separator.length, "Invalid separator"), s(!e.adjust || "function" == typeof e.adjust, "options.adjust must be a function"), s(!e.map || Array.isArray(e.map), "options.map must be an array"), s(!e.map || !e.adjust, "Cannot set both map and adjust options"), Object.assign(this, l.defaults, e), s("value" === this.type || void 0 === this.ancestor, "Non-value references cannot reference ancestors"), Array.isArray(this.map) && (this.map = new Map(this.map)), this.depth = this.path.length, this.key = this.path.length ? this.path.join(this.separator) : null, this.root = this.path[0], this.updateDisplay();
                }
                resolve(e, t, r, n) {
                    let a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
                    return s(!this.in || a.in, "Invalid in() reference usage"), "global" === this.type ? this._resolve(r.context, t, a) : "local" === this.type ? this._resolve(n, t, a) : this.ancestor ? "root" === this.ancestor ? this._resolve(t.ancestors[t.ancestors.length - 1], t, a) : (s(this.ancestor <= t.ancestors.length, "Invalid reference exceeds the schema root:", this.display), this._resolve(t.ancestors[this.ancestor - 1], t, a)) : this._resolve(e, t, a);
                }
                _resolve(e, t, r) {
                    let s;
                    if ("value" === this.type && t.mainstay.shadow && !1 !== r.shadow && (s = t.mainstay.shadow.get(this.absolute(t))), void 0 === s && (s = a(e, this.path, {
                        iterables: this.iterables,
                        functions: !0
                    })), this.adjust && (s = this.adjust(s)), this.map) {
                        const e = this.map.get(s);
                        void 0 !== e && (s = e);
                    }
                    return t.mainstay && t.mainstay.tracer.resolve(t, this, s), s;
                }
                toString() {
                    return this.display;
                }
                absolute(e) {
                    return [
                        ...e.path.slice(0, -this.ancestor),
                        ...this.path
                    ];
                }
                clone() {
                    return new l.Ref(this);
                }
                describe() {
                    const e = {
                        path: this.path
                    };
                    "value" !== this.type && (e.type = this.type), "." !== this.separator && (e.separator = this.separator), "value" === this.type && 1 !== this.ancestor && (e.ancestor = this.ancestor), this.map && (e.map = [
                        ...this.map
                    ]);
                    for (const t of [
                        "adjust",
                        "iterables",
                        "render"
                    ])null !== this[t] && void 0 !== this[t] && (e[t] = this[t]);
                    return !1 !== this.in && (e.in = !0), {
                        ref: e
                    };
                }
                updateDisplay() {
                    const e = null !== this.key ? this.key : "";
                    if ("value" !== this.type) return void (this.display = `ref:${this.type}:${e}`);
                    if (!this.separator) return void (this.display = `ref:${e}`);
                    if (!this.ancestor) return void (this.display = `ref:${this.separator}${e}`);
                    if ("root" === this.ancestor) return void (this.display = `ref:root:${e}`);
                    if (1 === this.ancestor) return void (this.display = `ref:${e || ".."}`);
                    const t = new Array(this.ancestor + 1).fill(this.separator).join("");
                    this.display = `ref:${t}${e || ""}`;
                }
            }, l.Ref.prototype[i.symbols.ref] = !0, t.build = function(e) {
                return "value" === (e = Object.assign({}, l.defaults, e)).type && void 0 === e.ancestor && (e.ancestor = 1), new l.Ref(e);
            }, l.context = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (e = e.trim(), r) {
                    const s = void 0 === r.global ? "$" : r.global;
                    if (s !== t && e.startsWith(s)) return {
                        key: e.slice(s.length),
                        type: "global"
                    };
                    const n = void 0 === r.local ? "#" : r.local;
                    if (n !== t && e.startsWith(n)) return {
                        key: e.slice(n.length),
                        type: "local"
                    };
                    const a = void 0 === r.root ? "/" : r.root;
                    if (a !== t && e.startsWith(a)) return {
                        key: e.slice(a.length),
                        type: "value",
                        root: !0
                    };
                }
                return {
                    key: e,
                    type: "value"
                };
            }, l.ancestor = function(e, t) {
                if (!t) return [
                    1,
                    0
                ];
                if (e[0] !== t) return [
                    1,
                    0
                ];
                if (e[1] !== t) return [
                    0,
                    1
                ];
                let r = 2;
                for(; e[r] === t;)++r;
                return [
                    r - 1,
                    r
                ];
            }, t.toSibling = 0, t.toParent = 1, t.Manager = class {
                constructor(){
                    this.refs = [];
                }
                register(e, s) {
                    if (e) {
                        if (s = void 0 === s ? t.toParent : s, Array.isArray(e)) for (const t of e)this.register(t, s);
                        else if (i.isSchema(e)) for (const t of e._refs.refs)t.ancestor - s >= 0 && this.refs.push({
                            ancestor: t.ancestor - s,
                            root: t.root
                        });
                        else t.isRef(e) && "value" === e.type && e.ancestor - s >= 0 && this.refs.push({
                            ancestor: e.ancestor - s,
                            root: e.root
                        }), o = o || r(3328), o.isTemplate(e) && this.register(e.refs(), s);
                    }
                }
                get length() {
                    return this.refs.length;
                }
                clone() {
                    const e = new t.Manager;
                    return e.refs = n(this.refs), e;
                }
                reset() {
                    this.refs = [];
                }
                roots() {
                    return this.refs.filter((e)=>!e.ancestor).map((e)=>e.root);
                }
            };
        },
        3378: (e, t, r)=>{
            "use strict";
            const s = r(5107), n = {};
            n.wrap = s.string().min(1).max(2).allow(!1), t.preferences = s.object({
                allowUnknown: s.boolean(),
                abortEarly: s.boolean(),
                artifacts: s.boolean(),
                cache: s.boolean(),
                context: s.object(),
                convert: s.boolean(),
                dateFormat: s.valid("date", "iso", "string", "time", "utc"),
                debug: s.boolean(),
                errors: {
                    escapeHtml: s.boolean(),
                    label: s.valid("path", "key", !1),
                    language: [
                        s.string(),
                        s.object().ref()
                    ],
                    render: s.boolean(),
                    stack: s.boolean(),
                    wrap: {
                        label: n.wrap,
                        array: n.wrap,
                        string: n.wrap
                    }
                },
                externals: s.boolean(),
                messages: s.object(),
                noDefaults: s.boolean(),
                nonEnumerables: s.boolean(),
                presence: s.valid("required", "optional", "forbidden"),
                skipFunctions: s.boolean(),
                stripUnknown: s.object({
                    arrays: s.boolean(),
                    objects: s.boolean()
                }).or("arrays", "objects").allow(!0, !1),
                warnings: s.boolean()
            }).strict(), n.nameRx = /^[a-zA-Z0-9]\w*$/, n.rule = s.object({
                alias: s.array().items(s.string().pattern(n.nameRx)).single(),
                args: s.array().items(s.string(), s.object({
                    name: s.string().pattern(n.nameRx).required(),
                    ref: s.boolean(),
                    assert: s.alternatives([
                        s.function(),
                        s.object().schema()
                    ]).conditional("ref", {
                        is: !0,
                        then: s.required()
                    }),
                    normalize: s.function(),
                    message: s.string().when("assert", {
                        is: s.function(),
                        then: s.required()
                    })
                })),
                convert: s.boolean(),
                manifest: s.boolean(),
                method: s.function().allow(!1),
                multi: s.boolean(),
                validate: s.function()
            }), t.extension = s.object({
                type: s.alternatives([
                    s.string(),
                    s.object().regex()
                ]).required(),
                args: s.function(),
                cast: s.object().pattern(n.nameRx, s.object({
                    from: s.function().maxArity(1).required(),
                    to: s.function().minArity(1).maxArity(2).required()
                })),
                base: s.object().schema().when("type", {
                    is: s.object().regex(),
                    then: s.forbidden()
                }),
                coerce: [
                    s.function().maxArity(3),
                    s.object({
                        method: s.function().maxArity(3).required(),
                        from: s.array().items(s.string()).single()
                    })
                ],
                flags: s.object().pattern(n.nameRx, s.object({
                    setter: s.string(),
                    default: s.any()
                })),
                manifest: {
                    build: s.function().arity(2)
                },
                messages: [
                    s.object(),
                    s.string()
                ],
                modifiers: s.object().pattern(n.nameRx, s.function().minArity(1).maxArity(2)),
                overrides: s.object().pattern(n.nameRx, s.function()),
                prepare: s.function().maxArity(3),
                rebuild: s.function().arity(1),
                rules: s.object().pattern(n.nameRx, n.rule),
                terms: s.object().pattern(n.nameRx, s.object({
                    init: s.array().allow(null).required(),
                    manifest: s.object().pattern(/.+/, [
                        s.valid("schema", "single"),
                        s.object({
                            mapped: s.object({
                                from: s.string().required(),
                                to: s.string().required()
                            }).required()
                        })
                    ])
                })),
                validate: s.function().maxArity(3)
            }).strict(), t.extensions = s.array().items(s.object(), s.function().arity(1)).strict(), n.desc = {
                buffer: s.object({
                    buffer: s.string()
                }),
                func: s.object({
                    function: s.function().required(),
                    options: {
                        literal: !0
                    }
                }),
                override: s.object({
                    override: !0
                }),
                ref: s.object({
                    ref: s.object({
                        type: s.valid("value", "global", "local"),
                        path: s.array().required(),
                        separator: s.string().length(1).allow(!1),
                        ancestor: s.number().min(0).integer().allow("root"),
                        map: s.array().items(s.array().length(2)).min(1),
                        adjust: s.function(),
                        iterables: s.boolean(),
                        in: s.boolean(),
                        render: s.boolean()
                    }).required()
                }),
                regex: s.object({
                    regex: s.string().min(3)
                }),
                special: s.object({
                    special: s.valid("deep").required()
                }),
                template: s.object({
                    template: s.string().required(),
                    options: s.object()
                }),
                value: s.object({
                    value: s.alternatives([
                        s.object(),
                        s.array()
                    ]).required()
                })
            }, n.desc.entity = s.alternatives([
                s.array().items(s.link("...")),
                s.boolean(),
                s.function(),
                s.number(),
                s.string(),
                n.desc.buffer,
                n.desc.func,
                n.desc.ref,
                n.desc.regex,
                n.desc.special,
                n.desc.template,
                n.desc.value,
                s.link("/")
            ]), n.desc.values = s.array().items(null, s.boolean(), s.function(), s.number().allow(1 / 0, -1 / 0), s.string().allow(""), s.symbol(), n.desc.buffer, n.desc.func, n.desc.override, n.desc.ref, n.desc.regex, n.desc.template, n.desc.value), n.desc.messages = s.object().pattern(/.+/, [
                s.string(),
                n.desc.template,
                s.object().pattern(/.+/, [
                    s.string(),
                    n.desc.template
                ])
            ]), t.description = s.object({
                type: s.string().required(),
                flags: s.object({
                    cast: s.string(),
                    default: s.any(),
                    description: s.string(),
                    empty: s.link("/"),
                    failover: n.desc.entity,
                    id: s.string(),
                    label: s.string(),
                    only: !0,
                    presence: [
                        "optional",
                        "required",
                        "forbidden"
                    ],
                    result: [
                        "raw",
                        "strip"
                    ],
                    strip: s.boolean(),
                    unit: s.string()
                }).unknown(),
                preferences: {
                    allowUnknown: s.boolean(),
                    abortEarly: s.boolean(),
                    artifacts: s.boolean(),
                    cache: s.boolean(),
                    convert: s.boolean(),
                    dateFormat: [
                        "date",
                        "iso",
                        "string",
                        "time",
                        "utc"
                    ],
                    errors: {
                        escapeHtml: s.boolean(),
                        label: [
                            "path",
                            "key"
                        ],
                        language: [
                            s.string(),
                            n.desc.ref
                        ],
                        wrap: {
                            label: n.wrap,
                            array: n.wrap
                        }
                    },
                    externals: s.boolean(),
                    messages: n.desc.messages,
                    noDefaults: s.boolean(),
                    nonEnumerables: s.boolean(),
                    presence: [
                        "required",
                        "optional",
                        "forbidden"
                    ],
                    skipFunctions: s.boolean(),
                    stripUnknown: s.object({
                        arrays: s.boolean(),
                        objects: s.boolean()
                    }).or("arrays", "objects").allow(!0, !1),
                    warnings: s.boolean()
                },
                allow: n.desc.values,
                invalid: n.desc.values,
                rules: s.array().min(1).items({
                    name: s.string().required(),
                    args: s.object().min(1),
                    keep: s.boolean(),
                    message: [
                        s.string(),
                        n.desc.messages
                    ],
                    warn: s.boolean()
                }),
                keys: s.object().pattern(/.*/, s.link("/")),
                link: n.desc.ref
            }).pattern(/^[a-z]\w*$/, s.any());
        },
        493: (e, t, r)=>{
            "use strict";
            const s = r(8571), n = r(9621), a = r(8160), i = {
                value: Symbol("value")
            };
            e.exports = i.State = class {
                constructor(e, t, r){
                    this.path = e, this.ancestors = t, this.mainstay = r.mainstay, this.schemas = r.schemas, this.debug = null;
                }
                localize(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    const s = new i.State(e, t, this);
                    return r && s.schemas && (s.schemas = [
                        i.schemas(r),
                        ...s.schemas
                    ]), s;
                }
                nest(e, t) {
                    const r = new i.State(this.path, this.ancestors, this);
                    return r.schemas = r.schemas && [
                        i.schemas(e),
                        ...r.schemas
                    ], r.debug = t, r;
                }
                shadow(e, t) {
                    this.mainstay.shadow = this.mainstay.shadow || new i.Shadow, this.mainstay.shadow.set(this.path, e, t);
                }
                snapshot() {
                    this.mainstay.shadow && (this._snapshot = s(this.mainstay.shadow.node(this.path))), this.mainstay.snapshot();
                }
                restore() {
                    this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.restore();
                }
            }, i.schemas = function(e) {
                return a.isSchema(e) ? {
                    schema: e
                } : e;
            }, i.Shadow = class {
                constructor(){
                    this._values = null;
                }
                set(e, t, r) {
                    if (!e.length) return;
                    if ("strip" === r && "number" == typeof e[e.length - 1]) return;
                    this._values = this._values || new Map;
                    let s = this._values;
                    for(let t = 0; t < e.length; ++t){
                        const r = e[t];
                        let n = s.get(r);
                        n || (n = new Map, s.set(r, n)), s = n;
                    }
                    s[i.value] = t;
                }
                get(e) {
                    const t = this.node(e);
                    if (t) return t[i.value];
                }
                node(e) {
                    if (this._values) return n(this._values, e, {
                        iterables: !0
                    });
                }
                override(e, t) {
                    if (!this._values) return;
                    const r = e.slice(0, -1), s = e[e.length - 1], a = n(this._values, r, {
                        iterables: !0
                    });
                    t ? a.set(s, t) : a && a.delete(s);
                }
            };
        },
        3328: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(5277), i = r(1447), o = r(8160), l = r(6354), c = r(6133), u = {
                symbol: Symbol("template"),
                opens: new Array(1e3).join("\0"),
                closes: new Array(1e3).join("\x01"),
                dateFormat: {
                    date: Date.prototype.toDateString,
                    iso: Date.prototype.toISOString,
                    string: Date.prototype.toString,
                    time: Date.prototype.toTimeString,
                    utc: Date.prototype.toUTCString
                }
            };
            e.exports = u.Template = class {
                constructor(e, t){
                    s("string" == typeof e, "Template source must be a string"), s(!e.includes("\0") && !e.includes("\x01"), "Template source cannot contain reserved control characters"), this.source = e, this.rendered = e, this._template = null, this._settings = n(t), this._parse();
                }
                _parse() {
                    if (!this.source.includes("{")) return;
                    const e = u.encode(this.source), t = u.split(e);
                    let r = !1;
                    const s = [], n = t.shift();
                    n && s.push(n);
                    for (const e of t){
                        const t = "{" !== e[0], n = t ? "}" : "}}", a = e.indexOf(n);
                        if (-1 === a || "{" === e[1]) {
                            s.push(`{${u.decode(e)}`);
                            continue;
                        }
                        let i = e.slice(t ? 0 : 1, a);
                        const o = ":" === i[0];
                        o && (i = i.slice(1));
                        const l = this._ref(u.decode(i), {
                            raw: t,
                            wrapped: o
                        });
                        s.push(l), "string" != typeof l && (r = !0);
                        const c = e.slice(a + n.length);
                        c && s.push(u.decode(c));
                    }
                    r ? this._template = s : this.rendered = s.join("");
                }
                static date(e, t) {
                    return u.dateFormat[t.dateFormat].call(e);
                }
                describe() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    if (!this._settings && e.compact) return this.source;
                    const t = {
                        template: this.source
                    };
                    return this._settings && (t.options = this._settings), t;
                }
                static build(e) {
                    return new u.Template(e.template, e.options);
                }
                isDynamic() {
                    return !!this._template;
                }
                static isTemplate(e) {
                    return !!e && !!e[o.symbols.template];
                }
                refs() {
                    if (!this._template) return;
                    const e = [];
                    for (const t of this._template)"string" != typeof t && e.push(...t.refs);
                    return e;
                }
                resolve(e, t, r, s) {
                    return this._template && 1 === this._template.length ? this._part(this._template[0], e, t, r, s, {}) : this.render(e, t, r, s);
                }
                _part(e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)r[s - 1] = arguments[s];
                    return e.ref ? e.ref.resolve(...r) : e.formula.evaluate(r);
                }
                render(e, t, r, s) {
                    let n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
                    if (!this.isDynamic()) return this.rendered;
                    const i = [];
                    for (const o of this._template)if ("string" == typeof o) i.push(o);
                    else {
                        const l = this._part(o, e, t, r, s, n), c = u.stringify(l, e, t, r, s, n);
                        if (void 0 !== c) {
                            const e = o.raw || !1 === (n.errors && n.errors.escapeHtml) ? c : a(c);
                            i.push(u.wrap(e, o.wrapped && r.errors.wrap.label));
                        }
                    }
                    return i.join("");
                }
                _ref(e, t) {
                    let { raw: r, wrapped: s } = t;
                    const n = [], a = (e)=>{
                        const t = c.create(e, this._settings);
                        return n.push(t), (e)=>t.resolve(...e);
                    };
                    try {
                        var o = new i.Parser(e, {
                            reference: a,
                            functions: u.functions,
                            constants: u.constants
                        });
                    } catch (t) {
                        throw t.message = `Invalid template variable "${e}" fails due to: ${t.message}`, t;
                    }
                    if (o.single) {
                        if ("reference" === o.single.type) {
                            const e = n[0];
                            return {
                                ref: e,
                                raw: r,
                                refs: n,
                                wrapped: s || "local" === e.type && "label" === e.key
                            };
                        }
                        return u.stringify(o.single.value);
                    }
                    return {
                        formula: o,
                        raw: r,
                        refs: n
                    };
                }
                toString() {
                    return this.source;
                }
            }, u.Template.prototype[o.symbols.template] = !0, u.Template.prototype.isImmutable = !0, u.encode = function(e) {
                return e.replace(/\\(\{+)/g, (e, t)=>u.opens.slice(0, t.length)).replace(/\\(\}+)/g, (e, t)=>u.closes.slice(0, t.length));
            }, u.decode = function(e) {
                return e.replace(/\u0000/g, "{").replace(/\u0001/g, "}");
            }, u.split = function(e) {
                const t = [];
                let r = "";
                for(let s = 0; s < e.length; ++s){
                    const n = e[s];
                    if ("{" === n) {
                        let n = "";
                        for(; s + 1 < e.length && "{" === e[s + 1];)n += "{", ++s;
                        t.push(r), r = n;
                    } else r += n;
                }
                return t.push(r), t;
            }, u.wrap = function(e, t) {
                return t ? 1 === t.length ? `${t}${e}${t}` : `${t[0]}${e}${t[1]}` : e;
            }, u.stringify = function(e, t, r, s, n) {
                let a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
                const i = typeof e, o = s && s.errors && s.errors.wrap || {};
                let l = !1;
                if (c.isRef(e) && e.render && (l = e.in, e = e.resolve(t, r, s, n, {
                    in: e.in,
                    ...a
                })), null === e) return "null";
                if ("string" === i) return u.wrap(e, a.arrayItems && o.string);
                if ("number" === i || "function" === i || "symbol" === i) return e.toString();
                if ("object" !== i) return JSON.stringify(e);
                if (e instanceof Date) return u.Template.date(e, s);
                if (e instanceof Map) {
                    const t = [];
                    for (const [r, s] of e.entries())t.push(`${r.toString()} -> ${s.toString()}`);
                    e = t;
                }
                if (!Array.isArray(e)) return e.toString();
                const f = [];
                for (const i of e)f.push(u.stringify(i, t, r, s, n, {
                    arrayItems: !0,
                    ...a
                }));
                return u.wrap(f.join(", "), !l && o.array);
            }, u.constants = {
                true: !0,
                false: !1,
                null: null,
                second: 1e3,
                minute: 6e4,
                hour: 36e5,
                day: 864e5
            }, u.functions = {
                if: (e, t, r)=>e ? t : r,
                length: (e)=>"string" == typeof e ? e.length : e && "object" == typeof e ? Array.isArray(e) ? e.length : Object.keys(e).length : null,
                msg (e) {
                    const [t, r, s, n, a] = this, i = a.messages;
                    if (!i) return "";
                    const o = l.template(t, i[0], e, r, s) || l.template(t, i[1], e, r, s);
                    return o ? o.render(t, r, s, n, a) : "";
                },
                number: (e)=>"number" == typeof e ? e : "string" == typeof e ? parseFloat(e) : "boolean" == typeof e ? e ? 1 : 0 : e instanceof Date ? e.getTime() : null
            };
        },
        4946: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(1687), a = r(8068), i = r(8160), o = r(3292), l = r(6354), c = r(6133), u = {};
            e.exports = a.extend({
                type: "alternatives",
                flags: {
                    match: {
                        default: "any"
                    }
                },
                terms: {
                    matches: {
                        init: [],
                        register: c.toSibling
                    }
                },
                args (e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)r[s - 1] = arguments[s];
                    return 1 === r.length && Array.isArray(r[0]) ? e.try(...r[0]) : e.try(...r);
                },
                validate (e, t) {
                    const { schema: r, error: s, state: a, prefs: i } = t;
                    if (r._flags.match) {
                        const t = [], o = [];
                        for(let s = 0; s < r.$_terms.matches.length; ++s){
                            const n = r.$_terms.matches[s], l = a.nest(n.schema, `match.${s}`);
                            l.snapshot();
                            const c = n.schema.$_validate(e, l, i);
                            c.errors ? (o.push(c.errors), l.restore()) : t.push(c.value);
                        }
                        if (0 === t.length) return {
                            errors: s("alternatives.any", {
                                details: o.map((e)=>l.details(e, {
                                        override: !1
                                    }))
                            })
                        };
                        if ("one" === r._flags.match) return 1 === t.length ? {
                            value: t[0]
                        } : {
                            errors: s("alternatives.one")
                        };
                        if (t.length !== r.$_terms.matches.length) return {
                            errors: s("alternatives.all", {
                                details: o.map((e)=>l.details(e, {
                                        override: !1
                                    }))
                            })
                        };
                        const c = (e)=>e.$_terms.matches.some((e)=>"object" === e.schema.type || "alternatives" === e.schema.type && c(e.schema));
                        return c(r) ? {
                            value: t.reduce((e, t)=>n(e, t, {
                                    mergeArrays: !1
                                }))
                        } : {
                            value: t[t.length - 1]
                        };
                    }
                    const o = [];
                    for(let t = 0; t < r.$_terms.matches.length; ++t){
                        const s = r.$_terms.matches[t];
                        if (s.schema) {
                            const r = a.nest(s.schema, `match.${t}`);
                            r.snapshot();
                            const n = s.schema.$_validate(e, r, i);
                            if (!n.errors) return n;
                            r.restore(), o.push({
                                schema: s.schema,
                                reports: n.errors
                            });
                            continue;
                        }
                        const n = s.ref ? s.ref.resolve(e, a, i) : e, l = s.is ? [
                            s
                        ] : s.switch;
                        for(let r = 0; r < l.length; ++r){
                            const o = l[r], { is: c, then: u, otherwise: f } = o, h = `match.${t}${s.switch ? "." + r : ""}`;
                            if (c.$_match(n, a.nest(c, `${h}.is`), i)) {
                                if (u) return u.$_validate(e, a.nest(u, `${h}.then`), i);
                            } else if (f) return f.$_validate(e, a.nest(f, `${h}.otherwise`), i);
                        }
                    }
                    return u.errors(o, t);
                },
                rules: {
                    conditional: {
                        method (e, t) {
                            s(!this._flags._endedSwitch, "Unreachable condition"), s(!this._flags.match, "Cannot combine match mode", this._flags.match, "with conditional rule"), s(void 0 === t.break, "Cannot use break option with alternatives conditional");
                            const r = this.clone(), n = o.when(r, e, t), a = n.is ? [
                                n
                            ] : n.switch;
                            for (const e of a)if (e.then && e.otherwise) {
                                r.$_setFlag("_endedSwitch", !0, {
                                    clone: !1
                                });
                                break;
                            }
                            return r.$_terms.matches.push(n), r.$_mutateRebuild();
                        }
                    },
                    match: {
                        method (e) {
                            if (s([
                                "any",
                                "one",
                                "all"
                            ].includes(e), "Invalid alternatives match mode", e), "any" !== e) for (const t of this.$_terms.matches)s(t.schema, "Cannot combine match mode", e, "with conditional rules");
                            return this.$_setFlag("match", e);
                        }
                    },
                    try: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            s(t.length, "Missing alternative schemas"), i.verifyFlat(t, "try"), s(!this._flags._endedSwitch, "Unreachable condition");
                            const n = this.clone();
                            for (const e of t)n.$_terms.matches.push({
                                schema: n.$_compile(e)
                            });
                            return n.$_mutateRebuild();
                        }
                    }
                },
                overrides: {
                    label (e) {
                        return this.$_parent("label", e).$_modify({
                            each: (t, r)=>"is" !== r.path[0] ? t.label(e) : void 0,
                            ref: !1
                        });
                    }
                },
                rebuild (e) {
                    e.$_modify({
                        each: (t)=>{
                            i.isSchema(t) && "array" === t.type && e.$_setFlag("_arrayItems", !0, {
                                clone: !1
                            });
                        }
                    });
                },
                manifest: {
                    build (e, t) {
                        if (t.matches) for (const r of t.matches){
                            const { schema: t, ref: s, is: n, not: a, then: i, otherwise: o } = r;
                            e = t ? e.try(t) : s ? e.conditional(s, {
                                is: n,
                                then: i,
                                not: a,
                                otherwise: o,
                                switch: r.switch
                            }) : e.conditional(n, {
                                then: i,
                                otherwise: o
                            });
                        }
                        return e;
                    }
                },
                messages: {
                    "alternatives.all": "{{#label}} does not match all of the required types",
                    "alternatives.any": "{{#label}} does not match any of the allowed types",
                    "alternatives.match": "{{#label}} does not match any of the allowed types",
                    "alternatives.one": "{{#label}} matches more than one allowed type",
                    "alternatives.types": "{{#label}} must be one of {{#types}}"
                }
            }), u.errors = function(e, t) {
                let { error: r, state: s } = t;
                if (!e.length) return {
                    errors: r("alternatives.any")
                };
                if (1 === e.length) return {
                    errors: e[0].reports
                };
                const n = new Set, a = [];
                for (const { reports: t, schema: i } of e){
                    if (t.length > 1) return u.unmatched(e, r);
                    const o = t[0];
                    if (o instanceof l.Report == 0) return u.unmatched(e, r);
                    if (o.state.path.length !== s.path.length) {
                        a.push({
                            type: i.type,
                            report: o
                        });
                        continue;
                    }
                    if ("any.only" === o.code) {
                        for (const e of o.local.valids)n.add(e);
                        continue;
                    }
                    const [c, f] = o.code.split(".");
                    "base" === f ? n.add(c) : a.push({
                        type: i.type,
                        report: o
                    });
                }
                return a.length ? 1 === a.length ? {
                    errors: a[0].report
                } : u.unmatched(e, r) : {
                    errors: r("alternatives.types", {
                        types: [
                            ...n
                        ]
                    })
                };
            }, u.unmatched = function(e, t) {
                const r = [];
                for (const t of e)r.push(...t.reports);
                return {
                    errors: t("alternatives.match", l.details(r, {
                        override: !1
                    }))
                };
            };
        },
        8068: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(7629), a = r(8160), i = r(6914);
            e.exports = n.extend({
                type: "any",
                flags: {
                    only: {
                        default: !1
                    }
                },
                terms: {
                    alterations: {
                        init: null
                    },
                    examples: {
                        init: null
                    },
                    externals: {
                        init: null
                    },
                    metas: {
                        init: []
                    },
                    notes: {
                        init: []
                    },
                    shared: {
                        init: null
                    },
                    tags: {
                        init: []
                    },
                    whens: {
                        init: null
                    }
                },
                rules: {
                    custom: {
                        method (e, t) {
                            return s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this.$_addRule({
                                name: "custom",
                                args: {
                                    method: e,
                                    description: t
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { method: s } = r;
                            try {
                                return s(e, t);
                            } catch (e) {
                                return t.error("any.custom", {
                                    error: e
                                });
                            }
                        },
                        args: [
                            "method",
                            "description"
                        ],
                        multi: !0
                    },
                    messages: {
                        method (e) {
                            return this.prefs({
                                messages: e
                            });
                        }
                    },
                    shared: {
                        method (e) {
                            s(a.isSchema(e) && e._flags.id, "Schema must be a schema with an id");
                            const t = this.clone();
                            return t.$_terms.shared = t.$_terms.shared || [], t.$_terms.shared.push(e), t.$_mutateRegister(e), t;
                        }
                    },
                    warning: {
                        method (e, t) {
                            return s(e && "string" == typeof e, "Invalid warning code"), this.$_addRule({
                                name: "warning",
                                args: {
                                    code: e,
                                    local: t
                                },
                                warn: !0
                            });
                        },
                        validate (e, t, r) {
                            let { code: s, local: n } = r;
                            return t.error(s, n);
                        },
                        args: [
                            "code",
                            "local"
                        ],
                        multi: !0
                    }
                },
                modifiers: {
                    keep (e) {
                        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        e.keep = t;
                    },
                    message (e, t) {
                        e.message = i.compile(t);
                    },
                    warn (e) {
                        let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        e.warn = t;
                    }
                },
                manifest: {
                    build (e, t) {
                        for(const r in t){
                            const s = t[r];
                            if ([
                                "examples",
                                "externals",
                                "metas",
                                "notes",
                                "tags"
                            ].includes(r)) for (const t of s)e = e[r.slice(0, -1)](t);
                            else if ("alterations" !== r) {
                                if ("whens" !== r) {
                                    if ("shared" === r) for (const t of s)e = e.shared(t);
                                } else for (const t of s){
                                    const { ref: r, is: s, not: n, then: a, otherwise: i, concat: o } = t;
                                    e = o ? e.concat(o) : r ? e.when(r, {
                                        is: s,
                                        not: n,
                                        then: a,
                                        otherwise: i,
                                        switch: t.switch,
                                        break: t.break
                                    }) : e.when(s, {
                                        then: a,
                                        otherwise: i,
                                        break: t.break
                                    });
                                }
                            } else {
                                const t = {};
                                for (const { target: e, adjuster: r } of s)t[e] = r;
                                e = e.alter(t);
                            }
                        }
                        return e;
                    }
                },
                messages: {
                    "any.custom": "{{#label}} failed custom validation because {{#error.message}}",
                    "any.default": "{{#label}} threw an error when running default method",
                    "any.failover": "{{#label}} threw an error when running failover method",
                    "any.invalid": "{{#label}} contains an invalid value",
                    "any.only": '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
                    "any.ref": "{{#label}} {{#arg}} references {{:#ref}} which {{#reason}}",
                    "any.required": "{{#label}} is required",
                    "any.unknown": "{{#label}} is not allowed"
                }
            });
        },
        546: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(9474), a = r(9621), i = r(8068), o = r(8160), l = r(3292), c = {};
            e.exports = i.extend({
                type: "array",
                flags: {
                    single: {
                        default: !1
                    },
                    sparse: {
                        default: !1
                    }
                },
                terms: {
                    items: {
                        init: [],
                        manifest: "schema"
                    },
                    ordered: {
                        init: [],
                        manifest: "schema"
                    },
                    _exclusions: {
                        init: []
                    },
                    _inclusions: {
                        init: []
                    },
                    _requireds: {
                        init: []
                    }
                },
                coerce: {
                    from: "object",
                    method (e, t) {
                        let { schema: r, state: s, prefs: n } = t;
                        if (!Array.isArray(e)) return;
                        const a = r.$_getRule("sort");
                        return a ? c.sort(r, e, a.args.options, s, n) : void 0;
                    }
                },
                validate (e, t) {
                    let { schema: r, error: s } = t;
                    if (!Array.isArray(e)) {
                        if (r._flags.single) {
                            const t = [
                                e
                            ];
                            return t[o.symbols.arraySingle] = !0, {
                                value: t
                            };
                        }
                        return {
                            errors: s("array.base")
                        };
                    }
                    if (r.$_getRule("items") || r.$_terms.externals) return {
                        value: e.slice()
                    };
                },
                rules: {
                    has: {
                        method (e) {
                            e = this.$_compile(e, {
                                appendPath: !0
                            });
                            const t = this.$_addRule({
                                name: "has",
                                args: {
                                    schema: e
                                }
                            });
                            return t.$_mutateRegister(e), t;
                        },
                        validate (e, t, r) {
                            let { state: s, prefs: n, error: a } = t, { schema: i } = r;
                            const o = [
                                e,
                                ...s.ancestors
                            ];
                            for(let t = 0; t < e.length; ++t){
                                const r = s.localize([
                                    ...s.path,
                                    t
                                ], o, i);
                                if (i.$_match(e[t], r, n)) return e;
                            }
                            const l = i._flags.label;
                            return l ? a("array.hasKnown", {
                                patternLabel: l
                            }) : a("array.hasUnknown", null);
                        },
                        multi: !0
                    },
                    items: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            o.verifyFlat(t, "items");
                            const s = this.$_addRule("items");
                            for(let e = 0; e < t.length; ++e){
                                const r = o.tryWithPath(()=>this.$_compile(t[e]), e, {
                                    append: !0
                                });
                                s.$_terms.items.push(r);
                            }
                            return s.$_mutateRebuild();
                        },
                        validate (e, t) {
                            let { schema: r, error: s, state: n, prefs: a, errorsArray: i } = t;
                            const l = r.$_terms._requireds.slice(), u = r.$_terms.ordered.slice(), f = [
                                ...r.$_terms._inclusions,
                                ...l
                            ], h = !e[o.symbols.arraySingle];
                            delete e[o.symbols.arraySingle];
                            const m = i();
                            let d = e.length;
                            for(let t = 0; t < d; ++t){
                                const i = e[t];
                                let o = !1, p = !1;
                                const g = h ? t : new Number(t), y = [
                                    ...n.path,
                                    g
                                ];
                                if (!r._flags.sparse && void 0 === i) {
                                    if (m.push(s("array.sparse", {
                                        key: g,
                                        path: y,
                                        pos: t,
                                        value: void 0
                                    }, n.localize(y))), a.abortEarly) return m;
                                    u.shift();
                                    continue;
                                }
                                const b = [
                                    e,
                                    ...n.ancestors
                                ];
                                for (const e of r.$_terms._exclusions)if (e.$_match(i, n.localize(y, b, e), a, {
                                    presence: "ignore"
                                })) {
                                    if (m.push(s("array.excludes", {
                                        pos: t,
                                        value: i
                                    }, n.localize(y))), a.abortEarly) return m;
                                    o = !0, u.shift();
                                    break;
                                }
                                if (o) continue;
                                if (r.$_terms.ordered.length) {
                                    if (u.length) {
                                        const o = u.shift(), l = o.$_validate(i, n.localize(y, b, o), a);
                                        if (l.errors) {
                                            if (m.push(...l.errors), a.abortEarly) return m;
                                        } else if ("strip" === o._flags.result) c.fastSplice(e, t), --t, --d;
                                        else {
                                            if (!r._flags.sparse && void 0 === l.value) {
                                                if (m.push(s("array.sparse", {
                                                    key: g,
                                                    path: y,
                                                    pos: t,
                                                    value: void 0
                                                }, n.localize(y))), a.abortEarly) return m;
                                                continue;
                                            }
                                            e[t] = l.value;
                                        }
                                        continue;
                                    }
                                    if (!r.$_terms.items.length) {
                                        if (m.push(s("array.orderedLength", {
                                            pos: t,
                                            limit: r.$_terms.ordered.length
                                        })), a.abortEarly) return m;
                                        break;
                                    }
                                }
                                const v = [];
                                let _ = l.length;
                                for(let o = 0; o < _; ++o){
                                    const u = n.localize(y, b, l[o]);
                                    u.snapshot();
                                    const f = l[o].$_validate(i, u, a);
                                    if (v[o] = f, !f.errors) {
                                        if (e[t] = f.value, p = !0, c.fastSplice(l, o), --o, --_, !r._flags.sparse && void 0 === f.value && (m.push(s("array.sparse", {
                                            key: g,
                                            path: y,
                                            pos: t,
                                            value: void 0
                                        }, n.localize(y))), a.abortEarly)) return m;
                                        break;
                                    }
                                    u.restore();
                                }
                                if (p) continue;
                                const w = a.stripUnknown && !!a.stripUnknown.arrays || !1;
                                _ = f.length;
                                for (const u of f){
                                    let f;
                                    const h = l.indexOf(u);
                                    if (-1 !== h) f = v[h];
                                    else {
                                        const l = n.localize(y, b, u);
                                        if (l.snapshot(), f = u.$_validate(i, l, a), !f.errors) {
                                            "strip" === u._flags.result ? (c.fastSplice(e, t), --t, --d) : r._flags.sparse || void 0 !== f.value ? e[t] = f.value : (m.push(s("array.sparse", {
                                                key: g,
                                                path: y,
                                                pos: t,
                                                value: void 0
                                            }, n.localize(y))), o = !0), p = !0;
                                            break;
                                        }
                                        l.restore();
                                    }
                                    if (1 === _) {
                                        if (w) {
                                            c.fastSplice(e, t), --t, --d, p = !0;
                                            break;
                                        }
                                        if (m.push(...f.errors), a.abortEarly) return m;
                                        o = !0;
                                        break;
                                    }
                                }
                                if (!o && (r.$_terms._inclusions.length || r.$_terms._requireds.length) && !p) {
                                    if (w) {
                                        c.fastSplice(e, t), --t, --d;
                                        continue;
                                    }
                                    if (m.push(s("array.includes", {
                                        pos: t,
                                        value: i
                                    }, n.localize(y))), a.abortEarly) return m;
                                }
                            }
                            return l.length && c.fillMissedErrors(r, m, l, e, n, a), u.length && (c.fillOrderedErrors(r, m, u, e, n, a), m.length || c.fillDefault(u, e, n, a)), m.length ? m : e;
                        },
                        priority: !0,
                        manifest: !1
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate (e, t, r, s) {
                            let { limit: n } = r, { name: a, operator: i, args: l } = s;
                            return o.compare(e.length, n, i) ? e : t.error("array." + a, {
                                limit: l.limit,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: o.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    ordered: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            o.verifyFlat(t, "ordered");
                            const s = this.$_addRule("items");
                            for(let e = 0; e < t.length; ++e){
                                const r = o.tryWithPath(()=>this.$_compile(t[e]), e, {
                                    append: !0
                                });
                                c.validateSingle(r, s), s.$_mutateRegister(r), s.$_terms.ordered.push(r);
                            }
                            return s.$_mutateRebuild();
                        }
                    },
                    single: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return s(!t || !this._flags._arrayItems, "Cannot specify single rule when array has array items"), this.$_setFlag("single", t);
                        }
                    },
                    sort: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            o.assertOptions(e, [
                                "by",
                                "order"
                            ]);
                            const t = {
                                order: e.order || "ascending"
                            };
                            return e.by && (t.by = l.ref(e.by, {
                                ancestor: 0
                            }), s(!t.by.ancestor, "Cannot sort by ancestor")), this.$_addRule({
                                name: "sort",
                                args: {
                                    options: t
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { error: s, state: n, prefs: a, schema: i } = t, { options: o } = r;
                            const { value: l, errors: u } = c.sort(i, e, o, n, a);
                            if (u) return u;
                            for(let t = 0; t < e.length; ++t)if (e[t] !== l[t]) return s("array.sort", {
                                order: o.order,
                                by: o.by ? o.by.key : "value"
                            });
                            return e;
                        },
                        convert: !0
                    },
                    sparse: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return this._flags.sparse === t ? this : (t ? this.clone() : this.$_addRule("items")).$_setFlag("sparse", t, {
                                clone: !1
                            });
                        }
                    },
                    unique: {
                        method (e) {
                            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            s(!e || "function" == typeof e || "string" == typeof e, "comparator must be a function or a string"), o.assertOptions(t, [
                                "ignoreUndefined",
                                "separator"
                            ]);
                            const r = {
                                name: "unique",
                                args: {
                                    options: t,
                                    comparator: e
                                }
                            };
                            if (e) {
                                if ("string" == typeof e) {
                                    const s = o.default(t.separator, ".");
                                    r.path = s ? e.split(s) : [
                                        e
                                    ];
                                } else r.comparator = e;
                            }
                            return this.$_addRule(r);
                        },
                        validate (e, t, r, i) {
                            let { state: o, error: l, schema: c } = t, { comparator: u, options: f } = r, { comparator: h, path: m } = i;
                            const d = {
                                string: Object.create(null),
                                number: Object.create(null),
                                undefined: Object.create(null),
                                boolean: Object.create(null),
                                object: new Map,
                                function: new Map,
                                custom: new Map
                            }, p = h || n, g = f.ignoreUndefined;
                            for(let t = 0; t < e.length; ++t){
                                const r = m ? a(e[t], m) : e[t], n = h ? d.custom : d[typeof r];
                                if (s(n, "Failed to find unique map container for type", typeof r), n instanceof Map) {
                                    const s = n.entries();
                                    let a;
                                    for(; !(a = s.next()).done;)if (p(a.value[0], r)) {
                                        const r = o.localize([
                                            ...o.path,
                                            t
                                        ], [
                                            e,
                                            ...o.ancestors
                                        ]), s = {
                                            pos: t,
                                            value: e[t],
                                            dupePos: a.value[1],
                                            dupeValue: e[a.value[1]]
                                        };
                                        return m && (s.path = u), l("array.unique", s, r);
                                    }
                                    n.set(r, t);
                                } else {
                                    if ((!g || void 0 !== r) && void 0 !== n[r]) {
                                        const s = {
                                            pos: t,
                                            value: e[t],
                                            dupePos: n[r],
                                            dupeValue: e[n[r]]
                                        };
                                        return m && (s.path = u), l("array.unique", s, o.localize([
                                            ...o.path,
                                            t
                                        ], [
                                            e,
                                            ...o.ancestors
                                        ]));
                                    }
                                    n[r] = t;
                                }
                            }
                            return e;
                        },
                        args: [
                            "comparator",
                            "options"
                        ],
                        multi: !0
                    }
                },
                cast: {
                    set: {
                        from: Array.isArray,
                        to: (e, t)=>new Set(e)
                    }
                },
                rebuild (e) {
                    e.$_terms._inclusions = [], e.$_terms._exclusions = [], e.$_terms._requireds = [];
                    for (const t of e.$_terms.items)c.validateSingle(t, e), "required" === t._flags.presence ? e.$_terms._requireds.push(t) : "forbidden" === t._flags.presence ? e.$_terms._exclusions.push(t) : e.$_terms._inclusions.push(t);
                    for (const t of e.$_terms.ordered)c.validateSingle(t, e);
                },
                manifest: {
                    build: (e, t)=>(t.items && (e = e.items(...t.items)), t.ordered && (e = e.ordered(...t.ordered)), e)
                },
                messages: {
                    "array.base": "{{#label}} must be an array",
                    "array.excludes": "{{#label}} contains an excluded value",
                    "array.hasKnown": "{{#label}} does not contain at least one required match for type {:#patternLabel}",
                    "array.hasUnknown": "{{#label}} does not contain at least one required match",
                    "array.includes": "{{#label}} does not match any of the allowed types",
                    "array.includesRequiredBoth": "{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)",
                    "array.includesRequiredKnowns": "{{#label}} does not contain {{#knownMisses}}",
                    "array.includesRequiredUnknowns": "{{#label}} does not contain {{#unknownMisses}} required value(s)",
                    "array.length": "{{#label}} must contain {{#limit}} items",
                    "array.max": "{{#label}} must contain less than or equal to {{#limit}} items",
                    "array.min": "{{#label}} must contain at least {{#limit}} items",
                    "array.orderedLength": "{{#label}} must contain at most {{#limit}} items",
                    "array.sort": "{{#label}} must be sorted in {#order} order by {{#by}}",
                    "array.sort.mismatching": "{{#label}} cannot be sorted due to mismatching types",
                    "array.sort.unsupported": "{{#label}} cannot be sorted due to unsupported type {#type}",
                    "array.sparse": "{{#label}} must not be a sparse array item",
                    "array.unique": "{{#label}} contains a duplicate value"
                }
            }), c.fillMissedErrors = function(e, t, r, s, n, a) {
                const i = [];
                let o = 0;
                for (const e of r){
                    const t = e._flags.label;
                    t ? i.push(t) : ++o;
                }
                i.length ? o ? t.push(e.$_createError("array.includesRequiredBoth", s, {
                    knownMisses: i,
                    unknownMisses: o
                }, n, a)) : t.push(e.$_createError("array.includesRequiredKnowns", s, {
                    knownMisses: i
                }, n, a)) : t.push(e.$_createError("array.includesRequiredUnknowns", s, {
                    unknownMisses: o
                }, n, a));
            }, c.fillOrderedErrors = function(e, t, r, s, n, a) {
                const i = [];
                for (const e of r)"required" === e._flags.presence && i.push(e);
                i.length && c.fillMissedErrors(e, t, i, s, n, a);
            }, c.fillDefault = function(e, t, r, s) {
                const n = [];
                let a = !0;
                for(let i = e.length - 1; i >= 0; --i){
                    const o = e[i], l = [
                        t,
                        ...r.ancestors
                    ], c = o.$_validate(void 0, r.localize(r.path, l, o), s).value;
                    if (a) {
                        if (void 0 === c) continue;
                        a = !1;
                    }
                    n.unshift(c);
                }
                n.length && t.push(...n);
            }, c.fastSplice = function(e, t) {
                let r = t;
                for(; r < e.length;)e[r++] = e[r];
                --e.length;
            }, c.validateSingle = function(e, t) {
                ("array" === e.type || e._flags._arrayItems) && (s(!t._flags.single, "Cannot specify array item with single rule enabled"), t.$_setFlag("_arrayItems", !0, {
                    clone: !1
                }));
            }, c.sort = function(e, t, r, s, n) {
                const a = "ascending" === r.order ? 1 : -1, i = -1 * a, o = a, l = (l, u)=>{
                    let f = c.compare(l, u, i, o);
                    if (null !== f) return f;
                    if (r.by && (l = r.by.resolve(l, s, n), u = r.by.resolve(u, s, n)), f = c.compare(l, u, i, o), null !== f) return f;
                    const h = typeof l;
                    if (h !== typeof u) throw e.$_createError("array.sort.mismatching", t, null, s, n);
                    if ("number" !== h && "string" !== h) throw e.$_createError("array.sort.unsupported", t, {
                        type: h
                    }, s, n);
                    return "number" === h ? (l - u) * a : l < u ? i : o;
                };
                try {
                    return {
                        value: t.slice().sort(l)
                    };
                } catch (e) {
                    return {
                        errors: e
                    };
                }
            }, c.compare = function(e, t, r, s) {
                return e === t ? 0 : void 0 === e ? 1 : void 0 === t ? -1 : null === e ? s : null === t ? r : null;
            };
        },
        4937: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = r(8160), i = r(2036), o = {
                isBool: function(e) {
                    return "boolean" == typeof e;
                }
            };
            e.exports = n.extend({
                type: "boolean",
                flags: {
                    sensitive: {
                        default: !1
                    }
                },
                terms: {
                    falsy: {
                        init: null,
                        manifest: "values"
                    },
                    truthy: {
                        init: null,
                        manifest: "values"
                    }
                },
                coerce (e, t) {
                    let { schema: r } = t;
                    if ("boolean" != typeof e) {
                        if ("string" == typeof e) {
                            const t = r._flags.sensitive ? e : e.toLowerCase();
                            e = "true" === t || "false" !== t && e;
                        }
                        return "boolean" != typeof e && (e = r.$_terms.truthy && r.$_terms.truthy.has(e, null, null, !r._flags.sensitive) || (!r.$_terms.falsy || !r.$_terms.falsy.has(e, null, null, !r._flags.sensitive)) && e), {
                            value: e
                        };
                    }
                },
                validate (e, t) {
                    let { error: r } = t;
                    if ("boolean" != typeof e) return {
                        value: e,
                        errors: r("boolean.base")
                    };
                },
                rules: {
                    truthy: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            a.verifyFlat(t, "truthy");
                            const n = this.clone();
                            n.$_terms.truthy = n.$_terms.truthy || new i;
                            for(let e = 0; e < t.length; ++e){
                                const r = t[e];
                                s(void 0 !== r, "Cannot call truthy with undefined"), n.$_terms.truthy.add(r);
                            }
                            return n;
                        }
                    },
                    falsy: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            a.verifyFlat(t, "falsy");
                            const n = this.clone();
                            n.$_terms.falsy = n.$_terms.falsy || new i;
                            for(let e = 0; e < t.length; ++e){
                                const r = t[e];
                                s(void 0 !== r, "Cannot call falsy with undefined"), n.$_terms.falsy.add(r);
                            }
                            return n;
                        }
                    },
                    sensitive: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return this.$_setFlag("sensitive", e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: o.isBool,
                        to: (e, t)=>e ? 1 : 0
                    },
                    string: {
                        from: o.isBool,
                        to: (e, t)=>e ? "true" : "false"
                    }
                },
                manifest: {
                    build: (e, t)=>(t.truthy && (e = e.truthy(...t.truthy)), t.falsy && (e = e.falsy(...t.falsy)), e)
                },
                messages: {
                    "boolean.base": "{{#label}} must be a boolean"
                }
            });
        },
        7500: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = r(8160), i = r(3328), o = {
                isDate: function(e) {
                    return e instanceof Date;
                }
            };
            e.exports = n.extend({
                type: "date",
                coerce: {
                    from: [
                        "number",
                        "string"
                    ],
                    method (e, t) {
                        let { schema: r } = t;
                        return {
                            value: o.parse(e, r._flags.format) || e
                        };
                    }
                },
                validate (e, t) {
                    let { schema: r, error: s, prefs: n } = t;
                    if (e instanceof Date && !isNaN(e.getTime())) return;
                    const a = r._flags.format;
                    return n.convert && a && "string" == typeof e ? {
                        value: e,
                        errors: s("date.format", {
                            format: a
                        })
                    } : {
                        value: e,
                        errors: s("date.base")
                    };
                },
                rules: {
                    compare: {
                        method: !1,
                        validate (e, t, r, s) {
                            let { date: n } = r, { name: i, operator: o, args: l } = s;
                            const c = "now" === n ? Date.now() : n.getTime();
                            return a.compare(e.getTime(), c, o) ? e : t.error("date." + i, {
                                limit: l.date,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "date",
                                ref: !0,
                                normalize: (e)=>"now" === e ? e : o.parse(e),
                                assert: (e)=>null !== e,
                                message: "must have a valid date format"
                            }
                        ]
                    },
                    format: {
                        method (e) {
                            return s([
                                "iso",
                                "javascript",
                                "unix"
                            ].includes(e), "Unknown date format", e), this.$_setFlag("format", e);
                        }
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    iso: {
                        method () {
                            return this.format("iso");
                        }
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    timestamp: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "javascript";
                            return s([
                                "javascript",
                                "unix"
                            ].includes(e), '"type" must be one of "javascript, unix"'), this.format(e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: o.isDate,
                        to: (e, t)=>e.getTime()
                    },
                    string: {
                        from: o.isDate,
                        to (e, t) {
                            let { prefs: r } = t;
                            return i.date(e, r);
                        }
                    }
                },
                messages: {
                    "date.base": "{{#label}} must be a valid date",
                    "date.format": '{{#label}} must be in {msg("date.format." + #format) || #format} format',
                    "date.greater": "{{#label}} must be greater than {{:#limit}}",
                    "date.less": "{{#label}} must be less than {{:#limit}}",
                    "date.max": "{{#label}} must be less than or equal to {{:#limit}}",
                    "date.min": "{{#label}} must be greater than or equal to {{:#limit}}",
                    "date.format.iso": "ISO 8601 date",
                    "date.format.javascript": "timestamp or number of milliseconds",
                    "date.format.unix": "timestamp or number of seconds"
                }
            }), o.parse = function(e, t) {
                if (e instanceof Date) return e;
                if ("string" != typeof e && (isNaN(e) || !isFinite(e))) return null;
                if (/^\s*$/.test(e)) return null;
                if ("iso" === t) return a.isIsoDate(e) ? o.date(e.toString()) : null;
                const r = e;
                if ("string" == typeof e && /^[+-]?\d+(\.\d+)?$/.test(e) && (e = parseFloat(e)), t) {
                    if ("javascript" === t) return o.date(1 * e);
                    if ("unix" === t) return o.date(1e3 * e);
                    if ("string" == typeof r) return null;
                }
                return o.date(e);
            }, o.date = function(e) {
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t;
            };
        },
        390: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(7824);
            e.exports = n.extend({
                type: "function",
                properties: {
                    typeof: "function"
                },
                rules: {
                    arity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "arity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { n: s } = r;
                            return e.length === s ? e : t.error("function.arity", {
                                n: s
                            });
                        }
                    },
                    class: {
                        method () {
                            return this.$_addRule("class");
                        },
                        validate: (e, t)=>/^\s*class\s/.test(e.toString()) ? e : t.error("function.class", {
                                value: e
                            })
                    },
                    minArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e > 0, "n must be a strict positive integer"), this.$_addRule({
                                name: "minArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { n: s } = r;
                            return e.length >= s ? e : t.error("function.minArity", {
                                n: s
                            });
                        }
                    },
                    maxArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "maxArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { n: s } = r;
                            return e.length <= s ? e : t.error("function.maxArity", {
                                n: s
                            });
                        }
                    }
                },
                messages: {
                    "function.arity": "{{#label}} must have an arity of {{#n}}",
                    "function.class": "{{#label}} must be a class",
                    "function.maxArity": "{{#label}} must have an arity lesser or equal to {{#n}}",
                    "function.minArity": "{{#label}} must have an arity greater or equal to {{#n}}"
                }
            });
        },
        7824: (e, t, r)=>{
            "use strict";
            const s = r(978), n = r(375), a = r(8571), i = r(3652), o = r(8068), l = r(8160), c = r(3292), u = r(6354), f = r(6133), h = r(3328), m = {
                renameDefaults: {
                    alias: !1,
                    multiple: !1,
                    override: !1
                }
            };
            e.exports = o.extend({
                type: "_keys",
                properties: {
                    typeof: "object"
                },
                flags: {
                    unknown: {
                        default: !1
                    }
                },
                terms: {
                    dependencies: {
                        init: null
                    },
                    keys: {
                        init: null,
                        manifest: {
                            mapped: {
                                from: "schema",
                                to: "key"
                            }
                        }
                    },
                    patterns: {
                        init: null
                    },
                    renames: {
                        init: null
                    }
                },
                args: (e, t)=>e.keys(t),
                validate (e, t) {
                    let { schema: r, error: s, state: n, prefs: a } = t;
                    if (!e || typeof e !== r.$_property("typeof") || Array.isArray(e)) return {
                        value: e,
                        errors: s("object.base", {
                            type: r.$_property("typeof")
                        })
                    };
                    if (!(r.$_terms.renames || r.$_terms.dependencies || r.$_terms.keys || r.$_terms.patterns || r.$_terms.externals)) return;
                    e = m.clone(e, a);
                    const i = [];
                    if (r.$_terms.renames && !m.rename(r, e, n, a, i)) return {
                        value: e,
                        errors: i
                    };
                    if (!r.$_terms.keys && !r.$_terms.patterns && !r.$_terms.dependencies) return {
                        value: e,
                        errors: i
                    };
                    const o = new Set(Object.keys(e));
                    if (r.$_terms.keys) {
                        const t = [
                            e,
                            ...n.ancestors
                        ];
                        for (const s of r.$_terms.keys){
                            const r = s.key, l = e[r];
                            o.delete(r);
                            const c = n.localize([
                                ...n.path,
                                r
                            ], t, s), u = s.schema.$_validate(l, c, a);
                            if (u.errors) {
                                if (a.abortEarly) return {
                                    value: e,
                                    errors: u.errors
                                };
                                void 0 !== u.value && (e[r] = u.value), i.push(...u.errors);
                            } else "strip" === s.schema._flags.result || void 0 === u.value && void 0 !== l ? delete e[r] : void 0 !== u.value && (e[r] = u.value);
                        }
                    }
                    if (o.size || r._flags._hasPatternMatch) {
                        const t = m.unknown(r, e, o, i, n, a);
                        if (t) return t;
                    }
                    if (r.$_terms.dependencies) for (const t of r.$_terms.dependencies){
                        if (null !== t.key && !1 === m.isPresent(t.options)(t.key.resolve(e, n, a, null, {
                            shadow: !1
                        }))) continue;
                        const s = m.dependencies[t.rel](r, t, e, n, a);
                        if (s) {
                            const t = r.$_createError(s.code, e, s.context, n, a);
                            if (a.abortEarly) return {
                                value: e,
                                errors: t
                            };
                            i.push(t);
                        }
                    }
                    return {
                        value: e,
                        errors: i
                    };
                },
                rules: {
                    and: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return l.verifyFlat(t, "and"), m.dependency(this, "and", null, t);
                        }
                    },
                    append: {
                        method (e) {
                            return null == e || 0 === Object.keys(e).length ? this : this.keys(e);
                        }
                    },
                    assert: {
                        method (e, t, r) {
                            h.isTemplate(e) || (e = c.ref(e)), n(void 0 === r || "string" == typeof r, "Message must be a string"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const s = this.$_addRule({
                                name: "assert",
                                args: {
                                    subject: e,
                                    schema: t,
                                    message: r
                                }
                            });
                            return s.$_mutateRegister(e), s.$_mutateRegister(t), s;
                        },
                        validate (e, t, r) {
                            let { error: s, prefs: n, state: a } = t, { subject: i, schema: o, message: l } = r;
                            const c = i.resolve(e, a, n), u = f.isRef(i) ? i.absolute(a) : [];
                            return o.$_match(c, a.localize(u, [
                                e,
                                ...a.ancestors
                            ], o), n) ? e : s("object.assert", {
                                subject: i,
                                message: l
                            });
                        },
                        args: [
                            "subject",
                            "schema",
                            "message"
                        ],
                        multi: !0
                    },
                    instance: {
                        method (e, t) {
                            return n("function" == typeof e, "constructor must be a function"), t = t || e.name, this.$_addRule({
                                name: "instance",
                                args: {
                                    constructor: e,
                                    name: t
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { constructor: s, name: n } = r;
                            return e instanceof s ? e : t.error("object.instance", {
                                type: n,
                                value: e
                            });
                        },
                        args: [
                            "constructor",
                            "name"
                        ]
                    },
                    keys: {
                        method (e) {
                            n(void 0 === e || "object" == typeof e, "Object schema must be a valid object"), n(!l.isSchema(e), "Object schema cannot be a joi schema");
                            const t = this.clone();
                            if (e) {
                                if (Object.keys(e).length) {
                                    t.$_terms.keys = t.$_terms.keys ? t.$_terms.keys.filter((t)=>!e.hasOwnProperty(t.key)) : new m.Keys;
                                    for(const r in e)l.tryWithPath(()=>t.$_terms.keys.push({
                                            key: r,
                                            schema: this.$_compile(e[r])
                                        }), r);
                                } else t.$_terms.keys = new m.Keys;
                            } else t.$_terms.keys = null;
                            return t.$_mutateRebuild();
                        }
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate (e, t, r, s) {
                            let { limit: n } = r, { name: a, operator: i, args: o } = s;
                            return l.compare(Object.keys(e).length, n, i) ? e : t.error("object." + a, {
                                limit: o.limit,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: l.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    nand: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return l.verifyFlat(t, "nand"), m.dependency(this, "nand", null, t);
                        }
                    },
                    or: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return l.verifyFlat(t, "or"), m.dependency(this, "or", null, t);
                        }
                    },
                    oxor: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return m.dependency(this, "oxor", null, t);
                        }
                    },
                    pattern: {
                        method (e, t) {
                            let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            const s = e instanceof RegExp;
                            s || (e = this.$_compile(e, {
                                appendPath: !0
                            })), n(void 0 !== t, "Invalid rule"), l.assertOptions(r, [
                                "fallthrough",
                                "matches"
                            ]), s && n(!e.flags.includes("g") && !e.flags.includes("y"), "pattern should not use global or sticky mode"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const a = this.clone();
                            a.$_terms.patterns = a.$_terms.patterns || [];
                            const i = {
                                [s ? "regex" : "schema"]: e,
                                rule: t
                            };
                            return r.matches && (i.matches = this.$_compile(r.matches), "array" !== i.matches.type && (i.matches = i.matches.$_root.array().items(i.matches)), a.$_mutateRegister(i.matches), a.$_setFlag("_hasPatternMatch", !0, {
                                clone: !1
                            })), r.fallthrough && (i.fallthrough = !0), a.$_terms.patterns.push(i), a.$_mutateRegister(t), a;
                        }
                    },
                    ref: {
                        method () {
                            return this.$_addRule("ref");
                        },
                        validate: (e, t)=>f.isRef(e) ? e : t.error("object.refType", {
                                value: e
                            })
                    },
                    regex: {
                        method () {
                            return this.$_addRule("regex");
                        },
                        validate: (e, t)=>e instanceof RegExp ? e : t.error("object.regex", {
                                value: e
                            })
                    },
                    rename: {
                        method (e, t) {
                            let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            n("string" == typeof e || e instanceof RegExp, "Rename missing the from argument"), n("string" == typeof t || t instanceof h, "Invalid rename to argument"), n(t !== e, "Cannot rename key to same name:", e), l.assertOptions(r, [
                                "alias",
                                "ignoreUndefined",
                                "override",
                                "multiple"
                            ]);
                            const a = this.clone();
                            a.$_terms.renames = a.$_terms.renames || [];
                            for (const t of a.$_terms.renames)n(t.from !== e, "Cannot rename the same key multiple times");
                            return t instanceof h && a.$_mutateRegister(t), a.$_terms.renames.push({
                                from: e,
                                to: t,
                                options: s(m.renameDefaults, r)
                            }), a;
                        }
                    },
                    schema: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "any";
                            return this.$_addRule({
                                name: "schema",
                                args: {
                                    type: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { type: s } = r;
                            return !l.isSchema(e) || "any" !== s && e.type !== s ? t.error("object.schema", {
                                type: s
                            }) : e;
                        }
                    },
                    unknown: {
                        method (e) {
                            return this.$_setFlag("unknown", !1 !== e);
                        }
                    },
                    with: {
                        method (e, t) {
                            let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            return m.dependency(this, "with", e, t, r);
                        }
                    },
                    without: {
                        method (e, t) {
                            let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                            return m.dependency(this, "without", e, t, r);
                        }
                    },
                    xor: {
                        method () {
                            for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                            return l.verifyFlat(t, "xor"), m.dependency(this, "xor", null, t);
                        }
                    }
                },
                overrides: {
                    default (e, t) {
                        return void 0 === e && (e = l.symbols.deepDefault), this.$_parent("default", e, t);
                    }
                },
                rebuild (e) {
                    if (e.$_terms.keys) {
                        const t = new i.Sorter;
                        for (const r of e.$_terms.keys)l.tryWithPath(()=>t.add(r, {
                                after: r.schema.$_rootReferences(),
                                group: r.key
                            }), r.key);
                        e.$_terms.keys = new m.Keys(...t.nodes);
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.keys && (e = e.keys(t.keys)), t.dependencies) for (const { rel: r, key: s = null, peers: n, options: a } of t.dependencies)e = m.dependency(e, r, s, n, a);
                        if (t.patterns) for (const { regex: r, schema: s, rule: n, fallthrough: a, matches: i } of t.patterns)e = e.pattern(r || s, n, {
                            fallthrough: a,
                            matches: i
                        });
                        if (t.renames) for (const { from: r, to: s, options: n } of t.renames)e = e.rename(r, s, n);
                        return e;
                    }
                },
                messages: {
                    "object.and": "{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}",
                    "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}',
                    "object.base": "{{#label}} must be of type {{#type}}",
                    "object.instance": "{{#label}} must be an instance of {{:#type}}",
                    "object.length": '{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.max": '{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.min": '{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.missing": "{{#label}} must contain at least one of {{#peersWithLabels}}",
                    "object.nand": "{{:#mainWithLabel}} must not exist simultaneously with {{#peersWithLabels}}",
                    "object.oxor": "{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}",
                    "object.pattern.match": "{{#label}} keys failed to match pattern requirements",
                    "object.refType": "{{#label}} must be a Joi reference",
                    "object.regex": "{{#label}} must be a RegExp object",
                    "object.rename.multiple": "{{#label}} cannot rename {{:#from}} because multiple renames are disabled and another key was already renamed to {{:#to}}",
                    "object.rename.override": "{{#label}} cannot rename {{:#from}} because override is disabled and target {{:#to}} exists",
                    "object.schema": "{{#label}} must be a Joi schema of {{#type}} type",
                    "object.unknown": "{{#label}} is not allowed",
                    "object.with": "{{:#mainWithLabel}} missing required peer {{:#peerWithLabel}}",
                    "object.without": "{{:#mainWithLabel}} conflict with forbidden peer {{:#peerWithLabel}}",
                    "object.xor": "{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}"
                }
            }), m.clone = function(e, t) {
                if ("object" == typeof e) {
                    if (t.nonEnumerables) return a(e, {
                        shallow: !0
                    });
                    const r = Object.create(Object.getPrototypeOf(e));
                    return Object.assign(r, e), r;
                }
                const r = function() {
                    for(var t = arguments.length, r = new Array(t), s = 0; s < t; s++)r[s] = arguments[s];
                    return e.apply(this, r);
                };
                return r.prototype = a(e.prototype), Object.defineProperty(r, "name", {
                    value: e.name,
                    writable: !1
                }), Object.defineProperty(r, "length", {
                    value: e.length,
                    writable: !1
                }), Object.assign(r, e), r;
            }, m.dependency = function(e, t, r, s, a) {
                n(null === r || "string" == typeof r, t, "key must be a strings"), a || (a = s.length > 1 && "object" == typeof s[s.length - 1] ? s.pop() : {}), l.assertOptions(a, [
                    "separator",
                    "isPresent"
                ]), s = [].concat(s);
                const i = l.default(a.separator, "."), o = [];
                for (const e of s)n("string" == typeof e, t, "peers must be strings"), o.push(c.ref(e, {
                    separator: i,
                    ancestor: 0,
                    prefix: !1
                }));
                null !== r && (r = c.ref(r, {
                    separator: i,
                    ancestor: 0,
                    prefix: !1
                }));
                const u = e.clone();
                return u.$_terms.dependencies = u.$_terms.dependencies || [], u.$_terms.dependencies.push(new m.Dependency(t, r, o, s, a)), u;
            }, m.dependencies = {
                and (e, t, r, s, n) {
                    const a = [], i = [], o = t.peers.length, l = m.isPresent(t.options);
                    for (const e of t.peers)!1 === l(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) ? a.push(e.key) : i.push(e.key);
                    if (a.length !== o && i.length !== o) return {
                        code: "object.and",
                        context: {
                            present: i,
                            presentWithLabels: m.keysToLabels(e, i),
                            missing: a,
                            missingWithLabels: m.keysToLabels(e, a)
                        }
                    };
                },
                nand (e, t, r, s, n) {
                    const a = [], i = m.isPresent(t.options);
                    for (const e of t.peers)i(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) && a.push(e.key);
                    if (a.length !== t.peers.length) return;
                    const o = t.paths[0], l = t.paths.slice(1);
                    return {
                        code: "object.nand",
                        context: {
                            main: o,
                            mainWithLabel: m.keysToLabels(e, o),
                            peers: l,
                            peersWithLabels: m.keysToLabels(e, l)
                        }
                    };
                },
                or (e, t, r, s, n) {
                    const a = m.isPresent(t.options);
                    for (const e of t.peers)if (a(e.resolve(r, s, n, null, {
                        shadow: !1
                    }))) return;
                    return {
                        code: "object.missing",
                        context: {
                            peers: t.paths,
                            peersWithLabels: m.keysToLabels(e, t.paths)
                        }
                    };
                },
                oxor (e, t, r, s, n) {
                    const a = [], i = m.isPresent(t.options);
                    for (const e of t.peers)i(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) && a.push(e.key);
                    if (!a.length || 1 === a.length) return;
                    const o = {
                        peers: t.paths,
                        peersWithLabels: m.keysToLabels(e, t.paths)
                    };
                    return o.present = a, o.presentWithLabels = m.keysToLabels(e, a), {
                        code: "object.oxor",
                        context: o
                    };
                },
                with (e, t, r, s, n) {
                    const a = m.isPresent(t.options);
                    for (const i of t.peers)if (!1 === a(i.resolve(r, s, n, null, {
                        shadow: !1
                    }))) return {
                        code: "object.with",
                        context: {
                            main: t.key.key,
                            mainWithLabel: m.keysToLabels(e, t.key.key),
                            peer: i.key,
                            peerWithLabel: m.keysToLabels(e, i.key)
                        }
                    };
                },
                without (e, t, r, s, n) {
                    const a = m.isPresent(t.options);
                    for (const i of t.peers)if (a(i.resolve(r, s, n, null, {
                        shadow: !1
                    }))) return {
                        code: "object.without",
                        context: {
                            main: t.key.key,
                            mainWithLabel: m.keysToLabels(e, t.key.key),
                            peer: i.key,
                            peerWithLabel: m.keysToLabels(e, i.key)
                        }
                    };
                },
                xor (e, t, r, s, n) {
                    const a = [], i = m.isPresent(t.options);
                    for (const e of t.peers)i(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) && a.push(e.key);
                    if (1 === a.length) return;
                    const o = {
                        peers: t.paths,
                        peersWithLabels: m.keysToLabels(e, t.paths)
                    };
                    return 0 === a.length ? {
                        code: "object.missing",
                        context: o
                    } : (o.present = a, o.presentWithLabels = m.keysToLabels(e, a), {
                        code: "object.xor",
                        context: o
                    });
                }
            }, m.keysToLabels = function(e, t) {
                return Array.isArray(t) ? t.map((t)=>e.$_mapLabels(t)) : e.$_mapLabels(t);
            }, m.isPresent = function(e) {
                return "function" == typeof e.isPresent ? e.isPresent : (e)=>void 0 !== e;
            }, m.rename = function(e, t, r, s, n) {
                const a = {};
                for (const i of e.$_terms.renames){
                    const o = [], l = "string" != typeof i.from;
                    if (l) for(const e in t){
                        if (void 0 === t[e] && i.options.ignoreUndefined) continue;
                        if (e === i.to) continue;
                        const r = i.from.exec(e);
                        r && o.push({
                            from: e,
                            to: i.to,
                            match: r
                        });
                    }
                    else !Object.prototype.hasOwnProperty.call(t, i.from) || void 0 === t[i.from] && i.options.ignoreUndefined || o.push(i);
                    for (const c of o){
                        const o = c.from;
                        let u = c.to;
                        if (u instanceof h && (u = u.render(t, r, s, c.match)), o !== u) {
                            if (!i.options.multiple && a[u] && (n.push(e.$_createError("object.rename.multiple", t, {
                                from: o,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            if (Object.prototype.hasOwnProperty.call(t, u) && !i.options.override && !a[u] && (n.push(e.$_createError("object.rename.override", t, {
                                from: o,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            void 0 === t[o] ? delete t[u] : t[u] = t[o], a[u] = !0, i.options.alias || delete t[o];
                        }
                    }
                }
                return !0;
            }, m.unknown = function(e, t, r, s, n, a) {
                if (e.$_terms.patterns) {
                    let i = !1;
                    const o = e.$_terms.patterns.map((e)=>{
                        if (e.matches) return i = !0, [];
                    }), l = [
                        t,
                        ...n.ancestors
                    ];
                    for (const i of r){
                        const c = t[i], u = [
                            ...n.path,
                            i
                        ];
                        for(let f = 0; f < e.$_terms.patterns.length; ++f){
                            const h = e.$_terms.patterns[f];
                            if (h.regex) {
                                const e = h.regex.test(i);
                                if (n.mainstay.tracer.debug(n, "rule", `pattern.${f}`, e ? "pass" : "error"), !e) continue;
                            } else if (!h.schema.$_match(i, n.nest(h.schema, `pattern.${f}`), a)) continue;
                            r.delete(i);
                            const m = n.localize(u, l, {
                                schema: h.rule,
                                key: i
                            }), d = h.rule.$_validate(c, m, a);
                            if (d.errors) {
                                if (a.abortEarly) return {
                                    value: t,
                                    errors: d.errors
                                };
                                s.push(...d.errors);
                            }
                            if (h.matches && o[f].push(i), t[i] = d.value, !h.fallthrough) break;
                        }
                    }
                    if (i) for(let r = 0; r < o.length; ++r){
                        const i = o[r];
                        if (!i) continue;
                        const c = e.$_terms.patterns[r].matches, f = n.localize(n.path, l, c), h = c.$_validate(i, f, a);
                        if (h.errors) {
                            const r = u.details(h.errors, {
                                override: !1
                            });
                            r.matches = i;
                            const o = e.$_createError("object.pattern.match", t, r, n, a);
                            if (a.abortEarly) return {
                                value: t,
                                errors: o
                            };
                            s.push(o);
                        }
                    }
                }
                if (r.size && (e.$_terms.keys || e.$_terms.patterns)) {
                    if (a.stripUnknown && !e._flags.unknown || a.skipFunctions) {
                        const e = !(!a.stripUnknown || !0 !== a.stripUnknown && !a.stripUnknown.objects);
                        for (const s of r)e ? (delete t[s], r.delete(s)) : "function" == typeof t[s] && r.delete(s);
                    }
                    if (!l.default(e._flags.unknown, a.allowUnknown)) for (const i of r){
                        const r = n.localize([
                            ...n.path,
                            i
                        ], []), o = e.$_createError("object.unknown", t[i], {
                            child: i
                        }, r, a, {
                            flags: !1
                        });
                        if (a.abortEarly) return {
                            value: t,
                            errors: o
                        };
                        s.push(o);
                    }
                }
            }, m.Dependency = class {
                constructor(e, t, r, s, n){
                    this.rel = e, this.key = t, this.peers = r, this.paths = s, this.options = n;
                }
                describe() {
                    const e = {
                        rel: this.rel,
                        peers: this.paths
                    };
                    return null !== this.key && (e.key = this.key.key), "." !== this.peers[0].separator && (e.options = {
                        ...e.options,
                        separator: this.peers[0].separator
                    }), this.options.isPresent && (e.options = {
                        ...e.options,
                        isPresent: this.options.isPresent
                    }), e;
                }
            }, m.Keys = class extends Array {
                concat(e) {
                    const t = this.slice(), r = new Map;
                    for(let e = 0; e < t.length; ++e)r.set(t[e].key, e);
                    for (const s of e){
                        const e = s.key, n = r.get(e);
                        void 0 !== n ? t[n] = {
                            key: e,
                            schema: t[n].schema.concat(s.schema)
                        } : t.push(s);
                    }
                    return t;
                }
            };
        },
        8785: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = r(8160), i = r(3292), o = r(6354), l = {};
            e.exports = n.extend({
                type: "link",
                properties: {
                    schemaChain: !0
                },
                terms: {
                    link: {
                        init: null,
                        manifest: "single",
                        register: !1
                    }
                },
                args: (e, t)=>e.ref(t),
                validate (e, t) {
                    let { schema: r, state: n, prefs: a } = t;
                    s(r.$_terms.link, "Uninitialized link schema");
                    const i = l.generate(r, e, n, a), o = r.$_terms.link[0].ref;
                    return i.$_validate(e, n.nest(i, `link:${o.display}:${i.type}`), a);
                },
                generate: (e, t, r, s)=>l.generate(e, t, r, s),
                rules: {
                    ref: {
                        method (e) {
                            s(!this.$_terms.link, "Cannot reinitialize schema"), e = i.ref(e), s("value" === e.type || "local" === e.type, "Invalid reference type:", e.type), s("local" === e.type || "root" === e.ancestor || e.ancestor > 0, "Link cannot reference itself");
                            const t = this.clone();
                            return t.$_terms.link = [
                                {
                                    ref: e
                                }
                            ], t;
                        }
                    },
                    relative: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return this.$_setFlag("relative", e);
                        }
                    }
                },
                overrides: {
                    concat (e) {
                        s(this.$_terms.link, "Uninitialized link schema"), s(a.isSchema(e), "Invalid schema object"), s("link" !== e.type, "Cannot merge type link with another link");
                        const t = this.clone();
                        return t.$_terms.whens || (t.$_terms.whens = []), t.$_terms.whens.push({
                            concat: e
                        }), t.$_mutateRebuild();
                    }
                },
                manifest: {
                    build: (e, t)=>(s(t.link, "Invalid link description missing link"), e.ref(t.link))
                }
            }), l.generate = function(e, t, r, s) {
                let n = r.mainstay.links.get(e);
                if (n) return n._generate(t, r, s).schema;
                const a = e.$_terms.link[0].ref, { perspective: i, path: o } = l.perspective(a, r);
                l.assert(i, "which is outside of schema boundaries", a, e, r, s);
                try {
                    n = o.length ? i.$_reach(o) : i;
                } catch (t) {
                    l.assert(!1, "to non-existing schema", a, e, r, s);
                }
                return l.assert("link" !== n.type, "which is another link", a, e, r, s), e._flags.relative || r.mainstay.links.set(e, n), n._generate(t, r, s).schema;
            }, l.perspective = function(e, t) {
                if ("local" === e.type) {
                    for (const { schema: r, key: s } of t.schemas){
                        if ((r._flags.id || s) === e.path[0]) return {
                            perspective: r,
                            path: e.path.slice(1)
                        };
                        if (r.$_terms.shared) {
                            for (const t of r.$_terms.shared)if (t._flags.id === e.path[0]) return {
                                perspective: t,
                                path: e.path.slice(1)
                            };
                        }
                    }
                    return {
                        perspective: null,
                        path: null
                    };
                }
                return "root" === e.ancestor ? {
                    perspective: t.schemas[t.schemas.length - 1].schema,
                    path: e.path
                } : {
                    perspective: t.schemas[e.ancestor] && t.schemas[e.ancestor].schema,
                    path: e.path
                };
            }, l.assert = function(e, t, r, n, a, i) {
                e || s(!1, `"${o.label(n._flags, a, i)}" contains link reference "${r.display}" ${t}`);
            };
        },
        3832: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = r(8160), i = {
                numberRx: /^\s*[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e([+-]?\d+))?\s*$/i,
                precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/,
                exponentialPartRegex: /[eE][+-]?\d+$/,
                leadingSignAndZerosRegex: /^[+-]?(0*)?/,
                dotRegex: /\./,
                trailingZerosRegex: /0+$/
            };
            e.exports = n.extend({
                type: "number",
                flags: {
                    unsafe: {
                        default: !1
                    }
                },
                coerce: {
                    from: "string",
                    method (e, t) {
                        let { schema: r, error: s } = t;
                        if (!e.match(i.numberRx)) return;
                        e = e.trim();
                        const n = {
                            value: parseFloat(e)
                        };
                        if (0 === n.value && (n.value = 0), !r._flags.unsafe) {
                            if (e.match(/e/i)) {
                                if (i.extractSignificantDigits(e) !== i.extractSignificantDigits(String(n.value))) return n.errors = s("number.unsafe"), n;
                            } else {
                                const t = n.value.toString();
                                if (t.match(/e/i)) return n;
                                if (t !== i.normalizeDecimal(e)) return n.errors = s("number.unsafe"), n;
                            }
                        }
                        return n;
                    }
                },
                validate (e, t) {
                    let { schema: r, error: s, prefs: n } = t;
                    if (e === 1 / 0 || e === -1 / 0) return {
                        value: e,
                        errors: s("number.infinity")
                    };
                    if (!a.isNumber(e)) return {
                        value: e,
                        errors: s("number.base")
                    };
                    const i = {
                        value: e
                    };
                    if (n.convert) {
                        const e = r.$_getRule("precision");
                        if (e) {
                            const t = Math.pow(10, e.args.limit);
                            i.value = Math.round(i.value * t) / t;
                        }
                    }
                    return 0 === i.value && (i.value = 0), !r._flags.unsafe && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) && (i.errors = s("number.unsafe")), i;
                },
                rules: {
                    compare: {
                        method: !1,
                        validate (e, t, r, s) {
                            let { limit: n } = r, { name: i, operator: o, args: l } = s;
                            return a.compare(e, n, o) ? e : t.error("number." + i, {
                                limit: l.limit,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: a.isNumber,
                                message: "must be a number"
                            }
                        ]
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    integer: {
                        method () {
                            return this.$_addRule("integer");
                        },
                        validate: (e, t)=>Math.trunc(e) - e == 0 ? e : t.error("number.integer")
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    multiple: {
                        method (e) {
                            return this.$_addRule({
                                name: "multiple",
                                args: {
                                    base: e
                                }
                            });
                        },
                        validate (e, t, r, s) {
                            let { base: n } = r;
                            return e * (1 / n) % 1 == 0 ? e : t.error("number.multiple", {
                                multiple: s.args.base,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "base",
                                ref: !0,
                                assert: (e)=>"number" == typeof e && isFinite(e) && e > 0,
                                message: "must be a positive number"
                            }
                        ],
                        multi: !0
                    },
                    negative: {
                        method () {
                            return this.sign("negative");
                        }
                    },
                    port: {
                        method () {
                            return this.$_addRule("port");
                        },
                        validate: (e, t)=>Number.isSafeInteger(e) && e >= 0 && e <= 65535 ? e : t.error("number.port")
                    },
                    positive: {
                        method () {
                            return this.sign("positive");
                        }
                    },
                    precision: {
                        method (e) {
                            return s(Number.isSafeInteger(e), "limit must be an integer"), this.$_addRule({
                                name: "precision",
                                args: {
                                    limit: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { limit: s } = r;
                            const n = e.toString().match(i.precisionRx);
                            return Math.max((n[1] ? n[1].length : 0) - (n[2] ? parseInt(n[2], 10) : 0), 0) <= s ? e : t.error("number.precision", {
                                limit: s,
                                value: e
                            });
                        },
                        convert: !0
                    },
                    sign: {
                        method (e) {
                            return s([
                                "negative",
                                "positive"
                            ].includes(e), "Invalid sign", e), this.$_addRule({
                                name: "sign",
                                args: {
                                    sign: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { sign: s } = r;
                            return "negative" === s && e < 0 || "positive" === s && e > 0 ? e : t.error(`number.${s}`);
                        }
                    },
                    unsafe: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("unsafe", e);
                        }
                    }
                },
                cast: {
                    string: {
                        from: (e)=>"number" == typeof e,
                        to: (e, t)=>e.toString()
                    }
                },
                messages: {
                    "number.base": "{{#label}} must be a number",
                    "number.greater": "{{#label}} must be greater than {{#limit}}",
                    "number.infinity": "{{#label}} cannot be infinity",
                    "number.integer": "{{#label}} must be an integer",
                    "number.less": "{{#label}} must be less than {{#limit}}",
                    "number.max": "{{#label}} must be less than or equal to {{#limit}}",
                    "number.min": "{{#label}} must be greater than or equal to {{#limit}}",
                    "number.multiple": "{{#label}} must be a multiple of {{#multiple}}",
                    "number.negative": "{{#label}} must be a negative number",
                    "number.port": "{{#label}} must be a valid port",
                    "number.positive": "{{#label}} must be a positive number",
                    "number.precision": "{{#label}} must have no more than {{#limit}} decimal places",
                    "number.unsafe": "{{#label}} must be a safe number"
                }
            }), i.extractSignificantDigits = function(e) {
                return e.replace(i.exponentialPartRegex, "").replace(i.dotRegex, "").replace(i.trailingZerosRegex, "").replace(i.leadingSignAndZerosRegex, "");
            }, i.normalizeDecimal = function(e) {
                return (e = e.replace(/^\+/, "").replace(/\.0*$/, "").replace(/^(-?)\.([^\.]*)$/, "$10.$2").replace(/^(-?)0+([0-9])/, "$1$2")).includes(".") && e.endsWith("0") && (e = e.replace(/0+$/, "")), "-0" === e ? "0" : e;
            };
        },
        8966: (e, t, r)=>{
            "use strict";
            const s = r(7824);
            e.exports = s.extend({
                type: "object",
                cast: {
                    map: {
                        from: (e)=>e && "object" == typeof e,
                        to: (e, t)=>new Map(Object.entries(e))
                    }
                }
            });
        },
        7417: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(5380), a = r(1745), i = r(9959), o = r(6064), l = r(9926), c = r(5752), u = r(8068), f = r(8160), h = {
                tlds: l instanceof Set && {
                    tlds: {
                        allow: l,
                        deny: null
                    }
                },
                base64Regex: {
                    true: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}==|[\w\-]{3}=)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
                    },
                    false: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}(==)?|[\w\-]{3}=?)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/
                    }
                },
                dataUriRegex: /^data:[\w+.-]+\/[\w+.-]+;((charset=[\w-]+|base64),)?(.*)$/,
                hexRegex: /^[a-f0-9]+$/i,
                ipRegex: i.regex({
                    cidr: "forbidden"
                }).regex,
                isoDurationRegex: /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?$/,
                guidBrackets: {
                    "{": "}",
                    "[": "]",
                    "(": ")",
                    "": ""
                },
                guidVersions: {
                    uuidv1: "1",
                    uuidv2: "2",
                    uuidv3: "3",
                    uuidv4: "4",
                    uuidv5: "5"
                },
                guidSeparators: new Set([
                    void 0,
                    !0,
                    !1,
                    "-",
                    ":"
                ]),
                normalizationForms: [
                    "NFC",
                    "NFD",
                    "NFKC",
                    "NFKD"
                ]
            };
            e.exports = u.extend({
                type: "string",
                flags: {
                    insensitive: {
                        default: !1
                    },
                    truncate: {
                        default: !1
                    }
                },
                terms: {
                    replacements: {
                        init: null
                    }
                },
                coerce: {
                    from: "string",
                    method (e, t) {
                        let { schema: r, state: s, prefs: n } = t;
                        const a = r.$_getRule("normalize");
                        a && (e = e.normalize(a.args.form));
                        const i = r.$_getRule("case");
                        i && (e = "upper" === i.args.direction ? e.toLocaleUpperCase() : e.toLocaleLowerCase());
                        const o = r.$_getRule("trim");
                        if (o && o.args.enabled && (e = e.trim()), r.$_terms.replacements) for (const t of r.$_terms.replacements)e = e.replace(t.pattern, t.replacement);
                        const l = r.$_getRule("hex");
                        if (l && l.args.options.byteAligned && e.length % 2 != 0 && (e = `0${e}`), r.$_getRule("isoDate")) {
                            const t = h.isoDate(e);
                            t && (e = t);
                        }
                        if (r._flags.truncate) {
                            const t = r.$_getRule("max");
                            if (t) {
                                let a = t.args.limit;
                                if (f.isResolvable(a) && (a = a.resolve(e, s, n), !f.limit(a))) return {
                                    value: e,
                                    errors: r.$_createError("any.ref", a, {
                                        ref: t.args.limit,
                                        arg: "limit",
                                        reason: "must be a positive integer"
                                    }, s, n)
                                };
                                e = e.slice(0, a);
                            }
                        }
                        return {
                            value: e
                        };
                    }
                },
                validate (e, t) {
                    let { schema: r, error: s } = t;
                    if ("string" != typeof e) return {
                        value: e,
                        errors: s("string.base")
                    };
                    if ("" === e) {
                        const t = r.$_getRule("min");
                        if (t && 0 === t.args.limit) return;
                        return {
                            value: e,
                            errors: s("string.empty")
                        };
                    }
                },
                rules: {
                    alphanum: {
                        method () {
                            return this.$_addRule("alphanum");
                        },
                        validate: (e, t)=>/^[a-zA-Z0-9]+$/.test(e) ? e : t.error("string.alphanum")
                    },
                    base64: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            return f.assertOptions(e, [
                                "paddingRequired",
                                "urlSafe"
                            ]), e = {
                                urlSafe: !1,
                                paddingRequired: !0,
                                ...e
                            }, s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), s("boolean" == typeof e.urlSafe, "urlSafe must be boolean"), this.$_addRule({
                                name: "base64",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { options: s } = r;
                            return h.base64Regex[s.paddingRequired][s.urlSafe].test(e) ? e : t.error("string.base64");
                        }
                    },
                    case: {
                        method (e) {
                            return s([
                                "lower",
                                "upper"
                            ].includes(e), "Invalid case:", e), this.$_addRule({
                                name: "case",
                                args: {
                                    direction: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { direction: s } = r;
                            return "lower" === s && e === e.toLocaleLowerCase() || "upper" === s && e === e.toLocaleUpperCase() ? e : t.error(`string.${s}case`);
                        },
                        convert: !0
                    },
                    creditCard: {
                        method () {
                            return this.$_addRule("creditCard");
                        },
                        validate (e, t) {
                            let r = e.length, s = 0, n = 1;
                            for(; r--;){
                                const t = e.charAt(r) * n;
                                s += t - 9 * (t > 9), n ^= 3;
                            }
                            return s > 0 && s % 10 == 0 ? e : t.error("string.creditCard");
                        }
                    },
                    dataUri: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            return f.assertOptions(e, [
                                "paddingRequired"
                            ]), e = {
                                paddingRequired: !0,
                                ...e
                            }, s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), this.$_addRule({
                                name: "dataUri",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { options: s } = r;
                            const n = e.match(h.dataUriRegex);
                            if (n) {
                                if (!n[2]) return e;
                                if ("base64" !== n[2]) return e;
                                if (h.base64Regex[s.paddingRequired].false.test(n[3])) return e;
                            }
                            return t.error("string.dataUri");
                        }
                    },
                    domain: {
                        method (e) {
                            e && f.assertOptions(e, [
                                "allowFullyQualified",
                                "allowUnicode",
                                "maxDomainSegments",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const t = h.addressOptions(e);
                            return this.$_addRule({
                                name: "domain",
                                args: {
                                    options: e
                                },
                                address: t
                            });
                        },
                        validate (e, t, r, s) {
                            let { address: a } = s;
                            return n.isValid(e, a) ? e : t.error("string.domain");
                        }
                    },
                    email: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            f.assertOptions(e, [
                                "allowFullyQualified",
                                "allowUnicode",
                                "ignoreLength",
                                "maxDomainSegments",
                                "minDomainSegments",
                                "multiple",
                                "separator",
                                "tlds"
                            ]), s(void 0 === e.multiple || "boolean" == typeof e.multiple, "multiple option must be an boolean");
                            const t = h.addressOptions(e), r = new RegExp(`\\s*[${e.separator ? o(e.separator) : ","}]\\s*`);
                            return this.$_addRule({
                                name: "email",
                                args: {
                                    options: e
                                },
                                regex: r,
                                address: t
                            });
                        },
                        validate (e, t, r, s) {
                            let { options: n } = r, { regex: i, address: o } = s;
                            const l = n.multiple ? e.split(i) : [
                                e
                            ], c = [];
                            for (const e of l)a.isValid(e, o) || c.push(e);
                            return c.length ? t.error("string.email", {
                                value: e,
                                invalids: c
                            }) : e;
                        }
                    },
                    guid: {
                        alias: "uuid",
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            f.assertOptions(e, [
                                "version",
                                "separator"
                            ]);
                            let t = "";
                            if (e.version) {
                                const r = [].concat(e.version);
                                s(r.length >= 1, "version must have at least 1 valid version specified");
                                const n = new Set;
                                for(let e = 0; e < r.length; ++e){
                                    const a = r[e];
                                    s("string" == typeof a, "version at position " + e + " must be a string");
                                    const i = h.guidVersions[a.toLowerCase()];
                                    s(i, "version at position " + e + " must be one of " + Object.keys(h.guidVersions).join(", ")), s(!n.has(i), "version at position " + e + " must not be a duplicate"), t += i, n.add(i);
                                }
                            }
                            s(h.guidSeparators.has(e.separator), 'separator must be one of true, false, "-", or ":"');
                            const r = void 0 === e.separator ? "[:-]?" : !0 === e.separator ? "[:-]" : !1 === e.separator ? "[]?" : `\\${e.separator}`, n = new RegExp(`^([\\[{\\(]?)[0-9A-F]{8}(${r})[0-9A-F]{4}\\2?[${t || "0-9A-F"}][0-9A-F]{3}\\2?[${t ? "89AB" : "0-9A-F"}][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$`, "i");
                            return this.$_addRule({
                                name: "guid",
                                args: {
                                    options: e
                                },
                                regex: n
                            });
                        },
                        validate (e, t, r, s) {
                            let { regex: n } = s;
                            const a = n.exec(e);
                            return a ? h.guidBrackets[a[1]] !== a[a.length - 1] ? t.error("string.guid") : e : t.error("string.guid");
                        }
                    },
                    hex: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            return f.assertOptions(e, [
                                "byteAligned"
                            ]), e = {
                                byteAligned: !1,
                                ...e
                            }, s("boolean" == typeof e.byteAligned, "byteAligned must be boolean"), this.$_addRule({
                                name: "hex",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { options: s } = r;
                            return h.hexRegex.test(e) ? s.byteAligned && e.length % 2 != 0 ? t.error("string.hexAlign") : e : t.error("string.hex");
                        }
                    },
                    hostname: {
                        method () {
                            return this.$_addRule("hostname");
                        },
                        validate: (e, t)=>n.isValid(e, {
                                minDomainSegments: 1
                            }) || h.ipRegex.test(e) ? e : t.error("string.hostname")
                    },
                    insensitive: {
                        method () {
                            return this.$_setFlag("insensitive", !0);
                        }
                    },
                    ip: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            f.assertOptions(e, [
                                "cidr",
                                "version"
                            ]);
                            const { cidr: t, versions: r, regex: s } = i.regex(e), n = e.version ? r : void 0;
                            return this.$_addRule({
                                name: "ip",
                                args: {
                                    options: {
                                        cidr: t,
                                        version: n
                                    }
                                },
                                regex: s
                            });
                        },
                        validate (e, t, r, s) {
                            let { options: n } = r, { regex: a } = s;
                            return a.test(e) ? e : n.version ? t.error("string.ipVersion", {
                                value: e,
                                cidr: n.cidr,
                                version: n.version
                            }) : t.error("string.ip", {
                                value: e,
                                cidr: n.cidr
                            });
                        }
                    },
                    isoDate: {
                        method () {
                            return this.$_addRule("isoDate");
                        },
                        validate (e, t) {
                            let { error: r } = t;
                            return h.isoDate(e) ? e : r("string.isoDate");
                        }
                    },
                    isoDuration: {
                        method () {
                            return this.$_addRule("isoDuration");
                        },
                        validate: (e, t)=>h.isoDurationRegex.test(e) ? e : t.error("string.isoDuration")
                    },
                    length: {
                        method (e, t) {
                            return h.length(this, "length", e, "=", t);
                        },
                        validate (e, t, r, s) {
                            let { limit: n, encoding: a } = r, { name: i, operator: o, args: l } = s;
                            const c = !a && e.length;
                            return f.compare(c, n, o) ? e : t.error("string." + i, {
                                limit: l.limit,
                                value: e,
                                encoding: a
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: f.limit,
                                message: "must be a positive integer"
                            },
                            "encoding"
                        ]
                    },
                    lowercase: {
                        method () {
                            return this.case("lower");
                        }
                    },
                    max: {
                        method (e, t) {
                            return h.length(this, "max", e, "<=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    min: {
                        method (e, t) {
                            return h.length(this, "min", e, ">=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    normalize: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "NFC";
                            return s(h.normalizationForms.includes(e), "normalization form must be one of " + h.normalizationForms.join(", ")), this.$_addRule({
                                name: "normalize",
                                args: {
                                    form: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { error: s } = t, { form: n } = r;
                            return e === e.normalize(n) ? e : s("string.normalize", {
                                value: e,
                                form: n
                            });
                        },
                        convert: !0
                    },
                    pattern: {
                        alias: "regex",
                        method (e) {
                            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            s(e instanceof RegExp, "regex must be a RegExp"), s(!e.flags.includes("g") && !e.flags.includes("y"), "regex should not use global or sticky mode"), "string" == typeof t && (t = {
                                name: t
                            }), f.assertOptions(t, [
                                "invert",
                                "name"
                            ]);
                            const r = [
                                "string.pattern",
                                t.invert ? ".invert" : "",
                                t.name ? ".name" : ".base"
                            ].join("");
                            return this.$_addRule({
                                name: "pattern",
                                args: {
                                    regex: e,
                                    options: t
                                },
                                errorCode: r
                            });
                        },
                        validate (e, t, r, s) {
                            let { regex: n, options: a } = r, { errorCode: i } = s;
                            return n.test(e) ^ a.invert ? e : t.error(i, {
                                name: a.name,
                                regex: n,
                                value: e
                            });
                        },
                        args: [
                            "regex",
                            "options"
                        ],
                        multi: !0
                    },
                    replace: {
                        method (e, t) {
                            "string" == typeof e && (e = new RegExp(o(e), "g")), s(e instanceof RegExp, "pattern must be a RegExp"), s("string" == typeof t, "replacement must be a String");
                            const r = this.clone();
                            return r.$_terms.replacements || (r.$_terms.replacements = []), r.$_terms.replacements.push({
                                pattern: e,
                                replacement: t
                            }), r;
                        }
                    },
                    token: {
                        method () {
                            return this.$_addRule("token");
                        },
                        validate: (e, t)=>/^\w+$/.test(e) ? e : t.error("string.token")
                    },
                    trim: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_addRule({
                                name: "trim",
                                args: {
                                    enabled: e
                                }
                            });
                        },
                        validate (e, t, r) {
                            let { enabled: s } = r;
                            return s && e !== e.trim() ? t.error("string.trim") : e;
                        },
                        convert: !0
                    },
                    truncate: {
                        method () {
                            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("truncate", e);
                        }
                    },
                    uppercase: {
                        method () {
                            return this.case("upper");
                        }
                    },
                    uri: {
                        method () {
                            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            f.assertOptions(e, [
                                "allowRelative",
                                "allowQuerySquareBrackets",
                                "domain",
                                "relativeOnly",
                                "scheme"
                            ]), e.domain && f.assertOptions(e.domain, [
                                "allowFullyQualified",
                                "allowUnicode",
                                "maxDomainSegments",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const { regex: t, scheme: r } = c.regex(e), s = e.domain ? h.addressOptions(e.domain) : null;
                            return this.$_addRule({
                                name: "uri",
                                args: {
                                    options: e
                                },
                                regex: t,
                                domain: s,
                                scheme: r
                            });
                        },
                        validate (e, t, r, s) {
                            let { options: a } = r, { regex: i, domain: o, scheme: l } = s;
                            if ([
                                "http:/",
                                "https:/"
                            ].includes(e)) return t.error("string.uri");
                            const c = i.exec(e);
                            if (c) {
                                const r = c[1] || c[2];
                                return !o || a.allowRelative && !r || n.isValid(r, o) ? e : t.error("string.domain", {
                                    value: r
                                });
                            }
                            return a.relativeOnly ? t.error("string.uriRelativeOnly") : a.scheme ? t.error("string.uriCustomScheme", {
                                scheme: l,
                                value: e
                            }) : t.error("string.uri");
                        }
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.replacements) for (const { pattern: r, replacement: s } of t.replacements)e = e.replace(r, s);
                        return e;
                    }
                },
                messages: {
                    "string.alphanum": "{{#label}} must only contain alpha-numeric characters",
                    "string.base": "{{#label}} must be a string",
                    "string.base64": "{{#label}} must be a valid base64 string",
                    "string.creditCard": "{{#label}} must be a credit card",
                    "string.dataUri": "{{#label}} must be a valid dataUri string",
                    "string.domain": "{{#label}} must contain a valid domain name",
                    "string.email": "{{#label}} must be a valid email",
                    "string.empty": "{{#label}} is not allowed to be empty",
                    "string.guid": "{{#label}} must be a valid GUID",
                    "string.hex": "{{#label}} must only contain hexadecimal characters",
                    "string.hexAlign": "{{#label}} hex decoded representation must be byte aligned",
                    "string.hostname": "{{#label}} must be a valid hostname",
                    "string.ip": "{{#label}} must be a valid ip address with a {{#cidr}} CIDR",
                    "string.ipVersion": "{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR",
                    "string.isoDate": "{{#label}} must be in iso format",
                    "string.isoDuration": "{{#label}} must be a valid ISO 8601 duration",
                    "string.length": "{{#label}} length must be {{#limit}} characters long",
                    "string.lowercase": "{{#label}} must only contain lowercase characters",
                    "string.max": "{{#label}} length must be less than or equal to {{#limit}} characters long",
                    "string.min": "{{#label}} length must be at least {{#limit}} characters long",
                    "string.normalize": "{{#label}} must be unicode normalized in the {{#form}} form",
                    "string.token": "{{#label}} must only contain alpha-numeric and underscore characters",
                    "string.pattern.base": "{{#label}} with value {:[.]} fails to match the required pattern: {{#regex}}",
                    "string.pattern.name": "{{#label}} with value {:[.]} fails to match the {{#name}} pattern",
                    "string.pattern.invert.base": "{{#label}} with value {:[.]} matches the inverted pattern: {{#regex}}",
                    "string.pattern.invert.name": "{{#label}} with value {:[.]} matches the inverted {{#name}} pattern",
                    "string.trim": "{{#label}} must not have leading or trailing whitespace",
                    "string.uri": "{{#label}} must be a valid uri",
                    "string.uriCustomScheme": "{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern",
                    "string.uriRelativeOnly": "{{#label}} must be a valid relative uri",
                    "string.uppercase": "{{#label}} must only contain uppercase characters"
                }
            }), h.addressOptions = function(e) {
                if (!e) return e;
                if (s(void 0 === e.minDomainSegments || Number.isSafeInteger(e.minDomainSegments) && e.minDomainSegments > 0, "minDomainSegments must be a positive integer"), s(void 0 === e.maxDomainSegments || Number.isSafeInteger(e.maxDomainSegments) && e.maxDomainSegments > 0, "maxDomainSegments must be a positive integer"), !1 === e.tlds) return e;
                if (!0 === e.tlds || void 0 === e.tlds) return s(h.tlds, "Built-in TLD list disabled"), Object.assign({}, e, h.tlds);
                s("object" == typeof e.tlds, "tlds must be true, false, or an object");
                const t = e.tlds.deny;
                if (t) return Array.isArray(t) && (e = Object.assign({}, e, {
                    tlds: {
                        deny: new Set(t)
                    }
                })), s(e.tlds.deny instanceof Set, "tlds.deny must be an array, Set, or boolean"), s(!e.tlds.allow, "Cannot specify both tlds.allow and tlds.deny lists"), h.validateTlds(e.tlds.deny, "tlds.deny"), e;
                const r = e.tlds.allow;
                return r ? !0 === r ? (s(h.tlds, "Built-in TLD list disabled"), Object.assign({}, e, h.tlds)) : (Array.isArray(r) && (e = Object.assign({}, e, {
                    tlds: {
                        allow: new Set(r)
                    }
                })), s(e.tlds.allow instanceof Set, "tlds.allow must be an array, Set, or boolean"), h.validateTlds(e.tlds.allow, "tlds.allow"), e) : e;
            }, h.validateTlds = function(e, t) {
                for (const r of e)s(n.isValid(r, {
                    minDomainSegments: 1,
                    maxDomainSegments: 1
                }), `${t} must contain valid top level domain names`);
            }, h.isoDate = function(e) {
                if (!f.isIsoDate(e)) return null;
                /.*T.*[+-]\d\d$/.test(e) && (e += "00");
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t.toISOString();
            }, h.length = function(e, t, r, n, a) {
                return s(!a || !1, "Invalid encoding:", a), e.$_addRule({
                    name: t,
                    method: "length",
                    args: {
                        limit: r,
                        encoding: a
                    },
                    operator: n
                });
            };
        },
        8826: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8068), a = {};
            a.Map = class extends Map {
                slice() {
                    return new a.Map(this);
                }
            }, e.exports = n.extend({
                type: "symbol",
                terms: {
                    map: {
                        init: new a.Map
                    }
                },
                coerce: {
                    method (e, t) {
                        let { schema: r, error: s } = t;
                        const n = r.$_terms.map.get(e);
                        return n && (e = n), r._flags.only && "symbol" != typeof e ? {
                            value: e,
                            errors: s("symbol.map", {
                                map: r.$_terms.map
                            })
                        } : {
                            value: e
                        };
                    }
                },
                validate (e, t) {
                    let { error: r } = t;
                    if ("symbol" != typeof e) return {
                        value: e,
                        errors: r("symbol.base")
                    };
                },
                rules: {
                    map: {
                        method (e) {
                            e && !e[Symbol.iterator] && "object" == typeof e && (e = Object.entries(e)), s(e && e[Symbol.iterator], "Iterable must be an iterable or object");
                            const t = this.clone(), r = [];
                            for (const n of e){
                                s(n && n[Symbol.iterator], "Entry must be an iterable");
                                const [e, a] = n;
                                s("object" != typeof e && "function" != typeof e && "symbol" != typeof e, "Key must not be of type object, function, or Symbol"), s("symbol" == typeof a, "Value must be a Symbol"), t.$_terms.map.set(e, a), r.push(a);
                            }
                            return t.valid(...r);
                        }
                    }
                },
                manifest: {
                    build: (e, t)=>(t.map && (e = e.map(t.map)), e)
                },
                messages: {
                    "symbol.base": "{{#label}} must be a symbol",
                    "symbol.map": "{{#label}} must be one of {{#map}}"
                }
            });
        },
        8863: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(738), i = r(9621), o = r(8160), l = r(6354), c = r(493), u = {
                result: Symbol("result")
            };
            t.entry = function(e, t, r) {
                let n = o.defaults;
                r && (s(void 0 === r.warnings, "Cannot override warnings preference in synchronous validation"), s(void 0 === r.artifacts, "Cannot override artifacts preference in synchronous validation"), n = o.preferences(o.defaults, r));
                const a = u.entry(e, t, n);
                s(!a.mainstay.externals.length, "Schema with external rules must use validateAsync()");
                const i = {
                    value: a.value
                };
                return a.error && (i.error = a.error), a.mainstay.warnings.length && (i.warning = l.details(a.mainstay.warnings)), a.mainstay.debug && (i.debug = a.mainstay.debug), a.mainstay.artifacts && (i.artifacts = a.mainstay.artifacts), i;
            }, t.entryAsync = async function(e, t, r) {
                let s = o.defaults;
                r && (s = o.preferences(o.defaults, r));
                const n = u.entry(e, t, s), a = n.mainstay;
                if (n.error) throw a.debug && (n.error.debug = a.debug), n.error;
                if (a.externals.length) {
                    let t = n.value;
                    const c = [];
                    for (const n of a.externals){
                        const f = n.state.path, h = "link" === n.schema.type ? a.links.get(n.schema) : null;
                        let m, d, p = t;
                        const g = f.length ? [
                            t
                        ] : [], y = f.length ? i(e, f) : e;
                        if (f.length) {
                            m = f[f.length - 1];
                            let e = t;
                            for (const t of f.slice(0, -1))e = e[t], g.unshift(e);
                            d = g[0], p = d[m];
                        }
                        try {
                            const e = (e, t)=>(h || n.schema).$_createError(e, p, t, n.state, s), i = await n.method(p, {
                                schema: n.schema,
                                linked: h,
                                state: n.state,
                                prefs: r,
                                original: y,
                                error: e,
                                errorsArray: u.errorsArray,
                                warn: (e, t)=>a.warnings.push((h || n.schema).$_createError(e, p, t, n.state, s)),
                                message: (e, t)=>(h || n.schema).$_createError("external", p, t, n.state, s, {
                                        messages: e
                                    })
                            });
                            if (void 0 === i || i === p) continue;
                            if (i instanceof l.Report) {
                                if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(i), s.abortEarly) break;
                                continue;
                            }
                            if (Array.isArray(i) && i[o.symbols.errors]) {
                                if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(...i), s.abortEarly) break;
                                continue;
                            }
                            d ? (a.tracer.value(n.state, "rule", p, i, "external"), d[m] = i) : (a.tracer.value(n.state, "rule", t, i, "external"), t = i);
                        } catch (e) {
                            throw s.errors.label && (e.message += ` (${n.label})`), e;
                        }
                    }
                    if (n.value = t, c.length) throw n.error = l.process(c, e, s), a.debug && (n.error.debug = a.debug), n.error;
                }
                if (!s.warnings && !s.debug && !s.artifacts) return n.value;
                const c = {
                    value: n.value
                };
                return a.warnings.length && (c.warning = l.details(a.warnings)), a.debug && (c.debug = a.debug), a.artifacts && (c.artifacts = a.artifacts), c;
            }, u.Mainstay = class {
                constructor(e, t, r){
                    this.externals = [], this.warnings = [], this.tracer = e, this.debug = t, this.links = r, this.shadow = null, this.artifacts = null, this._snapshots = [];
                }
                snapshot() {
                    this._snapshots.push({
                        externals: this.externals.slice(),
                        warnings: this.warnings.slice()
                    });
                }
                restore() {
                    const e = this._snapshots.pop();
                    this.externals = e.externals, this.warnings = e.warnings;
                }
            }, u.entry = function(e, r, s) {
                const { tracer: n, cleanup: a } = u.tracer(r, s), i = s.debug ? [] : null, o = r._ids._schemaChain ? new Map : null, f = new u.Mainstay(n, i, o), h = r._ids._schemaChain ? [
                    {
                        schema: r
                    }
                ] : null, m = new c([], [], {
                    mainstay: f,
                    schemas: h
                }), d = t.validate(e, r, m, s);
                a && r.$_root.untrace();
                const p = l.process(d.errors, e, s);
                return {
                    value: d.value,
                    error: p,
                    mainstay: f
                };
            }, u.tracer = function(e, t) {
                return e.$_root._tracer ? {
                    tracer: e.$_root._tracer._register(e)
                } : t.debug ? (s(e.$_root.trace, "Debug mode not supported"), {
                    tracer: e.$_root.trace()._register(e),
                    cleanup: !0
                }) : {
                    tracer: u.ignore
                };
            }, t.validate = function(e, t, r, s) {
                let n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
                if (t.$_terms.whens && (t = t._generate(e, r, s).schema), t._preferences && (s = u.prefs(t, s)), t._cache && s.cache) {
                    const s = t._cache.get(e);
                    if (r.mainstay.tracer.debug(r, "validate", "cached", !!s), s) return s;
                }
                const a = (n, a, i)=>t.$_createError(n, e, a, i || r, s), i = {
                    original: e,
                    prefs: s,
                    schema: t,
                    state: r,
                    error: a,
                    errorsArray: u.errorsArray,
                    warn: (e, t, s)=>r.mainstay.warnings.push(a(e, t, s)),
                    message: (n, a)=>t.$_createError("custom", e, a, r, s, {
                            messages: n
                        })
                };
                r.mainstay.tracer.entry(t, r);
                const l = t._definition;
                if (l.prepare && void 0 !== e && s.convert) {
                    const t = l.prepare(e, i);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "prepare", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), i);
                        e = t.value;
                    }
                }
                if (l.coerce && void 0 !== e && s.convert && (!l.coerce.from || l.coerce.from.includes(typeof e))) {
                    const t = l.coerce.method(e, i);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "coerced", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), i);
                        e = t.value;
                    }
                }
                const c = t._flags.empty;
                c && c.$_match(u.trim(e, t), r.nest(c), o.defaults) && (r.mainstay.tracer.value(r, "empty", e, void 0), e = void 0);
                const f = n.presence || t._flags.presence || (t._flags._endedSwitch ? null : s.presence);
                if (void 0 === e) {
                    if ("forbidden" === f) return u.finalize(e, null, i);
                    if ("required" === f) return u.finalize(e, [
                        t.$_createError("any.required", e, null, r, s)
                    ], i);
                    if ("optional" === f) {
                        if (t._flags.default !== o.symbols.deepDefault) return u.finalize(e, null, i);
                        r.mainstay.tracer.value(r, "default", e, {}), e = {};
                    }
                } else if ("forbidden" === f) return u.finalize(e, [
                    t.$_createError("any.unknown", e, null, r, s)
                ], i);
                const h = [];
                if (t._valids) {
                    const n = t._valids.get(e, r, s, t._flags.insensitive);
                    if (n) return s.convert && (r.mainstay.tracer.value(r, "valids", e, n.value), e = n.value), r.mainstay.tracer.filter(t, r, "valid", n), u.finalize(e, null, i);
                    if (t._flags.only) {
                        const n = t.$_createError("any.only", e, {
                            valids: t._valids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            n
                        ], i);
                        h.push(n);
                    }
                }
                if (t._invalids) {
                    const n = t._invalids.get(e, r, s, t._flags.insensitive);
                    if (n) {
                        r.mainstay.tracer.filter(t, r, "invalid", n);
                        const a = t.$_createError("any.invalid", e, {
                            invalids: t._invalids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            a
                        ], i);
                        h.push(a);
                    }
                }
                if (l.validate) {
                    const t = l.validate(e, i);
                    if (t && (r.mainstay.tracer.value(r, "base", e, t.value), e = t.value, t.errors)) {
                        if (!Array.isArray(t.errors)) return h.push(t.errors), u.finalize(e, h, i);
                        if (t.errors.length) return h.push(...t.errors), u.finalize(e, h, i);
                    }
                }
                return t._rules.length ? u.rules(e, h, i) : u.finalize(e, h, i);
            }, u.rules = function(e, t, r) {
                const { schema: s, state: n, prefs: a } = r;
                for (const i of s._rules){
                    const l = s._definition.rules[i.method];
                    if (l.convert && a.convert) {
                        n.mainstay.tracer.log(s, n, "rule", i.name, "full");
                        continue;
                    }
                    let c, f = i.args;
                    if (i._resolve.length) {
                        f = Object.assign({}, f);
                        for (const t of i._resolve){
                            const r = l.argsByName.get(t), i = f[t].resolve(e, n, a), u = r.normalize ? r.normalize(i) : i, h = o.validateArg(u, null, r);
                            if (h) {
                                c = s.$_createError("any.ref", i, {
                                    arg: t,
                                    ref: f[t],
                                    reason: h
                                }, n, a);
                                break;
                            }
                            f[t] = u;
                        }
                    }
                    c = c || l.validate(e, r, f, i);
                    const h = u.rule(c, i);
                    if (h.errors) {
                        if (n.mainstay.tracer.log(s, n, "rule", i.name, "error"), i.warn) {
                            n.mainstay.warnings.push(...h.errors);
                            continue;
                        }
                        if (a.abortEarly) return u.finalize(e, h.errors, r);
                        t.push(...h.errors);
                    } else n.mainstay.tracer.log(s, n, "rule", i.name, "pass"), n.mainstay.tracer.value(n, "rule", e, h.value, i.name), e = h.value;
                }
                return u.finalize(e, t, r);
            }, u.rule = function(e, t) {
                return e instanceof l.Report ? (u.error(e, t), {
                    errors: [
                        e
                    ],
                    value: null
                }) : Array.isArray(e) && e[o.symbols.errors] ? (e.forEach((e)=>u.error(e, t)), {
                    errors: e,
                    value: null
                }) : {
                    errors: null,
                    value: e
                };
            }, u.error = function(e, t) {
                return t.message && e._setTemplate(t.message), e;
            }, u.finalize = function(e, t, r) {
                t = t || [];
                const { schema: n, state: a, prefs: i } = r;
                if (t.length) {
                    const s = u.default("failover", void 0, t, r);
                    void 0 !== s && (a.mainstay.tracer.value(a, "failover", e, s), e = s, t = []);
                }
                if (t.length && n._flags.error) {
                    if ("function" == typeof n._flags.error) {
                        t = n._flags.error(t), Array.isArray(t) || (t = [
                            t
                        ]);
                        for (const e of t)s(e instanceof Error || e instanceof l.Report, "error() must return an Error object");
                    } else t = [
                        n._flags.error
                    ];
                }
                if (void 0 === e) {
                    const s = u.default("default", e, t, r);
                    a.mainstay.tracer.value(a, "default", e, s), e = s;
                }
                if (n._flags.cast && void 0 !== e) {
                    const t = n._definition.cast[n._flags.cast];
                    if (t.from(e)) {
                        const s = t.to(e, r);
                        a.mainstay.tracer.value(a, "cast", e, s, n._flags.cast), e = s;
                    }
                }
                if (n.$_terms.externals && i.externals && !1 !== i._externals) for (const { method: e } of n.$_terms.externals)a.mainstay.externals.push({
                    method: e,
                    schema: n,
                    state: a,
                    label: l.label(n._flags, a, i)
                });
                const o = {
                    value: e,
                    errors: t.length ? t : null
                };
                return n._flags.result && (o.value = "strip" === n._flags.result ? void 0 : r.original, a.mainstay.tracer.value(a, n._flags.result, e, o.value), a.shadow(e, n._flags.result)), n._cache && !1 !== i.cache && !n._refs.length && n._cache.set(r.original, o), void 0 === e || o.errors || void 0 === n._flags.artifact || (a.mainstay.artifacts = a.mainstay.artifacts || new Map, a.mainstay.artifacts.has(n._flags.artifact) || a.mainstay.artifacts.set(n._flags.artifact, []), a.mainstay.artifacts.get(n._flags.artifact).push(a.path)), o;
            }, u.prefs = function(e, t) {
                const r = t === o.defaults;
                return r && e._preferences[o.symbols.prefs] ? e._preferences[o.symbols.prefs] : (t = o.preferences(t, e._preferences), r && (e._preferences[o.symbols.prefs] = t), t);
            }, u.default = function(e, t, r, s) {
                const { schema: a, state: i, prefs: l } = s, c = a._flags[e];
                if (l.noDefaults || void 0 === c) return t;
                if (i.mainstay.tracer.log(a, i, "rule", e, "full"), !c) return c;
                if ("function" == typeof c) {
                    const t = c.length ? [
                        n(i.ancestors[0]),
                        s
                    ] : [];
                    try {
                        return c(...t);
                    } catch (t) {
                        return void r.push(a.$_createError(`any.${e}`, null, {
                            error: t
                        }, i, l));
                    }
                }
                return "object" != typeof c ? c : c[o.symbols.literal] ? c.literal : o.isResolvable(c) ? c.resolve(t, i, l) : n(c);
            }, u.trim = function(e, t) {
                if ("string" != typeof e) return e;
                const r = t.$_getRule("trim");
                return r && r.args.enabled ? e.trim() : e;
            }, u.ignore = {
                active: !1,
                debug: a,
                entry: a,
                filter: a,
                log: a,
                resolve: a,
                value: a
            }, u.errorsArray = function() {
                const e = [];
                return e[o.symbols.errors] = !0, e;
            };
        },
        2036: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(9474), a = r(8160), i = {};
            e.exports = i.Values = class {
                constructor(e, t){
                    this._values = new Set(e), this._refs = new Set(t), this._lowercase = i.lowercases(e), this._override = !1;
                }
                get length() {
                    return this._values.size + this._refs.size;
                }
                add(e, t) {
                    a.isResolvable(e) ? this._refs.has(e) || (this._refs.add(e), t && t.register(e)) : this.has(e, null, null, !1) || (this._values.add(e), "string" == typeof e && this._lowercase.set(e.toLowerCase(), e));
                }
                static merge(e, t, r) {
                    if (e = e || new i.Values, t) {
                        if (t._override) return t.clone();
                        for (const r of [
                            ...t._values,
                            ...t._refs
                        ])e.add(r);
                    }
                    if (r) for (const t of [
                        ...r._values,
                        ...r._refs
                    ])e.remove(t);
                    return e.length ? e : null;
                }
                remove(e) {
                    a.isResolvable(e) ? this._refs.delete(e) : (this._values.delete(e), "string" == typeof e && this._lowercase.delete(e.toLowerCase()));
                }
                has(e, t, r, s) {
                    return !!this.get(e, t, r, s);
                }
                get(e, t, r, s) {
                    if (!this.length) return !1;
                    if (this._values.has(e)) return {
                        value: e
                    };
                    if ("string" == typeof e && e && s) {
                        const t = this._lowercase.get(e.toLowerCase());
                        if (t) return {
                            value: t
                        };
                    }
                    if (!this._refs.size && "object" != typeof e) return !1;
                    if ("object" == typeof e) {
                        for (const t of this._values)if (n(t, e)) return {
                            value: t
                        };
                    }
                    if (t) for (const a of this._refs){
                        const i = a.resolve(e, t, r, null, {
                            in: !0
                        });
                        if (void 0 === i) continue;
                        const o = a.in && "object" == typeof i ? Array.isArray(i) ? i : Object.keys(i) : [
                            i
                        ];
                        for (const t of o)if (typeof t == typeof e) {
                            if (s && e && "string" == typeof e) {
                                if (t.toLowerCase() === e.toLowerCase()) return {
                                    value: t,
                                    ref: a
                                };
                            } else if (n(t, e)) return {
                                value: t,
                                ref: a
                            };
                        }
                    }
                    return !1;
                }
                override() {
                    this._override = !0;
                }
                values(e) {
                    if (e && e.display) {
                        const e = [];
                        for (const t of [
                            ...this._values,
                            ...this._refs
                        ])void 0 !== t && e.push(t);
                        return e;
                    }
                    return Array.from([
                        ...this._values,
                        ...this._refs
                    ]);
                }
                clone() {
                    const e = new i.Values(this._values, this._refs);
                    return e._override = this._override, e;
                }
                concat(e) {
                    s(!e._override, "Cannot concat override set of values");
                    const t = new i.Values([
                        ...this._values,
                        ...e._values
                    ], [
                        ...this._refs,
                        ...e._refs
                    ]);
                    return t._override = this._override, t;
                }
                describe() {
                    const e = [];
                    this._override && e.push({
                        override: !0
                    });
                    for (const t of this._values.values())e.push(t && "object" == typeof t ? {
                        value: t
                    } : t);
                    for (const t of this._refs.values())e.push(t.describe());
                    return e;
                }
            }, i.Values.prototype[a.symbols.values] = !0, i.Values.prototype.slice = i.Values.prototype.clone, i.lowercases = function(e) {
                const t = new Map;
                if (e) for (const r of e)"string" == typeof r && t.set(r.toLowerCase(), r);
                return t;
            };
        },
        978: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(1687), i = r(9621), o = {};
            e.exports = function(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (s(e && "object" == typeof e, "Invalid defaults value: must be an object"), s(!t || !0 === t || "object" == typeof t, "Invalid source value: must be true, falsy or an object"), s("object" == typeof r, "Invalid options: must be an object"), !t) return null;
                if (r.shallow) return o.applyToDefaultsWithShallow(e, t, r);
                const i = n(e);
                if (!0 === t) return i;
                const l = void 0 !== r.nullOverride && r.nullOverride;
                return a(i, t, {
                    nullOverride: l,
                    mergeArrays: !1
                });
            }, o.applyToDefaultsWithShallow = function(e, t, r) {
                const l = r.shallow;
                s(Array.isArray(l), "Invalid keys");
                const c = new Map, u = !0 === t ? null : new Set;
                for (let r of l){
                    r = Array.isArray(r) ? r : r.split(".");
                    const s = i(e, r);
                    s && "object" == typeof s ? c.set(s, u && i(t, r) || s) : u && u.add(r);
                }
                const f = n(e, {}, c);
                if (!u) return f;
                for (const e of u)o.reachCopy(f, t, e);
                const h = void 0 !== r.nullOverride && r.nullOverride;
                return a(f, t, {
                    nullOverride: h,
                    mergeArrays: !1
                });
            }, o.reachCopy = function(e, t, r) {
                for (const e of r){
                    if (!(e in t)) return;
                    const r = t[e];
                    if ("object" != typeof r || null === r) return;
                    t = r;
                }
                const s = t;
                let n = e;
                for(let e = 0; e < r.length - 1; ++e){
                    const t = r[e];
                    "object" != typeof n[t] && (n[t] = {}), n = n[t];
                }
                n[r[r.length - 1]] = s;
            };
        },
        375: (e, t, r)=>{
            "use strict";
            const s = r(7916);
            e.exports = function(e) {
                if (!e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                    if (1 === r.length && r[0] instanceof Error) throw r[0];
                    throw new s(r);
                }
            };
        },
        8571: (e, t, r)=>{
            "use strict";
            const s = r(9621), n = r(4277), a = r(7043), i = {
                needsProtoHack: new Set([
                    n.set,
                    n.map,
                    n.weakSet,
                    n.weakMap
                ])
            };
            e.exports = i.clone = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                if ("object" != typeof e || null === e) return e;
                let s = i.clone, o = r;
                if (t.shallow) {
                    if (!0 !== t.shallow) return i.cloneWithShallow(e, t);
                    s = (e)=>e;
                } else if (o) {
                    const t = o.get(e);
                    if (t) return t;
                } else o = new Map;
                const l = n.getInternalProto(e);
                if (l === n.buffer) return !1;
                if (l === n.date) return new Date(e.getTime());
                if (l === n.regex) return new RegExp(e);
                const c = i.base(e, l, t);
                if (c === e) return e;
                if (o && o.set(e, c), l === n.set) for (const r of e)c.add(s(r, t, o));
                else if (l === n.map) for (const [r, n] of e)c.set(r, s(n, t, o));
                const u = a.keys(e, t);
                for (const r of u){
                    if ("__proto__" === r) continue;
                    if (l === n.array && "length" === r) {
                        c.length = e.length;
                        continue;
                    }
                    const a = Object.getOwnPropertyDescriptor(e, r);
                    a ? a.get || a.set ? Object.defineProperty(c, r, a) : a.enumerable ? c[r] = s(e[r], t, o) : Object.defineProperty(c, r, {
                        enumerable: !1,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, o)
                    }) : Object.defineProperty(c, r, {
                        enumerable: !0,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, o)
                    });
                }
                return c;
            }, i.cloneWithShallow = function(e, t) {
                const r = t.shallow;
                (t = Object.assign({}, t)).shallow = !1;
                const n = new Map;
                for (const t of r){
                    const r = s(e, t);
                    "object" != typeof r && "function" != typeof r || n.set(r, r);
                }
                return i.clone(e, t, n);
            }, i.base = function(e, t, r) {
                if (!1 === r.prototype) return i.needsProtoHack.has(t) ? new t.constructor : t === n.array ? [] : {};
                const s = Object.getPrototypeOf(e);
                if (s && s.isImmutable) return e;
                if (t === n.array) {
                    const e = [];
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                if (i.needsProtoHack.has(t)) {
                    const e = new s.constructor;
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                return Object.create(s);
            };
        },
        9474: (e, t, r)=>{
            "use strict";
            const s = r(4277), n = {
                mismatched: null
            };
            e.exports = function(e, t, r) {
                return r = Object.assign({
                    prototype: !0
                }, r), !!n.isDeepEqual(e, t, r, []);
            }, n.isDeepEqual = function(e, t, r, a) {
                if (e === t) return 0 !== e || 1 / e == 1 / t;
                const i = typeof e;
                if (i !== typeof t) return !1;
                if (null === e || null === t) return !1;
                if ("function" === i) {
                    if (!r.deepFunction || e.toString() !== t.toString()) return !1;
                } else if ("object" !== i) return e != e && t != t;
                const o = n.getSharedType(e, t, !!r.prototype);
                switch(o){
                    case s.buffer:
                        return !1;
                    case s.promise:
                        return e === t;
                    case s.regex:
                        return e.toString() === t.toString();
                    case n.mismatched:
                        return !1;
                }
                for(let r = a.length - 1; r >= 0; --r)if (a[r].isSame(e, t)) return !0;
                a.push(new n.SeenEntry(e, t));
                try {
                    return !!n.isDeepEqualObj(o, e, t, r, a);
                } finally{
                    a.pop();
                }
            }, n.getSharedType = function(e, t, r) {
                if (r) return Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? n.mismatched : s.getInternalProto(e);
                const a = s.getInternalProto(e);
                return a !== s.getInternalProto(t) ? n.mismatched : a;
            }, n.valueOf = function(e) {
                const t = e.valueOf;
                if (void 0 === t) return e;
                try {
                    return t.call(e);
                } catch (e) {
                    return e;
                }
            }, n.hasOwnEnumerableProperty = function(e, t) {
                return Object.prototype.propertyIsEnumerable.call(e, t);
            }, n.isSetSimpleEqual = function(e, t) {
                for (const r of Set.prototype.values.call(e))if (!Set.prototype.has.call(t, r)) return !1;
                return !0;
            }, n.isDeepEqualObj = function(e, t, r, a, i) {
                const { isDeepEqual: o, valueOf: l, hasOwnEnumerableProperty: c } = n, { keys: u, getOwnPropertySymbols: f } = Object;
                if (e === s.array) {
                    if (!a.part) {
                        if (t.length !== r.length) return !1;
                        for(let e = 0; e < t.length; ++e)if (!o(t[e], r[e], a, i)) return !1;
                        return !0;
                    }
                    for (const e of t)for (const t of r)if (o(e, t, a, i)) return !0;
                } else if (e === s.set) {
                    if (t.size !== r.size) return !1;
                    if (!n.isSetSimpleEqual(t, r)) {
                        const e = new Set(Set.prototype.values.call(r));
                        for (const r of Set.prototype.values.call(t)){
                            if (e.delete(r)) continue;
                            let t = !1;
                            for (const s of e)if (o(r, s, a, i)) {
                                e.delete(s), t = !0;
                                break;
                            }
                            if (!t) return !1;
                        }
                    }
                } else if (e === s.map) {
                    if (t.size !== r.size) return !1;
                    for (const [e, s] of Map.prototype.entries.call(t)){
                        if (void 0 === s && !Map.prototype.has.call(r, e)) return !1;
                        if (!o(s, Map.prototype.get.call(r, e), a, i)) return !1;
                    }
                } else if (e === s.error && (t.name !== r.name || t.message !== r.message)) return !1;
                const h = l(t), m = l(r);
                if ((t !== h || r !== m) && !o(h, m, a, i)) return !1;
                const d = u(t);
                if (!a.part && d.length !== u(r).length && !a.skip) return !1;
                let p = 0;
                for (const e of d)if (a.skip && a.skip.includes(e)) void 0 === r[e] && ++p;
                else {
                    if (!c(r, e)) return !1;
                    if (!o(t[e], r[e], a, i)) return !1;
                }
                if (!a.part && d.length - p !== u(r).length) return !1;
                if (!1 !== a.symbols) {
                    const e = f(t), s = new Set(f(r));
                    for (const n of e){
                        if (!a.skip || !a.skip.includes(n)) {
                            if (c(t, n)) {
                                if (!c(r, n)) return !1;
                                if (!o(t[n], r[n], a, i)) return !1;
                            } else if (c(r, n)) return !1;
                        }
                        s.delete(n);
                    }
                    for (const e of s)if (c(r, e)) return !1;
                }
                return !0;
            }, n.SeenEntry = class {
                constructor(e, t){
                    this.obj = e, this.ref = t;
                }
                isSame(e, t) {
                    return this.obj === e && this.ref === t;
                }
            };
        },
        7916: (e, t, r)=>{
            "use strict";
            const s = r(8761);
            e.exports = class extends Error {
                constructor(e){
                    super(e.filter((e)=>"" !== e).map((e)=>"string" == typeof e ? e : e instanceof Error ? e.message : s(e)).join(" ") || "Unknown error"), "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, t.assert);
                }
            };
        },
        5277: (e)=>{
            "use strict";
            const t = {};
            e.exports = function(e) {
                if (!e) return "";
                let r = "";
                for(let s = 0; s < e.length; ++s){
                    const n = e.charCodeAt(s);
                    t.isSafe(n) ? r += e[s] : r += t.escapeHtmlChar(n);
                }
                return r;
            }, t.escapeHtmlChar = function(e) {
                return t.namedHtml.get(e) || (e >= 256 ? "&#" + e + ";" : `&#x${e.toString(16).padStart(2, "0")};`);
            }, t.isSafe = function(e) {
                return t.safeCharCodes.has(e);
            }, t.namedHtml = new Map([
                [
                    38,
                    "&amp;"
                ],
                [
                    60,
                    "&lt;"
                ],
                [
                    62,
                    "&gt;"
                ],
                [
                    34,
                    "&quot;"
                ],
                [
                    160,
                    "&nbsp;"
                ],
                [
                    162,
                    "&cent;"
                ],
                [
                    163,
                    "&pound;"
                ],
                [
                    164,
                    "&curren;"
                ],
                [
                    169,
                    "&copy;"
                ],
                [
                    174,
                    "&reg;"
                ]
            ]), t.safeCharCodes = function() {
                const e = new Set;
                for(let t = 32; t < 123; ++t)(t >= 97 || t >= 65 && t <= 90 || t >= 48 && t <= 57 || 32 === t || 46 === t || 44 === t || 45 === t || 58 === t || 95 === t) && e.add(t);
                return e;
            }();
        },
        6064: (e)=>{
            "use strict";
            e.exports = function(e) {
                return e.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, "\\$&");
            };
        },
        738: (e)=>{
            "use strict";
            e.exports = function() {};
        },
        1687: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(8571), a = r(7043), i = {};
            e.exports = i.merge = function(e, t, r) {
                if (s(e && "object" == typeof e, "Invalid target value: must be an object"), s(null == t || "object" == typeof t, "Invalid source value: must be null, undefined, or an object"), !t) return e;
                if (r = Object.assign({
                    nullOverride: !0,
                    mergeArrays: !0
                }, r), Array.isArray(t)) {
                    s(Array.isArray(e), "Cannot merge array onto an object"), r.mergeArrays || (e.length = 0);
                    for(let s = 0; s < t.length; ++s)e.push(n(t[s], {
                        symbols: r.symbols
                    }));
                    return e;
                }
                const o = a.keys(t, r);
                for(let s = 0; s < o.length; ++s){
                    const a = o[s];
                    if ("__proto__" === a || !Object.prototype.propertyIsEnumerable.call(t, a)) continue;
                    const l = t[a];
                    if (l && "object" == typeof l) {
                        if (e[a] === l) continue;
                        !e[a] || "object" != typeof e[a] || Array.isArray(e[a]) !== Array.isArray(l) || l instanceof Date || l instanceof RegExp ? e[a] = n(l, {
                            symbols: r.symbols
                        }) : i.merge(e[a], l, r);
                    } else (null != l || r.nullOverride) && (e[a] = l);
                }
                return e;
            };
        },
        9621: (e, t, r)=>{
            "use strict";
            const s = r(375), n = {};
            e.exports = function(e, t, r) {
                if (!1 === t || null == t) return e;
                "string" == typeof (r = r || {}) && (r = {
                    separator: r
                });
                const a = Array.isArray(t);
                s(!a || !r.separator, "Separator option is not valid for array-based chain");
                const i = a ? t : t.split(r.separator || ".");
                let o = e;
                for(let e = 0; e < i.length; ++e){
                    let a = i[e];
                    const l = r.iterables && n.iterables(o);
                    if (Array.isArray(o) || "set" === l) {
                        const e = Number(a);
                        Number.isInteger(e) && (a = e < 0 ? o.length + e : e);
                    }
                    if (!o || "function" == typeof o && !1 === r.functions || !l && void 0 === o[a]) {
                        s(!r.strict || e + 1 === i.length, "Missing segment", a, "in reach path ", t), s("object" == typeof o || !0 === r.functions || "function" != typeof o, "Invalid segment", a, "in reach path ", t), o = r.default;
                        break;
                    }
                    o = l ? "set" === l ? [
                        ...o
                    ][a] : o.get(a) : o[a];
                }
                return o;
            }, n.iterables = function(e) {
                return e instanceof Set ? "set" : e instanceof Map ? "map" : void 0;
            };
        },
        8761: (e)=>{
            "use strict";
            e.exports = function() {
                try {
                    return JSON.stringify(...arguments);
                } catch (e) {
                    return "[Cannot display object: " + e.message + "]";
                }
            };
        },
        4277: (e, t)=>{
            "use strict";
            const r = {};
            t = e.exports = {
                array: Array.prototype,
                buffer: !1,
                date: Date.prototype,
                error: Error.prototype,
                generic: Object.prototype,
                map: Map.prototype,
                promise: Promise.prototype,
                regex: RegExp.prototype,
                set: Set.prototype,
                weakMap: WeakMap.prototype,
                weakSet: WeakSet.prototype
            }, r.typeMap = new Map([
                [
                    "[object Error]",
                    t.error
                ],
                [
                    "[object Map]",
                    t.map
                ],
                [
                    "[object Promise]",
                    t.promise
                ],
                [
                    "[object Set]",
                    t.set
                ],
                [
                    "[object WeakMap]",
                    t.weakMap
                ],
                [
                    "[object WeakSet]",
                    t.weakSet
                ]
            ]), t.getInternalProto = function(e) {
                if (Array.isArray(e)) return t.array;
                if (e instanceof Date) return t.date;
                if (e instanceof RegExp) return t.regex;
                if (e instanceof Error) return t.error;
                const s = Object.prototype.toString.call(e);
                return r.typeMap.get(s) || t.generic;
            };
        },
        7043: (e, t)=>{
            "use strict";
            t.keys = function(e) {
                return !1 !== (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).symbols ? Reflect.ownKeys(e) : Object.getOwnPropertyNames(e);
            };
        },
        3652: (e, t, r)=>{
            "use strict";
            const s = r(375), n = {};
            t.Sorter = class {
                constructor(){
                    this._items = [], this.nodes = [];
                }
                add(e, t) {
                    const r = [].concat((t = t || {}).before || []), n = [].concat(t.after || []), a = t.group || "?", i = t.sort || 0;
                    s(!r.includes(a), `Item cannot come before itself: ${a}`), s(!r.includes("?"), "Item cannot come before unassociated items"), s(!n.includes(a), `Item cannot come after itself: ${a}`), s(!n.includes("?"), "Item cannot come after unassociated items"), Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e){
                        const e = {
                            seq: this._items.length,
                            sort: i,
                            before: r,
                            after: n,
                            group: a,
                            node: t
                        };
                        this._items.push(e);
                    }
                    if (!t.manual) {
                        const e = this._sort();
                        s(e, "item", "?" !== a ? `added into group ${a}` : "", "created a dependencies error");
                    }
                    return this.nodes;
                }
                merge(e) {
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e)if (t) for (const e of t._items)this._items.push(Object.assign({}, e));
                    this._items.sort(n.mergeSort);
                    for(let e = 0; e < this._items.length; ++e)this._items[e].seq = e;
                    const t = this._sort();
                    return s(t, "merge created a dependencies error"), this.nodes;
                }
                sort() {
                    const e = this._sort();
                    return s(e, "sort created a dependencies error"), this.nodes;
                }
                _sort() {
                    const e = {}, t = Object.create(null), r = Object.create(null);
                    for (const s of this._items){
                        const n = s.seq, a = s.group;
                        r[a] = r[a] || [], r[a].push(n), e[n] = s.before;
                        for (const e of s.after)t[e] = t[e] || [], t[e].push(n);
                    }
                    for(const t in e){
                        const s = [];
                        for(const n in e[t]){
                            const a = e[t][n];
                            r[a] = r[a] || [], s.push(...r[a]);
                        }
                        e[t] = s;
                    }
                    for(const s in t)if (r[s]) for (const n of r[s])e[n].push(...t[s]);
                    const s = {};
                    for(const t in e){
                        const r = e[t];
                        for (const e of r)s[e] = s[e] || [], s[e].push(t);
                    }
                    const n = {}, a = [];
                    for(let e = 0; e < this._items.length; ++e){
                        let t = e;
                        if (s[e]) {
                            t = null;
                            for(let e = 0; e < this._items.length; ++e){
                                if (!0 === n[e]) continue;
                                s[e] || (s[e] = []);
                                const r = s[e].length;
                                let a = 0;
                                for(let t = 0; t < r; ++t)n[s[e][t]] && ++a;
                                if (a === r) {
                                    t = e;
                                    break;
                                }
                            }
                        }
                        null !== t && (n[t] = !0, a.push(t));
                    }
                    if (a.length !== this._items.length) return !1;
                    const i = {};
                    for (const e of this._items)i[e.seq] = e;
                    this._items = [], this.nodes = [];
                    for (const e of a){
                        const t = i[e];
                        this.nodes.push(t.node), this._items.push(t);
                    }
                    return !0;
                }
            }, n.mergeSort = (e, t)=>e.sort === t.sort ? 0 : e.sort < t.sort ? -1 : 1;
        },
        5380: (e, t, r)=>{
            "use strict";
            const s = r(443), n = r(2178), a = {
                minDomainSegments: 2,
                nonAsciiRx: /[^\x00-\x7f]/,
                domainControlRx: /[\x00-\x20@\:\/\\#!\$&\'\(\)\*\+,;=\?]/,
                tldSegmentRx: /^[a-zA-Z](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                domainSegmentRx: /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                URL: s.URL || URL
            };
            t.analyze = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (!e) return n.code("DOMAIN_NON_EMPTY_STRING");
                if ("string" != typeof e) throw new Error("Invalid input: domain must be a string");
                if (e.length > 256) return n.code("DOMAIN_TOO_LONG");
                if (a.nonAsciiRx.test(e)) {
                    if (!1 === t.allowUnicode) return n.code("DOMAIN_INVALID_UNICODE_CHARS");
                    e = e.normalize("NFC");
                }
                if (a.domainControlRx.test(e)) return n.code("DOMAIN_INVALID_CHARS");
                e = a.punycode(e), t.allowFullyQualified && "." === e[e.length - 1] && (e = e.slice(0, -1));
                const r = t.minDomainSegments || a.minDomainSegments, s = e.split(".");
                if (s.length < r) return n.code("DOMAIN_SEGMENTS_COUNT");
                if (t.maxDomainSegments && s.length > t.maxDomainSegments) return n.code("DOMAIN_SEGMENTS_COUNT_MAX");
                const i = t.tlds;
                if (i) {
                    const e = s[s.length - 1].toLowerCase();
                    if (i.deny && i.deny.has(e) || i.allow && !i.allow.has(e)) return n.code("DOMAIN_FORBIDDEN_TLDS");
                }
                for(let e = 0; e < s.length; ++e){
                    const t = s[e];
                    if (!t.length) return n.code("DOMAIN_EMPTY_SEGMENT");
                    if (t.length > 63) return n.code("DOMAIN_LONG_SEGMENT");
                    if (e < s.length - 1) {
                        if (!a.domainSegmentRx.test(t)) return n.code("DOMAIN_INVALID_CHARS");
                    } else if (!a.tldSegmentRx.test(t)) return n.code("DOMAIN_INVALID_TLDS_CHARS");
                }
                return null;
            }, t.isValid = function(e, r) {
                return !t.analyze(e, r);
            }, a.punycode = function(e) {
                e.includes("%") && (e = e.replace(/%/g, "%25"));
                try {
                    return new a.URL(`http://${e}`).host;
                } catch (t) {
                    return e;
                }
            };
        },
        1745: (e, t, r)=>{
            "use strict";
            const s = r(9848), n = r(5380), a = r(2178), i = {
                nonAsciiRx: /[^\x00-\x7f]/,
                encoder: new (s.TextEncoder || TextEncoder)
            };
            t.analyze = function(e, t) {
                return i.email(e, t);
            }, t.isValid = function(e, t) {
                return !i.email(e, t);
            }, i.email = function(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if ("string" != typeof e) throw new Error("Invalid input: email must be a string");
                if (!e) return a.code("EMPTY_STRING");
                const r = !i.nonAsciiRx.test(e);
                if (!r) {
                    if (!1 === t.allowUnicode) return a.code("FORBIDDEN_UNICODE");
                    e = e.normalize("NFC");
                }
                const s = e.split("@");
                if (2 !== s.length) return s.length > 2 ? a.code("MULTIPLE_AT_CHAR") : a.code("MISSING_AT_CHAR");
                const [o, l] = s;
                if (!o) return a.code("EMPTY_LOCAL");
                if (!t.ignoreLength) {
                    if (e.length > 254) return a.code("ADDRESS_TOO_LONG");
                    if (i.encoder.encode(o).length > 64) return a.code("LOCAL_TOO_LONG");
                }
                return i.local(o, r) || n.analyze(l, t);
            }, i.local = function(e, t) {
                const r = e.split(".");
                for (const e of r){
                    if (!e.length) return a.code("EMPTY_LOCAL_SEGMENT");
                    if (t) {
                        if (!i.atextRx.test(e)) return a.code("INVALID_LOCAL_CHARS");
                    } else for (const t of e){
                        if (i.atextRx.test(t)) continue;
                        const e = i.binary(t);
                        if (!i.atomRx.test(e)) return a.code("INVALID_LOCAL_CHARS");
                    }
                }
            }, i.binary = function(e) {
                return Array.from(i.encoder.encode(e)).map((e)=>String.fromCharCode(e)).join("");
            }, i.atextRx = /^[\w!#\$%&'\*\+\-/=\?\^`\{\|\}~]+$/, i.atomRx = new RegExp([
                "(?:[\\xc2-\\xdf][\\x80-\\xbf])",
                "(?:\\xe0[\\xa0-\\xbf][\\x80-\\xbf])|(?:[\\xe1-\\xec][\\x80-\\xbf]{2})|(?:\\xed[\\x80-\\x9f][\\x80-\\xbf])|(?:[\\xee-\\xef][\\x80-\\xbf]{2})",
                "(?:\\xf0[\\x90-\\xbf][\\x80-\\xbf]{2})|(?:[\\xf1-\\xf3][\\x80-\\xbf]{3})|(?:\\xf4[\\x80-\\x8f][\\x80-\\xbf]{2})"
            ].join("|"));
        },
        2178: (e, t)=>{
            "use strict";
            t.codes = {
                EMPTY_STRING: "Address must be a non-empty string",
                FORBIDDEN_UNICODE: "Address contains forbidden Unicode characters",
                MULTIPLE_AT_CHAR: "Address cannot contain more than one @ character",
                MISSING_AT_CHAR: "Address must contain one @ character",
                EMPTY_LOCAL: "Address local part cannot be empty",
                ADDRESS_TOO_LONG: "Address too long",
                LOCAL_TOO_LONG: "Address local part too long",
                EMPTY_LOCAL_SEGMENT: "Address local part contains empty dot-separated segment",
                INVALID_LOCAL_CHARS: "Address local part contains invalid character",
                DOMAIN_NON_EMPTY_STRING: "Domain must be a non-empty string",
                DOMAIN_TOO_LONG: "Domain too long",
                DOMAIN_INVALID_UNICODE_CHARS: "Domain contains forbidden Unicode characters",
                DOMAIN_INVALID_CHARS: "Domain contains invalid character",
                DOMAIN_INVALID_TLDS_CHARS: "Domain contains invalid tld character",
                DOMAIN_SEGMENTS_COUNT: "Domain lacks the minimum required number of segments",
                DOMAIN_SEGMENTS_COUNT_MAX: "Domain contains too many segments",
                DOMAIN_FORBIDDEN_TLDS: "Domain uses forbidden TLD",
                DOMAIN_EMPTY_SEGMENT: "Domain contains empty dot-separated segment",
                DOMAIN_LONG_SEGMENT: "Domain contains dot-separated segment that is too long"
            }, t.code = function(e) {
                return {
                    code: e,
                    error: t.codes[e]
                };
            };
        },
        9959: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(5752);
            t.regex = function() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                s(void 0 === e.cidr || "string" == typeof e.cidr, "options.cidr must be a string");
                const t = e.cidr ? e.cidr.toLowerCase() : "optional";
                s([
                    "required",
                    "optional",
                    "forbidden"
                ].includes(t), "options.cidr must be one of required, optional, forbidden"), s(void 0 === e.version || "string" == typeof e.version || Array.isArray(e.version), "options.version must be a string or an array of string");
                let r = e.version || [
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ];
                Array.isArray(r) || (r = [
                    r
                ]), s(r.length >= 1, "options.version must have at least 1 version specified");
                for(let e = 0; e < r.length; ++e)s("string" == typeof r[e], "options.version must only contain strings"), r[e] = r[e].toLowerCase(), s([
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ].includes(r[e]), "options.version contains unknown version " + r[e] + " - must be one of ipv4, ipv6, ipvfuture");
                r = Array.from(new Set(r));
                const a = `(?:${r.map((e)=>{
                    if ("forbidden" === t) return n.ip[e];
                    const r = `\\/${"ipv4" === e ? n.ip.v4Cidr : n.ip.v6Cidr}`;
                    return "required" === t ? `${n.ip[e]}${r}` : `${n.ip[e]}(?:${r})?`;
                }).join("|")})`, i = new RegExp(`^${a}$`);
                return {
                    cidr: t,
                    versions: r,
                    regex: i,
                    raw: a
                };
            };
        },
        5752: (e, t, r)=>{
            "use strict";
            const s = r(375), n = r(6064), a = {
                generate: function() {
                    const e = {}, t = "\\dA-Fa-f", r = "[" + t + "]", s = "\\w-\\.~", n = "!\\$&'\\(\\)\\*\\+,;=", a = "%" + t, i = s + a + n + ":@", o = "[" + i + "]", l = "(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])";
                    e.ipv4address = "(?:" + l + "\\.){3}" + l;
                    const c = r + "{1,4}", u = "(?:" + c + ":" + c + "|" + e.ipv4address + ")", f = "(?:" + c + ":){6}" + u, h = "::(?:" + c + ":){5}" + u, m = "(?:" + c + ")?::(?:" + c + ":){4}" + u, d = "(?:(?:" + c + ":){0,1}" + c + ")?::(?:" + c + ":){3}" + u, p = "(?:(?:" + c + ":){0,2}" + c + ")?::(?:" + c + ":){2}" + u, g = "(?:(?:" + c + ":){0,3}" + c + ")?::" + c + ":" + u, y = "(?:(?:" + c + ":){0,4}" + c + ")?::" + u, b = "(?:(?:" + c + ":){0,5}" + c + ")?::" + c, v = "(?:(?:" + c + ":){0,6}" + c + ")?::";
                    e.ipv4Cidr = "(?:\\d|[1-2]\\d|3[0-2])", e.ipv6Cidr = "(?:0{0,2}\\d|0?[1-9]\\d|1[01]\\d|12[0-8])", e.ipv6address = "(?:" + f + "|" + h + "|" + m + "|" + d + "|" + p + "|" + g + "|" + y + "|" + b + "|" + v + ")", e.ipvFuture = "v" + r + "+\\.[" + s + n + ":]+", e.scheme = "[a-zA-Z][a-zA-Z\\d+-\\.]*", e.schemeRegex = new RegExp(e.scheme);
                    const _ = "[" + s + a + n + ":]*", w = "[" + s + a + n + "]{1,255}", $ = "(?:\\[(?:" + e.ipv6address + "|" + e.ipvFuture + ")\\]|" + e.ipv4address + "|" + w + ")", x = "(?:" + _ + "@)?" + $ + "(?::\\d*)?", j = "(?:" + _ + "@)?(" + $ + ")(?::\\d*)?", k = o + "*", R = o + "+", A = "(?:\\/" + k + ")*", S = "\\/(?:" + R + A + ")?", O = R + A, E = "[" + s + a + n + "@]+" + A, D = "(?:\\/\\/\\/" + k + A + ")";
                    return e.hierPart = "(?:(?:\\/\\/" + x + A + ")|" + S + "|" + O + "|" + D + ")", e.hierPartCapture = "(?:(?:\\/\\/" + j + A + ")|" + S + "|" + O + ")", e.relativeRef = "(?:(?:\\/\\/" + x + A + ")|" + S + "|" + E + "|)", e.relativeRefCapture = "(?:(?:\\/\\/" + j + A + ")|" + S + "|" + E + "|)", e.query = "[" + i + "\\/\\?]*(?=#|$)", e.queryWithSquareBrackets = "[" + i + "\\[\\]\\/\\?]*(?=#|$)", e.fragment = "[" + i + "\\/\\?]*", e;
                }
            };
            a.rfc3986 = a.generate(), t.ip = {
                v4Cidr: a.rfc3986.ipv4Cidr,
                v6Cidr: a.rfc3986.ipv6Cidr,
                ipv4: a.rfc3986.ipv4address,
                ipv6: a.rfc3986.ipv6address,
                ipvfuture: a.rfc3986.ipvFuture
            }, a.createRegex = function(e) {
                const t = a.rfc3986, r = "(?:\\?" + (e.allowQuerySquareBrackets ? t.queryWithSquareBrackets : t.query) + ")?(?:#" + t.fragment + ")?", i = e.domain ? t.relativeRefCapture : t.relativeRef;
                if (e.relativeOnly) return a.wrap(i + r);
                let o = "";
                if (e.scheme) {
                    s(e.scheme instanceof RegExp || "string" == typeof e.scheme || Array.isArray(e.scheme), "scheme must be a RegExp, String, or Array");
                    const r = [].concat(e.scheme);
                    s(r.length >= 1, "scheme must have at least 1 scheme specified");
                    const a = [];
                    for(let e = 0; e < r.length; ++e){
                        const i = r[e];
                        s(i instanceof RegExp || "string" == typeof i, "scheme at position " + e + " must be a RegExp or String"), i instanceof RegExp ? a.push(i.source.toString()) : (s(t.schemeRegex.test(i), "scheme at position " + e + " must be a valid scheme"), a.push(n(i)));
                    }
                    o = a.join("|");
                }
                const l = "(?:" + (o ? "(?:" + o + ")" : t.scheme) + ":" + (e.domain ? t.hierPartCapture : t.hierPart) + ")", c = e.allowRelative ? "(?:" + l + "|" + i + ")" : l;
                return a.wrap(c + r, o);
            }, a.wrap = function(e, t) {
                return {
                    raw: e = `(?=.)(?!https?:/(?:$|[^/]))(?!https?:///)(?!https?:[^/])${e}`,
                    regex: new RegExp(`^${e}$`),
                    scheme: t
                };
            }, a.uriRegex = a.createRegex({}), t.regex = function() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return e.scheme || e.allowRelative || e.relativeOnly || e.allowQuerySquareBrackets || e.domain ? a.createRegex(e) : a.uriRegex;
            };
        },
        1447: (e, t)=>{
            "use strict";
            const r = {
                operators: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "<=",
                    ">",
                    ">=",
                    "==",
                    "!=",
                    "&&",
                    "||",
                    "??"
                ],
                operatorCharacters: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "=",
                    ">",
                    "&",
                    "|",
                    "?"
                ],
                operatorsOrder: [
                    [
                        "^"
                    ],
                    [
                        "*",
                        "/",
                        "%"
                    ],
                    [
                        "+",
                        "-"
                    ],
                    [
                        "<",
                        "<=",
                        ">",
                        ">="
                    ],
                    [
                        "==",
                        "!="
                    ],
                    [
                        "&&"
                    ],
                    [
                        "||",
                        "??"
                    ]
                ],
                operatorsPrefix: [
                    "!",
                    "n"
                ],
                literals: {
                    '"': '"',
                    "`": "`",
                    "'": "'",
                    "[": "]"
                },
                numberRx: /^(?:[0-9]*(\.[0-9]*)?){1}$/,
                tokenRx: /^[\w\$\#\.\@\:\{\}]+$/,
                symbol: Symbol("formula"),
                settings: Symbol("settings")
            };
            t.Parser = class {
                constructor(e){
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!t[r.settings] && t.constants) for(const e in t.constants){
                        const r = t.constants[e];
                        if (null !== r && ![
                            "boolean",
                            "number",
                            "string"
                        ].includes(typeof r)) throw new Error(`Formula constant ${e} contains invalid ${typeof r} value type`);
                    }
                    this.settings = t[r.settings] ? t : Object.assign({
                        [r.settings]: !0,
                        constants: {},
                        functions: {}
                    }, t), this.single = null, this._parts = null, this._parse(e);
                }
                _parse(e) {
                    let s = [], n = "", a = 0, i = !1;
                    const o = (e)=>{
                        if (a) throw new Error("Formula missing closing parenthesis");
                        const o = s.length ? s[s.length - 1] : null;
                        if (i || n || e) {
                            if (o && "reference" === o.type && ")" === e) return o.type = "function", o.value = this._subFormula(n, o.value), void (n = "");
                            if (")" === e) {
                                const e = new t.Parser(n, this.settings);
                                s.push({
                                    type: "segment",
                                    value: e
                                });
                            } else if (i) {
                                if ("]" === i) return s.push({
                                    type: "reference",
                                    value: n
                                }), void (n = "");
                                s.push({
                                    type: "literal",
                                    value: n
                                });
                            } else if (r.operatorCharacters.includes(n)) o && "operator" === o.type && r.operators.includes(o.value + n) ? o.value += n : s.push({
                                type: "operator",
                                value: n
                            });
                            else if (n.match(r.numberRx)) s.push({
                                type: "constant",
                                value: parseFloat(n)
                            });
                            else if (void 0 !== this.settings.constants[n]) s.push({
                                type: "constant",
                                value: this.settings.constants[n]
                            });
                            else {
                                if (!n.match(r.tokenRx)) throw new Error(`Formula contains invalid token: ${n}`);
                                s.push({
                                    type: "reference",
                                    value: n
                                });
                            }
                            n = "";
                        }
                    };
                    for (const t of e)i ? t === i ? (o(), i = !1) : n += t : a ? "(" === t ? (n += t, ++a) : ")" === t ? (--a, a ? n += t : o(t)) : n += t : t in r.literals ? i = r.literals[t] : "(" === t ? (o(), ++a) : r.operatorCharacters.includes(t) ? (o(), n = t, o()) : " " !== t ? n += t : o();
                    o(), s = s.map((e, t)=>"operator" !== e.type || "-" !== e.value || t && "operator" !== s[t - 1].type ? e : {
                            type: "operator",
                            value: "n"
                        });
                    let l = !1;
                    for (const e of s){
                        if ("operator" === e.type) {
                            if (r.operatorsPrefix.includes(e.value)) continue;
                            if (!l) throw new Error("Formula contains an operator in invalid position");
                            if (!r.operators.includes(e.value)) throw new Error(`Formula contains an unknown operator ${e.value}`);
                        } else if (l) throw new Error("Formula missing expected operator");
                        l = !l;
                    }
                    if (!l) throw new Error("Formula contains invalid trailing operator");
                    1 === s.length && [
                        "reference",
                        "literal",
                        "constant"
                    ].includes(s[0].type) && (this.single = {
                        type: "reference" === s[0].type ? "reference" : "value",
                        value: s[0].value
                    }), this._parts = s.map((e)=>{
                        if ("operator" === e.type) return r.operatorsPrefix.includes(e.value) ? e : e.value;
                        if ("reference" !== e.type) return e.value;
                        if (this.settings.tokenRx && !this.settings.tokenRx.test(e.value)) throw new Error(`Formula contains invalid reference ${e.value}`);
                        return this.settings.reference ? this.settings.reference(e.value) : r.reference(e.value);
                    });
                }
                _subFormula(e, s) {
                    const n = this.settings.functions[s];
                    if ("function" != typeof n) throw new Error(`Formula contains unknown function ${s}`);
                    let a = [];
                    if (e) {
                        let t = "", n = 0, i = !1;
                        const o = ()=>{
                            if (!t) throw new Error(`Formula contains function ${s} with invalid arguments ${e}`);
                            a.push(t), t = "";
                        };
                        for(let s = 0; s < e.length; ++s){
                            const a = e[s];
                            i ? (t += a, a === i && (i = !1)) : a in r.literals && !n ? (t += a, i = r.literals[a]) : "," !== a || n ? (t += a, "(" === a ? ++n : ")" === a && --n) : o();
                        }
                        o();
                    }
                    return a = a.map((e)=>new t.Parser(e, this.settings)), function(e) {
                        const t = [];
                        for (const r of a)t.push(r.evaluate(e));
                        return n.call(e, ...t);
                    };
                }
                evaluate(e) {
                    const t = this._parts.slice();
                    for(let s = t.length - 2; s >= 0; --s){
                        const n = t[s];
                        if (n && "operator" === n.type) {
                            const a = t[s + 1];
                            t.splice(s + 1, 1);
                            const i = r.evaluate(a, e);
                            t[s] = r.single(n.value, i);
                        }
                    }
                    return r.operatorsOrder.forEach((s)=>{
                        for(let n = 1; n < t.length - 1;)if (s.includes(t[n])) {
                            const s = t[n], a = r.evaluate(t[n - 1], e), i = r.evaluate(t[n + 1], e);
                            t.splice(n, 2);
                            const o = r.calculate(s, a, i);
                            t[n - 1] = 0 === o ? 0 : o;
                        } else n += 2;
                    }), r.evaluate(t[0], e);
                }
            }, t.Parser.prototype[r.symbol] = !0, r.reference = function(e) {
                return function(t) {
                    return t && void 0 !== t[e] ? t[e] : null;
                };
            }, r.evaluate = function(e, t) {
                return null === e ? null : "function" == typeof e ? e(t) : e[r.symbol] ? e.evaluate(t) : e;
            }, r.single = function(e, t) {
                if ("!" === e) return !t;
                const r = -t;
                return 0 === r ? 0 : r;
            }, r.calculate = function(e, t, s) {
                if ("??" === e) return r.exists(t) ? t : s;
                if ("string" == typeof t || "string" == typeof s) {
                    if ("+" === e) return (t = r.exists(t) ? t : "") + (r.exists(s) ? s : "");
                } else switch(e){
                    case "^":
                        return Math.pow(t, s);
                    case "*":
                        return t * s;
                    case "/":
                        return t / s;
                    case "%":
                        return t % s;
                    case "+":
                        return t + s;
                    case "-":
                        return t - s;
                }
                switch(e){
                    case "<":
                        return t < s;
                    case "<=":
                        return t <= s;
                    case ">":
                        return t > s;
                    case ">=":
                        return t >= s;
                    case "==":
                        return t === s;
                    case "!=":
                        return t !== s;
                    case "&&":
                        return t && s;
                    case "||":
                        return t || s;
                }
                return null;
            }, r.exists = function(e) {
                return null != e;
            };
        },
        9926: ()=>{},
        5688: ()=>{},
        9708: ()=>{},
        1152: ()=>{},
        443: ()=>{},
        9848: ()=>{},
        5934: (e)=>{
            "use strict";
            e.exports = {
                version: "17.9.1"
            };
        }
    }, t = {}, function r(s) {
        var n = t[s];
        if (void 0 !== n) return n.exports;
        var a = t[s] = {
            exports: {}
        };
        return e[s](a, a.exports, r), a.exports;
    }(5107);
});

});

parcelRegister("lH5oz", function(module, exports) {
$parcel$export(module.exports, "ProviderRpcErrorCode", function () { return (parcelRequire("9s7cO")).ProviderRpcErrorCode; });
$parcel$export(module.exports, "chainIdValidation", function () { return (parcelRequire("2AQn5")).chainIdValidation; });
$parcel$export(module.exports, "chainNamespaceValidation", function () { return (parcelRequire("2AQn5")).chainNamespaceValidation; });
$parcel$export(module.exports, "chainValidation", function () { return (parcelRequire("2AQn5")).chainValidation; });
$parcel$export(module.exports, "validate", function () { return (parcelRequire("2AQn5")).validate; });

$parcel$export(module.exports, "ProviderRpcError", function () { return (parcelRequire("kJR1D")).ProviderRpcError; });
$parcel$export(module.exports, "createEIP1193Provider", function () { return (parcelRequire("dPPnm")).createEIP1193Provider; });
$parcel$export(module.exports, "InterVar", function () { return (parcelRequire("hUmk3")).InterVar; });
$parcel$export(module.exports, "weiHexToEth", function () { return (parcelRequire("3lyD3")).weiHexToEth; });
$parcel$export(module.exports, "weiToEth", function () { return (parcelRequire("3lyD3")).weiToEth; });
$parcel$export(module.exports, "isAddress", function () { return (parcelRequire("3lyD3")).isAddress; });
$parcel$export(module.exports, "bigIntToHex", function () { return (parcelRequire("3lyD3")).bigIntToHex; });
$parcel$export(module.exports, "ethToWeiBigInt", function () { return (parcelRequire("3lyD3")).ethToWeiBigInt; });
$parcel$export(module.exports, "chainIdToViemImport", function () { return (parcelRequire("3lyD3")).chainIdToViemImport; });
$parcel$export(module.exports, "isHex", function () { return (parcelRequire("8RKFj")).isHex; });
$parcel$export(module.exports, "toHex", function () { return (parcelRequire("kslqr")).toHex; });
$parcel$export(module.exports, "fromHex", function () { return (parcelRequire("6gMtw")).fromHex; });

var $kJR1D = parcelRequire("kJR1D");

var $dPPnm = parcelRequire("dPPnm");

var $hUmk3 = parcelRequire("hUmk3");

var $3lyD3 = parcelRequire("3lyD3");
parcelRequire("9s7cO");
parcelRequire("2AQn5");

var $6gMtw = parcelRequire("6gMtw");
var $8RKFj = parcelRequire("8RKFj");
var $kslqr = parcelRequire("kslqr");

});
parcelRegister("kJR1D", function(module, exports) {

$parcel$export(module.exports, "ProviderRpcError", function () { return $f191245837986f23$export$417589b978208a8f; });
class $f191245837986f23$export$417589b978208a8f extends Error {
    constructor(error){
        super(error.message);
        this.message = error.message;
        this.code = error.code;
        this.data = error.data;
    }
}

});

parcelRegister("dPPnm", function(module, exports) {

$parcel$export(module.exports, "createEIP1193Provider", function () { return $a127e3effd0eb14f$export$3179d0f9b8fae2a4; });

var $kJR1D = parcelRequire("kJR1D");
const $a127e3effd0eb14f$export$3179d0f9b8fae2a4 = (provider, requestPatch)=>{
    let baseRequest;
    if (provider.request) // Copy the original request method and bind the provider context to it
    baseRequest = provider.request.bind(provider);
    else if (provider.sendAsync) baseRequest = $a127e3effd0eb14f$var$createRequest(provider);
    const request = async ({ method: method, params: params })=>{
        const key = method;
        // If the request method is set to null
        // this indicates this method is not supported
        if (requestPatch && requestPatch[key] === null) throw new (0, $kJR1D.ProviderRpcError)({
            code: 4200,
            message: `The Provider does not support the requested method: ${method}`
        });
        if (requestPatch && requestPatch[key]) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore // @TODO - Fix this type error
        return requestPatch[key]({
            baseRequest: baseRequest,
            params: params
        });
        else if (baseRequest) return baseRequest({
            method: method,
            params: params
        });
        else throw new (0, $kJR1D.ProviderRpcError)({
            code: 4200,
            message: `The Provider does not support the requested method: ${method}`
        });
    };
    provider.request = request;
    return provider;
};
const $a127e3effd0eb14f$var$createRequest = (provider)=>({ method: method, params: params })=>new Promise((resolve, reject)=>{
            provider.sendAsync({
                id: 0,
                jsonrpc: "2.0",
                method: method,
                params: params
            }, (error, { result: result })=>{
                if (error) reject(JSON.parse(error));
                else resolve(result == undefined ? null : result);
            });
        });

});

parcelRegister("hUmk3", function(module, exports) {

$parcel$export(module.exports, "InterVar", function () { return $d098fb64953103e4$export$c6987e893c5dcce7; });
const $d098fb64953103e4$export$c6987e893c5dcce7 = `
@font-face {
  font-family: 'Inter';
  font-style:  normal;
  font-weight: 300 600;
  font-display: swap;
  src: url("https://rsms.me/inter/font-files/InterVariable.woff2") format("woff2-variations");
}
`;

});

parcelRegister("3lyD3", function(module, exports) {

$parcel$export(module.exports, "isAddress", function () { return $26fe31d93e0db8c8$export$977e255126d763d6; });
$parcel$export(module.exports, "weiHexToEth", function () { return $26fe31d93e0db8c8$export$6846f3b2c0d31273; });
$parcel$export(module.exports, "weiToEth", function () { return $26fe31d93e0db8c8$export$5c738bdb4a4e27c5; });
$parcel$export(module.exports, "ethToWeiBigInt", function () { return $26fe31d93e0db8c8$export$42317bc65128ed6f; });
$parcel$export(module.exports, "bigIntToHex", function () { return $26fe31d93e0db8c8$export$6b5b2c7ca7a3fdfa; });
$parcel$export(module.exports, "chainIdToViemImport", function () { return $26fe31d93e0db8c8$export$5b0e9e8c7ba03442; });

var $kTpAG = parcelRequire("kTpAG");
var $6gMtw = parcelRequire("6gMtw");
var $kslqr = parcelRequire("kslqr");
var $1KQzd = parcelRequire("1KQzd");
const $26fe31d93e0db8c8$export$977e255126d763d6 = (address)=>{
    return $26fe31d93e0db8c8$export$977e255126d763d6(address);
};
const $26fe31d93e0db8c8$export$6846f3b2c0d31273 = (wei)=>{
    const weiBigInt = (0, $6gMtw.hexToBigInt)(wei);
    return (0, $kTpAG.formatEther)(weiBigInt);
};
const $26fe31d93e0db8c8$export$5c738bdb4a4e27c5 = (wei)=>{
    if (!wei) return wei;
    const weiBigInt = (0, $6gMtw.fromHex)(wei, "bigint");
    return (0, $kTpAG.formatEther)(weiBigInt);
};
const $26fe31d93e0db8c8$export$42317bc65128ed6f = (eth)=>{
    if (typeof eth !== "string" && typeof eth !== "number") throw new Error("eth must be a string or number value");
    const ethString = typeof eth === "number" ? eth.toString() : eth;
    return (0, $1KQzd.parseEther)(ethString);
};
const $26fe31d93e0db8c8$export$6b5b2c7ca7a3fdfa = (value)=>{
    return (0, $kslqr.numberToHex)(value);
};
const $26fe31d93e0db8c8$export$efcedc5c94b00089 = (walletLabel, download)=>{
    if (!download) return `Please switch to ${walletLabel} to continue`;
    if (typeof download === "function") return `Please <a href="#" onclick="${()=>download()}">install</a> or enable to ${walletLabel} to continue`;
    else return `Please <a href="${download}" target="_blank">install</a> or enable to ${walletLabel} to continue`;
};


const $26fe31d93e0db8c8$export$5b0e9e8c7ba03442 = async (w3oChain)=>{
    const viemChains = await (parcelRequire("5Vqac"));
    const { id: id, label: label, token: token, publicRpcUrl: publicRpcUrl, blockExplorerUrl: blockExplorerUrl, rpcUrl: rpcUrl } = w3oChain;
    switch(id){
        case "0x89":
            {
                const { polygon: polygon } = viemChains;
                return polygon;
            }
        case "0xa":
            {
                const { optimism: optimism } = viemChains;
                return optimism;
            }
        case "0xa4b1":
            {
                const { arbitrum: arbitrum } = viemChains;
                return arbitrum;
            }
        case "0x144":
            {
                const { zkSync: zkSync } = viemChains;
                return zkSync;
            }
        case "0x38":
            {
                const { bsc: bsc } = viemChains;
                return bsc;
            }
        case "0x1":
            {
                const { mainnet: mainnet } = viemChains;
                return mainnet;
            }
        case "0xaa36a7":
            {
                const { sepolia: sepolia } = viemChains;
                return sepolia;
            }
        case "0xfa":
            {
                const { fantom: fantom } = viemChains;
                return fantom;
            }
        case "0xa86a":
            {
                const { avalanche: avalanche } = viemChains;
                return avalanche;
            }
        case "0xa4ec":
            {
                const { celo: celo } = viemChains;
                return celo;
            }
        case "0x2105":
            {
                const { base: base } = viemChains;
                return base;
            }
        case "0x14a33":
            {
                const { baseGoerli: baseGoerli } = viemChains;
                return baseGoerli;
            }
        case "0x64":
            {
                const { gnosis: gnosis } = viemChains;
                return gnosis;
            }
        case "0x63564C40":
            {
                const { harmonyOne: harmonyOne } = viemChains;
                return harmonyOne;
            }
        case "0x27bc86aa":
            {
                const { degen: degen } = viemChains;
                return degen;
            }
        default:
            {
                const { extractChain: extractChain, defineChain: defineChain } = await (parcelRequire("l1VSl"));
                const nonNativeChain = extractChain({
                    chains: Object.values(viemChains),
                    id: (0, $6gMtw.fromHex)(id, "number")
                });
                if (nonNativeChain) return nonNativeChain;
                return defineChain({
                    id: (0, $6gMtw.fromHex)(id, "number"),
                    name: label !== null && label !== void 0 ? label : "",
                    nativeCurrency: {
                        decimals: 18,
                        name: token !== null && token !== void 0 ? token : "",
                        symbol: token !== null && token !== void 0 ? token : ""
                    },
                    rpcUrls: {
                        default: {
                            http: [
                                rpcUrl !== null && rpcUrl !== void 0 ? rpcUrl : "",
                                publicRpcUrl !== null && publicRpcUrl !== void 0 ? publicRpcUrl : ""
                            ]
                        }
                    },
                    blockExplorers: {
                        default: {
                            name: "Explorer",
                            url: blockExplorerUrl !== null && blockExplorerUrl !== void 0 ? blockExplorerUrl : ""
                        }
                    }
                });
            }
    }
};

});
parcelRegister("kTpAG", function(module, exports) {

$parcel$export(module.exports, "formatEther", function () { return $f35ccb7c77823cd8$export$11bc63b4c03ea518; });

var $2TZ6B = parcelRequire("2TZ6B");

var $gxNNt = parcelRequire("gxNNt");
function $f35ccb7c77823cd8$export$11bc63b4c03ea518(wei, unit = "wei") {
    return (0, $gxNNt.formatUnits)(wei, (0, $2TZ6B.etherUnits)[unit]);
}

});
parcelRegister("2TZ6B", function(module, exports) {

$parcel$export(module.exports, "etherUnits", function () { return $21d01e202fc171ce$export$5bbd813111ed9646; });
$parcel$export(module.exports, "gweiUnits", function () { return $21d01e202fc171ce$export$a26120bf8be88528; });
const $21d01e202fc171ce$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $21d01e202fc171ce$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $21d01e202fc171ce$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});

parcelRegister("gxNNt", function(module, exports) {

$parcel$export(module.exports, "formatUnits", function () { return $c0b65b124abae776$export$bd39b96f71da1885; });
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $c0b65b124abae776$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith("-");
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, "0");
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, "");
    return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

});


parcelRegister("6gMtw", function(module, exports) {

$parcel$export(module.exports, "assertSize", function () { return $4909d6d626a4697d$export$2af489edb7fa35fe; });
$parcel$export(module.exports, "fromHex", function () { return $4909d6d626a4697d$export$1a8ceedbd5845648; });
$parcel$export(module.exports, "hexToNumber", function () { return $4909d6d626a4697d$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBigInt", function () { return $4909d6d626a4697d$export$92a44656ec81b584; });

var $3jiC4 = parcelRequire("3jiC4");

var $hWXkF = parcelRequire("hWXkF");

var $kL496 = parcelRequire("kL496");

var $5wMXX = parcelRequire("5wMXX");
function $4909d6d626a4697d$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $hWXkF.size)(hexOrBytes) > size) throw new (0, $3jiC4.SizeOverflowError)({
        givenSize: (0, $hWXkF.size)(hexOrBytes),
        maxSize: size
    });
}
function $4909d6d626a4697d$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $4909d6d626a4697d$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $4909d6d626a4697d$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $4909d6d626a4697d$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $4909d6d626a4697d$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $5wMXX.hexToBytes)(hex, opts);
}
function $4909d6d626a4697d$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $4909d6d626a4697d$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $4909d6d626a4697d$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $4909d6d626a4697d$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $kL496.trim)(hex);
    }
    if ((0, $kL496.trim)(hex) === "0x00") return false;
    if ((0, $kL496.trim)(hex) === "0x01") return true;
    throw new (0, $3jiC4.InvalidHexBooleanError)(hex);
}
function $4909d6d626a4697d$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($4909d6d626a4697d$export$92a44656ec81b584(hex, opts));
}
function $4909d6d626a4697d$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $5wMXX.hexToBytes)(hex);
    if (opts.size) {
        $4909d6d626a4697d$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $kL496.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("3jiC4", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", function () { return $2691959dbd96baef$export$47d164a8071229a9; });
$parcel$export(module.exports, "InvalidBytesBooleanError", function () { return $2691959dbd96baef$export$52fc62e5266c8838; });
$parcel$export(module.exports, "InvalidHexBooleanError", function () { return $2691959dbd96baef$export$f574ac54e35514c; });
$parcel$export(module.exports, "SizeOverflowError", function () { return $2691959dbd96baef$export$beb44ed4f8747d0e; });

var $dc01o = parcelRequire("dc01o");
class $2691959dbd96baef$export$47d164a8071229a9 extends (0, $dc01o.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntegerOutOfRangeError"
        });
    }
}
class $2691959dbd96baef$export$52fc62e5266c8838 extends (0, $dc01o.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidBytesBooleanError"
        });
    }
}
class $2691959dbd96baef$export$f574ac54e35514c extends (0, $dc01o.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidHexBooleanError"
        });
    }
}
class $2691959dbd96baef$export$ef05eafd11dd4a83 extends (0, $dc01o.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidHexValueError"
        });
    }
}
class $2691959dbd96baef$export$beb44ed4f8747d0e extends (0, $dc01o.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SizeOverflowError"
        });
    }
}

});
parcelRegister("dc01o", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $99ac699f15712e84$export$a490eb03cb7a0a5e; });

var $3zWKA = parcelRequire("3zWKA");
class $99ac699f15712e84$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        super();
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ViemError"
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $3zWKA.getVersion)()
        });
        const details = args.cause instanceof $99ac699f15712e84$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $99ac699f15712e84$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        this.message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://viem.sh${docsPath}${args.docsSlug ? `#${args.docsSlug}` : ""}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join("\n");
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $99ac699f15712e84$var$walk(this, fn);
    }
}
function $99ac699f15712e84$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err) return $99ac699f15712e84$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("3zWKA", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", function () { return $29b2369c44d83162$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getUrl", function () { return $29b2369c44d83162$export$94df0e59ebebf4a7; });
$parcel$export(module.exports, "getVersion", function () { return $29b2369c44d83162$export$c506eb22e615ba4a; });

var $hOIhj = parcelRequire("hOIhj");
const $29b2369c44d83162$export$b7fbffef12272e40 = (address)=>address;
const $29b2369c44d83162$export$94df0e59ebebf4a7 = (url)=>url;
const $29b2369c44d83162$export$c506eb22e615ba4a = ()=>`viem@${0, $hOIhj.version}`;

});
parcelRegister("hOIhj", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $cf8973e4a41fb027$export$83d89fbfd8236492; });
const $cf8973e4a41fb027$export$83d89fbfd8236492 = "2.12.0";

});




parcelRegister("hWXkF", function(module, exports) {

$parcel$export(module.exports, "size", function () { return $d115e09b107136f0$export$346677f925de839c; });

var $8RKFj = parcelRequire("8RKFj");
function $d115e09b107136f0$export$346677f925de839c(value) {
    if ((0, $8RKFj.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});
parcelRegister("8RKFj", function(module, exports) {

$parcel$export(module.exports, "isHex", function () { return $674778b9839ec81a$export$8a9b6341a7c96bc; });
function $674778b9839ec81a$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});


parcelRegister("kL496", function(module, exports) {

$parcel$export(module.exports, "trim", function () { return $f1cb69b887608cb5$export$87c2784dc9fc4ab; });
function $f1cb69b887608cb5$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});

parcelRegister("5wMXX", function(module, exports) {

$parcel$export(module.exports, "toBytes", function () { return $4065ec8999ebaade$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "hexToBytes", function () { return $4065ec8999ebaade$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "stringToBytes", function () { return $4065ec8999ebaade$export$c8dd6bc66a63753c; });

var $dc01o = parcelRequire("dc01o");

var $8RKFj = parcelRequire("8RKFj");

var $al9JM = parcelRequire("al9JM");

var $6gMtw = parcelRequire("6gMtw");

var $kslqr = parcelRequire("kslqr");
const $4065ec8999ebaade$var$encoder = /*#__PURE__*/ new TextEncoder();
function $4065ec8999ebaade$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $4065ec8999ebaade$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $4065ec8999ebaade$export$771517697a68241(value, opts);
    if ((0, $8RKFj.isHex)(value)) return $4065ec8999ebaade$export$31c96b9df38bc8d4(value, opts);
    return $4065ec8999ebaade$export$c8dd6bc66a63753c(value, opts);
}
function $4065ec8999ebaade$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $6gMtw.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $al9JM.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $4065ec8999ebaade$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $4065ec8999ebaade$var$charCodeToBase16(char) {
    if (char >= $4065ec8999ebaade$var$charCodeMap.zero && char <= $4065ec8999ebaade$var$charCodeMap.nine) return char - $4065ec8999ebaade$var$charCodeMap.zero;
    if (char >= $4065ec8999ebaade$var$charCodeMap.A && char <= $4065ec8999ebaade$var$charCodeMap.F) return char - ($4065ec8999ebaade$var$charCodeMap.A - 10);
    if (char >= $4065ec8999ebaade$var$charCodeMap.a && char <= $4065ec8999ebaade$var$charCodeMap.f) return char - ($4065ec8999ebaade$var$charCodeMap.a - 10);
    return undefined;
}
function $4065ec8999ebaade$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $6gMtw.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $al9JM.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $4065ec8999ebaade$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $4065ec8999ebaade$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $dc01o.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $4065ec8999ebaade$export$49ad9be85c347998(value, opts) {
    const hex = (0, $kslqr.numberToHex)(value, opts);
    return $4065ec8999ebaade$export$31c96b9df38bc8d4(hex);
}
function $4065ec8999ebaade$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $4065ec8999ebaade$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $6gMtw.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $al9JM.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("al9JM", function(module, exports) {

$parcel$export(module.exports, "pad", function () { return $78736b31444069db$export$5d04458e2a6c373e; });
$parcel$export(module.exports, "padHex", function () { return $78736b31444069db$export$1bcd51c0fce8ee55; });

var $20fbY = parcelRequire("20fbY");
function $78736b31444069db$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $78736b31444069db$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $78736b31444069db$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $78736b31444069db$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $20fbY.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $78736b31444069db$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $20fbY.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("20fbY", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", function () { return $17575db319191572$export$cfcd41bba8b36dbd; });
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", function () { return $17575db319191572$export$70445dc308a7f3d5; });
$parcel$export(module.exports, "InvalidBytesLengthError", function () { return $17575db319191572$export$8a5469becf223114; });

var $dc01o = parcelRequire("dc01o");
class $17575db319191572$export$cfcd41bba8b36dbd extends (0, $dc01o.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $17575db319191572$export$70445dc308a7f3d5 extends (0, $dc01o.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SizeExceedsPaddingSizeError"
        });
    }
}
class $17575db319191572$export$8a5469becf223114 extends (0, $dc01o.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidBytesLengthError"
        });
    }
}

});


parcelRegister("kslqr", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $ee470acf2d6593a4$export$7ea66e3774a60b67; });
$parcel$export(module.exports, "numberToHex", function () { return $ee470acf2d6593a4$export$4e87185b7ecfeec4; });
$parcel$export(module.exports, "stringToHex", function () { return $ee470acf2d6593a4$export$551c48dea6f88e6d; });
$parcel$export(module.exports, "boolToHex", function () { return $ee470acf2d6593a4$export$b5c95dec4f62ef7a; });
$parcel$export(module.exports, "bytesToHex", function () { return $ee470acf2d6593a4$export$58b867e287a802c8; });

var $3jiC4 = parcelRequire("3jiC4");

var $al9JM = parcelRequire("al9JM");

var $6gMtw = parcelRequire("6gMtw");
const $ee470acf2d6593a4$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $ee470acf2d6593a4$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $ee470acf2d6593a4$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $ee470acf2d6593a4$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $ee470acf2d6593a4$export$b5c95dec4f62ef7a(value, opts);
    return $ee470acf2d6593a4$export$58b867e287a802c8(value, opts);
}
function $ee470acf2d6593a4$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $6gMtw.assertSize)(hex, {
            size: opts.size
        });
        return (0, $al9JM.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $ee470acf2d6593a4$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $ee470acf2d6593a4$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $6gMtw.assertSize)(hex, {
            size: opts.size
        });
        return (0, $al9JM.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $ee470acf2d6593a4$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $3jiC4.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $al9JM.pad)(hex, {
        size: size
    });
    return hex;
}
const $ee470acf2d6593a4$var$encoder = /*#__PURE__*/ new TextEncoder();
function $ee470acf2d6593a4$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $ee470acf2d6593a4$var$encoder.encode(value_);
    return $ee470acf2d6593a4$export$58b867e287a802c8(value, opts);
}

});



parcelRegister("1KQzd", function(module, exports) {

$parcel$export(module.exports, "parseEther", function () { return $1472dd04f35253ea$export$642c4e67bbdc0bc7; });

var $2TZ6B = parcelRequire("2TZ6B");

var $dXS6I = parcelRequire("dXS6I");
function $1472dd04f35253ea$export$642c4e67bbdc0bc7(ether, unit = "wei") {
    return (0, $dXS6I.parseUnits)(ether, (0, $2TZ6B.etherUnits)[unit]);
}

});
parcelRegister("dXS6I", function(module, exports) {

$parcel$export(module.exports, "parseUnits", function () { return $a2aac1a474e5d679$export$203ae30b4f6490b3; });
/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */ function $a2aac1a474e5d679$export$203ae30b4f6490b3(value, decimals) {
    let [integer, fraction = "0"] = value.split(".");
    const negative = integer.startsWith("-");
    if (negative) integer = integer.slice(1);
    // trim leading zeros.
    fraction = fraction.replace(/(0+)$/, "");
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1) integer = `${BigInt(integer) + 1n}`;
        fraction = "";
    } else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9) fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, "0");
        else fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, "0");
    return BigInt(`${negative ? "-" : ""}${integer}${fraction}`);
}

});


parcelRegister("5Vqac", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = Promise.all([
    $2QMl3("fwmgL"),
    $2QMl3("aVpug")
]).then(()=>parcelRequire("3KJk7"));

});
parcelRegister("2QMl3", function(module, exports) {
"use strict";

function $2135ef291c37d858$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("jbWbx")).resolve(id));
}
module.exports = $2135ef291c37d858$var$load;

});


parcelRegister("l1VSl", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = Promise.all([
    $2QMl3("fwmgL"),
    $2QMl3("loioW")
]).then(()=>parcelRequire("3XP4Y"));

});


parcelRegister("9s7cO", function(module, exports) {

$parcel$export(module.exports, "ProviderRpcErrorCode", function () { return $6e1c517d7381a5e2$export$a9b3d16f1898eb51; });
var $6e1c517d7381a5e2$export$a9b3d16f1898eb51;
(function(ProviderRpcErrorCode) {
    ProviderRpcErrorCode[ProviderRpcErrorCode["ACCOUNT_ACCESS_REJECTED"] = 4001] = "ACCOUNT_ACCESS_REJECTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["ACCOUNT_ACCESS_ALREADY_REQUESTED"] = -32002] = "ACCOUNT_ACCESS_ALREADY_REQUESTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["UNAUTHORIZED"] = 4100] = "UNAUTHORIZED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
    ProviderRpcErrorCode[ProviderRpcErrorCode["UNSUPPORTED_METHOD"] = 4200] = "UNSUPPORTED_METHOD";
    ProviderRpcErrorCode[ProviderRpcErrorCode["DISCONNECTED"] = 4900] = "DISCONNECTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["CHAIN_DISCONNECTED"] = 4901] = "CHAIN_DISCONNECTED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["CHAIN_NOT_ADDED"] = 4902] = "CHAIN_NOT_ADDED";
    ProviderRpcErrorCode[ProviderRpcErrorCode["DOES_NOT_EXIST"] = -32601] = "DOES_NOT_EXIST";
    ProviderRpcErrorCode[ProviderRpcErrorCode["UNRECOGNIZED_CHAIN_ID"] = -32603] = "UNRECOGNIZED_CHAIN_ID";
})($6e1c517d7381a5e2$export$a9b3d16f1898eb51 || ($6e1c517d7381a5e2$export$a9b3d16f1898eb51 = {}));

});

parcelRegister("2AQn5", function(module, exports) {

$parcel$export(module.exports, "validate", function () { return $1e379166db456fbd$export$a22775fa5e2eebd9; });
$parcel$export(module.exports, "chainIdValidation", function () { return $1e379166db456fbd$export$82499834ac435e76; });
$parcel$export(module.exports, "chainNamespaceValidation", function () { return $1e379166db456fbd$export$339f369556873e03; });
$parcel$export(module.exports, "chainValidation", function () { return $1e379166db456fbd$export$392a124a91f4a641; });

var $6zFHJ = parcelRequire("6zFHJ");
function $1e379166db456fbd$export$a22775fa5e2eebd9(validator, data) {
    const result = validator.validate(data);
    return result.error ? result : null;
}
const $1e379166db456fbd$export$82499834ac435e76 = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).alternatives().try((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().pattern(/^0x[0-9a-fA-F]+$/), (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number().positive());
const $1e379166db456fbd$export$339f369556873e03 = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().valid("evm");
const $1e379166db456fbd$var$secondaryTokenValidation = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    address: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().optional()
});
const $1e379166db456fbd$export$392a124a91f4a641 = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    namespace: $1e379166db456fbd$export$339f369556873e03,
    id: $1e379166db456fbd$export$82499834ac435e76.required(),
    rpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    token: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    secondaryTokens: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().max(5).items($1e379166db456fbd$var$secondaryTokenValidation).optional(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    color: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    publicRpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    protectedRpcUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    blockExplorerUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
});

});


parcelRegister("cW7tz", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var partition = createAggregator(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = partition;

});

parcelRegister("eSAm6", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("aTZNU", function(module, exports) {
"use strict";
var $7efefb7052f73604$var$has = Object.prototype.hasOwnProperty, $7efefb7052f73604$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $7efefb7052f73604$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $7efefb7052f73604$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $7efefb7052f73604$var$Events().__proto__) $7efefb7052f73604$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $7efefb7052f73604$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $7efefb7052f73604$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $7efefb7052f73604$var$EE(fn, context || emitter, once), evt = $7efefb7052f73604$var$prefix ? $7efefb7052f73604$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $7efefb7052f73604$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $7efefb7052f73604$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $7efefb7052f73604$var$EventEmitter() {
    this._events = new $7efefb7052f73604$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $7efefb7052f73604$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($7efefb7052f73604$var$has.call(events, name)) names.push($7efefb7052f73604$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $7efefb7052f73604$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $7efefb7052f73604$var$prefix ? $7efefb7052f73604$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $7efefb7052f73604$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $7efefb7052f73604$var$prefix ? $7efefb7052f73604$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $7efefb7052f73604$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $7efefb7052f73604$var$prefix ? $7efefb7052f73604$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7efefb7052f73604$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $7efefb7052f73604$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7efefb7052f73604$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $7efefb7052f73604$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7efefb7052f73604$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $7efefb7052f73604$var$prefix ? $7efefb7052f73604$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $7efefb7052f73604$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $7efefb7052f73604$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $7efefb7052f73604$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7efefb7052f73604$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $7efefb7052f73604$var$prefix ? $7efefb7052f73604$var$prefix + event : event;
        if (this._events[evt]) $7efefb7052f73604$var$clearEvent(this, evt);
    } else {
        this._events = new $7efefb7052f73604$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$7efefb7052f73604$var$EventEmitter.prototype.off = $7efefb7052f73604$var$EventEmitter.prototype.removeListener;
$7efefb7052f73604$var$EventEmitter.prototype.addListener = $7efefb7052f73604$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$7efefb7052f73604$var$EventEmitter.prefixed = $7efefb7052f73604$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$7efefb7052f73604$var$EventEmitter.EventEmitter = $7efefb7052f73604$var$EventEmitter;
module.exports = $7efefb7052f73604$var$EventEmitter;

});

parcelRegister("kMSZN", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = Promise.all([
    $2QMl3("iFofN"),
    $2QMl3("eGoHK")
]).then(()=>parcelRequire("c1VIW"));

});

parcelRegister("aWRt8", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = Promise.all([
    $2QMl3("iFofN"),
    $2QMl3("jPmS5")
]).then(()=>parcelRequire("9W8Qb"));

});

parcelRegister("1M6JJ", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("6SB0y").then(()=>parcelRequire("cTzQC"));

});

parcelRegister("asBZJ", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("7KXsq").then(()=>parcelRequire("jHH1I"));

});

parcelRegister("dFJ70", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("fjkgt").then(()=>parcelRequire("eRVpD"));

});


parcelRegister("9aYCB", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("1zqH5").then(()=>parcelRequire("3RFav"));

});

parcelRegister("dfRJP", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = Promise.all([
    $2QMl3("bVTxz"),
    $2QMl3("7P9Z3")
]).then(()=>parcelRequire("gz6KT"));

});

parcelRegister("iiaIZ", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("y9shn").then(()=>parcelRequire("hv6Rq"));

});

parcelRegister("jiq0t", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = Promise.all([
    $2QMl3("bVTxz"),
    $2QMl3("aSj3W")
]).then(()=>parcelRequire("3oNEX"));

});

parcelRegister("4Nvi2", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("2FMGw").then(()=>parcelRequire("51bf8"));

});

parcelRegister("3YH4m", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("40rnA").then(()=>parcelRequire("jrXUv"));

});

parcelRegister("4UYwZ", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array ? array.length : 0;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    if (value !== value) return baseFindIndex(array, baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = uniqBy;

});

parcelRegister("9rNDL", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("aoSfI").then(()=>parcelRequire("jmvUl"));

});

parcelRegister("fpzET", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("8fo6w").then(()=>parcelRequire("cuotu"));

});

parcelRegister("aghlg", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("8qFsJ").then(()=>parcelRequire("47YRo"));

});

parcelRegister("bUHRZ", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("jTpgB").then(()=>parcelRequire("32krC"));

});

parcelRegister("382sz", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("8Xmfy").then(()=>parcelRequire("ah7pQ"));

});

parcelRegister("2SeTD", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("5gPun").then(()=>parcelRequire("gJMPZ"));

});

parcelRegister("bC8O1", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("4ddZN").then(()=>parcelRequire("j8dXZ"));

});

parcelRegister("lROFz", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("kihit").then(()=>parcelRequire("1UFXP"));

});

parcelRegister("Zbc2l", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("3ODwf").then(()=>parcelRequire("bMz55"));

});

parcelRegister("h9wEU", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("jAneu").then(()=>parcelRequire("cHPV3"));

});

parcelRegister("kS500", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("dgOvg").then(()=>parcelRequire("hTJKN"));

});

parcelRegister("3m7GZ", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("40FbK").then(()=>parcelRequire("71Wxi"));

});

parcelRegister("k8azg", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("a8VjC").then(()=>parcelRequire("9ovxc"));

});

parcelRegister("6gWi8", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("gtSHS").then(()=>parcelRequire("i91LP"));

});

parcelRegister("4hjyb", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("kXfNT").then(()=>parcelRequire("1IBNP"));

});

parcelRegister("dn0Kz", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("fWr4G").then(()=>parcelRequire("C29Tj"));

});

parcelRegister("FsEYj", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("uhJ5Z").then(()=>parcelRequire("i1DOF"));

});

parcelRegister("6ggk8", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("iyBh5").then(()=>parcelRequire("4zqwG"));

});

parcelRegister("lUvnX", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("9Dduj").then(()=>parcelRequire("axCa2"));

});

parcelRegister("ani4a", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("7nfZZ").then(()=>parcelRequire("ffvdr"));

});

parcelRegister("kXakg", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("jDMPo").then(()=>parcelRequire("178jO"));

});

parcelRegister("9cWLJ", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("8kO3j").then(()=>parcelRequire("6zUGk"));

});

parcelRegister("fPGQo", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("bwDhZ").then(()=>parcelRequire("cOcVI"));

});

parcelRegister("anmCq", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("ieIGg").then(()=>parcelRequire("anKt2"));

});

parcelRegister("uXKG0", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("hdd1R").then(()=>parcelRequire("NYARO"));

});

parcelRegister("4bHd0", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("acYSy").then(()=>parcelRequire("en4eI"));

});

parcelRegister("ceFHG", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("axO8Q").then(()=>parcelRequire("cpcpM"));

});

parcelRegister("1Gq9L", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("cxdzZ").then(()=>parcelRequire("f60g6"));

});

parcelRegister("iZjMn", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("iLd5l").then(()=>parcelRequire("hDcyZ"));

});

parcelRegister("cESaT", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("jizco").then(()=>parcelRequire("k4xgQ"));

});

parcelRegister("9vh4y", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("eL1pk").then(()=>parcelRequire("iCwhc"));

});

parcelRegister("cSdrw", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("koVOJ").then(()=>parcelRequire("1deaO"));

});

parcelRegister("evLcH", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("6ZWZX").then(()=>parcelRequire("9Qwlm"));

});

parcelRegister("7sKfd", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("8KGIe").then(()=>parcelRequire("hpqu3"));

});

parcelRegister("9l4JA", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("8MvJW").then(()=>parcelRequire("gZsKj"));

});

parcelRegister("eh7kV", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("dLNf4").then(()=>parcelRequire("500TQ"));

});

parcelRegister("5qAzX", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("2JcsW").then(()=>parcelRequire("fQQT8"));

});

parcelRegister("cPLUs", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("f5kGJ").then(()=>parcelRequire("8YCiC"));

});

parcelRegister("c4U9X", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("8IcdP").then(()=>parcelRequire("j842C"));

});

parcelRegister("c5Y2O", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("5KHHU").then(()=>parcelRequire("82wNt"));

});

parcelRegister("anmOI", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("819E0").then(()=>parcelRequire("0qY8S"));

});

parcelRegister("kQtcU", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("25zQ5").then(()=>parcelRequire("1KXTC"));

});

parcelRegister("4JfQk", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("4JZX7").then(()=>parcelRequire("78izb"));

});

parcelRegister("8hRVi", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("6k3aJ").then(()=>parcelRequire("kh1nu"));

});

parcelRegister("dnDoS", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("4qV53").then(()=>parcelRequire("lI85G"));

});

parcelRegister("cVlkT", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("YC3Ay").then(()=>parcelRequire("aDgmR"));

});

parcelRegister("2GHCb", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("kQ669").then(()=>parcelRequire("imTAG"));

});

parcelRegister("36ZvM", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("acHXu").then(()=>parcelRequire("eSNIm"));

});

parcelRegister("k4jZJ", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("5xvnP").then(()=>parcelRequire("lQjO9"));

});

parcelRegister("hOQ1z", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("11Vw3").then(()=>parcelRequire("7ii0O"));

});

parcelRegister("2OiZZ", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("eEP6W").then(()=>parcelRequire("5Gy4K"));

});

parcelRegister("aUOI1", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("aQAiZ").then(()=>parcelRequire("g3oeh"));

});

parcelRegister("7vnmh", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("4b2eC").then(()=>parcelRequire("dK8k5"));

});

parcelRegister("7sSeF", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("kOIJ9").then(()=>parcelRequire("6r1aY"));

});

parcelRegister("7Fafs", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("eY47Y").then(()=>parcelRequire("eyaxU"));

});

parcelRegister("aGM03", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("hJo54").then(()=>parcelRequire("gElQ7"));

});

parcelRegister("dj57A", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("bNoN0").then(()=>parcelRequire("aVviX"));

});

parcelRegister("hAfA1", function(module, exports) {

var $2QMl3 = parcelRequire("2QMl3");
module.exports = $2QMl3("5t7cu").then(()=>parcelRequire("fqRXl"));

});

// packages/alpinejs/src/scheduler.js
var $2667dc9b0d1347a4$var$flushPending = false;
var $2667dc9b0d1347a4$var$flushing = false;
var $2667dc9b0d1347a4$var$queue = [];
var $2667dc9b0d1347a4$var$lastFlushedIndex = -1;
function $2667dc9b0d1347a4$var$scheduler(callback) {
    $2667dc9b0d1347a4$var$queueJob(callback);
}
function $2667dc9b0d1347a4$var$queueJob(job) {
    if (!$2667dc9b0d1347a4$var$queue.includes(job)) $2667dc9b0d1347a4$var$queue.push(job);
    $2667dc9b0d1347a4$var$queueFlush();
}
function $2667dc9b0d1347a4$var$dequeueJob(job) {
    let index = $2667dc9b0d1347a4$var$queue.indexOf(job);
    if (index !== -1 && index > $2667dc9b0d1347a4$var$lastFlushedIndex) $2667dc9b0d1347a4$var$queue.splice(index, 1);
}
function $2667dc9b0d1347a4$var$queueFlush() {
    if (!$2667dc9b0d1347a4$var$flushing && !$2667dc9b0d1347a4$var$flushPending) {
        $2667dc9b0d1347a4$var$flushPending = true;
        queueMicrotask($2667dc9b0d1347a4$var$flushJobs);
    }
}
function $2667dc9b0d1347a4$var$flushJobs() {
    $2667dc9b0d1347a4$var$flushPending = false;
    $2667dc9b0d1347a4$var$flushing = true;
    for(let i = 0; i < $2667dc9b0d1347a4$var$queue.length; i++){
        $2667dc9b0d1347a4$var$queue[i]();
        $2667dc9b0d1347a4$var$lastFlushedIndex = i;
    }
    $2667dc9b0d1347a4$var$queue.length = 0;
    $2667dc9b0d1347a4$var$lastFlushedIndex = -1;
    $2667dc9b0d1347a4$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $2667dc9b0d1347a4$var$reactive;
var $2667dc9b0d1347a4$var$effect;
var $2667dc9b0d1347a4$var$release;
var $2667dc9b0d1347a4$var$raw;
var $2667dc9b0d1347a4$var$shouldSchedule = true;
function $2667dc9b0d1347a4$var$disableEffectScheduling(callback) {
    $2667dc9b0d1347a4$var$shouldSchedule = false;
    callback();
    $2667dc9b0d1347a4$var$shouldSchedule = true;
}
function $2667dc9b0d1347a4$var$setReactivityEngine(engine) {
    $2667dc9b0d1347a4$var$reactive = engine.reactive;
    $2667dc9b0d1347a4$var$release = engine.release;
    $2667dc9b0d1347a4$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($2667dc9b0d1347a4$var$shouldSchedule) $2667dc9b0d1347a4$var$scheduler(task);
                else task();
            }
        });
    $2667dc9b0d1347a4$var$raw = engine.raw;
}
function $2667dc9b0d1347a4$var$overrideEffect(override) {
    $2667dc9b0d1347a4$var$effect = override;
}
function $2667dc9b0d1347a4$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $2667dc9b0d1347a4$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $2667dc9b0d1347a4$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $2667dc9b0d1347a4$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $2667dc9b0d1347a4$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$2667dc9b0d1347a4$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $2667dc9b0d1347a4$var$onAttributeAddeds = [];
var $2667dc9b0d1347a4$var$onElRemoveds = [];
var $2667dc9b0d1347a4$var$onElAddeds = [];
function $2667dc9b0d1347a4$var$onElAdded(callback) {
    $2667dc9b0d1347a4$var$onElAddeds.push(callback);
}
function $2667dc9b0d1347a4$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $2667dc9b0d1347a4$var$onElRemoveds.push(callback);
    }
}
function $2667dc9b0d1347a4$var$onAttributesAdded(callback) {
    $2667dc9b0d1347a4$var$onAttributeAddeds.push(callback);
}
function $2667dc9b0d1347a4$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $2667dc9b0d1347a4$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $2667dc9b0d1347a4$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $2667dc9b0d1347a4$var$observer = new MutationObserver($2667dc9b0d1347a4$var$onMutate);
var $2667dc9b0d1347a4$var$currentlyObserving = false;
function $2667dc9b0d1347a4$var$startObservingMutations() {
    $2667dc9b0d1347a4$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $2667dc9b0d1347a4$var$currentlyObserving = true;
}
function $2667dc9b0d1347a4$var$stopObservingMutations() {
    $2667dc9b0d1347a4$var$flushObserver();
    $2667dc9b0d1347a4$var$observer.disconnect();
    $2667dc9b0d1347a4$var$currentlyObserving = false;
}
var $2667dc9b0d1347a4$var$queuedMutations = [];
function $2667dc9b0d1347a4$var$flushObserver() {
    let records = $2667dc9b0d1347a4$var$observer.takeRecords();
    $2667dc9b0d1347a4$var$queuedMutations.push(()=>records.length > 0 && $2667dc9b0d1347a4$var$onMutate(records));
    let queueLengthWhenTriggered = $2667dc9b0d1347a4$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($2667dc9b0d1347a4$var$queuedMutations.length === queueLengthWhenTriggered) while($2667dc9b0d1347a4$var$queuedMutations.length > 0)$2667dc9b0d1347a4$var$queuedMutations.shift()();
    });
}
function $2667dc9b0d1347a4$var$mutateDom(callback) {
    if (!$2667dc9b0d1347a4$var$currentlyObserving) return callback();
    $2667dc9b0d1347a4$var$stopObservingMutations();
    let result = callback();
    $2667dc9b0d1347a4$var$startObservingMutations();
    return result;
}
var $2667dc9b0d1347a4$var$isCollecting = false;
var $2667dc9b0d1347a4$var$deferredMutations = [];
function $2667dc9b0d1347a4$var$deferMutations() {
    $2667dc9b0d1347a4$var$isCollecting = true;
}
function $2667dc9b0d1347a4$var$flushAndStopDeferringMutations() {
    $2667dc9b0d1347a4$var$isCollecting = false;
    $2667dc9b0d1347a4$var$onMutate($2667dc9b0d1347a4$var$deferredMutations);
    $2667dc9b0d1347a4$var$deferredMutations = [];
}
function $2667dc9b0d1347a4$var$onMutate(mutations) {
    if ($2667dc9b0d1347a4$var$isCollecting) {
        $2667dc9b0d1347a4$var$deferredMutations = $2667dc9b0d1347a4$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $2667dc9b0d1347a4$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $2667dc9b0d1347a4$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $2667dc9b0d1347a4$var$onElRemoveds.forEach((i)=>i(node));
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $2667dc9b0d1347a4$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $2667dc9b0d1347a4$var$scope(node) {
    return $2667dc9b0d1347a4$var$mergeProxies($2667dc9b0d1347a4$var$closestDataStack(node));
}
function $2667dc9b0d1347a4$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$2667dc9b0d1347a4$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $2667dc9b0d1347a4$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $2667dc9b0d1347a4$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $2667dc9b0d1347a4$var$closestDataStack(node.parentNode);
}
function $2667dc9b0d1347a4$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $2667dc9b0d1347a4$var$mergeProxyTrap);
}
var $2667dc9b0d1347a4$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $2667dc9b0d1347a4$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $2667dc9b0d1347a4$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $2667dc9b0d1347a4$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $2667dc9b0d1347a4$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$2667dc9b0d1347a4$var$get(data2, path), (value)=>$2667dc9b0d1347a4$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $2667dc9b0d1347a4$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $2667dc9b0d1347a4$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $2667dc9b0d1347a4$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $2667dc9b0d1347a4$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $2667dc9b0d1347a4$var$magics = {};
function $2667dc9b0d1347a4$var$magic(name, callback) {
    $2667dc9b0d1347a4$var$magics[name] = callback;
}
function $2667dc9b0d1347a4$var$injectMagics(obj, el) {
    Object.entries($2667dc9b0d1347a4$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $2667dc9b0d1347a4$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $2667dc9b0d1347a4$var$interceptor,
                    ...utilities
                };
                $2667dc9b0d1347a4$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $2667dc9b0d1347a4$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $2667dc9b0d1347a4$var$handleError(e, el, expression);
    }
}
function $2667dc9b0d1347a4$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $2667dc9b0d1347a4$var$shouldAutoEvaluateFunctions = true;
function $2667dc9b0d1347a4$var$dontAutoEvaluateFunctions(callback) {
    let cache = $2667dc9b0d1347a4$var$shouldAutoEvaluateFunctions;
    $2667dc9b0d1347a4$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $2667dc9b0d1347a4$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $2667dc9b0d1347a4$var$evaluate(el, expression, extras = {}) {
    let result;
    $2667dc9b0d1347a4$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $2667dc9b0d1347a4$var$evaluateLater(...args) {
    return $2667dc9b0d1347a4$var$theEvaluatorFunction(...args);
}
var $2667dc9b0d1347a4$var$theEvaluatorFunction = $2667dc9b0d1347a4$var$normalEvaluator;
function $2667dc9b0d1347a4$var$setEvaluator(newEvaluator) {
    $2667dc9b0d1347a4$var$theEvaluatorFunction = newEvaluator;
}
function $2667dc9b0d1347a4$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $2667dc9b0d1347a4$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$2667dc9b0d1347a4$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $2667dc9b0d1347a4$var$generateEvaluatorFromFunction(dataStack, expression) : $2667dc9b0d1347a4$var$generateEvaluatorFromString(dataStack, expression, el);
    return $2667dc9b0d1347a4$var$tryCatch.bind(null, el, expression, evaluator);
}
function $2667dc9b0d1347a4$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($2667dc9b0d1347a4$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $2667dc9b0d1347a4$var$runIfTypeOfFunction(receiver, result);
    };
}
var $2667dc9b0d1347a4$var$evaluatorMemo = {};
function $2667dc9b0d1347a4$var$generateFunctionFromString(expression, el) {
    if ($2667dc9b0d1347a4$var$evaluatorMemo[expression]) return $2667dc9b0d1347a4$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $2667dc9b0d1347a4$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $2667dc9b0d1347a4$var$evaluatorMemo[expression] = func;
    return func;
}
function $2667dc9b0d1347a4$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $2667dc9b0d1347a4$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $2667dc9b0d1347a4$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$2667dc9b0d1347a4$var$handleError(error2, el, expression));
            if (func.finished) {
                $2667dc9b0d1347a4$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $2667dc9b0d1347a4$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$2667dc9b0d1347a4$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $2667dc9b0d1347a4$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($2667dc9b0d1347a4$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$2667dc9b0d1347a4$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$2667dc9b0d1347a4$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $2667dc9b0d1347a4$var$prefixAsString = "x-";
function $2667dc9b0d1347a4$var$prefix(subject = "") {
    return $2667dc9b0d1347a4$var$prefixAsString + subject;
}
function $2667dc9b0d1347a4$var$setPrefix(newPrefix) {
    $2667dc9b0d1347a4$var$prefixAsString = newPrefix;
}
var $2667dc9b0d1347a4$var$directiveHandlers = {};
function $2667dc9b0d1347a4$var$directive(name, callback) {
    $2667dc9b0d1347a4$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$2667dc9b0d1347a4$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $2667dc9b0d1347a4$var$directiveOrder.indexOf(directive2);
            $2667dc9b0d1347a4$var$directiveOrder.splice(pos >= 0 ? pos : $2667dc9b0d1347a4$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $2667dc9b0d1347a4$var$directiveExists(name) {
    return Object.keys($2667dc9b0d1347a4$var$directiveHandlers).includes(name);
}
function $2667dc9b0d1347a4$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $2667dc9b0d1347a4$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($2667dc9b0d1347a4$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($2667dc9b0d1347a4$var$outNonAlpineAttributes).map($2667dc9b0d1347a4$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($2667dc9b0d1347a4$var$byPriority);
    return directives2.map((directive2)=>{
        return $2667dc9b0d1347a4$var$getDirectiveHandler(el, directive2);
    });
}
function $2667dc9b0d1347a4$var$attributesOnly(attributes) {
    return Array.from(attributes).map($2667dc9b0d1347a4$var$toTransformedAttributes()).filter((attr)=>!$2667dc9b0d1347a4$var$outNonAlpineAttributes(attr));
}
var $2667dc9b0d1347a4$var$isDeferringHandlers = false;
var $2667dc9b0d1347a4$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $2667dc9b0d1347a4$var$currentHandlerStackKey = Symbol();
function $2667dc9b0d1347a4$var$deferHandlingDirectives(callback) {
    $2667dc9b0d1347a4$var$isDeferringHandlers = true;
    let key = Symbol();
    $2667dc9b0d1347a4$var$currentHandlerStackKey = key;
    $2667dc9b0d1347a4$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($2667dc9b0d1347a4$var$directiveHandlerStacks.get(key).length)$2667dc9b0d1347a4$var$directiveHandlerStacks.get(key).shift()();
        $2667dc9b0d1347a4$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $2667dc9b0d1347a4$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $2667dc9b0d1347a4$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $2667dc9b0d1347a4$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $2667dc9b0d1347a4$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $2667dc9b0d1347a4$var$evaluateLater.bind($2667dc9b0d1347a4$var$evaluateLater, el),
        evaluate: $2667dc9b0d1347a4$var$evaluate.bind($2667dc9b0d1347a4$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $2667dc9b0d1347a4$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $2667dc9b0d1347a4$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $2667dc9b0d1347a4$var$getElementBoundUtilities(el);
    $2667dc9b0d1347a4$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $2667dc9b0d1347a4$var$isDeferringHandlers ? $2667dc9b0d1347a4$var$directiveHandlerStacks.get($2667dc9b0d1347a4$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $2667dc9b0d1347a4$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $2667dc9b0d1347a4$var$into = (i)=>i;
function $2667dc9b0d1347a4$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $2667dc9b0d1347a4$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $2667dc9b0d1347a4$var$attributeTransformers = [];
function $2667dc9b0d1347a4$var$mapAttributes(callback) {
    $2667dc9b0d1347a4$var$attributeTransformers.push(callback);
}
function $2667dc9b0d1347a4$var$outNonAlpineAttributes({ name: name }) {
    return $2667dc9b0d1347a4$var$alpineAttributeRegex().test(name);
}
var $2667dc9b0d1347a4$var$alpineAttributeRegex = ()=>new RegExp(`^${$2667dc9b0d1347a4$var$prefixAsString}([^:^.]+)\\b`);
function $2667dc9b0d1347a4$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($2667dc9b0d1347a4$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $2667dc9b0d1347a4$var$DEFAULT = "DEFAULT";
var $2667dc9b0d1347a4$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $2667dc9b0d1347a4$var$DEFAULT,
    "teleport"
];
function $2667dc9b0d1347a4$var$byPriority(a, b) {
    let typeA = $2667dc9b0d1347a4$var$directiveOrder.indexOf(a.type) === -1 ? $2667dc9b0d1347a4$var$DEFAULT : a.type;
    let typeB = $2667dc9b0d1347a4$var$directiveOrder.indexOf(b.type) === -1 ? $2667dc9b0d1347a4$var$DEFAULT : b.type;
    return $2667dc9b0d1347a4$var$directiveOrder.indexOf(typeA) - $2667dc9b0d1347a4$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $2667dc9b0d1347a4$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $2667dc9b0d1347a4$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$2667dc9b0d1347a4$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $2667dc9b0d1347a4$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $2667dc9b0d1347a4$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $2667dc9b0d1347a4$var$started = false;
function $2667dc9b0d1347a4$var$start() {
    if ($2667dc9b0d1347a4$var$started) $2667dc9b0d1347a4$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $2667dc9b0d1347a4$var$started = true;
    if (!document.body) $2667dc9b0d1347a4$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $2667dc9b0d1347a4$var$dispatch(document, "alpine:init");
    $2667dc9b0d1347a4$var$dispatch(document, "alpine:initializing");
    $2667dc9b0d1347a4$var$startObservingMutations();
    $2667dc9b0d1347a4$var$onElAdded((el)=>$2667dc9b0d1347a4$var$initTree(el, $2667dc9b0d1347a4$var$walk));
    $2667dc9b0d1347a4$var$onElRemoved((el)=>$2667dc9b0d1347a4$var$destroyTree(el));
    $2667dc9b0d1347a4$var$onAttributesAdded((el, attrs)=>{
        $2667dc9b0d1347a4$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$2667dc9b0d1347a4$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($2667dc9b0d1347a4$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $2667dc9b0d1347a4$var$initTree(el);
    });
    $2667dc9b0d1347a4$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $2667dc9b0d1347a4$var$warnAboutMissingPlugins();
    });
}
var $2667dc9b0d1347a4$var$rootSelectorCallbacks = [];
var $2667dc9b0d1347a4$var$initSelectorCallbacks = [];
function $2667dc9b0d1347a4$var$rootSelectors() {
    return $2667dc9b0d1347a4$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $2667dc9b0d1347a4$var$allSelectors() {
    return $2667dc9b0d1347a4$var$rootSelectorCallbacks.concat($2667dc9b0d1347a4$var$initSelectorCallbacks).map((fn)=>fn());
}
function $2667dc9b0d1347a4$var$addRootSelector(selectorCallback) {
    $2667dc9b0d1347a4$var$rootSelectorCallbacks.push(selectorCallback);
}
function $2667dc9b0d1347a4$var$addInitSelector(selectorCallback) {
    $2667dc9b0d1347a4$var$initSelectorCallbacks.push(selectorCallback);
}
function $2667dc9b0d1347a4$var$closestRoot(el, includeInitSelectors = false) {
    return $2667dc9b0d1347a4$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $2667dc9b0d1347a4$var$allSelectors() : $2667dc9b0d1347a4$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $2667dc9b0d1347a4$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $2667dc9b0d1347a4$var$findClosest(el.parentElement, callback);
}
function $2667dc9b0d1347a4$var$isRoot(el) {
    return $2667dc9b0d1347a4$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $2667dc9b0d1347a4$var$initInterceptors2 = [];
function $2667dc9b0d1347a4$var$interceptInit(callback) {
    $2667dc9b0d1347a4$var$initInterceptors2.push(callback);
}
function $2667dc9b0d1347a4$var$initTree(el, walker = $2667dc9b0d1347a4$var$walk, intercept = ()=>{}) {
    $2667dc9b0d1347a4$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $2667dc9b0d1347a4$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $2667dc9b0d1347a4$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $2667dc9b0d1347a4$var$destroyTree(root, walker = $2667dc9b0d1347a4$var$walk) {
    walker(root, (el)=>{
        $2667dc9b0d1347a4$var$cleanupAttributes(el);
        $2667dc9b0d1347a4$var$cleanupElement(el);
    });
}
function $2667dc9b0d1347a4$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($2667dc9b0d1347a4$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $2667dc9b0d1347a4$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $2667dc9b0d1347a4$var$tickStack = [];
var $2667dc9b0d1347a4$var$isHolding = false;
function $2667dc9b0d1347a4$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $2667dc9b0d1347a4$var$isHolding || setTimeout(()=>{
            $2667dc9b0d1347a4$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $2667dc9b0d1347a4$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $2667dc9b0d1347a4$var$releaseNextTicks() {
    $2667dc9b0d1347a4$var$isHolding = false;
    while($2667dc9b0d1347a4$var$tickStack.length)$2667dc9b0d1347a4$var$tickStack.shift()();
}
function $2667dc9b0d1347a4$var$holdNextTicks() {
    $2667dc9b0d1347a4$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $2667dc9b0d1347a4$var$setClasses(el, value) {
    if (Array.isArray(value)) return $2667dc9b0d1347a4$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $2667dc9b0d1347a4$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $2667dc9b0d1347a4$var$setClasses(el, value());
    return $2667dc9b0d1347a4$var$setClassesFromString(el, value);
}
function $2667dc9b0d1347a4$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $2667dc9b0d1347a4$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $2667dc9b0d1347a4$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $2667dc9b0d1347a4$var$setStylesFromObject(el, value);
    return $2667dc9b0d1347a4$var$setStylesFromString(el, value);
}
function $2667dc9b0d1347a4$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $2667dc9b0d1347a4$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $2667dc9b0d1347a4$var$setStyles(el, previousStyles);
    };
}
function $2667dc9b0d1347a4$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $2667dc9b0d1347a4$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $2667dc9b0d1347a4$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$2667dc9b0d1347a4$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $2667dc9b0d1347a4$var$registerTransitionsFromHelper(el, modifiers, value);
    else $2667dc9b0d1347a4$var$registerTransitionsFromClassString(el, expression, value);
});
function $2667dc9b0d1347a4$var$registerTransitionsFromClassString(el, classString, stage) {
    $2667dc9b0d1347a4$var$registerTransitionObject(el, $2667dc9b0d1347a4$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $2667dc9b0d1347a4$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $2667dc9b0d1347a4$var$registerTransitionObject(el, $2667dc9b0d1347a4$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $2667dc9b0d1347a4$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $2667dc9b0d1347a4$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $2667dc9b0d1347a4$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $2667dc9b0d1347a4$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $2667dc9b0d1347a4$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $2667dc9b0d1347a4$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $2667dc9b0d1347a4$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $2667dc9b0d1347a4$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $2667dc9b0d1347a4$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $2667dc9b0d1347a4$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $2667dc9b0d1347a4$var$closestHide(parent);
}
function $2667dc9b0d1347a4$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $2667dc9b0d1347a4$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $2667dc9b0d1347a4$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $2667dc9b0d1347a4$var$once(()=>{
        $2667dc9b0d1347a4$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $2667dc9b0d1347a4$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $2667dc9b0d1347a4$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $2667dc9b0d1347a4$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $2667dc9b0d1347a4$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $2667dc9b0d1347a4$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $2667dc9b0d1347a4$var$mutateDom(()=>{
                stages.end();
            });
            $2667dc9b0d1347a4$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $2667dc9b0d1347a4$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $2667dc9b0d1347a4$var$isCloning = false;
function $2667dc9b0d1347a4$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$2667dc9b0d1347a4$var$isCloning ? fallback(...args) : callback(...args);
}
function $2667dc9b0d1347a4$var$onlyDuringClone(callback) {
    return (...args)=>$2667dc9b0d1347a4$var$isCloning && callback(...args);
}
var $2667dc9b0d1347a4$var$interceptors = [];
function $2667dc9b0d1347a4$var$interceptClone(callback) {
    $2667dc9b0d1347a4$var$interceptors.push(callback);
}
function $2667dc9b0d1347a4$var$cloneNode(from, to) {
    $2667dc9b0d1347a4$var$interceptors.forEach((i)=>i(from, to));
    $2667dc9b0d1347a4$var$isCloning = true;
    $2667dc9b0d1347a4$var$dontRegisterReactiveSideEffects(()=>{
        $2667dc9b0d1347a4$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $2667dc9b0d1347a4$var$isCloning = false;
}
var $2667dc9b0d1347a4$var$isCloningLegacy = false;
function $2667dc9b0d1347a4$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $2667dc9b0d1347a4$var$isCloning = true;
    $2667dc9b0d1347a4$var$isCloningLegacy = true;
    $2667dc9b0d1347a4$var$dontRegisterReactiveSideEffects(()=>{
        $2667dc9b0d1347a4$var$cloneTree(newEl);
    });
    $2667dc9b0d1347a4$var$isCloning = false;
    $2667dc9b0d1347a4$var$isCloningLegacy = false;
}
function $2667dc9b0d1347a4$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $2667dc9b0d1347a4$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $2667dc9b0d1347a4$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $2667dc9b0d1347a4$var$initTree(el, shallowWalker);
}
function $2667dc9b0d1347a4$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $2667dc9b0d1347a4$var$effect;
    $2667dc9b0d1347a4$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $2667dc9b0d1347a4$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $2667dc9b0d1347a4$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $2667dc9b0d1347a4$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $2667dc9b0d1347a4$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $2667dc9b0d1347a4$var$camelCase(name) : name;
    switch(name){
        case "value":
            $2667dc9b0d1347a4$var$bindInputValue(el, value);
            break;
        case "style":
            $2667dc9b0d1347a4$var$bindStyles(el, value);
            break;
        case "class":
            $2667dc9b0d1347a4$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $2667dc9b0d1347a4$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $2667dc9b0d1347a4$var$bindAttribute(el, name, value);
            break;
    }
}
function $2667dc9b0d1347a4$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $2667dc9b0d1347a4$var$safeParseBoolean(el.value) === value;
            else el.checked = $2667dc9b0d1347a4$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$2667dc9b0d1347a4$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $2667dc9b0d1347a4$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $2667dc9b0d1347a4$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $2667dc9b0d1347a4$var$setClasses(el, value);
}
function $2667dc9b0d1347a4$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $2667dc9b0d1347a4$var$setStyles(el, value);
}
function $2667dc9b0d1347a4$var$bindAttributeAndProperty(el, name, value) {
    $2667dc9b0d1347a4$var$bindAttribute(el, name, value);
    $2667dc9b0d1347a4$var$setPropertyIfChanged(el, name, value);
}
function $2667dc9b0d1347a4$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $2667dc9b0d1347a4$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($2667dc9b0d1347a4$var$isBooleanAttr(name)) value = name;
        $2667dc9b0d1347a4$var$setIfChanged(el, name, value);
    }
}
function $2667dc9b0d1347a4$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $2667dc9b0d1347a4$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $2667dc9b0d1347a4$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $2667dc9b0d1347a4$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $2667dc9b0d1347a4$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $2667dc9b0d1347a4$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $2667dc9b0d1347a4$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $2667dc9b0d1347a4$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $2667dc9b0d1347a4$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $2667dc9b0d1347a4$var$getAttributeBinding(el, name, fallback);
}
function $2667dc9b0d1347a4$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $2667dc9b0d1347a4$var$dontAutoEvaluateFunctions(()=>{
            return $2667dc9b0d1347a4$var$evaluate(el, binding.expression);
        });
    }
    return $2667dc9b0d1347a4$var$getAttributeBinding(el, name, fallback);
}
function $2667dc9b0d1347a4$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($2667dc9b0d1347a4$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $2667dc9b0d1347a4$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $2667dc9b0d1347a4$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $2667dc9b0d1347a4$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $2667dc9b0d1347a4$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($2667dc9b0d1347a4$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($2667dc9b0d1347a4$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($2667dc9b0d1347a4$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $2667dc9b0d1347a4$var$release(reference);
    };
}
function $2667dc9b0d1347a4$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $2667dc9b0d1347a4$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($2667dc9b0d1347a4$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $2667dc9b0d1347a4$var$stores = {};
var $2667dc9b0d1347a4$var$isReactive = false;
function $2667dc9b0d1347a4$var$store(name, value) {
    if (!$2667dc9b0d1347a4$var$isReactive) {
        $2667dc9b0d1347a4$var$stores = $2667dc9b0d1347a4$var$reactive($2667dc9b0d1347a4$var$stores);
        $2667dc9b0d1347a4$var$isReactive = true;
    }
    if (value === void 0) return $2667dc9b0d1347a4$var$stores[name];
    $2667dc9b0d1347a4$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $2667dc9b0d1347a4$var$stores[name].init();
    $2667dc9b0d1347a4$var$initInterceptors($2667dc9b0d1347a4$var$stores[name]);
}
function $2667dc9b0d1347a4$var$getStores() {
    return $2667dc9b0d1347a4$var$stores;
}
// packages/alpinejs/src/binds.js
var $2667dc9b0d1347a4$var$binds = {};
function $2667dc9b0d1347a4$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $2667dc9b0d1347a4$var$applyBindingsObject(name, getBindings());
    else $2667dc9b0d1347a4$var$binds[name] = getBindings;
    return ()=>{};
}
function $2667dc9b0d1347a4$var$injectBindingProviders(obj) {
    Object.entries($2667dc9b0d1347a4$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $2667dc9b0d1347a4$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $2667dc9b0d1347a4$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $2667dc9b0d1347a4$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $2667dc9b0d1347a4$var$datas = {};
function $2667dc9b0d1347a4$var$data(name, callback) {
    $2667dc9b0d1347a4$var$datas[name] = callback;
}
function $2667dc9b0d1347a4$var$injectDataProviders(obj, context) {
    Object.entries($2667dc9b0d1347a4$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $2667dc9b0d1347a4$var$Alpine = {
    get reactive () {
        return $2667dc9b0d1347a4$var$reactive;
    },
    get release () {
        return $2667dc9b0d1347a4$var$release;
    },
    get effect () {
        return $2667dc9b0d1347a4$var$effect;
    },
    get raw () {
        return $2667dc9b0d1347a4$var$raw;
    },
    version: "3.14.1",
    flushAndStopDeferringMutations: $2667dc9b0d1347a4$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $2667dc9b0d1347a4$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $2667dc9b0d1347a4$var$disableEffectScheduling,
    startObservingMutations: $2667dc9b0d1347a4$var$startObservingMutations,
    stopObservingMutations: $2667dc9b0d1347a4$var$stopObservingMutations,
    setReactivityEngine: $2667dc9b0d1347a4$var$setReactivityEngine,
    onAttributeRemoved: $2667dc9b0d1347a4$var$onAttributeRemoved,
    onAttributesAdded: $2667dc9b0d1347a4$var$onAttributesAdded,
    closestDataStack: $2667dc9b0d1347a4$var$closestDataStack,
    skipDuringClone: $2667dc9b0d1347a4$var$skipDuringClone,
    onlyDuringClone: $2667dc9b0d1347a4$var$onlyDuringClone,
    addRootSelector: $2667dc9b0d1347a4$var$addRootSelector,
    addInitSelector: $2667dc9b0d1347a4$var$addInitSelector,
    interceptClone: $2667dc9b0d1347a4$var$interceptClone,
    addScopeToNode: $2667dc9b0d1347a4$var$addScopeToNode,
    deferMutations: $2667dc9b0d1347a4$var$deferMutations,
    mapAttributes: $2667dc9b0d1347a4$var$mapAttributes,
    evaluateLater: $2667dc9b0d1347a4$var$evaluateLater,
    interceptInit: $2667dc9b0d1347a4$var$interceptInit,
    setEvaluator: $2667dc9b0d1347a4$var$setEvaluator,
    mergeProxies: $2667dc9b0d1347a4$var$mergeProxies,
    extractProp: $2667dc9b0d1347a4$var$extractProp,
    findClosest: $2667dc9b0d1347a4$var$findClosest,
    onElRemoved: $2667dc9b0d1347a4$var$onElRemoved,
    closestRoot: $2667dc9b0d1347a4$var$closestRoot,
    destroyTree: $2667dc9b0d1347a4$var$destroyTree,
    interceptor: $2667dc9b0d1347a4$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $2667dc9b0d1347a4$var$transition,
    setStyles: // INTERNAL
    $2667dc9b0d1347a4$var$setStyles,
    mutateDom: // INTERNAL
    $2667dc9b0d1347a4$var$mutateDom,
    directive: $2667dc9b0d1347a4$var$directive,
    entangle: $2667dc9b0d1347a4$var$entangle,
    throttle: $2667dc9b0d1347a4$var$throttle,
    debounce: $2667dc9b0d1347a4$var$debounce,
    evaluate: $2667dc9b0d1347a4$var$evaluate,
    initTree: $2667dc9b0d1347a4$var$initTree,
    nextTick: $2667dc9b0d1347a4$var$nextTick,
    prefixed: $2667dc9b0d1347a4$var$prefix,
    prefix: $2667dc9b0d1347a4$var$setPrefix,
    plugin: $2667dc9b0d1347a4$var$plugin,
    magic: $2667dc9b0d1347a4$var$magic,
    store: $2667dc9b0d1347a4$var$store,
    start: $2667dc9b0d1347a4$var$start,
    clone: $2667dc9b0d1347a4$var$clone,
    cloneNode: // INTERNAL
    $2667dc9b0d1347a4$var$cloneNode,
    // INTERNAL
    bound: $2667dc9b0d1347a4$var$getBinding,
    $data: $2667dc9b0d1347a4$var$scope,
    watch: $2667dc9b0d1347a4$var$watch,
    walk: $2667dc9b0d1347a4$var$walk,
    data: $2667dc9b0d1347a4$var$data,
    bind: $2667dc9b0d1347a4$var$bind2
};
var $2667dc9b0d1347a4$var$alpine_default = $2667dc9b0d1347a4$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $2667dc9b0d1347a4$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $2667dc9b0d1347a4$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $2667dc9b0d1347a4$var$isBooleanAttr2 = /* @__PURE__ */ $2667dc9b0d1347a4$var$makeMap($2667dc9b0d1347a4$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $2667dc9b0d1347a4$var$EMPTY_OBJ = Object.freeze({});
var $2667dc9b0d1347a4$var$EMPTY_ARR = Object.freeze([]);
var $2667dc9b0d1347a4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $2667dc9b0d1347a4$var$hasOwn = (val, key)=>$2667dc9b0d1347a4$var$hasOwnProperty.call(val, key);
var $2667dc9b0d1347a4$var$isArray = Array.isArray;
var $2667dc9b0d1347a4$var$isMap = (val)=>$2667dc9b0d1347a4$var$toTypeString(val) === "[object Map]";
var $2667dc9b0d1347a4$var$isString = (val)=>typeof val === "string";
var $2667dc9b0d1347a4$var$isSymbol = (val)=>typeof val === "symbol";
var $2667dc9b0d1347a4$var$isObject = (val)=>val !== null && typeof val === "object";
var $2667dc9b0d1347a4$var$objectToString = Object.prototype.toString;
var $2667dc9b0d1347a4$var$toTypeString = (value)=>$2667dc9b0d1347a4$var$objectToString.call(value);
var $2667dc9b0d1347a4$var$toRawType = (value)=>{
    return $2667dc9b0d1347a4$var$toTypeString(value).slice(8, -1);
};
var $2667dc9b0d1347a4$var$isIntegerKey = (key)=>$2667dc9b0d1347a4$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $2667dc9b0d1347a4$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $2667dc9b0d1347a4$var$camelizeRE = /-(\w)/g;
var $2667dc9b0d1347a4$var$camelize = $2667dc9b0d1347a4$var$cacheStringFunction((str)=>{
    return str.replace($2667dc9b0d1347a4$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $2667dc9b0d1347a4$var$hyphenateRE = /\B([A-Z])/g;
var $2667dc9b0d1347a4$var$hyphenate = $2667dc9b0d1347a4$var$cacheStringFunction((str)=>str.replace($2667dc9b0d1347a4$var$hyphenateRE, "-$1").toLowerCase());
var $2667dc9b0d1347a4$var$capitalize = $2667dc9b0d1347a4$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $2667dc9b0d1347a4$var$toHandlerKey = $2667dc9b0d1347a4$var$cacheStringFunction((str)=>str ? `on${$2667dc9b0d1347a4$var$capitalize(str)}` : ``);
var $2667dc9b0d1347a4$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $2667dc9b0d1347a4$var$targetMap = /* @__PURE__ */ new WeakMap();
var $2667dc9b0d1347a4$var$effectStack = [];
var $2667dc9b0d1347a4$var$activeEffect;
var $2667dc9b0d1347a4$var$ITERATE_KEY = Symbol("iterate");
var $2667dc9b0d1347a4$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $2667dc9b0d1347a4$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $2667dc9b0d1347a4$var$effect2(fn, options = $2667dc9b0d1347a4$var$EMPTY_OBJ) {
    if ($2667dc9b0d1347a4$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $2667dc9b0d1347a4$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $2667dc9b0d1347a4$var$stop(effect3) {
    if (effect3.active) {
        $2667dc9b0d1347a4$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $2667dc9b0d1347a4$var$uid = 0;
function $2667dc9b0d1347a4$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$2667dc9b0d1347a4$var$effectStack.includes(effect3)) {
            $2667dc9b0d1347a4$var$cleanup(effect3);
            try {
                $2667dc9b0d1347a4$var$enableTracking();
                $2667dc9b0d1347a4$var$effectStack.push(effect3);
                $2667dc9b0d1347a4$var$activeEffect = effect3;
                return fn();
            } finally{
                $2667dc9b0d1347a4$var$effectStack.pop();
                $2667dc9b0d1347a4$var$resetTracking();
                $2667dc9b0d1347a4$var$activeEffect = $2667dc9b0d1347a4$var$effectStack[$2667dc9b0d1347a4$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $2667dc9b0d1347a4$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $2667dc9b0d1347a4$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $2667dc9b0d1347a4$var$shouldTrack = true;
var $2667dc9b0d1347a4$var$trackStack = [];
function $2667dc9b0d1347a4$var$pauseTracking() {
    $2667dc9b0d1347a4$var$trackStack.push($2667dc9b0d1347a4$var$shouldTrack);
    $2667dc9b0d1347a4$var$shouldTrack = false;
}
function $2667dc9b0d1347a4$var$enableTracking() {
    $2667dc9b0d1347a4$var$trackStack.push($2667dc9b0d1347a4$var$shouldTrack);
    $2667dc9b0d1347a4$var$shouldTrack = true;
}
function $2667dc9b0d1347a4$var$resetTracking() {
    const last = $2667dc9b0d1347a4$var$trackStack.pop();
    $2667dc9b0d1347a4$var$shouldTrack = last === void 0 ? true : last;
}
function $2667dc9b0d1347a4$var$track(target, type, key) {
    if (!$2667dc9b0d1347a4$var$shouldTrack || $2667dc9b0d1347a4$var$activeEffect === void 0) return;
    let depsMap = $2667dc9b0d1347a4$var$targetMap.get(target);
    if (!depsMap) $2667dc9b0d1347a4$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($2667dc9b0d1347a4$var$activeEffect)) {
        dep.add($2667dc9b0d1347a4$var$activeEffect);
        $2667dc9b0d1347a4$var$activeEffect.deps.push(dep);
        if ($2667dc9b0d1347a4$var$activeEffect.options.onTrack) $2667dc9b0d1347a4$var$activeEffect.options.onTrack({
            effect: $2667dc9b0d1347a4$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $2667dc9b0d1347a4$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $2667dc9b0d1347a4$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $2667dc9b0d1347a4$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $2667dc9b0d1347a4$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$2667dc9b0d1347a4$var$isArray(target)) {
                    add2(depsMap.get($2667dc9b0d1347a4$var$ITERATE_KEY));
                    if ($2667dc9b0d1347a4$var$isMap(target)) add2(depsMap.get($2667dc9b0d1347a4$var$MAP_KEY_ITERATE_KEY));
                } else if ($2667dc9b0d1347a4$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$2667dc9b0d1347a4$var$isArray(target)) {
                    add2(depsMap.get($2667dc9b0d1347a4$var$ITERATE_KEY));
                    if ($2667dc9b0d1347a4$var$isMap(target)) add2(depsMap.get($2667dc9b0d1347a4$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($2667dc9b0d1347a4$var$isMap(target)) add2(depsMap.get($2667dc9b0d1347a4$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $2667dc9b0d1347a4$var$isNonTrackableKeys = /* @__PURE__ */ $2667dc9b0d1347a4$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $2667dc9b0d1347a4$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($2667dc9b0d1347a4$var$isSymbol));
var $2667dc9b0d1347a4$var$get2 = /* @__PURE__ */ $2667dc9b0d1347a4$var$createGetter();
var $2667dc9b0d1347a4$var$readonlyGet = /* @__PURE__ */ $2667dc9b0d1347a4$var$createGetter(true);
var $2667dc9b0d1347a4$var$arrayInstrumentations = /* @__PURE__ */ $2667dc9b0d1347a4$var$createArrayInstrumentations();
function $2667dc9b0d1347a4$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $2667dc9b0d1347a4$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$2667dc9b0d1347a4$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($2667dc9b0d1347a4$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $2667dc9b0d1347a4$var$pauseTracking();
            const res = $2667dc9b0d1347a4$var$toRaw(this)[key].apply(this, args);
            $2667dc9b0d1347a4$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $2667dc9b0d1347a4$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $2667dc9b0d1347a4$var$shallowReadonlyMap : $2667dc9b0d1347a4$var$readonlyMap : shallow ? $2667dc9b0d1347a4$var$shallowReactiveMap : $2667dc9b0d1347a4$var$reactiveMap).get(target)) return target;
        const targetIsArray = $2667dc9b0d1347a4$var$isArray(target);
        if (!isReadonly && targetIsArray && $2667dc9b0d1347a4$var$hasOwn($2667dc9b0d1347a4$var$arrayInstrumentations, key)) return Reflect.get($2667dc9b0d1347a4$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($2667dc9b0d1347a4$var$isSymbol(key) ? $2667dc9b0d1347a4$var$builtInSymbols.has(key) : $2667dc9b0d1347a4$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $2667dc9b0d1347a4$var$track(target, "get", key);
        if (shallow) return res;
        if ($2667dc9b0d1347a4$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$2667dc9b0d1347a4$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($2667dc9b0d1347a4$var$isObject(res)) return isReadonly ? $2667dc9b0d1347a4$var$readonly(res) : $2667dc9b0d1347a4$var$reactive2(res);
        return res;
    };
}
var $2667dc9b0d1347a4$var$set2 = /* @__PURE__ */ $2667dc9b0d1347a4$var$createSetter();
function $2667dc9b0d1347a4$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $2667dc9b0d1347a4$var$toRaw(value);
            oldValue = $2667dc9b0d1347a4$var$toRaw(oldValue);
            if (!$2667dc9b0d1347a4$var$isArray(target) && $2667dc9b0d1347a4$var$isRef(oldValue) && !$2667dc9b0d1347a4$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $2667dc9b0d1347a4$var$isArray(target) && $2667dc9b0d1347a4$var$isIntegerKey(key) ? Number(key) < target.length : $2667dc9b0d1347a4$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $2667dc9b0d1347a4$var$toRaw(receiver)) {
            if (!hadKey) $2667dc9b0d1347a4$var$trigger(target, "add", key, value);
            else if ($2667dc9b0d1347a4$var$hasChanged(value, oldValue)) $2667dc9b0d1347a4$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $2667dc9b0d1347a4$var$deleteProperty(target, key) {
    const hadKey = $2667dc9b0d1347a4$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $2667dc9b0d1347a4$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $2667dc9b0d1347a4$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$2667dc9b0d1347a4$var$isSymbol(key) || !$2667dc9b0d1347a4$var$builtInSymbols.has(key)) $2667dc9b0d1347a4$var$track(target, "has", key);
    return result;
}
function $2667dc9b0d1347a4$var$ownKeys(target) {
    $2667dc9b0d1347a4$var$track(target, "iterate", $2667dc9b0d1347a4$var$isArray(target) ? "length" : $2667dc9b0d1347a4$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $2667dc9b0d1347a4$var$mutableHandlers = {
    get: $2667dc9b0d1347a4$var$get2,
    set: $2667dc9b0d1347a4$var$set2,
    deleteProperty: $2667dc9b0d1347a4$var$deleteProperty,
    has: $2667dc9b0d1347a4$var$has,
    ownKeys: $2667dc9b0d1347a4$var$ownKeys
};
var $2667dc9b0d1347a4$var$readonlyHandlers = {
    get: $2667dc9b0d1347a4$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $2667dc9b0d1347a4$var$toReactive = (value)=>$2667dc9b0d1347a4$var$isObject(value) ? $2667dc9b0d1347a4$var$reactive2(value) : value;
var $2667dc9b0d1347a4$var$toReadonly = (value)=>$2667dc9b0d1347a4$var$isObject(value) ? $2667dc9b0d1347a4$var$readonly(value) : value;
var $2667dc9b0d1347a4$var$toShallow = (value)=>value;
var $2667dc9b0d1347a4$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $2667dc9b0d1347a4$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $2667dc9b0d1347a4$var$toRaw(target);
    const rawKey = $2667dc9b0d1347a4$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $2667dc9b0d1347a4$var$track(rawTarget, "get", key);
    !isReadonly && $2667dc9b0d1347a4$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $2667dc9b0d1347a4$var$getProto(rawTarget);
    const wrap = isShallow ? $2667dc9b0d1347a4$var$toShallow : isReadonly ? $2667dc9b0d1347a4$var$toReadonly : $2667dc9b0d1347a4$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $2667dc9b0d1347a4$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $2667dc9b0d1347a4$var$toRaw(target);
    const rawKey = $2667dc9b0d1347a4$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $2667dc9b0d1347a4$var$track(rawTarget, "has", key);
    !isReadonly && $2667dc9b0d1347a4$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $2667dc9b0d1347a4$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $2667dc9b0d1347a4$var$track($2667dc9b0d1347a4$var$toRaw(target), "iterate", $2667dc9b0d1347a4$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $2667dc9b0d1347a4$var$add(value) {
    value = $2667dc9b0d1347a4$var$toRaw(value);
    const target = $2667dc9b0d1347a4$var$toRaw(this);
    const proto = $2667dc9b0d1347a4$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $2667dc9b0d1347a4$var$trigger(target, "add", value, value);
    }
    return this;
}
function $2667dc9b0d1347a4$var$set$1(key, value) {
    value = $2667dc9b0d1347a4$var$toRaw(value);
    const target = $2667dc9b0d1347a4$var$toRaw(this);
    const { has: has2, get: get3 } = $2667dc9b0d1347a4$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $2667dc9b0d1347a4$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $2667dc9b0d1347a4$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $2667dc9b0d1347a4$var$trigger(target, "add", key, value);
    else if ($2667dc9b0d1347a4$var$hasChanged(value, oldValue)) $2667dc9b0d1347a4$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $2667dc9b0d1347a4$var$deleteEntry(key) {
    const target = $2667dc9b0d1347a4$var$toRaw(this);
    const { has: has2, get: get3 } = $2667dc9b0d1347a4$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $2667dc9b0d1347a4$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $2667dc9b0d1347a4$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $2667dc9b0d1347a4$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $2667dc9b0d1347a4$var$clear() {
    const target = $2667dc9b0d1347a4$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $2667dc9b0d1347a4$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $2667dc9b0d1347a4$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $2667dc9b0d1347a4$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $2667dc9b0d1347a4$var$toRaw(target);
        const wrap = isShallow ? $2667dc9b0d1347a4$var$toShallow : isReadonly ? $2667dc9b0d1347a4$var$toReadonly : $2667dc9b0d1347a4$var$toReactive;
        !isReadonly && $2667dc9b0d1347a4$var$track(rawTarget, "iterate", $2667dc9b0d1347a4$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $2667dc9b0d1347a4$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $2667dc9b0d1347a4$var$toRaw(target);
        const targetIsMap = $2667dc9b0d1347a4$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $2667dc9b0d1347a4$var$toShallow : isReadonly ? $2667dc9b0d1347a4$var$toReadonly : $2667dc9b0d1347a4$var$toReactive;
        !isReadonly && $2667dc9b0d1347a4$var$track(rawTarget, "iterate", isKeyOnly ? $2667dc9b0d1347a4$var$MAP_KEY_ITERATE_KEY : $2667dc9b0d1347a4$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $2667dc9b0d1347a4$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$2667dc9b0d1347a4$var$capitalize(type)} operation ${key}failed: target is readonly.`, $2667dc9b0d1347a4$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $2667dc9b0d1347a4$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $2667dc9b0d1347a4$var$get$1(this, key);
        },
        get size () {
            return $2667dc9b0d1347a4$var$size(this);
        },
        has: $2667dc9b0d1347a4$var$has$1,
        add: $2667dc9b0d1347a4$var$add,
        set: $2667dc9b0d1347a4$var$set$1,
        delete: $2667dc9b0d1347a4$var$deleteEntry,
        clear: $2667dc9b0d1347a4$var$clear,
        forEach: $2667dc9b0d1347a4$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $2667dc9b0d1347a4$var$get$1(this, key, false, true);
        },
        get size () {
            return $2667dc9b0d1347a4$var$size(this);
        },
        has: $2667dc9b0d1347a4$var$has$1,
        add: $2667dc9b0d1347a4$var$add,
        set: $2667dc9b0d1347a4$var$set$1,
        delete: $2667dc9b0d1347a4$var$deleteEntry,
        clear: $2667dc9b0d1347a4$var$clear,
        forEach: $2667dc9b0d1347a4$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $2667dc9b0d1347a4$var$get$1(this, key, true);
        },
        get size () {
            return $2667dc9b0d1347a4$var$size(this, true);
        },
        has (key) {
            return $2667dc9b0d1347a4$var$has$1.call(this, key, true);
        },
        add: $2667dc9b0d1347a4$var$createReadonlyMethod("add"),
        set: $2667dc9b0d1347a4$var$createReadonlyMethod("set"),
        delete: $2667dc9b0d1347a4$var$createReadonlyMethod("delete"),
        clear: $2667dc9b0d1347a4$var$createReadonlyMethod("clear"),
        forEach: $2667dc9b0d1347a4$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $2667dc9b0d1347a4$var$get$1(this, key, true, true);
        },
        get size () {
            return $2667dc9b0d1347a4$var$size(this, true);
        },
        has (key) {
            return $2667dc9b0d1347a4$var$has$1.call(this, key, true);
        },
        add: $2667dc9b0d1347a4$var$createReadonlyMethod("add"),
        set: $2667dc9b0d1347a4$var$createReadonlyMethod("set"),
        delete: $2667dc9b0d1347a4$var$createReadonlyMethod("delete"),
        clear: $2667dc9b0d1347a4$var$createReadonlyMethod("clear"),
        forEach: $2667dc9b0d1347a4$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $2667dc9b0d1347a4$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $2667dc9b0d1347a4$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $2667dc9b0d1347a4$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $2667dc9b0d1347a4$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$2667dc9b0d1347a4$var$mutableInstrumentations, $2667dc9b0d1347a4$var$readonlyInstrumentations, $2667dc9b0d1347a4$var$shallowInstrumentations, $2667dc9b0d1347a4$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $2667dc9b0d1347a4$var$createInstrumentations();
function $2667dc9b0d1347a4$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $2667dc9b0d1347a4$var$shallowReadonlyInstrumentations : $2667dc9b0d1347a4$var$shallowInstrumentations : isReadonly ? $2667dc9b0d1347a4$var$readonlyInstrumentations : $2667dc9b0d1347a4$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($2667dc9b0d1347a4$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $2667dc9b0d1347a4$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $2667dc9b0d1347a4$var$createInstrumentationGetter(false, false)
};
var $2667dc9b0d1347a4$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $2667dc9b0d1347a4$var$createInstrumentationGetter(true, false)
};
function $2667dc9b0d1347a4$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $2667dc9b0d1347a4$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $2667dc9b0d1347a4$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $2667dc9b0d1347a4$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $2667dc9b0d1347a4$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $2667dc9b0d1347a4$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $2667dc9b0d1347a4$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $2667dc9b0d1347a4$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $2667dc9b0d1347a4$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $2667dc9b0d1347a4$var$targetTypeMap($2667dc9b0d1347a4$var$toRawType(value));
}
function $2667dc9b0d1347a4$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $2667dc9b0d1347a4$var$createReactiveObject(target, false, $2667dc9b0d1347a4$var$mutableHandlers, $2667dc9b0d1347a4$var$mutableCollectionHandlers, $2667dc9b0d1347a4$var$reactiveMap);
}
function $2667dc9b0d1347a4$var$readonly(target) {
    return $2667dc9b0d1347a4$var$createReactiveObject(target, true, $2667dc9b0d1347a4$var$readonlyHandlers, $2667dc9b0d1347a4$var$readonlyCollectionHandlers, $2667dc9b0d1347a4$var$readonlyMap);
}
function $2667dc9b0d1347a4$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$2667dc9b0d1347a4$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $2667dc9b0d1347a4$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $2667dc9b0d1347a4$var$toRaw(observed) {
    return observed && $2667dc9b0d1347a4$var$toRaw(observed["__v_raw"]) || observed;
}
function $2667dc9b0d1347a4$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$2667dc9b0d1347a4$var$magic("nextTick", ()=>$2667dc9b0d1347a4$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$2667dc9b0d1347a4$var$magic("dispatch", (el)=>$2667dc9b0d1347a4$var$dispatch.bind($2667dc9b0d1347a4$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$2667dc9b0d1347a4$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $2667dc9b0d1347a4$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$2667dc9b0d1347a4$var$magic("store", $2667dc9b0d1347a4$var$getStores);
// packages/alpinejs/src/magics/$data.js
$2667dc9b0d1347a4$var$magic("data", (el)=>$2667dc9b0d1347a4$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$2667dc9b0d1347a4$var$magic("root", (el)=>$2667dc9b0d1347a4$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$2667dc9b0d1347a4$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $2667dc9b0d1347a4$var$mergeProxies($2667dc9b0d1347a4$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $2667dc9b0d1347a4$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $2667dc9b0d1347a4$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $2667dc9b0d1347a4$var$globalIdMemo = {};
function $2667dc9b0d1347a4$var$findAndIncrementId(name) {
    if (!$2667dc9b0d1347a4$var$globalIdMemo[name]) $2667dc9b0d1347a4$var$globalIdMemo[name] = 0;
    return ++$2667dc9b0d1347a4$var$globalIdMemo[name];
}
function $2667dc9b0d1347a4$var$closestIdRoot(el, name) {
    return $2667dc9b0d1347a4$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $2667dc9b0d1347a4$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $2667dc9b0d1347a4$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$2667dc9b0d1347a4$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $2667dc9b0d1347a4$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $2667dc9b0d1347a4$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $2667dc9b0d1347a4$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$2667dc9b0d1347a4$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $2667dc9b0d1347a4$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$2667dc9b0d1347a4$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$2667dc9b0d1347a4$var$warnMissingPluginMagic("Focus", "focus", "focus");
$2667dc9b0d1347a4$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $2667dc9b0d1347a4$var$warnMissingPluginMagic(name, magicName, slug) {
    $2667dc9b0d1347a4$var$magic(magicName, (el)=>$2667dc9b0d1347a4$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$2667dc9b0d1347a4$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $2667dc9b0d1347a4$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$2667dc9b0d1347a4$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $2667dc9b0d1347a4$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $2667dc9b0d1347a4$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $2667dc9b0d1347a4$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $2667dc9b0d1347a4$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $2667dc9b0d1347a4$var$skipDuringClone(()=>{
            $2667dc9b0d1347a4$var$initTree(clone2);
            clone2._x_ignore = true;
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $2667dc9b0d1347a4$var$getTarget(expression);
        $2667dc9b0d1347a4$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $2667dc9b0d1347a4$var$teleportContainerDuringClone = document.createElement("div");
function $2667dc9b0d1347a4$var$getTarget(expression) {
    let target = $2667dc9b0d1347a4$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $2667dc9b0d1347a4$var$teleportContainerDuringClone;
    })();
    if (!target) $2667dc9b0d1347a4$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $2667dc9b0d1347a4$var$handler = ()=>{};
$2667dc9b0d1347a4$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$2667dc9b0d1347a4$var$directive("ignore", $2667dc9b0d1347a4$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$2667dc9b0d1347a4$var$directive("effect", $2667dc9b0d1347a4$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($2667dc9b0d1347a4$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $2667dc9b0d1347a4$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $2667dc9b0d1347a4$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $2667dc9b0d1347a4$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $2667dc9b0d1347a4$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $2667dc9b0d1347a4$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $2667dc9b0d1347a4$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $2667dc9b0d1347a4$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($2667dc9b0d1347a4$var$isKeyEvent(event) || $2667dc9b0d1347a4$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($2667dc9b0d1347a4$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $2667dc9b0d1347a4$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $2667dc9b0d1347a4$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $2667dc9b0d1347a4$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $2667dc9b0d1347a4$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $2667dc9b0d1347a4$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $2667dc9b0d1347a4$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $2667dc9b0d1347a4$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $2667dc9b0d1347a4$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $2667dc9b0d1347a4$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $2667dc9b0d1347a4$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($2667dc9b0d1347a4$var$isClickEvent(e.type)) return false;
            if ($2667dc9b0d1347a4$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $2667dc9b0d1347a4$var$keyToModifiers(key) {
    if (!key) return [];
    key = $2667dc9b0d1347a4$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$2667dc9b0d1347a4$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $2667dc9b0d1347a4$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $2667dc9b0d1347a4$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $2667dc9b0d1347a4$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $2667dc9b0d1347a4$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($2667dc9b0d1347a4$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $2667dc9b0d1347a4$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $2667dc9b0d1347a4$var$isCloning ? ()=>{} : $2667dc9b0d1347a4$var$on(el, event, modifiers, (e)=>{
        setValue($2667dc9b0d1347a4$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($2667dc9b0d1347a4$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $2667dc9b0d1347a4$var$on(el.form, "reset", [], (e)=>{
            $2667dc9b0d1347a4$var$nextTick(()=>el._x_model && el._x_model.set($2667dc9b0d1347a4$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $2667dc9b0d1347a4$var$mutateDom(()=>$2667dc9b0d1347a4$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $2667dc9b0d1347a4$var$getInputValue(el, modifiers, event, currentValue) {
    return $2667dc9b0d1347a4$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $2667dc9b0d1347a4$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $2667dc9b0d1347a4$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$2667dc9b0d1347a4$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $2667dc9b0d1347a4$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $2667dc9b0d1347a4$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if (el.type === "radio") {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $2667dc9b0d1347a4$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $2667dc9b0d1347a4$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $2667dc9b0d1347a4$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $2667dc9b0d1347a4$var$isNumeric2(number) ? number : rawValue;
}
function $2667dc9b0d1347a4$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $2667dc9b0d1347a4$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $2667dc9b0d1347a4$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$2667dc9b0d1347a4$var$directive("cloak", (el)=>queueMicrotask(()=>$2667dc9b0d1347a4$var$mutateDom(()=>el.removeAttribute($2667dc9b0d1347a4$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$2667dc9b0d1347a4$var$addInitSelector(()=>`[${$2667dc9b0d1347a4$var$prefix("init")}]`);
$2667dc9b0d1347a4$var$directive("init", $2667dc9b0d1347a4$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$2667dc9b0d1347a4$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $2667dc9b0d1347a4$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$2667dc9b0d1347a4$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $2667dc9b0d1347a4$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $2667dc9b0d1347a4$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$2667dc9b0d1347a4$var$mapAttributes($2667dc9b0d1347a4$var$startingWith(":", $2667dc9b0d1347a4$var$into($2667dc9b0d1347a4$var$prefix("bind:"))));
var $2667dc9b0d1347a4$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $2667dc9b0d1347a4$var$injectBindingProviders(bindingProviders);
        let getBindings = $2667dc9b0d1347a4$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $2667dc9b0d1347a4$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $2667dc9b0d1347a4$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $2667dc9b0d1347a4$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $2667dc9b0d1347a4$var$mutateDom(()=>$2667dc9b0d1347a4$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$2667dc9b0d1347a4$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$2667dc9b0d1347a4$var$directive("bind", $2667dc9b0d1347a4$var$handler2);
function $2667dc9b0d1347a4$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$2667dc9b0d1347a4$var$addRootSelector(()=>`[${$2667dc9b0d1347a4$var$prefix("data")}]`);
$2667dc9b0d1347a4$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($2667dc9b0d1347a4$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $2667dc9b0d1347a4$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $2667dc9b0d1347a4$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $2667dc9b0d1347a4$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $2667dc9b0d1347a4$var$injectMagics(data2, el);
    let reactiveData = $2667dc9b0d1347a4$var$reactive(data2);
    $2667dc9b0d1347a4$var$initInterceptors(reactiveData);
    let undo = $2667dc9b0d1347a4$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $2667dc9b0d1347a4$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $2667dc9b0d1347a4$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$2667dc9b0d1347a4$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $2667dc9b0d1347a4$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$2667dc9b0d1347a4$var$isCloning) return false;
    if ($2667dc9b0d1347a4$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$2667dc9b0d1347a4$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $2667dc9b0d1347a4$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $2667dc9b0d1347a4$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $2667dc9b0d1347a4$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $2667dc9b0d1347a4$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$2667dc9b0d1347a4$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $2667dc9b0d1347a4$var$parseForExpression(expression);
    let evaluateItems = $2667dc9b0d1347a4$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $2667dc9b0d1347a4$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$2667dc9b0d1347a4$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $2667dc9b0d1347a4$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($2667dc9b0d1347a4$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $2667dc9b0d1347a4$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $2667dc9b0d1347a4$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $2667dc9b0d1347a4$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $2667dc9b0d1347a4$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($2667dc9b0d1347a4$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $2667dc9b0d1347a4$var$mutateDom(()=>{
                if (!elForSpot) $2667dc9b0d1347a4$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $2667dc9b0d1347a4$var$reactive(scope2);
            $2667dc9b0d1347a4$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $2667dc9b0d1347a4$var$mutateDom(()=>{
                lastEl.after(clone2);
                $2667dc9b0d1347a4$var$skipDuringClone(()=>$2667dc9b0d1347a4$var$initTree(clone2))();
            });
            if (typeof key === "object") $2667dc9b0d1347a4$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $2667dc9b0d1347a4$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $2667dc9b0d1347a4$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $2667dc9b0d1347a4$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $2667dc9b0d1347a4$var$handler3() {}
$2667dc9b0d1347a4$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $2667dc9b0d1347a4$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$2667dc9b0d1347a4$var$directive("ref", $2667dc9b0d1347a4$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$2667dc9b0d1347a4$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $2667dc9b0d1347a4$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $2667dc9b0d1347a4$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $2667dc9b0d1347a4$var$addScopeToNode(clone2, {}, el);
        $2667dc9b0d1347a4$var$mutateDom(()=>{
            el.after(clone2);
            $2667dc9b0d1347a4$var$skipDuringClone(()=>$2667dc9b0d1347a4$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $2667dc9b0d1347a4$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($2667dc9b0d1347a4$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$2667dc9b0d1347a4$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$2667dc9b0d1347a4$var$setIdRoot(el, name));
});
$2667dc9b0d1347a4$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$2667dc9b0d1347a4$var$mapAttributes($2667dc9b0d1347a4$var$startingWith("@", $2667dc9b0d1347a4$var$into($2667dc9b0d1347a4$var$prefix("on:"))));
$2667dc9b0d1347a4$var$directive("on", $2667dc9b0d1347a4$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $2667dc9b0d1347a4$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $2667dc9b0d1347a4$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$2667dc9b0d1347a4$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$2667dc9b0d1347a4$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$2667dc9b0d1347a4$var$warnMissingPluginDirective("Focus", "trap", "focus");
$2667dc9b0d1347a4$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $2667dc9b0d1347a4$var$warnMissingPluginDirective(name, directiveName, slug) {
    $2667dc9b0d1347a4$var$directive(directiveName, (el)=>$2667dc9b0d1347a4$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$2667dc9b0d1347a4$var$alpine_default.setEvaluator($2667dc9b0d1347a4$var$normalEvaluator);
$2667dc9b0d1347a4$var$alpine_default.setReactivityEngine({
    reactive: $2667dc9b0d1347a4$var$reactive2,
    effect: $2667dc9b0d1347a4$var$effect2,
    release: $2667dc9b0d1347a4$var$stop,
    raw: $2667dc9b0d1347a4$var$toRaw
});
var $2667dc9b0d1347a4$export$b7ee041e4ad2afec = $2667dc9b0d1347a4$var$alpine_default;
// packages/alpinejs/builds/module.js
var $2667dc9b0d1347a4$export$2e2bcd8739ae039 = $2667dc9b0d1347a4$export$b7ee041e4ad2afec;



var $j3oOb = parcelRequire("j3oOb");


parcelRequire("hRLut");
parcelRequire("8VqiI");

parcelRequire("6zFHJ");
parcelRequire("lH5oz");
parcelRequire("9EcIH");
parcelRequire("cW7tz");

parcelRequire("eSAm6");
parcelRequire("aTZNU");


var $j3oOb = parcelRequire("j3oOb");



function $f5c1deed46c0b2bb$var$coinbaseWallet({ supportedWalletType: supportedWalletType = "all", darkMode: darkMode = false, enableMobileWalletLink: enableMobileWalletLink = false, reloadOnDisconnect: reloadOnDisconnect = true } = {}) {
    return ()=>{
        return {
            label: "Coinbase Wallet",
            getIcon: async ()=>(await (parcelRequire("9aYCB"))).default,
            getInterface: async ({ chains: chains, appMetadata: appMetadata })=>{
                if (enableMobileWalletLink || reloadOnDisconnect || darkMode) console.warn("darkMode, enableMobileWalletLink and reloadOnDisconnect init props are deprecated after version 2.2.7 of @web3-onboard/coinbase");
                const { name: name, icon: icon } = appMetadata || {};
                // according to https://github.com/wagmi-dev/wagmi/issues/383
                // @coinbase/wallet-sdk export double default fields
                // so we need to detect it to get the real constructor
                const { default: CoinbaseWalletSDK } = await (parcelRequire("dfRJP"));
                const CoinbaseWalletSDKConstructor = CoinbaseWalletSDK.default ? CoinbaseWalletSDK.default : CoinbaseWalletSDK;
                const { isHex: isHex, toHex: toHex, createEIP1193Provider: createEIP1193Provider, fromHex: fromHex } = await Promise.resolve((parcelRequire("lH5oz")));
                const base64 = window.btoa(icon || "");
                const appLogoUrl = `data:image/svg+xml;base64,${base64}`;
                const appChainIds = chains.map(({ id: id })=>fromHex(id, "number"));
                const instance = new CoinbaseWalletSDKConstructor({
                    appName: name || "",
                    appLogoUrl: appLogoUrl,
                    appChainIds: appChainIds
                });
                const coinbaseWalletProvider = instance.makeWeb3Provider({
                    options: supportedWalletType
                });
                // patch the chainChanged event
                const on = coinbaseWalletProvider.on.bind(coinbaseWalletProvider);
                coinbaseWalletProvider.on = (event, listener)=>{
                    // @ts-ignore
                    on(event, (val)=>{
                        if (event === "chainChanged") {
                            let hexVal;
                            if (isHex(val)) hexVal = val;
                            else hexVal = toHex(val);
                            // @ts-ignore
                            listener(hexVal);
                            return;
                        }
                        listener(val);
                    });
                    return coinbaseWalletProvider;
                };
                const provider = createEIP1193Provider(coinbaseWalletProvider);
                provider.removeListener = (event, func)=>{};
                return {
                    provider: provider,
                    instance: instance
                };
            }
        };
    };
}
var $f5c1deed46c0b2bb$export$2e2bcd8739ae039 = $f5c1deed46c0b2bb$var$coinbaseWallet;



var $6zFHJ = parcelRequire("6zFHJ");
const $6002d546095f538e$var$wcOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    handleUri: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).func().optional(),
    version: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number().optional().custom((value, helpers)=>{
        if (value === 1) console.warn("Version 1 of WalletConnect has been fully deprecated. This version of @web3-onboard/walletconnect only supports version 2");
        else if (value !== 2 && value !== undefined) return helpers.error("any.invalid", {
            message: "Invalid version number. This version of @web3-onboard/walletconnect only supports version 2"
        });
        return value; // return the value unchanged if it's valid or not provided
    }, "Custom version validation"),
    projectId: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().messages({
        "any.required": `WalletConnect version 2 requires a projectId. Please visit https://cloud.walletconnect.com to get one.`
    }),
    dappUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().optional().custom((value, helpers)=>{
        if (!value) return helpers.message({
            message: "It is strongly recommended to supply a dappUrl as it is required by some wallets (i.e. MetaMask) to allow connection.",
            type: "any.custom"
        });
        return value; // return the value unchanged if it's provided
    }, "Custom dappUrl validation"),
    requiredChains: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number()).optional(),
    optionalChains: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).number()).optional(),
    qrModalOptions: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object().optional(),
    additionalRequiredMethods: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()).optional(),
    additionalOptionalMethods: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()).optional()
});
const $6002d546095f538e$var$validate = (validator, data)=>{
    const result = validator.validate(data);
    return result.error ? result : null;
};
const $6002d546095f538e$export$16afb597f1bff25e = (data)=>{
    return $6002d546095f538e$var$validate($6002d546095f538e$var$wcOptions, data);
};



// methods that require user interaction
const $1e99e460deded372$var$methods = [
    "eth_sendTransaction",
    "eth_signTransaction",
    "personal_sign",
    "eth_sign",
    "eth_signTypedData",
    "eth_signTypedData_v4",
    "wallet_addEthereumChain",
    "wallet_switchEthereumChain"
];





function $1e99e460deded372$var$walletConnect(options) {
    if (!options.projectId) throw new Error("WalletConnect requires a projectId. Please visit https://cloud.walletconnect.com to get one.");
    if (!options.dappUrl) console.warn(`It is strongly recommended to supply a dappUrl to the WalletConnect init object as it is required by some wallets (i.e. MetaMask) to allow connection.`);
    const { projectId: projectId, handleUri: handleUri, requiredChains: requiredChains, optionalChains: optionalChains, qrModalOptions: qrModalOptions, additionalRequiredMethods: additionalRequiredMethods, additionalOptionalMethods: additionalOptionalMethods, dappUrl: dappUrl } = options;
    let instance;
    return ()=>{
        return {
            label: "WalletConnect",
            getIcon: async ()=>(await (parcelRequire("iiaIZ"))).default,
            getInterface: async ({ chains: chains, EventEmitter: EventEmitter, appMetadata: appMetadata })=>{
                const { ProviderRpcError: ProviderRpcError, ProviderRpcErrorCode: ProviderRpcErrorCode } = await Promise.resolve((parcelRequire("lH5oz")));
                const { default: EthereumProvider, REQUIRED_METHODS: REQUIRED_METHODS } = await (parcelRequire("jiq0t"));
                const { Subject: Subject, fromEvent: fromEvent } = await (parcelRequire("4Nvi2"));
                const { takeUntil: takeUntil, take: take } = await (parcelRequire("3YH4m"));
                const getMetaData = ()=>{
                    if (!appMetadata) return undefined;
                    const url = dappUrl || appMetadata.explore || "";
                    !url && !url.length && console.warn(`It is strongly recommended to supply a dappUrl as it is required by some wallets (i.e. MetaMask) to allow connection.`);
                    const wcMetaData = {
                        name: appMetadata.name,
                        description: appMetadata.description || "",
                        url: url,
                        icons: []
                    };
                    if (appMetadata.icon !== undefined && appMetadata.icon.length) wcMetaData.icons = [
                        appMetadata.icon
                    ];
                    if (appMetadata.logo !== undefined && appMetadata.logo.length) wcMetaData.icons = wcMetaData.icons.length ? [
                        ...wcMetaData.icons,
                        appMetadata.logo
                    ] : [
                        appMetadata.logo
                    ];
                    return wcMetaData;
                };
                // default to mainnet
                const requiredChainsParsed = Array.isArray(requiredChains) && requiredChains.length && requiredChains.every((num)=>!isNaN(num)) ? // Required as WC package does not support hex numbers
                requiredChains.map((chainID)=>parseInt(chainID)) : [];
                // Defaults to the chains provided within the web3-onboard init chain property
                const optionalChainsParsed = Array.isArray(optionalChains) && optionalChains.length && optionalChains.every((num)=>!isNaN(num)) ? // Required as WC package does not support hex numbers
                optionalChains.map((chainID)=>parseInt(chainID)) : chains.map(({ id: id })=>parseInt(id, 16));
                const requiredMethodsSet = new Set(additionalRequiredMethods && Array.isArray(additionalRequiredMethods) ? [
                    ...additionalRequiredMethods,
                    ...REQUIRED_METHODS
                ] : REQUIRED_METHODS);
                const requiredMethods = Array.from(requiredMethodsSet);
                const optionalMethods = additionalOptionalMethods && Array.isArray(additionalOptionalMethods) ? [
                    ...additionalOptionalMethods,
                    ...$1e99e460deded372$var$methods
                ] : $1e99e460deded372$var$methods;
                const connector = await EthereumProvider.init({
                    projectId: projectId,
                    chains: requiredChainsParsed,
                    methods: requiredMethods,
                    optionalChains: optionalChainsParsed,
                    optionalMethods: optionalMethods,
                    showQrModal: true,
                    rpcMap: chains.map(({ id: id, rpcUrl: rpcUrl })=>({
                            id: id,
                            rpcUrl: rpcUrl
                        })).reduce((rpcMap, { id: id, rpcUrl: rpcUrl })=>{
                        rpcMap[parseInt(id, 16)] = rpcUrl || "";
                        return rpcMap;
                    }, {}),
                    metadata: getMetaData(),
                    qrModalOptions: qrModalOptions
                });
                const emitter = new EventEmitter();
                class EthProvider {
                    constructor({ connector: connector, chains: chains }){
                        this.emit = emitter.emit.bind(emitter);
                        this.on = emitter.on.bind(emitter);
                        this.removeListener = emitter.removeListener.bind(emitter);
                        this.connector = connector;
                        this.chains = chains;
                        this.disconnected$ = new Subject();
                        // listen for accountsChanged
                        fromEvent(this.connector, "accountsChanged", (payload)=>payload).pipe(takeUntil(this.disconnected$)).subscribe({
                            next: (payload)=>{
                                const accounts = Array.isArray(payload) ? payload : [
                                    payload
                                ];
                                this.emit("accountsChanged", accounts);
                            },
                            error: console.warn
                        });
                        // listen for chainChanged
                        fromEvent(this.connector, "chainChanged", (payload)=>payload).pipe(takeUntil(this.disconnected$)).subscribe({
                            next: (chainId)=>{
                                const hexChainId = (0, $90aaee8a682b4bde$export$b02a40aff8e4ad18)(chainId) ? chainId : `0x${chainId.toString(16)}`;
                                this.emit("chainChanged", hexChainId);
                            },
                            error: console.warn
                        });
                        // listen for disconnect event
                        fromEvent(this.connector, "session_delete", (payload)=>payload).pipe(takeUntil(this.disconnected$)).subscribe({
                            next: ()=>{
                                this.emit("accountsChanged", []);
                                this.disconnected$.next(true);
                                typeof localStorage !== "undefined" && localStorage.removeItem("walletconnect");
                            },
                            error: console.warn
                        });
                        this.disconnect = ()=>{
                            if (this.connector.session) {
                                this.connector.disconnect();
                                instance = null;
                            }
                        };
                        if (options && handleUri) // listen for uri event
                        fromEvent(this.connector, "display_uri", (payload)=>payload).pipe(takeUntil(this.disconnected$)).subscribe(async (uri)=>{
                            try {
                                handleUri && await handleUri(uri);
                            } catch (error) {
                                throw `An error occurred when handling the URI. Error: ${error}`;
                            }
                        });
                        const checkForSession = ()=>{
                            const session = this.connector.session;
                            instance = session;
                            if (session) {
                                this.emit("accountsChanged", this.connector.accounts);
                                this.emit("chainChanged", this.connector.chainId);
                            }
                        };
                        checkForSession();
                        this.request = async ({ method: method, params: params })=>{
                            if (method === "eth_chainId") return (0, $90aaee8a682b4bde$export$b02a40aff8e4ad18)(this.connector.chainId) ? this.connector.chainId : `0x${this.connector.chainId.toString(16)}`;
                            if (method === "eth_requestAccounts") return new Promise(async (resolve, reject)=>{
                                // Subscribe to connection events
                                fromEvent(this.connector, "connect", (payload)=>payload).pipe(take(1)).subscribe({
                                    next: ({ chainId: chainId })=>{
                                        this.emit("accountsChanged", this.connector.accounts);
                                        const hexChainId = (0, $90aaee8a682b4bde$export$b02a40aff8e4ad18)(chainId) ? chainId : `0x${chainId.toString(16)}`;
                                        this.emit("chainChanged", hexChainId);
                                        resolve(this.connector.accounts);
                                    },
                                    error: reject
                                });
                                // Check if connection is already established
                                if (!this.connector.session) // create new session
                                await this.connector.connect().catch((err)=>{
                                    console.error("err creating new session: ", err);
                                    reject(new ProviderRpcError({
                                        code: 4001,
                                        message: "User rejected the request."
                                    }));
                                });
                                else {
                                    // update ethereum provider to load accounts & chainId
                                    const accounts = this.connector.accounts;
                                    const chainId = this.connector.chainId;
                                    instance = this.connector.session;
                                    const hexChainId = `0x${chainId.toString(16)}`;
                                    this.emit("chainChanged", hexChainId);
                                    return resolve(accounts);
                                }
                            });
                            if (method === "eth_selectAccounts") throw new ProviderRpcError({
                                code: ProviderRpcErrorCode.UNSUPPORTED_METHOD,
                                message: `The Provider does not support the requested method: ${method}`
                            });
                            if (method == "wallet_switchEthereumChain") {
                                if (!params) throw new ProviderRpcError({
                                    code: ProviderRpcErrorCode.INVALID_PARAMS,
                                    message: `The Provider requires a chainId to be passed in as an argument`
                                });
                                const chainIdObj = params[0];
                                if (!chainIdObj.hasOwnProperty("chainId") || typeof chainIdObj["chainId"] === "undefined") throw new ProviderRpcError({
                                    code: ProviderRpcErrorCode.INVALID_PARAMS,
                                    message: `The Provider requires a chainId to be passed in as an argument`
                                });
                                return this.connector.request({
                                    method: "wallet_switchEthereumChain",
                                    params: [
                                        {
                                            chainId: chainIdObj.chainId
                                        }
                                    ]
                                });
                            }
                            return this.connector.request({
                                method: method,
                                params: params
                            });
                        };
                    }
                }
                return {
                    provider: new EthProvider({
                        chains: chains,
                        connector: connector
                    }),
                    instance: instance
                };
            }
        };
    };
}
var $1e99e460deded372$export$2e2bcd8739ae039 = $1e99e460deded372$var$walletConnect;


const $90aaee8a682b4bde$export$b02a40aff8e4ad18 = (value)=>{
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    return true;
};
function $90aaee8a682b4bde$var$initWalletConnect(options) {
    if (!options) throw new Error(`WalletConnect requires an initialization object to be passed - see the official docs for an example: https://onboard.blocknative.com/docs/wallets/walletconnect`);
    if (options) {
        const error = (0, $6002d546095f538e$export$16afb597f1bff25e)(options);
        if (error) throw error;
    }
    return (0, $1e99e460deded372$export$2e2bcd8739ae039)(options);
}
var $90aaee8a682b4bde$export$2e2bcd8739ae039 = $90aaee8a682b4bde$var$initWalletConnect;



var $4UYwZ = parcelRequire("4UYwZ");
/**
 * The `ProviderIdentityFlag` is a property on an injected provider
 * that uniquely identifies that provider
 */ var $43ce5c440073a0fd$export$ed1aacaf3c5fdac4;
(function(ProviderIdentityFlag) {
    ProviderIdentityFlag["AlphaWallet"] = "isAlphaWallet";
    ProviderIdentityFlag["ApexWallet"] = "isApexWallet";
    ProviderIdentityFlag["AToken"] = "isAToken";
    ProviderIdentityFlag["BifrostWallet"] = "isBifrost";
    ProviderIdentityFlag["Binance"] = "bbcSignTx";
    ProviderIdentityFlag["Bitpie"] = "isBitpie";
    ProviderIdentityFlag["BlockWallet"] = "isBlockWallet";
    ProviderIdentityFlag["Coinbase"] = "isToshi";
    ProviderIdentityFlag["CoinbaseExtension"] = "isCoinbaseWallet";
    ProviderIdentityFlag["Detected"] = "request";
    ProviderIdentityFlag["Dcent"] = "isDcentWallet";
    ProviderIdentityFlag["Exodus"] = "isExodus";
    ProviderIdentityFlag["Frontier"] = "isFrontier";
    ProviderIdentityFlag["Frame"] = "isFrame";
    ProviderIdentityFlag["HuobiWallet"] = "isHbWallet";
    ProviderIdentityFlag["HyperPay"] = "isHyperPay";
    ProviderIdentityFlag["ImToken"] = "isImToken";
    ProviderIdentityFlag["InfinityWallet"] = "isInfinityWallet";
    ProviderIdentityFlag["Liquality"] = "isLiquality";
    ProviderIdentityFlag["MeetOne"] = "wallet";
    ProviderIdentityFlag["MetaMask"] = "isMetaMask";
    ProviderIdentityFlag["MyKey"] = "isMYKEY";
    ProviderIdentityFlag["OwnBit"] = "isOwnbit";
    ProviderIdentityFlag["Status"] = "isStatus";
    ProviderIdentityFlag["Trust"] = "isTrust";
    ProviderIdentityFlag["TokenPocket"] = "isTokenPocket";
    ProviderIdentityFlag["TP"] = "isTp";
    ProviderIdentityFlag["WalletIo"] = "isWalletIO";
    ProviderIdentityFlag["XDEFI"] = "isXDEFI";
    ProviderIdentityFlag["OneInch"] = "isOneInchIOSWallet";
    ProviderIdentityFlag["Tokenary"] = "isTokenary";
    ProviderIdentityFlag["Tally"] = "isTally";
    ProviderIdentityFlag["BraveWallet"] = "isBraveWallet";
    ProviderIdentityFlag["Rabby"] = "isRabby";
    ProviderIdentityFlag["MathWallet"] = "isMathWallet";
    ProviderIdentityFlag["Bitget"] = "isBitKeep";
    ProviderIdentityFlag["Sequence"] = "isSequence";
    ProviderIdentityFlag["Core"] = "isAvalanche";
    ProviderIdentityFlag["Opera"] = "isOpera";
    ProviderIdentityFlag["Bitski"] = "isBitski";
    ProviderIdentityFlag["Enkrypt"] = "isEnkrypt";
    ProviderIdentityFlag["Phantom"] = "isPhantom";
    ProviderIdentityFlag["OKXWallet"] = "isOkxWallet";
    ProviderIdentityFlag["Zeal"] = "isZeal";
    ProviderIdentityFlag["Zerion"] = "isZerion";
    ProviderIdentityFlag["Rainbow"] = "isRainbow";
    ProviderIdentityFlag["SafePal"] = "isSafePal";
    ProviderIdentityFlag["DeFiWallet"] = "isDeficonnectProvider";
    ProviderIdentityFlag["Safeheron"] = "isSafeheron";
    ProviderIdentityFlag["Talisman"] = "isTalisman";
    ProviderIdentityFlag["OneKey"] = "isOneKey";
    ProviderIdentityFlag["Fordefi"] = "isFordefi";
    ProviderIdentityFlag["Coin98Wallet"] = "isCoin98";
    ProviderIdentityFlag["SubWallet"] = "isSubWallet";
    ProviderIdentityFlag["Kayros"] = "isKayros";
    ProviderIdentityFlag["FoxWallet"] = "isFoxWallet";
    ProviderIdentityFlag["Lif3Wallet"] = "isLif3Wallet";
    ProviderIdentityFlag["ZodiacPilot"] = "isZodiacPilot";
    ProviderIdentityFlag["StableWallet"] = "isStableWallet";
    ProviderIdentityFlag["Echooo"] = "isEchooo";
})($43ce5c440073a0fd$export$ed1aacaf3c5fdac4 || ($43ce5c440073a0fd$export$ed1aacaf3c5fdac4 = {}));
var $43ce5c440073a0fd$export$a9253ba86c8edfd5;
(function(ProviderExternalUrl) {
    ProviderExternalUrl["Binance"] = "https://www.bnbchain.org/ru/blog/binance-extension-wallet/";
    ProviderExternalUrl["Bitget"] = "https://web3.bitget.com/en/wallet-download";
    ProviderExternalUrl["Coinbase"] = "https://www.coinbase.com/wallet/downloads";
    ProviderExternalUrl["MetaMask"] = "https://metamask.io/download/";
    ProviderExternalUrl["OKXWallet"] = "https://okx.com/download";
    ProviderExternalUrl["Phantom"] = "https://phantom.app/ul/v1/connect";
    ProviderExternalUrl["Talisman"] = "https://www.talisman.xyz/";
    ProviderExternalUrl["Trust"] = "https://link.trustwallet.com";
    ProviderExternalUrl["OneKey"] = "https://onekey.so/download/";
    ProviderExternalUrl["RoninWallet"] = "https://wallet.skymavis.com/";
    ProviderExternalUrl["Coin98Wallet"] = "https://coin98.com/wallet/";
    ProviderExternalUrl["SubWallet"] = "https://www.subwallet.app/";
    ProviderExternalUrl["Kayros"] = "https://www.kayros.games/wallet/";
    ProviderExternalUrl["XDEFI"] = "https://xdefi.io/";
    ProviderExternalUrl["FoxWallet"] = "https://foxwallet.com/download";
    ProviderExternalUrl["Lif3Wallet"] = "https://lif3.com";
    ProviderExternalUrl["Rabby"] = "https://rabby.io";
    ProviderExternalUrl["ZodiacPilot"] = "https://pilot.gnosisguild.org/";
    ProviderExternalUrl["Echooo"] = "https://www.echooo.xyz";
})($43ce5c440073a0fd$export$a9253ba86c8edfd5 || ($43ce5c440073a0fd$export$a9253ba86c8edfd5 = {}));
var $43ce5c440073a0fd$export$f0b712b78e0e0d3a;
(function(ProviderLabel) {
    ProviderLabel["AlphaWallet"] = "AlphaWallet";
    ProviderLabel["ApexWallet"] = "Apex Wallet";
    ProviderLabel["AToken"] = "AToken";
    ProviderLabel["BifrostWallet"] = "Bifrost Wallet";
    ProviderLabel["Binance"] = "Binance Smart Wallet";
    ProviderLabel["Bitpie"] = "Bitpie";
    ProviderLabel["Bitski"] = "Bitski";
    ProviderLabel["BlockWallet"] = "BlockWallet";
    ProviderLabel["Brave"] = "Brave Wallet";
    ProviderLabel["Coinbase"] = "Coinbase Wallet";
    ProviderLabel["Dcent"] = "D'CENT";
    ProviderLabel["Detected"] = "Detected Wallet";
    ProviderLabel["Exodus"] = "Exodus";
    ProviderLabel["Frame"] = "Frame";
    ProviderLabel["Frontier"] = "Frontier";
    ProviderLabel["HuobiWallet"] = "Huobi Wallet";
    ProviderLabel["HyperPay"] = "HyperPay";
    ProviderLabel["ImToken"] = "imToken";
    ProviderLabel["InfinityWallet"] = "Infinity Wallet";
    ProviderLabel["Liquality"] = "Liquality";
    ProviderLabel["MeetOne"] = "MeetOne";
    ProviderLabel["MetaMask"] = "MetaMask";
    ProviderLabel["MyKey"] = "MyKey";
    ProviderLabel["Opera"] = "Opera Wallet";
    ProviderLabel["OwnBit"] = "OwnBit";
    ProviderLabel["Status"] = "Status Wallet";
    ProviderLabel["Trust"] = "Trust Wallet";
    ProviderLabel["TokenPocket"] = "TokenPocket";
    ProviderLabel["TP"] = "TP Wallet";
    ProviderLabel["WalletIo"] = "Wallet.io";
    ProviderLabel["XDEFI"] = "XDEFI Wallet";
    ProviderLabel["OneInch"] = "1inch Wallet";
    ProviderLabel["Tokenary"] = "Tokenary Wallet";
    ProviderLabel["Tally"] = "Taho";
    ProviderLabel["Rabby"] = "Rabby Wallet";
    ProviderLabel["MathWallet"] = "MathWallet";
    ProviderLabel["Bitget"] = "Bitget Wallet";
    ProviderLabel["Sequence"] = "Sequence";
    ProviderLabel["Core"] = "Core";
    ProviderLabel["Enkrypt"] = "Enkrypt";
    ProviderLabel["Zeal"] = "Zeal";
    ProviderLabel["Phantom"] = "Phantom";
    ProviderLabel["OKXWallet"] = "OKX Wallet";
    ProviderLabel["Zerion"] = "Zerion";
    ProviderLabel["Rainbow"] = "Rainbow";
    ProviderLabel["SafePal"] = "SafePal";
    ProviderLabel["DeFiWallet"] = "DeFi Wallet";
    ProviderLabel["Safeheron"] = "Safeheron";
    ProviderLabel["Talisman"] = "Talisman";
    ProviderLabel["OneKey"] = "OneKey";
    ProviderLabel["Fordefi"] = "Fordefi";
    ProviderLabel["RoninWallet"] = "Ronin Wallet";
    ProviderLabel["Coin98Wallet"] = "Coin98 Wallet";
    ProviderLabel["SubWallet"] = "SubWallet";
    ProviderLabel["Kayros"] = "Kayros";
    ProviderLabel["FoxWallet"] = "FoxWallet";
    ProviderLabel["Lif3Wallet"] = "Lif3 Wallet";
    ProviderLabel["ZodiacPilot"] = "Zodiac Pilot";
    ProviderLabel["StableWallet"] = "StableWallet";
    ProviderLabel["Echooo"] = "Echooo";
})($43ce5c440073a0fd$export$f0b712b78e0e0d3a || ($43ce5c440073a0fd$export$f0b712b78e0e0d3a = {}));
var $43ce5c440073a0fd$export$c1baa9dfa9de24b2;
(function(InjectedNameSpace) {
    InjectedNameSpace["Ethereum"] = "ethereum";
    InjectedNameSpace["Binance"] = "BinanceChain";
    InjectedNameSpace["Tally"] = "tally";
    InjectedNameSpace["Web3"] = "web3";
    InjectedNameSpace["Arbitrum"] = "arbitrum";
    InjectedNameSpace["XFI"] = "xfi";
    InjectedNameSpace["Bitget"] = "bitkeep";
    InjectedNameSpace["Avalanche"] = "avalanche";
    InjectedNameSpace["Bitski"] = "Bitski";
    InjectedNameSpace["Enkrypt"] = "enkrypt";
    InjectedNameSpace["Zeal"] = "zeal";
    InjectedNameSpace["Phantom"] = "phantom";
    InjectedNameSpace["OKXWallet"] = "okxwallet";
    InjectedNameSpace["Trust"] = "trustwallet";
    InjectedNameSpace["Frontier"] = "frontier";
    InjectedNameSpace["DeFiConnectProvider"] = "deficonnectProvider";
    InjectedNameSpace["Safeheron"] = "safeheron";
    InjectedNameSpace["Talisman"] = "talismanEth";
    InjectedNameSpace["OneKey"] = "$onekey";
    InjectedNameSpace["RoninWallet"] = "ronin";
    InjectedNameSpace["Coin98Wallet"] = "coin98";
    InjectedNameSpace["SubWallet"] = "SubWallet";
    InjectedNameSpace["Kayros"] = "kayros";
    InjectedNameSpace["FoxWallet"] = "foxwallet";
    InjectedNameSpace["Echooo"] = "echooo";
})($43ce5c440073a0fd$export$c1baa9dfa9de24b2 || ($43ce5c440073a0fd$export$c1baa9dfa9de24b2 = {}));
class $43ce5c440073a0fd$export$9c8150830466b77e extends Event {
    constructor(){
        super("eip6963:requestProvider");
    }
}


parcelRequire("lH5oz");
var $dPPnm = parcelRequire("dPPnm");

const $b7eaabe36b981b86$var$UNSUPPORTED_METHOD = null;
function $b7eaabe36b981b86$var$getInjectedInterface(identity, checkOtherProviderFlags) {
    return async ()=>({
            provider: window.ethereum.providers && Array.isArray(window.ethereum.providers) ? $b7eaabe36b981b86$var$getInterfaceFromProvidersArray(identity, checkOtherProviderFlags) : window.ethereum
        });
}
function $b7eaabe36b981b86$var$getInterfaceFromProvidersArray(identity, checkOtherProviderFlags) {
    return window.ethereum.providers.find((provider)=>{
        return checkOtherProviderFlags ? !!provider[identity] && !$b7eaabe36b981b86$var$otherProviderFlagsExist(identity, provider) : !!provider[identity];
    });
}
function $b7eaabe36b981b86$var$otherProviderFlagsExist(identity, provider) {
    const otherProviderFlags = Object.values((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4)).filter((id)=>id !== identity && id !== (0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Detected);
    return otherProviderFlags.some((id)=>!!provider[id]);
}

const $b7eaabe36b981b86$var$metamask = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).MetaMask,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).MetaMask] && !$b7eaabe36b981b86$var$otherProviderFlagsExist((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).MetaMask, provider),
    getIcon: async ()=>(await (parcelRequire("9rNDL"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).MetaMask, true),
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).MetaMask
};

const $b7eaabe36b981b86$var$infinitywallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).InfinityWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).InfinityWallet],
    getIcon: async ()=>(await (parcelRequire("fpzET"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).InfinityWallet),
    platforms: [
        "desktop"
    ]
};

const $b7eaabe36b981b86$var$exodus = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Exodus,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Exodus],
    getIcon: async ()=>(await (parcelRequire("aghlg"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Exodus),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$frontier = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Frontier,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Frontier,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider["ethereum"] && !!provider["ethereum"][(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Frontier],
    getIcon: async ()=>(await (parcelRequire("bUHRZ"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.frontier.ethereum)
        }),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$brave = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Brave,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).BraveWallet],
    getIcon: async ()=>(await (parcelRequire("382sz"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).BraveWallet),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$binance = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Binance,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Binance,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Binance],
    getIcon: async ()=>(await (parcelRequire("2SeTD"))).default,
    getInterface: async ()=>{
        // Replace the provider as the BNB provider is readonly
        let tempBNBProvider = {
            ...window.BinanceChain
        };
        window.BinanceChain = tempBNBProvider;
        const addListener = window.BinanceChain.on.bind(window.BinanceChain);
        window.BinanceChain.on = (event, func)=>{
            // intercept chainChanged event and format string
            if (event === "chainChanged") addListener(event, (chainId)=>{
                const cb = func;
                cb(`0x${parseInt(chainId).toString(16)}`);
            });
            else addListener(event, func);
        };
        const provider = (0, $dPPnm.createEIP1193Provider)(window.BinanceChain, {
            eth_chainId: ({ baseRequest: baseRequest })=>baseRequest({
                    method: "eth_chainId"
                }).then((id)=>`0x${parseInt(id).toString(16)}`),
            // Unsupported method -- will throw error
            eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD,
            wallet_switchEthereumChain: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
        });
        provider.removeListener = (event, func)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        "desktop"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).Binance
};

const $b7eaabe36b981b86$var$coinbase = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Coinbase,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Coinbase] || !!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).CoinbaseExtension],
    getIcon: async ()=>(await (parcelRequire("bC8O1"))).default,
    getInterface: async ()=>{
        const { provider: provider } = await $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).CoinbaseExtension)();
        const addListener = provider.on.bind(provider);
        provider.on = (event, func)=>{
            // intercept chainChanged event and format string
            if (event === "chainChanged") addListener(event, (chainId)=>{
                const cb = func;
                cb(`0x${parseInt(chainId).toString(16)}`);
            });
            else addListener(event, func);
        };
        return {
            provider: provider
        };
    },
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).Coinbase
};

const $b7eaabe36b981b86$var$detected = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Detected,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Detected],
    getIcon: async ()=>(await (parcelRequire("lROFz"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$trust = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Trust,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Trust,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Trust],
    getIcon: async ()=>(await (parcelRequire("Zbc2l"))).default,
    getInterface: async ()=>{
        const ethereumInjectionExists = window.hasOwnProperty((0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum);
        let provider;
        // check if trust is injected into window.ethereum
        if (ethereumInjectionExists && window[(0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum].isTrust) provider = window[(0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum];
        else // directly use the window.trustwallet injection
        provider = window[(0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Trust];
        return {
            provider: provider
        };
    },
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).Trust
};

const $b7eaabe36b981b86$var$opera = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Opera,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Opera],
    getIcon: async ()=>(await (parcelRequire("h9wEU"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
                eth_requestAccounts: async ({ baseRequest: baseRequest })=>baseRequest({
                        method: "eth_accounts"
                    }),
                eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$status = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Status,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Status],
    getIcon: async ()=>(await (parcelRequire("kS500"))).default,
    getInterface: async ()=>{
        const provider = window.ethereum;
        return {
            provider: provider
        };
    },
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$alphawallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).AlphaWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).AlphaWallet],
    getIcon: async ()=>(await (parcelRequire("3m7GZ"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$apexwallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).ApexWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).ApexWallet],
    getIcon: async ()=>(await (parcelRequire("k8azg"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "desktop",
        "Chrome",
        "Chromium",
        "Microsoft Edge"
    ]
};

const $b7eaabe36b981b86$var$atoken = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).AToken,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).AToken],
    getIcon: async ()=>(await (parcelRequire("6gWi8"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$bifrostwallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).BifrostWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).BifrostWallet],
    getIcon: async ()=>(await (parcelRequire("4hjyb"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).BifrostWallet),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$bitpie = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Bitpie,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ()=>!!window.Bitpie,
    getIcon: async ()=>(await (parcelRequire("dn0Kz"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$blockwallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).BlockWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).BlockWallet],
    getIcon: async ()=>(await (parcelRequire("FsEYj"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).BlockWallet),
    platforms: [
        "desktop"
    ]
};

const $b7eaabe36b981b86$var$frame = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Frame,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Frame],
    getIcon: async ()=>(await (parcelRequire("6ggk8"))).default,
    getInterface: async ()=>{
        const provider = window.ethereum;
        if (!provider || !provider.connected) throw new Error("Frame App must be open with a hot wallet connected. If not installed first download the Frame App.");
        return {
            provider: provider
        };
    },
    platforms: [
        "desktop"
    ]
};

const $b7eaabe36b981b86$var$huobiwallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).HuobiWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).HuobiWallet],
    getIcon: async ()=>(await (parcelRequire("lUvnX"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$hyperpay = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).HyperPay,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    // Note: The property `hiWallet` is as of now the only known way of identifying hyperpay
    // wallet as it is a direct clone of metamask. `checkProviderIdentity` implementation is subject to
    // future changes
    checkProviderIdentity: ()=>!!window.hiWallet,
    getIcon: async ()=>(await (parcelRequire("ani4a"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$imtoken = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).ImToken,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).ImToken],
    getIcon: async ()=>(await (parcelRequire("kXakg"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
                eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$liquality = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Liquality,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Liquality],
    getIcon: async ()=>(await (parcelRequire("9cWLJ"))).default,
    getInterface: async ()=>{
        const provider = (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
            wallet_switchEthereumChain: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD,
            eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
        });
        provider.removeListener = (event, func)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        "desktop"
    ]
};

const $b7eaabe36b981b86$var$meetone = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).MeetOne,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).MeetOne] === "MEETONE",
    getIcon: async ()=>(await (parcelRequire("fPGQo"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$mykey = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).MyKey,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).MyKey],
    getIcon: async ()=>(await (parcelRequire("anmCq"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$ownbit = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).OwnBit,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).OwnBit],
    getIcon: async ()=>(await (parcelRequire("uXKG0"))).default,
    getInterface: async ()=>{
        const provider = (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
            eth_chainId: ({ baseRequest: baseRequest })=>baseRequest({
                    method: "eth_chainId"
                }).then((id)=>`0x${parseInt(id).toString(16)}`),
            wallet_switchEthereumChain: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD,
            eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
        });
        provider.removeListener = (event, listener)=>{};
        provider.on = (event, listener)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$tokenpocket = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).TokenPocket,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).TokenPocket] && !provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).TP],
    getIcon: async ()=>(await (parcelRequire("4bHd0"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).TokenPocket),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$tp = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).TP,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).TP],
    getIcon: async ()=>(await (parcelRequire("ceFHG"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$xdefi = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).XDEFI,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).XFI,
    checkProviderIdentity: ({ provider: provider })=>provider && provider.ethereum && provider.ethereum[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).XDEFI],
    getIcon: async ()=>(await (parcelRequire("1Gq9L"))).default,
    getInterface: async ()=>({
            provider: window.xfi && window.xfi.ethereum
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).XDEFI
};

const $b7eaabe36b981b86$var$oneInch = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).OneInch,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).OneInch],
    getIcon: async ()=>(await (parcelRequire("iZjMn"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$tokenary = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Tokenary,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Tokenary],
    getIcon: async ()=>(await (parcelRequire("cESaT"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$tally = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Tally,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Tally,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Tally],
    getIcon: async ()=>(await (parcelRequire("9vh4y"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.tally)
        }),
    platforms: [
        "desktop"
    ]
};

const $b7eaabe36b981b86$var$zeal = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Zeal,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Zeal,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Zeal],
    getIcon: async ()=>(await (parcelRequire("cSdrw"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.zeal)
        }),
    platforms: [
        "desktop"
    ]
};

const $b7eaabe36b981b86$var$rabby = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Rabby,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Rabby],
    getIcon: async ()=>(await (parcelRequire("evLcH"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "desktop",
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$mathwallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).MathWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).MathWallet],
    getIcon: async ()=>(await (parcelRequire("7sKfd"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).MathWallet),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$bitget = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Bitget,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Bitget,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider["ethereum"][(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Bitget],
    getIcon: async ()=>(await (parcelRequire("9l4JA"))).default,
    getInterface: async ()=>({
            provider: window.bitkeep && window.bitkeep.ethereum
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).Bitget
};

const $b7eaabe36b981b86$var$sequence = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Sequence,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Sequence],
    getIcon: async ()=>(await (parcelRequire("eh7kV"))).default,
    getInterface: async ()=>({
            provider: window.ethereum
        }),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$core = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Core,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Avalanche,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Core],
    getIcon: async ()=>(await (parcelRequire("5qAzX"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Core),
    // Core wallet is only tested in chrome or chromium browser
    platforms: [
        "desktop",
        "Chrome",
        "Chromium",
        "Microsoft Edge"
    ]
};

const $b7eaabe36b981b86$var$bitski = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Bitski,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Bitski,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider.getProvider && !!provider.getProvider().isBitski,
    getIcon: async ()=>(await (parcelRequire("cPLUs"))).default,
    getInterface: async ()=>({
            provider: window.Bitski && window.Bitski.getProvider && window.Bitski.getProvider()
        }),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$zerion = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Zerion,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Zerion],
    getIcon: async ()=>(await (parcelRequire("c4U9X"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$enkrypt = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Enkrypt,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Enkrypt,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider.providers && !!provider.providers.ethereum,
    getIcon: async ()=>(await (parcelRequire("c5Y2O"))).default,
    getInterface: async ()=>{
        const addListener = window.enkrypt.providers.ethereum.on.bind(window.enkrypt.providers.ethereum);
        window.enkrypt.providers.ethereum.on = (event, func)=>{
            // intercept chainChanged event and format string
            if (event === "chainChanged") addListener(event, (chainId)=>{
                const cb = func;
                cb(`0x${parseInt(chainId).toString(16)}`);
            });
            else addListener(event, func);
        };
        const provider = (0, $dPPnm.createEIP1193Provider)(window.enkrypt.providers.ethereum, {
            eth_chainId: ({ baseRequest: baseRequest })=>baseRequest({
                    method: "eth_chainId"
                }).then((id)=>`0x${parseInt(id).toString(16)}`)
        });
        provider.removeListener = (event, func)=>{};
        return {
            provider: provider
        };
    },
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$phantom = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Phantom,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Phantom,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider["ethereum"] && !!provider["ethereum"][(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Phantom],
    getIcon: async ()=>(await (parcelRequire("anmOI"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.phantom.ethereum)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).Phantom
};

const $b7eaabe36b981b86$var$safepal = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).SafePal,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).SafePal],
    getIcon: async ()=>(await (parcelRequire("kQtcU"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$rainbow = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Rainbow,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Rainbow],
    getIcon: async ()=>(await (parcelRequire("4JfQk"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Rainbow),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$okxwallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).OKXWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).OKXWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).OKXWallet],
    getIcon: async ()=>(await (parcelRequire("8hRVi"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.okxwallet)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).OKXWallet
};

const $b7eaabe36b981b86$var$defiwallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).DeFiWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).DeFiConnectProvider,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).DeFiWallet],
    getIcon: async ()=>(await (parcelRequire("dnDoS"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.deficonnectProvider)
        }),
    platforms: [
        "all"
    ]
};

const $b7eaabe36b981b86$var$safeheron = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Safeheron,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Safeheron,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Safeheron],
    getIcon: async ()=>(await (parcelRequire("cVlkT"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.safeheron)
        }),
    platforms: [
        "desktop",
        "Chrome",
        "Chromium",
        "Microsoft Edge"
    ]
};

const $b7eaabe36b981b86$var$talisman = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Talisman,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Talisman,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Talisman],
    getIcon: async ()=>(await (parcelRequire("2GHCb"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.talismanEth)
        }),
    platforms: [
        "desktop"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).Talisman
};

const $b7eaabe36b981b86$var$ronin = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).RoninWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).RoninWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider,
    getIcon: async ()=>(await (parcelRequire("36ZvM"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ronin.provider)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).RoninWallet
};

const $b7eaabe36b981b86$var$onekey = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).OneKey,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).OneKey,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider.ethereum && !!provider.ethereum[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).OneKey],
    getIcon: async ()=>(await (parcelRequire("k4jZJ"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.$onekey.ethereum)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).OneKey
};

const $b7eaabe36b981b86$var$fordefi = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Fordefi,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Fordefi],
    getIcon: async ()=>(await (parcelRequire("hOQ1z"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Fordefi, true),
    platforms: [
        "desktop"
    ]
};

const $b7eaabe36b981b86$var$coin98wallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Coin98Wallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Coin98Wallet],
    getIcon: async ()=>(await (parcelRequire("2OiZZ"))).default,
    getInterface: async ()=>{
        const ethereumInjectionExists = window.hasOwnProperty((0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum);
        let provider;
        // check if coin98 is injected into window.ethereum
        if (ethereumInjectionExists && window[(0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum].isCoin98) provider = window[(0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum];
        else // directly use the window.coin98 injection
        provider = window[(0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Coin98Wallet].provider;
        return {
            provider: provider
        };
    },
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).Coin98Wallet
};

const $b7eaabe36b981b86$var$subwallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).SubWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).SubWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).SubWallet],
    getIcon: async ()=>(await (parcelRequire("aUOI1"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.SubWallet)
        }),
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).SubWallet
};

const $b7eaabe36b981b86$var$kayros = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Kayros,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Kayros,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Kayros],
    getIcon: async ()=>(await (parcelRequire("7vnmh"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.kayros)
        }),
    platforms: [
        "desktop"
    ]
};

const $b7eaabe36b981b86$var$foxwallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).FoxWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).FoxWallet,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).FoxWallet],
    getIcon: async ()=>(await (parcelRequire("7sSeF"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.foxwallet)
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$Lif3Wallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Lif3Wallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Lif3Wallet],
    getIcon: async ()=>(await (parcelRequire("7Fafs"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum, {
                wallet_switchEthereumChain: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD,
                eth_selectAccounts: $b7eaabe36b981b86$var$UNSUPPORTED_METHOD
            })
        }),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$zodiacPilot = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).ZodiacPilot,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).ZodiacPilot],
    getIcon: async ()=>(await (parcelRequire("aGM03"))).default,
    getInterface: async ()=>({
            provider: (0, $dPPnm.createEIP1193Provider)(window.ethereum)
        }),
    platforms: [
        "desktop"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).ZodiacPilot
};

const $b7eaabe36b981b86$var$stablewallet = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).StableWallet,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).StableWallet],
    getIcon: async ()=>(await (parcelRequire("dj57A"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).StableWallet),
    platforms: [
        "mobile"
    ]
};

const $b7eaabe36b981b86$var$echooo = {
    label: (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Echooo,
    injectedNamespace: (0, $43ce5c440073a0fd$export$c1baa9dfa9de24b2).Ethereum,
    checkProviderIdentity: ({ provider: provider })=>!!provider && !!provider[(0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Echooo],
    getIcon: async ()=>(await (parcelRequire("hAfA1"))).default,
    getInterface: $b7eaabe36b981b86$var$getInjectedInterface((0, $43ce5c440073a0fd$export$ed1aacaf3c5fdac4).Echooo),
    platforms: [
        "all"
    ],
    externalUrl: (0, $43ce5c440073a0fd$export$a9253ba86c8edfd5).Echooo
};
const $b7eaabe36b981b86$var$wallets = [
    $b7eaabe36b981b86$var$zeal,
    $b7eaabe36b981b86$var$exodus,
    $b7eaabe36b981b86$var$frontier,
    $b7eaabe36b981b86$var$metamask,
    $b7eaabe36b981b86$var$bifrostwallet,
    $b7eaabe36b981b86$var$binance,
    $b7eaabe36b981b86$var$coinbase,
    $b7eaabe36b981b86$var$detected,
    $b7eaabe36b981b86$var$trust,
    $b7eaabe36b981b86$var$opera,
    $b7eaabe36b981b86$var$status,
    $b7eaabe36b981b86$var$alphawallet,
    $b7eaabe36b981b86$var$apexwallet,
    $b7eaabe36b981b86$var$atoken,
    $b7eaabe36b981b86$var$bitget,
    $b7eaabe36b981b86$var$bitpie,
    $b7eaabe36b981b86$var$blockwallet,
    $b7eaabe36b981b86$var$brave,
    $b7eaabe36b981b86$var$frame,
    $b7eaabe36b981b86$var$huobiwallet,
    $b7eaabe36b981b86$var$hyperpay,
    $b7eaabe36b981b86$var$imtoken,
    $b7eaabe36b981b86$var$liquality,
    $b7eaabe36b981b86$var$meetone,
    $b7eaabe36b981b86$var$mykey,
    $b7eaabe36b981b86$var$ownbit,
    $b7eaabe36b981b86$var$tokenpocket,
    $b7eaabe36b981b86$var$tp,
    $b7eaabe36b981b86$var$xdefi,
    $b7eaabe36b981b86$var$oneInch,
    $b7eaabe36b981b86$var$tokenary,
    $b7eaabe36b981b86$var$tally,
    $b7eaabe36b981b86$var$rabby,
    $b7eaabe36b981b86$var$mathwallet,
    $b7eaabe36b981b86$var$sequence,
    $b7eaabe36b981b86$var$core,
    $b7eaabe36b981b86$var$bitski,
    $b7eaabe36b981b86$var$enkrypt,
    $b7eaabe36b981b86$var$phantom,
    $b7eaabe36b981b86$var$okxwallet,
    $b7eaabe36b981b86$var$zerion,
    $b7eaabe36b981b86$var$rainbow,
    $b7eaabe36b981b86$var$safepal,
    $b7eaabe36b981b86$var$defiwallet,
    $b7eaabe36b981b86$var$infinitywallet,
    $b7eaabe36b981b86$var$safeheron,
    $b7eaabe36b981b86$var$talisman,
    $b7eaabe36b981b86$var$onekey,
    $b7eaabe36b981b86$var$fordefi,
    $b7eaabe36b981b86$var$ronin,
    $b7eaabe36b981b86$var$coin98wallet,
    $b7eaabe36b981b86$var$subwallet,
    $b7eaabe36b981b86$var$kayros,
    $b7eaabe36b981b86$var$foxwallet,
    $b7eaabe36b981b86$var$Lif3Wallet,
    $b7eaabe36b981b86$var$zodiacPilot,
    $b7eaabe36b981b86$var$stablewallet,
    $b7eaabe36b981b86$var$echooo
];
var $b7eaabe36b981b86$export$2e2bcd8739ae039 = $b7eaabe36b981b86$var$wallets;



var $6zFHJ = parcelRequire("6zFHJ");
parcelRequire("lH5oz");
var $2AQn5 = parcelRequire("2AQn5");
const $ea44e110a1c459f5$var$walletModule = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    label: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    getIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().arity(0).required(),
    getInterface: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().maxArity(1).required(),
    injectedNamespace: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    checkProviderIdentity: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function().arity(1).required(),
    platforms: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()),
    externalUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string()
});
const $ea44e110a1c459f5$var$wallets = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items($ea44e110a1c459f5$var$walletModule);
const $ea44e110a1c459f5$var$filter = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object().pattern(/\w+/, (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).any().allow((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(), (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string())));
const $ea44e110a1c459f5$var$walletOptions = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    custom: $ea44e110a1c459f5$var$wallets,
    filter: $ea44e110a1c459f5$var$filter,
    displayUnavailable: [
        (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean(),
        (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).array().items((0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string())
    ],
    walletUnavailableMessage: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    sort: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).function(),
    externalUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string(),
    disable6963Support: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).boolean()
});
const $ea44e110a1c459f5$export$579090a152b2b16 = (data)=>(0, $2AQn5.validate)($ea44e110a1c459f5$var$walletOptions, data);
const $ea44e110a1c459f5$var$eip6963ProviderInfo = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required(),
    rdns: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).string().required()
});
const $ea44e110a1c459f5$var$eip6963ProviderDetail = (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object({
    info: $ea44e110a1c459f5$var$eip6963ProviderInfo.required(),
    provider: (0, (/*@__PURE__*/$parcel$interopDefault($6zFHJ))).object().required()
});
const $ea44e110a1c459f5$export$9f850aef0c7d58e5 = (data)=>(0, $2AQn5.validate)($ea44e110a1c459f5$var$eip6963ProviderDetail, data);


class $33a07d94dc8eae2d$export$417589b978208a8f extends Error {
    constructor(error){
        super(error.message);
        this.message = error.message;
        this.code = error.code;
        this.data = error.data;
    }
}
const $33a07d94dc8eae2d$export$edcd15c5afc9c733 = ({ label: label, externalUrl: externalUrl })=>externalUrl ? `Please <a href="${externalUrl}" target="_blank">install or switch to</a> ${label} to continue` : `Please install or enable ${label} to continue`;
const $33a07d94dc8eae2d$export$4e06f978fc4aa878 = (provider, checkProviderIdentity, device)=>{
    // No injected providers exist.
    if (!provider) return false;
    // Many injected providers add their own object into window.
    if (checkProviderIdentity({
        provider: provider,
        device: device
    })) return true;
    // For multiple injected providers, check providers array
    // example coinbase inj wallet pushes over-ridden wallets
    // into a providers array at window.ethereum
    return !!provider.providers?.some((provider)=>checkProviderIdentity({
            provider: provider,
            device: device
        }));
};
function $33a07d94dc8eae2d$export$303e63c37a8e91ee(svgString) {
    if (!svgString) return false;
    // Regular expression to match <script> tags
    const scriptTagRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    // Regular expression to match event handler attributes (e.g., onclick, onload)
    const eventHandlerRegex = /\bon[a-z]+\s*=\s*["']?(?:javascript:)?/gi;
    // Regular expression to match href or xlink:href attributes containing "javascript:"
    const hrefJavaScriptRegex = /\b(href|xlink:href)\s*=\s*["']?javascript:/gi;
    // Check for <script> tags
    if (scriptTagRegex.test(svgString)) return true;
    // Check for event handlers
    if (eventHandlerRegex.test(svgString)) return true;
    // Check for "javascript:" in href or xlink:href
    if (hrefJavaScriptRegex.test(svgString)) return true;
    // No executable JavaScript found
    return false;
}


const $072c96f2d8cbaa12$var$providers6963 = [];
function $072c96f2d8cbaa12$var$checkFor6963Providers() {
    // Add event listener for 'eip6963:announceProvider' event
    window.addEventListener("eip6963:announceProvider", (event)=>{
        const eipEvent = event;
        const { detail: detail } = eipEvent;
        if (!detail) return;
        if (eipEvent) {
            const result = (0, $ea44e110a1c459f5$export$9f850aef0c7d58e5)(detail);
            if (result && result.error) throw result.error;
        }
        const { info: info, provider: provider } = detail;
        const { name: name, icon: icon } = info;
        if ((0, $33a07d94dc8eae2d$export$303e63c37a8e91ee)(icon)) {
            console.error(`The icon for injected wallet: ${name} contains executable JavaScript and has been blocked.`);
            return;
        }
        // Push the provider information to the providers6963 array
        $072c96f2d8cbaa12$var$providers6963.push({
            label: name,
            getIcon: async ()=>icon,
            getInterface: async ()=>({
                    provider: provider
                }),
            platforms: [
                "all"
            ],
            eip6963Provider: provider,
            checkProviderIdentity: ({ provider: provider })=>!!provider
        });
    });
    // Dispatch a custom event to request the provider information
    window.dispatchEvent(new CustomEvent("eip6963:requestProvider"));
}
function $072c96f2d8cbaa12$var$injected(options) {
    if (typeof window === "undefined") return ()=>null;
    if (options) {
        const result = (0, $ea44e110a1c459f5$export$579090a152b2b16)(options);
        if (result && result.error) throw result.error;
    }
    !options?.disable6963Support && $072c96f2d8cbaa12$var$checkFor6963Providers();
    return (helpers)=>{
        const { device: device } = helpers;
        const { custom: custom = [], filter: filter = {}, displayUnavailable: displayUnavailable, sort: sort, walletUnavailableMessage: walletUnavailableMessage } = options || {};
        // combine custom with standard wallets and dedupe
        const allWallets = (0, (/*@__PURE__*/$parcel$interopDefault($4UYwZ)))([
            ...custom,
            ...$072c96f2d8cbaa12$var$providers6963,
            ...(0, $b7eaabe36b981b86$export$2e2bcd8739ae039)
        ], ({ label: label })=>label);
        const wallets = allWallets.reduce((acc, wallet)=>{
            const { label: label, platforms: platforms, injectedNamespace: injectedNamespace, checkProviderIdentity: checkProviderIdentity, eip6963Provider: eip6963Provider } = wallet;
            const walletFilters = filter[label];
            const filteredWallet = walletFilters === false;
            const provider = eip6963Provider || window[injectedNamespace];
            const walletAvailable = (0, $33a07d94dc8eae2d$export$4e06f978fc4aa878)(provider, checkProviderIdentity, device);
            let excludedDevice = false;
            // dev specified platform filters
            if (Array.isArray(walletFilters) && (walletFilters.includes(device.type) || device.os && walletFilters.includes(device.os.name))) excludedDevice = true;
            // unavailable filter
            if (walletFilters === "unavailable" && !walletAvailable) excludedDevice = true;
            // wallet specified platform filters
            const invalidPlatform = !platforms.includes("all") && device.type !== null && !platforms.includes(device.type) && !platforms.includes(device.os.name);
            const supportedWallet = !filteredWallet && !excludedDevice && !invalidPlatform && (walletAvailable || displayUnavailable === true || Array.isArray(displayUnavailable) && displayUnavailable.length && displayUnavailable.includes(wallet.label));
            if (supportedWallet) acc.push(// modify wallet to display error if unavailable but displayUnavailable is set
            (displayUnavailable === true || Array.isArray(displayUnavailable) && displayUnavailable.length && displayUnavailable.includes(wallet.label)) && !walletAvailable ? {
                ...wallet,
                getInterface: async ()=>{
                    throw new Error(walletUnavailableMessage ? walletUnavailableMessage(wallet) : (0, $33a07d94dc8eae2d$export$edcd15c5afc9c733)(wallet));
                }
            } : wallet);
            return acc;
        }, []);
        if (wallets.length) {
            const moreThanOneWallet = wallets.length > 1;
            // if more than one wallet, then remove detected wallet
            const formattedWallets = wallets.filter((wallet)=>{
                const { label: label } = wallet;
                return !(label === (0, $43ce5c440073a0fd$export$f0b712b78e0e0d3a).Detected && moreThanOneWallet);
            })// then map to the WalletModule interface
            .map(({ label: label, getIcon: getIcon, getInterface: getInterface })=>({
                    label: label,
                    getIcon: getIcon,
                    getInterface: getInterface
                }))// default sort by alphabetical
            .sort((a, b)=>a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
            return sort ? sort(formattedWallets) : formattedWallets;
        }
        return [];
    };
}
var $072c96f2d8cbaa12$export$2e2bcd8739ae039 = $072c96f2d8cbaa12$var$injected;


var $2f443f1aca6ad8c7$exports = {};
/*! For license information please see web3.min.js.LICENSE.txt */ !function(e, t) {
    $2f443f1aca6ad8c7$exports = t();
}($2f443f1aca6ad8c7$exports, ()=>(()=>{
        var e = {
            7256: (e, t)=>{
                "use strict";
                function r(e) {
                    if (Array.isArray(e)) {
                        const t = [];
                        let n = 0;
                        for(let o = 0; o < e.length; o++){
                            const i = r(e[o]);
                            t.push(i), n += i.length;
                        }
                        return h(i(n, 192), ...t);
                    }
                    const t = g(e);
                    return 1 === t.length && t[0] < 128 ? t : h(i(t.length, 128), t);
                }
                function n(e, t, r) {
                    if (r > e.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
                    return e.slice(t, r);
                }
                function o(e) {
                    if (0 === e[0]) throw new Error("invalid RLP: extra zeros");
                    return d(u(e));
                }
                function i(e, t) {
                    if (e < 56) return Uint8Array.from([
                        e + t
                    ]);
                    const r = p(e), n = p(t + 55 + r.length / 2);
                    return Uint8Array.from(l(n + r));
                }
                function s(e, t = !1) {
                    if (null == e || 0 === e.length) return Uint8Array.from([]);
                    const r = a(g(e));
                    if (t) return r;
                    if (0 !== r.remainder.length) throw new Error("invalid RLP: remainder must be zero");
                    return r.data;
                }
                function a(e) {
                    let t, r, i, s, c;
                    const u = [], d = e[0];
                    if (d <= 127) return {
                        data: e.slice(0, 1),
                        remainder: e.slice(1)
                    };
                    if (d <= 183) {
                        if (t = d - 127, i = 128 === d ? Uint8Array.from([]) : n(e, 1, t), 2 === t && i[0] < 128) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
                        return {
                            data: i,
                            remainder: e.slice(t)
                        };
                    }
                    if (d <= 191) {
                        if (r = d - 182, e.length - 1 < r) throw new Error("invalid RLP: not enough bytes for string length");
                        if (t = o(n(e, 1, r)), t <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
                        return i = n(e, r, t + r), {
                            data: i,
                            remainder: e.slice(t + r)
                        };
                    }
                    if (d <= 247) {
                        for(t = d - 191, s = n(e, 1, t); s.length;)c = a(s), u.push(c.data), s = c.remainder;
                        return {
                            data: u,
                            remainder: e.slice(t)
                        };
                    }
                    {
                        if (r = d - 246, t = o(n(e, 1, r)), t < 56) throw new Error("invalid RLP: encoded list too short");
                        const i = r + t;
                        if (i > e.length) throw new Error("invalid RLP: total length is larger than the data");
                        for(s = n(e, r, i); s.length;)c = a(s), u.push(c.data), s = c.remainder;
                        return {
                            data: u,
                            remainder: e.slice(i)
                        };
                    }
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.RLP = t.utils = t.decode = t.encode = void 0, t.encode = r, t.decode = s;
                const c = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function u(e) {
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += c[e[r]];
                    return t;
                }
                function d(e) {
                    const t = Number.parseInt(e, 16);
                    if (Number.isNaN(t)) throw new Error("Invalid byte sequence");
                    return t;
                }
                function l(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + typeof e);
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r;
                        t[r] = d(e.slice(n, n + 2));
                    }
                    return t;
                }
                function h(...e) {
                    if (1 === e.length) return e[0];
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    for(let t = 0, n = 0; t < e.length; t++){
                        const o = e[t];
                        r.set(o, n), n += o.length;
                    }
                    return r;
                }
                function f(e) {
                    return (new TextEncoder).encode(e);
                }
                function p(e) {
                    if (e < 0) throw new Error("Invalid integer as argument, must be unsigned!");
                    const t = e.toString(16);
                    return t.length % 2 ? `0${t}` : t;
                }
                function m(e) {
                    return e.length >= 2 && "0" === e[0] && "x" === e[1];
                }
                function g(e) {
                    if (e instanceof Uint8Array) return e;
                    if ("string" == typeof e) return m(e) ? l((t = "string" != typeof (r = e) ? r : m(r) ? r.slice(2) : r).length % 2 ? `0${t}` : t) : f(e);
                    var t, r;
                    if ("number" == typeof e || "bigint" == typeof e) return e ? l(p(e)) : Uint8Array.from([]);
                    if (null == e) return Uint8Array.from([]);
                    throw new Error("toBytes: received unsupported type " + typeof e);
                }
                t.utils = {
                    bytesToHex: u,
                    concatBytes: h,
                    hexToBytes: l,
                    utf8ToBytes: f
                }, t.RLP = {
                    encode: r,
                    decode: s
                };
            },
            5887: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createCurve = t.getHash = void 0;
                const n = r(7493), o = r(488), i = r(7851);
                function s(e) {
                    return {
                        hash: e,
                        hmac: (t, ...r)=>(0, n.hmac)(e, t, (0, o.concatBytes)(...r)),
                        randomBytes: o.randomBytes
                    };
                }
                t.getHash = s, t.createCurve = function(e, t) {
                    const r = (t)=>(0, i.weierstrass)({
                            ...e,
                            ...s(t)
                        });
                    return Object.freeze({
                        ...r(t),
                        create: r
                    });
                };
            },
            1465: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateBasic = t.wNAF = void 0;
                const n = r(9530), o = r(4323), i = BigInt(0), s = BigInt(1);
                t.wNAF = function(e, t) {
                    const r = (e, t)=>{
                        const r = t.negate();
                        return e ? r : t;
                    }, n = (e)=>({
                            windows: Math.ceil(t / e) + 1,
                            windowSize: 2 ** (e - 1)
                        });
                    return {
                        constTimeNegate: r,
                        unsafeLadder (t, r) {
                            let n = e.ZERO, o = t;
                            for(; r > i;)r & s && (n = n.add(o)), o = o.double(), r >>= s;
                            return n;
                        },
                        precomputeWindow (e, t) {
                            const { windows: r, windowSize: o } = n(t), i = [];
                            let s = e, a = s;
                            for(let e = 0; e < r; e++){
                                a = s, i.push(a);
                                for(let e = 1; e < o; e++)a = a.add(s), i.push(a);
                                s = a.double();
                            }
                            return i;
                        },
                        wNAF (t, o, i) {
                            const { windows: a, windowSize: c } = n(t);
                            let u = e.ZERO, d = e.BASE;
                            const l = BigInt(2 ** t - 1), h = 2 ** t, f = BigInt(t);
                            for(let e = 0; e < a; e++){
                                const t = e * c;
                                let n = Number(i & l);
                                i >>= f, n > c && (n -= h, i += s);
                                const a = t, p = t + Math.abs(n) - 1, m = e % 2 != 0, g = n < 0;
                                0 === n ? d = d.add(r(m, o[a])) : u = u.add(r(g, o[p]));
                            }
                            return {
                                p: u,
                                f: d
                            };
                        },
                        wNAFCached (e, t, r, n) {
                            const o = e._WINDOW_SIZE || 1;
                            let i = t.get(e);
                            return i || (i = this.precomputeWindow(e, o), 1 !== o && t.set(e, n(i))), this.wNAF(o, i, r);
                        }
                    };
                }, t.validateBasic = function(e) {
                    return (0, n.validateField)(e.Fp), (0, o.validateObject)(e, {
                        n: "bigint",
                        h: "bigint",
                        Gx: "field",
                        Gy: "field"
                    }, {
                        nBitLength: "isSafeInteger",
                        nByteLength: "isSafeInteger"
                    }), Object.freeze({
                        ...(0, n.nLength)(e.n, e.nBitLength),
                        ...e,
                        p: e.Fp.ORDER
                    });
                };
            },
            1322: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createHasher = t.isogenyMap = t.hash_to_field = t.expand_message_xof = t.expand_message_xmd = void 0;
                const n = r(9530), o = r(4323), i = o.bytesToNumberBE;
                function s(e, t) {
                    if (e < 0 || e >= 1 << 8 * t) throw new Error(`bad I2OSP call: value=${e} length=${t}`);
                    const r = Array.from({
                        length: t
                    }).fill(0);
                    for(let n = t - 1; n >= 0; n--)r[n] = 255 & e, e >>>= 8;
                    return new Uint8Array(r);
                }
                function a(e, t) {
                    const r = new Uint8Array(e.length);
                    for(let n = 0; n < e.length; n++)r[n] = e[n] ^ t[n];
                    return r;
                }
                function c(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                }
                function u(e) {
                    if (!Number.isSafeInteger(e)) throw new Error("number expected");
                }
                function d(e, t, r, n) {
                    c(e), c(t), u(r), t.length > 255 && (t = n((0, o.concatBytes)((0, o.utf8ToBytes)("H2C-OVERSIZE-DST-"), t)));
                    const { outputLen: i, blockLen: d } = n, l = Math.ceil(r / i);
                    if (l > 255) throw new Error("Invalid xmd length");
                    const h = (0, o.concatBytes)(t, s(t.length, 1)), f = s(0, d), p = s(r, 2), m = new Array(l), g = n((0, o.concatBytes)(f, e, p, s(0, 1), h));
                    m[0] = n((0, o.concatBytes)(g, s(1, 1), h));
                    for(let e = 1; e <= l; e++){
                        const t = [
                            a(g, m[e - 1]),
                            s(e + 1, 1),
                            h
                        ];
                        m[e] = n((0, o.concatBytes)(...t));
                    }
                    return (0, o.concatBytes)(...m).slice(0, r);
                }
                function l(e, t, r, n, i) {
                    if (c(e), c(t), u(r), t.length > 255) {
                        const e = Math.ceil(2 * n / 8);
                        t = i.create({
                            dkLen: e
                        }).update((0, o.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(t).digest();
                    }
                    if (r > 65535 || t.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
                    return i.create({
                        dkLen: r
                    }).update(e).update(s(r, 2)).update(t).update(s(t.length, 1)).digest();
                }
                function h(e, t, r) {
                    (0, o.validateObject)(r, {
                        DST: "string",
                        p: "bigint",
                        m: "isSafeInteger",
                        k: "isSafeInteger",
                        hash: "hash"
                    });
                    const { p: s, k: a, m: h, hash: f, expand: p, DST: m } = r;
                    c(e), u(t);
                    const g = function(e) {
                        if (e instanceof Uint8Array) return e;
                        if ("string" == typeof e) return (0, o.utf8ToBytes)(e);
                        throw new Error("DST must be Uint8Array or string");
                    }(m), y = s.toString(2).length, v = Math.ceil((y + a) / 8), b = t * h * v;
                    let E;
                    if ("xmd" === p) E = d(e, g, b, f);
                    else if ("xof" === p) E = l(e, g, b, a, f);
                    else {
                        if ("_internal_pass" !== p) throw new Error('expand must be "xmd" or "xof"');
                        E = e;
                    }
                    const _ = new Array(t);
                    for(let e = 0; e < t; e++){
                        const t = new Array(h);
                        for(let r = 0; r < h; r++){
                            const o = v * (r + e * h), a = E.subarray(o, o + v);
                            t[r] = (0, n.mod)(i(a), s);
                        }
                        _[e] = t;
                    }
                    return _;
                }
                t.expand_message_xmd = d, t.expand_message_xof = l, t.hash_to_field = h, t.isogenyMap = function(e, t) {
                    const r = t.map((e)=>Array.from(e).reverse());
                    return (t, n)=>{
                        const [o, i, s, a] = r.map((r)=>r.reduce((r, n)=>e.add(e.mul(r, t), n)));
                        return t = e.div(o, i), n = e.mul(n, e.div(s, a)), {
                            x: t,
                            y: n
                        };
                    };
                }, t.createHasher = function(e, t, r) {
                    if ("function" != typeof t) throw new Error("mapToCurve() must be defined");
                    return {
                        hashToCurve (n, o) {
                            const i = h(n, 2, {
                                ...r,
                                DST: r.DST,
                                ...o
                            }), s = e.fromAffine(t(i[0])), a = e.fromAffine(t(i[1])), c = s.add(a).clearCofactor();
                            return c.assertValidity(), c;
                        },
                        encodeToCurve (n, o) {
                            const i = h(n, 1, {
                                ...r,
                                DST: r.encodeDST,
                                ...o
                            }), s = e.fromAffine(t(i[0])).clearCofactor();
                            return s.assertValidity(), s;
                        }
                    };
                };
            },
            9530: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hashToPrivateScalar = t.FpSqrtEven = t.FpSqrtOdd = t.Field = t.nLength = t.FpIsSquare = t.FpDiv = t.FpInvertBatch = t.FpPow = t.validateField = t.isNegativeLE = t.FpSqrt = t.tonelliShanks = t.invert = t.pow2 = t.pow = t.mod = void 0;
                const n = r(4323), o = BigInt(0), i = BigInt(1), s = BigInt(2), a = BigInt(3), c = BigInt(4), u = BigInt(5), d = BigInt(8);
                function l(e, t) {
                    const r = e % t;
                    return r >= o ? r : t + r;
                }
                function h(e, t, r) {
                    if (r <= o || t < o) throw new Error("Expected power/modulo > 0");
                    if (r === i) return o;
                    let n = i;
                    for(; t > o;)t & i && (n = n * e % r), e = e * e % r, t >>= i;
                    return n;
                }
                function f(e, t) {
                    if (e === o || t <= o) throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
                    let r = l(e, t), n = t, s = o, a = i, c = i, u = o;
                    for(; r !== o;){
                        const e = n / r, t = n % r, o = s - c * e, i = a - u * e;
                        n = r, r = t, s = c, a = u, c = o, u = i;
                    }
                    if (n !== i) throw new Error("invert: does not exist");
                    return l(s, t);
                }
                function p(e) {
                    const t = (e - i) / s;
                    let r, n, a;
                    for(r = e - i, n = 0; r % s === o; r /= s, n++);
                    for(a = s; a < e && h(a, t, e) !== e - i; a++);
                    if (1 === n) {
                        const t = (e + i) / c;
                        return function(e, r) {
                            const n = e.pow(r, t);
                            if (!e.eql(e.sqr(n), r)) throw new Error("Cannot find square root");
                            return n;
                        };
                    }
                    const u = (r + i) / s;
                    return function(e, o) {
                        if (e.pow(o, t) === e.neg(e.ONE)) throw new Error("Cannot find square root");
                        let s = n, c = e.pow(e.mul(e.ONE, a), r), d = e.pow(o, u), l = e.pow(o, r);
                        for(; !e.eql(l, e.ONE);){
                            if (e.eql(l, e.ZERO)) return e.ZERO;
                            let t = 1;
                            for(let r = e.sqr(l); t < s && !e.eql(r, e.ONE); t++)r = e.sqr(r);
                            const r = e.pow(c, i << BigInt(s - t - 1));
                            c = e.sqr(r), d = e.mul(d, r), l = e.mul(l, c), s = t;
                        }
                        return d;
                    };
                }
                function m(e) {
                    if (e % c === a) {
                        const t = (e + i) / c;
                        return function(e, r) {
                            const n = e.pow(r, t);
                            if (!e.eql(e.sqr(n), r)) throw new Error("Cannot find square root");
                            return n;
                        };
                    }
                    if (e % d === u) {
                        const t = (e - u) / d;
                        return function(e, r) {
                            const n = e.mul(r, s), o = e.pow(n, t), i = e.mul(r, o), a = e.mul(e.mul(i, s), o), c = e.mul(i, e.sub(a, e.ONE));
                            if (!e.eql(e.sqr(c), r)) throw new Error("Cannot find square root");
                            return c;
                        };
                    }
                    return p(e);
                }
                BigInt(9), BigInt(16), t.mod = l, t.pow = h, t.pow2 = function(e, t, r) {
                    let n = e;
                    for(; t-- > o;)n *= n, n %= r;
                    return n;
                }, t.invert = f, t.tonelliShanks = p, t.FpSqrt = m, t.isNegativeLE = (e, t)=>(l(e, t) & i) === i;
                const g = [
                    "create",
                    "isValid",
                    "is0",
                    "neg",
                    "inv",
                    "sqrt",
                    "sqr",
                    "eql",
                    "add",
                    "sub",
                    "mul",
                    "pow",
                    "div",
                    "addN",
                    "subN",
                    "mulN",
                    "sqrN"
                ];
                function y(e, t, r) {
                    if (r < o) throw new Error("Expected power > 0");
                    if (r === o) return e.ONE;
                    if (r === i) return t;
                    let n = e.ONE, s = t;
                    for(; r > o;)r & i && (n = e.mul(n, s)), s = e.sqr(s), r >>= i;
                    return n;
                }
                function v(e, t) {
                    const r = new Array(t.length), n = t.reduce((t, n, o)=>e.is0(n) ? t : (r[o] = t, e.mul(t, n)), e.ONE), o = e.inv(n);
                    return t.reduceRight((t, n, o)=>e.is0(n) ? t : (r[o] = e.mul(t, r[o]), e.mul(t, n)), o), r;
                }
                function b(e, t) {
                    const r = void 0 !== t ? t : e.toString(2).length;
                    return {
                        nBitLength: r,
                        nByteLength: Math.ceil(r / 8)
                    };
                }
                t.validateField = function(e) {
                    const t = g.reduce((e, t)=>(e[t] = "function", e), {
                        ORDER: "bigint",
                        MASK: "bigint",
                        BYTES: "isSafeInteger",
                        BITS: "isSafeInteger"
                    });
                    return (0, n.validateObject)(e, t);
                }, t.FpPow = y, t.FpInvertBatch = v, t.FpDiv = function(e, t, r) {
                    return e.mul(t, "bigint" == typeof r ? f(r, e.ORDER) : e.inv(r));
                }, t.FpIsSquare = function(e) {
                    const t = (e.ORDER - i) / s;
                    return (r)=>{
                        const n = e.pow(r, t);
                        return e.eql(n, e.ZERO) || e.eql(n, e.ONE);
                    };
                }, t.nLength = b, t.Field = function(e, t, r = !1, s = {}) {
                    if (e <= o) throw new Error(`Expected Fp ORDER > 0, got ${e}`);
                    const { nBitLength: a, nByteLength: c } = b(e, t);
                    if (c > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
                    const u = m(e), d = Object.freeze({
                        ORDER: e,
                        BITS: a,
                        BYTES: c,
                        MASK: (0, n.bitMask)(a),
                        ZERO: o,
                        ONE: i,
                        create: (t)=>l(t, e),
                        isValid: (t)=>{
                            if ("bigint" != typeof t) throw new Error("Invalid field element: expected bigint, got " + typeof t);
                            return o <= t && t < e;
                        },
                        is0: (e)=>e === o,
                        isOdd: (e)=>(e & i) === i,
                        neg: (t)=>l(-t, e),
                        eql: (e, t)=>e === t,
                        sqr: (t)=>l(t * t, e),
                        add: (t, r)=>l(t + r, e),
                        sub: (t, r)=>l(t - r, e),
                        mul: (t, r)=>l(t * r, e),
                        pow: (e, t)=>y(d, e, t),
                        div: (t, r)=>l(t * f(r, e), e),
                        sqrN: (e)=>e * e,
                        addN: (e, t)=>e + t,
                        subN: (e, t)=>e - t,
                        mulN: (e, t)=>e * t,
                        inv: (t)=>f(t, e),
                        sqrt: s.sqrt || ((e)=>u(d, e)),
                        invertBatch: (e)=>v(d, e),
                        cmov: (e, t, r)=>r ? t : e,
                        toBytes: (e)=>r ? (0, n.numberToBytesLE)(e, c) : (0, n.numberToBytesBE)(e, c),
                        fromBytes: (e)=>{
                            if (e.length !== c) throw new Error(`Fp.fromBytes: expected ${c}, got ${e.length}`);
                            return r ? (0, n.bytesToNumberLE)(e) : (0, n.bytesToNumberBE)(e);
                        }
                    });
                    return Object.freeze(d);
                }, t.FpSqrtOdd = function(e, t) {
                    if (!e.isOdd) throw new Error("Field doesn't have isOdd");
                    const r = e.sqrt(t);
                    return e.isOdd(r) ? r : e.neg(r);
                }, t.FpSqrtEven = function(e, t) {
                    if (!e.isOdd) throw new Error("Field doesn't have isOdd");
                    const r = e.sqrt(t);
                    return e.isOdd(r) ? e.neg(r) : r;
                }, t.hashToPrivateScalar = function(e, t, r = !1) {
                    const o = (e = (0, n.ensureBytes)("privateHash", e)).length, s = b(t).nByteLength + 8;
                    if (s < 24 || o < s || o > 1024) throw new Error(`hashToPrivateScalar: expected ${s}-1024 bytes of input, got ${o}`);
                    return l(r ? (0, n.bytesToNumberLE)(e) : (0, n.bytesToNumberBE)(e), t - i) + i;
                };
            },
            4323: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateObject = t.createHmacDrbg = t.bitMask = t.bitSet = t.bitGet = t.bitLen = t.utf8ToBytes = t.equalBytes = t.concatBytes = t.ensureBytes = t.numberToVarBytesBE = t.numberToBytesLE = t.numberToBytesBE = t.bytesToNumberLE = t.bytesToNumberBE = t.hexToBytes = t.hexToNumber = t.numberToHexUnpadded = t.bytesToHex = void 0;
                const r = BigInt(0), n = BigInt(1), o = BigInt(2), i = (e)=>e instanceof Uint8Array, s = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function a(e) {
                    if (!i(e)) throw new Error("Uint8Array expected");
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += s[e[r]];
                    return t;
                }
                function c(e) {
                    const t = e.toString(16);
                    return 1 & t.length ? `0${t}` : t;
                }
                function u(e) {
                    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
                    return BigInt("" === e ? "0" : `0x${e}`);
                }
                function d(e) {
                    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
                    if (e.length % 2) throw new Error("hex string is invalid: unpadded " + e.length);
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r, o = e.slice(n, n + 2), i = Number.parseInt(o, 16);
                        if (Number.isNaN(i) || i < 0) throw new Error("invalid byte sequence");
                        t[r] = i;
                    }
                    return t;
                }
                function l(...e) {
                    const t = new Uint8Array(e.reduce((e, t)=>e + t.length, 0));
                    let r = 0;
                    return e.forEach((e)=>{
                        if (!i(e)) throw new Error("Uint8Array expected");
                        t.set(e, r), r += e.length;
                    }), t;
                }
                t.bytesToHex = a, t.numberToHexUnpadded = c, t.hexToNumber = u, t.hexToBytes = d, t.bytesToNumberBE = function(e) {
                    return u(a(e));
                }, t.bytesToNumberLE = function(e) {
                    if (!i(e)) throw new Error("Uint8Array expected");
                    return u(a(Uint8Array.from(e).reverse()));
                }, t.numberToBytesBE = (e, t)=>d(e.toString(16).padStart(2 * t, "0")), t.numberToBytesLE = (e, r)=>(0, t.numberToBytesBE)(e, r).reverse(), t.numberToVarBytesBE = (e)=>d(c(e)), t.ensureBytes = function(e, t, r) {
                    let n;
                    if ("string" == typeof t) try {
                        n = d(t);
                    } catch (r) {
                        throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${r}`);
                    }
                    else {
                        if (!i(t)) throw new Error(`${e} must be hex string or Uint8Array`);
                        n = Uint8Array.from(t);
                    }
                    const o = n.length;
                    if ("number" == typeof r && o !== r) throw new Error(`${e} expected ${r} bytes, got ${o}`);
                    return n;
                }, t.concatBytes = l, t.equalBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.utf8ToBytes = function(e) {
                    if ("string" != typeof e) throw new Error("utf8ToBytes expected string, got " + typeof e);
                    return (new TextEncoder).encode(e);
                }, t.bitLen = function(e) {
                    let t;
                    for(t = 0; e > r; e >>= n, t += 1);
                    return t;
                }, t.bitGet = (e, t)=>e >> BigInt(t) & n, t.bitSet = (e, t, o)=>e | (o ? n : r) << BigInt(t), t.bitMask = (e)=>(o << BigInt(e - 1)) - n;
                const h = (e)=>new Uint8Array(e), f = (e)=>Uint8Array.from(e);
                t.createHmacDrbg = function(e, t, r) {
                    if ("number" != typeof e || e < 2) throw new Error("hashLen must be a number");
                    if ("number" != typeof t || t < 2) throw new Error("qByteLen must be a number");
                    if ("function" != typeof r) throw new Error("hmacFn must be a function");
                    let n = h(e), o = h(e), i = 0;
                    const s = ()=>{
                        n.fill(1), o.fill(0), i = 0;
                    }, a = (...e)=>r(o, n, ...e), c = (e = h())=>{
                        o = a(f([
                            0
                        ]), e), n = a(), 0 !== e.length && (o = a(f([
                            1
                        ]), e), n = a());
                    }, u = ()=>{
                        if (i++ >= 1e3) throw new Error("drbg: tried 1000 values");
                        let e = 0;
                        const r = [];
                        for(; e < t;){
                            n = a();
                            const t = n.slice();
                            r.push(t), e += n.length;
                        }
                        return l(...r);
                    };
                    return (e, t)=>{
                        let r;
                        for(s(), c(e); !(r = t(u()));)c();
                        return s(), r;
                    };
                };
                const p = {
                    bigint: (e)=>"bigint" == typeof e,
                    function: (e)=>"function" == typeof e,
                    boolean: (e)=>"boolean" == typeof e,
                    string: (e)=>"string" == typeof e,
                    isSafeInteger: (e)=>Number.isSafeInteger(e),
                    array: (e)=>Array.isArray(e),
                    field: (e, t)=>t.Fp.isValid(e),
                    hash: (e)=>"function" == typeof e && Number.isSafeInteger(e.outputLen)
                };
                t.validateObject = function(e, t, r = {}) {
                    const n = (t, r, n)=>{
                        const o = p[r];
                        if ("function" != typeof o) throw new Error(`Invalid validator "${r}", expected function`);
                        const i = e[t];
                        if (!(n && void 0 === i || o(i, e))) throw new Error(`Invalid param ${String(t)}=${i} (${typeof i}), expected ${r}`);
                    };
                    for (const [e, r] of Object.entries(t))n(e, r, !1);
                    for (const [e, t] of Object.entries(r))n(e, t, !0);
                    return e;
                };
            },
            7851: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mapToCurveSimpleSWU = t.SWUFpSqrtRatio = t.weierstrass = t.weierstrassPoints = t.DER = void 0;
                const n = r(9530), o = r(4323), i = r(4323), s = r(1465), { bytesToNumberBE: a, hexToBytes: c } = o;
                t.DER = {
                    Err: class extends Error {
                        constructor(e = ""){
                            super(e);
                        }
                    },
                    _parseInt (e) {
                        const { Err: r } = t.DER;
                        if (e.length < 2 || 2 !== e[0]) throw new r("Invalid signature integer tag");
                        const n = e[1], o = e.subarray(2, n + 2);
                        if (!n || o.length !== n) throw new r("Invalid signature integer: wrong length");
                        if (128 & o[0]) throw new r("Invalid signature integer: negative");
                        if (0 === o[0] && !(128 & o[1])) throw new r("Invalid signature integer: unnecessary leading zero");
                        return {
                            d: a(o),
                            l: e.subarray(n + 2)
                        };
                    },
                    toSig (e) {
                        const { Err: r } = t.DER, n = "string" == typeof e ? c(e) : e;
                        if (!(n instanceof Uint8Array)) throw new Error("ui8a expected");
                        let o = n.length;
                        if (o < 2 || 48 != n[0]) throw new r("Invalid signature tag");
                        if (n[1] !== o - 2) throw new r("Invalid signature: incorrect length");
                        const { d: i, l: s } = t.DER._parseInt(n.subarray(2)), { d: a, l: u } = t.DER._parseInt(s);
                        if (u.length) throw new r("Invalid signature: left bytes after parsing");
                        return {
                            r: i,
                            s: a
                        };
                    },
                    hexFromSig (e) {
                        const t = (e)=>8 & Number.parseInt(e[0], 16) ? "00" + e : e, r = (e)=>{
                            const t = e.toString(16);
                            return 1 & t.length ? `0${t}` : t;
                        }, n = t(r(e.s)), o = t(r(e.r)), i = n.length / 2, s = o.length / 2, a = r(i), c = r(s);
                        return `30${r(s + i + 4)}02${c}${o}02${a}${n}`;
                    }
                };
                const u = BigInt(0), d = BigInt(1), l = BigInt(2), h = BigInt(3), f = BigInt(4);
                function p(e) {
                    const t = function(e) {
                        const t = (0, s.validateBasic)(e);
                        o.validateObject(t, {
                            a: "field",
                            b: "field"
                        }, {
                            allowedPrivateKeyLengths: "array",
                            wrapPrivateKey: "boolean",
                            isTorsionFree: "function",
                            clearCofactor: "function",
                            allowInfinityPoint: "boolean",
                            fromBytes: "function",
                            toBytes: "function"
                        });
                        const { endo: r, Fp: n, a: i } = t;
                        if (r) {
                            if (!n.eql(i, n.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
                            if ("object" != typeof r || "bigint" != typeof r.beta || "function" != typeof r.splitScalar) throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
                        }
                        return Object.freeze({
                            ...t
                        });
                    }(e), { Fp: r } = t, a = t.toBytes || ((e, t, n)=>{
                        const i = t.toAffine();
                        return o.concatBytes(Uint8Array.from([
                            4
                        ]), r.toBytes(i.x), r.toBytes(i.y));
                    }), c = t.fromBytes || ((e)=>{
                        const t = e.subarray(1);
                        return {
                            x: r.fromBytes(t.subarray(0, r.BYTES)),
                            y: r.fromBytes(t.subarray(r.BYTES, 2 * r.BYTES))
                        };
                    });
                    function l(e) {
                        const { a: n, b: o } = t, i = r.sqr(e), s = r.mul(i, e);
                        return r.add(r.add(s, r.mul(e, n)), o);
                    }
                    if (!r.eql(r.sqr(t.Gy), l(t.Gx))) throw new Error("bad generator point: equation left != right");
                    function f(e) {
                        return "bigint" == typeof e && u < e && e < t.n;
                    }
                    function p(e) {
                        if (!f(e)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
                    }
                    function m(e) {
                        const { allowedPrivateKeyLengths: r, nByteLength: s, wrapPrivateKey: a, n: c } = t;
                        if (r && "bigint" != typeof e) {
                            if (e instanceof Uint8Array && (e = o.bytesToHex(e)), "string" != typeof e || !r.includes(e.length)) throw new Error("Invalid key");
                            e = e.padStart(2 * s, "0");
                        }
                        let u;
                        try {
                            u = "bigint" == typeof e ? e : o.bytesToNumberBE((0, i.ensureBytes)("private key", e, s));
                        } catch (t) {
                            throw new Error(`private key must be ${s} bytes, hex or bigint, not ${typeof e}`);
                        }
                        return a && (u = n.mod(u, c)), p(u), u;
                    }
                    const g = new Map;
                    function y(e) {
                        if (!(e instanceof v)) throw new Error("ProjectivePoint expected");
                    }
                    class v {
                        constructor(e, t, n){
                            if (this.px = e, this.py = t, this.pz = n, null == e || !r.isValid(e)) throw new Error("x required");
                            if (null == t || !r.isValid(t)) throw new Error("y required");
                            if (null == n || !r.isValid(n)) throw new Error("z required");
                        }
                        static fromAffine(e) {
                            const { x: t, y: n } = e || {};
                            if (!e || !r.isValid(t) || !r.isValid(n)) throw new Error("invalid affine point");
                            if (e instanceof v) throw new Error("projective point not allowed");
                            const o = (e)=>r.eql(e, r.ZERO);
                            return o(t) && o(n) ? v.ZERO : new v(t, n, r.ONE);
                        }
                        get x() {
                            return this.toAffine().x;
                        }
                        get y() {
                            return this.toAffine().y;
                        }
                        static normalizeZ(e) {
                            const t = r.invertBatch(e.map((e)=>e.pz));
                            return e.map((e, r)=>e.toAffine(t[r])).map(v.fromAffine);
                        }
                        static fromHex(e) {
                            const t = v.fromAffine(c((0, i.ensureBytes)("pointHex", e)));
                            return t.assertValidity(), t;
                        }
                        static fromPrivateKey(e) {
                            return v.BASE.multiply(m(e));
                        }
                        _setWindowSize(e) {
                            this._WINDOW_SIZE = e, g.delete(this);
                        }
                        assertValidity() {
                            if (this.is0()) {
                                if (t.allowInfinityPoint) return;
                                throw new Error("bad point: ZERO");
                            }
                            const { x: e, y: n } = this.toAffine();
                            if (!r.isValid(e) || !r.isValid(n)) throw new Error("bad point: x or y not FE");
                            const o = r.sqr(n), i = l(e);
                            if (!r.eql(o, i)) throw new Error("bad point: equation left != right");
                            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
                        }
                        hasEvenY() {
                            const { y: e } = this.toAffine();
                            if (r.isOdd) return !r.isOdd(e);
                            throw new Error("Field doesn't support isOdd");
                        }
                        equals(e) {
                            y(e);
                            const { px: t, py: n, pz: o } = this, { px: i, py: s, pz: a } = e, c = r.eql(r.mul(t, a), r.mul(i, o)), u = r.eql(r.mul(n, a), r.mul(s, o));
                            return c && u;
                        }
                        negate() {
                            return new v(this.px, r.neg(this.py), this.pz);
                        }
                        double() {
                            const { a: e, b: n } = t, o = r.mul(n, h), { px: i, py: s, pz: a } = this;
                            let c = r.ZERO, u = r.ZERO, d = r.ZERO, l = r.mul(i, i), f = r.mul(s, s), p = r.mul(a, a), m = r.mul(i, s);
                            return m = r.add(m, m), d = r.mul(i, a), d = r.add(d, d), c = r.mul(e, d), u = r.mul(o, p), u = r.add(c, u), c = r.sub(f, u), u = r.add(f, u), u = r.mul(c, u), c = r.mul(m, c), d = r.mul(o, d), p = r.mul(e, p), m = r.sub(l, p), m = r.mul(e, m), m = r.add(m, d), d = r.add(l, l), l = r.add(d, l), l = r.add(l, p), l = r.mul(l, m), u = r.add(u, l), p = r.mul(s, a), p = r.add(p, p), l = r.mul(p, m), c = r.sub(c, l), d = r.mul(p, f), d = r.add(d, d), d = r.add(d, d), new v(c, u, d);
                        }
                        add(e) {
                            y(e);
                            const { px: n, py: o, pz: i } = this, { px: s, py: a, pz: c } = e;
                            let u = r.ZERO, d = r.ZERO, l = r.ZERO;
                            const f = t.a, p = r.mul(t.b, h);
                            let m = r.mul(n, s), g = r.mul(o, a), b = r.mul(i, c), E = r.add(n, o), _ = r.add(s, a);
                            E = r.mul(E, _), _ = r.add(m, g), E = r.sub(E, _), _ = r.add(n, i);
                            let A = r.add(s, c);
                            return _ = r.mul(_, A), A = r.add(m, b), _ = r.sub(_, A), A = r.add(o, i), u = r.add(a, c), A = r.mul(A, u), u = r.add(g, b), A = r.sub(A, u), l = r.mul(f, _), u = r.mul(p, b), l = r.add(u, l), u = r.sub(g, l), l = r.add(g, l), d = r.mul(u, l), g = r.add(m, m), g = r.add(g, m), b = r.mul(f, b), _ = r.mul(p, _), g = r.add(g, b), b = r.sub(m, b), b = r.mul(f, b), _ = r.add(_, b), m = r.mul(g, _), d = r.add(d, m), m = r.mul(A, _), u = r.mul(E, u), u = r.sub(u, m), m = r.mul(E, g), l = r.mul(A, l), l = r.add(l, m), new v(u, d, l);
                        }
                        subtract(e) {
                            return this.add(e.negate());
                        }
                        is0() {
                            return this.equals(v.ZERO);
                        }
                        wNAF(e) {
                            return E.wNAFCached(this, g, e, (e)=>{
                                const t = r.invertBatch(e.map((e)=>e.pz));
                                return e.map((e, r)=>e.toAffine(t[r])).map(v.fromAffine);
                            });
                        }
                        multiplyUnsafe(e) {
                            const n = v.ZERO;
                            if (e === u) return n;
                            if (p(e), e === d) return this;
                            const { endo: o } = t;
                            if (!o) return E.unsafeLadder(this, e);
                            let { k1neg: i, k1: s, k2neg: a, k2: c } = o.splitScalar(e), l = n, h = n, f = this;
                            for(; s > u || c > u;)s & d && (l = l.add(f)), c & d && (h = h.add(f)), f = f.double(), s >>= d, c >>= d;
                            return i && (l = l.negate()), a && (h = h.negate()), h = new v(r.mul(h.px, o.beta), h.py, h.pz), l.add(h);
                        }
                        multiply(e) {
                            p(e);
                            let n, o, i = e;
                            const { endo: s } = t;
                            if (s) {
                                const { k1neg: e, k1: t, k2neg: a, k2: c } = s.splitScalar(i);
                                let { p: u, f: d } = this.wNAF(t), { p: l, f: h } = this.wNAF(c);
                                u = E.constTimeNegate(e, u), l = E.constTimeNegate(a, l), l = new v(r.mul(l.px, s.beta), l.py, l.pz), n = u.add(l), o = d.add(h);
                            } else {
                                const { p: e, f: t } = this.wNAF(i);
                                n = e, o = t;
                            }
                            return v.normalizeZ([
                                n,
                                o
                            ])[0];
                        }
                        multiplyAndAddUnsafe(e, t, r) {
                            const n = v.BASE, o = (e, t)=>t !== u && t !== d && e.equals(n) ? e.multiply(t) : e.multiplyUnsafe(t), i = o(this, t).add(o(e, r));
                            return i.is0() ? void 0 : i;
                        }
                        toAffine(e) {
                            const { px: t, py: n, pz: o } = this, i = this.is0();
                            null == e && (e = i ? r.ONE : r.inv(o));
                            const s = r.mul(t, e), a = r.mul(n, e), c = r.mul(o, e);
                            if (i) return {
                                x: r.ZERO,
                                y: r.ZERO
                            };
                            if (!r.eql(c, r.ONE)) throw new Error("invZ was invalid");
                            return {
                                x: s,
                                y: a
                            };
                        }
                        isTorsionFree() {
                            const { h: e, isTorsionFree: r } = t;
                            if (e === d) return !0;
                            if (r) return r(v, this);
                            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
                        }
                        clearCofactor() {
                            const { h: e, clearCofactor: r } = t;
                            return e === d ? this : r ? r(v, this) : this.multiplyUnsafe(t.h);
                        }
                        toRawBytes(e = !0) {
                            return this.assertValidity(), a(v, this, e);
                        }
                        toHex(e = !0) {
                            return o.bytesToHex(this.toRawBytes(e));
                        }
                    }
                    v.BASE = new v(t.Gx, t.Gy, r.ONE), v.ZERO = new v(r.ZERO, r.ONE, r.ZERO);
                    const b = t.nBitLength, E = (0, s.wNAF)(v, t.endo ? Math.ceil(b / 2) : b);
                    return {
                        CURVE: t,
                        ProjectivePoint: v,
                        normPrivateKeyToScalar: m,
                        weierstrassEquation: l,
                        isWithinCurveOrder: f
                    };
                }
                function m(e, t) {
                    const r = e.ORDER;
                    let n = u;
                    for(let e = r - d; e % l === u; e /= l)n += d;
                    const o = n, i = (r - d) / l ** o, s = (i - d) / l, a = l ** o - d, c = l ** (o - d), p = e.pow(t, i), m = e.pow(t, (i + d) / l);
                    let g = (t, r)=>{
                        let n = p, i = e.pow(r, a), u = e.sqr(i);
                        u = e.mul(u, r);
                        let h = e.mul(t, u);
                        h = e.pow(h, s), h = e.mul(h, i), i = e.mul(h, r), u = e.mul(h, t);
                        let f = e.mul(u, i);
                        h = e.pow(f, c);
                        let g = e.eql(h, e.ONE);
                        i = e.mul(u, m), h = e.mul(f, n), u = e.cmov(i, u, g), f = e.cmov(h, f, g);
                        for(let t = o; t > d; t--){
                            let r = l ** (t - l), o = e.pow(f, r);
                            const s = e.eql(o, e.ONE);
                            i = e.mul(u, n), n = e.mul(n, n), o = e.mul(f, n), u = e.cmov(i, u, s), f = e.cmov(o, f, s);
                        }
                        return {
                            isValid: g,
                            value: u
                        };
                    };
                    if (e.ORDER % f === h) {
                        const r = (e.ORDER - h) / f, n = e.sqrt(e.neg(t));
                        g = (t, o)=>{
                            let i = e.sqr(o);
                            const s = e.mul(t, o);
                            i = e.mul(i, s);
                            let a = e.pow(i, r);
                            a = e.mul(a, s);
                            const c = e.mul(a, n), u = e.mul(e.sqr(a), o), d = e.eql(u, t);
                            return {
                                isValid: d,
                                value: e.cmov(c, a, d)
                            };
                        };
                    }
                    return g;
                }
                t.weierstrassPoints = p, t.weierstrass = function(e) {
                    const r = function(e) {
                        const t = (0, s.validateBasic)(e);
                        return o.validateObject(t, {
                            hash: "hash",
                            hmac: "function",
                            randomBytes: "function"
                        }, {
                            bits2int: "function",
                            bits2int_modN: "function",
                            lowS: "boolean"
                        }), Object.freeze({
                            lowS: !0,
                            ...t
                        });
                    }(e), { Fp: a, n: c } = r, l = a.BYTES + 1, h = 2 * a.BYTES + 1;
                    function f(e) {
                        return n.mod(e, c);
                    }
                    function m(e) {
                        return n.invert(e, c);
                    }
                    const { ProjectivePoint: g, normPrivateKeyToScalar: y, weierstrassEquation: v, isWithinCurveOrder: b } = p({
                        ...r,
                        toBytes (e, t, r) {
                            const n = t.toAffine(), i = a.toBytes(n.x), s = o.concatBytes;
                            return r ? s(Uint8Array.from([
                                t.hasEvenY() ? 2 : 3
                            ]), i) : s(Uint8Array.from([
                                4
                            ]), i, a.toBytes(n.y));
                        },
                        fromBytes (e) {
                            const t = e.length, r = e[0], n = e.subarray(1);
                            if (t !== l || 2 !== r && 3 !== r) {
                                if (t === h && 4 === r) return {
                                    x: a.fromBytes(n.subarray(0, a.BYTES)),
                                    y: a.fromBytes(n.subarray(a.BYTES, 2 * a.BYTES))
                                };
                                throw new Error(`Point of length ${t} was invalid. Expected ${l} compressed bytes or ${h} uncompressed bytes`);
                            }
                            {
                                const e = o.bytesToNumberBE(n);
                                if (!(u < (i = e) && i < a.ORDER)) throw new Error("Point is not on curve");
                                const t = v(e);
                                let s = a.sqrt(t);
                                return 1 == (1 & r) != ((s & d) === d) && (s = a.neg(s)), {
                                    x: e,
                                    y: s
                                };
                            }
                            var i;
                        }
                    }), E = (e)=>o.bytesToHex(o.numberToBytesBE(e, r.nByteLength));
                    function _(e) {
                        return e > c >> d;
                    }
                    const A = (e, t, r)=>o.bytesToNumberBE(e.slice(t, r));
                    class T {
                        constructor(e, t, r){
                            this.r = e, this.s = t, this.recovery = r, this.assertValidity();
                        }
                        static fromCompact(e) {
                            const t = r.nByteLength;
                            return e = (0, i.ensureBytes)("compactSignature", e, 2 * t), new T(A(e, 0, t), A(e, t, 2 * t));
                        }
                        static fromDER(e) {
                            const { r: r, s: n } = t.DER.toSig((0, i.ensureBytes)("DER", e));
                            return new T(r, n);
                        }
                        assertValidity() {
                            if (!b(this.r)) throw new Error("r must be 0 < r < CURVE.n");
                            if (!b(this.s)) throw new Error("s must be 0 < s < CURVE.n");
                        }
                        addRecoveryBit(e) {
                            return new T(this.r, this.s, e);
                        }
                        recoverPublicKey(e) {
                            const { r: t, s: n, recovery: o } = this, s = P((0, i.ensureBytes)("msgHash", e));
                            if (null == o || ![
                                0,
                                1,
                                2,
                                3
                            ].includes(o)) throw new Error("recovery id invalid");
                            const c = 2 === o || 3 === o ? t + r.n : t;
                            if (c >= a.ORDER) throw new Error("recovery id 2 or 3 invalid");
                            const u = 0 == (1 & o) ? "02" : "03", d = g.fromHex(u + E(c)), l = m(c), h = f(-s * l), p = f(n * l), y = g.BASE.multiplyAndAddUnsafe(d, h, p);
                            if (!y) throw new Error("point at infinify");
                            return y.assertValidity(), y;
                        }
                        hasHighS() {
                            return _(this.s);
                        }
                        normalizeS() {
                            return this.hasHighS() ? new T(this.r, f(-this.s), this.recovery) : this;
                        }
                        toDERRawBytes() {
                            return o.hexToBytes(this.toDERHex());
                        }
                        toDERHex() {
                            return t.DER.hexFromSig({
                                r: this.r,
                                s: this.s
                            });
                        }
                        toCompactRawBytes() {
                            return o.hexToBytes(this.toCompactHex());
                        }
                        toCompactHex() {
                            return E(this.r) + E(this.s);
                        }
                    }
                    const w = {
                        isValidPrivateKey (e) {
                            try {
                                return y(e), !0;
                            } catch (e) {
                                return !1;
                            }
                        },
                        normPrivateKeyToScalar: y,
                        randomPrivateKey: ()=>{
                            const e = r.randomBytes(a.BYTES + 8), t = n.hashToPrivateScalar(e, c);
                            return o.numberToBytesBE(t, r.nByteLength);
                        },
                        precompute: (e = 8, t = g.BASE)=>(t._setWindowSize(e), t.multiply(BigInt(3)), t)
                    };
                    function I(e) {
                        const t = e instanceof Uint8Array, r = "string" == typeof e, n = (t || r) && e.length;
                        return t ? n === l || n === h : r ? n === 2 * l || n === 2 * h : e instanceof g;
                    }
                    const R = r.bits2int || function(e) {
                        const t = o.bytesToNumberBE(e), n = 8 * e.length - r.nBitLength;
                        return n > 0 ? t >> BigInt(n) : t;
                    }, P = r.bits2int_modN || function(e) {
                        return f(R(e));
                    }, x = o.bitMask(r.nBitLength);
                    function O(e) {
                        if ("bigint" != typeof e) throw new Error("bigint expected");
                        if (!(u <= e && e < x)) throw new Error(`bigint expected < 2^${r.nBitLength}`);
                        return o.numberToBytesBE(e, r.nByteLength);
                    }
                    const S = {
                        lowS: r.lowS,
                        prehash: !1
                    }, C = {
                        lowS: r.lowS,
                        prehash: !1
                    };
                    return g.BASE._setWindowSize(8), {
                        CURVE: r,
                        getPublicKey: function(e, t = !0) {
                            return g.fromPrivateKey(e).toRawBytes(t);
                        },
                        getSharedSecret: function(e, t, r = !0) {
                            if (I(e)) throw new Error("first arg must be private key");
                            if (!I(t)) throw new Error("second arg must be public key");
                            return g.fromHex(t).multiply(y(e)).toRawBytes(r);
                        },
                        sign: function(e, t, n = S) {
                            const { seed: s, k2sig: c } = function(e, t, n = S) {
                                if ([
                                    "recovered",
                                    "canonical"
                                ].some((e)=>e in n)) throw new Error("sign() legacy options not supported");
                                const { hash: s, randomBytes: c } = r;
                                let { lowS: l, prehash: h, extraEntropy: p } = n;
                                null == l && (l = !0), e = (0, i.ensureBytes)("msgHash", e), h && (e = (0, i.ensureBytes)("prehashed msgHash", s(e)));
                                const v = P(e), E = y(t), A = [
                                    O(E),
                                    O(v)
                                ];
                                if (null != p) {
                                    const e = !0 === p ? c(a.BYTES) : p;
                                    A.push((0, i.ensureBytes)("extraEntropy", e, a.BYTES));
                                }
                                const w = o.concatBytes(...A), I = v;
                                return {
                                    seed: w,
                                    k2sig: function(e) {
                                        const t = R(e);
                                        if (!b(t)) return;
                                        const r = m(t), n = g.BASE.multiply(t).toAffine(), o = f(n.x);
                                        if (o === u) return;
                                        const i = f(r * f(I + o * E));
                                        if (i === u) return;
                                        let s = (n.x === o ? 0 : 2) | Number(n.y & d), a = i;
                                        return l && _(i) && (a = function(e) {
                                            return _(e) ? f(-e) : e;
                                        }(i), s ^= 1), new T(o, a, s);
                                    }
                                };
                            }(e, t, n);
                            return o.createHmacDrbg(r.hash.outputLen, r.nByteLength, r.hmac)(s, c);
                        },
                        verify: function(e, n, o, s = C) {
                            const a = e;
                            if (n = (0, i.ensureBytes)("msgHash", n), o = (0, i.ensureBytes)("publicKey", o), "strict" in s) throw new Error("options.strict was renamed to lowS");
                            const { lowS: c, prehash: u } = s;
                            let d, l;
                            try {
                                if ("string" == typeof a || a instanceof Uint8Array) try {
                                    d = T.fromDER(a);
                                } catch (e) {
                                    if (!(e instanceof t.DER.Err)) throw e;
                                    d = T.fromCompact(a);
                                }
                                else {
                                    if ("object" != typeof a || "bigint" != typeof a.r || "bigint" != typeof a.s) throw new Error("PARSE");
                                    {
                                        const { r: e, s: t } = a;
                                        d = new T(e, t);
                                    }
                                }
                                l = g.fromHex(o);
                            } catch (e) {
                                if ("PARSE" === e.message) throw new Error("signature must be Signature instance, Uint8Array or hex string");
                                return !1;
                            }
                            if (c && d.hasHighS()) return !1;
                            u && (n = r.hash(n));
                            const { r: h, s: p } = d, y = P(n), v = m(p), b = f(y * v), E = f(h * v), _ = g.BASE.multiplyAndAddUnsafe(l, b, E)?.toAffine();
                            return !!_ && f(_.x) === h;
                        },
                        ProjectivePoint: g,
                        Signature: T,
                        utils: w
                    };
                }, t.SWUFpSqrtRatio = m, t.mapToCurveSimpleSWU = function(e, t) {
                    if (n.validateField(e), !e.isValid(t.A) || !e.isValid(t.B) || !e.isValid(t.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
                    const r = m(e, t.Z);
                    if (!e.isOdd) throw new Error("Fp.isOdd is not implemented!");
                    return (n)=>{
                        let o, i, s, a, c, u, d, l;
                        o = e.sqr(n), o = e.mul(o, t.Z), i = e.sqr(o), i = e.add(i, o), s = e.add(i, e.ONE), s = e.mul(s, t.B), a = e.cmov(t.Z, e.neg(i), !e.eql(i, e.ZERO)), a = e.mul(a, t.A), i = e.sqr(s), u = e.sqr(a), c = e.mul(u, t.A), i = e.add(i, c), i = e.mul(i, s), u = e.mul(u, a), c = e.mul(u, t.B), i = e.add(i, c), d = e.mul(o, s);
                        const { isValid: h, value: f } = r(i, u);
                        l = e.mul(o, n), l = e.mul(l, f), d = e.cmov(d, s, h), l = e.cmov(l, f, h);
                        const p = e.isOdd(n) === e.isOdd(l);
                        return l = e.cmov(e.neg(l), l, p), d = e.div(d, a), {
                            x: d,
                            y: l
                        };
                    };
                };
            },
            1613: (e, t)=>{
                "use strict";
                function r(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Wrong positive integer: ${e}`);
                }
                function n(e) {
                    if ("boolean" != typeof e) throw new Error(`Expected boolean, not ${e}`);
                }
                function o(e, ...t) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
                    if (t.length > 0 && !t.includes(e.length)) throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
                }
                function i(e) {
                    if ("function" != typeof e || "function" != typeof e.create) throw new Error("Hash should be wrapped by utils.wrapConstructor");
                    r(e.outputLen), r(e.blockLen);
                }
                function s(e, t = !0) {
                    if (e.destroyed) throw new Error("Hash instance has been destroyed");
                    if (t && e.finished) throw new Error("Hash#digest() has already been called");
                }
                function a(e, t) {
                    o(e);
                    const r = t.outputLen;
                    if (e.length < r) throw new Error(`digestInto() expects output buffer of length at least ${r}`);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.output = t.exists = t.hash = t.bytes = t.bool = t.number = void 0, t.number = r, t.bool = n, t.bytes = o, t.hash = i, t.exists = s, t.output = a;
                const c = {
                    number: r,
                    bool: n,
                    bytes: o,
                    hash: i,
                    exists: s,
                    output: a
                };
                t.default = c;
            },
            4490: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SHA2 = void 0;
                const n = r(1613), o = r(488);
                class i extends o.Hash {
                    constructor(e, t, r, n){
                        super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = (0, o.createView)(this.buffer);
                    }
                    update(e) {
                        n.default.exists(this);
                        const { view: t, buffer: r, blockLen: i } = this, s = (e = (0, o.toBytes)(e)).length;
                        for(let n = 0; n < s;){
                            const a = Math.min(i - this.pos, s - n);
                            if (a !== i) r.set(e.subarray(n, n + a), this.pos), this.pos += a, n += a, this.pos === i && (this.process(t, 0), this.pos = 0);
                            else {
                                const t = (0, o.createView)(e);
                                for(; i <= s - n; n += i)this.process(t, n);
                            }
                        }
                        return this.length += e.length, this.roundClean(), this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.output(e, this), this.finished = !0;
                        const { buffer: t, view: r, blockLen: i, isLE: s } = this;
                        let { pos: a } = this;
                        t[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > i - a && (this.process(r, 0), a = 0);
                        for(let e = a; e < i; e++)t[e] = 0;
                        !function(e, t, r, n) {
                            if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, r, n);
                            const o = BigInt(32), i = BigInt(4294967295), s = Number(r >> o & i), a = Number(r & i), c = n ? 4 : 0, u = n ? 0 : 4;
                            e.setUint32(t + c, s, n), e.setUint32(t + u, a, n);
                        }(r, i - 8, BigInt(8 * this.length), s), this.process(r, 0);
                        const c = (0, o.createView)(e), u = this.outputLen;
                        if (u % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                        const d = u / 4, l = this.get();
                        if (d > l.length) throw new Error("_sha2: outputLen bigger than state");
                        for(let e = 0; e < d; e++)c.setUint32(4 * e, l[e], s);
                    }
                    digest() {
                        const { buffer: e, outputLen: t } = this;
                        this.digestInto(e);
                        const r = e.slice(0, t);
                        return this.destroy(), r;
                    }
                    _cloneInto(e) {
                        e || (e = new this.constructor), e.set(...this.get());
                        const { blockLen: t, buffer: r, length: n, finished: o, destroyed: i, pos: s } = this;
                        return e.length = n, e.pos = s, e.finished = o, e.destroyed = i, n % t && e.buffer.set(r), e;
                    }
                }
                t.SHA2 = i;
            },
            9419: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = void 0, t.crypto = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0;
            },
            7493: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hmac = void 0;
                const n = r(1613), o = r(488);
                class i extends o.Hash {
                    constructor(e, t){
                        super(), this.finished = !1, this.destroyed = !1, n.default.hash(e);
                        const r = (0, o.toBytes)(t);
                        if (this.iHash = e.create(), "function" != typeof this.iHash.update) throw new TypeError("Expected instance of class which extends utils.Hash");
                        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
                        const i = this.blockLen, s = new Uint8Array(i);
                        s.set(r.length > i ? e.create().update(r).digest() : r);
                        for(let e = 0; e < s.length; e++)s[e] ^= 54;
                        this.iHash.update(s), this.oHash = e.create();
                        for(let e = 0; e < s.length; e++)s[e] ^= 106;
                        this.oHash.update(s), s.fill(0);
                    }
                    update(e) {
                        return n.default.exists(this), this.iHash.update(e), this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.bytes(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
                    }
                    digest() {
                        const e = new Uint8Array(this.oHash.outputLen);
                        return this.digestInto(e), e;
                    }
                    _cloneInto(e) {
                        e || (e = Object.create(Object.getPrototypeOf(this), {}));
                        const { oHash: t, iHash: r, finished: n, destroyed: o, blockLen: i, outputLen: s } = this;
                        return e.finished = n, e.destroyed = o, e.blockLen = i, e.outputLen = s, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
                    }
                    destroy() {
                        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
                    }
                }
                t.hmac = (e, t, r)=>new i(e, t).update(r).digest(), t.hmac.create = (e, t)=>new i(e, t);
            },
            7371: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sha224 = t.sha256 = void 0;
                const n = r(4490), o = r(488), i = (e, t, r)=>e & t ^ e & r ^ t & r, s = new Uint32Array([
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ]), a = new Uint32Array([
                    1779033703,
                    3144134277,
                    1013904242,
                    2773480762,
                    1359893119,
                    2600822924,
                    528734635,
                    1541459225
                ]), c = new Uint32Array(64);
                class u extends n.SHA2 {
                    constructor(){
                        super(64, 32, 8, !1), this.A = 0 | a[0], this.B = 0 | a[1], this.C = 0 | a[2], this.D = 0 | a[3], this.E = 0 | a[4], this.F = 0 | a[5], this.G = 0 | a[6], this.H = 0 | a[7];
                    }
                    get() {
                        const { A: e, B: t, C: r, D: n, E: o, F: i, G: s, H: a } = this;
                        return [
                            e,
                            t,
                            r,
                            n,
                            o,
                            i,
                            s,
                            a
                        ];
                    }
                    set(e, t, r, n, o, i, s, a) {
                        this.A = 0 | e, this.B = 0 | t, this.C = 0 | r, this.D = 0 | n, this.E = 0 | o, this.F = 0 | i, this.G = 0 | s, this.H = 0 | a;
                    }
                    process(e, t) {
                        for(let r = 0; r < 16; r++, t += 4)c[r] = e.getUint32(t, !1);
                        for(let e = 16; e < 64; e++){
                            const t = c[e - 15], r = c[e - 2], n = (0, o.rotr)(t, 7) ^ (0, o.rotr)(t, 18) ^ t >>> 3, i = (0, o.rotr)(r, 17) ^ (0, o.rotr)(r, 19) ^ r >>> 10;
                            c[e] = i + c[e - 7] + n + c[e - 16] | 0;
                        }
                        let { A: r, B: n, C: a, D: u, E: d, F: l, G: h, H: f } = this;
                        for(let e = 0; e < 64; e++){
                            const t = f + ((0, o.rotr)(d, 6) ^ (0, o.rotr)(d, 11) ^ (0, o.rotr)(d, 25)) + ((p = d) & l ^ ~p & h) + s[e] + c[e] | 0, m = ((0, o.rotr)(r, 2) ^ (0, o.rotr)(r, 13) ^ (0, o.rotr)(r, 22)) + i(r, n, a) | 0;
                            f = h, h = l, l = d, d = u + t | 0, u = a, a = n, n = r, r = t + m | 0;
                        }
                        var p;
                        r = r + this.A | 0, n = n + this.B | 0, a = a + this.C | 0, u = u + this.D | 0, d = d + this.E | 0, l = l + this.F | 0, h = h + this.G | 0, f = f + this.H | 0, this.set(r, n, a, u, d, l, h, f);
                    }
                    roundClean() {
                        c.fill(0);
                    }
                    destroy() {
                        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
                    }
                }
                class d extends u {
                    constructor(){
                        super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
                    }
                }
                t.sha256 = (0, o.wrapConstructor)(()=>new u), t.sha224 = (0, o.wrapConstructor)(()=>new d);
            },
            488: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomBytes = t.wrapConstructorWithOpts = t.wrapConstructor = t.checkOpts = t.Hash = t.concatBytes = t.toBytes = t.utf8ToBytes = t.asyncLoop = t.nextTick = t.hexToBytes = t.bytesToHex = t.isLE = t.rotr = t.createView = t.u32 = t.u8 = void 0;
                const n = r(9419);
                if (t.u8 = (e)=>new Uint8Array(e.buffer, e.byteOffset, e.byteLength), t.u32 = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), t.createView = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength), t.rotr = (e, t)=>e << 32 - t | e >>> t, t.isLE = 68 === new Uint8Array(new Uint32Array([
                    287454020
                ]).buffer)[0], !t.isLE) throw new Error("Non little-endian hardware is not supported");
                const o = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function i(e) {
                    if ("string" != typeof e) throw new TypeError("utf8ToBytes expected string, got " + typeof e);
                    return (new TextEncoder).encode(e);
                }
                function s(e) {
                    if ("string" == typeof e && (e = i(e)), !(e instanceof Uint8Array)) throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
                    return e;
                }
                t.bytesToHex = function(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += o[e[r]];
                    return t;
                }, t.hexToBytes = function(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + typeof e);
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r, o = e.slice(n, n + 2), i = Number.parseInt(o, 16);
                        if (Number.isNaN(i) || i < 0) throw new Error("Invalid byte sequence");
                        t[r] = i;
                    }
                    return t;
                }, t.nextTick = async ()=>{}, t.asyncLoop = async function(e, r, n) {
                    let o = Date.now();
                    for(let i = 0; i < e; i++){
                        n(i);
                        const e = Date.now() - o;
                        e >= 0 && e < r || (await (0, t.nextTick)(), o += e);
                    }
                }, t.utf8ToBytes = i, t.toBytes = s, t.concatBytes = function(...e) {
                    if (!e.every((e)=>e instanceof Uint8Array)) throw new Error("Uint8Array list expected");
                    if (1 === e.length) return e[0];
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    for(let t = 0, n = 0; t < e.length; t++){
                        const o = e[t];
                        r.set(o, n), n += o.length;
                    }
                    return r;
                }, t.Hash = class {
                    clone() {
                        return this._cloneInto();
                    }
                }, t.checkOpts = function(e, t) {
                    if (void 0 !== t && ("object" != typeof t || (r = t, "[object Object]" !== Object.prototype.toString.call(r) || r.constructor !== Object))) throw new TypeError("Options should be object or undefined");
                    var r;
                    return Object.assign(e, t);
                }, t.wrapConstructor = function(e) {
                    const t = (t)=>e().update(s(t)).digest(), r = e();
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = ()=>e(), t;
                }, t.wrapConstructorWithOpts = function(e) {
                    const t = (t, r)=>e(r).update(s(t)).digest(), r = e({});
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (t)=>e(t), t;
                }, t.randomBytes = function(e = 32) {
                    if (n.crypto && "function" == typeof n.crypto.getRandomValues) return n.crypto.getRandomValues(new Uint8Array(e));
                    throw new Error("crypto.getRandomValues must be defined");
                };
            },
            8358: (e, t, r)=>{
                "use strict";
                var n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeToCurve = t.hashToCurve = t.schnorr = t.secp256k1 = void 0;
                const o = r(7371), i = r(488), s = r(9530), a = r(7851), c = r(4323), u = r(1322), d = r(5887), l = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), h = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), f = BigInt(1), p = BigInt(2), m = (e, t)=>(e + t / p) / t;
                function g(e) {
                    const t = l, r = BigInt(3), n = BigInt(6), o = BigInt(11), i = BigInt(22), a = BigInt(23), c = BigInt(44), u = BigInt(88), d = e * e * e % t, h = d * d * e % t, f = (0, s.pow2)(h, r, t) * h % t, m = (0, s.pow2)(f, r, t) * h % t, g = (0, s.pow2)(m, p, t) * d % t, v = (0, s.pow2)(g, o, t) * g % t, b = (0, s.pow2)(v, i, t) * v % t, E = (0, s.pow2)(b, c, t) * b % t, _ = (0, s.pow2)(E, u, t) * E % t, A = (0, s.pow2)(_, c, t) * b % t, T = (0, s.pow2)(A, r, t) * h % t, w = (0, s.pow2)(T, a, t) * v % t, I = (0, s.pow2)(w, n, t) * d % t, R = (0, s.pow2)(I, p, t);
                    if (!y.eql(y.sqr(R), e)) throw new Error("Cannot find square root");
                    return R;
                }
                const y = (0, s.Field)(l, void 0, void 0, {
                    sqrt: g
                });
                t.secp256k1 = (0, d.createCurve)({
                    a: BigInt(0),
                    b: BigInt(7),
                    Fp: y,
                    n: h,
                    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
                    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
                    h: BigInt(1),
                    lowS: !0,
                    endo: {
                        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
                        splitScalar: (e)=>{
                            const t = h, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -f * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), o = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), i = r, a = BigInt("0x100000000000000000000000000000000"), c = m(i * e, t), u = m(-n * e, t);
                            let d = (0, s.mod)(e - c * r - u * o, t), l = (0, s.mod)(-c * n - u * i, t);
                            const p = d > a, g = l > a;
                            if (p && (d = t - d), g && (l = t - l), d > a || l > a) throw new Error("splitScalar: Endomorphism failed, k=" + e);
                            return {
                                k1neg: p,
                                k1: d,
                                k2neg: g,
                                k2: l
                            };
                        }
                    }
                }, o.sha256);
                const v = BigInt(0), b = (e)=>"bigint" == typeof e && v < e && e < l, E = {};
                function _(e, ...t) {
                    let r = E[e];
                    if (void 0 === r) {
                        const t = (0, o.sha256)(Uint8Array.from(e, (e)=>e.charCodeAt(0)));
                        r = (0, c.concatBytes)(t, t), E[e] = r;
                    }
                    return (0, o.sha256)((0, c.concatBytes)(r, ...t));
                }
                const A = (e)=>e.toRawBytes(!0).slice(1), T = (e)=>(0, c.numberToBytesBE)(e, 32), w = (e)=>(0, s.mod)(e, l), I = (e)=>(0, s.mod)(e, h), R = t.secp256k1.ProjectivePoint;
                function P(e) {
                    let r = t.secp256k1.utils.normPrivateKeyToScalar(e), n = R.fromPrivateKey(r);
                    return {
                        scalar: n.hasEvenY() ? r : I(-r),
                        bytes: A(n)
                    };
                }
                function x(e) {
                    if (!b(e)) throw new Error("bad x: need 0 < x < p");
                    const t = w(e * e);
                    let r = g(w(t * e + BigInt(7)));
                    r % p !== v && (r = w(-r));
                    const n = new R(e, r, f);
                    return n.assertValidity(), n;
                }
                function O(...e) {
                    return I((0, c.bytesToNumberBE)(_("BIP0340/challenge", ...e)));
                }
                function S(e, t, r) {
                    const n = (0, c.ensureBytes)("signature", e, 64), o = (0, c.ensureBytes)("message", t), i = (0, c.ensureBytes)("publicKey", r, 32);
                    try {
                        const e = x((0, c.bytesToNumberBE)(i)), t = (0, c.bytesToNumberBE)(n.subarray(0, 32));
                        if (!b(t)) return !1;
                        const r = (0, c.bytesToNumberBE)(n.subarray(32, 64));
                        if (!("bigint" == typeof (d = r) && v < d && d < h)) return !1;
                        const l = O(T(t), A(e), o), f = (s = e, a = r, u = I(-l), R.BASE.multiplyAndAddUnsafe(s, a, u));
                        return !(!f || !f.hasEvenY() || f.toAffine().x !== t);
                    } catch (e) {
                        return !1;
                    }
                    var s, a, u, d;
                }
                t.schnorr = {
                    getPublicKey: function(e) {
                        return P(e).bytes;
                    },
                    sign: function(e, t, r = (0, i.randomBytes)(32)) {
                        const n = (0, c.ensureBytes)("message", e), { bytes: o, scalar: s } = P(t), a = (0, c.ensureBytes)("auxRand", r, 32), u = T(s ^ (0, c.bytesToNumberBE)(_("BIP0340/aux", a))), d = _("BIP0340/nonce", u, o, n), l = I((0, c.bytesToNumberBE)(d));
                        if (l === v) throw new Error("sign failed: k is zero");
                        const { bytes: h, scalar: f } = P(l), p = O(h, o, n), m = new Uint8Array(64);
                        if (m.set(h, 0), m.set(T(I(f + p * s)), 32), !S(m, n, o)) throw new Error("sign: Invalid signature produced");
                        return m;
                    },
                    verify: S,
                    utils: {
                        randomPrivateKey: t.secp256k1.utils.randomPrivateKey,
                        lift_x: x,
                        pointToBytes: A,
                        numberToBytesBE: c.numberToBytesBE,
                        bytesToNumberBE: c.bytesToNumberBE,
                        taggedHash: _,
                        mod: s.mod
                    }
                };
                const C = u.isogenyMap(y, [
                    [
                        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
                        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
                        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
                        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
                    ],
                    [
                        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
                        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
                        "0x0000000000000000000000000000000000000000000000000000000000000001"
                    ],
                    [
                        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
                        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
                        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
                        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
                    ],
                    [
                        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
                        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
                        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
                        "0x0000000000000000000000000000000000000000000000000000000000000001"
                    ]
                ].map((e)=>e.map((e)=>BigInt(e)))), B = (0, a.mapToCurveSimpleSWU)(y, {
                    A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
                    B: BigInt("1771"),
                    Z: y.create(BigInt("-11"))
                });
                n = u.createHasher(t.secp256k1.ProjectivePoint, (e)=>{
                    const { x: t, y: r } = B(y.create(e[0]));
                    return C(t, r);
                }, {
                    DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
                    encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
                    p: y.ORDER,
                    m: 1,
                    k: 128,
                    expand: "xmd",
                    hash: o.sha256
                }), t.hashToCurve = n.hashToCurve, t.encodeToCurve = n.encodeToCurve;
            },
            1238: (e, t)=>{
                var r;
                r = function(e) {
                    e.version = "1.2.2";
                    var t = function() {
                        for(var e = 0, t = new Array(256), r = 0; 256 != r; ++r)e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = r) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1, t[r] = e;
                        return "undefined" != typeof Int32Array ? new Int32Array(t) : t;
                    }(), r = function(e) {
                        var t = 0, r = 0, n = 0, o = "undefined" != typeof Int32Array ? new Int32Array(4096) : new Array(4096);
                        for(n = 0; 256 != n; ++n)o[n] = e[n];
                        for(n = 0; 256 != n; ++n)for(r = e[n], t = 256 + n; t < 4096; t += 256)r = o[t] = r >>> 8 ^ e[255 & r];
                        var i = [];
                        for(n = 1; 16 != n; ++n)i[n - 1] = "undefined" != typeof Int32Array ? o.subarray(256 * n, 256 * n + 256) : o.slice(256 * n, 256 * n + 256);
                        return i;
                    }(t), n = r[0], o = r[1], i = r[2], s = r[3], a = r[4], c = r[5], u = r[6], d = r[7], l = r[8], h = r[9], f = r[10], p = r[11], m = r[12], g = r[13], y = r[14];
                    e.table = t, e.bstr = function(e, r) {
                        for(var n = -1 ^ r, o = 0, i = e.length; o < i;)n = n >>> 8 ^ t[255 & (n ^ e.charCodeAt(o++))];
                        return ~n;
                    }, e.buf = function(e, r) {
                        for(var v = -1 ^ r, b = e.length - 15, E = 0; E < b;)v = y[e[E++] ^ 255 & v] ^ g[e[E++] ^ v >> 8 & 255] ^ m[e[E++] ^ v >> 16 & 255] ^ p[e[E++] ^ v >>> 24] ^ f[e[E++]] ^ h[e[E++]] ^ l[e[E++]] ^ d[e[E++]] ^ u[e[E++]] ^ c[e[E++]] ^ a[e[E++]] ^ s[e[E++]] ^ i[e[E++]] ^ o[e[E++]] ^ n[e[E++]] ^ t[e[E++]];
                        for(b += 15; E < b;)v = v >>> 8 ^ t[255 & (v ^ e[E++])];
                        return ~v;
                    }, e.str = function(e, r) {
                        for(var n = -1 ^ r, o = 0, i = e.length, s = 0, a = 0; o < i;)(s = e.charCodeAt(o++)) < 128 ? n = n >>> 8 ^ t[255 & (n ^ s)] : s < 2048 ? n = (n = n >>> 8 ^ t[255 & (n ^ (192 | s >> 6 & 31))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & s))] : s >= 55296 && s < 57344 ? (s = 64 + (1023 & s), a = 1023 & e.charCodeAt(o++), n = (n = (n = (n = n >>> 8 ^ t[255 & (n ^ (240 | s >> 8 & 7))]) >>> 8 ^ t[255 & (n ^ (128 | s >> 2 & 63))]) >>> 8 ^ t[255 & (n ^ (128 | a >> 6 & 15 | (3 & s) << 4))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & a))]) : n = (n = (n = n >>> 8 ^ t[255 & (n ^ (224 | s >> 12 & 15))]) >>> 8 ^ t[255 & (n ^ (128 | s >> 6 & 63))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & s))];
                        return ~n;
                    };
                }, "undefined" == typeof DO_NOT_EXPORT_CRC ? r(t) : r({});
            },
            6279: (e, t, r)=>{
                var n = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== r.g && r.g, o = function() {
                    function e() {
                        this.fetch = !1, this.DOMException = n.DOMException;
                    }
                    return e.prototype = n, new e;
                }();
                !function(e) {
                    !function(t) {
                        var r = void 0 !== e && e || "undefined" != typeof self && self || void 0 !== r && r, n = "URLSearchParams" in r, o = "Symbol" in r && "iterator" in Symbol, i = "FileReader" in r && "Blob" in r && function() {
                            try {
                                return new Blob, !0;
                            } catch (e) {
                                return !1;
                            }
                        }(), s = "FormData" in r, a = "ArrayBuffer" in r;
                        if (a) var c = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], u = ArrayBuffer.isView || function(e) {
                            return e && c.indexOf(Object.prototype.toString.call(e)) > -1;
                        };
                        function d(e) {
                            if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError('Invalid character in header field name: "' + e + '"');
                            return e.toLowerCase();
                        }
                        function l(e) {
                            return "string" != typeof e && (e = String(e)), e;
                        }
                        function h(e) {
                            var t = {
                                next: function() {
                                    var t = e.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return o && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function f(e) {
                            this.map = {}, e instanceof f ? e.forEach(function(e, t) {
                                this.append(t, e);
                            }, this) : Array.isArray(e) ? e.forEach(function(e) {
                                this.append(e[0], e[1]);
                            }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
                                this.append(t, e[t]);
                            }, this);
                        }
                        function p(e) {
                            if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e.bodyUsed = !0;
                        }
                        function m(e) {
                            return new Promise(function(t, r) {
                                e.onload = function() {
                                    t(e.result);
                                }, e.onerror = function() {
                                    r(e.error);
                                };
                            });
                        }
                        function g(e) {
                            var t = new FileReader, r = m(t);
                            return t.readAsArrayBuffer(e), r;
                        }
                        function y(e) {
                            if (e.slice) return e.slice(0);
                            var t = new Uint8Array(e.byteLength);
                            return t.set(new Uint8Array(e)), t.buffer;
                        }
                        function v() {
                            return this.bodyUsed = !1, this._initBody = function(e) {
                                var t;
                                this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : i && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : s && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : a && i && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = y(e.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : a && (ArrayBuffer.prototype.isPrototypeOf(e) || u(e)) ? this._bodyArrayBuffer = y(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, i && (this.blob = function() {
                                var e = p(this);
                                if (e) return e;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? p(this) || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer)) : this.blob().then(g);
                            }), this.text = function() {
                                var e, t, r, n = p(this);
                                if (n) return n;
                                if (this._bodyBlob) return e = this._bodyBlob, r = m(t = new FileReader), t.readAsText(e), r;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e) {
                                    for(var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++)r[n] = String.fromCharCode(t[n]);
                                    return r.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, s && (this.formData = function() {
                                return this.text().then(_);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        f.prototype.append = function(e, t) {
                            e = d(e), t = l(t);
                            var r = this.map[e];
                            this.map[e] = r ? r + ", " + t : t;
                        }, f.prototype.delete = function(e) {
                            delete this.map[d(e)];
                        }, f.prototype.get = function(e) {
                            return e = d(e), this.has(e) ? this.map[e] : null;
                        }, f.prototype.has = function(e) {
                            return this.map.hasOwnProperty(d(e));
                        }, f.prototype.set = function(e, t) {
                            this.map[d(e)] = l(t);
                        }, f.prototype.forEach = function(e, t) {
                            for(var r in this.map)this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
                        }, f.prototype.keys = function() {
                            var e = [];
                            return this.forEach(function(t, r) {
                                e.push(r);
                            }), h(e);
                        }, f.prototype.values = function() {
                            var e = [];
                            return this.forEach(function(t) {
                                e.push(t);
                            }), h(e);
                        }, f.prototype.entries = function() {
                            var e = [];
                            return this.forEach(function(t, r) {
                                e.push([
                                    r,
                                    t
                                ]);
                            }), h(e);
                        }, o && (f.prototype[Symbol.iterator] = f.prototype.entries);
                        var b = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function E(e, t) {
                            if (!(this instanceof E)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                            var r, n, o = (t = t || {}).body;
                            if (e instanceof E) {
                                if (e.bodyUsed) throw new TypeError("Already read");
                                this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new f(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
                            } else this.url = String(e);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new f(t.headers)), this.method = (n = (r = t.method || this.method || "GET").toUpperCase(), b.indexOf(n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                            if (this._initBody(o), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
                                var i = /([?&])_=[^&]*/;
                                i.test(this.url) ? this.url = this.url.replace(i, "$1_=" + (new Date).getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime();
                            }
                        }
                        function _(e) {
                            var t = new FormData;
                            return e.trim().split("&").forEach(function(e) {
                                if (e) {
                                    var r = e.split("="), n = r.shift().replace(/\+/g, " "), o = r.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(n), decodeURIComponent(o));
                                }
                            }), t;
                        }
                        function A(e, t) {
                            if (!(this instanceof A)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new f(t.headers), this.url = t.url || "", this._initBody(e);
                        }
                        E.prototype.clone = function() {
                            return new E(this, {
                                body: this._bodyInit
                            });
                        }, v.call(E.prototype), v.call(A.prototype), A.prototype.clone = function() {
                            return new A(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new f(this.headers),
                                url: this.url
                            });
                        }, A.error = function() {
                            var e = new A(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e.type = "error", e;
                        };
                        var T = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        A.redirect = function(e, t) {
                            if (-1 === T.indexOf(t)) throw new RangeError("Invalid status code");
                            return new A(null, {
                                status: t,
                                headers: {
                                    location: e
                                }
                            });
                        }, t.DOMException = r.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e) {
                            t.DOMException = function(e, t) {
                                this.message = e, this.name = t;
                                var r = Error(e);
                                this.stack = r.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function w(e, n) {
                            return new Promise(function(o, s) {
                                var c = new E(e, n);
                                if (c.signal && c.signal.aborted) return s(new t.DOMException("Aborted", "AbortError"));
                                var u = new XMLHttpRequest;
                                function d() {
                                    u.abort();
                                }
                                u.onload = function() {
                                    var e, t, r = {
                                        status: u.status,
                                        statusText: u.statusText,
                                        headers: (e = u.getAllResponseHeaders() || "", t = new f, e.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(e) {
                                            return 0 === e.indexOf("\n") ? e.substr(1, e.length) : e;
                                        }).forEach(function(e) {
                                            var r = e.split(":"), n = r.shift().trim();
                                            if (n) {
                                                var o = r.join(":").trim();
                                                t.append(n, o);
                                            }
                                        }), t)
                                    };
                                    r.url = "responseURL" in u ? u.responseURL : r.headers.get("X-Request-URL");
                                    var n = "response" in u ? u.response : u.responseText;
                                    setTimeout(function() {
                                        o(new A(n, r));
                                    }, 0);
                                }, u.onerror = function() {
                                    setTimeout(function() {
                                        s(new TypeError("Network request failed"));
                                    }, 0);
                                }, u.ontimeout = function() {
                                    setTimeout(function() {
                                        s(new TypeError("Network request failed"));
                                    }, 0);
                                }, u.onabort = function() {
                                    setTimeout(function() {
                                        s(new t.DOMException("Aborted", "AbortError"));
                                    }, 0);
                                }, u.open(c.method, function(e) {
                                    try {
                                        return "" === e && r.location.href ? r.location.href : e;
                                    } catch (t) {
                                        return e;
                                    }
                                }(c.url), !0), "include" === c.credentials ? u.withCredentials = !0 : "omit" === c.credentials && (u.withCredentials = !1), "responseType" in u && (i ? u.responseType = "blob" : a && c.headers.get("Content-Type") && -1 !== c.headers.get("Content-Type").indexOf("application/octet-stream") && (u.responseType = "arraybuffer")), !n || "object" != typeof n.headers || n.headers instanceof f ? c.headers.forEach(function(e, t) {
                                    u.setRequestHeader(t, e);
                                }) : Object.getOwnPropertyNames(n.headers).forEach(function(e) {
                                    u.setRequestHeader(e, l(n.headers[e]));
                                }), c.signal && (c.signal.addEventListener("abort", d), u.onreadystatechange = function() {
                                    4 === u.readyState && c.signal.removeEventListener("abort", d);
                                }), u.send(void 0 === c._bodyInit ? null : c._bodyInit);
                            });
                        }
                        w.polyfill = !0, r.fetch || (r.fetch = w, r.Headers = f, r.Request = E, r.Response = A), t.Headers = f, t.Request = E, t.Response = A, t.fetch = w;
                    }({});
                }(o), o.fetch.ponyfill = !0, delete o.fetch.polyfill;
                var i = n.fetch ? n : o;
                (t = i.fetch).default = i.fetch, t.fetch = i.fetch, t.Headers = i.Headers, t.Request = i.Request, t.Response = i.Response, e.exports = t;
            },
            7475: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>o
                });
                var n = null;
                "undefined" != typeof WebSocket ? n = WebSocket : "undefined" != typeof MozWebSocket ? n = MozWebSocket : void 0 !== r.g ? n = r.g.WebSocket || r.g.MozWebSocket : "undefined" != typeof window ? n = window.WebSocket || window.MozWebSocket : "undefined" != typeof self && (n = self.WebSocket || self.MozWebSocket);
                const o = n;
            },
            4406: (e)=>{
                var t, r, n = e.exports = {};
                function o() {
                    throw new Error("setTimeout has not been defined");
                }
                function i() {
                    throw new Error("clearTimeout has not been defined");
                }
                function s(e) {
                    if (t === setTimeout) return setTimeout(e, 0);
                    if ((t === o || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
                    try {
                        return t(e, 0);
                    } catch (r) {
                        try {
                            return t.call(null, e, 0);
                        } catch (r) {
                            return t.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        t = "function" == typeof setTimeout ? setTimeout : o;
                    } catch (e) {
                        t = o;
                    }
                    try {
                        r = "function" == typeof clearTimeout ? clearTimeout : i;
                    } catch (e) {
                        r = i;
                    }
                }();
                var a, c = [], u = !1, d = -1;
                function l() {
                    u && a && (u = !1, a.length ? c = a.concat(c) : d = -1, c.length && h());
                }
                function h() {
                    if (!u) {
                        var e = s(l);
                        u = !0;
                        for(var t = c.length; t;){
                            for(a = c, c = []; ++d < t;)a && a[d].run();
                            d = -1, t = c.length;
                        }
                        a = null, u = !1, function(e) {
                            if (r === clearTimeout) return clearTimeout(e);
                            if ((r === i || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
                            try {
                                r(e);
                            } catch (t) {
                                try {
                                    return r.call(null, e);
                                } catch (t) {
                                    return r.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function f(e, t) {
                    this.fun = e, this.array = t;
                }
                function p() {}
                n.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    c.push(new f(e, t)), 1 !== c.length || u || s(h);
                }, f.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = p, n.addListener = p, n.once = p, n.off = p, n.removeListener = p, n.removeAllListeners = p, n.emit = p, n.prependListener = p, n.prependOnceListener = p, n.listeners = function(e) {
                    return [];
                }, n.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, n.cwd = function() {
                    return "/";
                }, n.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, n.umask = function() {
                    return 0;
                };
            },
            6985: function(e, t, r) {
                var n = r(4406);
                !function(e, t) {
                    "use strict";
                    if (!e.setImmediate) {
                        var r, o, i, s, a, c = 1, u = {}, d = !1, l = e.document, h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                        h = h && h.setTimeout ? h : e, "[object process]" === ({}).toString.call(e.process) ? r = function(e) {
                            n.nextTick(function() {
                                p(e);
                            });
                        } : function() {
                            if (e.postMessage && !e.importScripts) {
                                var t = !0, r = e.onmessage;
                                return e.onmessage = function() {
                                    t = !1;
                                }, e.postMessage("", "*"), e.onmessage = r, t;
                            }
                        }() ? (s = "setImmediate$" + Math.random() + "$", a = function(t) {
                            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(s) && p(+t.data.slice(s.length));
                        }, e.addEventListener ? e.addEventListener("message", a, !1) : e.attachEvent("onmessage", a), r = function(t) {
                            e.postMessage(s + t, "*");
                        }) : e.MessageChannel ? ((i = new MessageChannel).port1.onmessage = function(e) {
                            p(e.data);
                        }, r = function(e) {
                            i.port2.postMessage(e);
                        }) : l && "onreadystatechange" in l.createElement("script") ? (o = l.documentElement, r = function(e) {
                            var t = l.createElement("script");
                            t.onreadystatechange = function() {
                                p(e), t.onreadystatechange = null, o.removeChild(t), t = null;
                            }, o.appendChild(t);
                        }) : r = function(e) {
                            setTimeout(p, 0, e);
                        }, h.setImmediate = function(e) {
                            "function" != typeof e && (e = new Function("" + e));
                            for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                            var o = {
                                callback: e,
                                args: t
                            };
                            return u[c] = o, r(c), c++;
                        }, h.clearImmediate = f;
                    }
                    function f(e) {
                        delete u[e];
                    }
                    function p(e) {
                        if (d) setTimeout(p, 0, e);
                        else {
                            var t = u[e];
                            if (t) {
                                d = !0;
                                try {
                                    !function(e) {
                                        var t = e.callback, r = e.args;
                                        switch(r.length){
                                            case 0:
                                                t();
                                                break;
                                            case 1:
                                                t(r[0]);
                                                break;
                                            case 2:
                                                t(r[0], r[1]);
                                                break;
                                            case 3:
                                                t(r[0], r[1], r[2]);
                                                break;
                                            default:
                                                t.apply(void 0, r);
                                        }
                                    }(t);
                                } finally{
                                    f(e), d = !1;
                                }
                            }
                        }
                    }
                }("undefined" == typeof self ? void 0 === r.g ? this : r.g : self);
            },
            9937: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const n = r(8381);
                t.default = {
                    encodeEventSignature: n.encodeEventSignature,
                    encodeFunctionCall: n.encodeFunctionCall,
                    encodeFunctionSignature: n.encodeFunctionSignature,
                    encodeParameter: n.encodeParameter,
                    encodeParameters: n.encodeParameters,
                    decodeParameter: n.decodeParameter,
                    decodeParameters: n.decodeParameters,
                    decodeLog: n.decodeLog
                };
            },
            1186: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.initAccountsForContext = void 0;
                const o = r(9970), i = r(9634), s = r(6637), a = r(9247);
                t.initAccountsForContext = (e)=>{
                    const t = (t, r)=>n(void 0, void 0, void 0, function*() {
                            const n = yield (0, s.prepareTransactionForSigning)(t, e), c = (0, i.format)({
                                format: "bytes"
                            }, r, o.ETH_DATA_FORMAT);
                            return (0, a.signTransaction)(n, c);
                        }), r = (e)=>{
                        const r = (0, a.privateKeyToAccount)(e);
                        return Object.assign(Object.assign({}, r), {
                            signTransaction: (e)=>n(void 0, void 0, void 0, function*() {
                                    return t(e, r.privateKey);
                                })
                        });
                    }, c = (e, r, o)=>n(void 0, void 0, void 0, function*() {
                            var i;
                            const s = yield (0, a.decrypt)(e, r, null === (i = null == o ? void 0 : o.nonStrict) || void 0 === i || i);
                            return Object.assign(Object.assign({}, s), {
                                signTransaction: (e)=>n(void 0, void 0, void 0, function*() {
                                        return t(e, s.privateKey);
                                    })
                            });
                        }), u = ()=>{
                        const e = (0, a.create)();
                        return Object.assign(Object.assign({}, e), {
                            signTransaction: (r)=>n(void 0, void 0, void 0, function*() {
                                    return t(r, e.privateKey);
                                })
                        });
                    }, d = new a.Wallet({
                        create: u,
                        privateKeyToAccount: r,
                        decrypt: c
                    });
                    return {
                        signTransaction: t,
                        create: u,
                        privateKeyToAccount: r,
                        decrypt: c,
                        recoverTransaction: a.recoverTransaction,
                        hashMessage: a.hashMessage,
                        sign: a.sign,
                        recover: a.recover,
                        encrypt: a.encrypt,
                        wallet: d,
                        privateKeyToAddress: a.privateKeyToAddress,
                        parseAndValidatePrivateKey: a.parseAndValidatePrivateKey,
                        privateKeyToPublicKey: a.privateKeyToPublicKey
                    };
                };
            },
            9913: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3PkgInfo = void 0, t.Web3PkgInfo = {
                    version: "4.10.0"
                };
            },
            9375: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                }, s = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3 = void 0;
                const a = r(6527), c = r(6637), u = s(r(3211)), d = r(1698), l = r(9910), h = r(9757), f = r(9820), p = i(r(9634)), m = r(9634), g = r(294), y = r(5071), v = s(r(9937)), b = r(1186), E = r(9913), _ = r(7632);
                class A extends a.Web3Context {
                    constructor(e = g.mainnet){
                        var t;
                        ((0, m.isNullish)(e) || "string" == typeof e && "" === e.trim() || "string" != typeof e && !(0, a.isSupportedProvider)(e) && !e.provider) && console.warn("NOTE: web3.js is running without provider. You need to pass a provider in order to interact with the network!");
                        let r = {};
                        "string" == typeof e || (0, a.isSupportedProvider)(e) ? r.provider = e : r = e || {}, r.registeredSubscriptions = Object.assign(Object.assign({}, c.registeredSubscriptions), null !== (t = r.registeredSubscriptions) && void 0 !== t ? t : {}), super(r);
                        const n = (0, b.initAccountsForContext)(this);
                        this._wallet = n.wallet, this._accountProvider = n, this.utils = p;
                        const o = this;
                        class i extends u.default {
                            constructor(e, t, r, n, i){
                                if ((0, m.isContractInitOptions)(t) && (0, m.isContractInitOptions)(r)) throw new y.InvalidMethodParamsError("Should not provide options at both 2nd and 3rd parameters");
                                let s, c, u, d = {};
                                if (!(0, m.isNullish)(t) && "object" != typeof t && "string" != typeof t) throw new y.InvalidMethodParamsError;
                                "string" == typeof t && (s = t), d = (0, m.isContractInitOptions)(t) ? t : (0, m.isContractInitOptions)(r) ? r : {}, c = t instanceof a.Web3Context ? t : r instanceof a.Web3Context ? r : n instanceof a.Web3Context ? n : o.getContextObject(), i ? u = i : (0, m.isDataFormat)(r) ? u = r : (0, m.isDataFormat)(n) && (u = n), super(e, s, d, c, u), super.subscribeToContextEvents(o);
                            }
                        }
                        const s = o.use(c.Web3Eth);
                        this.eth = Object.assign(s, {
                            ens: o.use(d.ENS, d.registryAddresses.main),
                            Iban: l.Iban,
                            net: o.use(f.Net),
                            personal: o.use(h.Personal),
                            Contract: i,
                            abi: v.default,
                            accounts: n
                        });
                    }
                }
                t.Web3 = A, A.version = E.Web3PkgInfo.version, A.utils = p, A.requestEIP6963Providers = _.requestEIP6963Providers, A.onNewProviderDiscovered = _.onNewProviderDiscovered, A.modules = {
                    Web3Eth: c.Web3Eth,
                    Iban: l.Iban,
                    Net: f.Net,
                    ENS: d.ENS,
                    Personal: h.Personal
                }, t.default = A;
            },
            7632: function(e, t) {
                "use strict";
                var r, n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.onNewProviderDiscovered = t.requestEIP6963Providers = t.web3ProvidersMapUpdated = t.eip6963ProvidersMap = t.Eip6963EventName = void 0, function(e) {
                    e.eip6963announceProvider = "eip6963:announceProvider", e.eip6963requestProvider = "eip6963:requestProvider";
                }(r = t.Eip6963EventName || (t.Eip6963EventName = {})), t.eip6963ProvidersMap = new Map, t.web3ProvidersMapUpdated = "web3:providersMapUpdated", t.requestEIP6963Providers = ()=>n(void 0, void 0, void 0, function*() {
                        return new Promise((e, n)=>{
                            "undefined" == typeof window && n(new Error("window object not available, EIP-6963 is intended to be used within a browser")), window.addEventListener(r.eip6963announceProvider, (r)=>{
                                t.eip6963ProvidersMap.set(r.detail.info.uuid, r.detail);
                                const n = new CustomEvent(t.web3ProvidersMapUpdated, {
                                    detail: t.eip6963ProvidersMap
                                });
                                window.dispatchEvent(n), e(t.eip6963ProvidersMap);
                            }), window.dispatchEvent(new Event(r.eip6963requestProvider));
                        });
                    }), t.onNewProviderDiscovered = (e)=>{
                    if ("undefined" == typeof window) throw new Error("window object not available, EIP-6963 is intended to be used within a browser");
                    window.addEventListener(t.web3ProvidersMapUpdated, e);
                };
            },
            5809: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ZodError = t.quotelessJson = t.ZodIssueCode = void 0;
                const n = r(3133);
                t.ZodIssueCode = n.util.arrayToEnum([
                    "invalid_type",
                    "invalid_literal",
                    "custom",
                    "invalid_union",
                    "invalid_union_discriminator",
                    "invalid_enum_value",
                    "unrecognized_keys",
                    "invalid_arguments",
                    "invalid_return_type",
                    "invalid_date",
                    "invalid_string",
                    "too_small",
                    "too_big",
                    "invalid_intersection_types",
                    "not_multiple_of",
                    "not_finite"
                ]), t.quotelessJson = (e)=>JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
                class o extends Error {
                    constructor(e){
                        super(), this.issues = [], this.addIssue = (e)=>{
                            this.issues = [
                                ...this.issues,
                                e
                            ];
                        }, this.addIssues = (e = [])=>{
                            this.issues = [
                                ...this.issues,
                                ...e
                            ];
                        };
                        const t = new.target.prototype;
                        Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
                    }
                    get errors() {
                        return this.issues;
                    }
                    format(e) {
                        const t = e || function(e) {
                            return e.message;
                        }, r = {
                            _errors: []
                        }, n = (e)=>{
                            for (const o of e.issues)if ("invalid_union" === o.code) o.unionErrors.map(n);
                            else if ("invalid_return_type" === o.code) n(o.returnTypeError);
                            else if ("invalid_arguments" === o.code) n(o.argumentsError);
                            else if (0 === o.path.length) r._errors.push(t(o));
                            else {
                                let e = r, n = 0;
                                for(; n < o.path.length;){
                                    const r = o.path[n];
                                    n === o.path.length - 1 ? (e[r] = e[r] || {
                                        _errors: []
                                    }, e[r]._errors.push(t(o))) : e[r] = e[r] || {
                                        _errors: []
                                    }, e = e[r], n++;
                                }
                            }
                        };
                        return n(this), r;
                    }
                    toString() {
                        return this.message;
                    }
                    get message() {
                        return JSON.stringify(this.issues, n.util.jsonStringifyReplacer, 2);
                    }
                    get isEmpty() {
                        return 0 === this.issues.length;
                    }
                    flatten(e = (e)=>e.message) {
                        const t = {}, r = [];
                        for (const n of this.issues)n.path.length > 0 ? (t[n.path[0]] = t[n.path[0]] || [], t[n.path[0]].push(e(n))) : r.push(e(n));
                        return {
                            formErrors: r,
                            fieldErrors: t
                        };
                    }
                    get formErrors() {
                        return this.flatten();
                    }
                }
                t.ZodError = o, o.create = (e)=>new o(e);
            },
            1909: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getErrorMap = t.setErrorMap = t.defaultErrorMap = void 0;
                const o = n(r(6013));
                t.defaultErrorMap = o.default;
                let i = o.default;
                t.setErrorMap = function(e) {
                    i = e;
                }, t.getErrorMap = function() {
                    return i;
                };
            },
            4474: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r), Object.defineProperty(e, n, {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    });
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(r(1909), t), o(r(4735), t), o(r(1832), t), o(r(3133), t), o(r(1176), t), o(r(5809), t);
            },
            3682: (e, t)=>{
                "use strict";
                var r;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.errorUtil = void 0, (r = t.errorUtil || (t.errorUtil = {})).errToObj = (e)=>"string" == typeof e ? {
                        message: e
                    } : e || {}, r.toString = (e)=>"string" == typeof e ? e : null == e ? void 0 : e.message;
            },
            4735: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAsync = t.isValid = t.isDirty = t.isAborted = t.OK = t.DIRTY = t.INVALID = t.ParseStatus = t.addIssueToContext = t.EMPTY_PATH = t.makeIssue = void 0;
                const o = r(1909), i = n(r(6013));
                t.makeIssue = (e)=>{
                    const { data: t, path: r, errorMaps: n, issueData: o } = e, i = [
                        ...r,
                        ...o.path || []
                    ], s = {
                        ...o,
                        path: i
                    };
                    let a = "";
                    const c = n.filter((e)=>!!e).slice().reverse();
                    for (const e of c)a = e(s, {
                        data: t,
                        defaultError: a
                    }).message;
                    return {
                        ...o,
                        path: i,
                        message: o.message || a
                    };
                }, t.EMPTY_PATH = [], t.addIssueToContext = function(e, r) {
                    const n = (0, t.makeIssue)({
                        issueData: r,
                        data: e.data,
                        path: e.path,
                        errorMaps: [
                            e.common.contextualErrorMap,
                            e.schemaErrorMap,
                            (0, o.getErrorMap)(),
                            i.default
                        ].filter((e)=>!!e)
                    });
                    e.common.issues.push(n);
                };
                class s {
                    constructor(){
                        this.value = "valid";
                    }
                    dirty() {
                        "valid" === this.value && (this.value = "dirty");
                    }
                    abort() {
                        "aborted" !== this.value && (this.value = "aborted");
                    }
                    static mergeArray(e, r) {
                        const n = [];
                        for (const o of r){
                            if ("aborted" === o.status) return t.INVALID;
                            "dirty" === o.status && e.dirty(), n.push(o.value);
                        }
                        return {
                            status: e.value,
                            value: n
                        };
                    }
                    static async mergeObjectAsync(e, t) {
                        const r = [];
                        for (const e of t)r.push({
                            key: await e.key,
                            value: await e.value
                        });
                        return s.mergeObjectSync(e, r);
                    }
                    static mergeObjectSync(e, r) {
                        const n = {};
                        for (const o of r){
                            const { key: r, value: i } = o;
                            if ("aborted" === r.status) return t.INVALID;
                            if ("aborted" === i.status) return t.INVALID;
                            "dirty" === r.status && e.dirty(), "dirty" === i.status && e.dirty(), "__proto__" === r.value || void 0 === i.value && !o.alwaysSet || (n[r.value] = i.value);
                        }
                        return {
                            status: e.value,
                            value: n
                        };
                    }
                }
                t.ParseStatus = s, t.INVALID = Object.freeze({
                    status: "aborted"
                }), t.DIRTY = (e)=>({
                        status: "dirty",
                        value: e
                    }), t.OK = (e)=>({
                        status: "valid",
                        value: e
                    }), t.isAborted = (e)=>"aborted" === e.status, t.isDirty = (e)=>"dirty" === e.status, t.isValid = (e)=>"valid" === e.status, t.isAsync = (e)=>"undefined" != typeof Promise && e instanceof Promise;
            },
            1832: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            3133: (e, t)=>{
                "use strict";
                var r;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getParsedType = t.ZodParsedType = t.objectUtil = t.util = void 0, function(e) {
                    e.assertEqual = (e)=>e, e.assertIs = function(e) {}, e.assertNever = function(e) {
                        throw new Error;
                    }, e.arrayToEnum = (e)=>{
                        const t = {};
                        for (const r of e)t[r] = r;
                        return t;
                    }, e.getValidEnumValues = (t)=>{
                        const r = e.objectKeys(t).filter((e)=>"number" != typeof t[t[e]]), n = {};
                        for (const e of r)n[e] = t[e];
                        return e.objectValues(n);
                    }, e.objectValues = (t)=>e.objectKeys(t).map(function(e) {
                            return t[e];
                        }), e.objectKeys = "function" == typeof Object.keys ? (e)=>Object.keys(e) : (e)=>{
                        const t = [];
                        for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
                        return t;
                    }, e.find = (e, t)=>{
                        for (const r of e)if (t(r)) return r;
                    }, e.isInteger = "function" == typeof Number.isInteger ? (e)=>Number.isInteger(e) : (e)=>"number" == typeof e && isFinite(e) && Math.floor(e) === e, e.joinValues = function(e, t = " | ") {
                        return e.map((e)=>"string" == typeof e ? `'${e}'` : e).join(t);
                    }, e.jsonStringifyReplacer = (e, t)=>"bigint" == typeof t ? t.toString() : t;
                }(r = t.util || (t.util = {})), (t.objectUtil || (t.objectUtil = {})).mergeShapes = (e, t)=>({
                        ...e,
                        ...t
                    }), t.ZodParsedType = r.arrayToEnum([
                    "string",
                    "nan",
                    "number",
                    "integer",
                    "float",
                    "boolean",
                    "date",
                    "bigint",
                    "symbol",
                    "function",
                    "undefined",
                    "null",
                    "array",
                    "object",
                    "unknown",
                    "promise",
                    "void",
                    "never",
                    "map",
                    "set"
                ]), t.getParsedType = (e)=>{
                    switch(typeof e){
                        case "undefined":
                            return t.ZodParsedType.undefined;
                        case "string":
                            return t.ZodParsedType.string;
                        case "number":
                            return isNaN(e) ? t.ZodParsedType.nan : t.ZodParsedType.number;
                        case "boolean":
                            return t.ZodParsedType.boolean;
                        case "function":
                            return t.ZodParsedType.function;
                        case "bigint":
                            return t.ZodParsedType.bigint;
                        case "symbol":
                            return t.ZodParsedType.symbol;
                        case "object":
                            return Array.isArray(e) ? t.ZodParsedType.array : null === e ? t.ZodParsedType.null : e.then && "function" == typeof e.then && e.catch && "function" == typeof e.catch ? t.ZodParsedType.promise : "undefined" != typeof Map && e instanceof Map ? t.ZodParsedType.map : "undefined" != typeof Set && e instanceof Set ? t.ZodParsedType.set : "undefined" != typeof Date && e instanceof Date ? t.ZodParsedType.date : t.ZodParsedType.object;
                        default:
                            return t.ZodParsedType.unknown;
                    }
                };
            },
            6750: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r), Object.defineProperty(e, n, {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    });
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                }, s = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.z = void 0;
                const a = i(r(4474));
                t.z = a, s(r(4474), t), t.default = a;
            },
            6013: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const n = r(3133), o = r(5809);
                t.default = (e, t)=>{
                    let r;
                    switch(e.code){
                        case o.ZodIssueCode.invalid_type:
                            r = e.received === n.ZodParsedType.undefined ? "Required" : `Expected ${e.expected}, received ${e.received}`;
                            break;
                        case o.ZodIssueCode.invalid_literal:
                            r = `Invalid literal value, expected ${JSON.stringify(e.expected, n.util.jsonStringifyReplacer)}`;
                            break;
                        case o.ZodIssueCode.unrecognized_keys:
                            r = `Unrecognized key(s) in object: ${n.util.joinValues(e.keys, ", ")}`;
                            break;
                        case o.ZodIssueCode.invalid_union:
                            r = "Invalid input";
                            break;
                        case o.ZodIssueCode.invalid_union_discriminator:
                            r = `Invalid discriminator value. Expected ${n.util.joinValues(e.options)}`;
                            break;
                        case o.ZodIssueCode.invalid_enum_value:
                            r = `Invalid enum value. Expected ${n.util.joinValues(e.options)}, received '${e.received}'`;
                            break;
                        case o.ZodIssueCode.invalid_arguments:
                            r = "Invalid function arguments";
                            break;
                        case o.ZodIssueCode.invalid_return_type:
                            r = "Invalid function return type";
                            break;
                        case o.ZodIssueCode.invalid_date:
                            r = "Invalid date";
                            break;
                        case o.ZodIssueCode.invalid_string:
                            "object" == typeof e.validation ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, "number" == typeof e.validation.position && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : n.util.assertNever(e.validation) : r = "regex" !== e.validation ? `Invalid ${e.validation}` : "Invalid";
                            break;
                        case o.ZodIssueCode.too_small:
                            r = "array" === e.type ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : "string" === e.type ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : "number" === e.type ? `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : "date" === e.type ? `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : "Invalid input";
                            break;
                        case o.ZodIssueCode.too_big:
                            r = "array" === e.type ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : "string" === e.type ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : "number" === e.type ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : "bigint" === e.type ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : "date" === e.type ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : "Invalid input";
                            break;
                        case o.ZodIssueCode.custom:
                            r = "Invalid input";
                            break;
                        case o.ZodIssueCode.invalid_intersection_types:
                            r = "Intersection results could not be merged";
                            break;
                        case o.ZodIssueCode.not_multiple_of:
                            r = `Number must be a multiple of ${e.multipleOf}`;
                            break;
                        case o.ZodIssueCode.not_finite:
                            r = "Number must be finite";
                            break;
                        default:
                            r = t.defaultError, n.util.assertNever(e);
                    }
                    return {
                        message: r
                    };
                };
            },
            1176: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.date = t.boolean = t.bigint = t.array = t.any = t.coerce = t.ZodFirstPartyTypeKind = t.late = t.ZodSchema = t.Schema = t.custom = t.ZodReadonly = t.ZodPipeline = t.ZodBranded = t.BRAND = t.ZodNaN = t.ZodCatch = t.ZodDefault = t.ZodNullable = t.ZodOptional = t.ZodTransformer = t.ZodEffects = t.ZodPromise = t.ZodNativeEnum = t.ZodEnum = t.ZodLiteral = t.ZodLazy = t.ZodFunction = t.ZodSet = t.ZodMap = t.ZodRecord = t.ZodTuple = t.ZodIntersection = t.ZodDiscriminatedUnion = t.ZodUnion = t.ZodObject = t.ZodArray = t.ZodVoid = t.ZodNever = t.ZodUnknown = t.ZodAny = t.ZodNull = t.ZodUndefined = t.ZodSymbol = t.ZodDate = t.ZodBoolean = t.ZodBigInt = t.ZodNumber = t.ZodString = t.ZodType = void 0, t.NEVER = t.void = t.unknown = t.union = t.undefined = t.tuple = t.transformer = t.symbol = t.string = t.strictObject = t.set = t.record = t.promise = t.preprocess = t.pipeline = t.ostring = t.optional = t.onumber = t.oboolean = t.object = t.number = t.nullable = t.null = t.never = t.nativeEnum = t.nan = t.map = t.literal = t.lazy = t.intersection = t.instanceof = t.function = t.enum = t.effect = t.discriminatedUnion = void 0;
                const n = r(1909), o = r(3682), i = r(4735), s = r(3133), a = r(5809);
                class c {
                    constructor(e, t, r, n){
                        this._cachedPath = [], this.parent = e, this.data = t, this._path = r, this._key = n;
                    }
                    get path() {
                        return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
                    }
                }
                const u = (e, t)=>{
                    if ((0, i.isValid)(t)) return {
                        success: !0,
                        data: t.value
                    };
                    if (!e.common.issues.length) throw new Error("Validation failed but no issues detected.");
                    return {
                        success: !1,
                        get error () {
                            if (this._error) return this._error;
                            const t = new a.ZodError(e.common.issues);
                            return this._error = t, this._error;
                        }
                    };
                };
                function d(e) {
                    if (!e) return {};
                    const { errorMap: t, invalid_type_error: r, required_error: n, description: o } = e;
                    if (t && (r || n)) throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');
                    return t ? {
                        errorMap: t,
                        description: o
                    } : {
                        errorMap: (e, t)=>"invalid_type" !== e.code ? {
                                message: t.defaultError
                            } : void 0 === t.data ? {
                                message: null != n ? n : t.defaultError
                            } : {
                                message: null != r ? r : t.defaultError
                            },
                        description: o
                    };
                }
                class l {
                    constructor(e){
                        this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
                    }
                    get description() {
                        return this._def.description;
                    }
                    _getType(e) {
                        return (0, s.getParsedType)(e.data);
                    }
                    _getOrReturnCtx(e, t) {
                        return t || {
                            common: e.parent.common,
                            data: e.data,
                            parsedType: (0, s.getParsedType)(e.data),
                            schemaErrorMap: this._def.errorMap,
                            path: e.path,
                            parent: e.parent
                        };
                    }
                    _processInputParams(e) {
                        return {
                            status: new i.ParseStatus,
                            ctx: {
                                common: e.parent.common,
                                data: e.data,
                                parsedType: (0, s.getParsedType)(e.data),
                                schemaErrorMap: this._def.errorMap,
                                path: e.path,
                                parent: e.parent
                            }
                        };
                    }
                    _parseSync(e) {
                        const t = this._parse(e);
                        if ((0, i.isAsync)(t)) throw new Error("Synchronous parse encountered promise.");
                        return t;
                    }
                    _parseAsync(e) {
                        const t = this._parse(e);
                        return Promise.resolve(t);
                    }
                    parse(e, t) {
                        const r = this.safeParse(e, t);
                        if (r.success) return r.data;
                        throw r.error;
                    }
                    safeParse(e, t) {
                        var r;
                        const n = {
                            common: {
                                issues: [],
                                async: null !== (r = null == t ? void 0 : t.async) && void 0 !== r && r,
                                contextualErrorMap: null == t ? void 0 : t.errorMap
                            },
                            path: (null == t ? void 0 : t.path) || [],
                            schemaErrorMap: this._def.errorMap,
                            parent: null,
                            data: e,
                            parsedType: (0, s.getParsedType)(e)
                        }, o = this._parseSync({
                            data: e,
                            path: n.path,
                            parent: n
                        });
                        return u(n, o);
                    }
                    async parseAsync(e, t) {
                        const r = await this.safeParseAsync(e, t);
                        if (r.success) return r.data;
                        throw r.error;
                    }
                    async safeParseAsync(e, t) {
                        const r = {
                            common: {
                                issues: [],
                                contextualErrorMap: null == t ? void 0 : t.errorMap,
                                async: !0
                            },
                            path: (null == t ? void 0 : t.path) || [],
                            schemaErrorMap: this._def.errorMap,
                            parent: null,
                            data: e,
                            parsedType: (0, s.getParsedType)(e)
                        }, n = this._parse({
                            data: e,
                            path: r.path,
                            parent: r
                        }), o = await ((0, i.isAsync)(n) ? n : Promise.resolve(n));
                        return u(r, o);
                    }
                    refine(e, t) {
                        const r = (e)=>"string" == typeof t || void 0 === t ? {
                                message: t
                            } : "function" == typeof t ? t(e) : t;
                        return this._refinement((t, n)=>{
                            const o = e(t), i = ()=>n.addIssue({
                                    code: a.ZodIssueCode.custom,
                                    ...r(t)
                                });
                            return "undefined" != typeof Promise && o instanceof Promise ? o.then((e)=>!!e || (i(), !1)) : !!o || (i(), !1);
                        });
                    }
                    refinement(e, t) {
                        return this._refinement((r, n)=>!!e(r) || (n.addIssue("function" == typeof t ? t(r, n) : t), !1));
                    }
                    _refinement(e) {
                        return new Y({
                            schema: this,
                            typeName: ae.ZodEffects,
                            effect: {
                                type: "refinement",
                                refinement: e
                            }
                        });
                    }
                    superRefine(e) {
                        return this._refinement(e);
                    }
                    optional() {
                        return $.create(this, this._def);
                    }
                    nullable() {
                        return ee.create(this, this._def);
                    }
                    nullish() {
                        return this.nullable().optional();
                    }
                    array() {
                        return k.create(this, this._def);
                    }
                    promise() {
                        return J.create(this, this._def);
                    }
                    or(e) {
                        return L.create([
                            this,
                            e
                        ], this._def);
                    }
                    and(e) {
                        return j.create(this, e, this._def);
                    }
                    transform(e) {
                        return new Y({
                            ...d(this._def),
                            schema: this,
                            typeName: ae.ZodEffects,
                            effect: {
                                type: "transform",
                                transform: e
                            }
                        });
                    }
                    default(e) {
                        const t = "function" == typeof e ? e : ()=>e;
                        return new te({
                            ...d(this._def),
                            innerType: this,
                            defaultValue: t,
                            typeName: ae.ZodDefault
                        });
                    }
                    brand() {
                        return new oe({
                            typeName: ae.ZodBranded,
                            type: this,
                            ...d(this._def)
                        });
                    }
                    catch(e) {
                        const t = "function" == typeof e ? e : ()=>e;
                        return new re({
                            ...d(this._def),
                            innerType: this,
                            catchValue: t,
                            typeName: ae.ZodCatch
                        });
                    }
                    describe(e) {
                        return new this.constructor({
                            ...this._def,
                            description: e
                        });
                    }
                    pipe(e) {
                        return ie.create(this, e);
                    }
                    readonly() {
                        return se.create(this);
                    }
                    isOptional() {
                        return this.safeParse(void 0).success;
                    }
                    isNullable() {
                        return this.safeParse(null).success;
                    }
                }
                t.ZodType = l, t.Schema = l, t.ZodSchema = l;
                const h = /^c[^\s-]{8,}$/i, f = /^[a-z][a-z0-9]*$/, p = /[0-9A-HJKMNP-TV-Z]{26}/, m = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, g = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, y = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u, v = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, b = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
                class E extends l {
                    constructor(){
                        super(...arguments), this._regex = (e, t, r)=>this.refinement((t)=>e.test(t), {
                                validation: t,
                                code: a.ZodIssueCode.invalid_string,
                                ...o.errorUtil.errToObj(r)
                            }), this.nonempty = (e)=>this.min(1, o.errorUtil.errToObj(e)), this.trim = ()=>new E({
                                ...this._def,
                                checks: [
                                    ...this._def.checks,
                                    {
                                        kind: "trim"
                                    }
                                ]
                            }), this.toLowerCase = ()=>new E({
                                ...this._def,
                                checks: [
                                    ...this._def.checks,
                                    {
                                        kind: "toLowerCase"
                                    }
                                ]
                            }), this.toUpperCase = ()=>new E({
                                ...this._def,
                                checks: [
                                    ...this._def.checks,
                                    {
                                        kind: "toUpperCase"
                                    }
                                ]
                            });
                    }
                    _parse(e) {
                        if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== s.ZodParsedType.string) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.string,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        const t = new i.ParseStatus;
                        let r;
                        for (const u of this._def.checks)if ("min" === u.kind) e.data.length < u.value && (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.too_small,
                            minimum: u.value,
                            type: "string",
                            inclusive: !0,
                            exact: !1,
                            message: u.message
                        }), t.dirty());
                        else if ("max" === u.kind) e.data.length > u.value && (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.too_big,
                            maximum: u.value,
                            type: "string",
                            inclusive: !0,
                            exact: !1,
                            message: u.message
                        }), t.dirty());
                        else if ("length" === u.kind) {
                            const n = e.data.length > u.value, o = e.data.length < u.value;
                            (n || o) && (r = this._getOrReturnCtx(e, r), n ? (0, i.addIssueToContext)(r, {
                                code: a.ZodIssueCode.too_big,
                                maximum: u.value,
                                type: "string",
                                inclusive: !0,
                                exact: !0,
                                message: u.message
                            }) : o && (0, i.addIssueToContext)(r, {
                                code: a.ZodIssueCode.too_small,
                                minimum: u.value,
                                type: "string",
                                inclusive: !0,
                                exact: !0,
                                message: u.message
                            }), t.dirty());
                        } else if ("email" === u.kind) g.test(e.data) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            validation: "email",
                            code: a.ZodIssueCode.invalid_string,
                            message: u.message
                        }), t.dirty());
                        else if ("emoji" === u.kind) y.test(e.data) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            validation: "emoji",
                            code: a.ZodIssueCode.invalid_string,
                            message: u.message
                        }), t.dirty());
                        else if ("uuid" === u.kind) m.test(e.data) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            validation: "uuid",
                            code: a.ZodIssueCode.invalid_string,
                            message: u.message
                        }), t.dirty());
                        else if ("cuid" === u.kind) h.test(e.data) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            validation: "cuid",
                            code: a.ZodIssueCode.invalid_string,
                            message: u.message
                        }), t.dirty());
                        else if ("cuid2" === u.kind) f.test(e.data) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            validation: "cuid2",
                            code: a.ZodIssueCode.invalid_string,
                            message: u.message
                        }), t.dirty());
                        else if ("ulid" === u.kind) p.test(e.data) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            validation: "ulid",
                            code: a.ZodIssueCode.invalid_string,
                            message: u.message
                        }), t.dirty());
                        else if ("url" === u.kind) try {
                            new URL(e.data);
                        } catch (n) {
                            r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                                validation: "url",
                                code: a.ZodIssueCode.invalid_string,
                                message: u.message
                            }), t.dirty();
                        }
                        else "regex" === u.kind ? (u.regex.lastIndex = 0, u.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            validation: "regex",
                            code: a.ZodIssueCode.invalid_string,
                            message: u.message
                        }), t.dirty())) : "trim" === u.kind ? e.data = e.data.trim() : "includes" === u.kind ? e.data.includes(u.value, u.position) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.invalid_string,
                            validation: {
                                includes: u.value,
                                position: u.position
                            },
                            message: u.message
                        }), t.dirty()) : "toLowerCase" === u.kind ? e.data = e.data.toLowerCase() : "toUpperCase" === u.kind ? e.data = e.data.toUpperCase() : "startsWith" === u.kind ? e.data.startsWith(u.value) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.invalid_string,
                            validation: {
                                startsWith: u.value
                            },
                            message: u.message
                        }), t.dirty()) : "endsWith" === u.kind ? e.data.endsWith(u.value) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.invalid_string,
                            validation: {
                                endsWith: u.value
                            },
                            message: u.message
                        }), t.dirty()) : "datetime" === u.kind ? ((c = u).precision ? c.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${c.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${c.precision}}Z$`) : 0 === c.precision ? c.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : c.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$")).test(e.data) || (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.invalid_string,
                            validation: "datetime",
                            message: u.message
                        }), t.dirty()) : "ip" === u.kind ? (n = e.data, ("v4" !== (o = u.version) && o || !v.test(n)) && ("v6" !== o && o || !b.test(n)) && (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            validation: "ip",
                            code: a.ZodIssueCode.invalid_string,
                            message: u.message
                        }), t.dirty())) : s.util.assertNever(u);
                        var n, o, c;
                        return {
                            status: t.value,
                            value: e.data
                        };
                    }
                    _addCheck(e) {
                        return new E({
                            ...this._def,
                            checks: [
                                ...this._def.checks,
                                e
                            ]
                        });
                    }
                    email(e) {
                        return this._addCheck({
                            kind: "email",
                            ...o.errorUtil.errToObj(e)
                        });
                    }
                    url(e) {
                        return this._addCheck({
                            kind: "url",
                            ...o.errorUtil.errToObj(e)
                        });
                    }
                    emoji(e) {
                        return this._addCheck({
                            kind: "emoji",
                            ...o.errorUtil.errToObj(e)
                        });
                    }
                    uuid(e) {
                        return this._addCheck({
                            kind: "uuid",
                            ...o.errorUtil.errToObj(e)
                        });
                    }
                    cuid(e) {
                        return this._addCheck({
                            kind: "cuid",
                            ...o.errorUtil.errToObj(e)
                        });
                    }
                    cuid2(e) {
                        return this._addCheck({
                            kind: "cuid2",
                            ...o.errorUtil.errToObj(e)
                        });
                    }
                    ulid(e) {
                        return this._addCheck({
                            kind: "ulid",
                            ...o.errorUtil.errToObj(e)
                        });
                    }
                    ip(e) {
                        return this._addCheck({
                            kind: "ip",
                            ...o.errorUtil.errToObj(e)
                        });
                    }
                    datetime(e) {
                        var t;
                        return "string" == typeof e ? this._addCheck({
                            kind: "datetime",
                            precision: null,
                            offset: !1,
                            message: e
                        }) : this._addCheck({
                            kind: "datetime",
                            precision: void 0 === (null == e ? void 0 : e.precision) ? null : null == e ? void 0 : e.precision,
                            offset: null !== (t = null == e ? void 0 : e.offset) && void 0 !== t && t,
                            ...o.errorUtil.errToObj(null == e ? void 0 : e.message)
                        });
                    }
                    regex(e, t) {
                        return this._addCheck({
                            kind: "regex",
                            regex: e,
                            ...o.errorUtil.errToObj(t)
                        });
                    }
                    includes(e, t) {
                        return this._addCheck({
                            kind: "includes",
                            value: e,
                            position: null == t ? void 0 : t.position,
                            ...o.errorUtil.errToObj(null == t ? void 0 : t.message)
                        });
                    }
                    startsWith(e, t) {
                        return this._addCheck({
                            kind: "startsWith",
                            value: e,
                            ...o.errorUtil.errToObj(t)
                        });
                    }
                    endsWith(e, t) {
                        return this._addCheck({
                            kind: "endsWith",
                            value: e,
                            ...o.errorUtil.errToObj(t)
                        });
                    }
                    min(e, t) {
                        return this._addCheck({
                            kind: "min",
                            value: e,
                            ...o.errorUtil.errToObj(t)
                        });
                    }
                    max(e, t) {
                        return this._addCheck({
                            kind: "max",
                            value: e,
                            ...o.errorUtil.errToObj(t)
                        });
                    }
                    length(e, t) {
                        return this._addCheck({
                            kind: "length",
                            value: e,
                            ...o.errorUtil.errToObj(t)
                        });
                    }
                    get isDatetime() {
                        return !!this._def.checks.find((e)=>"datetime" === e.kind);
                    }
                    get isEmail() {
                        return !!this._def.checks.find((e)=>"email" === e.kind);
                    }
                    get isURL() {
                        return !!this._def.checks.find((e)=>"url" === e.kind);
                    }
                    get isEmoji() {
                        return !!this._def.checks.find((e)=>"emoji" === e.kind);
                    }
                    get isUUID() {
                        return !!this._def.checks.find((e)=>"uuid" === e.kind);
                    }
                    get isCUID() {
                        return !!this._def.checks.find((e)=>"cuid" === e.kind);
                    }
                    get isCUID2() {
                        return !!this._def.checks.find((e)=>"cuid2" === e.kind);
                    }
                    get isULID() {
                        return !!this._def.checks.find((e)=>"ulid" === e.kind);
                    }
                    get isIP() {
                        return !!this._def.checks.find((e)=>"ip" === e.kind);
                    }
                    get minLength() {
                        let e = null;
                        for (const t of this._def.checks)"min" === t.kind && (null === e || t.value > e) && (e = t.value);
                        return e;
                    }
                    get maxLength() {
                        let e = null;
                        for (const t of this._def.checks)"max" === t.kind && (null === e || t.value < e) && (e = t.value);
                        return e;
                    }
                }
                function _(e, t) {
                    const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, o = r > n ? r : n;
                    return parseInt(e.toFixed(o).replace(".", "")) % parseInt(t.toFixed(o).replace(".", "")) / Math.pow(10, o);
                }
                t.ZodString = E, E.create = (e)=>{
                    var t;
                    return new E({
                        checks: [],
                        typeName: ae.ZodString,
                        coerce: null !== (t = null == e ? void 0 : e.coerce) && void 0 !== t && t,
                        ...d(e)
                    });
                };
                class A extends l {
                    constructor(){
                        super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
                    }
                    _parse(e) {
                        if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== s.ZodParsedType.number) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.number,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        let t;
                        const r = new i.ParseStatus;
                        for (const n of this._def.checks)"int" === n.kind ? s.util.isInteger(e.data) || (t = this._getOrReturnCtx(e, t), (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: "integer",
                            received: "float",
                            message: n.message
                        }), r.dirty()) : "min" === n.kind ? (n.inclusive ? e.data < n.value : e.data <= n.value) && (t = this._getOrReturnCtx(e, t), (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.too_small,
                            minimum: n.value,
                            type: "number",
                            inclusive: n.inclusive,
                            exact: !1,
                            message: n.message
                        }), r.dirty()) : "max" === n.kind ? (n.inclusive ? e.data > n.value : e.data >= n.value) && (t = this._getOrReturnCtx(e, t), (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.too_big,
                            maximum: n.value,
                            type: "number",
                            inclusive: n.inclusive,
                            exact: !1,
                            message: n.message
                        }), r.dirty()) : "multipleOf" === n.kind ? 0 !== _(e.data, n.value) && (t = this._getOrReturnCtx(e, t), (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.not_multiple_of,
                            multipleOf: n.value,
                            message: n.message
                        }), r.dirty()) : "finite" === n.kind ? Number.isFinite(e.data) || (t = this._getOrReturnCtx(e, t), (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.not_finite,
                            message: n.message
                        }), r.dirty()) : s.util.assertNever(n);
                        return {
                            status: r.value,
                            value: e.data
                        };
                    }
                    gte(e, t) {
                        return this.setLimit("min", e, !0, o.errorUtil.toString(t));
                    }
                    gt(e, t) {
                        return this.setLimit("min", e, !1, o.errorUtil.toString(t));
                    }
                    lte(e, t) {
                        return this.setLimit("max", e, !0, o.errorUtil.toString(t));
                    }
                    lt(e, t) {
                        return this.setLimit("max", e, !1, o.errorUtil.toString(t));
                    }
                    setLimit(e, t, r, n) {
                        return new A({
                            ...this._def,
                            checks: [
                                ...this._def.checks,
                                {
                                    kind: e,
                                    value: t,
                                    inclusive: r,
                                    message: o.errorUtil.toString(n)
                                }
                            ]
                        });
                    }
                    _addCheck(e) {
                        return new A({
                            ...this._def,
                            checks: [
                                ...this._def.checks,
                                e
                            ]
                        });
                    }
                    int(e) {
                        return this._addCheck({
                            kind: "int",
                            message: o.errorUtil.toString(e)
                        });
                    }
                    positive(e) {
                        return this._addCheck({
                            kind: "min",
                            value: 0,
                            inclusive: !1,
                            message: o.errorUtil.toString(e)
                        });
                    }
                    negative(e) {
                        return this._addCheck({
                            kind: "max",
                            value: 0,
                            inclusive: !1,
                            message: o.errorUtil.toString(e)
                        });
                    }
                    nonpositive(e) {
                        return this._addCheck({
                            kind: "max",
                            value: 0,
                            inclusive: !0,
                            message: o.errorUtil.toString(e)
                        });
                    }
                    nonnegative(e) {
                        return this._addCheck({
                            kind: "min",
                            value: 0,
                            inclusive: !0,
                            message: o.errorUtil.toString(e)
                        });
                    }
                    multipleOf(e, t) {
                        return this._addCheck({
                            kind: "multipleOf",
                            value: e,
                            message: o.errorUtil.toString(t)
                        });
                    }
                    finite(e) {
                        return this._addCheck({
                            kind: "finite",
                            message: o.errorUtil.toString(e)
                        });
                    }
                    safe(e) {
                        return this._addCheck({
                            kind: "min",
                            inclusive: !0,
                            value: Number.MIN_SAFE_INTEGER,
                            message: o.errorUtil.toString(e)
                        })._addCheck({
                            kind: "max",
                            inclusive: !0,
                            value: Number.MAX_SAFE_INTEGER,
                            message: o.errorUtil.toString(e)
                        });
                    }
                    get minValue() {
                        let e = null;
                        for (const t of this._def.checks)"min" === t.kind && (null === e || t.value > e) && (e = t.value);
                        return e;
                    }
                    get maxValue() {
                        let e = null;
                        for (const t of this._def.checks)"max" === t.kind && (null === e || t.value < e) && (e = t.value);
                        return e;
                    }
                    get isInt() {
                        return !!this._def.checks.find((e)=>"int" === e.kind || "multipleOf" === e.kind && s.util.isInteger(e.value));
                    }
                    get isFinite() {
                        let e = null, t = null;
                        for (const r of this._def.checks){
                            if ("finite" === r.kind || "int" === r.kind || "multipleOf" === r.kind) return !0;
                            "min" === r.kind ? (null === t || r.value > t) && (t = r.value) : "max" === r.kind && (null === e || r.value < e) && (e = r.value);
                        }
                        return Number.isFinite(t) && Number.isFinite(e);
                    }
                }
                t.ZodNumber = A, A.create = (e)=>new A({
                        checks: [],
                        typeName: ae.ZodNumber,
                        coerce: (null == e ? void 0 : e.coerce) || !1,
                        ...d(e)
                    });
                class T extends l {
                    constructor(){
                        super(...arguments), this.min = this.gte, this.max = this.lte;
                    }
                    _parse(e) {
                        if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== s.ZodParsedType.bigint) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.bigint,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        let t;
                        const r = new i.ParseStatus;
                        for (const n of this._def.checks)"min" === n.kind ? (n.inclusive ? e.data < n.value : e.data <= n.value) && (t = this._getOrReturnCtx(e, t), (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.too_small,
                            type: "bigint",
                            minimum: n.value,
                            inclusive: n.inclusive,
                            message: n.message
                        }), r.dirty()) : "max" === n.kind ? (n.inclusive ? e.data > n.value : e.data >= n.value) && (t = this._getOrReturnCtx(e, t), (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.too_big,
                            type: "bigint",
                            maximum: n.value,
                            inclusive: n.inclusive,
                            message: n.message
                        }), r.dirty()) : "multipleOf" === n.kind ? e.data % n.value !== BigInt(0) && (t = this._getOrReturnCtx(e, t), (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.not_multiple_of,
                            multipleOf: n.value,
                            message: n.message
                        }), r.dirty()) : s.util.assertNever(n);
                        return {
                            status: r.value,
                            value: e.data
                        };
                    }
                    gte(e, t) {
                        return this.setLimit("min", e, !0, o.errorUtil.toString(t));
                    }
                    gt(e, t) {
                        return this.setLimit("min", e, !1, o.errorUtil.toString(t));
                    }
                    lte(e, t) {
                        return this.setLimit("max", e, !0, o.errorUtil.toString(t));
                    }
                    lt(e, t) {
                        return this.setLimit("max", e, !1, o.errorUtil.toString(t));
                    }
                    setLimit(e, t, r, n) {
                        return new T({
                            ...this._def,
                            checks: [
                                ...this._def.checks,
                                {
                                    kind: e,
                                    value: t,
                                    inclusive: r,
                                    message: o.errorUtil.toString(n)
                                }
                            ]
                        });
                    }
                    _addCheck(e) {
                        return new T({
                            ...this._def,
                            checks: [
                                ...this._def.checks,
                                e
                            ]
                        });
                    }
                    positive(e) {
                        return this._addCheck({
                            kind: "min",
                            value: BigInt(0),
                            inclusive: !1,
                            message: o.errorUtil.toString(e)
                        });
                    }
                    negative(e) {
                        return this._addCheck({
                            kind: "max",
                            value: BigInt(0),
                            inclusive: !1,
                            message: o.errorUtil.toString(e)
                        });
                    }
                    nonpositive(e) {
                        return this._addCheck({
                            kind: "max",
                            value: BigInt(0),
                            inclusive: !0,
                            message: o.errorUtil.toString(e)
                        });
                    }
                    nonnegative(e) {
                        return this._addCheck({
                            kind: "min",
                            value: BigInt(0),
                            inclusive: !0,
                            message: o.errorUtil.toString(e)
                        });
                    }
                    multipleOf(e, t) {
                        return this._addCheck({
                            kind: "multipleOf",
                            value: e,
                            message: o.errorUtil.toString(t)
                        });
                    }
                    get minValue() {
                        let e = null;
                        for (const t of this._def.checks)"min" === t.kind && (null === e || t.value > e) && (e = t.value);
                        return e;
                    }
                    get maxValue() {
                        let e = null;
                        for (const t of this._def.checks)"max" === t.kind && (null === e || t.value < e) && (e = t.value);
                        return e;
                    }
                }
                t.ZodBigInt = T, T.create = (e)=>{
                    var t;
                    return new T({
                        checks: [],
                        typeName: ae.ZodBigInt,
                        coerce: null !== (t = null == e ? void 0 : e.coerce) && void 0 !== t && t,
                        ...d(e)
                    });
                };
                class w extends l {
                    _parse(e) {
                        if (this._def.coerce && (e.data = Boolean(e.data)), this._getType(e) !== s.ZodParsedType.boolean) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.boolean,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        return (0, i.OK)(e.data);
                    }
                }
                t.ZodBoolean = w, w.create = (e)=>new w({
                        typeName: ae.ZodBoolean,
                        coerce: (null == e ? void 0 : e.coerce) || !1,
                        ...d(e)
                    });
                class I extends l {
                    _parse(e) {
                        if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== s.ZodParsedType.date) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.date,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        if (isNaN(e.data.getTime())) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_date
                            }), i.INVALID;
                        }
                        const t = new i.ParseStatus;
                        let r;
                        for (const n of this._def.checks)"min" === n.kind ? e.data.getTime() < n.value && (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.too_small,
                            message: n.message,
                            inclusive: !0,
                            exact: !1,
                            minimum: n.value,
                            type: "date"
                        }), t.dirty()) : "max" === n.kind ? e.data.getTime() > n.value && (r = this._getOrReturnCtx(e, r), (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.too_big,
                            message: n.message,
                            inclusive: !0,
                            exact: !1,
                            maximum: n.value,
                            type: "date"
                        }), t.dirty()) : s.util.assertNever(n);
                        return {
                            status: t.value,
                            value: new Date(e.data.getTime())
                        };
                    }
                    _addCheck(e) {
                        return new I({
                            ...this._def,
                            checks: [
                                ...this._def.checks,
                                e
                            ]
                        });
                    }
                    min(e, t) {
                        return this._addCheck({
                            kind: "min",
                            value: e.getTime(),
                            message: o.errorUtil.toString(t)
                        });
                    }
                    max(e, t) {
                        return this._addCheck({
                            kind: "max",
                            value: e.getTime(),
                            message: o.errorUtil.toString(t)
                        });
                    }
                    get minDate() {
                        let e = null;
                        for (const t of this._def.checks)"min" === t.kind && (null === e || t.value > e) && (e = t.value);
                        return null != e ? new Date(e) : null;
                    }
                    get maxDate() {
                        let e = null;
                        for (const t of this._def.checks)"max" === t.kind && (null === e || t.value < e) && (e = t.value);
                        return null != e ? new Date(e) : null;
                    }
                }
                t.ZodDate = I, I.create = (e)=>new I({
                        checks: [],
                        coerce: (null == e ? void 0 : e.coerce) || !1,
                        typeName: ae.ZodDate,
                        ...d(e)
                    });
                class R extends l {
                    _parse(e) {
                        if (this._getType(e) !== s.ZodParsedType.symbol) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.symbol,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        return (0, i.OK)(e.data);
                    }
                }
                t.ZodSymbol = R, R.create = (e)=>new R({
                        typeName: ae.ZodSymbol,
                        ...d(e)
                    });
                class P extends l {
                    _parse(e) {
                        if (this._getType(e) !== s.ZodParsedType.undefined) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.undefined,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        return (0, i.OK)(e.data);
                    }
                }
                t.ZodUndefined = P, P.create = (e)=>new P({
                        typeName: ae.ZodUndefined,
                        ...d(e)
                    });
                class x extends l {
                    _parse(e) {
                        if (this._getType(e) !== s.ZodParsedType.null) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.null,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        return (0, i.OK)(e.data);
                    }
                }
                t.ZodNull = x, x.create = (e)=>new x({
                        typeName: ae.ZodNull,
                        ...d(e)
                    });
                class O extends l {
                    constructor(){
                        super(...arguments), this._any = !0;
                    }
                    _parse(e) {
                        return (0, i.OK)(e.data);
                    }
                }
                t.ZodAny = O, O.create = (e)=>new O({
                        typeName: ae.ZodAny,
                        ...d(e)
                    });
                class S extends l {
                    constructor(){
                        super(...arguments), this._unknown = !0;
                    }
                    _parse(e) {
                        return (0, i.OK)(e.data);
                    }
                }
                t.ZodUnknown = S, S.create = (e)=>new S({
                        typeName: ae.ZodUnknown,
                        ...d(e)
                    });
                class C extends l {
                    _parse(e) {
                        const t = this._getOrReturnCtx(e);
                        return (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: s.ZodParsedType.never,
                            received: t.parsedType
                        }), i.INVALID;
                    }
                }
                t.ZodNever = C, C.create = (e)=>new C({
                        typeName: ae.ZodNever,
                        ...d(e)
                    });
                class B extends l {
                    _parse(e) {
                        if (this._getType(e) !== s.ZodParsedType.undefined) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.void,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        return (0, i.OK)(e.data);
                    }
                }
                t.ZodVoid = B, B.create = (e)=>new B({
                        typeName: ae.ZodVoid,
                        ...d(e)
                    });
                class k extends l {
                    _parse(e) {
                        const { ctx: t, status: r } = this._processInputParams(e), n = this._def;
                        if (t.parsedType !== s.ZodParsedType.array) return (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: s.ZodParsedType.array,
                            received: t.parsedType
                        }), i.INVALID;
                        if (null !== n.exactLength) {
                            const e = t.data.length > n.exactLength.value, o = t.data.length < n.exactLength.value;
                            (e || o) && ((0, i.addIssueToContext)(t, {
                                code: e ? a.ZodIssueCode.too_big : a.ZodIssueCode.too_small,
                                minimum: o ? n.exactLength.value : void 0,
                                maximum: e ? n.exactLength.value : void 0,
                                type: "array",
                                inclusive: !0,
                                exact: !0,
                                message: n.exactLength.message
                            }), r.dirty());
                        }
                        if (null !== n.minLength && t.data.length < n.minLength.value && ((0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.too_small,
                            minimum: n.minLength.value,
                            type: "array",
                            inclusive: !0,
                            exact: !1,
                            message: n.minLength.message
                        }), r.dirty()), null !== n.maxLength && t.data.length > n.maxLength.value && ((0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.too_big,
                            maximum: n.maxLength.value,
                            type: "array",
                            inclusive: !0,
                            exact: !1,
                            message: n.maxLength.message
                        }), r.dirty()), t.common.async) return Promise.all([
                            ...t.data
                        ].map((e, r)=>n.type._parseAsync(new c(t, e, t.path, r)))).then((e)=>i.ParseStatus.mergeArray(r, e));
                        const o = [
                            ...t.data
                        ].map((e, r)=>n.type._parseSync(new c(t, e, t.path, r)));
                        return i.ParseStatus.mergeArray(r, o);
                    }
                    get element() {
                        return this._def.type;
                    }
                    min(e, t) {
                        return new k({
                            ...this._def,
                            minLength: {
                                value: e,
                                message: o.errorUtil.toString(t)
                            }
                        });
                    }
                    max(e, t) {
                        return new k({
                            ...this._def,
                            maxLength: {
                                value: e,
                                message: o.errorUtil.toString(t)
                            }
                        });
                    }
                    length(e, t) {
                        return new k({
                            ...this._def,
                            exactLength: {
                                value: e,
                                message: o.errorUtil.toString(t)
                            }
                        });
                    }
                    nonempty(e) {
                        return this.min(1, e);
                    }
                }
                function N(e) {
                    if (e instanceof M) {
                        const t = {};
                        for(const r in e.shape){
                            const n = e.shape[r];
                            t[r] = $.create(N(n));
                        }
                        return new M({
                            ...e._def,
                            shape: ()=>t
                        });
                    }
                    return e instanceof k ? new k({
                        ...e._def,
                        type: N(e.element)
                    }) : e instanceof $ ? $.create(N(e.unwrap())) : e instanceof ee ? ee.create(N(e.unwrap())) : e instanceof U ? U.create(e.items.map((e)=>N(e))) : e;
                }
                t.ZodArray = k, k.create = (e, t)=>new k({
                        type: e,
                        minLength: null,
                        maxLength: null,
                        exactLength: null,
                        typeName: ae.ZodArray,
                        ...d(t)
                    });
                class M extends l {
                    constructor(){
                        super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
                    }
                    _getCached() {
                        if (null !== this._cached) return this._cached;
                        const e = this._def.shape(), t = s.util.objectKeys(e);
                        return this._cached = {
                            shape: e,
                            keys: t
                        };
                    }
                    _parse(e) {
                        if (this._getType(e) !== s.ZodParsedType.object) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.object,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        const { status: t, ctx: r } = this._processInputParams(e), { shape: n, keys: o } = this._getCached(), u = [];
                        if (!(this._def.catchall instanceof C && "strip" === this._def.unknownKeys)) for(const e in r.data)o.includes(e) || u.push(e);
                        const d = [];
                        for (const e of o){
                            const t = n[e], o = r.data[e];
                            d.push({
                                key: {
                                    status: "valid",
                                    value: e
                                },
                                value: t._parse(new c(r, o, r.path, e)),
                                alwaysSet: e in r.data
                            });
                        }
                        if (this._def.catchall instanceof C) {
                            const e = this._def.unknownKeys;
                            if ("passthrough" === e) for (const e of u)d.push({
                                key: {
                                    status: "valid",
                                    value: e
                                },
                                value: {
                                    status: "valid",
                                    value: r.data[e]
                                }
                            });
                            else if ("strict" === e) u.length > 0 && ((0, i.addIssueToContext)(r, {
                                code: a.ZodIssueCode.unrecognized_keys,
                                keys: u
                            }), t.dirty());
                            else if ("strip" !== e) throw new Error("Internal ZodObject error: invalid unknownKeys value.");
                        } else {
                            const e = this._def.catchall;
                            for (const t of u){
                                const n = r.data[t];
                                d.push({
                                    key: {
                                        status: "valid",
                                        value: t
                                    },
                                    value: e._parse(new c(r, n, r.path, t)),
                                    alwaysSet: t in r.data
                                });
                            }
                        }
                        return r.common.async ? Promise.resolve().then(async ()=>{
                            const e = [];
                            for (const t of d){
                                const r = await t.key;
                                e.push({
                                    key: r,
                                    value: await t.value,
                                    alwaysSet: t.alwaysSet
                                });
                            }
                            return e;
                        }).then((e)=>i.ParseStatus.mergeObjectSync(t, e)) : i.ParseStatus.mergeObjectSync(t, d);
                    }
                    get shape() {
                        return this._def.shape();
                    }
                    strict(e) {
                        return o.errorUtil.errToObj, new M({
                            ...this._def,
                            unknownKeys: "strict",
                            ...void 0 !== e ? {
                                errorMap: (t, r)=>{
                                    var n, i, s, a;
                                    const c = null !== (s = null === (i = (n = this._def).errorMap) || void 0 === i ? void 0 : i.call(n, t, r).message) && void 0 !== s ? s : r.defaultError;
                                    return "unrecognized_keys" === t.code ? {
                                        message: null !== (a = o.errorUtil.errToObj(e).message) && void 0 !== a ? a : c
                                    } : {
                                        message: c
                                    };
                                }
                            } : {}
                        });
                    }
                    strip() {
                        return new M({
                            ...this._def,
                            unknownKeys: "strip"
                        });
                    }
                    passthrough() {
                        return new M({
                            ...this._def,
                            unknownKeys: "passthrough"
                        });
                    }
                    extend(e) {
                        return new M({
                            ...this._def,
                            shape: ()=>({
                                    ...this._def.shape(),
                                    ...e
                                })
                        });
                    }
                    merge(e) {
                        return new M({
                            unknownKeys: e._def.unknownKeys,
                            catchall: e._def.catchall,
                            shape: ()=>({
                                    ...this._def.shape(),
                                    ...e._def.shape()
                                }),
                            typeName: ae.ZodObject
                        });
                    }
                    setKey(e, t) {
                        return this.augment({
                            [e]: t
                        });
                    }
                    catchall(e) {
                        return new M({
                            ...this._def,
                            catchall: e
                        });
                    }
                    pick(e) {
                        const t = {};
                        return s.util.objectKeys(e).forEach((r)=>{
                            e[r] && this.shape[r] && (t[r] = this.shape[r]);
                        }), new M({
                            ...this._def,
                            shape: ()=>t
                        });
                    }
                    omit(e) {
                        const t = {};
                        return s.util.objectKeys(this.shape).forEach((r)=>{
                            e[r] || (t[r] = this.shape[r]);
                        }), new M({
                            ...this._def,
                            shape: ()=>t
                        });
                    }
                    deepPartial() {
                        return N(this);
                    }
                    partial(e) {
                        const t = {};
                        return s.util.objectKeys(this.shape).forEach((r)=>{
                            const n = this.shape[r];
                            e && !e[r] ? t[r] = n : t[r] = n.optional();
                        }), new M({
                            ...this._def,
                            shape: ()=>t
                        });
                    }
                    required(e) {
                        const t = {};
                        return s.util.objectKeys(this.shape).forEach((r)=>{
                            if (e && !e[r]) t[r] = this.shape[r];
                            else {
                                let e = this.shape[r];
                                for(; e instanceof $;)e = e._def.innerType;
                                t[r] = e;
                            }
                        }), new M({
                            ...this._def,
                            shape: ()=>t
                        });
                    }
                    keyof() {
                        return K(s.util.objectKeys(this.shape));
                    }
                }
                t.ZodObject = M, M.create = (e, t)=>new M({
                        shape: ()=>e,
                        unknownKeys: "strip",
                        catchall: C.create(),
                        typeName: ae.ZodObject,
                        ...d(t)
                    }), M.strictCreate = (e, t)=>new M({
                        shape: ()=>e,
                        unknownKeys: "strict",
                        catchall: C.create(),
                        typeName: ae.ZodObject,
                        ...d(t)
                    }), M.lazycreate = (e, t)=>new M({
                        shape: e,
                        unknownKeys: "strip",
                        catchall: C.create(),
                        typeName: ae.ZodObject,
                        ...d(t)
                    });
                class L extends l {
                    _parse(e) {
                        const { ctx: t } = this._processInputParams(e), r = this._def.options;
                        if (t.common.async) return Promise.all(r.map(async (e)=>{
                            const r = {
                                ...t,
                                common: {
                                    ...t.common,
                                    issues: []
                                },
                                parent: null
                            };
                            return {
                                result: await e._parseAsync({
                                    data: t.data,
                                    path: t.path,
                                    parent: r
                                }),
                                ctx: r
                            };
                        })).then(function(e) {
                            for (const t of e)if ("valid" === t.result.status) return t.result;
                            for (const r of e)if ("dirty" === r.result.status) return t.common.issues.push(...r.ctx.common.issues), r.result;
                            const r = e.map((e)=>new a.ZodError(e.ctx.common.issues));
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_union,
                                unionErrors: r
                            }), i.INVALID;
                        });
                        {
                            let e;
                            const n = [];
                            for (const o of r){
                                const r = {
                                    ...t,
                                    common: {
                                        ...t.common,
                                        issues: []
                                    },
                                    parent: null
                                }, i = o._parseSync({
                                    data: t.data,
                                    path: t.path,
                                    parent: r
                                });
                                if ("valid" === i.status) return i;
                                "dirty" !== i.status || e || (e = {
                                    result: i,
                                    ctx: r
                                }), r.common.issues.length && n.push(r.common.issues);
                            }
                            if (e) return t.common.issues.push(...e.ctx.common.issues), e.result;
                            const o = n.map((e)=>new a.ZodError(e));
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_union,
                                unionErrors: o
                            }), i.INVALID;
                        }
                    }
                    get options() {
                        return this._def.options;
                    }
                }
                t.ZodUnion = L, L.create = (e, t)=>new L({
                        options: e,
                        typeName: ae.ZodUnion,
                        ...d(t)
                    });
                const D = (e)=>e instanceof q ? D(e.schema) : e instanceof Y ? D(e.innerType()) : e instanceof z ? [
                        e.value
                    ] : e instanceof Q ? e.options : e instanceof X ? Object.keys(e.enum) : e instanceof te ? D(e._def.innerType) : e instanceof P ? [
                        void 0
                    ] : e instanceof x ? [
                        null
                    ] : null;
                class F extends l {
                    _parse(e) {
                        const { ctx: t } = this._processInputParams(e);
                        if (t.parsedType !== s.ZodParsedType.object) return (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: s.ZodParsedType.object,
                            received: t.parsedType
                        }), i.INVALID;
                        const r = this.discriminator, n = t.data[r], o = this.optionsMap.get(n);
                        return o ? t.common.async ? o._parseAsync({
                            data: t.data,
                            path: t.path,
                            parent: t
                        }) : o._parseSync({
                            data: t.data,
                            path: t.path,
                            parent: t
                        }) : ((0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.invalid_union_discriminator,
                            options: Array.from(this.optionsMap.keys()),
                            path: [
                                r
                            ]
                        }), i.INVALID);
                    }
                    get discriminator() {
                        return this._def.discriminator;
                    }
                    get options() {
                        return this._def.options;
                    }
                    get optionsMap() {
                        return this._def.optionsMap;
                    }
                    static create(e, t, r) {
                        const n = new Map;
                        for (const r of t){
                            const t = D(r.shape[e]);
                            if (!t) throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
                            for (const o of t){
                                if (n.has(o)) throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
                                n.set(o, r);
                            }
                        }
                        return new F({
                            typeName: ae.ZodDiscriminatedUnion,
                            discriminator: e,
                            options: t,
                            optionsMap: n,
                            ...d(r)
                        });
                    }
                }
                function H(e, t) {
                    const r = (0, s.getParsedType)(e), n = (0, s.getParsedType)(t);
                    if (e === t) return {
                        valid: !0,
                        data: e
                    };
                    if (r === s.ZodParsedType.object && n === s.ZodParsedType.object) {
                        const r = s.util.objectKeys(t), n = s.util.objectKeys(e).filter((e)=>-1 !== r.indexOf(e)), o = {
                            ...e,
                            ...t
                        };
                        for (const r of n){
                            const n = H(e[r], t[r]);
                            if (!n.valid) return {
                                valid: !1
                            };
                            o[r] = n.data;
                        }
                        return {
                            valid: !0,
                            data: o
                        };
                    }
                    if (r === s.ZodParsedType.array && n === s.ZodParsedType.array) {
                        if (e.length !== t.length) return {
                            valid: !1
                        };
                        const r = [];
                        for(let n = 0; n < e.length; n++){
                            const o = H(e[n], t[n]);
                            if (!o.valid) return {
                                valid: !1
                            };
                            r.push(o.data);
                        }
                        return {
                            valid: !0,
                            data: r
                        };
                    }
                    return r === s.ZodParsedType.date && n === s.ZodParsedType.date && +e == +t ? {
                        valid: !0,
                        data: e
                    } : {
                        valid: !1
                    };
                }
                t.ZodDiscriminatedUnion = F;
                class j extends l {
                    _parse(e) {
                        const { status: t, ctx: r } = this._processInputParams(e), n = (e, n)=>{
                            if ((0, i.isAborted)(e) || (0, i.isAborted)(n)) return i.INVALID;
                            const o = H(e.value, n.value);
                            return o.valid ? (((0, i.isDirty)(e) || (0, i.isDirty)(n)) && t.dirty(), {
                                status: t.value,
                                value: o.data
                            }) : ((0, i.addIssueToContext)(r, {
                                code: a.ZodIssueCode.invalid_intersection_types
                            }), i.INVALID);
                        };
                        return r.common.async ? Promise.all([
                            this._def.left._parseAsync({
                                data: r.data,
                                path: r.path,
                                parent: r
                            }),
                            this._def.right._parseAsync({
                                data: r.data,
                                path: r.path,
                                parent: r
                            })
                        ]).then(([e, t])=>n(e, t)) : n(this._def.left._parseSync({
                            data: r.data,
                            path: r.path,
                            parent: r
                        }), this._def.right._parseSync({
                            data: r.data,
                            path: r.path,
                            parent: r
                        }));
                    }
                }
                t.ZodIntersection = j, j.create = (e, t, r)=>new j({
                        left: e,
                        right: t,
                        typeName: ae.ZodIntersection,
                        ...d(r)
                    });
                class U extends l {
                    _parse(e) {
                        const { status: t, ctx: r } = this._processInputParams(e);
                        if (r.parsedType !== s.ZodParsedType.array) return (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: s.ZodParsedType.array,
                            received: r.parsedType
                        }), i.INVALID;
                        if (r.data.length < this._def.items.length) return (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.too_small,
                            minimum: this._def.items.length,
                            inclusive: !0,
                            exact: !1,
                            type: "array"
                        }), i.INVALID;
                        !this._def.rest && r.data.length > this._def.items.length && ((0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.too_big,
                            maximum: this._def.items.length,
                            inclusive: !0,
                            exact: !1,
                            type: "array"
                        }), t.dirty());
                        const n = [
                            ...r.data
                        ].map((e, t)=>{
                            const n = this._def.items[t] || this._def.rest;
                            return n ? n._parse(new c(r, e, r.path, t)) : null;
                        }).filter((e)=>!!e);
                        return r.common.async ? Promise.all(n).then((e)=>i.ParseStatus.mergeArray(t, e)) : i.ParseStatus.mergeArray(t, n);
                    }
                    get items() {
                        return this._def.items;
                    }
                    rest(e) {
                        return new U({
                            ...this._def,
                            rest: e
                        });
                    }
                }
                t.ZodTuple = U, U.create = (e, t)=>{
                    if (!Array.isArray(e)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
                    return new U({
                        items: e,
                        typeName: ae.ZodTuple,
                        rest: null,
                        ...d(t)
                    });
                };
                class G extends l {
                    get keySchema() {
                        return this._def.keyType;
                    }
                    get valueSchema() {
                        return this._def.valueType;
                    }
                    _parse(e) {
                        const { status: t, ctx: r } = this._processInputParams(e);
                        if (r.parsedType !== s.ZodParsedType.object) return (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: s.ZodParsedType.object,
                            received: r.parsedType
                        }), i.INVALID;
                        const n = [], o = this._def.keyType, u = this._def.valueType;
                        for(const e in r.data)n.push({
                            key: o._parse(new c(r, e, r.path, e)),
                            value: u._parse(new c(r, r.data[e], r.path, e))
                        });
                        return r.common.async ? i.ParseStatus.mergeObjectAsync(t, n) : i.ParseStatus.mergeObjectSync(t, n);
                    }
                    get element() {
                        return this._def.valueType;
                    }
                    static create(e, t, r) {
                        return new G(t instanceof l ? {
                            keyType: e,
                            valueType: t,
                            typeName: ae.ZodRecord,
                            ...d(r)
                        } : {
                            keyType: E.create(),
                            valueType: e,
                            typeName: ae.ZodRecord,
                            ...d(t)
                        });
                    }
                }
                t.ZodRecord = G;
                class V extends l {
                    get keySchema() {
                        return this._def.keyType;
                    }
                    get valueSchema() {
                        return this._def.valueType;
                    }
                    _parse(e) {
                        const { status: t, ctx: r } = this._processInputParams(e);
                        if (r.parsedType !== s.ZodParsedType.map) return (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: s.ZodParsedType.map,
                            received: r.parsedType
                        }), i.INVALID;
                        const n = this._def.keyType, o = this._def.valueType, u = [
                            ...r.data.entries()
                        ].map(([e, t], i)=>({
                                key: n._parse(new c(r, e, r.path, [
                                    i,
                                    "key"
                                ])),
                                value: o._parse(new c(r, t, r.path, [
                                    i,
                                    "value"
                                ]))
                            }));
                        if (r.common.async) {
                            const e = new Map;
                            return Promise.resolve().then(async ()=>{
                                for (const r of u){
                                    const n = await r.key, o = await r.value;
                                    if ("aborted" === n.status || "aborted" === o.status) return i.INVALID;
                                    "dirty" !== n.status && "dirty" !== o.status || t.dirty(), e.set(n.value, o.value);
                                }
                                return {
                                    status: t.value,
                                    value: e
                                };
                            });
                        }
                        {
                            const e = new Map;
                            for (const r of u){
                                const n = r.key, o = r.value;
                                if ("aborted" === n.status || "aborted" === o.status) return i.INVALID;
                                "dirty" !== n.status && "dirty" !== o.status || t.dirty(), e.set(n.value, o.value);
                            }
                            return {
                                status: t.value,
                                value: e
                            };
                        }
                    }
                }
                t.ZodMap = V, V.create = (e, t, r)=>new V({
                        valueType: t,
                        keyType: e,
                        typeName: ae.ZodMap,
                        ...d(r)
                    });
                class W extends l {
                    _parse(e) {
                        const { status: t, ctx: r } = this._processInputParams(e);
                        if (r.parsedType !== s.ZodParsedType.set) return (0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: s.ZodParsedType.set,
                            received: r.parsedType
                        }), i.INVALID;
                        const n = this._def;
                        null !== n.minSize && r.data.size < n.minSize.value && ((0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.too_small,
                            minimum: n.minSize.value,
                            type: "set",
                            inclusive: !0,
                            exact: !1,
                            message: n.minSize.message
                        }), t.dirty()), null !== n.maxSize && r.data.size > n.maxSize.value && ((0, i.addIssueToContext)(r, {
                            code: a.ZodIssueCode.too_big,
                            maximum: n.maxSize.value,
                            type: "set",
                            inclusive: !0,
                            exact: !1,
                            message: n.maxSize.message
                        }), t.dirty());
                        const o = this._def.valueType;
                        function u(e) {
                            const r = new Set;
                            for (const n of e){
                                if ("aborted" === n.status) return i.INVALID;
                                "dirty" === n.status && t.dirty(), r.add(n.value);
                            }
                            return {
                                status: t.value,
                                value: r
                            };
                        }
                        const d = [
                            ...r.data.values()
                        ].map((e, t)=>o._parse(new c(r, e, r.path, t)));
                        return r.common.async ? Promise.all(d).then((e)=>u(e)) : u(d);
                    }
                    min(e, t) {
                        return new W({
                            ...this._def,
                            minSize: {
                                value: e,
                                message: o.errorUtil.toString(t)
                            }
                        });
                    }
                    max(e, t) {
                        return new W({
                            ...this._def,
                            maxSize: {
                                value: e,
                                message: o.errorUtil.toString(t)
                            }
                        });
                    }
                    size(e, t) {
                        return this.min(e, t).max(e, t);
                    }
                    nonempty(e) {
                        return this.min(1, e);
                    }
                }
                t.ZodSet = W, W.create = (e, t)=>new W({
                        valueType: e,
                        minSize: null,
                        maxSize: null,
                        typeName: ae.ZodSet,
                        ...d(t)
                    });
                class Z extends l {
                    constructor(){
                        super(...arguments), this.validate = this.implement;
                    }
                    _parse(e) {
                        const { ctx: t } = this._processInputParams(e);
                        if (t.parsedType !== s.ZodParsedType.function) return (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: s.ZodParsedType.function,
                            received: t.parsedType
                        }), i.INVALID;
                        function r(e, r) {
                            return (0, i.makeIssue)({
                                data: e,
                                path: t.path,
                                errorMaps: [
                                    t.common.contextualErrorMap,
                                    t.schemaErrorMap,
                                    (0, n.getErrorMap)(),
                                    n.defaultErrorMap
                                ].filter((e)=>!!e),
                                issueData: {
                                    code: a.ZodIssueCode.invalid_arguments,
                                    argumentsError: r
                                }
                            });
                        }
                        function o(e, r) {
                            return (0, i.makeIssue)({
                                data: e,
                                path: t.path,
                                errorMaps: [
                                    t.common.contextualErrorMap,
                                    t.schemaErrorMap,
                                    (0, n.getErrorMap)(),
                                    n.defaultErrorMap
                                ].filter((e)=>!!e),
                                issueData: {
                                    code: a.ZodIssueCode.invalid_return_type,
                                    returnTypeError: r
                                }
                            });
                        }
                        const c = {
                            errorMap: t.common.contextualErrorMap
                        }, u = t.data;
                        if (this._def.returns instanceof J) {
                            const e = this;
                            return (0, i.OK)(async function(...t) {
                                const n = new a.ZodError([]), i = await e._def.args.parseAsync(t, c).catch((e)=>{
                                    throw n.addIssue(r(t, e)), n;
                                }), s = await Reflect.apply(u, this, i);
                                return await e._def.returns._def.type.parseAsync(s, c).catch((e)=>{
                                    throw n.addIssue(o(s, e)), n;
                                });
                            });
                        }
                        {
                            const e = this;
                            return (0, i.OK)(function(...t) {
                                const n = e._def.args.safeParse(t, c);
                                if (!n.success) throw new a.ZodError([
                                    r(t, n.error)
                                ]);
                                const i = Reflect.apply(u, this, n.data), s = e._def.returns.safeParse(i, c);
                                if (!s.success) throw new a.ZodError([
                                    o(i, s.error)
                                ]);
                                return s.data;
                            });
                        }
                    }
                    parameters() {
                        return this._def.args;
                    }
                    returnType() {
                        return this._def.returns;
                    }
                    args(...e) {
                        return new Z({
                            ...this._def,
                            args: U.create(e).rest(S.create())
                        });
                    }
                    returns(e) {
                        return new Z({
                            ...this._def,
                            returns: e
                        });
                    }
                    implement(e) {
                        return this.parse(e);
                    }
                    strictImplement(e) {
                        return this.parse(e);
                    }
                    static create(e, t, r) {
                        return new Z({
                            args: e || U.create([]).rest(S.create()),
                            returns: t || S.create(),
                            typeName: ae.ZodFunction,
                            ...d(r)
                        });
                    }
                }
                t.ZodFunction = Z;
                class q extends l {
                    get schema() {
                        return this._def.getter();
                    }
                    _parse(e) {
                        const { ctx: t } = this._processInputParams(e);
                        return this._def.getter()._parse({
                            data: t.data,
                            path: t.path,
                            parent: t
                        });
                    }
                }
                t.ZodLazy = q, q.create = (e, t)=>new q({
                        getter: e,
                        typeName: ae.ZodLazy,
                        ...d(t)
                    });
                class z extends l {
                    _parse(e) {
                        if (e.data !== this._def.value) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                received: t.data,
                                code: a.ZodIssueCode.invalid_literal,
                                expected: this._def.value
                            }), i.INVALID;
                        }
                        return {
                            status: "valid",
                            value: e.data
                        };
                    }
                    get value() {
                        return this._def.value;
                    }
                }
                function K(e, t) {
                    return new Q({
                        values: e,
                        typeName: ae.ZodEnum,
                        ...d(t)
                    });
                }
                t.ZodLiteral = z, z.create = (e, t)=>new z({
                        value: e,
                        typeName: ae.ZodLiteral,
                        ...d(t)
                    });
                class Q extends l {
                    _parse(e) {
                        if ("string" != typeof e.data) {
                            const t = this._getOrReturnCtx(e), r = this._def.values;
                            return (0, i.addIssueToContext)(t, {
                                expected: s.util.joinValues(r),
                                received: t.parsedType,
                                code: a.ZodIssueCode.invalid_type
                            }), i.INVALID;
                        }
                        if (-1 === this._def.values.indexOf(e.data)) {
                            const t = this._getOrReturnCtx(e), r = this._def.values;
                            return (0, i.addIssueToContext)(t, {
                                received: t.data,
                                code: a.ZodIssueCode.invalid_enum_value,
                                options: r
                            }), i.INVALID;
                        }
                        return (0, i.OK)(e.data);
                    }
                    get options() {
                        return this._def.values;
                    }
                    get enum() {
                        const e = {};
                        for (const t of this._def.values)e[t] = t;
                        return e;
                    }
                    get Values() {
                        const e = {};
                        for (const t of this._def.values)e[t] = t;
                        return e;
                    }
                    get Enum() {
                        const e = {};
                        for (const t of this._def.values)e[t] = t;
                        return e;
                    }
                    extract(e) {
                        return Q.create(e);
                    }
                    exclude(e) {
                        return Q.create(this.options.filter((t)=>!e.includes(t)));
                    }
                }
                t.ZodEnum = Q, Q.create = K;
                class X extends l {
                    _parse(e) {
                        const t = s.util.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
                        if (r.parsedType !== s.ZodParsedType.string && r.parsedType !== s.ZodParsedType.number) {
                            const e = s.util.objectValues(t);
                            return (0, i.addIssueToContext)(r, {
                                expected: s.util.joinValues(e),
                                received: r.parsedType,
                                code: a.ZodIssueCode.invalid_type
                            }), i.INVALID;
                        }
                        if (-1 === t.indexOf(e.data)) {
                            const e = s.util.objectValues(t);
                            return (0, i.addIssueToContext)(r, {
                                received: r.data,
                                code: a.ZodIssueCode.invalid_enum_value,
                                options: e
                            }), i.INVALID;
                        }
                        return (0, i.OK)(e.data);
                    }
                    get enum() {
                        return this._def.values;
                    }
                }
                t.ZodNativeEnum = X, X.create = (e, t)=>new X({
                        values: e,
                        typeName: ae.ZodNativeEnum,
                        ...d(t)
                    });
                class J extends l {
                    unwrap() {
                        return this._def.type;
                    }
                    _parse(e) {
                        const { ctx: t } = this._processInputParams(e);
                        if (t.parsedType !== s.ZodParsedType.promise && !1 === t.common.async) return (0, i.addIssueToContext)(t, {
                            code: a.ZodIssueCode.invalid_type,
                            expected: s.ZodParsedType.promise,
                            received: t.parsedType
                        }), i.INVALID;
                        const r = t.parsedType === s.ZodParsedType.promise ? t.data : Promise.resolve(t.data);
                        return (0, i.OK)(r.then((e)=>this._def.type.parseAsync(e, {
                                path: t.path,
                                errorMap: t.common.contextualErrorMap
                            })));
                    }
                }
                t.ZodPromise = J, J.create = (e, t)=>new J({
                        type: e,
                        typeName: ae.ZodPromise,
                        ...d(t)
                    });
                class Y extends l {
                    innerType() {
                        return this._def.schema;
                    }
                    sourceType() {
                        return this._def.schema._def.typeName === ae.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
                    }
                    _parse(e) {
                        const { status: t, ctx: r } = this._processInputParams(e), n = this._def.effect || null, o = {
                            addIssue: (e)=>{
                                (0, i.addIssueToContext)(r, e), e.fatal ? t.abort() : t.dirty();
                            },
                            get path () {
                                return r.path;
                            }
                        };
                        if (o.addIssue = o.addIssue.bind(o), "preprocess" === n.type) {
                            const e = n.transform(r.data, o);
                            return r.common.issues.length ? {
                                status: "dirty",
                                value: r.data
                            } : r.common.async ? Promise.resolve(e).then((e)=>this._def.schema._parseAsync({
                                    data: e,
                                    path: r.path,
                                    parent: r
                                })) : this._def.schema._parseSync({
                                data: e,
                                path: r.path,
                                parent: r
                            });
                        }
                        if ("refinement" === n.type) {
                            const e = (e)=>{
                                const t = n.refinement(e, o);
                                if (r.common.async) return Promise.resolve(t);
                                if (t instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                                return e;
                            };
                            if (!1 === r.common.async) {
                                const n = this._def.schema._parseSync({
                                    data: r.data,
                                    path: r.path,
                                    parent: r
                                });
                                return "aborted" === n.status ? i.INVALID : ("dirty" === n.status && t.dirty(), e(n.value), {
                                    status: t.value,
                                    value: n.value
                                });
                            }
                            return this._def.schema._parseAsync({
                                data: r.data,
                                path: r.path,
                                parent: r
                            }).then((r)=>"aborted" === r.status ? i.INVALID : ("dirty" === r.status && t.dirty(), e(r.value).then(()=>({
                                        status: t.value,
                                        value: r.value
                                    }))));
                        }
                        if ("transform" === n.type) {
                            if (!1 === r.common.async) {
                                const e = this._def.schema._parseSync({
                                    data: r.data,
                                    path: r.path,
                                    parent: r
                                });
                                if (!(0, i.isValid)(e)) return e;
                                const s = n.transform(e.value, o);
                                if (s instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
                                return {
                                    status: t.value,
                                    value: s
                                };
                            }
                            return this._def.schema._parseAsync({
                                data: r.data,
                                path: r.path,
                                parent: r
                            }).then((e)=>(0, i.isValid)(e) ? Promise.resolve(n.transform(e.value, o)).then((e)=>({
                                        status: t.value,
                                        value: e
                                    })) : e);
                        }
                        s.util.assertNever(n);
                    }
                }
                t.ZodEffects = Y, t.ZodTransformer = Y, Y.create = (e, t, r)=>new Y({
                        schema: e,
                        typeName: ae.ZodEffects,
                        effect: t,
                        ...d(r)
                    }), Y.createWithPreprocess = (e, t, r)=>new Y({
                        schema: t,
                        effect: {
                            type: "preprocess",
                            transform: e
                        },
                        typeName: ae.ZodEffects,
                        ...d(r)
                    });
                class $ extends l {
                    _parse(e) {
                        return this._getType(e) === s.ZodParsedType.undefined ? (0, i.OK)(void 0) : this._def.innerType._parse(e);
                    }
                    unwrap() {
                        return this._def.innerType;
                    }
                }
                t.ZodOptional = $, $.create = (e, t)=>new $({
                        innerType: e,
                        typeName: ae.ZodOptional,
                        ...d(t)
                    });
                class ee extends l {
                    _parse(e) {
                        return this._getType(e) === s.ZodParsedType.null ? (0, i.OK)(null) : this._def.innerType._parse(e);
                    }
                    unwrap() {
                        return this._def.innerType;
                    }
                }
                t.ZodNullable = ee, ee.create = (e, t)=>new ee({
                        innerType: e,
                        typeName: ae.ZodNullable,
                        ...d(t)
                    });
                class te extends l {
                    _parse(e) {
                        const { ctx: t } = this._processInputParams(e);
                        let r = t.data;
                        return t.parsedType === s.ZodParsedType.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
                            data: r,
                            path: t.path,
                            parent: t
                        });
                    }
                    removeDefault() {
                        return this._def.innerType;
                    }
                }
                t.ZodDefault = te, te.create = (e, t)=>new te({
                        innerType: e,
                        typeName: ae.ZodDefault,
                        defaultValue: "function" == typeof t.default ? t.default : ()=>t.default,
                        ...d(t)
                    });
                class re extends l {
                    _parse(e) {
                        const { ctx: t } = this._processInputParams(e), r = {
                            ...t,
                            common: {
                                ...t.common,
                                issues: []
                            }
                        }, n = this._def.innerType._parse({
                            data: r.data,
                            path: r.path,
                            parent: {
                                ...r
                            }
                        });
                        return (0, i.isAsync)(n) ? n.then((e)=>({
                                status: "valid",
                                value: "valid" === e.status ? e.value : this._def.catchValue({
                                    get error () {
                                        return new a.ZodError(r.common.issues);
                                    },
                                    input: r.data
                                })
                            })) : {
                            status: "valid",
                            value: "valid" === n.status ? n.value : this._def.catchValue({
                                get error () {
                                    return new a.ZodError(r.common.issues);
                                },
                                input: r.data
                            })
                        };
                    }
                    removeCatch() {
                        return this._def.innerType;
                    }
                }
                t.ZodCatch = re, re.create = (e, t)=>new re({
                        innerType: e,
                        typeName: ae.ZodCatch,
                        catchValue: "function" == typeof t.catch ? t.catch : ()=>t.catch,
                        ...d(t)
                    });
                class ne extends l {
                    _parse(e) {
                        if (this._getType(e) !== s.ZodParsedType.nan) {
                            const t = this._getOrReturnCtx(e);
                            return (0, i.addIssueToContext)(t, {
                                code: a.ZodIssueCode.invalid_type,
                                expected: s.ZodParsedType.nan,
                                received: t.parsedType
                            }), i.INVALID;
                        }
                        return {
                            status: "valid",
                            value: e.data
                        };
                    }
                }
                t.ZodNaN = ne, ne.create = (e)=>new ne({
                        typeName: ae.ZodNaN,
                        ...d(e)
                    }), t.BRAND = Symbol("zod_brand");
                class oe extends l {
                    _parse(e) {
                        const { ctx: t } = this._processInputParams(e), r = t.data;
                        return this._def.type._parse({
                            data: r,
                            path: t.path,
                            parent: t
                        });
                    }
                    unwrap() {
                        return this._def.type;
                    }
                }
                t.ZodBranded = oe;
                class ie extends l {
                    _parse(e) {
                        const { status: t, ctx: r } = this._processInputParams(e);
                        if (r.common.async) return (async ()=>{
                            const e = await this._def.in._parseAsync({
                                data: r.data,
                                path: r.path,
                                parent: r
                            });
                            return "aborted" === e.status ? i.INVALID : "dirty" === e.status ? (t.dirty(), (0, i.DIRTY)(e.value)) : this._def.out._parseAsync({
                                data: e.value,
                                path: r.path,
                                parent: r
                            });
                        })();
                        {
                            const e = this._def.in._parseSync({
                                data: r.data,
                                path: r.path,
                                parent: r
                            });
                            return "aborted" === e.status ? i.INVALID : "dirty" === e.status ? (t.dirty(), {
                                status: "dirty",
                                value: e.value
                            }) : this._def.out._parseSync({
                                data: e.value,
                                path: r.path,
                                parent: r
                            });
                        }
                    }
                    static create(e, t) {
                        return new ie({
                            in: e,
                            out: t,
                            typeName: ae.ZodPipeline
                        });
                    }
                }
                t.ZodPipeline = ie;
                class se extends l {
                    _parse(e) {
                        const t = this._def.innerType._parse(e);
                        return (0, i.isValid)(t) && (t.value = Object.freeze(t.value)), t;
                    }
                }
                var ae;
                t.ZodReadonly = se, se.create = (e, t)=>new se({
                        innerType: e,
                        typeName: ae.ZodReadonly,
                        ...d(t)
                    }), t.custom = (e, t = {}, r)=>e ? O.create().superRefine((n, o)=>{
                        var i, s;
                        if (!e(n)) {
                            const e = "function" == typeof t ? t(n) : "string" == typeof t ? {
                                message: t
                            } : t, a = null === (s = null !== (i = e.fatal) && void 0 !== i ? i : r) || void 0 === s || s, c = "string" == typeof e ? {
                                message: e
                            } : e;
                            o.addIssue({
                                code: "custom",
                                ...c,
                                fatal: a
                            });
                        }
                    }) : O.create(), t.late = {
                    object: M.lazycreate
                }, function(e) {
                    e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
                }(ae = t.ZodFirstPartyTypeKind || (t.ZodFirstPartyTypeKind = {})), t.instanceof = (e, r = {
                    message: `Input not instance of ${e.name}`
                })=>(0, t.custom)((t)=>t instanceof e, r);
                const ce = E.create;
                t.string = ce;
                const ue = A.create;
                t.number = ue;
                const de = ne.create;
                t.nan = de;
                const le = T.create;
                t.bigint = le;
                const he = w.create;
                t.boolean = he;
                const fe = I.create;
                t.date = fe;
                const pe = R.create;
                t.symbol = pe;
                const me = P.create;
                t.undefined = me;
                const ge = x.create;
                t.null = ge;
                const ye = O.create;
                t.any = ye;
                const ve = S.create;
                t.unknown = ve;
                const be = C.create;
                t.never = be;
                const Ee = B.create;
                t.void = Ee;
                const _e = k.create;
                t.array = _e;
                const Ae = M.create;
                t.object = Ae;
                const Te = M.strictCreate;
                t.strictObject = Te;
                const we = L.create;
                t.union = we;
                const Ie = F.create;
                t.discriminatedUnion = Ie;
                const Re = j.create;
                t.intersection = Re;
                const Pe = U.create;
                t.tuple = Pe;
                const xe = G.create;
                t.record = xe;
                const Oe = V.create;
                t.map = Oe;
                const Se = W.create;
                t.set = Se;
                const Ce = Z.create;
                t.function = Ce;
                const Be = q.create;
                t.lazy = Be;
                const ke = z.create;
                t.literal = ke;
                const Ne = Q.create;
                t.enum = Ne;
                const Me = X.create;
                t.nativeEnum = Me;
                const Le = J.create;
                t.promise = Le;
                const De = Y.create;
                t.effect = De, t.transformer = De;
                const Fe = $.create;
                t.optional = Fe;
                const He = ee.create;
                t.nullable = He;
                const je = Y.createWithPreprocess;
                t.preprocess = je;
                const Ue = ie.create;
                t.pipeline = Ue, t.ostring = ()=>ce().optional(), t.onumber = ()=>ue().optional(), t.oboolean = ()=>he().optional(), t.coerce = {
                    string: (e)=>E.create({
                            ...e,
                            coerce: !0
                        }),
                    number: (e)=>A.create({
                            ...e,
                            coerce: !0
                        }),
                    boolean: (e)=>w.create({
                            ...e,
                            coerce: !0
                        }),
                    bigint: (e)=>T.create({
                            ...e,
                            coerce: !0
                        }),
                    date: (e)=>I.create({
                            ...e,
                            coerce: !0
                        })
                }, t.NEVER = i.INVALID;
            },
            4530: (e, t)=>{
                "use strict";
                function r(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Wrong positive integer: ${e}`);
                }
                function n(e) {
                    if ("boolean" != typeof e) throw new Error(`Expected boolean, not ${e}`);
                }
                function o(e, ...t) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
                    if (t.length > 0 && !t.includes(e.length)) throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
                }
                function i(e) {
                    if ("function" != typeof e || "function" != typeof e.create) throw new Error("Hash should be wrapped by utils.wrapConstructor");
                    r(e.outputLen), r(e.blockLen);
                }
                function s(e, t = !0) {
                    if (e.destroyed) throw new Error("Hash instance has been destroyed");
                    if (t && e.finished) throw new Error("Hash#digest() has already been called");
                }
                function a(e, t) {
                    o(e);
                    const r = t.outputLen;
                    if (e.length < r) throw new Error(`digestInto() expects output buffer of length at least ${r}`);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.output = t.exists = t.hash = t.bytes = t.bool = t.number = void 0, t.number = r, t.bool = n, t.bytes = o, t.hash = i, t.exists = s, t.output = a;
                const c = {
                    number: r,
                    bool: n,
                    bytes: o,
                    hash: i,
                    exists: s,
                    output: a
                };
                t.default = c;
            },
            2023: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SHA2 = void 0;
                const n = r(4530), o = r(2071);
                class i extends o.Hash {
                    constructor(e, t, r, n){
                        super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = (0, o.createView)(this.buffer);
                    }
                    update(e) {
                        n.default.exists(this);
                        const { view: t, buffer: r, blockLen: i } = this, s = (e = (0, o.toBytes)(e)).length;
                        for(let n = 0; n < s;){
                            const a = Math.min(i - this.pos, s - n);
                            if (a !== i) r.set(e.subarray(n, n + a), this.pos), this.pos += a, n += a, this.pos === i && (this.process(t, 0), this.pos = 0);
                            else {
                                const t = (0, o.createView)(e);
                                for(; i <= s - n; n += i)this.process(t, n);
                            }
                        }
                        return this.length += e.length, this.roundClean(), this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.output(e, this), this.finished = !0;
                        const { buffer: t, view: r, blockLen: i, isLE: s } = this;
                        let { pos: a } = this;
                        t[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > i - a && (this.process(r, 0), a = 0);
                        for(let e = a; e < i; e++)t[e] = 0;
                        !function(e, t, r, n) {
                            if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, r, n);
                            const o = BigInt(32), i = BigInt(4294967295), s = Number(r >> o & i), a = Number(r & i), c = n ? 4 : 0, u = n ? 0 : 4;
                            e.setUint32(t + c, s, n), e.setUint32(t + u, a, n);
                        }(r, i - 8, BigInt(8 * this.length), s), this.process(r, 0);
                        const c = (0, o.createView)(e), u = this.outputLen;
                        if (u % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                        const d = u / 4, l = this.get();
                        if (d > l.length) throw new Error("_sha2: outputLen bigger than state");
                        for(let e = 0; e < d; e++)c.setUint32(4 * e, l[e], s);
                    }
                    digest() {
                        const { buffer: e, outputLen: t } = this;
                        this.digestInto(e);
                        const r = e.slice(0, t);
                        return this.destroy(), r;
                    }
                    _cloneInto(e) {
                        e || (e = new this.constructor), e.set(...this.get());
                        const { blockLen: t, buffer: r, length: n, finished: o, destroyed: i, pos: s } = this;
                        return e.length = n, e.pos = s, e.finished = o, e.destroyed = i, n % t && e.buffer.set(r), e;
                    }
                }
                t.SHA2 = i;
            },
            2286: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.add = t.toBig = t.split = t.fromBig = void 0;
                const r = BigInt(2 ** 32 - 1), n = BigInt(32);
                function o(e, t = !1) {
                    return t ? {
                        h: Number(e & r),
                        l: Number(e >> n & r)
                    } : {
                        h: 0 | Number(e >> n & r),
                        l: 0 | Number(e & r)
                    };
                }
                function i(e, t = !1) {
                    let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
                    for(let i = 0; i < e.length; i++){
                        const { h: s, l: a } = o(e[i], t);
                        [r[i], n[i]] = [
                            s,
                            a
                        ];
                    }
                    return [
                        r,
                        n
                    ];
                }
                function s(e, t, r, n) {
                    const o = (t >>> 0) + (n >>> 0);
                    return {
                        h: e + r + (o / 2 ** 32 | 0) | 0,
                        l: 0 | o
                    };
                }
                t.fromBig = o, t.split = i, t.toBig = (e, t)=>BigInt(e >>> 0) << n | BigInt(t >>> 0), t.add = s;
                const a = {
                    fromBig: o,
                    split: i,
                    toBig: t.toBig,
                    shrSH: (e, t, r)=>e >>> r,
                    shrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrSH: (e, t, r)=>e >>> r | t << 32 - r,
                    rotrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrBH: (e, t, r)=>e << 64 - r | t >>> r - 32,
                    rotrBL: (e, t, r)=>e >>> r - 32 | t << 64 - r,
                    rotr32H: (e, t)=>t,
                    rotr32L: (e, t)=>e,
                    rotlSH: (e, t, r)=>e << r | t >>> 32 - r,
                    rotlSL: (e, t, r)=>t << r | e >>> 32 - r,
                    rotlBH: (e, t, r)=>t << r - 32 | e >>> 64 - r,
                    rotlBL: (e, t, r)=>e << r - 32 | t >>> 64 - r,
                    add: s,
                    add3L: (e, t, r)=>(e >>> 0) + (t >>> 0) + (r >>> 0),
                    add3H: (e, t, r, n)=>t + r + n + (e / 2 ** 32 | 0) | 0,
                    add4L: (e, t, r, n)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0),
                    add4H: (e, t, r, n, o)=>t + r + n + o + (e / 2 ** 32 | 0) | 0,
                    add5H: (e, t, r, n, o, i)=>t + r + n + o + i + (e / 2 ** 32 | 0) | 0,
                    add5L: (e, t, r, n, o)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0)
                };
                t.default = a;
            },
            9043: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = void 0, t.crypto = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0;
            },
            4302: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hmac = void 0;
                const n = r(4530), o = r(2071);
                class i extends o.Hash {
                    constructor(e, t){
                        super(), this.finished = !1, this.destroyed = !1, n.default.hash(e);
                        const r = (0, o.toBytes)(t);
                        if (this.iHash = e.create(), "function" != typeof this.iHash.update) throw new TypeError("Expected instance of class which extends utils.Hash");
                        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
                        const i = this.blockLen, s = new Uint8Array(i);
                        s.set(r.length > i ? e.create().update(r).digest() : r);
                        for(let e = 0; e < s.length; e++)s[e] ^= 54;
                        this.iHash.update(s), this.oHash = e.create();
                        for(let e = 0; e < s.length; e++)s[e] ^= 106;
                        this.oHash.update(s), s.fill(0);
                    }
                    update(e) {
                        return n.default.exists(this), this.iHash.update(e), this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.bytes(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
                    }
                    digest() {
                        const e = new Uint8Array(this.oHash.outputLen);
                        return this.digestInto(e), e;
                    }
                    _cloneInto(e) {
                        e || (e = Object.create(Object.getPrototypeOf(this), {}));
                        const { oHash: t, iHash: r, finished: n, destroyed: o, blockLen: i, outputLen: s } = this;
                        return e.finished = n, e.destroyed = o, e.blockLen = i, e.outputLen = s, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
                    }
                    destroy() {
                        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
                    }
                }
                t.hmac = (e, t, r)=>new i(e, t).update(r).digest(), t.hmac.create = (e, t)=>new i(e, t);
            },
            8797: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.pbkdf2Async = t.pbkdf2 = void 0;
                const n = r(4530), o = r(4302), i = r(2071);
                function s(e, t, r, s) {
                    n.default.hash(e);
                    const a = (0, i.checkOpts)({
                        dkLen: 32,
                        asyncTick: 10
                    }, s), { c: c, dkLen: u, asyncTick: d } = a;
                    if (n.default.number(c), n.default.number(u), n.default.number(d), c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
                    const l = (0, i.toBytes)(t), h = (0, i.toBytes)(r), f = new Uint8Array(u), p = o.hmac.create(e, l), m = p._cloneInto().update(h);
                    return {
                        c: c,
                        dkLen: u,
                        asyncTick: d,
                        DK: f,
                        PRF: p,
                        PRFSalt: m
                    };
                }
                function a(e, t, r, n, o) {
                    return e.destroy(), t.destroy(), n && n.destroy(), o.fill(0), r;
                }
                t.pbkdf2 = function(e, t, r, n) {
                    const { c: o, dkLen: c, DK: u, PRF: d, PRFSalt: l } = s(e, t, r, n);
                    let h;
                    const f = new Uint8Array(4), p = (0, i.createView)(f), m = new Uint8Array(d.outputLen);
                    for(let e = 1, t = 0; t < c; e++, t += d.outputLen){
                        const r = u.subarray(t, t + d.outputLen);
                        p.setInt32(0, e, !1), (h = l._cloneInto(h)).update(f).digestInto(m), r.set(m.subarray(0, r.length));
                        for(let e = 1; e < o; e++){
                            d._cloneInto(h).update(m).digestInto(m);
                            for(let e = 0; e < r.length; e++)r[e] ^= m[e];
                        }
                    }
                    return a(d, l, u, h, m);
                }, t.pbkdf2Async = async function(e, t, r, n) {
                    const { c: o, dkLen: c, asyncTick: u, DK: d, PRF: l, PRFSalt: h } = s(e, t, r, n);
                    let f;
                    const p = new Uint8Array(4), m = (0, i.createView)(p), g = new Uint8Array(l.outputLen);
                    for(let e = 1, t = 0; t < c; e++, t += l.outputLen){
                        const r = d.subarray(t, t + l.outputLen);
                        m.setInt32(0, e, !1), (f = h._cloneInto(f)).update(p).digestInto(g), r.set(g.subarray(0, r.length)), await (0, i.asyncLoop)(o - 1, u, (e)=>{
                            l._cloneInto(f).update(g).digestInto(g);
                            for(let e = 0; e < r.length; e++)r[e] ^= g[e];
                        });
                    }
                    return a(l, h, d, f, g);
                };
            },
            217: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.scryptAsync = t.scrypt = void 0;
                const n = r(4530), o = r(8091), i = r(8797), s = r(2071), a = (e, t)=>e << t | e >>> 32 - t;
                function c(e, t, r, n, o, i) {
                    let s = e[t++] ^ r[n++], c = e[t++] ^ r[n++], u = e[t++] ^ r[n++], d = e[t++] ^ r[n++], l = e[t++] ^ r[n++], h = e[t++] ^ r[n++], f = e[t++] ^ r[n++], p = e[t++] ^ r[n++], m = e[t++] ^ r[n++], g = e[t++] ^ r[n++], y = e[t++] ^ r[n++], v = e[t++] ^ r[n++], b = e[t++] ^ r[n++], E = e[t++] ^ r[n++], _ = e[t++] ^ r[n++], A = e[t++] ^ r[n++], T = s, w = c, I = u, R = d, P = l, x = h, O = f, S = p, C = m, B = g, k = y, N = v, M = b, L = E, D = _, F = A;
                    for(let e = 0; e < 8; e += 2)P ^= a(T + M | 0, 7), C ^= a(P + T | 0, 9), M ^= a(C + P | 0, 13), T ^= a(M + C | 0, 18), B ^= a(x + w | 0, 7), L ^= a(B + x | 0, 9), w ^= a(L + B | 0, 13), x ^= a(w + L | 0, 18), D ^= a(k + O | 0, 7), I ^= a(D + k | 0, 9), O ^= a(I + D | 0, 13), k ^= a(O + I | 0, 18), R ^= a(F + N | 0, 7), S ^= a(R + F | 0, 9), N ^= a(S + R | 0, 13), F ^= a(N + S | 0, 18), w ^= a(T + R | 0, 7), I ^= a(w + T | 0, 9), R ^= a(I + w | 0, 13), T ^= a(R + I | 0, 18), O ^= a(x + P | 0, 7), S ^= a(O + x | 0, 9), P ^= a(S + O | 0, 13), x ^= a(P + S | 0, 18), N ^= a(k + B | 0, 7), C ^= a(N + k | 0, 9), B ^= a(C + N | 0, 13), k ^= a(B + C | 0, 18), M ^= a(F + D | 0, 7), L ^= a(M + F | 0, 9), D ^= a(L + M | 0, 13), F ^= a(D + L | 0, 18);
                    o[i++] = s + T | 0, o[i++] = c + w | 0, o[i++] = u + I | 0, o[i++] = d + R | 0, o[i++] = l + P | 0, o[i++] = h + x | 0, o[i++] = f + O | 0, o[i++] = p + S | 0, o[i++] = m + C | 0, o[i++] = g + B | 0, o[i++] = y + k | 0, o[i++] = v + N | 0, o[i++] = b + M | 0, o[i++] = E + L | 0, o[i++] = _ + D | 0, o[i++] = A + F | 0;
                }
                function u(e, t, r, n, o) {
                    let i = n + 0, s = n + 16 * o;
                    for(let n = 0; n < 16; n++)r[s + n] = e[t + 16 * (2 * o - 1) + n];
                    for(let n = 0; n < o; n++, i += 16, t += 16)c(r, s, e, t, r, i), n > 0 && (s += 16), c(r, i, e, t += 16, r, s);
                }
                function d(e, t, r) {
                    const a = (0, s.checkOpts)({
                        dkLen: 32,
                        asyncTick: 10,
                        maxmem: 1073742848
                    }, r), { N: c, r: u, p: d, dkLen: l, asyncTick: h, maxmem: f, onProgress: p } = a;
                    if (n.default.number(c), n.default.number(u), n.default.number(d), n.default.number(l), n.default.number(h), n.default.number(f), void 0 !== p && "function" != typeof p) throw new Error("progressCb should be function");
                    const m = 128 * u, g = m / 4;
                    if (c <= 1 || 0 != (c & c - 1) || c >= 2 ** (m / 8) || c > 2 ** 32) throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
                    if (d < 0 || d > 137438953440 / m) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
                    if (l < 0 || l > 137438953440) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
                    const y = m * (c + d);
                    if (y > f) throw new Error(`Scrypt: parameters too large, ${y} (128 * r * (N + p)) > ${f} (maxmem)`);
                    const v = (0, i.pbkdf2)(o.sha256, e, t, {
                        c: 1,
                        dkLen: m * d
                    }), b = (0, s.u32)(v), E = (0, s.u32)(new Uint8Array(m * c)), _ = (0, s.u32)(new Uint8Array(m));
                    let A = ()=>{};
                    if (p) {
                        const e = 2 * c * d, t = Math.max(Math.floor(e / 1e4), 1);
                        let r = 0;
                        A = ()=>{
                            r++, !p || r % t && r !== e || p(r / e);
                        };
                    }
                    return {
                        N: c,
                        r: u,
                        p: d,
                        dkLen: l,
                        blockSize32: g,
                        V: E,
                        B32: b,
                        B: v,
                        tmp: _,
                        blockMixCb: A,
                        asyncTick: h
                    };
                }
                function l(e, t, r, n, s) {
                    const a = (0, i.pbkdf2)(o.sha256, e, r, {
                        c: 1,
                        dkLen: t
                    });
                    return r.fill(0), n.fill(0), s.fill(0), a;
                }
                t.scrypt = function(e, t, r) {
                    const { N: n, r: o, p: i, dkLen: s, blockSize32: a, V: c, B32: h, B: f, tmp: p, blockMixCb: m } = d(e, t, r);
                    for(let e = 0; e < i; e++){
                        const t = a * e;
                        for(let e = 0; e < a; e++)c[e] = h[t + e];
                        for(let e = 0, t = 0; e < n - 1; e++)u(c, t, c, t += a, o), m();
                        u(c, (n - 1) * a, h, t, o), m();
                        for(let e = 0; e < n; e++){
                            const e = h[t + a - 16] % n;
                            for(let r = 0; r < a; r++)p[r] = h[t + r] ^ c[e * a + r];
                            u(p, 0, h, t, o), m();
                        }
                    }
                    return l(e, s, f, c, p);
                }, t.scryptAsync = async function(e, t, r) {
                    const { N: n, r: o, p: i, dkLen: a, blockSize32: c, V: h, B32: f, B: p, tmp: m, blockMixCb: g, asyncTick: y } = d(e, t, r);
                    for(let e = 0; e < i; e++){
                        const t = c * e;
                        for(let e = 0; e < c; e++)h[e] = f[t + e];
                        let r = 0;
                        await (0, s.asyncLoop)(n - 1, y, (e)=>{
                            u(h, r, h, r += c, o), g();
                        }), u(h, (n - 1) * c, f, t, o), g(), await (0, s.asyncLoop)(n, y, (e)=>{
                            const r = f[t + c - 16] % n;
                            for(let e = 0; e < c; e++)m[e] = f[t + e] ^ h[r * c + e];
                            u(m, 0, f, t, o), g();
                        });
                    }
                    return l(e, a, p, h, m);
                };
            },
            8091: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sha224 = t.sha256 = void 0;
                const n = r(2023), o = r(2071), i = (e, t, r)=>e & t ^ e & r ^ t & r, s = new Uint32Array([
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ]), a = new Uint32Array([
                    1779033703,
                    3144134277,
                    1013904242,
                    2773480762,
                    1359893119,
                    2600822924,
                    528734635,
                    1541459225
                ]), c = new Uint32Array(64);
                class u extends n.SHA2 {
                    constructor(){
                        super(64, 32, 8, !1), this.A = 0 | a[0], this.B = 0 | a[1], this.C = 0 | a[2], this.D = 0 | a[3], this.E = 0 | a[4], this.F = 0 | a[5], this.G = 0 | a[6], this.H = 0 | a[7];
                    }
                    get() {
                        const { A: e, B: t, C: r, D: n, E: o, F: i, G: s, H: a } = this;
                        return [
                            e,
                            t,
                            r,
                            n,
                            o,
                            i,
                            s,
                            a
                        ];
                    }
                    set(e, t, r, n, o, i, s, a) {
                        this.A = 0 | e, this.B = 0 | t, this.C = 0 | r, this.D = 0 | n, this.E = 0 | o, this.F = 0 | i, this.G = 0 | s, this.H = 0 | a;
                    }
                    process(e, t) {
                        for(let r = 0; r < 16; r++, t += 4)c[r] = e.getUint32(t, !1);
                        for(let e = 16; e < 64; e++){
                            const t = c[e - 15], r = c[e - 2], n = (0, o.rotr)(t, 7) ^ (0, o.rotr)(t, 18) ^ t >>> 3, i = (0, o.rotr)(r, 17) ^ (0, o.rotr)(r, 19) ^ r >>> 10;
                            c[e] = i + c[e - 7] + n + c[e - 16] | 0;
                        }
                        let { A: r, B: n, C: a, D: u, E: d, F: l, G: h, H: f } = this;
                        for(let e = 0; e < 64; e++){
                            const t = f + ((0, o.rotr)(d, 6) ^ (0, o.rotr)(d, 11) ^ (0, o.rotr)(d, 25)) + ((p = d) & l ^ ~p & h) + s[e] + c[e] | 0, m = ((0, o.rotr)(r, 2) ^ (0, o.rotr)(r, 13) ^ (0, o.rotr)(r, 22)) + i(r, n, a) | 0;
                            f = h, h = l, l = d, d = u + t | 0, u = a, a = n, n = r, r = t + m | 0;
                        }
                        var p;
                        r = r + this.A | 0, n = n + this.B | 0, a = a + this.C | 0, u = u + this.D | 0, d = d + this.E | 0, l = l + this.F | 0, h = h + this.G | 0, f = f + this.H | 0, this.set(r, n, a, u, d, l, h, f);
                    }
                    roundClean() {
                        c.fill(0);
                    }
                    destroy() {
                        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
                    }
                }
                class d extends u {
                    constructor(){
                        super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
                    }
                }
                t.sha256 = (0, o.wrapConstructor)(()=>new u), t.sha224 = (0, o.wrapConstructor)(()=>new d);
            },
            1366: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.shake256 = t.shake128 = t.keccak_512 = t.keccak_384 = t.keccak_256 = t.keccak_224 = t.sha3_512 = t.sha3_384 = t.sha3_256 = t.sha3_224 = t.Keccak = t.keccakP = void 0;
                const n = r(4530), o = r(2286), i = r(2071), [s, a, c] = [
                    [],
                    [],
                    []
                ], u = BigInt(0), d = BigInt(1), l = BigInt(2), h = BigInt(7), f = BigInt(256), p = BigInt(113);
                for(let e = 0, t = d, r = 1, n = 0; e < 24; e++){
                    [r, n] = [
                        n,
                        (2 * r + 3 * n) % 5
                    ], s.push(2 * (5 * n + r)), a.push((e + 1) * (e + 2) / 2 % 64);
                    let o = u;
                    for(let e = 0; e < 7; e++)t = (t << d ^ (t >> h) * p) % f, t & l && (o ^= d << (d << BigInt(e)) - d);
                    c.push(o);
                }
                const [m, g] = o.default.split(c, !0), y = (e, t, r)=>r > 32 ? o.default.rotlBH(e, t, r) : o.default.rotlSH(e, t, r), v = (e, t, r)=>r > 32 ? o.default.rotlBL(e, t, r) : o.default.rotlSL(e, t, r);
                function b(e, t = 24) {
                    const r = new Uint32Array(10);
                    for(let n = 24 - t; n < 24; n++){
                        for(let t = 0; t < 10; t++)r[t] = e[t] ^ e[t + 10] ^ e[t + 20] ^ e[t + 30] ^ e[t + 40];
                        for(let t = 0; t < 10; t += 2){
                            const n = (t + 8) % 10, o = (t + 2) % 10, i = r[o], s = r[o + 1], a = y(i, s, 1) ^ r[n], c = v(i, s, 1) ^ r[n + 1];
                            for(let r = 0; r < 50; r += 10)e[t + r] ^= a, e[t + r + 1] ^= c;
                        }
                        let t = e[2], o = e[3];
                        for(let r = 0; r < 24; r++){
                            const n = a[r], i = y(t, o, n), c = v(t, o, n), u = s[r];
                            t = e[u], o = e[u + 1], e[u] = i, e[u + 1] = c;
                        }
                        for(let t = 0; t < 50; t += 10){
                            for(let n = 0; n < 10; n++)r[n] = e[t + n];
                            for(let n = 0; n < 10; n++)e[t + n] ^= ~r[(n + 2) % 10] & r[(n + 4) % 10];
                        }
                        e[0] ^= m[n], e[1] ^= g[n];
                    }
                    r.fill(0);
                }
                t.keccakP = b;
                class E extends i.Hash {
                    constructor(e, t, r, o = !1, s = 24){
                        if (super(), this.blockLen = e, this.suffix = t, this.outputLen = r, this.enableXOF = o, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, n.default.number(r), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
                        this.state = new Uint8Array(200), this.state32 = (0, i.u32)(this.state);
                    }
                    keccak() {
                        b(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
                    }
                    update(e) {
                        n.default.exists(this);
                        const { blockLen: t, state: r } = this, o = (e = (0, i.toBytes)(e)).length;
                        for(let n = 0; n < o;){
                            const i = Math.min(t - this.pos, o - n);
                            for(let t = 0; t < i; t++)r[this.pos++] ^= e[n++];
                            this.pos === t && this.keccak();
                        }
                        return this;
                    }
                    finish() {
                        if (this.finished) return;
                        this.finished = !0;
                        const { state: e, suffix: t, pos: r, blockLen: n } = this;
                        e[r] ^= t, 0 != (128 & t) && r === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
                    }
                    writeInto(e) {
                        n.default.exists(this, !1), n.default.bytes(e), this.finish();
                        const t = this.state, { blockLen: r } = this;
                        for(let n = 0, o = e.length; n < o;){
                            this.posOut >= r && this.keccak();
                            const i = Math.min(r - this.posOut, o - n);
                            e.set(t.subarray(this.posOut, this.posOut + i), n), this.posOut += i, n += i;
                        }
                        return e;
                    }
                    xofInto(e) {
                        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                        return this.writeInto(e);
                    }
                    xof(e) {
                        return n.default.number(e), this.xofInto(new Uint8Array(e));
                    }
                    digestInto(e) {
                        if (n.default.output(e, this), this.finished) throw new Error("digest() was already called");
                        return this.writeInto(e), this.destroy(), e;
                    }
                    digest() {
                        return this.digestInto(new Uint8Array(this.outputLen));
                    }
                    destroy() {
                        this.destroyed = !0, this.state.fill(0);
                    }
                    _cloneInto(e) {
                        const { blockLen: t, suffix: r, outputLen: n, rounds: o, enableXOF: i } = this;
                        return e || (e = new E(t, r, n, i, o)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = o, e.suffix = r, e.outputLen = n, e.enableXOF = i, e.destroyed = this.destroyed, e;
                    }
                }
                t.Keccak = E;
                const _ = (e, t, r)=>(0, i.wrapConstructor)(()=>new E(t, e, r));
                t.sha3_224 = _(6, 144, 28), t.sha3_256 = _(6, 136, 32), t.sha3_384 = _(6, 104, 48), t.sha3_512 = _(6, 72, 64), t.keccak_224 = _(1, 144, 28), t.keccak_256 = _(1, 136, 32), t.keccak_384 = _(1, 104, 48), t.keccak_512 = _(1, 72, 64);
                const A = (e, t, r)=>(0, i.wrapConstructorWithOpts)((n = {})=>new E(t, e, void 0 === n.dkLen ? r : n.dkLen, !0));
                t.shake128 = A(31, 168, 16), t.shake256 = A(31, 136, 32);
            },
            8578: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sha384 = t.sha512_256 = t.sha512_224 = t.sha512 = t.SHA512 = void 0;
                const n = r(2023), o = r(2286), i = r(2071), [s, a] = o.default.split([
                    "0x428a2f98d728ae22",
                    "0x7137449123ef65cd",
                    "0xb5c0fbcfec4d3b2f",
                    "0xe9b5dba58189dbbc",
                    "0x3956c25bf348b538",
                    "0x59f111f1b605d019",
                    "0x923f82a4af194f9b",
                    "0xab1c5ed5da6d8118",
                    "0xd807aa98a3030242",
                    "0x12835b0145706fbe",
                    "0x243185be4ee4b28c",
                    "0x550c7dc3d5ffb4e2",
                    "0x72be5d74f27b896f",
                    "0x80deb1fe3b1696b1",
                    "0x9bdc06a725c71235",
                    "0xc19bf174cf692694",
                    "0xe49b69c19ef14ad2",
                    "0xefbe4786384f25e3",
                    "0x0fc19dc68b8cd5b5",
                    "0x240ca1cc77ac9c65",
                    "0x2de92c6f592b0275",
                    "0x4a7484aa6ea6e483",
                    "0x5cb0a9dcbd41fbd4",
                    "0x76f988da831153b5",
                    "0x983e5152ee66dfab",
                    "0xa831c66d2db43210",
                    "0xb00327c898fb213f",
                    "0xbf597fc7beef0ee4",
                    "0xc6e00bf33da88fc2",
                    "0xd5a79147930aa725",
                    "0x06ca6351e003826f",
                    "0x142929670a0e6e70",
                    "0x27b70a8546d22ffc",
                    "0x2e1b21385c26c926",
                    "0x4d2c6dfc5ac42aed",
                    "0x53380d139d95b3df",
                    "0x650a73548baf63de",
                    "0x766a0abb3c77b2a8",
                    "0x81c2c92e47edaee6",
                    "0x92722c851482353b",
                    "0xa2bfe8a14cf10364",
                    "0xa81a664bbc423001",
                    "0xc24b8b70d0f89791",
                    "0xc76c51a30654be30",
                    "0xd192e819d6ef5218",
                    "0xd69906245565a910",
                    "0xf40e35855771202a",
                    "0x106aa07032bbd1b8",
                    "0x19a4c116b8d2d0c8",
                    "0x1e376c085141ab53",
                    "0x2748774cdf8eeb99",
                    "0x34b0bcb5e19b48a8",
                    "0x391c0cb3c5c95a63",
                    "0x4ed8aa4ae3418acb",
                    "0x5b9cca4f7763e373",
                    "0x682e6ff3d6b2b8a3",
                    "0x748f82ee5defb2fc",
                    "0x78a5636f43172f60",
                    "0x84c87814a1f0ab72",
                    "0x8cc702081a6439ec",
                    "0x90befffa23631e28",
                    "0xa4506cebde82bde9",
                    "0xbef9a3f7b2c67915",
                    "0xc67178f2e372532b",
                    "0xca273eceea26619c",
                    "0xd186b8c721c0c207",
                    "0xeada7dd6cde0eb1e",
                    "0xf57d4f7fee6ed178",
                    "0x06f067aa72176fba",
                    "0x0a637dc5a2c898a6",
                    "0x113f9804bef90dae",
                    "0x1b710b35131c471b",
                    "0x28db77f523047d84",
                    "0x32caab7b40c72493",
                    "0x3c9ebe0a15c9bebc",
                    "0x431d67c49c100d4c",
                    "0x4cc5d4becb3e42b6",
                    "0x597f299cfc657e2a",
                    "0x5fcb6fab3ad6faec",
                    "0x6c44198c4a475817"
                ].map((e)=>BigInt(e))), c = new Uint32Array(80), u = new Uint32Array(80);
                class d extends n.SHA2 {
                    constructor(){
                        super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
                    }
                    get() {
                        const { Ah: e, Al: t, Bh: r, Bl: n, Ch: o, Cl: i, Dh: s, Dl: a, Eh: c, El: u, Fh: d, Fl: l, Gh: h, Gl: f, Hh: p, Hl: m } = this;
                        return [
                            e,
                            t,
                            r,
                            n,
                            o,
                            i,
                            s,
                            a,
                            c,
                            u,
                            d,
                            l,
                            h,
                            f,
                            p,
                            m
                        ];
                    }
                    set(e, t, r, n, o, i, s, a, c, u, d, l, h, f, p, m) {
                        this.Ah = 0 | e, this.Al = 0 | t, this.Bh = 0 | r, this.Bl = 0 | n, this.Ch = 0 | o, this.Cl = 0 | i, this.Dh = 0 | s, this.Dl = 0 | a, this.Eh = 0 | c, this.El = 0 | u, this.Fh = 0 | d, this.Fl = 0 | l, this.Gh = 0 | h, this.Gl = 0 | f, this.Hh = 0 | p, this.Hl = 0 | m;
                    }
                    process(e, t) {
                        for(let r = 0; r < 16; r++, t += 4)c[r] = e.getUint32(t), u[r] = e.getUint32(t += 4);
                        for(let e = 16; e < 80; e++){
                            const t = 0 | c[e - 15], r = 0 | u[e - 15], n = o.default.rotrSH(t, r, 1) ^ o.default.rotrSH(t, r, 8) ^ o.default.shrSH(t, r, 7), i = o.default.rotrSL(t, r, 1) ^ o.default.rotrSL(t, r, 8) ^ o.default.shrSL(t, r, 7), s = 0 | c[e - 2], a = 0 | u[e - 2], d = o.default.rotrSH(s, a, 19) ^ o.default.rotrBH(s, a, 61) ^ o.default.shrSH(s, a, 6), l = o.default.rotrSL(s, a, 19) ^ o.default.rotrBL(s, a, 61) ^ o.default.shrSL(s, a, 6), h = o.default.add4L(i, l, u[e - 7], u[e - 16]), f = o.default.add4H(h, n, d, c[e - 7], c[e - 16]);
                            c[e] = 0 | f, u[e] = 0 | h;
                        }
                        let { Ah: r, Al: n, Bh: i, Bl: d, Ch: l, Cl: h, Dh: f, Dl: p, Eh: m, El: g, Fh: y, Fl: v, Gh: b, Gl: E, Hh: _, Hl: A } = this;
                        for(let e = 0; e < 80; e++){
                            const t = o.default.rotrSH(m, g, 14) ^ o.default.rotrSH(m, g, 18) ^ o.default.rotrBH(m, g, 41), T = o.default.rotrSL(m, g, 14) ^ o.default.rotrSL(m, g, 18) ^ o.default.rotrBL(m, g, 41), w = m & y ^ ~m & b, I = g & v ^ ~g & E, R = o.default.add5L(A, T, I, a[e], u[e]), P = o.default.add5H(R, _, t, w, s[e], c[e]), x = 0 | R, O = o.default.rotrSH(r, n, 28) ^ o.default.rotrBH(r, n, 34) ^ o.default.rotrBH(r, n, 39), S = o.default.rotrSL(r, n, 28) ^ o.default.rotrBL(r, n, 34) ^ o.default.rotrBL(r, n, 39), C = r & i ^ r & l ^ i & l, B = n & d ^ n & h ^ d & h;
                            _ = 0 | b, A = 0 | E, b = 0 | y, E = 0 | v, y = 0 | m, v = 0 | g, ({ h: m, l: g } = o.default.add(0 | f, 0 | p, 0 | P, 0 | x)), f = 0 | l, p = 0 | h, l = 0 | i, h = 0 | d, i = 0 | r, d = 0 | n;
                            const k = o.default.add3L(x, S, B);
                            r = o.default.add3H(k, P, O, C), n = 0 | k;
                        }
                        ({ h: r, l: n } = o.default.add(0 | this.Ah, 0 | this.Al, 0 | r, 0 | n)), ({ h: i, l: d } = o.default.add(0 | this.Bh, 0 | this.Bl, 0 | i, 0 | d)), ({ h: l, l: h } = o.default.add(0 | this.Ch, 0 | this.Cl, 0 | l, 0 | h)), ({ h: f, l: p } = o.default.add(0 | this.Dh, 0 | this.Dl, 0 | f, 0 | p)), ({ h: m, l: g } = o.default.add(0 | this.Eh, 0 | this.El, 0 | m, 0 | g)), ({ h: y, l: v } = o.default.add(0 | this.Fh, 0 | this.Fl, 0 | y, 0 | v)), ({ h: b, l: E } = o.default.add(0 | this.Gh, 0 | this.Gl, 0 | b, 0 | E)), ({ h: _, l: A } = o.default.add(0 | this.Hh, 0 | this.Hl, 0 | _, 0 | A)), this.set(r, n, i, d, l, h, f, p, m, g, y, v, b, E, _, A);
                    }
                    roundClean() {
                        c.fill(0), u.fill(0);
                    }
                    destroy() {
                        this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                    }
                }
                t.SHA512 = d;
                class l extends d {
                    constructor(){
                        super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
                    }
                }
                class h extends d {
                    constructor(){
                        super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
                    }
                }
                class f extends d {
                    constructor(){
                        super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
                    }
                }
                t.sha512 = (0, i.wrapConstructor)(()=>new d), t.sha512_224 = (0, i.wrapConstructor)(()=>new l), t.sha512_256 = (0, i.wrapConstructor)(()=>new h), t.sha384 = (0, i.wrapConstructor)(()=>new f);
            },
            2071: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomBytes = t.wrapConstructorWithOpts = t.wrapConstructor = t.checkOpts = t.Hash = t.concatBytes = t.toBytes = t.utf8ToBytes = t.asyncLoop = t.nextTick = t.hexToBytes = t.bytesToHex = t.isLE = t.rotr = t.createView = t.u32 = t.u8 = void 0;
                const n = r(9043);
                if (t.u8 = (e)=>new Uint8Array(e.buffer, e.byteOffset, e.byteLength), t.u32 = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), t.createView = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength), t.rotr = (e, t)=>e << 32 - t | e >>> t, t.isLE = 68 === new Uint8Array(new Uint32Array([
                    287454020
                ]).buffer)[0], !t.isLE) throw new Error("Non little-endian hardware is not supported");
                const o = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function i(e) {
                    if ("string" != typeof e) throw new TypeError("utf8ToBytes expected string, got " + typeof e);
                    return (new TextEncoder).encode(e);
                }
                function s(e) {
                    if ("string" == typeof e && (e = i(e)), !(e instanceof Uint8Array)) throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
                    return e;
                }
                t.bytesToHex = function(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += o[e[r]];
                    return t;
                }, t.hexToBytes = function(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + typeof e);
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r, o = e.slice(n, n + 2), i = Number.parseInt(o, 16);
                        if (Number.isNaN(i) || i < 0) throw new Error("Invalid byte sequence");
                        t[r] = i;
                    }
                    return t;
                }, t.nextTick = async ()=>{}, t.asyncLoop = async function(e, r, n) {
                    let o = Date.now();
                    for(let i = 0; i < e; i++){
                        n(i);
                        const e = Date.now() - o;
                        e >= 0 && e < r || (await (0, t.nextTick)(), o += e);
                    }
                }, t.utf8ToBytes = i, t.toBytes = s, t.concatBytes = function(...e) {
                    if (!e.every((e)=>e instanceof Uint8Array)) throw new Error("Uint8Array list expected");
                    if (1 === e.length) return e[0];
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    for(let t = 0, n = 0; t < e.length; t++){
                        const o = e[t];
                        r.set(o, n), n += o.length;
                    }
                    return r;
                }, t.Hash = class {
                    clone() {
                        return this._cloneInto();
                    }
                }, t.checkOpts = function(e, t) {
                    if (void 0 !== t && ("object" != typeof t || (r = t, "[object Object]" !== Object.prototype.toString.call(r) || r.constructor !== Object))) throw new TypeError("Options should be object or undefined");
                    var r;
                    return Object.assign(e, t);
                }, t.wrapConstructor = function(e) {
                    const t = (t)=>e().update(s(t)).digest(), r = e();
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = ()=>e(), t;
                }, t.wrapConstructorWithOpts = function(e) {
                    const t = (t, r)=>e(r).update(s(t)).digest(), r = e({});
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (t)=>e(t), t;
                }, t.randomBytes = function(e = 32) {
                    if (n.crypto && "function" == typeof n.crypto.getRandomValues) return n.crypto.getRandomValues(new Uint8Array(e));
                    throw new Error("crypto.getRandomValues must be defined");
                };
            },
            3072: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decrypt = t.encrypt = void 0;
                const n = r(9043), o = r(6540), i = {
                    web: n.crypto
                };
                function s(e, t, r) {
                    if (!r.startsWith("aes-")) throw new Error(`AES submodule doesn't support mode ${r}`);
                    if (16 !== t.length) throw new Error("AES: wrong IV length");
                    if (r.startsWith("aes-128") && 16 !== e.length || r.startsWith("aes-256") && 32 !== e.length) throw new Error("AES: wrong key length");
                }
                async function a(e, t, r) {
                    if (!i.web) throw new Error("Browser crypto not available.");
                    let n;
                    if ([
                        "aes-128-cbc",
                        "aes-256-cbc"
                    ].includes(e) && (n = "cbc"), [
                        "aes-128-ctr",
                        "aes-256-ctr"
                    ].includes(e) && (n = "ctr"), !n) throw new Error("AES: unsupported mode");
                    return [
                        await i.web.subtle.importKey("raw", t, {
                            name: `AES-${n.toUpperCase()}`,
                            length: 8 * t.length
                        }, !0, [
                            "encrypt",
                            "decrypt"
                        ]),
                        {
                            name: `aes-${n}`,
                            iv: r,
                            counter: r,
                            length: 128
                        }
                    ];
                }
                async function c(e, t, r, n = "aes-128-ctr", c = !0) {
                    if (s(t, r, n), i.web) {
                        const [o, s] = await a(n, t, r), u = await i.web.subtle.encrypt(s, o, e);
                        let d = new Uint8Array(u);
                        return c || "aes-cbc" !== s.name || e.length % 16 || (d = d.slice(0, -16)), d;
                    }
                    if (i.node) {
                        const s = i.node.createCipheriv(n, t, r);
                        return s.setAutoPadding(c), (0, o.concatBytes)(s.update(e), s.final());
                    }
                    throw new Error("The environment doesn't have AES module");
                }
                t.encrypt = c, t.decrypt = async function(e, t, r, n = "aes-128-ctr", u = !0) {
                    if (s(t, r, n), i.web) {
                        const [s, d] = await a(n, t, r);
                        if (!u && "aes-cbc" === d.name) {
                            const i = await async function(e, t, r, n) {
                                const o = e.slice(-16);
                                for(let e = 0; e < 16; e++)o[e] ^= 16 ^ r[e];
                                return (await c(o, t, r, n)).slice(0, 16);
                            }(e, t, r, n);
                            e = (0, o.concatBytes)(e, i);
                        }
                        const l = await i.web.subtle.decrypt(d, s, e), h = new Uint8Array(l);
                        if ("aes-cbc" === d.name) {
                            const i = await c(h, t, r, n);
                            if (!(0, o.equalsBytes)(i, e)) throw new Error("AES: wrong padding");
                        }
                        return h;
                    }
                    if (i.node) {
                        const s = i.node.createDecipheriv(n, t, r);
                        return s.setAutoPadding(u), (0, o.concatBytes)(s.update(e), s.final());
                    }
                    throw new Error("The environment doesn't have AES module");
                };
            },
            7423: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                const n = r(1366), o = r(6540);
                t.keccak224 = (0, o.wrapHash)(n.keccak_224), t.keccak256 = (()=>{
                    const e = (0, o.wrapHash)(n.keccak_256);
                    return e.create = n.keccak_256.create, e;
                })(), t.keccak384 = (0, o.wrapHash)(n.keccak_384), t.keccak512 = (0, o.wrapHash)(n.keccak_512);
            },
            8109: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.pbkdf2Sync = t.pbkdf2 = void 0;
                const n = r(8797), o = r(8091), i = r(8578), s = r(6540);
                t.pbkdf2 = async function(e, t, r, a, c) {
                    if (![
                        "sha256",
                        "sha512"
                    ].includes(c)) throw new Error("Only sha256 and sha512 are supported");
                    return (0, s.assertBytes)(e), (0, s.assertBytes)(t), (0, n.pbkdf2Async)("sha256" === c ? o.sha256 : i.sha512, e, t, {
                        c: r,
                        dkLen: a
                    });
                }, t.pbkdf2Sync = function(e, t, r, a, c) {
                    if (![
                        "sha256",
                        "sha512"
                    ].includes(c)) throw new Error("Only sha256 and sha512 are supported");
                    return (0, s.assertBytes)(e), (0, s.assertBytes)(t), (0, n.pbkdf2)("sha256" === c ? o.sha256 : i.sha512, e, t, {
                        c: r,
                        dkLen: a
                    });
                };
            },
            7002: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.scryptSync = t.scrypt = void 0;
                const n = r(217), o = r(6540);
                t.scrypt = async function(e, t, r, i, s, a, c) {
                    return (0, o.assertBytes)(e), (0, o.assertBytes)(t), (0, n.scryptAsync)(e, t, {
                        N: r,
                        r: s,
                        p: i,
                        dkLen: a,
                        onProgress: c
                    });
                }, t.scryptSync = function(e, t, r, i, s, a, c) {
                    return (0, o.assertBytes)(e), (0, o.assertBytes)(t), (0, n.scrypt)(e, t, {
                        N: r,
                        r: s,
                        p: i,
                        dkLen: a,
                        onProgress: c
                    });
                };
            },
            5473: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.secp256k1 = void 0;
                var n = r(8358);
                Object.defineProperty(t, "secp256k1", {
                    enumerable: !0,
                    get: function() {
                        return n.secp256k1;
                    }
                });
            },
            6540: function(e, t, r) {
                "use strict";
                e = r.nmd(e);
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                const o = n(r(4530)), i = r(2071), s = o.default.bool;
                t.assertBool = s;
                const a = o.default.bytes;
                t.assertBytes = a;
                var c = r(2071);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return c.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return c.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return c.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return c.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return c.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got " + typeof e);
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    const t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, i.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return (t)=>(o.default.bytes(t), e(t));
                }, t.crypto = (()=>{
                    const t = "object" == typeof self && "crypto" in self ? self.crypto : void 0, r = "function" == typeof e.require && e.require.bind(e);
                    return {
                        node: r && !t ? r("crypto") : void 0,
                        web: t
                    };
                })();
            },
            8989: (e, t)=>{
                "use strict";
                function r(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Wrong positive integer: ${e}`);
                }
                function n(e) {
                    if ("boolean" != typeof e) throw new Error(`Expected boolean, not ${e}`);
                }
                function o(e, ...t) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
                    if (t.length > 0 && !t.includes(e.length)) throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
                }
                function i(e) {
                    if ("function" != typeof e || "function" != typeof e.create) throw new Error("Hash should be wrapped by utils.wrapConstructor");
                    r(e.outputLen), r(e.blockLen);
                }
                function s(e, t = !0) {
                    if (e.destroyed) throw new Error("Hash instance has been destroyed");
                    if (t && e.finished) throw new Error("Hash#digest() has already been called");
                }
                function a(e, t) {
                    o(e);
                    const r = t.outputLen;
                    if (e.length < r) throw new Error(`digestInto() expects output buffer of length at least ${r}`);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.output = t.exists = t.hash = t.bytes = t.bool = t.number = void 0, t.number = r, t.bool = n, t.bytes = o, t.hash = i, t.exists = s, t.output = a;
                const c = {
                    number: r,
                    bool: n,
                    bytes: o,
                    hash: i,
                    exists: s,
                    output: a
                };
                t.default = c;
            },
            7889: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.add = t.toBig = t.split = t.fromBig = void 0;
                const r = BigInt(2 ** 32 - 1), n = BigInt(32);
                function o(e, t = !1) {
                    return t ? {
                        h: Number(e & r),
                        l: Number(e >> n & r)
                    } : {
                        h: 0 | Number(e >> n & r),
                        l: 0 | Number(e & r)
                    };
                }
                function i(e, t = !1) {
                    let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
                    for(let i = 0; i < e.length; i++){
                        const { h: s, l: a } = o(e[i], t);
                        [r[i], n[i]] = [
                            s,
                            a
                        ];
                    }
                    return [
                        r,
                        n
                    ];
                }
                function s(e, t, r, n) {
                    const o = (t >>> 0) + (n >>> 0);
                    return {
                        h: e + r + (o / 2 ** 32 | 0) | 0,
                        l: 0 | o
                    };
                }
                t.fromBig = o, t.split = i, t.toBig = (e, t)=>BigInt(e >>> 0) << n | BigInt(t >>> 0), t.add = s;
                const a = {
                    fromBig: o,
                    split: i,
                    toBig: t.toBig,
                    shrSH: (e, t, r)=>e >>> r,
                    shrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrSH: (e, t, r)=>e >>> r | t << 32 - r,
                    rotrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrBH: (e, t, r)=>e << 64 - r | t >>> r - 32,
                    rotrBL: (e, t, r)=>e >>> r - 32 | t << 64 - r,
                    rotr32H: (e, t)=>t,
                    rotr32L: (e, t)=>e,
                    rotlSH: (e, t, r)=>e << r | t >>> 32 - r,
                    rotlSL: (e, t, r)=>t << r | e >>> 32 - r,
                    rotlBH: (e, t, r)=>t << r - 32 | e >>> 64 - r,
                    rotlBL: (e, t, r)=>e << r - 32 | t >>> 64 - r,
                    add: s,
                    add3L: (e, t, r)=>(e >>> 0) + (t >>> 0) + (r >>> 0),
                    add3H: (e, t, r, n)=>t + r + n + (e / 2 ** 32 | 0) | 0,
                    add4L: (e, t, r, n)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0),
                    add4H: (e, t, r, n, o)=>t + r + n + o + (e / 2 ** 32 | 0) | 0,
                    add5H: (e, t, r, n, o, i)=>t + r + n + o + i + (e / 2 ** 32 | 0) | 0,
                    add5L: (e, t, r, n, o)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0)
                };
                t.default = a;
            },
            4318: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = void 0, t.crypto = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0;
            },
            5179: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.shake256 = t.shake128 = t.keccak_512 = t.keccak_384 = t.keccak_256 = t.keccak_224 = t.sha3_512 = t.sha3_384 = t.sha3_256 = t.sha3_224 = t.Keccak = t.keccakP = void 0;
                const n = r(8989), o = r(7889), i = r(2263), [s, a, c] = [
                    [],
                    [],
                    []
                ], u = BigInt(0), d = BigInt(1), l = BigInt(2), h = BigInt(7), f = BigInt(256), p = BigInt(113);
                for(let e = 0, t = d, r = 1, n = 0; e < 24; e++){
                    [r, n] = [
                        n,
                        (2 * r + 3 * n) % 5
                    ], s.push(2 * (5 * n + r)), a.push((e + 1) * (e + 2) / 2 % 64);
                    let o = u;
                    for(let e = 0; e < 7; e++)t = (t << d ^ (t >> h) * p) % f, t & l && (o ^= d << (d << BigInt(e)) - d);
                    c.push(o);
                }
                const [m, g] = o.default.split(c, !0), y = (e, t, r)=>r > 32 ? o.default.rotlBH(e, t, r) : o.default.rotlSH(e, t, r), v = (e, t, r)=>r > 32 ? o.default.rotlBL(e, t, r) : o.default.rotlSL(e, t, r);
                function b(e, t = 24) {
                    const r = new Uint32Array(10);
                    for(let n = 24 - t; n < 24; n++){
                        for(let t = 0; t < 10; t++)r[t] = e[t] ^ e[t + 10] ^ e[t + 20] ^ e[t + 30] ^ e[t + 40];
                        for(let t = 0; t < 10; t += 2){
                            const n = (t + 8) % 10, o = (t + 2) % 10, i = r[o], s = r[o + 1], a = y(i, s, 1) ^ r[n], c = v(i, s, 1) ^ r[n + 1];
                            for(let r = 0; r < 50; r += 10)e[t + r] ^= a, e[t + r + 1] ^= c;
                        }
                        let t = e[2], o = e[3];
                        for(let r = 0; r < 24; r++){
                            const n = a[r], i = y(t, o, n), c = v(t, o, n), u = s[r];
                            t = e[u], o = e[u + 1], e[u] = i, e[u + 1] = c;
                        }
                        for(let t = 0; t < 50; t += 10){
                            for(let n = 0; n < 10; n++)r[n] = e[t + n];
                            for(let n = 0; n < 10; n++)e[t + n] ^= ~r[(n + 2) % 10] & r[(n + 4) % 10];
                        }
                        e[0] ^= m[n], e[1] ^= g[n];
                    }
                    r.fill(0);
                }
                t.keccakP = b;
                class E extends i.Hash {
                    constructor(e, t, r, o = !1, s = 24){
                        if (super(), this.blockLen = e, this.suffix = t, this.outputLen = r, this.enableXOF = o, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, n.default.number(r), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
                        this.state = new Uint8Array(200), this.state32 = (0, i.u32)(this.state);
                    }
                    keccak() {
                        b(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
                    }
                    update(e) {
                        n.default.exists(this);
                        const { blockLen: t, state: r } = this, o = (e = (0, i.toBytes)(e)).length;
                        for(let n = 0; n < o;){
                            const i = Math.min(t - this.pos, o - n);
                            for(let t = 0; t < i; t++)r[this.pos++] ^= e[n++];
                            this.pos === t && this.keccak();
                        }
                        return this;
                    }
                    finish() {
                        if (this.finished) return;
                        this.finished = !0;
                        const { state: e, suffix: t, pos: r, blockLen: n } = this;
                        e[r] ^= t, 0 != (128 & t) && r === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
                    }
                    writeInto(e) {
                        n.default.exists(this, !1), n.default.bytes(e), this.finish();
                        const t = this.state, { blockLen: r } = this;
                        for(let n = 0, o = e.length; n < o;){
                            this.posOut >= r && this.keccak();
                            const i = Math.min(r - this.posOut, o - n);
                            e.set(t.subarray(this.posOut, this.posOut + i), n), this.posOut += i, n += i;
                        }
                        return e;
                    }
                    xofInto(e) {
                        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                        return this.writeInto(e);
                    }
                    xof(e) {
                        return n.default.number(e), this.xofInto(new Uint8Array(e));
                    }
                    digestInto(e) {
                        if (n.default.output(e, this), this.finished) throw new Error("digest() was already called");
                        return this.writeInto(e), this.destroy(), e;
                    }
                    digest() {
                        return this.digestInto(new Uint8Array(this.outputLen));
                    }
                    destroy() {
                        this.destroyed = !0, this.state.fill(0);
                    }
                    _cloneInto(e) {
                        const { blockLen: t, suffix: r, outputLen: n, rounds: o, enableXOF: i } = this;
                        return e || (e = new E(t, r, n, i, o)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = o, e.suffix = r, e.outputLen = n, e.enableXOF = i, e.destroyed = this.destroyed, e;
                    }
                }
                t.Keccak = E;
                const _ = (e, t, r)=>(0, i.wrapConstructor)(()=>new E(t, e, r));
                t.sha3_224 = _(6, 144, 28), t.sha3_256 = _(6, 136, 32), t.sha3_384 = _(6, 104, 48), t.sha3_512 = _(6, 72, 64), t.keccak_224 = _(1, 144, 28), t.keccak_256 = _(1, 136, 32), t.keccak_384 = _(1, 104, 48), t.keccak_512 = _(1, 72, 64);
                const A = (e, t, r)=>(0, i.wrapConstructorWithOpts)((n = {})=>new E(t, e, void 0 === n.dkLen ? r : n.dkLen, !0));
                t.shake128 = A(31, 168, 16), t.shake256 = A(31, 136, 32);
            },
            2263: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomBytes = t.wrapConstructorWithOpts = t.wrapConstructor = t.checkOpts = t.Hash = t.concatBytes = t.toBytes = t.utf8ToBytes = t.asyncLoop = t.nextTick = t.hexToBytes = t.bytesToHex = t.isLE = t.rotr = t.createView = t.u32 = t.u8 = void 0;
                const n = r(4318);
                if (t.u8 = (e)=>new Uint8Array(e.buffer, e.byteOffset, e.byteLength), t.u32 = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), t.createView = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength), t.rotr = (e, t)=>e << 32 - t | e >>> t, t.isLE = 68 === new Uint8Array(new Uint32Array([
                    287454020
                ]).buffer)[0], !t.isLE) throw new Error("Non little-endian hardware is not supported");
                const o = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function i(e) {
                    if ("string" != typeof e) throw new TypeError("utf8ToBytes expected string, got " + typeof e);
                    return (new TextEncoder).encode(e);
                }
                function s(e) {
                    if ("string" == typeof e && (e = i(e)), !(e instanceof Uint8Array)) throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
                    return e;
                }
                t.bytesToHex = function(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += o[e[r]];
                    return t;
                }, t.hexToBytes = function(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + typeof e);
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r, o = e.slice(n, n + 2), i = Number.parseInt(o, 16);
                        if (Number.isNaN(i) || i < 0) throw new Error("Invalid byte sequence");
                        t[r] = i;
                    }
                    return t;
                }, t.nextTick = async ()=>{}, t.asyncLoop = async function(e, r, n) {
                    let o = Date.now();
                    for(let i = 0; i < e; i++){
                        n(i);
                        const e = Date.now() - o;
                        e >= 0 && e < r || (await (0, t.nextTick)(), o += e);
                    }
                }, t.utf8ToBytes = i, t.toBytes = s, t.concatBytes = function(...e) {
                    if (!e.every((e)=>e instanceof Uint8Array)) throw new Error("Uint8Array list expected");
                    if (1 === e.length) return e[0];
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    for(let t = 0, n = 0; t < e.length; t++){
                        const o = e[t];
                        r.set(o, n), n += o.length;
                    }
                    return r;
                }, t.Hash = class {
                    clone() {
                        return this._cloneInto();
                    }
                }, t.checkOpts = function(e, t) {
                    if (void 0 !== t && ("object" != typeof t || (r = t, "[object Object]" !== Object.prototype.toString.call(r) || r.constructor !== Object))) throw new TypeError("Options should be object or undefined");
                    var r;
                    return Object.assign(e, t);
                }, t.wrapConstructor = function(e) {
                    const t = (t)=>e().update(s(t)).digest(), r = e();
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = ()=>e(), t;
                }, t.wrapConstructorWithOpts = function(e) {
                    const t = (t, r)=>e(r).update(s(t)).digest(), r = e({});
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (t)=>e(t), t;
                }, t.randomBytes = function(e = 32) {
                    if (n.crypto && "function" == typeof n.crypto.getRandomValues) return n.crypto.getRandomValues(new Uint8Array(e));
                    throw new Error("crypto.getRandomValues must be defined");
                };
            },
            3687: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                const n = r(5179), o = r(5487);
                t.keccak224 = (0, o.wrapHash)(n.keccak_224), t.keccak256 = (()=>{
                    const e = (0, o.wrapHash)(n.keccak_256);
                    return e.create = n.keccak_256.create, e;
                })(), t.keccak384 = (0, o.wrapHash)(n.keccak_384), t.keccak512 = (0, o.wrapHash)(n.keccak_512);
            },
            1341: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getRandomBytes = t.getRandomBytesSync = void 0;
                const n = r(2263);
                t.getRandomBytesSync = function(e) {
                    return (0, n.randomBytes)(e);
                }, t.getRandomBytes = async function(e) {
                    return (0, n.randomBytes)(e);
                };
            },
            5487: function(e, t, r) {
                "use strict";
                e = r.nmd(e);
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                const o = n(r(8989)), i = r(2263), s = o.default.bool;
                t.assertBool = s;
                const a = o.default.bytes;
                t.assertBytes = a;
                var c = r(2263);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return c.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return c.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return c.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return c.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return c.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got " + typeof e);
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    const t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, i.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return (t)=>(o.default.bytes(t), e(t));
                }, t.crypto = (()=>{
                    const t = "object" == typeof self && "crypto" in self ? self.crypto : void 0, r = "function" == typeof e.require && e.require.bind(e);
                    return {
                        node: r && !t ? r("crypto") : void 0,
                        web: t
                    };
                })();
            },
            9386: (e)=>{
                "use strict";
                var t = Object.prototype.hasOwnProperty, r = "~";
                function n() {}
                function o(e, t, r) {
                    this.fn = e, this.context = t, this.once = r || !1;
                }
                function i(e, t, n, i, s) {
                    if ("function" != typeof n) throw new TypeError("The listener must be a function");
                    var a = new o(n, i || e, s), c = r ? r + t : t;
                    return e._events[c] ? e._events[c].fn ? e._events[c] = [
                        e._events[c],
                        a
                    ] : e._events[c].push(a) : (e._events[c] = a, e._eventsCount++), e;
                }
                function s(e, t) {
                    0 == --e._eventsCount ? e._events = new n : delete e._events[t];
                }
                function a() {
                    this._events = new n, this._eventsCount = 0;
                }
                Object.create && (n.prototype = Object.create(null), (new n).__proto__ || (r = !1)), a.prototype.eventNames = function() {
                    var e, n, o = [];
                    if (0 === this._eventsCount) return o;
                    for(n in e = this._events)t.call(e, n) && o.push(r ? n.slice(1) : n);
                    return Object.getOwnPropertySymbols ? o.concat(Object.getOwnPropertySymbols(e)) : o;
                }, a.prototype.listeners = function(e) {
                    var t = r ? r + e : e, n = this._events[t];
                    if (!n) return [];
                    if (n.fn) return [
                        n.fn
                    ];
                    for(var o = 0, i = n.length, s = new Array(i); o < i; o++)s[o] = n[o].fn;
                    return s;
                }, a.prototype.listenerCount = function(e) {
                    var t = r ? r + e : e, n = this._events[t];
                    return n ? n.fn ? 1 : n.length : 0;
                }, a.prototype.emit = function(e, t, n, o, i, s) {
                    var a = r ? r + e : e;
                    if (!this._events[a]) return !1;
                    var c, u, d = this._events[a], l = arguments.length;
                    if (d.fn) {
                        switch(d.once && this.removeListener(e, d.fn, void 0, !0), l){
                            case 1:
                                return d.fn.call(d.context), !0;
                            case 2:
                                return d.fn.call(d.context, t), !0;
                            case 3:
                                return d.fn.call(d.context, t, n), !0;
                            case 4:
                                return d.fn.call(d.context, t, n, o), !0;
                            case 5:
                                return d.fn.call(d.context, t, n, o, i), !0;
                            case 6:
                                return d.fn.call(d.context, t, n, o, i, s), !0;
                        }
                        for(u = 1, c = new Array(l - 1); u < l; u++)c[u - 1] = arguments[u];
                        d.fn.apply(d.context, c);
                    } else {
                        var h, f = d.length;
                        for(u = 0; u < f; u++)switch(d[u].once && this.removeListener(e, d[u].fn, void 0, !0), l){
                            case 1:
                                d[u].fn.call(d[u].context);
                                break;
                            case 2:
                                d[u].fn.call(d[u].context, t);
                                break;
                            case 3:
                                d[u].fn.call(d[u].context, t, n);
                                break;
                            case 4:
                                d[u].fn.call(d[u].context, t, n, o);
                                break;
                            default:
                                if (!c) for(h = 1, c = new Array(l - 1); h < l; h++)c[h - 1] = arguments[h];
                                d[u].fn.apply(d[u].context, c);
                        }
                    }
                    return !0;
                }, a.prototype.on = function(e, t, r) {
                    return i(this, e, t, r, !1);
                }, a.prototype.once = function(e, t, r) {
                    return i(this, e, t, r, !0);
                }, a.prototype.removeListener = function(e, t, n, o) {
                    var i = r ? r + e : e;
                    if (!this._events[i]) return this;
                    if (!t) return s(this, i), this;
                    var a = this._events[i];
                    if (a.fn) a.fn !== t || o && !a.once || n && a.context !== n || s(this, i);
                    else {
                        for(var c = 0, u = [], d = a.length; c < d; c++)(a[c].fn !== t || o && !a[c].once || n && a[c].context !== n) && u.push(a[c]);
                        u.length ? this._events[i] = 1 === u.length ? u[0] : u : s(this, i);
                    }
                    return this;
                }, a.prototype.removeAllListeners = function(e) {
                    var t;
                    return e ? (t = r ? r + e : e, this._events[t] && s(this, t)) : (this._events = new n, this._eventsCount = 0), this;
                }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = r, a.EventEmitter = a, e.exports = a;
            },
            5844: (e, t)=>{
                "use strict";
                function r(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Wrong positive integer: ${e}`);
                }
                function n(e) {
                    if ("boolean" != typeof e) throw new Error(`Expected boolean, not ${e}`);
                }
                function o(e, ...t) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
                    if (t.length > 0 && !t.includes(e.length)) throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
                }
                function i(e) {
                    if ("function" != typeof e || "function" != typeof e.create) throw new Error("Hash should be wrapped by utils.wrapConstructor");
                    r(e.outputLen), r(e.blockLen);
                }
                function s(e, t = !0) {
                    if (e.destroyed) throw new Error("Hash instance has been destroyed");
                    if (t && e.finished) throw new Error("Hash#digest() has already been called");
                }
                function a(e, t) {
                    o(e);
                    const r = t.outputLen;
                    if (e.length < r) throw new Error(`digestInto() expects output buffer of length at least ${r}`);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.output = t.exists = t.hash = t.bytes = t.bool = t.number = void 0, t.number = r, t.bool = n, t.bytes = o, t.hash = i, t.exists = s, t.output = a;
                const c = {
                    number: r,
                    bool: n,
                    bytes: o,
                    hash: i,
                    exists: s,
                    output: a
                };
                t.default = c;
            },
            6631: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.add = t.toBig = t.split = t.fromBig = void 0;
                const r = BigInt(2 ** 32 - 1), n = BigInt(32);
                function o(e, t = !1) {
                    return t ? {
                        h: Number(e & r),
                        l: Number(e >> n & r)
                    } : {
                        h: 0 | Number(e >> n & r),
                        l: 0 | Number(e & r)
                    };
                }
                function i(e, t = !1) {
                    let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
                    for(let i = 0; i < e.length; i++){
                        const { h: s, l: a } = o(e[i], t);
                        [r[i], n[i]] = [
                            s,
                            a
                        ];
                    }
                    return [
                        r,
                        n
                    ];
                }
                function s(e, t, r, n) {
                    const o = (t >>> 0) + (n >>> 0);
                    return {
                        h: e + r + (o / 2 ** 32 | 0) | 0,
                        l: 0 | o
                    };
                }
                t.fromBig = o, t.split = i, t.toBig = (e, t)=>BigInt(e >>> 0) << n | BigInt(t >>> 0), t.add = s;
                const a = {
                    fromBig: o,
                    split: i,
                    toBig: t.toBig,
                    shrSH: (e, t, r)=>e >>> r,
                    shrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrSH: (e, t, r)=>e >>> r | t << 32 - r,
                    rotrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrBH: (e, t, r)=>e << 64 - r | t >>> r - 32,
                    rotrBL: (e, t, r)=>e >>> r - 32 | t << 64 - r,
                    rotr32H: (e, t)=>t,
                    rotr32L: (e, t)=>e,
                    rotlSH: (e, t, r)=>e << r | t >>> 32 - r,
                    rotlSL: (e, t, r)=>t << r | e >>> 32 - r,
                    rotlBH: (e, t, r)=>t << r - 32 | e >>> 64 - r,
                    rotlBL: (e, t, r)=>e << r - 32 | t >>> 64 - r,
                    add: s,
                    add3L: (e, t, r)=>(e >>> 0) + (t >>> 0) + (r >>> 0),
                    add3H: (e, t, r, n)=>t + r + n + (e / 2 ** 32 | 0) | 0,
                    add4L: (e, t, r, n)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0),
                    add4H: (e, t, r, n, o)=>t + r + n + o + (e / 2 ** 32 | 0) | 0,
                    add5H: (e, t, r, n, o, i)=>t + r + n + o + i + (e / 2 ** 32 | 0) | 0,
                    add5L: (e, t, r, n, o)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0)
                };
                t.default = a;
            },
            4174: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = void 0, t.crypto = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0;
            },
            5406: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.shake256 = t.shake128 = t.keccak_512 = t.keccak_384 = t.keccak_256 = t.keccak_224 = t.sha3_512 = t.sha3_384 = t.sha3_256 = t.sha3_224 = t.Keccak = t.keccakP = void 0;
                const n = r(5844), o = r(6631), i = r(2532), [s, a, c] = [
                    [],
                    [],
                    []
                ], u = BigInt(0), d = BigInt(1), l = BigInt(2), h = BigInt(7), f = BigInt(256), p = BigInt(113);
                for(let e = 0, t = d, r = 1, n = 0; e < 24; e++){
                    [r, n] = [
                        n,
                        (2 * r + 3 * n) % 5
                    ], s.push(2 * (5 * n + r)), a.push((e + 1) * (e + 2) / 2 % 64);
                    let o = u;
                    for(let e = 0; e < 7; e++)t = (t << d ^ (t >> h) * p) % f, t & l && (o ^= d << (d << BigInt(e)) - d);
                    c.push(o);
                }
                const [m, g] = o.default.split(c, !0), y = (e, t, r)=>r > 32 ? o.default.rotlBH(e, t, r) : o.default.rotlSH(e, t, r), v = (e, t, r)=>r > 32 ? o.default.rotlBL(e, t, r) : o.default.rotlSL(e, t, r);
                function b(e, t = 24) {
                    const r = new Uint32Array(10);
                    for(let n = 24 - t; n < 24; n++){
                        for(let t = 0; t < 10; t++)r[t] = e[t] ^ e[t + 10] ^ e[t + 20] ^ e[t + 30] ^ e[t + 40];
                        for(let t = 0; t < 10; t += 2){
                            const n = (t + 8) % 10, o = (t + 2) % 10, i = r[o], s = r[o + 1], a = y(i, s, 1) ^ r[n], c = v(i, s, 1) ^ r[n + 1];
                            for(let r = 0; r < 50; r += 10)e[t + r] ^= a, e[t + r + 1] ^= c;
                        }
                        let t = e[2], o = e[3];
                        for(let r = 0; r < 24; r++){
                            const n = a[r], i = y(t, o, n), c = v(t, o, n), u = s[r];
                            t = e[u], o = e[u + 1], e[u] = i, e[u + 1] = c;
                        }
                        for(let t = 0; t < 50; t += 10){
                            for(let n = 0; n < 10; n++)r[n] = e[t + n];
                            for(let n = 0; n < 10; n++)e[t + n] ^= ~r[(n + 2) % 10] & r[(n + 4) % 10];
                        }
                        e[0] ^= m[n], e[1] ^= g[n];
                    }
                    r.fill(0);
                }
                t.keccakP = b;
                class E extends i.Hash {
                    constructor(e, t, r, o = !1, s = 24){
                        if (super(), this.blockLen = e, this.suffix = t, this.outputLen = r, this.enableXOF = o, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, n.default.number(r), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
                        this.state = new Uint8Array(200), this.state32 = (0, i.u32)(this.state);
                    }
                    keccak() {
                        b(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
                    }
                    update(e) {
                        n.default.exists(this);
                        const { blockLen: t, state: r } = this, o = (e = (0, i.toBytes)(e)).length;
                        for(let n = 0; n < o;){
                            const i = Math.min(t - this.pos, o - n);
                            for(let t = 0; t < i; t++)r[this.pos++] ^= e[n++];
                            this.pos === t && this.keccak();
                        }
                        return this;
                    }
                    finish() {
                        if (this.finished) return;
                        this.finished = !0;
                        const { state: e, suffix: t, pos: r, blockLen: n } = this;
                        e[r] ^= t, 0 != (128 & t) && r === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
                    }
                    writeInto(e) {
                        n.default.exists(this, !1), n.default.bytes(e), this.finish();
                        const t = this.state, { blockLen: r } = this;
                        for(let n = 0, o = e.length; n < o;){
                            this.posOut >= r && this.keccak();
                            const i = Math.min(r - this.posOut, o - n);
                            e.set(t.subarray(this.posOut, this.posOut + i), n), this.posOut += i, n += i;
                        }
                        return e;
                    }
                    xofInto(e) {
                        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                        return this.writeInto(e);
                    }
                    xof(e) {
                        return n.default.number(e), this.xofInto(new Uint8Array(e));
                    }
                    digestInto(e) {
                        if (n.default.output(e, this), this.finished) throw new Error("digest() was already called");
                        return this.writeInto(e), this.destroy(), e;
                    }
                    digest() {
                        return this.digestInto(new Uint8Array(this.outputLen));
                    }
                    destroy() {
                        this.destroyed = !0, this.state.fill(0);
                    }
                    _cloneInto(e) {
                        const { blockLen: t, suffix: r, outputLen: n, rounds: o, enableXOF: i } = this;
                        return e || (e = new E(t, r, n, i, o)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = o, e.suffix = r, e.outputLen = n, e.enableXOF = i, e.destroyed = this.destroyed, e;
                    }
                }
                t.Keccak = E;
                const _ = (e, t, r)=>(0, i.wrapConstructor)(()=>new E(t, e, r));
                t.sha3_224 = _(6, 144, 28), t.sha3_256 = _(6, 136, 32), t.sha3_384 = _(6, 104, 48), t.sha3_512 = _(6, 72, 64), t.keccak_224 = _(1, 144, 28), t.keccak_256 = _(1, 136, 32), t.keccak_384 = _(1, 104, 48), t.keccak_512 = _(1, 72, 64);
                const A = (e, t, r)=>(0, i.wrapConstructorWithOpts)((n = {})=>new E(t, e, void 0 === n.dkLen ? r : n.dkLen, !0));
                t.shake128 = A(31, 168, 16), t.shake256 = A(31, 136, 32);
            },
            2532: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomBytes = t.wrapConstructorWithOpts = t.wrapConstructor = t.checkOpts = t.Hash = t.concatBytes = t.toBytes = t.utf8ToBytes = t.asyncLoop = t.nextTick = t.hexToBytes = t.bytesToHex = t.isLE = t.rotr = t.createView = t.u32 = t.u8 = void 0;
                const n = r(4174);
                if (t.u8 = (e)=>new Uint8Array(e.buffer, e.byteOffset, e.byteLength), t.u32 = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), t.createView = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength), t.rotr = (e, t)=>e << 32 - t | e >>> t, t.isLE = 68 === new Uint8Array(new Uint32Array([
                    287454020
                ]).buffer)[0], !t.isLE) throw new Error("Non little-endian hardware is not supported");
                const o = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function i(e) {
                    if ("string" != typeof e) throw new TypeError("utf8ToBytes expected string, got " + typeof e);
                    return (new TextEncoder).encode(e);
                }
                function s(e) {
                    if ("string" == typeof e && (e = i(e)), !(e instanceof Uint8Array)) throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
                    return e;
                }
                t.bytesToHex = function(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += o[e[r]];
                    return t;
                }, t.hexToBytes = function(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + typeof e);
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r, o = e.slice(n, n + 2), i = Number.parseInt(o, 16);
                        if (Number.isNaN(i) || i < 0) throw new Error("Invalid byte sequence");
                        t[r] = i;
                    }
                    return t;
                }, t.nextTick = async ()=>{}, t.asyncLoop = async function(e, r, n) {
                    let o = Date.now();
                    for(let i = 0; i < e; i++){
                        n(i);
                        const e = Date.now() - o;
                        e >= 0 && e < r || (await (0, t.nextTick)(), o += e);
                    }
                }, t.utf8ToBytes = i, t.toBytes = s, t.concatBytes = function(...e) {
                    if (!e.every((e)=>e instanceof Uint8Array)) throw new Error("Uint8Array list expected");
                    if (1 === e.length) return e[0];
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    for(let t = 0, n = 0; t < e.length; t++){
                        const o = e[t];
                        r.set(o, n), n += o.length;
                    }
                    return r;
                }, t.Hash = class {
                    clone() {
                        return this._cloneInto();
                    }
                }, t.checkOpts = function(e, t) {
                    if (void 0 !== t && ("object" != typeof t || (r = t, "[object Object]" !== Object.prototype.toString.call(r) || r.constructor !== Object))) throw new TypeError("Options should be object or undefined");
                    var r;
                    return Object.assign(e, t);
                }, t.wrapConstructor = function(e) {
                    const t = (t)=>e().update(s(t)).digest(), r = e();
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = ()=>e(), t;
                }, t.wrapConstructorWithOpts = function(e) {
                    const t = (t, r)=>e(r).update(s(t)).digest(), r = e({});
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (t)=>e(t), t;
                }, t.randomBytes = function(e = 32) {
                    if (n.crypto && "function" == typeof n.crypto.getRandomValues) return n.crypto.getRandomValues(new Uint8Array(e));
                    throw new Error("crypto.getRandomValues must be defined");
                };
            },
            4488: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                const n = r(5406), o = r(7737);
                t.keccak224 = (0, o.wrapHash)(n.keccak_224), t.keccak256 = (()=>{
                    const e = (0, o.wrapHash)(n.keccak_256);
                    return e.create = n.keccak_256.create, e;
                })(), t.keccak384 = (0, o.wrapHash)(n.keccak_384), t.keccak512 = (0, o.wrapHash)(n.keccak_512);
            },
            7737: function(e, t, r) {
                "use strict";
                e = r.nmd(e);
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                const o = n(r(5844)), i = r(2532), s = o.default.bool;
                t.assertBool = s;
                const a = o.default.bytes;
                t.assertBytes = a;
                var c = r(2532);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return c.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return c.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return c.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return c.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return c.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got " + typeof e);
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    const t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, i.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return (t)=>(o.default.bytes(t), e(t));
                }, t.crypto = (()=>{
                    const t = "object" == typeof self && "crypto" in self ? self.crypto : void 0, r = "function" == typeof e.require && e.require.bind(e);
                    return {
                        node: r && !t ? r("crypto") : void 0,
                        web: t
                    };
                })();
            },
            6608: (e, t)=>{
                "use strict";
                function r(e) {
                    return function(e) {
                        let t = 0;
                        return ()=>e[t++];
                    }(function(e) {
                        let t = 0;
                        function r() {
                            return e[t++] << 8 | e[t++];
                        }
                        let n = r(), o = 1, i = [
                            0,
                            1
                        ];
                        for(let e = 1; e < n; e++)i.push(o += r());
                        let s = r(), a = t;
                        t += s;
                        let c = 0, u = 0;
                        function d() {
                            return 0 == c && (u = u << 8 | e[t++], c = 8), u >> --c & 1;
                        }
                        const l = 2 ** 31, h = l >>> 1, f = l - 1;
                        let p = 0;
                        for(let e = 0; e < 31; e++)p = p << 1 | d();
                        let m = [], g = 0, y = l;
                        for(;;){
                            let e = Math.floor(((p - g + 1) * o - 1) / y), t = 0, r = n;
                            for(; r - t > 1;){
                                let n = t + r >>> 1;
                                e < i[n] ? r = n : t = n;
                            }
                            if (0 == t) break;
                            m.push(t);
                            let s = g + Math.floor(y * i[t] / o), a = g + Math.floor(y * i[t + 1] / o) - 1;
                            for(; 0 == ((s ^ a) & h);)p = p << 1 & f | d(), s = s << 1 & f, a = a << 1 & f | 1;
                            for(; s & ~a & 536870912;)p = p & h | p << 1 & f >>> 1 | d(), s = s << 1 ^ h, a = (a ^ h) << 1 | h | 1;
                            g = s, y = 1 + a - s;
                        }
                        let v = n - 4;
                        return m.map((t)=>{
                            switch(t - v){
                                case 3:
                                    return v + 65792 + (e[a++] << 16 | e[a++] << 8 | e[a++]);
                                case 2:
                                    return v + 256 + (e[a++] << 8 | e[a++]);
                                case 1:
                                    return v + e[a++];
                                default:
                                    return t - 1;
                            }
                        });
                    }(function(e) {
                        let t = [];
                        [
                            ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
                        ].forEach((e, r)=>t[e.charCodeAt(0)] = r);
                        let r = e.length, n = new Uint8Array(6 * r >> 3);
                        for(let o = 0, i = 0, s = 0, a = 0; o < r; o++)a = a << 6 | t[e.charCodeAt(o)], s += 6, s >= 8 && (n[i++] = a >> (s -= 8));
                        return n;
                    }(e)));
                }
                function n(e) {
                    return 1 & e ? ~e >> 1 : e >> 1;
                }
                function o(e, t) {
                    let r = Array(e);
                    for(let o = 0, i = 0; o < e; o++)r[o] = i += n(t());
                    return r;
                }
                function i(e, t = 0) {
                    let r = [];
                    for(;;){
                        let n = e(), o = e();
                        if (!o) break;
                        t += n;
                        for(let e = 0; e < o; e++)r.push(t + e);
                        t += o + 1;
                    }
                    return r;
                }
                function s(e) {
                    return c(()=>{
                        let t = i(e);
                        if (t.length) return t;
                    });
                }
                function a(e) {
                    let t = [];
                    for(;;){
                        let r = e();
                        if (0 == r) break;
                        t.push(d(r, e));
                    }
                    for(;;){
                        let r = e() - 1;
                        if (r < 0) break;
                        t.push(l(r, e));
                    }
                    return t.flat();
                }
                function c(e) {
                    let t = [];
                    for(;;){
                        let r = e(t.length);
                        if (!r) break;
                        t.push(r);
                    }
                    return t;
                }
                function u(e, t, r) {
                    let n = Array(e).fill().map(()=>[]);
                    for(let i = 0; i < t; i++)o(e, r).forEach((e, t)=>n[t].push(e));
                    return n;
                }
                function d(e, t) {
                    let r = 1 + t(), n = t(), o = c(t);
                    return u(o.length, 1 + e, t).flatMap((e, t)=>{
                        let [i, ...s] = e;
                        return Array(o[t]).fill().map((e, t)=>{
                            let o = t * n;
                            return [
                                i + t * r,
                                s.map((e)=>e + o)
                            ];
                        });
                    });
                }
                function l(e, t) {
                    return u(1 + t(), 1 + e, t).map((e)=>[
                            e[0],
                            e.slice(1)
                        ]);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var h = r("AEIRrQh1DccBuQJ+APkBMQDiASoAnADQAHQAngBmANQAaACKAEQAgwBJAHcAOQA9ACoANQAmAGMAHgAvACgAJQAWACwAGQAjAB8ALwAVACgAEQAdAAkAHAARABgAFwA7ACcALAAtADcAEwApABAAHQAfABAAGAAeABsAFwAUBLoF3QEXE7k3ygXaALgArkYBbgCsCAPMAK6GNjY2NjFiAQ0ODBDyAAQHRgbrOAVeBV8APTI5B/a9GAUNz8gAFQPPBeelYALMCjYCjqgCht8/lW+QAsXSAoP5ASbmEADytAFIAjSUCkaWAOoA6QocAB7bwM8TEkSkBCJ+AQQCQBjED/IQBjDwDASIbgwDxAeuBzQAsgBwmO+snIYAYgaaAioG8AAiAEIMmhcCqgLKQiDWCMIwA7gCFAIA9zRyqgCohB8AHgQsAt4dASQAwBnUBQEQIFM+CZ4JjyUiIVbATOqDSQAaABMAHAAVclsAKAAVAE71HN89+gI5X8qc5jUKFyRfVAJfPfMAGgATABwAFXIgY0CeAMPyACIAQAzMFsKqAgHavwViBekC0KYCxLcCClMjpGwUehp0TPwAwhRuAugAEjQ0kBfQmAKBggETIgDEFG4C6AASNAFPUCyYTBEDLgIFMBDecB60Ad5KAHgyEn4COBYoAy4uwD5yAEDoAfwsAM4OqLwBImqIALgMAAwCAIraUAUi3HIeAKgu2AGoBgYGBgYrNAOiAG4BCiA+9Dd7BB8eALEBzgIoAgDmMhJ6OvpQtzOoLjVPBQAGAS4FYAVftr8FcDtkQhlBWEiee5pmZqH/EhoDzA4s+H4qBKpSAlpaAnwisi4BlqqsPGIDTB4EimgQANgCBrJGNioCBzACQGQAcgFoJngAiiQgAJwBUL4ALnAeAbbMAz40KEoEWgF2YAZsAmwA+FAeAzAIDABQSACyAABkAHoAMrwGDvr2IJSGBgAQKAAwALoiTgHYAeIOEjiXf4HvABEAGAA7AEQAPzp3gNrHEGYQYwgFTRBMc0EVEgKzD60L7BEcDNgq0tPfADSwB/IDWgfyA1oDWgfyB/IDWgfyA1oDWgNaA1ocEfAh2scQZg9PBHQFlQWSBN0IiiZQEYgHLwjZVBR0JRxOA0wBAyMsSSM7mjMSJUlME00KCAM2SWyufT8DTjGyVPyQqQPSMlY5cwgFHngSpwAxD3ojNbxOhXpOcacKUk+1tYZJaU5uAsU6rz//CigJmm/Cd1UGRBAeJ6gQ+gw2AbgBPg3wS9sE9AY+BMwfgBkcD9CVnwioLeAM8CbmLqSAXSP4KoYF8Ev3POALUFFrD1wLaAnmOmaBUQMkARAijgrgDTwIcBD2CsxuDegRSAc8A9hJnQCoBwQLFB04FbgmE2KvCww5egb+GvkLkiayEyx6/wXWGiQGUAEsGwIA0i7qhbNaNFwfT2IGBgsoI8oUq1AjDShAunhLGh4HGCWsApRDc0qKUTkeliH5PEANaS4WUX8H+DwIGVILhDyhRq5FERHVPpA9SyJMTC8EOIIsMieOCdIPiAy8fHUBXAkkCbQMdBM0ERo3yAg8BxwwlycnGAgkRphgnQT6ogP2E9QDDgVCCUQHFgO4HDATMRUsBRCBJ9oC9jbYLrYCklaDARoFzg8oH+IQU0fjDuwIngJoA4Yl7gAwFSQAGiKeCEZmAGKP21MILs4IympvI3cDahTqZBF2B5QOWgeqHDYVwhzkcMteDoYLKKayCV4BeAmcAWIE5ggMNV6MoyBEZ1aLWxieIGRBQl3/AjQMaBWiRMCHewKOD24SHgE4AXYHPA0EAnoR8BFuEJgI7oYHNbgz+zooBFIhhiAUCioDUmzRCyom/Az7bAGmEmUDDzRAd/FnrmC5JxgABxwyyEFjIfQLlU/QDJ8axBhFVDEZ5wfCA/Ya9iftQVoGAgOmBhY6UDPxBMALbAiOCUIATA6mGgfaGG0KdIzTATSOAbqcA1qUhgJykgY6Bw4Aag6KBXzoACACqgimAAgA0gNaADwCsAegABwAiEQBQAMqMgEk6AKSA5YINM4BmDIB9iwEHsYMGAD6Om5NAsO0AoBtZqUF4FsCkQJMOAFQKAQIUUpUA7J05ADeAE4GFuJKARiuTc4d5kYB4nIuAMoA/gAIOAcIRAHQAfZwALoBYgs0CaW2uAFQ7CwAhgAYbgHaAowA4AA4AIL0AVYAUAVc/AXWAlJMARQ0Gy5aZAG+AyIBNgEQAHwGzpCozAoiBHAH1gIQHhXkAu8xB7gEAyLiE9BCyAK94VgAMhkKOwqqCqlgXmM2CTR1PVMAER+rPso/UQVUO1Y7WztWO1s7VjtbO1Y7WztWO1sDmsLlwuUKb19IYe4MqQ3XRMs6TBPeYFRgNRPLLboUxBXRJVkZQBq/Jwgl51UMDwct1mYzCC80eBe/AEIpa4NEY4keMwpOHOpTlFT7LR4AtEulM7INrxsYREMFSnXwYi0WEQolAmSEAmJFXlCyAF43IwKh+gJomwJmDAKfhzgeDgJmPgJmKQRxBIIDfxYDfpU5CTl6GjmFOiYmAmwgAjI5OA0CbcoCbbHyjQI2akguAWoA4QDkAE0IB5sMkAEBDsUAELgCdzICdqVCAnlORgJ4vSBf3kWxRvYCfEICessCfQwCfPNIA0iAZicALhhJW0peGBpKzwLRBALQz0sqA4hSA4fpRMiRNQLypF0GAwOxS9FMMCgG0k1PTbICi0ICitvEHgogRmoIugKOOgKOX0OahAKO3AKOX3tRt1M4AA1S11SIApP+ApMPAOwAH1UhVbJV0wksHimYiTLkeGlFPjwCl6IC77VYJKsAXCgClpICln+fAKxZr1oMhFAAPgKWuAKWUVxHXNQCmc4CmWdczV0KHAKcnjnFOqACnBkCn54CnruNACASNC0SAp30Ap6VALhAYTdh8gKe1gKgcQGsAp6iIgKeUahjy2QqKC4CJ7ICJoECoP4CoE/aAqYyAqXRAqgCAIACp/Vof2i0AAZMah9q1AKs5gKssQKtagKtBQJXIAJV3wKx5NoDH1FsmgKywBACsusabONtZm1LYgMl0AK2Xz5CbpMDKUgCuGECuUoYArktenA5cOQCvRwDLbUDMhQCvotyBQMzdAK+HXMlc1ICw84CwwdzhXROOEh04wM8qgADPJ0DPcICxX8CxkoCxhOMAshsVALIRwLJUgLJMQJkoALd1Xh8ZHixeShL0wMYpmcFAmH3GfaVJ3sOXpVevhQCz24Cz28yTlbV9haiAMmwAs92ASztA04Vfk4IAtwqAtuNAtJSA1JfA1NiAQQDVY+AjEIDzhnwY0h4AoLRg5AC2soC2eGEE4RMpz8DhqgAMgNkEYZ0XPwAWALfaALeu3Z6AuIy7RcB8zMqAfSeAfLVigLr9gLpc3wCAur8AurnAPxKAbwC7owC65+WrZcGAu5CA4XjmHxw43GkAvMGAGwDjhmZlgL3FgORcQOSigL3mwL53AL4aZofmq6+OpshA52GAv79AR4APJ8fAJ+2AwWQA6ZtA6bcANTIAwZtoYuiCAwDDEwBIAEiB3AGZLxqCAC+BG7CFI4ethAAGng8ACYDNrIDxAwQA4yCAWYqJACM8gAkAOamCqKUCLoGIqbIBQCuBRjCBfAkREUEFn8Fbz5FRzJCKEK7X3gYX8MAlswFOQCQUyCbwDstYDkYutYONhjNGJDJ/QVeBV8FXgVfBWoFXwVeBV8FXgVfBV4FXwVeBV9NHAjejG4JCQkKa17wMgTQA7gGNsLCAMIErsIA7kcwFrkFTT5wPndCRkK9X3w+X+8AWBgzsgCNBcxyzAOm7kaBRC0qCzIdLj08fnTfccH4GckscAFy13U3HgVmBXHJyMm/CNZQYgcHBwqDXoSSxQA6P4gAChbYBuy0KgwAjMoSAwgUAOVsJEQrJlFCuELDSD8qXy5gPS4/KgnIRAUKSz9KPn8+iD53PngCkELDUElCX9JVVnFUETNyWzYCcQASdSZf5zpBIgluogppKjJDJC1CskLDMswIzANf0BUmNRAPEAMGAQYpfqTfcUE0UR7JssmzCWzI0tMKZ0FmD+wQqhgAk5QkTEIsG7BtQM4/Cjo/Sj53QkYcDhEkU05zYjM0Wui8GQqE9CQyQkYcZA9REBU6W0pJPgs7SpwzCogiNEJGG/wPWikqHzc4BwyPaPBlCnhk0GASYDQqdQZKYCBACSIlYLoNCXIXbFVgVBgIBQZk7mAcYJxghGC6YFJgmG8WHga8FdxcsLxhC0MdsgHCMtTICSYcByMKJQGAAnMBNjecWYcCAZEKv04hAOsqdJUR0RQErU3xAaICjqNWBUdmAP4ARBEHOx1egRKsEysmwbZOAFYTOwMAHBO+NVsC2RJLbBEiAN9VBnwEESVhADgAvQKhLgsWdrIgAWIBjQoDA+D0FgaxBlEGwAAky1ywYRC7aBOQCy1GDsIBwgEpCU4DYQUvLy8nJSYoMxktDSgTlABbAnVel1CcCHUmBA94TgHadRbVWCcgsLdN8QcYBVNmAP4ARBEHgQYNK3MRjhKsPzc0zrZdFBIAZsMSAGpKblAoIiLGADgAvQKhLi1CFdUClxiCAVDCWM90eY7epaIO/KAVRBvzEuASDQ8iAwHOCUEQmgwXMhM9EgBCALrVAQkAqwDoAJuRNgAbAGIbzTVzfTEUyAIXCUIrStroIyUSG4QCggTIEbHxcwA+QDQOrT8u1agjB8IQABBBLtUYIAB9suEjD8IhThzUqHclAUQqZiMC8qAPBFPz6x9sDMMNAQhDCkUABccLRAJSDcIIww1DLtWoMQrDCUMPkhroBCIOwgyYCCILwhZCAKcQwgsFGKd74wA7cgtCDEMAAq0JwwUi1/UMBQ110QaCAAfCEmIYEsMBCADxCAAAexViDRbSG/x2F8IYQgAuwgLyqMIAHsICXCcxhgABwgAC6hVDFcIr8qPCz6hCCgKlJ1IAAmIA5+QZwqViFb/LAPsaggioBRH/dwDfwqfCGOIBGsKjknl5BwKpoooAEsINGxIAA5oAbcINAAvCp0IIGkICwQionNEPAgfHqUIFAOGCL71txQNPAAPyABXCAAcCAAnCAGmSABrCAA7CCRjCjnAWAgABYgAOcgAuUiUABsIAF8IIKAANUQC6wi0AA8IADqIq8gCyYQAcIgAbwgAB8gqoAAXNCxwV4gAHogBCwgEJAGnCAAuCAB3CAAjCCagABdEAbqYZ3ACYCCgABdEAAUIAB+IAHaIIKAAGoQAJggAbMgBtIgDmwocACGIACEIAFMIDAGkCCSgABtEA45IACUILqA7L+2YAB0IAbqNATwBOAArCCwADQgAJtAM+AAciABmCAAISpwIACiIACkIACgKn8gbCAAkiAAMSABBCBwAUQgARcgAPkgAN8gANwgAZEg0WIgAVQgBuoha6AcIAwQATQgBpMhEA4VIAAkIABFkAF4IFIgAG1wAYwgQlAYIvWQBATAC2DwcUDHkALzF3AasMCGUCcyoTBgQQDnZSc2YxkCYFhxsFaTQ9A6gKuwYI3wAdAwIKdQF9eU5ZGygDVgIcRQEzBgp6TcSCWYFHADAAOAgAAgAAAFoR4gCClzMBMgB97BQYOU0IUQBeDAAIVwEOkdMAf0IEJ6wAYQDdHACcbz4mkgDUcrgA1tsBHQ/JfHoiH10kENgBj5eyKVpaVE8ZQ8mQAAAAhiM+RzAy5xieVgB5ATAsNylJIBYDN1wE/sz1AFJs4wBxAngCRhGBOs54NTXcAgEMFxkmCxsOsrMAAAMCBAICABnRAgAqAQAFBQUFBQUEBAQEBAQDBAUGBwgDBAQEBAMBASEAigCNAJI8AOcAuADZAKFDAL8ArwCqAKUA6wCjANcAoADkAQUBAADEAH4AXwDPANEBAADbAO8AjQCmAS4A5wDcANkKAAgOMTrZ2dnZu8Xh0tXTSDccAU8BWTRMAVcBZgFlAVgBSVBISm0SAVAaDA8KOT0SDQAmEyosLjE9Pz9CQkJDRBNFBSNWVlZWWFhXWC5ZWlxbWyJiZmZlZ2Ypa211dHd3d3d3d3l5eXl5eXl5eXl5e3t8e3phAEPxAEgAmQB3ADEAZfcAjQBWAFYANgJz7gCKAAT39wBjAJLxAJ4ATgBhAGP+/q8AhACEAGgAVQCwACMAtQCCAj0CQAD7AOYA/QD9AOcA/gDoAOgA5wDlAC4CeAFQAT8BPQFTAT0BPQE9ATgBNwE3ATcBGwFXFgAwDwcAAFIeER0KHB0VAI0AlQClAFAAaR8CMAB1AG4AlgMSAyQxAx5IRU4wAJACTgDGAlYCoQC/ApMCkwKTApMCkwKTAogCkwKTApMCkwKTApMCkgKSApUCnQKUApMCkwKRApECkQKQAnIB0QKUApoCkwKTApIbfhACAPsKA5oCXgI3HAFRFToC3RYPMBgBSzwYUpYBeKlBAWZeAQIDPEwBAwCWMB4flnEAMGcAcAA1AJADm8yS8LWLYQzBMhXJARgIpNx7MQsEKmEBuQDkhYeGhYeFiImJhYqNi4WMj42HjomPiZCFkYWShZORlIWVhZaJl4WYhZmFmoWbipyPnYmehQCJK6cAigRCBD8EQQREBEIESARFBEAERgRIBEcEQwRFBEgAqgOOANBYANYCEwD9YQD9ASAA/QD7APsA/AD72wOLKmzFAP0A+wD7APwA+yMAkGEA/QCQASAA/QCQAvMA/QCQ2wOLKmzFIwD+YQEgAP0A/QD7APsA/AD7AP4A+wD7APwA+9sDiypsxSMAkGEBIAD9AJAA/QCQAvMA/QCQ2wOLKmzFIwJKAT0CUQFAAlLIA6UC8wOl2wOLKmzFIwCQYQEgA6UAkAOlAJAC8wOlAJDbA4sqbMUjBDcAkAQ4AJANlDh0JwEzAJAHRXUKKgEEAM1hCQBbYQAFGjkJAJAJRN8AUAkAkAkAnW0/6mOd3brkH5dB9mNQ/eNThoJ1CP8EZzy46pMulzRpOAZDJDXL2yXaVtAh1MxM82zfnsL/FXSaOaxJlgv345IW0Dfon3fzkx0WByY6wfCroENsWq/bORcfBvtlWbGzP5ju+gqE1DjyFssbkkSeqLAdrCkLOfItA7XNe1PctDPFKoNd/aZ6IQq6JTB6IrDBZ5/nJIbTHMeaaIWRoDvc42ORs9KtvcQWZd+Nv1D2C/hrzaOrFUjpItLWRI4x3GmzQqZbVH5LoCEJpk3hzt1pmM7bPitwOPG8gTKLVFszSrDZyLmfq8LkwkSUhIQlN4nFJUEhU2N7NBTOGk4Y2q9A2M7ps8jcevOKfycp9u3DyCe9hCt7i5HV8U5pm5LnVnKnyzbIyAN/LU4aqT3JK+e9JsdusAsUCgAuCnc4IwbgPBg4EPGOv5gR8D+96c8fLb09f7L6ON2k+Zxe/Y0AYoZIZ8yuu1At7f70iuSFoFmyPpwDU/4lQ+mHkFmq/CwtE7A979KNdD8zaHSx4HoxWsM8vl+2brNxN0QtIUvOfNGAYyv1R5DaM1JAR0C+Ugp6/cNq4pUDyDPKJjFeP4/L1TBoOJak3PVlmDCi/1oF8k1mnzTCz15BdAvmFjQrjide74m2NW1NG/qRrzhbNwwejlhnPfRn4mIfYmXzj5Fbu3C2TUpnYg+djp65dxZJ8XhwUqJ8JYrrR4WtrHKdKjz0i77K+QitukOAZSfFIwvBr1GKYpSukYTqF4gNtgaNDqh78ZDH4Qerglo3VpTLT0wOglaX6bDNhfs04jHVcMfCHwIb+y5bAaBvh2RARFYEjxjr1xTfU09JEjdY1vfcPrPVmnBBSDPj9TcZ1V/Dz8fvy0WLWZM0JPbRL0hLSPeVoC8hgQIGaeE6AYVZnnqm62/wt00pDl5Nw/nDo+bF1tC4qo5DryXVn8ffL3kuT51e+VcBTGiibvP+vqX50dppfxyNORSr48S5WXV8fzcsgjRQH6zjl+nuUYFVloiEnZOPDpHD/7ILh3JuFCdvAi2ANXYXjTDA5Up6YLihbc7d+dBlI9+mdgr8m8+3/Dp26W/Jssn7b9/pOEP4i+/9TsPI9m2NfNKwEI35mqKV+HpZ+W69Y8sM/sIA9Ltvhd+evQTUUfSkYxki28/CBT0cT96HrlrSrE+V9RzhskX0CsDsCfHffBVybkxmHOFOgaUurWNQ2AcZbi1WjkZzYArWZBHFd1SYwtqQ0DIZt7OV40ewQxCr/LgxAc8dLJeAJFseWJq9XiOp21hLv/HhsFbYbg3zCR8JmonZjhuKYrS/KJc30vnOL2CM+GfogNWug2DstZPzauCNeeD8zlP8wxPyfLHYQB/J+wQE3aDpXH/5tdIQpLn3JXNJYZFiXInGB7FqxRxHYJ/re/lHprE5sngUMm11uOIA3bbtkk06I8DYxuwPD+e4sAeNfor0DkWmiCQFiNptkmiD2xGO1kIKGr/Tuu4bHe6z2NaS7Ih0c+Gpv+QbLY9ea122BXNSitM41sxUSlnWl+uJBIFoLqt66v/VfGIQos2lzhOOLDuScVxcyrqH3/FI4vaYB0b8gFHLXtxyX/9JpUCYNwlLZ1v5CeB99l0F795R5wl5UHRq1OYyKqsoIY07wJz2CT0TOf5/JRBPtJIIk5pOJ60SHayS9kMSKbI3fLLYztsY3B4MlSyoEfc9gL4yJVrPo+OGGunCK4p15UbCArJP/PQgUWDW4l+2P/tCqRRy2flIZL/nVeY/vyAfILUM5qEGfcFXXXrAit7skwDEFnD7mL1ATtyrz7HcodhzP7gShFhazIPm7X0+mTCeSWfrOr5WcvJfip19JRRLfXjuQpQjcNCuXo8kqkxQ68ukJQoxlnfjevc0WcKnGpUvyY54eJTS1IRWDqfHANukJLw56ts5yS6Nea7IrL6/78aKmZsch4Q694ujxgx5+0PhlGpzWimajpvkBOOUQlHLkJorzqu4e768L9nJtZWYturb7dsBxjzlNhd/gZcBuRgIUSdgZjg7Rx+f/zLcs4mAa3qDbJNUQVNbSg+dm0L3KH1uhesTPaErVYjZ8Isvfr+zfiX3DT0PlaOv+hdGvLUIlKSEcYHPMs0NtTGzyqMe74yciNFdAVZVzol/XtLsEqivKqfW7zWTCNCvZkPnnBlMv3UHW5RNNEJfuyR3MvYH/9E6gcts5GAwKIgCaBQ+V2Eh9O0IJkxFksPI1V9obqDKCpmPM55mLd+VQgRqgD+9XvsUxjbh/AXXPxOpc0FXFyJzc85aa1VQZa90LAWR4oinrBaOBr8DymCpFbdXMTn7Cv18S0hMR7T/o5VkRqN1g1/dvaDdZsRArO3bopkfee4efLF+hyVdcX4u3aNGTkWvLRafW+sXPktA1lla4UkSB7uJIULfxy/RAflk2miyw9xq9uVGgCNzqCv4iX+AUchfMkZdEgRZ9TZ+1CPTH2jXjMXjFl/+bEPzSjM7zPKKWhyZUgQG1lpp+DNz+Zz+85kD59q99U5R4B3vuI9WenCWqroy2U2Ruq6I+di5N/v9SmYnqJ5H1HLWCbIg6iVrn3s2gFBVFhrc1zzNqoFe275K3Jy1T0Mc5yeE1iRwO2b1L/j/S8jyvGDz6B3NMFEHErGHMM2+oJ5LobazyWEitdgMjQnsd0cjYrCqRpx8idpfwRq6hz/LleX6obpuJh/AGIu4sxD35hwkIEr5ShH8xro7tTDYK1GPHGylK6rp7NCG0lMr7YqwziMUBwXv0zPW667f3/IRLJRD7mkuwUP6mpkxyVjNlcBiAX12r//+WTuzWxsue7bsjRp7xFjpR2tRLqGHLvjYt3TpeybR82K61iLn+pOSWDfUv/HU8ecBtML+Gbz0v9vmlxSgZeBBzbGeP1KSqsH14ZM2kibgDhbS21hIALSOYFCE9LY+2CNvtzT2QuSJMiKP3zwvvs+/JkDwTg0jHVE0XH//U0nu5HKQtCL2KGDQYUgT7qIMVN/OoWqEz1oeG4wG7InZg47NE7rfHB2i7rkpYCUzaPfVtDYgTEPNpa8gXHI2Pp8A6YB8OYHkXDZMMcOL3rJD0Hxk+mRlsSJ12/7T52IcFst5zRc7uDJtQTXBdm9GvsvyXcBbMfKXWqsDSeEnFyPUXZGTafti4a0it8SN1qXxzBmzj+gVZ/FojNy+x73AuuqtJ/oaMZF6m5kbW6ItpfnUT/BrQunS+gLjTTUz0d8jTMpAfFQ40RQi9uM5qdFYzqk85hqSH1zsPOhiO5CN+hNZvL/RIs7m7LyLDuV80ZtyHHqVEngTVPBctHQhmcPjM30m1veDmHCXEpjybWAbgj3TqLUPNazzdHgxYmNuT7trWFcGOi7iTeL5YeK2yp2H98yoLN+skqhffZI/5n/ivceo44wJRY8bzC6DGwdgkMOulYhzW5m6OKyK2Mg+E3YE19L8ngE08TdAuNu0mIzd6kw0i03zzm4oqfVSZjZyxXnBhvt0v89EmnArya/UvHQrdQxBDAJagK2y+OqgBqzQ4FnUeiKfb7HFoUvFSknWhwq58TpBlVRZ0B0A7QWz7X4GLHcbdh5kFI/PKJ91OEh/kmnMEdh+Z23myFH8sXjR/KaHttrpz80N+bl0HM17RX48UjUWslrYHYW7oiHVgcGqTBoTrqK4JYwTTArFO1/APJ8DnEYf+wD92Dw15a9wrPxyJA88yYcv9RypzXLKAWmMuE0KAtIGjfKx1GbRQIq0AkttuRpBO7p4SGrTZuAOat3hTxXEcIKh3HgC1d88K7bz1+Jsi+y7tL/7zc0ZxCBB3hSxvP90GkUp1Lm2wuESafZyFy4Opir+o3gMWtDSuLF3LRHXTUGkKQtvARnwam8BuKv8Q2fHH/cEwPCQd3dhzgri8eTezRsQoGz6ha+S4E7ZzDB/LXwl04vA70NeVsf5rmv1TLvcQSNIBk3U6Qh6Bm+0905B91hopTLnTJRWZkUmbckEw0woG81azyw6LZaBL5Qx2HPvd3LHGLpN6mPZlto50NwW2zFOkgoPKV1gr142teD9aok2HNkPMepl3NIi78ShnAlJCzjZplteUoqz0+iUEOym1LZGGFHMBkc6/5f+sRCCFZZW6KrEby64o/ZfefQAPP6b5ko2fuujIv7uonIKXN6XiJsZmcOeGxteQ+b/ope3Z1HFeXYoW1AJrU/OiCpsyQP1Pr1BdQKFzS0oYnLCAweSnIh7qMFMRBMY7BcnJ5oskUbbRNiosqMzCYUAZPbo8tjCCsCBm5SoGcTHBMXcE+yQpl/OfBkcTw3oa4X7V+ohEh/Zkcv0cqc8sY40IsOW6lLiIrvYND/exZbRlOMgaHvb/QQKaY0k6Aamee2o3LVARCbIP4RoSd7u3CXkG+Iz6iFLfsN38F9xU4n3ueeVgiRs3jw70SMWu1QzDdiLsKtU1qvaLhv7dUbnLimdqYG+pa2aRZ8A6Q9JSr3yTs1MiAvfFHPQJTiqpI/hVUMmL6gPj6eL7lH0IkLCNcaogBA0TGfO0wO6ddf8Fju0L3YbRrWe8J3IewsNBCbpC2b6etQRJnSGLuWDiFoBez9hJHw6+bMQQGQS8YV/kzQ5AFHEqPaMgOjyR5zaHtlOBI4mjo8gdNItHUHQ7Bzq/E/xV1B+L0uoRcLIEj4hcv0yWQTwWLHzoFrvEZPygABpc4rnVjhfcBw5wOvaVVtgiG5qjklrTY1ZaXHkasyVYBd+lgo6zEHMumfK8XR2eD0cVn5w8l1uxGz2ACwtFob/CTV/TUx1kCKp+QROanLrNBiSPTxAf1eOFE+JifgAJ+pyrFqS/0wKlPWUVKlB2Bhu1Ggx2cvfdiR49VIsgBNnE75pf5lpFaQuz8+VPreUd/HLlW8kDSr25AnETsVRrOycLBPYD9/j/7Z0KKdOjtrM71AT+VsjD3D97aUDP5WrHp1DWghsk/lS/hp2VMwo0eqoEerLL/4/SlmyjStwWVDqF6jHC89niCwr1tMSe8GxeC9wjzMKmE7ZtdHOWqqc1OoTI24eVQc++crbyxSU4TxiB+vWoaAUpYQxZ06KKIPq6EvN/rN4DZ0/tQWYVqZ3FTIftPBfIuOWX3PonIKTUArpSvfmQRpkWD00wc3AQS98i4ZYaUbI+DGv90tuEKRjb2ocfdddC21YGUATYQmzelz7JqWBAQqKrWYdWEJlfPeRFZHtUm2MaISZsoOvURowxJKveGRegmBiKZ3d1cMFioJL33RoIKT0eDeK8FH/ybAhZU5TQIsWYmjyeT7EOLL5xZuRPf4qRIo6bbLtFOV6SX60fR8Smys/u1D5DjkmHJyr/woVAvBP2dxGo9gH1LgIm8XlFF1KSYvfj+0w7aTEfoFpcO+Jv3Ssbv8wwkED5JEC+jdln2dzToPNRtWiPbRb8f8G4aZX1j/2Vdbu7jM3gAVD5BKR+yJaOwLtwJodwjWu5di47tnNs9ahpnCUzVMObQfbTqMNs64MGANlgyihKjhwZ6p1Jsnro0/SfkOk6wx+HgUB6Mz9cUiF7KrJkhxnOVjCCcqPZglIojIRoDtkd2AkLNZC88GdP2qZV/1N6PBAe+fpgWZ36oHnewQ8CHdXcxbwQVjOn8U3qD9+e7FzWpg135vgdEMZ9fH5agDnNzdjKFZQ4tDsJs/S6Lk8FqjFJpHMjaRU6FI/DBDM0g+RRkxNoUvm14JAn5dgd6aVHt1aMkSXiJVenbm2FfrIEaFKHtm1erv1BJ5056ULL8AMGLmHav4yxg6F6n5oBq7bdP6zEr6f+QTDJ/KE1XfoG24JvVk2GL7Fb+me27otVFnq1e/2wEuqv6X+2zLQuJQszy5YJi/M5888fMy34L6z8ykD5sCHgzliAoAtEeoaFmnPT63kOYrZWspxYzqQBu/QKNyQ8e4QwKJUCVazmIUp6/zpLA3bWH2ch7QZN0rzWGxMRl3K1osWeETxL95TZSG/atM8LB9B92/71+g9UGWDPfD+lu/KdOQ85rocuHe91/gHA/iprG9PZ2juX49kaRxZ+1/sB3Ck35eWYBFsmCl0wC4QZWX5c5QMuSAEz1CJj0JWArSReV4D/vrgLw+EyhBB6aA4+B34PdlDaTLpm9q9Pkl+bzVWrSO+7uVrIECzsvk8RcmfmNSJretRcoI7ZcIfAqwciU9nJ8O4u1EgkcMOzC/MM2l6OYZRrGcqXCitp4LPXruVPzeD402JGV9grZyz9wJolMLC/YCcWs9CjiWv+DNRLaoSgD5M8T4PzmG8cXYM4jPo5SG1wY3QK/4wzVPrc33wI+AcGI//yXgvyBjocGrl768DMaYCGglwIit4r6t6ulwhwHJ4KeV3VHjspXXG4DIlDR2HNFvPaqkBViIvr433qZPuUINp6oi1LyVVC+EE1j6+wab8uPMeAo6e9uWYequvZynhnYazrvrDQJVkK3KZRoSR5BHi6vOC+AVCujMiQ1GVzGDZ4RFv8jFm7z5CU0iPH2JeXqUzqaKKP4P7osPkcIL99Y7fP3l+TzeFXO2kSpLIJW51oEY8DRIhqexGnxj0nmtGOseStuViIE2mJge45LENf77xjuI7egRNpzthNiajnuqikg0aQS1JqlIZf+hwSUlOp8BEQ0y3xiTOJkohBP3eyYiPDlZpFY88EWOpp4+hC/tQdhrQ56h2VJ2XA6vhPAbj+wH6iA2XYuTvRV25N8wNPQuA0Vzzem2ADZPFK2vr8l0I3GTV3fUN4S6FFYygW2Pu98f+lsgPf67rwVCbgMFAACW3P10GbxnK3SNuNK+VlPRiL7U3dK1o3spH/MFfDkgXuXjxDTxJrYctqHdwUg4rhUCNA13lGjuhJDatpFb/mExsBWS46aLFtROqVm8xQNPXK6A2rRfazJSWpIyh+FMmorXPXYnHQ7YLOmD4B5QTI8rzp7OomiarnaFs5syYjQ0ucc7g1/JzT446IFlDtpUL7DP9bLRCLJryUvi5R71/qX7ycqRSwunQ7+tfJz44Na3aJNszaMEZ/BV4iOGopabYdmvAPe+kIdGCNq5Q8fg8Ld0VNNXV0ZiiGej7zSA+pexy6wKC5k4rZa0k+qaN8bKq3oJWMQCSGaK7PrwMvA8t8BZTzjDqXcFTAIeRtl0SdlGSuAziVXItFcgAkeqwuNsbsrUZFcU6KUZLmvG415kHa0AwMFW2cNSUvPR0U9iCPh0nyslT92B5slYXiDWeSXvxHXItvjI8z5KCIVTIHqGZsbDBTr7WdHzcUAI1ipR86H3o0p2wPhfp7xg9oWOxWIK4a5BWdaV9OAPc0XuvlbwitCVtZDzZxGhIOl77ZgrRYR7LZQFE+Ih23hW3gI914ekkjgbKCi2bsqSAvij6GGj5p+k6evQtJp3qVh9vg+jiJvFCGcKBCITMWpqHZNKfE6IT0dKntS0rhu0DB5D9qIS0/RboNLsx2DlRMlx1QIBeBpHJNKdCL9uWM9eS7RJXKNOpraULtutuJYOl0apdE4LxfsyRSZb6fJkd51SHrI7lLB4vEg4fifJ1dqcWSeY4DgcyjrUcymK+gd3o+qj+3gHKWlLVdMUr3IeF8aClYBq+eeCV9Y7n1Ye8yL7rEvxY7jAlLwucKQ51pu59N8we8XwrbXPChBHXP4LnD3kDwQ85w1DKghtwvpO609fZOrPq8Q7GOOAjHhfR5VqvpoFne8oMHbCrWb1L0IdATo+h1PFeLLI8wc+FEyftLvskCdOtxKfAx3IEJXzBfWTKq5viKP/uu99dxnEpoNJhRtjSZGwOTWr7Ys44++P58O+nkYxd1Gcqm8G3Gh7AHSCxiPNyJWijI/lECrKrAXgBqkRShvdkd7IfoqUlziFDiglx+jdHnmRVmGnk3p/3n78M/HkzFUGZOS07cPnPn9jAnBWl4qDrB1ECf9idIKOdkJTKcZ690nuLW2yDsqwNpgrlT+wx2gv+Engha74lfVqbwqS15FRwuFDfq3bVCZcPy78TL2pH/DOdHeL9MFAtyybQNwHaO781rnJZAhR4M+AYWoSoa0EjQ99xivreM+FKwd7Jp/FC2vvvcq1z3RnRau/BM5KGkBPBSUBOzTNdfaJS/PWTDb1jRSgn2MuY3pVZbY9peHBVI3Ce/u70hg4f7MCVeAjYJfzTkDVLuB6jyjZs5Kko3u39ozgLK4LuwSbUrNIU5cl6Bs3De62AE084XRsm64Gs5W1ofxsWIZ9cYl8PNa5zQHl9ls5aiIKN0rHIIzBnLr03Kle2qq+n/gLDAzvF89vdZCvUFEHRoi9n33O3i49UWyeHP+ZAeRf+psM867nfqON092zE4Pj7AbLtvIUFJFr1y9Le0CL2flc7LUqbgGzOw4/q3vA/cJO5JeI8S+8bc1Y7pqYSzoEWSFn5G7EoPHTGHPMU6SeLKEeli+i8dHY3lWxSrIOU2y0TNo1SeRYewhVx05OXeVDf0xhHNckqp0arRk+bgToeSaHbVZ5nj3IH3m2oayt3sXY78qSPcDpc/5C7VXDRj6bROvvBG5JCsKl/yeMPAUn1flMsmr/FaFdb7gVUXnhLa+/Ilj87PpCC6rILQ6wkIP1ywEg0PztSEzbsJoRwQzDaxkiTN27YDnsy/YKfe6jKcqZWs64skzUAHIt+nXxju0dUVtbCSDAUXYw78Yd4bJKuYU8gbzLzgL4XIUC2HcPIVCUYvM7cybOBFVBdeGR4cOVB7QbGnohTRpiPrGqi1a8QXFBYqENawROuR43OG8dl+Jx4TpwAoi2kkPXW7b/ARSs4DO/z4H6oTIUpN3+/K6Iuc49C4/Uf1NxQTEE91VP8RnLKTpxjywMe2VxM1l4YGXSFY80HUAKIdqczBnnLMPklFV8mrr5hFDypn5TAT00ruU6AjDPNvncoVzX4ac6wAzTwrNH7oz1XLH1wzjQs5k7hcNLbznXQGB7M+rXxKtZXPrz1Ar+OxYGDkJvElknZsHD/IcxRd7ujmmLYpDDbverynroCnSKVQWEGjHL57PaI/WokvhYRpPMk4ni2EUhjDuIF+IU2R0fs40i+66bw8sz8OzyC2eFAxxicd2n5Juta2eWa9KtObD7xLmPvtK+8cjQt+NLjcZCTt+Ss9p1od0bklVgaIV1qJbWxUOr6iUzLDzFefYxAtyRcBr53IaDB25n60KQdhroQWMUpuWSUpELSFxiu4vgQeRoEZe78/ua3TlrszB8sLVZoecnV9YMYz+HkZA/pLqbFhzurB52Wl/WEM6sVk4q04OnzWZFi76JkcGgeeUyYUIwhCDMdIfTUdD4wQpYm3LBw0sp33CVK2q305jeyzgGnBzSMXjesm4XjcEhhrjPSLtwqqoaFCqD5DlHYhoTVafWtBUQXoNfDk19IFxq8sImCcqgMhOToIZUO2530aasY908dMX2nTMFjgv+lapdI8k/e0a7pFw6X3Tgf0m99bbCpOzVgRu2Dw/13CehVfFj+8BeKP6SZV4g/qiX42NWP568PzMajFm2ANmKtHjEIAIc2hc1iecBR9elGP4LmAQwAVmZT8kWc7JSY0ag583ch/Z16krGrjn2YdIaa22egy4/niU6m0WAG3K/yP65cfL//CP+JzcnoLHQFb/KJQeBrEbR1/IKo+YOFXWIQ8ghNxYdMwa49NeXzFqFOIXTmk3w/v5KneS8sGHiPGACh0DE9a1uLAochB79g3IqYObhlswemMucZnAE7dBkp5OAfToa5gHFbIPcec0fVWEOOLftQXsuffyv3wo1LWDDm+SyNMWgSEWtjMyYkjLjTkUtmj7DQlfbpHf38lDvoEN9d2ALxnWCjph4jvfEIRbHvltKbvE2BiYlz45mnJPeFrwZcBny3k0/pyXNrSbEIWvvZw14Y0Fqy4tba1Fu0yNNYaf47jfnz7VCCxKsrJz5oz3F8jXUdQqFu+gDq6EzvKDipXf/3NmcsCC74VB3OgHPgN7W9cU54pjGFDMfifl3m5Vhy21uk1U2nYCrddrifkpwGLYmLSSQAAjC6M3yB1fc6KHpgDnMXh2bYX2ns+Qma+DBgyCkZ0TqZK8Mp2Sryx7HdMM74X9hrwYhQbwlK+zgATAXRzQyS+hK4OTnP17/cyJ2WzY6DChYWGJYXGCnEdMswF5VTYQdSyTpdLXYuh+x2Qr7DR3H2x+YdP0qsLAzYJIWKwrrKkpBgWCmgNCn5t+QbWqf/LoLuvjgDFLtMoxNK5axIA9kammelvwh5ZI52ktrEm/OVEESPQPZGHAIhP7oWDBnGnuzG45XOTpZWsxwNO4UiyxH8riTvQq4JVq5GwX3yqVCbSR0ef/gVYDgiYaiD2EAAxuEPKyXTp/HhL96eVTpaDqFEoV2x1PP/UMcs/XqeGc1gZQG1ot6YxaIEWHanYavH9YdLFjlyU5yrYALVg/sxBjT39oD+BIXvf4LTbvvvpX3srxckEX1XAM9s2uajUTlpPq32mcx4T+sibdQEHQV2WmgwMhbYovh7WWTPfLF03ZbV5a+ElsSIyH6kgJ8+D6aN/6f+ZstkZOYZYx9GbagcrEqwNblz0iZ9NTyvIAeNn3Oup7rtyD4wVE0PoqcnR/LoSK1s1esmOGPjs3zHB8xW4iL8IrhqAJfsWNBYW9TGR11C3KZJaN7MP4O5Ykmpvw94hHzVmsYA68RQdFYfPlFOgCNBoSdy5ODcv11l9bLs135M4okEc4/e8hQczcz2PWipIVSBxa/5sr9xyTFbjG4xm8f4LmrAhD1uEDGrFDl/6X7Nw7/WZPW7fZJGYN8eZ68Td5KGfJyKjD+pTysvTi+8Q8R0L9wKAxAUrYswdvAuiNeenxSplQZjYTxbcH/wP97fOY215SozY3UDRhv7lomztURB2O2UriTX3oAiTKoInkHQietZyhBQ9wMTVHgMrxOP5T/0gN14eFTz0m2D6/iJMbXYGHdIkKEGV2Voa8k/hVNvAVAZKrDEXthUxotwYkYysTDk8j27XEVy+4a30jopuAp5+/xWYb0ne6lwKZwR3j6kDXroOOtrHqWlkJHSWLoPEQJQo/ARzR8UBZSckmeBPn3gJwY62Zo2dyy1AyRRDQBFAJKH9KX+7auP8U8XDo7mMSzq5ZxmaJ5bLpNg4ZM7938SAjMHcu1yB4+lkHnVLnIp86AOPgigH+ZFDRq1QuKWK3pK5JkLDJdakj176NCbjXDASt1h/t1p+GHyKbAoevHSnHuPfoBmQ3nJrDjOhPfwVYi8V5r0KB8BsrfFu8BvhYCbNrvCVnd4Q8RktqIR/ZilioC6g3++L7PHzuXa8NFSF5zd+ISzGLTjrfaKXsBFCkkK0ksSDbl91yXUghMFOskQBeUoo7o3wuIsE29goRIORuJ4b1jSumvR0gR8B21iyW1G4FqHkZOlWz9zq5FnaJX1WbeAxe2DfGSAnw4cqDwg3LFalk6eH89Sdc41Fr6voEa0hfwdkb54yOM7WevDugT1FRzEqdg9zZZ44ZAKGH3ZyqFve3SE4UDN6tLmIFTdIwMrtYRXWBQDB7vvqOuYj7cN31av64+jg/g1uce+am3TOl0cUUL6s0l35FJ9p8vJcG+G8lAFqC0pdmd/aaWYpqDLvB5LEasLMgbPN2N+Wvkh6HYxPOrZEfoxQX/67AzcWOR0K3eYGOgQhyWL7cwKGlxmY/E2b8CKi6Ssgok+7B+zTtq/DXmaDAHRnwbwvCDJ9pITO5RQgBuprEWT0avZv7QjbzITYD8Fzgy4TSYG3z9tLso0Z7MfgHDLKU+kHrzxWkBPwJRydKMXG4AaCA7mlAmjzpNhGOrMGZGZlHSjPbmO5jPd/lKBrViZ0BaXMmqaFOwA/f03O04qQX6MSVA37+SA5Pne/KP7caLJKuOCJXoXpzArUrYesMVc/RXnOv03YrwKgPlR2SjpqIycyulmodZBy6gVc1jA9y6lJqWgR6SY6tc24sVcYuh2GaTeikYJnhr2d6BiL3oLx8M8wuJBdI3FRVIIAx4XougScOw2xWgwUoSYKeLUHc310kVBzSE/vFeHAjlUil8KZftctMgwGjwrhMbjDbK4rB32fTe9jnsqijdp5kOwkD9+klel+lNh3joAFQ");
                const f = new Map([
                    [
                        8217,
                        "apostrophe"
                    ],
                    [
                        8260,
                        "fraction slash"
                    ],
                    [
                        12539,
                        "middle dot"
                    ]
                ]);
                function p(e) {
                    return `{${function(e) {
                        return e.toString(16).toUpperCase().padStart(2, "0");
                    }(e)}}`;
                }
                function m(e) {
                    let t = [];
                    for(let r = 0, n = e.length; r < n;){
                        let n = e.codePointAt(r);
                        r += n < 65536 ? 1 : 2, t.push(n);
                    }
                    return t;
                }
                function g(e) {
                    let t = e.length;
                    if (t < 4096) return String.fromCodePoint(...e);
                    let r = [];
                    for(let n = 0; n < t;)r.push(String.fromCodePoint(...e.slice(n, n += 4096)));
                    return r.join("");
                }
                function y(e, t) {
                    let r = e.length, n = r - t.length;
                    for(let o = 0; 0 == n && o < r; o++)n = e[o] - t[o];
                    return n;
                }
                var v = r("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");
                function b(e) {
                    return e >> 24 & 255;
                }
                function E(e) {
                    return 16777215 & e;
                }
                const _ = new Map(s(v).flatMap((e, t)=>e.map((e)=>[
                            e,
                            t + 1 << 24
                        ]))), A = new Set(i(v)), T = new Map, w = new Map;
                for (let [e, t] of a(v)){
                    if (!A.has(e) && 2 == t.length) {
                        let [r, n] = t, o = w.get(r);
                        o || (o = new Map, w.set(r, o)), o.set(n, e);
                    }
                    T.set(e, t.reverse());
                }
                const I = 44032, R = 4352, P = 4449, x = 4519;
                function O(e) {
                    return e >= I && e < 55204;
                }
                function S(e, t) {
                    if (e >= R && e < 4371 && t >= P && t < 4470) return I + 588 * (e - R) + 28 * (t - P);
                    if (O(e) && t > x && t < 4547 && (e - I) % 28 == 0) return e + (t - x);
                    {
                        let r = w.get(e);
                        return r && (r = r.get(t), r) ? r : -1;
                    }
                }
                function C(e) {
                    let t = [], r = [], n = !1;
                    function o(e) {
                        let r = _.get(e);
                        r && (n = !0, e |= r), t.push(e);
                    }
                    for (let n of e)for(;;){
                        if (n < 128) t.push(n);
                        else if (O(n)) {
                            let e = n - I, t = e % 588 / 28 | 0, r = e % 28;
                            o(R + (e / 588 | 0)), o(P + t), r > 0 && o(x + r);
                        } else {
                            let e = T.get(n);
                            e ? r.push(...e) : o(n);
                        }
                        if (!r.length) break;
                        n = r.pop();
                    }
                    if (n && t.length > 1) {
                        let e = b(t[0]);
                        for(let r = 1; r < t.length; r++){
                            let n = b(t[r]);
                            if (0 == n || e <= n) {
                                e = n;
                                continue;
                            }
                            let o = r - 1;
                            for(;;){
                                let r = t[o + 1];
                                if (t[o + 1] = t[o], t[o] = r, !o) break;
                                if (e = b(t[--o]), e <= n) break;
                            }
                            e = b(t[r]);
                        }
                    }
                    return t;
                }
                function B(e) {
                    return C(e).map(E);
                }
                function k(e) {
                    return function(e) {
                        let t = [], r = [], n = -1, o = 0;
                        for (let i of e){
                            let e = b(i), s = E(i);
                            if (-1 == n) 0 == e ? n = s : t.push(s);
                            else if (o > 0 && o >= e) 0 == e ? (t.push(n, ...r), r.length = 0, n = s) : r.push(s), o = e;
                            else {
                                let i = S(n, s);
                                i >= 0 ? n = i : 0 == o && 0 == e ? (t.push(n), n = s) : (r.push(s), o = e);
                            }
                        }
                        return n >= 0 && t.push(n, ...r), t;
                    }(C(e));
                }
                const N = 65039, M = ".";
                function L() {
                    return new Set(i(h));
                }
                const D = new Map(a(h)), F = L(), H = L(), j = L(), U = L(), G = s(h);
                function V() {
                    return new Set([
                        i(h).map((e)=>G[e]),
                        i(h)
                    ].flat(2));
                }
                const W = h(), Z = c((e)=>{
                    let t = c(h).map((e)=>e + 96);
                    if (t.length) {
                        let r = e >= W;
                        t[0] -= 32, t = g(t), r && (t = `Restricted[${t}]`);
                        let n = V(), o = V(), i = [
                            ...n,
                            ...o
                        ].sort((e, t)=>e - t);
                        return {
                            N: t,
                            P: n,
                            M: h() - 1,
                            R: r,
                            V: new Set(i)
                        };
                    }
                }), q = L(), z = new Map;
                [
                    ...q,
                    ...L()
                ].sort((e, t)=>e - t).map((e, t, r)=>{
                    let n = h(), o = r[t] = n ? r[t - n] : {
                        V: [],
                        M: new Map
                    };
                    o.V.push(e), q.has(e) || z.set(e, o);
                });
                for (let { V: e, M: t } of new Set(z.values())){
                    let r = [];
                    for (let t of e){
                        let e = Z.filter((e)=>e.V.has(t)), n = r.find(({ G: t })=>e.some((e)=>t.has(e)));
                        n || (n = {
                            G: new Set,
                            V: []
                        }, r.push(n)), n.V.push(t), e.forEach((e)=>n.G.add(e));
                    }
                    let n = r.flatMap(({ G: e })=>[
                            ...e
                        ]);
                    for (let { G: e, V: o } of r){
                        let r = new Set(n.filter((t)=>!e.has(t)));
                        for (let e of o)t.set(e, r);
                    }
                }
                let K = new Set, Q = new Set;
                for (let e of Z)for (let t of e.V)(K.has(t) ? Q : K).add(t);
                for (let e of K)z.has(e) || Q.has(e) || z.set(e, 1);
                const X = new Set([
                    ...K,
                    ...B(K)
                ]), J = i(h), Y = function e(t) {
                    let r = c(()=>{
                        let t = i(h).map((e)=>J[e]);
                        if (t.length) return e(t);
                    }).sort((e, t)=>t.Q.size - e.Q.size), n = h(), o = n % 3;
                    n = n / 3 | 0;
                    let s = 1 & n;
                    return n >>= 1, {
                        B: r,
                        V: o,
                        F: s,
                        S: 1 & n,
                        C: 2 & n,
                        Q: new Set(t)
                    };
                }([]);
                class $ extends Array {
                    get is_emoji() {
                        return !0;
                    }
                }
                function ee(e, t = p) {
                    let r = [];
                    ne(e[0]) && r.push("\u25CC");
                    let n = 0, o = e.length;
                    for(let i = 0; i < o; i++){
                        let o = e[i];
                        oe(o) && (r.push(g(e.slice(n, i))), r.push(t(o)), n = i + 1);
                    }
                    return r.push(g(e.slice(n, o))), r.join("");
                }
                function te(e) {
                    return (oe(e) ? "" : `"${ee([
                        e
                    ])}" `) + p(e);
                }
                function re(e) {
                    for(let t = e.lastIndexOf(95); t > 0;)if (95 !== e[--t]) throw new Error("underscore allowed only at start");
                }
                function ne(e) {
                    return H.has(e);
                }
                function oe(e) {
                    return j.has(e);
                }
                function ie(e, t) {
                    let r = 0;
                    return e.split(M).map((e)=>{
                        let n, o = m(e), i = {
                            input: o,
                            offset: r
                        };
                        r += o.length + 1;
                        try {
                            let e, r = i.tokens = de(o, k), s = r.length;
                            if (!s) throw new Error("empty label");
                            {
                                let o = r[0], a = s > 1 || o.is_emoji;
                                if (!a && o.every((e)=>e < 128)) n = o, re(n), function(e) {
                                    if (e.length >= 4 && 45 == e[2] && 45 == e[3]) throw new Error("invalid label extension");
                                }(n), e = "ASCII";
                                else if (a && (i.emoji = !0, o = r.flatMap((e)=>e.is_emoji ? [] : e)), n = r.flatMap((e)=>!t && e.is_emoji ? le(e) : e), re(n), o.length) {
                                    if (H.has(n[0])) throw ue("leading combining mark");
                                    for(let e = 1; e < s; e++){
                                        let t = r[e];
                                        if (!t.is_emoji && H.has(t[0])) throw ue(`emoji + combining mark: "${g(r[e - 1])} + ${ee([
                                            t[0]
                                        ])}"`);
                                    }
                                    !function(e) {
                                        let t = e[0], r = f.get(t);
                                        if (r) throw ue(`leading ${r}`);
                                        let n = e.length, o = -1;
                                        for(let i = 1; i < n; i++){
                                            t = e[i];
                                            let n = f.get(t);
                                            if (n) {
                                                if (o == i) throw ue(`${r} + ${n}`);
                                                o = i + 1, r = n;
                                            }
                                        }
                                        if (o == n) throw ue(`trailing ${r}`);
                                    }(n);
                                    let t = [
                                        ...new Set(o)
                                    ], [i] = function(e) {
                                        let t = Z;
                                        for (let r of e){
                                            let e = t.filter((e)=>e.V.has(r));
                                            if (!e.length) throw t === Z ? ae(r) : ce(t[0], r);
                                            if (t = e, 1 == e.length) break;
                                        }
                                        return t;
                                    }(t);
                                    !function(e, t) {
                                        let { V: r, M: n } = e;
                                        for (let n of t)if (!r.has(n)) throw ce(e, n);
                                        if (n >= 0) {
                                            for(let r = 1, o = B(t).length; r < o; r++)if (H.has(t[r])) {
                                                let i = r + 1;
                                                for(; i < o && H.has(t[i]);)i++;
                                                if (i - r > n) throw new Error(`too many combining marks: ${e.N} "${g(t.slice(r - 1, i))}" (${i - r}/${n})`);
                                                r = i;
                                            }
                                        }
                                    }(i, o), function(e, t) {
                                        let r, n = [];
                                        for (let e of t){
                                            let t = z.get(e);
                                            if (1 === t) return;
                                            if (t) {
                                                let n = t.M.get(e);
                                                if (r = r ? r.filter((e)=>n.has(e)) : [
                                                    ...n
                                                ], !r.length) return;
                                            } else n.push(e);
                                        }
                                        if (r) {
                                            for (let t of r)if (n.every((e)=>t.V.has(e))) throw new Error(`whole-script confusable: ${e.N}/${t.N}`);
                                        }
                                    }(i, t), e = i.N;
                                } else e = "Emoji";
                            }
                            i.type = e;
                        } catch (e) {
                            i.error = e;
                        }
                        return i.output = n, i;
                    });
                }
                function se(e) {
                    return e.map(({ input: t, error: r, output: n })=>{
                        if (r) {
                            let n = r.message;
                            throw new Error(1 == e.length ? n : `Invalid label "${ee(t)}": ${n}`);
                        }
                        return g(n);
                    }).join(M);
                }
                function ae(e) {
                    return new Error(`disallowed character: ${te(e)}`);
                }
                function ce(e, t) {
                    let r = te(t), n = Z.find((e)=>e.P.has(t));
                    return n && (r = `${n.N} ${r}`), new Error(`illegal mixture: ${e.N} + ${r}`);
                }
                function ue(e) {
                    return new Error(`illegal placement: ${e}`);
                }
                function de(e, t) {
                    let r = [], n = [];
                    for(e = e.slice().reverse(); e.length;){
                        let o = he(e);
                        if (o) n.length && (r.push(t(n)), n = []), r.push(o);
                        else {
                            let t = e.pop();
                            if (X.has(t)) n.push(t);
                            else {
                                let e = D.get(t);
                                if (e) n.push(...e);
                                else if (!F.has(t)) throw ae(t);
                            }
                        }
                    }
                    return n.length && r.push(t(n)), r;
                }
                function le(e) {
                    return e.filter((e)=>e != N);
                }
                function he(e, t) {
                    let r, n, o = Y, i = [], s = e.length;
                    for(t && (t.length = 0); s;){
                        let a = e[--s];
                        if (o = o.B.find((e)=>e.Q.has(a)), !o) break;
                        if (o.S) n = a;
                        else if (o.C && a === n) break;
                        i.push(a), o.F && (i.push(N), s > 0 && e[s - 1] == N && s--), o.V && (r = fe(i, o), t && t.push(...e.slice(s).reverse()), e.length = s);
                    }
                    return r;
                }
                function fe(e, t) {
                    let r = $.from(e);
                    return 2 == t.V && r.splice(1, 1), r;
                }
                const pe = "valid", me = "mapped", ge = "ignored";
                function ye(e) {
                    return e == pe || e == me;
                }
                function ve(e) {
                    return e.some((e)=>U.has(e));
                }
                function be(e) {
                    for(let t = 0; t < e.length; t++)if (e[t].type == pe) {
                        let r = t + 1;
                        for(; r < e.length && e[r].type == pe;)r++;
                        e.splice(t, r - t, {
                            type: pe,
                            cps: e.slice(t, r).flatMap((e)=>e.cps)
                        });
                    }
                    return e;
                }
                t.ens_beautify = function(e) {
                    let t = ie(e, !0);
                    for (let { type: e, output: r, error: n } of t)if (!n && "Greek" !== e) {
                        let e = 0;
                        for(;;){
                            let t = r.indexOf(958, e);
                            if (t < 0) break;
                            r[t] = 926, e = t + 1;
                        }
                    }
                    return se(t);
                }, t.ens_emoji = function() {
                    let e = [];
                    return function t(r, n, o) {
                        if (r.S) o = n[n.length - 1];
                        else if (r.C && o === n[n.length - 1]) return;
                        r.F && n.push(N), r.V && e.push(fe(n, r));
                        for (let e of r.B)for (let r of e.Q)t(e, [
                            ...n,
                            r
                        ], o);
                    }(Y, []), e.sort(y);
                }, t.ens_normalize = function(e) {
                    return se(ie(e));
                }, t.ens_normalize_fragment = function(e, t) {
                    let r = t ? B : k;
                    return e.split(M).map((e)=>g(de(m(e), r).flatMap((e)=>e.is_emoji ? le(e) : e))).join(M);
                }, t.ens_split = ie, t.ens_tokenize = function e(t, { nf: r = !0 } = {}) {
                    let n = m(t).reverse(), o = [], i = [];
                    for(; n.length;){
                        let e = he(n, o);
                        if (e) i.push({
                            type: "emoji",
                            emoji: e,
                            input: o.slice(),
                            cps: le(e)
                        });
                        else {
                            let e = n.pop();
                            if (46 == e) i.push({
                                type: "stop",
                                cp: e
                            });
                            else if (X.has(e)) i.push({
                                type: pe,
                                cps: [
                                    e
                                ]
                            });
                            else if (F.has(e)) i.push({
                                type: ge,
                                cp: e
                            });
                            else {
                                let t = D.get(e);
                                t ? i.push({
                                    type: me,
                                    cp: e,
                                    cps: t.slice()
                                }) : i.push({
                                    type: "disallowed",
                                    cp: e
                                });
                            }
                        }
                    }
                    if (r) for(let t = 0, r = -1; t < i.length; t++){
                        let n = i[t];
                        if (ye(n.type)) {
                            if (ve(n.cps)) {
                                let n = t + 1;
                                for(let e = n; e < i.length; e++){
                                    let { type: t, cps: r } = i[e];
                                    if (ye(t)) {
                                        if (!ve(r)) break;
                                        n = e + 1;
                                    } else if (t !== ge) break;
                                }
                                r < 0 && (r = t);
                                let o = i.slice(r, n), s = o.flatMap((e)=>ye(e.type) ? e.cps : []), a = k(s);
                                y(a, s) ? (i.splice(r, n - r, {
                                    type: "nfc",
                                    input: s,
                                    cps: a,
                                    tokens0: be(o),
                                    tokens: e(g(a), {
                                        nf: !1
                                    })
                                }), t = r) : t = n - 1, r = -1;
                            } else r = t;
                        } else n.type !== ge && (r = -1);
                    }
                    return be(i);
                }, t.is_combining_mark = ne, t.nfc = k, t.nfd = B, t.safe_str_from_cps = ee, t.should_escape = oe;
            },
            1732: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.outputSyncingFormatter = t.outputPostFormatter = t.inputPostFormatter = t.outputBlockFormatter = t.outputTransactionReceiptFormatter = t.outputLogFormatter = t.inputLogFormatter = t.inputTopicFormatter = t.outputTransactionFormatter = t.inputSignFormatter = t.inputTransactionFormatter = t.inputCallFormatter = t.txInputOptionsFormatter = t.inputAddressFormatter = t.inputDefaultBlockNumberFormatter = t.inputBlockNumberFormatter = t.outputBigIntegerFormatter = t.outputProofFormatter = t.inputStorageKeysFormatter = void 0;
                const n = r(5071), o = r(9910), i = r(9970), s = r(9634), a = r(7345);
                t.inputStorageKeysFormatter = (e)=>e.map((e)=>(0, s.numberToHex)(e)), t.outputProofFormatter = (e)=>({
                        address: (0, s.toChecksumAddress)(e.address),
                        nonce: (0, s.hexToNumberString)(e.nonce),
                        balance: (0, s.hexToNumberString)(e.balance)
                    }), t.outputBigIntegerFormatter = (e)=>(0, s.toNumber)(e), t.inputBlockNumberFormatter = (e)=>{
                    if (!(0, a.isNullish)(e)) return "string" == typeof e && (0, a.isBlockTag)(e) ? e : "genesis" === e ? "0x0" : "string" == typeof e && (0, s.isHexStrict)(e) ? e.toLowerCase() : (0, s.numberToHex)(e);
                }, t.inputDefaultBlockNumberFormatter = (e, r)=>e ? (0, t.inputBlockNumberFormatter)(e) : (0, t.inputBlockNumberFormatter)(r), t.inputAddressFormatter = (e)=>{
                    if (o.Iban.isValid(e) && o.Iban.isDirect(e)) return new o.Iban(e).toAddress().toLowerCase();
                    if ((0, s.isAddress)(e)) return `0x${e.toLowerCase().replace("0x", "")}`;
                    throw new n.FormatterError(`Provided address ${e} is invalid, the capitalization checksum test failed, or it's an indirect IBAN address which can't be converted.`);
                }, t.txInputOptionsFormatter = (e)=>{
                    var r;
                    const o = Object.assign({}, e);
                    if (e.to && (o.to = (0, t.inputAddressFormatter)(e.to)), e.data && e.input) throw new n.FormatterError('You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.');
                    if (!e.input && e.data && (o.input = e.data, delete o.data), e.input && !e.input.startsWith("0x") && (o.input = `0x${e.input}`), o.input && !(0, s.isHexStrict)(o.input)) throw new n.FormatterError("The input field must be HEX encoded data.");
                    return (e.gas || e.gasLimit) && (o.gas = (0, s.toNumber)(null !== (r = e.gas) && void 0 !== r ? r : e.gasLimit)), (e.maxPriorityFeePerGas || e.maxFeePerGas) && delete o.gasPrice, [
                        "gasPrice",
                        "gas",
                        "value",
                        "maxPriorityFeePerGas",
                        "maxFeePerGas",
                        "nonce",
                        "chainId"
                    ].filter((e)=>!(0, a.isNullish)(o[e])).forEach((e)=>{
                        o[e] = (0, s.numberToHex)(o[e]);
                    }), o;
                }, t.inputCallFormatter = (e, r)=>{
                    var n;
                    const o = (0, t.txInputOptionsFormatter)(e), i = null !== (n = o.from) && void 0 !== n ? n : r;
                    return i && (o.from = (0, t.inputAddressFormatter)(i)), o;
                }, t.inputTransactionFormatter = (e, r)=>{
                    var o;
                    const i = (0, t.txInputOptionsFormatter)(e);
                    if ("number" != typeof i.from && (!i.from || "object" != typeof i.from)) {
                        if (i.from = null !== (o = i.from) && void 0 !== o ? o : r, !e.from && "number" != typeof e.from) throw new n.FormatterError('The send transactions "from" field must be defined!');
                        i.from = (0, t.inputAddressFormatter)(e.from);
                    }
                    return i;
                }, t.inputSignFormatter = (e)=>(0, s.isHexStrict)(e) ? e : (0, s.utf8ToHex)(e), t.outputTransactionFormatter = (e)=>{
                    const r = Object.assign({}, e);
                    return e.blockNumber && (r.blockNumber = (0, s.hexToNumber)(e.blockNumber)), e.transactionIndex && (r.transactionIndex = (0, s.hexToNumber)(e.transactionIndex)), r.nonce = (0, s.hexToNumber)(e.nonce), r.gas = (0, s.hexToNumber)(e.gas), e.gasPrice && (r.gasPrice = (0, t.outputBigIntegerFormatter)(e.gasPrice)), e.maxFeePerGas && (r.maxFeePerGas = (0, t.outputBigIntegerFormatter)(e.maxFeePerGas)), e.maxPriorityFeePerGas && (r.maxPriorityFeePerGas = (0, t.outputBigIntegerFormatter)(e.maxPriorityFeePerGas)), e.type && (r.type = (0, s.hexToNumber)(e.type)), r.value = (0, t.outputBigIntegerFormatter)(e.value), e.to && (0, s.isAddress)(e.to) ? r.to = (0, s.toChecksumAddress)(e.to) : r.to = void 0, e.from && (r.from = (0, s.toChecksumAddress)(e.from)), r;
                }, t.inputTopicFormatter = (e)=>{
                    if ((0, a.isNullish)(e)) return null;
                    const t = String(e);
                    return (0, a.isHex)(t) ? t : (0, s.fromUtf8)(t);
                }, t.inputLogFormatter = (e)=>{
                    var r;
                    const n = (0, a.isNullish)(e) ? {} : (0, s.mergeDeep)({}, e);
                    return (0, a.isNullish)(n.fromBlock) && (n.fromBlock = i.BlockTags.LATEST), n.fromBlock = (0, t.inputBlockNumberFormatter)(n.fromBlock), (0, a.isNullish)(n.toBlock) || (n.toBlock = (0, t.inputBlockNumberFormatter)(n.toBlock)), n.topics = null !== (r = n.topics) && void 0 !== r ? r : [], n.topics = n.topics.map((e)=>Array.isArray(e) ? e.map(t.inputTopicFormatter) : (0, t.inputTopicFormatter)(e)), n.address && (n.address = Array.isArray(n.address) ? n.address.map((e)=>(0, t.inputAddressFormatter)(e)) : (0, t.inputAddressFormatter)(n.address)), n;
                }, t.outputLogFormatter = (e)=>{
                    const t = Object.assign({}, e), r = "string" == typeof e.logIndex ? e.logIndex : (0, s.numberToHex)(e.logIndex);
                    if ("string" == typeof e.blockHash && "string" == typeof e.transactionHash) {
                        const n = (0, s.sha3Raw)(`${e.blockHash.replace("0x", "")}${e.transactionHash.replace("0x", "")}${r.replace("0x", "")}`);
                        t.id = `log_${n.replace("0x", "").slice(0, 8)}`;
                    } else e.id || (t.id = void 0);
                    return e.blockNumber && (0, s.isHexStrict)(e.blockNumber) && (t.blockNumber = (0, s.hexToNumber)(e.blockNumber)), e.transactionIndex && (0, s.isHexStrict)(e.transactionIndex) && (t.transactionIndex = (0, s.hexToNumber)(e.transactionIndex)), e.logIndex && (0, s.isHexStrict)(e.logIndex) && (t.logIndex = (0, s.hexToNumber)(e.logIndex)), e.address && (t.address = (0, s.toChecksumAddress)(e.address)), t;
                }, t.outputTransactionReceiptFormatter = (e)=>{
                    if ("object" != typeof e) throw new n.FormatterError(`Received receipt is invalid: ${String(e)}`);
                    const r = Object.assign({}, e);
                    return e.blockNumber && (r.blockNumber = (0, s.hexToNumber)(e.blockNumber)), e.transactionIndex && (r.transactionIndex = (0, s.hexToNumber)(e.transactionIndex)), r.cumulativeGasUsed = (0, s.hexToNumber)(e.cumulativeGasUsed), r.gasUsed = (0, s.hexToNumber)(e.gasUsed), e.logs && Array.isArray(e.logs) && (r.logs = e.logs.map(t.outputLogFormatter)), e.effectiveGasPrice && (r.effectiveGasPrice = (0, s.hexToNumber)(e.effectiveGasPrice)), e.contractAddress && (r.contractAddress = (0, s.toChecksumAddress)(e.contractAddress)), e.status && (r.status = Boolean(parseInt(e.status, 10))), r;
                }, t.outputBlockFormatter = (e)=>{
                    const r = Object.assign({}, e);
                    return r.gasLimit = (0, s.hexToNumber)(e.gasLimit), r.gasUsed = (0, s.hexToNumber)(e.gasUsed), r.size = (0, s.hexToNumber)(e.size), r.timestamp = (0, s.hexToNumber)(e.timestamp), e.number && (r.number = (0, s.hexToNumber)(e.number)), e.difficulty && (r.difficulty = (0, t.outputBigIntegerFormatter)(e.difficulty)), e.totalDifficulty && (r.totalDifficulty = (0, t.outputBigIntegerFormatter)(e.totalDifficulty)), e.transactions && Array.isArray(e.transactions) && (r.transactions = e.transactions.map(t.outputTransactionFormatter)), e.miner && (r.miner = (0, s.toChecksumAddress)(e.miner)), e.baseFeePerGas && (r.baseFeePerGas = (0, t.outputBigIntegerFormatter)(e.baseFeePerGas)), r;
                }, t.inputPostFormatter = (e)=>{
                    var t;
                    const r = Object.assign({}, e);
                    return e.ttl && (r.ttl = (0, s.numberToHex)(e.ttl)), e.workToProve && (r.workToProve = (0, s.numberToHex)(e.workToProve)), e.priority && (r.priority = (0, s.numberToHex)(e.priority)), e.topics && !Array.isArray(e.topics) && (r.topics = e.topics ? [
                        e.topics
                    ] : []), r.topics = null === (t = r.topics) || void 0 === t ? void 0 : t.map((e)=>e.startsWith("0x") ? e : (0, s.fromUtf8)(e)), r;
                }, t.outputPostFormatter = (e)=>{
                    var t;
                    const r = Object.assign({}, e);
                    return e.expiry && (r.expiry = (0, s.hexToNumber)(e.expiry)), e.sent && (r.sent = (0, s.hexToNumber)(e.sent)), e.ttl && (r.ttl = (0, s.hexToNumber)(e.ttl)), e.workProved && (r.workProved = (0, s.hexToNumber)(e.workProved)), e.topics || (r.topics = []), r.topics = null === (t = r.topics) || void 0 === t ? void 0 : t.map(s.toUtf8), r;
                }, t.outputSyncingFormatter = (e)=>{
                    const t = Object.assign({}, e);
                    return t.startingBlock = (0, s.hexToNumber)(e.startingBlock), t.currentBlock = (0, s.hexToNumber)(e.currentBlock), t.highestBlock = (0, s.hexToNumber)(e.highestBlock), e.knownStates && (t.knownStates = (0, s.hexToNumber)(e.knownStates)), e.pulledStates && (t.pulledStates = (0, s.hexToNumber)(e.pulledStates)), t;
                };
            },
            6527: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }, s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formatters = void 0, i(r(6171), t), i(r(8441), t), i(r(860), t), i(r(1819), t), i(r(8174), t), i(r(8202), t), i(r(7003), t), i(r(8165), t), i(r(1732), t), i(r(4738), t), i(r(8976), t), t.formatters = s(r(1732));
            },
            8165: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            7003: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isSupportSubscriptions = t.isSupportedProvider = t.isLegacySendAsyncProvider = t.isLegacySendProvider = t.isEIP1193Provider = t.isLegacyRequestProvider = t.isMetaMaskProvider = t.isWeb3Provider = void 0;
                const n = r(9970);
                t.isWeb3Provider = (e)=>n.Web3BaseProvider.isWeb3Provider(e), t.isMetaMaskProvider = (e)=>"string" != typeof e && "request" in e && "AsyncFunction" === e.request.constructor.name && "isMetaMask" in e && e.isMetaMask, t.isLegacyRequestProvider = (e)=>"string" != typeof e && "request" in e && "Function" === e.request.constructor.name, t.isEIP1193Provider = (e)=>"string" != typeof e && "request" in e && "AsyncFunction" === e.request.constructor.name, t.isLegacySendProvider = (e)=>"string" != typeof e && "send" in e, t.isLegacySendAsyncProvider = (e)=>"string" != typeof e && "sendAsync" in e, t.isSupportedProvider = (e)=>e && ((0, t.isWeb3Provider)(e) || (0, t.isEIP1193Provider)(e) || (0, t.isLegacyRequestProvider)(e) || (0, t.isLegacySendAsyncProvider)(e) || (0, t.isLegacySendProvider)(e)), t.isSupportSubscriptions = (e)=>e && "supportsSubscriptions" in e ? e.supportsSubscriptions() : !(!e || "string" == typeof e || !("on" in e));
            },
            8202: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3BatchRequest = t.DEFAULT_BATCH_REQUEST_TIMEOUT = void 0;
                const o = r(9634), i = r(5071);
                t.DEFAULT_BATCH_REQUEST_TIMEOUT = 1e3, t.Web3BatchRequest = class {
                    constructor(e){
                        this._requestManager = e, this._requests = new Map;
                    }
                    get requests() {
                        return [
                            ...this._requests.values()
                        ].map((e)=>e.payload);
                    }
                    add(e) {
                        const t = o.jsonRpc.toPayload(e), r = new o.Web3DeferredPromise;
                        return this._requests.set(t.id, {
                            payload: t,
                            promise: r
                        }), r;
                    }
                    execute(e) {
                        var r;
                        return n(this, void 0, void 0, function*() {
                            if (0 === this.requests.length) return Promise.resolve([]);
                            const n = new o.Web3DeferredPromise({
                                timeout: null !== (r = null == e ? void 0 : e.timeout) && void 0 !== r ? r : t.DEFAULT_BATCH_REQUEST_TIMEOUT,
                                eagerStart: !0,
                                timeoutMessage: "Batch request timeout"
                            });
                            return this._processBatchRequest(n).catch((e)=>n.reject(e)), n.catch((e)=>{
                                e instanceof i.OperationTimeoutError && this._abortAllRequests("Batch request timeout"), n.reject(e);
                            }), n;
                        });
                    }
                    _processBatchRequest(e) {
                        var t, r;
                        return n(this, void 0, void 0, function*() {
                            const n = yield this._requestManager.sendBatch([
                                ...this._requests.values()
                            ].map((e)=>e.payload));
                            if (n.length !== this._requests.size) throw this._abortAllRequests("Invalid batch response"), new i.ResponseError(n, `Batch request size mismatch the results size. Requests: ${this._requests.size}, Responses: ${n.length}`);
                            const s = this.requests.map((e)=>e.id).map(Number).sort((e, t)=>e - t), a = n.map((e)=>e.id).map(Number).sort((e, t)=>e - t);
                            if (JSON.stringify(s) !== JSON.stringify(a)) throw this._abortAllRequests("Invalid batch response"), new i.ResponseError(n, `Batch request mismatch the results. Requests: [${s.join()}], Responses: [${a.join()}]`);
                            for (const e of n)o.jsonRpc.isResponseWithResult(e) ? null === (t = this._requests.get(e.id)) || void 0 === t || t.promise.resolve(e.result) : o.jsonRpc.isResponseWithError(e) && (null === (r = this._requests.get(e.id)) || void 0 === r || r.promise.reject(e.error));
                            e.resolve(n);
                        });
                    }
                    _abortAllRequests(e) {
                        for (const { promise: t } of this._requests.values())t.reject(new i.OperationAbortError(e));
                    }
                };
            },
            6171: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Config = t.Web3ConfigEvent = void 0;
                const n = r(9970), o = r(5071), i = r(9634), s = r(8976);
                var a;
                !function(e) {
                    e.CONFIG_CHANGE = "CONFIG_CHANGE";
                }(a = t.Web3ConfigEvent || (t.Web3ConfigEvent = {}));
                class c extends s.Web3EventEmitter {
                    constructor(e){
                        super(), this.config = {
                            handleRevert: !1,
                            defaultAccount: void 0,
                            defaultBlock: "latest",
                            transactionBlockTimeout: 50,
                            transactionConfirmationBlocks: 24,
                            transactionPollingInterval: 1e3,
                            transactionPollingTimeout: 75e4,
                            transactionReceiptPollingInterval: void 0,
                            transactionSendTimeout: 75e4,
                            transactionConfirmationPollingInterval: void 0,
                            blockHeaderTimeout: 10,
                            maxListenersWarningThreshold: 100,
                            contractDataInputFill: "data",
                            defaultNetworkId: void 0,
                            defaultChain: "mainnet",
                            defaultHardfork: "london",
                            defaultCommon: void 0,
                            defaultTransactionType: "0x2",
                            defaultMaxPriorityFeePerGas: (0, i.toHex)(25e8),
                            enableExperimentalFeatures: {
                                useSubscriptionWhenCheckingBlockTimeout: !1,
                                useRpcCallSpecification: !1
                            },
                            transactionBuilder: void 0,
                            transactionTypeParser: void 0,
                            defaultReturnFormat: n.DEFAULT_RETURN_FORMAT
                        }, this.setConfig(null != e ? e : {});
                    }
                    setConfig(e) {
                        const t = Object.keys(e);
                        for (const r of t)this._triggerConfigChange(r, e[r]);
                        Object.assign(this.config, e);
                    }
                    get handleRevert() {
                        return this.config.handleRevert;
                    }
                    set handleRevert(e) {
                        this._triggerConfigChange("handleRevert", e), this.config.handleRevert = e;
                    }
                    get contractDataInputFill() {
                        return this.config.contractDataInputFill;
                    }
                    set contractDataInputFill(e) {
                        this._triggerConfigChange("contractDataInputFill", e), this.config.contractDataInputFill = e;
                    }
                    get defaultAccount() {
                        return this.config.defaultAccount;
                    }
                    set defaultAccount(e) {
                        this._triggerConfigChange("defaultAccount", e), this.config.defaultAccount = e;
                    }
                    get defaultBlock() {
                        return this.config.defaultBlock;
                    }
                    set defaultBlock(e) {
                        this._triggerConfigChange("defaultBlock", e), this.config.defaultBlock = e;
                    }
                    get transactionSendTimeout() {
                        return this.config.transactionSendTimeout;
                    }
                    set transactionSendTimeout(e) {
                        this._triggerConfigChange("transactionSendTimeout", e), this.config.transactionSendTimeout = e;
                    }
                    get transactionBlockTimeout() {
                        return this.config.transactionBlockTimeout;
                    }
                    set transactionBlockTimeout(e) {
                        this._triggerConfigChange("transactionBlockTimeout", e), this.config.transactionBlockTimeout = e;
                    }
                    get transactionConfirmationBlocks() {
                        return this.config.transactionConfirmationBlocks;
                    }
                    set transactionConfirmationBlocks(e) {
                        this._triggerConfigChange("transactionConfirmationBlocks", e), this.config.transactionConfirmationBlocks = e;
                    }
                    get transactionPollingInterval() {
                        return this.config.transactionPollingInterval;
                    }
                    set transactionPollingInterval(e) {
                        this._triggerConfigChange("transactionPollingInterval", e), this.config.transactionPollingInterval = e, this.transactionReceiptPollingInterval = e, this.transactionConfirmationPollingInterval = e;
                    }
                    get transactionPollingTimeout() {
                        return this.config.transactionPollingTimeout;
                    }
                    set transactionPollingTimeout(e) {
                        this._triggerConfigChange("transactionPollingTimeout", e), this.config.transactionPollingTimeout = e;
                    }
                    get transactionReceiptPollingInterval() {
                        return this.config.transactionReceiptPollingInterval;
                    }
                    set transactionReceiptPollingInterval(e) {
                        this._triggerConfigChange("transactionReceiptPollingInterval", e), this.config.transactionReceiptPollingInterval = e;
                    }
                    get transactionConfirmationPollingInterval() {
                        return this.config.transactionConfirmationPollingInterval;
                    }
                    set transactionConfirmationPollingInterval(e) {
                        this._triggerConfigChange("transactionConfirmationPollingInterval", e), this.config.transactionConfirmationPollingInterval = e;
                    }
                    get blockHeaderTimeout() {
                        return this.config.blockHeaderTimeout;
                    }
                    set blockHeaderTimeout(e) {
                        this._triggerConfigChange("blockHeaderTimeout", e), this.config.blockHeaderTimeout = e;
                    }
                    get enableExperimentalFeatures() {
                        return this.config.enableExperimentalFeatures;
                    }
                    set enableExperimentalFeatures(e) {
                        this._triggerConfigChange("enableExperimentalFeatures", e), this.config.enableExperimentalFeatures = e;
                    }
                    get maxListenersWarningThreshold() {
                        return this.config.maxListenersWarningThreshold;
                    }
                    set maxListenersWarningThreshold(e) {
                        this._triggerConfigChange("maxListenersWarningThreshold", e), this.setMaxListenerWarningThreshold(e), this.config.maxListenersWarningThreshold = e;
                    }
                    get defaultReturnFormat() {
                        return this.config.defaultReturnFormat;
                    }
                    set defaultReturnFormat(e) {
                        this._triggerConfigChange("defaultReturnFormat", e), this.config.defaultReturnFormat = e;
                    }
                    get defaultNetworkId() {
                        return this.config.defaultNetworkId;
                    }
                    set defaultNetworkId(e) {
                        this._triggerConfigChange("defaultNetworkId", e), this.config.defaultNetworkId = e;
                    }
                    get defaultChain() {
                        return this.config.defaultChain;
                    }
                    set defaultChain(e) {
                        if (!(0, i.isNullish)(this.config.defaultCommon) && !(0, i.isNullish)(this.config.defaultCommon.baseChain) && e !== this.config.defaultCommon.baseChain) throw new o.ConfigChainMismatchError(this.config.defaultChain, e);
                        this._triggerConfigChange("defaultChain", e), this.config.defaultChain = e;
                    }
                    get defaultHardfork() {
                        return this.config.defaultHardfork;
                    }
                    set defaultHardfork(e) {
                        if (!(0, i.isNullish)(this.config.defaultCommon) && !(0, i.isNullish)(this.config.defaultCommon.hardfork) && e !== this.config.defaultCommon.hardfork) throw new o.ConfigHardforkMismatchError(this.config.defaultCommon.hardfork, e);
                        this._triggerConfigChange("defaultHardfork", e), this.config.defaultHardfork = e;
                    }
                    get defaultCommon() {
                        return this.config.defaultCommon;
                    }
                    set defaultCommon(e) {
                        if (!(0, i.isNullish)(this.config.defaultHardfork) && !(0, i.isNullish)(e) && !(0, i.isNullish)(e.hardfork) && this.config.defaultHardfork !== e.hardfork) throw new o.ConfigHardforkMismatchError(this.config.defaultHardfork, e.hardfork);
                        if (!(0, i.isNullish)(this.config.defaultChain) && !(0, i.isNullish)(e) && !(0, i.isNullish)(e.baseChain) && this.config.defaultChain !== e.baseChain) throw new o.ConfigChainMismatchError(this.config.defaultChain, e.baseChain);
                        this._triggerConfigChange("defaultCommon", e), this.config.defaultCommon = e;
                    }
                    get defaultTransactionType() {
                        return this.config.defaultTransactionType;
                    }
                    set defaultTransactionType(e) {
                        this._triggerConfigChange("defaultTransactionType", e), this.config.defaultTransactionType = e;
                    }
                    get defaultMaxPriorityFeePerGas() {
                        return this.config.defaultMaxPriorityFeePerGas;
                    }
                    set defaultMaxPriorityFeePerGas(e) {
                        this._triggerConfigChange("defaultMaxPriorityFeePerGas", e), this.config.defaultMaxPriorityFeePerGas = e;
                    }
                    get transactionBuilder() {
                        return this.config.transactionBuilder;
                    }
                    set transactionBuilder(e) {
                        this._triggerConfigChange("transactionBuilder", e), this.config.transactionBuilder = e;
                    }
                    get transactionTypeParser() {
                        return this.config.transactionTypeParser;
                    }
                    set transactionTypeParser(e) {
                        this._triggerConfigChange("transactionTypeParser", e), this.config.transactionTypeParser = e;
                    }
                    _triggerConfigChange(e, t) {
                        this.emit(a.CONFIG_CHANGE, {
                            name: e,
                            oldValue: this.config[e],
                            newValue: t
                        });
                    }
                }
                t.Web3Config = c;
            },
            8174: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3EthPluginBase = t.Web3PluginBase = t.Web3Context = void 0;
                const o = r(5071), i = r(9634), s = r(9247), a = r(7003), c = r(8202), u = r(6171), d = r(8441), l = r(860);
                class h extends u.Web3Config {
                    constructor(e){
                        var t;
                        if (super(), this.providers = d.Web3RequestManager.providers, (0, i.isNullish)(e) || "string" == typeof e && "" !== e.trim() || (0, a.isSupportedProvider)(e)) return this._requestManager = new d.Web3RequestManager(e), void (this._subscriptionManager = new l.Web3SubscriptionManager(this._requestManager, {}));
                        const { config: r, provider: n, requestManager: o, subscriptionManager: s, registeredSubscriptions: c, accountProvider: u, wallet: h, requestManagerMiddleware: f } = e;
                        this.setConfig(null != r ? r : {}), this._requestManager = null != o ? o : new d.Web3RequestManager(n, null === (t = null == r ? void 0 : r.enableExperimentalFeatures) || void 0 === t ? void 0 : t.useSubscriptionWhenCheckingBlockTimeout, f), this._subscriptionManager = s || new l.Web3SubscriptionManager(this.requestManager, null != c ? c : {}), u && (this._accountProvider = u), h && (this._wallet = h);
                    }
                    get requestManager() {
                        return this._requestManager;
                    }
                    get subscriptionManager() {
                        return this._subscriptionManager;
                    }
                    get wallet() {
                        return this._wallet;
                    }
                    get accountProvider() {
                        return this._accountProvider;
                    }
                    static fromContextObject(...e) {
                        return new this(...e.reverse());
                    }
                    getContextObject() {
                        var e;
                        return {
                            config: this.config,
                            provider: this.provider,
                            requestManager: this.requestManager,
                            subscriptionManager: this.subscriptionManager,
                            registeredSubscriptions: null === (e = this.subscriptionManager) || void 0 === e ? void 0 : e.registeredSubscriptions,
                            providers: this.providers,
                            wallet: this.wallet,
                            accountProvider: this.accountProvider
                        };
                    }
                    use(e, ...t) {
                        const r = new e(...[
                            ...t,
                            this.getContextObject()
                        ]);
                        return this.on(u.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            r.setConfig({
                                [e.name]: e.newValue
                            });
                        }), this[e.name] = r, r;
                    }
                    link(e) {
                        this.setConfig(e.config), this._requestManager = e.requestManager, this.provider = e.provider, this._subscriptionManager = e.subscriptionManager, this._wallet = e.wallet, this._accountProvider = e._accountProvider, e.on(u.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            this.setConfig({
                                [e.name]: e.newValue
                            });
                        });
                    }
                    registerPlugin(e) {
                        if (void 0 !== this[e.pluginNamespace]) throw new o.ExistingPluginNamespaceError(e.pluginNamespace);
                        const t = {
                            [e.pluginNamespace]: e
                        };
                        t[e.pluginNamespace].link(this), Object.assign(this, t);
                    }
                    get provider() {
                        return this.currentProvider;
                    }
                    set provider(e) {
                        this.requestManager.setProvider(e);
                    }
                    get currentProvider() {
                        return this.requestManager.provider;
                    }
                    set currentProvider(e) {
                        this.requestManager.setProvider(e);
                    }
                    get givenProvider() {
                        return h.givenProvider;
                    }
                    setProvider(e) {
                        return this.provider = e, !0;
                    }
                    setRequestManagerMiddleware(e) {
                        this.requestManager.setMiddleware(e);
                    }
                    get BatchRequest() {
                        return c.Web3BatchRequest.bind(void 0, this._requestManager);
                    }
                    extend(e) {
                        var t;
                        return e.property && !this[e.property] && (this[e.property] = {}), null === (t = e.methods) || void 0 === t || t.forEach((t)=>{
                            const r = (...e)=>n(this, void 0, void 0, function*() {
                                    return this.requestManager.send({
                                        method: t.call,
                                        params: e
                                    });
                                });
                            e.property ? this[e.property][t.name] = r : this[t.name] = r;
                        }), this;
                    }
                }
                t.Web3Context = h, h.providers = d.Web3RequestManager.providers;
                class f extends h {
                    registerNewTransactionType(e, t) {
                        s.TransactionFactory.registerTransactionType(e, t);
                    }
                }
                t.Web3PluginBase = f, t.Web3EthPluginBase = class extends f {
                };
            },
            8976: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3EventEmitter = void 0;
                const n = r(9634);
                t.Web3EventEmitter = class {
                    constructor(){
                        this._emitter = new n.EventEmitter;
                    }
                    on(e, t) {
                        this._emitter.on(e, t);
                    }
                    once(e, t) {
                        this._emitter.once(e, t);
                    }
                    off(e, t) {
                        this._emitter.off(e, t);
                    }
                    emit(e, t) {
                        this._emitter.emit(e, t);
                    }
                    listenerCount(e) {
                        return this._emitter.listenerCount(e);
                    }
                    listeners(e) {
                        return this._emitter.listeners(e);
                    }
                    eventNames() {
                        return this._emitter.eventNames();
                    }
                    removeAllListeners() {
                        return this._emitter.removeAllListeners();
                    }
                    setMaxListenerWarningThreshold(e) {
                        this._emitter.setMaxListeners(e);
                    }
                    getMaxListeners() {
                        return this._emitter.getMaxListeners();
                    }
                };
            },
            4738: function(e, t, r) {
                "use strict";
                var n, o = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3PromiEvent = void 0;
                const i = r(8976);
                class s extends i.Web3EventEmitter {
                    constructor(e){
                        super(), this[n] = "Promise", this._promise = new Promise(e);
                    }
                    then(e, t) {
                        return o(this, void 0, void 0, function*() {
                            return this._promise.then(e, t);
                        });
                    }
                    catch(e) {
                        return o(this, void 0, void 0, function*() {
                            return this._promise.catch(e);
                        });
                    }
                    finally(e) {
                        return o(this, void 0, void 0, function*() {
                            return this._promise.finally(e);
                        });
                    }
                    on(e, t) {
                        return super.on(e, t), this;
                    }
                    once(e, t) {
                        return super.once(e, t), this;
                    }
                }
                t.Web3PromiEvent = s, n = Symbol.toStringTag;
            },
            8441: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                }, o = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3RequestManager = t.Web3RequestManagerEvent = void 0;
                const i = r(5071), s = o(r(2636)), a = o(r(1161)), c = r(9634), u = r(7003), d = r(8976);
                var l;
                !function(e) {
                    e.PROVIDER_CHANGED = "PROVIDER_CHANGED", e.BEFORE_PROVIDER_CHANGE = "BEFORE_PROVIDER_CHANGE";
                }(l = t.Web3RequestManagerEvent || (t.Web3RequestManagerEvent = {}));
                const h = {
                    HttpProvider: s.default,
                    WebsocketProvider: a.default
                };
                class f extends d.Web3EventEmitter {
                    constructor(e, t, r){
                        super(), (0, c.isNullish)(e) || this.setProvider(e), this.useRpcCallSpecification = t, (0, c.isNullish)(r) || (this.middleware = r);
                    }
                    static get providers() {
                        return h;
                    }
                    get provider() {
                        return this._provider;
                    }
                    get providers() {
                        return h;
                    }
                    setProvider(e) {
                        let t;
                        if (e && "string" == typeof e && this.providers) {
                            if (/^http(s)?:\/\//i.test(e)) t = new this.providers.HttpProvider(e);
                            else {
                                if (!/^ws(s)?:\/\//i.test(e)) throw new i.ProviderError(`Can't autodetect provider for "${e}"`);
                                t = new this.providers.WebsocketProvider(e);
                            }
                        } else t = (0, c.isNullish)(e) ? void 0 : e;
                        return this.emit(l.BEFORE_PROVIDER_CHANGE, this._provider), this._provider = t, this.emit(l.PROVIDER_CHANGED, this._provider), !0;
                    }
                    setMiddleware(e) {
                        this.middleware = e;
                    }
                    send(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = Object.assign({}, e);
                            let r = yield this._sendRequest(t);
                            if ((0, c.isNullish)(this.middleware) || (r = yield this.middleware.processResponse(r)), c.jsonRpc.isResponseWithResult(r)) return r.result;
                            throw new i.ResponseError(r);
                        });
                    }
                    sendBatch(e) {
                        return n(this, void 0, void 0, function*() {
                            return yield this._sendRequest(e);
                        });
                    }
                    _sendRequest(e) {
                        return n(this, void 0, void 0, function*() {
                            const { provider: t } = this;
                            if ((0, c.isNullish)(t)) throw new i.ProviderError("Provider not available. Use `.setProvider` or `.provider=` to initialize the provider.");
                            let r = c.jsonRpc.isBatchRequest(e) ? c.jsonRpc.toBatchPayload(e) : c.jsonRpc.toPayload(e);
                            if ((0, c.isNullish)(this.middleware) || (r = yield this.middleware.processRequest(r)), (0, u.isWeb3Provider)(t)) {
                                let e;
                                try {
                                    e = yield t.request(r);
                                } catch (t) {
                                    e = t;
                                }
                                return this._processJsonRpcResponse(r, e, {
                                    legacy: !1,
                                    error: !1
                                });
                            }
                            if ((0, u.isEIP1193Provider)(t)) return t.request(r).then((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !1
                                })).catch((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !0
                                }));
                            if ((0, u.isLegacyRequestProvider)(t)) return new Promise((e, n)=>{
                                const o = (e)=>{
                                    n(this._processJsonRpcResponse(r, e, {
                                        legacy: !0,
                                        error: !0
                                    }));
                                }, i = (t)=>e(this._processJsonRpcResponse(r, t, {
                                        legacy: !0,
                                        error: !1
                                    })), s = t.request(r, (e, t)=>e ? o(e) : i(t));
                                (0, c.isPromise)(s) && s.then(i).catch((e)=>{
                                    try {
                                        const t = this._processJsonRpcResponse(r, e, {
                                            legacy: !0,
                                            error: !0
                                        });
                                        n(t);
                                    } catch (e) {
                                        n(e);
                                    }
                                });
                            });
                            if ((0, u.isLegacySendProvider)(t)) return new Promise((e, n)=>{
                                t.send(r, (t, o)=>{
                                    if (t) return n(this._processJsonRpcResponse(r, t, {
                                        legacy: !0,
                                        error: !0
                                    }));
                                    if ((0, c.isNullish)(o)) throw new i.ResponseError({}, 'Got a "nullish" response from provider.');
                                    return e(this._processJsonRpcResponse(r, o, {
                                        legacy: !0,
                                        error: !1
                                    }));
                                });
                            });
                            if ((0, u.isLegacySendAsyncProvider)(t)) return t.sendAsync(r).then((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !1
                                })).catch((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !0
                                }));
                            throw new i.ProviderError("Provider does not have a request or send method to use.");
                        });
                    }
                    _processJsonRpcResponse(e, t, { legacy: r, error: n }) {
                        if ((0, c.isNullish)(t)) return this._buildResponse(e, null, n);
                        if (c.jsonRpc.isResponseWithError(t)) {
                            if (this.useRpcCallSpecification && (0, c.isResponseRpcError)(t)) {
                                const e = t;
                                if (i.rpcErrorsMap.get(e.error.code)) throw new (i.rpcErrorsMap.get(e.error.code)).error(e);
                                throw new i.RpcError(e);
                            }
                            if (!f._isReverted(t)) throw new i.InvalidResponseError(t, e);
                        }
                        if (c.jsonRpc.isResponseWithResult(t)) return t;
                        if (t instanceof Error) throw f._isReverted(t), t;
                        if (!r && c.jsonRpc.isBatchRequest(e) && c.jsonRpc.isBatchResponse(t)) return t;
                        if (r && !n && c.jsonRpc.isBatchRequest(e)) return t;
                        if (r && n && c.jsonRpc.isBatchRequest(e)) throw t;
                        if (r && !c.jsonRpc.isResponseWithError(t) && !c.jsonRpc.isResponseWithResult(t)) return this._buildResponse(e, t, n);
                        if (c.jsonRpc.isBatchRequest(e) && !Array.isArray(t)) throw new i.ResponseError(t, "Got normal response for a batch request.");
                        if (!c.jsonRpc.isBatchRequest(e) && Array.isArray(t)) throw new i.ResponseError(t, "Got batch response for a normal request.");
                        throw new i.ResponseError(t, "Invalid response");
                    }
                    static _isReverted(e) {
                        let t;
                        if (c.jsonRpc.isResponseWithError(e) ? t = e.error : e instanceof Error && (t = e), null == t ? void 0 : t.message.includes("revert")) throw new i.ContractExecutionError(t);
                        return !1;
                    }
                    _buildResponse(e, t, r) {
                        const n = {
                            jsonrpc: "2.0",
                            id: c.jsonRpc.isBatchRequest(e) ? e[0].id : "id" in e ? e.id : null
                        };
                        return r ? Object.assign(Object.assign({}, n), {
                            error: t
                        }) : Object.assign(Object.assign({}, n), {
                            result: t
                        });
                    }
                }
                t.Web3RequestManager = f;
            },
            860: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3SubscriptionManager = void 0;
                const o = r(9970), i = r(5071), s = r(9634), a = r(7003), c = r(8441);
                t.Web3SubscriptionManager = class {
                    constructor(e, t, r = !1){
                        this.requestManager = e, this.registeredSubscriptions = t, this.tolerateUnlinkedSubscription = r, this._subscriptions = new Map, this.requestManager.on(c.Web3RequestManagerEvent.BEFORE_PROVIDER_CHANGE, ()=>n(this, void 0, void 0, function*() {
                                yield this.unsubscribe();
                            })), this.requestManager.on(c.Web3RequestManagerEvent.PROVIDER_CHANGED, ()=>{
                            this.clear(), this.listenToProviderEvents();
                        }), this.listenToProviderEvents();
                    }
                    listenToProviderEvents() {
                        const e = this.requestManager.provider;
                        this.requestManager.provider && ("function" != typeof (null == e ? void 0 : e.supportsSubscriptions) || (null == e ? void 0 : e.supportsSubscriptions())) && "function" == typeof this.requestManager.provider.on && ("function" == typeof this.requestManager.provider.request ? this.requestManager.provider.on("message", (e)=>this.messageListener(e)) : e.on("data", (e)=>this.messageListener(e)));
                    }
                    messageListener(e) {
                        var t, r, n;
                        if (!e) throw new i.SubscriptionError("Should not call messageListener with no data. Type was");
                        const o = (null === (t = e.params) || void 0 === t ? void 0 : t.subscription) || (null === (r = e.data) || void 0 === r ? void 0 : r.subscription) || (null === (n = e.id) || void 0 === n ? void 0 : n.toString(16));
                        if (o) {
                            const t = this._subscriptions.get(o);
                            null == t || t.processSubscriptionData(e);
                        }
                    }
                    subscribe(e, t, r = o.DEFAULT_RETURN_FORMAT) {
                        return n(this, void 0, void 0, function*() {
                            const n = this.registeredSubscriptions[e];
                            if (!n) throw new i.SubscriptionError("Invalid subscription type");
                            const o = new n(null != t ? t : void 0, {
                                subscriptionManager: this,
                                returnFormat: r
                            });
                            return yield this.addSubscription(o), o;
                        });
                    }
                    get subscriptions() {
                        return this._subscriptions;
                    }
                    addSubscription(e) {
                        return n(this, void 0, void 0, function*() {
                            if (!this.requestManager.provider) throw new i.ProviderError("Provider not available");
                            if (!this.supportsSubscriptions()) throw new i.SubscriptionError("The current provider does not support subscriptions");
                            if (e.id && this._subscriptions.has(e.id)) throw new i.SubscriptionError(`Subscription with id "${e.id}" already exists`);
                            if (yield e.sendSubscriptionRequest(), (0, s.isNullish)(e.id)) throw new i.SubscriptionError("Subscription is not subscribed yet.");
                            return this._subscriptions.set(e.id, e), e.id;
                        });
                    }
                    removeSubscription(e) {
                        return n(this, void 0, void 0, function*() {
                            const { id: t } = e;
                            if ((0, s.isNullish)(t)) throw new i.SubscriptionError("Subscription is not subscribed yet. Or, had already been unsubscribed but not through the Subscription Manager.");
                            if (!this._subscriptions.has(t) && !this.tolerateUnlinkedSubscription) throw new i.SubscriptionError(`Subscription with id "${t.toString()}" does not exists`);
                            return yield e.sendUnsubscribeRequest(), this._subscriptions.delete(t), t;
                        });
                    }
                    unsubscribe(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = [];
                            for (const [r, n] of this.subscriptions.entries())(!e || "function" == typeof e && e({
                                id: r,
                                sub: n
                            })) && t.push(this.removeSubscription(n));
                            return Promise.all(t);
                        });
                    }
                    clear() {
                        this._subscriptions.clear();
                    }
                    supportsSubscriptions() {
                        return !(0, s.isNullish)(this.requestManager.provider) && (0, a.isSupportSubscriptions)(this.requestManager.provider);
                    }
                };
            },
            1819: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Subscription = void 0;
                const o = r(9970), i = r(9634), s = r(860), a = r(8976);
                class c extends a.Web3EventEmitter {
                    constructor(e, t){
                        var r;
                        super(), this.args = e;
                        const { requestManager: n } = t, { subscriptionManager: i } = t;
                        this._subscriptionManager = n ? new s.Web3SubscriptionManager(n, {}, !0) : i, this._returnFormat = null !== (r = null == t ? void 0 : t.returnFormat) && void 0 !== r ? r : o.DEFAULT_RETURN_FORMAT;
                    }
                    get id() {
                        return this._id;
                    }
                    get lastBlock() {
                        return this._lastBlock;
                    }
                    subscribe() {
                        return n(this, void 0, void 0, function*() {
                            return this._subscriptionManager.addSubscription(this);
                        });
                    }
                    processSubscriptionData(e) {
                        var t, r;
                        (null == e ? void 0 : e.data) ? this._processSubscriptionResult(null !== (r = null === (t = null == e ? void 0 : e.data) || void 0 === t ? void 0 : t.result) && void 0 !== r ? r : null == e ? void 0 : e.data) : e && i.jsonRpc.isResponseWithNotification(e) && this._processSubscriptionResult(null == e ? void 0 : e.params.result);
                    }
                    sendSubscriptionRequest() {
                        return n(this, void 0, void 0, function*() {
                            return this._id = yield this._subscriptionManager.requestManager.send({
                                method: "eth_subscribe",
                                params: this._buildSubscriptionParams()
                            }), this.emit("connected", this._id), this._id;
                        });
                    }
                    get returnFormat() {
                        return this._returnFormat;
                    }
                    get subscriptionManager() {
                        return this._subscriptionManager;
                    }
                    resubscribe() {
                        return n(this, void 0, void 0, function*() {
                            yield this.unsubscribe(), yield this.subscribe();
                        });
                    }
                    unsubscribe() {
                        return n(this, void 0, void 0, function*() {
                            this.id && (yield this._subscriptionManager.removeSubscription(this));
                        });
                    }
                    sendUnsubscribeRequest() {
                        return n(this, void 0, void 0, function*() {
                            yield this._subscriptionManager.requestManager.send({
                                method: "eth_unsubscribe",
                                params: [
                                    this.id
                                ]
                            }), this._id = void 0;
                        });
                    }
                    formatSubscriptionResult(e) {
                        return e;
                    }
                    _processSubscriptionResult(e) {
                        this.emit("data", this.formatSubscriptionResult(e));
                    }
                    _processSubscriptionError(e) {
                        this.emit("error", e);
                    }
                    _buildSubscriptionParams() {
                        throw new Error("Implement in the child class");
                    }
                }
                t.Web3Subscription = c;
            },
            7639: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ERR_TX_POLLING_TIMEOUT = t.ERR_TX_DATA_AND_INPUT = t.ERR_TX_UNSUPPORTED_TYPE = t.ERR_TX_UNSUPPORTED_EIP_1559 = t.ERR_TX_UNABLE_TO_POPULATE_NONCE = t.ERR_TX_INVALID_NONCE_OR_CHAIN_ID = t.ERR_TX_INVALID_OBJECT = t.ERR_TX_INVALID_LEGACY_FEE_MARKET = t.ERR_TX_INVALID_FEE_MARKET_GAS_PRICE = t.ERR_TX_INVALID_FEE_MARKET_GAS = t.ERR_TX_INVALID_LEGACY_GAS = t.ERR_TX_MISSING_GAS = t.ERR_TX_MISSING_CHAIN_INFO = t.ERR_TX_INVALID_CHAIN_INFO = t.ERR_TX_CHAIN_ID_MISMATCH = t.ERR_TX_MISSING_CUSTOM_CHAIN_ID = t.ERR_TX_MISSING_CUSTOM_CHAIN = t.ERR_TX_INVALID_CALL = t.ERR_TX_INVALID_SENDER = t.ERR_RAW_TX_UNDEFINED = t.ERR_TX_OUT_OF_GAS = t.ERR_TX_REVERT_WITHOUT_REASON = t.ERR_TX_CONTRACT_NOT_STORED = t.ERR_TX_NO_CONTRACT_ADDRESS = t.ERR_TX_REVERT_TRANSACTION = t.ERR_TX_REVERT_INSTRUCTION = t.ERR_TX = t.ERR_CONTRACT_TX_DATA_AND_INPUT = t.ERR_CONTRACT_EXECUTION_REVERTED = t.ERR_CONTRACT_INSTANTIATION = t.ERR_CONTRACT_MISSING_FROM_ADDRESS = t.ERR_CONTRACT_MISSING_ADDRESS = t.ERR_CONTRACT_MISSING_DEPLOY_DATA = t.ERR_CONTRACT_RESERVED_EVENT = t.ERR_CONTRACT_EVENT_NOT_EXISTS = t.ERR_CONTRACT_REQUIRED_CALLBACK = t.ERR_CONTRACT_ABI_MISSING = t.ERR_CONTRACT_RESOLVER_MISSING = t.ERR_CONTRACT = t.ERR_MULTIPLE_ERRORS = t.ERR_INVALID_METHOD_PARAMS = t.ERR_EXISTING_PLUGIN_NAMESPACE = t.ERR_ABI_ENCODING = t.ERR_OPERATION_ABORT = t.ERR_OPERATION_TIMEOUT = t.ERR_METHOD_NOT_IMPLEMENTED = t.ERR_FORMATTERS = t.ERR_PARAM = t.ERR_INVALID_RESPONSE = t.ERR_RESPONSE = void 0, t.ERR_INVALID_BYTES = t.ERR_INVALID_STRING = t.ERR_ENS_NETWORK_NOT_SYNCED = t.ERR_ENS_UNSUPPORTED_NETWORK = t.ERR_ENS_CHECK_INTERFACE_SUPPORT = t.JSONRPC_ERR_CHAIN_DISCONNECTED = t.JSONRPC_ERR_DISCONNECTED = t.JSONRPC_ERR_UNSUPPORTED_METHOD = t.JSONRPC_ERR_UNAUTHORIZED = t.JSONRPC_ERR_REJECTED_REQUEST = t.GENESIS_BLOCK_NUMBER = t.ERR_INVALID_SIGNATURE = t.ERR_SIGNATURE_FAILED = t.ERR_PBKDF2_ITERATIONS = t.ERR_INVALID_KEYSTORE = t.ERR_IV_LENGTH = t.ERR_INVALID_PASSWORD = t.ERR_KEY_VERSION_UNSUPPORTED = t.ERR_KEY_DERIVATION_FAIL = t.ERR_UNSUPPORTED_KDF = t.ERR_INVALID_PRIVATE_KEY = t.ERR_PRIVATE_KEY_LENGTH = t.ERR_WS_PROVIDER = t.ERR_SUBSCRIPTION = t.ERR_INVALID_CLIENT = t.ERR_INVALID_PROVIDER = t.ERR_PROVIDER = t.ERR_REQ_ALREADY_SENT = t.ERR_CONN_PENDING_REQUESTS = t.ERR_CONN_MAX_ATTEMPTS = t.ERR_CONN_CLOSE = t.ERR_CONN_NOT_OPEN = t.ERR_CONN_TIMEOUT = t.ERR_CONN_INVALID = t.ERR_CONN = t.ERR_TX_GAS_MISMATCH_INNER_ERROR = t.ERR_TX_MISSING_GAS_INNER_ERROR = t.ERR_TX_INVALID_PROPERTIES_FOR_TYPE = t.ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR = t.ERR_TX_INVALID_RECEIVER = t.ERR_TX_HARDFORK_MISMATCH = t.ERR_TX_CHAIN_MISMATCH = t.ERR_TX_GAS_MISMATCH = t.ERR_TX_SIGNING = t.ERR_TX_BLOCK_TIMEOUT = t.ERR_TX_SEND_TIMEOUT = t.ERR_TX_NOT_FOUND = t.ERR_TX_LOCAL_WALLET_NOT_AVAILABLE = t.ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER = t.ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL = void 0, t.ERR_RPC_NOT_SUPPORTED = t.ERR_RPC_LIMIT_EXCEEDED = t.ERR_RPC_UNSUPPORTED_METHOD = t.ERR_RPC_TRANSACTION_REJECTED = t.ERR_RPC_UNAVAILABLE_RESOURCE = t.ERR_RPC_MISSING_RESOURCE = t.ERR_RPC_INVALID_INPUT = t.ERR_RPC_INTERNAL_ERROR = t.ERR_RPC_INVALID_PARAMS = t.ERR_RPC_INVALID_METHOD = t.ERR_RPC_INVALID_REQUEST = t.ERR_RPC_INVALID_JSON = t.ERR_SCHEMA_FORMAT = t.ERR_CORE_CHAIN_MISMATCH = t.ERR_CORE_HARDFORK_MISMATCH = t.ERR_VALIDATION = t.ERR_INVALID_INTEGER = t.ERR_INVALID_NIBBLE_WIDTH = t.ERR_INVALID_TYPE_ABI = t.ERR_INVALID_BLOCK = t.ERR_INVALID_LARGE_VALUE = t.ERR_INVALID_SIZE = t.ERR_INVALID_UNSIGNED_INTEGER = t.ERR_INVALID_BOOLEAN = t.ERR_INVALID_TYPE = t.ERR_INVALID_HEX = t.ERR_INVALID_ADDRESS = t.ERR_INVALID_UNIT = t.ERR_INVALID_NUMBER = void 0, t.ERR_RESPONSE = 100, t.ERR_INVALID_RESPONSE = 101, t.ERR_PARAM = 200, t.ERR_FORMATTERS = 201, t.ERR_METHOD_NOT_IMPLEMENTED = 202, t.ERR_OPERATION_TIMEOUT = 203, t.ERR_OPERATION_ABORT = 204, t.ERR_ABI_ENCODING = 205, t.ERR_EXISTING_PLUGIN_NAMESPACE = 206, t.ERR_INVALID_METHOD_PARAMS = 207, t.ERR_MULTIPLE_ERRORS = 208, t.ERR_CONTRACT = 300, t.ERR_CONTRACT_RESOLVER_MISSING = 301, t.ERR_CONTRACT_ABI_MISSING = 302, t.ERR_CONTRACT_REQUIRED_CALLBACK = 303, t.ERR_CONTRACT_EVENT_NOT_EXISTS = 304, t.ERR_CONTRACT_RESERVED_EVENT = 305, t.ERR_CONTRACT_MISSING_DEPLOY_DATA = 306, t.ERR_CONTRACT_MISSING_ADDRESS = 307, t.ERR_CONTRACT_MISSING_FROM_ADDRESS = 308, t.ERR_CONTRACT_INSTANTIATION = 309, t.ERR_CONTRACT_EXECUTION_REVERTED = 310, t.ERR_CONTRACT_TX_DATA_AND_INPUT = 311, t.ERR_TX = 400, t.ERR_TX_REVERT_INSTRUCTION = 401, t.ERR_TX_REVERT_TRANSACTION = 402, t.ERR_TX_NO_CONTRACT_ADDRESS = 403, t.ERR_TX_CONTRACT_NOT_STORED = 404, t.ERR_TX_REVERT_WITHOUT_REASON = 405, t.ERR_TX_OUT_OF_GAS = 406, t.ERR_RAW_TX_UNDEFINED = 407, t.ERR_TX_INVALID_SENDER = 408, t.ERR_TX_INVALID_CALL = 409, t.ERR_TX_MISSING_CUSTOM_CHAIN = 410, t.ERR_TX_MISSING_CUSTOM_CHAIN_ID = 411, t.ERR_TX_CHAIN_ID_MISMATCH = 412, t.ERR_TX_INVALID_CHAIN_INFO = 413, t.ERR_TX_MISSING_CHAIN_INFO = 414, t.ERR_TX_MISSING_GAS = 415, t.ERR_TX_INVALID_LEGACY_GAS = 416, t.ERR_TX_INVALID_FEE_MARKET_GAS = 417, t.ERR_TX_INVALID_FEE_MARKET_GAS_PRICE = 418, t.ERR_TX_INVALID_LEGACY_FEE_MARKET = 419, t.ERR_TX_INVALID_OBJECT = 420, t.ERR_TX_INVALID_NONCE_OR_CHAIN_ID = 421, t.ERR_TX_UNABLE_TO_POPULATE_NONCE = 422, t.ERR_TX_UNSUPPORTED_EIP_1559 = 423, t.ERR_TX_UNSUPPORTED_TYPE = 424, t.ERR_TX_DATA_AND_INPUT = 425, t.ERR_TX_POLLING_TIMEOUT = 426, t.ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL = 427, t.ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER = 428, t.ERR_TX_LOCAL_WALLET_NOT_AVAILABLE = 429, t.ERR_TX_NOT_FOUND = 430, t.ERR_TX_SEND_TIMEOUT = 431, t.ERR_TX_BLOCK_TIMEOUT = 432, t.ERR_TX_SIGNING = 433, t.ERR_TX_GAS_MISMATCH = 434, t.ERR_TX_CHAIN_MISMATCH = 435, t.ERR_TX_HARDFORK_MISMATCH = 436, t.ERR_TX_INVALID_RECEIVER = 437, t.ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR = 438, t.ERR_TX_INVALID_PROPERTIES_FOR_TYPE = 439, t.ERR_TX_MISSING_GAS_INNER_ERROR = 440, t.ERR_TX_GAS_MISMATCH_INNER_ERROR = 441, t.ERR_CONN = 500, t.ERR_CONN_INVALID = 501, t.ERR_CONN_TIMEOUT = 502, t.ERR_CONN_NOT_OPEN = 503, t.ERR_CONN_CLOSE = 504, t.ERR_CONN_MAX_ATTEMPTS = 505, t.ERR_CONN_PENDING_REQUESTS = 506, t.ERR_REQ_ALREADY_SENT = 507, t.ERR_PROVIDER = 600, t.ERR_INVALID_PROVIDER = 601, t.ERR_INVALID_CLIENT = 602, t.ERR_SUBSCRIPTION = 603, t.ERR_WS_PROVIDER = 604, t.ERR_PRIVATE_KEY_LENGTH = 701, t.ERR_INVALID_PRIVATE_KEY = 702, t.ERR_UNSUPPORTED_KDF = 703, t.ERR_KEY_DERIVATION_FAIL = 704, t.ERR_KEY_VERSION_UNSUPPORTED = 705, t.ERR_INVALID_PASSWORD = 706, t.ERR_IV_LENGTH = 707, t.ERR_INVALID_KEYSTORE = 708, t.ERR_PBKDF2_ITERATIONS = 709, t.ERR_SIGNATURE_FAILED = 801, t.ERR_INVALID_SIGNATURE = 802, t.GENESIS_BLOCK_NUMBER = "0x0", t.JSONRPC_ERR_REJECTED_REQUEST = 4001, t.JSONRPC_ERR_UNAUTHORIZED = 4100, t.JSONRPC_ERR_UNSUPPORTED_METHOD = 4200, t.JSONRPC_ERR_DISCONNECTED = 4900, t.JSONRPC_ERR_CHAIN_DISCONNECTED = 4901, t.ERR_ENS_CHECK_INTERFACE_SUPPORT = 901, t.ERR_ENS_UNSUPPORTED_NETWORK = 902, t.ERR_ENS_NETWORK_NOT_SYNCED = 903, t.ERR_INVALID_STRING = 1001, t.ERR_INVALID_BYTES = 1002, t.ERR_INVALID_NUMBER = 1003, t.ERR_INVALID_UNIT = 1004, t.ERR_INVALID_ADDRESS = 1005, t.ERR_INVALID_HEX = 1006, t.ERR_INVALID_TYPE = 1007, t.ERR_INVALID_BOOLEAN = 1008, t.ERR_INVALID_UNSIGNED_INTEGER = 1009, t.ERR_INVALID_SIZE = 1010, t.ERR_INVALID_LARGE_VALUE = 1011, t.ERR_INVALID_BLOCK = 1012, t.ERR_INVALID_TYPE_ABI = 1013, t.ERR_INVALID_NIBBLE_WIDTH = 1014, t.ERR_INVALID_INTEGER = 1015, t.ERR_VALIDATION = 1100, t.ERR_CORE_HARDFORK_MISMATCH = 1101, t.ERR_CORE_CHAIN_MISMATCH = 1102, t.ERR_SCHEMA_FORMAT = 1200, t.ERR_RPC_INVALID_JSON = -32700, t.ERR_RPC_INVALID_REQUEST = -32600, t.ERR_RPC_INVALID_METHOD = -32601, t.ERR_RPC_INVALID_PARAMS = -32602, t.ERR_RPC_INTERNAL_ERROR = -32603, t.ERR_RPC_INVALID_INPUT = -32000, t.ERR_RPC_MISSING_RESOURCE = -32001, t.ERR_RPC_UNAVAILABLE_RESOURCE = -32002, t.ERR_RPC_TRANSACTION_REJECTED = -32003, t.ERR_RPC_UNSUPPORTED_METHOD = -32004, t.ERR_RPC_LIMIT_EXCEEDED = -32005, t.ERR_RPC_NOT_SUPPORTED = -32006;
            },
            8105: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PBKDF2IterationsError = t.IVLengthError = t.InvalidPasswordError = t.KeyStoreVersionError = t.KeyDerivationError = t.InvalidKdfError = t.InvalidSignatureError = t.InvalidPrivateKeyError = t.PrivateKeyLengthError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.BaseWeb3Error {
                    constructor(){
                        super("Private key must be 32 bytes."), this.code = n.ERR_PRIVATE_KEY_LENGTH;
                    }
                }
                t.PrivateKeyLengthError = i;
                class s extends o.BaseWeb3Error {
                    constructor(){
                        super("Invalid Private Key, Not a valid string or uint8Array"), this.code = n.ERR_INVALID_PRIVATE_KEY;
                    }
                }
                t.InvalidPrivateKeyError = s;
                class a extends o.BaseWeb3Error {
                    constructor(e){
                        super(`"${e}"`), this.code = n.ERR_INVALID_SIGNATURE;
                    }
                }
                t.InvalidSignatureError = a;
                class c extends o.BaseWeb3Error {
                    constructor(){
                        super("Invalid key derivation function"), this.code = n.ERR_UNSUPPORTED_KDF;
                    }
                }
                t.InvalidKdfError = c;
                class u extends o.BaseWeb3Error {
                    constructor(){
                        super("Key derivation failed - possibly wrong password"), this.code = n.ERR_KEY_DERIVATION_FAIL;
                    }
                }
                t.KeyDerivationError = u;
                class d extends o.BaseWeb3Error {
                    constructor(){
                        super("Unsupported key store version"), this.code = n.ERR_KEY_VERSION_UNSUPPORTED;
                    }
                }
                t.KeyStoreVersionError = d;
                class l extends o.BaseWeb3Error {
                    constructor(){
                        super("Password cannot be empty"), this.code = n.ERR_INVALID_PASSWORD;
                    }
                }
                t.InvalidPasswordError = l;
                class h extends o.BaseWeb3Error {
                    constructor(){
                        super("Initialization vector must be 16 bytes"), this.code = n.ERR_IV_LENGTH;
                    }
                }
                t.IVLengthError = h;
                class f extends o.BaseWeb3Error {
                    constructor(){
                        super("c > 1000, pbkdf2 is less secure with less iterations"), this.code = n.ERR_PBKDF2_ITERATIONS;
                    }
                }
                t.PBKDF2IterationsError = f;
            },
            3789: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.RequestAlreadySentError = t.PendingRequestsOnReconnectingError = t.MaxAttemptsReachedOnReconnectingError = t.ConnectionCloseError = t.ConnectionNotOpenError = t.ConnectionTimeoutError = t.InvalidConnectionError = t.ConnectionError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.code = n.ERR_CONN, t && (this.errorCode = t.code, this.errorReason = t.reason);
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            errorCode: this.errorCode,
                            errorReason: this.errorReason
                        });
                    }
                }
                t.ConnectionError = i, t.InvalidConnectionError = class extends i {
                    constructor(e, t){
                        super(`CONNECTION ERROR: Couldn't connect to node ${e}.`, t), this.host = e, this.code = n.ERR_CONN_INVALID;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            host: this.host
                        });
                    }
                }, t.ConnectionTimeoutError = class extends i {
                    constructor(e){
                        super(`CONNECTION TIMEOUT: timeout of ${e}ms achieved`), this.duration = e, this.code = n.ERR_CONN_TIMEOUT;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            duration: this.duration
                        });
                    }
                }, t.ConnectionNotOpenError = class extends i {
                    constructor(e){
                        super("Connection not open", e), this.code = n.ERR_CONN_NOT_OPEN;
                    }
                }, t.ConnectionCloseError = class extends i {
                    constructor(e){
                        var t, r;
                        super(`CONNECTION ERROR: The connection got closed with the close code ${null !== (t = null == e ? void 0 : e.code) && void 0 !== t ? t : ""} and the following reason string ${null !== (r = null == e ? void 0 : e.reason) && void 0 !== r ? r : ""}`, e), this.code = n.ERR_CONN_CLOSE;
                    }
                }, t.MaxAttemptsReachedOnReconnectingError = class extends i {
                    constructor(e){
                        super(`Maximum number of reconnect attempts reached! (${e})`), this.code = n.ERR_CONN_MAX_ATTEMPTS;
                    }
                }, t.PendingRequestsOnReconnectingError = class extends i {
                    constructor(){
                        super("CONNECTION ERROR: Provider started to reconnect before the response got received!"), this.code = n.ERR_CONN_PENDING_REQUESTS;
                    }
                }, t.RequestAlreadySentError = class extends i {
                    constructor(e){
                        super(`Request already sent with following id: ${e}`), this.code = n.ERR_REQ_ALREADY_SENT;
                    }
                };
            },
            510: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ContractTransactionDataAndInputError = t.ContractExecutionError = t.Eip838ExecutionError = t.ContractInstantiationError = t.ContractNoFromAddressDefinedError = t.ContractNoAddressDefinedError = t.ContractMissingDeployDataError = t.ContractReservedEventError = t.ContractEventDoesNotExistError = t.ContractOnceRequiresCallbackError = t.ContractMissingABIError = t.ResolverMethodMissingError = t.Web3ContractError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.code = n.ERR_CONTRACT, this.receipt = t;
                    }
                }
                t.Web3ContractError = i;
                class s extends o.BaseWeb3Error {
                    constructor(e, t){
                        super(`The resolver at ${e} does not implement requested method: "${t}".`), this.address = e, this.name = t, this.code = n.ERR_CONTRACT_RESOLVER_MISSING;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            address: this.address,
                            name: this.name
                        });
                    }
                }
                t.ResolverMethodMissingError = s;
                class a extends o.BaseWeb3Error {
                    constructor(){
                        super("You must provide the json interface of the contract when instantiating a contract object."), this.code = n.ERR_CONTRACT_ABI_MISSING;
                    }
                }
                t.ContractMissingABIError = a;
                class c extends o.BaseWeb3Error {
                    constructor(){
                        super("Once requires a callback as the second parameter."), this.code = n.ERR_CONTRACT_REQUIRED_CALLBACK;
                    }
                }
                t.ContractOnceRequiresCallbackError = c;
                class u extends o.BaseWeb3Error {
                    constructor(e){
                        super(`Event "${e}" doesn't exist in this contract.`), this.eventName = e, this.code = n.ERR_CONTRACT_EVENT_NOT_EXISTS;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            eventName: this.eventName
                        });
                    }
                }
                t.ContractEventDoesNotExistError = u;
                class d extends o.BaseWeb3Error {
                    constructor(e){
                        super(`Event "${e}" doesn't exist in this contract.`), this.type = e, this.code = n.ERR_CONTRACT_RESERVED_EVENT;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            type: this.type
                        });
                    }
                }
                t.ContractReservedEventError = d;
                class l extends o.BaseWeb3Error {
                    constructor(){
                        super('No "data" specified in neither the given options, nor the default options.'), this.code = n.ERR_CONTRACT_MISSING_DEPLOY_DATA;
                    }
                }
                t.ContractMissingDeployDataError = l;
                class h extends o.BaseWeb3Error {
                    constructor(){
                        super("This contract object doesn't have address set yet, please set an address first."), this.code = n.ERR_CONTRACT_MISSING_ADDRESS;
                    }
                }
                t.ContractNoAddressDefinedError = h;
                class f extends o.BaseWeb3Error {
                    constructor(){
                        super('No "from" address specified in neither the given options, nor the default options.'), this.code = n.ERR_CONTRACT_MISSING_FROM_ADDRESS;
                    }
                }
                t.ContractNoFromAddressDefinedError = f;
                class p extends o.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_CONTRACT_INSTANTIATION;
                    }
                }
                t.ContractInstantiationError = p;
                class m extends i {
                    constructor(e){
                        if (super(e.message || "Error"), this.name = "name" in e && e.name || this.constructor.name, this.stack = "stack" in e && e.stack || void 0, this.code = e.code, "object" == typeof e.data) {
                            let t;
                            t = "originalError" in e.data ? e.data.originalError : e.data, this.data = t.data, this.cause = new m(t);
                        } else this.data = e.data;
                    }
                    setDecodedProperties(e, t, r) {
                        this.errorName = e, this.errorSignature = t, this.errorArgs = r;
                    }
                    toJSON() {
                        let e = Object.assign(Object.assign({}, super.toJSON()), {
                            data: this.data
                        });
                        return this.errorName && (e = Object.assign(Object.assign({}, e), {
                            errorName: this.errorName,
                            errorSignature: this.errorSignature,
                            errorArgs: this.errorArgs
                        })), e;
                    }
                }
                t.Eip838ExecutionError = m, t.ContractExecutionError = class extends i {
                    constructor(e){
                        super("Error happened while trying to execute a function inside a smart contract"), this.code = n.ERR_CONTRACT_EXECUTION_REVERTED, this.cause = new m(e);
                    }
                };
                class g extends o.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`data: ${null !== (t = e.data) && void 0 !== t ? t : "undefined"}, input: ${null !== (r = e.input) && void 0 !== r ? r : "undefined"}`, 'You can\'t have "data" and "input" as properties of a contract at the same time, please use either "data" or "input" instead.'), this.code = n.ERR_CONTRACT_TX_DATA_AND_INPUT;
                    }
                }
                t.ContractTransactionDataAndInputError = g;
            },
            3628: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ConfigChainMismatchError = t.ConfigHardforkMismatchError = void 0;
                const n = r(3685), o = r(7639);
                class i extends n.BaseWeb3Error {
                    constructor(e, t){
                        super(`Web3Config hardfork doesnt match in defaultHardfork ${e} and common.hardfork ${t}`), this.code = o.ERR_CORE_HARDFORK_MISMATCH;
                    }
                }
                t.ConfigHardforkMismatchError = i;
                class s extends n.BaseWeb3Error {
                    constructor(e, t){
                        super(`Web3Config chain doesnt match in defaultHardfork ${e} and common.hardfork ${t}`), this.code = o.ERR_CORE_HARDFORK_MISMATCH;
                    }
                }
                t.ConfigChainMismatchError = s;
            },
            1591: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ENSNetworkNotSyncedError = t.ENSUnsupportedNetworkError = t.ENSCheckInterfaceSupportError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.BaseWeb3Error {
                    constructor(e){
                        super(`ENS resolver check interface support error. "${e}"`), this.code = n.ERR_ENS_CHECK_INTERFACE_SUPPORT;
                    }
                }
                t.ENSCheckInterfaceSupportError = i;
                class s extends o.BaseWeb3Error {
                    constructor(e){
                        super(`ENS is not supported on network ${e}`), this.code = n.ERR_ENS_UNSUPPORTED_NETWORK;
                    }
                }
                t.ENSUnsupportedNetworkError = s;
                class a extends o.BaseWeb3Error {
                    constructor(){
                        super("Network not synced"), this.code = n.ERR_ENS_NETWORK_NOT_SYNCED;
                    }
                }
                t.ENSNetworkNotSyncedError = a;
            },
            7297: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ExistingPluginNamespaceError = t.AbiError = t.OperationAbortError = t.OperationTimeoutError = t.MethodNotImplementedError = t.FormatterError = t.InvalidMethodParamsError = t.InvalidNumberOfParamsError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.BaseWeb3Error {
                    constructor(e, t, r){
                        super(`Invalid number of parameters for "${r}". Got "${e}" expected "${t}"!`), this.got = e, this.expected = t, this.method = r, this.code = n.ERR_PARAM;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            got: this.got,
                            expected: this.expected,
                            method: this.method
                        });
                    }
                }
                t.InvalidNumberOfParamsError = i;
                class s extends o.BaseWeb3Error {
                    constructor(e){
                        super(`Invalid parameters passed. "${void 0 !== e ? e : ""}"`), this.hint = e, this.code = n.ERR_INVALID_METHOD_PARAMS;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            hint: this.hint
                        });
                    }
                }
                t.InvalidMethodParamsError = s;
                class a extends o.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_FORMATTERS;
                    }
                }
                t.FormatterError = a;
                class c extends o.BaseWeb3Error {
                    constructor(){
                        super("The method you're trying to call is not implemented."), this.code = n.ERR_METHOD_NOT_IMPLEMENTED;
                    }
                }
                t.MethodNotImplementedError = c;
                class u extends o.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_OPERATION_TIMEOUT;
                    }
                }
                t.OperationTimeoutError = u;
                class d extends o.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_OPERATION_ABORT;
                    }
                }
                t.OperationAbortError = d;
                class l extends o.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.code = n.ERR_ABI_ENCODING, this.props = null != t ? t : {};
                    }
                }
                t.AbiError = l;
                class h extends o.BaseWeb3Error {
                    constructor(e){
                        super(`A plugin with the namespace: ${e} has already been registered.`), this.code = n.ERR_EXISTING_PLUGIN_NAMESPACE;
                    }
                }
                t.ExistingPluginNamespaceError = h;
            },
            7108: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3WSProviderError = t.SubscriptionError = t.InvalidClientError = t.InvalidProviderError = t.ProviderError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_PROVIDER;
                    }
                }
                t.ProviderError = i;
                class s extends o.BaseWeb3Error {
                    constructor(e){
                        super(`Provider with url "${e}" is not set or invalid`), this.clientUrl = e, this.code = n.ERR_INVALID_PROVIDER;
                    }
                }
                t.InvalidProviderError = s;
                class a extends o.BaseWeb3Error {
                    constructor(e){
                        super(`Client URL "${e}" is invalid.`), this.code = n.ERR_INVALID_CLIENT;
                    }
                }
                t.InvalidClientError = a;
                class c extends o.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_SUBSCRIPTION;
                    }
                }
                t.SubscriptionError = c;
                class u extends o.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_WS_PROVIDER;
                    }
                }
                t.Web3WSProviderError = u;
            },
            9491: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidResponseError = t.ResponseError = void 0;
                const n = r(3685), o = r(7639), i = (e)=>((e)=>!(Array.isArray(e) || "2.0" !== e.jsonrpc || !e || void 0 !== e.result && null !== e.result || !("error" in e) || "number" != typeof e.id && "string" != typeof e.id))(e) ? e.error.message : "";
                class s extends n.BaseWeb3Error {
                    constructor(e, t, r){
                        var s;
                        let a;
                        super(null != t ? t : `Returned error: ${Array.isArray(e) ? e.map((e)=>i(e)).join(",") : i(e)}`), this.code = o.ERR_RESPONSE, t || (this.data = Array.isArray(e) ? e.map((e)=>{
                            var t;
                            return null === (t = e.error) || void 0 === t ? void 0 : t.data;
                        }) : null === (s = null == e ? void 0 : e.error) || void 0 === s ? void 0 : s.data), this.request = r, "error" in e ? a = e.error : e instanceof Array && (a = e.filter((e)=>e.error).map((e)=>e.error)), Array.isArray(a) && a.length > 0 ? this.cause = new n.MultipleErrors(a) : this.cause = a;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            data: this.data,
                            request: this.request
                        });
                    }
                }
                t.ResponseError = s, t.InvalidResponseError = class extends s {
                    constructor(e, t){
                        let r;
                        super(e, void 0, t), this.code = o.ERR_INVALID_RESPONSE, "error" in e ? r = e.error : e instanceof Array && (r = e.map((e)=>e.error)), Array.isArray(r) ? this.cause = new n.MultipleErrors(r) : this.cause = r;
                    }
                };
            },
            4032: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.RpcErrorMessages = t.genericRpcErrorMessageTemplate = void 0;
                const n = r(7639);
                t.genericRpcErrorMessageTemplate = "An Rpc error has occured with a code of *code*", t.RpcErrorMessages = {
                    [n.ERR_RPC_INVALID_JSON]: {
                        message: "Parse error",
                        description: "Invalid JSON"
                    },
                    [n.ERR_RPC_INVALID_REQUEST]: {
                        message: "Invalid request",
                        description: "JSON is not a valid request object	"
                    },
                    [n.ERR_RPC_INVALID_METHOD]: {
                        message: "Method not found",
                        description: "Method does not exist	"
                    },
                    [n.ERR_RPC_INVALID_PARAMS]: {
                        message: "Invalid params",
                        description: "Invalid method parameters"
                    },
                    [n.ERR_RPC_INTERNAL_ERROR]: {
                        message: "Internal error",
                        description: "Internal JSON-RPC error"
                    },
                    [n.ERR_RPC_INVALID_INPUT]: {
                        message: "Invalid input",
                        description: "Missing or invalid parameters"
                    },
                    [n.ERR_RPC_MISSING_RESOURCE]: {
                        message: "Resource not found",
                        description: "Requested resource not found"
                    },
                    [n.ERR_RPC_UNAVAILABLE_RESOURCE]: {
                        message: "Resource unavailable",
                        description: "Requested resource not available"
                    },
                    [n.ERR_RPC_TRANSACTION_REJECTED]: {
                        message: "Transaction rejected",
                        description: "Transaction creation failed"
                    },
                    [n.ERR_RPC_UNSUPPORTED_METHOD]: {
                        message: "Method not supported",
                        description: "Method is not implemented"
                    },
                    [n.ERR_RPC_LIMIT_EXCEEDED]: {
                        message: "Limit exceeded",
                        description: "Request exceeds defined limit"
                    },
                    [n.ERR_RPC_NOT_SUPPORTED]: {
                        message: "JSON-RPC version not supported",
                        description: "Version of JSON-RPC protocol is not supported"
                    },
                    [n.JSONRPC_ERR_REJECTED_REQUEST]: {
                        name: "User Rejected Request",
                        message: "The user rejected the request."
                    },
                    [n.JSONRPC_ERR_UNAUTHORIZED]: {
                        name: "Unauthorized",
                        message: "The requested method and/or account has not been authorized by the user."
                    },
                    [n.JSONRPC_ERR_UNSUPPORTED_METHOD]: {
                        name: "Unsupported Method",
                        message: "The Provider does not support the requested method."
                    },
                    [n.JSONRPC_ERR_DISCONNECTED]: {
                        name: "Disconnected",
                        message: "The Provider is disconnected from all chains."
                    },
                    [n.JSONRPC_ERR_CHAIN_DISCONNECTED]: {
                        name: "Chain Disconnected",
                        message: "The Provider is not connected to the requested chain."
                    },
                    "0-999": {
                        name: "",
                        message: "Not used."
                    },
                    1e3: {
                        name: "Normal Closure",
                        message: "The connection successfully completed the purpose for which it was created."
                    },
                    1001: {
                        name: "Going Away",
                        message: "The endpoint is going away, either because of a server failure or because the browser is navigating away from the page that opened the connection."
                    },
                    1002: {
                        name: "Protocol error",
                        message: "The endpoint is terminating the connection due to a protocol error."
                    },
                    1003: {
                        name: "Unsupported Data",
                        message: "The connection is being terminated because the endpoint received data of a type it cannot accept. (For example, a text-only endpoint received binary data.)"
                    },
                    1004: {
                        name: "Reserved",
                        message: "Reserved. A meaning might be defined in the future."
                    },
                    1005: {
                        name: "No Status Rcvd",
                        message: "Reserved. Indicates that no status code was provided even though one was expected."
                    },
                    1006: {
                        name: "Abnormal Closure",
                        message: "Reserved. Indicates that a connection was closed abnormally (that is, with no close frame being sent) when a status code is expected."
                    },
                    1007: {
                        name: "Invalid frame payload data",
                        message: "The endpoint is terminating the connection because a message was received that contained inconsistent data (e.g., non-UTF-8 data within a text message)."
                    },
                    1008: {
                        name: "Policy Violation",
                        message: "The endpoint is terminating the connection because it received a message that violates its policy. This is a generic status code, used when codes 1003 and 1009 are not suitable."
                    },
                    1009: {
                        name: "Message Too Big",
                        message: "The endpoint is terminating the connection because a data frame was received that is too large."
                    },
                    1010: {
                        name: "Mandatory Ext.",
                        message: "The client is terminating the connection because it expected the server to negotiate one or more extension, but the server didn't."
                    },
                    1011: {
                        name: "Internal Error",
                        message: "The server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request."
                    },
                    1012: {
                        name: "Service Restart",
                        message: "The server is terminating the connection because it is restarting."
                    },
                    1013: {
                        name: "Try Again Later",
                        message: "The server is terminating the connection due to a temporary condition, e.g. it is overloaded and is casting off some of its clients."
                    },
                    1014: {
                        name: "Bad Gateway",
                        message: "The server was acting as a gateway or proxy and received an invalid response from the upstream server. This is similar to 502 HTTP Status Code."
                    },
                    1015: {
                        name: "TLS handshake",
                        message: "Reserved. Indicates that the connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified)."
                    },
                    "1016-2999": {
                        name: "",
                        message: "For definition by future revisions of the WebSocket Protocol specification, and for definition by extension specifications."
                    },
                    "3000-3999": {
                        name: "",
                        message: "For use by libraries, frameworks, and applications. These status codes are registered directly with IANA. The interpretation of these codes is undefined by the WebSocket protocol."
                    },
                    "4000-4999": {
                        name: "",
                        message: "For private use, and thus can't be registered. Such codes can be used by prior agreements between WebSocket applications. The interpretation of these codes is undefined by the WebSocket protocol."
                    }
                };
            },
            655: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rpcErrorsMap = t.LimitExceededError = t.TransactionRejectedError = t.VersionNotSupportedError = t.ResourcesNotFoundError = t.ResourceUnavailableError = t.MethodNotSupported = t.InvalidInputError = t.InternalError = t.InvalidParamsError = t.MethodNotFoundError = t.InvalidRequestError = t.ParseError = t.EIP1193ProviderRpcError = t.RpcError = void 0;
                const n = r(3685), o = r(7639), i = r(4032);
                class s extends n.BaseWeb3Error {
                    constructor(e, t){
                        super(null != t ? t : i.genericRpcErrorMessageTemplate.replace("*code*", e.error.code.toString())), this.code = e.error.code, this.id = e.id, this.jsonrpc = e.jsonrpc, this.jsonRpcError = e.error;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            error: this.jsonRpcError,
                            id: this.id,
                            jsonRpc: this.jsonrpc
                        });
                    }
                }
                t.RpcError = s;
                class a extends n.BaseWeb3Error {
                    constructor(e, t){
                        var r, n, o, s;
                        if (e) {
                            if (null === (r = i.RpcErrorMessages[e]) || void 0 === r ? void 0 : r.message) super(i.RpcErrorMessages[e].message);
                            else {
                                const t = Object.keys(i.RpcErrorMessages).find((t)=>"string" == typeof t && e >= parseInt(t.split("-")[0], 10) && e <= parseInt(t.split("-")[1], 10));
                                super(null !== (o = null === (n = i.RpcErrorMessages[null != t ? t : ""]) || void 0 === n ? void 0 : n.message) && void 0 !== o ? o : i.genericRpcErrorMessageTemplate.replace("*code*", null !== (s = null == e ? void 0 : e.toString()) && void 0 !== s ? s : '""'));
                            }
                        } else super();
                        this.code = e, this.data = t;
                    }
                }
                t.EIP1193ProviderRpcError = a;
                class c extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_INVALID_JSON].message), this.code = o.ERR_RPC_INVALID_JSON;
                    }
                }
                t.ParseError = c;
                class u extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_INVALID_REQUEST].message), this.code = o.ERR_RPC_INVALID_REQUEST;
                    }
                }
                t.InvalidRequestError = u;
                class d extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_INVALID_METHOD].message), this.code = o.ERR_RPC_INVALID_METHOD;
                    }
                }
                t.MethodNotFoundError = d;
                class l extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_INVALID_PARAMS].message), this.code = o.ERR_RPC_INVALID_PARAMS;
                    }
                }
                t.InvalidParamsError = l;
                class h extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_INTERNAL_ERROR].message), this.code = o.ERR_RPC_INTERNAL_ERROR;
                    }
                }
                t.InternalError = h;
                class f extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_INVALID_INPUT].message), this.code = o.ERR_RPC_INVALID_INPUT;
                    }
                }
                t.InvalidInputError = f;
                class p extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_UNSUPPORTED_METHOD].message), this.code = o.ERR_RPC_UNSUPPORTED_METHOD;
                    }
                }
                t.MethodNotSupported = p;
                class m extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_UNAVAILABLE_RESOURCE].message), this.code = o.ERR_RPC_UNAVAILABLE_RESOURCE;
                    }
                }
                t.ResourceUnavailableError = m;
                class g extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_MISSING_RESOURCE].message), this.code = o.ERR_RPC_MISSING_RESOURCE;
                    }
                }
                t.ResourcesNotFoundError = g;
                class y extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_NOT_SUPPORTED].message), this.code = o.ERR_RPC_NOT_SUPPORTED;
                    }
                }
                t.VersionNotSupportedError = y;
                class v extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_TRANSACTION_REJECTED].message), this.code = o.ERR_RPC_TRANSACTION_REJECTED;
                    }
                }
                t.TransactionRejectedError = v;
                class b extends s {
                    constructor(e){
                        super(e, i.RpcErrorMessages[o.ERR_RPC_LIMIT_EXCEEDED].message), this.code = o.ERR_RPC_LIMIT_EXCEEDED;
                    }
                }
                t.LimitExceededError = b, t.rpcErrorsMap = new Map, t.rpcErrorsMap.set(o.ERR_RPC_INVALID_JSON, {
                    error: c
                }), t.rpcErrorsMap.set(o.ERR_RPC_INVALID_REQUEST, {
                    error: u
                }), t.rpcErrorsMap.set(o.ERR_RPC_INVALID_METHOD, {
                    error: d
                }), t.rpcErrorsMap.set(o.ERR_RPC_INVALID_PARAMS, {
                    error: l
                }), t.rpcErrorsMap.set(o.ERR_RPC_INTERNAL_ERROR, {
                    error: h
                }), t.rpcErrorsMap.set(o.ERR_RPC_INVALID_INPUT, {
                    error: f
                }), t.rpcErrorsMap.set(o.ERR_RPC_UNSUPPORTED_METHOD, {
                    error: p
                }), t.rpcErrorsMap.set(o.ERR_RPC_UNAVAILABLE_RESOURCE, {
                    error: m
                }), t.rpcErrorsMap.set(o.ERR_RPC_TRANSACTION_REJECTED, {
                    error: v
                }), t.rpcErrorsMap.set(o.ERR_RPC_MISSING_RESOURCE, {
                    error: g
                }), t.rpcErrorsMap.set(o.ERR_RPC_NOT_SUPPORTED, {
                    error: y
                }), t.rpcErrorsMap.set(o.ERR_RPC_LIMIT_EXCEEDED, {
                    error: b
                });
            },
            1066: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SchemaFormatError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.BaseWeb3Error {
                    constructor(e){
                        super(`Format for the type ${e} is unsupported`), this.type = e, this.code = n.ERR_SCHEMA_FORMAT;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            type: this.type
                        });
                    }
                }
                t.SchemaFormatError = i;
            },
            1075: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SignatureError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.InvalidValueError {
                    constructor(){
                        super(...arguments), this.code = n.ERR_SIGNATURE_FAILED;
                    }
                }
                t.SignatureError = i;
            },
            8450: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidPropertiesForTransactionTypeError = t.LocalWalletNotAvailableError = t.TransactionSigningError = t.TransactionReceiptMissingBlockNumberError = t.TransactionMissingReceiptOrBlockHashError = t.TransactionBlockTimeoutError = t.TransactionPollingTimeoutError = t.TransactionSendTimeoutError = t.TransactionDataAndInputError = t.UnsupportedTransactionTypeError = t.Eip1559NotSupportedError = t.UnableToPopulateNonceError = t.InvalidNonceOrChainIdError = t.InvalidTransactionObjectError = t.UnsupportedFeeMarketError = t.Eip1559GasPriceError = t.InvalidMaxPriorityFeePerGasOrMaxFeePerGas = t.InvalidGasOrGasPrice = t.TransactionGasMismatchError = t.TransactionGasMismatchInnerError = t.MissingGasError = t.MissingGasInnerError = t.MissingChainOrHardforkError = t.CommonOrChainAndHardforkError = t.HardforkMismatchError = t.ChainMismatchError = t.ChainIdMismatchError = t.MissingCustomChainIdError = t.MissingCustomChainError = t.InvalidTransactionCall = t.InvalidTransactionWithReceiver = t.InvalidTransactionWithSender = t.TransactionNotFound = t.UndefinedRawTransactionError = t.TransactionOutOfGasError = t.TransactionRevertedWithoutReasonError = t.ContractCodeNotStoredError = t.NoContractAddressFoundError = t.TransactionRevertWithCustomError = t.TransactionRevertInstructionError = t.RevertInstructionError = t.TransactionError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.receipt = t, this.code = n.ERR_TX;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            receipt: this.receipt
                        });
                    }
                }
                t.TransactionError = i;
                class s extends o.BaseWeb3Error {
                    constructor(e, t){
                        super(`Your request got reverted with the following reason string: ${e}`), this.reason = e, this.signature = t, this.code = n.ERR_TX_REVERT_INSTRUCTION;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            reason: this.reason,
                            signature: this.signature
                        });
                    }
                }
                t.RevertInstructionError = s;
                class a extends o.BaseWeb3Error {
                    constructor(e, t, r, i){
                        super("Transaction has been reverted by the EVM" + (void 0 === r ? "" : `:\n ${o.BaseWeb3Error.convertToString(r)}`)), this.reason = e, this.signature = t, this.receipt = r, this.data = i, this.code = n.ERR_TX_REVERT_TRANSACTION;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            reason: this.reason,
                            signature: this.signature,
                            receipt: this.receipt,
                            data: this.data
                        });
                    }
                }
                t.TransactionRevertInstructionError = a, t.TransactionRevertWithCustomError = class extends a {
                    constructor(e, t, r, o, i, s, a){
                        super(e), this.reason = e, this.customErrorName = t, this.customErrorDecodedSignature = r, this.customErrorArguments = o, this.signature = i, this.receipt = s, this.data = a, this.code = n.ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            reason: this.reason,
                            customErrorName: this.customErrorName,
                            customErrorDecodedSignature: this.customErrorDecodedSignature,
                            customErrorArguments: this.customErrorArguments,
                            signature: this.signature,
                            receipt: this.receipt,
                            data: this.data
                        });
                    }
                }, t.NoContractAddressFoundError = class extends i {
                    constructor(e){
                        super("The transaction receipt didn't contain a contract address.", e), this.code = n.ERR_TX_NO_CONTRACT_ADDRESS;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            receipt: this.receipt
                        });
                    }
                }, t.ContractCodeNotStoredError = class extends i {
                    constructor(e){
                        super("The contract code couldn't be stored, please check your gas limit.", e), this.code = n.ERR_TX_CONTRACT_NOT_STORED;
                    }
                }, t.TransactionRevertedWithoutReasonError = class extends i {
                    constructor(e){
                        super("Transaction has been reverted by the EVM" + (void 0 === e ? "" : `:\n ${o.BaseWeb3Error.convertToString(e)}`), e), this.code = n.ERR_TX_REVERT_WITHOUT_REASON;
                    }
                }, t.TransactionOutOfGasError = class extends i {
                    constructor(e){
                        super(`Transaction ran out of gas. Please provide more gas:\n ${JSON.stringify(e, void 0, 2)}`, e), this.code = n.ERR_TX_OUT_OF_GAS;
                    }
                }, t.UndefinedRawTransactionError = class extends i {
                    constructor(){
                        super("Raw transaction undefined"), this.code = n.ERR_RAW_TX_UNDEFINED;
                    }
                }, t.TransactionNotFound = class extends i {
                    constructor(){
                        super("Transaction not found"), this.code = n.ERR_TX_NOT_FOUND;
                    }
                };
                class c extends o.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction with invalid sender"), this.code = n.ERR_TX_INVALID_SENDER;
                    }
                }
                t.InvalidTransactionWithSender = c;
                class u extends o.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction with invalid receiver"), this.code = n.ERR_TX_INVALID_RECEIVER;
                    }
                }
                t.InvalidTransactionWithReceiver = u;
                class d extends o.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction call"), this.code = n.ERR_TX_INVALID_CALL;
                    }
                }
                t.InvalidTransactionCall = d;
                class l extends o.InvalidValueError {
                    constructor(){
                        super("MissingCustomChainError", "If tx.common is provided it must have tx.common.customChain"), this.code = n.ERR_TX_MISSING_CUSTOM_CHAIN;
                    }
                }
                t.MissingCustomChainError = l;
                class h extends o.InvalidValueError {
                    constructor(){
                        super("MissingCustomChainIdError", "If tx.common is provided it must have tx.common.customChain and tx.common.customChain.chainId"), this.code = n.ERR_TX_MISSING_CUSTOM_CHAIN_ID;
                    }
                }
                t.MissingCustomChainIdError = h;
                class f extends o.InvalidValueError {
                    constructor(e){
                        super(JSON.stringify(e), "Chain Id doesnt match in tx.chainId tx.common.customChain.chainId"), this.code = n.ERR_TX_CHAIN_ID_MISMATCH;
                    }
                }
                t.ChainIdMismatchError = f;
                class p extends o.InvalidValueError {
                    constructor(e){
                        super(JSON.stringify(e), "Chain doesnt match in tx.chain tx.common.basechain"), this.code = n.ERR_TX_CHAIN_MISMATCH;
                    }
                }
                t.ChainMismatchError = p;
                class m extends o.InvalidValueError {
                    constructor(e){
                        super(JSON.stringify(e), "hardfork doesnt match in tx.hardfork tx.common.hardfork"), this.code = n.ERR_TX_HARDFORK_MISMATCH;
                    }
                }
                t.HardforkMismatchError = m;
                class g extends o.InvalidValueError {
                    constructor(){
                        super("CommonOrChainAndHardforkError", "Please provide the common object or the chain and hardfork property but not all together."), this.code = n.ERR_TX_INVALID_CHAIN_INFO;
                    }
                }
                t.CommonOrChainAndHardforkError = g;
                class y extends o.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super("MissingChainOrHardforkError", `When specifying chain and hardfork, both values must be defined. Received "chain": ${null !== (t = e.chain) && void 0 !== t ? t : "undefined"}, "hardfork": ${null !== (r = e.hardfork) && void 0 !== r ? r : "undefined"}`), this.code = n.ERR_TX_MISSING_CHAIN_INFO;
                    }
                }
                t.MissingChainOrHardforkError = y;
                class v extends o.BaseWeb3Error {
                    constructor(){
                        super('Missing properties in transaction, either define "gas" and "gasPrice" for type 0 transactions or "gas", "maxPriorityFeePerGas" and "maxFeePerGas" for type 2 transactions'), this.code = n.ERR_TX_MISSING_GAS_INNER_ERROR;
                    }
                }
                t.MissingGasInnerError = v;
                class b extends o.InvalidValueError {
                    constructor(e){
                        var t, r, o, i;
                        super(`gas: ${null !== (t = e.gas) && void 0 !== t ? t : "undefined"}, gasPrice: ${null !== (r = e.gasPrice) && void 0 !== r ? r : "undefined"}, maxPriorityFeePerGas: ${null !== (o = e.maxPriorityFeePerGas) && void 0 !== o ? o : "undefined"}, maxFeePerGas: ${null !== (i = e.maxFeePerGas) && void 0 !== i ? i : "undefined"}`, '"gas" is missing'), this.code = n.ERR_TX_MISSING_GAS, this.cause = new v;
                    }
                }
                t.MissingGasError = b;
                class E extends o.BaseWeb3Error {
                    constructor(){
                        super('Missing properties in transaction, either define "gas" and "gasPrice" for type 0 transactions or "gas", "maxPriorityFeePerGas" and "maxFeePerGas" for type 2 transactions, not both'), this.code = n.ERR_TX_GAS_MISMATCH_INNER_ERROR;
                    }
                }
                t.TransactionGasMismatchInnerError = E;
                class _ extends o.InvalidValueError {
                    constructor(e){
                        var t, r, o, i;
                        super(`gas: ${null !== (t = e.gas) && void 0 !== t ? t : "undefined"}, gasPrice: ${null !== (r = e.gasPrice) && void 0 !== r ? r : "undefined"}, maxPriorityFeePerGas: ${null !== (o = e.maxPriorityFeePerGas) && void 0 !== o ? o : "undefined"}, maxFeePerGas: ${null !== (i = e.maxFeePerGas) && void 0 !== i ? i : "undefined"}`, "transaction must specify legacy or fee market gas properties, not both"), this.code = n.ERR_TX_GAS_MISMATCH, this.cause = new E;
                    }
                }
                t.TransactionGasMismatchError = _;
                class A extends o.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`gas: ${null !== (t = e.gas) && void 0 !== t ? t : "undefined"}, gasPrice: ${null !== (r = e.gasPrice) && void 0 !== r ? r : "undefined"}`, "Gas or gasPrice is lower than 0"), this.code = n.ERR_TX_INVALID_LEGACY_GAS;
                    }
                }
                t.InvalidGasOrGasPrice = A;
                class T extends o.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`maxPriorityFeePerGas: ${null !== (t = e.maxPriorityFeePerGas) && void 0 !== t ? t : "undefined"}, maxFeePerGas: ${null !== (r = e.maxFeePerGas) && void 0 !== r ? r : "undefined"}`, "maxPriorityFeePerGas or maxFeePerGas is lower than 0"), this.code = n.ERR_TX_INVALID_FEE_MARKET_GAS;
                    }
                }
                t.InvalidMaxPriorityFeePerGasOrMaxFeePerGas = T;
                class w extends o.InvalidValueError {
                    constructor(e){
                        super(e, "eip-1559 transactions don't support gasPrice"), this.code = n.ERR_TX_INVALID_FEE_MARKET_GAS_PRICE;
                    }
                }
                t.Eip1559GasPriceError = w;
                class I extends o.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`maxPriorityFeePerGas: ${null !== (t = e.maxPriorityFeePerGas) && void 0 !== t ? t : "undefined"}, maxFeePerGas: ${null !== (r = e.maxFeePerGas) && void 0 !== r ? r : "undefined"}`, "pre-eip-1559 transaction don't support maxFeePerGas/maxPriorityFeePerGas"), this.code = n.ERR_TX_INVALID_LEGACY_FEE_MARKET;
                    }
                }
                t.UnsupportedFeeMarketError = I;
                class R extends o.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction object"), this.code = n.ERR_TX_INVALID_OBJECT;
                    }
                }
                t.InvalidTransactionObjectError = R;
                class P extends o.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`nonce: ${null !== (t = e.nonce) && void 0 !== t ? t : "undefined"}, chainId: ${null !== (r = e.chainId) && void 0 !== r ? r : "undefined"}`, "Nonce or chainId is lower than 0"), this.code = n.ERR_TX_INVALID_NONCE_OR_CHAIN_ID;
                    }
                }
                t.InvalidNonceOrChainIdError = P;
                class x extends o.InvalidValueError {
                    constructor(){
                        super("UnableToPopulateNonceError", "unable to populate nonce, no from address available"), this.code = n.ERR_TX_UNABLE_TO_POPULATE_NONCE;
                    }
                }
                t.UnableToPopulateNonceError = x;
                class O extends o.InvalidValueError {
                    constructor(){
                        super("Eip1559NotSupportedError", "Network doesn't support eip-1559"), this.code = n.ERR_TX_UNSUPPORTED_EIP_1559;
                    }
                }
                t.Eip1559NotSupportedError = O;
                class S extends o.InvalidValueError {
                    constructor(e){
                        super(e, "unsupported transaction type"), this.code = n.ERR_TX_UNSUPPORTED_TYPE;
                    }
                }
                t.UnsupportedTransactionTypeError = S;
                class C extends o.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`data: ${null !== (t = e.data) && void 0 !== t ? t : "undefined"}, input: ${null !== (r = e.input) && void 0 !== r ? r : "undefined"}`, 'You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.'), this.code = n.ERR_TX_DATA_AND_INPUT;
                    }
                }
                t.TransactionDataAndInputError = C;
                class B extends o.BaseWeb3Error {
                    constructor(e){
                        super(`The connected Ethereum Node did not respond within ${e.numberOfSeconds} seconds, please make sure your transaction was properly sent and you are connected to a healthy Node. Be aware that transaction might still be pending or mined!\n\tTransaction Hash: ${e.transactionHash ? e.transactionHash.toString() : "not available"}`), this.code = n.ERR_TX_SEND_TIMEOUT;
                    }
                }
                function k(e) {
                    return `Please make sure your transaction was properly sent and there are no previous pending transaction for the same account. However, be aware that it might still be mined!\n\tTransaction Hash: ${e ? e.toString() : "not available"}`;
                }
                t.TransactionSendTimeoutError = B;
                class N extends o.BaseWeb3Error {
                    constructor(e){
                        super(`Transaction was not mined within ${e.numberOfSeconds} seconds. ${k(e.transactionHash)}`), this.code = n.ERR_TX_POLLING_TIMEOUT;
                    }
                }
                t.TransactionPollingTimeoutError = N;
                class M extends o.BaseWeb3Error {
                    constructor(e){
                        super(`Transaction started at ${e.starterBlockNumber} but was not mined within ${e.numberOfBlocks} blocks. ${k(e.transactionHash)}`), this.code = n.ERR_TX_BLOCK_TIMEOUT;
                    }
                }
                t.TransactionBlockTimeoutError = M;
                class L extends o.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`receipt: ${JSON.stringify(e.receipt)}, blockHash: ${null === (t = e.blockHash) || void 0 === t ? void 0 : t.toString()}, transactionHash: ${null === (r = e.transactionHash) || void 0 === r ? void 0 : r.toString()}`, "Receipt missing or blockHash null"), this.code = n.ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL;
                    }
                }
                t.TransactionMissingReceiptOrBlockHashError = L;
                class D extends o.InvalidValueError {
                    constructor(e){
                        super(`receipt: ${JSON.stringify(e.receipt)}`, "Receipt missing block number"), this.code = n.ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER;
                    }
                }
                t.TransactionReceiptMissingBlockNumberError = D;
                class F extends o.BaseWeb3Error {
                    constructor(e){
                        super(`Invalid signature. "${e}"`), this.code = n.ERR_TX_SIGNING;
                    }
                }
                t.TransactionSigningError = F;
                class H extends o.InvalidValueError {
                    constructor(){
                        super("LocalWalletNotAvailableError", "Attempted to index account in local wallet, but no wallet is available"), this.code = n.ERR_TX_LOCAL_WALLET_NOT_AVAILABLE;
                    }
                }
                t.LocalWalletNotAvailableError = H;
                class j extends o.BaseWeb3Error {
                    constructor(e, t){
                        const r = [];
                        e.forEach((e)=>r.push(e.keyword)), super(`The following properties are invalid for the transaction type ${t}: ${r.join(", ")}`), this.code = n.ERR_TX_INVALID_PROPERTIES_FOR_TYPE;
                    }
                }
                t.InvalidPropertiesForTransactionTypeError = j;
            },
            4618: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidTypeAbiInputError = t.InvalidBlockError = t.InvalidLargeValueError = t.InvalidSizeError = t.InvalidUnsignedIntegerError = t.InvalidBooleanError = t.InvalidTypeError = t.NibbleWidthError = t.HexProcessingError = t.InvalidIntegerError = t.InvalidUnitError = t.InvalidStringError = t.InvalidAddressError = t.InvalidNumberError = t.InvalidBytesError = void 0;
                const n = r(7639), o = r(3685);
                class i extends o.InvalidValueError {
                    constructor(e){
                        super(e, "can not parse as byte data"), this.code = n.ERR_INVALID_BYTES;
                    }
                }
                t.InvalidBytesError = i;
                class s extends o.InvalidValueError {
                    constructor(e){
                        super(e, "can not parse as number data"), this.code = n.ERR_INVALID_NUMBER;
                    }
                }
                t.InvalidNumberError = s;
                class a extends o.InvalidValueError {
                    constructor(e){
                        super(e, "invalid ethereum address"), this.code = n.ERR_INVALID_ADDRESS;
                    }
                }
                t.InvalidAddressError = a;
                class c extends o.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid string"), this.code = n.ERR_INVALID_STRING;
                    }
                }
                t.InvalidStringError = c;
                class u extends o.InvalidValueError {
                    constructor(e){
                        super(e, "invalid unit"), this.code = n.ERR_INVALID_UNIT;
                    }
                }
                t.InvalidUnitError = u;
                class d extends o.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid unit. Must be a positive integer"), this.code = n.ERR_INVALID_INTEGER;
                    }
                }
                t.InvalidIntegerError = d;
                class l extends o.InvalidValueError {
                    constructor(e){
                        super(e, "can not be converted to hex"), this.code = n.ERR_INVALID_HEX;
                    }
                }
                t.HexProcessingError = l;
                class h extends o.InvalidValueError {
                    constructor(e){
                        super(e, "value greater than the nibble width"), this.code = n.ERR_INVALID_NIBBLE_WIDTH;
                    }
                }
                t.NibbleWidthError = h;
                class f extends o.InvalidValueError {
                    constructor(e){
                        super(e, "invalid type, type not supported"), this.code = n.ERR_INVALID_TYPE;
                    }
                }
                t.InvalidTypeError = f;
                class p extends o.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid boolean."), this.code = n.ERR_INVALID_BOOLEAN;
                    }
                }
                t.InvalidBooleanError = p;
                class m extends o.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid unsigned integer."), this.code = n.ERR_INVALID_UNSIGNED_INTEGER;
                    }
                }
                t.InvalidUnsignedIntegerError = m;
                class g extends o.InvalidValueError {
                    constructor(e){
                        super(e, "invalid size given."), this.code = n.ERR_INVALID_SIZE;
                    }
                }
                t.InvalidSizeError = g;
                class y extends o.InvalidValueError {
                    constructor(e){
                        super(e, "value is larger than size."), this.code = n.ERR_INVALID_LARGE_VALUE;
                    }
                }
                t.InvalidLargeValueError = y;
                class v extends o.InvalidValueError {
                    constructor(e){
                        super(e, "invalid string given"), this.code = n.ERR_INVALID_BLOCK;
                    }
                }
                t.InvalidBlockError = v;
                class b extends o.InvalidValueError {
                    constructor(e){
                        super(e, "components found but type is not tuple"), this.code = n.ERR_INVALID_TYPE_ABI;
                    }
                }
                t.InvalidTypeAbiInputError = b;
            },
            5071: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(r(7639), t), o(r(3685), t), o(r(8105), t), o(r(3789), t), o(r(510), t), o(r(1591), t), o(r(7297), t), o(r(7108), t), o(r(1075), t), o(r(8450), t), o(r(4618), t), o(r(9491), t), o(r(3628), t), o(r(655), t), o(r(4032), t), o(r(1066), t);
            },
            3685: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidValueError = t.MultipleErrors = t.BaseWeb3Error = void 0;
                const n = r(7639);
                class o extends Error {
                    constructor(e, t){
                        super(e), Array.isArray(t) ? this.cause = new i(t) : this.cause = t, this.name = this.constructor.name, "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(new.target.constructor) : this.stack = (new Error).stack;
                    }
                    get innerError() {
                        return this.cause instanceof i ? this.cause.errors : this.cause;
                    }
                    set innerError(e) {
                        Array.isArray(e) ? this.cause = new i(e) : this.cause = e;
                    }
                    static convertToString(e, t = !1) {
                        if (null == e) return "undefined";
                        const r = JSON.stringify(e, (e, t)=>"bigint" == typeof t ? t.toString() : t);
                        return t && [
                            "bigint",
                            "string"
                        ].includes(typeof e) ? r.replace(/['\\"]+/g, "") : r;
                    }
                    toJSON() {
                        return {
                            name: this.name,
                            code: this.code,
                            message: this.message,
                            cause: this.cause,
                            innerError: this.cause
                        };
                    }
                }
                t.BaseWeb3Error = o;
                class i extends o {
                    constructor(e){
                        super(`Multiple errors occurred: [${e.map((e)=>e.message).join("], [")}]`), this.code = n.ERR_MULTIPLE_ERRORS, this.errors = e;
                    }
                }
                t.MultipleErrors = i, t.InvalidValueError = class extends o {
                    constructor(e, t){
                        super(`Invalid value given "${o.convertToString(e, !0)}". Error: ${t}.`), this.name = this.constructor.name;
                    }
                };
            },
            9722: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeErrorSignature = void 0;
                const n = r(9634), o = r(5071), i = r(1583);
                t.encodeErrorSignature = (e)=>{
                    if ("string" != typeof e && !(0, i.isAbiErrorFragment)(e)) throw new o.AbiError("Invalid parameter value in encodeErrorSignature");
                    let t;
                    return t = !e || "function" != typeof e && "object" != typeof e ? e : (0, i.jsonInterfaceMethodToString)(e), (0, n.sha3Raw)(t);
                };
            },
            5893: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeEventSignature = void 0;
                const n = r(9634), o = r(5071), i = r(1583);
                t.encodeEventSignature = (e)=>{
                    if ("string" != typeof e && !(0, i.isAbiEventFragment)(e)) throw new o.AbiError("Invalid parameter value in encodeEventSignature");
                    let t;
                    return t = !e || "function" != typeof e && "object" != typeof e ? e : (0, i.jsonInterfaceMethodToString)(e), (0, n.sha3Raw)(t);
                };
            },
            3249: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeFunctionCall = t.encodeFunctionSignature = void 0;
                const n = r(5071), o = r(9634), i = r(1583), s = r(4566);
                t.encodeFunctionSignature = (e)=>{
                    if ("string" != typeof e && !(0, i.isAbiFunctionFragment)(e)) throw new n.AbiError("Invalid parameter value in encodeFunctionSignature");
                    let t;
                    return t = !e || "function" != typeof e && "object" != typeof e ? e : (0, i.jsonInterfaceMethodToString)(e), (0, o.sha3Raw)(t).slice(0, 10);
                }, t.encodeFunctionCall = (e, r)=>{
                    var o;
                    if (!(0, i.isAbiFunctionFragment)(e)) throw new n.AbiError("Invalid parameter value in encodeFunctionCall");
                    return `${(0, t.encodeFunctionSignature)(e)}${(0, s.encodeParameters)(null !== (o = e.inputs) && void 0 !== o ? o : [], null != r ? r : []).replace("0x", "")}`;
                };
            },
            734: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeLog = void 0;
                const n = r(4566), o = [
                    "bool",
                    "string",
                    "int",
                    "uint",
                    "address",
                    "fixed",
                    "ufixed"
                ];
                t.decodeLog = (e, t, r)=>{
                    const i = Array.isArray(r) ? r : [
                        r
                    ], s = {}, a = {};
                    for (const [t, r] of e.entries())r.indexed ? s[t] = r : a[t] = r;
                    const c = t ? (0, n.decodeParametersWith)(Object.values(a), t, !0) : {
                        __length__: 0
                    }, u = i.length - Object.keys(s).length, d = Object.values(s).map((e, t)=>{
                        var r, s;
                        return o.some((t)=>e.type.startsWith(t)) ? (r = e.type, s = i[t + u], "string" === r ? s : (0, n.decodeParameter)(r, s)) : i[t + u];
                    }), l = {
                        __length__: 0
                    };
                    let h = 0, f = 0;
                    for (const [t, r] of e.entries())l[t] = "string" === r.type ? "" : void 0, s[t] && (l[t] = d[h], h += 1), a[t] && (l[t] = c[String(f)], f += 1), r.name && (l[r.name] = l[t]), l.__length__ += 1;
                    return l;
                };
            },
            4566: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeParameter = t.decodeParameters = t.decodeParametersWith = t.encodeParameter = t.inferTypesAndEncodeParameters = t.encodeParameters = void 0;
                const n = r(5071), o = r(6729), i = r(4581);
                var s = r(4581);
                Object.defineProperty(t, "encodeParameters", {
                    enumerable: !0,
                    get: function() {
                        return s.encodeParameters;
                    }
                }), Object.defineProperty(t, "inferTypesAndEncodeParameters", {
                    enumerable: !0,
                    get: function() {
                        return s.inferTypesAndEncodeParameters;
                    }
                }), t.encodeParameter = (e, t)=>(0, i.encodeParameters)([
                        e
                    ], [
                        t
                    ]), t.decodeParametersWith = (e, t, r)=>{
                    try {
                        if (e.length > 0 && (!t || "0x" === t || "0X" === t)) throw new n.AbiError("Returned values aren't valid, did it run Out of Gas? You might also see this error if you are not using the correct ABI for the contract you are retrieving data from, requesting data from a block number that does not exist, or querying a node which is not fully synced.");
                        return (0, o.decodeParameters)(e, `0x${t.replace(/0x/i, "")}`, r);
                    } catch (e) {
                        throw new n.AbiError(`Parameter decoding error: ${e.message}`, {
                            internalErr: e
                        });
                    }
                }, t.decodeParameters = (e, r)=>(0, t.decodeParametersWith)(e, r, !1), t.decodeParameter = (e, r)=>(0, t.decodeParameters)([
                        e
                    ], r)[0];
            },
            1691: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeAddress = t.encodeAddress = void 0;
                const n = r(5071), o = r(9634), i = r(7345), s = r(3852), a = s.WORD_SIZE - 20;
                t.encodeAddress = function(e, t) {
                    if ("string" != typeof t) throw new n.AbiError("address type expects string as input type", {
                        value: t,
                        name: e.name,
                        type: e.type
                    });
                    let r = t.toLowerCase();
                    if (r.startsWith("0x") || (r = `0x${r}`), !(0, i.isAddress)(r)) throw new n.AbiError("provided input is not valid address", {
                        value: t,
                        name: e.name,
                        type: e.type
                    });
                    const o = i.utils.hexToUint8Array(r), c = (0, s.alloc)(s.WORD_SIZE);
                    return c.set(o, a), {
                        dynamic: !1,
                        encoded: c
                    };
                }, t.decodeAddress = function(e, t) {
                    const r = t.subarray(a, s.WORD_SIZE);
                    if (20 !== r.length) throw new n.AbiError("Invalid decoding input, not enough bytes to decode address", {
                        bytes: t
                    });
                    const c = i.utils.uint8ArrayToHexString(r);
                    return {
                        result: (0, o.toChecksumAddress)(c),
                        encoded: t.subarray(s.WORD_SIZE),
                        consumed: s.WORD_SIZE
                    };
                };
            },
            7064: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeArray = t.encodeArray = void 0;
                const n = r(5071), o = r(9634), i = r(5555), s = r(3852), a = r(8809), c = r(5433);
                t.encodeArray = function(e, t) {
                    if (!Array.isArray(t)) throw new n.AbiError("Expected value to be array", {
                        abi: e,
                        values: t
                    });
                    const { size: r, param: a } = (0, s.extractArrayType)(e), u = t.map((e)=>(0, i.encodeParamFromAbiParameter)(a, e)), d = -1 === r, l = u.length > 0 && u[0].dynamic;
                    if (!d && t.length !== r) throw new n.AbiError("Given arguments count doesn't match array length", {
                        arrayLength: r,
                        argumentsLength: t.length
                    });
                    if (d || l) {
                        const e = (0, c.encodeDynamicParams)(u);
                        if (d) {
                            const t = (0, i.encodeNumber)({
                                type: "uint256",
                                name: ""
                            }, u.length).encoded;
                            return {
                                dynamic: !0,
                                encoded: u.length > 0 ? (0, o.uint8ArrayConcat)(t, e) : t
                            };
                        }
                        return {
                            dynamic: !0,
                            encoded: e
                        };
                    }
                    return {
                        dynamic: !1,
                        encoded: (0, o.uint8ArrayConcat)(...u.map((e)=>e.encoded))
                    };
                }, t.decodeArray = function(e, t) {
                    let { size: r, param: n } = (0, s.extractArrayType)(e), o = 0;
                    const c = [];
                    let u = t;
                    if (-1 === r) {
                        const e = (0, a.decodeNumber)({
                            type: "uint32",
                            name: ""
                        }, t);
                        r = Number(e.result), o = e.consumed, u = e.encoded;
                    }
                    if ((0, s.isDynamic)(n)) {
                        for(let e = 0; e < r; e += 1){
                            const t = (0, a.decodeNumber)({
                                type: "uint32",
                                name: ""
                            }, u.subarray(e * s.WORD_SIZE));
                            o += t.consumed;
                            const r = (0, i.decodeParamFromAbiParameter)(n, u.subarray(Number(t.result)));
                            o += r.consumed, c.push(r.result);
                        }
                        return {
                            result: c,
                            encoded: u.subarray(o),
                            consumed: o
                        };
                    }
                    for(let e = 0; e < r; e += 1){
                        const e = (0, i.decodeParamFromAbiParameter)(n, t.subarray(o));
                        o += e.consumed, c.push(e.result);
                    }
                    return {
                        result: c,
                        encoded: t.subarray(o),
                        consumed: o
                    };
                };
            },
            2252: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeBool = t.encodeBoolean = void 0;
                const n = r(5071), o = r(9634), i = r(3852), s = r(8809);
                t.encodeBoolean = function(e, t) {
                    let r;
                    try {
                        r = (0, o.toBool)(t);
                    } catch (r) {
                        if (r instanceof n.InvalidBooleanError) throw new n.AbiError("provided input is not valid boolean value", {
                            type: e.type,
                            value: t,
                            name: e.name
                        });
                    }
                    return (0, s.encodeNumber)({
                        type: "uint8",
                        name: ""
                    }, Number(r));
                }, t.decodeBool = function(e, t) {
                    const r = (0, s.decodeNumber)({
                        type: "uint8",
                        name: ""
                    }, t);
                    if (r.result > 1 || r.result < 0) throw new n.AbiError("Invalid boolean value encoded", {
                        boolBytes: t.subarray(0, i.WORD_SIZE),
                        numberResult: r
                    });
                    return {
                        result: r.result === BigInt(1),
                        encoded: r.encoded,
                        consumed: i.WORD_SIZE
                    };
                };
            },
            7144: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeBytes = t.encodeBytes = void 0;
                const n = r(5071), o = r(9634), i = r(7345), s = r(3852), a = r(8809);
                t.encodeBytes = function(e, t) {
                    if ("string" == typeof t && t.length % 2 != 0 && (t += "0"), !(0, i.isBytes)(t)) throw new n.AbiError("provided input is not valid bytes value", {
                        type: e.type,
                        value: t,
                        name: e.name
                    });
                    const r = (0, o.bytesToUint8Array)(t), [, c] = e.type.split("bytes");
                    if (c) {
                        if (Number(c) > 32 || Number(c) < 1) throw new n.AbiError("invalid bytes type. Static byte type can have between 1 and 32 bytes", {
                            type: e.type
                        });
                        if (Number(c) < r.length) throw new n.AbiError("provided input size is different than type size", {
                            type: e.type,
                            value: t,
                            name: e.name
                        });
                        const o = (0, s.alloc)(s.WORD_SIZE);
                        return o.set(r), {
                            dynamic: !1,
                            encoded: o
                        };
                    }
                    const u = Math.ceil(r.length / s.WORD_SIZE), d = (0, s.alloc)(s.WORD_SIZE + u * s.WORD_SIZE);
                    return d.set((0, a.encodeNumber)({
                        type: "uint32",
                        name: ""
                    }, r.length).encoded), d.set(r, s.WORD_SIZE), {
                        dynamic: !0,
                        encoded: d
                    };
                }, t.decodeBytes = function(e, t) {
                    const [, r] = e.type.split("bytes");
                    let i = Number(r), c = t, u = 1, d = 0;
                    if (!i) {
                        const e = (0, a.decodeNumber)({
                            type: "uint32",
                            name: ""
                        }, c);
                        i = Number(e.result), d += e.consumed, c = e.encoded, u = Math.ceil(i / s.WORD_SIZE);
                    }
                    if (i > t.length) throw new n.AbiError("there is not enough data to decode", {
                        type: e.type,
                        encoded: t,
                        size: i
                    });
                    return {
                        result: (0, o.bytesToHex)(c.subarray(0, i)),
                        encoded: c.subarray(u * s.WORD_SIZE),
                        consumed: d + u * s.WORD_SIZE
                    };
                };
            },
            5555: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeParamFromAbiParameter = t.encodeParamFromAbiParameter = t.decodeArray = t.encodeArray = t.decodeTuple = t.encodeTuple = t.decodeString = t.encodeString = t.decodeNumber = t.encodeNumber = t.decodeBytes = t.encodeBytes = t.decodeBool = t.encodeBoolean = t.decodeAddress = t.encodeAddress = void 0;
                const n = r(5071), o = r(1691), i = r(2252), s = r(7144), a = r(8809), c = r(8574), u = r(4759), d = r(7064);
                var l = r(1691);
                Object.defineProperty(t, "encodeAddress", {
                    enumerable: !0,
                    get: function() {
                        return l.encodeAddress;
                    }
                }), Object.defineProperty(t, "decodeAddress", {
                    enumerable: !0,
                    get: function() {
                        return l.decodeAddress;
                    }
                });
                var h = r(2252);
                Object.defineProperty(t, "encodeBoolean", {
                    enumerable: !0,
                    get: function() {
                        return h.encodeBoolean;
                    }
                }), Object.defineProperty(t, "decodeBool", {
                    enumerable: !0,
                    get: function() {
                        return h.decodeBool;
                    }
                });
                var f = r(7144);
                Object.defineProperty(t, "encodeBytes", {
                    enumerable: !0,
                    get: function() {
                        return f.encodeBytes;
                    }
                }), Object.defineProperty(t, "decodeBytes", {
                    enumerable: !0,
                    get: function() {
                        return f.decodeBytes;
                    }
                });
                var p = r(8809);
                Object.defineProperty(t, "encodeNumber", {
                    enumerable: !0,
                    get: function() {
                        return p.encodeNumber;
                    }
                }), Object.defineProperty(t, "decodeNumber", {
                    enumerable: !0,
                    get: function() {
                        return p.decodeNumber;
                    }
                });
                var m = r(8574);
                Object.defineProperty(t, "encodeString", {
                    enumerable: !0,
                    get: function() {
                        return m.encodeString;
                    }
                }), Object.defineProperty(t, "decodeString", {
                    enumerable: !0,
                    get: function() {
                        return m.decodeString;
                    }
                });
                var g = r(4759);
                Object.defineProperty(t, "encodeTuple", {
                    enumerable: !0,
                    get: function() {
                        return g.encodeTuple;
                    }
                }), Object.defineProperty(t, "decodeTuple", {
                    enumerable: !0,
                    get: function() {
                        return g.decodeTuple;
                    }
                });
                var y = r(7064);
                Object.defineProperty(t, "encodeArray", {
                    enumerable: !0,
                    get: function() {
                        return y.encodeArray;
                    }
                }), Object.defineProperty(t, "decodeArray", {
                    enumerable: !0,
                    get: function() {
                        return y.decodeArray;
                    }
                }), t.encodeParamFromAbiParameter = function(e, t) {
                    if ("string" === e.type) return (0, c.encodeString)(e, t);
                    if ("bool" === e.type) return (0, i.encodeBoolean)(e, t);
                    if ("address" === e.type) return (0, o.encodeAddress)(e, t);
                    if ("tuple" === e.type) return (0, u.encodeTuple)(e, t);
                    if (e.type.endsWith("]")) return (0, d.encodeArray)(e, t);
                    if (e.type.startsWith("bytes")) return (0, s.encodeBytes)(e, t);
                    if (e.type.startsWith("uint") || e.type.startsWith("int")) return (0, a.encodeNumber)(e, t);
                    throw new n.AbiError("Unsupported", {
                        param: e,
                        value: t
                    });
                }, t.decodeParamFromAbiParameter = function(e, t) {
                    if ("string" === e.type) return (0, c.decodeString)(e, t);
                    if ("bool" === e.type) return (0, i.decodeBool)(e, t);
                    if ("address" === e.type) return (0, o.decodeAddress)(e, t);
                    if ("tuple" === e.type) return (0, u.decodeTuple)(e, t);
                    if (e.type.endsWith("]")) return (0, d.decodeArray)(e, t);
                    if (e.type.startsWith("bytes")) return (0, s.decodeBytes)(e, t);
                    if (e.type.startsWith("uint") || e.type.startsWith("int")) return (0, a.decodeNumber)(e, t);
                    throw new n.AbiError("Unsupported", {
                        param: e,
                        bytes: t
                    });
                };
            },
            8809: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeNumber = t.encodeNumber = void 0;
                const n = r(5071), o = r(9634), i = r(7345), s = r(3852), a = r(5978), c = BigInt(1) << BigInt(256);
                function u(e, t = s.WORD_SIZE) {
                    let r;
                    return r = e < 0 ? (c + e).toString(16) : e.toString(16), r = (0, o.padLeft)(r, 2 * t), i.utils.hexToUint8Array(r);
                }
                t.encodeNumber = function(e, t) {
                    let r;
                    try {
                        r = (0, o.toBigInt)(t);
                    } catch (r) {
                        throw new n.AbiError("provided input is not number value", {
                            type: e.type,
                            value: t,
                            name: e.name
                        });
                    }
                    const i = a.numberLimits.get(e.type);
                    if (!i) throw new n.AbiError("provided abi contains invalid number datatype", {
                        type: e.type
                    });
                    if (r < i.min) throw new n.AbiError("provided input is less then minimum for given type", {
                        type: e.type,
                        value: t,
                        name: e.name,
                        minimum: i.min.toString()
                    });
                    if (r > i.max) throw new n.AbiError("provided input is greater then maximum for given type", {
                        type: e.type,
                        value: t,
                        name: e.name,
                        maximum: i.max.toString()
                    });
                    return {
                        dynamic: !1,
                        encoded: u(r)
                    };
                }, t.decodeNumber = function(e, t) {
                    if (t.length < s.WORD_SIZE) throw new n.AbiError("Not enough bytes left to decode", {
                        param: e,
                        bytesLeft: t.length
                    });
                    const r = t.subarray(0, s.WORD_SIZE), o = a.numberLimits.get(e.type);
                    if (!o) throw new n.AbiError("provided abi contains invalid number datatype", {
                        type: e.type
                    });
                    const u = function(e, t) {
                        const r = i.utils.uint8ArrayToHexString(e), n = BigInt(r);
                        return n <= t ? n : n - c;
                    }(r, o.max);
                    if (u < o.min) throw new n.AbiError("decoded value is less then minimum for given type", {
                        type: e.type,
                        value: u,
                        name: e.name,
                        minimum: o.min.toString()
                    });
                    if (u > o.max) throw new n.AbiError("decoded value is greater then maximum for given type", {
                        type: e.type,
                        value: u,
                        name: e.name,
                        maximum: o.max.toString()
                    });
                    return {
                        result: u,
                        encoded: t.subarray(s.WORD_SIZE),
                        consumed: s.WORD_SIZE
                    };
                };
            },
            5978: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.numberLimits = void 0, t.numberLimits = new Map;
                let r = BigInt(256);
                for(let e = 8; e <= 256; e += 8)t.numberLimits.set(`uint${e}`, {
                    min: BigInt(0),
                    max: r - BigInt(1)
                }), t.numberLimits.set(`int${e}`, {
                    min: -r / BigInt(2),
                    max: r / BigInt(2) - BigInt(1)
                }), r *= BigInt(256);
                t.numberLimits.set("int", t.numberLimits.get("int256")), t.numberLimits.set("uint", t.numberLimits.get("uint256"));
            },
            8574: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeString = t.encodeString = void 0;
                const n = r(5071), o = r(9634), i = r(7144);
                t.encodeString = function(e, t) {
                    if ("string" != typeof t) throw new n.AbiError("invalid input, should be string", {
                        input: t
                    });
                    const r = (0, o.utf8ToBytes)(t);
                    return (0, i.encodeBytes)({
                        type: "bytes",
                        name: ""
                    }, r);
                }, t.decodeString = function(e, t) {
                    const r = (0, i.decodeBytes)({
                        type: "bytes",
                        name: ""
                    }, t);
                    return {
                        result: (0, o.hexToUtf8)(r.result),
                        encoded: r.encoded,
                        consumed: r.consumed
                    };
                };
            },
            4759: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeTuple = t.encodeTuple = void 0;
                const n = r(5071), o = r(9634), i = r(5555), s = r(5433), a = r(3852), c = r(8809);
                t.encodeTuple = function(e, t) {
                    var r, a, c;
                    let u = !1;
                    if (!Array.isArray(t) && "object" != typeof t) throw new n.AbiError("param must be either Array or Object", {
                        param: e,
                        input: t
                    });
                    const d = t, l = [];
                    for(let o = 0; o < (null !== (a = null === (r = e.components) || void 0 === r ? void 0 : r.length) && void 0 !== a ? a : 0); o += 1){
                        const r = e.components[o];
                        let s;
                        if (Array.isArray(d)) {
                            if (o >= d.length) throw new n.AbiError("input param length missmatch", {
                                param: e,
                                input: t
                            });
                            s = (0, i.encodeParamFromAbiParameter)(r, d[o]);
                        } else {
                            const o = d[null !== (c = r.name) && void 0 !== c ? c : ""];
                            if (null == o) throw new n.AbiError("missing input defined in abi", {
                                param: e,
                                input: t,
                                paramName: r.name
                            });
                            s = (0, i.encodeParamFromAbiParameter)(r, o);
                        }
                        s.dynamic && (u = !0), l.push(s);
                    }
                    return u ? {
                        dynamic: !0,
                        encoded: (0, s.encodeDynamicParams)(l)
                    } : {
                        dynamic: !1,
                        encoded: (0, o.uint8ArrayConcat)(...l.map((e)=>e.encoded))
                    };
                }, t.decodeTuple = function(e, t) {
                    const r = {
                        __length__: 0
                    };
                    let n = 0;
                    if (!e.components) return {
                        result: r,
                        encoded: t,
                        consumed: n
                    };
                    let o = 0;
                    for (const [s, u] of e.components.entries()){
                        let e;
                        if ((0, a.isDynamic)(u)) {
                            const r = (0, c.decodeNumber)({
                                type: "uint32",
                                name: ""
                            }, t.subarray(n));
                            e = (0, i.decodeParamFromAbiParameter)(u, t.subarray(Number(r.result))), n += r.consumed, o += e.consumed;
                        } else e = (0, i.decodeParamFromAbiParameter)(u, t.subarray(n)), n += e.consumed;
                        r.__length__ += 1, r[s] = e.result, u.name && "" !== u.name && (r[u.name] = e.result);
                    }
                    return {
                        encoded: t.subarray(n + o),
                        result: r,
                        consumed: n + o
                    };
                };
            },
            5433: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeDynamicParams = void 0;
                const n = r(9634), o = r(3852), i = r(8809);
                t.encodeDynamicParams = function(e) {
                    let t = 0, r = 0;
                    const s = [], a = [];
                    for (const r of e)r.dynamic ? t += o.WORD_SIZE : t += r.encoded.length;
                    for (const n of e)n.dynamic ? (s.push((0, i.encodeNumber)({
                        type: "uint256",
                        name: ""
                    }, t + r)), a.push(n), r += n.encoded.length) : s.push(n);
                    return (0, n.uint8ArrayConcat)(...s.map((e)=>e.encoded), ...a.map((e)=>e.encoded));
                };
            },
            6729: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeParameters = void 0;
                const n = r(7345), o = r(4759), i = r(3852);
                t.decodeParameters = function(e, t, r) {
                    const s = (0, i.toAbiParams)(e), a = n.utils.hexToUint8Array(t);
                    return (0, o.decodeTuple)({
                        type: "tuple",
                        name: "",
                        components: s
                    }, a).result;
                };
            },
            4581: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.inferTypesAndEncodeParameters = t.encodeParameters = void 0;
                const n = r(5071), o = r(9634), i = r(7345), s = r(5555), a = r(3852);
                function c(e) {
                    const t = [];
                    return e.forEach((e)=>{
                        if (Array.isArray(e)) {
                            const r = c(e);
                            t.push({
                                type: "tuple",
                                components: r,
                                name: ""
                            });
                        } else t.push({
                            type: (0, o.toHex)(e, !0)
                        });
                    }), t;
                }
                t.encodeParameters = function(e, t) {
                    if ((null == e ? void 0 : e.length) !== t.length) throw new n.AbiError("Invalid number of values received for given ABI", {
                        expected: null == e ? void 0 : e.length,
                        received: t.length
                    });
                    const r = (0, a.toAbiParams)(e);
                    return i.utils.uint8ArrayToHexString((0, s.encodeTuple)({
                        type: "tuple",
                        name: "",
                        components: r
                    }, t).encoded);
                }, t.inferTypesAndEncodeParameters = function(e) {
                    try {
                        const t = c(e);
                        return i.utils.uint8ArrayToHexString((0, s.encodeTuple)({
                            type: "tuple",
                            name: "",
                            components: t
                        }, e).encoded);
                    } catch (t) {
                        throw new n.AbiError("Could not infer types from given params", {
                            params: e
                        });
                    }
                };
            },
            3852: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isDynamic = t.extractArrayType = t.toAbiParams = t.isAbiParameter = t.convertExternalAbiParameter = t.allocUnsafe = t.alloc = t.WORD_SIZE = void 0;
                const n = r(1655), o = r(5071), i = r(9634), s = r(1583);
                function a(e) {
                    var t, r;
                    return Object.assign(Object.assign({}, e), {
                        name: null !== (t = e.name) && void 0 !== t ? t : "",
                        components: null === (r = e.components) || void 0 === r ? void 0 : r.map((e)=>a(e))
                    });
                }
                function c(e) {
                    return !(0, i.isNullish)(e) && "object" == typeof e && !(0, i.isNullish)(e.type) && "string" == typeof e.type;
                }
                function u(e) {
                    const t = e.type.lastIndexOf("["), r = e.type.substring(0, t), n = e.type.substring(t);
                    let i = -1;
                    if ("[]" !== n && (i = Number(n.slice(1, -1)), isNaN(i))) throw new o.AbiError("Invalid fixed array size", {
                        size: n
                    });
                    return {
                        param: {
                            type: r,
                            name: "",
                            components: e.components
                        },
                        size: i
                    };
                }
                t.WORD_SIZE = 32, t.alloc = function(e = 0) {
                    var t;
                    if (void 0 !== (null === (t = globalThis.Buffer) || void 0 === t ? void 0 : t.alloc)) {
                        const t = globalThis.Buffer.alloc(e);
                        return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
                    }
                    return new Uint8Array(e);
                }, t.allocUnsafe = function(e = 0) {
                    var t;
                    if (void 0 !== (null === (t = globalThis.Buffer) || void 0 === t ? void 0 : t.allocUnsafe)) {
                        const t = globalThis.Buffer.allocUnsafe(e);
                        return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
                    }
                    return new Uint8Array(e);
                }, t.convertExternalAbiParameter = a, t.isAbiParameter = c, t.toAbiParams = function(e) {
                    return e.map((e)=>{
                        var t;
                        if (c(e)) return e;
                        if ("string" == typeof e) return a((0, n.parseAbiParameter)(e.replace(/tuple/, "")));
                        if ((0, s.isSimplifiedStructFormat)(e)) {
                            const r = Object.keys(e)[0], n = (0, s.mapStructNameAndType)(r);
                            return n.name = null !== (t = n.name) && void 0 !== t ? t : "", Object.assign(Object.assign({}, n), {
                                components: (0, s.mapStructToCoderFormat)(e[r])
                            });
                        }
                        throw new o.AbiError("Invalid abi");
                    });
                }, t.extractArrayType = u, t.isDynamic = function e(t) {
                    var r, n;
                    return !("string" !== t.type && "bytes" !== t.type && !t.type.endsWith("[]")) || ("tuple" === t.type ? null !== (n = null === (r = t.components) || void 0 === r ? void 0 : r.some(e)) && void 0 !== n && n : !!t.type.endsWith("]") && e(u(t).param));
                };
            },
            5610: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeContractErrorData = void 0;
                const n = r(9722), o = r(4566), i = r(1583);
                t.decodeContractErrorData = (e, t)=>{
                    if (null == t ? void 0 : t.data) {
                        let r, s, a;
                        try {
                            const c = t.data.slice(0, 10), u = e.find((e)=>(0, n.encodeErrorSignature)(e).startsWith(c));
                            (null == u ? void 0 : u.inputs) && (r = u.name, s = (0, i.jsonInterfaceMethodToString)(u), a = (0, o.decodeParameters)([
                                ...u.inputs
                            ], t.data.substring(10)));
                        } catch (e) {
                            console.error(e);
                        }
                        r && t.setDecodedProperties(r, s, a);
                    }
                };
            },
            6329: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getMessage = void 0;
                const n = r(9634), o = r(5071), i = r(4581), s = /^\w+/, a = /^(.*)\[([0-9]*?)]$/, c = (e, t, r = [])=>{
                    const n = t.match(s)[0];
                    return r.includes(n) ? r : e.types[n] ? [
                        n,
                        ...e.types[n].reduce((t, r)=>[
                                ...t,
                                ...c(e, r.type, t).filter((e)=>!t.includes(e))
                            ], [])
                    ] : r;
                }, u = (e, t)=>(0, n.keccak256)(((e, t)=>{
                        const [r, ...n] = c(e, t);
                        return [
                            r,
                            ...n.sort()
                        ].map((t)=>`${t}(${e.types[t].map((e)=>`${e.type} ${e.name}`)})`).join("");
                    })(e, t)), d = (e, t, r)=>(0, n.keccak256)(h(e, t, r));
                t.getMessage = (e, t)=>{
                    const r = `0x1901${d(e, "EIP712Domain", e.domain).substring(2)}${d(e, e.primaryType, e.message).substring(2)}`;
                    return t ? (0, n.keccak256)(r) : r;
                };
                const l = (e, t, r)=>{
                    const s = t.match(a);
                    if (s) {
                        const t = s[1], a = Number(s[2]) || void 0;
                        if (!Array.isArray(r)) throw new o.AbiError("Cannot encode data: value is not of array type", {
                            data: r
                        });
                        if (a && r.length !== a) throw new o.AbiError(`Cannot encode data: expected length of ${a}, but got ${r.length}`, {
                            data: r
                        });
                        const c = r.map((r)=>l(e, t, r)), u = c.map((e)=>e[0]), d = c.map((e)=>e[1]);
                        return [
                            "bytes32",
                            (0, n.keccak256)((0, i.encodeParameters)(u, d))
                        ];
                    }
                    return e.types[t] ? [
                        "bytes32",
                        d(e, t, r)
                    ] : "string" === t || "bytes" === t ? [
                        "bytes32",
                        (0, n.keccak256)(r)
                    ] : [
                        t,
                        r
                    ];
                }, h = (e, t, r)=>{
                    const [s, a] = e.types[t].reduce(([t, i], s)=>{
                        if ((0, n.isNullish)(r[s.name]) || (0, n.isNullish)(r[s.name])) throw new o.AbiError(`Cannot encode data: missing data for '${s.name}'`, {
                            data: r,
                            field: s
                        });
                        const a = r[s.name], [c, u] = l(e, s.type, a);
                        return [
                            [
                                ...t,
                                c
                            ],
                            [
                                ...i,
                                u
                            ]
                        ];
                    }, [
                        [
                            "bytes32"
                        ],
                        [
                            u(e, t)
                        ]
                    ]);
                    return (0, i.encodeParameters)(s, a);
                };
            },
            8381: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getEncodedEip712Data = void 0, o(r(9722), t), o(r(5893), t), o(r(3249), t), o(r(734), t), o(r(4566), t), o(r(1583), t), o(r(5610), t);
                var i = r(6329);
                Object.defineProperty(t, "getEncodedEip712Data", {
                    enumerable: !0,
                    get: function() {
                        return i.getMessage;
                    }
                });
            },
            1583: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.jsonInterfaceMethodToString = t.flattenTypes = t.formatParam = t.formatOddHexstrings = t.isOddHexstring = t.mapTypes = t.mapStructToCoderFormat = t.mapStructNameAndType = t.isSimplifiedStructFormat = t.isAbiConstructorFragment = t.isAbiFunctionFragment = t.isAbiEventFragment = t.isAbiErrorFragment = t.isAbiFragment = void 0;
                const n = r(5071), o = r(9634);
                t.isAbiFragment = (e)=>!(0, o.isNullish)(e) && "object" == typeof e && !(0, o.isNullish)(e.type) && [
                        "function",
                        "event",
                        "constructor",
                        "error"
                    ].includes(e.type), t.isAbiErrorFragment = (e)=>!(0, o.isNullish)(e) && "object" == typeof e && !(0, o.isNullish)(e.type) && "error" === e.type, t.isAbiEventFragment = (e)=>!(0, o.isNullish)(e) && "object" == typeof e && !(0, o.isNullish)(e.type) && "event" === e.type, t.isAbiFunctionFragment = (e)=>!(0, o.isNullish)(e) && "object" == typeof e && !(0, o.isNullish)(e.type) && "function" === e.type, t.isAbiConstructorFragment = (e)=>!(0, o.isNullish)(e) && "object" == typeof e && !(0, o.isNullish)(e.type) && "constructor" === e.type, t.isSimplifiedStructFormat = (e)=>"object" == typeof e && void 0 === e.components && void 0 === e.name, t.mapStructNameAndType = (e)=>e.includes("[]") ? {
                        type: "tuple[]",
                        name: e.slice(0, -2)
                    } : {
                        type: "tuple",
                        name: e
                    }, t.mapStructToCoderFormat = (e)=>{
                    const r = [];
                    for (const n of Object.keys(e)){
                        const o = e[n];
                        "object" == typeof o ? r.push(Object.assign(Object.assign({}, (0, t.mapStructNameAndType)(n)), {
                            components: (0, t.mapStructToCoderFormat)(o)
                        })) : r.push({
                            name: n,
                            type: e[n]
                        });
                    }
                    return r;
                }, t.mapTypes = (e)=>{
                    const r = [];
                    for (const n of e){
                        let e = n;
                        if ("object" == typeof n && (e = Object.assign({}, n)), "object" == typeof n && "function" === n.type && (e = Object.assign(Object.assign({}, n), {
                            type: "bytes24"
                        })), (0, t.isSimplifiedStructFormat)(e)) {
                            const n = Object.keys(e)[0];
                            r.push(Object.assign(Object.assign({}, (0, t.mapStructNameAndType)(n)), {
                                components: (0, t.mapStructToCoderFormat)(e[n])
                            }));
                        } else r.push(e);
                    }
                    return r;
                }, t.isOddHexstring = (e)=>"string" == typeof e && /^(-)?0x[0-9a-f]*$/i.test(e) && e.length % 2 == 1, t.formatOddHexstrings = (e)=>(0, t.isOddHexstring)(e) ? `0x0${e.substring(2)}` : e;
                const i = /^bytes([0-9]*)$/, s = /^bytes([0-9]*)\[\]$/, a = /^(u?int)([0-9]*)$/, c = /^(u?int)([0-9]*)\[\]$/;
                t.formatParam = (e, r)=>{
                    const n = "object" != typeof r || Array.isArray(r) ? r : Object.assign({}, r);
                    if (n instanceof BigInt || "bigint" == typeof n) return n.toString(10);
                    if (s.exec(e) || c.exec(e)) return [
                        ...n
                    ].map((r)=>(0, t.formatParam)(e.replace("[]", ""), r));
                    let u = a.exec(e);
                    if (u) {
                        const e = parseInt(u[2] ? u[2] : "256", 10);
                        if (e / 8 < n.length) return (0, o.leftPad)(n, e);
                    }
                    if (u = i.exec(e), u) {
                        const e = (0, o.isUint8Array)(n) ? (0, o.toHex)(n) : n, r = parseInt(u[1], 10);
                        if (r) {
                            let i = 2 * r;
                            n.startsWith("0x") && (i += 2);
                            const s = e.length < i ? (0, o.rightPad)(n, 2 * r) : e;
                            return (0, t.formatOddHexstrings)(s);
                        }
                        return (0, t.formatOddHexstrings)(e);
                    }
                    return n;
                }, t.flattenTypes = (e, r)=>{
                    const o = [];
                    return r.forEach((r)=>{
                        if ("object" == typeof r.components) {
                            if (!r.type.startsWith("tuple")) throw new n.AbiError(`Invalid value given "${r.type}". Error: components found but type is not tuple.`);
                            const i = r.type.indexOf("["), s = i >= 0 ? r.type.substring(i) : "", a = (0, t.flattenTypes)(e, r.components);
                            Array.isArray(a) && e ? o.push(`tuple(${a.join(",")})${s}`) : e ? o.push(`(${a.join()})`) : o.push(`(${a.join(",")})${s}`);
                        } else o.push(r.type);
                    }), o;
                }, t.jsonInterfaceMethodToString = (e)=>{
                    var r, n, o, i;
                    return (0, t.isAbiErrorFragment)(e) || (0, t.isAbiEventFragment)(e) || (0, t.isAbiFunctionFragment)(e) ? (null === (r = e.name) || void 0 === r ? void 0 : r.includes("(")) ? e.name : `${null !== (n = e.name) && void 0 !== n ? n : ""}(${(0, t.flattenTypes)(!1, null !== (o = e.inputs) && void 0 !== o ? o : []).join(",")})` : `(${(0, t.flattenTypes)(!1, null !== (i = e.inputs) && void 0 !== i ? i : []).join(",")})`;
                };
            },
            1560: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decrypt = t.create = t.privateKeyToAccount = t.encrypt = t.privateKeyToPublicKey = t.privateKeyToAddress = t.recover = t.recoverTransaction = t.signTransaction = t.sign = t.hashMessage = t.parseAndValidatePrivateKey = void 0;
                const o = r(3072), i = r(8109), s = r(7002), a = r(5071), c = r(9634), u = r(7345), d = r(4555), l = r(5774), h = r(7668);
                t.parseAndValidatePrivateKey = (e, t)=>{
                    let r;
                    if (!t && "string" == typeof e && (0, u.isHexStrict)(e) && 66 !== e.length) throw new a.PrivateKeyLengthError;
                    try {
                        r = (0, c.isUint8Array)(e) ? e : (0, c.bytesToUint8Array)(e);
                    } catch (e) {
                        throw new a.InvalidPrivateKeyError;
                    }
                    if (!t && 32 !== r.byteLength) throw new a.PrivateKeyLengthError;
                    return r;
                }, t.hashMessage = (e)=>{
                    const t = (0, u.isHexStrict)(e) ? e : (0, c.utf8ToHex)(e), r = (0, c.hexToBytes)(t), n = (0, c.hexToBytes)((0, c.fromUtf8)(`Ethereum Signed Message:\n${r.byteLength}`)), o = (0, c.uint8ArrayConcat)(n, r);
                    return (0, c.sha3Raw)(o);
                }, t.sign = (e, r)=>{
                    const n = (0, t.parseAndValidatePrivateKey)(r), o = (0, t.hashMessage)(e), i = d.secp256k1.sign(o.substring(2), n), s = i.toCompactRawBytes(), a = i.r.toString(16).padStart(64, "0"), u = i.s.toString(16).padStart(64, "0"), l = i.recovery + 27;
                    return {
                        message: e,
                        messageHash: o,
                        v: (0, c.numberToHex)(l),
                        r: `0x${a}`,
                        s: `0x${u}`,
                        signature: `${(0, c.bytesToHex)(s)}${l.toString(16)}`
                    };
                }, t.signTransaction = (e, t)=>n(void 0, void 0, void 0, function*() {
                        const r = e.sign((0, c.hexToBytes)(t));
                        if ((0, u.isNullish)(r.v) || (0, u.isNullish)(r.r) || (0, u.isNullish)(r.s)) throw new a.TransactionSigningError("Signer Error");
                        const n = r.validate(!0);
                        if (n.length > 0) {
                            let e = "Signer Error ";
                            for (const t of n)e += `${e} ${t}.`;
                            throw new a.TransactionSigningError(e);
                        }
                        const o = (0, c.bytesToHex)(r.serialize()), i = (0, c.sha3Raw)(o);
                        return {
                            messageHash: (0, c.bytesToHex)(r.getMessageToSign(!0)),
                            v: `0x${r.v.toString(16)}`,
                            r: `0x${r.r.toString(16).padStart(64, "0")}`,
                            s: `0x${r.s.toString(16).padStart(64, "0")}`,
                            rawTransaction: o,
                            transactionHash: (0, c.bytesToHex)(i)
                        };
                    }), t.recoverTransaction = (e)=>{
                    if ((0, u.isNullish)(e)) throw new a.UndefinedRawTransactionError;
                    const t = h.TransactionFactory.fromSerializedData((0, c.hexToBytes)(e));
                    return (0, c.toChecksumAddress)(t.getSenderAddress().toString());
                }, t.recover = (e, r, n, o, i)=>{
                    if ("object" == typeof e) {
                        const r = `${e.r}${e.s.slice(2)}${e.v.slice(2)}`;
                        return (0, t.recover)(e.messageHash, r, n);
                    }
                    if ("string" == typeof r && "string" == typeof n && !(0, u.isNullish)(o)) {
                        const s = `${n}${o.slice(2)}${r.slice(2)}`;
                        return (0, t.recover)(e, s, i);
                    }
                    if ((0, u.isNullish)(r)) throw new a.InvalidSignatureError("signature string undefined");
                    const s = n ? e : (0, t.hashMessage)(e);
                    let l = parseInt(r.substring(130), 16);
                    l > 26 && (l -= 27);
                    const h = d.secp256k1.Signature.fromCompact(r.slice(2, 130)).addRecoveryBit(l).recoverPublicKey(s.replace("0x", "")).toRawBytes(!1), f = (0, c.sha3Raw)(h.subarray(1));
                    return (0, c.toChecksumAddress)(`0x${f.slice(-40)}`);
                }, t.privateKeyToAddress = (e)=>{
                    const r = (0, t.parseAndValidatePrivateKey)(e), n = d.secp256k1.getPublicKey(r, !1), o = (0, c.sha3Raw)(n.slice(1)).slice(-40);
                    return (0, c.toChecksumAddress)(`0x${o}`);
                }, t.privateKeyToPublicKey = (e, r)=>{
                    const n = (0, t.parseAndValidatePrivateKey)(e);
                    return `0x${(0, c.bytesToHex)(d.secp256k1.getPublicKey(n, r)).slice(4)}`;
                }, t.encrypt = (e, r, d)=>n(void 0, void 0, void 0, function*() {
                        var n, l, h, f, p, m, g;
                        const y = (0, t.parseAndValidatePrivateKey)(e);
                        let v;
                        if (v = (null == d ? void 0 : d.salt) ? "string" == typeof d.salt ? (0, c.hexToBytes)(d.salt) : d.salt : (0, c.randomBytes)(32), !(0, u.isString)(r) && !(0, c.isUint8Array)(r)) throw new a.InvalidPasswordError;
                        const b = "string" == typeof r ? (0, c.hexToBytes)((0, c.utf8ToHex)(r)) : r;
                        let E;
                        if (null == d ? void 0 : d.iv) {
                            if (E = "string" == typeof d.iv ? (0, c.hexToBytes)(d.iv) : d.iv, 16 !== E.length) throw new a.IVLengthError;
                        } else E = (0, c.randomBytes)(16);
                        const _ = null !== (n = null == d ? void 0 : d.kdf) && void 0 !== n ? n : "scrypt";
                        let A, T;
                        if ("pbkdf2" === _) {
                            if (T = {
                                dklen: null !== (l = null == d ? void 0 : d.dklen) && void 0 !== l ? l : 32,
                                salt: (0, c.bytesToHex)(v).replace("0x", ""),
                                c: null !== (h = null == d ? void 0 : d.c) && void 0 !== h ? h : 262144,
                                prf: "hmac-sha256"
                            }, T.c < 1e3) throw new a.PBKDF2IterationsError;
                            A = (0, i.pbkdf2Sync)(b, v, T.c, T.dklen, "sha256");
                        } else {
                            if ("scrypt" !== _) throw new a.InvalidKdfError;
                            T = {
                                n: null !== (f = null == d ? void 0 : d.n) && void 0 !== f ? f : 8192,
                                r: null !== (p = null == d ? void 0 : d.r) && void 0 !== p ? p : 8,
                                p: null !== (m = null == d ? void 0 : d.p) && void 0 !== m ? m : 1,
                                dklen: null !== (g = null == d ? void 0 : d.dklen) && void 0 !== g ? g : 32,
                                salt: (0, c.bytesToHex)(v).replace("0x", "")
                            }, A = (0, s.scryptSync)(b, v, T.n, T.p, T.r, T.dklen);
                        }
                        const w = yield (0, o.encrypt)(y, A.slice(0, 16), E, "aes-128-ctr"), I = (0, c.bytesToHex)(w).slice(2), R = (0, c.sha3Raw)((0, c.uint8ArrayConcat)(A.slice(16, 32), w)).replace("0x", "");
                        return {
                            version: 3,
                            id: (0, c.uuidV4)(),
                            address: (0, t.privateKeyToAddress)(y).toLowerCase().replace("0x", ""),
                            crypto: {
                                ciphertext: I,
                                cipherparams: {
                                    iv: (0, c.bytesToHex)(E).replace("0x", "")
                                },
                                cipher: "aes-128-ctr",
                                kdf: _,
                                kdfparams: T,
                                mac: R
                            }
                        };
                    }), t.privateKeyToAccount = (e, r)=>{
                    const o = (0, t.parseAndValidatePrivateKey)(e, r);
                    return {
                        address: (0, t.privateKeyToAddress)(o),
                        privateKey: (0, c.bytesToHex)(o),
                        signTransaction: (e)=>{
                            throw new a.TransactionSigningError("Do not have network access to sign the transaction");
                        },
                        sign: (e)=>(0, t.sign)("string" == typeof e ? e : JSON.stringify(e), o),
                        encrypt: (e, r)=>n(void 0, void 0, void 0, function*() {
                                return (0, t.encrypt)(o, e, r);
                            })
                    };
                }, t.create = ()=>{
                    const e = d.secp256k1.utils.randomPrivateKey();
                    return (0, t.privateKeyToAccount)(`${(0, c.bytesToHex)(e)}`);
                }, t.decrypt = (e, r, d)=>n(void 0, void 0, void 0, function*() {
                        const n = "object" == typeof e ? e : JSON.parse(d ? e.toLowerCase() : e);
                        if (u.validator.validateJSONSchema(l.keyStoreSchema, n), 3 !== n.version) throw new a.KeyStoreVersionError;
                        const h = "string" == typeof r ? (0, c.hexToBytes)((0, c.utf8ToHex)(r)) : r;
                        let f;
                        if (u.validator.validate([
                            "bytes"
                        ], [
                            h
                        ]), "scrypt" === n.crypto.kdf) {
                            const e = n.crypto.kdfparams, t = "string" == typeof e.salt ? (0, c.hexToBytes)(e.salt) : e.salt;
                            f = (0, s.scryptSync)(h, t, e.n, e.p, e.r, e.dklen);
                        } else {
                            if ("pbkdf2" !== n.crypto.kdf) throw new a.InvalidKdfError;
                            {
                                const e = n.crypto.kdfparams, t = "string" == typeof e.salt ? (0, c.hexToBytes)(e.salt) : e.salt;
                                f = (0, i.pbkdf2Sync)(h, t, e.c, e.dklen, "sha256");
                            }
                        }
                        const p = (0, c.hexToBytes)(n.crypto.ciphertext);
                        if ((0, c.sha3Raw)((0, c.uint8ArrayConcat)(f.slice(16, 32), p)).replace("0x", "") !== n.crypto.mac) throw new a.KeyDerivationError;
                        const m = yield (0, o.decrypt)((0, c.hexToBytes)(n.crypto.ciphertext), f.slice(0, 16), (0, c.hexToBytes)(n.crypto.cipherparams.iv));
                        return (0, t.privateKeyToAccount)(m);
                    });
            },
            7634: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "goerli",
                    chainId: 5,
                    networkId: 5,
                    defaultHardfork: "merge",
                    consensus: {
                        type: "poa",
                        algorithm: "clique",
                        clique: {
                            period: 15,
                            epoch: 3e4
                        }
                    },
                    comment: "Cross-client PoA test network",
                    url: "https://github.com/goerli/testnet",
                    genesis: {
                        timestamp: "0x5c51a607",
                        gasLimit: 10485760,
                        difficulty: 1,
                        nonce: "0x0000000000000000",
                        extraData: "0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
                    },
                    hardforks: [
                        {
                            name: "chainstart",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "homestead",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "tangerineWhistle",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "spuriousDragon",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "byzantium",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "constantinople",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "petersburg",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "istanbul",
                            block: 1561651,
                            forkHash: "0xc25efa5c"
                        },
                        {
                            name: "berlin",
                            block: 4460644,
                            forkHash: "0x757a1c47"
                        },
                        {
                            name: "london",
                            block: 5062605,
                            forkHash: "0xb8c6299d"
                        },
                        {
                            "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://goerli.etherscan.io/block/7382818",
                            name: "merge",
                            ttd: "10790000",
                            block: 7382819,
                            forkHash: "0xb8c6299d"
                        },
                        {
                            name: "mergeForkIdTransition",
                            block: null,
                            forkHash: null
                        },
                        {
                            name: "shanghai",
                            block: null,
                            forkHash: null
                        }
                    ],
                    bootstrapNodes: [],
                    dnsNetworks: [
                        "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.goerli.ethdisco.net"
                    ]
                };
            },
            3233: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "mainnet",
                    chainId: 1,
                    networkId: 1,
                    defaultHardfork: "merge",
                    consensus: {
                        type: "pow",
                        algorithm: "ethash",
                        ethash: {}
                    },
                    comment: "The Ethereum main chain",
                    url: "https://ethstats.net/",
                    genesis: {
                        gasLimit: 5e3,
                        difficulty: 17179869184,
                        nonce: "0x0000000000000042",
                        extraData: "0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa"
                    },
                    hardforks: [
                        {
                            name: "chainstart",
                            block: 0,
                            forkHash: "0xfc64ec04"
                        },
                        {
                            name: "homestead",
                            block: 115e4,
                            forkHash: "0x97c2c34c"
                        },
                        {
                            name: "dao",
                            block: 192e4,
                            forkHash: "0x91d1f948"
                        },
                        {
                            name: "tangerineWhistle",
                            block: 2463e3,
                            forkHash: "0x7a64da13"
                        },
                        {
                            name: "spuriousDragon",
                            block: 2675e3,
                            forkHash: "0x3edd5b10"
                        },
                        {
                            name: "byzantium",
                            block: 437e4,
                            forkHash: "0xa00bc324"
                        },
                        {
                            name: "constantinople",
                            block: 728e4,
                            forkHash: "0x668db0af"
                        },
                        {
                            name: "petersburg",
                            block: 728e4,
                            forkHash: "0x668db0af"
                        },
                        {
                            name: "istanbul",
                            block: 9069e3,
                            forkHash: "0x879d6e30"
                        },
                        {
                            name: "muirGlacier",
                            block: 92e5,
                            forkHash: "0xe029e991"
                        },
                        {
                            name: "berlin",
                            block: 12244e3,
                            forkHash: "0x0eb440f6"
                        },
                        {
                            name: "london",
                            block: 12965e3,
                            forkHash: "0xb715077d"
                        },
                        {
                            name: "arrowGlacier",
                            block: 13773e3,
                            forkHash: "0x20c327fc"
                        },
                        {
                            name: "grayGlacier",
                            block: 1505e4,
                            forkHash: "0xf0afd0e3"
                        },
                        {
                            "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://etherscan.io/block/15537393",
                            name: "merge",
                            ttd: "58750000000000000000000",
                            block: 15537394,
                            forkHash: "0xf0afd0e3"
                        },
                        {
                            name: "mergeForkIdTransition",
                            block: null,
                            forkHash: null
                        },
                        {
                            name: "shanghai",
                            block: null,
                            forkHash: null
                        }
                    ],
                    bootstrapNodes: [],
                    dnsNetworks: [
                        "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.mainnet.ethdisco.net"
                    ]
                };
            },
            5077: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "sepolia",
                    chainId: 11155111,
                    networkId: 11155111,
                    defaultHardfork: "merge",
                    consensus: {
                        type: "pow",
                        algorithm: "ethash",
                        ethash: {}
                    },
                    comment: "PoW test network to replace Ropsten",
                    url: "https://github.com/ethereum/go-ethereum/pull/23730",
                    genesis: {
                        timestamp: "0x6159af19",
                        gasLimit: 3e7,
                        difficulty: 131072,
                        nonce: "0x0000000000000000",
                        extraData: "0x5365706f6c69612c20417468656e732c204174746963612c2047726565636521"
                    },
                    hardforks: [
                        {
                            name: "chainstart",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "homestead",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "tangerineWhistle",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "spuriousDragon",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "byzantium",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "constantinople",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "petersburg",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "istanbul",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "muirGlacier",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "berlin",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "london",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://sepolia.etherscan.io/block/1450408",
                            name: "merge",
                            ttd: "17000000000000000",
                            block: 1450409,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "mergeForkIdTransition",
                            block: 1735371,
                            forkHash: "0xb96cbd13"
                        },
                        {
                            name: "shanghai",
                            block: null,
                            timestamp: "1677557088",
                            forkHash: "0xf7f9bc08"
                        }
                    ],
                    bootstrapNodes: [],
                    dnsNetworks: [
                        "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.sepolia.ethdisco.net"
                    ]
                };
            },
            6664: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Common = void 0;
                const o = n(r(1238)), i = r(9634), s = r(850), a = r(2290), c = n(r(7634)), u = n(r(3233)), d = n(r(5077)), l = r(5257), h = r(4443), f = r(9137), { buf: p } = o.default;
                class m extends i.EventEmitter {
                    constructor(e){
                        var t, r;
                        super(), this._eips = [], this._customChains = null !== (t = e.customChains) && void 0 !== t ? t : [], this._chainParams = this.setChain(e.chain), this.DEFAULT_HARDFORK = null !== (r = this._chainParams.defaultHardfork) && void 0 !== r ? r : h.Hardfork.Merge, this.HARDFORK_CHANGES = this.hardforks().map((e)=>[
                                e.name,
                                f.hardforks[e.name]
                            ]), this._hardfork = this.DEFAULT_HARDFORK, void 0 !== e.hardfork && this.setHardfork(e.hardfork), e.eips && this.setEIPs(e.eips);
                    }
                    static custom(e, t = {}) {
                        var r;
                        const n = null !== (r = t.baseChain) && void 0 !== r ? r : "mainnet", o = Object.assign({}, m._getChainParams(n));
                        if (o.name = "custom-chain", "string" != typeof e) return new m(Object.assign({
                            chain: Object.assign(Object.assign({}, o), e)
                        }, t));
                        if (e === h.CustomChain.PolygonMainnet) return m.custom({
                            name: h.CustomChain.PolygonMainnet,
                            chainId: 137,
                            networkId: 137
                        }, t);
                        if (e === h.CustomChain.PolygonMumbai) return m.custom({
                            name: h.CustomChain.PolygonMumbai,
                            chainId: 80001,
                            networkId: 80001
                        }, t);
                        if (e === h.CustomChain.ArbitrumRinkebyTestnet) return m.custom({
                            name: h.CustomChain.ArbitrumRinkebyTestnet,
                            chainId: 421611,
                            networkId: 421611
                        }, t);
                        if (e === h.CustomChain.ArbitrumOne) return m.custom({
                            name: h.CustomChain.ArbitrumOne,
                            chainId: 42161,
                            networkId: 42161
                        }, t);
                        if (e === h.CustomChain.xDaiChain) return m.custom({
                            name: h.CustomChain.xDaiChain,
                            chainId: 100,
                            networkId: 100
                        }, t);
                        if (e === h.CustomChain.OptimisticKovan) return m.custom({
                            name: h.CustomChain.OptimisticKovan,
                            chainId: 69,
                            networkId: 69
                        }, Object.assign({
                            hardfork: h.Hardfork.Berlin
                        }, t));
                        if (e === h.CustomChain.OptimisticEthereum) return m.custom({
                            name: h.CustomChain.OptimisticEthereum,
                            chainId: 10,
                            networkId: 10
                        }, Object.assign({
                            hardfork: h.Hardfork.Berlin
                        }, t));
                        throw new Error(`Custom chain ${e} not supported`);
                    }
                    static fromGethGenesis(e, { chain: t, eips: r, genesisHash: n, hardfork: o, mergeForkIdPostMerge: i }) {
                        var s;
                        const c = (0, a.parseGethGenesis)(e, t, i), u = new m({
                            chain: null !== (s = c.name) && void 0 !== s ? s : "custom",
                            customChains: [
                                c
                            ],
                            eips: r,
                            hardfork: null != o ? o : c.hardfork
                        });
                        return void 0 !== n && u.setForkHashes(n), u;
                    }
                    static isSupportedChainId(e) {
                        const t = this._getInitializedChains();
                        return Boolean(t.names[e.toString()]);
                    }
                    static _getChainParams(e, t) {
                        let r = e;
                        const n = this._getInitializedChains(t);
                        if ("number" == typeof r || "bigint" == typeof r) {
                            if (r = r.toString(), n.names[r]) return n[n.names[r]];
                            throw new Error(`Chain with ID ${r} not supported`);
                        }
                        if (void 0 !== n[r]) return n[r];
                        throw new Error(`Chain with name ${r} not supported`);
                    }
                    setChain(e) {
                        if ("number" == typeof e || "bigint" == typeof e || "string" == typeof e) this._chainParams = m._getChainParams(e, this._customChains);
                        else {
                            if ("object" != typeof e) throw new Error("Wrong input format");
                            {
                                if (this._customChains.length > 0) throw new Error("Chain must be a string, number, or bigint when initialized with customChains passed in");
                                const t = [
                                    "networkId",
                                    "genesis",
                                    "hardforks",
                                    "bootstrapNodes"
                                ];
                                for (const r of t)if (!(r in e)) throw new Error(`Missing required chain parameter: ${r}`);
                                this._chainParams = e;
                            }
                        }
                        for (const e of this.hardforks())if (void 0 === e.block) throw new Error("Hardfork cannot have undefined block number");
                        return this._chainParams;
                    }
                    setHardfork(e) {
                        let t = !1;
                        for (const r of this.HARDFORK_CHANGES)r[0] === e && (this._hardfork !== e && (this._hardfork = e, this.emit("hardforkChanged", e)), t = !0);
                        if (!t) throw new Error(`Hardfork with name ${e} not supported`);
                    }
                    getHardforkByBlockNumber(e, t, r) {
                        const n = (0, a.toType)(e, s.TypeOutput.BigInt), o = (0, a.toType)(t, s.TypeOutput.BigInt), i = (0, a.toType)(r, s.TypeOutput.Number), c = this.hardforks().filter((e)=>null !== e.block || null !== e.ttd && void 0 !== e.ttd || void 0 !== e.timestamp), u = c.findIndex((e)=>null !== e.ttd && void 0 !== e.ttd);
                        if (c.slice(u + 1).findIndex((e)=>null !== e.ttd && void 0 !== e.ttd) >= 0) throw Error("More than one merge hardforks found with ttd specified");
                        let d = c.findIndex((e)=>null !== e.block && e.block > n || void 0 !== i && Number(e.timestamp) > i);
                        if (-1 === d) d = c.length;
                        else if (0 === d) throw Error("Must have at least one hardfork at block 0");
                        if (void 0 === i && (d -= c.slice(0, d).reverse().findIndex((e)=>null !== e.block || void 0 !== e.ttd)), d -= 1, null === c[d].block && void 0 === c[d].timestamp) (null == o || BigInt(c[d].ttd) > o) && (d -= 1);
                        else if (u >= 0 && null != o) {
                            if (d >= u && BigInt(c[u].ttd) > o) throw Error("Maximum HF determined by total difficulty is lower than the block number HF");
                            if (d < u && BigInt(c[u].ttd) <= o) throw Error("HF determined by block number is lower than the minimum total difficulty HF");
                        }
                        const l = d;
                        for(; d < c.length - 1 && c[d].block === c[d + 1].block && c[d].timestamp === c[d + 1].timestamp; d += 1);
                        if (i) {
                            if (c.slice(0, l).reduce((e, t)=>{
                                var r;
                                return Math.max(Number(null !== (r = t.timestamp) && void 0 !== r ? r : "0"), e);
                            }, 0) > i) throw Error("Maximum HF determined by timestamp is lower than the block number/ttd HF");
                            if (c.slice(d + 1).reduce((e, t)=>{
                                var r;
                                return Math.min(Number(null !== (r = t.timestamp) && void 0 !== r ? r : i), e);
                            }, i) < i) throw Error("Maximum HF determined by block number/ttd is lower than timestamp HF");
                        }
                        return c[d].name;
                    }
                    setHardforkByBlockNumber(e, t, r) {
                        const n = this.getHardforkByBlockNumber(e, t, r);
                        return this.setHardfork(n), n;
                    }
                    _getHardfork(e) {
                        const t = this.hardforks();
                        for (const r of t)if (r.name === e) return r;
                        return null;
                    }
                    setEIPs(e = []) {
                        for (const t of e){
                            if (!(t in l.EIPs)) throw new Error(`${t} not supported`);
                            const r = this.gteHardfork(l.EIPs[t].minimumHardfork);
                            if (!r) throw new Error(`${t} cannot be activated on hardfork ${this.hardfork()}, minimumHardfork: ${r}`);
                            if (void 0 !== l.EIPs[t].requiredEIPs) {
                                for (const r of l.EIPs[t].requiredEIPs)if (!e.includes(r) && !this.isActivatedEIP(r)) throw new Error(`${t} requires EIP ${r}, but is not included in the EIP list`);
                            }
                        }
                        this._eips = e;
                    }
                    param(e, t) {
                        let r;
                        for (const n of this._eips)if (r = this.paramByEIP(e, t, n), void 0 !== r) return r;
                        return this.paramByHardfork(e, t, this._hardfork);
                    }
                    paramByHardfork(e, t, r) {
                        let n = null;
                        for (const o of this.HARDFORK_CHANGES){
                            if ("eips" in o[1]) {
                                const r = o[1].eips;
                                for (const o of r){
                                    const r = this.paramByEIP(e, t, o);
                                    n = "bigint" == typeof r ? r : n;
                                }
                            } else {
                                if (void 0 === o[1][e]) throw new Error(`Topic ${e} not defined`);
                                void 0 !== o[1][e][t] && (n = o[1][e][t].v);
                            }
                            if (o[0] === r) break;
                        }
                        return BigInt(null != n ? n : 0);
                    }
                    paramByEIP(e, t, r) {
                        if (!(r in l.EIPs)) throw new Error(`${r} not supported`);
                        const n = l.EIPs[r];
                        if (!(e in n)) throw new Error(`Topic ${e} not defined`);
                        if (void 0 === n[e][t]) return;
                        const o = n[e][t].v;
                        return BigInt(o);
                    }
                    paramByBlock(e, t, r, n, o) {
                        const i = this.getHardforkByBlockNumber(r, n, o);
                        return this.paramByHardfork(e, t, i);
                    }
                    isActivatedEIP(e) {
                        if (this.eips().includes(e)) return !0;
                        for (const t of this.HARDFORK_CHANGES){
                            const r = t[1];
                            if (this.gteHardfork(r.name) && "eips" in r && r.eips.includes(e)) return !0;
                        }
                        return !1;
                    }
                    hardforkIsActiveOnBlock(e, t) {
                        const r = (0, a.toType)(t, s.TypeOutput.BigInt), n = null != e ? e : this._hardfork, o = this.hardforkBlock(n);
                        return "bigint" == typeof o && o !== BigInt(0) && r >= o;
                    }
                    activeOnBlock(e) {
                        return this.hardforkIsActiveOnBlock(null, e);
                    }
                    hardforkGteHardfork(e, t) {
                        const r = null != e ? e : this._hardfork, n = this.hardforks();
                        let o = -1, i = -1, s = 0;
                        for (const e of n)e.name === r && (o = s), e.name === t && (i = s), s += 1;
                        return o >= i && -1 !== i;
                    }
                    gteHardfork(e) {
                        return this.hardforkGteHardfork(null, e);
                    }
                    hardforkBlock(e) {
                        var t;
                        const r = null != e ? e : this._hardfork, n = null === (t = this._getHardfork(r)) || void 0 === t ? void 0 : t.block;
                        return null == n ? null : BigInt(n);
                    }
                    hardforkTimestamp(e) {
                        var t;
                        const r = null != e ? e : this._hardfork, n = null === (t = this._getHardfork(r)) || void 0 === t ? void 0 : t.timestamp;
                        return null == n ? null : BigInt(n);
                    }
                    eipBlock(e) {
                        for (const t of this.HARDFORK_CHANGES){
                            const r = t[1];
                            if ("eips" in r && r.eips.includes(e)) return this.hardforkBlock("number" == typeof t[0] ? String(t[0]) : t[0]);
                        }
                        return null;
                    }
                    hardforkTTD(e) {
                        var t;
                        const r = null != e ? e : this._hardfork, n = null === (t = this._getHardfork(r)) || void 0 === t ? void 0 : t.ttd;
                        return null == n ? null : BigInt(n);
                    }
                    isHardforkBlock(e, t) {
                        const r = (0, a.toType)(e, s.TypeOutput.BigInt), n = null != t ? t : this._hardfork, o = this.hardforkBlock(n);
                        return "bigint" == typeof o && o !== BigInt(0) && o === r;
                    }
                    nextHardforkBlockOrTimestamp(e) {
                        var t, r;
                        const n = null != e ? e : this._hardfork, o = this.hardforks();
                        let i = o.findIndex((e)=>e.name === n);
                        if (n === h.Hardfork.Merge && (i -= 1), i < 0) return null;
                        let s = null !== (t = o[i].timestamp) && void 0 !== t ? t : o[i].block;
                        s = null != s ? Number(s) : null;
                        const a = o.slice(i + 1).find((e)=>{
                            var t;
                            let r = null !== (t = e.timestamp) && void 0 !== t ? t : e.block;
                            return r = null != r ? Number(r) : null, e.name !== h.Hardfork.Merge && null != r && r !== s;
                        });
                        if (void 0 === a) return null;
                        const c = null !== (r = a.timestamp) && void 0 !== r ? r : a.block;
                        return null == c ? null : BigInt(c);
                    }
                    nextHardforkBlock(e) {
                        const t = null != e ? e : this._hardfork;
                        let r = this.hardforkBlock(t);
                        if (null === r && t === h.Hardfork.Merge) {
                            const e = this.hardforks(), t = e.findIndex((e)=>null !== e.ttd && void 0 !== e.ttd);
                            if (t < 0) throw Error("Merge hardfork should have been found");
                            r = this.hardforkBlock(e[t - 1].name);
                        }
                        return null === r ? null : this.hardforks().reduce((e, t)=>{
                            const n = BigInt(null === t.block || void 0 !== t.ttd && null !== t.ttd ? 0 : t.block);
                            return n > r && null === e ? n : e;
                        }, null);
                    }
                    isNextHardforkBlock(e, t) {
                        const r = (0, a.toType)(e, s.TypeOutput.BigInt), n = null != t ? t : this._hardfork, o = this.nextHardforkBlock(n);
                        return null !== o && o === r;
                    }
                    _calcForkHash(e, t) {
                        let r = new Uint8Array, n = 0;
                        for (const t of this.hardforks()){
                            const { block: o, timestamp: s, name: a } = t;
                            let c = null != s ? s : o;
                            if (c = null !== c ? Number(c) : null, "number" == typeof c && 0 !== c && c !== n && a !== h.Hardfork.Merge) {
                                const e = (0, i.hexToBytes)(c.toString(16).padStart(16, "0"));
                                r = (0, i.uint8ArrayConcat)(r, e), n = c;
                            }
                            if (t.name === e) break;
                        }
                        const o = (0, i.uint8ArrayConcat)(t, r);
                        return (0, i.bytesToHex)((0, a.intToUint8Array)(p(o) >>> 0));
                    }
                    forkHash(e, t) {
                        const r = null != e ? e : this._hardfork, n = this._getHardfork(r);
                        if (null === n || null === (null == n ? void 0 : n.block) && void 0 === (null == n ? void 0 : n.timestamp) && void 0 === (null == n ? void 0 : n.ttd)) throw new Error("No fork hash calculation possible for future hardfork");
                        if (null !== (null == n ? void 0 : n.forkHash) && void 0 !== (null == n ? void 0 : n.forkHash)) return n.forkHash;
                        if (!t) throw new Error("genesisHash required for forkHash calculation");
                        return this._calcForkHash(r, t);
                    }
                    hardforkForForkHash(e) {
                        const t = this.hardforks().filter((t)=>t.forkHash === e);
                        return t.length >= 1 ? t[t.length - 1] : null;
                    }
                    setForkHashes(e) {
                        var t;
                        for (const r of this.hardforks()){
                            const n = null !== (t = r.timestamp) && void 0 !== t ? t : r.block;
                            null !== r.forkHash && void 0 !== r.forkHash || null == n && void 0 === r.ttd || (r.forkHash = this.forkHash(r.name, e));
                        }
                    }
                    genesis() {
                        return this._chainParams.genesis;
                    }
                    hardforks() {
                        return this._chainParams.hardforks;
                    }
                    bootstrapNodes() {
                        return this._chainParams.bootstrapNodes;
                    }
                    dnsNetworks() {
                        return this._chainParams.dnsNetworks;
                    }
                    hardfork() {
                        return this._hardfork;
                    }
                    chainId() {
                        return BigInt(this._chainParams.chainId);
                    }
                    chainName() {
                        return this._chainParams.name;
                    }
                    networkId() {
                        return BigInt(this._chainParams.networkId);
                    }
                    eips() {
                        return this._eips;
                    }
                    consensusType() {
                        const e = this.hardfork();
                        let t;
                        for (const r of this.HARDFORK_CHANGES)if ("consensus" in r[1] && (t = r[1].consensus.type), r[0] === e) break;
                        return null != t ? t : this._chainParams.consensus.type;
                    }
                    consensusAlgorithm() {
                        const e = this.hardfork();
                        let t;
                        for (const r of this.HARDFORK_CHANGES)if ("consensus" in r[1] && (t = r[1].consensus.algorithm), r[0] === e) break;
                        return null != t ? t : this._chainParams.consensus.algorithm;
                    }
                    consensusConfig() {
                        var e;
                        const t = this.hardfork();
                        let r;
                        for (const e of this.HARDFORK_CHANGES)if ("consensus" in e[1] && (r = e[1].consensus[e[1].consensus.algorithm]), e[0] === t) break;
                        return null !== (e = null != r ? r : this._chainParams.consensus[this.consensusAlgorithm()]) && void 0 !== e ? e : {};
                    }
                    copy() {
                        const e = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
                        return e.removeAllListeners(), e;
                    }
                    static _getInitializedChains(e) {
                        const t = {};
                        for (const [e, r] of Object.entries(h.Chain))t[r] = e.toLowerCase();
                        const r = {
                            mainnet: u.default,
                            goerli: c.default,
                            sepolia: d.default
                        };
                        if (e) for (const n of e){
                            const { name: e } = n;
                            t[n.chainId.toString()] = e, r[e] = n;
                        }
                        return r.names = t, r;
                    }
                }
                t.Common = m;
            },
            2819: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-1153",
                    number: 1153,
                    comment: "Transient Storage",
                    url: "https://eips.ethereum.org/EIPS/eip-1153",
                    status: "Review",
                    minimumHardfork: "chainstart",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {
                        tstore: {
                            v: 100,
                            d: "Base fee of the TSTORE opcode"
                        },
                        tload: {
                            v: 100,
                            d: "Base fee of the TLOAD opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            4013: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-1559",
                    number: 1559,
                    comment: "Fee market change for ETH 1.0 chain",
                    url: "https://eips.ethereum.org/EIPS/eip-1559",
                    status: "Final",
                    minimumHardfork: "berlin",
                    requiredEIPs: [
                        2930
                    ],
                    gasConfig: {
                        baseFeeMaxChangeDenominator: {
                            v: 8,
                            d: "Maximum base fee change denominator"
                        },
                        elasticityMultiplier: {
                            v: 2,
                            d: "Maximum block gas target elasticity"
                        },
                        initialBaseFee: {
                            v: 1e9,
                            d: "Initial base fee on first EIP1559 block"
                        }
                    },
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            1933: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2315",
                    number: 2315,
                    comment: "Simple subroutines for the EVM",
                    url: "https://eips.ethereum.org/EIPS/eip-2315",
                    status: "Draft",
                    minimumHardfork: "istanbul",
                    gasConfig: {},
                    gasPrices: {
                        beginsub: {
                            v: 2,
                            d: "Base fee of the BEGINSUB opcode"
                        },
                        returnsub: {
                            v: 5,
                            d: "Base fee of the RETURNSUB opcode"
                        },
                        jumpsub: {
                            v: 10,
                            d: "Base fee of the JUMPSUB opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            4638: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2537",
                    number: 2537,
                    comment: "BLS12-381 precompiles",
                    url: "https://eips.ethereum.org/EIPS/eip-2537",
                    status: "Draft",
                    minimumHardfork: "chainstart",
                    gasConfig: {},
                    gasPrices: {
                        Bls12381G1AddGas: {
                            v: 600,
                            d: "Gas cost of a single BLS12-381 G1 addition precompile-call"
                        },
                        Bls12381G1MulGas: {
                            v: 12e3,
                            d: "Gas cost of a single BLS12-381 G1 multiplication precompile-call"
                        },
                        Bls12381G2AddGas: {
                            v: 4500,
                            d: "Gas cost of a single BLS12-381 G2 addition precompile-call"
                        },
                        Bls12381G2MulGas: {
                            v: 55e3,
                            d: "Gas cost of a single BLS12-381 G2 multiplication precompile-call"
                        },
                        Bls12381PairingBaseGas: {
                            v: 115e3,
                            d: "Base gas cost of BLS12-381 pairing check"
                        },
                        Bls12381PairingPerPairGas: {
                            v: 23e3,
                            d: "Per-pair gas cost of BLS12-381 pairing check"
                        },
                        Bls12381MapG1Gas: {
                            v: 5500,
                            d: "Gas cost of BLS12-381 map field element to G1"
                        },
                        Bls12381MapG2Gas: {
                            v: 11e4,
                            d: "Gas cost of BLS12-381 map field element to G2"
                        },
                        Bls12381MultiExpGasDiscount: {
                            v: [
                                [
                                    1,
                                    1200
                                ],
                                [
                                    2,
                                    888
                                ],
                                [
                                    3,
                                    764
                                ],
                                [
                                    4,
                                    641
                                ],
                                [
                                    5,
                                    594
                                ],
                                [
                                    6,
                                    547
                                ],
                                [
                                    7,
                                    500
                                ],
                                [
                                    8,
                                    453
                                ],
                                [
                                    9,
                                    438
                                ],
                                [
                                    10,
                                    423
                                ],
                                [
                                    11,
                                    408
                                ],
                                [
                                    12,
                                    394
                                ],
                                [
                                    13,
                                    379
                                ],
                                [
                                    14,
                                    364
                                ],
                                [
                                    15,
                                    349
                                ],
                                [
                                    16,
                                    334
                                ],
                                [
                                    17,
                                    330
                                ],
                                [
                                    18,
                                    326
                                ],
                                [
                                    19,
                                    322
                                ],
                                [
                                    20,
                                    318
                                ],
                                [
                                    21,
                                    314
                                ],
                                [
                                    22,
                                    310
                                ],
                                [
                                    23,
                                    306
                                ],
                                [
                                    24,
                                    302
                                ],
                                [
                                    25,
                                    298
                                ],
                                [
                                    26,
                                    294
                                ],
                                [
                                    27,
                                    289
                                ],
                                [
                                    28,
                                    285
                                ],
                                [
                                    29,
                                    281
                                ],
                                [
                                    30,
                                    277
                                ],
                                [
                                    31,
                                    273
                                ],
                                [
                                    32,
                                    269
                                ],
                                [
                                    33,
                                    268
                                ],
                                [
                                    34,
                                    266
                                ],
                                [
                                    35,
                                    265
                                ],
                                [
                                    36,
                                    263
                                ],
                                [
                                    37,
                                    262
                                ],
                                [
                                    38,
                                    260
                                ],
                                [
                                    39,
                                    259
                                ],
                                [
                                    40,
                                    257
                                ],
                                [
                                    41,
                                    256
                                ],
                                [
                                    42,
                                    254
                                ],
                                [
                                    43,
                                    253
                                ],
                                [
                                    44,
                                    251
                                ],
                                [
                                    45,
                                    250
                                ],
                                [
                                    46,
                                    248
                                ],
                                [
                                    47,
                                    247
                                ],
                                [
                                    48,
                                    245
                                ],
                                [
                                    49,
                                    244
                                ],
                                [
                                    50,
                                    242
                                ],
                                [
                                    51,
                                    241
                                ],
                                [
                                    52,
                                    239
                                ],
                                [
                                    53,
                                    238
                                ],
                                [
                                    54,
                                    236
                                ],
                                [
                                    55,
                                    235
                                ],
                                [
                                    56,
                                    233
                                ],
                                [
                                    57,
                                    232
                                ],
                                [
                                    58,
                                    231
                                ],
                                [
                                    59,
                                    229
                                ],
                                [
                                    60,
                                    228
                                ],
                                [
                                    61,
                                    226
                                ],
                                [
                                    62,
                                    225
                                ],
                                [
                                    63,
                                    223
                                ],
                                [
                                    64,
                                    222
                                ],
                                [
                                    65,
                                    221
                                ],
                                [
                                    66,
                                    220
                                ],
                                [
                                    67,
                                    219
                                ],
                                [
                                    68,
                                    219
                                ],
                                [
                                    69,
                                    218
                                ],
                                [
                                    70,
                                    217
                                ],
                                [
                                    71,
                                    216
                                ],
                                [
                                    72,
                                    216
                                ],
                                [
                                    73,
                                    215
                                ],
                                [
                                    74,
                                    214
                                ],
                                [
                                    75,
                                    213
                                ],
                                [
                                    76,
                                    213
                                ],
                                [
                                    77,
                                    212
                                ],
                                [
                                    78,
                                    211
                                ],
                                [
                                    79,
                                    211
                                ],
                                [
                                    80,
                                    210
                                ],
                                [
                                    81,
                                    209
                                ],
                                [
                                    82,
                                    208
                                ],
                                [
                                    83,
                                    208
                                ],
                                [
                                    84,
                                    207
                                ],
                                [
                                    85,
                                    206
                                ],
                                [
                                    86,
                                    205
                                ],
                                [
                                    87,
                                    205
                                ],
                                [
                                    88,
                                    204
                                ],
                                [
                                    89,
                                    203
                                ],
                                [
                                    90,
                                    202
                                ],
                                [
                                    91,
                                    202
                                ],
                                [
                                    92,
                                    201
                                ],
                                [
                                    93,
                                    200
                                ],
                                [
                                    94,
                                    199
                                ],
                                [
                                    95,
                                    199
                                ],
                                [
                                    96,
                                    198
                                ],
                                [
                                    97,
                                    197
                                ],
                                [
                                    98,
                                    196
                                ],
                                [
                                    99,
                                    196
                                ],
                                [
                                    100,
                                    195
                                ],
                                [
                                    101,
                                    194
                                ],
                                [
                                    102,
                                    193
                                ],
                                [
                                    103,
                                    193
                                ],
                                [
                                    104,
                                    192
                                ],
                                [
                                    105,
                                    191
                                ],
                                [
                                    106,
                                    191
                                ],
                                [
                                    107,
                                    190
                                ],
                                [
                                    108,
                                    189
                                ],
                                [
                                    109,
                                    188
                                ],
                                [
                                    110,
                                    188
                                ],
                                [
                                    111,
                                    187
                                ],
                                [
                                    112,
                                    186
                                ],
                                [
                                    113,
                                    185
                                ],
                                [
                                    114,
                                    185
                                ],
                                [
                                    115,
                                    184
                                ],
                                [
                                    116,
                                    183
                                ],
                                [
                                    117,
                                    182
                                ],
                                [
                                    118,
                                    182
                                ],
                                [
                                    119,
                                    181
                                ],
                                [
                                    120,
                                    180
                                ],
                                [
                                    121,
                                    179
                                ],
                                [
                                    122,
                                    179
                                ],
                                [
                                    123,
                                    178
                                ],
                                [
                                    124,
                                    177
                                ],
                                [
                                    125,
                                    176
                                ],
                                [
                                    126,
                                    176
                                ],
                                [
                                    127,
                                    175
                                ],
                                [
                                    128,
                                    174
                                ]
                            ],
                            d: "Discount gas costs of calls to the MultiExp precompiles with `k` (point, scalar) pair"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            6906: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2565",
                    number: 2565,
                    comment: "ModExp gas cost",
                    url: "https://eips.ethereum.org/EIPS/eip-2565",
                    status: "Final",
                    minimumHardfork: "byzantium",
                    gasConfig: {},
                    gasPrices: {
                        modexpGquaddivisor: {
                            v: 3,
                            d: "Gquaddivisor from modexp precompile for gas calculation"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            3399: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2718",
                    comment: "Typed Transaction Envelope",
                    url: "https://eips.ethereum.org/EIPS/eip-2718",
                    status: "Final",
                    minimumHardfork: "chainstart",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            7387: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2929",
                    comment: "Gas cost increases for state access opcodes",
                    url: "https://eips.ethereum.org/EIPS/eip-2929",
                    status: "Final",
                    minimumHardfork: "chainstart",
                    gasConfig: {},
                    gasPrices: {
                        coldsload: {
                            v: 2100,
                            d: "Gas cost of the first read of storage from a given location (per transaction)"
                        },
                        coldaccountaccess: {
                            v: 2600,
                            d: "Gas cost of the first read of a given address (per transaction)"
                        },
                        warmstorageread: {
                            v: 100,
                            d: "Gas cost of reading storage locations which have already loaded 'cold'"
                        },
                        sstoreCleanGasEIP2200: {
                            v: 2900,
                            d: "Once per SSTORE operation from clean non-zero to something else"
                        },
                        sstoreNoopGasEIP2200: {
                            v: 100,
                            d: "Once per SSTORE operation if the value doesn't change"
                        },
                        sstoreDirtyGasEIP2200: {
                            v: 100,
                            d: "Once per SSTORE operation if a dirty value is changed"
                        },
                        sstoreInitRefundEIP2200: {
                            v: 19900,
                            d: "Once per SSTORE operation for resetting to the original zero value"
                        },
                        sstoreCleanRefundEIP2200: {
                            v: 4900,
                            d: "Once per SSTORE operation for resetting to the original non-zero value"
                        },
                        call: {
                            v: 0,
                            d: "Base fee of the CALL opcode"
                        },
                        callcode: {
                            v: 0,
                            d: "Base fee of the CALLCODE opcode"
                        },
                        delegatecall: {
                            v: 0,
                            d: "Base fee of the DELEGATECALL opcode"
                        },
                        staticcall: {
                            v: 0,
                            d: "Base fee of the STATICCALL opcode"
                        },
                        balance: {
                            v: 0,
                            d: "Base fee of the BALANCE opcode"
                        },
                        extcodesize: {
                            v: 0,
                            d: "Base fee of the EXTCODESIZE opcode"
                        },
                        extcodecopy: {
                            v: 0,
                            d: "Base fee of the EXTCODECOPY opcode"
                        },
                        extcodehash: {
                            v: 0,
                            d: "Base fee of the EXTCODEHASH opcode"
                        },
                        sload: {
                            v: 0,
                            d: "Base fee of the SLOAD opcode"
                        },
                        sstore: {
                            v: 0,
                            d: "Base fee of the SSTORE opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            6299: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2930",
                    comment: "Optional access lists",
                    url: "https://eips.ethereum.org/EIPS/eip-2930",
                    status: "Final",
                    minimumHardfork: "istanbul",
                    requiredEIPs: [
                        2718,
                        2929
                    ],
                    gasConfig: {},
                    gasPrices: {
                        accessListStorageKeyCost: {
                            v: 1900,
                            d: "Gas cost per storage key in an Access List transaction"
                        },
                        accessListAddressCost: {
                            v: 2400,
                            d: "Gas cost per storage key in an Access List transaction"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            1073: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3198",
                    number: 3198,
                    comment: "BASEFEE opcode",
                    url: "https://eips.ethereum.org/EIPS/eip-3198",
                    status: "Final",
                    minimumHardfork: "london",
                    gasConfig: {},
                    gasPrices: {
                        basefee: {
                            v: 2,
                            d: "Gas cost of the BASEFEE opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            634: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3529",
                    comment: "Reduction in refunds",
                    url: "https://eips.ethereum.org/EIPS/eip-3529",
                    status: "Final",
                    minimumHardfork: "berlin",
                    requiredEIPs: [
                        2929
                    ],
                    gasConfig: {
                        maxRefundQuotient: {
                            v: 5,
                            d: "Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"
                        }
                    },
                    gasPrices: {
                        selfdestructRefund: {
                            v: 0,
                            d: "Refunded following a selfdestruct operation"
                        },
                        sstoreClearRefundEIP2200: {
                            v: 4800,
                            d: "Once per SSTORE operation for clearing an originally existing storage slot"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            3829: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3540",
                    number: 3540,
                    comment: "EVM Object Format (EOF) v1",
                    url: "https://eips.ethereum.org/EIPS/eip-3540",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [
                        3541
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            5729: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3541",
                    comment: "Reject new contracts starting with the 0xEF byte",
                    url: "https://eips.ethereum.org/EIPS/eip-3541",
                    status: "Final",
                    minimumHardfork: "berlin",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            8958: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3554",
                    comment: "Reduction in refunds",
                    url: "Difficulty Bomb Delay to December 1st 2021",
                    status: "Final",
                    minimumHardfork: "muirGlacier",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 95e5,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            8334: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3607",
                    number: 3607,
                    comment: "Reject transactions from senders with deployed code",
                    url: "https://eips.ethereum.org/EIPS/eip-3607",
                    status: "Final",
                    minimumHardfork: "chainstart",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            3412: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3651",
                    number: 3198,
                    comment: "Warm COINBASE",
                    url: "https://eips.ethereum.org/EIPS/eip-3651",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [
                        2929
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            6337: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3670",
                    number: 3670,
                    comment: "EOF - Code Validation",
                    url: "https://eips.ethereum.org/EIPS/eip-3670",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [
                        3540
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            2610: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3675",
                    number: 3675,
                    comment: "Upgrade consensus to Proof-of-Stake",
                    url: "https://eips.ethereum.org/EIPS/eip-3675",
                    status: "Final",
                    minimumHardfork: "london",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            7619: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3855",
                    number: 3855,
                    comment: "PUSH0 instruction",
                    url: "https://eips.ethereum.org/EIPS/eip-3855",
                    status: "Review",
                    minimumHardfork: "chainstart",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {
                        push0: {
                            v: 2,
                            d: "Base fee of the PUSH0 opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            8018: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3860",
                    number: 3860,
                    comment: "Limit and meter initcode",
                    url: "https://eips.ethereum.org/EIPS/eip-3860",
                    status: "Review",
                    minimumHardfork: "spuriousDragon",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {
                        initCodeWordCost: {
                            v: 2,
                            d: "Gas to pay for each word (32 bytes) of initcode when creating a contract"
                        }
                    },
                    vm: {
                        maxInitCodeSize: {
                            v: 49152,
                            d: "Maximum length of initialization code when creating a contract"
                        }
                    },
                    pow: {}
                };
            },
            6779: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-4345",
                    number: 4345,
                    comment: "Difficulty Bomb Delay to June 2022",
                    url: "https://eips.ethereum.org/EIPS/eip-4345",
                    status: "Final",
                    minimumHardfork: "london",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 107e5,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            623: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-4399",
                    number: 4399,
                    comment: "Supplant DIFFICULTY opcode with PREVRANDAO",
                    url: "https://eips.ethereum.org/EIPS/eip-4399",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            797: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-5133",
                    number: 5133,
                    comment: "Delaying Difficulty Bomb to mid-September 2022",
                    url: "https://eips.ethereum.org/EIPS/eip-5133",
                    status: "Draft",
                    minimumHardfork: "grayGlacier",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 114e5,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            5257: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EIPs = void 0;
                const o = n(r(2819)), i = n(r(4013)), s = n(r(1933)), a = n(r(4638)), c = n(r(6906)), u = n(r(3399)), d = n(r(7387)), l = n(r(6299)), h = n(r(1073)), f = n(r(634)), p = n(r(3829)), m = n(r(5729)), g = n(r(8958)), y = n(r(8334)), v = n(r(3412)), b = n(r(6337)), E = n(r(2610)), _ = n(r(7619)), A = n(r(8018)), T = n(r(6779)), w = n(r(623)), I = n(r(797));
                t.EIPs = {
                    1153: o.default,
                    1559: i.default,
                    2315: s.default,
                    2537: a.default,
                    2565: c.default,
                    2718: u.default,
                    2929: d.default,
                    2930: l.default,
                    3198: h.default,
                    3529: f.default,
                    3540: p.default,
                    3541: m.default,
                    3554: g.default,
                    3607: y.default,
                    3651: v.default,
                    3670: b.default,
                    3675: E.default,
                    3855: _.default,
                    3860: A.default,
                    4345: T.default,
                    4399: w.default,
                    5133: I.default
                };
            },
            4443: (e, t)=>{
                "use strict";
                var r, n, o, i, s;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.CustomChain = t.ConsensusAlgorithm = t.ConsensusType = t.Hardfork = t.Chain = void 0, (s = t.Chain || (t.Chain = {}))[s.Mainnet = 1] = "Mainnet", s[s.Goerli = 5] = "Goerli", s[s.Sepolia = 11155111] = "Sepolia", (i = t.Hardfork || (t.Hardfork = {})).Chainstart = "chainstart", i.Homestead = "homestead", i.Dao = "dao", i.TangerineWhistle = "tangerineWhistle", i.SpuriousDragon = "spuriousDragon", i.Byzantium = "byzantium", i.Constantinople = "constantinople", i.Petersburg = "petersburg", i.Istanbul = "istanbul", i.MuirGlacier = "muirGlacier", i.Berlin = "berlin", i.London = "london", i.ArrowGlacier = "arrowGlacier", i.GrayGlacier = "grayGlacier", i.MergeForkIdTransition = "mergeForkIdTransition", i.Merge = "merge", i.Shanghai = "shanghai", i.ShardingForkDev = "shardingFork", (o = t.ConsensusType || (t.ConsensusType = {})).ProofOfStake = "pos", o.ProofOfWork = "pow", o.ProofOfAuthority = "poa", (n = t.ConsensusAlgorithm || (t.ConsensusAlgorithm = {})).Ethash = "ethash", n.Clique = "clique", n.Casper = "casper", (r = t.CustomChain || (t.CustomChain = {})).PolygonMainnet = "polygon-mainnet", r.PolygonMumbai = "polygon-mumbai", r.ArbitrumRinkebyTestnet = "arbitrum-rinkeby-testnet", r.ArbitrumOne = "arbitrum-one", r.xDaiChain = "x-dai-chain", r.OptimisticKovan = "optimistic-kovan", r.OptimisticEthereum = "optimistic-ethereum";
            },
            3923: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "arrowGlacier",
                    comment: "HF to delay the difficulty bomb",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/arrow-glacier.md",
                    status: "Final",
                    eips: [
                        4345
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            9126: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "berlin",
                    comment: "HF targeted for July 2020 following the Muir Glacier HF",
                    url: "https://eips.ethereum.org/EIPS/eip-2070",
                    status: "Final",
                    eips: [
                        2565,
                        2929,
                        2718,
                        2930
                    ]
                };
            },
            7251: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "byzantium",
                    comment: "Hardfork with new precompiles, instructions and other protocol changes",
                    url: "https://eips.ethereum.org/EIPS/eip-609",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        modexpGquaddivisor: {
                            v: 20,
                            d: "Gquaddivisor from modexp precompile for gas calculation"
                        },
                        ecAdd: {
                            v: 500,
                            d: "Gas costs for curve addition precompile"
                        },
                        ecMul: {
                            v: 4e4,
                            d: "Gas costs for curve multiplication precompile"
                        },
                        ecPairing: {
                            v: 1e5,
                            d: "Base gas costs for curve pairing precompile"
                        },
                        ecPairingWord: {
                            v: 8e4,
                            d: "Gas costs regarding curve pairing precompile input length"
                        },
                        revert: {
                            v: 0,
                            d: "Base fee of the REVERT opcode"
                        },
                        staticcall: {
                            v: 700,
                            d: "Base fee of the STATICCALL opcode"
                        },
                        returndatasize: {
                            v: 2,
                            d: "Base fee of the RETURNDATASIZE opcode"
                        },
                        returndatacopy: {
                            v: 3,
                            d: "Base fee of the RETURNDATACOPY opcode"
                        }
                    },
                    vm: {},
                    pow: {
                        minerReward: {
                            v: "3000000000000000000",
                            d: "the amount a miner get rewarded for mining a block"
                        },
                        difficultyBombDelay: {
                            v: 3e6,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            9454: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "chainstart",
                    comment: "Start of the Ethereum main chain",
                    url: "",
                    status: "",
                    gasConfig: {
                        minGasLimit: {
                            v: 5e3,
                            d: "Minimum the gas limit may ever be"
                        },
                        gasLimitBoundDivisor: {
                            v: 1024,
                            d: "The bound divisor of the gas limit, used in update calculations"
                        },
                        maxRefundQuotient: {
                            v: 2,
                            d: "Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"
                        }
                    },
                    gasPrices: {
                        base: {
                            v: 2,
                            d: "Gas base cost, used e.g. for ChainID opcode (Istanbul)"
                        },
                        tierStep: {
                            v: [
                                0,
                                2,
                                3,
                                5,
                                8,
                                10,
                                20
                            ],
                            d: "Once per operation, for a selection of them"
                        },
                        exp: {
                            v: 10,
                            d: "Base fee of the EXP opcode"
                        },
                        expByte: {
                            v: 10,
                            d: "Times ceil(log256(exponent)) for the EXP instruction"
                        },
                        sha3: {
                            v: 30,
                            d: "Base fee of the SHA3 opcode"
                        },
                        sha3Word: {
                            v: 6,
                            d: "Once per word of the SHA3 operation's data"
                        },
                        sload: {
                            v: 50,
                            d: "Base fee of the SLOAD opcode"
                        },
                        sstoreSet: {
                            v: 2e4,
                            d: "Once per SSTORE operation if the zeroness changes from zero"
                        },
                        sstoreReset: {
                            v: 5e3,
                            d: "Once per SSTORE operation if the zeroness does not change from zero"
                        },
                        sstoreRefund: {
                            v: 15e3,
                            d: "Once per SSTORE operation if the zeroness changes to zero"
                        },
                        jumpdest: {
                            v: 1,
                            d: "Base fee of the JUMPDEST opcode"
                        },
                        log: {
                            v: 375,
                            d: "Base fee of the LOG opcode"
                        },
                        logData: {
                            v: 8,
                            d: "Per byte in a LOG* operation's data"
                        },
                        logTopic: {
                            v: 375,
                            d: "Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas"
                        },
                        create: {
                            v: 32e3,
                            d: "Base fee of the CREATE opcode"
                        },
                        call: {
                            v: 40,
                            d: "Base fee of the CALL opcode"
                        },
                        callStipend: {
                            v: 2300,
                            d: "Free gas given at beginning of call"
                        },
                        callValueTransfer: {
                            v: 9e3,
                            d: "Paid for CALL when the value transfor is non-zero"
                        },
                        callNewAccount: {
                            v: 25e3,
                            d: "Paid for CALL when the destination address didn't exist prior"
                        },
                        selfdestructRefund: {
                            v: 24e3,
                            d: "Refunded following a selfdestruct operation"
                        },
                        memory: {
                            v: 3,
                            d: "Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL"
                        },
                        quadCoeffDiv: {
                            v: 512,
                            d: "Divisor for the quadratic particle of the memory cost equation"
                        },
                        createData: {
                            v: 200,
                            d: ""
                        },
                        tx: {
                            v: 21e3,
                            d: "Per transaction. NOTE: Not payable on data of calls between transactions"
                        },
                        txCreation: {
                            v: 32e3,
                            d: "The cost of creating a contract via tx"
                        },
                        txDataZero: {
                            v: 4,
                            d: "Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions"
                        },
                        txDataNonZero: {
                            v: 68,
                            d: "Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"
                        },
                        copy: {
                            v: 3,
                            d: "Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added"
                        },
                        ecRecover: {
                            v: 3e3,
                            d: ""
                        },
                        sha256: {
                            v: 60,
                            d: ""
                        },
                        sha256Word: {
                            v: 12,
                            d: ""
                        },
                        ripemd160: {
                            v: 600,
                            d: ""
                        },
                        ripemd160Word: {
                            v: 120,
                            d: ""
                        },
                        identity: {
                            v: 15,
                            d: ""
                        },
                        identityWord: {
                            v: 3,
                            d: ""
                        },
                        stop: {
                            v: 0,
                            d: "Base fee of the STOP opcode"
                        },
                        add: {
                            v: 3,
                            d: "Base fee of the ADD opcode"
                        },
                        mul: {
                            v: 5,
                            d: "Base fee of the MUL opcode"
                        },
                        sub: {
                            v: 3,
                            d: "Base fee of the SUB opcode"
                        },
                        div: {
                            v: 5,
                            d: "Base fee of the DIV opcode"
                        },
                        sdiv: {
                            v: 5,
                            d: "Base fee of the SDIV opcode"
                        },
                        mod: {
                            v: 5,
                            d: "Base fee of the MOD opcode"
                        },
                        smod: {
                            v: 5,
                            d: "Base fee of the SMOD opcode"
                        },
                        addmod: {
                            v: 8,
                            d: "Base fee of the ADDMOD opcode"
                        },
                        mulmod: {
                            v: 8,
                            d: "Base fee of the MULMOD opcode"
                        },
                        signextend: {
                            v: 5,
                            d: "Base fee of the SIGNEXTEND opcode"
                        },
                        lt: {
                            v: 3,
                            d: "Base fee of the LT opcode"
                        },
                        gt: {
                            v: 3,
                            d: "Base fee of the GT opcode"
                        },
                        slt: {
                            v: 3,
                            d: "Base fee of the SLT opcode"
                        },
                        sgt: {
                            v: 3,
                            d: "Base fee of the SGT opcode"
                        },
                        eq: {
                            v: 3,
                            d: "Base fee of the EQ opcode"
                        },
                        iszero: {
                            v: 3,
                            d: "Base fee of the ISZERO opcode"
                        },
                        and: {
                            v: 3,
                            d: "Base fee of the AND opcode"
                        },
                        or: {
                            v: 3,
                            d: "Base fee of the OR opcode"
                        },
                        xor: {
                            v: 3,
                            d: "Base fee of the XOR opcode"
                        },
                        not: {
                            v: 3,
                            d: "Base fee of the NOT opcode"
                        },
                        byte: {
                            v: 3,
                            d: "Base fee of the BYTE opcode"
                        },
                        address: {
                            v: 2,
                            d: "Base fee of the ADDRESS opcode"
                        },
                        balance: {
                            v: 20,
                            d: "Base fee of the BALANCE opcode"
                        },
                        origin: {
                            v: 2,
                            d: "Base fee of the ORIGIN opcode"
                        },
                        caller: {
                            v: 2,
                            d: "Base fee of the CALLER opcode"
                        },
                        callvalue: {
                            v: 2,
                            d: "Base fee of the CALLVALUE opcode"
                        },
                        calldataload: {
                            v: 3,
                            d: "Base fee of the CALLDATALOAD opcode"
                        },
                        calldatasize: {
                            v: 2,
                            d: "Base fee of the CALLDATASIZE opcode"
                        },
                        calldatacopy: {
                            v: 3,
                            d: "Base fee of the CALLDATACOPY opcode"
                        },
                        codesize: {
                            v: 2,
                            d: "Base fee of the CODESIZE opcode"
                        },
                        codecopy: {
                            v: 3,
                            d: "Base fee of the CODECOPY opcode"
                        },
                        gasprice: {
                            v: 2,
                            d: "Base fee of the GASPRICE opcode"
                        },
                        extcodesize: {
                            v: 20,
                            d: "Base fee of the EXTCODESIZE opcode"
                        },
                        extcodecopy: {
                            v: 20,
                            d: "Base fee of the EXTCODECOPY opcode"
                        },
                        blockhash: {
                            v: 20,
                            d: "Base fee of the BLOCKHASH opcode"
                        },
                        coinbase: {
                            v: 2,
                            d: "Base fee of the COINBASE opcode"
                        },
                        timestamp: {
                            v: 2,
                            d: "Base fee of the TIMESTAMP opcode"
                        },
                        number: {
                            v: 2,
                            d: "Base fee of the NUMBER opcode"
                        },
                        difficulty: {
                            v: 2,
                            d: "Base fee of the DIFFICULTY opcode"
                        },
                        gaslimit: {
                            v: 2,
                            d: "Base fee of the GASLIMIT opcode"
                        },
                        pop: {
                            v: 2,
                            d: "Base fee of the POP opcode"
                        },
                        mload: {
                            v: 3,
                            d: "Base fee of the MLOAD opcode"
                        },
                        mstore: {
                            v: 3,
                            d: "Base fee of the MSTORE opcode"
                        },
                        mstore8: {
                            v: 3,
                            d: "Base fee of the MSTORE8 opcode"
                        },
                        sstore: {
                            v: 0,
                            d: "Base fee of the SSTORE opcode"
                        },
                        jump: {
                            v: 8,
                            d: "Base fee of the JUMP opcode"
                        },
                        jumpi: {
                            v: 10,
                            d: "Base fee of the JUMPI opcode"
                        },
                        pc: {
                            v: 2,
                            d: "Base fee of the PC opcode"
                        },
                        msize: {
                            v: 2,
                            d: "Base fee of the MSIZE opcode"
                        },
                        gas: {
                            v: 2,
                            d: "Base fee of the GAS opcode"
                        },
                        push: {
                            v: 3,
                            d: "Base fee of the PUSH opcode"
                        },
                        dup: {
                            v: 3,
                            d: "Base fee of the DUP opcode"
                        },
                        swap: {
                            v: 3,
                            d: "Base fee of the SWAP opcode"
                        },
                        callcode: {
                            v: 40,
                            d: "Base fee of the CALLCODE opcode"
                        },
                        return: {
                            v: 0,
                            d: "Base fee of the RETURN opcode"
                        },
                        invalid: {
                            v: 0,
                            d: "Base fee of the INVALID opcode"
                        },
                        selfdestruct: {
                            v: 0,
                            d: "Base fee of the SELFDESTRUCT opcode"
                        }
                    },
                    vm: {
                        stackLimit: {
                            v: 1024,
                            d: "Maximum size of VM stack allowed"
                        },
                        callCreateDepth: {
                            v: 1024,
                            d: "Maximum depth of call/create stack"
                        },
                        maxExtraDataSize: {
                            v: 32,
                            d: "Maximum size extra data may be after Genesis"
                        }
                    },
                    pow: {
                        minimumDifficulty: {
                            v: 131072,
                            d: "The minimum that the difficulty may ever be"
                        },
                        difficultyBoundDivisor: {
                            v: 2048,
                            d: "The bound divisor of the difficulty, used in the update calculations"
                        },
                        durationLimit: {
                            v: 13,
                            d: "The decision boundary on the blocktime duration used to determine whether difficulty should go up or not"
                        },
                        epochDuration: {
                            v: 3e4,
                            d: "Duration between proof-of-work epochs"
                        },
                        timebombPeriod: {
                            v: 1e5,
                            d: "Exponential difficulty timebomb period"
                        },
                        minerReward: {
                            v: "5000000000000000000",
                            d: "the amount a miner get rewarded for mining a block"
                        },
                        difficultyBombDelay: {
                            v: 0,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            1353: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "constantinople",
                    comment: "Postponed hardfork including EIP-1283 (SSTORE gas metering changes)",
                    url: "https://eips.ethereum.org/EIPS/eip-1013",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        netSstoreNoopGas: {
                            v: 200,
                            d: "Once per SSTORE operation if the value doesn't change"
                        },
                        netSstoreInitGas: {
                            v: 2e4,
                            d: "Once per SSTORE operation from clean zero"
                        },
                        netSstoreCleanGas: {
                            v: 5e3,
                            d: "Once per SSTORE operation from clean non-zero"
                        },
                        netSstoreDirtyGas: {
                            v: 200,
                            d: "Once per SSTORE operation from dirty"
                        },
                        netSstoreClearRefund: {
                            v: 15e3,
                            d: "Once per SSTORE operation for clearing an originally existing storage slot"
                        },
                        netSstoreResetRefund: {
                            v: 4800,
                            d: "Once per SSTORE operation for resetting to the original non-zero value"
                        },
                        netSstoreResetClearRefund: {
                            v: 19800,
                            d: "Once per SSTORE operation for resetting to the original zero value"
                        },
                        shl: {
                            v: 3,
                            d: "Base fee of the SHL opcode"
                        },
                        shr: {
                            v: 3,
                            d: "Base fee of the SHR opcode"
                        },
                        sar: {
                            v: 3,
                            d: "Base fee of the SAR opcode"
                        },
                        extcodehash: {
                            v: 400,
                            d: "Base fee of the EXTCODEHASH opcode"
                        },
                        create2: {
                            v: 32e3,
                            d: "Base fee of the CREATE2 opcode"
                        }
                    },
                    vm: {},
                    pow: {
                        minerReward: {
                            v: "2000000000000000000",
                            d: "The amount a miner gets rewarded for mining a block"
                        },
                        difficultyBombDelay: {
                            v: 5e6,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            3810: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "dao",
                    comment: "DAO rescue hardfork",
                    url: "https://eips.ethereum.org/EIPS/eip-779",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            6257: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "grayGlacier",
                    comment: "Delaying the difficulty bomb to Mid September 2022",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/gray-glacier.md",
                    status: "Draft",
                    eips: [
                        5133
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            7446: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "homestead",
                    comment: "Homestead hardfork with protocol and network changes",
                    url: "https://eips.ethereum.org/EIPS/eip-606",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        delegatecall: {
                            v: 40,
                            d: "Base fee of the DELEGATECALL opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            9137: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hardforks = void 0;
                const o = n(r(9454)), i = n(r(3810)), s = n(r(7446)), a = n(r(7458)), c = n(r(2546)), u = n(r(7251)), d = n(r(1353)), l = n(r(5338)), h = n(r(9597)), f = n(r(7931)), p = n(r(9126)), m = n(r(1233)), g = n(r(2761)), y = n(r(3923)), v = n(r(6257)), b = n(r(6697)), E = n(r(6668));
                t.hardforks = {
                    chainstart: o.default,
                    homestead: s.default,
                    dao: i.default,
                    tangerineWhistle: a.default,
                    spuriousDragon: c.default,
                    byzantium: u.default,
                    constantinople: d.default,
                    petersburg: l.default,
                    istanbul: h.default,
                    muirGlacier: f.default,
                    berlin: p.default,
                    london: m.default,
                    shanghai: g.default,
                    arrowGlacier: y.default,
                    grayGlacier: v.default,
                    mergeForkIdTransition: b.default,
                    merge: E.default
                };
            },
            9597: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "istanbul",
                    comment: "HF targeted for December 2019 following the Constantinople/Petersburg HF",
                    url: "https://eips.ethereum.org/EIPS/eip-1679",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        blake2Round: {
                            v: 1,
                            d: "Gas cost per round for the Blake2 F precompile"
                        },
                        ecAdd: {
                            v: 150,
                            d: "Gas costs for curve addition precompile"
                        },
                        ecMul: {
                            v: 6e3,
                            d: "Gas costs for curve multiplication precompile"
                        },
                        ecPairing: {
                            v: 45e3,
                            d: "Base gas costs for curve pairing precompile"
                        },
                        ecPairingWord: {
                            v: 34e3,
                            d: "Gas costs regarding curve pairing precompile input length"
                        },
                        txDataNonZero: {
                            v: 16,
                            d: "Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"
                        },
                        sstoreSentryGasEIP2200: {
                            v: 2300,
                            d: "Minimum gas required to be present for an SSTORE call, not consumed"
                        },
                        sstoreNoopGasEIP2200: {
                            v: 800,
                            d: "Once per SSTORE operation if the value doesn't change"
                        },
                        sstoreDirtyGasEIP2200: {
                            v: 800,
                            d: "Once per SSTORE operation if a dirty value is changed"
                        },
                        sstoreInitGasEIP2200: {
                            v: 2e4,
                            d: "Once per SSTORE operation from clean zero to non-zero"
                        },
                        sstoreInitRefundEIP2200: {
                            v: 19200,
                            d: "Once per SSTORE operation for resetting to the original zero value"
                        },
                        sstoreCleanGasEIP2200: {
                            v: 5e3,
                            d: "Once per SSTORE operation from clean non-zero to something else"
                        },
                        sstoreCleanRefundEIP2200: {
                            v: 4200,
                            d: "Once per SSTORE operation for resetting to the original non-zero value"
                        },
                        sstoreClearRefundEIP2200: {
                            v: 15e3,
                            d: "Once per SSTORE operation for clearing an originally existing storage slot"
                        },
                        balance: {
                            v: 700,
                            d: "Base fee of the BALANCE opcode"
                        },
                        extcodehash: {
                            v: 700,
                            d: "Base fee of the EXTCODEHASH opcode"
                        },
                        chainid: {
                            v: 2,
                            d: "Base fee of the CHAINID opcode"
                        },
                        selfbalance: {
                            v: 5,
                            d: "Base fee of the SELFBALANCE opcode"
                        },
                        sload: {
                            v: 800,
                            d: "Base fee of the SLOAD opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            1233: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "london",
                    comment: "HF targeted for July 2021 following the Berlin fork",
                    url: "https://github.com/ethereum/eth1.0-specs/blob/master/network-upgrades/mainnet-upgrades/london.md",
                    status: "Final",
                    eips: [
                        1559,
                        3198,
                        3529,
                        3541
                    ]
                };
            },
            6668: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "merge",
                    comment: "Hardfork to upgrade the consensus mechanism to Proof-of-Stake",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/merge.md",
                    status: "Final",
                    consensus: {
                        type: "pos",
                        algorithm: "casper",
                        casper: {}
                    },
                    eips: [
                        3675,
                        4399
                    ]
                };
            },
            6697: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "mergeForkIdTransition",
                    comment: "Pre-merge hardfork to fork off non-upgraded clients",
                    url: "https://eips.ethereum.org/EIPS/eip-3675",
                    status: "Draft",
                    eips: []
                };
            },
            7931: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "muirGlacier",
                    comment: "HF to delay the difficulty bomb",
                    url: "https://eips.ethereum.org/EIPS/eip-2384",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 9e6,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            5338: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "petersburg",
                    comment: "Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople",
                    url: "https://eips.ethereum.org/EIPS/eip-1716",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        netSstoreNoopGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreInitGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreCleanGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreDirtyGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreClearRefund: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreResetRefund: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreResetClearRefund: {
                            v: null,
                            d: "Removed along EIP-1283"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            2761: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "shanghai",
                    comment: "Next feature hardfork after the merge hardfork having withdrawals, warm coinbase, push0, limit/meter initcode",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/shanghai.md",
                    status: "Final",
                    eips: [
                        3651,
                        3855,
                        3860,
                        4895
                    ]
                };
            },
            2546: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "spuriousDragon",
                    comment: "HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit",
                    url: "https://eips.ethereum.org/EIPS/eip-607",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        expByte: {
                            v: 50,
                            d: "Times ceil(log256(exponent)) for the EXP instruction"
                        }
                    },
                    vm: {
                        maxCodeSize: {
                            v: 24576,
                            d: "Maximum length of contract code"
                        }
                    },
                    pow: {}
                };
            },
            7458: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "tangerineWhistle",
                    comment: "Hardfork with gas cost changes for IO-heavy operations",
                    url: "https://eips.ethereum.org/EIPS/eip-608",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        sload: {
                            v: 200,
                            d: "Once per SLOAD operation"
                        },
                        call: {
                            v: 700,
                            d: "Once per CALL operation & message call transaction"
                        },
                        extcodesize: {
                            v: 700,
                            d: "Base fee of the EXTCODESIZE opcode"
                        },
                        extcodecopy: {
                            v: 700,
                            d: "Base fee of the EXTCODECOPY opcode"
                        },
                        balance: {
                            v: 400,
                            d: "Base fee of the BALANCE opcode"
                        },
                        delegatecall: {
                            v: 700,
                            d: "Base fee of the DELEGATECALL opcode"
                        },
                        callcode: {
                            v: 700,
                            d: "Base fee of the CALLCODE opcode"
                        },
                        selfdestruct: {
                            v: 5e3,
                            d: "Base fee of the SELFDESTRUCT opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            8317: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(r(6664), t), o(r(4443), t), o(r(850), t), o(r(2290), t);
            },
            850: (e, t)=>{
                "use strict";
                var r;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TypeOutput = void 0, (r = t.TypeOutput || (t.TypeOutput = {}))[r.Number = 0] = "Number", r[r.BigInt = 1] = "BigInt", r[r.Uint8Array = 2] = "Uint8Array", r[r.PrefixedHexString = 3] = "PrefixedHexString";
            },
            2290: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toType = t.ecrecover = t.bigIntToUnpaddedUint8Array = t.bigIntToHex = t.unpadUint8Array = t.stripZeros = t.setLengthLeft = t.assertIsUint8Array = t.zeros = t.bigIntToUint8Array = t.uint8ArrayToBigInt = t.toUint8Array = t.intToUint8Array = t.padToEven = t.parseGethGenesis = t.stripHexPrefix = void 0;
                const n = r(7345), o = r(9634), i = r(4555), s = r(4443), a = r(850);
                t.stripHexPrefix = (e)=>{
                    if ("string" != typeof e) throw new Error("[stripHexPrefix] input must be type 'string', received " + typeof e);
                    return (0, n.isHexPrefixed)(e) ? e.slice(2) : e;
                };
                const c = function(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Received an invalid integer type: ${e}`);
                    return `0x${e.toString(16)}`;
                };
                function u(e) {
                    let t = e;
                    if ("string" != typeof t) throw new Error("[padToEven] value must be type 'string', received " + typeof t);
                    return t.length % 2 && (t = `0${t}`), t;
                }
                function d(e) {
                    const t = (0, o.bytesToHex)(e);
                    return "0x" === t ? BigInt(0) : BigInt(t);
                }
                function l(e) {
                    return (0, t.toUint8Array)(`0x${e.toString(16)}`);
                }
                function h(e) {
                    if (!(0, o.isUint8Array)(e)) throw new Error(`This method only supports Uint8Array but input was: ${e}`);
                }
                function f(e) {
                    let t = e[0];
                    for(; e.length > 0 && "0" === t.toString();)t = (e = e.slice(1))[0];
                    return e;
                }
                t.parseGethGenesis = function(e, r, o) {
                    try {
                        if ([
                            "config",
                            "difficulty",
                            "gasLimit",
                            "alloc"
                        ].some((t)=>!(t in e))) throw new Error("Invalid format, expected geth genesis fields missing");
                        return void 0 !== r && (e.name = r), function(e, r = !0) {
                            var o, i;
                            const { name: a, config: u, difficulty: d, mixHash: l, gasLimit: h, coinbase: f, baseFeePerGas: p } = e;
                            let { extraData: m, timestamp: g, nonce: y } = e;
                            const v = Number(g), { chainId: b } = u;
                            if ("" === m && (m = "0x"), (0, n.isHexPrefixed)(g) || (g = c(parseInt(g))), 18 !== y.length && (y = function(e) {
                                return e && "0x0" !== e ? (0, n.isHexPrefixed)(e) ? `0x${(0, t.stripHexPrefix)(e).padStart(16, "0")}` : `0x${e.padStart(16, "0")}` : "0x0000000000000000";
                            }(y)), u.eip155Block !== u.eip158Block) throw new Error("EIP155 block number must equal EIP 158 block number since both are part of SpuriousDragon hardfork and the client only supports activating the full hardfork");
                            const E = {
                                name: a,
                                chainId: b,
                                networkId: b,
                                genesis: {
                                    timestamp: g,
                                    gasLimit: parseInt(h),
                                    difficulty: parseInt(d),
                                    nonce: y,
                                    extraData: m,
                                    mixHash: l,
                                    coinbase: f,
                                    baseFeePerGas: p
                                },
                                hardfork: void 0,
                                hardforks: [],
                                bootstrapNodes: [],
                                consensus: void 0 !== u.clique ? {
                                    type: "poa",
                                    algorithm: "clique",
                                    clique: {
                                        period: null !== (o = u.clique.period) && void 0 !== o ? o : u.clique.blockperiodseconds,
                                        epoch: null !== (i = u.clique.epoch) && void 0 !== i ? i : u.clique.epochlength
                                    }
                                } : {
                                    type: "pow",
                                    algorithm: "ethash",
                                    ethash: {}
                                }
                            }, _ = {
                                [s.Hardfork.Homestead]: {
                                    name: "homesteadBlock"
                                },
                                [s.Hardfork.Dao]: {
                                    name: "daoForkBlock"
                                },
                                [s.Hardfork.TangerineWhistle]: {
                                    name: "eip150Block"
                                },
                                [s.Hardfork.SpuriousDragon]: {
                                    name: "eip155Block"
                                },
                                [s.Hardfork.Byzantium]: {
                                    name: "byzantiumBlock"
                                },
                                [s.Hardfork.Constantinople]: {
                                    name: "constantinopleBlock"
                                },
                                [s.Hardfork.Petersburg]: {
                                    name: "petersburgBlock"
                                },
                                [s.Hardfork.Istanbul]: {
                                    name: "istanbulBlock"
                                },
                                [s.Hardfork.MuirGlacier]: {
                                    name: "muirGlacierBlock"
                                },
                                [s.Hardfork.Berlin]: {
                                    name: "berlinBlock"
                                },
                                [s.Hardfork.London]: {
                                    name: "londonBlock"
                                },
                                [s.Hardfork.MergeForkIdTransition]: {
                                    name: "mergeForkBlock",
                                    postMerge: r
                                },
                                [s.Hardfork.Shanghai]: {
                                    name: "shanghaiTime",
                                    postMerge: !0,
                                    isTimestamp: !0
                                },
                                [s.Hardfork.ShardingForkDev]: {
                                    name: "shardingForkTime",
                                    postMerge: !0,
                                    isTimestamp: !0
                                }
                            }, A = Object.keys(_).reduce((e, t)=>(e[_[t].name] = t, e), {}), T = Object.keys(u).filter((e)=>void 0 !== A[e] && void 0 !== u[e] && null !== u[e]);
                            if (E.hardforks = T.map((e)=>({
                                    name: A[e],
                                    block: !0 === _[A[e]].isTimestamp || "number" != typeof u[e] ? null : u[e],
                                    timestamp: !0 === _[A[e]].isTimestamp && "number" == typeof u[e] ? u[e] : void 0
                                })).filter((e)=>null !== e.block || void 0 !== e.timestamp), E.hardforks.sort((e, t)=>{
                                var r, n;
                                return (null !== (r = e.block) && void 0 !== r ? r : 1 / 0) - (null !== (n = t.block) && void 0 !== n ? n : 1 / 0);
                            }), E.hardforks.sort((e, t)=>{
                                var r, n;
                                return (null !== (r = e.timestamp) && void 0 !== r ? r : v) - (null !== (n = t.timestamp) && void 0 !== n ? n : v);
                            }), void 0 !== u.terminalTotalDifficulty) {
                                const e = {
                                    name: s.Hardfork.Merge,
                                    ttd: u.terminalTotalDifficulty,
                                    block: null
                                }, t = E.hardforks.findIndex((e)=>{
                                    var t;
                                    return !0 === (null === (t = _[e.name]) || void 0 === t ? void 0 : t.postMerge);
                                });
                                -1 !== t ? E.hardforks.splice(t, 0, e) : E.hardforks.push(e);
                            }
                            const w = E.hardforks.length > 0 ? E.hardforks.slice(-1)[0] : void 0;
                            return E.hardfork = null == w ? void 0 : w.name, E.hardforks.unshift({
                                name: s.Hardfork.Chainstart,
                                block: 0
                            }), E;
                        }(e, o);
                    } catch (e) {
                        throw new Error(`Error parsing parameters file: ${e.message}`);
                    }
                }, t.padToEven = u, t.intToUint8Array = function(e) {
                    const t = c(e);
                    return (0, o.hexToBytes)(`0x${u(t.slice(2))}`);
                }, t.toUint8Array = function(e) {
                    var r;
                    if (null == e) return new Uint8Array;
                    if (e instanceof Uint8Array) return e;
                    if ("Uint8Array" === (null === (r = null == e ? void 0 : e.constructor) || void 0 === r ? void 0 : r.name)) return Uint8Array.from(e);
                    if (Array.isArray(e)) return Uint8Array.from(e);
                    if ("string" == typeof e) {
                        if (!(0, n.isHexString)(e)) throw new Error(`Cannot convert string to Uint8Array. only supports 0x-prefixed hex strings and this string was given: ${e}`);
                        return (0, o.hexToBytes)(u((0, t.stripHexPrefix)(e)));
                    }
                    if ("number" == typeof e) return (0, t.toUint8Array)((0, o.numberToHex)(e));
                    if ("bigint" == typeof e) {
                        if (e < BigInt(0)) throw new Error(`Cannot convert negative bigint to Uint8Array. Given: ${e}`);
                        let r = e.toString(16);
                        return r.length % 2 && (r = `0${r}`), (0, t.toUint8Array)(`0x${r}`);
                    }
                    if (e.toArray) return Uint8Array.from(e.toArray());
                    throw new Error("invalid type");
                }, t.uint8ArrayToBigInt = d, t.bigIntToUint8Array = l, t.zeros = function(e) {
                    return new Uint8Array(e).fill(0);
                }, t.assertIsUint8Array = h, t.setLengthLeft = function(e, r) {
                    return h(e), function(e, r, n) {
                        const o = (0, t.zeros)(r);
                        return e.length < r ? (o.set(e, r - e.length), o) : e.subarray(-r);
                    }(e, r);
                }, t.stripZeros = f, t.unpadUint8Array = function(e) {
                    return h(e), f(e);
                }, t.bigIntToHex = (e)=>`0x${e.toString(16)}`, t.bigIntToUnpaddedUint8Array = function(e) {
                    return (0, t.unpadUint8Array)(l(e));
                }, t.ecrecover = function(e, t, r, n, o) {
                    const s = function(e, t) {
                        return e === BigInt(0) || e === BigInt(1) ? e : void 0 === t ? e - BigInt(27) : e - (t * BigInt(2) + BigInt(35));
                    }(t, o);
                    if (!function(e) {
                        return e === BigInt(0) || e === BigInt(1);
                    }(s)) throw new Error("Invalid signature v value");
                    return new i.secp256k1.Signature(d(r), d(n)).addRecoveryBit(Number(s)).recoverPublicKey(e).toRawBytes(!1).slice(1);
                }, t.toType = function(e, r) {
                    if (null === e) return null;
                    if (void 0 === e) return;
                    if ("string" == typeof e && !(0, n.isHexString)(e)) throw new Error(`A string must be provided with a 0x-prefix, given: ${e}`);
                    if ("number" == typeof e && !Number.isSafeInteger(e)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
                    const i = (0, t.toUint8Array)(e);
                    switch(r){
                        case a.TypeOutput.Uint8Array:
                            return i;
                        case a.TypeOutput.BigInt:
                            return d(i);
                        case a.TypeOutput.Number:
                            {
                                const e = d(i);
                                if (e > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
                                return Number(e);
                            }
                        case a.TypeOutput.PrefixedHexString:
                            return (0, o.bytesToHex)(i);
                        default:
                            throw new Error("unknown outputType");
                    }
                };
            },
            9247: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(r(8632), t), o(r(1560), t), o(r(4874), t), o(r(5774), t), o(r(8317), t), o(r(9275), t);
            },
            5774: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keyStoreSchema = void 0, t.keyStoreSchema = {
                    type: "object",
                    required: [
                        "crypto",
                        "id",
                        "version",
                        "address"
                    ],
                    properties: {
                        crypto: {
                            type: "object",
                            required: [
                                "cipher",
                                "ciphertext",
                                "cipherparams",
                                "kdf",
                                "kdfparams",
                                "mac"
                            ],
                            properties: {
                                cipher: {
                                    type: "string"
                                },
                                ciphertext: {
                                    type: "string"
                                },
                                cipherparams: {
                                    type: "object"
                                },
                                kdf: {
                                    type: "string"
                                },
                                kdfparams: {
                                    type: "object"
                                },
                                salt: {
                                    type: "string"
                                },
                                mac: {
                                    type: "string"
                                }
                            }
                        },
                        id: {
                            type: "string"
                        },
                        version: {
                            type: "number"
                        },
                        address: {
                            type: "string"
                        }
                    }
                };
            },
            7592: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Address = void 0;
                const n = r(7423), o = r(9634), i = r(4555), s = r(2290);
                class a {
                    constructor(e){
                        if (20 !== e.length) throw new Error("Invalid address length");
                        this.buf = e;
                    }
                    static zero() {
                        return new a((0, s.zeros)(20));
                    }
                    equals(e) {
                        return (0, o.uint8ArrayEquals)(this.buf, e.buf);
                    }
                    isZero() {
                        return this.equals(a.zero());
                    }
                    toString() {
                        return (0, o.bytesToHex)(this.buf);
                    }
                    toArray() {
                        return this.buf;
                    }
                    static publicToAddress(e, t = !1) {
                        let r = e;
                        if ((0, s.assertIsUint8Array)(r), t && 64 !== r.length && (r = i.secp256k1.ProjectivePoint.fromHex(r).toRawBytes(!1).slice(1)), 64 !== r.length) throw new Error("Expected pubKey to be of length 64");
                        return (0, n.keccak256)(r).slice(-20);
                    }
                }
                t.Address = a;
            },
            915: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BaseTransaction = void 0;
                const n = r(9634), o = r(4555), i = r(2290), s = r(6664), a = r(4443), c = r(9964), u = r(7592), d = r(4562);
                t.BaseTransaction = class {
                    constructor(e, t){
                        var r, n;
                        this.cache = {
                            hash: void 0,
                            dataFee: void 0
                        }, this.activeCapabilities = [], this.DEFAULT_CHAIN = a.Chain.Mainnet, this.DEFAULT_HARDFORK = a.Hardfork.Merge;
                        const { nonce: o, gasLimit: s, to: c, value: l, data: h, v: f, r: p, s: m, type: g } = e;
                        this._type = Number((0, i.uint8ArrayToBigInt)((0, i.toUint8Array)(g))), this.txOptions = t;
                        const y = (0, i.toUint8Array)("" === c ? "0x" : c), v = (0, i.toUint8Array)("" === f ? "0x" : f), b = (0, i.toUint8Array)("" === p ? "0x" : p), E = (0, i.toUint8Array)("" === m ? "0x" : m);
                        this.nonce = (0, i.uint8ArrayToBigInt)((0, i.toUint8Array)("" === o ? "0x" : o)), this.gasLimit = (0, i.uint8ArrayToBigInt)((0, i.toUint8Array)("" === s ? "0x" : s)), this.to = y.length > 0 ? new u.Address(y) : void 0, this.value = (0, i.uint8ArrayToBigInt)((0, i.toUint8Array)("" === l ? "0x" : l)), this.data = (0, i.toUint8Array)("" === h ? "0x" : h), this.v = v.length > 0 ? (0, i.uint8ArrayToBigInt)(v) : void 0, this.r = b.length > 0 ? (0, i.uint8ArrayToBigInt)(b) : void 0, this.s = E.length > 0 ? (0, i.uint8ArrayToBigInt)(E) : void 0, this._validateCannotExceedMaxInteger({
                            value: this.value,
                            r: this.r,
                            s: this.s
                        }), this._validateCannotExceedMaxInteger({
                            gasLimit: this.gasLimit
                        }, 64), this._validateCannotExceedMaxInteger({
                            nonce: this.nonce
                        }, 64, !0);
                        const _ = void 0 === this.to || null === this.to, A = null !== (r = t.allowUnlimitedInitCodeSize) && void 0 !== r && r, T = null !== (n = t.common) && void 0 !== n ? n : this._getCommon();
                        _ && T.isActivatedEIP(3860) && !A && (0, d.checkMaxInitCodeSize)(T, this.data.length);
                    }
                    get type() {
                        return this._type;
                    }
                    supports(e) {
                        return this.activeCapabilities.includes(e);
                    }
                    validate(e = !1) {
                        const t = [];
                        return this.getBaseFee() > this.gasLimit && t.push(`gasLimit is too low. given ${this.gasLimit}, need at least ${this.getBaseFee()}`), this.isSigned() && !this.verifySignature() && t.push("Invalid Signature"), e ? t : 0 === t.length;
                    }
                    _validateYParity() {
                        const { v: e } = this;
                        if (void 0 !== e && e !== BigInt(0) && e !== BigInt(1)) {
                            const e = this._errorMsg("The y-parity of the transaction should either be 0 or 1");
                            throw new Error(e);
                        }
                    }
                    _validateHighS() {
                        const { s: e } = this;
                        if (this.common.gteHardfork("homestead") && void 0 !== e && e > o.SECP256K1_ORDER_DIV_2) {
                            const e = this._errorMsg("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
                            throw new Error(e);
                        }
                    }
                    getBaseFee() {
                        const e = this.common.param("gasPrices", "tx");
                        let t = this.getDataFee();
                        if (e && (t += e), this.common.gteHardfork("homestead") && this.toCreationAddress()) {
                            const e = this.common.param("gasPrices", "txCreation");
                            e && (t += e);
                        }
                        return t;
                    }
                    getDataFee() {
                        const e = this.common.param("gasPrices", "txDataZero"), t = this.common.param("gasPrices", "txDataNonZero");
                        let r = BigInt(0);
                        for(let n = 0; n < this.data.length; n += 1)0 === this.data[n] ? r += e : r += t;
                        if ((void 0 === this.to || null === this.to) && this.common.isActivatedEIP(3860)) {
                            const e = BigInt(Math.ceil(this.data.length / 32));
                            r += this.common.param("gasPrices", "initCodeWordCost") * e;
                        }
                        return r;
                    }
                    toCreationAddress() {
                        return void 0 === this.to || 0 === this.to.buf.length;
                    }
                    isSigned() {
                        const { v: e, r: t, s: r } = this;
                        return void 0 !== e && void 0 !== t && void 0 !== r;
                    }
                    verifySignature() {
                        try {
                            const e = this.getSenderPublicKey();
                            return 0 !== (0, i.unpadUint8Array)(e).length;
                        } catch (e) {
                            return !1;
                        }
                    }
                    getSenderAddress() {
                        return new u.Address(u.Address.publicToAddress(this.getSenderPublicKey()));
                    }
                    sign(e) {
                        if (32 !== e.length) {
                            const e = this._errorMsg("Private key must be 32 bytes in length.");
                            throw new Error(e);
                        }
                        let t = !1;
                        0 === this.type && this.common.gteHardfork("spuriousDragon") && !this.supports(c.Capability.EIP155ReplayProtection) && (this.activeCapabilities.push(c.Capability.EIP155ReplayProtection), t = !0);
                        const r = this.getMessageToSign(!0), { v: n, r: o, s: i } = this._ecsign(r, e), s = this._processSignature(n, o, i);
                        if (t) {
                            const e = this.activeCapabilities.indexOf(c.Capability.EIP155ReplayProtection);
                            e > -1 && this.activeCapabilities.splice(e, 1);
                        }
                        return s;
                    }
                    _getCommon(e, t) {
                        var r, n, o, a;
                        if (void 0 !== t) {
                            const r = (0, i.uint8ArrayToBigInt)((0, i.toUint8Array)(t));
                            if (e) {
                                if (e.chainId() !== r) {
                                    const e = this._errorMsg("The chain ID does not match the chain ID of Common");
                                    throw new Error(e);
                                }
                                return e.copy();
                            }
                            return s.Common.isSupportedChainId(r) ? new s.Common({
                                chain: r,
                                hardfork: this.DEFAULT_HARDFORK
                            }) : s.Common.custom({
                                name: "custom-chain",
                                networkId: r,
                                chainId: r
                            }, {
                                baseChain: this.DEFAULT_CHAIN,
                                hardfork: this.DEFAULT_HARDFORK
                            });
                        }
                        if ((null == e ? void 0 : e.copy) && "function" == typeof (null == e ? void 0 : e.copy)) return e.copy();
                        if (e) {
                            const t = "function" == typeof e.hardfork ? e.hardfork() : e.hardfork;
                            return s.Common.custom({
                                name: "custom-chain",
                                networkId: e.networkId ? e.networkId() : null !== (n = BigInt(null === (r = e.customChain) || void 0 === r ? void 0 : r.networkId)) && void 0 !== n ? n : void 0,
                                chainId: e.chainId ? e.chainId() : null !== (a = BigInt(null === (o = e.customChain) || void 0 === o ? void 0 : o.chainId)) && void 0 !== a ? a : void 0
                            }, {
                                baseChain: this.DEFAULT_CHAIN,
                                hardfork: t || this.DEFAULT_HARDFORK
                            });
                        }
                        return new s.Common({
                            chain: this.DEFAULT_CHAIN,
                            hardfork: this.DEFAULT_HARDFORK
                        });
                    }
                    _validateCannotExceedMaxInteger(e, t = 256, r = !1) {
                        for (const [n, i] of Object.entries(e))switch(t){
                            case 64:
                                if (r) {
                                    if (void 0 !== i && i >= o.MAX_UINT64) {
                                        const e = this._errorMsg(`${n} cannot equal or exceed MAX_UINT64 (2^64-1), given ${i}`);
                                        throw new Error(e);
                                    }
                                } else if (void 0 !== i && i > o.MAX_UINT64) {
                                    const e = this._errorMsg(`${n} cannot exceed MAX_UINT64 (2^64-1), given ${i}`);
                                    throw new Error(e);
                                }
                                break;
                            case 256:
                                if (r) {
                                    if (void 0 !== i && i >= o.MAX_INTEGER) {
                                        const e = this._errorMsg(`${n} cannot equal or exceed MAX_INTEGER (2^256-1), given ${i}`);
                                        throw new Error(e);
                                    }
                                } else if (void 0 !== i && i > o.MAX_INTEGER) {
                                    const e = this._errorMsg(`${n} cannot exceed MAX_INTEGER (2^256-1), given ${i}`);
                                    throw new Error(e);
                                }
                                break;
                            default:
                                {
                                    const e = this._errorMsg("unimplemented bits value");
                                    throw new Error(e);
                                }
                        }
                    }
                    static _validateNotArray(e) {
                        const t = [
                            "nonce",
                            "gasPrice",
                            "gasLimit",
                            "to",
                            "value",
                            "data",
                            "v",
                            "r",
                            "s",
                            "type",
                            "baseFee",
                            "maxFeePerGas",
                            "chainId"
                        ];
                        for (const [r, n] of Object.entries(e))if (t.includes(r) && Array.isArray(n)) throw new Error(`${r} cannot be an array`);
                    }
                    _getSharedErrorPostfix() {
                        let e = "";
                        try {
                            e = this.isSigned() ? (0, n.bytesToHex)(this.hash()) : "not available (unsigned)";
                        } catch (t) {
                            e = "error";
                        }
                        let t = "";
                        try {
                            t = this.isSigned().toString();
                        } catch (t) {
                            e = "error";
                        }
                        let r = "";
                        try {
                            r = this.common.hardfork();
                        } catch (e) {
                            r = "error";
                        }
                        let o = `tx type=${this.type} hash=${e} nonce=${this.nonce} value=${this.value} `;
                        return o += `signed=${t} hf=${r}`, o;
                    }
                    _ecsign(e, t, r) {
                        const n = o.secp256k1.sign(e, t), i = n.toCompactRawBytes();
                        return {
                            r: i.subarray(0, 32),
                            s: i.subarray(32, 64),
                            v: void 0 === r ? BigInt(n.recovery + 27) : BigInt(n.recovery + 35) + BigInt(r) * BigInt(2)
                        };
                    }
                    static fromSerializedTx(e, t = {}) {}
                    static fromTxData(e, t = {}) {}
                };
            },
            4555: function(e, t, r) {
                "use strict";
                var n, o = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && o(t, e, r);
                    return i(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SECP256K1_ORDER_DIV_2 = t.SECP256K1_ORDER = t.MAX_INTEGER = t.MAX_UINT64 = t.secp256k1 = void 0;
                const a = s(r(5473));
                t.secp256k1 = null !== (n = a.secp256k1) && void 0 !== n ? n : a, t.MAX_UINT64 = BigInt("0xffffffffffffffff"), t.MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), t.SECP256K1_ORDER = t.secp256k1.CURVE.n, t.SECP256K1_ORDER_DIV_2 = t.SECP256K1_ORDER / BigInt(2);
            },
            6135: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FeeMarketEIP1559Transaction = void 0;
                const n = r(7423), o = r(7345), i = r(7256), s = r(9634), a = r(4555), c = r(915), u = r(4562), d = r(2290), l = (0, s.hexToBytes)(2..toString(16).padStart(2, "0"));
                class h extends c.BaseTransaction {
                    constructor(e, t = {}){
                        var r;
                        super(Object.assign(Object.assign({}, e), {
                            type: 2
                        }), t), this.DEFAULT_HARDFORK = "london";
                        const { chainId: n, accessList: o, maxFeePerGas: i, maxPriorityFeePerGas: s } = e;
                        if (this.common = this._getCommon(t.common, n), this.chainId = this.common.chainId(), !this.common.isActivatedEIP(1559)) throw new Error("EIP-1559 not enabled on Common");
                        this.activeCapabilities = this.activeCapabilities.concat([
                            1559,
                            2718,
                            2930
                        ]);
                        const l = (0, u.getAccessListData)(null != o ? o : []);
                        if (this.accessList = l.accessList, this.AccessListJSON = l.AccessListJSON, (0, u.verifyAccessList)(this.accessList), this.maxFeePerGas = (0, d.uint8ArrayToBigInt)((0, d.toUint8Array)("" === i ? "0x" : i)), this.maxPriorityFeePerGas = (0, d.uint8ArrayToBigInt)((0, d.toUint8Array)("" === s ? "0x" : s)), this._validateCannotExceedMaxInteger({
                            maxFeePerGas: this.maxFeePerGas,
                            maxPriorityFeePerGas: this.maxPriorityFeePerGas
                        }), c.BaseTransaction._validateNotArray(e), this.gasLimit * this.maxFeePerGas > a.MAX_INTEGER) {
                            const e = this._errorMsg("gasLimit * maxFeePerGas cannot exceed MAX_INTEGER (2^256-1)");
                            throw new Error(e);
                        }
                        if (this.maxFeePerGas < this.maxPriorityFeePerGas) {
                            const e = this._errorMsg("maxFeePerGas cannot be less than maxPriorityFeePerGas (The total must be the larger of the two)");
                            throw new Error(e);
                        }
                        this._validateYParity(), this._validateHighS(), (null === (r = null == t ? void 0 : t.freeze) || void 0 === r || r) && Object.freeze(this);
                    }
                    static fromTxData(e, t = {}) {
                        return new h(e, t);
                    }
                    static fromSerializedTx(e, t = {}) {
                        if (!(0, s.uint8ArrayEquals)(e.subarray(0, 1), l)) throw new Error(`Invalid serialized tx input: not an EIP-1559 transaction (wrong tx type, expected: 2, received: ${(0, s.bytesToHex)(e.subarray(0, 1))}`);
                        const r = i.RLP.decode(e.subarray(1));
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input: must be array");
                        return h.fromValuesArray(r, t);
                    }
                    static fromValuesArray(e, t = {}) {
                        if (9 !== e.length && 12 !== e.length) throw new Error("Invalid EIP-1559 transaction. Only expecting 9 values (for unsigned tx) or 12 values (for signed tx).");
                        const [r, n, i, s, a, c, u, l, f, p, m, g] = e;
                        return this._validateNotArray({
                            chainId: r,
                            v: p
                        }), (0, o.validateNoLeadingZeroes)({
                            nonce: n,
                            maxPriorityFeePerGas: i,
                            maxFeePerGas: s,
                            gasLimit: a,
                            value: u,
                            v: p,
                            r: m,
                            s: g
                        }), new h({
                            chainId: (0, d.uint8ArrayToBigInt)(r),
                            nonce: n,
                            maxPriorityFeePerGas: i,
                            maxFeePerGas: s,
                            gasLimit: a,
                            to: c,
                            value: u,
                            data: l,
                            accessList: null != f ? f : [],
                            v: void 0 !== p ? (0, d.uint8ArrayToBigInt)(p) : void 0,
                            r: m,
                            s: g
                        }, t);
                    }
                    getDataFee() {
                        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
                        let e = super.getDataFee();
                        return e += BigInt((0, u.getDataFeeEIP2930)(this.accessList, this.common)), Object.isFrozen(this) && (this.cache.dataFee = {
                            value: e,
                            hardfork: this.common.hardfork()
                        }), e;
                    }
                    getUpfrontCost(e = BigInt(0)) {
                        const t = this.maxPriorityFeePerGas, r = this.maxFeePerGas - e, n = (t < r ? t : r) + e;
                        return this.gasLimit * n + this.value;
                    }
                    raw() {
                        return [
                            (0, d.bigIntToUnpaddedUint8Array)(this.chainId),
                            (0, d.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, d.bigIntToUnpaddedUint8Array)(this.maxPriorityFeePerGas),
                            (0, d.bigIntToUnpaddedUint8Array)(this.maxFeePerGas),
                            (0, d.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, d.bigIntToUnpaddedUint8Array)(this.value),
                            this.data,
                            this.accessList,
                            void 0 !== this.v ? (0, d.bigIntToUnpaddedUint8Array)(this.v) : Uint8Array.from([]),
                            void 0 !== this.r ? (0, d.bigIntToUnpaddedUint8Array)(this.r) : Uint8Array.from([]),
                            void 0 !== this.s ? (0, d.bigIntToUnpaddedUint8Array)(this.s) : Uint8Array.from([])
                        ];
                    }
                    serialize() {
                        const e = this.raw();
                        return (0, s.uint8ArrayConcat)(l, i.RLP.encode(e));
                    }
                    getMessageToSign(e = !0) {
                        const t = this.raw().slice(0, 9), r = (0, s.uint8ArrayConcat)(l, i.RLP.encode(t));
                        return e ? (0, n.keccak256)(r) : r;
                    }
                    hash() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, n.keccak256)(this.serialize())), this.cache.hash) : (0, n.keccak256)(this.serialize());
                    }
                    getMessageToVerifySignature() {
                        return this.getMessageToSign();
                    }
                    getSenderPublicKey() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call this method if transaction is not signed");
                            throw new Error(e);
                        }
                        const e = this.getMessageToVerifySignature(), { v: t, r: r, s: n } = this;
                        this._validateHighS();
                        try {
                            return (0, d.ecrecover)(e, t + BigInt(27), (0, d.bigIntToUnpaddedUint8Array)(r), (0, d.bigIntToUnpaddedUint8Array)(n));
                        } catch (e) {
                            const t = this._errorMsg("Invalid Signature");
                            throw new Error(t);
                        }
                    }
                    _processSignature(e, t, r) {
                        const n = Object.assign(Object.assign({}, this.txOptions), {
                            common: this.common
                        });
                        return h.fromTxData({
                            chainId: this.chainId,
                            nonce: this.nonce,
                            maxPriorityFeePerGas: this.maxPriorityFeePerGas,
                            maxFeePerGas: this.maxFeePerGas,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            accessList: this.accessList,
                            v: e - BigInt(27),
                            r: (0, d.uint8ArrayToBigInt)(t),
                            s: (0, d.uint8ArrayToBigInt)(r)
                        }, n);
                    }
                    toJSON() {
                        const e = (0, u.getAccessListJSON)(this.accessList);
                        return {
                            chainId: (0, d.bigIntToHex)(this.chainId),
                            nonce: (0, d.bigIntToHex)(this.nonce),
                            maxPriorityFeePerGas: (0, d.bigIntToHex)(this.maxPriorityFeePerGas),
                            maxFeePerGas: (0, d.bigIntToHex)(this.maxFeePerGas),
                            gasLimit: (0, d.bigIntToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, d.bigIntToHex)(this.value),
                            data: (0, s.bytesToHex)(this.data),
                            accessList: e,
                            v: void 0 !== this.v ? (0, d.bigIntToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, d.bigIntToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, d.bigIntToHex)(this.s) : void 0
                        };
                    }
                    errorStr() {
                        let e = this._getSharedErrorPostfix();
                        return e += ` maxFeePerGas=${this.maxFeePerGas} maxPriorityFeePerGas=${this.maxPriorityFeePerGas}`, e;
                    }
                    _errorMsg(e) {
                        return `${e} (${this.errorStr()})`;
                    }
                }
                t.FeeMarketEIP1559Transaction = h;
            },
            9013: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AccessListEIP2930Transaction = void 0;
                const n = r(7423), o = r(7345), i = r(7256), s = r(9634), a = r(4555), c = r(4562), u = r(2290), d = r(915), l = (0, s.hexToBytes)(1..toString(16).padStart(2, "0"));
                class h extends d.BaseTransaction {
                    constructor(e, t = {}){
                        var r;
                        super(Object.assign(Object.assign({}, e), {
                            type: 1
                        }), t), this.DEFAULT_HARDFORK = "berlin";
                        const { chainId: n, accessList: o, gasPrice: i } = e;
                        if (this.common = this._getCommon(t.common, n), this.chainId = this.common.chainId(), !this.common.isActivatedEIP(2930)) throw new Error("EIP-2930 not enabled on Common");
                        this.activeCapabilities = this.activeCapabilities.concat([
                            2718,
                            2930
                        ]);
                        const s = (0, c.getAccessListData)(null != o ? o : []);
                        if (this.accessList = s.accessList, this.AccessListJSON = s.AccessListJSON, (0, c.verifyAccessList)(this.accessList), this.gasPrice = (0, u.uint8ArrayToBigInt)((0, u.toUint8Array)("" === i ? "0x" : i)), this._validateCannotExceedMaxInteger({
                            gasPrice: this.gasPrice
                        }), d.BaseTransaction._validateNotArray(e), this.gasPrice * this.gasLimit > a.MAX_INTEGER) {
                            const e = this._errorMsg("gasLimit * gasPrice cannot exceed MAX_INTEGER");
                            throw new Error(e);
                        }
                        this._validateYParity(), this._validateHighS(), (null === (r = null == t ? void 0 : t.freeze) || void 0 === r || r) && Object.freeze(this);
                    }
                    static fromTxData(e, t = {}) {
                        return new h(e, t);
                    }
                    static fromSerializedTx(e, t = {}) {
                        if (!(0, s.uint8ArrayEquals)(e.subarray(0, 1), l)) throw new Error(`Invalid serialized tx input: not an EIP-2930 transaction (wrong tx type, expected: 1, received: ${(0, s.bytesToHex)(e.subarray(0, 1))}`);
                        const r = i.RLP.decode(Uint8Array.from(e.subarray(1)));
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input: must be array");
                        return h.fromValuesArray(r, t);
                    }
                    static fromValuesArray(e, t = {}) {
                        if (8 !== e.length && 11 !== e.length) throw new Error("Invalid EIP-2930 transaction. Only expecting 8 values (for unsigned tx) or 11 values (for signed tx).");
                        const [r, n, i, s, a, c, d, l, f, p, m] = e;
                        return this._validateNotArray({
                            chainId: r,
                            v: f
                        }), (0, o.validateNoLeadingZeroes)({
                            nonce: n,
                            gasPrice: i,
                            gasLimit: s,
                            value: c,
                            v: f,
                            r: p,
                            s: m
                        }), new h({
                            chainId: (0, u.uint8ArrayToBigInt)(r),
                            nonce: n,
                            gasPrice: i,
                            gasLimit: s,
                            to: a,
                            value: c,
                            data: d,
                            accessList: null != l ? l : [],
                            v: void 0 !== f ? (0, u.uint8ArrayToBigInt)(f) : void 0,
                            r: p,
                            s: m
                        }, t);
                    }
                    getDataFee() {
                        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
                        let e = super.getDataFee();
                        return e += BigInt((0, c.getDataFeeEIP2930)(this.accessList, this.common)), Object.isFrozen(this) && (this.cache.dataFee = {
                            value: e,
                            hardfork: this.common.hardfork()
                        }), e;
                    }
                    getUpfrontCost() {
                        return this.gasLimit * this.gasPrice + this.value;
                    }
                    raw() {
                        return [
                            (0, u.bigIntToUnpaddedUint8Array)(this.chainId),
                            (0, u.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, u.bigIntToUnpaddedUint8Array)(this.gasPrice),
                            (0, u.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, u.bigIntToUnpaddedUint8Array)(this.value),
                            this.data,
                            this.accessList,
                            void 0 !== this.v ? (0, u.bigIntToUnpaddedUint8Array)(this.v) : Uint8Array.from([]),
                            void 0 !== this.r ? (0, u.bigIntToUnpaddedUint8Array)(this.r) : Uint8Array.from([]),
                            void 0 !== this.s ? (0, u.bigIntToUnpaddedUint8Array)(this.s) : Uint8Array.from([])
                        ];
                    }
                    serialize() {
                        const e = this.raw();
                        return (0, s.uint8ArrayConcat)(l, i.RLP.encode(e));
                    }
                    getMessageToSign(e = !0) {
                        const t = this.raw().slice(0, 8), r = (0, s.uint8ArrayConcat)(l, i.RLP.encode(t));
                        return e ? (0, n.keccak256)(r) : r;
                    }
                    hash() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, n.keccak256)(this.serialize())), this.cache.hash) : (0, n.keccak256)(this.serialize());
                    }
                    getMessageToVerifySignature() {
                        return this.getMessageToSign();
                    }
                    getSenderPublicKey() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call this method if transaction is not signed");
                            throw new Error(e);
                        }
                        const e = this.getMessageToVerifySignature(), { v: t, r: r, s: n } = this;
                        this._validateHighS();
                        try {
                            return (0, u.ecrecover)(e, t + BigInt(27), (0, u.bigIntToUnpaddedUint8Array)(r), (0, u.bigIntToUnpaddedUint8Array)(n));
                        } catch (e) {
                            const t = this._errorMsg("Invalid Signature");
                            throw new Error(t);
                        }
                    }
                    _processSignature(e, t, r) {
                        const n = Object.assign(Object.assign({}, this.txOptions), {
                            common: this.common
                        });
                        return h.fromTxData({
                            chainId: this.chainId,
                            nonce: this.nonce,
                            gasPrice: this.gasPrice,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            accessList: this.accessList,
                            v: e - BigInt(27),
                            r: (0, u.uint8ArrayToBigInt)(t),
                            s: (0, u.uint8ArrayToBigInt)(r)
                        }, n);
                    }
                    toJSON() {
                        const e = (0, c.getAccessListJSON)(this.accessList);
                        return {
                            chainId: (0, u.bigIntToHex)(this.chainId),
                            nonce: (0, u.bigIntToHex)(this.nonce),
                            gasPrice: (0, u.bigIntToHex)(this.gasPrice),
                            gasLimit: (0, u.bigIntToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, u.bigIntToHex)(this.value),
                            data: (0, s.bytesToHex)(this.data),
                            accessList: e,
                            v: void 0 !== this.v ? (0, u.bigIntToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, u.bigIntToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, u.bigIntToHex)(this.s) : void 0
                        };
                    }
                    errorStr() {
                        var e, t;
                        let r = this._getSharedErrorPostfix();
                        return r += ` gasPrice=${this.gasPrice} accessListCount=${null !== (t = null === (e = this.accessList) || void 0 === e ? void 0 : e.length) && void 0 !== t ? t : 0}`, r;
                    }
                    _errorMsg(e) {
                        return `${e} (${this.errorStr()})`;
                    }
                }
                t.AccessListEIP2930Transaction = h;
            },
            9275: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                }, s = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.txUtils = t.BaseTransaction = t.TransactionFactory = t.Transaction = t.AccessListEIP2930Transaction = t.FeeMarketEIP1559Transaction = void 0;
                var a = r(6135);
                Object.defineProperty(t, "FeeMarketEIP1559Transaction", {
                    enumerable: !0,
                    get: function() {
                        return a.FeeMarketEIP1559Transaction;
                    }
                });
                var c = r(9013);
                Object.defineProperty(t, "AccessListEIP2930Transaction", {
                    enumerable: !0,
                    get: function() {
                        return c.AccessListEIP2930Transaction;
                    }
                });
                var u = r(5381);
                Object.defineProperty(t, "Transaction", {
                    enumerable: !0,
                    get: function() {
                        return u.Transaction;
                    }
                });
                var d = r(7668);
                Object.defineProperty(t, "TransactionFactory", {
                    enumerable: !0,
                    get: function() {
                        return d.TransactionFactory;
                    }
                });
                var l = r(915);
                Object.defineProperty(t, "BaseTransaction", {
                    enumerable: !0,
                    get: function() {
                        return l.BaseTransaction;
                    }
                }), t.txUtils = i(r(4562)), s(r(9964), t);
            },
            5381: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Transaction = void 0;
                const n = r(7256), o = r(7423), i = r(9634), s = r(7345), a = r(2290), c = r(4555), u = r(915), d = r(9964);
                function l(e, t) {
                    const r = Number(e), n = 2 * Number(t);
                    return r === n + 35 || r === n + 36;
                }
                class h extends u.BaseTransaction {
                    constructor(e, t = {}){
                        var r;
                        if (super(Object.assign(Object.assign({}, e), {
                            type: 0
                        }), t), this.common = this._validateTxV(this.v, t.common), this.gasPrice = (0, a.uint8ArrayToBigInt)((0, a.toUint8Array)("" === e.gasPrice ? "0x" : e.gasPrice)), this.gasPrice * this.gasLimit > c.MAX_INTEGER) {
                            const e = this._errorMsg("gas limit * gasPrice cannot exceed MAX_INTEGER (2^256-1)");
                            throw new Error(e);
                        }
                        this._validateCannotExceedMaxInteger({
                            gasPrice: this.gasPrice
                        }), u.BaseTransaction._validateNotArray(e), this.common.gteHardfork("spuriousDragon") && (this.isSigned() ? l(this.v, this.common.chainId()) && this.activeCapabilities.push(d.Capability.EIP155ReplayProtection) : this.activeCapabilities.push(d.Capability.EIP155ReplayProtection)), (null === (r = null == t ? void 0 : t.freeze) || void 0 === r || r) && Object.freeze(this);
                    }
                    static fromTxData(e, t = {}) {
                        return new h(e, t);
                    }
                    static fromSerializedTx(e, t = {}) {
                        const r = n.RLP.decode(e);
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input. Must be array");
                        return this.fromValuesArray(r, t);
                    }
                    static fromValuesArray(e, t = {}) {
                        if (6 !== e.length && 9 !== e.length) throw new Error("Invalid transaction. Only expecting 6 values (for unsigned tx) or 9 values (for signed tx).");
                        const [r, n, o, i, a, c, u, d, l] = e;
                        return (0, s.validateNoLeadingZeroes)({
                            nonce: r,
                            gasPrice: n,
                            gasLimit: o,
                            value: a,
                            v: u,
                            r: d,
                            s: l
                        }), new h({
                            nonce: r,
                            gasPrice: n,
                            gasLimit: o,
                            to: i,
                            value: a,
                            data: c,
                            v: u,
                            r: d,
                            s: l
                        }, t);
                    }
                    raw() {
                        return [
                            (0, a.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasPrice),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, a.bigIntToUnpaddedUint8Array)(this.value),
                            this.data,
                            void 0 !== this.v ? (0, a.bigIntToUnpaddedUint8Array)(this.v) : Uint8Array.from([]),
                            void 0 !== this.r ? (0, a.bigIntToUnpaddedUint8Array)(this.r) : Uint8Array.from([]),
                            void 0 !== this.s ? (0, a.bigIntToUnpaddedUint8Array)(this.s) : Uint8Array.from([])
                        ];
                    }
                    serialize() {
                        return n.RLP.encode(this.raw());
                    }
                    _getMessageToSign() {
                        const e = [
                            (0, a.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasPrice),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, a.bigIntToUnpaddedUint8Array)(this.value),
                            this.data
                        ];
                        return this.supports(d.Capability.EIP155ReplayProtection) && (e.push((0, a.toUint8Array)(this.common.chainId())), e.push((0, a.unpadUint8Array)((0, a.toUint8Array)(0))), e.push((0, a.unpadUint8Array)((0, a.toUint8Array)(0)))), e;
                    }
                    getMessageToSign(e = !0) {
                        const t = this._getMessageToSign();
                        return e ? (0, o.keccak256)(n.RLP.encode(t)) : t;
                    }
                    getDataFee() {
                        return this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork() ? this.cache.dataFee.value : (Object.isFrozen(this) && (this.cache.dataFee = {
                            value: super.getDataFee(),
                            hardfork: this.common.hardfork()
                        }), super.getDataFee());
                    }
                    getUpfrontCost() {
                        return this.gasLimit * this.gasPrice + this.value;
                    }
                    hash() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, o.keccak256)(n.RLP.encode(this.raw()))), this.cache.hash) : (0, o.keccak256)(n.RLP.encode(this.raw()));
                    }
                    getMessageToVerifySignature() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("This transaction is not signed");
                            throw new Error(e);
                        }
                        const e = this._getMessageToSign();
                        return (0, o.keccak256)(n.RLP.encode(e));
                    }
                    getSenderPublicKey() {
                        const e = this.getMessageToVerifySignature(), { v: t, r: r, s: n } = this;
                        this._validateHighS();
                        try {
                            return (0, a.ecrecover)(e, t, (0, a.bigIntToUnpaddedUint8Array)(r), (0, a.bigIntToUnpaddedUint8Array)(n), this.supports(d.Capability.EIP155ReplayProtection) ? this.common.chainId() : void 0);
                        } catch (e) {
                            const t = this._errorMsg("Invalid Signature");
                            throw new Error(t);
                        }
                    }
                    _processSignature(e, t, r) {
                        let n = e;
                        this.supports(d.Capability.EIP155ReplayProtection) && (n += this.common.chainId() * BigInt(2) + BigInt(8));
                        const o = Object.assign(Object.assign({}, this.txOptions), {
                            common: this.common
                        });
                        return h.fromTxData({
                            nonce: this.nonce,
                            gasPrice: this.gasPrice,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            v: n,
                            r: (0, a.uint8ArrayToBigInt)(t),
                            s: (0, a.uint8ArrayToBigInt)(r)
                        }, o);
                    }
                    toJSON() {
                        return {
                            nonce: (0, a.bigIntToHex)(this.nonce),
                            gasPrice: (0, a.bigIntToHex)(this.gasPrice),
                            gasLimit: (0, a.bigIntToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, a.bigIntToHex)(this.value),
                            data: (0, i.bytesToHex)(this.data),
                            v: void 0 !== this.v ? (0, a.bigIntToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, a.bigIntToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, a.bigIntToHex)(this.s) : void 0
                        };
                    }
                    _validateTxV(e, t) {
                        let r;
                        const n = void 0 !== e ? Number(e) : void 0;
                        if (void 0 !== n && n < 37 && 27 !== n && 28 !== n) throw new Error(`Legacy txs need either v = 27/28 or v >= 37 (EIP-155 replay protection), got v = ${n}`);
                        if (void 0 !== n && 0 !== n && (!t || t.gteHardfork("spuriousDragon")) && 27 !== n && 28 !== n) {
                            if (t) {
                                if (!l(BigInt(n), t.chainId())) throw new Error(`Incompatible EIP155-based V ${n} and chain id ${t.chainId()}. See the Common parameter of the Transaction constructor to set the chain id.`);
                            } else {
                                let e;
                                e = (n - 35) % 2 == 0 ? 35 : 36, r = BigInt(n - e) / BigInt(2);
                            }
                        }
                        return this._getCommon(t, r);
                    }
                    errorStr() {
                        let e = this._getSharedErrorPostfix();
                        return e += ` gasPrice=${this.gasPrice}`, e;
                    }
                    _errorMsg(e) {
                        return `${e} (${this.errorStr()})`;
                    }
                }
                t.Transaction = h;
            },
            7668: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TransactionFactory = void 0;
                const n = r(9634), o = r(2290), i = r(6135), s = r(9013), a = r(5381), c = new Map;
                class u {
                    constructor(){}
                    static typeToInt(e) {
                        return Number((0, o.uint8ArrayToBigInt)((0, o.toUint8Array)(e)));
                    }
                    static registerTransactionType(e, t) {
                        const r = u.typeToInt(e);
                        c.set(r, t);
                    }
                    static fromTxData(e, t = {}) {
                        if (!("type" in e) || void 0 === e.type) return a.Transaction.fromTxData(e, t);
                        const r = u.typeToInt(e.type);
                        if (0 === r) return a.Transaction.fromTxData(e, t);
                        if (1 === r) return s.AccessListEIP2930Transaction.fromTxData(e, t);
                        if (2 === r) return i.FeeMarketEIP1559Transaction.fromTxData(e, t);
                        const n = c.get(r);
                        if (null == n ? void 0 : n.fromTxData) return n.fromTxData(e, t);
                        throw new Error(`Tx instantiation with type ${r} not supported`);
                    }
                    static fromSerializedData(e, t = {}) {
                        if (!(e[0] <= 127)) return a.Transaction.fromSerializedTx(e, t);
                        switch(e[0]){
                            case 1:
                                return s.AccessListEIP2930Transaction.fromSerializedTx(e, t);
                            case 2:
                                return i.FeeMarketEIP1559Transaction.fromSerializedTx(e, t);
                            default:
                                {
                                    const r = c.get(Number(e[0]));
                                    if (null == r ? void 0 : r.fromSerializedTx) return r.fromSerializedTx(e, t);
                                    throw new Error(`TypedTransaction with ID ${e[0]} unknown`);
                                }
                        }
                    }
                    static fromBlockBodyData(e, t = {}) {
                        if ((0, n.isUint8Array)(e)) return this.fromSerializedData(e, t);
                        if (Array.isArray(e)) return a.Transaction.fromValuesArray(e, t);
                        throw new Error("Cannot decode transaction: unknown type input");
                    }
                }
                t.TransactionFactory = u;
            },
            9964: (e, t)=>{
                "use strict";
                function r(e) {
                    if (0 === e.length) return !0;
                    const t = e[0];
                    return !!Array.isArray(t);
                }
                var n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAccessList = t.isAccessListUint8Array = t.Capability = void 0, (n = t.Capability || (t.Capability = {}))[n.EIP155ReplayProtection = 155] = "EIP155ReplayProtection", n[n.EIP1559FeeMarket = 1559] = "EIP1559FeeMarket", n[n.EIP2718TypedTransaction = 2718] = "EIP2718TypedTransaction", n[n.EIP2930AccessLists = 2930] = "EIP2930AccessLists", t.isAccessListUint8Array = r, t.isAccessList = function(e) {
                    return !r(e);
                };
            },
            4562: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getDataFeeEIP2930 = t.getAccessListJSON = t.verifyAccessList = t.getAccessListData = t.checkMaxInitCodeSize = void 0;
                const n = r(9634), o = r(2290), i = r(9964);
                t.checkMaxInitCodeSize = (e, t)=>{
                    const r = e.param("vm", "maxInitCodeSize");
                    if (r && BigInt(t) > r) throw new Error(`the initcode size of this transaction is too large: it is ${t} while the max is ${e.param("vm", "maxInitCodeSize")}`);
                }, t.getAccessListData = (e)=>{
                    let t, r;
                    if ((0, i.isAccessList)(e)) {
                        t = e;
                        const n = [];
                        for(let t = 0; t < e.length; t += 1){
                            const r = e[t], i = (0, o.toUint8Array)(r.address), s = [];
                            for(let e = 0; e < r.storageKeys.length; e += 1)s.push((0, o.toUint8Array)(r.storageKeys[e]));
                            n.push([
                                i,
                                s
                            ]);
                        }
                        r = n;
                    } else {
                        r = null != e ? e : [];
                        const o = [];
                        for(let e = 0; e < r.length; e += 1){
                            const t = r[e], i = (0, n.bytesToHex)(t[0]), s = [];
                            for(let e = 0; e < t[1].length; e += 1)s.push((0, n.bytesToHex)(t[1][e]));
                            const a = {
                                address: i,
                                storageKeys: s
                            };
                            o.push(a);
                        }
                        t = o;
                    }
                    return {
                        AccessListJSON: t,
                        accessList: r
                    };
                }, t.verifyAccessList = (e)=>{
                    for(let t = 0; t < e.length; t += 1){
                        const r = e[t], n = r[0], o = r[1];
                        if (void 0 !== r[2]) throw new Error("Access list item cannot have 3 elements. It can only have an address, and an array of storage slots.");
                        if (20 !== n.length) throw new Error("Invalid EIP-2930 transaction: address length should be 20 bytes");
                        for(let e = 0; e < o.length; e += 1)if (32 !== o[e].length) throw new Error("Invalid EIP-2930 transaction: storage slot length should be 32 bytes");
                    }
                }, t.getAccessListJSON = (e)=>{
                    const t = [];
                    for(let r = 0; r < e.length; r += 1){
                        const i = e[r], s = {
                            address: (0, n.bytesToHex)((0, o.setLengthLeft)(i[0], 20)),
                            storageKeys: []
                        }, a = i && i[1];
                        for(let e = 0; e < a.length; e += 1){
                            const t = a[e];
                            s.storageKeys.push((0, n.bytesToHex)((0, o.setLengthLeft)(t, 32)));
                        }
                        t.push(s);
                    }
                    return t;
                }, t.getDataFeeEIP2930 = (e, t)=>{
                    const r = t.param("gasPrices", "accessListStorageKeyCost"), n = t.param("gasPrices", "accessListAddressCost");
                    let o = 0;
                    for(let t = 0; t < e.length; t += 1)o += e[t][1].length;
                    return e.length * Number(n) + o * Number(r);
                };
            },
            4874: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8632: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Wallet = void 0;
                const o = r(9970), i = r(7345);
                class s extends o.Web3BaseWallet {
                    constructor(){
                        super(...arguments), this._addressMap = new Map, this._defaultKeyName = "web3js_wallet";
                    }
                    static getStorage() {
                        let e;
                        try {
                            e = window.localStorage;
                            const t = "__storage_test__";
                            return e.setItem(t, t), e.removeItem(t), e;
                        } catch (t) {
                            return !t || 22 !== t.code && 1014 !== t.code && "QuotaExceededError" !== t.name && "NS_ERROR_DOM_QUOTA_REACHED" !== t.name || (0, i.isNullish)(e) || 0 === e.length ? void 0 : e;
                        }
                    }
                    create(e) {
                        for(let t = 0; t < e; t += 1)this.add(this._accountProvider.create());
                        return this;
                    }
                    add(e) {
                        var t;
                        if ("string" == typeof e) return this.add(this._accountProvider.privateKeyToAccount(e));
                        let r = this.length;
                        return this.get(e.address) && (console.warn(`Account ${e.address.toLowerCase()} already exists.`), r = null !== (t = this._addressMap.get(e.address.toLowerCase())) && void 0 !== t ? t : r), this._addressMap.set(e.address.toLowerCase(), r), this[r] = e, this;
                    }
                    get(e) {
                        if ("string" == typeof e) {
                            const t = this._addressMap.get(e.toLowerCase());
                            return (0, i.isNullish)(t) ? void 0 : this[t];
                        }
                        return this[e];
                    }
                    remove(e) {
                        if ("string" == typeof e) {
                            const t = this._addressMap.get(e.toLowerCase());
                            return !(0, i.isNullish)(t) && (this._addressMap.delete(e.toLowerCase()), this.splice(t, 1), !0);
                        }
                        return !!this[e] && (this.splice(e, 1), !0);
                    }
                    clear() {
                        return this._addressMap.clear(), this.length = 0, this;
                    }
                    encrypt(e, t) {
                        return n(this, void 0, void 0, function*() {
                            return Promise.all(this.map((r)=>n(this, void 0, void 0, function*() {
                                    return r.encrypt(e, t);
                                })));
                        });
                    }
                    decrypt(e, t, r) {
                        return n(this, void 0, void 0, function*() {
                            const o = yield Promise.all(e.map((e)=>n(this, void 0, void 0, function*() {
                                    return this._accountProvider.decrypt(e, t, r);
                                })));
                            for (const e of o)this.add(e);
                            return this;
                        });
                    }
                    save(e, t) {
                        return n(this, void 0, void 0, function*() {
                            const r = s.getStorage();
                            if (!r) throw new Error("Local storage not available.");
                            return r.setItem(null != t ? t : this._defaultKeyName, JSON.stringify((yield this.encrypt(e)))), !0;
                        });
                    }
                    load(e, t) {
                        return n(this, void 0, void 0, function*() {
                            const r = s.getStorage();
                            if (!r) throw new Error("Local storage not available.");
                            const n = r.getItem(null != t ? t : this._defaultKeyName);
                            return n && (yield this.decrypt(JSON.parse(n) || [], e)), this;
                        });
                    }
                }
                t.Wallet = s;
            },
            6658: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Contract = void 0;
                const o = r(6527), i = r(5071), s = r(6637), a = r(8381), c = r(9970), u = r(9634), d = r(7345), l = r(5537), h = r(7388), f = r(3948), p = {
                    logs: h.LogsSubscription,
                    newHeads: s.NewHeadsSubscription,
                    newBlockHeaders: s.NewHeadsSubscription
                };
                class m extends o.Web3Context {
                    constructor(e, t, r, n, s){
                        var a, c, l;
                        const h = (0, u.isContractInitOptions)(t) ? t : (0, u.isContractInitOptions)(r) ? r : void 0;
                        let g, y;
                        if (g = (0, f.isWeb3ContractContext)(t) ? t : (0, f.isWeb3ContractContext)(r) ? r : n, y = "object" == typeof t && "provider" in t ? t.provider : "object" == typeof r && "provider" in r ? r.provider : "object" == typeof n && "provider" in n ? n.provider : m.givenProvider, super(Object.assign(Object.assign({}, g), {
                            provider: y,
                            registeredSubscriptions: p
                        })), this.syncWithContext = !1, this._functions = {}, (null == g ? void 0 : g.wallet) && (this._wallet = g.wallet), (null == g ? void 0 : g.accountProvider) && (this._accountProvider = g.accountProvider), !(0, d.isNullish)(h) && !(0, d.isNullish)(h.data) && !(0, d.isNullish)(h.input) && "both" !== this.config.contractDataInputFill) throw new i.ContractTransactionDataAndInputError({
                            data: h.data,
                            input: h.input
                        });
                        this._overloadedMethodAbis = new Map;
                        const v = (0, u.isDataFormat)(n) ? n : (0, u.isDataFormat)(r) ? r : null != s ? s : this.defaultReturnFormat, b = "string" == typeof t ? t : void 0;
                        this.config.contractDataInputFill = null !== (a = null == h ? void 0 : h.dataInputFill) && void 0 !== a ? a : this.config.contractDataInputFill, this._parseAndSetJsonInterface(e, v), this.defaultReturnFormat !== v && (this.defaultReturnFormat = v), (0, d.isNullish)(b) || this._parseAndSetAddress(b, v), this.options = {
                            address: b,
                            jsonInterface: this._jsonInterface,
                            gas: null !== (c = null == h ? void 0 : h.gas) && void 0 !== c ? c : null == h ? void 0 : h.gasLimit,
                            gasPrice: null == h ? void 0 : h.gasPrice,
                            from: null == h ? void 0 : h.from,
                            input: null == h ? void 0 : h.input,
                            data: null == h ? void 0 : h.data
                        }, this.syncWithContext = null !== (l = null == h ? void 0 : h.syncWithContext) && void 0 !== l && l, g instanceof o.Web3Context && this.subscribeToContextEvents(g), Object.defineProperty(this.options, "address", {
                            set: (e)=>this._parseAndSetAddress(e, v),
                            get: ()=>this._address
                        }), Object.defineProperty(this.options, "jsonInterface", {
                            set: (e)=>this._parseAndSetJsonInterface(e, v),
                            get: ()=>this._jsonInterface
                        }), g instanceof o.Web3Context && g.on(o.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            this.setConfig({
                                [e.name]: e.newValue
                            });
                        });
                    }
                    get events() {
                        return this._events;
                    }
                    get methods() {
                        return this._methods;
                    }
                    clone() {
                        let e;
                        return e = this.options.address ? new m([
                            ...this._jsonInterface,
                            ...this._errorsInterface
                        ], this.options.address, {
                            gas: this.options.gas,
                            gasPrice: this.options.gasPrice,
                            from: this.options.from,
                            input: this.options.input,
                            data: this.options.data,
                            provider: this.currentProvider,
                            syncWithContext: this.syncWithContext,
                            dataInputFill: this.config.contractDataInputFill
                        }, this.getContextObject()) : new m([
                            ...this._jsonInterface,
                            ...this._errorsInterface
                        ], {
                            gas: this.options.gas,
                            gasPrice: this.options.gasPrice,
                            from: this.options.from,
                            input: this.options.input,
                            data: this.options.data,
                            provider: this.currentProvider,
                            syncWithContext: this.syncWithContext,
                            dataInputFill: this.config.contractDataInputFill
                        }, this.getContextObject()), this.context && e.subscribeToContextEvents(this.context), e;
                    }
                    deploy(e) {
                        var t, r, o;
                        let s = this._jsonInterface.find((e)=>"constructor" === e.type);
                        s || (s = {
                            type: "constructor",
                            stateMutability: ""
                        });
                        const a = (0, u.format)({
                            format: "bytes"
                        }, null !== (t = null == e ? void 0 : e.input) && void 0 !== t ? t : this.options.input, c.DEFAULT_RETURN_FORMAT), d = (0, u.format)({
                            format: "bytes"
                        }, null !== (r = null == e ? void 0 : e.data) && void 0 !== r ? r : this.options.data, c.DEFAULT_RETURN_FORMAT);
                        if (!(a && "0x" !== a.trim() || d && "0x" !== d.trim())) throw new i.Web3ContractError("contract creation without any data provided.");
                        const h = null !== (o = null == e ? void 0 : e.arguments) && void 0 !== o ? o : [], f = Object.assign(Object.assign({}, this.options), {
                            input: a,
                            data: d
                        }), p = null != a ? a : d;
                        return {
                            arguments: h,
                            send: (e)=>{
                                const t = Object.assign({}, e);
                                return this._contractMethodDeploySend(s, h, t, f);
                            },
                            estimateGas: (e, t = this.defaultReturnFormat)=>n(this, void 0, void 0, function*() {
                                    const r = Object.assign({}, e);
                                    return this._contractMethodEstimateGas({
                                        abi: s,
                                        params: h,
                                        returnFormat: t,
                                        options: r,
                                        contractOptions: f
                                    });
                                }),
                            encodeABI: ()=>(0, l.encodeMethodABI)(s, h, (0, u.format)({
                                    format: "bytes"
                                }, p, this.defaultReturnFormat)),
                            decodeData: (e)=>Object.assign(Object.assign({}, (0, l.decodeMethodParams)(s, e.replace(p, ""), !1)), {
                                    __method__: s.type
                                })
                        };
                    }
                    getPastEvents(e, t, r) {
                        var o;
                        return n(this, void 0, void 0, function*() {
                            const n = "string" == typeof e ? e : s.ALL_EVENTS, a = "string" == typeof e || (0, u.isDataFormat)(e) ? (0, u.isDataFormat)(t) ? {} : t : e, c = (0, u.isDataFormat)(e) ? e : (0, u.isDataFormat)(t) ? t : null != r ? r : this.defaultReturnFormat, d = "allEvents" === n || n === s.ALL_EVENTS ? s.ALL_EVENTS_ABI : this._jsonInterface.find((e)=>"name" in e && e.name === n);
                            if (!d) throw new i.Web3ContractError(`Event ${n} not found.`);
                            const { fromBlock: h, toBlock: f, topics: p, address: m } = (0, l.encodeEventABI)(this.options, d, null != a ? a : {}), g = yield (0, s.getLogs)(this, {
                                fromBlock: h,
                                toBlock: f,
                                topics: p,
                                address: m
                            }, c), y = g ? g.map((e)=>"string" == typeof e ? e : (0, s.decodeEventABI)(d, e, this._jsonInterface, c)) : [], v = null !== (o = null == a ? void 0 : a.filter) && void 0 !== o ? o : {}, b = Object.keys(v);
                            return b.length > 0 ? y.filter((e)=>"string" == typeof e || b.every((t)=>{
                                    var r;
                                    if (Array.isArray(v[t])) return v[t].some((r)=>String(e.returnValues[t]).toUpperCase() === String(r).toUpperCase());
                                    const n = null === (r = d.inputs) || void 0 === r ? void 0 : r.filter((e)=>e.name === t)[0];
                                    return !(!(null == n ? void 0 : n.indexed) || "string" !== n.type || (0, u.keccak256)(v[t]) !== String(e.returnValues[t])) || String(e.returnValues[t]).toUpperCase() === String(v[t]).toUpperCase();
                                })) : y;
                        });
                    }
                    _parseAndSetAddress(e, t = this.defaultReturnFormat) {
                        this._address = e ? (0, u.toChecksumAddress)((0, u.format)({
                            format: "address"
                        }, e, t)) : e;
                    }
                    decodeMethodData(e) {
                        const t = e.slice(0, 10), r = this._jsonInterface.filter((e)=>"error" !== e.type).find((e)=>t === (0, a.encodeFunctionSignature)((0, a.jsonInterfaceMethodToString)(e)));
                        if (!r) throw new i.Web3ContractError(`The ABI for the provided method signature ${t} was not found.`);
                        return Object.assign(Object.assign({}, (0, l.decodeMethodParams)(r, e)), {
                            __method__: (0, a.jsonInterfaceMethodToString)(r)
                        });
                    }
                    _parseAndSetJsonInterface(e, t = this.defaultReturnFormat) {
                        var r, n, o, i, c;
                        this._functions = {}, this._methods = {}, this._events = {};
                        let u = [];
                        const d = e.filter((e)=>"error" !== e.type), l = e.filter((e)=>(0, a.isAbiErrorFragment)(e));
                        for (const e of d){
                            const s = Object.assign(Object.assign({}, e), {
                                signature: ""
                            });
                            if ((0, a.isAbiFunctionFragment)(s)) {
                                const e = (0, a.jsonInterfaceMethodToString)(s), t = (0, a.encodeFunctionSignature)(e);
                                s.methodNameWithInputs = e, s.signature = t, s.constant = null !== (n = (r = "view" === s.stateMutability, void 0 !== r) ? r : "pure" === s.stateMutability) && void 0 !== n ? n : s.constant, s.payable = (o = "payable" === s.stateMutability, void 0 !== o) ? o : s.payable, this._overloadedMethodAbis.set(s.name, [
                                    ...null !== (i = this._overloadedMethodAbis.get(s.name)) && void 0 !== i ? i : [],
                                    s
                                ]);
                                const u = null !== (c = this._overloadedMethodAbis.get(s.name)) && void 0 !== c ? c : [], d = this._createContractMethod(u, l), h = this._createContractMethod(u, l, !0);
                                this._functions[e] = {
                                    signature: t,
                                    method: h
                                }, this._methods[s.name] = d, this._methods[e] = h, this._methods[t] = h;
                            } else if ((0, a.isAbiEventFragment)(s)) {
                                const e = (0, a.jsonInterfaceMethodToString)(s), r = (0, a.encodeEventSignature)(e), n = this._createContractEvent(s, t);
                                s.signature = r, e in this._events && "bound" !== s.name || (this._events[e] = n), this._events[s.name] = n, this._events[r] = n;
                            }
                            u = [
                                ...u,
                                s
                            ];
                        }
                        this._events.allEvents = this._createContractEvent(s.ALL_EVENTS_ABI, t), this._jsonInterface = [
                            ...u
                        ], this._errorsInterface = l;
                    }
                    _getAbiParams(e, t) {
                        var r;
                        try {
                            return d.utils.transformJsonDataToAbiFormat(null !== (r = e.inputs) && void 0 !== r ? r : [], t);
                        } catch (t) {
                            throw new i.Web3ContractError(`Invalid parameters for method ${e.name}: ${t.message}`);
                        }
                    }
                    _createContractMethod(e, t, r = !1) {
                        const o = e[e.length - 1];
                        return (...e)=>{
                            var i, s, a;
                            let c;
                            const u = null !== (s = r ? null === (i = this._overloadedMethodAbis.get(o.name)) || void 0 === i ? void 0 : i.filter((e)=>e.signature === o.signature) : this._overloadedMethodAbis.get(o.name)) && void 0 !== s ? s : [];
                            let h = u[0];
                            const f = t, p = u.filter((t)=>{
                                var r;
                                return (null !== (r = t.inputs) && void 0 !== r ? r : []).length === e.length;
                            });
                            if (1 === u.length || 0 === p.length) c = this._getAbiParams(h, e), d.validator.validate(null !== (a = o.inputs) && void 0 !== a ? a : [], c);
                            else {
                                const t = [], r = [];
                                for (const n of p)try {
                                    c = this._getAbiParams(n, e), d.validator.validate(n.inputs, c), r.push(n);
                                } catch (e) {
                                    t.push(e);
                                }
                                if (1 === r.length ? [h] = r : r.length > 1 && ([h] = r, console.warn(`Multiple methods found that is compatible with the given inputs.\n\tFound ${r.length} compatible methods: ${JSON.stringify(r.map((e)=>`${e.methodNameWithInputs} (signature: ${e.signature})`))} \n\tThe first one will be used: ${h.methodNameWithInputs}`)), t.length === p.length) throw new d.Web3ValidatorError(t);
                            }
                            const m = {
                                arguments: c,
                                call: (e, t)=>n(this, void 0, void 0, function*() {
                                        return this._contractMethodCall(h, c, f, e, t);
                                    }),
                                send: (e)=>this._contractMethodSend(h, c, f, e),
                                estimateGas: (e, t = this.defaultReturnFormat)=>n(this, void 0, void 0, function*() {
                                        return this._contractMethodEstimateGas({
                                            abi: h,
                                            params: c,
                                            returnFormat: t,
                                            options: e
                                        });
                                    }),
                                encodeABI: ()=>(0, l.encodeMethodABI)(h, c),
                                decodeData: (e)=>(0, l.decodeMethodParams)(h, e),
                                createAccessList: (e, t)=>n(this, void 0, void 0, function*() {
                                        return this._contractMethodCreateAccessList(h, c, f, e, t);
                                    })
                            };
                            return h.stateMutability, m;
                        };
                    }
                    _contractMethodCall(e, t, r, o, c) {
                        var u;
                        return n(this, void 0, void 0, function*() {
                            const n = (0, f.getEthTxCallParams)({
                                abi: e,
                                params: t,
                                options: Object.assign(Object.assign({}, o), {
                                    dataInputFill: this.config.contractDataInputFill
                                }),
                                contractOptions: Object.assign(Object.assign({}, this.options), {
                                    from: null !== (u = this.options.from) && void 0 !== u ? u : this.config.defaultAccount
                                })
                            });
                            try {
                                const t = yield (0, s.call)(this, n, c, this.defaultReturnFormat);
                                return (0, l.decodeMethodReturn)(e, t);
                            } catch (e) {
                                throw e instanceof i.ContractExecutionError && (0, a.decodeContractErrorData)(r, e.cause), e;
                            }
                        });
                    }
                    _contractMethodCreateAccessList(e, t, r, o, c) {
                        var u;
                        return n(this, void 0, void 0, function*() {
                            const n = (0, f.getCreateAccessListParams)({
                                abi: e,
                                params: t,
                                options: Object.assign(Object.assign({}, o), {
                                    dataInputFill: this.config.contractDataInputFill
                                }),
                                contractOptions: Object.assign(Object.assign({}, this.options), {
                                    from: null !== (u = this.options.from) && void 0 !== u ? u : this.config.defaultAccount
                                })
                            });
                            try {
                                return (0, s.createAccessList)(this, n, c, this.defaultReturnFormat);
                            } catch (e) {
                                throw e instanceof i.ContractExecutionError && (0, a.decodeContractErrorData)(r, e.cause), e;
                            }
                        });
                    }
                    _contractMethodSend(e, t, r, n, o) {
                        var c, u;
                        let d = null != o ? o : this.options;
                        d = Object.assign(Object.assign({}, d), {
                            input: void 0,
                            from: null !== (u = null !== (c = d.from) && void 0 !== c ? c : this.defaultAccount) && void 0 !== u ? u : void 0
                        });
                        const l = (0, f.getSendTxParams)({
                            abi: e,
                            params: t,
                            options: Object.assign(Object.assign({}, n), {
                                dataInputFill: this.config.contractDataInputFill
                            }),
                            contractOptions: d
                        }), h = (0, s.sendTransaction)(this, l, this.defaultReturnFormat, {
                            checkRevertBeforeSending: !1,
                            contractAbi: this._jsonInterface
                        });
                        return h.on("error", (e)=>{
                            e instanceof i.ContractExecutionError && (0, a.decodeContractErrorData)(r, e.cause);
                        }), h;
                    }
                    _contractMethodDeploySend(e, t, r, n) {
                        var o, a;
                        let c = null != n ? n : this.options;
                        c = Object.assign(Object.assign({}, c), {
                            from: null !== (a = null !== (o = c.from) && void 0 !== o ? o : this.defaultAccount) && void 0 !== a ? a : void 0
                        });
                        const u = (0, f.getSendTxParams)({
                            abi: e,
                            params: t,
                            options: Object.assign(Object.assign({}, r), {
                                dataInputFill: this.contractDataInputFill
                            }),
                            contractOptions: c
                        });
                        return (0, s.sendTransaction)(this, u, this.defaultReturnFormat, {
                            transactionResolver: (e)=>{
                                if (e.status === BigInt(0)) throw new i.Web3ContractError("code couldn't be stored", e);
                                const t = this.clone();
                                return t.options.address = e.contractAddress, t;
                            },
                            contractAbi: this._jsonInterface,
                            checkRevertBeforeSending: !1
                        });
                    }
                    _contractMethodEstimateGas({ abi: e, params: t, returnFormat: r, options: o, contractOptions: i }) {
                        return n(this, void 0, void 0, function*() {
                            const n = (0, f.getEstimateGasParams)({
                                abi: e,
                                params: t,
                                options: Object.assign(Object.assign({}, o), {
                                    dataInputFill: this.config.contractDataInputFill
                                }),
                                contractOptions: null != i ? i : this.options
                            });
                            return (0, s.estimateGas)(this, n, c.BlockTags.LATEST, null != r ? r : this.defaultReturnFormat);
                        });
                    }
                    _createContractEvent(e, t = this.defaultReturnFormat) {
                        return (...r)=>{
                            var n;
                            const { topics: o, fromBlock: s } = (0, l.encodeEventABI)(this.options, e, r[0]), a = new h.LogsSubscription({
                                address: this.options.address,
                                topics: o,
                                abi: e,
                                jsonInterface: this._jsonInterface
                            }, {
                                subscriptionManager: this.subscriptionManager,
                                returnFormat: t
                            });
                            return (0, d.isNullish)(s) || this.getPastEvents(e.name, {
                                fromBlock: s,
                                topics: o
                            }, t).then((e)=>{
                                e && e.forEach((e)=>a.emit("data", e));
                            }).catch((e)=>{
                                a.emit("error", new i.SubscriptionError("Failed to get past events.", e));
                            }), null === (n = this.subscriptionManager) || void 0 === n || n.addSubscription(a).catch((e)=>{
                                a.emit("error", new i.SubscriptionError("Failed to subscribe.", e));
                            }), a;
                        };
                    }
                    subscribeToContextEvents(e) {
                        const t = this;
                        this.context = e, t.syncWithContext && e.on(o.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            t.setConfig({
                                [e.name]: e.newValue
                            });
                        });
                    }
                }
                t.Contract = m;
            },
            5537: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeMethodReturn = t.decodeMethodParams = t.encodeMethodABI = t.encodeEventABI = t.decodeEventABI = void 0;
                const n = r(9634), o = r(9970), i = r(8381), s = r(6637), a = r(5071);
                var c = r(6637);
                Object.defineProperty(t, "decodeEventABI", {
                    enumerable: !0,
                    get: function() {
                        return c.decodeEventABI;
                    }
                }), t.encodeEventABI = ({ address: e }, t, r)=>{
                    var a, c;
                    const u = null == r ? void 0 : r.topics, d = null !== (a = null == r ? void 0 : r.filter) && void 0 !== a ? a : {}, l = {};
                    if ((0, n.isNullish)(null == r ? void 0 : r.fromBlock) || (l.fromBlock = (0, n.format)(s.blockSchema.properties.number, null == r ? void 0 : r.fromBlock, {
                        number: o.FMT_NUMBER.HEX,
                        bytes: o.FMT_BYTES.HEX
                    })), (0, n.isNullish)(null == r ? void 0 : r.toBlock) || (l.toBlock = (0, n.format)(s.blockSchema.properties.number, null == r ? void 0 : r.toBlock, {
                        number: o.FMT_NUMBER.HEX,
                        bytes: o.FMT_BYTES.HEX
                    })), u && Array.isArray(u)) l.topics = [
                        ...u
                    ];
                    else if (l.topics = [], !t || t.anonymous || [
                        s.ALL_EVENTS,
                        "allEvents"
                    ].includes(t.name) || l.topics.push(null !== (c = t.signature) && void 0 !== c ? c : (0, i.encodeEventSignature)((0, i.jsonInterfaceMethodToString)(t))), ![
                        s.ALL_EVENTS,
                        "allEvents"
                    ].includes(t.name) && t.inputs) for (const e of t.inputs){
                        if (!e.indexed) continue;
                        const t = d[e.name];
                        t ? Array.isArray(t) ? l.topics.push(t.map((t)=>(0, i.encodeParameter)(e.type, t))) : "string" === e.type ? l.topics.push((0, n.keccak256)(t)) : l.topics.push((0, i.encodeParameter)(e.type, t)) : l.topics.push(null);
                    }
                    return l.topics.length || delete l.topics, e && (l.address = e.toLowerCase()), l;
                }, t.encodeMethodABI = (e, t, r)=>{
                    const n = Array.isArray(e.inputs) ? e.inputs.length : 0;
                    if (e.inputs && n !== t.length) throw new a.Web3ContractError(`The number of arguments is not matching the methods required number. You need to pass ${n} arguments.`);
                    let o;
                    if (o = e.inputs ? (0, i.encodeParameters)(Array.isArray(e.inputs) ? e.inputs : [], t).replace("0x", "") : (0, i.inferTypesAndEncodeParameters)(t).replace("0x", ""), (0, i.isAbiConstructorFragment)(e)) {
                        if (!r) throw new a.Web3ContractError("The contract has no contract data option set. This is necessary to append the constructor parameters.");
                        return r.startsWith("0x") ? `${r}${o}` : `0x${r}${o}`;
                    }
                    return `${(0, i.encodeFunctionSignature)(e)}${o}`;
                }, t.decodeMethodParams = (e, t, r = !0)=>{
                    const n = r && t && t.length >= 10 && t.startsWith("0x") ? t.slice(10) : t;
                    if (!e.inputs) throw new a.Web3ContractError("No inputs found in the ABI");
                    return (0, i.decodeParameters)([
                        ...e.inputs
                    ], n);
                }, t.decodeMethodReturn = (e, t)=>{
                    if ("constructor" === e.type) return t;
                    if (!t) return null;
                    const r = t.length >= 2 ? t.slice(2) : t;
                    if (!e.outputs) return null;
                    const n = (0, i.decodeParameters)([
                        ...e.outputs
                    ], r);
                    return 1 === n.__length__ ? n[0] : n;
                };
            },
            3211: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const i = r(6658);
                o(r(5537), t), o(r(6658), t), o(r(7388), t), o(r(3951), t), o(r(3948), t), t.default = i.Contract;
            },
            7388: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LogsSubscription = void 0;
                const n = r(6527), o = r(6637);
                class i extends n.Web3Subscription {
                    constructor(e, t){
                        super(e, t), this.address = e.address, this.topics = e.topics, this.abi = e.abi, this.jsonInterface = e.jsonInterface;
                    }
                    _buildSubscriptionParams() {
                        return [
                            "logs",
                            {
                                address: this.address,
                                topics: this.topics
                            }
                        ];
                    }
                    formatSubscriptionResult(e) {
                        return (0, o.decodeEventABI)(this.abi, e, this.jsonInterface, super.returnFormat);
                    }
                }
                t.LogsSubscription = i;
            },
            3951: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            3948: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getCreateAccessListParams = t.isWeb3ContractContext = t.getEstimateGasParams = t.getEthTxCallParams = t.getSendTxParams = void 0;
                const n = r(5071), o = r(9634), i = r(5537), s = (e, t, r, n)=>{
                    var s, a;
                    const c = {};
                    return (0, o.isNullish)(e.data) && "both" !== n || (c.data = (0, i.encodeMethodABI)(t, r, null !== (s = e.data) && void 0 !== s ? s : e.input)), (0, o.isNullish)(e.input) && "both" !== n || (c.input = (0, i.encodeMethodABI)(t, r, null !== (a = e.input) && void 0 !== a ? a : e.data)), (0, o.isNullish)(c.input) && (0, o.isNullish)(c.data) && (c[n] = (0, i.encodeMethodABI)(t, r)), {
                        data: c.data,
                        input: c.input
                    };
                };
                t.getSendTxParams = ({ abi: e, params: t, options: r, contractOptions: i })=>{
                    var a, c, u;
                    if (!(null !== (u = null !== (c = null !== (a = null == r ? void 0 : r.input) && void 0 !== a ? a : null == r ? void 0 : r.data) && void 0 !== c ? c : i.input) && void 0 !== u ? u : i.data) && !(null == r ? void 0 : r.to) && !i.address) throw new n.Web3ContractError("Contract address not specified");
                    if (!(null == r ? void 0 : r.from) && !i.from) throw new n.Web3ContractError('Contract "from" address not specified');
                    let d = (0, o.mergeDeep)({
                        to: i.address,
                        gas: i.gas,
                        gasPrice: i.gasPrice,
                        from: i.from,
                        input: i.input,
                        maxPriorityFeePerGas: i.maxPriorityFeePerGas,
                        maxFeePerGas: i.maxFeePerGas,
                        data: i.data
                    }, r);
                    const l = s(d, e, t, null == r ? void 0 : r.dataInputFill);
                    return d = Object.assign(Object.assign({}, d), {
                        data: l.data,
                        input: l.input
                    }), d;
                }, t.getEthTxCallParams = ({ abi: e, params: t, options: r, contractOptions: i })=>{
                    if (!(null == r ? void 0 : r.to) && !i.address) throw new n.Web3ContractError("Contract address not specified");
                    let a = (0, o.mergeDeep)({
                        to: i.address,
                        gas: i.gas,
                        gasPrice: i.gasPrice,
                        from: i.from,
                        input: i.input,
                        maxPriorityFeePerGas: i.maxPriorityFeePerGas,
                        maxFeePerGas: i.maxFeePerGas,
                        data: i.data
                    }, r);
                    const c = s(a, e, t, null == r ? void 0 : r.dataInputFill);
                    return a = Object.assign(Object.assign({}, a), {
                        data: c.data,
                        input: c.input
                    }), a;
                }, t.getEstimateGasParams = ({ abi: e, params: t, options: r, contractOptions: n })=>{
                    let i = (0, o.mergeDeep)({
                        to: n.address,
                        gas: n.gas,
                        gasPrice: n.gasPrice,
                        from: n.from,
                        input: n.input,
                        data: n.data
                    }, r);
                    const a = s(i, e, t, null == r ? void 0 : r.dataInputFill);
                    return i = Object.assign(Object.assign({}, i), {
                        data: a.data,
                        input: a.input
                    }), i;
                }, t.isWeb3ContractContext = (e)=>"object" == typeof e && !(0, o.isNullish)(e) && 0 !== Object.keys(e).length && !(0, o.isContractInitOptions)(e), t.getCreateAccessListParams = ({ abi: e, params: t, options: r, contractOptions: i })=>{
                    if (!(null == r ? void 0 : r.to) && !i.address) throw new n.Web3ContractError("Contract address not specified");
                    if (!(null == r ? void 0 : r.from) && !i.from) throw new n.Web3ContractError('Contract "from" address not specified');
                    let a = (0, o.mergeDeep)({
                        to: i.address,
                        gas: i.gas,
                        gasPrice: i.gasPrice,
                        from: i.from,
                        input: i.input,
                        maxPriorityFeePerGas: i.maxPriorityFeePerGas,
                        maxFeePerGas: i.maxFeePerGas,
                        data: i.data
                    }, r);
                    const c = s(a, e, t, null == r ? void 0 : r.dataInputFill);
                    return a = Object.assign(Object.assign({}, a), {
                        data: c.data,
                        input: c.input
                    }), a;
                };
            },
            6919: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ENSRegistryAbi = void 0, t.ENSRegistryAbi = [
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "label",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "NewOwner",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "resolver",
                                type: "address"
                            }
                        ],
                        name: "NewResolver",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "Transfer",
                        type: "event"
                    },
                    {
                        inputs: [
                            {
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            }
                        ],
                        name: "isApprovedForAll",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "owner",
                        outputs: [
                            {
                                internalType: "address",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "recordExists",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "resolver",
                        outputs: [
                            {
                                internalType: "address",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "ttl",
                        outputs: [
                            {
                                internalType: "uint64",
                                name: "",
                                type: "uint64"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    }
                ];
            },
            172: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PublicResolverAbi = void 0, t.PublicResolverAbi = [
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "a",
                                type: "address"
                            }
                        ],
                        name: "AddrChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "uint256",
                                name: "coinType",
                                type: "uint256"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "newAddress",
                                type: "bytes"
                            }
                        ],
                        name: "AddressChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                indexed: !0,
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            },
                            {
                                indexed: !1,
                                internalType: "bool",
                                name: "approved",
                                type: "bool"
                            }
                        ],
                        name: "ApprovalForAll",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "hash",
                                type: "bytes"
                            }
                        ],
                        name: "ContenthashChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "name",
                                type: "bytes"
                            },
                            {
                                indexed: !1,
                                internalType: "uint16",
                                name: "resource",
                                type: "uint16"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "record",
                                type: "bytes"
                            }
                        ],
                        name: "DNSRecordChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "name",
                                type: "bytes"
                            },
                            {
                                indexed: !1,
                                internalType: "uint16",
                                name: "resource",
                                type: "uint16"
                            }
                        ],
                        name: "DNSRecordDeleted",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "DNSZoneCleared",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "lastzonehash",
                                type: "bytes"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "zonehash",
                                type: "bytes"
                            }
                        ],
                        name: "DNSZonehashChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                internalType: "bytes4",
                                name: "interfaceID",
                                type: "bytes4"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "implementer",
                                type: "address"
                            }
                        ],
                        name: "InterfaceChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "string",
                                name: "name",
                                type: "string"
                            }
                        ],
                        name: "NameChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes32",
                                name: "x",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes32",
                                name: "y",
                                type: "bytes32"
                            }
                        ],
                        name: "PubkeyChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                internalType: "string",
                                name: "indexedKey",
                                type: "string"
                            },
                            {
                                indexed: !1,
                                internalType: "string",
                                name: "key",
                                type: "string"
                            }
                        ],
                        name: "TextChanged",
                        type: "event"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "uint256",
                                name: "contentTypes",
                                type: "uint256"
                            }
                        ],
                        name: "ABI",
                        outputs: [
                            {
                                internalType: "uint256",
                                name: "",
                                type: "uint256"
                            },
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "addr",
                        outputs: [
                            {
                                internalType: "address payable",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "uint256",
                                name: "coinType",
                                type: "uint256"
                            }
                        ],
                        name: "addr",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "contenthash",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "name",
                                type: "bytes32"
                            },
                            {
                                internalType: "uint16",
                                name: "resource",
                                type: "uint16"
                            }
                        ],
                        name: "dnsRecord",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "name",
                                type: "bytes32"
                            }
                        ],
                        name: "hasDNSRecords",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes4",
                                name: "interfaceID",
                                type: "bytes4"
                            }
                        ],
                        name: "interfaceImplementer",
                        outputs: [
                            {
                                internalType: "address",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "address",
                                name: "account",
                                type: "address"
                            },
                            {
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            }
                        ],
                        name: "isApprovedForAll",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "name",
                        outputs: [
                            {
                                internalType: "string",
                                name: "",
                                type: "string"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "pubkey",
                        outputs: [
                            {
                                internalType: "bytes32",
                                name: "x",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "y",
                                type: "bytes32"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes4",
                                name: "interfaceID",
                                type: "bytes4"
                            }
                        ],
                        name: "supportsInterface",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "string",
                                name: "key",
                                type: "string"
                            }
                        ],
                        name: "text",
                        outputs: [
                            {
                                internalType: "string",
                                name: "",
                                type: "string"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "zonehash",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "address",
                                name: "a",
                                type: "address"
                            }
                        ],
                        name: "setAddr",
                        outputs: [],
                        stateMutability: "nonpayable",
                        type: "function"
                    }
                ];
            },
            8677: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.networkIds = t.registryAddresses = t.methodsInInterface = t.interfaceIds = void 0, t.interfaceIds = {
                    addr: "0x3b3b57de",
                    name: "0x691f3431",
                    abi: "0x2203ab56",
                    pubkey: "0xc8690233",
                    text: "0x59d1d43c",
                    contenthash: "0xbc1c58d1"
                }, t.methodsInInterface = {
                    setAddr: "addr",
                    addr: "addr",
                    setPubkey: "pubkey",
                    pubkey: "pubkey",
                    setContenthash: "contenthash",
                    contenthash: "contenthash",
                    text: "text",
                    name: "name"
                }, t.registryAddresses = {
                    main: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
                    goerli: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
                }, t.networkIds = {
                    "0x1": "main",
                    "0x5": "goerli"
                };
            },
            9142: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ENS = void 0;
                const o = r(6527), i = r(5071), s = r(6637), a = r(9820), c = r(9970), u = r(7345), d = r(8677), l = r(67), h = r(8067);
                class f extends o.Web3Context {
                    constructor(e, t){
                        super(null != t ? t : ""), this.registryAddress = null != e ? e : d.registryAddresses.main, this._registry = new l.Registry(this.getContextObject(), e), this._resolver = new h.Resolver(this._registry);
                    }
                    getResolver(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.getResolver(e);
                        });
                    }
                    recordExists(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.recordExists(e);
                        });
                    }
                    getTTL(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.getTTL(e);
                        });
                    }
                    getOwner(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.getOwner(e);
                        });
                    }
                    getAddress(e, t = 60) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getAddress(e, t);
                        });
                    }
                    getText(e, t) {
                        return n(this, void 0, void 0, function*() {
                            return (0, u.isAddress)(e) ? this._resolver.getText((yield this._resolver.getName(e, !1)), t) : this._resolver.getText(e, t);
                        });
                    }
                    getName(e, t = !0) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getName(e, t);
                        });
                    }
                    getPubkey(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getPubkey(e);
                        });
                    }
                    getContenthash(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getContenthash(e);
                        });
                    }
                    checkNetwork() {
                        return n(this, void 0, void 0, function*() {
                            const e = Date.now() / 1e3;
                            if (!this._lastSyncCheck || e - this._lastSyncCheck > 3600) {
                                const t = yield (0, s.isSyncing)(this);
                                if ("boolean" != typeof t || t) throw new i.ENSNetworkNotSyncedError;
                                this._lastSyncCheck = e;
                            }
                            if (this._detectedAddress) return this._detectedAddress;
                            const t = yield (0, a.getId)(this, Object.assign(Object.assign({}, this.defaultReturnFormat), {
                                number: c.FMT_NUMBER.HEX
                            })), r = d.registryAddresses[d.networkIds[t]];
                            if (void 0 === r) throw new i.ENSUnsupportedNetworkError(t);
                            return this._detectedAddress = r, this._detectedAddress;
                        });
                    }
                    supportsInterface(e, t) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.supportsInterface(e, t);
                        });
                    }
                    get events() {
                        return this._registry.events;
                    }
                    setAddress(e, t, r) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.setAddress(e, t, r);
                        });
                    }
                }
                t.ENS = f;
            },
            1698: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.registryAddresses = void 0;
                const i = r(8677);
                Object.defineProperty(t, "registryAddresses", {
                    enumerable: !0,
                    get: function() {
                        return i.registryAddresses;
                    }
                }), o(r(9142), t);
            },
            67: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Registry = void 0;
                const o = r(3211), i = r(6919), s = r(172), a = r(8677), c = r(8196);
                t.Registry = class {
                    constructor(e, t){
                        this.contract = new o.Contract(i.ENSRegistryAbi, null != t ? t : a.registryAddresses.main, e), this.context = e;
                    }
                    getOwner(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.owner((0, c.namehash)(e)).call();
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    getTTL(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.ttl((0, c.namehash)(e)).call();
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    recordExists(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.recordExists((0, c.namehash)(e)).call();
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    getResolver(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.resolver((0, c.namehash)(e)).call().then((e)=>{
                                    if ("string" == typeof e) return new o.Contract(s.PublicResolverAbi, e, this.context);
                                    throw new Error;
                                });
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    get events() {
                        return this.contract.events;
                    }
                };
            },
            8067: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Resolver = void 0;
                const o = r(5071), i = r(9634), s = r(7345), a = r(8677), c = r(8196);
                t.Resolver = class {
                    constructor(e){
                        this.registry = e;
                    }
                    getResolverContractAdapter(e) {
                        return n(this, void 0, void 0, function*() {
                            return this.registry.getResolver(e);
                        });
                    }
                    checkInterfaceSupport(e, t) {
                        var r, s;
                        return n(this, void 0, void 0, function*() {
                            if ((0, i.isNullish)(a.interfaceIds[t])) throw new o.ResolverMethodMissingError(null !== (r = e.options.address) && void 0 !== r ? r : "", t);
                            if (!(yield e.methods.supportsInterface(a.interfaceIds[t]).call())) throw new o.ResolverMethodMissingError(null !== (s = e.options.address) && void 0 !== s ? s : "", t);
                        });
                    }
                    supportsInterface(e, t) {
                        var r;
                        return n(this, void 0, void 0, function*() {
                            const n = yield this.getResolverContractAdapter(e);
                            let o = t;
                            if (!(0, s.isHexStrict)(o)) {
                                if (o = null !== (r = (0, i.sha3)(t)) && void 0 !== r ? r : "", "" === t) throw new Error("Invalid interface Id");
                                o = o.slice(0, 10);
                            }
                            return n.methods.supportsInterface(o).call();
                        });
                    }
                    getAddress(e, t = 60) {
                        return n(this, void 0, void 0, function*() {
                            const r = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(r, a.methodsInInterface.addr), r.methods.addr((0, c.namehash)(e), t).call();
                        });
                    }
                    getPubkey(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(t, a.methodsInInterface.pubkey), t.methods.pubkey((0, c.namehash)(e)).call();
                        });
                    }
                    getContenthash(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(t, a.methodsInInterface.contenthash), t.methods.contenthash((0, c.namehash)(e)).call();
                        });
                    }
                    setAddress(e, t, r) {
                        return n(this, void 0, void 0, function*() {
                            const n = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(n, a.methodsInInterface.setAddr), n.methods.setAddr((0, c.namehash)(e), t).send(r);
                        });
                    }
                    getText(e, t) {
                        return n(this, void 0, void 0, function*() {
                            const r = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(r, a.methodsInInterface.text), r.methods.text((0, c.namehash)(e), t).call();
                        });
                    }
                    getName(e, t = !0) {
                        return n(this, void 0, void 0, function*() {
                            const r = `${e.toLowerCase().substring(2)}.addr.reverse`, n = yield this.getResolverContractAdapter(r);
                            return t && (yield this.checkInterfaceSupport(n, a.methodsInInterface.name)), n.methods.name((0, c.namehash)(r)).call();
                        });
                    }
                };
            },
            8196: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.namehash = t.normalize = void 0;
                const n = r(9634), o = r(6608);
                t.normalize = (e)=>(0, o.ens_normalize)(e), t.namehash = (e)=>{
                    let r = "";
                    for(let e = 0; e < 32; e += 1)r += "00";
                    if (e) {
                        const o = (0, t.normalize)(e).split(".");
                        for(let e = o.length - 1; e >= 0; e -= 1){
                            const t = (0, n.sha3Raw)(o[e]).slice(2);
                            r = (0, n.sha3Raw)(`0x${r}${t}`).slice(2);
                        }
                    }
                    return `0x${r}`;
                };
            },
            5609: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Iban = void 0;
                const n = r(9634), o = r(7345), i = r(5071);
                class s {
                    constructor(e){
                        if (this.toAddress = ()=>{
                            if (this.isDirect()) {
                                const e = this._iban.slice(4), t = s._parseInt(e, 36), r = (0, n.leftPad)(t, 40);
                                return (0, n.toChecksumAddress)(r);
                            }
                            throw new Error("Iban is indirect and cannot be converted. Must be length of 34 or 35");
                        }, !s.isIndirect(e) && !s.isDirect(e)) throw new Error("Invalid IBAN was provided");
                        this._iban = e;
                    }
                    static isDirect(e) {
                        return 34 === e.length || 35 === e.length;
                    }
                    isDirect() {
                        return s.isDirect(this._iban);
                    }
                    static isIndirect(e) {
                        return 20 === e.length;
                    }
                    isIndirect() {
                        return s.isIndirect(this._iban);
                    }
                    static isValid(e) {
                        return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(e) && 1 === s._mod9710(s._iso13616Prepare(e));
                    }
                    isValid() {
                        return s.isValid(this._iban);
                    }
                    static fromBban(e) {
                        const t = `0${(98 - this._mod9710(this._iso13616Prepare(`XE00${e}`))).toString()}`.slice(-2);
                        return new s(`XE${t}${e}`);
                    }
                    static createIndirect(e) {
                        return s.fromBban(`ETH${e.institution}${e.identifier}`);
                    }
                    static fromAddress(e) {
                        if (!(0, o.isAddress)(e)) throw new i.InvalidAddressError(e);
                        const t = BigInt((0, n.hexToNumber)(e)).toString(36), r = (0, n.leftPad)(t, 15);
                        return s.fromBban(r.toUpperCase());
                    }
                    static toIban(e) {
                        return s.fromAddress(e).toString();
                    }
                    client() {
                        return this.isIndirect() ? this._iban.slice(11) : "";
                    }
                    checksum() {
                        return this._iban.slice(2, 4);
                    }
                    institution() {
                        return this.isIndirect() ? this._iban.slice(7, 11) : "";
                    }
                    toString() {
                        return this._iban;
                    }
                }
                t.Iban = s, s._iso13616Prepare = (e)=>{
                    const t = "A".charCodeAt(0), r = "Z".charCodeAt(0), n = e.toUpperCase();
                    return `${n.slice(4)}${n.slice(0, 4)}`.split("").map((e)=>{
                        const n = e.charCodeAt(0);
                        return n >= t && n <= r ? n - t + 10 : e;
                    }).join("");
                }, s._parseInt = (e, t)=>[
                        ...e
                    ].reduce((e, r)=>BigInt(parseInt(r, t)) + BigInt(t) * e, BigInt(0)), s._mod9710 = (e)=>{
                    let t, r = e;
                    for(; r.length > 2;)t = r.slice(0, 9), r = `${(parseInt(t, 10) % 97).toString()}${r.slice(t.length)}`;
                    return parseInt(r, 10) % 97;
                }, s.toAddress = (e)=>new s(e).toAddress();
            },
            9910: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const i = r(5609);
                o(r(5609), t), o(r(1965), t), t.default = i.Iban;
            },
            1965: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            9757: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const i = r(9638);
                o(r(9638), t), t.default = i.Personal;
            },
            9638: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Personal = void 0;
                const a = r(6527), c = i(r(706));
                class u extends a.Web3Context {
                    getAccounts() {
                        return s(this, void 0, void 0, function*() {
                            return c.getAccounts(this.requestManager);
                        });
                    }
                    newAccount(e) {
                        return s(this, void 0, void 0, function*() {
                            return c.newAccount(this.requestManager, e);
                        });
                    }
                    unlockAccount(e, t, r) {
                        return s(this, void 0, void 0, function*() {
                            return c.unlockAccount(this.requestManager, e, t, r);
                        });
                    }
                    lockAccount(e) {
                        return s(this, void 0, void 0, function*() {
                            return c.lockAccount(this.requestManager, e);
                        });
                    }
                    importRawKey(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return c.importRawKey(this.requestManager, e, t);
                        });
                    }
                    sendTransaction(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return c.sendTransaction(this.requestManager, e, t);
                        });
                    }
                    signTransaction(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return c.signTransaction(this.requestManager, e, t);
                        });
                    }
                    sign(e, t, r) {
                        return s(this, void 0, void 0, function*() {
                            return c.sign(this.requestManager, e, t, r);
                        });
                    }
                    ecRecover(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return c.ecRecover(this.requestManager, e, t);
                        });
                    }
                }
                t.Personal = u;
            },
            706: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ecRecover = t.sign = t.signTransaction = t.sendTransaction = t.importRawKey = t.lockAccount = t.unlockAccount = t.newAccount = t.getAccounts = void 0;
                const o = r(9634), i = r(6637), s = r(9970), a = r(7345), c = r(1181);
                t.getAccounts = (e)=>n(void 0, void 0, void 0, function*() {
                        return (yield c.personalRpcMethods.getAccounts(e)).map(o.toChecksumAddress);
                    }), t.newAccount = (e, t)=>n(void 0, void 0, void 0, function*() {
                        a.validator.validate([
                            "string"
                        ], [
                            t
                        ]);
                        const r = yield c.personalRpcMethods.newAccount(e, t);
                        return (0, o.toChecksumAddress)(r);
                    }), t.unlockAccount = (e, t, r, o)=>n(void 0, void 0, void 0, function*() {
                        return a.validator.validate([
                            "address",
                            "string",
                            "uint"
                        ], [
                            t,
                            r,
                            o
                        ]), c.personalRpcMethods.unlockAccount(e, t, r, o);
                    }), t.lockAccount = (e, t)=>n(void 0, void 0, void 0, function*() {
                        return a.validator.validate([
                            "address"
                        ], [
                            t
                        ]), c.personalRpcMethods.lockAccount(e, t);
                    }), t.importRawKey = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        return a.validator.validate([
                            "string",
                            "string"
                        ], [
                            t,
                            r
                        ]), c.personalRpcMethods.importRawKey(e, t, r);
                    }), t.sendTransaction = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        const n = (0, i.formatTransaction)(t, s.ETH_DATA_FORMAT);
                        return c.personalRpcMethods.sendTransaction(e, n, r);
                    }), t.signTransaction = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        const n = (0, i.formatTransaction)(t, s.ETH_DATA_FORMAT);
                        return c.personalRpcMethods.signTransaction(e, n, r);
                    }), t.sign = (e, t, r, i)=>n(void 0, void 0, void 0, function*() {
                        a.validator.validate([
                            "string",
                            "address",
                            "string"
                        ], [
                            t,
                            r,
                            i
                        ]);
                        const n = (0, a.isHexStrict)(t) ? t : (0, o.utf8ToHex)(t);
                        return c.personalRpcMethods.sign(e, n, r, i);
                    }), t.ecRecover = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        a.validator.validate([
                            "string",
                            "string"
                        ], [
                            t,
                            r
                        ]);
                        const n = (0, a.isHexStrict)(t) ? t : (0, o.utf8ToHex)(t);
                        return c.personalRpcMethods.ecRecover(e, n, r);
                    });
            },
            9326: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NUMBER_DATA_FORMAT = t.ALL_EVENTS_ABI = t.ALL_EVENTS = void 0;
                const n = r(9970);
                t.ALL_EVENTS = "ALLEVENTS", t.ALL_EVENTS_ABI = {
                    name: t.ALL_EVENTS,
                    signature: "",
                    type: "event",
                    inputs: []
                }, t.NUMBER_DATA_FORMAT = {
                    bytes: n.FMT_BYTES.HEX,
                    number: n.FMT_NUMBER.NUMBER
                };
            },
            6637: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SendTxHelper = t.trySendTransaction = t.waitForTransactionReceipt = t.getTransactionFromOrToAttr = t.transactionBuilder = t.detectTransactionType = void 0, r(6985);
                const i = r(1435);
                o(r(1435), t), o(r(7543), t), o(r(1922), t), o(r(9326), t), o(r(4832), t), o(r(8650), t), o(r(3222), t), o(r(5140), t), o(r(1258), t), o(r(7460), t);
                var s = r(7350);
                Object.defineProperty(t, "detectTransactionType", {
                    enumerable: !0,
                    get: function() {
                        return s.detectTransactionType;
                    }
                });
                var a = r(223);
                Object.defineProperty(t, "transactionBuilder", {
                    enumerable: !0,
                    get: function() {
                        return a.transactionBuilder;
                    }
                }), Object.defineProperty(t, "getTransactionFromOrToAttr", {
                    enumerable: !0,
                    get: function() {
                        return a.getTransactionFromOrToAttr;
                    }
                });
                var c = r(4745);
                Object.defineProperty(t, "waitForTransactionReceipt", {
                    enumerable: !0,
                    get: function() {
                        return c.waitForTransactionReceipt;
                    }
                });
                var u = r(8425);
                Object.defineProperty(t, "trySendTransaction", {
                    enumerable: !0,
                    get: function() {
                        return u.trySendTransaction;
                    }
                });
                var d = r(7322);
                Object.defineProperty(t, "SendTxHelper", {
                    enumerable: !0,
                    get: function() {
                        return d.SendTxHelper;
                    }
                }), t.default = i.Web3Eth;
            },
            3222: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                }, o = this && this.__rest || function(e, t) {
                    var r = {};
                    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var o = 0;
                        for(n = Object.getOwnPropertySymbols(e); o < n.length; o++)t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
                    }
                    return r;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.signTypedData = t.createAccessList = t.getFeeHistory = t.getProof = t.getChainId = t.getLogs = t.estimateGas = t.call = t.signTransaction = t.sign = t.sendSignedTransaction = t.sendTransaction = t.getTransactionCount = t.getTransactionReceipt = t.getTransactionFromBlock = t.getPendingTransactions = t.getTransaction = t.getUncle = t.getBlockUncleCount = t.getBlockTransactionCount = t.getBlock = t.getCode = t.getStorageAt = t.getBalance = t.getBlockNumber = t.getMaxPriorityFeePerGas = t.getGasPrice = t.getHashRate = t.isMining = t.getCoinbase = t.isSyncing = t.getProtocolVersion = void 0;
                const i = r(9970), s = r(6527), a = r(9634), c = r(9247), u = r(7345), d = r(5071), l = r(1181), h = r(5900), f = r(1922), p = r(223), m = r(5140), g = r(8425), y = r(4745), v = r(9326), b = r(7322);
                t.getProtocolVersion = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getProtocolVersion(e.requestManager);
                    }), t.isSyncing = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getSyncing(e.requestManager);
                    }), t.getCoinbase = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getCoinbase(e.requestManager);
                    }), t.isMining = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getMining(e.requestManager);
                    }), t.getHashRate = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getHashRate(e.requestManager);
                        return (0, a.format)({
                            format: "uint"
                        }, r, null != t ? t : e.defaultReturnFormat);
                    });
                }, t.getGasPrice = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getGasPrice(e.requestManager);
                        return (0, a.format)({
                            format: "uint"
                        }, r, null != t ? t : e.defaultReturnFormat);
                    });
                }, t.getMaxPriorityFeePerGas = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getMaxPriorityFeePerGas(e.requestManager);
                        return (0, a.format)({
                            format: "uint"
                        }, r, null != t ? t : e.defaultReturnFormat);
                    });
                }, t.getBlockNumber = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getBlockNumber(e.requestManager);
                        return (0, a.format)({
                            format: "uint"
                        }, r, null != t ? t : e.defaultReturnFormat);
                    });
                }, t.getBalance = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), s = yield l.ethRpcMethods.getBalance(e.requestManager, t, n);
                        return (0, a.format)({
                            format: "uint"
                        }, s, null != o ? o : e.defaultReturnFormat);
                    });
                }, t.getStorageAt = function(e, t, r, o = e.defaultBlock, s) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), c = (0, u.isBlockTag)(o) ? o : (0, a.format)({
                            format: "uint"
                        }, o, i.ETH_DATA_FORMAT), d = yield l.ethRpcMethods.getStorageAt(e.requestManager, t, n, c);
                        return (0, a.format)({
                            format: "bytes"
                        }, d, null != s ? s : e.defaultReturnFormat);
                    });
                }, t.getCode = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), s = yield l.ethRpcMethods.getCode(e.requestManager, t, n);
                        return (0, a.format)({
                            format: "bytes"
                        }, s, null != o ? o : e.defaultReturnFormat);
                    });
                }, t.getBlock = function(e, t = e.defaultBlock, r = !1, o) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        if ((0, u.isBytes)(t)) {
                            const o = (0, a.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockByHash(e.requestManager, o, r);
                        } else {
                            const o = (0, u.isBlockTag)(t) ? t : (0, a.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockByNumber(e.requestManager, o, r);
                        }
                        return (0, a.format)(f.blockSchema, n, null != o ? o : e.defaultReturnFormat);
                    });
                }, t.getBlockTransactionCount = function(e, t = e.defaultBlock, r) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, a.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockTransactionCountByHash(e.requestManager, r);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, a.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockTransactionCountByNumber(e.requestManager, r);
                        }
                        return (0, a.format)({
                            format: "uint"
                        }, n, null != r ? r : e.defaultReturnFormat);
                    });
                }, t.getBlockUncleCount = function(e, t = e.defaultBlock, r) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, a.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getUncleCountByBlockHash(e.requestManager, r);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, a.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getUncleCountByBlockNumber(e.requestManager, r);
                        }
                        return (0, a.format)({
                            format: "uint"
                        }, n, null != r ? r : e.defaultReturnFormat);
                    });
                }, t.getUncle = function(e, t = e.defaultBlock, r, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT);
                        let s;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, a.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            s = yield l.ethRpcMethods.getUncleByBlockHashAndIndex(e.requestManager, r, n);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, a.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            s = yield l.ethRpcMethods.getUncleByBlockNumberAndIndex(e.requestManager, r, n);
                        }
                        return (0, a.format)(f.blockSchema, s, null != o ? o : e.defaultReturnFormat);
                    });
                }, t.getTransaction = function(e, t, r = e.defaultReturnFormat) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, a.format)({
                            format: "bytes32"
                        }, t, i.DEFAULT_RETURN_FORMAT), o = yield l.ethRpcMethods.getTransactionByHash(e.requestManager, n);
                        return (0, u.isNullish)(o) ? o : (0, m.formatTransaction)(o, r, {
                            fillInputAndData: !0
                        });
                    });
                }, t.getPendingTransactions = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return (yield l.ethRpcMethods.getPendingTransactions(e.requestManager)).map((r)=>(0, m.formatTransaction)(r, null != t ? t : e.defaultReturnFormat, {
                                fillInputAndData: !0
                            }));
                    });
                }, t.getTransactionFromBlock = function(e, t = e.defaultBlock, r, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT);
                        let s;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, a.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            s = yield l.ethRpcMethods.getTransactionByBlockHashAndIndex(e.requestManager, r, n);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, a.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            s = yield l.ethRpcMethods.getTransactionByBlockNumberAndIndex(e.requestManager, r, n);
                        }
                        return (0, u.isNullish)(s) ? s : (0, m.formatTransaction)(s, null != o ? o : e.defaultReturnFormat, {
                            fillInputAndData: !0
                        });
                    });
                }, t.getTransactionReceipt = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, a.format)({
                            format: "bytes32"
                        }, t, i.DEFAULT_RETURN_FORMAT), o = yield l.ethRpcMethods.getTransactionReceipt(e.requestManager, n);
                        return (0, u.isNullish)(o) ? o : (0, a.format)(f.transactionReceiptSchema, o, null != r ? r : e.defaultReturnFormat);
                    });
                }, t.getTransactionCount = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), s = yield l.ethRpcMethods.getTransactionCount(e.requestManager, t, n);
                        return (0, a.format)({
                            format: "uint"
                        }, s, null != o ? o : e.defaultReturnFormat);
                    });
                }, t.sendTransaction = function(e, t, r, o = {
                    checkRevertBeforeSending: !0
                }, c) {
                    const d = new s.Web3PromiEvent((s, l)=>{
                        setImmediate(()=>{
                            (()=>{
                                n(this, void 0, void 0, function*() {
                                    const n = new b.SendTxHelper({
                                        web3Context: e,
                                        promiEvent: d,
                                        options: o,
                                        returnFormat: r
                                    });
                                    let h = Object.assign({}, t);
                                    (0, u.isNullish)(c) || (h = yield c.processTransaction(h));
                                    let g = (0, m.formatTransaction)(Object.assign(Object.assign({}, h), {
                                        from: (0, p.getTransactionFromOrToAttr)("from", e, h),
                                        to: (0, p.getTransactionFromOrToAttr)("to", e, h)
                                    }), i.ETH_DATA_FORMAT);
                                    try {
                                        let t;
                                        g = yield n.populateGasPrice({
                                            transaction: h,
                                            transactionFormatted: g
                                        }), yield n.checkRevertBeforeSending(g), n.emitSending(g), e.wallet && !(0, u.isNullish)(g.from) && (t = e.wallet.get(g.from));
                                        const o = yield n.signAndSend({
                                            wallet: t,
                                            tx: g
                                        }), i = (0, a.format)({
                                            format: "bytes32"
                                        }, o, null != r ? r : e.defaultReturnFormat);
                                        n.emitSent(g), n.emitTransactionHash(i);
                                        const c = yield (0, y.waitForTransactionReceipt)(e, o, null != r ? r : e.defaultReturnFormat), d = n.getReceiptWithEvents((0, a.format)(f.transactionReceiptSchema, c, null != r ? r : e.defaultReturnFormat));
                                        n.emitReceipt(d), s((yield n.handleResolve({
                                            receipt: d,
                                            tx: g
                                        }))), n.emitConfirmation({
                                            receipt: d,
                                            transactionHash: o
                                        });
                                    } catch (e) {
                                        l((yield n.handleError({
                                            error: e,
                                            tx: g
                                        })));
                                    }
                                });
                            })();
                        });
                    });
                    return d;
                }, t.sendSignedTransaction = function(e, t, r, u = {
                    checkRevertBeforeSending: !0
                }) {
                    const d = new s.Web3PromiEvent((s, h)=>{
                        setImmediate(()=>{
                            (()=>{
                                n(this, void 0, void 0, function*() {
                                    const p = new b.SendTxHelper({
                                        web3Context: e,
                                        promiEvent: d,
                                        options: u,
                                        returnFormat: r
                                    }), m = (0, a.format)({
                                        format: "bytes"
                                    }, t, i.ETH_DATA_FORMAT), v = c.TransactionFactory.fromSerializedData((0, a.bytesToUint8Array)((0, a.hexToBytes)(m))), E = Object.assign(Object.assign({}, v.toJSON()), {
                                        from: v.getSenderAddress().toString()
                                    });
                                    try {
                                        const { v: t, r: i, s: c } = E, u = o(E, [
                                            "v",
                                            "r",
                                            "s"
                                        ]);
                                        yield p.checkRevertBeforeSending(u), p.emitSending(m);
                                        const d = yield (0, g.trySendTransaction)(e, ()=>n(this, void 0, void 0, function*() {
                                                return l.ethRpcMethods.sendRawTransaction(e.requestManager, m);
                                            }));
                                        p.emitSent(m);
                                        const h = (0, a.format)({
                                            format: "bytes32"
                                        }, d, null != r ? r : e.defaultReturnFormat);
                                        p.emitTransactionHash(h);
                                        const v = yield (0, y.waitForTransactionReceipt)(e, d, null != r ? r : e.defaultReturnFormat), b = p.getReceiptWithEvents((0, a.format)(f.transactionReceiptSchema, v, null != r ? r : e.defaultReturnFormat));
                                        p.emitReceipt(b), s((yield p.handleResolve({
                                            receipt: b,
                                            tx: E
                                        }))), p.emitConfirmation({
                                            receipt: b,
                                            transactionHash: d
                                        });
                                    } catch (e) {
                                        h((yield p.handleError({
                                            error: e,
                                            tx: E
                                        })));
                                    }
                                });
                            })();
                        });
                    });
                    return d;
                }, t.sign = function(e, t, r, o = e.defaultReturnFormat) {
                    var s;
                    return n(this, void 0, void 0, function*() {
                        const n = (0, a.format)({
                            format: "bytes"
                        }, t, i.DEFAULT_RETURN_FORMAT);
                        if (null === (s = e.wallet) || void 0 === s ? void 0 : s.get(r)) {
                            const t = e.wallet.get(r).sign(n);
                            return (0, a.format)(f.SignatureObjectSchema, t, o);
                        }
                        if ("number" == typeof r) throw new d.SignatureError(t, 'RPC method "eth_sign" does not support index signatures');
                        const c = yield l.ethRpcMethods.sign(e.requestManager, r, n);
                        return (0, a.format)({
                            format: "bytes"
                        }, c, o);
                    });
                }, t.signTransaction = function(e, t, r = e.defaultReturnFormat) {
                    return n(this, void 0, void 0, function*() {
                        const n = yield l.ethRpcMethods.signTransaction(e.requestManager, (0, m.formatTransaction)(t, i.ETH_DATA_FORMAT));
                        return (0, u.isString)(n) ? (0, h.decodeSignedTransaction)(n, r, {
                            fillInputAndData: !0
                        }) : {
                            raw: (0, a.format)({
                                format: "bytes"
                            }, n.raw, r),
                            tx: (0, m.formatTransaction)(n.tx, r, {
                                fillInputAndData: !0
                            })
                        };
                    });
                }, t.call = function(e, t, r = e.defaultBlock, o = e.defaultReturnFormat) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), s = yield l.ethRpcMethods.call(e.requestManager, (0, m.formatTransaction)(t, i.ETH_DATA_FORMAT), n);
                        return (0, a.format)({
                            format: "bytes"
                        }, s, o);
                    });
                }, t.estimateGas = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, m.formatTransaction)(t, i.ETH_DATA_FORMAT), s = (0, u.isBlockTag)(r) ? r : (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), c = yield l.ethRpcMethods.estimateGas(e.requestManager, n, s);
                        return (0, a.format)({
                            format: "uint"
                        }, c, null != o ? o : e.defaultReturnFormat);
                    });
                }, t.getLogs = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        let { toBlock: n, fromBlock: o } = t;
                        (0, u.isNullish)(n) || "number" != typeof n && "bigint" != typeof n || (n = (0, a.numberToHex)(n)), (0, u.isNullish)(o) || "number" != typeof o && "bigint" != typeof o || (o = (0, a.numberToHex)(o));
                        const i = Object.assign(Object.assign({}, t), {
                            fromBlock: o,
                            toBlock: n
                        });
                        return (yield l.ethRpcMethods.getLogs(e.requestManager, i)).map((t)=>"string" == typeof t ? t : (0, a.format)(f.logSchema, t, null != r ? r : e.defaultReturnFormat));
                    });
                }, t.getChainId = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getChainId(e.requestManager);
                        return (0, a.format)({
                            format: "uint"
                        }, r, null != t ? t : e.defaultReturnFormat);
                    });
                }, t.getProof = function(e, t, r, o = e.defaultBlock, s) {
                    return n(this, void 0, void 0, function*() {
                        const n = r.map((e)=>(0, a.format)({
                                format: "bytes"
                            }, e, i.ETH_DATA_FORMAT)), c = (0, u.isBlockTag)(o) ? o : (0, a.format)({
                            format: "uint"
                        }, o, i.ETH_DATA_FORMAT), d = yield l.ethRpcMethods.getProof(e.requestManager, t, n, c);
                        return (0, a.format)(f.accountSchema, d, null != s ? s : e.defaultReturnFormat);
                    });
                }, t.getFeeHistory = function(e, t, r = e.defaultBlock, o, s) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, a.format)({
                            format: "uint"
                        }, t, i.ETH_DATA_FORMAT), c = (0, u.isBlockTag)(r) ? r : (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), d = (0, a.format)({
                            type: "array",
                            items: {
                                format: "uint"
                            }
                        }, o, v.NUMBER_DATA_FORMAT), h = yield l.ethRpcMethods.getFeeHistory(e.requestManager, n, c, d);
                        return (0, a.format)(f.feeHistorySchema, h, null != s ? s : e.defaultReturnFormat);
                    });
                }, t.createAccessList = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, a.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), s = yield l.ethRpcMethods.createAccessList(e.requestManager, (0, m.formatTransaction)(t, i.ETH_DATA_FORMAT), n);
                        return (0, a.format)(f.accessListResultSchema, s, null != o ? o : e.defaultReturnFormat);
                    });
                }, t.signTypedData = function(e, t, r, o, i) {
                    return n(this, void 0, void 0, function*() {
                        const n = yield l.ethRpcMethods.signTypedData(e.requestManager, t, r, o);
                        return (0, a.format)({
                            format: "bytes"
                        }, n, null != i ? i : e.defaultReturnFormat);
                    });
                };
            },
            1922: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.accountSchema = t.storageProofSchema = t.feeHistorySchema = t.SignatureObjectSchema = t.transactionReceiptSchema = t.syncSchema = t.logSchema = t.blockHeaderSchema = t.blockSchema = t.withdrawalsSchema = t.transactionInfoSchema = t.transactionSchema = t.customChainSchema = t.hardforkSchema = t.chainSchema = t.accessListResultSchema = t.accessListSchema = t.accessListItemSchema = void 0, t.accessListItemSchema = {
                    type: "object",
                    properties: {
                        address: {
                            format: "address"
                        },
                        storageKeys: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        }
                    }
                }, t.accessListSchema = {
                    type: "array",
                    items: Object.assign({}, t.accessListItemSchema)
                }, t.accessListResultSchema = {
                    type: "object",
                    properties: {
                        accessList: Object.assign({}, t.accessListSchema),
                        gasUsed: {
                            type: "string"
                        }
                    }
                }, t.chainSchema = {
                    type: "string",
                    enum: [
                        "goerli",
                        "kovan",
                        "mainnet",
                        "rinkeby",
                        "ropsten",
                        "sepolia"
                    ]
                }, t.hardforkSchema = {
                    type: "string",
                    enum: [
                        "arrowGlacier",
                        "berlin",
                        "byzantium",
                        "chainstart",
                        "constantinople",
                        "dao",
                        "homestead",
                        "istanbul",
                        "london",
                        "merge",
                        "muirGlacier",
                        "petersburg",
                        "shanghai",
                        "spuriousDragon",
                        "tangerineWhistle"
                    ]
                }, t.customChainSchema = {
                    type: "object",
                    properties: {
                        name: {
                            format: "string"
                        },
                        networkId: {
                            format: "uint"
                        },
                        chainId: {
                            format: "uint"
                        }
                    }
                }, t.transactionSchema = {
                    type: "object",
                    properties: {
                        from: {
                            format: "address"
                        },
                        to: {
                            oneOf: [
                                {
                                    format: "address"
                                },
                                {
                                    type: "null"
                                }
                            ]
                        },
                        value: {
                            format: "uint"
                        },
                        gas: {
                            format: "uint"
                        },
                        gasPrice: {
                            format: "uint"
                        },
                        effectiveGasPrice: {
                            format: "uint"
                        },
                        type: {
                            format: "uint"
                        },
                        maxFeePerGas: {
                            format: "uint"
                        },
                        maxPriorityFeePerGas: {
                            format: "uint"
                        },
                        accessList: Object.assign({}, t.accessListSchema),
                        data: {
                            format: "bytes"
                        },
                        input: {
                            format: "bytes"
                        },
                        nonce: {
                            format: "uint"
                        },
                        chain: Object.assign({}, t.chainSchema),
                        hardfork: Object.assign({}, t.hardforkSchema),
                        chainId: {
                            format: "uint"
                        },
                        networkId: {
                            format: "uint"
                        },
                        common: {
                            type: "object",
                            properties: {
                                customChain: Object.assign({}, t.customChainSchema),
                                baseChain: Object.assign({}, t.chainSchema),
                                hardfork: Object.assign({}, t.hardforkSchema)
                            }
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        v: {
                            format: "uint"
                        },
                        r: {
                            format: "bytes32"
                        },
                        s: {
                            format: "bytes32"
                        }
                    }
                }, t.transactionInfoSchema = {
                    type: "object",
                    properties: Object.assign(Object.assign({}, t.transactionSchema.properties), {
                        blockHash: {
                            format: "bytes32"
                        },
                        blockNumber: {
                            format: "uint"
                        },
                        hash: {
                            format: "bytes32"
                        },
                        transactionIndex: {
                            format: "uint"
                        },
                        from: {
                            format: "address"
                        },
                        to: {
                            oneOf: [
                                {
                                    format: "address"
                                },
                                {
                                    type: "null"
                                }
                            ]
                        },
                        value: {
                            format: "uint"
                        },
                        gas: {
                            format: "uint"
                        },
                        gasPrice: {
                            format: "uint"
                        },
                        effectiveGasPrice: {
                            format: "uint"
                        },
                        type: {
                            format: "uint"
                        },
                        maxFeePerGas: {
                            format: "uint"
                        },
                        maxPriorityFeePerGas: {
                            format: "uint"
                        },
                        accessList: Object.assign({}, t.accessListSchema),
                        data: {
                            format: "bytes"
                        },
                        input: {
                            format: "bytes"
                        },
                        nonce: {
                            format: "uint"
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        v: {
                            format: "uint"
                        },
                        r: {
                            format: "bytes32"
                        },
                        s: {
                            format: "bytes32"
                        }
                    })
                }, t.withdrawalsSchema = {
                    type: "object",
                    properties: {
                        index: {
                            format: "uint"
                        },
                        validatorIndex: {
                            format: "uint"
                        },
                        address: {
                            format: "address"
                        },
                        amount: {
                            format: "uint"
                        }
                    }
                }, t.blockSchema = {
                    type: "object",
                    properties: {
                        baseFeePerGas: {
                            format: "uint"
                        },
                        blobGasUsed: {
                            format: "uint"
                        },
                        difficulty: {
                            format: "uint"
                        },
                        excessBlobGas: {
                            format: "uint"
                        },
                        extraData: {
                            format: "bytes"
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        gasUsed: {
                            format: "uint"
                        },
                        hash: {
                            format: "bytes32"
                        },
                        logsBloom: {
                            format: "bytes256"
                        },
                        miner: {
                            format: "bytes"
                        },
                        mixHash: {
                            format: "bytes32"
                        },
                        nonce: {
                            format: "uint"
                        },
                        number: {
                            format: "uint"
                        },
                        parentBeaconBlockRoot: {
                            format: "bytes32"
                        },
                        parentHash: {
                            format: "bytes32"
                        },
                        receiptsRoot: {
                            format: "bytes32"
                        },
                        sha3Uncles: {
                            format: "bytes32"
                        },
                        size: {
                            format: "uint"
                        },
                        stateRoot: {
                            format: "bytes32"
                        },
                        timestamp: {
                            format: "uint"
                        },
                        totalDifficulty: {
                            format: "uint"
                        },
                        transactions: {
                            oneOf: [
                                {
                                    type: "array",
                                    items: Object.assign({}, t.transactionInfoSchema)
                                },
                                {
                                    type: "array",
                                    items: {
                                        format: "bytes32"
                                    }
                                }
                            ]
                        },
                        transactionsRoot: {
                            format: "bytes32"
                        },
                        uncles: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        },
                        withdrawals: {
                            type: "array",
                            items: Object.assign({}, t.withdrawalsSchema)
                        },
                        withdrawalsRoot: {
                            format: "bytes32"
                        }
                    }
                }, t.blockHeaderSchema = {
                    type: "object",
                    properties: {
                        author: {
                            format: "bytes32"
                        },
                        excessDataGas: {
                            format: "uint"
                        },
                        baseFeePerGas: {
                            format: "uint"
                        },
                        blobGasUsed: {
                            format: "uint"
                        },
                        difficulty: {
                            format: "uint"
                        },
                        excessBlobGas: {
                            format: "uint"
                        },
                        extraData: {
                            format: "bytes"
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        gasUsed: {
                            format: "uint"
                        },
                        hash: {
                            format: "bytes32"
                        },
                        logsBloom: {
                            format: "bytes256"
                        },
                        miner: {
                            format: "bytes"
                        },
                        mixHash: {
                            format: "bytes32"
                        },
                        nonce: {
                            format: "uint"
                        },
                        number: {
                            format: "uint"
                        },
                        parentBeaconBlockRoot: {
                            format: "bytes32"
                        },
                        parentHash: {
                            format: "bytes32"
                        },
                        receiptsRoot: {
                            format: "bytes32"
                        },
                        sha3Uncles: {
                            format: "bytes32"
                        },
                        size: {
                            format: "uint"
                        },
                        stateRoot: {
                            format: "bytes32"
                        },
                        timestamp: {
                            format: "uint"
                        },
                        totalDifficulty: {
                            format: "uint"
                        },
                        transactions: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        },
                        transactionsRoot: {
                            format: "bytes32"
                        },
                        uncles: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        },
                        withdrawals: {
                            type: "array",
                            items: Object.assign({}, t.withdrawalsSchema)
                        },
                        withdrawalsRoot: {
                            format: "bytes32"
                        }
                    }
                }, t.logSchema = {
                    type: "object",
                    properties: {
                        removed: {
                            format: "bool"
                        },
                        logIndex: {
                            format: "uint"
                        },
                        transactionIndex: {
                            format: "uint"
                        },
                        transactionHash: {
                            format: "bytes32"
                        },
                        blockHash: {
                            format: "bytes32"
                        },
                        blockNumber: {
                            format: "uint"
                        },
                        address: {
                            format: "address"
                        },
                        data: {
                            format: "bytes"
                        },
                        topics: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        }
                    }
                }, t.syncSchema = {
                    type: "object",
                    properties: {
                        startingBlock: {
                            format: "string"
                        },
                        currentBlock: {
                            format: "string"
                        },
                        highestBlock: {
                            format: "string"
                        },
                        knownStates: {
                            format: "string"
                        },
                        pulledStates: {
                            format: "string"
                        }
                    }
                }, t.transactionReceiptSchema = {
                    type: "object",
                    properties: {
                        transactionHash: {
                            format: "bytes32"
                        },
                        transactionIndex: {
                            format: "uint"
                        },
                        blockHash: {
                            format: "bytes32"
                        },
                        blockNumber: {
                            format: "uint"
                        },
                        from: {
                            format: "address"
                        },
                        to: {
                            format: "address"
                        },
                        cumulativeGasUsed: {
                            format: "uint"
                        },
                        gasUsed: {
                            format: "uint"
                        },
                        effectiveGasPrice: {
                            format: "uint"
                        },
                        contractAddress: {
                            format: "address"
                        },
                        logs: {
                            type: "array",
                            items: Object.assign({}, t.logSchema)
                        },
                        logsBloom: {
                            format: "bytes"
                        },
                        root: {
                            format: "bytes"
                        },
                        status: {
                            format: "uint"
                        },
                        type: {
                            format: "uint"
                        }
                    }
                }, t.SignatureObjectSchema = {
                    type: "object",
                    properties: {
                        messageHash: {
                            format: "bytes"
                        },
                        r: {
                            format: "bytes32"
                        },
                        s: {
                            format: "bytes32"
                        },
                        v: {
                            format: "bytes"
                        },
                        message: {
                            format: "bytes"
                        },
                        signature: {
                            format: "bytes"
                        }
                    }
                }, t.feeHistorySchema = {
                    type: "object",
                    properties: {
                        oldestBlock: {
                            format: "uint"
                        },
                        baseFeePerGas: {
                            type: "array",
                            items: {
                                format: "uint"
                            }
                        },
                        reward: {
                            type: "array",
                            items: {
                                type: "array",
                                items: {
                                    format: "uint"
                                }
                            }
                        },
                        gasUsedRatio: {
                            type: "array",
                            items: {
                                type: "number"
                            }
                        }
                    }
                }, t.storageProofSchema = {
                    type: "object",
                    properties: {
                        key: {
                            format: "bytes32"
                        },
                        value: {
                            format: "uint"
                        },
                        proof: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        }
                    }
                }, t.accountSchema = {
                    type: "object",
                    properties: {
                        balance: {
                            format: "uint"
                        },
                        codeHash: {
                            format: "bytes32"
                        },
                        nonce: {
                            format: "uint"
                        },
                        storageHash: {
                            format: "bytes32"
                        },
                        accountProof: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        },
                        storageProof: {
                            type: "array",
                            items: Object.assign({}, t.storageProofSchema)
                        }
                    }
                };
            },
            4832: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5900: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeSignedTransaction = void 0;
                const n = r(9634), o = r(9247), i = r(7350), s = r(5140);
                t.decodeSignedTransaction = function(e, t, r = {
                    fillInputAndData: !1
                }) {
                    return {
                        raw: (0, n.format)({
                            format: "bytes"
                        }, e, t),
                        tx: (0, s.formatTransaction)(Object.assign(Object.assign({}, o.TransactionFactory.fromSerializedData((0, n.hexToBytes)(e)).toJSON()), {
                            hash: (0, n.bytesToHex)((0, n.keccak256)((0, n.hexToBytes)(e))),
                            type: (0, i.detectRawTransactionType)((0, n.hexToBytes)(e))
                        }), t, {
                            fillInputAndData: r.fillInputAndData
                        })
                    };
                };
            },
            7543: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeEventABI = void 0;
                const n = r(9634), o = r(9970), i = r(8381), s = r(1922), a = r(9326);
                t.decodeEventABI = (e, t, r, c = o.DEFAULT_RETURN_FORMAT)=>{
                    var u, d, l, h, f;
                    let p = Object.assign({}, e);
                    const m = (0, n.format)(s.logSchema, t, c);
                    if ([
                        a.ALL_EVENTS,
                        "allEvents"
                    ].includes(p.name)) p = r.find((e)=>e.signature === t.topics[0]) || {
                        anonymous: !0
                    };
                    if (p.inputs = null !== (d = null !== (u = p.inputs) && void 0 !== u ? u : e.inputs) && void 0 !== d ? d : [], !p.anonymous) {
                        let e = 0;
                        (null !== (l = p.inputs) && void 0 !== l ? l : []).forEach((t)=>{
                            t.indexed && (e += 1);
                        }), e > 0 && (null == t ? void 0 : t.topics) && (null == t ? void 0 : t.topics.length) !== e + 1 && (p = Object.assign(Object.assign({}, p), {
                            anonymous: !0,
                            inputs: []
                        }));
                    }
                    const g = p.anonymous ? t.topics : (null !== (h = t.topics) && void 0 !== h ? h : []).slice(1);
                    return Object.assign(Object.assign({}, m), {
                        returnValues: (0, i.decodeLog)([
                            ...null !== (f = p.inputs) && void 0 !== f ? f : []
                        ], t.data, g),
                        event: p.name,
                        signature: !p.anonymous && t.topics && 0 !== t.topics.length && t.topics[0] ? t.topics[0] : void 0,
                        raw: {
                            data: t.data,
                            topics: t.topics
                        }
                    });
                };
            },
            7350: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.detectRawTransactionType = t.detectTransactionType = t.defaultTransactionTypeParser = void 0;
                const n = r(9634), o = r(9970), i = r(7345), s = r(5071), a = {
                    type: "object",
                    properties: {
                        accessList: {
                            type: "null"
                        },
                        maxFeePerGas: {
                            type: "null"
                        },
                        maxPriorityFeePerGas: {
                            type: "null"
                        }
                    }
                }, c = {
                    type: "object",
                    properties: {
                        maxFeePerGas: {
                            type: "null"
                        },
                        maxPriorityFeePerGas: {
                            type: "null"
                        }
                    }
                }, u = {
                    type: "object",
                    properties: {
                        gasPrice: {
                            type: "null"
                        }
                    }
                }, d = (e, t, r)=>{
                    try {
                        i.validator.validateJSONSchema(e, t);
                    } catch (e) {
                        if (e instanceof i.Web3ValidatorError) throw new s.InvalidPropertiesForTransactionTypeError(e.errors, r);
                        throw e;
                    }
                };
                t.defaultTransactionTypeParser = (e)=>{
                    var t, r;
                    const s = e;
                    if (!(0, i.isNullish)(s.type)) {
                        let e;
                        switch(s.type){
                            case "0x0":
                                e = a;
                                break;
                            case "0x1":
                                e = c;
                                break;
                            case "0x2":
                                e = u;
                                break;
                            default:
                                return (0, n.format)({
                                    format: "uint"
                                }, s.type, o.ETH_DATA_FORMAT);
                        }
                        return d(e, s, s.type), (0, n.format)({
                            format: "uint"
                        }, s.type, o.ETH_DATA_FORMAT);
                    }
                    if (!(0, i.isNullish)(s.maxFeePerGas) || !(0, i.isNullish)(s.maxPriorityFeePerGas)) return d(u, s, "0x2"), "0x2";
                    if (!(0, i.isNullish)(s.accessList)) return d(c, s, "0x1"), "0x1";
                    const l = null !== (t = s.hardfork) && void 0 !== t ? t : null === (r = s.common) || void 0 === r ? void 0 : r.hardfork;
                    if (!(0, i.isNullish)(l)) {
                        const e = Object.keys(o.HardforksOrdered).indexOf(l);
                        if (e >= Object.keys(o.HardforksOrdered).indexOf("london")) return (0, i.isNullish)(s.gasPrice) ? "0x2" : "0x0";
                        if (e === Object.keys(o.HardforksOrdered).indexOf("berlin")) return "0x0";
                    }
                    return (0, i.isNullish)(s.gasPrice) ? void 0 : (d(a, s, "0x0"), "0x0");
                }, t.detectTransactionType = (e, r)=>{
                    var n;
                    return (null !== (n = null == r ? void 0 : r.transactionTypeParser) && void 0 !== n ? n : t.defaultTransactionTypeParser)(e);
                }, t.detectRawTransactionType = (e)=>e[0] > 127 ? "0x0" : (0, n.toHex)(e[0]);
            },
            5140: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formatTransaction = void 0;
                const n = r(9970), o = r(7345), i = r(9634), s = r(5071), a = r(1922);
                t.formatTransaction = function(e, t = n.DEFAULT_RETURN_FORMAT, r = {
                    transactionSchema: a.transactionInfoSchema,
                    fillInputAndData: !1
                }) {
                    var c, u;
                    let d = (0, i.mergeDeep)({}, e);
                    if ((0, o.isNullish)(null == e ? void 0 : e.common) || (d.common = Object.assign({}, e.common), (0, o.isNullish)(null === (c = e.common) || void 0 === c ? void 0 : c.customChain) || (d.common.customChain = Object.assign({}, e.common.customChain))), d = (0, i.format)(null !== (u = r.transactionSchema) && void 0 !== u ? u : a.transactionInfoSchema, d, t), !(0, o.isNullish)(d.data) && !(0, o.isNullish)(d.input) && (0, i.toHex)(d.data) !== (0, i.toHex)(d.input)) throw new s.TransactionDataAndInputError({
                        data: (0, i.bytesToHex)(d.data),
                        input: (0, i.bytesToHex)(d.input)
                    });
                    return r.fillInputAndData && ((0, o.isNullish)(d.data) ? (0, o.isNullish)(d.input) || (d.data = d.input) : d.input = d.data), (0, o.isNullish)(d.gasLimit) || (d.gas = d.gasLimit, delete d.gasLimit), d;
                };
            },
            4429: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getRevertReason = t.parseTransactionError = void 0;
                const o = r(5071), i = r(8381), s = r(3222);
                t.parseTransactionError = (e, t)=>{
                    var r, n, s, a, c;
                    if (e instanceof o.ContractExecutionError && e.cause instanceof o.Eip838ExecutionError) {
                        if (void 0 !== t) {
                            const o = t.filter((e)=>(0, i.isAbiErrorFragment)(e));
                            return (0, i.decodeContractErrorData)(o, e.cause), {
                                reason: e.cause.message,
                                signature: null === (r = e.cause.data) || void 0 === r ? void 0 : r.slice(0, 10),
                                data: null === (n = e.cause.data) || void 0 === n ? void 0 : n.substring(10),
                                customErrorName: e.cause.errorName,
                                customErrorDecodedSignature: e.cause.errorSignature,
                                customErrorArguments: e.cause.errorArgs
                            };
                        }
                        return {
                            reason: e.cause.message,
                            signature: null === (s = e.cause.data) || void 0 === s ? void 0 : s.slice(0, 10),
                            data: null === (a = e.cause.data) || void 0 === a ? void 0 : a.substring(10)
                        };
                    }
                    if (e instanceof o.InvalidResponseError && !Array.isArray(null === (c = e.cause) || void 0 === c ? void 0 : c.errors) && void 0 !== e.cause) return e.cause.message;
                    throw e;
                }, t.getRevertReason = function(e, r, o, i = e.defaultReturnFormat) {
                    return n(this, void 0, void 0, function*() {
                        try {
                            return void (yield (0, s.call)(e, r, e.defaultBlock, i));
                        } catch (e) {
                            return (0, t.parseTransactionError)(e, o);
                        }
                    });
                };
            },
            1882: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTransactionError = void 0;
                const o = r(5071), i = r(4429);
                t.getTransactionError = function(e, t, r, s, a, c) {
                    return n(this, void 0, void 0, function*() {
                        let n, u = c;
                        if (void 0 === u && (void 0 !== s ? u = (0, i.parseTransactionError)(s) : e.handleRevert && void 0 !== t && (u = yield (0, i.getRevertReason)(e, t, a))), void 0 === u) n = new o.TransactionRevertedWithoutReasonError(r);
                        else if ("string" == typeof u) n = new o.TransactionRevertInstructionError(u, void 0, r);
                        else if (void 0 !== u.customErrorName && void 0 !== u.customErrorDecodedSignature && void 0 !== u.customErrorArguments) {
                            const e = u;
                            n = new o.TransactionRevertWithCustomError(e.reason, e.customErrorName, e.customErrorDecodedSignature, e.customErrorArguments, e.signature, r, e.data);
                        } else n = new o.TransactionRevertInstructionError(u.reason, u.signature, r, u.data);
                        return n;
                    });
                };
            },
            8736: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTransactionGasPricing = void 0;
                const o = r(9970), i = r(7345), s = r(5071), a = r(9634), c = r(3222), u = r(223);
                t.getTransactionGasPricing = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const d = (0, u.getTransactionType)(e, t);
                        if (!(0, i.isNullish)(d)) {
                            if (d.startsWith("-")) throw new s.UnsupportedTransactionTypeError(d);
                            if (Number(d) < 0 || Number(d) > 127) throw new s.UnsupportedTransactionTypeError(d);
                            if ((0, i.isNullish)(e.gasPrice) && ("0x0" === d || "0x1" === d)) return {
                                gasPrice: yield (0, c.getGasPrice)(t, r),
                                maxPriorityFeePerGas: void 0,
                                maxFeePerGas: void 0
                            };
                            if ("0x2" === d) return Object.assign({
                                gasPrice: void 0
                            }, (yield function(e, t, r) {
                                var u, d, l, h;
                                return n(this, void 0, void 0, function*() {
                                    const n = yield (0, c.getBlock)(t, t.defaultBlock, !1, o.ETH_DATA_FORMAT);
                                    if ((0, i.isNullish)(n.baseFeePerGas)) throw new s.Eip1559NotSupportedError;
                                    let f;
                                    if ((0, i.isNullish)(e.gasPrice) && BigInt(n.baseFeePerGas) === BigInt(0) && (f = yield (0, c.getGasPrice)(t, r)), !(0, i.isNullish)(e.gasPrice) || !(0, i.isNullish)(f)) {
                                        const t = (0, a.format)({
                                            format: "uint"
                                        }, null !== (u = e.gasPrice) && void 0 !== u ? u : f, r);
                                        return {
                                            maxPriorityFeePerGas: t,
                                            maxFeePerGas: t
                                        };
                                    }
                                    return {
                                        maxPriorityFeePerGas: (0, a.format)({
                                            format: "uint"
                                        }, null !== (d = e.maxPriorityFeePerGas) && void 0 !== d ? d : t.defaultMaxPriorityFeePerGas, r),
                                        maxFeePerGas: (0, a.format)({
                                            format: "uint"
                                        }, null !== (l = e.maxFeePerGas) && void 0 !== l ? l : BigInt(n.baseFeePerGas) * BigInt(2) + BigInt(null !== (h = e.maxPriorityFeePerGas) && void 0 !== h ? h : t.defaultMaxPriorityFeePerGas), r)
                                    };
                                });
                            }(e, t, r)));
                        }
                    });
                };
            },
            1258: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.prepareTransactionForSigning = void 0;
                const o = r(9970), i = r(9634), s = r(9247), a = r(7345), c = r(8650), u = r(5140), d = r(223);
                t.prepareTransactionForSigning = (e, t, r, l = !1, h = !0)=>n(void 0, void 0, void 0, function*() {
                        const n = yield (0, d.transactionBuilder)({
                            transaction: e,
                            web3Context: t,
                            privateKey: r,
                            fillGasPrice: l,
                            fillGasLimit: h
                        }), f = (0, u.formatTransaction)(n, o.ETH_DATA_FORMAT);
                        return (0, c.validateTransactionForSigning)(f), s.TransactionFactory.fromTxData(((e)=>{
                            var t, r;
                            return {
                                nonce: e.nonce,
                                gasPrice: e.gasPrice,
                                gasLimit: null !== (t = e.gasLimit) && void 0 !== t ? t : e.gas,
                                to: e.to,
                                value: e.value,
                                data: null !== (r = e.data) && void 0 !== r ? r : e.input,
                                type: e.type,
                                chainId: e.chainId,
                                accessList: e.accessList,
                                maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                                maxFeePerGas: e.maxFeePerGas
                            };
                        })(f), ((e, t)=>{
                            var r, n, o, c, u, d, l, h, f, p, m, g, y, v, b, E, _, A;
                            let T;
                            if (((0, a.isNullish)(e.chain) || (0, a.isNullish)(e.hardfork)) && (0, a.isNullish)(e.common)) t.defaultCommon ? (T = Object.assign({}, t.defaultCommon), (0, a.isNullish)(T.hardfork) && (T.hardfork = null !== (r = e.hardfork) && void 0 !== r ? r : t.defaultHardfork), (0, a.isNullish)(T.baseChain) && (T.baseChain = t.defaultChain)) : T = s.Common.custom({
                                name: "custom-network",
                                chainId: (0, i.toNumber)(e.chainId),
                                networkId: (0, a.isNullish)(e.networkId) ? void 0 : (0, i.toNumber)(e.networkId),
                                defaultHardfork: null !== (n = e.hardfork) && void 0 !== n ? n : t.defaultHardfork
                            }, {
                                baseChain: t.defaultChain
                            });
                            else {
                                const r = null !== (d = null !== (u = null === (c = null === (o = null == e ? void 0 : e.common) || void 0 === o ? void 0 : o.customChain) || void 0 === c ? void 0 : c.name) && void 0 !== u ? u : e.chain) && void 0 !== d ? d : "custom-network", n = (0, i.toNumber)(null !== (f = null === (h = null === (l = null == e ? void 0 : e.common) || void 0 === l ? void 0 : l.customChain) || void 0 === h ? void 0 : h.chainId) && void 0 !== f ? f : null == e ? void 0 : e.chainId), a = (0, i.toNumber)(null !== (g = null === (m = null === (p = null == e ? void 0 : e.common) || void 0 === p ? void 0 : p.customChain) || void 0 === m ? void 0 : m.networkId) && void 0 !== g ? g : null == e ? void 0 : e.networkId), w = null !== (b = null !== (v = null === (y = null == e ? void 0 : e.common) || void 0 === y ? void 0 : y.hardfork) && void 0 !== v ? v : null == e ? void 0 : e.hardfork) && void 0 !== b ? b : t.defaultHardfork, I = null !== (A = null !== (_ = null === (E = e.common) || void 0 === E ? void 0 : E.baseChain) && void 0 !== _ ? _ : e.chain) && void 0 !== A ? A : t.defaultChain;
                                n && a && r && (T = s.Common.custom({
                                    name: r,
                                    chainId: n,
                                    networkId: a,
                                    defaultHardfork: w
                                }, {
                                    baseChain: I
                                }));
                            }
                            return {
                                common: T
                            };
                        })(f, t));
                    });
            },
            4659: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rejectIfBlockTimeout = void 0;
                const o = r(9634), i = r(5071), s = r(9326), a = r(3222);
                function c(e, t, r) {
                    const c = e.transactionPollingInterval, [u, d] = (0, o.rejectIfConditionAtInterval)(()=>n(this, void 0, void 0, function*() {
                            let n;
                            try {
                                n = yield (0, a.getBlockNumber)(e, s.NUMBER_DATA_FORMAT);
                            } catch (e) {
                                return void console.warn("An error happen while trying to get the block number", e);
                            }
                            const o = n - t;
                            if (o >= e.transactionBlockTimeout) return new i.TransactionBlockTimeoutError({
                                starterBlockNumber: t,
                                numberOfBlocks: o,
                                transactionHash: r
                            });
                        }), c);
                    return [
                        d,
                        {
                            clean: ()=>{
                                clearInterval(u);
                            }
                        }
                    ];
                }
                t.rejectIfBlockTimeout = function(e, t) {
                    var r, o;
                    return n(this, void 0, void 0, function*() {
                        const { provider: u } = e.requestManager;
                        let d;
                        const l = yield (0, a.getBlockNumber)(e, s.NUMBER_DATA_FORMAT);
                        return d = (null === (o = (r = u).supportsSubscriptions) || void 0 === o ? void 0 : o.call(r)) && e.enableExperimentalFeatures.useSubscriptionWhenCheckingBlockTimeout ? yield function(e, t, r) {
                            var o;
                            return n(this, void 0, void 0, function*() {
                                let n, s, a = !0;
                                function u(n, o) {
                                    o && console.warn("error happened at subscription. So revert to polling...", o), s.clean(), a = !1;
                                    const [i, u] = c(e, t, r);
                                    s.clean = u.clean, i.catch((e)=>n(e));
                                }
                                try {
                                    n = yield null === (o = e.subscriptionManager) || void 0 === o ? void 0 : o.subscribe("newHeads"), s = {
                                        clean: ()=>{
                                            var t;
                                            n.id && (null === (t = e.subscriptionManager) || void 0 === t || t.removeSubscription(n).then(()=>{}).catch(()=>{}));
                                        }
                                    };
                                } catch (n) {
                                    return c(e, t, r);
                                }
                                return [
                                    new Promise((o, s)=>{
                                        try {
                                            n.on("data", (n)=>{
                                                if (a = !1, !(null == n ? void 0 : n.number)) return;
                                                const o = Number(BigInt(n.number) - BigInt(t));
                                                o >= e.transactionBlockTimeout && s(new i.TransactionBlockTimeoutError({
                                                    starterBlockNumber: t,
                                                    numberOfBlocks: o,
                                                    transactionHash: r
                                                }));
                                            }), n.on("error", (e)=>{
                                                u(s, e);
                                            });
                                        } catch (e) {
                                            u(s, e);
                                        }
                                        setTimeout(()=>{
                                            a && u(s);
                                        }, 1e3 * e.blockHeaderTimeout);
                                    }),
                                    s
                                ];
                            });
                        }(e, l, t) : c(e, l, t), d;
                    });
                };
            },
            7322: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SendTxHelper = void 0;
                const o = r(9970), i = r(7345), s = r(5071), a = r(1181), c = r(8736), u = r(8425), d = r(2117), l = r(9326), h = r(1882), f = r(4429), p = r(7543);
                t.SendTxHelper = class {
                    constructor({ options: e, web3Context: t, promiEvent: r, returnFormat: n }){
                        this.options = {
                            checkRevertBeforeSending: !0
                        }, this.options = e, this.web3Context = t, this.promiEvent = r, this.returnFormat = n;
                    }
                    getReceiptWithEvents(e) {
                        var t, r;
                        const n = Object.assign({}, null != e ? e : {});
                        if ((null === (t = this.options) || void 0 === t ? void 0 : t.contractAbi) && n.logs && n.logs.length > 0) {
                            n.events = {};
                            for (const e of n.logs){
                                const t = (0, p.decodeEventABI)(l.ALL_EVENTS_ABI, e, null === (r = this.options) || void 0 === r ? void 0 : r.contractAbi, this.returnFormat);
                                t.event && (n.events[t.event] = t);
                            }
                        }
                        return n;
                    }
                    checkRevertBeforeSending(e) {
                        return n(this, void 0, void 0, function*() {
                            if (!1 !== this.options.checkRevertBeforeSending) {
                                let t = e;
                                (0, i.isNullish)(e.data) && (0, i.isNullish)(e.input) && (0, i.isNullish)(e.gas) && (t = Object.assign(Object.assign({}, e), {
                                    gas: 21e3
                                }));
                                const r = yield (0, f.getRevertReason)(this.web3Context, t, this.options.contractAbi);
                                if (void 0 !== r) throw yield (0, h.getTransactionError)(this.web3Context, e, void 0, void 0, this.options.contractAbi, r);
                            }
                        });
                    }
                    emitSending(e) {
                        this.promiEvent.listenerCount("sending") > 0 && this.promiEvent.emit("sending", e);
                    }
                    populateGasPrice({ transactionFormatted: e, transaction: t }) {
                        var r;
                        return n(this, void 0, void 0, function*() {
                            let n = e;
                            return !(null === (r = this.options) || void 0 === r ? void 0 : r.ignoreGasPricing) && (0, i.isNullish)(e.gasPrice) && ((0, i.isNullish)(t.maxPriorityFeePerGas) || (0, i.isNullish)(t.maxFeePerGas)) && (n = Object.assign(Object.assign({}, e), (yield (0, c.getTransactionGasPricing)(e, this.web3Context, o.ETH_DATA_FORMAT)))), n;
                        });
                    }
                    signAndSend({ wallet: e, tx: t }) {
                        return n(this, void 0, void 0, function*() {
                            if (e) {
                                const r = yield e.signTransaction(t);
                                return (0, u.trySendTransaction)(this.web3Context, ()=>n(this, void 0, void 0, function*() {
                                        return a.ethRpcMethods.sendRawTransaction(this.web3Context.requestManager, r.rawTransaction);
                                    }), r.transactionHash);
                            }
                            return (0, u.trySendTransaction)(this.web3Context, ()=>n(this, void 0, void 0, function*() {
                                    return a.ethRpcMethods.sendTransaction(this.web3Context.requestManager, t);
                                }));
                        });
                    }
                    emitSent(e) {
                        this.promiEvent.listenerCount("sent") > 0 && this.promiEvent.emit("sent", e);
                    }
                    emitTransactionHash(e) {
                        this.promiEvent.listenerCount("transactionHash") > 0 && this.promiEvent.emit("transactionHash", e);
                    }
                    emitReceipt(e) {
                        this.promiEvent.listenerCount("receipt") > 0 && this.promiEvent.emit("receipt", e);
                    }
                    handleError({ error: e, tx: t }) {
                        var r;
                        return n(this, void 0, void 0, function*() {
                            let n = e;
                            return n instanceof s.ContractExecutionError && this.web3Context.handleRevert && (n = yield (0, h.getTransactionError)(this.web3Context, t, void 0, void 0, null === (r = this.options) || void 0 === r ? void 0 : r.contractAbi)), (n instanceof s.InvalidResponseError || n instanceof s.ContractExecutionError || n instanceof s.TransactionRevertWithCustomError || n instanceof s.TransactionRevertedWithoutReasonError || n instanceof s.TransactionRevertInstructionError || n instanceof s.TransactionPollingTimeoutError) && this.promiEvent.listenerCount("error") > 0 && this.promiEvent.emit("error", n), n;
                        });
                    }
                    emitConfirmation({ receipt: e, transactionHash: t, customTransactionReceiptSchema: r }) {
                        this.promiEvent.listenerCount("confirmation") > 0 && (0, d.watchTransactionForConfirmations)(this.web3Context, this.promiEvent, e, t, this.returnFormat, r);
                    }
                    handleResolve({ receipt: e, tx: t }) {
                        var r, o, i;
                        return n(this, void 0, void 0, function*() {
                            if (null === (r = this.options) || void 0 === r ? void 0 : r.transactionResolver) return null === (o = this.options) || void 0 === o ? void 0 : o.transactionResolver(e);
                            if (e.status === BigInt(0)) {
                                const r = yield (0, h.getTransactionError)(this.web3Context, t, e, void 0, null === (i = this.options) || void 0 === i ? void 0 : i.contractAbi);
                                throw this.promiEvent.listenerCount("error") > 0 && this.promiEvent.emit("error", r), r;
                            }
                            return e;
                        });
                    }
                };
            },
            223: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.transactionBuilder = t.defaultTransactionBuilder = t.getTransactionType = t.getTransactionNonce = t.getTransactionFromOrToAttr = void 0;
                const o = r(9970), i = r(9247), s = r(9820), a = r(7345), c = r(5071), u = r(9634), d = r(9326), l = r(3222), h = r(7350), f = r(1922), p = r(8736);
                function m(e) {
                    var r, i;
                    return n(this, void 0, void 0, function*() {
                        let n = (0, u.format)(f.transactionSchema, e.transaction, e.web3Context.defaultReturnFormat);
                        if ((0, a.isNullish)(n.from) && (n.from = (0, t.getTransactionFromOrToAttr)("from", e.web3Context, void 0, e.privateKey)), (0, a.isNullish)(n.nonce) && (n.nonce = yield (0, t.getTransactionNonce)(e.web3Context, n.from, o.ETH_DATA_FORMAT)), (0, a.isNullish)(n.value) && (n.value = "0x0"), (0, a.isNullish)(n.data)) (0, a.isNullish)(n.input) ? n.input = "0x" : n.input.startsWith("0x") || (n.input = `0x${n.input}`);
                        else {
                            if (!(0, a.isNullish)(n.input) && n.data !== n.input) throw new c.TransactionDataAndInputError({
                                data: (0, u.bytesToHex)(n.data),
                                input: (0, u.bytesToHex)(n.input)
                            });
                            n.data.startsWith("0x") || (n.data = `0x${n.data}`);
                        }
                        if ((0, a.isNullish)(n.common)) {
                            if (e.web3Context.defaultCommon) {
                                const t = e.web3Context.defaultCommon, r = t.customChain.chainId, o = t.customChain.networkId, i = t.customChain.name;
                                n.common = Object.assign(Object.assign({}, t), {
                                    customChain: {
                                        chainId: r,
                                        networkId: o,
                                        name: i
                                    }
                                });
                            }
                            (0, a.isNullish)(n.chain) && (n.chain = e.web3Context.defaultChain), (0, a.isNullish)(n.hardfork) && (n.hardfork = e.web3Context.defaultHardfork);
                        }
                        if ((0, a.isNullish)(n.chainId) && (0, a.isNullish)(null === (r = n.common) || void 0 === r ? void 0 : r.customChain.chainId) && (n.chainId = yield (0, l.getChainId)(e.web3Context, o.ETH_DATA_FORMAT)), (0, a.isNullish)(n.networkId) && (n.networkId = null !== (i = e.web3Context.defaultNetworkId) && void 0 !== i ? i : yield (0, s.getId)(e.web3Context, o.ETH_DATA_FORMAT)), (0, a.isNullish)(n.gasLimit) && !(0, a.isNullish)(n.gas) && (n.gasLimit = n.gas), n.type = (0, t.getTransactionType)(n, e.web3Context), !(0, a.isNullish)(n.accessList) || "0x1" !== n.type && "0x2" !== n.type || (n.accessList = []), e.fillGasPrice && (n = Object.assign(Object.assign({}, n), (yield (0, p.getTransactionGasPricing)(n, e.web3Context, o.ETH_DATA_FORMAT)))), (0, a.isNullish)(n.gas) && (0, a.isNullish)(n.gasLimit) && e.fillGasLimit) {
                            const t = yield (0, l.estimateGas)(e.web3Context, n, "latest", o.ETH_DATA_FORMAT);
                            n = Object.assign(Object.assign({}, n), {
                                gas: (0, u.format)({
                                    format: "uint"
                                }, t, o.ETH_DATA_FORMAT)
                            });
                        }
                        return n;
                    });
                }
                t.getTransactionFromOrToAttr = (e, t, r, n)=>{
                    if (void 0 !== r && e in r && void 0 !== r[e]) {
                        if ("string" == typeof r[e] && (0, a.isAddress)(r[e])) return r[e];
                        if (!(0, a.isHexStrict)(r[e]) && (0, a.isNumber)(r[e])) {
                            if (t.wallet) {
                                const n = t.wallet.get((0, u.format)({
                                    format: "uint"
                                }, r[e], d.NUMBER_DATA_FORMAT));
                                if (!(0, a.isNullish)(n)) return n.address;
                                throw new c.LocalWalletNotAvailableError;
                            }
                            throw new c.LocalWalletNotAvailableError;
                        }
                        throw "from" === e ? new c.InvalidTransactionWithSender(r.from) : new c.InvalidTransactionWithReceiver(r.to);
                    }
                    if ("from" === e) {
                        if (!(0, a.isNullish)(n)) return (0, i.privateKeyToAddress)(n);
                        if (!(0, a.isNullish)(t.defaultAccount)) return t.defaultAccount;
                    }
                }, t.getTransactionNonce = (e, t, r = e.defaultReturnFormat)=>n(void 0, void 0, void 0, function*() {
                        if ((0, a.isNullish)(t)) throw new c.UnableToPopulateNonceError;
                        return (0, l.getTransactionCount)(e, t, e.defaultBlock, r);
                    }), t.getTransactionType = (e, t)=>{
                    const r = (0, h.detectTransactionType)(e, t);
                    return (0, a.isNullish)(r) ? (0, a.isNullish)(t.defaultTransactionType) ? void 0 : (0, u.format)({
                        format: "uint"
                    }, t.defaultTransactionType, o.ETH_DATA_FORMAT) : r;
                }, t.defaultTransactionBuilder = m, t.transactionBuilder = (e)=>n(void 0, void 0, void 0, function*() {
                        var t;
                        return (null !== (t = e.web3Context.transactionBuilder) && void 0 !== t ? t : m)(Object.assign(Object.assign({}, e), {
                            transaction: e.transaction
                        }));
                    });
            },
            8425: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.trySendTransaction = void 0;
                const o = r(9634), i = r(5071), s = r(4659);
                t.trySendTransaction = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const [n, a] = (0, o.rejectIfTimeout)(e.transactionSendTimeout, new i.TransactionSendTimeoutError({
                            numberOfSeconds: e.transactionSendTimeout / 1e3,
                            transactionHash: r
                        })), [c, u] = yield (0, s.rejectIfBlockTimeout)(e, r);
                        try {
                            return yield Promise.race([
                                t(),
                                a,
                                c
                            ]);
                        } finally{
                            clearTimeout(n), u.clean();
                        }
                    });
                };
            },
            4745: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.waitForTransactionReceipt = void 0;
                const o = r(5071), i = r(9634), s = r(4659), a = r(3222);
                t.waitForTransactionReceipt = function(e, t, r, c) {
                    var u;
                    return n(this, void 0, void 0, function*() {
                        const d = null !== (u = e.transactionReceiptPollingInterval) && void 0 !== u ? u : e.transactionPollingInterval, [l, h] = (0, i.pollTillDefinedAndReturnIntervalId)(()=>n(this, void 0, void 0, function*() {
                                try {
                                    return (null != c ? c : a.getTransactionReceipt)(e, t, r);
                                } catch (e) {
                                    return void console.warn("An error happen while trying to get the transaction receipt", e);
                                }
                            }), d), [f, p] = (0, i.rejectIfTimeout)(e.transactionPollingTimeout, new o.TransactionPollingTimeoutError({
                            numberOfSeconds: e.transactionPollingTimeout / 1e3,
                            transactionHash: t
                        })), [m, g] = yield (0, s.rejectIfBlockTimeout)(e, t);
                        try {
                            return yield Promise.race([
                                l,
                                p,
                                m
                            ]);
                        } finally{
                            f && clearTimeout(f), h && clearInterval(h), g.clean();
                        }
                    });
                };
            },
            8717: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watchTransactionByPolling = void 0;
                const o = r(9634), i = r(1181), s = r(1922);
                t.watchTransactionByPolling = ({ web3Context: e, transactionReceipt: t, transactionPromiEvent: r, customTransactionReceiptSchema: a, returnFormat: c })=>{
                    var u;
                    let d = 1;
                    const l = setInterval(()=>{
                        n(void 0, void 0, void 0, function*() {
                            d >= e.transactionConfirmationBlocks && clearInterval(l);
                            const n = yield i.ethRpcMethods.getBlockByNumber(e.requestManager, (0, o.numberToHex)(BigInt(t.blockNumber) + BigInt(d)), !1);
                            (null == n ? void 0 : n.hash) && (d += 1, r.emit("confirmation", {
                                confirmations: (0, o.format)({
                                    format: "uint"
                                }, d, c),
                                receipt: (0, o.format)(null != a ? a : s.transactionReceiptSchema, t, c),
                                latestBlockHash: (0, o.format)({
                                    format: "bytes32"
                                }, n.hash, c)
                            }));
                        });
                    }, null !== (u = e.transactionReceiptPollingInterval) && void 0 !== u ? u : e.transactionPollingInterval);
                };
            },
            2539: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watchTransactionBySubscription = void 0;
                const o = r(9634), i = r(1922), s = r(8717);
                t.watchTransactionBySubscription = ({ web3Context: e, transactionReceipt: t, transactionPromiEvent: r, customTransactionReceiptSchema: a, returnFormat: c })=>{
                    let u, d = !0;
                    setImmediate(()=>{
                        var l;
                        null === (l = e.subscriptionManager) || void 0 === l || l.subscribe("newHeads").then((l)=>{
                            l.on("data", (s)=>n(void 0, void 0, void 0, function*() {
                                    var n;
                                    if (d = !1, !(null == s ? void 0 : s.number) || u === (null == s ? void 0 : s.parentHash)) return;
                                    u = null == s ? void 0 : s.parentHash;
                                    const h = BigInt(s.number) - BigInt(t.blockNumber) + BigInt(1);
                                    r.emit("confirmation", {
                                        confirmations: (0, o.format)({
                                            format: "uint"
                                        }, h, c),
                                        receipt: (0, o.format)(null != a ? a : i.transactionReceiptSchema, t, c),
                                        latestBlockHash: (0, o.format)({
                                            format: "bytes32"
                                        }, s.parentHash, c)
                                    }), h >= e.transactionConfirmationBlocks && (yield null === (n = e.subscriptionManager) || void 0 === n ? void 0 : n.removeSubscription(l));
                                })), l.on("error", ()=>n(void 0, void 0, void 0, function*() {
                                    var n;
                                    yield null === (n = e.subscriptionManager) || void 0 === n ? void 0 : n.removeSubscription(l), d = !1, (0, s.watchTransactionByPolling)({
                                        web3Context: e,
                                        transactionReceipt: t,
                                        transactionPromiEvent: r,
                                        customTransactionReceiptSchema: a,
                                        returnFormat: c
                                    });
                                }));
                        }).catch(()=>{
                            d = !1, (0, s.watchTransactionByPolling)({
                                web3Context: e,
                                transactionReceipt: t,
                                customTransactionReceiptSchema: a,
                                transactionPromiEvent: r,
                                returnFormat: c
                            });
                        });
                    }), setTimeout(()=>{
                        d && (0, s.watchTransactionByPolling)({
                            web3Context: e,
                            transactionReceipt: t,
                            transactionPromiEvent: r,
                            returnFormat: c
                        });
                    }, 1e3 * e.blockHeaderTimeout);
                };
            },
            2117: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watchTransactionForConfirmations = void 0;
                const n = r(9634), o = r(7345), i = r(5071), s = r(1922), a = r(8717), c = r(2539);
                t.watchTransactionForConfirmations = function(e, t, r, u, d, l) {
                    if ((0, o.isNullish)(r) || (0, o.isNullish)(r.blockHash)) throw new i.TransactionMissingReceiptOrBlockHashError({
                        receipt: r,
                        blockHash: (0, n.format)({
                            format: "bytes32"
                        }, null == r ? void 0 : r.blockHash, d),
                        transactionHash: (0, n.format)({
                            format: "bytes32"
                        }, u, d)
                    });
                    if (!r.blockNumber) throw new i.TransactionReceiptMissingBlockNumberError({
                        receipt: r
                    });
                    t.emit("confirmation", {
                        confirmations: (0, n.format)({
                            format: "uint"
                        }, 1, d),
                        receipt: (0, n.format)(null != l ? l : s.transactionReceiptSchema, r, d),
                        latestBlockHash: (0, n.format)({
                            format: "bytes32"
                        }, r.blockHash, d)
                    });
                    const h = e.requestManager.provider;
                    h && "supportsSubscriptions" in h && h.supportsSubscriptions() ? (0, c.watchTransactionBySubscription)({
                        web3Context: e,
                        transactionReceipt: r,
                        transactionPromiEvent: t,
                        customTransactionReceiptSchema: l,
                        returnFormat: d
                    }) : (0, a.watchTransactionByPolling)({
                        web3Context: e,
                        transactionReceipt: r,
                        transactionPromiEvent: t,
                        customTransactionReceiptSchema: l,
                        returnFormat: d
                    });
                };
            },
            8650: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateTransactionForSigning = t.validateGas = t.validateFeeMarketGas = t.validateLegacyGas = t.validateHardfork = t.validateBaseChain = t.validateChainInfo = t.validateCustomChainInfo = t.validateTransactionCall = t.isTransactionCall = t.validateTransactionWithSender = t.isTransactionWithSender = t.isTransactionLegacyUnsigned = t.isTransaction2930Unsigned = t.isTransaction1559Unsigned = t.isAccessList = t.isAccessListEntry = t.isBaseTransaction = void 0;
                const n = r(9970), o = r(7345), i = r(5071), s = r(5140);
                function a(e) {
                    return !(!(0, o.isNullish)(e.to) && !(0, o.isAddress)(e.to) || !(0, o.isHexStrict)(e.type) && !(0, o.isNullish)(e.type) && 2 !== e.type.length || !(0, o.isHexStrict)(e.nonce) || !(0, o.isHexStrict)(e.gas) || !(0, o.isHexStrict)(e.value) || !(0, o.isHexStrict)(e.input) || e.chainId && !(0, o.isHexStrict)(e.chainId));
                }
                function c(e) {
                    return !(!(0, o.isNullish)(e.address) && !(0, o.isAddress)(e.address) || !(0, o.isNullish)(e.storageKeys) && !e.storageKeys.every((e)=>(0, o.isHexString32Bytes)(e)));
                }
                function u(e) {
                    return !(!Array.isArray(e) || !e.every((e)=>c(e)));
                }
                function d(e) {
                    return !!(a(e) && (0, o.isHexStrict)(e.maxFeePerGas) && (0, o.isHexStrict)(e.maxPriorityFeePerGas) && u(e.accessList));
                }
                function l(e) {
                    return !!a(e) && !!(0, o.isHexStrict)(e.gasPrice) && !!u(e.accessList);
                }
                function h(e) {
                    return !!a(e) && !!(0, o.isHexStrict)(e.gasPrice);
                }
                function f(e) {
                    return !!(0, o.isAddress)(e.from) && !!a(e) && !!(d(e) || l(e) || h(e));
                }
                function p(e) {
                    return !(!(0, o.isNullish)(e.from) && !(0, o.isAddress)(e.from) || !(0, o.isAddress)(e.to) || !(0, o.isNullish)(e.gas) && !(0, o.isHexStrict)(e.gas) || !(0, o.isNullish)(e.gasPrice) && !(0, o.isHexStrict)(e.gasPrice) || !(0, o.isNullish)(e.value) && !(0, o.isHexStrict)(e.value) || !(0, o.isNullish)(e.data) && !(0, o.isHexStrict)(e.data) || !(0, o.isNullish)(e.input) && !(0, o.isHexStrict)(e.input) || !(0, o.isNullish)(e.type) || d(e) || l(e));
                }
                t.isBaseTransaction = a, t.isAccessListEntry = c, t.isAccessList = u, t.isTransaction1559Unsigned = d, t.isTransaction2930Unsigned = l, t.isTransactionLegacyUnsigned = h, t.isTransactionWithSender = f, t.validateTransactionWithSender = function(e) {
                    if (!f(e)) throw new i.InvalidTransactionWithSender(e);
                }, t.isTransactionCall = p, t.validateTransactionCall = function(e) {
                    if (!p(e)) throw new i.InvalidTransactionCall(e);
                }, t.validateCustomChainInfo = (e)=>{
                    if (!(0, o.isNullish)(e.common)) {
                        if ((0, o.isNullish)(e.common.customChain)) throw new i.MissingCustomChainError;
                        if ((0, o.isNullish)(e.common.customChain.chainId)) throw new i.MissingCustomChainIdError;
                        if (!(0, o.isNullish)(e.chainId) && e.chainId !== e.common.customChain.chainId) throw new i.ChainIdMismatchError({
                            txChainId: e.chainId,
                            customChainId: e.common.customChain.chainId
                        });
                    }
                }, t.validateChainInfo = (e)=>{
                    if (!(0, o.isNullish)(e.common) && !(0, o.isNullish)(e.chain) && !(0, o.isNullish)(e.hardfork)) throw new i.CommonOrChainAndHardforkError;
                    if (!(0, o.isNullish)(e.chain) && (0, o.isNullish)(e.hardfork) || !(0, o.isNullish)(e.hardfork) && (0, o.isNullish)(e.chain)) throw new i.MissingChainOrHardforkError({
                        chain: e.chain,
                        hardfork: e.hardfork
                    });
                }, t.validateBaseChain = (e)=>{
                    if (!(0, o.isNullish)(e.common) && !(0, o.isNullish)(e.common.baseChain) && !(0, o.isNullish)(e.chain) && e.chain !== e.common.baseChain) throw new i.ChainMismatchError({
                        txChain: e.chain,
                        baseChain: e.common.baseChain
                    });
                }, t.validateHardfork = (e)=>{
                    if (!(0, o.isNullish)(e.common) && !(0, o.isNullish)(e.common.hardfork) && !(0, o.isNullish)(e.hardfork) && e.hardfork !== e.common.hardfork) throw new i.HardforkMismatchError({
                        txHardfork: e.hardfork,
                        commonHardfork: e.common.hardfork
                    });
                }, t.validateLegacyGas = (e)=>{
                    if ((0, o.isNullish)(e.gas) || !(0, o.isUInt)(e.gas) || (0, o.isNullish)(e.gasPrice) || !(0, o.isUInt)(e.gasPrice)) throw new i.InvalidGasOrGasPrice({
                        gas: e.gas,
                        gasPrice: e.gasPrice
                    });
                    if (!(0, o.isNullish)(e.maxFeePerGas) || !(0, o.isNullish)(e.maxPriorityFeePerGas)) throw new i.UnsupportedFeeMarketError({
                        maxFeePerGas: e.maxFeePerGas,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas
                    });
                }, t.validateFeeMarketGas = (e)=>{
                    if (!(0, o.isNullish)(e.gasPrice) && "0x2" === e.type) throw new i.Eip1559GasPriceError(e.gasPrice);
                    if ("0x0" === e.type || "0x1" === e.type) throw new i.UnsupportedFeeMarketError({
                        maxFeePerGas: e.maxFeePerGas,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas
                    });
                    if ((0, o.isNullish)(e.maxFeePerGas) || !(0, o.isUInt)(e.maxFeePerGas) || (0, o.isNullish)(e.maxPriorityFeePerGas) || !(0, o.isUInt)(e.maxPriorityFeePerGas)) throw new i.InvalidMaxPriorityFeePerGasOrMaxFeePerGas({
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                        maxFeePerGas: e.maxFeePerGas
                    });
                }, t.validateGas = (e)=>{
                    const r = !(0, o.isNullish)(e.gas) || !(0, o.isNullish)(e.gasLimit), n = r && !(0, o.isNullish)(e.gasPrice), s = r && !(0, o.isNullish)(e.maxPriorityFeePerGas) && !(0, o.isNullish)(e.maxFeePerGas);
                    if (!n && !s) throw new i.MissingGasError({
                        gas: e.gas,
                        gasPrice: e.gasPrice,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                        maxFeePerGas: e.maxFeePerGas
                    });
                    if (n && s) throw new i.TransactionGasMismatchError({
                        gas: e.gas,
                        gasPrice: e.gasPrice,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                        maxFeePerGas: e.maxFeePerGas
                    });
                    (n ? t.validateLegacyGas : t.validateFeeMarketGas)(e), (!(0, o.isNullish)(e.type) && e.type > "0x1" ? t.validateFeeMarketGas : t.validateLegacyGas)(e);
                }, t.validateTransactionForSigning = (e, r)=>{
                    if (!(0, o.isNullish)(r)) return void r(e);
                    if ("object" != typeof e || (0, o.isNullish)(e)) throw new i.InvalidTransactionObjectError(e);
                    (0, t.validateCustomChainInfo)(e), (0, t.validateChainInfo)(e), (0, t.validateBaseChain)(e), (0, t.validateHardfork)(e);
                    const a = (0, s.formatTransaction)(e, n.ETH_DATA_FORMAT);
                    if ((0, t.validateGas)(a), (0, o.isNullish)(a.nonce) || (0, o.isNullish)(a.chainId) || a.nonce.startsWith("-") || a.chainId.startsWith("-")) throw new i.InvalidNonceOrChainIdError({
                        nonce: e.nonce,
                        chainId: e.chainId
                    });
                };
            },
            1435: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Eth = t.registeredSubscriptions = void 0;
                const a = r(9970), c = r(6527), u = r(5071), d = r(9634), l = r(1181), h = i(r(3222)), f = r(7460);
                t.registeredSubscriptions = {
                    logs: f.LogsSubscription,
                    newPendingTransactions: f.NewPendingTransactionsSubscription,
                    newHeads: f.NewHeadsSubscription,
                    syncing: f.SyncingSubscription,
                    pendingTransactions: f.NewPendingTransactionsSubscription,
                    newBlockHeaders: f.NewHeadsSubscription
                };
                class p extends c.Web3Context {
                    constructor(e){
                        "string" == typeof e || (0, c.isSupportedProvider)(e) ? super({
                            provider: e,
                            registeredSubscriptions: t.registeredSubscriptions
                        }) : e.registeredSubscriptions ? super(e) : (super(Object.assign(Object.assign({}, e), {
                            registeredSubscriptions: t.registeredSubscriptions
                        })), this.getFeeData = this.calculateFeeData);
                    }
                    setTransactionMiddleware(e) {
                        this.transactionMiddleware = e;
                    }
                    getTransactionMiddleware() {
                        return this.transactionMiddleware;
                    }
                    getProtocolVersion() {
                        return s(this, void 0, void 0, function*() {
                            return l.ethRpcMethods.getProtocolVersion(this.requestManager);
                        });
                    }
                    isSyncing() {
                        return s(this, void 0, void 0, function*() {
                            return l.ethRpcMethods.getSyncing(this.requestManager);
                        });
                    }
                    getCoinbase() {
                        return s(this, void 0, void 0, function*() {
                            return l.ethRpcMethods.getCoinbase(this.requestManager);
                        });
                    }
                    isMining() {
                        return s(this, void 0, void 0, function*() {
                            return l.ethRpcMethods.getMining(this.requestManager);
                        });
                    }
                    getHashrate(e) {
                        var t;
                        return void 0 === e && (e = null !== (t = this.defaultReturnFormat) && void 0 !== t ? t : a.DEFAULT_RETURN_FORMAT), s(this, void 0, void 0, function*() {
                            return this.getHashRate(e);
                        });
                    }
                    getHashRate(e = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getHashRate(this, e);
                        });
                    }
                    getGasPrice(e = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getGasPrice(this, e);
                        });
                    }
                    getMaxPriorityFeePerGas(e = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getMaxPriorityFeePerGas(this, e);
                        });
                    }
                    calculateFeeData(e = BigInt(2), t = d.ethUnitMap.Gwei) {
                        var r;
                        return s(this, void 0, void 0, function*() {
                            const n = yield this.getBlock(void 0, !1), o = null !== (r = null == n ? void 0 : n.baseFeePerGas) && void 0 !== r ? r : void 0;
                            let i, s, a;
                            try {
                                i = yield this.getGasPrice();
                            } catch (e) {}
                            try {
                                s = yield this.getMaxPriorityFeePerGas();
                            } catch (e) {}
                            return o && (s = null != s ? s : t, a = o * e + s), {
                                gasPrice: i,
                                maxFeePerGas: a,
                                maxPriorityFeePerGas: s,
                                baseFeePerGas: o
                            };
                        });
                    }
                    getAccounts() {
                        var e;
                        return s(this, void 0, void 0, function*() {
                            return (null !== (e = yield l.ethRpcMethods.getAccounts(this.requestManager)) && void 0 !== e ? e : []).map((e)=>(0, d.toChecksumAddress)(e));
                        });
                    }
                    getBlockNumber(e = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlockNumber(this, e);
                        });
                    }
                    getBalance(e, t = this.defaultBlock, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBalance(this, e, t, r);
                        });
                    }
                    getStorageAt(e, t, r = this.defaultBlock, n = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getStorageAt(this, e, t, r, n);
                        });
                    }
                    getCode(e, t = this.defaultBlock, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getCode(this, e, t, r);
                        });
                    }
                    getBlock(e = this.defaultBlock, t = !1, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlock(this, e, t, r);
                        });
                    }
                    getBlockTransactionCount(e = this.defaultBlock, t = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlockTransactionCount(this, e, t);
                        });
                    }
                    getBlockUncleCount(e = this.defaultBlock, t = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlockUncleCount(this, e, t);
                        });
                    }
                    getUncle(e = this.defaultBlock, t, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getUncle(this, e, t, r);
                        });
                    }
                    getTransaction(e, t = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            const r = yield h.getTransaction(this, e, t);
                            if (!r) throw new u.TransactionNotFound;
                            return r;
                        });
                    }
                    getPendingTransactions(e = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getPendingTransactions(this, e);
                        });
                    }
                    getTransactionFromBlock(e = this.defaultBlock, t, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getTransactionFromBlock(this, e, t, r);
                        });
                    }
                    getTransactionReceipt(e, t = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            const r = yield h.getTransactionReceipt(this, e, t);
                            if (!r) throw new u.TransactionNotFound;
                            return r;
                        });
                    }
                    getTransactionCount(e, t = this.defaultBlock, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getTransactionCount(this, e, t, r);
                        });
                    }
                    sendTransaction(e, t = this.defaultReturnFormat, r) {
                        return h.sendTransaction(this, e, t, r, this.transactionMiddleware);
                    }
                    sendSignedTransaction(e, t = this.defaultReturnFormat, r) {
                        return h.sendSignedTransaction(this, e, t, r);
                    }
                    sign(e, t, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.sign(this, e, t, r);
                        });
                    }
                    signTransaction(e, t = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.signTransaction(this, e, t);
                        });
                    }
                    call(e, t = this.defaultBlock, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.call(this, e, t, r);
                        });
                    }
                    estimateGas(e, t = this.defaultBlock, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.estimateGas(this, e, t, r);
                        });
                    }
                    getPastLogs(e, t = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getLogs(this, e, t);
                        });
                    }
                    getWork() {
                        return s(this, void 0, void 0, function*() {
                            return l.ethRpcMethods.getWork(this.requestManager);
                        });
                    }
                    submitWork(e, t, r) {
                        return s(this, void 0, void 0, function*() {
                            return l.ethRpcMethods.submitWork(this.requestManager, e, t, r);
                        });
                    }
                    requestAccounts() {
                        return s(this, void 0, void 0, function*() {
                            return l.ethRpcMethods.requestAccounts(this.requestManager);
                        });
                    }
                    getChainId(e = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getChainId(this, e);
                        });
                    }
                    getNodeInfo() {
                        return s(this, void 0, void 0, function*() {
                            return l.ethRpcMethods.getNodeInfo(this.requestManager);
                        });
                    }
                    getProof(e, t, r = this.defaultBlock, n = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getProof(this, e, t, r, n);
                        });
                    }
                    getFeeHistory(e, t = this.defaultBlock, r, n = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.getFeeHistory(this, e, t, r, n);
                        });
                    }
                    createAccessList(e, t = this.defaultBlock, r = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return h.createAccessList(this, e, t, r);
                        });
                    }
                    signTypedData(e, t, r, n) {
                        var o;
                        return void 0 === r && (r = !1), void 0 === n && (n = null !== (o = this.defaultReturnFormat) && void 0 !== o ? o : a.DEFAULT_RETURN_FORMAT), s(this, void 0, void 0, function*() {
                            return h.signTypedData(this, e, t, r, n);
                        });
                    }
                    subscribe(e, t, r) {
                        var n, o;
                        return void 0 === r && (r = null !== (n = this.defaultReturnFormat) && void 0 !== n ? n : a.DEFAULT_RETURN_FORMAT), s(this, void 0, void 0, function*() {
                            const n = yield null === (o = this.subscriptionManager) || void 0 === o ? void 0 : o.subscribe(e, t, r);
                            return n instanceof f.LogsSubscription && "logs" === e && "object" == typeof t && !(0, d.isNullish)(t.fromBlock) && Number.isFinite(Number(t.fromBlock)) && setImmediate(()=>{
                                this.getPastLogs(t).then((e)=>{
                                    for (const t of e)n._processSubscriptionResult(t);
                                }).catch((e)=>{
                                    n._processSubscriptionError(e);
                                });
                            }), n;
                        });
                    }
                    static shouldClearSubscription({ sub: e }) {
                        return !(e instanceof f.SyncingSubscription);
                    }
                    clearSubscriptions(e = !1) {
                        var t;
                        return null === (t = this.subscriptionManager) || void 0 === t ? void 0 : t.unsubscribe(e ? p.shouldClearSubscription : void 0);
                    }
                }
                t.Web3Eth = p;
            },
            7460: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SyncingSubscription = t.NewHeadsSubscription = t.NewPendingTransactionsSubscription = t.LogsSubscription = void 0;
                const n = r(9634), o = r(6527), i = r(1922);
                class s extends o.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "logs",
                            this.args
                        ];
                    }
                    formatSubscriptionResult(e) {
                        return (0, n.format)(i.logSchema, e, super.returnFormat);
                    }
                }
                t.LogsSubscription = s;
                class a extends o.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "newPendingTransactions"
                        ];
                    }
                    formatSubscriptionResult(e) {
                        return (0, n.format)({
                            format: "string"
                        }, e, super.returnFormat);
                    }
                }
                t.NewPendingTransactionsSubscription = a;
                class c extends o.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "newHeads"
                        ];
                    }
                    formatSubscriptionResult(e) {
                        return (0, n.format)(i.blockHeaderSchema, e, super.returnFormat);
                    }
                }
                t.NewHeadsSubscription = c;
                class u extends o.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "syncing"
                        ];
                    }
                    _processSubscriptionResult(e) {
                        if ("boolean" == typeof e) this.emit("changed", e);
                        else {
                            const t = Object.fromEntries(Object.entries(e.status).map(([e, t])=>[
                                    e.charAt(0).toLowerCase() + e.substring(1),
                                    t
                                ]));
                            this.emit("changed", e.syncing), this.emit("data", (0, n.format)(i.syncSchema, t, super.returnFormat));
                        }
                    }
                }
                t.SyncingSubscription = u;
            },
            9820: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const i = r(2491);
                o(r(2491), t), o(r(7961), t), t.default = i.Net;
            },
            2491: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Net = void 0;
                const a = r(6527), c = i(r(7961));
                class u extends a.Web3Context {
                    getId(e = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return c.getId(this, e);
                        });
                    }
                    getPeerCount(e = this.defaultReturnFormat) {
                        return s(this, void 0, void 0, function*() {
                            return c.getPeerCount(this, e);
                        });
                    }
                    isListening() {
                        return s(this, void 0, void 0, function*() {
                            return c.isListening(this);
                        });
                    }
                }
                t.Net = u;
            },
            7961: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isListening = t.getPeerCount = t.getId = void 0;
                const o = r(9634), i = r(1181);
                t.getId = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield i.netRpcMethods.getId(e.requestManager);
                        return (0, o.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getPeerCount = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield i.netRpcMethods.getPeerCount(e.requestManager);
                        return (0, o.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.isListening = (e)=>n(void 0, void 0, void 0, function*() {
                        return i.netRpcMethods.isListening(e.requestManager);
                    });
            },
            2636: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                }, o = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.HttpProvider = void 0;
                const i = o(r(6279)), s = r(9970), a = r(5071);
                class c extends s.Web3BaseProvider {
                    constructor(e, t){
                        if (super(), !c.validateClientUrl(e)) throw new a.InvalidClientError(e);
                        this.clientUrl = e, this.httpProviderOptions = t;
                    }
                    static validateClientUrl(e) {
                        return "string" == typeof e && /^http(s)?:\/\//i.test(e);
                    }
                    getStatus() {
                        throw new a.MethodNotImplementedError;
                    }
                    supportsSubscriptions() {
                        return !1;
                    }
                    request(e, t) {
                        var r;
                        return n(this, void 0, void 0, function*() {
                            const n = Object.assign(Object.assign({}, null === (r = this.httpProviderOptions) || void 0 === r ? void 0 : r.providerOptions), t), o = yield (0, i.default)(this.clientUrl, Object.assign(Object.assign({}, n), {
                                method: "POST",
                                headers: Object.assign(Object.assign({}, n.headers), {
                                    "Content-Type": "application/json"
                                }),
                                body: JSON.stringify(e)
                            }));
                            if (!o.ok) throw new a.ResponseError((yield o.json()));
                            return yield o.json();
                        });
                    }
                    on() {
                        throw new a.MethodNotImplementedError;
                    }
                    removeListener() {
                        throw new a.MethodNotImplementedError;
                    }
                    once() {
                        throw new a.MethodNotImplementedError;
                    }
                    removeAllListeners() {
                        throw new a.MethodNotImplementedError;
                    }
                    connect() {
                        throw new a.MethodNotImplementedError;
                    }
                    disconnect() {
                        throw new a.MethodNotImplementedError;
                    }
                    reset() {
                        throw new a.MethodNotImplementedError;
                    }
                    reconnect() {
                        throw new a.MethodNotImplementedError;
                    }
                }
                t.default = c, t.HttpProvider = c;
            },
            1161: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.WebSocketProvider = void 0;
                const o = n(r(7475)), i = r(9634), s = r(5071);
                class a extends i.SocketProvider {
                    constructor(e, t, r){
                        super(e, t, r);
                    }
                    _validateProviderPath(e) {
                        return "string" == typeof e && /^ws(s)?:\/\//i.test(e);
                    }
                    getStatus() {
                        if (this._socketConnection && !(0, i.isNullish)(this._socketConnection)) switch(this._socketConnection.readyState){
                            case this._socketConnection.CONNECTING:
                                return "connecting";
                            case this._socketConnection.OPEN:
                                return "connected";
                            default:
                                return "disconnected";
                        }
                        return "disconnected";
                    }
                    _openSocketConnection() {
                        this._socketConnection = new o.default(this._socketPath, void 0, this._socketOptions && 0 === Object.keys(this._socketOptions).length ? void 0 : this._socketOptions);
                    }
                    _closeSocketConnection(e, t) {
                        var r;
                        null === (r = this._socketConnection) || void 0 === r || r.close(e, t);
                    }
                    _sendToSocket(e) {
                        var t;
                        if ("disconnected" === this.getStatus()) throw new s.ConnectionNotOpenError;
                        null === (t = this._socketConnection) || void 0 === t || t.send(JSON.stringify(e));
                    }
                    _parseResponses(e) {
                        return this.chunkResponseParser.parseResponse(e.data);
                    }
                    _addSocketListeners() {
                        var e, t, r, n;
                        null === (e = this._socketConnection) || void 0 === e || e.addEventListener("open", this._onOpenHandler), null === (t = this._socketConnection) || void 0 === t || t.addEventListener("message", this._onMessageHandler), null === (r = this._socketConnection) || void 0 === r || r.addEventListener("close", (e)=>this._onCloseHandler(e)), null === (n = this._socketConnection) || void 0 === n || n.addEventListener("error", this._onErrorHandler);
                    }
                    _removeSocketListeners() {
                        var e, t, r;
                        null === (e = this._socketConnection) || void 0 === e || e.removeEventListener("message", this._onMessageHandler), null === (t = this._socketConnection) || void 0 === t || t.removeEventListener("open", this._onOpenHandler), null === (r = this._socketConnection) || void 0 === r || r.removeEventListener("close", this._onCloseHandler);
                    }
                    _onCloseEvent(e) {
                        var t;
                        !this._reconnectOptions.autoReconnect || [
                            1e3,
                            1001
                        ].includes(e.code) && e.wasClean ? (this._clearQueues(e), this._removeSocketListeners(), this._onDisconnect(e.code, e.reason), null === (t = this._socketConnection) || void 0 === t || t.removeEventListener("error", this._onErrorHandler)) : this._reconnect();
                    }
                }
                t.default = a, t.WebSocketProvider = a;
            },
            9298: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getProof = t.getChainId = t.requestAccounts = t.getPendingTransactions = t.getFeeHistory = t.submitHashrate = t.submitWork = t.getWork = t.getLogs = t.getFilterLogs = t.getFilterChanges = t.uninstallFilter = t.newPendingTransactionFilter = t.newBlockFilter = t.newFilter = t.compileSerpent = t.compileLLL = t.compileSolidity = t.getCompilers = t.getUncleByBlockNumberAndIndex = t.getUncleByBlockHashAndIndex = t.getTransactionReceipt = t.getTransactionByBlockNumberAndIndex = t.getTransactionByBlockHashAndIndex = t.getTransactionByHash = t.getBlockByNumber = t.getBlockByHash = t.estimateGas = t.call = t.sendRawTransaction = t.sendTransaction = t.signTransaction = t.sign = t.getCode = t.getUncleCountByBlockNumber = t.getUncleCountByBlockHash = t.getBlockTransactionCountByNumber = t.getBlockTransactionCountByHash = t.getTransactionCount = t.getStorageAt = t.getBalance = t.getBlockNumber = t.getAccounts = t.getMaxPriorityFeePerGas = t.getGasPrice = t.getHashRate = t.getMining = t.getCoinbase = t.getSyncing = t.getProtocolVersion = void 0, t.signTypedData = t.createAccessList = t.getNodeInfo = void 0;
                const o = r(7345);
                t.getProtocolVersion = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_protocolVersion",
                            params: []
                        });
                    });
                }, t.getSyncing = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_syncing",
                            params: []
                        });
                    });
                }, t.getCoinbase = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_coinbase",
                            params: []
                        });
                    });
                }, t.getMining = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_mining",
                            params: []
                        });
                    });
                }, t.getHashRate = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_hashrate",
                            params: []
                        });
                    });
                }, t.getGasPrice = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_gasPrice",
                            params: []
                        });
                    });
                }, t.getMaxPriorityFeePerGas = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_maxPriorityFeePerGas",
                            params: []
                        });
                    });
                }, t.getAccounts = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_accounts",
                            params: []
                        });
                    });
                }, t.getBlockNumber = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_blockNumber",
                            params: []
                        });
                    });
                }, t.getBalance = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "address",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getBalance",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getStorageAt = function(e, t, r, i) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "address",
                            "hex",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r,
                            i
                        ]), e.send({
                            method: "eth_getStorageAt",
                            params: [
                                t,
                                r,
                                i
                            ]
                        });
                    });
                }, t.getTransactionCount = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "address",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getTransactionCount",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getBlockTransactionCountByHash = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getBlockTransactionCountByHash",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getBlockTransactionCountByNumber = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getBlockTransactionCountByNumber",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getUncleCountByBlockHash = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getUncleCountByBlockHash",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getUncleCountByBlockNumber = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getUncleCountByBlockNumber",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getCode = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "address",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getCode",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.sign = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "address",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_sign",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.signTransaction = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_signTransaction",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.sendTransaction = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_sendTransaction",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.sendRawTransaction = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_sendRawTransaction",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.call = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            r
                        ]), e.send({
                            method: "eth_call",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.estimateGas = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            r
                        ]), e.send({
                            method: "eth_estimateGas",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getBlockByHash = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "bytes32",
                            "bool"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getBlockByHash",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getBlockByNumber = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "blockNumberOrTag",
                            "bool"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getBlockByNumber",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getTransactionByHash = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getTransactionByHash",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getTransactionByBlockHashAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "bytes32",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getTransactionByBlockHashAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getTransactionByBlockNumberAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "blockNumberOrTag",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getTransactionByBlockNumberAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getTransactionReceipt = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getTransactionReceipt",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getUncleByBlockHashAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "bytes32",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getUncleByBlockHashAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getUncleByBlockNumberAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "blockNumberOrTag",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getUncleByBlockNumberAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getCompilers = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_getCompilers",
                            params: []
                        });
                    });
                }, t.compileSolidity = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "string"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_compileSolidity",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.compileLLL = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "string"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_compileLLL",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.compileSerpent = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "string"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_compileSerpent",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.newFilter = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "filter"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_newFilter",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.newBlockFilter = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_newBlockFilter",
                            params: []
                        });
                    });
                }, t.newPendingTransactionFilter = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_newPendingTransactionFilter",
                            params: []
                        });
                    });
                }, t.uninstallFilter = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_uninstallFilter",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getFilterChanges = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getFilterChanges",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getFilterLogs = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getFilterLogs",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getLogs = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "filter"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getLogs",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getWork = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_getWork",
                            params: []
                        });
                    });
                }, t.submitWork = function(e, t, r, i) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "bytes8",
                            "bytes32",
                            "bytes32"
                        ], [
                            t,
                            r,
                            i
                        ]), e.send({
                            method: "eth_submitWork",
                            params: [
                                t,
                                r,
                                i
                            ]
                        });
                    });
                }, t.submitHashrate = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "bytes32",
                            "bytes32"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_submitHashrate",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getFeeHistory = function(e, t, r, i) {
                    return n(this, void 0, void 0, function*() {
                        o.validator.validate([
                            "hex",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]);
                        for (const e of i)o.validator.validate([
                            "number"
                        ], [
                            e
                        ]);
                        return e.send({
                            method: "eth_feeHistory",
                            params: [
                                t,
                                r,
                                i
                            ]
                        });
                    });
                }, t.getPendingTransactions = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_pendingTransactions",
                            params: []
                        });
                    });
                }, t.requestAccounts = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_requestAccounts",
                            params: []
                        });
                    });
                }, t.getChainId = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_chainId",
                            params: []
                        });
                    });
                }, t.getProof = function(e, t, r, i) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "address",
                            "bytes32[]",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r,
                            i
                        ]), e.send({
                            method: "eth_getProof",
                            params: [
                                t,
                                r,
                                i
                            ]
                        });
                    });
                }, t.getNodeInfo = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "web3_clientVersion",
                            params: []
                        });
                    });
                }, t.createAccessList = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            r
                        ]), e.send({
                            method: "eth_createAccessList",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.signTypedData = function(e, t, r, i = !1) {
                    return n(this, void 0, void 0, function*() {
                        return o.validator.validate([
                            "address"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_signTypedData" + (i ? "" : "_v4"),
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                };
            },
            1181: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.personalRpcMethods = t.netRpcMethods = t.ethRpcMethods = void 0;
                const s = i(r(9298));
                t.ethRpcMethods = s;
                const a = i(r(9960));
                t.netRpcMethods = a;
                const c = i(r(6745));
                t.personalRpcMethods = c;
            },
            9960: function(e, t) {
                "use strict";
                var r = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isListening = t.getPeerCount = t.getId = void 0, t.getId = function(e) {
                    return r(this, void 0, void 0, function*() {
                        return e.send({
                            method: "net_version",
                            params: []
                        });
                    });
                }, t.getPeerCount = function(e) {
                    return r(this, void 0, void 0, function*() {
                        return e.send({
                            method: "net_peerCount",
                            params: []
                        });
                    });
                }, t.isListening = function(e) {
                    return r(this, void 0, void 0, function*() {
                        return e.send({
                            method: "net_listening",
                            params: []
                        });
                    });
                };
            },
            6745: function(e, t) {
                "use strict";
                var r = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ecRecover = t.sign = t.signTransaction = t.sendTransaction = t.importRawKey = t.lockAccount = t.unlockAccount = t.newAccount = t.getAccounts = void 0, t.getAccounts = (e)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_listAccounts",
                            params: []
                        });
                    }), t.newAccount = (e, t)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_newAccount",
                            params: [
                                t
                            ]
                        });
                    }), t.unlockAccount = (e, t, n, o)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_unlockAccount",
                            params: [
                                t,
                                n,
                                o
                            ]
                        });
                    }), t.lockAccount = (e, t)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_lockAccount",
                            params: [
                                t
                            ]
                        });
                    }), t.importRawKey = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_importRawKey",
                            params: [
                                t,
                                n
                            ]
                        });
                    }), t.sendTransaction = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_sendTransaction",
                            params: [
                                t,
                                n
                            ]
                        });
                    }), t.signTransaction = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_signTransaction",
                            params: [
                                t,
                                n
                            ]
                        });
                    }), t.sign = (e, t, n, o)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_sign",
                            params: [
                                t,
                                n,
                                o
                            ]
                        });
                    }), t.ecRecover = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_ecRecover",
                            params: [
                                t,
                                n
                            ]
                        });
                    });
            },
            294: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mainnet = void 0;
                const i = r(8590);
                o(r(4740), t), o(r(8590), t), o(r(7214), t), t.mainnet = new i.QuickNodeProvider;
            },
            4740: (e, t)=>{
                "use strict";
                var r, n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Network = t.Transport = void 0, (n = t.Transport || (t.Transport = {})).HTTPS = "https", n.WebSocket = "wss", (r = t.Network || (t.Network = {})).ETH_MAINNET = "eth_mainnet", r.ETH_GOERLI = "eth_goerli", r.ETH_SEPOLIA = "eth_sepolia", r.ETH_HOLESKY = "eth_holesky", r.POLYGON_MAINNET = "polygon_mainnet", r.POLYGON_MUMBAI = "polygon_mumbai", r.POLYGON_AMONY = "polygon_amony", r.ARBITRUM_MAINNET = "arbitrum_mainnet", r.ARBITRUM_SEPOLIA = "arbitrum_sepolia", r.BASE_MAINNET = "base_mainnet", r.BASE_SEPOLIA = "base_sepolia", r.OPTIMISM_MAINNET = "optimism_mainnet", r.OPTIMISM_SEPOLIA = "optimism_sepolia", r.BNB_MAINNET = "bnb_mainnet", r.BNB_TESTNET = "bnb_testnet";
            },
            7214: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                }, o = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3ExternalProvider = void 0;
                const i = o(r(2636)), s = o(r(1161)), a = r(9634), c = r(4740);
                class u extends a.Eip1193Provider {
                    constructor(e, t, r, n){
                        super(), this.transport = t, t === c.Transport.HTTPS ? this.provider = new i.default(this.getRPCURL(e, t, r, n)) : t === c.Transport.WebSocket && (this.provider = new s.default(this.getRPCURL(e, t, r, n)));
                    }
                    request(e, t) {
                        return n(this, void 0, void 0, function*() {
                            return this.transport === c.Transport.HTTPS ? this.provider.request(e, t) : this.provider.request(e);
                        });
                    }
                    getStatus() {
                        return this.provider.getStatus();
                    }
                    supportsSubscriptions() {
                        return this.provider.supportsSubscriptions();
                    }
                    once(e, t) {
                        var r;
                        (null === (r = this.provider) || void 0 === r ? void 0 : r.once) && this.provider.once(e, t);
                    }
                    removeAllListeners(e) {
                        var t;
                        (null === (t = this.provider) || void 0 === t ? void 0 : t.removeAllListeners) && this.provider.removeAllListeners(e);
                    }
                    connect() {
                        var e;
                        (null === (e = this.provider) || void 0 === e ? void 0 : e.connect) && this.provider.connect();
                    }
                    disconnect(e, t) {
                        var r;
                        (null === (r = this.provider) || void 0 === r ? void 0 : r.disconnect) && this.provider.disconnect(e, t);
                    }
                    reset() {
                        var e;
                        (null === (e = this.provider) || void 0 === e ? void 0 : e.reset) && this.provider.reset();
                    }
                    on(e, t) {
                        this.provider && this.provider.on(e, t);
                    }
                    removeListener(e, t) {
                        this.provider && this.provider.removeListener(e, t);
                    }
                }
                t.Web3ExternalProvider = u;
            },
            8590: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.QuickNodeProvider = void 0;
                const n = r(4740), o = r(7214), i = (e)=>void 0 !== e && e.trim().length > 0;
                class s extends o.Web3ExternalProvider {
                    constructor(e = n.Network.ETH_MAINNET, t = n.Transport.HTTPS, r = "", o = ""){
                        super(e, t, r, o);
                    }
                    getRPCURL(e, t, r, o) {
                        let s = "", a = "";
                        switch(e){
                            case n.Network.ETH_MAINNET:
                                s = i(o) ? o : "powerful-holy-bush.quiknode.pro", a = i(r) ? r : "3240624a343867035925ff7561eb60dfdba2a668";
                                break;
                            case n.Network.ETH_SEPOLIA:
                                s = i(o) ? o : "dimensional-fabled-glitter.ethereum-sepolia.quiknode.pro", a = i(r) ? r : "382a3b5a4b938f2d6e8686c19af4b22921fde2cd";
                                break;
                            case n.Network.ETH_HOLESKY:
                                s = i(o) ? o : "yolo-morning-card.ethereum-holesky.quiknode.pro", a = i(r) ? r : "481ebe70638c4dcf176af617a16d02ab866b9af9";
                                break;
                            case n.Network.ARBITRUM_MAINNET:
                                s = i(o) ? o : "autumn-divine-dinghy.arbitrum-mainnet.quiknode.pro", a = i(r) ? r : "a5d7bfbf60b5ae9ce3628e53d69ef50d529e9a8c";
                                break;
                            case n.Network.ARBITRUM_SEPOLIA:
                                s = i(o) ? o : "few-patient-pond.arbitrum-sepolia.quiknode.pro", a = i(r) ? r : "3be985450970628c860b959c65cd2642dcafe53c";
                                break;
                            case n.Network.BNB_MAINNET:
                                s = i(o) ? o : "purple-empty-reel.bsc.quiknode.pro", a = i(r) ? r : "ebf6c532961e21f092ff2facce1ec4c89c540158";
                                break;
                            case n.Network.BNB_TESTNET:
                                s = i(o) ? o : "floral-rough-scion.bsc-testnet.quiknode.pro", a = i(r) ? r : "5b297e5acff5f81f4c37ebf6f235f7299b6f9d28";
                                break;
                            case n.Network.POLYGON_MAINNET:
                                s = i(o) ? o : "small-chaotic-moon.matic.quiknode.pro", a = i(r) ? r : "847569f8a017e84d985e10d0f44365d965a951f1";
                                break;
                            case n.Network.POLYGON_AMONY:
                                s = i(o) ? o : "prettiest-side-shape.matic-amoy.quiknode.pro", a = i(r) ? r : "79a9476eea661d4f82de614db1d8a895b14b881c";
                                break;
                            default:
                                throw new Error("Network info not avalible.");
                        }
                        return `${t}://${s}/${a}`;
                    }
                }
                t.QuickNodeProvider = s;
            },
            6325: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5529: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            2453: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            2856: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            6877: (e, t)=>{
                "use strict";
                var r, n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ETH_DATA_FORMAT = t.DEFAULT_RETURN_FORMAT = t.FMT_BYTES = t.FMT_NUMBER = void 0, function(e) {
                    e.NUMBER = "NUMBER_NUMBER", e.HEX = "NUMBER_HEX", e.STR = "NUMBER_STR", e.BIGINT = "NUMBER_BIGINT";
                }(r = t.FMT_NUMBER || (t.FMT_NUMBER = {})), function(e) {
                    e.HEX = "BYTES_HEX", e.UINT8ARRAY = "BYTES_UINT8ARRAY";
                }(n = t.FMT_BYTES || (t.FMT_BYTES = {})), t.DEFAULT_RETURN_FORMAT = {
                    number: r.BIGINT,
                    bytes: n.HEX
                }, t.ETH_DATA_FORMAT = {
                    number: r.HEX,
                    bytes: n.HEX
                };
            },
            9779: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            1517: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8223: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            4205: (e, t)=>{
                "use strict";
                var r, n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.HardforksOrdered = t.BlockTags = void 0, (n = t.BlockTags || (t.BlockTags = {})).EARLIEST = "earliest", n.LATEST = "latest", n.PENDING = "pending", n.SAFE = "safe", n.FINALIZED = "finalized", (r = t.HardforksOrdered || (t.HardforksOrdered = {})).chainstart = "chainstart", r.frontier = "frontier", r.homestead = "homestead", r.dao = "dao", r.tangerineWhistle = "tangerineWhistle", r.spuriousDragon = "spuriousDragon", r.byzantium = "byzantium", r.constantinople = "constantinople", r.petersburg = "petersburg", r.istanbul = "istanbul", r.muirGlacier = "muirGlacier", r.berlin = "berlin", r.london = "london", r.altair = "altair", r.arrowGlacier = "arrowGlacier", r.grayGlacier = "grayGlacier", r.bellatrix = "bellatrix", r.merge = "merge", r.capella = "capella", r.shanghai = "shanghai";
            },
            9970: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(r(9779), t), o(r(6325), t), o(r(2453), t), o(r(2856), t), o(r(5529), t), o(r(6877), t), o(r(4205), t), o(r(1517), t), o(r(8223), t), o(r(2196), t), o(r(8887), t), o(r(8173), t), o(r(1040), t), o(r(5640), t), o(r(1436), t), o(r(4933), t);
            },
            2196: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8887: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TypedArray = void 0, t.TypedArray = Object.getPrototypeOf(Uint8Array);
            },
            8173: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            1040: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5640: function(e, t) {
                "use strict";
                var r = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3BaseProvider = void 0;
                const n = Symbol.for("web3/base-provider");
                class o {
                    static isWeb3Provider(e) {
                        return e instanceof o || Boolean(e && e[n]);
                    }
                    get [n]() {
                        return !0;
                    }
                    send(e, t) {
                        this.request(e).then((e)=>{
                            t(null, e);
                        }).catch((e)=>{
                            t(e);
                        });
                    }
                    sendAsync(e) {
                        return r(this, void 0, void 0, function*() {
                            return this.request(e);
                        });
                    }
                    asEIP1193Provider() {
                        const e = Object.create(this), t = e.request;
                        return e.request = function(e) {
                            return r(this, void 0, void 0, function*() {
                                return (yield t(e)).result;
                            });
                        }, e.asEIP1193Provider = void 0, e;
                    }
                }
                t.Web3BaseProvider = o;
            },
            1436: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3BaseWallet = void 0, t.Web3BaseWallet = class extends Array {
                    constructor(e){
                        super(), this._accountProvider = e;
                    }
                };
            },
            4933: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            4108: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ChunkResponseParser = void 0;
                const n = r(5071);
                t.ChunkResponseParser = class {
                    constructor(e, t){
                        this.eventEmitter = e, this.autoReconnect = t, this.chunkTimeout = 15e3;
                    }
                    clearQueues() {
                        "function" == typeof this._clearQueues && this._clearQueues();
                    }
                    onError(e) {
                        this._clearQueues = e;
                    }
                    parseResponse(e) {
                        const t = [];
                        return e.replace(/\}[\n\r]?\{/g, "}|--|{").replace(/\}\][\n\r]?\[\{/g, "}]|--|[{").replace(/\}[\n\r]?\[\{/g, "}|--|[{").replace(/\}\][\n\r]?\{/g, "}]|--|{").split("|--|").forEach((e)=>{
                            let r, o = e;
                            this.lastChunk && (o = this.lastChunk + o);
                            try {
                                r = JSON.parse(o);
                            } catch (e) {
                                return this.lastChunk = o, this.lastChunkTimeout && clearTimeout(this.lastChunkTimeout), void (this.lastChunkTimeout = setTimeout(()=>{
                                    this.autoReconnect || (this.clearQueues(), this.eventEmitter.emit("error", new n.InvalidResponseError({
                                        id: 1,
                                        jsonrpc: "2.0",
                                        error: {
                                            code: 2,
                                            message: "Chunk timeout"
                                        }
                                    })));
                                }, this.chunkTimeout));
                            }
                            clearTimeout(this.lastChunkTimeout), this.lastChunk = void 0, r && t.push(r);
                        }), t;
                    }
                };
            },
            7086: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toBool = t.toChecksumAddress = t.toWei = t.fromWei = t.toBigInt = t.toNumber = t.toHex = t.toAscii = t.hexToAscii = t.fromAscii = t.asciiToHex = t.hexToString = t.utf8ToBytes = t.toUtf8 = t.hexToUtf8 = t.stringToHex = t.fromUtf8 = t.utf8ToHex = t.hexToNumberString = t.fromDecimal = t.numberToHex = t.toDecimal = t.hexToNumber = t.hexToBytes = t.bytesToHex = t.bytesToUint8Array = t.ethUnitMap = void 0;
                const n = r(3687), o = r(5487), i = r(7345), s = r(5071), a = r(7541);
                t.ethUnitMap = {
                    noether: BigInt(0),
                    wei: BigInt(1),
                    kwei: BigInt(1e3),
                    Kwei: BigInt(1e3),
                    babbage: BigInt(1e3),
                    femtoether: BigInt(1e3),
                    mwei: BigInt(1e6),
                    Mwei: BigInt(1e6),
                    lovelace: BigInt(1e6),
                    picoether: BigInt(1e6),
                    gwei: BigInt(1e9),
                    Gwei: BigInt(1e9),
                    shannon: BigInt(1e9),
                    nanoether: BigInt(1e9),
                    nano: BigInt(1e9),
                    szabo: BigInt(1e12),
                    microether: BigInt(1e12),
                    micro: BigInt(1e12),
                    finney: BigInt(1e15),
                    milliether: BigInt(1e15),
                    milli: BigInt(1e15),
                    ether: BigInt("1000000000000000000"),
                    kether: BigInt("1000000000000000000000"),
                    grand: BigInt("1000000000000000000000"),
                    mether: BigInt("1000000000000000000000000"),
                    gether: BigInt("1000000000000000000000000000"),
                    tether: BigInt("1000000000000000000000000000000")
                };
                const c = "Warning: Using type `number` with values that are large or contain many decimals may cause loss of precision, it is recommended to use type `string` or `BigInt` when using conversion methods";
                t.bytesToUint8Array = (e)=>{
                    if (i.validator.validate([
                        "bytes"
                    ], [
                        e
                    ]), (0, a.isUint8Array)(e)) return e;
                    if (Array.isArray(e)) return new Uint8Array(e);
                    if ("string" == typeof e) return i.utils.hexToUint8Array(e);
                    throw new s.InvalidBytesError(e);
                };
                const { uint8ArrayToHexString: u } = i.utils;
                t.bytesToHex = (e)=>u((0, t.bytesToUint8Array)(e)), t.hexToBytes = (e)=>"string" == typeof e && "0x" !== e.slice(0, 2).toLowerCase() ? (0, t.bytesToUint8Array)(`0x${e}`) : (0, t.bytesToUint8Array)(e), t.hexToNumber = (e)=>(i.validator.validate([
                        "hex"
                    ], [
                        e
                    ]), i.utils.hexToNumber(e)), t.toDecimal = t.hexToNumber, t.numberToHex = (e, t)=>{
                    "bigint" != typeof e && i.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    let r = i.utils.numberToHex(e);
                    return t && (r.startsWith("-") || r.length % 2 != 1 ? r.length % 2 == 0 && r.startsWith("-") && (r = "-0x0".concat(r.slice(3))) : r = "0x0".concat(r.slice(2))), r;
                }, t.fromDecimal = t.numberToHex, t.hexToNumberString = (e)=>(0, t.hexToNumber)(e).toString(), t.utf8ToHex = (e)=>{
                    i.validator.validate([
                        "string"
                    ], [
                        e
                    ]);
                    let r = e.replace(/^(?:\u0000)/, "");
                    return r = r.replace(/(?:\u0000)$/, ""), (0, t.bytesToHex)((new TextEncoder).encode(r));
                }, t.fromUtf8 = t.utf8ToHex, t.stringToHex = t.utf8ToHex, t.hexToUtf8 = (e)=>(0, o.bytesToUtf8)((0, t.hexToBytes)(e)), t.toUtf8 = (e)=>"string" == typeof e ? (0, t.hexToUtf8)(e) : (i.validator.validate([
                        "bytes"
                    ], [
                        e
                    ]), (0, o.bytesToUtf8)(e)), t.utf8ToBytes = o.utf8ToBytes, t.hexToString = t.hexToUtf8, t.asciiToHex = (e)=>{
                    i.validator.validate([
                        "string"
                    ], [
                        e
                    ]);
                    let t = "";
                    for(let r = 0; r < e.length; r += 1){
                        const n = e.charCodeAt(r).toString(16);
                        t += n.length % 2 != 0 ? `0${n}` : n;
                    }
                    return `0x${t}`;
                }, t.fromAscii = t.asciiToHex, t.hexToAscii = (e)=>new TextDecoder("ascii").decode((0, t.hexToBytes)(e)), t.toAscii = t.hexToAscii, t.toHex = (e, r)=>{
                    if ("string" == typeof e && (0, i.isAddress)(e)) return r ? "address" : `0x${e.toLowerCase().replace(/^0x/i, "")}`;
                    if ("boolean" == typeof e) return r ? "bool" : e ? "0x01" : "0x00";
                    if ("number" == typeof e) return r ? e < 0 ? "int256" : "uint256" : (0, t.numberToHex)(e);
                    if ("bigint" == typeof e) return r ? "bigint" : (0, t.numberToHex)(e);
                    if ((0, a.isUint8Array)(e)) return r ? "bytes" : (0, t.bytesToHex)(e);
                    if ("object" == typeof e && e) return r ? "string" : (0, t.utf8ToHex)(JSON.stringify(e));
                    if ("string" == typeof e) {
                        if (e.startsWith("-0x") || e.startsWith("-0X")) return r ? "int256" : (0, t.numberToHex)(e);
                        if ((0, i.isHexStrict)(e)) return r ? "bytes" : e;
                        if ((0, i.isHex)(e) && !(0, i.isInt)(e) && !(0, i.isUInt)(e)) return r ? "bytes" : `0x${e}`;
                        if ((0, i.isHex)(e) && !(0, i.isInt)(e) && (0, i.isUInt)(e)) return r ? "uint" : (0, t.numberToHex)(e);
                        if (!Number.isFinite(e)) return r ? "string" : (0, t.utf8ToHex)(e);
                    }
                    throw new s.HexProcessingError(e);
                }, t.toNumber = (e)=>{
                    if ("number" == typeof e) return e > 1e20 ? (console.warn(c), BigInt(e)) : e;
                    if ("bigint" == typeof e) return e >= Number.MIN_SAFE_INTEGER && e <= Number.MAX_SAFE_INTEGER ? Number(e) : e;
                    if ("string" == typeof e && (0, i.isHexStrict)(e)) return (0, t.hexToNumber)(e);
                    try {
                        return (0, t.toNumber)(BigInt(e));
                    } catch (t) {
                        throw new s.InvalidNumberError(e);
                    }
                }, t.toBigInt = (e)=>{
                    if ("number" == typeof e) return BigInt(e);
                    if ("bigint" == typeof e) return e;
                    if ("string" == typeof e && (0, i.isHex)(e)) return e.startsWith("-") ? -BigInt(e.substring(1)) : BigInt(e);
                    throw new s.InvalidNumberError(e);
                }, t.fromWei = (e, r)=>{
                    let n;
                    if ("string" == typeof r) {
                        if (n = t.ethUnitMap[r], !n) throw new s.InvalidUnitError(r);
                    } else {
                        if (r < 0 || !Number.isInteger(r)) throw new s.InvalidIntegerError(r);
                        n = (0, i.bigintPower)(BigInt(10), BigInt(r));
                    }
                    const o = String((0, t.toNumber)(e)), a = n.toString().length - 1;
                    if (a <= 0) return o.toString();
                    const c = o.padStart(a, "0"), u = c.slice(0, -a), d = c.slice(-a).replace(/\.?0+$/, "");
                    return "" === u ? `0.${d}` : "" === d ? u : `${u}.${d}`.slice(0, u.length + a + 1);
                }, t.toWei = (e, r)=>{
                    let n;
                    if (i.validator.validate([
                        "number"
                    ], [
                        e
                    ]), "string" == typeof r) {
                        if (n = t.ethUnitMap[r], !n) throw new s.InvalidUnitError(r);
                    } else {
                        if (r < 0 || !Number.isInteger(r)) throw new s.InvalidIntegerError(r);
                        n = (0, i.bigintPower)(BigInt(10), BigInt(r));
                    }
                    let o = e;
                    "number" == typeof o && (o < 1e-15 && console.warn(c), o > 1e20 ? (console.warn(c), o = BigInt(o)) : o = o.toLocaleString("fullwide", {
                        useGrouping: !1,
                        maximumFractionDigits: 20
                    }));
                    const [a, u] = String("string" != typeof o || (0, i.isHexStrict)(o) ? (0, t.toNumber)(o) : o).split(".").concat(""), d = BigInt(`${a}${u}`) * n, l = u.length;
                    return 0 === l ? d.toString() : d.toString().slice(0, -l);
                }, t.toChecksumAddress = (e)=>{
                    if (!(0, i.isAddress)(e, !1)) throw new s.InvalidAddressError(e);
                    const r = e.toLowerCase().replace(/^0x/i, ""), o = i.utils.uint8ArrayToHexString((0, n.keccak256)(i.utils.ensureIfUint8Array((0, t.utf8ToBytes)(r))));
                    if ((0, i.isNullish)(o) || "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470" === o) return "";
                    let a = "0x";
                    const c = o.replace(/^0x/i, "");
                    for(let e = 0; e < r.length; e += 1)parseInt(c[e], 16) > 7 ? a += r[e].toUpperCase() : a += r[e];
                    return a;
                }, t.toBool = (e)=>{
                    if ("boolean" == typeof e) return e;
                    if ("number" == typeof e && (0 === e || 1 === e)) return Boolean(e);
                    if ("bigint" == typeof e && (e === BigInt(0) || e === BigInt(1))) return Boolean(e);
                    if ("string" == typeof e && !(0, i.isHexStrict)(e) && ("1" === e || "0" === e || "false" === e || "true" === e)) return "true" === e || "false" !== e && Boolean(Number(e));
                    if ("string" == typeof e && (0, i.isHexStrict)(e) && ("0x1" === e || "0x0" === e)) return Boolean((0, t.toNumber)(e));
                    throw new s.InvalidBooleanError(e);
                };
            },
            8512: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EventEmitter = void 0;
                const o = n(r(9386));
                class i extends o.default {
                    constructor(){
                        super(...arguments), this.maxListeners = Number.MAX_SAFE_INTEGER;
                    }
                    setMaxListeners(e) {
                        return this.maxListeners = e, this;
                    }
                    getMaxListeners() {
                        return this.maxListeners;
                    }
                }
                t.EventEmitter = i;
            },
            3065: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.format = t.convert = t.convertScalarValue = t.isDataFormat = void 0;
                const n = r(5071), o = r(9970), i = r(7345), s = r(7086), a = r(7151), c = r(2557), u = r(7541), { parseBaseType: d } = i.utils;
                t.isDataFormat = (e)=>"object" == typeof e && !(0, i.isNullish)(e) && "number" in e && "bytes" in e;
                const l = (e, t, r = [])=>{
                    let n, o = Object.assign({}, e);
                    for (const e of t){
                        if (o.oneOf && n) {
                            const e = n, t = r.find(([t])=>t === e);
                            t && t[0] === n && (o = o.oneOf[t[1]]);
                        }
                        if (!o.properties && !o.items) return;
                        o.properties ? o = o.properties[e] : o.items && o.items.properties ? o = o.items.properties[e] : o.items && (0, i.isObject)(o.items) ? o = o.items : o.items && Array.isArray(o.items) && (o = o.items[parseInt(e, 10)]), o && e && (n = e);
                    }
                    return o;
                };
                t.convertScalarValue = (e, t, r)=>{
                    try {
                        const { baseType: i, baseTypeSize: a } = d(t);
                        if ("int" === i || "uint" === i) switch(r.number){
                            case o.FMT_NUMBER.NUMBER:
                                return Number((0, s.toBigInt)(e));
                            case o.FMT_NUMBER.HEX:
                                return (0, s.numberToHex)((0, s.toBigInt)(e));
                            case o.FMT_NUMBER.STR:
                                return (0, s.toBigInt)(e).toString();
                            case o.FMT_NUMBER.BIGINT:
                                return (0, s.toBigInt)(e);
                            default:
                                throw new n.FormatterError(`Invalid format: ${String(r.number)}`);
                        }
                        if ("bytes" === i) {
                            let t;
                            switch(a ? "string" == typeof e ? t = (0, c.padLeft)(e, 2 * a) : (0, u.isUint8Array)(e) && (t = (0, u.uint8ArrayConcat)(new Uint8Array(a - e.length), e)) : t = e, r.bytes){
                                case o.FMT_BYTES.HEX:
                                    return (0, s.bytesToHex)((0, s.bytesToUint8Array)(t));
                                case o.FMT_BYTES.UINT8ARRAY:
                                    return (0, s.bytesToUint8Array)(t);
                                default:
                                    throw new n.FormatterError(`Invalid format: ${String(r.bytes)}`);
                            }
                        }
                    } catch (t) {
                        return e;
                    }
                    return e;
                };
                const h = ({ value: e, schemaProp: r, schema: n, object: o, key: s, dataPath: a, format: c, oneOfPath: u = [] })=>{
                    var d, l;
                    if (Array.isArray(e)) {
                        let h = r;
                        if (void 0 !== (null == r ? void 0 : r.oneOf) && r.oneOf.forEach((t, n)=>{
                            var o, i;
                            !Array.isArray(null == r ? void 0 : r.items) && ("object" == typeof e[0] && "object" === (null === (o = null == t ? void 0 : t.items) || void 0 === o ? void 0 : o.type) || "string" == typeof e[0] && "object" !== (null === (i = null == t ? void 0 : t.items) || void 0 === i ? void 0 : i.type)) && (h = t, u.push([
                                s,
                                n
                            ]));
                        }), (0, i.isNullish)(null == h ? void 0 : h.items)) return delete o[s], a.pop(), !0;
                        if ((0, i.isObject)(h.items) && !(0, i.isNullish)(h.items.format)) {
                            for(let r = 0; r < e.length; r += 1)o[s][r] = (0, t.convertScalarValue)(e[r], null === (d = null == h ? void 0 : h.items) || void 0 === d ? void 0 : d.format, c);
                            return a.pop(), !0;
                        }
                        if (!Array.isArray(null == h ? void 0 : h.items) && "object" === (null === (l = null == h ? void 0 : h.items) || void 0 === l ? void 0 : l.type)) {
                            for (const r of e)(0, t.convert)(r, n, a, c, u);
                            return a.pop(), !0;
                        }
                        if (Array.isArray(null == h ? void 0 : h.items)) {
                            for(let r = 0; r < e.length; r += 1)o[s][r] = (0, t.convertScalarValue)(e[r], h.items[r].format, c);
                            return a.pop(), !0;
                        }
                    }
                    return !1;
                };
                t.convert = (e, r, n, o, s = [])=>{
                    var a;
                    if (!(0, i.isObject)(e) && !Array.isArray(e)) return (0, t.convertScalarValue)(e, null == r ? void 0 : r.format, o);
                    const c = e;
                    if (Array.isArray(c) && "array" === (null == r ? void 0 : r.type) && "object" === (null === (a = null == r ? void 0 : r.items) || void 0 === a ? void 0 : a.type)) h({
                        value: c,
                        schemaProp: r,
                        schema: r,
                        object: c,
                        key: "",
                        dataPath: n,
                        format: o,
                        oneOfPath: s
                    });
                    else for (const [e, a] of Object.entries(c)){
                        n.push(e);
                        const u = l(r, n, s);
                        (0, i.isNullish)(u) ? (delete c[e], n.pop()) : (0, i.isObject)(a) ? ((0, t.convert)(a, r, n, o, s), n.pop()) : h({
                            value: a,
                            schemaProp: u,
                            schema: r,
                            object: c,
                            key: e,
                            dataPath: n,
                            format: o,
                            oneOfPath: s
                        }) || (c[e] = (0, t.convertScalarValue)(a, u.format, o), n.pop());
                    }
                    return c;
                }, t.format = (e, r, s = o.DEFAULT_RETURN_FORMAT)=>{
                    let c;
                    c = (0, i.isObject)(r) ? (0, a.mergeDeep)({}, r) : Array.isArray(r) ? [
                        ...r
                    ] : r;
                    const u = (0, i.isObject)(e) ? e : i.utils.ethAbiToJsonSchema(e);
                    if (!u.properties && !u.items && !u.format) throw new n.FormatterError("Invalid json schema for formatting");
                    return (0, t.convert)(c, u, [], s);
                };
            },
            3561: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getStorageSlotNumForLongString = t.soliditySha3Raw = t.soliditySha3 = t.encodePacked = t.processSolidityEncodePackedArgs = t.keccak256 = t.keccak256Wrapper = t.sha3Raw = t.sha3 = void 0;
                const n = r(3687), o = r(5487), i = r(5071), s = r(7345), a = r(7086), c = r(2557), u = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
                t.sha3 = (e)=>{
                    let t;
                    t = "string" == typeof e ? e.startsWith("0x") && (0, s.isHexStrict)(e) ? (0, a.hexToBytes)(e) : (0, o.utf8ToBytes)(e) : e;
                    const r = (0, a.bytesToHex)((0, n.keccak256)(s.utils.ensureIfUint8Array(t)));
                    return r === u ? void 0 : r;
                }, t.sha3Raw = (e)=>{
                    const r = (0, t.sha3)(e);
                    return (0, s.isNullish)(r) ? u : r;
                }, t.keccak256Wrapper = (e)=>{
                    let t;
                    return t = "bigint" == typeof e || "number" == typeof e ? (0, o.utf8ToBytes)(e.toString()) : Array.isArray(e) ? new Uint8Array(e) : "string" != typeof e || (0, s.isHexStrict)(e) ? (0, a.bytesToUint8Array)(e) : (0, o.utf8ToBytes)(e), (0, a.bytesToHex)((0, n.keccak256)(s.utils.ensureIfUint8Array(t)));
                }, t.keccak256 = t.keccak256Wrapper;
                const d = (e, t)=>{
                    const r = /^(\d+).*$/.exec(e.slice(t));
                    return r ? parseInt(r[1], 10) : 0;
                }, l = (e)=>e.toString(2).length, h = (e, t)=>{
                    const r = t.toString();
                    if ("string" === e) {
                        if ("string" == typeof t) return (0, a.utf8ToHex)(t);
                        throw new i.InvalidStringError(t);
                    }
                    if ("bool" === e || "boolean" === e) {
                        if ("boolean" == typeof t) return t ? "01" : "00";
                        throw new i.InvalidBooleanError(t);
                    }
                    if ("address" === e) {
                        if (!(0, s.isAddress)(r)) throw new i.InvalidAddressError(r);
                        return r;
                    }
                    const n = ((e)=>e.startsWith("int[") ? `int256${e.slice(3)}` : "int" === e ? "int256" : e.startsWith("uint[") ? `uint256'${e.slice(4)}` : "uint" === e ? "uint256" : e)(e);
                    if (e.startsWith("uint")) {
                        const e = d(n, 4);
                        if (e % 8 || e < 8 || e > 256) throw new i.InvalidSizeError(r);
                        const t = (0, a.toNumber)(r);
                        if (l(t) > e) throw new i.InvalidLargeValueError(r);
                        if (t < BigInt(0)) throw new i.InvalidUnsignedIntegerError(r);
                        return e ? (0, c.leftPad)(t.toString(16), e / 8 * 2) : t.toString(16);
                    }
                    if (e.startsWith("int")) {
                        const t = d(n, 3);
                        if (t % 8 || t < 8 || t > 256) throw new i.InvalidSizeError(e);
                        const o = (0, a.toNumber)(r);
                        if (l(o) > t) throw new i.InvalidLargeValueError(r);
                        return o < BigInt(0) ? (0, c.toTwosComplement)(o.toString(), t / 8 * 2) : t ? (0, c.leftPad)(o.toString(16), t / 4) : o.toString(16);
                    }
                    if ("bytes" === n) {
                        if (r.replace(/^0x/i, "").length % 2 != 0) throw new i.InvalidBytesError(r);
                        return r;
                    }
                    if (e.startsWith("bytes")) {
                        if (r.replace(/^0x/i, "").length % 2 != 0) throw new i.InvalidBytesError(r);
                        const t = d(e, 5);
                        if (!t || t < 1 || t > 64 || t < r.replace(/^0x/i, "").length / 2) throw new i.InvalidBytesError(r);
                        return (0, c.rightPad)(r, 2 * t);
                    }
                    return "";
                };
                t.processSolidityEncodePackedArgs = (e)=>{
                    const [t, r] = ((e)=>{
                        if (Array.isArray(e)) throw new Error("Autodetection of array types is not supported.");
                        let t, r;
                        if ("object" == typeof e && ("t" in e || "type" in e) && ("v" in e || "value" in e)) t = "t" in e ? e.t : e.type, r = "v" in e ? e.v : e.value, t = "bigint" === t.toLowerCase() ? "int" : t;
                        else {
                            if ("bigint" == typeof e) return [
                                "int",
                                e
                            ];
                            t = (0, a.toHex)(e, !0), r = (0, a.toHex)(e), t.startsWith("int") || t.startsWith("uint") || (t = "bytes");
                        }
                        return !t.startsWith("int") && !t.startsWith("uint") || "string" != typeof r || /^(-)?0x/i.test(r) || (r = (0, a.toBigInt)(r)), [
                            t,
                            r
                        ];
                    })(e);
                    return Array.isArray(r) ? r.map((e)=>h(t, e).replace("0x", "")).join("") : h(t, r).replace("0x", "");
                }, t.encodePacked = (...e)=>`0x${e.map(t.processSolidityEncodePackedArgs).join("").toLowerCase()}`, t.soliditySha3 = (...e)=>(0, t.sha3)((0, t.encodePacked)(...e)), t.soliditySha3Raw = (...e)=>(0, t.sha3Raw)((0, t.encodePacked)(...e)), t.getStorageSlotNumForLongString = (e)=>(0, t.sha3)(`0x${("number" == typeof e ? e.toString() : e).padStart(64, "0")}`);
            },
            9634: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }, s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.jsonRpc = void 0, i(r(7086), t), i(r(8512), t), i(r(4578), t), i(r(3065), t), i(r(3561), t), i(r(4822), t), i(r(2557), t), i(r(7151), t), i(r(3718), t), i(r(9250), t), t.jsonRpc = s(r(9250)), i(r(6982), t), i(r(4108), t), i(r(7717), t), i(r(997), t), i(r(222), t), i(r(7541), t);
            },
            9250: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBatchRequest = t.toBatchPayload = t.toPayload = t.setRequestIdStart = t.isBatchResponse = t.isValidResponse = t.validateResponse = t.isSubscriptionResult = t.isResponseWithNotification = t.isResponseWithError = t.isResponseWithResult = t.isResponseRpcError = void 0;
                const n = r(7345), o = r(5071), i = r(7717);
                let s;
                t.isResponseRpcError = (e)=>{
                    const t = e.error.code;
                    return o.rpcErrorsMap.has(t) || t >= -32099 && t <= -32000;
                }, t.isResponseWithResult = (e)=>!Array.isArray(e) && !!e && "2.0" === e.jsonrpc && "result" in e && (0, n.isNullish)(e.error) && ("number" == typeof e.id || "string" == typeof e.id), t.isResponseWithError = (e)=>!Array.isArray(e) && "2.0" === e.jsonrpc && !!e && (0, n.isNullish)(e.result) && "error" in e && ("number" == typeof e.id || "string" == typeof e.id), t.isResponseWithNotification = (e)=>!(Array.isArray(e) || !e || "2.0" !== e.jsonrpc || (0, n.isNullish)(e.params) || (0, n.isNullish)(e.method)), t.isSubscriptionResult = (e)=>!Array.isArray(e) && !!e && "2.0" === e.jsonrpc && "id" in e && "result" in e, t.validateResponse = (e)=>(0, t.isResponseWithResult)(e) || (0, t.isResponseWithError)(e), t.isValidResponse = (e)=>Array.isArray(e) ? e.every(t.validateResponse) : (0, t.validateResponse)(e), t.isBatchResponse = (e)=>Array.isArray(e) && e.length > 0 && (0, t.isValidResponse)(e), t.setRequestIdStart = (e)=>{
                    s = e;
                }, t.toPayload = (e)=>{
                    var t, r, n, o;
                    return void 0 !== s && (s += 1), {
                        jsonrpc: null !== (t = e.jsonrpc) && void 0 !== t ? t : "2.0",
                        id: null !== (n = null !== (r = e.id) && void 0 !== r ? r : s) && void 0 !== n ? n : (0, i.uuidV4)(),
                        method: e.method,
                        params: null !== (o = e.params) && void 0 !== o ? o : void 0
                    };
                }, t.toBatchPayload = (e)=>e.map((e)=>(0, t.toPayload)(e)), t.isBatchRequest = (e)=>Array.isArray(e) && e.length > 0;
            },
            7151: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mergeDeep = void 0;
                const n = r(9970), o = r(7345), i = (e)=>!("object" != typeof e || (0, o.isNullish)(e) || Array.isArray(e) || e instanceof n.TypedArray);
                t.mergeDeep = (e, ...r)=>{
                    if (!i(e)) return e;
                    const s = Object.assign({}, e);
                    for (const e of r)for(const r in e)i(e[r]) ? (s[r] || (s[r] = {}), s[r] = (0, t.mergeDeep)(s[r], e[r])) : !(0, o.isNullish)(e[r]) && Object.hasOwnProperty.call(e, r) && (Array.isArray(e[r]) || e[r] instanceof n.TypedArray ? s[r] = e[r].slice(0) : s[r] = e[r]);
                    return s;
                };
            },
            3718: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rejectIfConditionAtInterval = t.rejectIfTimeout = t.pollTillDefined = t.pollTillDefinedAndReturnIntervalId = t.waitWithTimeout = t.isPromise = void 0;
                const o = r(7345);
                function i(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        const o = yield Promise.race([
                            e instanceof Promise ? e : e(),
                            new Promise((e, o)=>{
                                n = setTimeout(()=>r ? o(r) : e(void 0), t);
                            })
                        ]);
                        if (n && clearTimeout(n), o instanceof Error) throw o;
                        return o;
                    });
                }
                function s(e, t) {
                    let r;
                    return [
                        new Promise((s, a)=>{
                            r = setInterval(function c() {
                                return (()=>{
                                    n(this, void 0, void 0, function*() {
                                        try {
                                            const n = yield i(e, t);
                                            (0, o.isNullish)(n) || (clearInterval(r), s(n));
                                        } catch (e) {
                                            clearInterval(r), a(e);
                                        }
                                    });
                                })(), c;
                            }(), t);
                        }),
                        r
                    ];
                }
                t.isPromise = function(e) {
                    return ("object" == typeof e || "function" == typeof e) && "function" == typeof e.then;
                }, t.waitWithTimeout = i, t.pollTillDefinedAndReturnIntervalId = s, t.pollTillDefined = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return s(e, t)[0];
                    });
                }, t.rejectIfTimeout = function(e, t) {
                    let r;
                    const n = new Promise((n, o)=>{
                        r = setTimeout(()=>{
                            o(t);
                        }, e);
                    });
                    return [
                        r,
                        n
                    ];
                }, t.rejectIfConditionAtInterval = function(e, t) {
                    let r;
                    const o = new Promise((o, i)=>{
                        r = setInterval(()=>{
                            (()=>{
                                n(this, void 0, void 0, function*() {
                                    const t = yield e();
                                    t && (clearInterval(r), i(t));
                                });
                            })();
                        }, t);
                    });
                    return [
                        r,
                        o
                    ];
                };
            },
            4822: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomHex = t.randomBytes = void 0;
                const n = r(1341), o = r(7086);
                t.randomBytes = (e)=>(0, n.getRandomBytesSync)(e), t.randomHex = (e)=>(0, o.bytesToHex)((0, t.randomBytes)(e));
            },
            222: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SocketProvider = void 0;
                const a = r(5071), c = r(997), u = r(4108), d = r(4578), l = r(6982), h = i(r(9250)), f = {
                    autoReconnect: !0,
                    delay: 5e3,
                    maxAttempts: 5
                };
                class p extends c.Eip1193Provider {
                    constructor(e, t, r){
                        if (super(), this._connectionStatus = "connecting", this._onMessageHandler = this._onMessage.bind(this), this._onOpenHandler = this._onConnect.bind(this), this._onCloseHandler = this._onCloseEvent.bind(this), this._onErrorHandler = this._onError.bind(this), !this._validateProviderPath(e)) throw new a.InvalidClientError(e);
                        this._socketPath = e, this._socketOptions = t, this._reconnectOptions = Object.assign(Object.assign({}, f), null != r ? r : {}), this._pendingRequestsQueue = new Map, this._sentRequestsQueue = new Map, this._init(), this.connect(), this.chunkResponseParser = new u.ChunkResponseParser(this._eventEmitter, this._reconnectOptions.autoReconnect), this.chunkResponseParser.onError(()=>{
                            this._clearQueues();
                        }), this.isReconnecting = !1;
                    }
                    get SocketConnection() {
                        return this._socketConnection;
                    }
                    _init() {
                        this._reconnectAttempts = 0;
                    }
                    connect() {
                        try {
                            this._openSocketConnection(), this._connectionStatus = "connecting", this._addSocketListeners();
                        } catch (e) {
                            if (!this.isReconnecting) throw this._connectionStatus = "disconnected", e && e.message ? new a.ConnectionError(`Error while connecting to ${this._socketPath}. Reason: ${e.message}`) : new a.InvalidClientError(this._socketPath);
                            setImmediate(()=>{
                                this._reconnect();
                            });
                        }
                    }
                    _validateProviderPath(e) {
                        return !!e;
                    }
                    getPendingRequestQueueSize() {
                        return this._pendingRequestsQueue.size;
                    }
                    getSentRequestsQueueSize() {
                        return this._sentRequestsQueue.size;
                    }
                    supportsSubscriptions() {
                        return !0;
                    }
                    on(e, t) {
                        this._eventEmitter.on(e, t);
                    }
                    once(e, t) {
                        this._eventEmitter.once(e, t);
                    }
                    removeListener(e, t) {
                        this._eventEmitter.removeListener(e, t);
                    }
                    _onDisconnect(e, t) {
                        this._connectionStatus = "disconnected", super._onDisconnect(e, t);
                    }
                    disconnect(e, t) {
                        const r = null != e ? e : 1e3;
                        this._removeSocketListeners(), "disconnected" !== this.getStatus() && this._closeSocketConnection(r, t), this._onDisconnect(r, t);
                    }
                    safeDisconnect(e, t, r = !1, n = 1e3) {
                        return s(this, void 0, void 0, function*() {
                            let o = 0;
                            yield (()=>s(this, void 0, void 0, function*() {
                                    return new Promise((e)=>{
                                        const t = setInterval(()=>{
                                            r && o >= 5 && this.clearQueues(), 0 === this.getPendingRequestQueueSize() && 0 === this.getSentRequestsQueueSize() && (clearInterval(t), e(!0)), o += 1;
                                        }, n);
                                    });
                                }))(), this.disconnect(e, t);
                        });
                    }
                    removeAllListeners(e) {
                        this._eventEmitter.removeAllListeners(e);
                    }
                    _onError(e) {
                        this.isReconnecting ? this._reconnect() : this._eventEmitter.emit("error", e);
                    }
                    reset() {
                        this._sentRequestsQueue.clear(), this._pendingRequestsQueue.clear(), this._init(), this._removeSocketListeners(), this._addSocketListeners();
                    }
                    _reconnect() {
                        this.isReconnecting || (this.isReconnecting = !0, this._sentRequestsQueue.size > 0 && this._sentRequestsQueue.forEach((e, t)=>{
                            e.deferredPromise.reject(new a.PendingRequestsOnReconnectingError), this._sentRequestsQueue.delete(t);
                        }), this._reconnectAttempts < this._reconnectOptions.maxAttempts ? (this._reconnectAttempts += 1, setTimeout(()=>{
                            this._removeSocketListeners(), this.connect(), this.isReconnecting = !1;
                        }, this._reconnectOptions.delay)) : (this.isReconnecting = !1, this._clearQueues(), this._removeSocketListeners(), this._eventEmitter.emit("error", new a.MaxAttemptsReachedOnReconnectingError(this._reconnectOptions.maxAttempts))));
                    }
                    request(e) {
                        return s(this, void 0, void 0, function*() {
                            if ((0, d.isNullish)(this._socketConnection)) throw new Error("Connection is undefined");
                            "disconnected" === this.getStatus() && this.connect();
                            const t = h.isBatchRequest(e) ? e[0].id : e.id;
                            if (!t) throw new a.Web3WSProviderError("Request Id not defined");
                            if (this._sentRequestsQueue.has(t)) throw new a.RequestAlreadySentError(t);
                            const r = new l.Web3DeferredPromise;
                            r.catch((e)=>{
                                this._eventEmitter.emit("error", e);
                            });
                            const n = {
                                payload: e,
                                deferredPromise: r
                            };
                            if ("connecting" === this.getStatus()) return this._pendingRequestsQueue.set(t, n), n.deferredPromise;
                            this._sentRequestsQueue.set(t, n);
                            try {
                                this._sendToSocket(n.payload);
                            } catch (e) {
                                this._sentRequestsQueue.delete(t), this._eventEmitter.emit("error", e);
                            }
                            return r;
                        });
                    }
                    _onConnect() {
                        this._connectionStatus = "connected", this._reconnectAttempts = 0, super._onConnect(), this._sendPendingRequests();
                    }
                    _sendPendingRequests() {
                        for (const [e, t] of this._pendingRequestsQueue.entries())this._sendToSocket(t.payload), this._pendingRequestsQueue.delete(e), this._sentRequestsQueue.set(e, t);
                    }
                    _onMessage(e) {
                        const t = this._parseResponses(e);
                        if (!(0, d.isNullish)(t) && 0 !== t.length) for (const e of t){
                            if (h.isResponseWithNotification(e) && e.method.endsWith("_subscription")) return void this._eventEmitter.emit("message", e);
                            const t = h.isBatchResponse(e) ? e[0].id : e.id, r = this._sentRequestsQueue.get(t);
                            if (!r) return;
                            (h.isBatchResponse(e) || h.isResponseWithResult(e) || h.isResponseWithError(e)) && (this._eventEmitter.emit("message", e), r.deferredPromise.resolve(e)), this._sentRequestsQueue.delete(t);
                        }
                    }
                    clearQueues(e) {
                        this._clearQueues(e);
                    }
                    _clearQueues(e) {
                        this._pendingRequestsQueue.size > 0 && this._pendingRequestsQueue.forEach((t, r)=>{
                            t.deferredPromise.reject(new a.ConnectionNotOpenError(e)), this._pendingRequestsQueue.delete(r);
                        }), this._sentRequestsQueue.size > 0 && this._sentRequestsQueue.forEach((t, r)=>{
                            t.deferredPromise.reject(new a.ConnectionNotOpenError(e)), this._sentRequestsQueue.delete(r);
                        }), this._removeSocketListeners();
                    }
                }
                t.SocketProvider = p;
            },
            2557: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.fromTwosComplement = t.toTwosComplement = t.leftPad = t.rightPad = t.padRight = t.padLeft = void 0;
                const n = r(5071), o = r(7345), i = r(7086);
                t.padLeft = (e, t, r = "0")=>"string" == typeof e ? (0, o.isHexStrict)(e) ? o.utils.padLeft(e, t, r) : e.padStart(t, r) : (o.validator.validate([
                        "int"
                    ], [
                        e
                    ]), o.utils.padLeft(e, t, r)), t.padRight = (e, t, r = "0")=>{
                    if ("string" == typeof e && !(0, o.isHexStrict)(e)) return e.padEnd(t, r);
                    o.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    const n = "string" == typeof e && (0, o.isHexStrict)(e) ? e : (0, i.numberToHex)(e), s = n.startsWith("-") ? 3 : 2;
                    return n.padEnd(t + s, r);
                }, t.rightPad = t.padRight, t.leftPad = t.padLeft, t.toTwosComplement = (e, r = 64)=>{
                    o.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    const s = (0, i.toNumber)(e);
                    if (s >= 0) return (0, t.padLeft)((0, i.toHex)(s), r);
                    const a = (0, o.bigintPower)(BigInt(2), BigInt(4 * r));
                    if (-s >= a) throw new n.NibbleWidthError(`value: ${e}, nibbleWidth: ${r}`);
                    const c = BigInt(s) + a;
                    return (0, t.padLeft)((0, i.numberToHex)(c), r);
                }, t.fromTwosComplement = (e, t = 64)=>{
                    o.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    const r = (0, i.toNumber)(e);
                    if (r < 0) return r;
                    const s = Math.ceil(Math.log(Number(r)) / Math.log(2));
                    if (s > 4 * t) throw new n.NibbleWidthError(`value: "${e}", nibbleWidth: "${t}"`);
                    if (4 * t !== s) return r;
                    const a = (0, o.bigintPower)(BigInt(2), BigInt(t) * BigInt(4));
                    return (0, i.toNumber)(BigInt(r) - a);
                };
            },
            7541: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.uint8ArrayEquals = t.uint8ArrayConcat = t.isUint8Array = void 0, t.isUint8Array = function(e) {
                    var t, r;
                    return e instanceof Uint8Array || "Uint8Array" === (null === (t = null == e ? void 0 : e.constructor) || void 0 === t ? void 0 : t.name) || "Buffer" === (null === (r = null == e ? void 0 : e.constructor) || void 0 === r ? void 0 : r.name);
                }, t.uint8ArrayConcat = function(...e) {
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    let n = 0;
                    for (const t of e)r.set(t, n), n += t.length;
                    return r;
                }, t.uint8ArrayEquals = function(e, t) {
                    if (e === t) return !0;
                    if (e.byteLength !== t.byteLength) return !1;
                    for(let r = 0; r < e.byteLength; r += 1)if (e[r] !== t[r]) return !1;
                    return !0;
                };
            },
            7717: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.uuidV4 = void 0;
                const n = r(7086), o = r(4822);
                t.uuidV4 = ()=>{
                    const e = (0, o.randomBytes)(16);
                    e[6] = 15 & e[6] | 64, e[8] = 63 & e[8] | 128;
                    const t = (0, n.bytesToHex)(e);
                    return [
                        t.substring(2, 10),
                        t.substring(10, 14),
                        t.substring(14, 18),
                        t.substring(18, 22),
                        t.substring(22, 34)
                    ].join("-");
                };
            },
            4578: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNullish = t.isContractInitOptions = t.compareBlockNumbers = t.isTopicInBloom = t.isTopic = t.isContractAddressInBloom = t.isUserEthereumAddressInBloom = t.isInBloom = t.isBloom = t.isAddress = t.checkAddressCheckSum = t.isHex = t.isHexStrict = void 0;
                const n = r(5071), o = r(7345), i = r(9970);
                t.isHexStrict = o.isHexStrict, t.isHex = o.isHex, t.checkAddressCheckSum = o.checkAddressCheckSum, t.isAddress = o.isAddress, t.isBloom = o.isBloom, t.isInBloom = o.isInBloom, t.isUserEthereumAddressInBloom = o.isUserEthereumAddressInBloom, t.isContractAddressInBloom = o.isContractAddressInBloom, t.isTopic = o.isTopic, t.isTopicInBloom = o.isTopicInBloom, t.compareBlockNumbers = (e, t)=>{
                    const r = "string" == typeof e && (0, o.isBlockTag)(e), s = "string" == typeof t && (0, o.isBlockTag)(t);
                    if (e === t || ("earliest" === e || 0 === e) && ("earliest" === t || 0 === t)) return 0;
                    if ("earliest" === e && t > 0) return -1;
                    if ("earliest" === t && e > 0) return 1;
                    if (r && s) {
                        const r = {
                            [i.BlockTags.EARLIEST]: 1,
                            [i.BlockTags.FINALIZED]: 2,
                            [i.BlockTags.SAFE]: 3,
                            [i.BlockTags.LATEST]: 4,
                            [i.BlockTags.PENDING]: 5
                        };
                        return r[e] < r[t] ? -1 : 1;
                    }
                    if (r && !s || !r && s) throw new n.InvalidBlockError("Cannot compare blocktag with provided non-blocktag input.");
                    const a = BigInt(e), c = BigInt(t);
                    return a < c ? -1 : a === c ? 0 : 1;
                }, t.isContractInitOptions = (e)=>"object" == typeof e && !(0, o.isNullish)(e) && 0 !== Object.keys(e).length && [
                        "input",
                        "data",
                        "from",
                        "gas",
                        "gasPrice",
                        "gasLimit",
                        "address",
                        "jsonInterface",
                        "syncWithContext",
                        "dataInputFill"
                    ].some((t)=>t in e), t.isNullish = o.isNullish;
            },
            6982: function(e, t, r) {
                "use strict";
                var n, o = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3DeferredPromise = void 0;
                const i = r(5071);
                t.Web3DeferredPromise = class {
                    constructor({ timeout: e, eagerStart: t, timeoutMessage: r } = {
                        timeout: 0,
                        eagerStart: !1,
                        timeoutMessage: "DeferredPromise timed out"
                    }){
                        this[n] = "Promise", this._state = "pending", this._promise = new Promise((e, t)=>{
                            this._resolve = e, this._reject = t;
                        }), this._timeoutMessage = r, this._timeoutInterval = e, t && this.startTimer();
                    }
                    get state() {
                        return this._state;
                    }
                    then(e, t) {
                        return o(this, void 0, void 0, function*() {
                            return this._promise.then(e, t);
                        });
                    }
                    catch(e) {
                        return o(this, void 0, void 0, function*() {
                            return this._promise.catch(e);
                        });
                    }
                    finally(e) {
                        return o(this, void 0, void 0, function*() {
                            return this._promise.finally(e);
                        });
                    }
                    resolve(e) {
                        this._resolve(e), this._state = "fulfilled", this._clearTimeout();
                    }
                    reject(e) {
                        this._reject(e), this._state = "rejected", this._clearTimeout();
                    }
                    startTimer() {
                        this._timeoutInterval && this._timeoutInterval > 0 && (this._timeoutId = setTimeout(this._checkTimeout.bind(this), this._timeoutInterval));
                    }
                    _checkTimeout() {
                        "pending" === this._state && this._timeoutId && this.reject(new i.OperationTimeoutError(this._timeoutMessage));
                    }
                    _clearTimeout() {
                        this._timeoutId && clearTimeout(this._timeoutId);
                    }
                }, n = Symbol.toStringTag;
            },
            997: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function s(e) {
                            try {
                                c(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function a(e) {
                            try {
                                c(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        c((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Eip1193Provider = void 0;
                const o = r(9970), i = r(9386), s = r(5071), a = r(9250);
                class c extends o.Web3BaseProvider {
                    constructor(){
                        super(...arguments), this._eventEmitter = new i.EventEmitter, this._chainId = "", this._accounts = [];
                    }
                    _getChainId() {
                        var e;
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.request((0, a.toPayload)({
                                method: "eth_chainId",
                                params: []
                            }));
                            return null !== (e = null == t ? void 0 : t.result) && void 0 !== e ? e : "";
                        });
                    }
                    _getAccounts() {
                        var e;
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.request((0, a.toPayload)({
                                method: "eth_accounts",
                                params: []
                            }));
                            return null !== (e = null == t ? void 0 : t.result) && void 0 !== e ? e : [];
                        });
                    }
                    _onConnect() {
                        Promise.all([
                            this._getChainId().then((e)=>{
                                e !== this._chainId && (this._chainId = e, this._eventEmitter.emit("chainChanged", this._chainId));
                            }).catch((e)=>{
                                console.error(e);
                            }),
                            this._getAccounts().then((e)=>{
                                this._accounts.length === e.length && e.every((t)=>e.includes(t)) || (this._accounts = e, this._onAccountsChanged());
                            }).catch((e)=>{
                                console.error(e);
                            })
                        ]).then(()=>this._eventEmitter.emit("connect", {
                                chainId: this._chainId
                            })).catch((e)=>{
                            console.error(e);
                        });
                    }
                    _onDisconnect(e, t) {
                        this._eventEmitter.emit("disconnect", new s.EIP1193ProviderRpcError(e, t));
                    }
                    _onAccountsChanged() {
                        this._eventEmitter.emit("accountsChanged", this._accounts);
                    }
                }
                t.Eip1193Provider = c;
            },
            1438: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.VALID_ETH_BASE_TYPES = void 0, t.VALID_ETH_BASE_TYPES = [
                    "bool",
                    "int",
                    "uint",
                    "bytes",
                    "string",
                    "address",
                    "tuple"
                ];
            },
            3637: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validator = void 0;
                const n = r(7985);
                t.validator = new n.Web3Validator;
            },
            356: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3ValidatorError = void 0;
                const n = r(5071), o = (e)=>e.message ? e.message : "unspecified error";
                class i extends n.BaseWeb3Error {
                    constructor(e){
                        super(), this.code = n.ERR_VALIDATION, this.errors = e, super.message = `Web3 validator found ${e.length} error[s]:\n${this._compileErrors().join("\n")}`;
                    }
                    _compileErrors() {
                        return this.errors.map(o);
                    }
                }
                t.Web3ValidatorError = i;
            },
            2677: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const n = r(2681), o = r(6660), i = r(5191), s = r(4416), a = r(3921), c = r(5164), u = r(7420), d = r(6378), l = {
                    address: (e)=>(0, n.isAddress)(e),
                    bloom: (e)=>(0, i.isBloom)(e),
                    blockNumber: (e)=>(0, o.isBlockNumber)(e),
                    blockTag: (e)=>(0, o.isBlockTag)(e),
                    blockNumberOrTag: (e)=>(0, o.isBlockNumberOrTag)(e),
                    bool: (e)=>(0, s.isBoolean)(e),
                    bytes: (e)=>(0, a.isBytes)(e),
                    filter: (e)=>(0, c.isFilterObject)(e),
                    hex: (e)=>(0, u.isHexStrict)(e),
                    uint: (e)=>(0, d.isUInt)(e),
                    int: (e)=>(0, d.isInt)(e),
                    number: (e)=>(0, d.isNumber)(e),
                    string: (e)=>(0, u.isString)(e)
                };
                for(let e = 8; e <= 256; e += 8)l[`int${e}`] = (t)=>(0, d.isInt)(t, {
                        bitSize: e
                    }), l[`uint${e}`] = (t)=>(0, d.isUInt)(t, {
                        bitSize: e
                    });
                for(let e = 1; e <= 32; e += 1)l[`bytes${e}`] = (t)=>(0, a.isBytes)(t, {
                        size: e
                    });
                l.bytes256 = l.bytes, t.default = l;
            },
            7345: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }, s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return o(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.utils = void 0, i(r(7985), t), i(r(3637), t), i(r(5421), t), t.utils = s(r(8171)), i(r(356), t), i(r(1438), t), i(r(1851), t);
            },
            5421: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8171: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ensureIfUint8Array = t.hexToUint8Array = t.uint8ArrayToHexString = t.padLeft = t.numberToHex = t.hexToNumber = t.codePointToInt = t.transformJsonDataToAbiFormat = t.fetchArrayElement = t.ethAbiToJsonSchema = t.abiSchemaToJsonSchema = t.parseBaseType = void 0;
                const n = r(5071), o = r(1438), i = r(1283), s = r(7420), a = r(356), c = [
                    "hex",
                    "number",
                    "blockNumber",
                    "blockNumberOrTag",
                    "filter",
                    "bloom"
                ];
                t.parseBaseType = (e)=>{
                    let t, r = e.replace(/ /, ""), n = !1, i = [];
                    if (e.includes("[") && (r = r.slice(0, r.indexOf("[")), i = [
                        ...e.matchAll(/(?:\[(\d*)\])/g)
                    ].map((e)=>parseInt(e[1], 10)).map((e)=>Number.isNaN(e) ? -1 : e), n = i.length > 0), o.VALID_ETH_BASE_TYPES.includes(r)) return {
                        baseType: r,
                        isArray: n,
                        baseTypeSize: t,
                        arraySizes: i
                    };
                    if (r.startsWith("int")) t = parseInt(r.substring(3), 10), r = "int";
                    else if (r.startsWith("uint")) t = parseInt(e.substring(4), 10), r = "uint";
                    else {
                        if (!r.startsWith("bytes")) return {
                            baseType: void 0,
                            isArray: !1,
                            baseTypeSize: void 0,
                            arraySizes: i
                        };
                        t = parseInt(r.substring(5), 10), r = "bytes";
                    }
                    return {
                        baseType: r,
                        isArray: n,
                        baseTypeSize: t,
                        arraySizes: i
                    };
                };
                const u = (e, r = {})=>{
                    if (Object.keys(r).includes("type")) throw new a.Web3ValidatorError([
                        {
                            keyword: "eth",
                            message: 'Either "eth" or "type" can be presented in schema',
                            params: {
                                eth: e
                            },
                            instancePath: "",
                            schemaPath: ""
                        }
                    ]);
                    const { baseType: n, baseTypeSize: o } = (0, t.parseBaseType)(e);
                    if (!n && !c.includes(e)) throw new a.Web3ValidatorError([
                        {
                            keyword: "eth",
                            message: `Eth data type "${e}" is not valid`,
                            params: {
                                eth: e
                            },
                            instancePath: "",
                            schemaPath: ""
                        }
                    ]);
                    if (n) {
                        if ("tuple" === n) throw new Error('"tuple" type is not implemented directly.');
                        return {
                            format: `${n}${null != o ? o : ""}`,
                            required: !0
                        };
                    }
                    return e ? {
                        format: e,
                        required: !0
                    } : {};
                };
                t.abiSchemaToJsonSchema = (e, r = "/0")=>{
                    const n = {
                        type: "array",
                        items: [],
                        maxItems: e.length,
                        minItems: e.length
                    };
                    for (const [o, s] of e.entries()){
                        let e, a, c = [];
                        (0, i.isAbiParameterSchema)(s) ? (e = s.type, a = s.name || `${r}/${o}`, c = s.components) : "string" == typeof s ? (e = s, a = `${r}/${o}`) : Array.isArray(s) && (s[0] && "string" == typeof s[0] && s[0].startsWith("tuple") && !Array.isArray(s[0]) && s[1] && Array.isArray(s[1]) ? (e = s[0], a = `${r}/${o}`, c = s[1]) : (e = "tuple", a = `${r}/${o}`, c = s));
                        const { baseType: d, isArray: l, arraySizes: h } = (0, t.parseBaseType)(e);
                        let f, p = n;
                        for(let e = h.length - 1; e > 0; e -= 1)f = {
                            type: "array",
                            $id: a,
                            items: [],
                            maxItems: h[e],
                            minItems: h[e]
                        }, h[e] < 0 && (delete f.maxItems, delete f.minItems), Array.isArray(p.items) ? 0 === p.items.length ? p.items = [
                            f
                        ] : p.items.push(f) : p.items = [
                            p.items,
                            f
                        ], p = f;
                        if ("tuple" !== d || l) {
                            if ("tuple" === d && l) {
                                const e = h[0], r = Object.assign({
                                    type: "array",
                                    $id: a,
                                    items: (0, t.abiSchemaToJsonSchema)(c, a)
                                }, e >= 0 && {
                                    minItems: e,
                                    maxItems: e
                                });
                                p.items.push(r);
                            } else if (l) {
                                const t = h[0], r = Object.assign({
                                    type: "array",
                                    $id: a,
                                    items: u(e)
                                }, t >= 0 && {
                                    minItems: t,
                                    maxItems: t
                                });
                                p.items.push(r);
                            } else Array.isArray(p.items), p.items.push(Object.assign({
                                $id: a
                            }, u(e)));
                        } else {
                            const e = (0, t.abiSchemaToJsonSchema)(c, a);
                            e.$id = a, p.items.push(e);
                        }
                        p = n;
                    }
                    return n;
                }, t.ethAbiToJsonSchema = (e)=>(0, t.abiSchemaToJsonSchema)(e), t.fetchArrayElement = (e, r)=>1 === r ? e : (0, t.fetchArrayElement)(e[0], r - 1), t.transformJsonDataToAbiFormat = (e, r, n)=>{
                    const o = [];
                    for (const [s, a] of e.entries()){
                        let e, c, u = [];
                        (0, i.isAbiParameterSchema)(a) ? (e = a.type, c = a.name, u = a.components) : "string" == typeof a ? e = a : Array.isArray(a) && (a[1] && Array.isArray(a[1]) ? (e = a[0], u = a[1]) : (e = "tuple", u = a));
                        const { baseType: d, isArray: l, arraySizes: h } = (0, t.parseBaseType)(e), f = Array.isArray(r) ? r[s] : r[c];
                        if ("tuple" !== d || l) {
                            if ("tuple" === d && l) {
                                const e = [];
                                for (const r of f)if (h.length > 1) {
                                    const o = (0, t.fetchArrayElement)(r, h.length - 1), i = [];
                                    for (const e of o)i.push((0, t.transformJsonDataToAbiFormat)(u, e, n));
                                    e.push(i);
                                } else e.push((0, t.transformJsonDataToAbiFormat)(u, r, n));
                                o.push(e);
                            } else o.push(f);
                        } else o.push((0, t.transformJsonDataToAbiFormat)(u, f, n));
                    }
                    return (n = null != n ? n : []).push(...o), n;
                }, t.codePointToInt = (e)=>{
                    if (e >= 48 && e <= 57) return e - 48;
                    if (e >= 65 && e <= 70) return e - 55;
                    if (e >= 97 && e <= 102) return e - 87;
                    throw new Error(`Invalid code point: ${e}`);
                }, t.hexToNumber = (e)=>{
                    if (!(0, s.isHexStrict)(e)) throw new Error("Invalid hex string");
                    const [t, r] = e.startsWith("-") ? [
                        !0,
                        e.slice(1)
                    ] : [
                        !1,
                        e
                    ], n = BigInt(r);
                    return n > Number.MAX_SAFE_INTEGER ? t ? -n : n : n < Number.MIN_SAFE_INTEGER ? n : t ? -1 * Number(n) : Number(n);
                }, t.numberToHex = (e)=>{
                    if (("number" == typeof e || "bigint" == typeof e) && e < 0) return `-0x${e.toString(16).slice(1)}`;
                    if (("number" == typeof e || "bigint" == typeof e) && e >= 0) return `0x${e.toString(16)}`;
                    if ("string" == typeof e && (0, s.isHexStrict)(e)) {
                        const [t, r] = e.startsWith("-") ? [
                            !0,
                            e.slice(1)
                        ] : [
                            !1,
                            e
                        ];
                        return `${t ? "-" : ""}0x${r.split(/^(-)?0(x|X)/).slice(-1)[0].replace(/^0+/, "").toLowerCase()}`;
                    }
                    if ("string" == typeof e && !(0, s.isHexStrict)(e)) return (0, t.numberToHex)(BigInt(e));
                    throw new n.InvalidNumberError(e);
                }, t.padLeft = (e, r, n = "0")=>{
                    if ("string" == typeof e && !(0, s.isHexStrict)(e)) return e.padStart(r, n);
                    const o = "string" == typeof e && (0, s.isHexStrict)(e) ? e : (0, t.numberToHex)(e), [i, a] = o.startsWith("-") ? [
                        "-0x",
                        o.slice(3)
                    ] : [
                        "0x",
                        o.slice(2)
                    ];
                    return `${i}${a.padStart(r, n)}`;
                }, t.uint8ArrayToHexString = function(e) {
                    let t = "0x";
                    for (const r of e){
                        const e = r.toString(16);
                        t += 1 === e.length ? `0${e}` : e;
                    }
                    return t;
                };
                function d(e) {
                    return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : void 0;
                }
                t.hexToUint8Array = function(e) {
                    let t = 0;
                    if (!e.startsWith("0") || "x" !== e[1] && "X" !== e[1] || (t = 2), e.length % 2 != 0) throw new n.InvalidBytesError(`hex string has odd length: ${e}`);
                    const r = (e.length - t) / 2, o = new Uint8Array(r);
                    for(let i = 0, s = t; i < r; i += 1){
                        const t = d(e.charCodeAt(s++)), r = d(e.charCodeAt(s++));
                        if (void 0 === t || void 0 === r) throw new n.InvalidBytesError(`Invalid byte sequence ("${e[s - 2]}${e[s - 1]}" in "${e}").`);
                        o[i] = 16 * t + r;
                    }
                    return o;
                }, t.ensureIfUint8Array = function(e) {
                    var t;
                    return e instanceof Uint8Array || "Uint8Array" !== (null === (t = null == e ? void 0 : e.constructor) || void 0 === t ? void 0 : t.name) ? e : Uint8Array.from(e);
                };
            },
            1283: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAbiParameterSchema = void 0, t.isAbiParameterSchema = (e)=>"object" == typeof e && "type" in e && "name" in e;
            },
            2681: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAddress = t.checkAddressCheckSum = void 0;
                const n = r(4488), o = r(7737), i = r(8171), s = r(7420), a = r(3921);
                t.checkAddressCheckSum = (e)=>{
                    if (!/^(0x)?[0-9a-f]{40}$/i.test(e)) return !1;
                    const t = e.slice(2), r = (0, o.utf8ToBytes)(t.toLowerCase()), s = (0, i.uint8ArrayToHexString)((0, n.keccak256)((0, i.ensureIfUint8Array)(r))).slice(2);
                    for(let e = 0; e < 40; e += 1)if (parseInt(s[e], 16) > 7 && t[e].toUpperCase() !== t[e] || parseInt(s[e], 16) <= 7 && t[e].toLowerCase() !== t[e]) return !1;
                    return !0;
                }, t.isAddress = (e, r = !0)=>{
                    if ("string" != typeof e && !(0, a.isUint8Array)(e)) return !1;
                    let n;
                    return n = (0, a.isUint8Array)(e) ? (0, i.uint8ArrayToHexString)(e) : "string" != typeof e || (0, s.isHexStrict)(e) || e.toLowerCase().startsWith("0x") ? e : `0x${e}`, !!/^(0x)?[0-9a-f]{40}$/i.test(n) && (!(!/^(0x|0X)?[0-9a-f]{40}$/.test(n) && !/^(0x|0X)?[0-9A-F]{40}$/.test(n)) || !r || (0, t.checkAddressCheckSum)(n));
                };
            },
            6660: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBlockNumberOrTag = t.isBlockTag = t.isBlockNumber = void 0;
                const n = r(9970), o = r(6378);
                t.isBlockNumber = (e)=>(0, o.isUInt)(e), t.isBlockTag = (e)=>Object.values(n.BlockTags).includes(e), t.isBlockNumberOrTag = (e)=>(0, t.isBlockTag)(e) || (0, t.isBlockNumber)(e);
            },
            5191: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isContractAddressInBloom = t.isUserEthereumAddressInBloom = t.isInBloom = t.isBloom = void 0;
                const n = r(4488), o = r(8171), i = r(2681), s = r(7420);
                t.isBloom = (e)=>!("string" != typeof e || !/^(0x)?[0-9a-f]{512}$/i.test(e) || !/^(0x)?[0-9a-f]{512}$/.test(e) && !/^(0x)?[0-9A-F]{512}$/.test(e)), t.isInBloom = (e, r)=>{
                    if ("string" == typeof r && !(0, s.isHexStrict)(r)) return !1;
                    if (!(0, t.isBloom)(e)) return !1;
                    const i = "string" == typeof r ? (0, o.hexToUint8Array)(r) : r, a = (0, o.uint8ArrayToHexString)((0, n.keccak256)(i)).slice(2);
                    for(let t = 0; t < 12; t += 4){
                        const r = (parseInt(a.slice(t, t + 2), 16) << 8) + parseInt(a.slice(t + 2, t + 4), 16) & 2047, n = 1 << r % 4;
                        if (((0, o.codePointToInt)(e.charCodeAt(e.length - 1 - Math.floor(r / 4))) & n) !== n) return !1;
                    }
                    return !0;
                }, t.isUserEthereumAddressInBloom = (e, r)=>{
                    if (!(0, t.isBloom)(e)) return !1;
                    if (!(0, i.isAddress)(r)) return !1;
                    const n = (0, o.padLeft)(r, 64);
                    return (0, t.isInBloom)(e, n);
                }, t.isContractAddressInBloom = (e, r)=>!!(0, t.isBloom)(e) && !!(0, i.isAddress)(r) && (0, t.isInBloom)(e, r);
            },
            4416: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBoolean = void 0;
                const n = r(7420);
                t.isBoolean = (e)=>!![
                        "number",
                        "string",
                        "boolean"
                    ].includes(typeof e) && ("boolean" == typeof e || ("string" != typeof e || (0, n.isHexStrict)(e) ? "string" == typeof e && (0, n.isHexStrict)(e) ? "0x1" === e || "0x0" === e : 1 === e || 0 === e : "1" === e || "0" === e));
            },
            3921: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBytes = t.isUint8Array = void 0;
                const n = r(8171), o = r(7420);
                t.isUint8Array = (e)=>{
                    var t, r;
                    return e instanceof Uint8Array || "Uint8Array" === (null === (t = null == e ? void 0 : e.constructor) || void 0 === t ? void 0 : t.name) || "Buffer" === (null === (r = null == e ? void 0 : e.constructor) || void 0 === r ? void 0 : r.name);
                }, t.isBytes = (e, r = {
                    abiType: "bytes"
                })=>{
                    if ("string" != typeof e && !Array.isArray(e) && !(0, t.isUint8Array)(e)) return !1;
                    if ("string" == typeof e && (0, o.isHexStrict)(e) && e.startsWith("-")) return !1;
                    if ("string" == typeof e && !(0, o.isHexStrict)(e)) return !1;
                    let i;
                    if ("string" == typeof e) {
                        if (e.length % 2 != 0) return !1;
                        i = (0, n.hexToUint8Array)(e);
                    } else if (Array.isArray(e)) {
                        if (e.some((e)=>e < 0 || e > 255 || !Number.isInteger(e))) return !1;
                        i = new Uint8Array(e);
                    } else i = e;
                    if (null == r ? void 0 : r.abiType) {
                        const { baseTypeSize: e } = (0, n.parseBaseType)(r.abiType);
                        return !e || i.length === e;
                    }
                    return !(null == r ? void 0 : r.size) || i.length === (null == r ? void 0 : r.size);
                };
            },
            1478: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isValidEthBaseType = void 0;
                const n = r(8171);
                t.isValidEthBaseType = (e)=>{
                    const { baseType: t, baseTypeSize: r } = (0, n.parseBaseType)(e);
                    return !!t && (t === e || ("int" !== t && "uint" !== t || !r || r <= 256 && r % 8 == 0) && ("bytes" !== t || !r || r >= 1 && r <= 32));
                };
            },
            5164: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isFilterObject = void 0;
                const n = r(2681), o = r(6660), i = r(2102), s = r(5702);
                t.isFilterObject = (e)=>{
                    const t = [
                        "fromBlock",
                        "toBlock",
                        "address",
                        "topics",
                        "blockHash"
                    ];
                    if ((0, i.isNullish)(e) || "object" != typeof e) return !1;
                    if (!Object.keys(e).every((e)=>t.includes(e))) return !1;
                    if (!(0, i.isNullish)(e.fromBlock) && !(0, o.isBlockNumberOrTag)(e.fromBlock) || !(0, i.isNullish)(e.toBlock) && !(0, o.isBlockNumberOrTag)(e.toBlock)) return !1;
                    if (!(0, i.isNullish)(e.address)) {
                        if (Array.isArray(e.address)) {
                            if (!e.address.every((e)=>(0, n.isAddress)(e))) return !1;
                        } else if (!(0, n.isAddress)(e.address)) return !1;
                    }
                    return !(!(0, i.isNullish)(e.topics) && !e.topics.every((e)=>!!(0, i.isNullish)(e) || (Array.isArray(e) ? e.every((e)=>(0, s.isTopic)(e)) : !!(0, s.isTopic)(e))));
                };
            },
            1851: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(r(2681), t), o(r(6660), t), o(r(5191), t), o(r(4416), t), o(r(3921), t), o(r(1478), t), o(r(5164), t), o(r(6378), t), o(r(7420), t), o(r(5702), t), o(r(2102), t);
            },
            6378: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNumber = t.isInt = t.isUInt = t.bigintPower = t.isBigInt = void 0;
                const n = r(8171), o = r(7420);
                t.isBigInt = (e)=>"bigint" == typeof e, t.bigintPower = (e, t)=>{
                    if (t === BigInt(0)) return BigInt(1);
                    let r = e;
                    for(let n = 1; n < t; n += 1)r *= e;
                    return r;
                }, t.isUInt = (e, r = {
                    abiType: "uint"
                })=>{
                    if (![
                        "number",
                        "string",
                        "bigint"
                    ].includes(typeof e) || "string" == typeof e && 0 === e.length) return !1;
                    let i;
                    if (null == r ? void 0 : r.abiType) {
                        const { baseTypeSize: e } = (0, n.parseBaseType)(r.abiType);
                        e && (i = e);
                    } else r.bitSize && (i = r.bitSize);
                    const s = (0, t.bigintPower)(BigInt(2), BigInt(null != i ? i : 256)) - BigInt(1);
                    try {
                        const t = "string" == typeof e && (0, o.isHexStrict)(e) ? BigInt((0, n.hexToNumber)(e)) : BigInt(e);
                        return t >= 0 && t <= s;
                    } catch (e) {
                        return !1;
                    }
                }, t.isInt = (e, r = {
                    abiType: "int"
                })=>{
                    if (![
                        "number",
                        "string",
                        "bigint"
                    ].includes(typeof e)) return !1;
                    if ("number" == typeof e && e > Number.MAX_SAFE_INTEGER) return !1;
                    let i;
                    if (null == r ? void 0 : r.abiType) {
                        const { baseTypeSize: e, baseType: t } = (0, n.parseBaseType)(r.abiType);
                        if ("int" !== t) return !1;
                        e && (i = e);
                    } else r.bitSize && (i = r.bitSize);
                    const s = (0, t.bigintPower)(BigInt(2), BigInt((null != i ? i : 256) - 1)), a = BigInt(-1) * (0, t.bigintPower)(BigInt(2), BigInt((null != i ? i : 256) - 1));
                    try {
                        const t = "string" == typeof e && (0, o.isHexStrict)(e) ? BigInt((0, n.hexToNumber)(e)) : BigInt(e);
                        return t >= a && t <= s;
                    } catch (e) {
                        return !1;
                    }
                }, t.isNumber = (e)=>!!(0, t.isInt)(e) || !("string" != typeof e || !/[0-9.]/.test(e) || e.indexOf(".") !== e.lastIndexOf(".")) || "number" == typeof e;
            },
            2102: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isObject = t.isNullish = void 0;
                const n = r(9970);
                t.isNullish = (e)=>null == e, t.isObject = (e)=>!("object" != typeof e || (0, t.isNullish)(e) || Array.isArray(e) || e instanceof n.TypedArray);
            },
            7420: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateNoLeadingZeroes = t.isHexPrefixed = t.isHexString32Bytes = t.isHexString8Bytes = t.isHex = t.isHexString = t.isHexStrict = t.isString = void 0, t.isString = (e)=>"string" == typeof e, t.isHexStrict = (e)=>"string" == typeof e && /^((-)?0x[0-9a-f]+|(0x))$/i.test(e), t.isHexString = function(e, t) {
                    return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || void 0 !== t && t > 0 && e.length !== 2 + 2 * t);
                }, t.isHex = (e)=>"number" == typeof e || "bigint" == typeof e || "string" == typeof e && /^((-0x|0x|-)?[0-9a-f]+|(0x))$/i.test(e), t.isHexString8Bytes = (e, r = !0)=>r ? (0, t.isHexStrict)(e) && 18 === e.length : (0, t.isHex)(e) && 16 === e.length, t.isHexString32Bytes = (e, r = !0)=>r ? (0, t.isHexStrict)(e) && 66 === e.length : (0, t.isHex)(e) && 64 === e.length, t.isHexPrefixed = function(e) {
                    if ("string" != typeof e) throw new Error("[isHexPrefixed] input must be type 'string', received type " + typeof e);
                    return e.startsWith("0x");
                }, t.validateNoLeadingZeroes = function(e) {
                    for (const [t, r] of Object.entries(e))if (void 0 !== r && r.length > 0 && 0 === r[0]) throw new Error(`${t} cannot have leading zeroes, received: ${r.toString()}`);
                };
            },
            5702: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isTopicInBloom = t.isTopic = void 0;
                const n = r(5191);
                t.isTopic = (e)=>!("string" != typeof e || !/^(0x)?[0-9a-f]{64}$/i.test(e) || !/^(0x)?[0-9a-f]{64}$/.test(e) && !/^(0x)?[0-9A-F]{64}$/.test(e)), t.isTopicInBloom = (e, r)=>!!(0, n.isBloom)(e) && !!(0, t.isTopic)(r) && (0, n.isInBloom)(e, r);
            },
            1714: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Validator = void 0;
                const o = r(5071), i = r(6750), s = r(356), a = n(r(2677)), c = (e)=>{
                    if ((!(null == e ? void 0 : e.type) || "object" === (null == e ? void 0 : e.type)) && (null == e ? void 0 : e.properties)) {
                        const t = {};
                        for (const r of Object.keys(e.properties)){
                            const n = c(e.properties[r]);
                            n && (t[r] = n);
                        }
                        return Array.isArray(e.required) ? i.z.object(t).partial().required(e.required.reduce((e, t)=>Object.assign(Object.assign({}, e), {
                                [t]: !0
                            }), {})) : i.z.object(t).partial();
                    }
                    if ("array" === (null == e ? void 0 : e.type) && (null == e ? void 0 : e.items)) {
                        if (Array.isArray(e.items) && e.items.length > 1 && void 0 !== e.maxItems && new Set(e.items.map((e)=>e.$id)).size === e.items.length) {
                            const t = [];
                            for (const r of e.items){
                                const e = c(r);
                                e && t.push(e);
                            }
                            return i.z.tuple(t);
                        }
                        const t = Array.isArray(e.items) ? e.items[0] : e.items;
                        let r = i.z.array(c(t));
                        return r = void 0 !== e.minItems ? r.min(e.minItems) : r, r = void 0 !== e.maxItems ? r.max(e.maxItems) : r, r;
                    }
                    if (e.oneOf && Array.isArray(e.oneOf)) return i.z.union(e.oneOf.map((e)=>c(e)));
                    if (null == e ? void 0 : e.format) {
                        if (!a.default[e.format]) throw new o.SchemaFormatError(e.format);
                        return i.z.any().refine(a.default[e.format], (t)=>({
                                params: {
                                    value: t,
                                    format: e.format
                                }
                            }));
                    }
                    return (null == e ? void 0 : e.type) && "object" !== (null == e ? void 0 : e.type) && "function" == typeof i.z[String(e.type)] ? i.z[String(e.type)]() : i.z.object({
                        data: i.z.any()
                    }).partial();
                };
                class u {
                    static factory() {
                        return u.validatorInstance || (u.validatorInstance = new u), u.validatorInstance;
                    }
                    validate(e, t, r) {
                        var n, o;
                        const i = c(e).safeParse(t);
                        if (!i.success) {
                            const e = this.convertErrors(null !== (o = null === (n = i.error) || void 0 === n ? void 0 : n.issues) && void 0 !== o ? o : []);
                            if (e) {
                                if (null == r ? void 0 : r.silent) return e;
                                throw new s.Web3ValidatorError(e);
                            }
                        }
                    }
                    convertErrors(e) {
                        if (e && Array.isArray(e) && e.length > 0) return e.map((e)=>{
                            var t;
                            let r, n, o, s;
                            s = e.path.join("/");
                            const a = String(e.path[e.path.length - 1]), c = e.path.join("/");
                            if (e.code === i.ZodIssueCode.too_big) n = "maxItems", s = `${c}/maxItems`, o = {
                                limit: e.maximum
                            }, r = `must NOT have more than ${e.maximum} items`;
                            else if (e.code === i.ZodIssueCode.too_small) n = "minItems", s = `${c}/minItems`, o = {
                                limit: e.minimum
                            }, r = `must NOT have fewer than ${e.minimum} items`;
                            else if (e.code === i.ZodIssueCode.custom) {
                                const { value: n, format: i } = null !== (t = e.params) && void 0 !== t ? t : {};
                                r = void 0 === n ? `value at "/${s}" is required` : `value "${"object" == typeof n ? JSON.stringify(n) : n}" at "/${s}" must pass "${i}" validation`, o = {
                                    value: n
                                };
                            }
                            return {
                                keyword: null != n ? n : a,
                                instancePath: c ? `/${c}` : "",
                                schemaPath: s ? `#${s}` : "#",
                                params: null != o ? o : {
                                    value: e.message
                                },
                                message: null != r ? r : e.message
                            };
                        });
                    }
                }
                t.Validator = u;
            },
            7985: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Validator = void 0;
                const n = r(1714), o = r(8171), i = r(356);
                t.Web3Validator = class {
                    constructor(){
                        this._validator = n.Validator.factory();
                    }
                    validateJSONSchema(e, t, r) {
                        return this._validator.validate(e, t, r);
                    }
                    validate(e, t, r = {
                        silent: !1
                    }) {
                        var n, s;
                        const a = (0, o.ethAbiToJsonSchema)(e);
                        if (!Array.isArray(a.items) || 0 !== (null === (n = a.items) || void 0 === n ? void 0 : n.length) || 0 !== t.length) {
                            if (Array.isArray(a.items) && 0 === (null === (s = a.items) || void 0 === s ? void 0 : s.length) && 0 !== t.length) throw new i.Web3ValidatorError([
                                {
                                    instancePath: "/0",
                                    schemaPath: "/",
                                    keyword: "required",
                                    message: "empty schema against data can not be validated",
                                    params: t
                                }
                            ]);
                            return this._validator.validate(a, t, r);
                        }
                    }
                };
            },
            1655: (e, t, r)=>{
                "use strict";
                function n(e, t) {
                    return e.exec(t)?.groups;
                }
                r.r(t), r.d(t, {
                    BaseError: ()=>u,
                    narrow: ()=>d,
                    parseAbi: ()=>M,
                    parseAbiItem: ()=>L,
                    parseAbiParameter: ()=>D,
                    parseAbiParameters: ()=>F
                });
                var o = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, i = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/, s = /^\(.+?\).*?$/, a = Object.defineProperty, c = (e, t, r)=>(((e, t, r)=>{
                        t in e ? a(e, t, {
                            enumerable: !0,
                            configurable: !0,
                            writable: !0,
                            value: r
                        }) : e[t] = r;
                    })(e, "symbol" != typeof t ? t + "" : t, r), r), u = class extends Error {
                    constructor(e, t = {}){
                        const r = t.cause instanceof u ? t.cause.details : t.cause?.message ? t.cause.message : t.details, n = t.cause instanceof u && t.cause.docsPath || t.docsPath;
                        super([
                            e || "An error occurred.",
                            "",
                            ...t.metaMessages ? [
                                ...t.metaMessages,
                                ""
                            ] : [],
                            ...n ? [
                                `Docs: https://abitype.dev${n}`
                            ] : [],
                            ...r ? [
                                `Details: ${r}`
                            ] : [],
                            "Version: abitype@0.7.1"
                        ].join("\n")), c(this, "details"), c(this, "docsPath"), c(this, "metaMessages"), c(this, "shortMessage"), c(this, "name", "AbiTypeError"), t.cause && (this.cause = t.cause), this.details = r, this.docsPath = n, this.metaMessages = t.metaMessages, this.shortMessage = e;
                    }
                };
                function d(e) {
                    return e;
                }
                var l = /^error (?<name>[a-zA-Z0-9_]+)\((?<parameters>.*?)\)$/, h = /^event (?<name>[a-zA-Z0-9_]+)\((?<parameters>.*?)\)$/, f = /^function (?<name>[a-zA-Z0-9_]+)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns \((?<returns>.*?)\))?$/, p = /^struct (?<name>[a-zA-Z0-9_]+) \{(?<properties>.*?)\}$/;
                function m(e) {
                    return p.test(e);
                }
                function g(e) {
                    return n(p, e);
                }
                var y = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/, v = /^fallback\(\)$/, b = /^receive\(\) external payable$/, E = new Set([
                    "memory",
                    "indexed",
                    "storage",
                    "calldata"
                ]), _ = new Set([
                    "indexed"
                ]), A = new Set([
                    "calldata",
                    "memory",
                    "storage"
                ]), T = new Map([
                    [
                        "address",
                        {
                            type: "address"
                        }
                    ],
                    [
                        "bool",
                        {
                            type: "bool"
                        }
                    ],
                    [
                        "bytes",
                        {
                            type: "bytes"
                        }
                    ],
                    [
                        "bytes32",
                        {
                            type: "bytes32"
                        }
                    ],
                    [
                        "int",
                        {
                            type: "int256"
                        }
                    ],
                    [
                        "int256",
                        {
                            type: "int256"
                        }
                    ],
                    [
                        "string",
                        {
                            type: "string"
                        }
                    ],
                    [
                        "uint",
                        {
                            type: "uint256"
                        }
                    ],
                    [
                        "uint8",
                        {
                            type: "uint8"
                        }
                    ],
                    [
                        "uint16",
                        {
                            type: "uint16"
                        }
                    ],
                    [
                        "uint24",
                        {
                            type: "uint24"
                        }
                    ],
                    [
                        "uint32",
                        {
                            type: "uint32"
                        }
                    ],
                    [
                        "uint64",
                        {
                            type: "uint64"
                        }
                    ],
                    [
                        "uint96",
                        {
                            type: "uint96"
                        }
                    ],
                    [
                        "uint112",
                        {
                            type: "uint112"
                        }
                    ],
                    [
                        "uint160",
                        {
                            type: "uint160"
                        }
                    ],
                    [
                        "uint192",
                        {
                            type: "uint192"
                        }
                    ],
                    [
                        "uint256",
                        {
                            type: "uint256"
                        }
                    ],
                    [
                        "address owner",
                        {
                            type: "address",
                            name: "owner"
                        }
                    ],
                    [
                        "address to",
                        {
                            type: "address",
                            name: "to"
                        }
                    ],
                    [
                        "bool approved",
                        {
                            type: "bool",
                            name: "approved"
                        }
                    ],
                    [
                        "bytes _data",
                        {
                            type: "bytes",
                            name: "_data"
                        }
                    ],
                    [
                        "bytes data",
                        {
                            type: "bytes",
                            name: "data"
                        }
                    ],
                    [
                        "bytes signature",
                        {
                            type: "bytes",
                            name: "signature"
                        }
                    ],
                    [
                        "bytes32 hash",
                        {
                            type: "bytes32",
                            name: "hash"
                        }
                    ],
                    [
                        "bytes32 r",
                        {
                            type: "bytes32",
                            name: "r"
                        }
                    ],
                    [
                        "bytes32 root",
                        {
                            type: "bytes32",
                            name: "root"
                        }
                    ],
                    [
                        "bytes32 s",
                        {
                            type: "bytes32",
                            name: "s"
                        }
                    ],
                    [
                        "string name",
                        {
                            type: "string",
                            name: "name"
                        }
                    ],
                    [
                        "string symbol",
                        {
                            type: "string",
                            name: "symbol"
                        }
                    ],
                    [
                        "string tokenURI",
                        {
                            type: "string",
                            name: "tokenURI"
                        }
                    ],
                    [
                        "uint tokenId",
                        {
                            type: "uint256",
                            name: "tokenId"
                        }
                    ],
                    [
                        "uint8 v",
                        {
                            type: "uint8",
                            name: "v"
                        }
                    ],
                    [
                        "uint256 balance",
                        {
                            type: "uint256",
                            name: "balance"
                        }
                    ],
                    [
                        "uint256 tokenId",
                        {
                            type: "uint256",
                            name: "tokenId"
                        }
                    ],
                    [
                        "uint256 value",
                        {
                            type: "uint256",
                            name: "value"
                        }
                    ],
                    [
                        "event:address indexed from",
                        {
                            type: "address",
                            name: "from",
                            indexed: !0
                        }
                    ],
                    [
                        "event:address indexed to",
                        {
                            type: "address",
                            name: "to",
                            indexed: !0
                        }
                    ],
                    [
                        "event:uint indexed tokenId",
                        {
                            type: "uint256",
                            name: "tokenId",
                            indexed: !0
                        }
                    ],
                    [
                        "event:uint256 indexed tokenId",
                        {
                            type: "uint256",
                            name: "tokenId",
                            indexed: !0
                        }
                    ]
                ]);
                function w(e, t = {}) {
                    if (function(e) {
                        return f.test(e);
                    }(e)) {
                        const r = function(e) {
                            return n(f, e);
                        }(e);
                        if (!r) throw new u("Invalid function signature.", {
                            details: e
                        });
                        const o = O(r.parameters), i = [], s = o.length;
                        for(let e = 0; e < s; e++)i.push(x(o[e], {
                            modifiers: A,
                            structs: t,
                            type: "function"
                        }));
                        const a = [];
                        if (r.returns) {
                            const e = O(r.returns), n = e.length;
                            for(let r = 0; r < n; r++)a.push(x(e[r], {
                                modifiers: A,
                                structs: t,
                                type: "function"
                            }));
                        }
                        return {
                            name: r.name,
                            type: "function",
                            stateMutability: r.stateMutability ?? "nonpayable",
                            inputs: i,
                            outputs: a
                        };
                    }
                    if (function(e) {
                        return h.test(e);
                    }(e)) {
                        const r = function(e) {
                            return n(h, e);
                        }(e);
                        if (!r) throw new u("Invalid event signature.", {
                            details: e
                        });
                        const o = O(r.parameters), i = [], s = o.length;
                        for(let e = 0; e < s; e++)i.push(x(o[e], {
                            modifiers: _,
                            structs: t,
                            type: "event"
                        }));
                        return {
                            name: r.name,
                            type: "event",
                            inputs: i
                        };
                    }
                    if (function(e) {
                        return l.test(e);
                    }(e)) {
                        const r = function(e) {
                            return n(l, e);
                        }(e);
                        if (!r) throw new u("Invalid error signature.", {
                            details: e
                        });
                        const o = O(r.parameters), i = [], s = o.length;
                        for(let e = 0; e < s; e++)i.push(x(o[e], {
                            structs: t,
                            type: "error"
                        }));
                        return {
                            name: r.name,
                            type: "error",
                            inputs: i
                        };
                    }
                    if (function(e) {
                        return y.test(e);
                    }(e)) {
                        const r = function(e) {
                            return n(y, e);
                        }(e);
                        if (!r) throw new u("Invalid constructor signature.", {
                            details: e
                        });
                        const o = O(r.parameters), i = [], s = o.length;
                        for(let e = 0; e < s; e++)i.push(x(o[e], {
                            structs: t,
                            type: "constructor"
                        }));
                        return {
                            type: "constructor",
                            stateMutability: r.stateMutability ?? "nonpayable",
                            inputs: i
                        };
                    }
                    if (function(e) {
                        return v.test(e);
                    }(e)) return {
                        type: "fallback"
                    };
                    if (function(e) {
                        return b.test(e);
                    }(e)) return {
                        type: "receive",
                        stateMutability: "payable"
                    };
                    throw new u("Unknown signature.", {
                        details: e
                    });
                }
                var I = /^(?<type>[a-zA-Z0-9_]+?)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z0-9_]+))?$/, R = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z0-9_]+))?$/, P = /^u?int$/;
                function x(e, t) {
                    const r = function(e, t) {
                        return t ? `${t}:${e}` : e;
                    }(e, t?.type);
                    if (T.has(r)) return T.get(r);
                    const a = s.test(e), c = n(a ? R : I, e);
                    if (!c) throw new u("Invalid ABI parameter.", {
                        details: e
                    });
                    if (c.name && function(e) {
                        return "address" === e || "bool" === e || "function" === e || "string" === e || "tuple" === e || o.test(e) || i.test(e) || C.test(e);
                    }(c.name)) throw new u("Invalid ABI parameter.", {
                        details: e,
                        metaMessages: [
                            `"${c.name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
                        ]
                    });
                    const d = c.name ? {
                        name: c.name
                    } : {}, l = "indexed" === c.modifier ? {
                        indexed: !0
                    } : {}, h = t?.structs ?? {};
                    let f, p = {};
                    if (a) {
                        f = "tuple";
                        const e = O(c.type), t = [], r = e.length;
                        for(let n = 0; n < r; n++)t.push(x(e[n], {
                            structs: h
                        }));
                        p = {
                            components: t
                        };
                    } else if (c.type in h) f = "tuple", p = {
                        components: h[c.type]
                    };
                    else if (P.test(c.type)) f = `${c.type}256`;
                    else if (f = c.type, "struct" !== t?.type && !S(f)) throw new u("Unknown type.", {
                        metaMessages: [
                            `Type "${f}" is not a valid ABI type.`
                        ]
                    });
                    if (c.modifier) {
                        if (!t?.modifiers?.has?.(c.modifier)) throw new u("Invalid ABI parameter.", {
                            details: e,
                            metaMessages: [
                                `Modifier "${c.modifier}" not allowed${t?.type ? ` in "${t.type}" type` : ""}.`
                            ]
                        });
                        if (A.has(c.modifier) && !function(e, t) {
                            return t || "bytes" === e || "string" === e || "tuple" === e;
                        }(f, !!c.array)) throw new u("Invalid ABI parameter.", {
                            details: e,
                            metaMessages: [
                                `Modifier "${c.modifier}" not allowed${t?.type ? ` in "${t.type}" type` : ""}.`,
                                `Data location can only be specified for array, struct, or mapping types, but "${c.modifier}" was given.`
                            ]
                        });
                    }
                    const m = {
                        type: `${f}${c.array ?? ""}`,
                        ...d,
                        ...l,
                        ...p
                    };
                    return T.set(r, m), m;
                }
                function O(e, t = [], r = "", n = 0) {
                    if ("" === e) {
                        if ("" === r) return t;
                        if (0 !== n) throw new u("Unbalanced parentheses.", {
                            metaMessages: [
                                `"${r.trim()}" has too many ${n > 0 ? "opening" : "closing"} parentheses.`
                            ],
                            details: `Depth "${n}"`
                        });
                        return [
                            ...t,
                            r.trim()
                        ];
                    }
                    const o = e.length;
                    for(let i = 0; i < o; i++){
                        const o = e[i], s = e.slice(i + 1);
                        switch(o){
                            case ",":
                                return 0 === n ? O(s, [
                                    ...t,
                                    r.trim()
                                ]) : O(s, t, `${r}${o}`, n);
                            case "(":
                                return O(s, t, `${r}${o}`, n + 1);
                            case ")":
                                return O(s, t, `${r}${o}`, n - 1);
                            default:
                                return O(s, t, `${r}${o}`, n);
                        }
                    }
                    return [];
                }
                function S(e) {
                    return "address" === e || "bool" === e || "function" === e || "string" === e || o.test(e) || i.test(e);
                }
                var C = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
                function B(e) {
                    const t = {}, r = e.length;
                    for(let n = 0; n < r; n++){
                        const r = e[n];
                        if (!m(r)) continue;
                        const o = g(r);
                        if (!o) throw new u("Invalid struct signature.", {
                            details: r
                        });
                        const i = o.properties.split(";"), s = [], a = i.length;
                        for(let e = 0; e < a; e++){
                            const t = i[e].trim();
                            if (!t) continue;
                            const r = x(t, {
                                type: "struct"
                            });
                            s.push(r);
                        }
                        if (!s.length) throw new u("Invalid struct signature.", {
                            details: r,
                            metaMessages: [
                                "No properties exist."
                            ]
                        });
                        t[o.name] = s;
                    }
                    const n = {}, o = Object.entries(t), i = o.length;
                    for(let e = 0; e < i; e++){
                        const [r, i] = o[e];
                        n[r] = N(i, t);
                    }
                    return n;
                }
                var k = /^(?<type>[a-zA-Z0-9_]+?)(?<array>(?:\[\d*?\])+?)?$/;
                function N(e, t, r = new Set) {
                    const o = [], i = e.length;
                    for(let a = 0; a < i; a++){
                        const i = e[a];
                        if (s.test(i.type)) o.push(i);
                        else {
                            const e = n(k, i.type);
                            if (!e?.type) throw new u("Invalid ABI parameter.", {
                                details: JSON.stringify(i, null, 2),
                                metaMessages: [
                                    "ABI parameter type is invalid."
                                ]
                            });
                            const { array: s, type: a } = e;
                            if (a in t) {
                                if (r.has(a)) throw new u("Circular reference detected.", {
                                    metaMessages: [
                                        `Struct "${a}" is a circular reference.`
                                    ]
                                });
                                o.push({
                                    ...i,
                                    type: `tuple${s ?? ""}`,
                                    components: N(t[a] ?? [], t, new Set([
                                        ...r,
                                        a
                                    ]))
                                });
                            } else {
                                if (!S(a)) throw new u("Unknown type.", {
                                    metaMessages: [
                                        `Type "${a}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
                                    ]
                                });
                                o.push(i);
                            }
                        }
                    }
                    return o;
                }
                function M(e) {
                    const t = B(e), r = [], n = e.length;
                    for(let o = 0; o < n; o++){
                        const n = e[o];
                        m(n) || r.push(w(n, t));
                    }
                    return r;
                }
                function L(e) {
                    let t;
                    if ("string" == typeof e) t = w(e);
                    else {
                        const r = B(e), n = e.length;
                        for(let o = 0; o < n; o++){
                            const n = e[o];
                            if (!m(n)) {
                                t = w(n, r);
                                break;
                            }
                        }
                    }
                    if (!t) throw new u("Failed to parse ABI item.", {
                        details: `parseAbiItem(${JSON.stringify(e, null, 2)})`,
                        docsPath: "/api/human.html#parseabiitem-1"
                    });
                    return t;
                }
                function D(e) {
                    let t;
                    if ("string" == typeof e) t = x(e, {
                        modifiers: E
                    });
                    else {
                        const r = B(e), n = e.length;
                        for(let o = 0; o < n; o++){
                            const n = e[o];
                            if (!m(n)) {
                                t = x(n, {
                                    modifiers: E,
                                    structs: r
                                });
                                break;
                            }
                        }
                    }
                    if (!t) throw new u("Failed to parse ABI parameter.", {
                        details: `parseAbiParameter(${JSON.stringify(e, null, 2)})`,
                        docsPath: "/api/human.html#parseabiparameter-1"
                    });
                    return t;
                }
                function F(e) {
                    const t = [];
                    if ("string" == typeof e) {
                        const r = O(e), n = r.length;
                        for(let e = 0; e < n; e++)t.push(x(r[e], {
                            modifiers: E
                        }));
                    } else {
                        const r = B(e), n = e.length;
                        for(let o = 0; o < n; o++){
                            const n = e[o];
                            if (m(n)) continue;
                            const i = O(n), s = i.length;
                            for(let e = 0; e < s; e++)t.push(x(i[e], {
                                modifiers: E,
                                structs: r
                            }));
                        }
                    }
                    if (0 === t.length) throw new u("Failed to parse ABI parameters.", {
                        details: `parseAbiParameters(${JSON.stringify(e, null, 2)})`,
                        docsPath: "/api/human.html#parseabiparameters-1"
                    });
                    return t;
                }
            }
        }, t = {};
        function r(n) {
            var o = t[n];
            if (void 0 !== o) return o.exports;
            var i = t[n] = {
                id: n,
                loaded: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.loaded = !0, i.exports;
        }
        r.d = (e, t)=>{
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.nmd = (e)=>(e.paths = [], e.children || (e.children = []), e);
        var n = r(9375);
        return n.default;
    })());


var $754ad8dab4b3502e$export$2e2bcd8739ae039 = [
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "inputs": [],
        "name": "ERC721EnumerableForbiddenBatchMint",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "sender",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "ERC721IncorrectOwner",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "ERC721InsufficientApproval",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "approver",
                "type": "address"
            }
        ],
        "name": "ERC721InvalidApprover",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "name": "ERC721InvalidOperator",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "ERC721InvalidOwner",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "receiver",
                "type": "address"
            }
        ],
        "name": "ERC721InvalidReceiver",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "sender",
                "type": "address"
            }
        ],
        "name": "ERC721InvalidSender",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "ERC721NonexistentToken",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "index",
                "type": "uint256"
            }
        ],
        "name": "ERC721OutOfBoundsIndex",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "InvalidInitialization",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotInitializing",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "OwnableInvalidOwner",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "OwnableUnauthorizedAccount",
        "type": "error"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "approved",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "Approval",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "ApprovalForAll",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "_fromTokenId",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "_toTokenId",
                "type": "uint256"
            }
        ],
        "name": "BatchMetadataUpdate",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint64",
                "name": "version",
                "type": "uint64"
            }
        ],
        "name": "Initialized",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "_tokenId",
                "type": "uint256"
            }
        ],
        "name": "MetadataUpdate",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "Transfer",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newAdmin",
                "type": "address"
            }
        ],
        "name": "addAdmin",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            },
            {
                "internalType": "enum LmwrCoinbasePromoNftV1.Category",
                "name": "category",
                "type": "uint8"
            }
        ],
        "name": "adminMint",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "approve",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "balanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "enum LmwrCoinbasePromoNftV1.Category",
                "name": "",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "categoryTokens",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "enum LmwrCoinbasePromoNftV1.Category",
                "name": "",
                "type": "uint8"
            }
        ],
        "name": "chancesPct",
        "outputs": [
            {
                "internalType": "uint8",
                "name": "",
                "type": "uint8"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "chancesValid",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "getApproved",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "getTokenCategory",
        "outputs": [
            {
                "internalType": "enum LmwrCoinbasePromoNftV1.Category",
                "name": "",
                "type": "uint8"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "name",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "symbol",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "_baseUri",
                "type": "string"
            },
            {
                "internalType": "uint256",
                "name": "_mintPrice",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_mintStartTime",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_mintEndTime",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "_supraAddr",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "_supraClientAddress",
                "type": "address"
            }
        ],
        "name": "initialize",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "name": "isApprovedForAll",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "mint",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "nonce",
                "type": "uint256"
            },
            {
                "internalType": "uint256[]",
                "name": "rngList",
                "type": "uint256[]"
            }
        ],
        "name": "mintCallback",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "mintEndTime",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "mintPrice",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "mintStartTime",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "name",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "ownerOf",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "admin",
                "type": "address"
            }
        ],
        "name": "removeAdmin",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "setApprovalForAll",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "_baseTokenURI",
                "type": "string"
            }
        ],
        "name": "setBaseUri",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "_supraClientAddress",
                "type": "address"
            }
        ],
        "name": "setSupraClientAddress",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bytes4",
                "name": "interfaceId",
                "type": "bytes4"
            }
        ],
        "name": "supportsInterface",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "symbol",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "index",
                "type": "uint256"
            }
        ],
        "name": "tokenByIndex",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "index",
                "type": "uint256"
            }
        ],
        "name": "tokenOfOwnerByIndex",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "tokenURI",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "transferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "enum LmwrCoinbasePromoNftV1.Category",
                "name": "category",
                "type": "uint8"
            },
            {
                "internalType": "uint8",
                "name": "chancePct",
                "type": "uint8"
            }
        ],
        "name": "updateChances",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_mintStartTimeEpoch",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_mintEndTimeEpoch",
                "type": "uint256"
            }
        ],
        "name": "updateMintingDates",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "withdrawEther",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "stateMutability": "payable",
        "type": "receive"
    }
];


window["Alpine"] = (0, $2667dc9b0d1347a4$export$2e2bcd8739ae039);
//const CONTRACT_ADDRESS = "0xEf28f70b44859422403a9e0c6372D0e1EB118b26";
const $346628e66a294ef2$var$CONTRACT_ADDRESS = "0x43d2b22eb66a95240fd4c48bcd3a8923bf1649f1";
const $346628e66a294ef2$var$BASE_TESTNET_ID = 84532;
const $346628e66a294ef2$var$BASE_TESTNET_SETTINGS = {
    chainId: $346628e66a294ef2$var$BASE_TESTNET_ID,
    chainNamespace: "evm",
    rpcUrl: "https://sepolia.base.org",
    label: "Base Sepolia Testnet",
    token: "ETH"
};
const $346628e66a294ef2$var$BASE_MAINNET_ID = 8453;
const $346628e66a294ef2$var$BASE_MAINNET_SETTINGS = {
    chainId: $346628e66a294ef2$var$BASE_MAINNET_ID,
    chainNamespace: "evm",
    rpcUrl: "https://mainnet.base.org",
    label: "Base Mainnet",
    token: "ETH"
};
const $346628e66a294ef2$var$chainId = $346628e66a294ef2$var$BASE_MAINNET_ID;
const $346628e66a294ef2$var$chainSettings = $346628e66a294ef2$var$BASE_MAINNET_SETTINGS;
const $346628e66a294ef2$var$walletDataRaw = {
    walletConnected: false,
    walletLabel: undefined,
    account: undefined,
    ethBalance: undefined,
    nfts: [],
    reveal: null,
    mintingAvailable: function() {
        return Date.now() < 1721404800000;
    },
    //mintPrice: 1000000000000,
    mintPrice: 1000000000000000,
    mintingInProgress: false,
    mintingStatusText: null,
    mintingError: false
};
(0, $2667dc9b0d1347a4$export$2e2bcd8739ae039).data("walletData", ()=>$346628e66a294ef2$var$walletDataRaw);
const $346628e66a294ef2$var$data = (0, $2667dc9b0d1347a4$export$2e2bcd8739ae039).reactive($346628e66a294ef2$var$walletDataRaw);
// initialize the module with options
const $346628e66a294ef2$var$injected = (0, $072c96f2d8cbaa12$export$2e2bcd8739ae039)();
const $346628e66a294ef2$var$coinbaseWalletSdk = (0, $f5c1deed46c0b2bb$export$2e2bcd8739ae039)({
    darkMode: true
});
const $346628e66a294ef2$var$walletConnect = (0, $90aaee8a682b4bde$export$2e2bcd8739ae039)({
    projectId: "74dc73223f0b737ac1392afcca110a87",
    dappUrl: "https://lmwr.com/",
    requiredChains: [
        $346628e66a294ef2$var$chainId
    ]
});
var $00960e6b19616630$exports = {};
$00960e6b19616630$exports = new URL("limewire_icon.a33049ae.svg", import.meta.url).toString();


var $527e8949273abae9$exports = {};
$527e8949273abae9$exports = new URL("limewire_logo.2d2504ca.svg", import.meta.url).toString();


// can also initialize with no options...
// const coinbaseWalletSdk = coinbaseWalletSdk()
const $346628e66a294ef2$var$onboard = (0, $j3oOb.aB)({
    // ... other Onboard options
    wallets: [
        $346628e66a294ef2$var$injected,
        $346628e66a294ef2$var$coinbaseWalletSdk,
        $346628e66a294ef2$var$walletConnect
    ],
    chains: [
        {
            id: $346628e66a294ef2$var$chainId
        }
    ],
    connect: {
        autoConnectLastWallet: true
    },
    accountCenter: {
        mobile: {
            enabled: false
        },
        desktop: {
            enabled: false
        }
    },
    notify: {
        enabled: false
    },
    apiKey: "f9df0476-b7b8-4590-93f6-d650fdbd20f8",
    appMetadata: {
        name: "lmwr.com",
        description: "lmwr.com is the official project website of the lmwr token",
        icon: new URL($00960e6b19616630$exports).toString(),
        logo: new URL($527e8949273abae9$exports).toString()
    },
    theme: "dark"
});
const $346628e66a294ef2$var$state = $346628e66a294ef2$var$onboard.state.select("wallets");
$346628e66a294ef2$var$state.subscribe(async function(update) {
    console.log("Wallets have changed", update);
    if (update.length > 1) {
        console.log("Forbidden: More than 1 wallet - disconnecting and reconnecting");
        await window.disconnectWallet();
        await $346628e66a294ef2$var$onboard.connectWallet();
    } else await $346628e66a294ef2$var$refreshData($346628e66a294ef2$var$onboard.state.get().wallets);
});
let $346628e66a294ef2$var$lastConnectedWallet = JSON.parse(localStorage.getItem("onboard.js:last_connected_wallet") || "[]");
if (Array.isArray($346628e66a294ef2$var$lastConnectedWallet) && $346628e66a294ef2$var$lastConnectedWallet.length) {
    console.log(`Trying to reconnect to wallet ${$346628e66a294ef2$var$lastConnectedWallet[0]}`);
    $346628e66a294ef2$var$onboard.connectWallet({
        autoSelect: {
            label: $346628e66a294ef2$var$lastConnectedWallet[0],
            disableModals: true
        }
    });
}
async function $346628e66a294ef2$var$changeChain() {
    const wallets = $346628e66a294ef2$var$onboard.state.get().wallets;
    if (wallets.length > 0) {
        if (parseInt(wallets[0].chains[0].id, 16) !== $346628e66a294ef2$var$chainId) {
            try {
                await $346628e66a294ef2$var$onboard.setChain({
                    ...$346628e66a294ef2$var$chainSettings,
                    wallet: wallets[0].label
                });
            } catch (e) {
                console.log("Error changing chains on wallet", e);
            }
            return true;
        }
    }
    return false;
}
async function $346628e66a294ef2$var$refreshData(walletStates) {
    let hadToChangeChain = await $346628e66a294ef2$var$changeChain();
    if (hadToChangeChain || !walletStates || walletStates.length === 0) {
        console.log("No connected wallets found or chain was changed");
        $346628e66a294ef2$var$data.walletConnected = false;
        $346628e66a294ef2$var$data.walletLabel = undefined;
        $346628e66a294ef2$var$data.account = undefined;
        $346628e66a294ef2$var$data.ethBalance = undefined;
        $346628e66a294ef2$var$data.nfts = [];
        $346628e66a294ef2$var$data.reveal = null;
    } else {
        if (walletStates[0].accounts[0].address === $346628e66a294ef2$var$data.account?.address) {
            console.log("Empty update - doing nothing");
            return;
        }
        const web3 = new (0, (/*@__PURE__*/$parcel$interopDefault($2f443f1aca6ad8c7$exports)))({
            provider: walletStates[0].provider,
            config: {
                defaultNetworkId: $346628e66a294ef2$var$chainId
            }
        });
        $346628e66a294ef2$var$data.reveal = null;
        $346628e66a294ef2$var$data.walletLabel = walletStates[0].label;
        $346628e66a294ef2$var$data.account = walletStates[0].accounts[0];
        const address = $346628e66a294ef2$var$data.account.address;
        $346628e66a294ef2$var$data.ethBalance = await web3.eth.getBalance(address);
        $346628e66a294ef2$var$data.walletConnected = true;
        console.log(`Wallet ${address} has an ETH balance of ${$346628e66a294ef2$var$data.ethBalance} WEI`);
        const contract = new web3.eth.Contract((0, $754ad8dab4b3502e$export$2e2bcd8739ae039), $346628e66a294ef2$var$CONTRACT_ADDRESS);
        contract.defaultAccount = address;
        const balance = await contract.methods.balanceOf(address).call();
        console.log(`Address ${address} has a balance of ${balance} tokens`);
        for(let i = 0; i < balance; i++){
            const tokenId = await contract.methods.tokenOfOwnerByIndex(address, i).call();
            console.log(`Address ${address} owns token ${tokenId}`);
            const category = await contract.methods.getTokenCategory(tokenId).call();
            console.log($346628e66a294ef2$var$data.nfts.length, $346628e66a294ef2$var$data.walletConnected);
            $346628e66a294ef2$var$data.nfts.push({
                id: tokenId,
                category: category,
                image: $346628e66a294ef2$var$getNftImageUrl(category),
                animationUrl: $346628e66a294ef2$var$getNftAnimationUrl(category)
            });
        }
    }
}
var $e9102301ab641f19$exports = {};
$e9102301ab641f19$exports = new URL("promos_base2024_3_0_image.4779e79c.png", import.meta.url).toString();


var $753fb914008f2ee8$exports = {};
$753fb914008f2ee8$exports = new URL("promos_base2024_3_1_image.f42376b9.png", import.meta.url).toString();


var $9acb92d83f8ecc8a$exports = {};
$9acb92d83f8ecc8a$exports = new URL("promos_base2024_3_2_image.017c5e56.png", import.meta.url).toString();


var $9f88e540b1831df3$exports = {};
$9f88e540b1831df3$exports = new URL("promos_base2024_3_3_image.f42376b9.png", import.meta.url).toString();


function $346628e66a294ef2$var$getNftImageUrl(category) {
    switch(Number(category)){
        case 0:
            return new URL($e9102301ab641f19$exports).toString();
        case 1:
            return new URL($753fb914008f2ee8$exports).toString();
        case 2:
            return new URL($9acb92d83f8ecc8a$exports).toString();
        case 3:
            return new URL($9f88e540b1831df3$exports).toString();
    }
}
var $f98314c80481a281$exports = {};
$f98314c80481a281$exports = new URL("promos_base2024_3_0_video.c485cab3.mp4", import.meta.url).toString();


var $0ac321dfa01f23e1$exports = {};
$0ac321dfa01f23e1$exports = new URL("promos_base2024_3_1_video.1881bc8f.mp4", import.meta.url).toString();


var $4a7dbedb666c0eb2$exports = {};
$4a7dbedb666c0eb2$exports = new URL("promos_base2024_3_2_video.a5ea18fd.mp4", import.meta.url).toString();


var $6f97df66402feeb9$exports = {};
$6f97df66402feeb9$exports = new URL("promos_base2024_3_3_video.1881bc8f.mp4", import.meta.url).toString();


function $346628e66a294ef2$var$getNftAnimationUrl(category) {
    switch(Number(category)){
        case 0:
            return new URL($f98314c80481a281$exports).toString();
        case 1:
            return new URL($0ac321dfa01f23e1$exports).toString();
        case 2:
            return new URL($4a7dbedb666c0eb2$exports).toString();
        case 3:
            return new URL($6f97df66402feeb9$exports).toString();
    }
}
window["connectWallet"] = async function() {
    await $346628e66a294ef2$var$onboard.connectWallet();
};
window["disconnectWallet"] = async function() {
    for (const walletstate of $346628e66a294ef2$var$onboard.state.get().wallets)await $346628e66a294ef2$var$onboard.disconnectWallet({
        label: walletstate.label
    });
};
window["mint"] = async function() {
    try {
        $346628e66a294ef2$var$data.mintingError = false;
        $346628e66a294ef2$var$data.mintingInProgress = true;
        $346628e66a294ef2$var$data.mintingStatusText = "Estimating Gas Fees ...";
        const wallet = $346628e66a294ef2$var$onboard.state.get().wallets[0];
        const web3 = new (0, (/*@__PURE__*/$parcel$interopDefault($2f443f1aca6ad8c7$exports)))({
            provider: wallet.provider,
            config: {
                defaultNetworkId: $346628e66a294ef2$var$chainId,
                handleRevert: true
            }
        });
        const address = wallet.accounts[0].address;
        const contract = new web3.eth.Contract((0, $754ad8dab4b3502e$export$2e2bcd8739ae039), $346628e66a294ef2$var$CONTRACT_ADDRESS);
        const estimatedGas = await contract.methods.mint().estimateGas({
            from: address,
            value: $346628e66a294ef2$var$data.mintPrice
        });
        console.log("Estimated gas", estimatedGas);
        $346628e66a294ef2$var$data.mintingStatusText = "Sending transaction ...";
        const numberOfNftsBeforeMinting = $346628e66a294ef2$var$data.nfts.length || 0;
        const res = await contract.methods.mint().send({
            from: address,
            value: $346628e66a294ef2$var$data.mintPrice,
            gas: estimatedGas
        });
        console.log("Successfully sent minting tx", res);
        $346628e66a294ef2$var$data.mintingStatusText = "Minting transaction sent - waiting for Non-Fungible Torrent";
        setTimeout(()=>{
            const checkForNft = async ()=>{
                try {
                    console.log("Checking for NFT ...");
                    const balance = await contract.methods.balanceOf(address).call();
                    if (balance > numberOfNftsBeforeMinting) {
                        $346628e66a294ef2$var$data.mintingInProgress = false;
                        $346628e66a294ef2$var$data.mintingStatusText = "Minting complete - enjoy your new Non-Fungible Torrent!";
                        $346628e66a294ef2$var$data.mintingError = false;
                        setTimeout(()=>location.reload(), 5000);
                    } else {
                        console.log("Not yet found ...");
                        setTimeout(checkForNft, 10000);
                    }
                } catch (e) {
                    console.log("Error checking for NFT", e);
                    $346628e66a294ef2$var$data.mintingStatusText = "An error occurred while checking for your NFTs - please refresh the page";
                    $346628e66a294ef2$var$data.mintingError = true;
                }
            };
            checkForNft();
        }, 10000);
    } catch (e) {
        console.log("Error minting", e);
        $346628e66a294ef2$var$data.mintingError = true;
        $346628e66a294ef2$var$data.mintingStatusText = `Error: ${e}`;
        $346628e66a294ef2$var$data.mintingInProgress = false;
    }
};
var $0f31c0c86015efd2$exports = {};
$0f31c0c86015efd2$exports = new URL("deadmau5 - Apnea.fd4d7931.m4a", import.meta.url).toString();


var $9e0cc2437411ea62$exports = {};
$9e0cc2437411ea62$exports = new URL("Sean Kingston - Sally.85aa6e0b.mp3", import.meta.url).toString();


window["downloadLink"] = function(id) {
    let url = "";
    switch(Number(id)){
        case 1:
            url = new URL($0f31c0c86015efd2$exports);
            break;
        case 2:
            url = new URL($9e0cc2437411ea62$exports);
            break;
    }
    console.log("Downloadlink: ", url, id);
    return url.toString();
};
(0, $2667dc9b0d1347a4$export$2e2bcd8739ae039).start();


//# sourceMappingURL=index.896ef28d.js.map
